
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire9346"];
var parcelRegister = parcelRequire.register;
parcelRegister("8gXIX", function(module, exports) {

$parcel$export(module.exports, "timeseriesFireSize", () => $605e2555f4dc9b1f$export$f3d40b41498d8f9c);
const $605e2555f4dc9b1f$export$f3d40b41498d8f9c = {
    "IPCC Regions": {
        "ARP": [
            {
                "Region Name": "ARP",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "ARP",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "ARP",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "ARP",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "ARP",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "ARP",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "ARP",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "ARP",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "ARP",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "ARP",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "ARP",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "ARP",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "ARP",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "ARP",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "ARP",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "ARP",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "ARP",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "ARP",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "ARP",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "ARP",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "ARP",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "ARP",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "CAF": [
            {
                "Region Name": "CAF",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "CAF",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "CAF",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "CAF",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "CAF",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "CAF",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "CAF",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "CAF",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "CAF",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "CAF",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "CAF",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "CAF",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "CAF",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "CAF",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "CAF",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "CAF",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "CAF",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "CAF",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "CAF",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "CAF",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "CAF",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "CAF",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "CAR": [
            {
                "Region Name": "CAR",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "CAR",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "CAR",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "CAR",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "CAR",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "CAR",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "CAR",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "CAR",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "CAR",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "CAR",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "CAR",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "CAR",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "CAR",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "CAR",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "CAR",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "CAR",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "CAR",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "CAR",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "CAR",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "CAR",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "CAR",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "CAR",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "CAU": [
            {
                "Region Name": "CAU",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 185
            },
            {
                "Region Name": "CAU",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "CAU",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 93
            },
            {
                "Region Name": "CAU",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "CAU",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 130
            },
            {
                "Region Name": "CAU",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 102
            },
            {
                "Region Name": "CAU",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 57
            },
            {
                "Region Name": "CAU",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "CAU",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "CAU",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 154
            },
            {
                "Region Name": "CAU",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 169
            },
            {
                "Region Name": "CAU",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 89
            },
            {
                "Region Name": "CAU",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 109
            },
            {
                "Region Name": "CAU",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 100
            },
            {
                "Region Name": "CAU",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "CAU",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 126
            },
            {
                "Region Name": "CAU",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 151
            },
            {
                "Region Name": "CAU",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "CAU",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "CAU",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 74
            },
            {
                "Region Name": "CAU",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 80
            },
            {
                "Region Name": "CAU",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 179
            }
        ],
        "CNA": [
            {
                "Region Name": "CNA",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "CNA",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "CNA",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "CNA",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "CNA",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "CNA",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "CNA",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "CNA",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "CNA",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "CNA",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "CNA",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "CNA",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "CNA",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "CNA",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "CNA",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "CNA",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "CNA",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "CNA",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "CNA",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "CNA",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "CNA",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "CNA",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "EAN": [
            {
                "Region Name": "EAN",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "EAN",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "EAN",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "EAN",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "EAN",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "EAN",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "EAN",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "EAN",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "EAN",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "EAN",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "EAN",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "EAN",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "EAN",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "EAN",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "EAN",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "EAN",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "EAN",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "EAN",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "EAN",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "EAN",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "EAN",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "EAN",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "EAS": [
            {
                "Region Name": "EAS",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "EAS",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "EAS",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "EAS",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "EAS",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "EAS",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "EAS",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "EAS",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "EAS",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "EAS",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "EAS",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "EAS",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "EAS",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "EAS",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "EAS",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "EAS",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "EAS",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "EAS",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "EAS",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "EAS",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "EAS",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "EAS",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "EAU": [
            {
                "Region Name": "EAU",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "EAU",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "EAU",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "EAU",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "EAU",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "EAU",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "EAU",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "EAU",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "EAU",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "EAU",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "EAU",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "EAU",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "EAU",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "EAU",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "EAU",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "EAU",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "EAU",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "EAU",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 64
            },
            {
                "Region Name": "EAU",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "EAU",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "EAU",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "EAU",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 16
            }
        ],
        "ECA": [
            {
                "Region Name": "ECA",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "ECA",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "ECA",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "ECA",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "ECA",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "ECA",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "ECA",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "ECA",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "ECA",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "ECA",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "ECA",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "ECA",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "ECA",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "ECA",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "ECA",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "ECA",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "ECA",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "ECA",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "ECA",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "ECA",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "ECA",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "ECA",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "EEU": [
            {
                "Region Name": "EEU",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "EEU",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "EEU",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "EEU",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "EEU",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "EEU",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "EEU",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "EEU",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "EEU",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "EEU",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "EEU",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "EEU",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "EEU",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "EEU",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "EEU",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "EEU",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "EEU",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "EEU",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "EEU",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "EEU",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "EEU",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "EEU",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "ENA": [
            {
                "Region Name": "ENA",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "ENA",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "ENA",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "ENA",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "ENA",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "ENA",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "ENA",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "ENA",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "ENA",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "ENA",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "ENA",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "ENA",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "ENA",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "ENA",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "ENA",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "ENA",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "ENA",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "ENA",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "ENA",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "ENA",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "ENA",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "ENA",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "ESAF": [
            {
                "Region Name": "ESAF",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "ESAF",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "ESAF",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "ESAF",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "ESAF",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "ESAF",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "ESAF",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "ESAF",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "ESAF",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "ESAF",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "ESAF",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "ESAF",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "ESAF",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "ESAF",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "ESAF",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "ESAF",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "ESAF",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "ESAF",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "ESAF",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "ESAF",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "ESAF",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "ESAF",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "ESB": [
            {
                "Region Name": "ESB",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "ESB",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "ESB",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "ESB",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "ESB",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "ESB",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "ESB",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "ESB",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "ESB",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "ESB",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "ESB",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "ESB",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "ESB",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "ESB",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "ESB",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "ESB",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "ESB",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "ESB",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "ESB",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "ESB",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "ESB",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "ESB",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "GIC": [
            {
                "Region Name": "GIC",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "GIC",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "GIC",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "GIC",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "GIC",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "GIC",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "GIC",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "GIC",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "GIC",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "GIC",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "GIC",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "GIC",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "GIC",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "GIC",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "GIC",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "GIC",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "GIC",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "GIC",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "GIC",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "GIC",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "GIC",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "GIC",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "MDG": [
            {
                "Region Name": "MDG",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "MDG",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "MDG",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "MDG",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "MDG",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "MDG",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "MDG",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "MDG",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "MDG",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "MDG",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "MDG",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "MDG",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "MDG",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "MDG",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "MDG",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "MDG",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "MDG",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "MDG",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "MDG",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "MDG",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "MDG",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "MDG",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "MED": [
            {
                "Region Name": "MED",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "MED",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "MED",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "MED",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "MED",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "MED",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "MED",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "MED",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "MED",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "MED",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "MED",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "MED",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "MED",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "MED",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "MED",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "MED",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "MED",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "MED",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "MED",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "MED",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "MED",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "MED",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "NAU": [
            {
                "Region Name": "NAU",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 101
            },
            {
                "Region Name": "NAU",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 64
            },
            {
                "Region Name": "NAU",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 102
            },
            {
                "Region Name": "NAU",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "NAU",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 82
            },
            {
                "Region Name": "NAU",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "NAU",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 68
            },
            {
                "Region Name": "NAU",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 68
            },
            {
                "Region Name": "NAU",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "NAU",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 70
            },
            {
                "Region Name": "NAU",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 88
            },
            {
                "Region Name": "NAU",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "NAU",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "NAU",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "NAU",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "NAU",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "NAU",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 64
            },
            {
                "Region Name": "NAU",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "NAU",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "NAU",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "NAU",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "NAU",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 53
            }
        ],
        "NCA": [
            {
                "Region Name": "NCA",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "NCA",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "NCA",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "NCA",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "NCA",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "NCA",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "NCA",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "NCA",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "NCA",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "NCA",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "NCA",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "NCA",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "NCA",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "NCA",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "NCA",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "NCA",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "NCA",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "NCA",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "NCA",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "NCA",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "NCA",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "NCA",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "NEAF": [
            {
                "Region Name": "NEAF",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "NEAF",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "NEAF",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "NEAF",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "NEAF",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "NEAF",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "NEAF",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "NEAF",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "NEAF",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "NEAF",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "NEAF",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "NEAF",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "NEAF",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "NEAF",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "NEAF",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "NEAF",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "NEAF",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "NEAF",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "NEAF",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "NEAF",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "NEAF",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "NEAF",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 21
            }
        ],
        "NEN": [
            {
                "Region Name": "NEN",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 86
            },
            {
                "Region Name": "NEN",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "NEN",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "NEN",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "NEN",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "NEN",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "NEN",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "NEN",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "NEN",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "NEN",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "NEN",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "NEN",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 83
            },
            {
                "Region Name": "NEN",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "NEN",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "NEN",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "NEN",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "NEN",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "NEN",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "NEN",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "NEN",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 85
            },
            {
                "Region Name": "NEN",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "NEN",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 135
            }
        ],
        "NES": [
            {
                "Region Name": "NES",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "NES",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "NES",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "NES",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "NES",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "NES",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "NES",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "NES",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "NES",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "NES",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "NES",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "NES",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "NES",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "NES",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "NES",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "NES",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "NES",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "NES",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "NES",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "NES",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "NES",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "NES",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "NEU": [
            {
                "Region Name": "NEU",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "NEU",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "NEU",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "NEU",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "NEU",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "NEU",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "NEU",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "NEU",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "NEU",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "NEU",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "NEU",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "NEU",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "NEU",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "NEU",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "NEU",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "NEU",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "NEU",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "NEU",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "NEU",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "NEU",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "NEU",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "NEU",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "NSA": [
            {
                "Region Name": "NSA",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "NSA",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "NSA",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "NSA",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "NSA",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "NSA",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "NSA",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "NSA",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "NSA",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "NSA",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "NSA",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "NSA",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "NSA",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "NSA",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "NSA",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "NSA",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "NSA",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "NSA",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "NSA",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "NSA",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "NSA",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "NSA",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "NWN": [
            {
                "Region Name": "NWN",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "NWN",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "NWN",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "NWN",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "NWN",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "NWN",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "NWN",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "NWN",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "NWN",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "NWN",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "NWN",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "NWN",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "NWN",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "NWN",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "NWN",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "NWN",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "NWN",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "NWN",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "NWN",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "NWN",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "NWN",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "NWN",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 44
            }
        ],
        "NWS": [
            {
                "Region Name": "NWS",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "NWS",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "NWS",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "NWS",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "NWS",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "NWS",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "NWS",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "NWS",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "NWS",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "NWS",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "NWS",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "NWS",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "NWS",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "NWS",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "NWS",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "NWS",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "NWS",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "NWS",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "NWS",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "NWS",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "NWS",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "NWS",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "NZ": [
            {
                "Region Name": "NZ",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NZ",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "NZ",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "NZ",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "NZ",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "NZ",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "NZ",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "NZ",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "NZ",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "NZ",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "NZ",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "NZ",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NZ",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "NZ",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "NZ",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "NZ",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "NZ",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "NZ",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "NZ",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "NZ",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "NZ",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "NZ",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "RAR": [
            {
                "Region Name": "RAR",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "RAR",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "RAR",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "RAR",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "RAR",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "RAR",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "RAR",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "RAR",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "RAR",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "RAR",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "RAR",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "RAR",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "RAR",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "RAR",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "RAR",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "RAR",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "RAR",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "RAR",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "RAR",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "RAR",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "RAR",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "RAR",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "RFE": [
            {
                "Region Name": "RFE",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "RFE",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "RFE",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "RFE",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "RFE",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "RFE",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "RFE",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "RFE",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "RFE",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "RFE",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "RFE",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "RFE",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "RFE",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "RFE",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "RFE",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "RFE",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "RFE",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "RFE",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "RFE",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "RFE",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "RFE",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "RFE",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 26
            }
        ],
        "SAH": [
            {
                "Region Name": "SAH",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "SAH",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "SAH",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "SAH",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 73
            },
            {
                "Region Name": "SAH",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 65
            },
            {
                "Region Name": "SAH",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 67
            },
            {
                "Region Name": "SAH",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 61
            },
            {
                "Region Name": "SAH",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "SAH",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 68
            },
            {
                "Region Name": "SAH",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "SAH",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 68
            },
            {
                "Region Name": "SAH",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "SAH",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "SAH",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "SAH",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "SAH",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "SAH",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "SAH",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "SAH",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "SAH",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "SAH",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "SAH",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 47
            }
        ],
        "SAM": [
            {
                "Region Name": "SAM",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "SAM",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "SAM",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "SAM",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "SAM",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "SAM",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "SAM",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "SAM",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "SAM",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "SAM",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "SAM",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "SAM",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "SAM",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "SAM",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "SAM",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "SAM",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "SAM",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "SAM",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "SAM",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "SAM",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "SAM",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "SAM",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 19
            }
        ],
        "SAS": [
            {
                "Region Name": "SAS",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "SAS",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "SAS",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "SAS",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "SAS",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "SAS",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "SAS",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "SAS",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "SAS",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "SAS",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "SAS",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "SAS",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "SAS",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "SAS",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "SAS",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "SAS",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "SAS",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "SAS",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "SAS",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "SAS",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "SAS",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "SAS",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "SAU": [
            {
                "Region Name": "SAU",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 105
            },
            {
                "Region Name": "SAU",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "SAU",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "SAU",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "SAU",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "SAU",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "SAU",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "SAU",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "SAU",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "SAU",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "SAU",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SAU",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "SAU",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "SAU",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "SAU",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "SAU",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "SAU",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "SAU",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "SAU",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "SAU",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SAU",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "SAU",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "SCA": [
            {
                "Region Name": "SCA",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SCA",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "SCA",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SCA",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "SCA",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SCA",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SCA",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "SCA",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SCA",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SCA",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "SCA",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "SCA",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "SCA",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SCA",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "SCA",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "SCA",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SCA",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SCA",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SCA",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "SCA",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SCA",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SCA",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "SEA": [
            {
                "Region Name": "SEA",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "SEA",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "SEA",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "SEA",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "SEA",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "SEA",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "SEA",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "SEA",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "SEA",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "SEA",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "SEA",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "SEA",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SEA",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "SEA",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "SEA",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "SEA",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "SEA",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "SEA",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "SEA",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "SEA",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SEA",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SEA",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "SEAF": [
            {
                "Region Name": "SEAF",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "SEAF",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "SEAF",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "SEAF",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "SEAF",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "SEAF",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "SEAF",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "SEAF",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "SEAF",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "SEAF",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "SEAF",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "SEAF",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "SEAF",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "SEAF",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "SEAF",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "SEAF",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "SEAF",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "SEAF",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "SEAF",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "SEAF",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "SEAF",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "SEAF",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "SES": [
            {
                "Region Name": "SES",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "SES",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SES",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SES",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SES",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SES",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "SES",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SES",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SES",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SES",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SES",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SES",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SES",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SES",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SES",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SES",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "SES",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SES",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SES",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "SES",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "SES",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "SES",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "SSA": [
            {
                "Region Name": "SSA",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 86
            },
            {
                "Region Name": "SSA",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "SSA",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "SSA",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "SSA",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "SSA",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SSA",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "SSA",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "SSA",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "SSA",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "SSA",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "SSA",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "SSA",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "SSA",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "SSA",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "SSA",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "SSA",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "SSA",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "SSA",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "SSA",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "SSA",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "SSA",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "SWS": [
            {
                "Region Name": "SWS",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SWS",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "SWS",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "SWS",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "SWS",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "SWS",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "SWS",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "SWS",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "SWS",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "SWS",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "SWS",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "SWS",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "SWS",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "SWS",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "SWS",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "SWS",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "SWS",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "SWS",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "SWS",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "SWS",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "SWS",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "SWS",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "TIB": [
            {
                "Region Name": "TIB",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "TIB",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "TIB",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "TIB",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "TIB",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "TIB",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "TIB",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "TIB",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "TIB",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "TIB",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "TIB",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "TIB",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "TIB",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "TIB",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "TIB",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "TIB",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "TIB",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "TIB",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "TIB",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "TIB",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "TIB",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "TIB",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "WAF": [
            {
                "Region Name": "WAF",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "WAF",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "WAF",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "WAF",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "WAF",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "WAF",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "WAF",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "WAF",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "WAF",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "WAF",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "WAF",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "WAF",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "WAF",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "WAF",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "WAF",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "WAF",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "WAF",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "WAF",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "WAF",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "WAF",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "WAF",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "WAF",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "WAN": [
            {
                "Region Name": "WAN",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "WAN",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "WAN",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "WAN",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "WAN",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "WAN",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "WAN",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "WAN",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "WAN",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "WAN",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "WAN",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "WAN",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "WAN",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "WAN",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "WAN",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "WAN",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "WAN",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "WAN",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "WAN",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "WAN",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "WAN",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "WAN",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "WCA": [
            {
                "Region Name": "WCA",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "WCA",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "WCA",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "WCA",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "WCA",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "WCA",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "WCA",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "WCA",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "WCA",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "WCA",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "WCA",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "WCA",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "WCA",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "WCA",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "WCA",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "WCA",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "WCA",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "WCA",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "WCA",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "WCA",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "WCA",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "WCA",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "WCE": [
            {
                "Region Name": "WCE",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "WCE",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "WCE",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "WCE",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "WCE",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "WCE",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "WCE",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "WCE",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "WCE",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "WCE",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "WCE",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "WCE",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "WCE",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "WCE",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "WCE",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "WCE",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "WCE",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "WCE",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "WCE",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "WCE",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "WCE",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "WCE",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "WNA": [
            {
                "Region Name": "WNA",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "WNA",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "WNA",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "WNA",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "WNA",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "WNA",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "WNA",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "WNA",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "WNA",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "WNA",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "WNA",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "WNA",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "WNA",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "WNA",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "WNA",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "WNA",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "WNA",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "WNA",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "WNA",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "WNA",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "WNA",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "WNA",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "WSAF": [
            {
                "Region Name": "WSAF",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "WSAF",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "WSAF",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "WSAF",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "WSAF",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "WSAF",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "WSAF",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "WSAF",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "WSAF",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "WSAF",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "WSAF",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "WSAF",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "WSAF",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "WSAF",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "WSAF",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "WSAF",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "WSAF",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "WSAF",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "WSAF",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "WSAF",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "WSAF",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "WSAF",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 19
            }
        ],
        "WSB": [
            {
                "Region Name": "WSB",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "WSB",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "WSB",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "WSB",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "WSB",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "WSB",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "WSB",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "WSB",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "WSB",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "WSB",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "WSB",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "WSB",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "WSB",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "WSB",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "WSB",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "WSB",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "WSB",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "WSB",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "WSB",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "WSB",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "WSB",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "WSB",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ]
    },
    "Countries": {
        "Afghanistan": [
            {
                "Region Name": "Afghanistan",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Afghanistan",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 66
            },
            {
                "Region Name": "Afghanistan",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Afghanistan",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Afghanistan",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Afghanistan",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Afghanistan",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Afghanistan",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Afghanistan",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Afghanistan",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Afghanistan",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Afghanistan",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Afghanistan",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Afghanistan",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Afghanistan",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Afghanistan",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Afghanistan",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Afghanistan",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Afghanistan",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Afghanistan",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Afghanistan",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Afghanistan",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Albania": [
            {
                "Region Name": "Albania",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Albania",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Albania",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Albania",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Albania",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Albania",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Albania",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Albania",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Albania",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Albania",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Albania",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Albania",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Albania",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Albania",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Albania",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Albania",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Albania",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Albania",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Albania",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Albania",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Albania",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Albania",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Algeria": [
            {
                "Region Name": "Algeria",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Algeria",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Algeria",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Algeria",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Algeria",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Algeria",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Algeria",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Algeria",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Algeria",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Algeria",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Algeria",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Algeria",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Algeria",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Algeria",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Algeria",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Algeria",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Algeria",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Algeria",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Algeria",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Algeria",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "Algeria",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Algeria",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 29
            }
        ],
        "American Samoa": [
            {
                "Region Name": "American Samoa",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "American Samoa",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "American Samoa",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "American Samoa",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "American Samoa",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "American Samoa",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "American Samoa",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "American Samoa",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "American Samoa",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "American Samoa",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "American Samoa",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "American Samoa",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "American Samoa",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "American Samoa",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "American Samoa",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "American Samoa",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "American Samoa",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "American Samoa",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "American Samoa",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "American Samoa",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "American Samoa",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "American Samoa",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Andorra": [
            {
                "Region Name": "Andorra",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Angola": [
            {
                "Region Name": "Angola",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Angola",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Angola",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Angola",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Angola",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Angola",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Angola",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Angola",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Angola",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Angola",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Angola",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Angola",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Angola",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Angola",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Angola",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Angola",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Angola",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Angola",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Angola",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Angola",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Angola",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Angola",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "Anguilla": [
            {
                "Region Name": "Anguilla",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anguilla",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anguilla",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anguilla",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anguilla",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anguilla",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anguilla",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anguilla",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anguilla",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anguilla",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anguilla",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anguilla",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anguilla",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anguilla",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anguilla",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anguilla",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anguilla",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anguilla",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anguilla",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anguilla",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anguilla",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anguilla",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Antarctica": [
            {
                "Region Name": "Antarctica",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Antigua and Barbuda": [
            {
                "Region Name": "Antigua and Barbuda",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antigua and Barbuda",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antigua and Barbuda",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antigua and Barbuda",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antigua and Barbuda",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antigua and Barbuda",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antigua and Barbuda",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antigua and Barbuda",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antigua and Barbuda",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antigua and Barbuda",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antigua and Barbuda",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antigua and Barbuda",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antigua and Barbuda",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antigua and Barbuda",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antigua and Barbuda",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antigua and Barbuda",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antigua and Barbuda",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antigua and Barbuda",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antigua and Barbuda",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antigua and Barbuda",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antigua and Barbuda",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antigua and Barbuda",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Argentina": [
            {
                "Region Name": "Argentina",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Argentina",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Argentina",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Argentina",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Argentina",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Argentina",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Argentina",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Argentina",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Argentina",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Argentina",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Argentina",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Argentina",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Argentina",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Argentina",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Argentina",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Argentina",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Argentina",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Argentina",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Argentina",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Argentina",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Argentina",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Argentina",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Armenia": [
            {
                "Region Name": "Armenia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Armenia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Armenia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Armenia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Armenia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Armenia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Armenia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Armenia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Armenia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Armenia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Armenia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Armenia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Armenia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Armenia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Armenia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Armenia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Armenia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Armenia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Armenia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Armenia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Armenia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Armenia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Aruba": [
            {
                "Region Name": "Aruba",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aruba",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aruba",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aruba",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aruba",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aruba",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aruba",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aruba",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aruba",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aruba",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aruba",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aruba",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aruba",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aruba",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aruba",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aruba",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aruba",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aruba",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aruba",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aruba",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aruba",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aruba",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Australia": [
            {
                "Region Name": "Australia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 113
            },
            {
                "Region Name": "Australia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Australia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "Australia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Australia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 66
            },
            {
                "Region Name": "Australia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 66
            },
            {
                "Region Name": "Australia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Australia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Australia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Australia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Australia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 76
            },
            {
                "Region Name": "Australia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Australia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Australia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 57
            },
            {
                "Region Name": "Australia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Australia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Australia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "Australia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Australia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Australia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Australia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Australia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 52
            }
        ],
        "Austria": [
            {
                "Region Name": "Austria",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Austria",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Austria",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Austria",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Austria",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Austria",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austria",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Austria",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Austria",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austria",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Austria",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austria",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Austria",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Austria",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austria",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Austria",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Austria",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Austria",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austria",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Austria",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austria",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Austria",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Azerbaijan": [
            {
                "Region Name": "Azerbaijan",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Azerbaijan",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Azerbaijan",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Azerbaijan",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Azerbaijan",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Azerbaijan",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Azerbaijan",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Azerbaijan",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Azerbaijan",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Azerbaijan",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Azerbaijan",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Azerbaijan",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Azerbaijan",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Azerbaijan",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Azerbaijan",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Azerbaijan",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Azerbaijan",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Azerbaijan",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Azerbaijan",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Azerbaijan",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Azerbaijan",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Azerbaijan",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Bahamas": [
            {
                "Region Name": "Bahamas",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Bahamas",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Bahamas",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Bahamas",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bahamas",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Bahamas",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Bahamas",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Bahamas",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Bahamas",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bahamas",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Bahamas",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Bahamas",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Bahamas",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Bahamas",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Bahamas",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Bahamas",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Bahamas",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bahamas",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Bahamas",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Bahamas",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bahamas",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bahamas",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Bahrain": [
            {
                "Region Name": "Bahrain",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bahrain",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bahrain",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bahrain",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bahrain",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bahrain",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bahrain",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bahrain",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bahrain",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bahrain",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bahrain",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bahrain",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bahrain",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bahrain",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bahrain",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bahrain",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bahrain",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bahrain",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bahrain",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bahrain",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bahrain",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bahrain",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bangladesh": [
            {
                "Region Name": "Bangladesh",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bangladesh",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bangladesh",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bangladesh",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bangladesh",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bangladesh",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bangladesh",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bangladesh",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bangladesh",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bangladesh",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bangladesh",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bangladesh",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bangladesh",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bangladesh",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bangladesh",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bangladesh",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bangladesh",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bangladesh",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bangladesh",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bangladesh",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bangladesh",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bangladesh",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Barbados": [
            {
                "Region Name": "Barbados",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbados",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbados",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbados",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbados",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbados",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbados",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbados",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Barbados",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbados",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbados",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbados",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbados",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbados",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbados",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbados",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbados",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbados",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbados",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbados",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbados",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbados",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Bassas Da India": [
            {
                "Region Name": "Bassas Da India",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bassas Da India",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bassas Da India",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bassas Da India",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bassas Da India",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bassas Da India",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bassas Da India",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bassas Da India",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bassas Da India",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bassas Da India",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bassas Da India",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bassas Da India",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bassas Da India",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bassas Da India",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bassas Da India",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bassas Da India",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bassas Da India",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bassas Da India",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bassas Da India",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bassas Da India",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bassas Da India",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bassas Da India",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Belarus": [
            {
                "Region Name": "Belarus",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Belarus",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Belarus",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Belarus",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Belarus",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Belarus",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Belarus",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Belarus",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Belarus",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Belarus",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Belarus",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Belarus",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Belarus",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Belarus",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Belarus",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Belarus",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Belarus",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Belarus",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Belarus",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Belarus",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Belarus",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Belarus",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Belgium": [
            {
                "Region Name": "Belgium",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belgium",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belgium",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Belgium",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belgium",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Belgium",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Belgium",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belgium",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Belgium",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belgium",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Belgium",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Belgium",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belgium",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Belgium",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belgium",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Belgium",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belgium",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belgium",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belgium",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Belgium",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belgium",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belgium",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Belize": [
            {
                "Region Name": "Belize",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Belize",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Belize",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Belize",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Belize",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Belize",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Belize",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Belize",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Belize",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Belize",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Belize",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Belize",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Belize",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Belize",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Belize",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Belize",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Belize",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Belize",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Belize",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Belize",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Belize",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Belize",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Benin": [
            {
                "Region Name": "Benin",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Benin",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Benin",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Benin",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Benin",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Benin",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Benin",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Benin",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Benin",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Benin",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Benin",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Benin",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Benin",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Benin",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Benin",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Benin",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Benin",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Benin",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Benin",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Benin",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Benin",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Benin",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "Bermuda": [
            {
                "Region Name": "Bermuda",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bermuda",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bermuda",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bermuda",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bermuda",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bermuda",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bermuda",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bermuda",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bermuda",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bermuda",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bermuda",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bermuda",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bermuda",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bermuda",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bermuda",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bermuda",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bermuda",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bermuda",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bermuda",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bermuda",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bermuda",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bermuda",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bhutan": [
            {
                "Region Name": "Bhutan",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bhutan",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bhutan",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bhutan",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bhutan",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Bhutan",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Bhutan",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bhutan",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bhutan",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bhutan",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bhutan",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bhutan",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bhutan",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Bhutan",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Bhutan",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bhutan",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bhutan",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bhutan",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bhutan",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bhutan",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bhutan",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bhutan",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 25
            }
        ],
        "Bolivia": [
            {
                "Region Name": "Bolivia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Bolivia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bolivia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Bolivia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Bolivia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Bolivia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Bolivia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Bolivia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bolivia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Bolivia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Bolivia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Bolivia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Bolivia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bolivia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Bolivia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Bolivia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Bolivia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bolivia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Bolivia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Bolivia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Bolivia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Bolivia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 27
            }
        ],
        "Bonaire, Sint Eustatius and Saba": [
            {
                "Region Name": "Bonaire, Sint Eustatius and Saba",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire, Sint Eustatius and Saba",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire, Sint Eustatius and Saba",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire, Sint Eustatius and Saba",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire, Sint Eustatius and Saba",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire, Sint Eustatius and Saba",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire, Sint Eustatius and Saba",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire, Sint Eustatius and Saba",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire, Sint Eustatius and Saba",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire, Sint Eustatius and Saba",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire, Sint Eustatius and Saba",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire, Sint Eustatius and Saba",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire, Sint Eustatius and Saba",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire, Sint Eustatius and Saba",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire, Sint Eustatius and Saba",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire, Sint Eustatius and Saba",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire, Sint Eustatius and Saba",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire, Sint Eustatius and Saba",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire, Sint Eustatius and Saba",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire, Sint Eustatius and Saba",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire, Sint Eustatius and Saba",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire, Sint Eustatius and Saba",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bosnia and Herzegovina": [
            {
                "Region Name": "Bosnia and Herzegovina",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bosnia and Herzegovina",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Bosnia and Herzegovina",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Bosnia and Herzegovina",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bosnia and Herzegovina",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Bosnia and Herzegovina",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Bosnia and Herzegovina",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bosnia and Herzegovina",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bosnia and Herzegovina",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bosnia and Herzegovina",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bosnia and Herzegovina",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Bosnia and Herzegovina",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bosnia and Herzegovina",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bosnia and Herzegovina",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bosnia and Herzegovina",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bosnia and Herzegovina",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Bosnia and Herzegovina",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bosnia and Herzegovina",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bosnia and Herzegovina",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bosnia and Herzegovina",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Bosnia and Herzegovina",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bosnia and Herzegovina",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Botswana": [
            {
                "Region Name": "Botswana",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 142
            },
            {
                "Region Name": "Botswana",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 66
            },
            {
                "Region Name": "Botswana",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 110
            },
            {
                "Region Name": "Botswana",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 186
            },
            {
                "Region Name": "Botswana",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 140
            },
            {
                "Region Name": "Botswana",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 129
            },
            {
                "Region Name": "Botswana",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 232
            },
            {
                "Region Name": "Botswana",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 74
            },
            {
                "Region Name": "Botswana",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 409
            },
            {
                "Region Name": "Botswana",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 310
            },
            {
                "Region Name": "Botswana",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 190
            },
            {
                "Region Name": "Botswana",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 176
            },
            {
                "Region Name": "Botswana",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 140
            },
            {
                "Region Name": "Botswana",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 87
            },
            {
                "Region Name": "Botswana",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 92
            },
            {
                "Region Name": "Botswana",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 127
            },
            {
                "Region Name": "Botswana",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 129
            },
            {
                "Region Name": "Botswana",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 74
            },
            {
                "Region Name": "Botswana",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 139
            },
            {
                "Region Name": "Botswana",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 154
            },
            {
                "Region Name": "Botswana",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 167
            },
            {
                "Region Name": "Botswana",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 173
            }
        ],
        "Bouvet Island": [
            {
                "Region Name": "Bouvet Island",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bouvet Island",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bouvet Island",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bouvet Island",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bouvet Island",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bouvet Island",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bouvet Island",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bouvet Island",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bouvet Island",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bouvet Island",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bouvet Island",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bouvet Island",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bouvet Island",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bouvet Island",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bouvet Island",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bouvet Island",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bouvet Island",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bouvet Island",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bouvet Island",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bouvet Island",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bouvet Island",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bouvet Island",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Brazil": [
            {
                "Region Name": "Brazil",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Brazil",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Brazil",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Brazil",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Brazil",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Brazil",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Brazil",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Brazil",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Brazil",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Brazil",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Brazil",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Brazil",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Brazil",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Brazil",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Brazil",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Brazil",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Brazil",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Brazil",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Brazil",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Brazil",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Brazil",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Brazil",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "British Indian Ocean Territory": [
            {
                "Region Name": "British Indian Ocean Territory",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Indian Ocean Territory",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Indian Ocean Territory",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Indian Ocean Territory",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Indian Ocean Territory",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Indian Ocean Territory",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Indian Ocean Territory",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Indian Ocean Territory",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Indian Ocean Territory",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Indian Ocean Territory",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Indian Ocean Territory",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Indian Ocean Territory",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Indian Ocean Territory",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Indian Ocean Territory",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Indian Ocean Territory",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Indian Ocean Territory",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Indian Ocean Territory",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Indian Ocean Territory",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Indian Ocean Territory",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Indian Ocean Territory",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Indian Ocean Territory",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Indian Ocean Territory",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "British Virgin Islands": [
            {
                "Region Name": "British Virgin Islands",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Virgin Islands",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Virgin Islands",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "British Virgin Islands",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Virgin Islands",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Virgin Islands",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Virgin Islands",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Virgin Islands",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Virgin Islands",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Virgin Islands",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Virgin Islands",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Virgin Islands",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Virgin Islands",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Virgin Islands",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Virgin Islands",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Virgin Islands",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Virgin Islands",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Virgin Islands",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Virgin Islands",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Virgin Islands",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Virgin Islands",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "British Virgin Islands",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Brunei": [
            {
                "Region Name": "Brunei",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Brunei",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Brunei",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Brunei",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Brunei",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Brunei",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Brunei",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Brunei",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Brunei",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Brunei",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Bulgaria": [
            {
                "Region Name": "Bulgaria",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bulgaria",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bulgaria",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bulgaria",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bulgaria",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bulgaria",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bulgaria",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bulgaria",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bulgaria",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bulgaria",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bulgaria",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bulgaria",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bulgaria",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bulgaria",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bulgaria",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bulgaria",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bulgaria",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bulgaria",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bulgaria",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bulgaria",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bulgaria",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Bulgaria",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Burkina Faso": [
            {
                "Region Name": "Burkina Faso",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Burkina Faso",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Burkina Faso",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Burkina Faso",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Burkina Faso",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Burkina Faso",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Burkina Faso",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Burkina Faso",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Burkina Faso",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Burkina Faso",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Burkina Faso",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Burkina Faso",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Burkina Faso",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Burkina Faso",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Burkina Faso",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Burkina Faso",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Burkina Faso",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Burkina Faso",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Burkina Faso",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Burkina Faso",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Burkina Faso",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Burkina Faso",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 27
            }
        ],
        "Burundi": [
            {
                "Region Name": "Burundi",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Burundi",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Burundi",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Burundi",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Burundi",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Burundi",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Burundi",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Burundi",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Burundi",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Burundi",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Burundi",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Burundi",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Burundi",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Burundi",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Burundi",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Burundi",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Burundi",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Burundi",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Burundi",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Burundi",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Burundi",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Burundi",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Cambodia": [
            {
                "Region Name": "Cambodia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Cambodia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Cambodia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cambodia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Cambodia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Cambodia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Cambodia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Cambodia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cambodia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Cambodia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cambodia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cambodia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cambodia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cambodia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cambodia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Cambodia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cambodia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cambodia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cambodia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cambodia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cambodia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cambodia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Cameroon": [
            {
                "Region Name": "Cameroon",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Cameroon",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Cameroon",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Cameroon",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Cameroon",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Cameroon",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cameroon",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cameroon",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Cameroon",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cameroon",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cameroon",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cameroon",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cameroon",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cameroon",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cameroon",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cameroon",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cameroon",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cameroon",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cameroon",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cameroon",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cameroon",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cameroon",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Canada": [
            {
                "Region Name": "Canada",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Canada",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Canada",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Canada",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Canada",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Canada",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Canada",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Canada",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Canada",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Canada",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Canada",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Canada",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Canada",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Canada",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Canada",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Canada",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Canada",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Canada",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Canada",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Canada",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Canada",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Canada",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 54
            }
        ],
        "Cape Verde": [
            {
                "Region Name": "Cape Verde",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cape Verde",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cape Verde",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cape Verde",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cape Verde",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cape Verde",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cape Verde",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cape Verde",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cape Verde",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cape Verde",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cape Verde",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cape Verde",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cape Verde",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cape Verde",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cape Verde",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cape Verde",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cape Verde",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cape Verde",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cape Verde",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cape Verde",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cape Verde",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cape Verde",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Cayman Islands": [
            {
                "Region Name": "Cayman Islands",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayman Islands",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayman Islands",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayman Islands",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayman Islands",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayman Islands",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayman Islands",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayman Islands",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayman Islands",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayman Islands",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayman Islands",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayman Islands",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayman Islands",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayman Islands",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayman Islands",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayman Islands",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayman Islands",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayman Islands",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayman Islands",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayman Islands",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayman Islands",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayman Islands",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Central African Republic": [
            {
                "Region Name": "Central African Republic",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Central African Republic",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Central African Republic",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Central African Republic",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Central African Republic",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Central African Republic",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Central African Republic",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Central African Republic",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Central African Republic",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Central African Republic",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Central African Republic",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Central African Republic",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Central African Republic",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Central African Republic",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Central African Republic",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Central African Republic",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Central African Republic",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Central African Republic",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Central African Republic",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Central African Republic",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Central African Republic",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Central African Republic",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Chad": [
            {
                "Region Name": "Chad",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Chad",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Chad",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Chad",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Chad",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Chad",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Chad",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Chad",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Chad",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Chad",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Chad",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Chad",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Chad",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Chad",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Chad",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Chad",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Chad",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Chad",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Chad",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Chad",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Chad",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Chad",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Chile": [
            {
                "Region Name": "Chile",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chile",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chile",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chile",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chile",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chile",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chile",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chile",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Chile",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chile",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chile",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chile",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chile",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chile",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Chile",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Chile",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chile",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chile",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chile",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chile",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Chile",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Chile",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "China": [
            {
                "Region Name": "China",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "China",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "China",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "China",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "China",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "China",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "China",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "China",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "China",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "China",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "China",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "China",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "China",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "China",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "China",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "China",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "China",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "China",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "China",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "China",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "China",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "China",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Christmas Island": [
            {
                "Region Name": "Christmas Island",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christmas Island",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christmas Island",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christmas Island",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christmas Island",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christmas Island",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christmas Island",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christmas Island",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christmas Island",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christmas Island",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christmas Island",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christmas Island",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christmas Island",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christmas Island",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christmas Island",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christmas Island",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christmas Island",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christmas Island",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christmas Island",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christmas Island",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christmas Island",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christmas Island",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Clipperton Island": [
            {
                "Region Name": "Clipperton Island",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clipperton Island",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clipperton Island",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clipperton Island",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clipperton Island",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clipperton Island",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clipperton Island",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clipperton Island",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clipperton Island",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clipperton Island",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clipperton Island",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clipperton Island",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clipperton Island",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clipperton Island",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clipperton Island",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clipperton Island",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clipperton Island",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clipperton Island",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clipperton Island",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clipperton Island",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clipperton Island",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clipperton Island",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cocos (Keeling) Islands": [
            {
                "Region Name": "Cocos (Keeling) Islands",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cocos (Keeling) Islands",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cocos (Keeling) Islands",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cocos (Keeling) Islands",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cocos (Keeling) Islands",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cocos (Keeling) Islands",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cocos (Keeling) Islands",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cocos (Keeling) Islands",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cocos (Keeling) Islands",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cocos (Keeling) Islands",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cocos (Keeling) Islands",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cocos (Keeling) Islands",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cocos (Keeling) Islands",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cocos (Keeling) Islands",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cocos (Keeling) Islands",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cocos (Keeling) Islands",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cocos (Keeling) Islands",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cocos (Keeling) Islands",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cocos (Keeling) Islands",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cocos (Keeling) Islands",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cocos (Keeling) Islands",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cocos (Keeling) Islands",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Colombia": [
            {
                "Region Name": "Colombia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Colombia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Colombia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Colombia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Colombia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Colombia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Colombia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Colombia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Colombia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Colombia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Colombia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Colombia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Colombia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Colombia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Colombia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Colombia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Colombia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Colombia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Colombia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Colombia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Colombia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Colombia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Comoros": [
            {
                "Region Name": "Comoros",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comoros",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Comoros",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comoros",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Comoros",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Comoros",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Comoros",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Comoros",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Comoros",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Comoros",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Comoros",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Comoros",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Comoros",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Comoros",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Comoros",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Comoros",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comoros",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Comoros",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Comoros",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comoros",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comoros",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Comoros",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Congo": [
            {
                "Region Name": "Congo",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Congo",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Congo",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Congo",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Congo",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Congo",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Congo",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Congo",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Congo",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Congo",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Congo",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Congo",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Congo",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Congo",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Congo",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Congo",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Congo",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Congo",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Congo",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Congo",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Congo",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Congo",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Cook Islands": [
            {
                "Region Name": "Cook Islands",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cook Islands",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cook Islands",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cook Islands",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cook Islands",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cook Islands",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cook Islands",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cook Islands",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cook Islands",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cook Islands",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cook Islands",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cook Islands",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cook Islands",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cook Islands",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cook Islands",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cook Islands",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cook Islands",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cook Islands",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cook Islands",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cook Islands",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cook Islands",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cook Islands",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Costa Rica": [
            {
                "Region Name": "Costa Rica",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Costa Rica",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Costa Rica",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Costa Rica",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Costa Rica",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Costa Rica",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Costa Rica",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Costa Rica",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Costa Rica",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Costa Rica",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Costa Rica",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Costa Rica",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Costa Rica",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Costa Rica",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Costa Rica",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Costa Rica",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Costa Rica",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Costa Rica",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Costa Rica",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Costa Rica",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Costa Rica",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Costa Rica",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "C\xf4te d'Ivoire": [
            {
                "Region Name": "C\xf4te d'Ivoire",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "C\xf4te d'Ivoire",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "C\xf4te d'Ivoire",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "C\xf4te d'Ivoire",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "C\xf4te d'Ivoire",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "C\xf4te d'Ivoire",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "C\xf4te d'Ivoire",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "C\xf4te d'Ivoire",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "C\xf4te d'Ivoire",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "C\xf4te d'Ivoire",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "C\xf4te d'Ivoire",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "C\xf4te d'Ivoire",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "C\xf4te d'Ivoire",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "C\xf4te d'Ivoire",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "C\xf4te d'Ivoire",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "C\xf4te d'Ivoire",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "C\xf4te d'Ivoire",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "C\xf4te d'Ivoire",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "C\xf4te d'Ivoire",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "C\xf4te d'Ivoire",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "C\xf4te d'Ivoire",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "C\xf4te d'Ivoire",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Croatia": [
            {
                "Region Name": "Croatia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Croatia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Croatia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Croatia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Croatia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Croatia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Croatia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Croatia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Croatia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Croatia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Croatia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Croatia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Croatia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Croatia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Croatia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Croatia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Croatia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Croatia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Croatia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Croatia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Croatia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Croatia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Cuba": [
            {
                "Region Name": "Cuba",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuba",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cuba",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cuba",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuba",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cuba",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuba",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuba",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cuba",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuba",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuba",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cuba",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cuba",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cuba",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cuba",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cuba",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cuba",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cuba",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuba",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuba",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cuba",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuba",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Cura\xe7ao": [
            {
                "Region Name": "Cura\xe7ao",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cura\xe7ao",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cura\xe7ao",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cura\xe7ao",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cura\xe7ao",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cura\xe7ao",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cura\xe7ao",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cura\xe7ao",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cura\xe7ao",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cura\xe7ao",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cura\xe7ao",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cura\xe7ao",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cura\xe7ao",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cura\xe7ao",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cura\xe7ao",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cura\xe7ao",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cura\xe7ao",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cura\xe7ao",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cura\xe7ao",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cura\xe7ao",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cura\xe7ao",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cura\xe7ao",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cyprus": [
            {
                "Region Name": "Cyprus",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cyprus",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cyprus",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cyprus",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cyprus",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cyprus",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cyprus",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Cyprus",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cyprus",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cyprus",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cyprus",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Cyprus",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cyprus",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cyprus",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cyprus",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Cyprus",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cyprus",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cyprus",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cyprus",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cyprus",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Cyprus",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Cyprus",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Czechia": [
            {
                "Region Name": "Czechia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Czechia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Czechia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Czechia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Czechia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Czechia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Czechia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Czechia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Czechia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Czechia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Czechia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Czechia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Czechia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Czechia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Czechia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Czechia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Czechia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Czechia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Czechia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Czechia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Czechia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Czechia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Democratic Republic of The Congo": [
            {
                "Region Name": "Democratic Republic of The Congo",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Democratic Republic of The Congo",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Democratic Republic of The Congo",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Democratic Republic of The Congo",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Democratic Republic of The Congo",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Democratic Republic of The Congo",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Democratic Republic of The Congo",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Democratic Republic of The Congo",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Democratic Republic of The Congo",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Democratic Republic of The Congo",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Democratic Republic of The Congo",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Democratic Republic of The Congo",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Democratic Republic of The Congo",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Democratic Republic of The Congo",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Democratic Republic of The Congo",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Democratic Republic of The Congo",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Democratic Republic of The Congo",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Democratic Republic of The Congo",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Democratic Republic of The Congo",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Democratic Republic of The Congo",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Democratic Republic of The Congo",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Democratic Republic of The Congo",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Denmark": [
            {
                "Region Name": "Denmark",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Denmark",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Denmark",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Denmark",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denmark",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Denmark",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Denmark",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Denmark",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Denmark",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denmark",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denmark",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Denmark",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Denmark",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denmark",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Denmark",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denmark",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denmark",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Denmark",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Denmark",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denmark",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denmark",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Denmark",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Djibouti": [
            {
                "Region Name": "Djibouti",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djibouti",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djibouti",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djibouti",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djibouti",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Djibouti",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djibouti",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djibouti",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djibouti",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djibouti",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Djibouti",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djibouti",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djibouti",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djibouti",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djibouti",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Djibouti",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Djibouti",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djibouti",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djibouti",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Djibouti",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djibouti",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Djibouti",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Dominica": [
            {
                "Region Name": "Dominica",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dominica",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dominica",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dominica",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dominica",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dominica",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dominica",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dominica",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dominica",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dominica",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dominica",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dominica",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dominica",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dominica",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dominica",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dominica",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dominica",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dominica",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dominica",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dominica",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dominica",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dominica",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dominican Republic": [
            {
                "Region Name": "Dominican Republic",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dominican Republic",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dominican Republic",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dominican Republic",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Dominican Republic",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dominican Republic",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dominican Republic",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dominican Republic",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dominican Republic",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Dominican Republic",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dominican Republic",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dominican Republic",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dominican Republic",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dominican Republic",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dominican Republic",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dominican Republic",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dominican Republic",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Dominican Republic",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dominican Republic",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dominican Republic",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Dominican Republic",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dominican Republic",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Ecuador": [
            {
                "Region Name": "Ecuador",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ecuador",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ecuador",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ecuador",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ecuador",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ecuador",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ecuador",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ecuador",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ecuador",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ecuador",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ecuador",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ecuador",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ecuador",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ecuador",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ecuador",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ecuador",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ecuador",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ecuador",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ecuador",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ecuador",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Ecuador",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ecuador",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Egypt": [
            {
                "Region Name": "Egypt",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Egypt",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Egypt",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Egypt",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Egypt",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Egypt",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Egypt",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Egypt",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Egypt",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Egypt",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Egypt",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Egypt",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Egypt",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Egypt",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Egypt",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Egypt",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Egypt",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Egypt",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Egypt",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Egypt",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Egypt",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Egypt",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "El Salvador": [
            {
                "Region Name": "El Salvador",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "El Salvador",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "El Salvador",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "El Salvador",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "El Salvador",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "El Salvador",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "El Salvador",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "El Salvador",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "El Salvador",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "El Salvador",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "El Salvador",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "El Salvador",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "El Salvador",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "El Salvador",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "El Salvador",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "El Salvador",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "El Salvador",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "El Salvador",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "El Salvador",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "El Salvador",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "El Salvador",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "El Salvador",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Equatorial Guinea": [
            {
                "Region Name": "Equatorial Guinea",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Equatorial Guinea",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Equatorial Guinea",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Equatorial Guinea",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Equatorial Guinea",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Equatorial Guinea",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Equatorial Guinea",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Equatorial Guinea",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Equatorial Guinea",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Equatorial Guinea",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Equatorial Guinea",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Equatorial Guinea",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Equatorial Guinea",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Equatorial Guinea",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Equatorial Guinea",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Equatorial Guinea",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Equatorial Guinea",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Equatorial Guinea",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Equatorial Guinea",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Equatorial Guinea",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Equatorial Guinea",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Equatorial Guinea",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Eritrea": [
            {
                "Region Name": "Eritrea",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Eritrea",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Eritrea",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 59
            },
            {
                "Region Name": "Eritrea",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Eritrea",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Eritrea",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Eritrea",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Eritrea",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Eritrea",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Eritrea",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Eritrea",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Eritrea",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Eritrea",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Eritrea",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Eritrea",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Eritrea",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Eritrea",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Eritrea",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Eritrea",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Eritrea",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Eritrea",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Eritrea",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "Estonia": [
            {
                "Region Name": "Estonia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Estonia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Estonia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Estonia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Estonia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Estonia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Estonia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Estonia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Estonia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Estonia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Estonia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Estonia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Estonia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Estonia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Estonia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Estonia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Estonia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Estonia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Estonia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Estonia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Estonia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Estonia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Eswatini": [
            {
                "Region Name": "Eswatini",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Eswatini",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Eswatini",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Eswatini",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Eswatini",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Eswatini",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Eswatini",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Eswatini",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Eswatini",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Eswatini",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Eswatini",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Eswatini",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Eswatini",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Eswatini",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Eswatini",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Eswatini",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Eswatini",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Eswatini",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Eswatini",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Eswatini",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Eswatini",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Eswatini",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Ethiopia": [
            {
                "Region Name": "Ethiopia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Ethiopia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Ethiopia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Ethiopia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Ethiopia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Ethiopia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Ethiopia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Ethiopia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Ethiopia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Ethiopia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Ethiopia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Ethiopia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Ethiopia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Ethiopia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Ethiopia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Ethiopia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Ethiopia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Ethiopia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Ethiopia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Ethiopia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Ethiopia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Ethiopia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Faroes": [
            {
                "Region Name": "Faroes",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faroes",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faroes",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faroes",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faroes",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faroes",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faroes",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faroes",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faroes",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faroes",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faroes",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faroes",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faroes",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faroes",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faroes",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faroes",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faroes",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faroes",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faroes",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faroes",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faroes",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faroes",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Fiji": [
            {
                "Region Name": "Fiji",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiji",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Fiji",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Fiji",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiji",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Fiji",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Fiji",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Fiji",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Fiji",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Fiji",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiji",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiji",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Fiji",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Fiji",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Fiji",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Fiji",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Fiji",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Fiji",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Fiji",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiji",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Fiji",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Fiji",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Finland": [
            {
                "Region Name": "Finland",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Finland",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Finland",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finland",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finland",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Finland",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Finland",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Finland",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Finland",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Finland",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Finland",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finland",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Finland",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finland",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Finland",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Finland",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finland",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Finland",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Finland",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finland",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Finland",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finland",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "France": [
            {
                "Region Name": "France",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "France",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "France",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "France",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "France",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "France",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "France",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "France",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "France",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "France",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "France",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "France",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "France",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "France",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "France",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "France",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "France",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "France",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "France",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "France",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "France",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "France",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "French Polynesia": [
            {
                "Region Name": "French Polynesia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Polynesia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Polynesia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Polynesia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Polynesia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Polynesia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Polynesia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Polynesia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Polynesia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Polynesia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Polynesia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Polynesia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Polynesia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Polynesia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Polynesia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Polynesia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Polynesia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Polynesia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Polynesia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Polynesia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Polynesia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Polynesia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "French Southern and Antarctic Lands": [
            {
                "Region Name": "French Southern and Antarctic Lands",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Southern and Antarctic Lands",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Southern and Antarctic Lands",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Southern and Antarctic Lands",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Southern and Antarctic Lands",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Southern and Antarctic Lands",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Southern and Antarctic Lands",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Southern and Antarctic Lands",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Southern and Antarctic Lands",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Southern and Antarctic Lands",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Southern and Antarctic Lands",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Southern and Antarctic Lands",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Southern and Antarctic Lands",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Southern and Antarctic Lands",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Southern and Antarctic Lands",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Southern and Antarctic Lands",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Southern and Antarctic Lands",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Southern and Antarctic Lands",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Southern and Antarctic Lands",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Southern and Antarctic Lands",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Southern and Antarctic Lands",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "French Southern and Antarctic Lands",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gabon": [
            {
                "Region Name": "Gabon",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Gabon",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Gabon",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Gabon",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Gabon",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Gabon",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Gabon",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Gabon",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Gabon",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Gabon",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Gabon",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Gabon",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Gabon",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Gabon",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Gabon",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Gabon",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Gabon",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Gabon",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Gabon",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Gabon",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Gabon",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Gabon",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Gambia": [
            {
                "Region Name": "Gambia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Gambia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Gambia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Gambia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Gambia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Gambia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Gambia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Gambia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Gambia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Gambia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Gambia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Gambia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Gambia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Gambia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Gambia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Gambia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Gambia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Gambia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Gambia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Gambia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Gambia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Gambia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Georgia": [
            {
                "Region Name": "Georgia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Georgia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Georgia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Georgia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Georgia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Georgia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Georgia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Georgia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Georgia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Georgia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Georgia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Georgia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Georgia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Georgia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Georgia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Georgia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Georgia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Georgia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Georgia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Georgia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Georgia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Georgia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Germany": [
            {
                "Region Name": "Germany",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Germany",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Germany",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Germany",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Germany",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Germany",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Germany",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Germany",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Germany",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Germany",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Germany",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Germany",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Germany",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Germany",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Germany",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Germany",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Germany",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Germany",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Germany",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Germany",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Germany",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Germany",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Ghana": [
            {
                "Region Name": "Ghana",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Ghana",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Ghana",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Ghana",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Ghana",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Ghana",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Ghana",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Ghana",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Ghana",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Ghana",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Ghana",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Ghana",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Ghana",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Ghana",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Ghana",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Ghana",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Ghana",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Ghana",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Ghana",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Ghana",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Ghana",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Ghana",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "Gibraltar": [
            {
                "Region Name": "Gibraltar",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gibraltar",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gibraltar",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gibraltar",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gibraltar",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gibraltar",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gibraltar",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gibraltar",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gibraltar",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gibraltar",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gibraltar",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gibraltar",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gibraltar",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gibraltar",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gibraltar",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gibraltar",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gibraltar",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gibraltar",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gibraltar",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gibraltar",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gibraltar",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gibraltar",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Greece": [
            {
                "Region Name": "Greece",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Greece",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Greece",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Greece",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Greece",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Greece",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Greece",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Greece",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Greece",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Greece",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Greece",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Greece",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Greece",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Greece",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Greece",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Greece",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Greece",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Greece",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Greece",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Greece",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 105
            },
            {
                "Region Name": "Greece",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Greece",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 172
            }
        ],
        "Greenland": [
            {
                "Region Name": "Greenland",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Greenland",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Greenland",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Greenland",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Greenland",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Greenland",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Greenland",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Greenland",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Greenland",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Greenland",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Greenland",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Greenland",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Greenland",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Greenland",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Greenland",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Greenland",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Greenland",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Greenland",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Greenland",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Greenland",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Greenland",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Greenland",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Grenada": [
            {
                "Region Name": "Grenada",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenada",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenada",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenada",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenada",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenada",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grenada",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenada",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenada",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenada",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenada",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenada",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenada",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenada",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenada",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenada",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenada",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenada",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenada",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenada",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenada",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenada",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Guam": [
            {
                "Region Name": "Guam",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guam",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guam",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guam",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guam",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guam",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guam",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guam",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guam",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guam",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guam",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guam",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guam",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guam",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guam",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guam",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guam",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guam",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guam",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guam",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guam",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guam",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Guatemala": [
            {
                "Region Name": "Guatemala",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guatemala",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guatemala",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guatemala",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Guatemala",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guatemala",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guatemala",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guatemala",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guatemala",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guatemala",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guatemala",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guatemala",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guatemala",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guatemala",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guatemala",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guatemala",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guatemala",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guatemala",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guatemala",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guatemala",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guatemala",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guatemala",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Guernsey": [
            {
                "Region Name": "Guernsey",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guernsey",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guernsey",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guernsey",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guernsey",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guernsey",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guernsey",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guernsey",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guernsey",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guernsey",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guernsey",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guernsey",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guernsey",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guernsey",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guernsey",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guernsey",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guernsey",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guernsey",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guernsey",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guernsey",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guernsey",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guernsey",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Guinea": [
            {
                "Region Name": "Guinea",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Guinea",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guinea",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guinea",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guinea",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Guinea",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guinea",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guinea",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guinea",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guinea",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guinea",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guinea",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guinea",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guinea",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Guinea",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guinea",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guinea",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guinea",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guinea",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guinea",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guinea",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guinea",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Guinea-Bissau": [
            {
                "Region Name": "Guinea-Bissau",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Guinea-Bissau",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Guinea-Bissau",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Guinea-Bissau",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Guinea-Bissau",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Guinea-Bissau",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guinea-Bissau",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Guinea-Bissau",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guinea-Bissau",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Guinea-Bissau",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Guinea-Bissau",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guinea-Bissau",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Guinea-Bissau",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Guinea-Bissau",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guinea-Bissau",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Guinea-Bissau",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Guinea-Bissau",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Guinea-Bissau",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Guinea-Bissau",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guinea-Bissau",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Guinea-Bissau",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guinea-Bissau",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Guyana": [
            {
                "Region Name": "Guyana",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guyana",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Guyana",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guyana",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guyana",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Guyana",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guyana",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guyana",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guyana",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guyana",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Guyana",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guyana",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guyana",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Guyana",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guyana",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guyana",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guyana",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guyana",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guyana",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guyana",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guyana",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Guyana",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Haiti": [
            {
                "Region Name": "Haiti",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Haiti",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Haiti",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Haiti",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Haiti",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Haiti",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Haiti",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Haiti",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Haiti",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Haiti",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Haiti",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Haiti",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Haiti",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Haiti",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Haiti",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Haiti",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Haiti",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Haiti",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Haiti",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Haiti",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Haiti",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Haiti",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Heard Island and Mcdonald Islands": [
            {
                "Region Name": "Heard Island and Mcdonald Islands",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heard Island and Mcdonald Islands",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heard Island and Mcdonald Islands",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heard Island and Mcdonald Islands",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heard Island and Mcdonald Islands",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heard Island and Mcdonald Islands",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heard Island and Mcdonald Islands",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heard Island and Mcdonald Islands",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heard Island and Mcdonald Islands",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heard Island and Mcdonald Islands",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heard Island and Mcdonald Islands",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heard Island and Mcdonald Islands",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heard Island and Mcdonald Islands",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heard Island and Mcdonald Islands",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heard Island and Mcdonald Islands",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heard Island and Mcdonald Islands",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heard Island and Mcdonald Islands",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heard Island and Mcdonald Islands",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heard Island and Mcdonald Islands",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heard Island and Mcdonald Islands",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heard Island and Mcdonald Islands",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heard Island and Mcdonald Islands",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Honduras": [
            {
                "Region Name": "Honduras",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Honduras",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Honduras",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Honduras",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Honduras",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Honduras",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Honduras",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Honduras",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Honduras",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Honduras",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Honduras",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Honduras",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Honduras",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Honduras",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Honduras",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Honduras",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Honduras",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Honduras",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Honduras",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Honduras",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Honduras",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Honduras",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Hong Kong": [
            {
                "Region Name": "Hong Kong",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hong Kong",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hong Kong",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hong Kong",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hong Kong",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Hong Kong",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Hong Kong",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hong Kong",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hong Kong",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hong Kong",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hong Kong",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hong Kong",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hong Kong",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hong Kong",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Hong Kong",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hong Kong",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hong Kong",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hong Kong",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hong Kong",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hong Kong",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hong Kong",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hong Kong",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hungary": [
            {
                "Region Name": "Hungary",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hungary",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Hungary",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hungary",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hungary",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Hungary",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hungary",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hungary",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hungary",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hungary",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hungary",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hungary",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Hungary",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hungary",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hungary",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hungary",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hungary",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hungary",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hungary",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hungary",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hungary",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Hungary",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Iceland": [
            {
                "Region Name": "Iceland",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iceland",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iceland",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iceland",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iceland",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Iceland",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iceland",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iceland",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iceland",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iceland",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iceland",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iceland",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iceland",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iceland",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iceland",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iceland",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iceland",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iceland",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iceland",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iceland",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iceland",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iceland",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "India": [
            {
                "Region Name": "India",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "India",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "India",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "India",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "India",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "India",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "India",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "India",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "India",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "India",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "India",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "India",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "India",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "India",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "India",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "India",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "India",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "India",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "India",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "India",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "India",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "India",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Indonesia": [
            {
                "Region Name": "Indonesia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Indonesia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Indonesia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Indonesia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Indonesia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Indonesia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Indonesia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Indonesia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Indonesia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Indonesia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Indonesia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Indonesia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Indonesia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Indonesia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Indonesia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Indonesia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Indonesia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Indonesia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Indonesia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Indonesia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Indonesia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Indonesia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Iran": [
            {
                "Region Name": "Iran",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Iran",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Iran",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Iran",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Iran",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Iran",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Iran",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Iran",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Iran",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Iran",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Iran",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Iran",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Iran",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Iran",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Iran",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Iran",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Iran",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Iran",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Iran",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Iran",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Iran",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Iran",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Iraq": [
            {
                "Region Name": "Iraq",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Iraq",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Iraq",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Iraq",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Iraq",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Iraq",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Iraq",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Iraq",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Iraq",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Iraq",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Iraq",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Iraq",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Iraq",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Iraq",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Iraq",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Iraq",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Iraq",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Iraq",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Iraq",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Iraq",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Iraq",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Iraq",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Ireland": [
            {
                "Region Name": "Ireland",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ireland",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ireland",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ireland",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ireland",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ireland",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ireland",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ireland",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ireland",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ireland",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Ireland",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ireland",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ireland",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ireland",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ireland",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ireland",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ireland",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ireland",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ireland",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ireland",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ireland",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ireland",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Isle of Man": [
            {
                "Region Name": "Isle of Man",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isle of Man",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isle of Man",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isle of Man",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isle of Man",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isle of Man",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isle of Man",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isle of Man",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isle of Man",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isle of Man",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isle of Man",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isle of Man",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isle of Man",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isle of Man",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isle of Man",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isle of Man",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isle of Man",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isle of Man",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isle of Man",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isle of Man",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isle of Man",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isle of Man",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Israel": [
            {
                "Region Name": "Israel",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Israel",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Israel",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Israel",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Israel",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Israel",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Israel",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Israel",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Israel",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Israel",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Israel",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Israel",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Israel",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Israel",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Israel",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Israel",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Israel",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Israel",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Israel",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Israel",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Israel",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Israel",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Italy": [
            {
                "Region Name": "Italy",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Italy",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Italy",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Italy",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Italy",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Italy",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Italy",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Italy",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Italy",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Italy",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Italy",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Italy",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Italy",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Italy",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Italy",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Italy",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Italy",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Italy",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Italy",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Italy",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Italy",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Italy",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Jamaica": [
            {
                "Region Name": "Jamaica",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jamaica",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jamaica",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jamaica",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jamaica",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jamaica",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jamaica",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jamaica",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jamaica",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jamaica",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jamaica",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jamaica",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jamaica",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jamaica",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jamaica",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jamaica",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jamaica",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jamaica",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jamaica",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jamaica",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jamaica",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jamaica",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Japan": [
            {
                "Region Name": "Japan",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Japan",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Japan",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Japan",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Japan",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Japan",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Japan",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Japan",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Japan",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Japan",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Japan",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Japan",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Japan",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Japan",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Japan",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Japan",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Japan",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Japan",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Japan",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Japan",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Japan",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Japan",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 21
            }
        ],
        "Jersey": [
            {
                "Region Name": "Jersey",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jersey",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jersey",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jersey",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jersey",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jersey",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jersey",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jersey",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jersey",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jersey",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jersey",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jersey",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jersey",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jersey",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jersey",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jersey",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jersey",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jersey",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jersey",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jersey",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jersey",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jersey",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jordan": [
            {
                "Region Name": "Jordan",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jordan",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jordan",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jordan",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jordan",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jordan",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jordan",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jordan",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jordan",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jordan",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jordan",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jordan",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jordan",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jordan",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jordan",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jordan",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jordan",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jordan",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jordan",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jordan",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jordan",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jordan",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Kazakhstan": [
            {
                "Region Name": "Kazakhstan",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 91
            },
            {
                "Region Name": "Kazakhstan",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Kazakhstan",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Kazakhstan",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "Kazakhstan",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 66
            },
            {
                "Region Name": "Kazakhstan",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Kazakhstan",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Kazakhstan",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Kazakhstan",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "Kazakhstan",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Kazakhstan",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Kazakhstan",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kazakhstan",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Kazakhstan",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Kazakhstan",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Kazakhstan",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Kazakhstan",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Kazakhstan",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Kazakhstan",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Kazakhstan",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Kazakhstan",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Kazakhstan",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "Kenya": [
            {
                "Region Name": "Kenya",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kenya",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kenya",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kenya",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kenya",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kenya",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kenya",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kenya",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kenya",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kenya",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Kenya",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kenya",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kenya",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kenya",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kenya",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kenya",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kenya",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kenya",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Kenya",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kenya",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kenya",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kenya",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Kiribati": [
            {
                "Region Name": "Kiribati",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiribati",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiribati",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiribati",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiribati",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiribati",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiribati",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiribati",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiribati",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiribati",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiribati",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiribati",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiribati",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiribati",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiribati",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiribati",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiribati",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiribati",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiribati",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiribati",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiribati",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiribati",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kuwait": [
            {
                "Region Name": "Kuwait",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kuwait",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kuwait",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kuwait",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kuwait",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kuwait",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kuwait",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kuwait",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kuwait",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kuwait",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kuwait",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kuwait",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuwait",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuwait",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuwait",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kuwait",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kuwait",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kuwait",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kuwait",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kuwait",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kuwait",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kuwait",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Kyrgyzstan": [
            {
                "Region Name": "Kyrgyzstan",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Kyrgyzstan",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kyrgyzstan",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kyrgyzstan",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kyrgyzstan",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kyrgyzstan",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kyrgyzstan",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kyrgyzstan",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kyrgyzstan",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kyrgyzstan",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kyrgyzstan",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kyrgyzstan",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kyrgyzstan",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kyrgyzstan",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kyrgyzstan",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kyrgyzstan",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kyrgyzstan",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kyrgyzstan",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kyrgyzstan",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kyrgyzstan",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kyrgyzstan",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kyrgyzstan",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Laos": [
            {
                "Region Name": "Laos",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Laos",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Laos",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Laos",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Laos",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Laos",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Laos",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Laos",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Laos",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Laos",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Laos",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Laos",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Laos",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Laos",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Laos",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Laos",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Laos",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Laos",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Laos",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Laos",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Laos",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Laos",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Latvia": [
            {
                "Region Name": "Latvia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Latvia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Latvia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Latvia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Latvia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Latvia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Latvia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Latvia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Latvia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Latvia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Latvia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Latvia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Latvia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Latvia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Latvia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Latvia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Latvia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Latvia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Latvia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Latvia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Latvia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Latvia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Lebanon": [
            {
                "Region Name": "Lebanon",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lebanon",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lebanon",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lebanon",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lebanon",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lebanon",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lebanon",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lebanon",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lebanon",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lebanon",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lebanon",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lebanon",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lebanon",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lebanon",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lebanon",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lebanon",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lebanon",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lebanon",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lebanon",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lebanon",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lebanon",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lebanon",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lesotho": [
            {
                "Region Name": "Lesotho",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lesotho",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Lesotho",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lesotho",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Lesotho",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lesotho",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lesotho",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lesotho",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lesotho",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lesotho",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Lesotho",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lesotho",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lesotho",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lesotho",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lesotho",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lesotho",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lesotho",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lesotho",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lesotho",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lesotho",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lesotho",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lesotho",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Liberia": [
            {
                "Region Name": "Liberia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Liberia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Liberia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Liberia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Liberia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Liberia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Liberia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Liberia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Liberia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Liberia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Liberia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Liberia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Liberia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Liberia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Liberia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Liberia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Liberia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Liberia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Liberia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Liberia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Liberia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Liberia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Libya": [
            {
                "Region Name": "Libya",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Libya",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Libya",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libya",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libya",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Libya",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libya",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libya",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libya",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libya",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Libya",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Libya",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Libya",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Libya",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Libya",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Libya",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libya",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libya",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Libya",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Libya",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libya",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libya",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Liechtenstein": [
            {
                "Region Name": "Liechtenstein",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liechtenstein",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liechtenstein",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liechtenstein",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liechtenstein",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liechtenstein",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liechtenstein",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liechtenstein",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liechtenstein",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liechtenstein",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liechtenstein",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liechtenstein",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liechtenstein",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liechtenstein",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liechtenstein",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liechtenstein",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liechtenstein",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liechtenstein",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liechtenstein",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liechtenstein",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liechtenstein",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liechtenstein",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lithuania": [
            {
                "Region Name": "Lithuania",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lithuania",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lithuania",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lithuania",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lithuania",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lithuania",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lithuania",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lithuania",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lithuania",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lithuania",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lithuania",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lithuania",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lithuania",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lithuania",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lithuania",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lithuania",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lithuania",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lithuania",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lithuania",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lithuania",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lithuania",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lithuania",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Luxembourg": [
            {
                "Region Name": "Luxembourg",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Macau": [
            {
                "Region Name": "Macau",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Madagascar": [
            {
                "Region Name": "Madagascar",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Madagascar",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Madagascar",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Madagascar",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Madagascar",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Madagascar",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Madagascar",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Madagascar",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Madagascar",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Madagascar",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Madagascar",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Madagascar",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Madagascar",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Madagascar",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Madagascar",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Madagascar",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Madagascar",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Madagascar",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Madagascar",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Madagascar",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Madagascar",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Madagascar",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Malawi": [
            {
                "Region Name": "Malawi",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Malawi",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Malawi",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Malawi",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Malawi",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Malawi",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Malawi",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Malawi",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Malawi",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Malawi",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Malawi",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Malawi",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Malawi",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Malawi",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Malawi",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Malawi",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Malawi",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Malawi",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Malawi",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Malawi",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Malawi",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Malawi",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Malaysia": [
            {
                "Region Name": "Malaysia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Malaysia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Malaysia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Malaysia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Malaysia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Malaysia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Malaysia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Malaysia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Malaysia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Malaysia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Malaysia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Malaysia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Malaysia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Malaysia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Malaysia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Malaysia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Malaysia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Malaysia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Malaysia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Malaysia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Malaysia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Malaysia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Maldives": [
            {
                "Region Name": "Maldives",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldives",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldives",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldives",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldives",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldives",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldives",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldives",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldives",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldives",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldives",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldives",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldives",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldives",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldives",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldives",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldives",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldives",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldives",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldives",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldives",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldives",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mali": [
            {
                "Region Name": "Mali",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Mali",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Mali",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Mali",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Mali",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Mali",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Mali",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mali",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mali",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mali",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mali",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mali",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mali",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mali",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mali",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mali",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mali",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mali",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mali",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Mali",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Mali",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mali",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "Malta": [
            {
                "Region Name": "Malta",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malta",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malta",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malta",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malta",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malta",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malta",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malta",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malta",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malta",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malta",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malta",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malta",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malta",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malta",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malta",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malta",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malta",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malta",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malta",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malta",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malta",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Marshall Islands": [
            {
                "Region Name": "Marshall Islands",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marshall Islands",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marshall Islands",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marshall Islands",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marshall Islands",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marshall Islands",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marshall Islands",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marshall Islands",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marshall Islands",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marshall Islands",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marshall Islands",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marshall Islands",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marshall Islands",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marshall Islands",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marshall Islands",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marshall Islands",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marshall Islands",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marshall Islands",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marshall Islands",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marshall Islands",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marshall Islands",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marshall Islands",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mauritania": [
            {
                "Region Name": "Mauritania",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Mauritania",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Mauritania",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 80
            },
            {
                "Region Name": "Mauritania",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 68
            },
            {
                "Region Name": "Mauritania",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 101
            },
            {
                "Region Name": "Mauritania",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 125
            },
            {
                "Region Name": "Mauritania",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 97
            },
            {
                "Region Name": "Mauritania",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 93
            },
            {
                "Region Name": "Mauritania",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 129
            },
            {
                "Region Name": "Mauritania",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Mauritania",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 74
            },
            {
                "Region Name": "Mauritania",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Mauritania",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Mauritania",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Mauritania",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Mauritania",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Mauritania",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Mauritania",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 76
            },
            {
                "Region Name": "Mauritania",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 85
            },
            {
                "Region Name": "Mauritania",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Mauritania",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 71
            },
            {
                "Region Name": "Mauritania",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 45
            }
        ],
        "Mauritius": [
            {
                "Region Name": "Mauritius",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mauritius",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mauritius",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauritius",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauritius",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mauritius",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauritius",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauritius",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauritius",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mauritius",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauritius",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mauritius",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mauritius",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mauritius",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauritius",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauritius",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauritius",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mauritius",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauritius",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauritius",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauritius",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauritius",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mexico": [
            {
                "Region Name": "Mexico",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mexico",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mexico",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mexico",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mexico",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mexico",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mexico",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mexico",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mexico",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mexico",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mexico",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mexico",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mexico",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mexico",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mexico",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mexico",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mexico",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mexico",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mexico",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mexico",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mexico",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mexico",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Micronesia": [
            {
                "Region Name": "Micronesia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micronesia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micronesia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micronesia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micronesia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micronesia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micronesia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micronesia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micronesia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micronesia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micronesia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micronesia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micronesia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micronesia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micronesia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micronesia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micronesia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micronesia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micronesia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micronesia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micronesia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micronesia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Moldova": [
            {
                "Region Name": "Moldova",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Moldova",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Moldova",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Moldova",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Moldova",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Moldova",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Moldova",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Moldova",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Moldova",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Moldova",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Moldova",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Moldova",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Moldova",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Moldova",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Moldova",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Moldova",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Moldova",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Moldova",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Moldova",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Moldova",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Moldova",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Moldova",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Mongolia": [
            {
                "Region Name": "Mongolia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Mongolia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 83
            },
            {
                "Region Name": "Mongolia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 90
            },
            {
                "Region Name": "Mongolia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 73
            },
            {
                "Region Name": "Mongolia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 83
            },
            {
                "Region Name": "Mongolia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 73
            },
            {
                "Region Name": "Mongolia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Mongolia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Mongolia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Mongolia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 115
            },
            {
                "Region Name": "Mongolia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "Mongolia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 85
            },
            {
                "Region Name": "Mongolia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 130
            },
            {
                "Region Name": "Mongolia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 88
            },
            {
                "Region Name": "Mongolia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 180
            },
            {
                "Region Name": "Mongolia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Mongolia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mongolia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 158
            },
            {
                "Region Name": "Mongolia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mongolia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mongolia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "Mongolia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 314
            }
        ],
        "Montenegro": [
            {
                "Region Name": "Montenegro",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montenegro",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Montenegro",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montenegro",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montenegro",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Montenegro",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Montenegro",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Montenegro",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Montenegro",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Montenegro",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Montenegro",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Montenegro",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Montenegro",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Montenegro",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Montenegro",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Montenegro",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Montenegro",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Montenegro",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Montenegro",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Montenegro",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Montenegro",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Montenegro",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Montserrat": [
            {
                "Region Name": "Montserrat",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrat",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrat",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrat",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrat",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrat",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrat",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrat",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Montserrat",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrat",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrat",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrat",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrat",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrat",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrat",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrat",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrat",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrat",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrat",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrat",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrat",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrat",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Morocco": [
            {
                "Region Name": "Morocco",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Morocco",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Morocco",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Morocco",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Morocco",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Morocco",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Morocco",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Morocco",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Morocco",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Morocco",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Morocco",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Morocco",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Morocco",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Morocco",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Morocco",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Morocco",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Morocco",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Morocco",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Morocco",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Morocco",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Morocco",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 84
            },
            {
                "Region Name": "Morocco",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 16
            }
        ],
        "Mozambique": [
            {
                "Region Name": "Mozambique",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mozambique",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Mozambique",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mozambique",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mozambique",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mozambique",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mozambique",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Mozambique",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Mozambique",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Mozambique",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mozambique",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mozambique",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Mozambique",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mozambique",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mozambique",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mozambique",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mozambique",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mozambique",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mozambique",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mozambique",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mozambique",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Mozambique",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Myanmar/Burma": [
            {
                "Region Name": "Myanmar/Burma",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Myanmar/Burma",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Myanmar/Burma",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Myanmar/Burma",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Myanmar/Burma",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Myanmar/Burma",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Myanmar/Burma",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Myanmar/Burma",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Myanmar/Burma",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Myanmar/Burma",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Myanmar/Burma",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Myanmar/Burma",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Myanmar/Burma",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Myanmar/Burma",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Myanmar/Burma",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Myanmar/Burma",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Myanmar/Burma",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Myanmar/Burma",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Myanmar/Burma",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Myanmar/Burma",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Myanmar/Burma",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Myanmar/Burma",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Namibia": [
            {
                "Region Name": "Namibia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 71
            },
            {
                "Region Name": "Namibia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 90
            },
            {
                "Region Name": "Namibia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 65
            },
            {
                "Region Name": "Namibia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 98
            },
            {
                "Region Name": "Namibia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 82
            },
            {
                "Region Name": "Namibia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 80
            },
            {
                "Region Name": "Namibia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Namibia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 82
            },
            {
                "Region Name": "Namibia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 75
            },
            {
                "Region Name": "Namibia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 89
            },
            {
                "Region Name": "Namibia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 99
            },
            {
                "Region Name": "Namibia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "Namibia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Namibia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Namibia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Namibia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Namibia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Namibia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Namibia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Namibia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Namibia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Namibia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 40
            }
        ],
        "Nauru": [
            {
                "Region Name": "Nauru",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nauru",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nauru",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nauru",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nauru",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nauru",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nauru",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nauru",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nauru",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nauru",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nauru",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nauru",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nauru",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nauru",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nauru",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nauru",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nauru",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nauru",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nauru",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nauru",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nauru",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nauru",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nepal": [
            {
                "Region Name": "Nepal",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nepal",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Nepal",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Nepal",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nepal",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nepal",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Nepal",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nepal",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nepal",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Nepal",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Nepal",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Nepal",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Nepal",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nepal",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nepal",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Nepal",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Nepal",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nepal",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Nepal",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nepal",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nepal",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nepal",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 24
            }
        ],
        "Netherlands": [
            {
                "Region Name": "Netherlands",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Netherlands",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Netherlands",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Netherlands",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Netherlands",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Netherlands",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Netherlands",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Netherlands",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Netherlands",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Netherlands",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Netherlands",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Netherlands",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Netherlands",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Netherlands",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Netherlands",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Netherlands",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Netherlands",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Netherlands",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Netherlands",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Netherlands",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Netherlands",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Netherlands",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "New Caledonia": [
            {
                "Region Name": "New Caledonia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "New Caledonia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "New Caledonia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "New Caledonia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "New Caledonia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "New Caledonia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Caledonia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Caledonia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Caledonia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Caledonia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "New Caledonia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Caledonia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "New Caledonia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Caledonia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "New Caledonia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Caledonia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "New Caledonia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "New Caledonia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "New Caledonia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Caledonia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "New Caledonia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Caledonia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "New Zealand": [
            {
                "Region Name": "New Zealand",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Zealand",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "New Zealand",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "New Zealand",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "New Zealand",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "New Zealand",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "New Zealand",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "New Zealand",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "New Zealand",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "New Zealand",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "New Zealand",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "New Zealand",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Zealand",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "New Zealand",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "New Zealand",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "New Zealand",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "New Zealand",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "New Zealand",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "New Zealand",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "New Zealand",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "New Zealand",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "New Zealand",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Nicaragua": [
            {
                "Region Name": "Nicaragua",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nicaragua",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nicaragua",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nicaragua",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nicaragua",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nicaragua",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nicaragua",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nicaragua",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nicaragua",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nicaragua",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nicaragua",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nicaragua",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nicaragua",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nicaragua",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nicaragua",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nicaragua",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nicaragua",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nicaragua",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nicaragua",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nicaragua",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nicaragua",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nicaragua",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Niger": [
            {
                "Region Name": "Niger",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Niger",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Niger",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 59
            },
            {
                "Region Name": "Niger",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Niger",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 59
            },
            {
                "Region Name": "Niger",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Niger",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Niger",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Niger",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Niger",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Niger",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Niger",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Niger",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Niger",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Niger",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Niger",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Niger",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Niger",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Niger",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Niger",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 66
            },
            {
                "Region Name": "Niger",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Niger",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 45
            }
        ],
        "Nigeria": [
            {
                "Region Name": "Nigeria",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nigeria",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nigeria",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Nigeria",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Nigeria",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nigeria",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nigeria",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nigeria",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nigeria",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nigeria",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nigeria",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nigeria",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nigeria",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nigeria",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nigeria",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nigeria",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nigeria",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nigeria",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nigeria",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Nigeria",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nigeria",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nigeria",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "Niue": [
            {
                "Region Name": "Niue",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niue",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niue",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niue",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niue",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niue",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niue",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niue",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niue",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niue",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niue",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niue",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niue",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niue",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niue",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niue",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niue",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niue",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niue",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niue",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niue",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niue",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Norfolk Island": [
            {
                "Region Name": "Norfolk Island",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norfolk Island",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norfolk Island",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norfolk Island",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norfolk Island",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norfolk Island",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norfolk Island",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norfolk Island",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norfolk Island",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norfolk Island",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norfolk Island",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norfolk Island",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norfolk Island",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norfolk Island",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norfolk Island",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norfolk Island",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norfolk Island",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norfolk Island",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norfolk Island",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norfolk Island",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norfolk Island",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norfolk Island",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "North Korea": [
            {
                "Region Name": "North Korea",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North Korea",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North Korea",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North Korea",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North Korea",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North Korea",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "North Korea",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North Korea",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North Korea",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North Korea",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North Korea",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Korea",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North Korea",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North Korea",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North Korea",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Korea",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Korea",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North Korea",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North Korea",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North Korea",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "North Korea",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North Korea",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "North Macedonia": [
            {
                "Region Name": "North Macedonia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Macedonia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "North Macedonia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Macedonia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Macedonia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Macedonia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "North Macedonia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North Macedonia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "North Macedonia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "North Macedonia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North Macedonia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "North Macedonia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North Macedonia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "North Macedonia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North Macedonia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North Macedonia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North Macedonia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Macedonia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North Macedonia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Macedonia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "North Macedonia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North Macedonia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Northern Mariana Islands": [
            {
                "Region Name": "Northern Mariana Islands",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Mariana Islands",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Mariana Islands",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Mariana Islands",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Mariana Islands",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Mariana Islands",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Mariana Islands",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Mariana Islands",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Mariana Islands",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Mariana Islands",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Mariana Islands",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Mariana Islands",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Mariana Islands",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Mariana Islands",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Mariana Islands",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Mariana Islands",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Mariana Islands",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Mariana Islands",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Mariana Islands",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Mariana Islands",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Mariana Islands",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Mariana Islands",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Norway": [
            {
                "Region Name": "Norway",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Norway",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Norway",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norway",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norway",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Norway",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Norway",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Norway",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norway",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norway",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norway",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norway",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norway",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norway",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norway",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norway",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norway",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Norway",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Norway",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norway",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norway",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norway",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Oman": [
            {
                "Region Name": "Oman",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oman",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oman",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oman",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oman",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oman",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oman",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oman",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oman",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oman",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oman",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oman",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oman",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oman",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oman",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oman",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oman",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oman",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oman",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oman",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oman",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oman",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Pakistan": [
            {
                "Region Name": "Pakistan",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pakistan",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pakistan",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pakistan",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pakistan",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pakistan",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pakistan",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pakistan",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pakistan",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pakistan",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pakistan",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pakistan",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pakistan",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pakistan",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pakistan",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pakistan",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pakistan",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pakistan",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pakistan",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pakistan",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pakistan",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pakistan",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Palau": [
            {
                "Region Name": "Palau",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palau",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palau",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palau",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palau",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palau",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palau",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palau",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palau",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palau",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palau",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palau",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palau",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palau",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palau",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palau",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palau",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palau",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palau",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palau",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palau",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palau",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Palestine": [
            {
                "Region Name": "Palestine",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Palestine",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palestine",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Palestine",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Palestine",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palestine",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palestine",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Palestine",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palestine",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Palestine",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palestine",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palestine",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palestine",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palestine",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Palestine",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Palestine",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Palestine",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palestine",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Palestine",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Palestine",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Palestine",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palestine",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Panama": [
            {
                "Region Name": "Panama",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Panama",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Panama",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Panama",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Panama",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Panama",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Panama",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Panama",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Panama",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Panama",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Panama",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Panama",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Panama",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Panama",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Panama",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Panama",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Panama",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Panama",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Panama",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Panama",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Panama",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Panama",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Papua New Guinea": [
            {
                "Region Name": "Papua New Guinea",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Papua New Guinea",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Papua New Guinea",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Papua New Guinea",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Papua New Guinea",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Papua New Guinea",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Papua New Guinea",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Papua New Guinea",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Papua New Guinea",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Papua New Guinea",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Papua New Guinea",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Papua New Guinea",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Papua New Guinea",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Papua New Guinea",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Papua New Guinea",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Papua New Guinea",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Papua New Guinea",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Papua New Guinea",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Papua New Guinea",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Papua New Guinea",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Papua New Guinea",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Papua New Guinea",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Paraguay": [
            {
                "Region Name": "Paraguay",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Paraguay",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Paraguay",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Paraguay",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Paraguay",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Paraguay",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Paraguay",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Paraguay",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Paraguay",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paraguay",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Paraguay",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Paraguay",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Paraguay",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paraguay",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paraguay",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paraguay",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Paraguay",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paraguay",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Paraguay",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Paraguay",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Paraguay",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Paraguay",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Peru": [
            {
                "Region Name": "Peru",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Peru",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Peru",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Peru",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Peru",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Peru",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Peru",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Peru",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Peru",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Peru",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Peru",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Peru",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Peru",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Peru",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Peru",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Peru",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Peru",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Peru",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Peru",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Peru",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Peru",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Peru",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Philippines": [
            {
                "Region Name": "Philippines",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Philippines",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Philippines",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Philippines",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Philippines",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Philippines",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Philippines",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Philippines",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Philippines",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Philippines",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Philippines",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Philippines",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Philippines",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Philippines",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Philippines",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Philippines",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Philippines",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Philippines",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Philippines",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Philippines",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Philippines",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Philippines",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Pitcairn Islands": [
            {
                "Region Name": "Pitcairn Islands",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pitcairn Islands",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pitcairn Islands",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pitcairn Islands",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pitcairn Islands",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pitcairn Islands",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pitcairn Islands",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pitcairn Islands",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pitcairn Islands",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pitcairn Islands",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pitcairn Islands",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pitcairn Islands",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pitcairn Islands",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pitcairn Islands",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pitcairn Islands",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pitcairn Islands",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pitcairn Islands",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pitcairn Islands",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pitcairn Islands",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pitcairn Islands",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pitcairn Islands",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pitcairn Islands",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Poland": [
            {
                "Region Name": "Poland",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Poland",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Poland",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Poland",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Poland",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Poland",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Poland",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Poland",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Poland",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Poland",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Poland",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Poland",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Poland",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Poland",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Poland",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Poland",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Poland",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Poland",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Poland",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Poland",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Poland",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Poland",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Portugal": [
            {
                "Region Name": "Portugal",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Portugal",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Portugal",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Portugal",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Portugal",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Portugal",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Portugal",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Portugal",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Portugal",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Portugal",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Portugal",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Portugal",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Portugal",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Portugal",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Portugal",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Portugal",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 67
            },
            {
                "Region Name": "Portugal",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Portugal",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Portugal",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Portugal",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Portugal",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Portugal",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 37
            }
        ],
        "Puerto Rico": [
            {
                "Region Name": "Puerto Rico",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Puerto Rico",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Puerto Rico",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Puerto Rico",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Puerto Rico",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Puerto Rico",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puerto Rico",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Puerto Rico",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Puerto Rico",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Puerto Rico",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Puerto Rico",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Puerto Rico",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Puerto Rico",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Puerto Rico",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Puerto Rico",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Puerto Rico",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Puerto Rico",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Puerto Rico",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Puerto Rico",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puerto Rico",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Puerto Rico",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Puerto Rico",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Qatar": [
            {
                "Region Name": "Qatar",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qatar",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qatar",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qatar",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qatar",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qatar",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qatar",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qatar",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Qatar",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qatar",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qatar",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Qatar",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qatar",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qatar",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Qatar",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qatar",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qatar",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qatar",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qatar",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qatar",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qatar",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qatar",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Romania": [
            {
                "Region Name": "Romania",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Romania",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Romania",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Romania",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Romania",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Romania",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Romania",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Romania",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Romania",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Romania",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Romania",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Romania",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Romania",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Romania",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Romania",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Romania",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Romania",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Romania",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Romania",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Romania",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Romania",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Romania",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Russian Federation": [
            {
                "Region Name": "Russian Federation",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Russian Federation",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Russian Federation",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Russian Federation",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Russian Federation",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Russian Federation",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Russian Federation",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Russian Federation",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Russian Federation",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Russian Federation",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Russian Federation",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Russian Federation",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Russian Federation",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Russian Federation",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Russian Federation",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Russian Federation",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Russian Federation",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Russian Federation",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Russian Federation",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Russian Federation",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Russian Federation",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Russian Federation",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Rwanda": [
            {
                "Region Name": "Rwanda",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Rwanda",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rwanda",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Rwanda",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Rwanda",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Rwanda",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rwanda",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Rwanda",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Rwanda",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Rwanda",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Rwanda",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Rwanda",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Rwanda",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Rwanda",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Rwanda",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Rwanda",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Rwanda",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Rwanda",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Rwanda",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Rwanda",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Rwanda",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Rwanda",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 24
            }
        ],
        "Saint Barth\xe9lemy": [
            {
                "Region Name": "Saint Barth\xe9lemy",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Barth\xe9lemy",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Barth\xe9lemy",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Barth\xe9lemy",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Barth\xe9lemy",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Barth\xe9lemy",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Barth\xe9lemy",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Barth\xe9lemy",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Barth\xe9lemy",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Barth\xe9lemy",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Barth\xe9lemy",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Barth\xe9lemy",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Barth\xe9lemy",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Barth\xe9lemy",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Barth\xe9lemy",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Barth\xe9lemy",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Barth\xe9lemy",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Barth\xe9lemy",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Barth\xe9lemy",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Barth\xe9lemy",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Barth\xe9lemy",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Barth\xe9lemy",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Helena, Ascension and Tristan Da Cunha": [
            {
                "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena, Ascension and Tristan Da Cunha",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Kitts and Nevis": [
            {
                "Region Name": "Saint Kitts and Nevis",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Kitts and Nevis",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Kitts and Nevis",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Kitts and Nevis",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Kitts and Nevis",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Kitts and Nevis",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Kitts and Nevis",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Kitts and Nevis",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saint Kitts and Nevis",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Kitts and Nevis",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Kitts and Nevis",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Kitts and Nevis",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Kitts and Nevis",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Kitts and Nevis",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Kitts and Nevis",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Kitts and Nevis",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Kitts and Nevis",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Kitts and Nevis",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Kitts and Nevis",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Kitts and Nevis",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Kitts and Nevis",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Kitts and Nevis",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Lucia": [
            {
                "Region Name": "Saint Lucia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Pierre and Miquelon": [
            {
                "Region Name": "Saint Pierre and Miquelon",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre and Miquelon",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre and Miquelon",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre and Miquelon",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre and Miquelon",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre and Miquelon",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre and Miquelon",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre and Miquelon",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre and Miquelon",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre and Miquelon",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre and Miquelon",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre and Miquelon",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre and Miquelon",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre and Miquelon",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre and Miquelon",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre and Miquelon",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre and Miquelon",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre and Miquelon",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre and Miquelon",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre and Miquelon",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre and Miquelon",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre and Miquelon",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Vincent and The Grenadines": [
            {
                "Region Name": "Saint Vincent and The Grenadines",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Vincent and The Grenadines",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Vincent and The Grenadines",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Vincent and The Grenadines",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Vincent and The Grenadines",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Vincent and The Grenadines",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Vincent and The Grenadines",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Vincent and The Grenadines",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Vincent and The Grenadines",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Vincent and The Grenadines",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Vincent and The Grenadines",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Vincent and The Grenadines",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Vincent and The Grenadines",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Vincent and The Grenadines",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Vincent and The Grenadines",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Vincent and The Grenadines",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Vincent and The Grenadines",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Vincent and The Grenadines",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Vincent and The Grenadines",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Vincent and The Grenadines",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Vincent and The Grenadines",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Vincent and The Grenadines",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Samoa": [
            {
                "Region Name": "Samoa",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samoa",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samoa",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samoa",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samoa",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samoa",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samoa",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samoa",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samoa",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samoa",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Samoa",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samoa",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samoa",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samoa",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samoa",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samoa",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samoa",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samoa",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samoa",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samoa",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samoa",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samoa",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "S\xe3o Tom\xe9 and Pr\xedncipe": [
            {
                "Region Name": "S\xe3o Tom\xe9 and Pr\xedncipe",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 and Pr\xedncipe",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 and Pr\xedncipe",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 and Pr\xedncipe",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 and Pr\xedncipe",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 and Pr\xedncipe",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 and Pr\xedncipe",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 and Pr\xedncipe",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 and Pr\xedncipe",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 and Pr\xedncipe",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 and Pr\xedncipe",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 and Pr\xedncipe",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 and Pr\xedncipe",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 and Pr\xedncipe",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 and Pr\xedncipe",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 and Pr\xedncipe",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 and Pr\xedncipe",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 and Pr\xedncipe",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 and Pr\xedncipe",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 and Pr\xedncipe",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 and Pr\xedncipe",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 and Pr\xedncipe",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saudi Arabia": [
            {
                "Region Name": "Saudi Arabia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Saudi Arabia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Saudi Arabia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Saudi Arabia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Saudi Arabia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Saudi Arabia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Saudi Arabia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Saudi Arabia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Saudi Arabia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Saudi Arabia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Saudi Arabia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Saudi Arabia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Saudi Arabia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Saudi Arabia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saudi Arabia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Saudi Arabia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saudi Arabia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saudi Arabia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Saudi Arabia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Saudi Arabia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saudi Arabia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Saudi Arabia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Senegal": [
            {
                "Region Name": "Senegal",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Senegal",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Senegal",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Senegal",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Senegal",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Senegal",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Senegal",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Senegal",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Senegal",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Senegal",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Senegal",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Senegal",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Senegal",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Senegal",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Senegal",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Senegal",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Senegal",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Senegal",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Senegal",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Senegal",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Senegal",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Senegal",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 28
            }
        ],
        "Serbia": [
            {
                "Region Name": "Serbia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Serbia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Serbia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Serbia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Serbia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Serbia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Serbia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Serbia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Serbia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Serbia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Serbia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Serbia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Serbia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Serbia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Serbia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Serbia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Serbia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Serbia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Serbia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Serbia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Serbia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Serbia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Seychelles": [
            {
                "Region Name": "Seychelles",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seychelles",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seychelles",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seychelles",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seychelles",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seychelles",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seychelles",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seychelles",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seychelles",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seychelles",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seychelles",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seychelles",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seychelles",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seychelles",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seychelles",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seychelles",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seychelles",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seychelles",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seychelles",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seychelles",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seychelles",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seychelles",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sierra Leone": [
            {
                "Region Name": "Sierra Leone",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sierra Leone",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sierra Leone",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sierra Leone",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sierra Leone",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sierra Leone",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sierra Leone",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sierra Leone",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sierra Leone",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sierra Leone",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sierra Leone",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sierra Leone",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sierra Leone",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sierra Leone",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sierra Leone",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sierra Leone",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sierra Leone",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sierra Leone",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sierra Leone",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sierra Leone",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sierra Leone",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sierra Leone",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Singapore": [
            {
                "Region Name": "Singapore",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singapore",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singapore",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singapore",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singapore",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singapore",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singapore",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singapore",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singapore",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singapore",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singapore",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singapore",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singapore",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singapore",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singapore",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singapore",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singapore",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singapore",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singapore",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singapore",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singapore",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singapore",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sint-Maarten": [
            {
                "Region Name": "Sint-Maarten",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint-Maarten",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint-Maarten",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint-Maarten",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint-Maarten",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint-Maarten",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint-Maarten",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint-Maarten",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint-Maarten",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint-Maarten",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint-Maarten",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint-Maarten",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint-Maarten",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint-Maarten",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint-Maarten",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint-Maarten",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint-Maarten",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint-Maarten",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint-Maarten",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint-Maarten",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint-Maarten",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint-Maarten",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Slovakia": [
            {
                "Region Name": "Slovakia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Slovakia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Slovakia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Slovakia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Slovakia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Slovakia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Slovakia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Slovakia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Slovakia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Slovakia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Slovakia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Slovakia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Slovakia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Slovakia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Slovakia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Slovakia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Slovakia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Slovakia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Slovakia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Slovakia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Slovakia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Slovakia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Slovenia": [
            {
                "Region Name": "Slovenia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Slovenia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Slovenia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Slovenia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Slovenia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Slovenia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Slovenia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Slovenia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Slovenia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Slovenia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Slovenia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Slovenia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Slovenia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Slovenia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Slovenia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Slovenia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Slovenia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Slovenia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Slovenia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Slovenia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Slovenia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Slovenia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Solomon Islands": [
            {
                "Region Name": "Solomon Islands",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solomon Islands",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solomon Islands",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solomon Islands",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solomon Islands",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solomon Islands",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solomon Islands",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solomon Islands",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solomon Islands",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solomon Islands",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solomon Islands",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solomon Islands",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solomon Islands",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solomon Islands",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solomon Islands",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solomon Islands",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solomon Islands",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solomon Islands",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solomon Islands",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solomon Islands",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solomon Islands",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solomon Islands",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Somalia": [
            {
                "Region Name": "Somalia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Somalia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Somalia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Somalia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Somalia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Somalia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Somalia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Somalia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Somalia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Somalia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Somalia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Somalia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Somalia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Somalia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Somalia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Somalia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Somalia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Somalia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Somalia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Somalia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Somalia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Somalia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "South Africa": [
            {
                "Region Name": "South Africa",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "South Africa",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "South Africa",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "South Africa",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "South Africa",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "South Africa",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "South Africa",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "South Africa",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "South Africa",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "South Africa",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "South Africa",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "South Africa",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "South Africa",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "South Africa",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "South Africa",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "South Africa",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "South Africa",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "South Africa",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "South Africa",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South Africa",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "South Africa",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "South Africa",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "South Georgia and The South Sandwich Islands": [
            {
                "Region Name": "South Georgia and The South Sandwich Islands",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Georgia and The South Sandwich Islands",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Georgia and The South Sandwich Islands",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Georgia and The South Sandwich Islands",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Georgia and The South Sandwich Islands",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Georgia and The South Sandwich Islands",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Georgia and The South Sandwich Islands",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Georgia and The South Sandwich Islands",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Georgia and The South Sandwich Islands",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Georgia and The South Sandwich Islands",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Georgia and The South Sandwich Islands",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Georgia and The South Sandwich Islands",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Georgia and The South Sandwich Islands",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Georgia and The South Sandwich Islands",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Georgia and The South Sandwich Islands",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Georgia and The South Sandwich Islands",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Georgia and The South Sandwich Islands",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Georgia and The South Sandwich Islands",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Georgia and The South Sandwich Islands",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Georgia and The South Sandwich Islands",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Georgia and The South Sandwich Islands",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Georgia and The South Sandwich Islands",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "South Korea": [
            {
                "Region Name": "South Korea",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "South Korea",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South Korea",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "South Korea",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "South Korea",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "South Korea",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "South Korea",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "South Korea",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "South Korea",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "South Korea",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "South Korea",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "South Korea",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South Korea",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "South Korea",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South Korea",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "South Korea",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "South Korea",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Korea",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "South Korea",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "South Korea",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "South Korea",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "South Korea",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "South Sudan": [
            {
                "Region Name": "South Sudan",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "South Sudan",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "South Sudan",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "South Sudan",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "South Sudan",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "South Sudan",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "South Sudan",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "South Sudan",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "South Sudan",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "South Sudan",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "South Sudan",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "South Sudan",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "South Sudan",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "South Sudan",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "South Sudan",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "South Sudan",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "South Sudan",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "South Sudan",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "South Sudan",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "South Sudan",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "South Sudan",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "South Sudan",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 36
            }
        ],
        "Spain": [
            {
                "Region Name": "Spain",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Spain",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Spain",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Spain",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Spain",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Spain",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Spain",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Spain",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Spain",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Spain",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Spain",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Spain",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Spain",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Spain",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Spain",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Spain",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Spain",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Spain",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Spain",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Spain",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Spain",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 67
            },
            {
                "Region Name": "Spain",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "Sri Lanka": [
            {
                "Region Name": "Sri Lanka",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sri Lanka",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sri Lanka",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sri Lanka",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sri Lanka",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sri Lanka",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sri Lanka",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Sri Lanka",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sri Lanka",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sri Lanka",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sri Lanka",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sri Lanka",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sri Lanka",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sri Lanka",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Sri Lanka",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sri Lanka",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sri Lanka",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sri Lanka",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sri Lanka",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sri Lanka",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sri Lanka",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sri Lanka",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Sudan": [
            {
                "Region Name": "Sudan",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Sudan",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Sudan",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Sudan",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Sudan",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Sudan",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Sudan",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Sudan",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Sudan",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Sudan",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Sudan",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Sudan",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Sudan",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Sudan",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Sudan",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Sudan",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Sudan",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Sudan",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Sudan",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Sudan",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Sudan",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Sudan",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "Suriname": [
            {
                "Region Name": "Suriname",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Suriname",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Suriname",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Suriname",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Suriname",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Suriname",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Suriname",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Suriname",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Suriname",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Suriname",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Suriname",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Suriname",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Suriname",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Suriname",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Suriname",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Suriname",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Suriname",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Suriname",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Suriname",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Suriname",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Suriname",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Suriname",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Sweden": [
            {
                "Region Name": "Sweden",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sweden",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sweden",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sweden",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sweden",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sweden",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sweden",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sweden",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sweden",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sweden",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sweden",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sweden",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sweden",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Sweden",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sweden",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sweden",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sweden",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Sweden",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sweden",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sweden",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sweden",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sweden",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Switzerland": [
            {
                "Region Name": "Switzerland",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Switzerland",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Switzerland",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Switzerland",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Switzerland",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Switzerland",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Switzerland",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Switzerland",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Switzerland",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Switzerland",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Switzerland",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Switzerland",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Switzerland",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Switzerland",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Switzerland",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Switzerland",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Switzerland",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Switzerland",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Switzerland",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Switzerland",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Switzerland",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Switzerland",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Syria": [
            {
                "Region Name": "Syria",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Syria",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Syria",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Syria",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Syria",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Syria",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Syria",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Syria",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Syria",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Syria",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Syria",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Syria",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Syria",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Syria",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Syria",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Syria",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Syria",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Syria",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Syria",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Syria",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Syria",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Syria",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Tajikistan": [
            {
                "Region Name": "Tajikistan",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tajikistan",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tajikistan",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Tajikistan",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tajikistan",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Tajikistan",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Tajikistan",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tajikistan",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tajikistan",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tajikistan",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tajikistan",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tajikistan",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tajikistan",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Tajikistan",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tajikistan",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tajikistan",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tajikistan",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tajikistan",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tajikistan",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tajikistan",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tajikistan",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tajikistan",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Thailand": [
            {
                "Region Name": "Thailand",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Thailand",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Thailand",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Thailand",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Thailand",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Thailand",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Thailand",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Thailand",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Thailand",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Thailand",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Thailand",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Thailand",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Thailand",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Thailand",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Thailand",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Thailand",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Thailand",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Thailand",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Thailand",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Thailand",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Thailand",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Thailand",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Timor-Leste": [
            {
                "Region Name": "Timor-Leste",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Timor-Leste",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Timor-Leste",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Timor-Leste",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Timor-Leste",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Timor-Leste",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Timor-Leste",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Timor-Leste",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Timor-Leste",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Timor-Leste",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Timor-Leste",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Timor-Leste",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Timor-Leste",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Timor-Leste",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Timor-Leste",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Timor-Leste",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Timor-Leste",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Timor-Leste",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Timor-Leste",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Timor-Leste",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Timor-Leste",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Timor-Leste",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Togo": [
            {
                "Region Name": "Togo",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Togo",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Togo",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Togo",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Togo",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Togo",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Togo",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Togo",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Togo",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Togo",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Togo",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Togo",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Togo",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Togo",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Togo",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Togo",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Togo",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Togo",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Togo",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Togo",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Togo",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Togo",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Tokelau": [
            {
                "Region Name": "Tokelau",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokelau",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokelau",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokelau",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokelau",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokelau",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokelau",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokelau",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokelau",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokelau",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokelau",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokelau",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokelau",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokelau",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokelau",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokelau",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokelau",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokelau",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokelau",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokelau",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokelau",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokelau",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tonga": [
            {
                "Region Name": "Tonga",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tonga",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tonga",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tonga",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tonga",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tonga",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tonga",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tonga",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tonga",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tonga",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tonga",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tonga",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tonga",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tonga",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tonga",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tonga",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tonga",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tonga",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tonga",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tonga",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tonga",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tonga",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Trinidad and Tobago": [
            {
                "Region Name": "Trinidad and Tobago",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trinidad and Tobago",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Trinidad and Tobago",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trinidad and Tobago",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Trinidad and Tobago",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Trinidad and Tobago",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Trinidad and Tobago",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Trinidad and Tobago",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Trinidad and Tobago",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Trinidad and Tobago",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinidad and Tobago",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trinidad and Tobago",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trinidad and Tobago",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Trinidad and Tobago",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trinidad and Tobago",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Trinidad and Tobago",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Trinidad and Tobago",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trinidad and Tobago",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trinidad and Tobago",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Trinidad and Tobago",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinidad and Tobago",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trinidad and Tobago",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Tunisia": [
            {
                "Region Name": "Tunisia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tunisia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tunisia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tunisia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tunisia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tunisia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tunisia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tunisia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tunisia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Tunisia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tunisia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tunisia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Tunisia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Tunisia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tunisia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tunisia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Tunisia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tunisia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tunisia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Tunisia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Tunisia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tunisia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Turkey": [
            {
                "Region Name": "Turkey",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Turkey",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Turkey",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Turkey",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Turkey",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Turkey",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Turkey",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Turkey",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Turkey",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Turkey",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Turkey",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Turkey",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Turkey",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Turkey",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Turkey",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Turkey",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Turkey",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Turkey",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Turkey",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Turkey",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Turkey",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Turkey",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Turkmenistan": [
            {
                "Region Name": "Turkmenistan",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Turkmenistan",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Turkmenistan",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Turkmenistan",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Turkmenistan",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Turkmenistan",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Turkmenistan",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Turkmenistan",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Turkmenistan",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Turkmenistan",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Turkmenistan",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Turkmenistan",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Turkmenistan",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Turkmenistan",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Turkmenistan",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Turkmenistan",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Turkmenistan",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Turkmenistan",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Turkmenistan",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Turkmenistan",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Turkmenistan",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Turkmenistan",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Turks and Caicos Islands": [
            {
                "Region Name": "Turks and Caicos Islands",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Turks and Caicos Islands",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Turks and Caicos Islands",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Turks and Caicos Islands",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Turks and Caicos Islands",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Turks and Caicos Islands",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Turks and Caicos Islands",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Turks and Caicos Islands",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Turks and Caicos Islands",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Turks and Caicos Islands",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Turks and Caicos Islands",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Turks and Caicos Islands",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Turks and Caicos Islands",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Turks and Caicos Islands",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Turks and Caicos Islands",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Turks and Caicos Islands",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Turks and Caicos Islands",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Turks and Caicos Islands",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Turks and Caicos Islands",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Turks and Caicos Islands",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Turks and Caicos Islands",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Turks and Caicos Islands",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tuvalu": [
            {
                "Region Name": "Tuvalu",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuvalu",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuvalu",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuvalu",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuvalu",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuvalu",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuvalu",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuvalu",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuvalu",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuvalu",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuvalu",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuvalu",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuvalu",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuvalu",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuvalu",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuvalu",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuvalu",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuvalu",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuvalu",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuvalu",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuvalu",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuvalu",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Uganda": [
            {
                "Region Name": "Uganda",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Uganda",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Uganda",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Uganda",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Uganda",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Uganda",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Uganda",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Uganda",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Uganda",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Uganda",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Uganda",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Uganda",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Uganda",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Uganda",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Uganda",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Uganda",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Uganda",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Uganda",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Uganda",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Uganda",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Uganda",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Uganda",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Ukraine": [
            {
                "Region Name": "Ukraine",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ukraine",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ukraine",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ukraine",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ukraine",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ukraine",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ukraine",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ukraine",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ukraine",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ukraine",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ukraine",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ukraine",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ukraine",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ukraine",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ukraine",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ukraine",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ukraine",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ukraine",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ukraine",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ukraine",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ukraine",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ukraine",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "United Arab Emirates": [
            {
                "Region Name": "United Arab Emirates",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United Arab Emirates",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United Arab Emirates",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "United Arab Emirates",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United Arab Emirates",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United Arab Emirates",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "United Arab Emirates",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United Arab Emirates",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United Arab Emirates",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "United Arab Emirates",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United Arab Emirates",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "United Arab Emirates",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "United Arab Emirates",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United Arab Emirates",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United Arab Emirates",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United Arab Emirates",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United Arab Emirates",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "United Arab Emirates",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "United Arab Emirates",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United Arab Emirates",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "United Arab Emirates",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "United Arab Emirates",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "United Kingdom": [
            {
                "Region Name": "United Kingdom",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "United Kingdom",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "United Kingdom",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "United Kingdom",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "United Kingdom",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "United Kingdom",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "United Kingdom",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United Kingdom",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "United Kingdom",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "United Kingdom",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "United Kingdom",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "United Kingdom",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United Kingdom",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United Kingdom",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "United Kingdom",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "United Kingdom",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "United Kingdom",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "United Kingdom",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "United Kingdom",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "United Kingdom",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United Kingdom",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "United Kingdom",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "United Republic of Tanzania": [
            {
                "Region Name": "United Republic of Tanzania",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "United Republic of Tanzania",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "United Republic of Tanzania",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "United Republic of Tanzania",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "United Republic of Tanzania",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "United Republic of Tanzania",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "United Republic of Tanzania",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "United Republic of Tanzania",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "United Republic of Tanzania",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "United Republic of Tanzania",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "United Republic of Tanzania",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "United Republic of Tanzania",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "United Republic of Tanzania",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "United Republic of Tanzania",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "United Republic of Tanzania",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "United Republic of Tanzania",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "United Republic of Tanzania",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "United Republic of Tanzania",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "United Republic of Tanzania",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "United Republic of Tanzania",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "United Republic of Tanzania",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "United Republic of Tanzania",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "United States": [
            {
                "Region Name": "United States",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "United States",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "United States",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "United States",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "United States",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "United States",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "United States",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "United States",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "United States",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "United States",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "United States",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "United States",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "United States",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "United States",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "United States",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "United States",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "United States",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "United States",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "United States",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "United States",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "United States",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "United States",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "United States Minor Outlying Islands": [
            {
                "Region Name": "United States Minor Outlying Islands",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United States Minor Outlying Islands",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United States Minor Outlying Islands",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United States Minor Outlying Islands",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United States Minor Outlying Islands",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United States Minor Outlying Islands",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United States Minor Outlying Islands",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United States Minor Outlying Islands",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United States Minor Outlying Islands",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United States Minor Outlying Islands",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United States Minor Outlying Islands",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United States Minor Outlying Islands",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United States Minor Outlying Islands",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United States Minor Outlying Islands",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United States Minor Outlying Islands",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United States Minor Outlying Islands",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United States Minor Outlying Islands",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United States Minor Outlying Islands",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United States Minor Outlying Islands",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United States Minor Outlying Islands",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United States Minor Outlying Islands",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "United States Minor Outlying Islands",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Uruguay": [
            {
                "Region Name": "Uruguay",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uruguay",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uruguay",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uruguay",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uruguay",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Uruguay",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Uruguay",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Uruguay",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uruguay",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uruguay",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Uruguay",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uruguay",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Uruguay",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Uruguay",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Uruguay",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Uruguay",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uruguay",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Uruguay",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Uruguay",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uruguay",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Uruguay",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Uruguay",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Us Virgin Islands": [
            {
                "Region Name": "Us Virgin Islands",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Us Virgin Islands",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Us Virgin Islands",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Us Virgin Islands",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Us Virgin Islands",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Us Virgin Islands",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Us Virgin Islands",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Us Virgin Islands",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Us Virgin Islands",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Us Virgin Islands",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Us Virgin Islands",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Us Virgin Islands",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Us Virgin Islands",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Us Virgin Islands",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Us Virgin Islands",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Us Virgin Islands",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Us Virgin Islands",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Us Virgin Islands",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Us Virgin Islands",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Us Virgin Islands",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Us Virgin Islands",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Us Virgin Islands",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Uzbekistan": [
            {
                "Region Name": "Uzbekistan",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Uzbekistan",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Uzbekistan",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Uzbekistan",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Uzbekistan",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Uzbekistan",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Uzbekistan",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Uzbekistan",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Uzbekistan",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uzbekistan",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Uzbekistan",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Uzbekistan",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Uzbekistan",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Uzbekistan",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Uzbekistan",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Uzbekistan",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Uzbekistan",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Uzbekistan",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Uzbekistan",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Uzbekistan",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Uzbekistan",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Uzbekistan",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Vanuatu": [
            {
                "Region Name": "Vanuatu",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vanuatu",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Vanuatu",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vanuatu",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vanuatu",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vanuatu",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vanuatu",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vanuatu",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vanuatu",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vanuatu",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vanuatu",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vanuatu",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vanuatu",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vanuatu",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vanuatu",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vanuatu",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vanuatu",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vanuatu",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vanuatu",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vanuatu",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vanuatu",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vanuatu",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vatican City": [
            {
                "Region Name": "Vatican City",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vatican City",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vatican City",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vatican City",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vatican City",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vatican City",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vatican City",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vatican City",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vatican City",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vatican City",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vatican City",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vatican City",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vatican City",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vatican City",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vatican City",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vatican City",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vatican City",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vatican City",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vatican City",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vatican City",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vatican City",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vatican City",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Venezuela": [
            {
                "Region Name": "Venezuela",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Venezuela",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Venezuela",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Venezuela",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Venezuela",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Venezuela",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Venezuela",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Venezuela",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Venezuela",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Venezuela",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Venezuela",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Venezuela",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Venezuela",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Venezuela",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Venezuela",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Venezuela",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Venezuela",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Venezuela",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Venezuela",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Venezuela",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Venezuela",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Venezuela",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Vietnam": [
            {
                "Region Name": "Vietnam",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Vietnam",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Vietnam",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vietnam",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vietnam",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vietnam",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vietnam",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Vietnam",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Vietnam",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vietnam",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vietnam",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Vietnam",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vietnam",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Vietnam",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Vietnam",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vietnam",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Vietnam",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Vietnam",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Vietnam",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Vietnam",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Vietnam",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Vietnam",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Wallis and Futuna": [
            {
                "Region Name": "Wallis and Futuna",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallis and Futuna",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallis and Futuna",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallis and Futuna",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallis and Futuna",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallis and Futuna",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallis and Futuna",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallis and Futuna",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallis and Futuna",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallis and Futuna",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallis and Futuna",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallis and Futuna",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallis and Futuna",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallis and Futuna",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallis and Futuna",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallis and Futuna",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallis and Futuna",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallis and Futuna",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallis and Futuna",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallis and Futuna",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallis and Futuna",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallis and Futuna",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Yemen": [
            {
                "Region Name": "Yemen",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yemen",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yemen",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yemen",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yemen",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yemen",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yemen",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yemen",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yemen",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yemen",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yemen",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yemen",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yemen",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yemen",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yemen",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yemen",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yemen",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yemen",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yemen",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yemen",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yemen",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yemen",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Zambia": [
            {
                "Region Name": "Zambia",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Zambia",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Zambia",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Zambia",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Zambia",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Zambia",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Zambia",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Zambia",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Zambia",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Zambia",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Zambia",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Zambia",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Zambia",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Zambia",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Zambia",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Zambia",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Zambia",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Zambia",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Zambia",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Zambia",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Zambia",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Zambia",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Zimbabwe": [
            {
                "Region Name": "Zimbabwe",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Zimbabwe",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Zimbabwe",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Zimbabwe",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Zimbabwe",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Zimbabwe",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Zimbabwe",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Zimbabwe",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Zimbabwe",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Zimbabwe",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Zimbabwe",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Zimbabwe",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Zimbabwe",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Zimbabwe",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Zimbabwe",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Zimbabwe",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Zimbabwe",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Zimbabwe",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Zimbabwe",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Zimbabwe",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Zimbabwe",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Zimbabwe",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ]
    },
    "States and Provinces": {
        "'Asir (Province of Saudi Arabia)": [
            {
                "Region Name": "'Asir (Province of Saudi Arabia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Asir (Province of Saudi Arabia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Asir (Province of Saudi Arabia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Asir (Province of Saudi Arabia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "'Asir (Province of Saudi Arabia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Asir (Province of Saudi Arabia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Asir (Province of Saudi Arabia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "'Asir (Province of Saudi Arabia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Asir (Province of Saudi Arabia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Asir (Province of Saudi Arabia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Asir (Province of Saudi Arabia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Asir (Province of Saudi Arabia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Asir (Province of Saudi Arabia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Asir (Province of Saudi Arabia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Asir (Province of Saudi Arabia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Asir (Province of Saudi Arabia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Asir (Province of Saudi Arabia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Asir (Province of Saudi Arabia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Asir (Province of Saudi Arabia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "'Asir (Province of Saudi Arabia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "'Asir (Province of Saudi Arabia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Asir (Province of Saudi Arabia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "'Eua (Island Group of Tonga)": [
            {
                "Region Name": "'Eua (Island Group of Tonga)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Eua (Island Group of Tonga)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Eua (Island Group of Tonga)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Eua (Island Group of Tonga)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Eua (Island Group of Tonga)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Eua (Island Group of Tonga)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Eua (Island Group of Tonga)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Eua (Island Group of Tonga)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Eua (Island Group of Tonga)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Eua (Island Group of Tonga)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Eua (Island Group of Tonga)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Eua (Island Group of Tonga)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Eua (Island Group of Tonga)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Eua (Island Group of Tonga)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Eua (Island Group of Tonga)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Eua (Island Group of Tonga)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Eua (Island Group of Tonga)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Eua (Island Group of Tonga)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Eua (Island Group of Tonga)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Eua (Island Group of Tonga)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Eua (Island Group of Tonga)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "'Eua (Island Group of Tonga)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "`Adan (Governorate of Yemen)": [
            {
                "Region Name": "`Adan (Governorate of Yemen)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "`Adan (Governorate of Yemen)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "`Adan (Governorate of Yemen)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "`Adan (Governorate of Yemen)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "`Adan (Governorate of Yemen)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "`Adan (Governorate of Yemen)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "`Adan (Governorate of Yemen)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "`Adan (Governorate of Yemen)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "`Adan (Governorate of Yemen)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "`Adan (Governorate of Yemen)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "`Adan (Governorate of Yemen)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "`Adan (Governorate of Yemen)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "`Adan (Governorate of Yemen)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "`Adan (Governorate of Yemen)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "`Adan (Governorate of Yemen)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "`Adan (Governorate of Yemen)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "`Adan (Governorate of Yemen)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "`Adan (Governorate of Yemen)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "`Adan (Governorate of Yemen)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "`Adan (Governorate of Yemen)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "`Adan (Governorate of Yemen)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "`Adan (Governorate of Yemen)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\xb7\u220F\xa7a\xa0\xbail (Province of Saudi Arabia)": [
            {
                "Region Name": "\xb7\u220F\xa7a\xa0\xbail (Province of Saudi Arabia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xb7\u220F\xa7a\xa0\xbail (Province of Saudi Arabia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xb7\u220F\xa7a\xa0\xbail (Province of Saudi Arabia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "\xb7\u220F\xa7a\xa0\xbail (Province of Saudi Arabia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "\xb7\u220F\xa7a\xa0\xbail (Province of Saudi Arabia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "\xb7\u220F\xa7a\xa0\xbail (Province of Saudi Arabia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "\xb7\u220F\xa7a\xa0\xbail (Province of Saudi Arabia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "\xb7\u220F\xa7a\xa0\xbail (Province of Saudi Arabia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "\xb7\u220F\xa7a\xa0\xbail (Province of Saudi Arabia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "\xb7\u220F\xa7a\xa0\xbail (Province of Saudi Arabia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\xb7\u220F\xa7a\xa0\xbail (Province of Saudi Arabia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "\xb7\u220F\xa7a\xa0\xbail (Province of Saudi Arabia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "\xb7\u220F\xa7a\xa0\xbail (Province of Saudi Arabia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xb7\u220F\xa7a\xa0\xbail (Province of Saudi Arabia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xb7\u220F\xa7a\xa0\xbail (Province of Saudi Arabia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xb7\u220F\xa7a\xa0\xbail (Province of Saudi Arabia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xb7\u220F\xa7a\xa0\xbail (Province of Saudi Arabia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xb7\u220F\xa7a\xa0\xbail (Province of Saudi Arabia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xb7\u220F\xa7a\xa0\xbail (Province of Saudi Arabia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xb7\u220F\xa7a\xa0\xbail (Province of Saudi Arabia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xb7\u220F\xa7a\xa0\xbail (Province of Saudi Arabia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xb7\u220F\xa7a\xa0\xbail (Province of Saudi Arabia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "A'ana (District of Samoa)": [
            {
                "Region Name": "A'ana (District of Samoa)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A'ana (District of Samoa)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A'ana (District of Samoa)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A'ana (District of Samoa)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A'ana (District of Samoa)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A'ana (District of Samoa)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A'ana (District of Samoa)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A'ana (District of Samoa)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A'ana (District of Samoa)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A'ana (District of Samoa)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A'ana (District of Samoa)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A'ana (District of Samoa)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A'ana (District of Samoa)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A'ana (District of Samoa)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A'ana (District of Samoa)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A'ana (District of Samoa)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A'ana (District of Samoa)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A'ana (District of Samoa)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A'ana (District of Samoa)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A'ana (District of Samoa)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A'ana (District of Samoa)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A'ana (District of Samoa)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "A\u221A\xb1asco (Municipality of Puerto Rico)": [
            {
                "Region Name": "A\u221A\xb1asco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u221A\xb1asco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u221A\xb1asco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u221A\xb1asco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u221A\xb1asco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u221A\xb1asco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u221A\xb1asco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u221A\xb1asco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u221A\xb1asco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u221A\xb1asco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u221A\xb1asco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u221A\xb1asco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u221A\xb1asco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u221A\xb1asco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u221A\xb1asco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u221A\xb1asco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u221A\xb1asco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u221A\xb1asco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u221A\xb1asco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u221A\xb1asco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u221A\xb1asco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u221A\xb1asco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Aargau (Canton of Switzerland)": [
            {
                "Region Name": "Aargau (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aargau (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aargau (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aargau (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aargau (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aargau (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aargau (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aargau (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aargau (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aargau (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aargau (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aargau (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aargau (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aargau (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aargau (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aargau (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aargau (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aargau (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aargau (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aargau (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aargau (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aargau (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Abia (State of Nigeria)": [
            {
                "Region Name": "Abia (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Abia (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Abia (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Abia (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Abia (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Abia (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Abia (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Abia (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Abia (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Abia (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Abia (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Abia (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Abia (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Abia (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Abia (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Abia (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Abia (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Abia (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Abia (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Abia (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Abia (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Abia (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Abidjan (Autonomous district of C\xf4te d'Ivoire)": [
            {
                "Region Name": "Abidjan (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abidjan (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abidjan (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abidjan (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Abidjan (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Abidjan (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Abidjan (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Abidjan (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abidjan (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Abidjan (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abidjan (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Abidjan (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abidjan (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Abidjan (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abidjan (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abidjan (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abidjan (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Abidjan (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Abidjan (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abidjan (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abidjan (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abidjan (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Abkhazia (Autonomous Republic of Georgia)": [
            {
                "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Abkhazia (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Abra (Province of Philippines)": [
            {
                "Region Name": "Abra (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Abra (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Abra (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Abra (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Abra (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Abra (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abra (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Abra (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Abra (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Abra (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Abra (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Abra (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Abra (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Abra (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Abra (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Abra (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Abra (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Abra (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Abra (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Abra (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Abra (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Abra (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Abruzzo (Region of Italy)": [
            {
                "Region Name": "Abruzzo (Region of Italy)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abruzzo (Region of Italy)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abruzzo (Region of Italy)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Abruzzo (Region of Italy)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abruzzo (Region of Italy)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abruzzo (Region of Italy)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Abruzzo (Region of Italy)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Abruzzo (Region of Italy)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abruzzo (Region of Italy)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abruzzo (Region of Italy)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Abruzzo (Region of Italy)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Abruzzo (Region of Italy)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abruzzo (Region of Italy)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abruzzo (Region of Italy)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Abruzzo (Region of Italy)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abruzzo (Region of Italy)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Abruzzo (Region of Italy)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abruzzo (Region of Italy)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abruzzo (Region of Italy)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Abruzzo (Region of Italy)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Abruzzo (Region of Italy)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abruzzo (Region of Italy)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Absheron (Region of Azerbaijan)": [
            {
                "Region Name": "Absheron (Region of Azerbaijan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Absheron (Region of Azerbaijan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Absheron (Region of Azerbaijan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Absheron (Region of Azerbaijan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Absheron (Region of Azerbaijan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Absheron (Region of Azerbaijan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Absheron (Region of Azerbaijan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Absheron (Region of Azerbaijan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Absheron (Region of Azerbaijan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Absheron (Region of Azerbaijan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Absheron (Region of Azerbaijan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Absheron (Region of Azerbaijan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Absheron (Region of Azerbaijan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Absheron (Region of Azerbaijan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Absheron (Region of Azerbaijan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Absheron (Region of Azerbaijan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 83
            },
            {
                "Region Name": "Absheron (Region of Azerbaijan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Absheron (Region of Azerbaijan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Absheron (Region of Azerbaijan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Absheron (Region of Azerbaijan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Absheron (Region of Azerbaijan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Absheron (Region of Azerbaijan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Abu Dhabi (Emirate of United Arab Emirates)": [
            {
                "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Abu Dhabi (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Abyan (Governorate of Yemen)": [
            {
                "Region Name": "Abyan (Governorate of Yemen)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abyan (Governorate of Yemen)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abyan (Governorate of Yemen)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abyan (Governorate of Yemen)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abyan (Governorate of Yemen)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abyan (Governorate of Yemen)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abyan (Governorate of Yemen)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abyan (Governorate of Yemen)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abyan (Governorate of Yemen)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abyan (Governorate of Yemen)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abyan (Governorate of Yemen)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abyan (Governorate of Yemen)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abyan (Governorate of Yemen)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abyan (Governorate of Yemen)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abyan (Governorate of Yemen)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abyan (Governorate of Yemen)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abyan (Governorate of Yemen)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abyan (Governorate of Yemen)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abyan (Governorate of Yemen)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abyan (Governorate of Yemen)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abyan (Governorate of Yemen)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Abyan (Governorate of Yemen)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Aceh (Province of Indonesia)": [
            {
                "Region Name": "Aceh (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Aceh (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aceh (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Aceh (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Aceh (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Aceh (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Aceh (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Aceh (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Aceh (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Aceh (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Aceh (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Aceh (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Aceh (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Aceh (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Aceh (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Aceh (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Aceh (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Aceh (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Aceh (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aceh (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aceh (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Aceh (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Acklins (District of Bahamas)": [
            {
                "Region Name": "Acklins (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acklins (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acklins (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acklins (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acklins (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acklins (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acklins (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acklins (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acklins (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acklins (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acklins (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acklins (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acklins (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acklins (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acklins (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acklins (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acklins (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acklins (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acklins (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acklins (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acklins (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acklins (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Acoua (Commune of Mayotte)": [
            {
                "Region Name": "Acoua (Commune of Mayotte)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acoua (Commune of Mayotte)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acoua (Commune of Mayotte)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acoua (Commune of Mayotte)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acoua (Commune of Mayotte)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acoua (Commune of Mayotte)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acoua (Commune of Mayotte)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acoua (Commune of Mayotte)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acoua (Commune of Mayotte)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acoua (Commune of Mayotte)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acoua (Commune of Mayotte)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acoua (Commune of Mayotte)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acoua (Commune of Mayotte)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acoua (Commune of Mayotte)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acoua (Commune of Mayotte)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acoua (Commune of Mayotte)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acoua (Commune of Mayotte)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acoua (Commune of Mayotte)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acoua (Commune of Mayotte)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acoua (Commune of Mayotte)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acoua (Commune of Mayotte)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acoua (Commune of Mayotte)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Acquaviva (Municipality of San Marino)": [
            {
                "Region Name": "Acquaviva (Municipality of San Marino)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acquaviva (Municipality of San Marino)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acquaviva (Municipality of San Marino)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acquaviva (Municipality of San Marino)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acquaviva (Municipality of San Marino)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acquaviva (Municipality of San Marino)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acquaviva (Municipality of San Marino)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acquaviva (Municipality of San Marino)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acquaviva (Municipality of San Marino)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acquaviva (Municipality of San Marino)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acquaviva (Municipality of San Marino)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acquaviva (Municipality of San Marino)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acquaviva (Municipality of San Marino)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acquaviva (Municipality of San Marino)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acquaviva (Municipality of San Marino)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acquaviva (Municipality of San Marino)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acquaviva (Municipality of San Marino)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acquaviva (Municipality of San Marino)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acquaviva (Municipality of San Marino)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acquaviva (Municipality of San Marino)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acquaviva (Municipality of San Marino)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Acquaviva (Municipality of San Marino)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Acre (State of Brazil)": [
            {
                "Region Name": "Acre (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Acre (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Acre (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Acre (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Acre (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Acre (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Acre (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Acre (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Acre (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Acre (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Acre (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Acre (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Acre (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Acre (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Acre (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Acre (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Acre (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Acre (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Acre (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Acre (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Acre (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Acre (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Ad Dakhliyah (Region of Oman)": [
            {
                "Region Name": "Ad Dakhliyah (Region of Oman)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dakhliyah (Region of Oman)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dakhliyah (Region of Oman)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dakhliyah (Region of Oman)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dakhliyah (Region of Oman)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dakhliyah (Region of Oman)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dakhliyah (Region of Oman)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dakhliyah (Region of Oman)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dakhliyah (Region of Oman)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dakhliyah (Region of Oman)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dakhliyah (Region of Oman)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dakhliyah (Region of Oman)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dakhliyah (Region of Oman)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dakhliyah (Region of Oman)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dakhliyah (Region of Oman)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dakhliyah (Region of Oman)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dakhliyah (Region of Oman)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dakhliyah (Region of Oman)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dakhliyah (Region of Oman)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dakhliyah (Region of Oman)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dakhliyah (Region of Oman)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dakhliyah (Region of Oman)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ad Daqahliyah (Governorate of Egypt)": [
            {
                "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ad Daqahliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 21
            }
        ],
        "Ad Dawhah (Municipality of Qatar)": [
            {
                "Region Name": "Ad Dawhah (Municipality of Qatar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dawhah (Municipality of Qatar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dawhah (Municipality of Qatar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dawhah (Municipality of Qatar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dawhah (Municipality of Qatar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dawhah (Municipality of Qatar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dawhah (Municipality of Qatar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dawhah (Municipality of Qatar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dawhah (Municipality of Qatar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dawhah (Municipality of Qatar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dawhah (Municipality of Qatar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dawhah (Municipality of Qatar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dawhah (Municipality of Qatar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dawhah (Municipality of Qatar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dawhah (Municipality of Qatar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dawhah (Municipality of Qatar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dawhah (Municipality of Qatar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dawhah (Municipality of Qatar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dawhah (Municipality of Qatar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dawhah (Municipality of Qatar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dawhah (Municipality of Qatar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ad Dawhah (Municipality of Qatar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Adamaoua (Region of Cameroon)": [
            {
                "Region Name": "Adamaoua (Region of Cameroon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Adamaoua (Region of Cameroon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Adamaoua (Region of Cameroon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Adamaoua (Region of Cameroon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Adamaoua (Region of Cameroon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Adamaoua (Region of Cameroon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Adamaoua (Region of Cameroon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Adamaoua (Region of Cameroon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Adamaoua (Region of Cameroon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Adamaoua (Region of Cameroon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Adamaoua (Region of Cameroon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Adamaoua (Region of Cameroon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Adamaoua (Region of Cameroon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Adamaoua (Region of Cameroon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Adamaoua (Region of Cameroon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Adamaoua (Region of Cameroon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Adamaoua (Region of Cameroon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Adamaoua (Region of Cameroon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Adamaoua (Region of Cameroon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Adamaoua (Region of Cameroon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Adamaoua (Region of Cameroon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Adamaoua (Region of Cameroon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Adamawa (State of Nigeria)": [
            {
                "Region Name": "Adamawa (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Adamawa (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Adamawa (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Adamawa (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Adamawa (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Adamawa (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Adamawa (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Adamawa (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Adamawa (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Adamawa (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Adamawa (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Adamawa (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Adamawa (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Adamawa (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Adamawa (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Adamawa (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Adamawa (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Adamawa (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Adamawa (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Adamawa (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Adamawa (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Adamawa (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Adana (Province of Turkey)": [
            {
                "Region Name": "Adana (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Adana (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Adana (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Adana (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Adana (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Adana (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Adana (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Adana (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Adana (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Adana (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Adana (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Adana (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Adana (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Adana (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Adana (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Adana (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Adana (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Adana (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Adana (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Adana (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Adana (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Adana (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Addis Abeba (City of Ethiopia)": [
            {
                "Region Name": "Addis Abeba (City of Ethiopia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Addis Abeba (City of Ethiopia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Addis Abeba (City of Ethiopia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Addis Abeba (City of Ethiopia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Addis Abeba (City of Ethiopia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Addis Abeba (City of Ethiopia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Addis Abeba (City of Ethiopia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Addis Abeba (City of Ethiopia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Addis Abeba (City of Ethiopia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Addis Abeba (City of Ethiopia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Addis Abeba (City of Ethiopia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Addis Abeba (City of Ethiopia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Addis Abeba (City of Ethiopia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Addis Abeba (City of Ethiopia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Addis Abeba (City of Ethiopia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Addis Abeba (City of Ethiopia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Addis Abeba (City of Ethiopia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Addis Abeba (City of Ethiopia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Addis Abeba (City of Ethiopia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Addis Abeba (City of Ethiopia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Addis Abeba (City of Ethiopia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Addis Abeba (City of Ethiopia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Adiyaman (Province of Turkey)": [
            {
                "Region Name": "Adiyaman (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Adiyaman (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Adiyaman (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adiyaman (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Adiyaman (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Adiyaman (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Adiyaman (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Adiyaman (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Adiyaman (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Adiyaman (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Adiyaman (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Adiyaman (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Adiyaman (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Adiyaman (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Adiyaman (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Adiyaman (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Adiyaman (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Adiyaman (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Adiyaman (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Adiyaman (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Adiyaman (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Adiyaman (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Adjumani (District of Uganda)": [
            {
                "Region Name": "Adjumani (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Adjumani (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Adjumani (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Adjumani (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Adjumani (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Adjumani (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Adjumani (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Adjumani (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Adjumani (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Adjumani (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Adjumani (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Adjumani (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Adjumani (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Adjumani (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Adjumani (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Adjumani (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Adjumani (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Adjumani (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Adjumani (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Adjumani (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Adjumani (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Adjumani (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Adjuntas (Municipality of Puerto Rico)": [
            {
                "Region Name": "Adjuntas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adjuntas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adjuntas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adjuntas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adjuntas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adjuntas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adjuntas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adjuntas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adjuntas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adjuntas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adjuntas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adjuntas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adjuntas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adjuntas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adjuntas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adjuntas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adjuntas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adjuntas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adjuntas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adjuntas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adjuntas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adjuntas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Adrar (Province of Algeria)": [
            {
                "Region Name": "Adrar (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Adrar (Region of Mauritania)": [
            {
                "Region Name": "Adrar (Region of Mauritania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Region of Mauritania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Region of Mauritania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Region of Mauritania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Region of Mauritania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Region of Mauritania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Region of Mauritania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Region of Mauritania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Region of Mauritania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Region of Mauritania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Region of Mauritania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Region of Mauritania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Region of Mauritania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Region of Mauritania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Region of Mauritania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Region of Mauritania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Region of Mauritania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Region of Mauritania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Region of Mauritania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Region of Mauritania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Region of Mauritania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Adrar (Region of Mauritania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Adygey (Republic of Russia)": [
            {
                "Region Name": "Adygey (Republic of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Adygey (Republic of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Adygey (Republic of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Adygey (Republic of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Adygey (Republic of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Adygey (Republic of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Adygey (Republic of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Adygey (Republic of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Adygey (Republic of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Adygey (Republic of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Adygey (Republic of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Adygey (Republic of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Adygey (Republic of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Adygey (Republic of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Adygey (Republic of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Adygey (Republic of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Adygey (Republic of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Adygey (Republic of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Adygey (Republic of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Adygey (Republic of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Adygey (Republic of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Adygey (Republic of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Aegean (Decentralized administration of Greece)": [
            {
                "Region Name": "Aegean (Decentralized administration of Greece)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Aegean (Decentralized administration of Greece)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aegean (Decentralized administration of Greece)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Aegean (Decentralized administration of Greece)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aegean (Decentralized administration of Greece)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Aegean (Decentralized administration of Greece)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Aegean (Decentralized administration of Greece)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 128
            },
            {
                "Region Name": "Aegean (Decentralized administration of Greece)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aegean (Decentralized administration of Greece)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Aegean (Decentralized administration of Greece)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Aegean (Decentralized administration of Greece)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 74
            },
            {
                "Region Name": "Aegean (Decentralized administration of Greece)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Aegean (Decentralized administration of Greece)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Aegean (Decentralized administration of Greece)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Aegean (Decentralized administration of Greece)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Aegean (Decentralized administration of Greece)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aegean (Decentralized administration of Greece)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aegean (Decentralized administration of Greece)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aegean (Decentralized administration of Greece)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Aegean (Decentralized administration of Greece)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Aegean (Decentralized administration of Greece)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Aegean (Decentralized administration of Greece)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 179
            }
        ],
        "Aerodrom (Municipality of North Macedonia)": [
            {
                "Region Name": "Aerodrom (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aerodrom (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aerodrom (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aerodrom (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aerodrom (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aerodrom (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aerodrom (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aerodrom (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aerodrom (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aerodrom (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aerodrom (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aerodrom (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aerodrom (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aerodrom (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aerodrom (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aerodrom (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aerodrom (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Aerodrom (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aerodrom (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aerodrom (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aerodrom (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aerodrom (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Afar (State of Ethiopia)": [
            {
                "Region Name": "Afar (State of Ethiopia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Afar (State of Ethiopia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Afar (State of Ethiopia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Afar (State of Ethiopia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Afar (State of Ethiopia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Afar (State of Ethiopia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Afar (State of Ethiopia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Afar (State of Ethiopia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Afar (State of Ethiopia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Afar (State of Ethiopia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Afar (State of Ethiopia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Afar (State of Ethiopia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Afar (State of Ethiopia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Afar (State of Ethiopia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Afar (State of Ethiopia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Afar (State of Ethiopia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Afar (State of Ethiopia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Afar (State of Ethiopia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Afar (State of Ethiopia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Afar (State of Ethiopia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Afar (State of Ethiopia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Afar (State of Ethiopia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Afyon (Province of Turkey)": [
            {
                "Region Name": "Afyon (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Afyon (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Afyon (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Afyon (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Afyon (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Afyon (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Afyon (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Afyon (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Afyon (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Afyon (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Afyon (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Afyon (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Afyon (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Afyon (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Afyon (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Afyon (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Afyon (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Afyon (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Afyon (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Afyon (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Afyon (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Afyon (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Agadez (Department of Niger)": [
            {
                "Region Name": "Agadez (Department of Niger)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agadez (Department of Niger)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agadez (Department of Niger)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agadez (Department of Niger)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agadez (Department of Niger)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agadez (Department of Niger)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Agadez (Department of Niger)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Agadez (Department of Niger)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Agadez (Department of Niger)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Agadez (Department of Niger)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Agadez (Department of Niger)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Agadez (Department of Niger)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 119
            },
            {
                "Region Name": "Agadez (Department of Niger)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Agadez (Department of Niger)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Agadez (Department of Niger)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agadez (Department of Niger)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Agadez (Department of Niger)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Agadez (Department of Niger)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Agadez (Department of Niger)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Agadez (Department of Niger)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Agadez (Department of Niger)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Agadez (Department of Niger)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 89
            }
        ],
        "Agalega Islands (Region of Mauritius)": [
            {
                "Region Name": "Agalega Islands (Region of Mauritius)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agalega Islands (Region of Mauritius)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agalega Islands (Region of Mauritius)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agalega Islands (Region of Mauritius)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agalega Islands (Region of Mauritius)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agalega Islands (Region of Mauritius)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agalega Islands (Region of Mauritius)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agalega Islands (Region of Mauritius)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agalega Islands (Region of Mauritius)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agalega Islands (Region of Mauritius)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agalega Islands (Region of Mauritius)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agalega Islands (Region of Mauritius)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agalega Islands (Region of Mauritius)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agalega Islands (Region of Mauritius)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agalega Islands (Region of Mauritius)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agalega Islands (Region of Mauritius)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agalega Islands (Region of Mauritius)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agalega Islands (Region of Mauritius)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agalega Islands (Region of Mauritius)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agalega Islands (Region of Mauritius)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agalega Islands (Region of Mauritius)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agalega Islands (Region of Mauritius)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Agana Heights (Municipality of Guam)": [
            {
                "Region Name": "Agana Heights (Municipality of Guam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agana Heights (Municipality of Guam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agana Heights (Municipality of Guam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agana Heights (Municipality of Guam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agana Heights (Municipality of Guam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agana Heights (Municipality of Guam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agana Heights (Municipality of Guam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agana Heights (Municipality of Guam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agana Heights (Municipality of Guam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agana Heights (Municipality of Guam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agana Heights (Municipality of Guam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agana Heights (Municipality of Guam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agana Heights (Municipality of Guam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agana Heights (Municipality of Guam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agana Heights (Municipality of Guam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agana Heights (Municipality of Guam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agana Heights (Municipality of Guam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agana Heights (Municipality of Guam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agana Heights (Municipality of Guam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agana Heights (Municipality of Guam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agana Heights (Municipality of Guam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agana Heights (Municipality of Guam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Agat (Municipality of Guam)": [
            {
                "Region Name": "Agat (Municipality of Guam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agat (Municipality of Guam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agat (Municipality of Guam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agat (Municipality of Guam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agat (Municipality of Guam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agat (Municipality of Guam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agat (Municipality of Guam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agat (Municipality of Guam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agat (Municipality of Guam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agat (Municipality of Guam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agat (Municipality of Guam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agat (Municipality of Guam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agat (Municipality of Guam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agat (Municipality of Guam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agat (Municipality of Guam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agat (Municipality of Guam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agat (Municipality of Guam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agat (Municipality of Guam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agat (Municipality of Guam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agat (Municipality of Guam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agat (Municipality of Guam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agat (Municipality of Guam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Agri (Province of Turkey)": [
            {
                "Region Name": "Agri (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Agri (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Agri (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Agri (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agri (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Agri (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Agri (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Agri (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Agri (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Agri (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Agri (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Agri (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Agri (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agri (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Agri (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Agri (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Agri (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Agri (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Agri (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Agri (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Agri (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Agri (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Aguada (Municipality of Puerto Rico)": [
            {
                "Region Name": "Aguada (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguada (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguada (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguada (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguada (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguada (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguada (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguada (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguada (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguada (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguada (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguada (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguada (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguada (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguada (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguada (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguada (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguada (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguada (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguada (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguada (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguada (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Aguadilla (Municipality of Puerto Rico)": [
            {
                "Region Name": "Aguadilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguadilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguadilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguadilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguadilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguadilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguadilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguadilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguadilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguadilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguadilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguadilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguadilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguadilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguadilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguadilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguadilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguadilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguadilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguadilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguadilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguadilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Aguas Buenas (Municipality of Puerto Rico)": [
            {
                "Region Name": "Aguas Buenas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguas Buenas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguas Buenas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguas Buenas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguas Buenas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguas Buenas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguas Buenas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguas Buenas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguas Buenas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguas Buenas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguas Buenas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguas Buenas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguas Buenas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguas Buenas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguas Buenas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguas Buenas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguas Buenas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguas Buenas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguas Buenas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguas Buenas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguas Buenas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguas Buenas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Aguascalientes (State of M\xe9xico)": [
            {
                "Region Name": "Aguascalientes (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguascalientes (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguascalientes (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguascalientes (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Aguascalientes (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguascalientes (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguascalientes (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Aguascalientes (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aguascalientes (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguascalientes (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Aguascalientes (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Aguascalientes (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguascalientes (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguascalientes (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguascalientes (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Aguascalientes (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Aguascalientes (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aguascalientes (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Aguascalientes (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Aguascalientes (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aguascalientes (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aguascalientes (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Agusan del Norte (Province of Philippines)": [
            {
                "Region Name": "Agusan del Norte (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Norte (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Norte (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Agusan del Norte (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Norte (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Norte (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Norte (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Norte (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Norte (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Norte (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Norte (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Agusan del Norte (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Norte (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Norte (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Norte (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Agusan del Norte (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Norte (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Agusan del Norte (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Norte (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Norte (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Norte (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Norte (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Agusan del Sur (Province of Philippines)": [
            {
                "Region Name": "Agusan del Sur (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Sur (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Agusan del Sur (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Sur (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Sur (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Sur (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Sur (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Sur (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Agusan del Sur (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Sur (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Sur (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Sur (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Sur (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Sur (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Sur (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Sur (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Sur (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Sur (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Sur (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Agusan del Sur (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Sur (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Agusan del Sur (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ahafo (Region of Ghana)": [
            {
                "Region Name": "Ahafo (Region of Ghana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ahafo (Region of Ghana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ahafo (Region of Ghana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ahafo (Region of Ghana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ahafo (Region of Ghana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ahafo (Region of Ghana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ahafo (Region of Ghana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ahafo (Region of Ghana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ahafo (Region of Ghana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ahafo (Region of Ghana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ahafo (Region of Ghana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ahafo (Region of Ghana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ahafo (Region of Ghana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ahafo (Region of Ghana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ahafo (Region of Ghana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ahafo (Region of Ghana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ahafo (Region of Ghana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ahafo (Region of Ghana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ahafo (Region of Ghana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ahafo (Region of Ghana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ahafo (Region of Ghana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ahafo (Region of Ghana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Ahal (Province of Turkmenistan)": [
            {
                "Region Name": "Ahal (Province of Turkmenistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ahal (Province of Turkmenistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ahal (Province of Turkmenistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ahal (Province of Turkmenistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ahal (Province of Turkmenistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ahal (Province of Turkmenistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ahal (Province of Turkmenistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ahal (Province of Turkmenistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ahal (Province of Turkmenistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ahal (Province of Turkmenistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ahal (Province of Turkmenistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ahal (Province of Turkmenistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Ahal (Province of Turkmenistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Ahal (Province of Turkmenistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ahal (Province of Turkmenistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ahal (Province of Turkmenistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ahal (Province of Turkmenistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ahal (Province of Turkmenistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ahal (Province of Turkmenistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ahal (Province of Turkmenistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ahal (Province of Turkmenistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ahal (Province of Turkmenistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Ahuachap\xe1n (Department of El Salvador)": [
            {
                "Region Name": "Ahuachap\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ahuachap\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ahuachap\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ahuachap\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ahuachap\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ahuachap\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ahuachap\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ahuachap\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ahuachap\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ahuachap\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ahuachap\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ahuachap\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ahuachap\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ahuachap\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ahuachap\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ahuachap\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ahuachap\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ahuachap\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ahuachap\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ahuachap\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ahuachap\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ahuachap\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Aibonito (Municipality of Puerto Rico)": [
            {
                "Region Name": "Aibonito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aibonito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aibonito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aibonito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aibonito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aibonito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aibonito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aibonito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aibonito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aibonito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aibonito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aibonito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aibonito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aibonito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aibonito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aibonito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aibonito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aibonito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aibonito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aibonito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aibonito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aibonito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Aichi (Prefecture of Japan)": [
            {
                "Region Name": "Aichi (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aichi (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aichi (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aichi (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aichi (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aichi (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aichi (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aichi (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aichi (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aichi (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aichi (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aichi (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aichi (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aichi (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aichi (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aichi (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aichi (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aichi (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aichi (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aichi (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aichi (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aichi (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Aiga-i-le-Tai (District of Samoa)": [
            {
                "Region Name": "Aiga-i-le-Tai (District of Samoa)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiga-i-le-Tai (District of Samoa)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiga-i-le-Tai (District of Samoa)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiga-i-le-Tai (District of Samoa)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiga-i-le-Tai (District of Samoa)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiga-i-le-Tai (District of Samoa)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiga-i-le-Tai (District of Samoa)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiga-i-le-Tai (District of Samoa)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiga-i-le-Tai (District of Samoa)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiga-i-le-Tai (District of Samoa)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiga-i-le-Tai (District of Samoa)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiga-i-le-Tai (District of Samoa)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiga-i-le-Tai (District of Samoa)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiga-i-le-Tai (District of Samoa)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiga-i-le-Tai (District of Samoa)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiga-i-le-Tai (District of Samoa)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiga-i-le-Tai (District of Samoa)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiga-i-le-Tai (District of Samoa)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiga-i-le-Tai (District of Samoa)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiga-i-le-Tai (District of Samoa)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiga-i-le-Tai (District of Samoa)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiga-i-le-Tai (District of Samoa)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Aileu (District of Timor-Leste)": [
            {
                "Region Name": "Aileu (District of Timor-Leste)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aileu (District of Timor-Leste)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Aileu (District of Timor-Leste)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Aileu (District of Timor-Leste)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Aileu (District of Timor-Leste)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Aileu (District of Timor-Leste)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Aileu (District of Timor-Leste)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aileu (District of Timor-Leste)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aileu (District of Timor-Leste)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aileu (District of Timor-Leste)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aileu (District of Timor-Leste)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Aileu (District of Timor-Leste)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aileu (District of Timor-Leste)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Aileu (District of Timor-Leste)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aileu (District of Timor-Leste)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aileu (District of Timor-Leste)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aileu (District of Timor-Leste)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aileu (District of Timor-Leste)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Aileu (District of Timor-Leste)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aileu (District of Timor-Leste)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aileu (District of Timor-Leste)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aileu (District of Timor-Leste)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Ailinglaplap (Atol of Marshall Islands)": [
            {
                "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailinglaplap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ailuk (Atol of Marshall Islands)": [
            {
                "Region Name": "Ailuk (Atol of Marshall Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailuk (Atol of Marshall Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailuk (Atol of Marshall Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailuk (Atol of Marshall Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailuk (Atol of Marshall Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailuk (Atol of Marshall Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailuk (Atol of Marshall Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailuk (Atol of Marshall Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailuk (Atol of Marshall Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailuk (Atol of Marshall Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailuk (Atol of Marshall Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailuk (Atol of Marshall Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailuk (Atol of Marshall Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailuk (Atol of Marshall Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailuk (Atol of Marshall Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailuk (Atol of Marshall Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailuk (Atol of Marshall Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailuk (Atol of Marshall Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailuk (Atol of Marshall Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailuk (Atol of Marshall Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailuk (Atol of Marshall Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ailuk (Atol of Marshall Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Aimeliik (State of Palau)": [
            {
                "Region Name": "Aimeliik (State of Palau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aimeliik (State of Palau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aimeliik (State of Palau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aimeliik (State of Palau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aimeliik (State of Palau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aimeliik (State of Palau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aimeliik (State of Palau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aimeliik (State of Palau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aimeliik (State of Palau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aimeliik (State of Palau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aimeliik (State of Palau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aimeliik (State of Palau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aimeliik (State of Palau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aimeliik (State of Palau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aimeliik (State of Palau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aimeliik (State of Palau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aimeliik (State of Palau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aimeliik (State of Palau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aimeliik (State of Palau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aimeliik (State of Palau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aimeliik (State of Palau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aimeliik (State of Palau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "A\xefn Defla (Province of Algeria)": [
            {
                "Region Name": "A\xefn Defla (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "A\xefn Defla (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "A\xefn Defla (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "A\xefn Defla (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "A\xefn Defla (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "A\xefn Defla (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "A\xefn Defla (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "A\xefn Defla (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "A\xefn Defla (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "A\xefn Defla (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "A\xefn Defla (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "A\xefn Defla (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "A\xefn Defla (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "A\xefn Defla (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "A\xefn Defla (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "A\xefn Defla (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "A\xefn Defla (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "A\xefn Defla (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "A\xefn Defla (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "A\xefn Defla (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "A\xefn Defla (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "A\xefn Defla (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "A\xefn T\xe9mouchent (Province of Algeria)": [
            {
                "Region Name": "A\xefn T\xe9mouchent (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\xefn T\xe9mouchent (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\xefn T\xe9mouchent (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\xefn T\xe9mouchent (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\xefn T\xe9mouchent (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\xefn T\xe9mouchent (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\xefn T\xe9mouchent (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\xefn T\xe9mouchent (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\xefn T\xe9mouchent (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\xefn T\xe9mouchent (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\xefn T\xe9mouchent (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\xefn T\xe9mouchent (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\xefn T\xe9mouchent (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "A\xefn T\xe9mouchent (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\xefn T\xe9mouchent (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\xefn T\xe9mouchent (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\xefn T\xe9mouchent (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\xefn T\xe9mouchent (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\xefn T\xe9mouchent (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\xefn T\xe9mouchent (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\xefn T\xe9mouchent (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\xefn T\xe9mouchent (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ainaro (District of Timor-Leste)": [
            {
                "Region Name": "Ainaro (District of Timor-Leste)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ainaro (District of Timor-Leste)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ainaro (District of Timor-Leste)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ainaro (District of Timor-Leste)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ainaro (District of Timor-Leste)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ainaro (District of Timor-Leste)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ainaro (District of Timor-Leste)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ainaro (District of Timor-Leste)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ainaro (District of Timor-Leste)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ainaro (District of Timor-Leste)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ainaro (District of Timor-Leste)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ainaro (District of Timor-Leste)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ainaro (District of Timor-Leste)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ainaro (District of Timor-Leste)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ainaro (District of Timor-Leste)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ainaro (District of Timor-Leste)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ainaro (District of Timor-Leste)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ainaro (District of Timor-Leste)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ainaro (District of Timor-Leste)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ainaro (District of Timor-Leste)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ainaro (District of Timor-Leste)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ainaro (District of Timor-Leste)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Airai (State of Palau)": [
            {
                "Region Name": "Airai (State of Palau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Airai (State of Palau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Airai (State of Palau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Airai (State of Palau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Airai (State of Palau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Airai (State of Palau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Airai (State of Palau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Airai (State of Palau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Airai (State of Palau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Airai (State of Palau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Airai (State of Palau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Airai (State of Palau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Airai (State of Palau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Airai (State of Palau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Airai (State of Palau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Airai (State of Palau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Airai (State of Palau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Airai (State of Palau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Airai (State of Palau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Airai (State of Palau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Airai (State of Palau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Airai (State of Palau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Aitutaki (Island Council of Cook Islands)": [
            {
                "Region Name": "Aitutaki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aitutaki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aitutaki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aitutaki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aitutaki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aitutaki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aitutaki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aitutaki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aitutaki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aitutaki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aitutaki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aitutaki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aitutaki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aitutaki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aitutaki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aitutaki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aitutaki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aitutaki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aitutaki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aitutaki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aitutaki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aitutaki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Aiwo (District of Nauru)": [
            {
                "Region Name": "Aiwo (District of Nauru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiwo (District of Nauru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiwo (District of Nauru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiwo (District of Nauru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiwo (District of Nauru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiwo (District of Nauru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiwo (District of Nauru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiwo (District of Nauru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiwo (District of Nauru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiwo (District of Nauru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiwo (District of Nauru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiwo (District of Nauru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiwo (District of Nauru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiwo (District of Nauru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiwo (District of Nauru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiwo (District of Nauru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiwo (District of Nauru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiwo (District of Nauru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiwo (District of Nauru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiwo (District of Nauru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiwo (District of Nauru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aiwo (District of Nauru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ajaria (Autonomous Republic of Georgia)": [
            {
                "Region Name": "Ajaria (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajaria (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajaria (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajaria (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajaria (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajaria (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajaria (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajaria (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajaria (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajaria (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajaria (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajaria (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajaria (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajaria (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajaria (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajaria (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajaria (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajaria (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajaria (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajaria (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajaria (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajaria (Autonomous Republic of Georgia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ajlun (Province of Jordan)": [
            {
                "Region Name": "Ajlun (Province of Jordan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajlun (Province of Jordan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajlun (Province of Jordan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajlun (Province of Jordan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajlun (Province of Jordan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajlun (Province of Jordan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajlun (Province of Jordan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajlun (Province of Jordan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajlun (Province of Jordan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajlun (Province of Jordan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajlun (Province of Jordan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajlun (Province of Jordan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajlun (Province of Jordan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajlun (Province of Jordan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajlun (Province of Jordan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajlun (Province of Jordan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajlun (Province of Jordan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajlun (Province of Jordan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajlun (Province of Jordan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajlun (Province of Jordan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajlun (Province of Jordan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajlun (Province of Jordan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ajman (Emirate of United Arab Emirates)": [
            {
                "Region Name": "Ajman (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajman (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajman (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajman (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajman (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajman (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajman (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajman (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajman (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajman (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajman (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajman (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajman (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajman (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajman (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajman (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajman (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajman (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajman (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajman (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajman (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ajman (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Akershus (County of Norway)": [
            {
                "Region Name": "Akershus (County of Norway)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akershus (County of Norway)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akershus (County of Norway)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akershus (County of Norway)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akershus (County of Norway)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akershus (County of Norway)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akershus (County of Norway)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akershus (County of Norway)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akershus (County of Norway)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akershus (County of Norway)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akershus (County of Norway)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akershus (County of Norway)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akershus (County of Norway)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akershus (County of Norway)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akershus (County of Norway)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akershus (County of Norway)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akershus (County of Norway)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akershus (County of Norway)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akershus (County of Norway)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akershus (County of Norway)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akershus (County of Norway)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akershus (County of Norway)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Akita (Prefecture of Japan)": [
            {
                "Region Name": "Akita (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akita (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akita (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akita (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akita (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akita (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akita (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akita (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akita (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akita (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akita (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akita (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akita (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akita (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akita (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akita (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akita (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Akita (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Akita (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akita (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Akita (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Akita (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Akkar (Governorate of Lebanon)": [
            {
                "Region Name": "Akkar (Governorate of Lebanon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akkar (Governorate of Lebanon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Akkar (Governorate of Lebanon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Akkar (Governorate of Lebanon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akkar (Governorate of Lebanon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Akkar (Governorate of Lebanon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Akkar (Governorate of Lebanon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akkar (Governorate of Lebanon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akkar (Governorate of Lebanon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akkar (Governorate of Lebanon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akkar (Governorate of Lebanon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akkar (Governorate of Lebanon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Akkar (Governorate of Lebanon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akkar (Governorate of Lebanon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akkar (Governorate of Lebanon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akkar (Governorate of Lebanon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akkar (Governorate of Lebanon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akkar (Governorate of Lebanon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akkar (Governorate of Lebanon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Akkar (Governorate of Lebanon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Akkar (Governorate of Lebanon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akkar (Governorate of Lebanon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Aklan (Province of Philippines)": [
            {
                "Region Name": "Aklan (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aklan (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aklan (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aklan (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aklan (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aklan (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aklan (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Aklan (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aklan (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Aklan (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aklan (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aklan (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aklan (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aklan (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aklan (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aklan (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aklan (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aklan (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Aklan (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aklan (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aklan (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aklan (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)": [
            {
                "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akrotiri (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Aksaray (Province of Turkey)": [
            {
                "Region Name": "Aksaray (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aksaray (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aksaray (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Aksaray (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Aksaray (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aksaray (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aksaray (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aksaray (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Aksaray (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Aksaray (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Aksaray (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Aksaray (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Aksaray (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aksaray (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Aksaray (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Aksaray (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Aksaray (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Aksaray (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Aksaray (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aksaray (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Aksaray (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aksaray (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Akwa Ibom (State of Nigeria)": [
            {
                "Region Name": "Akwa Ibom (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akwa Ibom (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Akwa Ibom (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Akwa Ibom (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Akwa Ibom (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Akwa Ibom (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Akwa Ibom (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Akwa Ibom (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akwa Ibom (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Akwa Ibom (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akwa Ibom (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Akwa Ibom (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Akwa Ibom (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Akwa Ibom (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Akwa Ibom (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Akwa Ibom (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Akwa Ibom (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Akwa Ibom (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Akwa Ibom (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Akwa Ibom (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Akwa Ibom (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Akwa Ibom (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Al-Anbar (Province of Iraq)": [
            {
                "Region Name": "Al-Anbar (Province of Iraq)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al-Anbar (Province of Iraq)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al-Anbar (Province of Iraq)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al-Anbar (Province of Iraq)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Al-Anbar (Province of Iraq)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al-Anbar (Province of Iraq)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Al-Anbar (Province of Iraq)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al-Anbar (Province of Iraq)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al-Anbar (Province of Iraq)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al-Anbar (Province of Iraq)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al-Anbar (Province of Iraq)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Al-Anbar (Province of Iraq)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al-Anbar (Province of Iraq)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al-Anbar (Province of Iraq)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al-Anbar (Province of Iraq)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al-Anbar (Province of Iraq)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al-Anbar (Province of Iraq)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al-Anbar (Province of Iraq)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Al-Anbar (Province of Iraq)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Al-Anbar (Province of Iraq)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al-Anbar (Province of Iraq)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al-Anbar (Province of Iraq)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Al-Basrah (Province of Iraq)": [
            {
                "Region Name": "Al-Basrah (Province of Iraq)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al-Basrah (Province of Iraq)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Al-Basrah (Province of Iraq)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al-Basrah (Province of Iraq)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Al-Basrah (Province of Iraq)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Al-Basrah (Province of Iraq)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al-Basrah (Province of Iraq)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Al-Basrah (Province of Iraq)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al-Basrah (Province of Iraq)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Al-Basrah (Province of Iraq)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al-Basrah (Province of Iraq)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Al-Basrah (Province of Iraq)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Al-Basrah (Province of Iraq)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al-Basrah (Province of Iraq)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Al-Basrah (Province of Iraq)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al-Basrah (Province of Iraq)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al-Basrah (Province of Iraq)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Al-Basrah (Province of Iraq)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Al-Basrah (Province of Iraq)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al-Basrah (Province of Iraq)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al-Basrah (Province of Iraq)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Al-Basrah (Province of Iraq)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Al-\u1E24asakah (Governorate of Syria)": [
            {
                "Region Name": "Al-\u1E24asakah (Governorate of Syria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al-\u1E24asakah (Governorate of Syria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al-\u1E24asakah (Governorate of Syria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al-\u1E24asakah (Governorate of Syria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al-\u1E24asakah (Governorate of Syria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al-\u1E24asakah (Governorate of Syria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al-\u1E24asakah (Governorate of Syria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Al-\u1E24asakah (Governorate of Syria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Al-\u1E24asakah (Governorate of Syria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Al-\u1E24asakah (Governorate of Syria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al-\u1E24asakah (Governorate of Syria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Al-\u1E24asakah (Governorate of Syria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Al-\u1E24asakah (Governorate of Syria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al-\u1E24asakah (Governorate of Syria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al-\u1E24asakah (Governorate of Syria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Al-\u1E24asakah (Governorate of Syria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al-\u1E24asakah (Governorate of Syria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Al-\u1E24asakah (Governorate of Syria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Al-\u1E24asakah (Governorate of Syria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Al-\u1E24asakah (Governorate of Syria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al-\u1E24asakah (Governorate of Syria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al-\u1E24asakah (Governorate of Syria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Al-Muthannia (Province of Iraq)": [
            {
                "Region Name": "Al-Muthannia (Province of Iraq)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al-Muthannia (Province of Iraq)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al-Muthannia (Province of Iraq)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al-Muthannia (Province of Iraq)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al-Muthannia (Province of Iraq)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al-Muthannia (Province of Iraq)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Al-Muthannia (Province of Iraq)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al-Muthannia (Province of Iraq)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al-Muthannia (Province of Iraq)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al-Muthannia (Province of Iraq)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al-Muthannia (Province of Iraq)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al-Muthannia (Province of Iraq)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al-Muthannia (Province of Iraq)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al-Muthannia (Province of Iraq)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al-Muthannia (Province of Iraq)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al-Muthannia (Province of Iraq)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al-Muthannia (Province of Iraq)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al-Muthannia (Province of Iraq)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al-Muthannia (Province of Iraq)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al-Muthannia (Province of Iraq)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al-Muthannia (Province of Iraq)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al-Muthannia (Province of Iraq)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Al-Qadisiyah (Province of Iraq)": [
            {
                "Region Name": "Al-Qadisiyah (Province of Iraq)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al-Qadisiyah (Province of Iraq)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Al-Qadisiyah (Province of Iraq)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al-Qadisiyah (Province of Iraq)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al-Qadisiyah (Province of Iraq)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al-Qadisiyah (Province of Iraq)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Al-Qadisiyah (Province of Iraq)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Al-Qadisiyah (Province of Iraq)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al-Qadisiyah (Province of Iraq)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al-Qadisiyah (Province of Iraq)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al-Qadisiyah (Province of Iraq)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Al-Qadisiyah (Province of Iraq)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al-Qadisiyah (Province of Iraq)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Al-Qadisiyah (Province of Iraq)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Al-Qadisiyah (Province of Iraq)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al-Qadisiyah (Province of Iraq)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al-Qadisiyah (Province of Iraq)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al-Qadisiyah (Province of Iraq)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al-Qadisiyah (Province of Iraq)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Al-Qadisiyah (Province of Iraq)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Al-Qadisiyah (Province of Iraq)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Al-Qadisiyah (Province of Iraq)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Al Ahmadi (Province of Kuwait)": [
            {
                "Region Name": "Al Ahmadi (Province of Kuwait)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Ahmadi (Province of Kuwait)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Al Ahmadi (Province of Kuwait)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Ahmadi (Province of Kuwait)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Ahmadi (Province of Kuwait)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Ahmadi (Province of Kuwait)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Ahmadi (Province of Kuwait)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Ahmadi (Province of Kuwait)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Ahmadi (Province of Kuwait)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Ahmadi (Province of Kuwait)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Ahmadi (Province of Kuwait)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Ahmadi (Province of Kuwait)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Ahmadi (Province of Kuwait)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Ahmadi (Province of Kuwait)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Ahmadi (Province of Kuwait)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Ahmadi (Province of Kuwait)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Ahmadi (Province of Kuwait)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Ahmadi (Province of Kuwait)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al Ahmadi (Province of Kuwait)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Ahmadi (Province of Kuwait)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Ahmadi (Province of Kuwait)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Ahmadi (Province of Kuwait)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Bahah (Province of Saudi Arabia)": [
            {
                "Region Name": "Al Bahah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Bahah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Bahah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Bahr al Ahmar (Governorate of Egypt)": [
            {
                "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bahr al Ahmar (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Batinah North (Region of Oman)": [
            {
                "Region Name": "Al Batinah North (Region of Oman)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah North (Region of Oman)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah North (Region of Oman)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah North (Region of Oman)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah North (Region of Oman)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah North (Region of Oman)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah North (Region of Oman)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Batinah North (Region of Oman)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah North (Region of Oman)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah North (Region of Oman)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah North (Region of Oman)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah North (Region of Oman)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah North (Region of Oman)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah North (Region of Oman)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah North (Region of Oman)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah North (Region of Oman)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah North (Region of Oman)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah North (Region of Oman)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah North (Region of Oman)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah North (Region of Oman)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah North (Region of Oman)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah North (Region of Oman)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Batinah South (Region of Oman)": [
            {
                "Region Name": "Al Batinah South (Region of Oman)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah South (Region of Oman)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah South (Region of Oman)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah South (Region of Oman)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah South (Region of Oman)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah South (Region of Oman)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah South (Region of Oman)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah South (Region of Oman)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah South (Region of Oman)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah South (Region of Oman)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah South (Region of Oman)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah South (Region of Oman)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah South (Region of Oman)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah South (Region of Oman)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah South (Region of Oman)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah South (Region of Oman)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah South (Region of Oman)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah South (Region of Oman)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah South (Region of Oman)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah South (Region of Oman)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah South (Region of Oman)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Batinah South (Region of Oman)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Bayda' (Governorate of Yemen)": [
            {
                "Region Name": "Al Bayda' (Governorate of Yemen)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bayda' (Governorate of Yemen)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bayda' (Governorate of Yemen)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bayda' (Governorate of Yemen)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bayda' (Governorate of Yemen)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bayda' (Governorate of Yemen)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bayda' (Governorate of Yemen)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bayda' (Governorate of Yemen)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bayda' (Governorate of Yemen)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bayda' (Governorate of Yemen)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bayda' (Governorate of Yemen)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bayda' (Governorate of Yemen)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bayda' (Governorate of Yemen)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bayda' (Governorate of Yemen)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bayda' (Governorate of Yemen)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bayda' (Governorate of Yemen)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bayda' (Governorate of Yemen)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bayda' (Governorate of Yemen)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bayda' (Governorate of Yemen)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bayda' (Governorate of Yemen)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bayda' (Governorate of Yemen)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Bayda' (Governorate of Yemen)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Buhayrah (Governorate of Egypt)": [
            {
                "Region Name": "Al Buhayrah (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buhayrah (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buhayrah (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buhayrah (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buhayrah (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al Buhayrah (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Al Buhayrah (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Al Buhayrah (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al Buhayrah (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buhayrah (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Buhayrah (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Al Buhayrah (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Buhayrah (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al Buhayrah (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Al Buhayrah (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buhayrah (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al Buhayrah (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Buhayrah (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Buhayrah (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buhayrah (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al Buhayrah (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al Buhayrah (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Al Buraymi (Region of Oman)": [
            {
                "Region Name": "Al Buraymi (Region of Oman)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buraymi (Region of Oman)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buraymi (Region of Oman)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buraymi (Region of Oman)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buraymi (Region of Oman)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buraymi (Region of Oman)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buraymi (Region of Oman)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buraymi (Region of Oman)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buraymi (Region of Oman)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buraymi (Region of Oman)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buraymi (Region of Oman)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buraymi (Region of Oman)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buraymi (Region of Oman)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buraymi (Region of Oman)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buraymi (Region of Oman)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buraymi (Region of Oman)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buraymi (Region of Oman)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buraymi (Region of Oman)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buraymi (Region of Oman)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buraymi (Region of Oman)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buraymi (Region of Oman)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Buraymi (Region of Oman)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Butnan (District of Libya)": [
            {
                "Region Name": "Al Butnan (District of Libya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Butnan (District of Libya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Butnan (District of Libya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Butnan (District of Libya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Butnan (District of Libya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Butnan (District of Libya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Butnan (District of Libya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Butnan (District of Libya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Butnan (District of Libya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Butnan (District of Libya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Butnan (District of Libya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Butnan (District of Libya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Butnan (District of Libya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Butnan (District of Libya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Butnan (District of Libya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Butnan (District of Libya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Butnan (District of Libya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Butnan (District of Libya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Butnan (District of Libya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Butnan (District of Libya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Butnan (District of Libya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Butnan (District of Libya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Daayen (Municipality of Qatar)": [
            {
                "Region Name": "Al Daayen (Municipality of Qatar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Daayen (Municipality of Qatar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Daayen (Municipality of Qatar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Daayen (Municipality of Qatar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Daayen (Municipality of Qatar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Daayen (Municipality of Qatar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Daayen (Municipality of Qatar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Daayen (Municipality of Qatar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Daayen (Municipality of Qatar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Daayen (Municipality of Qatar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Daayen (Municipality of Qatar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Daayen (Municipality of Qatar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Daayen (Municipality of Qatar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Daayen (Municipality of Qatar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Daayen (Municipality of Qatar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Daayen (Municipality of Qatar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Daayen (Municipality of Qatar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Daayen (Municipality of Qatar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Daayen (Municipality of Qatar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Daayen (Municipality of Qatar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Daayen (Municipality of Qatar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Daayen (Municipality of Qatar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Dali' (Governorate of Yemen)": [
            {
                "Region Name": "Al Dali' (Governorate of Yemen)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dali' (Governorate of Yemen)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dali' (Governorate of Yemen)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dali' (Governorate of Yemen)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dali' (Governorate of Yemen)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dali' (Governorate of Yemen)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dali' (Governorate of Yemen)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dali' (Governorate of Yemen)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dali' (Governorate of Yemen)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dali' (Governorate of Yemen)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dali' (Governorate of Yemen)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dali' (Governorate of Yemen)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dali' (Governorate of Yemen)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dali' (Governorate of Yemen)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dali' (Governorate of Yemen)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dali' (Governorate of Yemen)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dali' (Governorate of Yemen)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dali' (Governorate of Yemen)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dali' (Governorate of Yemen)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dali' (Governorate of Yemen)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dali' (Governorate of Yemen)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dali' (Governorate of Yemen)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Dhahira (Region of Oman)": [
            {
                "Region Name": "Al Dhahira (Region of Oman)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dhahira (Region of Oman)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dhahira (Region of Oman)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dhahira (Region of Oman)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dhahira (Region of Oman)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dhahira (Region of Oman)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al Dhahira (Region of Oman)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dhahira (Region of Oman)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dhahira (Region of Oman)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dhahira (Region of Oman)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dhahira (Region of Oman)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dhahira (Region of Oman)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dhahira (Region of Oman)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dhahira (Region of Oman)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dhahira (Region of Oman)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dhahira (Region of Oman)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dhahira (Region of Oman)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dhahira (Region of Oman)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Al Dhahira (Region of Oman)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Al Dhahira (Region of Oman)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Dhahira (Region of Oman)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Dhahira (Region of Oman)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Farwaniyah (Province of Kuwait)": [
            {
                "Region Name": "Al Farwaniyah (Province of Kuwait)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Farwaniyah (Province of Kuwait)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Farwaniyah (Province of Kuwait)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Farwaniyah (Province of Kuwait)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Farwaniyah (Province of Kuwait)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Farwaniyah (Province of Kuwait)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Farwaniyah (Province of Kuwait)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Farwaniyah (Province of Kuwait)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Farwaniyah (Province of Kuwait)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Farwaniyah (Province of Kuwait)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Farwaniyah (Province of Kuwait)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Farwaniyah (Province of Kuwait)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Farwaniyah (Province of Kuwait)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Farwaniyah (Province of Kuwait)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Farwaniyah (Province of Kuwait)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Farwaniyah (Province of Kuwait)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Farwaniyah (Province of Kuwait)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Farwaniyah (Province of Kuwait)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Farwaniyah (Province of Kuwait)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Farwaniyah (Province of Kuwait)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Farwaniyah (Province of Kuwait)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Farwaniyah (Province of Kuwait)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Fayyum (Governorate of Egypt)": [
            {
                "Region Name": "Al Fayyum (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Fayyum (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Fayyum (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Fayyum (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Fayyum (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Fayyum (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Fayyum (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Fayyum (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Fayyum (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Fayyum (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Fayyum (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Fayyum (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Fayyum (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Fayyum (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Fayyum (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Fayyum (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Fayyum (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Fayyum (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Fayyum (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Fayyum (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Fayyum (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Fayyum (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Gharbiyah (Governorate of Egypt)": [
            {
                "Region Name": "Al Gharbiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Gharbiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Gharbiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Al Gharbiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al Gharbiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Al Gharbiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Al Gharbiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Gharbiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Gharbiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Al Gharbiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Gharbiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Gharbiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Al Gharbiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al Gharbiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al Gharbiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al Gharbiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al Gharbiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Gharbiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Gharbiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Gharbiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Gharbiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Gharbiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Al Hudaydah (Governorate of Yemen)": [
            {
                "Region Name": "Al Hudaydah (Governorate of Yemen)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudaydah (Governorate of Yemen)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudaydah (Governorate of Yemen)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudaydah (Governorate of Yemen)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudaydah (Governorate of Yemen)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Hudaydah (Governorate of Yemen)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudaydah (Governorate of Yemen)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudaydah (Governorate of Yemen)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Hudaydah (Governorate of Yemen)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudaydah (Governorate of Yemen)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Hudaydah (Governorate of Yemen)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudaydah (Governorate of Yemen)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudaydah (Governorate of Yemen)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudaydah (Governorate of Yemen)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Hudaydah (Governorate of Yemen)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Al Hudaydah (Governorate of Yemen)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al Hudaydah (Governorate of Yemen)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudaydah (Governorate of Yemen)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudaydah (Governorate of Yemen)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudaydah (Governorate of Yemen)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudaydah (Governorate of Yemen)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Hudaydah (Governorate of Yemen)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Al Hudud ash Shamaliyah (Province of Saudi Arabia)": [
            {
                "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Hudud ash Shamaliyah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Iskandariyah (Governorate of Egypt)": [
            {
                "Region Name": "Al Iskandariyah (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Iskandariyah (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Iskandariyah (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Iskandariyah (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Iskandariyah (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Iskandariyah (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Iskandariyah (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Iskandariyah (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Iskandariyah (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Iskandariyah (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Iskandariyah (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Iskandariyah (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Iskandariyah (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Iskandariyah (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Iskandariyah (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Iskandariyah (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Iskandariyah (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al Iskandariyah (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Iskandariyah (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Iskandariyah (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Iskandariyah (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Iskandariyah (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Isma`iliyah (Governorate of Egypt)": [
            {
                "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Isma`iliyah (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Jabal al Akhdar (District of Libya)": [
            {
                "Region Name": "Al Jabal al Akhdar (District of Libya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Akhdar (District of Libya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Jabal al Akhdar (District of Libya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Akhdar (District of Libya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Akhdar (District of Libya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al Jabal al Akhdar (District of Libya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Akhdar (District of Libya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Akhdar (District of Libya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Akhdar (District of Libya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Akhdar (District of Libya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Akhdar (District of Libya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Akhdar (District of Libya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Al Jabal al Akhdar (District of Libya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Akhdar (District of Libya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Akhdar (District of Libya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Akhdar (District of Libya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Akhdar (District of Libya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Akhdar (District of Libya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Akhdar (District of Libya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Akhdar (District of Libya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Akhdar (District of Libya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Akhdar (District of Libya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Jabal al Gharbi (District of Libya)": [
            {
                "Region Name": "Al Jabal al Gharbi (District of Libya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Gharbi (District of Libya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Gharbi (District of Libya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Gharbi (District of Libya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Gharbi (District of Libya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Gharbi (District of Libya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Gharbi (District of Libya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Gharbi (District of Libya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Gharbi (District of Libya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Gharbi (District of Libya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Gharbi (District of Libya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Gharbi (District of Libya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Gharbi (District of Libya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Gharbi (District of Libya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Gharbi (District of Libya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Gharbi (District of Libya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Gharbi (District of Libya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Gharbi (District of Libya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Gharbi (District of Libya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Gharbi (District of Libya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Gharbi (District of Libya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jabal al Gharbi (District of Libya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Jahrah (Province of Kuwait)": [
            {
                "Region Name": "Al Jahrah (Province of Kuwait)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Jahrah (Province of Kuwait)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Al Jahrah (Province of Kuwait)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jahrah (Province of Kuwait)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Jahrah (Province of Kuwait)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al Jahrah (Province of Kuwait)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Jahrah (Province of Kuwait)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jahrah (Province of Kuwait)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Al Jahrah (Province of Kuwait)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Al Jahrah (Province of Kuwait)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Jahrah (Province of Kuwait)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Jahrah (Province of Kuwait)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jahrah (Province of Kuwait)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jahrah (Province of Kuwait)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jahrah (Province of Kuwait)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Al Jahrah (Province of Kuwait)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jahrah (Province of Kuwait)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Al Jahrah (Province of Kuwait)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Jahrah (Province of Kuwait)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Al Jahrah (Province of Kuwait)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jahrah (Province of Kuwait)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Al Jahrah (Province of Kuwait)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Al Jawf (Governorate of Yemen)": [
            {
                "Region Name": "Al Jawf (Governorate of Yemen)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jawf (Governorate of Yemen)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jawf (Governorate of Yemen)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jawf (Governorate of Yemen)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jawf (Governorate of Yemen)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jawf (Governorate of Yemen)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jawf (Governorate of Yemen)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jawf (Governorate of Yemen)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jawf (Governorate of Yemen)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jawf (Governorate of Yemen)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jawf (Governorate of Yemen)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jawf (Governorate of Yemen)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jawf (Governorate of Yemen)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jawf (Governorate of Yemen)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jawf (Governorate of Yemen)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jawf (Governorate of Yemen)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jawf (Governorate of Yemen)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jawf (Governorate of Yemen)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jawf (Governorate of Yemen)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jawf (Governorate of Yemen)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jawf (Governorate of Yemen)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jawf (Governorate of Yemen)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Jawf (Province of Saudi Arabia)": [
            {
                "Region Name": "Al Jawf (Province of Saudi Arabia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Al Jawf (Province of Saudi Arabia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Al Jawf (Province of Saudi Arabia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Al Jawf (Province of Saudi Arabia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Al Jawf (Province of Saudi Arabia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Al Jawf (Province of Saudi Arabia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Al Jawf (Province of Saudi Arabia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Al Jawf (Province of Saudi Arabia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al Jawf (Province of Saudi Arabia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Al Jawf (Province of Saudi Arabia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Al Jawf (Province of Saudi Arabia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Al Jawf (Province of Saudi Arabia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Al Jawf (Province of Saudi Arabia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Al Jawf (Province of Saudi Arabia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Jawf (Province of Saudi Arabia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Jawf (Province of Saudi Arabia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Jawf (Province of Saudi Arabia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Jawf (Province of Saudi Arabia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Jawf (Province of Saudi Arabia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al Jawf (Province of Saudi Arabia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Jawf (Province of Saudi Arabia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Jawf (Province of Saudi Arabia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Al Jazirah (State of Sudan)": [
            {
                "Region Name": "Al Jazirah (State of Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Jazirah (State of Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Al Jazirah (State of Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Al Jazirah (State of Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Al Jazirah (State of Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al Jazirah (State of Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Al Jazirah (State of Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Al Jazirah (State of Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Jazirah (State of Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Al Jazirah (State of Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al Jazirah (State of Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Jazirah (State of Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Al Jazirah (State of Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al Jazirah (State of Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al Jazirah (State of Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Al Jazirah (State of Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Al Jazirah (State of Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Al Jazirah (State of Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Al Jazirah (State of Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Al Jazirah (State of Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Al Jazirah (State of Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Al Jazirah (State of Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Al Jifarah (District of Libya)": [
            {
                "Region Name": "Al Jifarah (District of Libya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jifarah (District of Libya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jifarah (District of Libya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jifarah (District of Libya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jifarah (District of Libya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jifarah (District of Libya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jifarah (District of Libya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jifarah (District of Libya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jifarah (District of Libya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jifarah (District of Libya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jifarah (District of Libya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jifarah (District of Libya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jifarah (District of Libya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jifarah (District of Libya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jifarah (District of Libya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jifarah (District of Libya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jifarah (District of Libya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jifarah (District of Libya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al Jifarah (District of Libya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Al Jifarah (District of Libya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jifarah (District of Libya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jifarah (District of Libya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Jizah (Governorate of Egypt)": [
            {
                "Region Name": "Al Jizah (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jizah (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jizah (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jizah (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jizah (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jizah (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jizah (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jizah (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jizah (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jizah (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jizah (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jizah (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jizah (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jizah (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jizah (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jizah (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jizah (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jizah (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jizah (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jizah (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jizah (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al Jizah (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Jufrah (District of Libya)": [
            {
                "Region Name": "Al Jufrah (District of Libya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jufrah (District of Libya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jufrah (District of Libya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jufrah (District of Libya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jufrah (District of Libya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jufrah (District of Libya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jufrah (District of Libya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jufrah (District of Libya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jufrah (District of Libya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jufrah (District of Libya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jufrah (District of Libya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jufrah (District of Libya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jufrah (District of Libya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jufrah (District of Libya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jufrah (District of Libya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jufrah (District of Libya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jufrah (District of Libya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jufrah (District of Libya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Jufrah (District of Libya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jufrah (District of Libya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jufrah (District of Libya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Jufrah (District of Libya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Khor (Municipality of Qatar)": [
            {
                "Region Name": "Al Khor (Municipality of Qatar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Khor (Municipality of Qatar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Khor (Municipality of Qatar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Khor (Municipality of Qatar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Khor (Municipality of Qatar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Khor (Municipality of Qatar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al Khor (Municipality of Qatar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Khor (Municipality of Qatar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Al Khor (Municipality of Qatar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Khor (Municipality of Qatar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Khor (Municipality of Qatar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al Khor (Municipality of Qatar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Khor (Municipality of Qatar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Khor (Municipality of Qatar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Al Khor (Municipality of Qatar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Khor (Municipality of Qatar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Khor (Municipality of Qatar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Khor (Municipality of Qatar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Khor (Municipality of Qatar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Khor (Municipality of Qatar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Khor (Municipality of Qatar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Khor (Municipality of Qatar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Kufrah (District of Libya)": [
            {
                "Region Name": "Al Kufrah (District of Libya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kufrah (District of Libya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kufrah (District of Libya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kufrah (District of Libya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kufrah (District of Libya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kufrah (District of Libya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kufrah (District of Libya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kufrah (District of Libya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kufrah (District of Libya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kufrah (District of Libya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kufrah (District of Libya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kufrah (District of Libya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kufrah (District of Libya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kufrah (District of Libya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kufrah (District of Libya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kufrah (District of Libya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kufrah (District of Libya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kufrah (District of Libya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kufrah (District of Libya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kufrah (District of Libya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kufrah (District of Libya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kufrah (District of Libya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Kuwayt (Province of Kuwait)": [
            {
                "Region Name": "Al Kuwayt (Province of Kuwait)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kuwayt (Province of Kuwait)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kuwayt (Province of Kuwait)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kuwayt (Province of Kuwait)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kuwayt (Province of Kuwait)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kuwayt (Province of Kuwait)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kuwayt (Province of Kuwait)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kuwayt (Province of Kuwait)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kuwayt (Province of Kuwait)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kuwayt (Province of Kuwait)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kuwayt (Province of Kuwait)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kuwayt (Province of Kuwait)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kuwayt (Province of Kuwait)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kuwayt (Province of Kuwait)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kuwayt (Province of Kuwait)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kuwayt (Province of Kuwait)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kuwayt (Province of Kuwait)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kuwayt (Province of Kuwait)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kuwayt (Province of Kuwait)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kuwayt (Province of Kuwait)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kuwayt (Province of Kuwait)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Kuwayt (Province of Kuwait)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Madinah (Province of Saudi Arabia)": [
            {
                "Region Name": "Al Madinah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Al Madinah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Madinah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Madinah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Al Madinah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Madinah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Madinah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Madinah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Madinah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Madinah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Madinah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Madinah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Madinah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Madinah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Madinah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Madinah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Madinah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Madinah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Madinah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Madinah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Madinah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Madinah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Mahrah (Governorate of Yemen)": [
            {
                "Region Name": "Al Mahrah (Governorate of Yemen)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahrah (Governorate of Yemen)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahrah (Governorate of Yemen)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahrah (Governorate of Yemen)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahrah (Governorate of Yemen)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahrah (Governorate of Yemen)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahrah (Governorate of Yemen)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahrah (Governorate of Yemen)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahrah (Governorate of Yemen)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahrah (Governorate of Yemen)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahrah (Governorate of Yemen)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahrah (Governorate of Yemen)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahrah (Governorate of Yemen)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahrah (Governorate of Yemen)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahrah (Governorate of Yemen)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahrah (Governorate of Yemen)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahrah (Governorate of Yemen)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahrah (Governorate of Yemen)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahrah (Governorate of Yemen)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahrah (Governorate of Yemen)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahrah (Governorate of Yemen)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahrah (Governorate of Yemen)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Mahwit (Governorate of Yemen)": [
            {
                "Region Name": "Al Mahwit (Governorate of Yemen)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahwit (Governorate of Yemen)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahwit (Governorate of Yemen)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahwit (Governorate of Yemen)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahwit (Governorate of Yemen)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahwit (Governorate of Yemen)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahwit (Governorate of Yemen)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahwit (Governorate of Yemen)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahwit (Governorate of Yemen)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahwit (Governorate of Yemen)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahwit (Governorate of Yemen)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahwit (Governorate of Yemen)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahwit (Governorate of Yemen)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahwit (Governorate of Yemen)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahwit (Governorate of Yemen)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahwit (Governorate of Yemen)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahwit (Governorate of Yemen)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahwit (Governorate of Yemen)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahwit (Governorate of Yemen)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahwit (Governorate of Yemen)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahwit (Governorate of Yemen)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Mahwit (Governorate of Yemen)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Marj (District of Libya)": [
            {
                "Region Name": "Al Marj (District of Libya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marj (District of Libya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Marj (District of Libya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marj (District of Libya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marj (District of Libya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marj (District of Libya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marj (District of Libya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marj (District of Libya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marj (District of Libya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marj (District of Libya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marj (District of Libya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marj (District of Libya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marj (District of Libya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marj (District of Libya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marj (District of Libya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Marj (District of Libya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marj (District of Libya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marj (District of Libya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marj (District of Libya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Marj (District of Libya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marj (District of Libya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marj (District of Libya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Marqab (District of Libya)": [
            {
                "Region Name": "Al Marqab (District of Libya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marqab (District of Libya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marqab (District of Libya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marqab (District of Libya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marqab (District of Libya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marqab (District of Libya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marqab (District of Libya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marqab (District of Libya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marqab (District of Libya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marqab (District of Libya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marqab (District of Libya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marqab (District of Libya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marqab (District of Libya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marqab (District of Libya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marqab (District of Libya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marqab (District of Libya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marqab (District of Libya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marqab (District of Libya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marqab (District of Libya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Al Marqab (District of Libya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marqab (District of Libya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Marqab (District of Libya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Minufiyah (Governorate of Egypt)": [
            {
                "Region Name": "Al Minufiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minufiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minufiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minufiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minufiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minufiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minufiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minufiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minufiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minufiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minufiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minufiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minufiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minufiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minufiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minufiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minufiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minufiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minufiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minufiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minufiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minufiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Minya (Governorate of Egypt)": [
            {
                "Region Name": "Al Minya (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minya (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minya (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minya (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minya (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minya (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minya (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minya (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minya (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minya (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minya (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minya (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minya (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minya (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minya (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minya (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minya (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minya (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minya (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minya (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Minya (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Minya (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Qadarif (State of Sudan)": [
            {
                "Region Name": "Al Qadarif (State of Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Al Qadarif (State of Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Al Qadarif (State of Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Al Qadarif (State of Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Al Qadarif (State of Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Al Qadarif (State of Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Al Qadarif (State of Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Al Qadarif (State of Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Al Qadarif (State of Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Al Qadarif (State of Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Al Qadarif (State of Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Al Qadarif (State of Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Al Qadarif (State of Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Al Qadarif (State of Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Al Qadarif (State of Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Al Qadarif (State of Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Al Qadarif (State of Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Al Qadarif (State of Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Al Qadarif (State of Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Al Qadarif (State of Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Al Qadarif (State of Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Al Qadarif (State of Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Al Qahirah (Governorate of Egypt)": [
            {
                "Region Name": "Al Qahirah (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qahirah (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qahirah (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qahirah (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qahirah (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qahirah (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qahirah (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qahirah (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qahirah (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qahirah (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qahirah (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qahirah (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qahirah (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qahirah (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qahirah (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qahirah (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qahirah (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qahirah (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qahirah (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qahirah (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qahirah (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qahirah (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Qalyubiyah (Governorate of Egypt)": [
            {
                "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qalyubiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Qassim (Province of Saudi Arabia)": [
            {
                "Region Name": "Al Qassim (Province of Saudi Arabia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Al Qassim (Province of Saudi Arabia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al Qassim (Province of Saudi Arabia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Qassim (Province of Saudi Arabia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al Qassim (Province of Saudi Arabia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Qassim (Province of Saudi Arabia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Al Qassim (Province of Saudi Arabia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Qassim (Province of Saudi Arabia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Qassim (Province of Saudi Arabia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Qassim (Province of Saudi Arabia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Al Qassim (Province of Saudi Arabia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qassim (Province of Saudi Arabia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qassim (Province of Saudi Arabia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qassim (Province of Saudi Arabia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qassim (Province of Saudi Arabia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qassim (Province of Saudi Arabia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qassim (Province of Saudi Arabia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qassim (Province of Saudi Arabia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qassim (Province of Saudi Arabia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qassim (Province of Saudi Arabia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qassim (Province of Saudi Arabia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Qassim (Province of Saudi Arabia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Uqsur (Governorate of Egypt)": [
            {
                "Region Name": "Al Uqsur (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Uqsur (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Uqsur (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Uqsur (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Uqsur (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Uqsur (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Uqsur (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Uqsur (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Uqsur (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Uqsur (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Uqsur (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Uqsur (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Uqsur (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Uqsur (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Uqsur (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Uqsur (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Uqsur (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Uqsur (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Uqsur (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Uqsur (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Uqsur (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Uqsur (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Wadi al Jadid (Governorate of Egypt)": [
            {
                "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Al Wadi al Jadid (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "Al Wahat (District of Libya)": [
            {
                "Region Name": "Al Wahat (District of Libya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wahat (District of Libya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wahat (District of Libya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wahat (District of Libya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wahat (District of Libya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wahat (District of Libya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wahat (District of Libya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wahat (District of Libya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wahat (District of Libya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wahat (District of Libya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Wahat (District of Libya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Wahat (District of Libya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wahat (District of Libya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wahat (District of Libya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wahat (District of Libya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wahat (District of Libya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wahat (District of Libya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wahat (District of Libya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Wahat (District of Libya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wahat (District of Libya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wahat (District of Libya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wahat (District of Libya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Wakrah (Municipality of Qatar)": [
            {
                "Region Name": "Al Wakrah (Municipality of Qatar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wakrah (Municipality of Qatar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wakrah (Municipality of Qatar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wakrah (Municipality of Qatar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wakrah (Municipality of Qatar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Wakrah (Municipality of Qatar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wakrah (Municipality of Qatar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wakrah (Municipality of Qatar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wakrah (Municipality of Qatar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wakrah (Municipality of Qatar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wakrah (Municipality of Qatar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wakrah (Municipality of Qatar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wakrah (Municipality of Qatar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wakrah (Municipality of Qatar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wakrah (Municipality of Qatar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Wakrah (Municipality of Qatar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wakrah (Municipality of Qatar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Wakrah (Municipality of Qatar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wakrah (Municipality of Qatar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wakrah (Municipality of Qatar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wakrah (Municipality of Qatar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Al Wakrah (Municipality of Qatar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Al Wusta (Region of Oman)": [
            {
                "Region Name": "Al Wusta (Region of Oman)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wusta (Region of Oman)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wusta (Region of Oman)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wusta (Region of Oman)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wusta (Region of Oman)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wusta (Region of Oman)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wusta (Region of Oman)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wusta (Region of Oman)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wusta (Region of Oman)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wusta (Region of Oman)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wusta (Region of Oman)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wusta (Region of Oman)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wusta (Region of Oman)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wusta (Region of Oman)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wusta (Region of Oman)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Wusta (Region of Oman)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wusta (Region of Oman)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wusta (Region of Oman)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wusta (Region of Oman)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wusta (Region of Oman)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Al Wusta (Region of Oman)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Al Wusta (Region of Oman)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Alabama (State of United States)": [
            {
                "Region Name": "Alabama (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Alabama (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Alabama (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alabama (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alabama (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alabama (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Alabama (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alabama (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Alabama (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alabama (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Alabama (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alabama (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alabama (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alabama (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Alabama (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Alabama (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alabama (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Alabama (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Alabama (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alabama (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alabama (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alabama (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Alagoas (State of Brazil)": [
            {
                "Region Name": "Alagoas (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alagoas (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alagoas (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alagoas (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Alagoas (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alagoas (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alagoas (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alagoas (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Alagoas (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alagoas (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Alagoas (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Alagoas (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Alagoas (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Alagoas (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Alagoas (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Alagoas (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alagoas (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Alagoas (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alagoas (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Alagoas (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Alagoas (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Alagoas (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Alajuela (Province of Costa Rica)": [
            {
                "Region Name": "Alajuela (Province of Costa Rica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alajuela (Province of Costa Rica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alajuela (Province of Costa Rica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Alajuela (Province of Costa Rica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Alajuela (Province of Costa Rica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Alajuela (Province of Costa Rica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alajuela (Province of Costa Rica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Alajuela (Province of Costa Rica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alajuela (Province of Costa Rica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alajuela (Province of Costa Rica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Alajuela (Province of Costa Rica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Alajuela (Province of Costa Rica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Alajuela (Province of Costa Rica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Alajuela (Province of Costa Rica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Alajuela (Province of Costa Rica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Alajuela (Province of Costa Rica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Alajuela (Province of Costa Rica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alajuela (Province of Costa Rica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Alajuela (Province of Costa Rica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Alajuela (Province of Costa Rica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alajuela (Province of Costa Rica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Alajuela (Province of Costa Rica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Alaska (State of United States)": [
            {
                "Region Name": "Alaska (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Alaska (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Alaska (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Alaska (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Alaska (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alaska (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alaska (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alaska (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Alaska (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Alaska (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alaska (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alaska (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alaska (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Alaska (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Alaska (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alaska (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Alaska (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Alaska (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Alaska (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Alaska (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alaska (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Alaska (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Alba (County of Romania)": [
            {
                "Region Name": "Alba (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Alba (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Alba (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Alba (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alba (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Alba (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Alba (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Alba (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Alba (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Alba (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Alba (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Alba (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alba (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alba (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alba (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Alba (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Alba (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Alba (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Alba (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Alba (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alba (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Alba (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Albay (Province of Philippines)": [
            {
                "Region Name": "Albay (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Albay (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Albay (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Albay (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Albay (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Albay (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Albay (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Albay (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Albay (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Albay (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Albay (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Albay (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Albay (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Albay (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Albay (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Albay (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Albay (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Albay (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Albay (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Albay (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Albay (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Albay (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Alberta (Province of Canada)": [
            {
                "Region Name": "Alberta (Province of Canada)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Alberta (Province of Canada)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Alberta (Province of Canada)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Alberta (Province of Canada)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Alberta (Province of Canada)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Alberta (Province of Canada)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Alberta (Province of Canada)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Alberta (Province of Canada)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Alberta (Province of Canada)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Alberta (Province of Canada)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Alberta (Province of Canada)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Alberta (Province of Canada)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Alberta (Province of Canada)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Alberta (Province of Canada)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 103
            },
            {
                "Region Name": "Alberta (Province of Canada)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Alberta (Province of Canada)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Alberta (Province of Canada)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Alberta (Province of Canada)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "Alberta (Province of Canada)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alberta (Province of Canada)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Alberta (Province of Canada)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Alberta (Province of Canada)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 72
            }
        ],
        "Alborz (Province of Iran)": [
            {
                "Region Name": "Alborz (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Alborz (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Alborz (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alborz (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Alborz (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Alborz (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Alborz (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alborz (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alborz (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Alborz (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Alborz (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Alborz (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alborz (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Alborz (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Alborz (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alborz (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alborz (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Alborz (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Alborz (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alborz (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alborz (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alborz (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Alderney (Parish of Guernsey)": [
            {
                "Region Name": "Alderney (Parish of Guernsey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alderney (Parish of Guernsey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alderney (Parish of Guernsey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alderney (Parish of Guernsey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alderney (Parish of Guernsey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alderney (Parish of Guernsey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alderney (Parish of Guernsey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alderney (Parish of Guernsey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alderney (Parish of Guernsey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alderney (Parish of Guernsey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alderney (Parish of Guernsey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alderney (Parish of Guernsey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alderney (Parish of Guernsey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alderney (Parish of Guernsey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alderney (Parish of Guernsey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alderney (Parish of Guernsey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alderney (Parish of Guernsey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alderney (Parish of Guernsey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alderney (Parish of Guernsey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alderney (Parish of Guernsey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alderney (Parish of Guernsey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alderney (Parish of Guernsey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Aleppo (Governorate of Syria)": [
            {
                "Region Name": "Aleppo (Governorate of Syria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Aleppo (Governorate of Syria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Aleppo (Governorate of Syria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Aleppo (Governorate of Syria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Aleppo (Governorate of Syria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Aleppo (Governorate of Syria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aleppo (Governorate of Syria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aleppo (Governorate of Syria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aleppo (Governorate of Syria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Aleppo (Governorate of Syria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Aleppo (Governorate of Syria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Aleppo (Governorate of Syria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Aleppo (Governorate of Syria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Aleppo (Governorate of Syria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Aleppo (Governorate of Syria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Aleppo (Governorate of Syria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Aleppo (Governorate of Syria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Aleppo (Governorate of Syria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Aleppo (Governorate of Syria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Aleppo (Governorate of Syria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Aleppo (Governorate of Syria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Aleppo (Governorate of Syria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Alger (Province of Algeria)": [
            {
                "Region Name": "Alger (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alger (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alger (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alger (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alger (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alger (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alger (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alger (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alger (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alger (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alger (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alger (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alger (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alger (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alger (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alger (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alger (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alger (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alger (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alger (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alger (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alger (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ali Sabieh (Region of Djibouti)": [
            {
                "Region Name": "Ali Sabieh (Region of Djibouti)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ali Sabieh (Region of Djibouti)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ali Sabieh (Region of Djibouti)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ali Sabieh (Region of Djibouti)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ali Sabieh (Region of Djibouti)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ali Sabieh (Region of Djibouti)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ali Sabieh (Region of Djibouti)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ali Sabieh (Region of Djibouti)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ali Sabieh (Region of Djibouti)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ali Sabieh (Region of Djibouti)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ali Sabieh (Region of Djibouti)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ali Sabieh (Region of Djibouti)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ali Sabieh (Region of Djibouti)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ali Sabieh (Region of Djibouti)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ali Sabieh (Region of Djibouti)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ali Sabieh (Region of Djibouti)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ali Sabieh (Region of Djibouti)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ali Sabieh (Region of Djibouti)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ali Sabieh (Region of Djibouti)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ali Sabieh (Region of Djibouti)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ali Sabieh (Region of Djibouti)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ali Sabieh (Region of Djibouti)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Alibori (Department of Benin)": [
            {
                "Region Name": "Alibori (Department of Benin)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Alibori (Department of Benin)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Alibori (Department of Benin)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Alibori (Department of Benin)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Alibori (Department of Benin)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Alibori (Department of Benin)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Alibori (Department of Benin)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Alibori (Department of Benin)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Alibori (Department of Benin)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Alibori (Department of Benin)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Alibori (Department of Benin)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Alibori (Department of Benin)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Alibori (Department of Benin)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Alibori (Department of Benin)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Alibori (Department of Benin)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Alibori (Department of Benin)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Alibori (Department of Benin)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Alibori (Department of Benin)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Alibori (Department of Benin)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Alibori (Department of Benin)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Alibori (Department of Benin)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Alibori (Department of Benin)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "Almaty (Region of Kazakhstan)": [
            {
                "Region Name": "Almaty (Region of Kazakhstan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Almaty (Region of Kazakhstan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Almaty (Region of Kazakhstan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Almaty (Region of Kazakhstan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Almaty (Region of Kazakhstan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Almaty (Region of Kazakhstan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Almaty (Region of Kazakhstan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Almaty (Region of Kazakhstan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Almaty (Region of Kazakhstan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Almaty (Region of Kazakhstan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Almaty (Region of Kazakhstan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Almaty (Region of Kazakhstan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Almaty (Region of Kazakhstan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Almaty (Region of Kazakhstan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Almaty (Region of Kazakhstan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Almaty (Region of Kazakhstan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Almaty (Region of Kazakhstan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Almaty (Region of Kazakhstan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Almaty (Region of Kazakhstan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Almaty (Region of Kazakhstan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Almaty (Region of Kazakhstan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Almaty (Region of Kazakhstan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Alo (Kingdom of Wallis and Futuna)": [
            {
                "Region Name": "Alo (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alo (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alo (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alo (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alo (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alo (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alo (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alo (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alo (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alo (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alo (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alo (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alo (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alo (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alo (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alo (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alo (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alo (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alo (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alo (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alo (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alo (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Alta Verapaz (Department of Guatemala)": [
            {
                "Region Name": "Alta Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Alta Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Alta Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Alta Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alta Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alta Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alta Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Alta Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Alta Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Alta Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Alta Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alta Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Alta Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alta Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Alta Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alta Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Alta Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Alta Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Alta Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Alta Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alta Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Alta Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Altay (Territory of Russia)": [
            {
                "Region Name": "Altay (Territory of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Altay (Territory of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Altay (Territory of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Altay (Territory of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Altay (Territory of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Altay (Territory of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Altay (Territory of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Altay (Territory of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Altay (Territory of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Altay (Territory of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Altay (Territory of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Altay (Territory of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Altay (Territory of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Altay (Territory of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Altay (Territory of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Altay (Territory of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Altay (Territory of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Altay (Territory of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Altay (Territory of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Altay (Territory of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Altay (Territory of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Altay (Territory of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Alto Paraguay (Department of Paraguay)": [
            {
                "Region Name": "Alto Paraguay (Department of Paraguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Alto Paraguay (Department of Paraguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Alto Paraguay (Department of Paraguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Alto Paraguay (Department of Paraguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Alto Paraguay (Department of Paraguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Alto Paraguay (Department of Paraguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Alto Paraguay (Department of Paraguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Alto Paraguay (Department of Paraguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Alto Paraguay (Department of Paraguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Alto Paraguay (Department of Paraguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Alto Paraguay (Department of Paraguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Alto Paraguay (Department of Paraguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Alto Paraguay (Department of Paraguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Alto Paraguay (Department of Paraguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Alto Paraguay (Department of Paraguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Alto Paraguay (Department of Paraguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Alto Paraguay (Department of Paraguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alto Paraguay (Department of Paraguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Alto Paraguay (Department of Paraguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Alto Paraguay (Department of Paraguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Alto Paraguay (Department of Paraguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Alto Paraguay (Department of Paraguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Alto Paran\xe1 (Department of Paraguay)": [
            {
                "Region Name": "Alto Paran\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alto Paran\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alto Paran\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alto Paran\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alto Paran\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alto Paran\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alto Paran\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alto Paran\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alto Paran\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Alto Paran\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Alto Paran\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Alto Paran\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alto Paran\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alto Paran\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alto Paran\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alto Paran\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alto Paran\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alto Paran\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Alto Paran\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Alto Paran\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Alto Paran\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Alto Paran\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Alytaus (County of Lithuania)": [
            {
                "Region Name": "Alytaus (County of Lithuania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alytaus (County of Lithuania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Alytaus (County of Lithuania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alytaus (County of Lithuania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Alytaus (County of Lithuania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alytaus (County of Lithuania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alytaus (County of Lithuania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alytaus (County of Lithuania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alytaus (County of Lithuania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alytaus (County of Lithuania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alytaus (County of Lithuania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alytaus (County of Lithuania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alytaus (County of Lithuania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alytaus (County of Lithuania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alytaus (County of Lithuania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alytaus (County of Lithuania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alytaus (County of Lithuania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alytaus (County of Lithuania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alytaus (County of Lithuania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alytaus (County of Lithuania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alytaus (County of Lithuania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Alytaus (County of Lithuania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Amajyaruguru (Province of Rwanda)": [
            {
                "Region Name": "Amajyaruguru (Province of Rwanda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyaruguru (Province of Rwanda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyaruguru (Province of Rwanda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyaruguru (Province of Rwanda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Amajyaruguru (Province of Rwanda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amajyaruguru (Province of Rwanda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyaruguru (Province of Rwanda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyaruguru (Province of Rwanda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Amajyaruguru (Province of Rwanda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyaruguru (Province of Rwanda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amajyaruguru (Province of Rwanda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amajyaruguru (Province of Rwanda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Amajyaruguru (Province of Rwanda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyaruguru (Province of Rwanda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Amajyaruguru (Province of Rwanda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyaruguru (Province of Rwanda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Amajyaruguru (Province of Rwanda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyaruguru (Province of Rwanda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyaruguru (Province of Rwanda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amajyaruguru (Province of Rwanda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyaruguru (Province of Rwanda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyaruguru (Province of Rwanda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Amajyepfo (Province of Rwanda)": [
            {
                "Region Name": "Amajyepfo (Province of Rwanda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Amajyepfo (Province of Rwanda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyepfo (Province of Rwanda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyepfo (Province of Rwanda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyepfo (Province of Rwanda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyepfo (Province of Rwanda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyepfo (Province of Rwanda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amajyepfo (Province of Rwanda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyepfo (Province of Rwanda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amajyepfo (Province of Rwanda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyepfo (Province of Rwanda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyepfo (Province of Rwanda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyepfo (Province of Rwanda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyepfo (Province of Rwanda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amajyepfo (Province of Rwanda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Amajyepfo (Province of Rwanda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyepfo (Province of Rwanda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyepfo (Province of Rwanda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyepfo (Province of Rwanda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyepfo (Province of Rwanda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyepfo (Province of Rwanda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amajyepfo (Province of Rwanda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Amambay (Department of Paraguay)": [
            {
                "Region Name": "Amambay (Department of Paraguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Amambay (Department of Paraguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Amambay (Department of Paraguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Amambay (Department of Paraguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Amambay (Department of Paraguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Amambay (Department of Paraguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Amambay (Department of Paraguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Amambay (Department of Paraguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Amambay (Department of Paraguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Amambay (Department of Paraguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Amambay (Department of Paraguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Amambay (Department of Paraguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Amambay (Department of Paraguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Amambay (Department of Paraguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Amambay (Department of Paraguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Amambay (Department of Paraguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Amambay (Department of Paraguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Amambay (Department of Paraguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Amambay (Department of Paraguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Amambay (Department of Paraguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Amambay (Department of Paraguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Amambay (Department of Paraguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Amanat Al Asimah (Governorate of Yemen)": [
            {
                "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amanat Al Asimah (Governorate of Yemen)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Amap\xe1 (State of Brazil)": [
            {
                "Region Name": "Amap\xe1 (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Amap\xe1 (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Amap\xe1 (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Amap\xe1 (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Amap\xe1 (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Amap\xe1 (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Amap\xe1 (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Amap\xe1 (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Amap\xe1 (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Amap\xe1 (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Amap\xe1 (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Amap\xe1 (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Amap\xe1 (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Amap\xe1 (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Amap\xe1 (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Amap\xe1 (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Amap\xe1 (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Amap\xe1 (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Amap\xe1 (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Amap\xe1 (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Amap\xe1 (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Amap\xe1 (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Amasya (Province of Turkey)": [
            {
                "Region Name": "Amasya (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amasya (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amasya (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Amasya (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Amasya (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Amasya (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amasya (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amasya (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Amasya (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Amasya (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Amasya (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Amasya (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Amasya (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amasya (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amasya (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amasya (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amasya (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amasya (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amasya (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Amasya (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amasya (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Amasya (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Amazonas (Commissiary of Colombia)": [
            {
                "Region Name": "Amazonas (Commissiary of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amazonas (Commissiary of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Amazonas (Commissiary of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amazonas (Commissiary of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amazonas (Commissiary of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amazonas (Commissiary of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Amazonas (Commissiary of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amazonas (Commissiary of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amazonas (Commissiary of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amazonas (Commissiary of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amazonas (Commissiary of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amazonas (Commissiary of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amazonas (Commissiary of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amazonas (Commissiary of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amazonas (Commissiary of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amazonas (Commissiary of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Amazonas (Commissiary of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amazonas (Commissiary of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amazonas (Commissiary of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Amazonas (Commissiary of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amazonas (Commissiary of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amazonas (Commissiary of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Amazonas (Region of Peru)": [
            {
                "Region Name": "Amazonas (Region of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Amazonas (Region of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Amazonas (Region of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Amazonas (Region of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Amazonas (Region of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Amazonas (Region of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Amazonas (Region of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Amazonas (Region of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Amazonas (Region of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Amazonas (Region of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amazonas (Region of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Amazonas (Region of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Amazonas (Region of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Amazonas (Region of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Amazonas (Region of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Amazonas (Region of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Amazonas (Region of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Amazonas (Region of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amazonas (Region of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Amazonas (Region of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amazonas (Region of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Amazonas (Region of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Amazonas (State of Brazil)": [
            {
                "Region Name": "Amazonas (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Amazonas (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Amazonas (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Amazonas (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Amazonas (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Amazonas (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Amazonas (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Amazonas (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Amazonas (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Amazonas (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Amazonas (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Amazonas (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Amazonas (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Amazonas (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Amazonas (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Amazonas (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Amazonas (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Amazonas (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Amazonas (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Amazonas (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Amazonas (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Amazonas (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Amazonas (State of Venezuela)": [
            {
                "Region Name": "Amazonas (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Amazonas (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Amazonas (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Amazonas (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Amazonas (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Amazonas (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Amazonas (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Amazonas (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Amazonas (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Amazonas (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Amazonas (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Amazonas (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Amazonas (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Amazonas (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Amazonas (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Amazonas (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Amazonas (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Amazonas (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Amazonas (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Amazonas (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Amazonas (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Amazonas (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Ambeno (District of Timor-Leste)": [
            {
                "Region Name": "Ambeno (District of Timor-Leste)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ambeno (District of Timor-Leste)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ambeno (District of Timor-Leste)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ambeno (District of Timor-Leste)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Ambeno (District of Timor-Leste)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ambeno (District of Timor-Leste)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ambeno (District of Timor-Leste)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ambeno (District of Timor-Leste)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ambeno (District of Timor-Leste)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ambeno (District of Timor-Leste)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ambeno (District of Timor-Leste)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ambeno (District of Timor-Leste)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ambeno (District of Timor-Leste)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ambeno (District of Timor-Leste)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ambeno (District of Timor-Leste)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ambeno (District of Timor-Leste)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ambeno (District of Timor-Leste)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ambeno (District of Timor-Leste)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ambeno (District of Timor-Leste)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ambeno (District of Timor-Leste)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ambeno (District of Timor-Leste)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ambeno (District of Timor-Leste)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Amhara (State of Ethiopia)": [
            {
                "Region Name": "Amhara (State of Ethiopia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Amhara (State of Ethiopia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Amhara (State of Ethiopia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Amhara (State of Ethiopia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Amhara (State of Ethiopia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Amhara (State of Ethiopia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Amhara (State of Ethiopia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Amhara (State of Ethiopia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Amhara (State of Ethiopia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Amhara (State of Ethiopia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Amhara (State of Ethiopia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Amhara (State of Ethiopia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Amhara (State of Ethiopia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Amhara (State of Ethiopia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Amhara (State of Ethiopia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Amhara (State of Ethiopia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Amhara (State of Ethiopia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Amhara (State of Ethiopia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Amhara (State of Ethiopia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Amhara (State of Ethiopia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Amhara (State of Ethiopia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Amhara (State of Ethiopia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "Amman (Province of Jordan)": [
            {
                "Region Name": "Amman (Province of Jordan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amman (Province of Jordan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amman (Province of Jordan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amman (Province of Jordan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amman (Province of Jordan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amman (Province of Jordan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amman (Province of Jordan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amman (Province of Jordan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amman (Province of Jordan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amman (Province of Jordan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amman (Province of Jordan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amman (Province of Jordan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amman (Province of Jordan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amman (Province of Jordan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amman (Province of Jordan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amman (Province of Jordan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amman (Province of Jordan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amman (Province of Jordan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amman (Province of Jordan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amman (Province of Jordan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amman (Province of Jordan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amman (Province of Jordan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Amnat Charoen (Province of Thailand)": [
            {
                "Region Name": "Amnat Charoen (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Amnat Charoen (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Amnat Charoen (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Amnat Charoen (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Amnat Charoen (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amnat Charoen (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amnat Charoen (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amnat Charoen (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Amnat Charoen (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Amnat Charoen (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Amnat Charoen (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Amnat Charoen (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Amnat Charoen (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Amnat Charoen (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amnat Charoen (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Amnat Charoen (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amnat Charoen (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amnat Charoen (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Amnat Charoen (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amnat Charoen (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amnat Charoen (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Amnat Charoen (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Ampara (District of Sri Lanka)": [
            {
                "Region Name": "Ampara (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ampara (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ampara (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ampara (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Ampara (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Ampara (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ampara (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Ampara (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Ampara (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ampara (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Ampara (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ampara (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Ampara (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Ampara (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Ampara (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ampara (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ampara (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Ampara (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ampara (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ampara (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ampara (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ampara (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Amran (Governorate of Yemen)": [
            {
                "Region Name": "Amran (Governorate of Yemen)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amran (Governorate of Yemen)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amran (Governorate of Yemen)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amran (Governorate of Yemen)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amran (Governorate of Yemen)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amran (Governorate of Yemen)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amran (Governorate of Yemen)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amran (Governorate of Yemen)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amran (Governorate of Yemen)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amran (Governorate of Yemen)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amran (Governorate of Yemen)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amran (Governorate of Yemen)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amran (Governorate of Yemen)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amran (Governorate of Yemen)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amran (Governorate of Yemen)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amran (Governorate of Yemen)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amran (Governorate of Yemen)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amran (Governorate of Yemen)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amran (Governorate of Yemen)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amran (Governorate of Yemen)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amran (Governorate of Yemen)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Amran (Governorate of Yemen)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Amur (Region of Russia)": [
            {
                "Region Name": "Amur (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Amur (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Amur (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Amur (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Amur (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Amur (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Amur (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Amur (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Amur (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Amur (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Amur (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Amur (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Amur (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Amur (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Amur (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Amur (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Amur (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Amur (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Amur (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Amur (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Amur (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Amur (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 36
            }
        ],
        "An-Najaf (Province of Iraq)": [
            {
                "Region Name": "An-Najaf (Province of Iraq)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "An-Najaf (Province of Iraq)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "An-Najaf (Province of Iraq)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "An-Najaf (Province of Iraq)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "An-Najaf (Province of Iraq)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "An-Najaf (Province of Iraq)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "An-Najaf (Province of Iraq)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "An-Najaf (Province of Iraq)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "An-Najaf (Province of Iraq)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "An-Najaf (Province of Iraq)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "An-Najaf (Province of Iraq)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "An-Najaf (Province of Iraq)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "An-Najaf (Province of Iraq)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "An-Najaf (Province of Iraq)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "An-Najaf (Province of Iraq)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "An-Najaf (Province of Iraq)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "An-Najaf (Province of Iraq)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "An-Najaf (Province of Iraq)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "An-Najaf (Province of Iraq)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "An-Najaf (Province of Iraq)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "An-Najaf (Province of Iraq)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "An-Najaf (Province of Iraq)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "An Giang (Province of Vietnam)": [
            {
                "Region Name": "An Giang (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "An Giang (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "An Giang (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "An Giang (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "An Giang (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "An Giang (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "An Giang (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "An Giang (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "An Giang (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "An Giang (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "An Giang (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "An Giang (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "An Giang (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "An Giang (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "An Giang (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "An Giang (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "An Giang (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "An Giang (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "An Giang (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "An Giang (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "An Giang (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "An Giang (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 22
            }
        ],
        "An Nuqat al Khams (District of Libya)": [
            {
                "Region Name": "An Nuqat al Khams (District of Libya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "An Nuqat al Khams (District of Libya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "An Nuqat al Khams (District of Libya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "An Nuqat al Khams (District of Libya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "An Nuqat al Khams (District of Libya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "An Nuqat al Khams (District of Libya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "An Nuqat al Khams (District of Libya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "An Nuqat al Khams (District of Libya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "An Nuqat al Khams (District of Libya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "An Nuqat al Khams (District of Libya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "An Nuqat al Khams (District of Libya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "An Nuqat al Khams (District of Libya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "An Nuqat al Khams (District of Libya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "An Nuqat al Khams (District of Libya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "An Nuqat al Khams (District of Libya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "An Nuqat al Khams (District of Libya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "An Nuqat al Khams (District of Libya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "An Nuqat al Khams (District of Libya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "An Nuqat al Khams (District of Libya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "An Nuqat al Khams (District of Libya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "An Nuqat al Khams (District of Libya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "An Nuqat al Khams (District of Libya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Anabar (District of Nauru)": [
            {
                "Region Name": "Anabar (District of Nauru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anabar (District of Nauru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anabar (District of Nauru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anabar (District of Nauru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anabar (District of Nauru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anabar (District of Nauru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anabar (District of Nauru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anabar (District of Nauru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anabar (District of Nauru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anabar (District of Nauru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anabar (District of Nauru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anabar (District of Nauru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anabar (District of Nauru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anabar (District of Nauru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anabar (District of Nauru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anabar (District of Nauru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anabar (District of Nauru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anabar (District of Nauru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anabar (District of Nauru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anabar (District of Nauru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anabar (District of Nauru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anabar (District of Nauru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Anafu (Atoll of Tokelau)": [
            {
                "Region Name": "Anafu (Atoll of Tokelau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anafu (Atoll of Tokelau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anafu (Atoll of Tokelau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anafu (Atoll of Tokelau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anafu (Atoll of Tokelau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anafu (Atoll of Tokelau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anafu (Atoll of Tokelau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anafu (Atoll of Tokelau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anafu (Atoll of Tokelau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anafu (Atoll of Tokelau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anafu (Atoll of Tokelau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anafu (Atoll of Tokelau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anafu (Atoll of Tokelau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anafu (Atoll of Tokelau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anafu (Atoll of Tokelau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anafu (Atoll of Tokelau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anafu (Atoll of Tokelau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anafu (Atoll of Tokelau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anafu (Atoll of Tokelau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anafu (Atoll of Tokelau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anafu (Atoll of Tokelau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anafu (Atoll of Tokelau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Anambra (State of Nigeria)": [
            {
                "Region Name": "Anambra (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Anambra (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Anambra (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Anambra (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Anambra (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Anambra (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Anambra (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Anambra (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Anambra (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Anambra (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Anambra (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Anambra (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Anambra (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Anambra (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Anambra (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Anambra (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Anambra (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Anambra (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Anambra (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Anambra (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Anambra (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Anambra (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Ancash (Region of Peru)": [
            {
                "Region Name": "Ancash (Region of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ancash (Region of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ancash (Region of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ancash (Region of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ancash (Region of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ancash (Region of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ancash (Region of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ancash (Region of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ancash (Region of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ancash (Region of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ancash (Region of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ancash (Region of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ancash (Region of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ancash (Region of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ancash (Region of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ancash (Region of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ancash (Region of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ancash (Region of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ancash (Region of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ancash (Region of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ancash (Region of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ancash (Region of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Andaluc\xeda (Autonomous Community of Spain)": [
            {
                "Region Name": "Andaluc\xeda (Autonomous Community of Spain)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Andaluc\xeda (Autonomous Community of Spain)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Andaluc\xeda (Autonomous Community of Spain)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Andaluc\xeda (Autonomous Community of Spain)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Andaluc\xeda (Autonomous Community of Spain)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Andaluc\xeda (Autonomous Community of Spain)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Andaluc\xeda (Autonomous Community of Spain)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Andaluc\xeda (Autonomous Community of Spain)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Andaluc\xeda (Autonomous Community of Spain)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Andaluc\xeda (Autonomous Community of Spain)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Andaluc\xeda (Autonomous Community of Spain)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Andaluc\xeda (Autonomous Community of Spain)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Andaluc\xeda (Autonomous Community of Spain)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Andaluc\xeda (Autonomous Community of Spain)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Andaluc\xeda (Autonomous Community of Spain)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Andaluc\xeda (Autonomous Community of Spain)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Andaluc\xeda (Autonomous Community of Spain)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Andaluc\xeda (Autonomous Community of Spain)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Andaluc\xeda (Autonomous Community of Spain)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "Andaluc\xeda (Autonomous Community of Spain)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Andaluc\xeda (Autonomous Community of Spain)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Andaluc\xeda (Autonomous Community of Spain)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Andaman and Nicobar (Union Territory of India)": [
            {
                "Region Name": "Andaman and Nicobar (Union Territory of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Andaman and Nicobar (Union Territory of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andaman and Nicobar (Union Territory of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Andaman and Nicobar (Union Territory of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Andaman and Nicobar (Union Territory of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andaman and Nicobar (Union Territory of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andaman and Nicobar (Union Territory of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Andaman and Nicobar (Union Territory of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Andaman and Nicobar (Union Territory of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andaman and Nicobar (Union Territory of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andaman and Nicobar (Union Territory of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Andaman and Nicobar (Union Territory of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Andaman and Nicobar (Union Territory of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Andaman and Nicobar (Union Territory of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Andaman and Nicobar (Union Territory of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Andaman and Nicobar (Union Territory of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andaman and Nicobar (Union Territory of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andaman and Nicobar (Union Territory of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andaman and Nicobar (Union Territory of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andaman and Nicobar (Union Territory of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andaman and Nicobar (Union Territory of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andaman and Nicobar (Union Territory of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Andhra Pradesh (State of India)": [
            {
                "Region Name": "Andhra Pradesh (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Andhra Pradesh (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Andhra Pradesh (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Andhra Pradesh (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Andhra Pradesh (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Andhra Pradesh (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Andhra Pradesh (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Andhra Pradesh (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Andhra Pradesh (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Andhra Pradesh (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Andhra Pradesh (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Andhra Pradesh (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Andhra Pradesh (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Andhra Pradesh (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Andhra Pradesh (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Andhra Pradesh (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Andhra Pradesh (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Andhra Pradesh (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Andhra Pradesh (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Andhra Pradesh (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Andhra Pradesh (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Andhra Pradesh (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 16
            }
        ],
        "Andijon (Region of Uzbekistan)": [
            {
                "Region Name": "Andijon (Region of Uzbekistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andijon (Region of Uzbekistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andijon (Region of Uzbekistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andijon (Region of Uzbekistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andijon (Region of Uzbekistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andijon (Region of Uzbekistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andijon (Region of Uzbekistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andijon (Region of Uzbekistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andijon (Region of Uzbekistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andijon (Region of Uzbekistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Andijon (Region of Uzbekistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andijon (Region of Uzbekistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andijon (Region of Uzbekistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andijon (Region of Uzbekistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andijon (Region of Uzbekistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andijon (Region of Uzbekistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andijon (Region of Uzbekistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andijon (Region of Uzbekistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andijon (Region of Uzbekistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Andijon (Region of Uzbekistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Andijon (Region of Uzbekistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andijon (Region of Uzbekistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Andorra la Vella (Parish of Andorra)": [
            {
                "Region Name": "Andorra la Vella (Parish of Andorra)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra la Vella (Parish of Andorra)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra la Vella (Parish of Andorra)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra la Vella (Parish of Andorra)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra la Vella (Parish of Andorra)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra la Vella (Parish of Andorra)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra la Vella (Parish of Andorra)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra la Vella (Parish of Andorra)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra la Vella (Parish of Andorra)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra la Vella (Parish of Andorra)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra la Vella (Parish of Andorra)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra la Vella (Parish of Andorra)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra la Vella (Parish of Andorra)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra la Vella (Parish of Andorra)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra la Vella (Parish of Andorra)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra la Vella (Parish of Andorra)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra la Vella (Parish of Andorra)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra la Vella (Parish of Andorra)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra la Vella (Parish of Andorra)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra la Vella (Parish of Andorra)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra la Vella (Parish of Andorra)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andorra la Vella (Parish of Andorra)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Andreas (Parish District of Isle of Man)": [
            {
                "Region Name": "Andreas (Parish District of Isle of Man)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andreas (Parish District of Isle of Man)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andreas (Parish District of Isle of Man)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andreas (Parish District of Isle of Man)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andreas (Parish District of Isle of Man)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andreas (Parish District of Isle of Man)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andreas (Parish District of Isle of Man)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andreas (Parish District of Isle of Man)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andreas (Parish District of Isle of Man)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andreas (Parish District of Isle of Man)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andreas (Parish District of Isle of Man)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andreas (Parish District of Isle of Man)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andreas (Parish District of Isle of Man)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andreas (Parish District of Isle of Man)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andreas (Parish District of Isle of Man)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andreas (Parish District of Isle of Man)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andreas (Parish District of Isle of Man)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andreas (Parish District of Isle of Man)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andreas (Parish District of Isle of Man)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andreas (Parish District of Isle of Man)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andreas (Parish District of Isle of Man)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andreas (Parish District of Isle of Man)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Andrijevica (Municipality of Montenegro)": [
            {
                "Region Name": "Andrijevica (Municipality of Montenegro)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andrijevica (Municipality of Montenegro)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andrijevica (Municipality of Montenegro)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andrijevica (Municipality of Montenegro)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andrijevica (Municipality of Montenegro)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andrijevica (Municipality of Montenegro)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andrijevica (Municipality of Montenegro)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andrijevica (Municipality of Montenegro)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andrijevica (Municipality of Montenegro)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andrijevica (Municipality of Montenegro)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andrijevica (Municipality of Montenegro)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andrijevica (Municipality of Montenegro)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andrijevica (Municipality of Montenegro)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andrijevica (Municipality of Montenegro)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andrijevica (Municipality of Montenegro)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andrijevica (Municipality of Montenegro)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andrijevica (Municipality of Montenegro)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andrijevica (Municipality of Montenegro)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andrijevica (Municipality of Montenegro)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andrijevica (Municipality of Montenegro)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andrijevica (Municipality of Montenegro)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Andrijevica (Municipality of Montenegro)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Anegada (District of British Virgin Islands)": [
            {
                "Region Name": "Anegada (District of British Virgin Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anegada (District of British Virgin Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anegada (District of British Virgin Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anegada (District of British Virgin Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anegada (District of British Virgin Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anegada (District of British Virgin Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anegada (District of British Virgin Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anegada (District of British Virgin Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anegada (District of British Virgin Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anegada (District of British Virgin Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anegada (District of British Virgin Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anegada (District of British Virgin Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anegada (District of British Virgin Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anegada (District of British Virgin Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anegada (District of British Virgin Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anegada (District of British Virgin Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anegada (District of British Virgin Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anegada (District of British Virgin Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anegada (District of British Virgin Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anegada (District of British Virgin Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anegada (District of British Virgin Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anegada (District of British Virgin Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Anenii Noi (District of Moldova)": [
            {
                "Region Name": "Anenii Noi (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anenii Noi (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anenii Noi (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anenii Noi (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Anenii Noi (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Anenii Noi (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Anenii Noi (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Anenii Noi (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Anenii Noi (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anenii Noi (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Anenii Noi (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anenii Noi (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Anenii Noi (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Anenii Noi (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Anenii Noi (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Anenii Noi (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Anenii Noi (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anenii Noi (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Anenii Noi (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anenii Noi (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Anenii Noi (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anenii Noi (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Anetan (District of Nauru)": [
            {
                "Region Name": "Anetan (District of Nauru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anetan (District of Nauru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anetan (District of Nauru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anetan (District of Nauru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anetan (District of Nauru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anetan (District of Nauru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anetan (District of Nauru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anetan (District of Nauru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anetan (District of Nauru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anetan (District of Nauru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anetan (District of Nauru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anetan (District of Nauru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anetan (District of Nauru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anetan (District of Nauru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anetan (District of Nauru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anetan (District of Nauru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anetan (District of Nauru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anetan (District of Nauru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anetan (District of Nauru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anetan (District of Nauru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anetan (District of Nauru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anetan (District of Nauru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ang Thong (Province of Thailand)": [
            {
                "Region Name": "Ang Thong (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ang Thong (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ang Thong (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Ang Thong (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ang Thong (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ang Thong (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ang Thong (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ang Thong (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ang Thong (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ang Thong (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ang Thong (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ang Thong (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ang Thong (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ang Thong (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ang Thong (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ang Thong (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ang Thong (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Ang Thong (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ang Thong (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ang Thong (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ang Thong (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ang Thong (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Angaur (State of Palau)": [
            {
                "Region Name": "Angaur (State of Palau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Angaur (State of Palau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Angaur (State of Palau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Angaur (State of Palau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Angaur (State of Palau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Angaur (State of Palau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Angaur (State of Palau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Angaur (State of Palau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Angaur (State of Palau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Angaur (State of Palau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Angaur (State of Palau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Angaur (State of Palau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Angaur (State of Palau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Angaur (State of Palau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Angaur (State of Palau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Angaur (State of Palau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Angaur (State of Palau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Angaur (State of Palau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Angaur (State of Palau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Angaur (State of Palau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Angaur (State of Palau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Angaur (State of Palau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Anhui (Province of China)": [
            {
                "Region Name": "Anhui (Province of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Anhui (Province of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Anhui (Province of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Anhui (Province of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Anhui (Province of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 57
            },
            {
                "Region Name": "Anhui (Province of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Anhui (Province of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Anhui (Province of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Anhui (Province of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "Anhui (Province of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Anhui (Province of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 65
            },
            {
                "Region Name": "Anhui (Province of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Anhui (Province of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Anhui (Province of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Anhui (Province of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Anhui (Province of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Anhui (Province of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Anhui (Province of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Anhui (Province of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Anhui (Province of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Anhui (Province of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Anhui (Province of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Anibare (District of Nauru)": [
            {
                "Region Name": "Anibare (District of Nauru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anibare (District of Nauru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anibare (District of Nauru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anibare (District of Nauru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anibare (District of Nauru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anibare (District of Nauru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anibare (District of Nauru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anibare (District of Nauru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anibare (District of Nauru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anibare (District of Nauru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anibare (District of Nauru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anibare (District of Nauru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anibare (District of Nauru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anibare (District of Nauru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anibare (District of Nauru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anibare (District of Nauru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anibare (District of Nauru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anibare (District of Nauru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anibare (District of Nauru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anibare (District of Nauru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anibare (District of Nauru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anibare (District of Nauru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ankara (Province of Turkey)": [
            {
                "Region Name": "Ankara (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ankara (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ankara (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ankara (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ankara (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Ankara (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ankara (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ankara (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ankara (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ankara (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ankara (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ankara (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ankara (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ankara (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ankara (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ankara (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ankara (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ankara (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ankara (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ankara (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ankara (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ankara (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Annaba (Province of Algeria)": [
            {
                "Region Name": "Annaba (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Annaba (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Annaba (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annaba (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annaba (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Annaba (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Annaba (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Annaba (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annaba (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annaba (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Annaba (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Annaba (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Annaba (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Annaba (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Annaba (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Annaba (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Annaba (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Annaba (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Annaba (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Annaba (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Annaba (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Annaba (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Annob\xf3n (Province of Equatorial Guinea)": [
            {
                "Region Name": "Annob\xf3n (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annob\xf3n (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annob\xf3n (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annob\xf3n (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annob\xf3n (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annob\xf3n (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annob\xf3n (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annob\xf3n (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annob\xf3n (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annob\xf3n (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annob\xf3n (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annob\xf3n (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annob\xf3n (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annob\xf3n (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annob\xf3n (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annob\xf3n (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annob\xf3n (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annob\xf3n (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annob\xf3n (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annob\xf3n (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annob\xf3n (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Annob\xf3n (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Anse-la-Raye (Quarter of Saint Lucia)": [
            {
                "Region Name": "Anse-la-Raye (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse-la-Raye (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse-la-Raye (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse-la-Raye (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse-la-Raye (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse-la-Raye (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse-la-Raye (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse-la-Raye (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse-la-Raye (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse-la-Raye (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse-la-Raye (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse-la-Raye (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse-la-Raye (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse-la-Raye (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse-la-Raye (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse-la-Raye (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse-la-Raye (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse-la-Raye (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse-la-Raye (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse-la-Raye (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse-la-Raye (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse-la-Raye (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Anse \u221A\xe2toile (District of Seychelles)": [
            {
                "Region Name": "Anse \u221A\xe2toile (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse \u221A\xe2toile (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse \u221A\xe2toile (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse \u221A\xe2toile (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse \u221A\xe2toile (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse \u221A\xe2toile (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse \u221A\xe2toile (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse \u221A\xe2toile (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse \u221A\xe2toile (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse \u221A\xe2toile (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse \u221A\xe2toile (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse \u221A\xe2toile (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse \u221A\xe2toile (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse \u221A\xe2toile (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse \u221A\xe2toile (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse \u221A\xe2toile (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse \u221A\xe2toile (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse \u221A\xe2toile (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse \u221A\xe2toile (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse \u221A\xe2toile (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse \u221A\xe2toile (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse \u221A\xe2toile (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Anse aux Pins (District of Seychelles)": [
            {
                "Region Name": "Anse aux Pins (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse aux Pins (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse aux Pins (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse aux Pins (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse aux Pins (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse aux Pins (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse aux Pins (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse aux Pins (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse aux Pins (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse aux Pins (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse aux Pins (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse aux Pins (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse aux Pins (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse aux Pins (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse aux Pins (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse aux Pins (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse aux Pins (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse aux Pins (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse aux Pins (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse aux Pins (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse aux Pins (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse aux Pins (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Anse Boileau (District of Seychelles)": [
            {
                "Region Name": "Anse Boileau (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Boileau (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Boileau (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Boileau (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Boileau (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Boileau (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Boileau (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Boileau (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Boileau (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Boileau (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Boileau (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Boileau (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Boileau (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Boileau (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Boileau (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Boileau (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Boileau (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Boileau (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Boileau (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Boileau (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Boileau (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Boileau (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Anse Royale (District of Seychelles)": [
            {
                "Region Name": "Anse Royale (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Royale (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Royale (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Royale (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Royale (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Royale (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Royale (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Royale (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Royale (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Royale (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Royale (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Royale (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Royale (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Royale (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Royale (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Royale (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Royale (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Royale (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Royale (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Royale (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Royale (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anse Royale (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Anseba (Region of Eritrea)": [
            {
                "Region Name": "Anseba (Region of Eritrea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anseba (Region of Eritrea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anseba (Region of Eritrea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anseba (Region of Eritrea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anseba (Region of Eritrea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anseba (Region of Eritrea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Anseba (Region of Eritrea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Anseba (Region of Eritrea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anseba (Region of Eritrea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anseba (Region of Eritrea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anseba (Region of Eritrea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anseba (Region of Eritrea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anseba (Region of Eritrea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anseba (Region of Eritrea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anseba (Region of Eritrea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anseba (Region of Eritrea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anseba (Region of Eritrea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anseba (Region of Eritrea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anseba (Region of Eritrea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Anseba (Region of Eritrea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anseba (Region of Eritrea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anseba (Region of Eritrea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Antalya (Province of Turkey)": [
            {
                "Region Name": "Antalya (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Antalya (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Antalya (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Antalya (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Antalya (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Antalya (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Antalya (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 122
            },
            {
                "Region Name": "Antalya (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Antalya (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Antalya (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Antalya (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Antalya (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Antalya (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Antalya (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antalya (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Antalya (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Antalya (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antalya (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antalya (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antalya (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 466
            },
            {
                "Region Name": "Antalya (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antalya (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Antananarivo (NA of Madagascar)": [
            {
                "Region Name": "Antananarivo (NA of Madagascar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Antananarivo (NA of Madagascar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Antananarivo (NA of Madagascar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Antananarivo (NA of Madagascar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Antananarivo (NA of Madagascar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Antananarivo (NA of Madagascar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Antananarivo (NA of Madagascar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Antananarivo (NA of Madagascar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Antananarivo (NA of Madagascar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Antananarivo (NA of Madagascar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Antananarivo (NA of Madagascar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Antananarivo (NA of Madagascar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Antananarivo (NA of Madagascar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Antananarivo (NA of Madagascar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Antananarivo (NA of Madagascar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Antananarivo (NA of Madagascar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Antananarivo (NA of Madagascar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Antananarivo (NA of Madagascar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Antananarivo (NA of Madagascar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Antananarivo (NA of Madagascar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Antananarivo (NA of Madagascar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Antananarivo (NA of Madagascar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Antioquia (Department of Colombia)": [
            {
                "Region Name": "Antioquia (Department of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Antioquia (Department of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Antioquia (Department of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Antioquia (Department of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Antioquia (Department of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Antioquia (Department of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Antioquia (Department of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Antioquia (Department of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Antioquia (Department of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Antioquia (Department of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Antioquia (Department of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Antioquia (Department of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Antioquia (Department of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Antioquia (Department of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Antioquia (Department of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Antioquia (Department of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Antioquia (Department of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Antioquia (Department of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Antioquia (Department of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Antioquia (Department of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Antioquia (Department of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Antioquia (Department of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Antique (Province of Philippines)": [
            {
                "Region Name": "Antique (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Antique (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Antique (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Antique (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Antique (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Antique (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Antique (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Antique (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Antique (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Antique (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Antique (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antique (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Antique (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Antique (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Antique (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Antique (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Antique (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Antique (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Antique (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Antique (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Antique (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antique (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Antofagasta (Region of Chile)": [
            {
                "Region Name": "Antofagasta (Region of Chile)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antofagasta (Region of Chile)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antofagasta (Region of Chile)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antofagasta (Region of Chile)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antofagasta (Region of Chile)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antofagasta (Region of Chile)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antofagasta (Region of Chile)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antofagasta (Region of Chile)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antofagasta (Region of Chile)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antofagasta (Region of Chile)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antofagasta (Region of Chile)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antofagasta (Region of Chile)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antofagasta (Region of Chile)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antofagasta (Region of Chile)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antofagasta (Region of Chile)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antofagasta (Region of Chile)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antofagasta (Region of Chile)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antofagasta (Region of Chile)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antofagasta (Region of Chile)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antofagasta (Region of Chile)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antofagasta (Region of Chile)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antofagasta (Region of Chile)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Antsiranana (NA of Madagascar)": [
            {
                "Region Name": "Antsiranana (NA of Madagascar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Antsiranana (NA of Madagascar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Antsiranana (NA of Madagascar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Antsiranana (NA of Madagascar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Antsiranana (NA of Madagascar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Antsiranana (NA of Madagascar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Antsiranana (NA of Madagascar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Antsiranana (NA of Madagascar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Antsiranana (NA of Madagascar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Antsiranana (NA of Madagascar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Antsiranana (NA of Madagascar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Antsiranana (NA of Madagascar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Antsiranana (NA of Madagascar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Antsiranana (NA of Madagascar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Antsiranana (NA of Madagascar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Antsiranana (NA of Madagascar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Antsiranana (NA of Madagascar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Antsiranana (NA of Madagascar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Antsiranana (NA of Madagascar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Antsiranana (NA of Madagascar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Antsiranana (NA of Madagascar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Antsiranana (NA of Madagascar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Anuradhapura (District of Sri Lanka)": [
            {
                "Region Name": "Anuradhapura (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Anuradhapura (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Anuradhapura (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Anuradhapura (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Anuradhapura (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Anuradhapura (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Anuradhapura (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Anuradhapura (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Anuradhapura (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Anuradhapura (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anuradhapura (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Anuradhapura (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Anuradhapura (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anuradhapura (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anuradhapura (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Anuradhapura (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Anuradhapura (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Anuradhapura (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anuradhapura (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anuradhapura (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anuradhapura (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Anuradhapura (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Anzo\xe1tegui (State of Venezuela)": [
            {
                "Region Name": "Anzo\xe1tegui (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Anzo\xe1tegui (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Anzo\xe1tegui (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Anzo\xe1tegui (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Anzo\xe1tegui (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Anzo\xe1tegui (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Anzo\xe1tegui (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Anzo\xe1tegui (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Anzo\xe1tegui (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Anzo\xe1tegui (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Anzo\xe1tegui (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Anzo\xe1tegui (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Anzo\xe1tegui (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Anzo\xe1tegui (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Anzo\xe1tegui (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Anzo\xe1tegui (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Anzo\xe1tegui (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Anzo\xe1tegui (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Anzo\xe1tegui (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Anzo\xe1tegui (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Anzo\xe1tegui (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Anzo\xe1tegui (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Aomori (Prefecture of Japan)": [
            {
                "Region Name": "Aomori (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aomori (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aomori (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aomori (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aomori (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aomori (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aomori (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aomori (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aomori (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aomori (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aomori (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aomori (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aomori (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aomori (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aomori (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aomori (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aomori (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aomori (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aomori (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aomori (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aomori (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aomori (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Apac (District of Uganda)": [
            {
                "Region Name": "Apac (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Apac (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Apac (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Apac (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Apac (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Apac (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Apac (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Apac (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Apac (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Apac (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Apac (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Apac (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Apac (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Apac (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Apac (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Apac (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Apac (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Apac (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Apac (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Apac (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Apac (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Apac (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Apayao (Province of Philippines)": [
            {
                "Region Name": "Apayao (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Apayao (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Apayao (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Apayao (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Apayao (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Apayao (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Apayao (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Apayao (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Apayao (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Apayao (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Apayao (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Apayao (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Apayao (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Apayao (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Apayao (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Apayao (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Apayao (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Apayao (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Apayao (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Apayao (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Apayao (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Apayao (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Appenzell Ausserrhoden (Canton of Switzerland)": [
            {
                "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Ausserrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Appenzell Innerrhoden (Canton of Switzerland)": [
            {
                "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Appenzell Innerrhoden (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Apulia (Region of Italy)": [
            {
                "Region Name": "Apulia (Region of Italy)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Apulia (Region of Italy)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Apulia (Region of Italy)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Apulia (Region of Italy)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Apulia (Region of Italy)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Apulia (Region of Italy)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Apulia (Region of Italy)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Apulia (Region of Italy)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Apulia (Region of Italy)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Apulia (Region of Italy)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Apulia (Region of Italy)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Apulia (Region of Italy)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Apulia (Region of Italy)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Apulia (Region of Italy)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Apulia (Region of Italy)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Apulia (Region of Italy)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Apulia (Region of Italy)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Apulia (Region of Italy)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Apulia (Region of Italy)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Apulia (Region of Italy)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Apulia (Region of Italy)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Apulia (Region of Italy)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Apure (State of Venezuela)": [
            {
                "Region Name": "Apure (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Apure (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Apure (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Apure (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Apure (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Apure (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Apure (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Apure (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Apure (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Apure (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Apure (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Apure (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Apure (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Apure (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Apure (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Apure (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Apure (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Apure (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Apure (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Apure (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Apure (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Apure (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Apur\xedmac (Region of Peru)": [
            {
                "Region Name": "Apur\xedmac (Region of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Apur\xedmac (Region of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Apur\xedmac (Region of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Apur\xedmac (Region of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Apur\xedmac (Region of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Apur\xedmac (Region of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Apur\xedmac (Region of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Apur\xedmac (Region of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Apur\xedmac (Region of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Apur\xedmac (Region of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Apur\xedmac (Region of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Apur\xedmac (Region of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Apur\xedmac (Region of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Apur\xedmac (Region of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Apur\xedmac (Region of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Apur\xedmac (Region of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Apur\xedmac (Region of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Apur\xedmac (Region of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Apur\xedmac (Region of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Apur\xedmac (Region of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Apur\xedmac (Region of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Apur\xedmac (Region of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Aqaba (Province of Jordan)": [
            {
                "Region Name": "Aqaba (Province of Jordan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aqaba (Province of Jordan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aqaba (Province of Jordan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aqaba (Province of Jordan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aqaba (Province of Jordan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aqaba (Province of Jordan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aqaba (Province of Jordan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aqaba (Province of Jordan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aqaba (Province of Jordan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aqaba (Province of Jordan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aqaba (Province of Jordan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aqaba (Province of Jordan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aqaba (Province of Jordan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aqaba (Province of Jordan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aqaba (Province of Jordan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aqaba (Province of Jordan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aqaba (Province of Jordan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aqaba (Province of Jordan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aqaba (Province of Jordan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aqaba (Province of Jordan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aqaba (Province of Jordan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aqaba (Province of Jordan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Aqmola (Region of Kazakhstan)": [
            {
                "Region Name": "Aqmola (Region of Kazakhstan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Aqmola (Region of Kazakhstan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Aqmola (Region of Kazakhstan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Aqmola (Region of Kazakhstan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Aqmola (Region of Kazakhstan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Aqmola (Region of Kazakhstan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Aqmola (Region of Kazakhstan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Aqmola (Region of Kazakhstan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Aqmola (Region of Kazakhstan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Aqmola (Region of Kazakhstan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Aqmola (Region of Kazakhstan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Aqmola (Region of Kazakhstan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Aqmola (Region of Kazakhstan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Aqmola (Region of Kazakhstan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Aqmola (Region of Kazakhstan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Aqmola (Region of Kazakhstan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Aqmola (Region of Kazakhstan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Aqmola (Region of Kazakhstan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Aqmola (Region of Kazakhstan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Aqmola (Region of Kazakhstan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Aqmola (Region of Kazakhstan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Aqmola (Region of Kazakhstan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 74
            }
        ],
        "Aqt\xf6be (Region of Kazakhstan)": [
            {
                "Region Name": "Aqt\xf6be (Region of Kazakhstan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 132
            },
            {
                "Region Name": "Aqt\xf6be (Region of Kazakhstan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 80
            },
            {
                "Region Name": "Aqt\xf6be (Region of Kazakhstan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 122
            },
            {
                "Region Name": "Aqt\xf6be (Region of Kazakhstan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 78
            },
            {
                "Region Name": "Aqt\xf6be (Region of Kazakhstan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 158
            },
            {
                "Region Name": "Aqt\xf6be (Region of Kazakhstan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 61
            },
            {
                "Region Name": "Aqt\xf6be (Region of Kazakhstan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 81
            },
            {
                "Region Name": "Aqt\xf6be (Region of Kazakhstan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 68
            },
            {
                "Region Name": "Aqt\xf6be (Region of Kazakhstan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 161
            },
            {
                "Region Name": "Aqt\xf6be (Region of Kazakhstan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Aqt\xf6be (Region of Kazakhstan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 82
            },
            {
                "Region Name": "Aqt\xf6be (Region of Kazakhstan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Aqt\xf6be (Region of Kazakhstan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 93
            },
            {
                "Region Name": "Aqt\xf6be (Region of Kazakhstan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 134
            },
            {
                "Region Name": "Aqt\xf6be (Region of Kazakhstan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 129
            },
            {
                "Region Name": "Aqt\xf6be (Region of Kazakhstan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 171
            },
            {
                "Region Name": "Aqt\xf6be (Region of Kazakhstan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 89
            },
            {
                "Region Name": "Aqt\xf6be (Region of Kazakhstan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 108
            },
            {
                "Region Name": "Aqt\xf6be (Region of Kazakhstan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 70
            },
            {
                "Region Name": "Aqt\xf6be (Region of Kazakhstan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 77
            },
            {
                "Region Name": "Aqt\xf6be (Region of Kazakhstan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Aqt\xf6be (Region of Kazakhstan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Ar Raqqah (Governorate of Syria)": [
            {
                "Region Name": "Ar Raqqah (Governorate of Syria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ar Raqqah (Governorate of Syria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ar Raqqah (Governorate of Syria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ar Raqqah (Governorate of Syria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ar Raqqah (Governorate of Syria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ar Raqqah (Governorate of Syria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ar Raqqah (Governorate of Syria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Raqqah (Governorate of Syria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ar Raqqah (Governorate of Syria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ar Raqqah (Governorate of Syria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ar Raqqah (Governorate of Syria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ar Raqqah (Governorate of Syria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ar Raqqah (Governorate of Syria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Raqqah (Governorate of Syria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ar Raqqah (Governorate of Syria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Raqqah (Governorate of Syria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Raqqah (Governorate of Syria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ar Raqqah (Governorate of Syria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ar Raqqah (Governorate of Syria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ar Raqqah (Governorate of Syria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ar Raqqah (Governorate of Syria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ar Raqqah (Governorate of Syria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Ar Rayyan (Municipality of Qatar)": [
            {
                "Region Name": "Ar Rayyan (Municipality of Qatar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Rayyan (Municipality of Qatar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Rayyan (Municipality of Qatar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Rayyan (Municipality of Qatar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Rayyan (Municipality of Qatar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Rayyan (Municipality of Qatar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ar Rayyan (Municipality of Qatar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Rayyan (Municipality of Qatar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Rayyan (Municipality of Qatar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Rayyan (Municipality of Qatar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Rayyan (Municipality of Qatar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Rayyan (Municipality of Qatar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Rayyan (Municipality of Qatar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ar Rayyan (Municipality of Qatar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Rayyan (Municipality of Qatar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Rayyan (Municipality of Qatar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Rayyan (Municipality of Qatar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Rayyan (Municipality of Qatar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Rayyan (Municipality of Qatar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Rayyan (Municipality of Qatar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Rayyan (Municipality of Qatar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Rayyan (Municipality of Qatar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ar Riyad (Province of Saudi Arabia)": [
            {
                "Region Name": "Ar Riyad (Province of Saudi Arabia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ar Riyad (Province of Saudi Arabia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ar Riyad (Province of Saudi Arabia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ar Riyad (Province of Saudi Arabia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ar Riyad (Province of Saudi Arabia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ar Riyad (Province of Saudi Arabia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ar Riyad (Province of Saudi Arabia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ar Riyad (Province of Saudi Arabia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Riyad (Province of Saudi Arabia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ar Riyad (Province of Saudi Arabia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Riyad (Province of Saudi Arabia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Riyad (Province of Saudi Arabia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Riyad (Province of Saudi Arabia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Riyad (Province of Saudi Arabia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Riyad (Province of Saudi Arabia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Riyad (Province of Saudi Arabia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Riyad (Province of Saudi Arabia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Riyad (Province of Saudi Arabia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ar Riyad (Province of Saudi Arabia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Riyad (Province of Saudi Arabia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Riyad (Province of Saudi Arabia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ar Riyad (Province of Saudi Arabia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Aracinovo (Municipality of North Macedonia)": [
            {
                "Region Name": "Aracinovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aracinovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aracinovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aracinovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aracinovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aracinovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aracinovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aracinovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aracinovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aracinovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aracinovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aracinovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aracinovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aracinovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aracinovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aracinovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aracinovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aracinovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aracinovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aracinovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aracinovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aracinovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Arad (County of Romania)": [
            {
                "Region Name": "Arad (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arad (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Arad (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Arad (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Arad (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arad (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Arad (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arad (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Arad (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Arad (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Arad (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Arad (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Arad (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arad (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Arad (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arad (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arad (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Arad (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arad (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arad (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Arad (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arad (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Aragatsotn (Province of Armenia)": [
            {
                "Region Name": "Aragatsotn (Province of Armenia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aragatsotn (Province of Armenia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aragatsotn (Province of Armenia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aragatsotn (Province of Armenia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aragatsotn (Province of Armenia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Aragatsotn (Province of Armenia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aragatsotn (Province of Armenia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aragatsotn (Province of Armenia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aragatsotn (Province of Armenia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Aragatsotn (Province of Armenia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aragatsotn (Province of Armenia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aragatsotn (Province of Armenia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aragatsotn (Province of Armenia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aragatsotn (Province of Armenia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aragatsotn (Province of Armenia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aragatsotn (Province of Armenia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aragatsotn (Province of Armenia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aragatsotn (Province of Armenia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Aragatsotn (Province of Armenia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aragatsotn (Province of Armenia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aragatsotn (Province of Armenia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aragatsotn (Province of Armenia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Arag\xf3n (Autonomous Community of Spain)": [
            {
                "Region Name": "Arag\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arag\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arag\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arag\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arag\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Arag\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arag\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Arag\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 70
            },
            {
                "Region Name": "Arag\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Arag\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Arag\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Arag\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Arag\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arag\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 97
            },
            {
                "Region Name": "Arag\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Arag\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Arag\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arag\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Arag\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arag\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Arag\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 82
            },
            {
                "Region Name": "Arag\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 41
            }
        ],
        "Aragua (State of Venezuela)": [
            {
                "Region Name": "Aragua (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Aragua (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Aragua (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Aragua (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Aragua (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Aragua (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Aragua (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Aragua (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Aragua (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Aragua (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Aragua (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Aragua (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Aragua (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Aragua (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Aragua (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Aragua (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Aragua (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Aragua (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Aragua (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Aragua (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Aragua (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Aragua (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Aran (Region of Azerbaijan)": [
            {
                "Region Name": "Aran (Region of Azerbaijan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Aran (Region of Azerbaijan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Aran (Region of Azerbaijan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Aran (Region of Azerbaijan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Aran (Region of Azerbaijan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Aran (Region of Azerbaijan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Aran (Region of Azerbaijan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Aran (Region of Azerbaijan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Aran (Region of Azerbaijan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Aran (Region of Azerbaijan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Aran (Region of Azerbaijan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Aran (Region of Azerbaijan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Aran (Region of Azerbaijan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Aran (Region of Azerbaijan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Aran (Region of Azerbaijan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Aran (Region of Azerbaijan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Aran (Region of Azerbaijan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Aran (Region of Azerbaijan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Aran (Region of Azerbaijan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Aran (Region of Azerbaijan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Aran (Region of Azerbaijan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Aran (Region of Azerbaijan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Ararat (Province of Armenia)": [
            {
                "Region Name": "Ararat (Province of Armenia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ararat (Province of Armenia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ararat (Province of Armenia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ararat (Province of Armenia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ararat (Province of Armenia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ararat (Province of Armenia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ararat (Province of Armenia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ararat (Province of Armenia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ararat (Province of Armenia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ararat (Province of Armenia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ararat (Province of Armenia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ararat (Province of Armenia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ararat (Province of Armenia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ararat (Province of Armenia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ararat (Province of Armenia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ararat (Province of Armenia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ararat (Province of Armenia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ararat (Province of Armenia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ararat (Province of Armenia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ararat (Province of Armenia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ararat (Province of Armenia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ararat (Province of Armenia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Arauca (Intendancy of Colombia)": [
            {
                "Region Name": "Arauca (Intendancy of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Arauca (Intendancy of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Arauca (Intendancy of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Arauca (Intendancy of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Arauca (Intendancy of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Arauca (Intendancy of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Arauca (Intendancy of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Arauca (Intendancy of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Arauca (Intendancy of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Arauca (Intendancy of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Arauca (Intendancy of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Arauca (Intendancy of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Arauca (Intendancy of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Arauca (Intendancy of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Arauca (Intendancy of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Arauca (Intendancy of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Arauca (Intendancy of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Arauca (Intendancy of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Arauca (Intendancy of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Arauca (Intendancy of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Arauca (Intendancy of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Arauca (Intendancy of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 19
            }
        ],
        "Araucan\xeda (Region of Chile)": [
            {
                "Region Name": "Araucan\xeda (Region of Chile)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Araucan\xeda (Region of Chile)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Araucan\xeda (Region of Chile)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Araucan\xeda (Region of Chile)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Araucan\xeda (Region of Chile)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Araucan\xeda (Region of Chile)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Araucan\xeda (Region of Chile)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Araucan\xeda (Region of Chile)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Araucan\xeda (Region of Chile)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Araucan\xeda (Region of Chile)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Araucan\xeda (Region of Chile)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Araucan\xeda (Region of Chile)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Araucan\xeda (Region of Chile)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Araucan\xeda (Region of Chile)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Araucan\xeda (Region of Chile)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Araucan\xeda (Region of Chile)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Araucan\xeda (Region of Chile)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Araucan\xeda (Region of Chile)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Araucan\xeda (Region of Chile)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Araucan\xeda (Region of Chile)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Araucan\xeda (Region of Chile)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Araucan\xeda (Region of Chile)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Arbil (Province of Iraq)": [
            {
                "Region Name": "Arbil (Province of Iraq)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Arbil (Province of Iraq)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arbil (Province of Iraq)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Arbil (Province of Iraq)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Arbil (Province of Iraq)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Arbil (Province of Iraq)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arbil (Province of Iraq)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Arbil (Province of Iraq)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arbil (Province of Iraq)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Arbil (Province of Iraq)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Arbil (Province of Iraq)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Arbil (Province of Iraq)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Arbil (Province of Iraq)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Arbil (Province of Iraq)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Arbil (Province of Iraq)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Arbil (Province of Iraq)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arbil (Province of Iraq)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Arbil (Province of Iraq)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Arbil (Province of Iraq)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Arbil (Province of Iraq)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Arbil (Province of Iraq)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Arbil (Province of Iraq)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Arbory & Rushen (Parish District of Isle of Man)": [
            {
                "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arbory & Rushen (Parish District of Isle of Man)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Archipelago (Sub-Region of \xc5land)": [
            {
                "Region Name": "Archipelago (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Archipelago (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Archipelago (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Archipelago (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Archipelago (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Archipelago (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Archipelago (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Archipelago (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Archipelago (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Archipelago (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Archipelago (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Archipelago (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Archipelago (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Archipelago (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Archipelago (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Archipelago (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Archipelago (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Archipelago (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Archipelago (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Archipelago (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Archipelago (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Archipelago (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ardahan (Province of Turkey)": [
            {
                "Region Name": "Ardahan (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ardahan (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ardahan (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ardahan (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ardahan (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ardahan (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ardahan (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ardahan (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ardahan (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ardahan (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ardahan (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ardahan (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ardahan (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ardahan (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ardahan (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ardahan (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ardahan (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ardahan (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ardahan (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ardahan (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ardahan (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ardahan (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ardebil (Province of Iran)": [
            {
                "Region Name": "Ardebil (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ardebil (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ardebil (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ardebil (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ardebil (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ardebil (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ardebil (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ardebil (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ardebil (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ardebil (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ardebil (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ardebil (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ardebil (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ardebil (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Ardebil (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ardebil (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ardebil (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ardebil (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ardebil (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ardebil (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ardebil (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ardebil (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Arecibo (Municipality of Puerto Rico)": [
            {
                "Region Name": "Arecibo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arecibo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arecibo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arecibo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arecibo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arecibo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arecibo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arecibo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arecibo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arecibo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arecibo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Arecibo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arecibo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Arecibo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arecibo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arecibo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arecibo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arecibo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arecibo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arecibo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arecibo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arecibo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Arequipa (Region of Peru)": [
            {
                "Region Name": "Arequipa (Region of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arequipa (Region of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arequipa (Region of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arequipa (Region of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Arequipa (Region of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Arequipa (Region of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arequipa (Region of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Arequipa (Region of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arequipa (Region of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arequipa (Region of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Arequipa (Region of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arequipa (Region of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Arequipa (Region of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arequipa (Region of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arequipa (Region of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arequipa (Region of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arequipa (Region of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Arequipa (Region of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Arequipa (Region of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Arequipa (Region of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Arequipa (Region of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Arequipa (Region of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Arge\u0219 (County of Romania)": [
            {
                "Region Name": "Arge\u0219 (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Arge\u0219 (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Arge\u0219 (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arge\u0219 (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arge\u0219 (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Arge\u0219 (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Arge\u0219 (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Arge\u0219 (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Arge\u0219 (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Arge\u0219 (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Arge\u0219 (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Arge\u0219 (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Arge\u0219 (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Arge\u0219 (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arge\u0219 (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Arge\u0219 (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Arge\u0219 (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arge\u0219 (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Arge\u0219 (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arge\u0219 (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arge\u0219 (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Arge\u0219 (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Arhangay (Province of Mongolia)": [
            {
                "Region Name": "Arhangay (Province of Mongolia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Arhangay (Province of Mongolia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arhangay (Province of Mongolia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arhangay (Province of Mongolia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Arhangay (Province of Mongolia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arhangay (Province of Mongolia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arhangay (Province of Mongolia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Arhangay (Province of Mongolia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arhangay (Province of Mongolia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arhangay (Province of Mongolia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arhangay (Province of Mongolia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Arhangay (Province of Mongolia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arhangay (Province of Mongolia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arhangay (Province of Mongolia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Arhangay (Province of Mongolia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arhangay (Province of Mongolia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arhangay (Province of Mongolia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arhangay (Province of Mongolia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arhangay (Province of Mongolia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Arhangay (Province of Mongolia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arhangay (Province of Mongolia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arhangay (Province of Mongolia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ariana (Governorate of Tunisia)": [
            {
                "Region Name": "Ariana (Governorate of Tunisia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ariana (Governorate of Tunisia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ariana (Governorate of Tunisia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ariana (Governorate of Tunisia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ariana (Governorate of Tunisia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ariana (Governorate of Tunisia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ariana (Governorate of Tunisia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ariana (Governorate of Tunisia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ariana (Governorate of Tunisia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ariana (Governorate of Tunisia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ariana (Governorate of Tunisia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ariana (Governorate of Tunisia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ariana (Governorate of Tunisia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ariana (Governorate of Tunisia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ariana (Governorate of Tunisia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ariana (Governorate of Tunisia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ariana (Governorate of Tunisia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ariana (Governorate of Tunisia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ariana (Governorate of Tunisia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ariana (Governorate of Tunisia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ariana (Governorate of Tunisia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ariana (Governorate of Tunisia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Arica y Parinacota (Region of Chile)": [
            {
                "Region Name": "Arica y Parinacota (Region of Chile)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arica y Parinacota (Region of Chile)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arica y Parinacota (Region of Chile)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arica y Parinacota (Region of Chile)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arica y Parinacota (Region of Chile)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arica y Parinacota (Region of Chile)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arica y Parinacota (Region of Chile)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arica y Parinacota (Region of Chile)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arica y Parinacota (Region of Chile)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arica y Parinacota (Region of Chile)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arica y Parinacota (Region of Chile)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arica y Parinacota (Region of Chile)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arica y Parinacota (Region of Chile)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arica y Parinacota (Region of Chile)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arica y Parinacota (Region of Chile)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arica y Parinacota (Region of Chile)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arica y Parinacota (Region of Chile)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arica y Parinacota (Region of Chile)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arica y Parinacota (Region of Chile)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arica y Parinacota (Region of Chile)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arica y Parinacota (Region of Chile)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arica y Parinacota (Region of Chile)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Arima (Borough of Trinidad and Tobago)": [
            {
                "Region Name": "Arima (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arima (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arima (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arima (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arima (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arima (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arima (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arima (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arima (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arima (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arima (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arima (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arima (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arima (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arima (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arima (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arima (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arima (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arima (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arima (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arima (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arima (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Arizona (State of United States)": [
            {
                "Region Name": "Arizona (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Arizona (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Arizona (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Arizona (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Arizona (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Arizona (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Arizona (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Arizona (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Arizona (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Arizona (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Arizona (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Arizona (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Arizona (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Arizona (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Arizona (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Arizona (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Arizona (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Arizona (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Arizona (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 82
            },
            {
                "Region Name": "Arizona (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Arizona (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Arizona (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Arkansas (State of United States)": [
            {
                "Region Name": "Arkansas (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Arkansas (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Arkansas (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Arkansas (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Arkansas (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Arkansas (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Arkansas (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Arkansas (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Arkansas (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arkansas (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Arkansas (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Arkansas (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Arkansas (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Arkansas (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Arkansas (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Arkansas (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Arkansas (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Arkansas (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Arkansas (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Arkansas (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Arkansas (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Arkansas (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Arkhangel'sk (Region of Russia)": [
            {
                "Region Name": "Arkhangel'sk (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Arkhangel'sk (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Arkhangel'sk (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Arkhangel'sk (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Arkhangel'sk (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Arkhangel'sk (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Arkhangel'sk (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Arkhangel'sk (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Arkhangel'sk (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Arkhangel'sk (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Arkhangel'sk (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arkhangel'sk (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arkhangel'sk (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Arkhangel'sk (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arkhangel'sk (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Arkhangel'sk (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arkhangel'sk (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arkhangel'sk (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Arkhangel'sk (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arkhangel'sk (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arkhangel'sk (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Arkhangel'sk (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Armavir (Province of Armenia)": [
            {
                "Region Name": "Armavir (Province of Armenia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Armavir (Province of Armenia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Armavir (Province of Armenia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Armavir (Province of Armenia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Armavir (Province of Armenia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Armavir (Province of Armenia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Armavir (Province of Armenia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Armavir (Province of Armenia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Armavir (Province of Armenia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Armavir (Province of Armenia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Armavir (Province of Armenia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Armavir (Province of Armenia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Armavir (Province of Armenia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Armavir (Province of Armenia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Armavir (Province of Armenia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Armavir (Province of Armenia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Armavir (Province of Armenia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Armavir (Province of Armenia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Armavir (Province of Armenia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Armavir (Province of Armenia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Armavir (Province of Armenia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Armavir (Province of Armenia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Arno (Atol of Marshall Islands)": [
            {
                "Region Name": "Arno (Atol of Marshall Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arno (Atol of Marshall Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arno (Atol of Marshall Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arno (Atol of Marshall Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arno (Atol of Marshall Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arno (Atol of Marshall Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arno (Atol of Marshall Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arno (Atol of Marshall Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arno (Atol of Marshall Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arno (Atol of Marshall Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arno (Atol of Marshall Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arno (Atol of Marshall Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arno (Atol of Marshall Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arno (Atol of Marshall Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arno (Atol of Marshall Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arno (Atol of Marshall Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arno (Atol of Marshall Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arno (Atol of Marshall Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arno (Atol of Marshall Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arno (Atol of Marshall Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arno (Atol of Marshall Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arno (Atol of Marshall Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Arroyo (Municipality of Puerto Rico)": [
            {
                "Region Name": "Arroyo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arroyo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arroyo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arroyo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arroyo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arroyo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arroyo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arroyo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arroyo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arroyo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arroyo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arroyo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arroyo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arroyo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arroyo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arroyo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arroyo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arroyo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arroyo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arroyo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arroyo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arroyo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Arta (Region of Djibouti)": [
            {
                "Region Name": "Arta (Region of Djibouti)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arta (Region of Djibouti)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arta (Region of Djibouti)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arta (Region of Djibouti)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arta (Region of Djibouti)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Arta (Region of Djibouti)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arta (Region of Djibouti)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arta (Region of Djibouti)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arta (Region of Djibouti)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arta (Region of Djibouti)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arta (Region of Djibouti)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arta (Region of Djibouti)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arta (Region of Djibouti)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arta (Region of Djibouti)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arta (Region of Djibouti)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Arta (Region of Djibouti)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arta (Region of Djibouti)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arta (Region of Djibouti)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arta (Region of Djibouti)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arta (Region of Djibouti)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Arta (Region of Djibouti)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Arta (Region of Djibouti)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Artigas (Department of Uruguay)": [
            {
                "Region Name": "Artigas (Department of Uruguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Artigas (Department of Uruguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Artigas (Department of Uruguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Artigas (Department of Uruguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Artigas (Department of Uruguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Artigas (Department of Uruguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Artigas (Department of Uruguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Artigas (Department of Uruguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Artigas (Department of Uruguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Artigas (Department of Uruguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Artigas (Department of Uruguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Artigas (Department of Uruguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Artigas (Department of Uruguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Artigas (Department of Uruguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Artigas (Department of Uruguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Artigas (Department of Uruguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Artigas (Department of Uruguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Artigas (Department of Uruguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Artigas (Department of Uruguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Artigas (Department of Uruguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Artigas (Department of Uruguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Artigas (Department of Uruguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Artvin (Province of Turkey)": [
            {
                "Region Name": "Artvin (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Artvin (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Artvin (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Artvin (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Artvin (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Artvin (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Artvin (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Artvin (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Artvin (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Artvin (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Artvin (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Artvin (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Artvin (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Artvin (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Artvin (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Artvin (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Artvin (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Artvin (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Artvin (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Artvin (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Artvin (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Artvin (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Arua (District of Uganda)": [
            {
                "Region Name": "Arua (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Arua (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Arua (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Arua (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Arua (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Arua (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Arua (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Arua (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Arua (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Arua (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Arua (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Arua (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Arua (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Arua (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Arua (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Arua (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Arua (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Arua (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Arua (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Arua (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Arua (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Arua (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Arunachal Pradesh (State of India)": [
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arunachal Pradesh (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Arusha (Region of Tanzania)": [
            {
                "Region Name": "Arusha (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Arusha (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Arusha (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Arusha (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Arusha (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Arusha (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Arusha (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Arusha (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Arusha (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Arusha (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Arusha (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Arusha (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Arusha (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Arusha (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Arusha (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Arusha (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Arusha (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Arusha (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Arusha (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Arusha (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Arusha (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Arusha (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 35
            }
        ],
        "As-Sulaymaniyah (Province of Iraq)": [
            {
                "Region Name": "As-Sulaymaniyah (Province of Iraq)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "As-Sulaymaniyah (Province of Iraq)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "As-Sulaymaniyah (Province of Iraq)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "As-Sulaymaniyah (Province of Iraq)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "As-Sulaymaniyah (Province of Iraq)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "As-Sulaymaniyah (Province of Iraq)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "As-Sulaymaniyah (Province of Iraq)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "As-Sulaymaniyah (Province of Iraq)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "As-Sulaymaniyah (Province of Iraq)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "As-Sulaymaniyah (Province of Iraq)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "As-Sulaymaniyah (Province of Iraq)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "As-Sulaymaniyah (Province of Iraq)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "As-Sulaymaniyah (Province of Iraq)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "As-Sulaymaniyah (Province of Iraq)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "As-Sulaymaniyah (Province of Iraq)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "As-Sulaymaniyah (Province of Iraq)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "As-Sulaymaniyah (Province of Iraq)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "As-Sulaymaniyah (Province of Iraq)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "As-Sulaymaniyah (Province of Iraq)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "As-Sulaymaniyah (Province of Iraq)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "As-Sulaymaniyah (Province of Iraq)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "As-Sulaymaniyah (Province of Iraq)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "As Suwayda' (Governorate of Syria)": [
            {
                "Region Name": "As Suwayda' (Governorate of Syria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suwayda' (Governorate of Syria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suwayda' (Governorate of Syria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suwayda' (Governorate of Syria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "As Suwayda' (Governorate of Syria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suwayda' (Governorate of Syria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suwayda' (Governorate of Syria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suwayda' (Governorate of Syria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suwayda' (Governorate of Syria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "As Suwayda' (Governorate of Syria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suwayda' (Governorate of Syria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suwayda' (Governorate of Syria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suwayda' (Governorate of Syria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suwayda' (Governorate of Syria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suwayda' (Governorate of Syria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "As Suwayda' (Governorate of Syria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suwayda' (Governorate of Syria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suwayda' (Governorate of Syria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suwayda' (Governorate of Syria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "As Suwayda' (Governorate of Syria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suwayda' (Governorate of Syria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suwayda' (Governorate of Syria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "As Suways (Governorate of Egypt)": [
            {
                "Region Name": "As Suways (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suways (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suways (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suways (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suways (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suways (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suways (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suways (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suways (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suways (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suways (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suways (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suways (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suways (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suways (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suways (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suways (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suways (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suways (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suways (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suways (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "As Suways (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Asan (Municipality of Guam)": [
            {
                "Region Name": "Asan (Municipality of Guam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asan (Municipality of Guam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asan (Municipality of Guam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asan (Municipality of Guam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asan (Municipality of Guam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asan (Municipality of Guam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asan (Municipality of Guam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asan (Municipality of Guam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asan (Municipality of Guam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asan (Municipality of Guam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asan (Municipality of Guam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asan (Municipality of Guam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asan (Municipality of Guam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asan (Municipality of Guam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asan (Municipality of Guam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asan (Municipality of Guam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asan (Municipality of Guam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asan (Municipality of Guam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asan (Municipality of Guam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asan (Municipality of Guam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asan (Municipality of Guam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asan (Municipality of Guam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ascension (Administrative Area of Saint Helena, Ascension and Tris)": [
            {
                "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ascension (Administrative Area of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "A\u015Fgabat (Capital City District of Turkmenistan)": [
            {
                "Region Name": "A\u015Fgabat (Capital City District of Turkmenistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "A\u015Fgabat (Capital City District of Turkmenistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u015Fgabat (Capital City District of Turkmenistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "A\u015Fgabat (Capital City District of Turkmenistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "A\u015Fgabat (Capital City District of Turkmenistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "A\u015Fgabat (Capital City District of Turkmenistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u015Fgabat (Capital City District of Turkmenistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "A\u015Fgabat (Capital City District of Turkmenistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u015Fgabat (Capital City District of Turkmenistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "A\u015Fgabat (Capital City District of Turkmenistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "A\u015Fgabat (Capital City District of Turkmenistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u015Fgabat (Capital City District of Turkmenistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "A\u015Fgabat (Capital City District of Turkmenistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u015Fgabat (Capital City District of Turkmenistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u015Fgabat (Capital City District of Turkmenistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u015Fgabat (Capital City District of Turkmenistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u015Fgabat (Capital City District of Turkmenistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u015Fgabat (Capital City District of Turkmenistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u015Fgabat (Capital City District of Turkmenistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u015Fgabat (Capital City District of Turkmenistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u015Fgabat (Capital City District of Turkmenistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "A\u015Fgabat (Capital City District of Turkmenistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ash-Sharq\u012Byah (Province of Saudi Arabia)": [
            {
                "Region Name": "Ash-Sharq\u012Byah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash-Sharq\u012Byah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ash-Sharq\u012Byah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ash-Sharq\u012Byah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ash-Sharq\u012Byah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ash-Sharq\u012Byah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ash-Sharq\u012Byah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash-Sharq\u012Byah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ash-Sharq\u012Byah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 64
            },
            {
                "Region Name": "Ash-Sharq\u012Byah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash-Sharq\u012Byah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ash-Sharq\u012Byah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ash-Sharq\u012Byah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ash-Sharq\u012Byah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ash-Sharq\u012Byah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ash-Sharq\u012Byah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ash-Sharq\u012Byah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ash-Sharq\u012Byah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ash-Sharq\u012Byah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ash-Sharq\u012Byah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ash-Sharq\u012Byah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ash-Sharq\u012Byah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Ash Sharqiyah (Governorate of Egypt)": [
            {
                "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ash Sharqiyah (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Ash Sharqiyah North (Region of Oman)": [
            {
                "Region Name": "Ash Sharqiyah North (Region of Oman)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah North (Region of Oman)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah North (Region of Oman)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah North (Region of Oman)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah North (Region of Oman)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah North (Region of Oman)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah North (Region of Oman)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah North (Region of Oman)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah North (Region of Oman)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah North (Region of Oman)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah North (Region of Oman)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah North (Region of Oman)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah North (Region of Oman)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah North (Region of Oman)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah North (Region of Oman)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah North (Region of Oman)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah North (Region of Oman)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah North (Region of Oman)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah North (Region of Oman)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ash Sharqiyah North (Region of Oman)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah North (Region of Oman)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah North (Region of Oman)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ash Sharqiyah South (Region of Oman)": [
            {
                "Region Name": "Ash Sharqiyah South (Region of Oman)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah South (Region of Oman)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah South (Region of Oman)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah South (Region of Oman)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah South (Region of Oman)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah South (Region of Oman)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah South (Region of Oman)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah South (Region of Oman)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah South (Region of Oman)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah South (Region of Oman)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah South (Region of Oman)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah South (Region of Oman)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah South (Region of Oman)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah South (Region of Oman)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah South (Region of Oman)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah South (Region of Oman)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah South (Region of Oman)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah South (Region of Oman)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah South (Region of Oman)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah South (Region of Oman)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah South (Region of Oman)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ash Sharqiyah South (Region of Oman)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ashanti (Region of Ghana)": [
            {
                "Region Name": "Ashanti (Region of Ghana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Ashanti (Region of Ghana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Ashanti (Region of Ghana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Ashanti (Region of Ghana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ashanti (Region of Ghana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Ashanti (Region of Ghana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Ashanti (Region of Ghana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Ashanti (Region of Ghana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Ashanti (Region of Ghana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Ashanti (Region of Ghana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Ashanti (Region of Ghana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Ashanti (Region of Ghana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Ashanti (Region of Ghana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Ashanti (Region of Ghana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Ashanti (Region of Ghana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Ashanti (Region of Ghana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Ashanti (Region of Ghana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Ashanti (Region of Ghana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Ashanti (Region of Ghana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Ashanti (Region of Ghana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Ashanti (Region of Ghana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Ashanti (Region of Ghana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 27
            }
        ],
        "Ashmore and Cartier Islands (Territory of Australia)": [
            {
                "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ashmore and Cartier Islands (Territory of Australia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Assaba (Region of Mauritania)": [
            {
                "Region Name": "Assaba (Region of Mauritania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Assaba (Region of Mauritania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Assaba (Region of Mauritania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 175
            },
            {
                "Region Name": "Assaba (Region of Mauritania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Assaba (Region of Mauritania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 95
            },
            {
                "Region Name": "Assaba (Region of Mauritania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 110
            },
            {
                "Region Name": "Assaba (Region of Mauritania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 138
            },
            {
                "Region Name": "Assaba (Region of Mauritania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Assaba (Region of Mauritania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 519
            },
            {
                "Region Name": "Assaba (Region of Mauritania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Assaba (Region of Mauritania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Assaba (Region of Mauritania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Assaba (Region of Mauritania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Assaba (Region of Mauritania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Assaba (Region of Mauritania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "Assaba (Region of Mauritania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 196
            },
            {
                "Region Name": "Assaba (Region of Mauritania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Assaba (Region of Mauritania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Assaba (Region of Mauritania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 168
            },
            {
                "Region Name": "Assaba (Region of Mauritania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Assaba (Region of Mauritania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 86
            },
            {
                "Region Name": "Assaba (Region of Mauritania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 66
            }
        ],
        "Assam (State of India)": [
            {
                "Region Name": "Assam (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Assam (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Assam (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Assam (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Assam (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Assam (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Assam (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Assam (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Assam (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Assam (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Assam (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Assam (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Assam (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Assam (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Assam (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Assam (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Assam (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Assam (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Assam (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Assam (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Assam (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Assam (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Astrakhan' (Region of Russia)": [
            {
                "Region Name": "Astrakhan' (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Astrakhan' (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Astrakhan' (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Astrakhan' (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Astrakhan' (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Astrakhan' (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Astrakhan' (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Astrakhan' (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Astrakhan' (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Astrakhan' (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Astrakhan' (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Astrakhan' (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Astrakhan' (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Astrakhan' (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Astrakhan' (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Astrakhan' (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Astrakhan' (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Astrakhan' (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Astrakhan' (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Astrakhan' (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Astrakhan' (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Astrakhan' (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 22
            }
        ],
        "Asunci\xf3n (Capital District of Paraguay)": [
            {
                "Region Name": "Asunci\xf3n (Capital District of Paraguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asunci\xf3n (Capital District of Paraguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asunci\xf3n (Capital District of Paraguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asunci\xf3n (Capital District of Paraguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asunci\xf3n (Capital District of Paraguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asunci\xf3n (Capital District of Paraguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asunci\xf3n (Capital District of Paraguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asunci\xf3n (Capital District of Paraguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asunci\xf3n (Capital District of Paraguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asunci\xf3n (Capital District of Paraguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asunci\xf3n (Capital District of Paraguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asunci\xf3n (Capital District of Paraguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asunci\xf3n (Capital District of Paraguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asunci\xf3n (Capital District of Paraguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asunci\xf3n (Capital District of Paraguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asunci\xf3n (Capital District of Paraguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Asunci\xf3n (Capital District of Paraguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asunci\xf3n (Capital District of Paraguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asunci\xf3n (Capital District of Paraguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Asunci\xf3n (Capital District of Paraguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Asunci\xf3n (Capital District of Paraguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asunci\xf3n (Capital District of Paraguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Aswan (Governorate of Egypt)": [
            {
                "Region Name": "Aswan (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aswan (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aswan (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aswan (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aswan (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aswan (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aswan (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aswan (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aswan (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aswan (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aswan (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aswan (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aswan (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aswan (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aswan (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aswan (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aswan (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Aswan (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Aswan (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Aswan (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Aswan (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Aswan (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Asyut (Governorate of Egypt)": [
            {
                "Region Name": "Asyut (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asyut (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asyut (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asyut (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asyut (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asyut (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asyut (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asyut (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asyut (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asyut (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asyut (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asyut (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asyut (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asyut (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asyut (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asyut (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Asyut (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asyut (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asyut (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asyut (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asyut (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Asyut (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "At-Ta'mim (Province of Iraq)": [
            {
                "Region Name": "At-Ta'mim (Province of Iraq)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "At-Ta'mim (Province of Iraq)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "At-Ta'mim (Province of Iraq)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "At-Ta'mim (Province of Iraq)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "At-Ta'mim (Province of Iraq)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "At-Ta'mim (Province of Iraq)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "At-Ta'mim (Province of Iraq)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "At-Ta'mim (Province of Iraq)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "At-Ta'mim (Province of Iraq)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "At-Ta'mim (Province of Iraq)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "At-Ta'mim (Province of Iraq)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "At-Ta'mim (Province of Iraq)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "At-Ta'mim (Province of Iraq)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "At-Ta'mim (Province of Iraq)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "At-Ta'mim (Province of Iraq)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "At-Ta'mim (Province of Iraq)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "At-Ta'mim (Province of Iraq)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "At-Ta'mim (Province of Iraq)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "At-Ta'mim (Province of Iraq)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "At-Ta'mim (Province of Iraq)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "At-Ta'mim (Province of Iraq)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "At-Ta'mim (Province of Iraq)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Atacama (Region of Chile)": [
            {
                "Region Name": "Atacama (Region of Chile)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Atacama (Region of Chile)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atacama (Region of Chile)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atacama (Region of Chile)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atacama (Region of Chile)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atacama (Region of Chile)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atacama (Region of Chile)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atacama (Region of Chile)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atacama (Region of Chile)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atacama (Region of Chile)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atacama (Region of Chile)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atacama (Region of Chile)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atacama (Region of Chile)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Atacama (Region of Chile)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atacama (Region of Chile)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atacama (Region of Chile)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atacama (Region of Chile)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atacama (Region of Chile)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atacama (Region of Chile)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atacama (Region of Chile)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Atacama (Region of Chile)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atacama (Region of Chile)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Atakora (Department of Benin)": [
            {
                "Region Name": "Atakora (Department of Benin)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Atakora (Department of Benin)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Atakora (Department of Benin)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Atakora (Department of Benin)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Atakora (Department of Benin)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Atakora (Department of Benin)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Atakora (Department of Benin)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Atakora (Department of Benin)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Atakora (Department of Benin)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Atakora (Department of Benin)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Atakora (Department of Benin)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Atakora (Department of Benin)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Atakora (Department of Benin)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Atakora (Department of Benin)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Atakora (Department of Benin)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Atakora (Department of Benin)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Atakora (Department of Benin)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Atakora (Department of Benin)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Atakora (Department of Benin)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Atakora (Department of Benin)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Atakora (Department of Benin)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Atakora (Department of Benin)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 39
            }
        ],
        "Athos (Decentralized administration of Greece)": [
            {
                "Region Name": "Athos (Decentralized administration of Greece)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Athos (Decentralized administration of Greece)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Athos (Decentralized administration of Greece)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Athos (Decentralized administration of Greece)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Athos (Decentralized administration of Greece)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Athos (Decentralized administration of Greece)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Athos (Decentralized administration of Greece)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Athos (Decentralized administration of Greece)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Athos (Decentralized administration of Greece)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Athos (Decentralized administration of Greece)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Athos (Decentralized administration of Greece)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Athos (Decentralized administration of Greece)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Athos (Decentralized administration of Greece)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Athos (Decentralized administration of Greece)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Athos (Decentralized administration of Greece)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Athos (Decentralized administration of Greece)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Athos (Decentralized administration of Greece)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Athos (Decentralized administration of Greece)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Athos (Decentralized administration of Greece)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Athos (Decentralized administration of Greece)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Athos (Decentralized administration of Greece)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Athos (Decentralized administration of Greece)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Atiu (Island Council of Cook Islands)": [
            {
                "Region Name": "Atiu (Island Council of Cook Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atiu (Island Council of Cook Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atiu (Island Council of Cook Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atiu (Island Council of Cook Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atiu (Island Council of Cook Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atiu (Island Council of Cook Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atiu (Island Council of Cook Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atiu (Island Council of Cook Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atiu (Island Council of Cook Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atiu (Island Council of Cook Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atiu (Island Council of Cook Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atiu (Island Council of Cook Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atiu (Island Council of Cook Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atiu (Island Council of Cook Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atiu (Island Council of Cook Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atiu (Island Council of Cook Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atiu (Island Council of Cook Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atiu (Island Council of Cook Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atiu (Island Council of Cook Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atiu (Island Council of Cook Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atiu (Island Council of Cook Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atiu (Island Council of Cook Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Atl\xe1ntico (Department of Colombia)": [
            {
                "Region Name": "Atl\xe1ntico (Department of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Atl\xe1ntico (Department of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Atl\xe1ntico (Department of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atl\xe1ntico (Department of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atl\xe1ntico (Department of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Atl\xe1ntico (Department of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atl\xe1ntico (Department of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Atl\xe1ntico (Department of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atl\xe1ntico (Department of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atl\xe1ntico (Department of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atl\xe1ntico (Department of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Atl\xe1ntico (Department of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atl\xe1ntico (Department of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Atl\xe1ntico (Department of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Atl\xe1ntico (Department of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atl\xe1ntico (Department of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atl\xe1ntico (Department of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Atl\xe1ntico (Department of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atl\xe1ntico (Department of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atl\xe1ntico (Department of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atl\xe1ntico (Department of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atl\xe1ntico (Department of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Atl\xe1ntico Norte (Autonomous Region of Nicaragua)": [
            {
                "Region Name": "Atl\xe1ntico Norte (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Atl\xe1ntico Norte (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Atl\xe1ntico Norte (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Atl\xe1ntico Norte (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Atl\xe1ntico Norte (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Atl\xe1ntico Norte (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Atl\xe1ntico Norte (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Atl\xe1ntico Norte (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Atl\xe1ntico Norte (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Atl\xe1ntico Norte (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Atl\xe1ntico Norte (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Atl\xe1ntico Norte (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Atl\xe1ntico Norte (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Atl\xe1ntico Norte (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Atl\xe1ntico Norte (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Atl\xe1ntico Norte (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Atl\xe1ntico Norte (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Atl\xe1ntico Norte (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Atl\xe1ntico Norte (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Atl\xe1ntico Norte (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Atl\xe1ntico Norte (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Atl\xe1ntico Norte (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Atl\xe1ntico Sur (Autonomous Region of Nicaragua)": [
            {
                "Region Name": "Atl\xe1ntico Sur (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Atl\xe1ntico Sur (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Atl\xe1ntico Sur (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Atl\xe1ntico Sur (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Atl\xe1ntico Sur (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Atl\xe1ntico Sur (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Atl\xe1ntico Sur (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Atl\xe1ntico Sur (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Atl\xe1ntico Sur (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Atl\xe1ntico Sur (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Atl\xe1ntico Sur (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Atl\xe1ntico Sur (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Atl\xe1ntico Sur (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Atl\xe1ntico Sur (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Atl\xe1ntico Sur (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Atl\xe1ntico Sur (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Atl\xe1ntico Sur (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Atl\xe1ntico Sur (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Atl\xe1ntico Sur (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Atl\xe1ntico Sur (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Atl\xe1ntico Sur (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Atl\xe1ntico Sur (Autonomous Region of Nicaragua)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Atl\xe1ntida (Department of Honduras)": [
            {
                "Region Name": "Atl\xe1ntida (Department of Honduras)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Atl\xe1ntida (Department of Honduras)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Atl\xe1ntida (Department of Honduras)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Atl\xe1ntida (Department of Honduras)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Atl\xe1ntida (Department of Honduras)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Atl\xe1ntida (Department of Honduras)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Atl\xe1ntida (Department of Honduras)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Atl\xe1ntida (Department of Honduras)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Atl\xe1ntida (Department of Honduras)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Atl\xe1ntida (Department of Honduras)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Atl\xe1ntida (Department of Honduras)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atl\xe1ntida (Department of Honduras)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Atl\xe1ntida (Department of Honduras)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Atl\xe1ntida (Department of Honduras)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Atl\xe1ntida (Department of Honduras)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Atl\xe1ntida (Department of Honduras)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Atl\xe1ntida (Department of Honduras)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atl\xe1ntida (Department of Honduras)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Atl\xe1ntida (Department of Honduras)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Atl\xe1ntida (Department of Honduras)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Atl\xe1ntida (Department of Honduras)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atl\xe1ntida (Department of Honduras)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Atlantique (Department of Benin)": [
            {
                "Region Name": "Atlantique (Department of Benin)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Atlantique (Department of Benin)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Atlantique (Department of Benin)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Atlantique (Department of Benin)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Atlantique (Department of Benin)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Atlantique (Department of Benin)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Atlantique (Department of Benin)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Atlantique (Department of Benin)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Atlantique (Department of Benin)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Atlantique (Department of Benin)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Atlantique (Department of Benin)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Atlantique (Department of Benin)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Atlantique (Department of Benin)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Atlantique (Department of Benin)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Atlantique (Department of Benin)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Atlantique (Department of Benin)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Atlantique (Department of Benin)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Atlantique (Department of Benin)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Atlantique (Department of Benin)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Atlantique (Department of Benin)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Atlantique (Department of Benin)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Atlantique (Department of Benin)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Attapu (Province of Laos)": [
            {
                "Region Name": "Attapu (Province of Laos)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Attapu (Province of Laos)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Attapu (Province of Laos)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Attapu (Province of Laos)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Attapu (Province of Laos)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Attapu (Province of Laos)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Attapu (Province of Laos)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Attapu (Province of Laos)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Attapu (Province of Laos)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Attapu (Province of Laos)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Attapu (Province of Laos)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Attapu (Province of Laos)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Attapu (Province of Laos)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Attapu (Province of Laos)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Attapu (Province of Laos)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Attapu (Province of Laos)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Attapu (Province of Laos)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Attapu (Province of Laos)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Attapu (Province of Laos)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Attapu (Province of Laos)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Attapu (Province of Laos)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Attapu (Province of Laos)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Attica (Decentralized administration of Greece)": [
            {
                "Region Name": "Attica (Decentralized administration of Greece)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Attica (Decentralized administration of Greece)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Attica (Decentralized administration of Greece)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Attica (Decentralized administration of Greece)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Attica (Decentralized administration of Greece)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Attica (Decentralized administration of Greece)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Attica (Decentralized administration of Greece)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Attica (Decentralized administration of Greece)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 138
            },
            {
                "Region Name": "Attica (Decentralized administration of Greece)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Attica (Decentralized administration of Greece)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Attica (Decentralized administration of Greece)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Attica (Decentralized administration of Greece)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Attica (Decentralized administration of Greece)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Attica (Decentralized administration of Greece)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Attica (Decentralized administration of Greece)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Attica (Decentralized administration of Greece)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Attica (Decentralized administration of Greece)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Attica (Decentralized administration of Greece)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Attica (Decentralized administration of Greece)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Attica (Decentralized administration of Greece)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 106
            },
            {
                "Region Name": "Attica (Decentralized administration of Greece)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Attica (Decentralized administration of Greece)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 117
            }
        ],
        "Atua (District of Samoa)": [
            {
                "Region Name": "Atua (District of Samoa)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atua (District of Samoa)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atua (District of Samoa)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atua (District of Samoa)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atua (District of Samoa)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atua (District of Samoa)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atua (District of Samoa)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atua (District of Samoa)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atua (District of Samoa)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atua (District of Samoa)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atua (District of Samoa)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atua (District of Samoa)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atua (District of Samoa)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atua (District of Samoa)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atua (District of Samoa)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atua (District of Samoa)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atua (District of Samoa)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atua (District of Samoa)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atua (District of Samoa)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atua (District of Samoa)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atua (District of Samoa)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Atua (District of Samoa)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Atyrau (Region of Kazakhstan)": [
            {
                "Region Name": "Atyrau (Region of Kazakhstan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 198
            },
            {
                "Region Name": "Atyrau (Region of Kazakhstan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Atyrau (Region of Kazakhstan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 57
            },
            {
                "Region Name": "Atyrau (Region of Kazakhstan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Atyrau (Region of Kazakhstan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 143
            },
            {
                "Region Name": "Atyrau (Region of Kazakhstan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 138
            },
            {
                "Region Name": "Atyrau (Region of Kazakhstan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "Atyrau (Region of Kazakhstan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 65
            },
            {
                "Region Name": "Atyrau (Region of Kazakhstan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Atyrau (Region of Kazakhstan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Atyrau (Region of Kazakhstan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Atyrau (Region of Kazakhstan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Atyrau (Region of Kazakhstan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Atyrau (Region of Kazakhstan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 94
            },
            {
                "Region Name": "Atyrau (Region of Kazakhstan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Atyrau (Region of Kazakhstan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 97
            },
            {
                "Region Name": "Atyrau (Region of Kazakhstan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 65
            },
            {
                "Region Name": "Atyrau (Region of Kazakhstan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 73
            },
            {
                "Region Name": "Atyrau (Region of Kazakhstan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Atyrau (Region of Kazakhstan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Atyrau (Region of Kazakhstan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 73
            },
            {
                "Region Name": "Atyrau (Region of Kazakhstan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 32
            }
        ],
        "Au Cap (District of Seychelles)": [
            {
                "Region Name": "Au Cap (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Cap (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Cap (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Cap (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Cap (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Cap (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Cap (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Cap (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Cap (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Cap (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Cap (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Cap (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Cap (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Cap (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Cap (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Cap (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Cap (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Cap (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Cap (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Cap (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Cap (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Cap (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Au Vent (Parish of Saint-Barth\xe9lemy)": [
            {
                "Region Name": "Au Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Au Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Auckland (Region of New Zealand)": [
            {
                "Region Name": "Auckland (Region of New Zealand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auckland (Region of New Zealand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auckland (Region of New Zealand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auckland (Region of New Zealand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auckland (Region of New Zealand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auckland (Region of New Zealand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auckland (Region of New Zealand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auckland (Region of New Zealand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auckland (Region of New Zealand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auckland (Region of New Zealand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auckland (Region of New Zealand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auckland (Region of New Zealand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auckland (Region of New Zealand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auckland (Region of New Zealand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auckland (Region of New Zealand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auckland (Region of New Zealand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auckland (Region of New Zealand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auckland (Region of New Zealand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auckland (Region of New Zealand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auckland (Region of New Zealand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auckland (Region of New Zealand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auckland (Region of New Zealand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Aur (Atol of Marshall Islands)": [
            {
                "Region Name": "Aur (Atol of Marshall Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aur (Atol of Marshall Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aur (Atol of Marshall Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aur (Atol of Marshall Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aur (Atol of Marshall Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aur (Atol of Marshall Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aur (Atol of Marshall Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aur (Atol of Marshall Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aur (Atol of Marshall Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aur (Atol of Marshall Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aur (Atol of Marshall Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aur (Atol of Marshall Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aur (Atol of Marshall Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aur (Atol of Marshall Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aur (Atol of Marshall Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aur (Atol of Marshall Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aur (Atol of Marshall Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aur (Atol of Marshall Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aur (Atol of Marshall Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aur (Atol of Marshall Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aur (Atol of Marshall Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aur (Atol of Marshall Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Aurora (Province of Philippines)": [
            {
                "Region Name": "Aurora (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aurora (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aurora (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aurora (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aurora (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aurora (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aurora (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Aurora (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aurora (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aurora (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aurora (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aurora (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aurora (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aurora (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aurora (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aurora (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aurora (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aurora (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aurora (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aurora (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aurora (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aurora (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Aust-Agder (County of Norway)": [
            {
                "Region Name": "Aust-Agder (County of Norway)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aust-Agder (County of Norway)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aust-Agder (County of Norway)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aust-Agder (County of Norway)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aust-Agder (County of Norway)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aust-Agder (County of Norway)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aust-Agder (County of Norway)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Aust-Agder (County of Norway)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aust-Agder (County of Norway)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aust-Agder (County of Norway)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aust-Agder (County of Norway)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aust-Agder (County of Norway)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aust-Agder (County of Norway)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aust-Agder (County of Norway)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aust-Agder (County of Norway)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aust-Agder (County of Norway)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aust-Agder (County of Norway)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aust-Agder (County of Norway)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aust-Agder (County of Norway)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aust-Agder (County of Norway)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aust-Agder (County of Norway)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aust-Agder (County of Norway)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Australian Capital Territory (Territory of Australia)": [
            {
                "Region Name": "Australian Capital Territory (Territory of Australia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 238
            },
            {
                "Region Name": "Australian Capital Territory (Territory of Australia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Australian Capital Territory (Territory of Australia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australian Capital Territory (Territory of Australia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Australian Capital Territory (Territory of Australia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australian Capital Territory (Territory of Australia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australian Capital Territory (Territory of Australia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australian Capital Territory (Territory of Australia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australian Capital Territory (Territory of Australia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australian Capital Territory (Territory of Australia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australian Capital Territory (Territory of Australia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australian Capital Territory (Territory of Australia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australian Capital Territory (Territory of Australia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australian Capital Territory (Territory of Australia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australian Capital Territory (Territory of Australia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Australian Capital Territory (Territory of Australia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australian Capital Territory (Territory of Australia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Australian Capital Territory (Territory of Australia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 353
            },
            {
                "Region Name": "Australian Capital Territory (Territory of Australia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australian Capital Territory (Territory of Australia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australian Capital Territory (Territory of Australia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australian Capital Territory (Territory of Australia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Austurland (Region of Iceland)": [
            {
                "Region Name": "Austurland (Region of Iceland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austurland (Region of Iceland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austurland (Region of Iceland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austurland (Region of Iceland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austurland (Region of Iceland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austurland (Region of Iceland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austurland (Region of Iceland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austurland (Region of Iceland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austurland (Region of Iceland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austurland (Region of Iceland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austurland (Region of Iceland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austurland (Region of Iceland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austurland (Region of Iceland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austurland (Region of Iceland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austurland (Region of Iceland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austurland (Region of Iceland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austurland (Region of Iceland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austurland (Region of Iceland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austurland (Region of Iceland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austurland (Region of Iceland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austurland (Region of Iceland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Austurland (Region of Iceland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Auvergne-Rh\xf4ne-Alpes (Region of France)": [
            {
                "Region Name": "Auvergne-Rh\xf4ne-Alpes (Region of France)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Auvergne-Rh\xf4ne-Alpes (Region of France)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Auvergne-Rh\xf4ne-Alpes (Region of France)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Auvergne-Rh\xf4ne-Alpes (Region of France)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Auvergne-Rh\xf4ne-Alpes (Region of France)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Auvergne-Rh\xf4ne-Alpes (Region of France)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Auvergne-Rh\xf4ne-Alpes (Region of France)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auvergne-Rh\xf4ne-Alpes (Region of France)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Auvergne-Rh\xf4ne-Alpes (Region of France)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Auvergne-Rh\xf4ne-Alpes (Region of France)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Auvergne-Rh\xf4ne-Alpes (Region of France)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auvergne-Rh\xf4ne-Alpes (Region of France)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auvergne-Rh\xf4ne-Alpes (Region of France)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Auvergne-Rh\xf4ne-Alpes (Region of France)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Auvergne-Rh\xf4ne-Alpes (Region of France)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Auvergne-Rh\xf4ne-Alpes (Region of France)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Auvergne-Rh\xf4ne-Alpes (Region of France)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Auvergne-Rh\xf4ne-Alpes (Region of France)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auvergne-Rh\xf4ne-Alpes (Region of France)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Auvergne-Rh\xf4ne-Alpes (Region of France)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Auvergne-Rh\xf4ne-Alpes (Region of France)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Auvergne-Rh\xf4ne-Alpes (Region of France)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Aveiro (District of Portugal)": [
            {
                "Region Name": "Aveiro (District of Portugal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Aveiro (District of Portugal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aveiro (District of Portugal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Aveiro (District of Portugal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 57
            },
            {
                "Region Name": "Aveiro (District of Portugal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Aveiro (District of Portugal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Aveiro (District of Portugal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aveiro (District of Portugal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Aveiro (District of Portugal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Aveiro (District of Portugal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Aveiro (District of Portugal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Aveiro (District of Portugal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Aveiro (District of Portugal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Aveiro (District of Portugal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Aveiro (District of Portugal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 156
            },
            {
                "Region Name": "Aveiro (District of Portugal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Aveiro (District of Portugal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aveiro (District of Portugal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Aveiro (District of Portugal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Aveiro (District of Portugal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aveiro (District of Portugal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Aveiro (District of Portugal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Awdal (Region of Somalia)": [
            {
                "Region Name": "Awdal (Region of Somalia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Awdal (Region of Somalia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Awdal (Region of Somalia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Awdal (Region of Somalia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Awdal (Region of Somalia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Awdal (Region of Somalia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Awdal (Region of Somalia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Awdal (Region of Somalia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Awdal (Region of Somalia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Awdal (Region of Somalia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Awdal (Region of Somalia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Awdal (Region of Somalia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Awdal (Region of Somalia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Awdal (Region of Somalia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Awdal (Region of Somalia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Awdal (Region of Somalia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Awdal (Region of Somalia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Awdal (Region of Somalia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Awdal (Region of Somalia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Awdal (Region of Somalia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Awdal (Region of Somalia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Awdal (Region of Somalia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Ayacucho (Region of Peru)": [
            {
                "Region Name": "Ayacucho (Region of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ayacucho (Region of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ayacucho (Region of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ayacucho (Region of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ayacucho (Region of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ayacucho (Region of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ayacucho (Region of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ayacucho (Region of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ayacucho (Region of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ayacucho (Region of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ayacucho (Region of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ayacucho (Region of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ayacucho (Region of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ayacucho (Region of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ayacucho (Region of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ayacucho (Region of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ayacucho (Region of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ayacucho (Region of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ayacucho (Region of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ayacucho (Region of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ayacucho (Region of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Ayacucho (Region of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Aydin (Province of Turkey)": [
            {
                "Region Name": "Aydin (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aydin (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Aydin (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Aydin (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Aydin (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Aydin (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Aydin (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aydin (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aydin (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Aydin (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Aydin (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aydin (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Aydin (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aydin (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Aydin (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aydin (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Aydin (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aydin (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Aydin (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aydin (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Aydin (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Aydin (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ayeyarwady (Division of Myanmar)": [
            {
                "Region Name": "Ayeyarwady (Division of Myanmar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ayeyarwady (Division of Myanmar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ayeyarwady (Division of Myanmar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ayeyarwady (Division of Myanmar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ayeyarwady (Division of Myanmar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ayeyarwady (Division of Myanmar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ayeyarwady (Division of Myanmar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ayeyarwady (Division of Myanmar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ayeyarwady (Division of Myanmar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ayeyarwady (Division of Myanmar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ayeyarwady (Division of Myanmar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ayeyarwady (Division of Myanmar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ayeyarwady (Division of Myanmar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ayeyarwady (Division of Myanmar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ayeyarwady (Division of Myanmar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ayeyarwady (Division of Myanmar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ayeyarwady (Division of Myanmar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ayeyarwady (Division of Myanmar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ayeyarwady (Division of Myanmar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ayeyarwady (Division of Myanmar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ayeyarwady (Division of Myanmar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ayeyarwady (Division of Myanmar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Ays\xe9n del General Ib\xe1\xf1ez del Campo (Region of Chile)": [
            {
                "Region Name": "Ays\xe9n del General Ib\xe1\xf1ez del Campo (Region of Chile)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ays\xe9n del General Ib\xe1\xf1ez del Campo (Region of Chile)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ays\xe9n del General Ib\xe1\xf1ez del Campo (Region of Chile)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ays\xe9n del General Ib\xe1\xf1ez del Campo (Region of Chile)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ays\xe9n del General Ib\xe1\xf1ez del Campo (Region of Chile)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ays\xe9n del General Ib\xe1\xf1ez del Campo (Region of Chile)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ays\xe9n del General Ib\xe1\xf1ez del Campo (Region of Chile)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Ays\xe9n del General Ib\xe1\xf1ez del Campo (Region of Chile)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ays\xe9n del General Ib\xe1\xf1ez del Campo (Region of Chile)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ays\xe9n del General Ib\xe1\xf1ez del Campo (Region of Chile)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ays\xe9n del General Ib\xe1\xf1ez del Campo (Region of Chile)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ays\xe9n del General Ib\xe1\xf1ez del Campo (Region of Chile)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ays\xe9n del General Ib\xe1\xf1ez del Campo (Region of Chile)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Ays\xe9n del General Ib\xe1\xf1ez del Campo (Region of Chile)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ays\xe9n del General Ib\xe1\xf1ez del Campo (Region of Chile)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ays\xe9n del General Ib\xe1\xf1ez del Campo (Region of Chile)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ays\xe9n del General Ib\xe1\xf1ez del Campo (Region of Chile)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 93
            },
            {
                "Region Name": "Ays\xe9n del General Ib\xe1\xf1ez del Campo (Region of Chile)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ays\xe9n del General Ib\xe1\xf1ez del Campo (Region of Chile)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ays\xe9n del General Ib\xe1\xf1ez del Campo (Region of Chile)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ays\xe9n del General Ib\xe1\xf1ez del Campo (Region of Chile)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ays\xe9n del General Ib\xe1\xf1ez del Campo (Region of Chile)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Az Zawiyah (District of Libya)": [
            {
                "Region Name": "Az Zawiyah (District of Libya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Az Zawiyah (District of Libya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Az Zawiyah (District of Libya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Az Zawiyah (District of Libya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Az Zawiyah (District of Libya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Az Zawiyah (District of Libya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Az Zawiyah (District of Libya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Az Zawiyah (District of Libya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Az Zawiyah (District of Libya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Az Zawiyah (District of Libya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Az Zawiyah (District of Libya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Az Zawiyah (District of Libya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Az Zawiyah (District of Libya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Az Zawiyah (District of Libya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Az Zawiyah (District of Libya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Az Zawiyah (District of Libya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Az Zawiyah (District of Libya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Az Zawiyah (District of Libya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Az Zawiyah (District of Libya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Az Zawiyah (District of Libya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Az Zawiyah (District of Libya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Az Zawiyah (District of Libya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Azad Kashmir (Centrally Administered Area of Pakistan)": [
            {
                "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Azad Kashmir (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Azores ('Autonomous Region' of Portugal)": [
            {
                "Region Name": "Azores ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azores ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azores ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azores ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azores ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azores ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azores ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azores ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azores ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azores ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azores ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azores ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azores ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azores ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azores ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azores ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azores ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azores ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azores ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azores ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azores ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azores ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Azua (Province of Dominican Republic)": [
            {
                "Region Name": "Azua (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azua (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Azua (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Azua (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Azua (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Azua (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Azua (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Azua (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Azua (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azua (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Azua (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Azua (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Azua (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Azua (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Azua (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azua (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Azua (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Azua (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Azua (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Azua (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Azua (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Azua (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Azuay (Province of Ecuador)": [
            {
                "Region Name": "Azuay (Province of Ecuador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Azuay (Province of Ecuador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Azuay (Province of Ecuador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azuay (Province of Ecuador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Azuay (Province of Ecuador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Azuay (Province of Ecuador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Azuay (Province of Ecuador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azuay (Province of Ecuador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Azuay (Province of Ecuador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Azuay (Province of Ecuador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azuay (Province of Ecuador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Azuay (Province of Ecuador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azuay (Province of Ecuador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azuay (Province of Ecuador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azuay (Province of Ecuador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Azuay (Province of Ecuador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azuay (Province of Ecuador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Azuay (Province of Ecuador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azuay (Province of Ecuador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Azuay (Province of Ecuador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azuay (Province of Ecuador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Azuay (Province of Ecuador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "B\xe0 R\u1ECBa - V\u0169ng T\xe0u (Province of Vietnam)": [
            {
                "Region Name": "B\xe0 R\u1ECBa - V\u0169ng T\xe0u (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xe0 R\u1ECBa - V\u0169ng T\xe0u (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe0 R\u1ECBa - V\u0169ng T\xe0u (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xe0 R\u1ECBa - V\u0169ng T\xe0u (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe0 R\u1ECBa - V\u0169ng T\xe0u (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xe0 R\u1ECBa - V\u0169ng T\xe0u (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xe0 R\u1ECBa - V\u0169ng T\xe0u (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xe0 R\u1ECBa - V\u0169ng T\xe0u (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe0 R\u1ECBa - V\u0169ng T\xe0u (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xe0 R\u1ECBa - V\u0169ng T\xe0u (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xe0 R\u1ECBa - V\u0169ng T\xe0u (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xe0 R\u1ECBa - V\u0169ng T\xe0u (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xe0 R\u1ECBa - V\u0169ng T\xe0u (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xe0 R\u1ECBa - V\u0169ng T\xe0u (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xe0 R\u1ECBa - V\u0169ng T\xe0u (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe0 R\u1ECBa - V\u0169ng T\xe0u (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe0 R\u1ECBa - V\u0169ng T\xe0u (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xe0 R\u1ECBa - V\u0169ng T\xe0u (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xe0 R\u1ECBa - V\u0169ng T\xe0u (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "B\xe0 R\u1ECBa - V\u0169ng T\xe0u (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xe0 R\u1ECBa - V\u0169ng T\xe0u (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xe0 R\u1ECBa - V\u0169ng T\xe0u (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Baalbak - Hermel (Governorate of Lebanon)": [
            {
                "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baalbak - Hermel (Governorate of Lebanon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Babil (Province of Iraq)": [
            {
                "Region Name": "Babil (Province of Iraq)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Babil (Province of Iraq)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Babil (Province of Iraq)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Babil (Province of Iraq)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Babil (Province of Iraq)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Babil (Province of Iraq)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Babil (Province of Iraq)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Babil (Province of Iraq)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Babil (Province of Iraq)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Babil (Province of Iraq)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Babil (Province of Iraq)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Babil (Province of Iraq)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Babil (Province of Iraq)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Babil (Province of Iraq)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Babil (Province of Iraq)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Babil (Province of Iraq)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Babil (Province of Iraq)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Babil (Province of Iraq)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Babil (Province of Iraq)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Babil (Province of Iraq)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Babil (Province of Iraq)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Babil (Province of Iraq)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "B\u1EAFc Giang (Province of Vietnam)": [
            {
                "Region Name": "B\u1EAFc Giang (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Giang (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Giang (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Giang (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\u1EAFc Giang (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\u1EAFc Giang (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Giang (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "B\u1EAFc Giang (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Giang (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Giang (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Giang (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Giang (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Giang (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Giang (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Giang (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Giang (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Giang (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Giang (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\u1EAFc Giang (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\u1EAFc Giang (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Giang (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\u1EAFc Giang (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "B\u1EAFc K\u1EA1n (Province of Vietnam)": [
            {
                "Region Name": "B\u1EAFc K\u1EA1n (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\u1EAFc K\u1EA1n (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\u1EAFc K\u1EA1n (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\u1EAFc K\u1EA1n (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\u1EAFc K\u1EA1n (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\u1EAFc K\u1EA1n (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc K\u1EA1n (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\u1EAFc K\u1EA1n (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc K\u1EA1n (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc K\u1EA1n (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc K\u1EA1n (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc K\u1EA1n (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc K\u1EA1n (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc K\u1EA1n (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc K\u1EA1n (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc K\u1EA1n (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc K\u1EA1n (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc K\u1EA1n (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc K\u1EA1n (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc K\u1EA1n (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc K\u1EA1n (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc K\u1EA1n (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "B\u1EA1c Li\xeau (Province of Vietnam)": [
            {
                "Region Name": "B\u1EA1c Li\xeau (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EA1c Li\xeau (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EA1c Li\xeau (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "B\u1EA1c Li\xeau (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EA1c Li\xeau (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EA1c Li\xeau (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EA1c Li\xeau (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EA1c Li\xeau (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EA1c Li\xeau (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "B\u1EA1c Li\xeau (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "B\u1EA1c Li\xeau (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EA1c Li\xeau (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "B\u1EA1c Li\xeau (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "B\u1EA1c Li\xeau (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "B\u1EA1c Li\xeau (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "B\u1EA1c Li\xeau (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EA1c Li\xeau (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\u1EA1c Li\xeau (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\u1EA1c Li\xeau (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "B\u1EA1c Li\xeau (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EA1c Li\xeau (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EA1c Li\xeau (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "B\u1EAFc Ninh (Province of Vietnam)": [
            {
                "Region Name": "B\u1EAFc Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EAFc Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bac\u0103u (County of Romania)": [
            {
                "Region Name": "Bac\u0103u (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bac\u0103u (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bac\u0103u (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bac\u0103u (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bac\u0103u (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bac\u0103u (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bac\u0103u (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bac\u0103u (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bac\u0103u (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bac\u0103u (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bac\u0103u (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bac\u0103u (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bac\u0103u (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bac\u0103u (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bac\u0103u (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bac\u0103u (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bac\u0103u (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bac\u0103u (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bac\u0103u (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bac\u0103u (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bac\u0103u (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bac\u0103u (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "B\xe1cs-Kiskun (County of Hungary)": [
            {
                "Region Name": "B\xe1cs-Kiskun (County of Hungary)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xe1cs-Kiskun (County of Hungary)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe1cs-Kiskun (County of Hungary)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "B\xe1cs-Kiskun (County of Hungary)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xe1cs-Kiskun (County of Hungary)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xe1cs-Kiskun (County of Hungary)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "B\xe1cs-Kiskun (County of Hungary)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe1cs-Kiskun (County of Hungary)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "B\xe1cs-Kiskun (County of Hungary)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe1cs-Kiskun (County of Hungary)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe1cs-Kiskun (County of Hungary)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "B\xe1cs-Kiskun (County of Hungary)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xe1cs-Kiskun (County of Hungary)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "B\xe1cs-Kiskun (County of Hungary)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xe1cs-Kiskun (County of Hungary)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe1cs-Kiskun (County of Hungary)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe1cs-Kiskun (County of Hungary)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe1cs-Kiskun (County of Hungary)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xe1cs-Kiskun (County of Hungary)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe1cs-Kiskun (County of Hungary)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe1cs-Kiskun (County of Hungary)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe1cs-Kiskun (County of Hungary)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Badakhshan (Province of Afghanistan)": [
            {
                "Region Name": "Badakhshan (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badakhshan (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badakhshan (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badakhshan (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badakhshan (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Badakhshan (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badakhshan (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badakhshan (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badakhshan (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badakhshan (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badakhshan (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badakhshan (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badakhshan (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badakhshan (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badakhshan (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badakhshan (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badakhshan (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badakhshan (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badakhshan (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badakhshan (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badakhshan (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badakhshan (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Baden-W\xfcrttemberg (State of Germany)": [
            {
                "Region Name": "Baden-W\xfcrttemberg (State of Germany)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Baden-W\xfcrttemberg (State of Germany)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baden-W\xfcrttemberg (State of Germany)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baden-W\xfcrttemberg (State of Germany)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Baden-W\xfcrttemberg (State of Germany)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Baden-W\xfcrttemberg (State of Germany)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Baden-W\xfcrttemberg (State of Germany)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baden-W\xfcrttemberg (State of Germany)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baden-W\xfcrttemberg (State of Germany)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baden-W\xfcrttemberg (State of Germany)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baden-W\xfcrttemberg (State of Germany)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baden-W\xfcrttemberg (State of Germany)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baden-W\xfcrttemberg (State of Germany)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Baden-W\xfcrttemberg (State of Germany)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baden-W\xfcrttemberg (State of Germany)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baden-W\xfcrttemberg (State of Germany)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Baden-W\xfcrttemberg (State of Germany)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baden-W\xfcrttemberg (State of Germany)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baden-W\xfcrttemberg (State of Germany)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baden-W\xfcrttemberg (State of Germany)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baden-W\xfcrttemberg (State of Germany)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baden-W\xfcrttemberg (State of Germany)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Badghis (Province of Afghanistan)": [
            {
                "Region Name": "Badghis (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Badghis (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 108
            },
            {
                "Region Name": "Badghis (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Badghis (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Badghis (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badghis (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Badghis (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badghis (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Badghis (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Badghis (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badghis (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Badghis (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Badghis (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badghis (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Badghis (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badghis (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badghis (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badghis (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 103
            },
            {
                "Region Name": "Badghis (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Badghis (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Badghis (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badghis (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Badulla (District of Sri Lanka)": [
            {
                "Region Name": "Badulla (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Badulla (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Badulla (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Badulla (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Badulla (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Badulla (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Badulla (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Badulla (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Badulla (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badulla (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Badulla (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Badulla (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Badulla (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Badulla (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Badulla (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Badulla (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badulla (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Badulla (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Badulla (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badulla (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Badulla (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Badulla (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bafat\xe1 (Region of Guinea-Bissau)": [
            {
                "Region Name": "Bafat\xe1 (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Bafat\xe1 (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bafat\xe1 (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Bafat\xe1 (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Bafat\xe1 (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Bafat\xe1 (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bafat\xe1 (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Bafat\xe1 (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Bafat\xe1 (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bafat\xe1 (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bafat\xe1 (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bafat\xe1 (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bafat\xe1 (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Bafat\xe1 (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bafat\xe1 (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Bafat\xe1 (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Bafat\xe1 (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Bafat\xe1 (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bafat\xe1 (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bafat\xe1 (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bafat\xe1 (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bafat\xe1 (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Baghdad (Province of Iraq)": [
            {
                "Region Name": "Baghdad (Province of Iraq)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghdad (Province of Iraq)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Baghdad (Province of Iraq)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghdad (Province of Iraq)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghdad (Province of Iraq)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghdad (Province of Iraq)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghdad (Province of Iraq)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghdad (Province of Iraq)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghdad (Province of Iraq)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Baghdad (Province of Iraq)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghdad (Province of Iraq)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghdad (Province of Iraq)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghdad (Province of Iraq)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghdad (Province of Iraq)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghdad (Province of Iraq)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghdad (Province of Iraq)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghdad (Province of Iraq)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghdad (Province of Iraq)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghdad (Province of Iraq)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghdad (Province of Iraq)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghdad (Province of Iraq)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghdad (Province of Iraq)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Baghlan (Province of Afghanistan)": [
            {
                "Region Name": "Baghlan (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghlan (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Baghlan (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Baghlan (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Baghlan (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Baghlan (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghlan (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Baghlan (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Baghlan (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Baghlan (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghlan (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Baghlan (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Baghlan (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghlan (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghlan (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghlan (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghlan (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghlan (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghlan (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Baghlan (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghlan (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baghlan (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bago (Division of Myanmar)": [
            {
                "Region Name": "Bago (Division of Myanmar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bago (Division of Myanmar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bago (Division of Myanmar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bago (Division of Myanmar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bago (Division of Myanmar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bago (Division of Myanmar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bago (Division of Myanmar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bago (Division of Myanmar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bago (Division of Myanmar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bago (Division of Myanmar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bago (Division of Myanmar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bago (Division of Myanmar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bago (Division of Myanmar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bago (Division of Myanmar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bago (Division of Myanmar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bago (Division of Myanmar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bago (Division of Myanmar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bago (Division of Myanmar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bago (Division of Myanmar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bago (Division of Myanmar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bago (Division of Myanmar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bago (Division of Myanmar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Bahia (State of Brazil)": [
            {
                "Region Name": "Bahia (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Bahia (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bahia (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Bahia (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Bahia (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bahia (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Bahia (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Bahia (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bahia (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Bahia (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Bahia (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Bahia (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Bahia (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Bahia (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Bahia (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bahia (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Bahia (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bahia (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Bahia (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Bahia (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Bahia (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Bahia (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Bahoruco (Province of Dominican Republic)": [
            {
                "Region Name": "Bahoruco (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bahoruco (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bahoruco (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bahoruco (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bahoruco (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bahoruco (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bahoruco (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bahoruco (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bahoruco (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bahoruco (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bahoruco (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bahoruco (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bahoruco (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bahoruco (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bahoruco (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bahoruco (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bahoruco (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bahoruco (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bahoruco (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bahoruco (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bahoruco (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bahoruco (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Baie Lazare (District of Seychelles)": [
            {
                "Region Name": "Baie Lazare (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Lazare (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Lazare (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Lazare (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Lazare (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Lazare (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Lazare (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Lazare (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Lazare (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Lazare (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Lazare (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Lazare (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Lazare (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Lazare (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Lazare (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Lazare (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Lazare (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Lazare (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Lazare (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Lazare (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Lazare (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Lazare (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Baie Sainte Anne (District of Seychelles)": [
            {
                "Region Name": "Baie Sainte Anne (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Sainte Anne (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Sainte Anne (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Sainte Anne (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Sainte Anne (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Sainte Anne (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Sainte Anne (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Sainte Anne (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Sainte Anne (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Sainte Anne (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Sainte Anne (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Sainte Anne (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Sainte Anne (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Sainte Anne (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Sainte Anne (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Sainte Anne (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Sainte Anne (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Sainte Anne (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Sainte Anne (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Sainte Anne (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Sainte Anne (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baie Sainte Anne (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Baiti (District of Nauru)": [
            {
                "Region Name": "Baiti (District of Nauru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baiti (District of Nauru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baiti (District of Nauru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baiti (District of Nauru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baiti (District of Nauru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baiti (District of Nauru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baiti (District of Nauru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baiti (District of Nauru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baiti (District of Nauru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baiti (District of Nauru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baiti (District of Nauru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baiti (District of Nauru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baiti (District of Nauru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baiti (District of Nauru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baiti (District of Nauru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baiti (District of Nauru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baiti (District of Nauru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baiti (District of Nauru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baiti (District of Nauru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baiti (District of Nauru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baiti (District of Nauru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baiti (District of Nauru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Baja California (State of M\xe9xico)": [
            {
                "Region Name": "Baja California (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Baja California (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Baja California (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Baja California (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Baja California (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Baja California (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Baja California (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Baja California (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Baja California (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Baja California (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Baja California (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Baja California (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Baja California (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Baja California (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Baja California (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Baja California (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Baja California (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Baja California (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Baja California (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 61
            },
            {
                "Region Name": "Baja California (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Baja California (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Baja California (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "Baja California Sur (State of M\xe9xico)": [
            {
                "Region Name": "Baja California Sur (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baja California Sur (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baja California Sur (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baja California Sur (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baja California Sur (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baja California Sur (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baja California Sur (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baja California Sur (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Baja California Sur (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baja California Sur (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baja California Sur (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Baja California Sur (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Baja California Sur (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Baja California Sur (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Baja California Sur (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baja California Sur (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baja California Sur (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baja California Sur (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baja California Sur (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Baja California Sur (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baja California Sur (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baja California Sur (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Baja Verapaz (Department of Guatemala)": [
            {
                "Region Name": "Baja Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Baja Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Baja Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Baja Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Baja Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Baja Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Baja Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Baja Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Baja Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Baja Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Baja Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Baja Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Baja Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Baja Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Baja Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Baja Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Baja Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Baja Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Baja Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Baja Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Baja Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baja Verapaz (Department of Guatemala)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Baker (Island of United States Minor Outlying Isl)": [
            {
                "Region Name": "Baker (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baker (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baker (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baker (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baker (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baker (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baker (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baker (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baker (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baker (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baker (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baker (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baker (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baker (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baker (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baker (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baker (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baker (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baker (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baker (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baker (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baker (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bakool (Region of Somalia)": [
            {
                "Region Name": "Bakool (Region of Somalia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bakool (Region of Somalia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bakool (Region of Somalia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bakool (Region of Somalia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bakool (Region of Somalia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bakool (Region of Somalia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bakool (Region of Somalia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bakool (Region of Somalia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bakool (Region of Somalia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bakool (Region of Somalia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bakool (Region of Somalia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bakool (Region of Somalia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bakool (Region of Somalia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bakool (Region of Somalia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bakool (Region of Somalia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bakool (Region of Somalia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bakool (Region of Somalia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bakool (Region of Somalia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bakool (Region of Somalia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bakool (Region of Somalia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bakool (Region of Somalia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bakool (Region of Somalia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Balaka (District of Malawi)": [
            {
                "Region Name": "Balaka (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Balaka (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Balaka (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Balaka (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Balaka (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Balaka (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Balaka (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Balaka (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Balaka (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Balaka (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Balaka (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Balaka (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Balaka (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Balaka (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Balaka (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Balaka (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Balaka (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Balaka (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Balaka (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Balaka (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Balaka (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Balaka (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Bali (Province of Indonesia)": [
            {
                "Region Name": "Bali (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bali (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bali (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bali (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bali (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bali (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bali (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bali (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bali (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bali (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bali (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bali (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bali (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bali (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bali (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bali (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bali (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bali (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bali (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bali (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bali (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bali (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Balikesir (Province of Turkey)": [
            {
                "Region Name": "Balikesir (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Balikesir (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Balikesir (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Balikesir (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Balikesir (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Balikesir (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Balikesir (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Balikesir (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Balikesir (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Balikesir (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Balikesir (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Balikesir (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Balikesir (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Balikesir (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Balikesir (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Balikesir (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Balikesir (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Balikesir (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Balikesir (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Balikesir (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Balikesir (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Balikesir (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Balkan (Province of Turkmenistan)": [
            {
                "Region Name": "Balkan (Province of Turkmenistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Balkan (Province of Turkmenistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Balkan (Province of Turkmenistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Balkan (Province of Turkmenistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Balkan (Province of Turkmenistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 59
            },
            {
                "Region Name": "Balkan (Province of Turkmenistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Balkan (Province of Turkmenistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Balkan (Province of Turkmenistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Balkan (Province of Turkmenistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Balkan (Province of Turkmenistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Balkan (Province of Turkmenistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Balkan (Province of Turkmenistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Balkan (Province of Turkmenistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Balkan (Province of Turkmenistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Balkan (Province of Turkmenistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Balkan (Province of Turkmenistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Balkan (Province of Turkmenistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Balkan (Province of Turkmenistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Balkan (Province of Turkmenistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Balkan (Province of Turkmenistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Balkan (Province of Turkmenistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Balkan (Province of Turkmenistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Balkh (Province of Afghanistan)": [
            {
                "Region Name": "Balkh (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Balkh (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Balkh (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Balkh (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Balkh (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Balkh (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Balkh (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Balkh (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Balkh (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Balkh (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Balkh (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Balkh (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Balkh (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Balkh (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Balkh (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Balkh (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balkh (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Balkh (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Balkh (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Balkh (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Balkh (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balkh (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Ballaugh (Parish District of Isle of Man)": [
            {
                "Region Name": "Ballaugh (Parish District of Isle of Man)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ballaugh (Parish District of Isle of Man)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ballaugh (Parish District of Isle of Man)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ballaugh (Parish District of Isle of Man)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ballaugh (Parish District of Isle of Man)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ballaugh (Parish District of Isle of Man)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ballaugh (Parish District of Isle of Man)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ballaugh (Parish District of Isle of Man)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ballaugh (Parish District of Isle of Man)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ballaugh (Parish District of Isle of Man)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ballaugh (Parish District of Isle of Man)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ballaugh (Parish District of Isle of Man)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ballaugh (Parish District of Isle of Man)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ballaugh (Parish District of Isle of Man)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ballaugh (Parish District of Isle of Man)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ballaugh (Parish District of Isle of Man)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ballaugh (Parish District of Isle of Man)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ballaugh (Parish District of Isle of Man)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ballaugh (Parish District of Isle of Man)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ballaugh (Parish District of Isle of Man)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ballaugh (Parish District of Isle of Man)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ballaugh (Parish District of Isle of Man)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Balochistan (Province of Pakistan)": [
            {
                "Region Name": "Balochistan (Province of Pakistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balochistan (Province of Pakistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Balochistan (Province of Pakistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Balochistan (Province of Pakistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Balochistan (Province of Pakistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balochistan (Province of Pakistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Balochistan (Province of Pakistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Balochistan (Province of Pakistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Balochistan (Province of Pakistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Balochistan (Province of Pakistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Balochistan (Province of Pakistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Balochistan (Province of Pakistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Balochistan (Province of Pakistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Balochistan (Province of Pakistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Balochistan (Province of Pakistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Balochistan (Province of Pakistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Balochistan (Province of Pakistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Balochistan (Province of Pakistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Balochistan (Province of Pakistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Balochistan (Province of Pakistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Balochistan (Province of Pakistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Balochistan (Province of Pakistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Balqa (Province of Jordan)": [
            {
                "Region Name": "Balqa (Province of Jordan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balqa (Province of Jordan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balqa (Province of Jordan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balqa (Province of Jordan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balqa (Province of Jordan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balqa (Province of Jordan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balqa (Province of Jordan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balqa (Province of Jordan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balqa (Province of Jordan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balqa (Province of Jordan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balqa (Province of Jordan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balqa (Province of Jordan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balqa (Province of Jordan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balqa (Province of Jordan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balqa (Province of Jordan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balqa (Province of Jordan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balqa (Province of Jordan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balqa (Province of Jordan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balqa (Province of Jordan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balqa (Province of Jordan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balqa (Province of Jordan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balqa (Province of Jordan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Balzers (Commune of Liechtenstein)": [
            {
                "Region Name": "Balzers (Commune of Liechtenstein)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balzers (Commune of Liechtenstein)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balzers (Commune of Liechtenstein)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balzers (Commune of Liechtenstein)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balzers (Commune of Liechtenstein)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balzers (Commune of Liechtenstein)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balzers (Commune of Liechtenstein)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balzers (Commune of Liechtenstein)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balzers (Commune of Liechtenstein)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balzers (Commune of Liechtenstein)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balzers (Commune of Liechtenstein)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balzers (Commune of Liechtenstein)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balzers (Commune of Liechtenstein)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balzers (Commune of Liechtenstein)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balzers (Commune of Liechtenstein)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balzers (Commune of Liechtenstein)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balzers (Commune of Liechtenstein)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balzers (Commune of Liechtenstein)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balzers (Commune of Liechtenstein)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balzers (Commune of Liechtenstein)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balzers (Commune of Liechtenstein)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Balzers (Commune of Liechtenstein)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bamako (District of Mali)": [
            {
                "Region Name": "Bamako (District of Mali)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bamako (District of Mali)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bamako (District of Mali)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamako (District of Mali)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamako (District of Mali)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bamako (District of Mali)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamako (District of Mali)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamako (District of Mali)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamako (District of Mali)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamako (District of Mali)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamako (District of Mali)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamako (District of Mali)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamako (District of Mali)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamako (District of Mali)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bamako (District of Mali)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamako (District of Mali)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamako (District of Mali)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamako (District of Mali)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamako (District of Mali)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamako (District of Mali)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamako (District of Mali)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamako (District of Mali)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bamingui-Bangoran (Prefecture of Central African Republic)": [
            {
                "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 88
            },
            {
                "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 70
            },
            {
                "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 66
            },
            {
                "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Bamingui-Bangoran (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 42
            }
        ],
        "Bamyan (Province of Afghanistan)": [
            {
                "Region Name": "Bamyan (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamyan (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamyan (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamyan (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamyan (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamyan (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamyan (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamyan (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamyan (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamyan (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamyan (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamyan (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamyan (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamyan (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamyan (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamyan (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamyan (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamyan (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamyan (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamyan (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamyan (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bamyan (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Banaadir (Region of Somalia)": [
            {
                "Region Name": "Banaadir (Region of Somalia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banaadir (Region of Somalia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banaadir (Region of Somalia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banaadir (Region of Somalia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banaadir (Region of Somalia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banaadir (Region of Somalia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banaadir (Region of Somalia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banaadir (Region of Somalia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banaadir (Region of Somalia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banaadir (Region of Somalia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banaadir (Region of Somalia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banaadir (Region of Somalia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banaadir (Region of Somalia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banaadir (Region of Somalia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banaadir (Region of Somalia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banaadir (Region of Somalia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banaadir (Region of Somalia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banaadir (Region of Somalia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banaadir (Region of Somalia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banaadir (Region of Somalia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banaadir (Region of Somalia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banaadir (Region of Somalia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bandraboua (Commune of Mayotte)": [
            {
                "Region Name": "Bandraboua (Commune of Mayotte)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandraboua (Commune of Mayotte)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandraboua (Commune of Mayotte)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandraboua (Commune of Mayotte)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandraboua (Commune of Mayotte)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandraboua (Commune of Mayotte)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandraboua (Commune of Mayotte)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandraboua (Commune of Mayotte)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandraboua (Commune of Mayotte)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandraboua (Commune of Mayotte)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandraboua (Commune of Mayotte)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandraboua (Commune of Mayotte)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandraboua (Commune of Mayotte)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandraboua (Commune of Mayotte)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandraboua (Commune of Mayotte)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandraboua (Commune of Mayotte)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandraboua (Commune of Mayotte)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandraboua (Commune of Mayotte)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandraboua (Commune of Mayotte)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandraboua (Commune of Mayotte)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandraboua (Commune of Mayotte)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandraboua (Commune of Mayotte)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bandrele (Commune of Mayotte)": [
            {
                "Region Name": "Bandrele (Commune of Mayotte)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandrele (Commune of Mayotte)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandrele (Commune of Mayotte)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandrele (Commune of Mayotte)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandrele (Commune of Mayotte)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandrele (Commune of Mayotte)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandrele (Commune of Mayotte)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandrele (Commune of Mayotte)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandrele (Commune of Mayotte)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandrele (Commune of Mayotte)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandrele (Commune of Mayotte)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandrele (Commune of Mayotte)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandrele (Commune of Mayotte)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandrele (Commune of Mayotte)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandrele (Commune of Mayotte)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandrele (Commune of Mayotte)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandrele (Commune of Mayotte)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandrele (Commune of Mayotte)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandrele (Commune of Mayotte)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandrele (Commune of Mayotte)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandrele (Commune of Mayotte)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bandrele (Commune of Mayotte)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bangka Belitung (Province of Indonesia)": [
            {
                "Region Name": "Bangka Belitung (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bangka Belitung (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bangka Belitung (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bangka Belitung (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bangka Belitung (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bangka Belitung (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bangka Belitung (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bangka Belitung (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bangka Belitung (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bangka Belitung (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bangka Belitung (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bangka Belitung (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bangka Belitung (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bangka Belitung (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bangka Belitung (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bangka Belitung (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bangka Belitung (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bangka Belitung (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bangka Belitung (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bangka Belitung (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bangka Belitung (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bangka Belitung (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Bangkok Metropolis (Province of Thailand)": [
            {
                "Region Name": "Bangkok Metropolis (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bangkok Metropolis (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bangkok Metropolis (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bangkok Metropolis (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bangkok Metropolis (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bangkok Metropolis (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bangkok Metropolis (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bangkok Metropolis (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bangkok Metropolis (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bangkok Metropolis (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bangkok Metropolis (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bangkok Metropolis (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bangkok Metropolis (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bangkok Metropolis (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bangkok Metropolis (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bangkok Metropolis (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bangkok Metropolis (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bangkok Metropolis (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bangkok Metropolis (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bangkok Metropolis (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bangkok Metropolis (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bangkok Metropolis (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bangui (Autonomous Commune of Central African Republic)": [
            {
                "Region Name": "Bangui (Autonomous Commune of Central African Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bangui (Autonomous Commune of Central African Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bangui (Autonomous Commune of Central African Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bangui (Autonomous Commune of Central African Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bangui (Autonomous Commune of Central African Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bangui (Autonomous Commune of Central African Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bangui (Autonomous Commune of Central African Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bangui (Autonomous Commune of Central African Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bangui (Autonomous Commune of Central African Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bangui (Autonomous Commune of Central African Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bangui (Autonomous Commune of Central African Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bangui (Autonomous Commune of Central African Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bangui (Autonomous Commune of Central African Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bangui (Autonomous Commune of Central African Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bangui (Autonomous Commune of Central African Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bangui (Autonomous Commune of Central African Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Bangui (Autonomous Commune of Central African Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bangui (Autonomous Commune of Central African Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bangui (Autonomous Commune of Central African Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bangui (Autonomous Commune of Central African Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bangui (Autonomous Commune of Central African Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bangui (Autonomous Commune of Central African Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Bani Suwayf (Governorate of Egypt)": [
            {
                "Region Name": "Bani Suwayf (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bani Suwayf (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bani Suwayf (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bani Suwayf (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bani Suwayf (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bani Suwayf (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bani Suwayf (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bani Suwayf (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bani Suwayf (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bani Suwayf (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bani Suwayf (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bani Suwayf (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bani Suwayf (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bani Suwayf (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bani Suwayf (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bani Suwayf (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bani Suwayf (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bani Suwayf (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bani Suwayf (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bani Suwayf (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bani Suwayf (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bani Suwayf (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Banjul (Independent City of Gambia)": [
            {
                "Region Name": "Banjul (Independent City of Gambia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banjul (Independent City of Gambia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banjul (Independent City of Gambia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banjul (Independent City of Gambia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banjul (Independent City of Gambia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banjul (Independent City of Gambia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banjul (Independent City of Gambia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banjul (Independent City of Gambia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banjul (Independent City of Gambia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banjul (Independent City of Gambia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banjul (Independent City of Gambia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banjul (Independent City of Gambia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banjul (Independent City of Gambia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banjul (Independent City of Gambia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banjul (Independent City of Gambia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banjul (Independent City of Gambia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banjul (Independent City of Gambia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banjul (Independent City of Gambia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banjul (Independent City of Gambia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banjul (Independent City of Gambia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banjul (Independent City of Gambia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banjul (Independent City of Gambia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Banskobystrick\xfd (Region of Slovakia)": [
            {
                "Region Name": "Banskobystrick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banskobystrick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banskobystrick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banskobystrick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banskobystrick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banskobystrick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Banskobystrick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banskobystrick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banskobystrick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banskobystrick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banskobystrick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Banskobystrick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banskobystrick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Banskobystrick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banskobystrick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banskobystrick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banskobystrick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Banskobystrick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banskobystrick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banskobystrick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banskobystrick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banskobystrick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "B\xe2nt\xe9ay M\xe9anchey (Province of Cambodia)": [
            {
                "Region Name": "B\xe2nt\xe9ay M\xe9anchey (Province of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "B\xe2nt\xe9ay M\xe9anchey (Province of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "B\xe2nt\xe9ay M\xe9anchey (Province of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "B\xe2nt\xe9ay M\xe9anchey (Province of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "B\xe2nt\xe9ay M\xe9anchey (Province of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "B\xe2nt\xe9ay M\xe9anchey (Province of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "B\xe2nt\xe9ay M\xe9anchey (Province of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "B\xe2nt\xe9ay M\xe9anchey (Province of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "B\xe2nt\xe9ay M\xe9anchey (Province of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "B\xe2nt\xe9ay M\xe9anchey (Province of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "B\xe2nt\xe9ay M\xe9anchey (Province of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "B\xe2nt\xe9ay M\xe9anchey (Province of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "B\xe2nt\xe9ay M\xe9anchey (Province of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "B\xe2nt\xe9ay M\xe9anchey (Province of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "B\xe2nt\xe9ay M\xe9anchey (Province of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "B\xe2nt\xe9ay M\xe9anchey (Province of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "B\xe2nt\xe9ay M\xe9anchey (Province of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "B\xe2nt\xe9ay M\xe9anchey (Province of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "B\xe2nt\xe9ay M\xe9anchey (Province of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xe2nt\xe9ay M\xe9anchey (Province of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "B\xe2nt\xe9ay M\xe9anchey (Province of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "B\xe2nt\xe9ay M\xe9anchey (Province of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Banten (Province of Indonesia)": [
            {
                "Region Name": "Banten (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Banten (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Banten (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Banten (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Banten (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Banten (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Banten (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Banten (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Banten (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banten (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Banten (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Banten (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banten (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Banten (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Banten (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Banten (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banten (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Banten (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banten (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banten (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banten (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Banten (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Bar (Municipality of Montenegro)": [
            {
                "Region Name": "Bar (Municipality of Montenegro)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bar (Municipality of Montenegro)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bar (Municipality of Montenegro)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bar (Municipality of Montenegro)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bar (Municipality of Montenegro)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bar (Municipality of Montenegro)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bar (Municipality of Montenegro)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bar (Municipality of Montenegro)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bar (Municipality of Montenegro)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bar (Municipality of Montenegro)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bar (Municipality of Montenegro)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bar (Municipality of Montenegro)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bar (Municipality of Montenegro)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bar (Municipality of Montenegro)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bar (Municipality of Montenegro)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bar (Municipality of Montenegro)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bar (Municipality of Montenegro)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bar (Municipality of Montenegro)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bar (Municipality of Montenegro)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bar (Municipality of Montenegro)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bar (Municipality of Montenegro)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bar (Municipality of Montenegro)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Barahona (Province of Dominican Republic)": [
            {
                "Region Name": "Barahona (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barahona (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barahona (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Barahona (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barahona (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barahona (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Barahona (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Barahona (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Barahona (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Barahona (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Barahona (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barahona (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Barahona (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Barahona (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Barahona (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barahona (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Barahona (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barahona (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Barahona (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Barahona (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Barahona (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Barahona (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Baranya (County of Hungary)": [
            {
                "Region Name": "Baranya (County of Hungary)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Baranya (County of Hungary)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Baranya (County of Hungary)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Baranya (County of Hungary)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Baranya (County of Hungary)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Baranya (County of Hungary)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Baranya (County of Hungary)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Baranya (County of Hungary)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Baranya (County of Hungary)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baranya (County of Hungary)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baranya (County of Hungary)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Baranya (County of Hungary)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baranya (County of Hungary)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baranya (County of Hungary)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baranya (County of Hungary)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baranya (County of Hungary)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Baranya (County of Hungary)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baranya (County of Hungary)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baranya (County of Hungary)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baranya (County of Hungary)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baranya (County of Hungary)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baranya (County of Hungary)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Barbuda (Dependency of Antigua and Barbuda)": [
            {
                "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barbuda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Barceloneta (Municipality of Puerto Rico)": [
            {
                "Region Name": "Barceloneta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barceloneta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barceloneta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barceloneta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barceloneta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barceloneta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barceloneta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barceloneta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barceloneta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barceloneta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barceloneta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barceloneta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barceloneta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barceloneta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barceloneta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barceloneta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barceloneta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barceloneta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barceloneta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barceloneta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barceloneta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barceloneta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Barh el Ghazel (Region of Chad)": [
            {
                "Region Name": "Barh el Ghazel (Region of Chad)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barh el Ghazel (Region of Chad)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Barh el Ghazel (Region of Chad)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Barh el Ghazel (Region of Chad)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Barh el Ghazel (Region of Chad)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Barh el Ghazel (Region of Chad)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Barh el Ghazel (Region of Chad)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Barh el Ghazel (Region of Chad)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Barh el Ghazel (Region of Chad)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Barh el Ghazel (Region of Chad)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barh el Ghazel (Region of Chad)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Barh el Ghazel (Region of Chad)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Barh el Ghazel (Region of Chad)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 80
            },
            {
                "Region Name": "Barh el Ghazel (Region of Chad)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Barh el Ghazel (Region of Chad)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 92
            },
            {
                "Region Name": "Barh el Ghazel (Region of Chad)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Barh el Ghazel (Region of Chad)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 182
            },
            {
                "Region Name": "Barh el Ghazel (Region of Chad)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Barh el Ghazel (Region of Chad)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 472
            },
            {
                "Region Name": "Barh el Ghazel (Region of Chad)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "Barh el Ghazel (Region of Chad)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 68
            },
            {
                "Region Name": "Barh el Ghazel (Region of Chad)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 35
            }
        ],
        "Bari (Region of Somalia)": [
            {
                "Region Name": "Bari (Region of Somalia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bari (Region of Somalia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bari (Region of Somalia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bari (Region of Somalia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bari (Region of Somalia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bari (Region of Somalia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bari (Region of Somalia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bari (Region of Somalia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bari (Region of Somalia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bari (Region of Somalia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bari (Region of Somalia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bari (Region of Somalia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bari (Region of Somalia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bari (Region of Somalia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bari (Region of Somalia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bari (Region of Somalia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bari (Region of Somalia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bari (Region of Somalia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bari (Region of Somalia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bari (Region of Somalia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bari (Region of Somalia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bari (Region of Somalia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Barima-Waini (Region of Guyana)": [
            {
                "Region Name": "Barima-Waini (Region of Guyana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barima-Waini (Region of Guyana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Barima-Waini (Region of Guyana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Barima-Waini (Region of Guyana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Barima-Waini (Region of Guyana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Barima-Waini (Region of Guyana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barima-Waini (Region of Guyana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barima-Waini (Region of Guyana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Barima-Waini (Region of Guyana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Barima-Waini (Region of Guyana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barima-Waini (Region of Guyana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Barima-Waini (Region of Guyana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Barima-Waini (Region of Guyana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Barima-Waini (Region of Guyana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Barima-Waini (Region of Guyana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Barima-Waini (Region of Guyana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Barima-Waini (Region of Guyana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Barima-Waini (Region of Guyana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Barima-Waini (Region of Guyana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Barima-Waini (Region of Guyana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Barima-Waini (Region of Guyana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Barima-Waini (Region of Guyana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Barinas (State of Venezuela)": [
            {
                "Region Name": "Barinas (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Barinas (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Barinas (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Barinas (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Barinas (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Barinas (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Barinas (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Barinas (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Barinas (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Barinas (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Barinas (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Barinas (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Barinas (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Barinas (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Barinas (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Barinas (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Barinas (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Barinas (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Barinas (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Barinas (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Barinas (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Barinas (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Baringo (County of Kenya)": [
            {
                "Region Name": "Baringo (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baringo (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Baringo (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Baringo (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baringo (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baringo (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baringo (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Baringo (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baringo (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Baringo (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Baringo (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Baringo (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Baringo (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Baringo (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Baringo (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baringo (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Baringo (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Baringo (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Baringo (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Baringo (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Baringo (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Baringo (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Barisal (Division of Bangladesh)": [
            {
                "Region Name": "Barisal (Division of Bangladesh)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barisal (Division of Bangladesh)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barisal (Division of Bangladesh)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barisal (Division of Bangladesh)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barisal (Division of Bangladesh)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barisal (Division of Bangladesh)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barisal (Division of Bangladesh)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barisal (Division of Bangladesh)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barisal (Division of Bangladesh)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barisal (Division of Bangladesh)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barisal (Division of Bangladesh)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barisal (Division of Bangladesh)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barisal (Division of Bangladesh)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barisal (Division of Bangladesh)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barisal (Division of Bangladesh)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barisal (Division of Bangladesh)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barisal (Division of Bangladesh)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barisal (Division of Bangladesh)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barisal (Division of Bangladesh)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barisal (Division of Bangladesh)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barisal (Division of Bangladesh)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barisal (Division of Bangladesh)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Barranquitas (Municipality of Puerto Rico)": [
            {
                "Region Name": "Barranquitas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barranquitas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barranquitas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barranquitas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barranquitas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barranquitas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barranquitas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barranquitas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barranquitas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barranquitas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barranquitas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barranquitas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barranquitas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barranquitas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barranquitas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barranquitas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barranquitas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barranquitas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barranquitas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barranquitas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barranquitas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barranquitas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Barrigada (Municipality of Guam)": [
            {
                "Region Name": "Barrigada (Municipality of Guam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barrigada (Municipality of Guam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barrigada (Municipality of Guam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barrigada (Municipality of Guam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barrigada (Municipality of Guam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barrigada (Municipality of Guam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barrigada (Municipality of Guam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barrigada (Municipality of Guam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barrigada (Municipality of Guam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barrigada (Municipality of Guam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barrigada (Municipality of Guam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barrigada (Municipality of Guam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barrigada (Municipality of Guam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barrigada (Municipality of Guam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barrigada (Municipality of Guam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barrigada (Municipality of Guam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barrigada (Municipality of Guam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barrigada (Municipality of Guam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barrigada (Municipality of Guam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barrigada (Municipality of Guam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barrigada (Municipality of Guam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Barrigada (Municipality of Guam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bart\u0131n (Province of Turkey)": [
            {
                "Region Name": "Bart\u0131n (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bart\u0131n (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bart\u0131n (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bart\u0131n (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bart\u0131n (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bart\u0131n (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bart\u0131n (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bart\u0131n (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bart\u0131n (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bart\u0131n (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bart\u0131n (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bart\u0131n (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bart\u0131n (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bart\u0131n (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bart\u0131n (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bart\u0131n (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bart\u0131n (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bart\u0131n (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bart\u0131n (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bart\u0131n (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bart\u0131n (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bart\u0131n (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bas-Sassandra (District of C\xf4te d'Ivoire)": [
            {
                "Region Name": "Bas-Sassandra (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bas-Sassandra (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bas-Sassandra (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bas-Sassandra (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bas-Sassandra (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bas-Sassandra (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bas-Sassandra (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bas-Sassandra (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bas-Sassandra (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bas-Sassandra (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bas-Sassandra (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bas-Sassandra (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bas-Sassandra (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bas-Sassandra (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bas-Sassandra (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bas-Sassandra (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bas-Sassandra (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bas-Sassandra (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bas-Sassandra (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bas-Sassandra (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bas-Sassandra (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bas-Sassandra (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bas-Uele (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bas-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Basarabeasca (District of Moldova)": [
            {
                "Region Name": "Basarabeasca (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basarabeasca (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basarabeasca (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basarabeasca (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Basarabeasca (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basarabeasca (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basarabeasca (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Basarabeasca (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basarabeasca (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basarabeasca (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basarabeasca (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basarabeasca (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basarabeasca (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Basarabeasca (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basarabeasca (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Basarabeasca (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Basarabeasca (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basarabeasca (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basarabeasca (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basarabeasca (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basarabeasca (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basarabeasca (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Basel-Landschaft (Canton of Switzerland)": [
            {
                "Region Name": "Basel-Landschaft (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Landschaft (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Landschaft (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Landschaft (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Landschaft (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Landschaft (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Landschaft (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Landschaft (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Landschaft (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Landschaft (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Landschaft (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Landschaft (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Landschaft (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Landschaft (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Landschaft (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Landschaft (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Landschaft (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Landschaft (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Landschaft (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Landschaft (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Landschaft (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Landschaft (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Basel-Stadt (Canton of Switzerland)": [
            {
                "Region Name": "Basel-Stadt (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Stadt (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Stadt (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Stadt (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Stadt (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Stadt (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Stadt (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Stadt (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Stadt (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Stadt (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Stadt (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Stadt (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Stadt (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Stadt (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Stadt (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Stadt (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Stadt (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Stadt (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Stadt (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Stadt (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Stadt (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basel-Stadt (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bashkortostan (Republic of Russia)": [
            {
                "Region Name": "Bashkortostan (Republic of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bashkortostan (Republic of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bashkortostan (Republic of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bashkortostan (Republic of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bashkortostan (Republic of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bashkortostan (Republic of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bashkortostan (Republic of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bashkortostan (Republic of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bashkortostan (Republic of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bashkortostan (Republic of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bashkortostan (Republic of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bashkortostan (Republic of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bashkortostan (Republic of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bashkortostan (Republic of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bashkortostan (Republic of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bashkortostan (Republic of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bashkortostan (Republic of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bashkortostan (Republic of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bashkortostan (Republic of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bashkortostan (Republic of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bashkortostan (Republic of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bashkortostan (Republic of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Basilan (Province of Philippines)": [
            {
                "Region Name": "Basilan (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basilan (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basilan (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basilan (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basilan (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basilan (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basilan (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basilan (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basilan (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basilan (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basilan (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basilan (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basilan (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basilan (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basilan (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basilan (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basilan (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basilan (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basilan (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basilan (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basilan (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basilan (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Basilicata (Region of Italy)": [
            {
                "Region Name": "Basilicata (Region of Italy)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Basilicata (Region of Italy)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Basilicata (Region of Italy)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Basilicata (Region of Italy)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Basilicata (Region of Italy)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Basilicata (Region of Italy)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Basilicata (Region of Italy)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Basilicata (Region of Italy)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Basilicata (Region of Italy)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Basilicata (Region of Italy)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Basilicata (Region of Italy)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Basilicata (Region of Italy)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Basilicata (Region of Italy)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Basilicata (Region of Italy)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Basilicata (Region of Italy)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Basilicata (Region of Italy)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Basilicata (Region of Italy)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Basilicata (Region of Italy)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Basilicata (Region of Italy)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Basilicata (Region of Italy)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Basilicata (Region of Italy)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Basilicata (Region of Italy)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Basse-Kotto (Prefecture of Central African Republic)": [
            {
                "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Basse-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Basse-Terre (District of Guadeloupe)": [
            {
                "Region Name": "Basse-Terre (District of Guadeloupe)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basse-Terre (District of Guadeloupe)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basse-Terre (District of Guadeloupe)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basse-Terre (District of Guadeloupe)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basse-Terre (District of Guadeloupe)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basse-Terre (District of Guadeloupe)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basse-Terre (District of Guadeloupe)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basse-Terre (District of Guadeloupe)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basse-Terre (District of Guadeloupe)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basse-Terre (District of Guadeloupe)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basse-Terre (District of Guadeloupe)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basse-Terre (District of Guadeloupe)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basse-Terre (District of Guadeloupe)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basse-Terre (District of Guadeloupe)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basse-Terre (District of Guadeloupe)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basse-Terre (District of Guadeloupe)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basse-Terre (District of Guadeloupe)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basse-Terre (District of Guadeloupe)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basse-Terre (District of Guadeloupe)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basse-Terre (District of Guadeloupe)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basse-Terre (District of Guadeloupe)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Basse-Terre (District of Guadeloupe)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bataan (Province of Philippines)": [
            {
                "Region Name": "Bataan (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bataan (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bataan (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bataan (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bataan (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bataan (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bataan (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bataan (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bataan (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bataan (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bataan (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bataan (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bataan (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bataan (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bataan (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bataan (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bataan (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bataan (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bataan (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bataan (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bataan (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bataan (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Batanes (Province of Philippines)": [
            {
                "Region Name": "Batanes (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batanes (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batanes (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batanes (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batanes (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batanes (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batanes (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batanes (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batanes (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batanes (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batanes (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batanes (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batanes (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batanes (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batanes (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batanes (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batanes (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batanes (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batanes (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batanes (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batanes (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batanes (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Batangas (Province of Philippines)": [
            {
                "Region Name": "Batangas (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batangas (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Batangas (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Batangas (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Batangas (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Batangas (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Batangas (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batangas (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Batangas (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Batangas (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batangas (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Batangas (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Batangas (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batangas (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batangas (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Batangas (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batangas (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batangas (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Batangas (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Batangas (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batangas (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batangas (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Batd\xe2mb\xe2ng (Province of Cambodia)": [
            {
                "Region Name": "Batd\xe2mb\xe2ng (Province of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Batd\xe2mb\xe2ng (Province of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Batd\xe2mb\xe2ng (Province of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Batd\xe2mb\xe2ng (Province of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Batd\xe2mb\xe2ng (Province of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Batd\xe2mb\xe2ng (Province of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Batd\xe2mb\xe2ng (Province of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Batd\xe2mb\xe2ng (Province of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Batd\xe2mb\xe2ng (Province of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Batd\xe2mb\xe2ng (Province of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Batd\xe2mb\xe2ng (Province of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Batd\xe2mb\xe2ng (Province of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Batd\xe2mb\xe2ng (Province of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Batd\xe2mb\xe2ng (Province of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Batd\xe2mb\xe2ng (Province of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Batd\xe2mb\xe2ng (Province of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Batd\xe2mb\xe2ng (Province of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Batd\xe2mb\xe2ng (Province of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Batd\xe2mb\xe2ng (Province of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Batd\xe2mb\xe2ng (Province of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Batd\xe2mb\xe2ng (Province of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Batd\xe2mb\xe2ng (Province of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Batha (Region of Chad)": [
            {
                "Region Name": "Batha (Region of Chad)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 61
            },
            {
                "Region Name": "Batha (Region of Chad)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 235
            },
            {
                "Region Name": "Batha (Region of Chad)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 78
            },
            {
                "Region Name": "Batha (Region of Chad)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 452
            },
            {
                "Region Name": "Batha (Region of Chad)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 253
            },
            {
                "Region Name": "Batha (Region of Chad)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 170
            },
            {
                "Region Name": "Batha (Region of Chad)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 133
            },
            {
                "Region Name": "Batha (Region of Chad)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Batha (Region of Chad)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 487
            },
            {
                "Region Name": "Batha (Region of Chad)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 202
            },
            {
                "Region Name": "Batha (Region of Chad)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 147
            },
            {
                "Region Name": "Batha (Region of Chad)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 65
            },
            {
                "Region Name": "Batha (Region of Chad)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 266
            },
            {
                "Region Name": "Batha (Region of Chad)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 100
            },
            {
                "Region Name": "Batha (Region of Chad)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 248
            },
            {
                "Region Name": "Batha (Region of Chad)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 70
            },
            {
                "Region Name": "Batha (Region of Chad)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 258
            },
            {
                "Region Name": "Batha (Region of Chad)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 59
            },
            {
                "Region Name": "Batha (Region of Chad)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 434
            },
            {
                "Region Name": "Batha (Region of Chad)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Batha (Region of Chad)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 155
            },
            {
                "Region Name": "Batha (Region of Chad)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 46
            }
        ],
        "Batken (Province of Kyrgyzstan)": [
            {
                "Region Name": "Batken (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batken (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Batken (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batken (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Batken (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Batken (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batken (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batken (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batken (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batken (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batken (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batken (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batken (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batken (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Batken (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batken (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Batken (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Batken (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batken (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batken (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batken (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Batken (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Batman (Province of Turkey)": [
            {
                "Region Name": "Batman (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Batman (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Batman (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Batman (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Batman (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Batman (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Batman (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Batman (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Batman (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Batman (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Batman (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Batman (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Batman (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Batman (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Batman (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Batman (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Batman (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Batman (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Batman (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Batman (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Batman (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Batman (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Batna (Province of Algeria)": [
            {
                "Region Name": "Batna (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Batna (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Batna (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Batna (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Batna (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Batna (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Batna (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Batna (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Batna (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Batna (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Batna (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Batna (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Batna (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Batna (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Batna (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Batna (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batna (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batna (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Batna (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Batna (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batna (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batna (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Batticaloa (District of Sri Lanka)": [
            {
                "Region Name": "Batticaloa (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Batticaloa (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Batticaloa (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Batticaloa (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Batticaloa (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Batticaloa (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Batticaloa (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Batticaloa (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Batticaloa (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Batticaloa (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Batticaloa (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Batticaloa (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Batticaloa (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Batticaloa (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Batticaloa (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batticaloa (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Batticaloa (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Batticaloa (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Batticaloa (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batticaloa (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batticaloa (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Batticaloa (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Baucau (District of Timor-Leste)": [
            {
                "Region Name": "Baucau (District of Timor-Leste)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Baucau (District of Timor-Leste)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baucau (District of Timor-Leste)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baucau (District of Timor-Leste)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Baucau (District of Timor-Leste)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Baucau (District of Timor-Leste)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baucau (District of Timor-Leste)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Baucau (District of Timor-Leste)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Baucau (District of Timor-Leste)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baucau (District of Timor-Leste)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baucau (District of Timor-Leste)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baucau (District of Timor-Leste)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baucau (District of Timor-Leste)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baucau (District of Timor-Leste)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baucau (District of Timor-Leste)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baucau (District of Timor-Leste)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baucau (District of Timor-Leste)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baucau (District of Timor-Leste)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Baucau (District of Timor-Leste)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Baucau (District of Timor-Leste)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baucau (District of Timor-Leste)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Baucau (District of Timor-Leste)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Bauchi (State of Nigeria)": [
            {
                "Region Name": "Bauchi (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Bauchi (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Bauchi (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Bauchi (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Bauchi (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Bauchi (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Bauchi (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Bauchi (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Bauchi (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Bauchi (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Bauchi (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Bauchi (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Bauchi (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Bauchi (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Bauchi (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Bauchi (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Bauchi (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Bauchi (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Bauchi (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Bauchi (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Bauchi (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Bauchi (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Bay (Region of Somalia)": [
            {
                "Region Name": "Bay (Region of Somalia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay (Region of Somalia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay (Region of Somalia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bay (Region of Somalia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bay (Region of Somalia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bay (Region of Somalia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bay (Region of Somalia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay (Region of Somalia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay (Region of Somalia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bay (Region of Somalia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bay (Region of Somalia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay (Region of Somalia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bay (Region of Somalia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay (Region of Somalia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay (Region of Somalia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay (Region of Somalia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay (Region of Somalia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay (Region of Somalia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay (Region of Somalia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bay (Region of Somalia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay (Region of Somalia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bay (Region of Somalia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Bay of Plenty (Region of New Zealand)": [
            {
                "Region Name": "Bay of Plenty (Region of New Zealand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay of Plenty (Region of New Zealand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay of Plenty (Region of New Zealand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay of Plenty (Region of New Zealand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay of Plenty (Region of New Zealand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay of Plenty (Region of New Zealand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay of Plenty (Region of New Zealand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay of Plenty (Region of New Zealand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay of Plenty (Region of New Zealand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay of Plenty (Region of New Zealand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay of Plenty (Region of New Zealand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bay of Plenty (Region of New Zealand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay of Plenty (Region of New Zealand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay of Plenty (Region of New Zealand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay of Plenty (Region of New Zealand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay of Plenty (Region of New Zealand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay of Plenty (Region of New Zealand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay of Plenty (Region of New Zealand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay of Plenty (Region of New Zealand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay of Plenty (Region of New Zealand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay of Plenty (Region of New Zealand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bay of Plenty (Region of New Zealand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bayam\u221A\u2265n (Municipality of Puerto Rico)": [
            {
                "Region Name": "Bayam\u221A\u2265n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayam\u221A\u2265n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayam\u221A\u2265n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayam\u221A\u2265n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayam\u221A\u2265n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayam\u221A\u2265n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayam\u221A\u2265n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayam\u221A\u2265n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayam\u221A\u2265n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayam\u221A\u2265n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayam\u221A\u2265n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayam\u221A\u2265n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayam\u221A\u2265n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayam\u221A\u2265n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayam\u221A\u2265n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayam\u221A\u2265n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayam\u221A\u2265n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayam\u221A\u2265n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayam\u221A\u2265n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayam\u221A\u2265n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayam\u221A\u2265n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayam\u221A\u2265n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bayan-\xd6lgiy (Province of Mongolia)": [
            {
                "Region Name": "Bayan-\xd6lgiy (Province of Mongolia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayan-\xd6lgiy (Province of Mongolia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bayan-\xd6lgiy (Province of Mongolia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayan-\xd6lgiy (Province of Mongolia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayan-\xd6lgiy (Province of Mongolia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayan-\xd6lgiy (Province of Mongolia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bayan-\xd6lgiy (Province of Mongolia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bayan-\xd6lgiy (Province of Mongolia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayan-\xd6lgiy (Province of Mongolia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayan-\xd6lgiy (Province of Mongolia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bayan-\xd6lgiy (Province of Mongolia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayan-\xd6lgiy (Province of Mongolia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayan-\xd6lgiy (Province of Mongolia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bayan-\xd6lgiy (Province of Mongolia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayan-\xd6lgiy (Province of Mongolia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bayan-\xd6lgiy (Province of Mongolia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayan-\xd6lgiy (Province of Mongolia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bayan-\xd6lgiy (Province of Mongolia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayan-\xd6lgiy (Province of Mongolia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bayan-\xd6lgiy (Province of Mongolia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayan-\xd6lgiy (Province of Mongolia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bayan-\xd6lgiy (Province of Mongolia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Bayanhongor (Province of Mongolia)": [
            {
                "Region Name": "Bayanhongor (Province of Mongolia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayanhongor (Province of Mongolia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayanhongor (Province of Mongolia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayanhongor (Province of Mongolia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayanhongor (Province of Mongolia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayanhongor (Province of Mongolia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bayanhongor (Province of Mongolia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayanhongor (Province of Mongolia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bayanhongor (Province of Mongolia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayanhongor (Province of Mongolia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayanhongor (Province of Mongolia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bayanhongor (Province of Mongolia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayanhongor (Province of Mongolia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bayanhongor (Province of Mongolia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayanhongor (Province of Mongolia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayanhongor (Province of Mongolia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayanhongor (Province of Mongolia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayanhongor (Province of Mongolia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bayanhongor (Province of Mongolia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayanhongor (Province of Mongolia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayanhongor (Province of Mongolia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayanhongor (Province of Mongolia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Bayburt (Province of Turkey)": [
            {
                "Region Name": "Bayburt (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayburt (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayburt (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayburt (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayburt (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayburt (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayburt (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayburt (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayburt (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayburt (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayburt (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayburt (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayburt (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayburt (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayburt (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayburt (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayburt (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayburt (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayburt (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayburt (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayburt (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bayburt (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bayelsa (State of Nigeria)": [
            {
                "Region Name": "Bayelsa (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayelsa (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bayelsa (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayelsa (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayelsa (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayelsa (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayelsa (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayelsa (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayelsa (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayelsa (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bayelsa (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayelsa (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayelsa (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bayelsa (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bayelsa (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayelsa (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bayelsa (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayelsa (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bayelsa (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayelsa (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bayelsa (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bayelsa (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Bayern (Free State of Germany)": [
            {
                "Region Name": "Bayern (Free State of Germany)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayern (Free State of Germany)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayern (Free State of Germany)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bayern (Free State of Germany)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayern (Free State of Germany)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayern (Free State of Germany)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bayern (Free State of Germany)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayern (Free State of Germany)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayern (Free State of Germany)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayern (Free State of Germany)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bayern (Free State of Germany)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayern (Free State of Germany)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bayern (Free State of Germany)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bayern (Free State of Germany)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bayern (Free State of Germany)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayern (Free State of Germany)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayern (Free State of Germany)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayern (Free State of Germany)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayern (Free State of Germany)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayern (Free State of Germany)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bayern (Free State of Germany)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bayern (Free State of Germany)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Beau Vallon (District of Seychelles)": [
            {
                "Region Name": "Beau Vallon (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beau Vallon (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beau Vallon (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beau Vallon (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beau Vallon (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beau Vallon (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beau Vallon (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beau Vallon (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beau Vallon (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beau Vallon (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beau Vallon (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beau Vallon (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beau Vallon (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beau Vallon (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beau Vallon (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beau Vallon (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beau Vallon (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beau Vallon (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beau Vallon (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beau Vallon (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beau Vallon (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beau Vallon (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "B\xe9char (Province of Algeria)": [
            {
                "Region Name": "B\xe9char (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9char (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9char (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9char (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9char (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9char (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9char (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9char (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9char (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9char (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9char (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9char (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9char (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9char (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9char (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9char (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9char (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9char (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9char (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9char (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9char (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9char (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Beijing (Municipality of China)": [
            {
                "Region Name": "Beijing (Municipality of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Beijing (Municipality of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beijing (Municipality of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beijing (Municipality of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Beijing (Municipality of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beijing (Municipality of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Beijing (Municipality of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beijing (Municipality of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Beijing (Municipality of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beijing (Municipality of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Beijing (Municipality of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Beijing (Municipality of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Beijing (Municipality of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beijing (Municipality of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beijing (Municipality of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Beijing (Municipality of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Beijing (Municipality of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Beijing (Municipality of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beijing (Municipality of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beijing (Municipality of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Beijing (Municipality of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beijing (Municipality of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Beirut (Governorate of Lebanon)": [
            {
                "Region Name": "Beirut (Governorate of Lebanon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beirut (Governorate of Lebanon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beirut (Governorate of Lebanon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beirut (Governorate of Lebanon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beirut (Governorate of Lebanon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beirut (Governorate of Lebanon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beirut (Governorate of Lebanon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beirut (Governorate of Lebanon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beirut (Governorate of Lebanon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beirut (Governorate of Lebanon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beirut (Governorate of Lebanon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beirut (Governorate of Lebanon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beirut (Governorate of Lebanon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beirut (Governorate of Lebanon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beirut (Governorate of Lebanon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beirut (Governorate of Lebanon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beirut (Governorate of Lebanon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beirut (Governorate of Lebanon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beirut (Governorate of Lebanon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beirut (Governorate of Lebanon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beirut (Governorate of Lebanon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beirut (Governorate of Lebanon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Beja (District of Portugal)": [
            {
                "Region Name": "Beja (District of Portugal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Beja (District of Portugal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Beja (District of Portugal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Beja (District of Portugal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Beja (District of Portugal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Beja (District of Portugal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Beja (District of Portugal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Beja (District of Portugal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Beja (District of Portugal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Beja (District of Portugal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Beja (District of Portugal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Beja (District of Portugal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Beja (District of Portugal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Beja (District of Portugal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Beja (District of Portugal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Beja (District of Portugal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Beja (District of Portugal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Beja (District of Portugal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Beja (District of Portugal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Beja (District of Portugal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Beja (District of Portugal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Beja (District of Portugal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 54
            }
        ],
        "B\xe9ja (Governorate of Tunisia)": [
            {
                "Region Name": "B\xe9ja (Governorate of Tunisia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9ja (Governorate of Tunisia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9ja (Governorate of Tunisia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xe9ja (Governorate of Tunisia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9ja (Governorate of Tunisia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9ja (Governorate of Tunisia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xe9ja (Governorate of Tunisia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xe9ja (Governorate of Tunisia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xe9ja (Governorate of Tunisia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9ja (Governorate of Tunisia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xe9ja (Governorate of Tunisia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "B\xe9ja (Governorate of Tunisia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xe9ja (Governorate of Tunisia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xe9ja (Governorate of Tunisia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9ja (Governorate of Tunisia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9ja (Governorate of Tunisia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xe9ja (Governorate of Tunisia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xe9ja (Governorate of Tunisia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "B\xe9ja (Governorate of Tunisia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "B\xe9ja (Governorate of Tunisia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xe9ja (Governorate of Tunisia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "B\xe9ja (Governorate of Tunisia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "B\xe9ja\xefa (Province of Algeria)": [
            {
                "Region Name": "B\xe9ja\xefa (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xe9ja\xefa (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "B\xe9ja\xefa (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xe9ja\xefa (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "B\xe9ja\xefa (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "B\xe9ja\xefa (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "B\xe9ja\xefa (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "B\xe9ja\xefa (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "B\xe9ja\xefa (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "B\xe9ja\xefa (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "B\xe9ja\xefa (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "B\xe9ja\xefa (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "B\xe9ja\xefa (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xe9ja\xefa (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xe9ja\xefa (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "B\xe9ja\xefa (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "B\xe9ja\xefa (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9ja\xefa (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "B\xe9ja\xefa (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "B\xe9ja\xefa (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 97
            },
            {
                "Region Name": "B\xe9ja\xefa (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "B\xe9ja\xefa (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 38
            }
        ],
        "Bekaa (Governorate of Lebanon)": [
            {
                "Region Name": "Bekaa (Governorate of Lebanon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bekaa (Governorate of Lebanon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bekaa (Governorate of Lebanon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bekaa (Governorate of Lebanon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bekaa (Governorate of Lebanon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bekaa (Governorate of Lebanon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bekaa (Governorate of Lebanon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bekaa (Governorate of Lebanon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bekaa (Governorate of Lebanon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bekaa (Governorate of Lebanon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bekaa (Governorate of Lebanon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bekaa (Governorate of Lebanon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bekaa (Governorate of Lebanon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bekaa (Governorate of Lebanon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bekaa (Governorate of Lebanon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bekaa (Governorate of Lebanon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bekaa (Governorate of Lebanon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bekaa (Governorate of Lebanon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bekaa (Governorate of Lebanon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bekaa (Governorate of Lebanon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bekaa (Governorate of Lebanon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bekaa (Governorate of Lebanon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "B\xe9k\xe9s (County of Hungary)": [
            {
                "Region Name": "B\xe9k\xe9s (County of Hungary)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "B\xe9k\xe9s (County of Hungary)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "B\xe9k\xe9s (County of Hungary)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xe9k\xe9s (County of Hungary)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "B\xe9k\xe9s (County of Hungary)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xe9k\xe9s (County of Hungary)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xe9k\xe9s (County of Hungary)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "B\xe9k\xe9s (County of Hungary)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "B\xe9k\xe9s (County of Hungary)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "B\xe9k\xe9s (County of Hungary)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "B\xe9k\xe9s (County of Hungary)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xe9k\xe9s (County of Hungary)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xe9k\xe9s (County of Hungary)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "B\xe9k\xe9s (County of Hungary)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9k\xe9s (County of Hungary)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9k\xe9s (County of Hungary)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xe9k\xe9s (County of Hungary)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9k\xe9s (County of Hungary)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9k\xe9s (County of Hungary)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9k\xe9s (County of Hungary)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xe9k\xe9s (County of Hungary)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xe9k\xe9s (County of Hungary)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bel Air (District of Seychelles)": [
            {
                "Region Name": "Bel Air (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bel Air (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bel Air (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bel Air (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bel Air (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bel Air (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bel Air (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bel Air (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bel Air (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bel Air (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bel Air (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bel Air (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bel Air (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bel Air (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bel Air (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bel Air (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bel Air (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bel Air (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bel Air (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bel Air (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bel Air (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bel Air (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Belait (District of Brunei)": [
            {
                "Region Name": "Belait (District of Brunei)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Belait (District of Brunei)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Belait (District of Brunei)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belait (District of Brunei)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belait (District of Brunei)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belait (District of Brunei)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belait (District of Brunei)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belait (District of Brunei)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Belait (District of Brunei)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belait (District of Brunei)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belait (District of Brunei)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belait (District of Brunei)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belait (District of Brunei)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Belait (District of Brunei)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Belait (District of Brunei)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belait (District of Brunei)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belait (District of Brunei)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belait (District of Brunei)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Belait (District of Brunei)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belait (District of Brunei)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belait (District of Brunei)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belait (District of Brunei)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Belgorod (Region of Russia)": [
            {
                "Region Name": "Belgorod (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Belgorod (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Belgorod (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Belgorod (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Belgorod (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Belgorod (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Belgorod (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Belgorod (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Belgorod (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Belgorod (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Belgorod (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Belgorod (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Belgorod (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Belgorod (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Belgorod (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Belgorod (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Belgorod (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Belgorod (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Belgorod (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Belgorod (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Belgorod (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belgorod (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Belize (District of Belize)": [
            {
                "Region Name": "Belize (District of Belize)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Belize (District of Belize)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Belize (District of Belize)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Belize (District of Belize)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Belize (District of Belize)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Belize (District of Belize)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Belize (District of Belize)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Belize (District of Belize)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Belize (District of Belize)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Belize (District of Belize)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Belize (District of Belize)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belize (District of Belize)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Belize (District of Belize)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Belize (District of Belize)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Belize (District of Belize)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Belize (District of Belize)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Belize (District of Belize)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Belize (District of Belize)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Belize (District of Belize)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Belize (District of Belize)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Belize (District of Belize)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Belize (District of Belize)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Belombre (District of Seychelles)": [
            {
                "Region Name": "Belombre (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belombre (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belombre (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belombre (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belombre (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belombre (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belombre (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belombre (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belombre (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belombre (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belombre (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belombre (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belombre (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belombre (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belombre (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belombre (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belombre (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belombre (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belombre (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belombre (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belombre (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Belombre (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ben Arous (Tunis Sud) (Governorate of Tunisia)": [
            {
                "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ben Arous (Tunis Sud) (Governorate of Tunisia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "B\u1EBFn Tre (Province of Vietnam)": [
            {
                "Region Name": "B\u1EBFn Tre (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EBFn Tre (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EBFn Tre (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EBFn Tre (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EBFn Tre (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EBFn Tre (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EBFn Tre (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EBFn Tre (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EBFn Tre (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EBFn Tre (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "B\u1EBFn Tre (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EBFn Tre (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EBFn Tre (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "B\u1EBFn Tre (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "B\u1EBFn Tre (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EBFn Tre (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EBFn Tre (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EBFn Tre (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EBFn Tre (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EBFn Tre (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EBFn Tre (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u1EBFn Tre (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bender (City of Moldova)": [
            {
                "Region Name": "Bender (City of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bender (City of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bender (City of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bender (City of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bender (City of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bender (City of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bender (City of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bender (City of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bender (City of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bender (City of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bender (City of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bender (City of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bender (City of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bender (City of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bender (City of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bender (City of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bender (City of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bender (City of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bender (City of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bender (City of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bender (City of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bender (City of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Benghazi (District of Libya)": [
            {
                "Region Name": "Benghazi (District of Libya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Benghazi (District of Libya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Benghazi (District of Libya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Benghazi (District of Libya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Benghazi (District of Libya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Benghazi (District of Libya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Benghazi (District of Libya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Benghazi (District of Libya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Benghazi (District of Libya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Benghazi (District of Libya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Benghazi (District of Libya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Benghazi (District of Libya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Benghazi (District of Libya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Benghazi (District of Libya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Benghazi (District of Libya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Benghazi (District of Libya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Benghazi (District of Libya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Benghazi (District of Libya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Benghazi (District of Libya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Benghazi (District of Libya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Benghazi (District of Libya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Benghazi (District of Libya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bengkulu (Province of Indonesia)": [
            {
                "Region Name": "Bengkulu (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bengkulu (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bengkulu (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bengkulu (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bengkulu (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bengkulu (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bengkulu (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bengkulu (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bengkulu (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bengkulu (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bengkulu (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bengkulu (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bengkulu (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bengkulu (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bengkulu (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bengkulu (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bengkulu (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bengkulu (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bengkulu (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bengkulu (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bengkulu (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bengkulu (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Bengo (Province of Angola)": [
            {
                "Region Name": "Bengo (Province of Angola)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bengo (Province of Angola)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bengo (Province of Angola)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bengo (Province of Angola)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bengo (Province of Angola)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bengo (Province of Angola)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bengo (Province of Angola)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bengo (Province of Angola)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bengo (Province of Angola)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bengo (Province of Angola)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bengo (Province of Angola)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bengo (Province of Angola)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bengo (Province of Angola)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bengo (Province of Angola)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bengo (Province of Angola)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bengo (Province of Angola)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bengo (Province of Angola)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bengo (Province of Angola)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bengo (Province of Angola)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bengo (Province of Angola)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bengo (Province of Angola)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bengo (Province of Angola)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Benguela (Province of Angola)": [
            {
                "Region Name": "Benguela (Province of Angola)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Benguela (Province of Angola)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Benguela (Province of Angola)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Benguela (Province of Angola)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Benguela (Province of Angola)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Benguela (Province of Angola)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Benguela (Province of Angola)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Benguela (Province of Angola)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Benguela (Province of Angola)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Benguela (Province of Angola)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Benguela (Province of Angola)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Benguela (Province of Angola)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Benguela (Province of Angola)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Benguela (Province of Angola)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Benguela (Province of Angola)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Benguela (Province of Angola)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Benguela (Province of Angola)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Benguela (Province of Angola)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Benguela (Province of Angola)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Benguela (Province of Angola)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Benguela (Province of Angola)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Benguela (Province of Angola)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Benguet (Province of Philippines)": [
            {
                "Region Name": "Benguet (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Benguet (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Benguet (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Benguet (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Benguet (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Benguet (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Benguet (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Benguet (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Benguet (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Benguet (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Benguet (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Benguet (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Benguet (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Benguet (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Benguet (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Benguet (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Benguet (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Benguet (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Benguet (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Benguet (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Benguet (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Benguet (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Beni (Department of Bolivia)": [
            {
                "Region Name": "Beni (Department of Bolivia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Beni (Department of Bolivia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Beni (Department of Bolivia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Beni (Department of Bolivia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Beni (Department of Bolivia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Beni (Department of Bolivia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Beni (Department of Bolivia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Beni (Department of Bolivia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Beni (Department of Bolivia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Beni (Department of Bolivia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Beni (Department of Bolivia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Beni (Department of Bolivia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Beni (Department of Bolivia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Beni (Department of Bolivia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Beni (Department of Bolivia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Beni (Department of Bolivia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Beni (Department of Bolivia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Beni (Department of Bolivia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Beni (Department of Bolivia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Beni (Department of Bolivia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Beni (Department of Bolivia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Beni (Department of Bolivia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 38
            }
        ],
        "Benshangul-Gumaz (State of Ethiopia)": [
            {
                "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Benshangul-Gumaz (State of Ethiopia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "Benue (State of Nigeria)": [
            {
                "Region Name": "Benue (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Benue (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Benue (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Benue (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Benue (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Benue (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Benue (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Benue (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Benue (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Benue (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Benue (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Benue (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Benue (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Benue (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Benue (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Benue (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Benue (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Benue (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Benue (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Benue (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Benue (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Benue (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Berane (Municipality of Montenegro)": [
            {
                "Region Name": "Berane (Municipality of Montenegro)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berane (Municipality of Montenegro)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berane (Municipality of Montenegro)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berane (Municipality of Montenegro)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berane (Municipality of Montenegro)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berane (Municipality of Montenegro)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Berane (Municipality of Montenegro)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berane (Municipality of Montenegro)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berane (Municipality of Montenegro)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berane (Municipality of Montenegro)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berane (Municipality of Montenegro)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berane (Municipality of Montenegro)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berane (Municipality of Montenegro)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berane (Municipality of Montenegro)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berane (Municipality of Montenegro)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berane (Municipality of Montenegro)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berane (Municipality of Montenegro)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berane (Municipality of Montenegro)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berane (Municipality of Montenegro)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Berane (Municipality of Montenegro)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berane (Municipality of Montenegro)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berane (Municipality of Montenegro)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Berat (County of Albania)": [
            {
                "Region Name": "Berat (County of Albania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berat (County of Albania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berat (County of Albania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berat (County of Albania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berat (County of Albania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berat (County of Albania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Berat (County of Albania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Berat (County of Albania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berat (County of Albania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berat (County of Albania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Berat (County of Albania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berat (County of Albania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berat (County of Albania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berat (County of Albania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berat (County of Albania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berat (County of Albania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Berat (County of Albania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berat (County of Albania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berat (County of Albania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berat (County of Albania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berat (County of Albania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Berat (County of Albania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Berea (District of Lesotho)": [
            {
                "Region Name": "Berea (District of Lesotho)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Berea (District of Lesotho)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Berea (District of Lesotho)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Berea (District of Lesotho)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Berea (District of Lesotho)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Berea (District of Lesotho)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Berea (District of Lesotho)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berea (District of Lesotho)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berea (District of Lesotho)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Berea (District of Lesotho)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berea (District of Lesotho)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Berea (District of Lesotho)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Berea (District of Lesotho)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berea (District of Lesotho)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berea (District of Lesotho)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berea (District of Lesotho)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Berea (District of Lesotho)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Berea (District of Lesotho)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Berea (District of Lesotho)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berea (District of Lesotho)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Berea (District of Lesotho)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Berea (District of Lesotho)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Berlin (State of Germany)": [
            {
                "Region Name": "Berlin (State of Germany)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berlin (State of Germany)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berlin (State of Germany)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berlin (State of Germany)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berlin (State of Germany)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berlin (State of Germany)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berlin (State of Germany)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berlin (State of Germany)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berlin (State of Germany)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berlin (State of Germany)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berlin (State of Germany)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berlin (State of Germany)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berlin (State of Germany)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berlin (State of Germany)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berlin (State of Germany)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berlin (State of Germany)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berlin (State of Germany)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berlin (State of Germany)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berlin (State of Germany)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berlin (State of Germany)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berlin (State of Germany)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berlin (State of Germany)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bern (Canton of Switzerland)": [
            {
                "Region Name": "Bern (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bern (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bern (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bern (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bern (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bern (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bern (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bern (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bern (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bern (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bern (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bern (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bern (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bern (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bern (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bern (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bern (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bern (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bern (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bern (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bern (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bern (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Berovo (Municipality of North Macedonia)": [
            {
                "Region Name": "Berovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Berovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Berovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Berovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Berry Islands (District of Bahamas)": [
            {
                "Region Name": "Berry Islands (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berry Islands (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berry Islands (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berry Islands (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berry Islands (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berry Islands (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berry Islands (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berry Islands (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berry Islands (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berry Islands (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berry Islands (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berry Islands (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berry Islands (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berry Islands (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berry Islands (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berry Islands (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berry Islands (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berry Islands (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berry Islands (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berry Islands (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berry Islands (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Berry Islands (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "B\u0192\xc9l\u2248\xa3i (City of Moldova)": [
            {
                "Region Name": "B\u0192\xc9l\u2248\xa3i (City of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u0192\xc9l\u2248\xa3i (City of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u0192\xc9l\u2248\xa3i (City of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u0192\xc9l\u2248\xa3i (City of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u0192\xc9l\u2248\xa3i (City of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u0192\xc9l\u2248\xa3i (City of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u0192\xc9l\u2248\xa3i (City of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u0192\xc9l\u2248\xa3i (City of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u0192\xc9l\u2248\xa3i (City of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u0192\xc9l\u2248\xa3i (City of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u0192\xc9l\u2248\xa3i (City of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u0192\xc9l\u2248\xa3i (City of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u0192\xc9l\u2248\xa3i (City of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u0192\xc9l\u2248\xa3i (City of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u0192\xc9l\u2248\xa3i (City of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u0192\xc9l\u2248\xa3i (City of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u0192\xc9l\u2248\xa3i (City of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u0192\xc9l\u2248\xa3i (City of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u0192\xc9l\u2248\xa3i (City of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u0192\xc9l\u2248\xa3i (City of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u0192\xc9l\u2248\xa3i (City of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\u0192\xc9l\u2248\xa3i (City of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bi\xe9 (Province of Angola)": [
            {
                "Region Name": "Bi\xe9 (Province of Angola)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bi\xe9 (Province of Angola)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bi\xe9 (Province of Angola)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bi\xe9 (Province of Angola)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Bi\xe9 (Province of Angola)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bi\xe9 (Province of Angola)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bi\xe9 (Province of Angola)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bi\xe9 (Province of Angola)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bi\xe9 (Province of Angola)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bi\xe9 (Province of Angola)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bi\xe9 (Province of Angola)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bi\xe9 (Province of Angola)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bi\xe9 (Province of Angola)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bi\xe9 (Province of Angola)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bi\xe9 (Province of Angola)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bi\xe9 (Province of Angola)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bi\xe9 (Province of Angola)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bi\xe9 (Province of Angola)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bi\xe9 (Province of Angola)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bi\xe9 (Province of Angola)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bi\xe9 (Province of Angola)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bi\xe9 (Province of Angola)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Bihar (State of India)": [
            {
                "Region Name": "Bihar (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bihar (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bihar (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bihar (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bihar (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bihar (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Bihar (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Bihar (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Bihar (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Bihar (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bihar (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bihar (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Bihar (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Bihar (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bihar (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Bihar (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bihar (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Bihar (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bihar (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Bihar (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bihar (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bihar (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Bihor (County of Romania)": [
            {
                "Region Name": "Bihor (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bihor (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bihor (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bihor (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bihor (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bihor (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bihor (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bihor (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bihor (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bihor (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bihor (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bihor (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bihor (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bihor (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bihor (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bihor (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bihor (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bihor (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bihor (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bihor (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bihor (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bihor (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Bijelo Polje (Municipality of Montenegro)": [
            {
                "Region Name": "Bijelo Polje (Municipality of Montenegro)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bijelo Polje (Municipality of Montenegro)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bijelo Polje (Municipality of Montenegro)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bijelo Polje (Municipality of Montenegro)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bijelo Polje (Municipality of Montenegro)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bijelo Polje (Municipality of Montenegro)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bijelo Polje (Municipality of Montenegro)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bijelo Polje (Municipality of Montenegro)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bijelo Polje (Municipality of Montenegro)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bijelo Polje (Municipality of Montenegro)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bijelo Polje (Municipality of Montenegro)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bijelo Polje (Municipality of Montenegro)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bijelo Polje (Municipality of Montenegro)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bijelo Polje (Municipality of Montenegro)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bijelo Polje (Municipality of Montenegro)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bijelo Polje (Municipality of Montenegro)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bijelo Polje (Municipality of Montenegro)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bijelo Polje (Municipality of Montenegro)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bijelo Polje (Municipality of Montenegro)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bijelo Polje (Municipality of Montenegro)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bijelo Polje (Municipality of Montenegro)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bijelo Polje (Municipality of Montenegro)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bilecik (Province of Turkey)": [
            {
                "Region Name": "Bilecik (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bilecik (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bilecik (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bilecik (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bilecik (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bilecik (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bilecik (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bilecik (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bilecik (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bilecik (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bilecik (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bilecik (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bilecik (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bilecik (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bilecik (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bilecik (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Bilecik (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bilecik (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bilecik (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bilecik (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bilecik (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bilecik (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Biliran (Province of Philippines)": [
            {
                "Region Name": "Biliran (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biliran (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biliran (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biliran (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biliran (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biliran (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biliran (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biliran (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biliran (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biliran (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biliran (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biliran (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biliran (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biliran (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biliran (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biliran (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biliran (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biliran (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biliran (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biliran (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biliran (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biliran (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Biminis (District of Bahamas)": [
            {
                "Region Name": "Biminis (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biminis (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biminis (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biminis (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biminis (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biminis (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biminis (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biminis (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biminis (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biminis (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biminis (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biminis (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biminis (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biminis (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biminis (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biminis (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biminis (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biminis (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biminis (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biminis (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biminis (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biminis (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bing\xf6l (Province of Turkey)": [
            {
                "Region Name": "Bing\xf6l (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bing\xf6l (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bing\xf6l (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bing\xf6l (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bing\xf6l (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bing\xf6l (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bing\xf6l (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bing\xf6l (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bing\xf6l (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bing\xf6l (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bing\xf6l (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bing\xf6l (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bing\xf6l (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bing\xf6l (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Bing\xf6l (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bing\xf6l (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bing\xf6l (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Bing\xf6l (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bing\xf6l (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bing\xf6l (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Bing\xf6l (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bing\xf6l (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "B\xecnh \u0110\u1ECBnh (Province of Vietnam)": [
            {
                "Region Name": "B\xecnh \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xecnh \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xecnh \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "B\xecnh \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "B\xecnh \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xecnh \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "B\xecnh \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xecnh \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xecnh \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xecnh \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xecnh \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "B\xecnh \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xecnh \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xecnh \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xecnh \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xecnh \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xecnh \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xecnh \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "B\xecnh \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xecnh \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xecnh \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xecnh \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "B\xecnh D\u01B0\u01A1ng (Province of Vietnam)": [
            {
                "Region Name": "B\xecnh D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xecnh D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xecnh D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "B\xecnh D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xecnh D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xecnh D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xecnh D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xecnh D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xecnh D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xecnh D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "B\xecnh D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xecnh D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xecnh D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xecnh D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xecnh D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xecnh D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xecnh D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xecnh D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xecnh D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "B\xecnh D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "B\xecnh D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "B\xecnh D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "B\xecnh Ph\u01B0\u1EDBc (Province of Vietnam)": [
            {
                "Region Name": "B\xecnh Ph\u01B0\u1EDBc (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "B\xecnh Ph\u01B0\u1EDBc (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "B\xecnh Ph\u01B0\u1EDBc (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xecnh Ph\u01B0\u1EDBc (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "B\xecnh Ph\u01B0\u1EDBc (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "B\xecnh Ph\u01B0\u1EDBc (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "B\xecnh Ph\u01B0\u1EDBc (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "B\xecnh Ph\u01B0\u1EDBc (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xecnh Ph\u01B0\u1EDBc (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xecnh Ph\u01B0\u1EDBc (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xecnh Ph\u01B0\u1EDBc (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xecnh Ph\u01B0\u1EDBc (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xecnh Ph\u01B0\u1EDBc (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xecnh Ph\u01B0\u1EDBc (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "B\xecnh Ph\u01B0\u1EDBc (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xecnh Ph\u01B0\u1EDBc (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "B\xecnh Ph\u01B0\u1EDBc (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xecnh Ph\u01B0\u1EDBc (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "B\xecnh Ph\u01B0\u1EDBc (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "B\xecnh Ph\u01B0\u1EDBc (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xecnh Ph\u01B0\u1EDBc (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "B\xecnh Ph\u01B0\u1EDBc (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "B\xecnh Thu\u1EADn (Province of Vietnam)": [
            {
                "Region Name": "B\xecnh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "B\xecnh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "B\xecnh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "B\xecnh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "B\xecnh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xecnh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "B\xecnh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xecnh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "B\xecnh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xecnh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "B\xecnh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xecnh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "B\xecnh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "B\xecnh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "B\xecnh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xecnh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "B\xecnh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "B\xecnh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "B\xecnh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "B\xecnh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "B\xecnh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "B\xecnh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Biob\xedo (Region of Chile)": [
            {
                "Region Name": "Biob\xedo (Region of Chile)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Biob\xedo (Region of Chile)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Biob\xedo (Region of Chile)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Biob\xedo (Region of Chile)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Biob\xedo (Region of Chile)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Biob\xedo (Region of Chile)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Biob\xedo (Region of Chile)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Biob\xedo (Region of Chile)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Biob\xedo (Region of Chile)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Biob\xedo (Region of Chile)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Biob\xedo (Region of Chile)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Biob\xedo (Region of Chile)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Biob\xedo (Region of Chile)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Biob\xedo (Region of Chile)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Biob\xedo (Region of Chile)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Biob\xedo (Region of Chile)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Biob\xedo (Region of Chile)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Biob\xedo (Region of Chile)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Biob\xedo (Region of Chile)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Biob\xedo (Region of Chile)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Biob\xedo (Region of Chile)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 87
            },
            {
                "Region Name": "Biob\xedo (Region of Chile)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Bioko Norte (Province of Equatorial Guinea)": [
            {
                "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bioko Norte (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Bioko Sur (Province of Equatorial Guinea)": [
            {
                "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bioko Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Biombo (Region of Guinea-Bissau)": [
            {
                "Region Name": "Biombo (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Biombo (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Biombo (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biombo (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Biombo (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Biombo (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Biombo (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Biombo (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Biombo (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biombo (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Biombo (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Biombo (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Biombo (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Biombo (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Biombo (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biombo (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Biombo (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Biombo (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biombo (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Biombo (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Biombo (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Biombo (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bi\u015Fkek (City of Kyrgyzstan)": [
            {
                "Region Name": "Bi\u015Fkek (City of Kyrgyzstan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bi\u015Fkek (City of Kyrgyzstan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bi\u015Fkek (City of Kyrgyzstan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bi\u015Fkek (City of Kyrgyzstan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bi\u015Fkek (City of Kyrgyzstan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bi\u015Fkek (City of Kyrgyzstan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bi\u015Fkek (City of Kyrgyzstan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bi\u015Fkek (City of Kyrgyzstan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bi\u015Fkek (City of Kyrgyzstan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bi\u015Fkek (City of Kyrgyzstan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bi\u015Fkek (City of Kyrgyzstan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bi\u015Fkek (City of Kyrgyzstan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bi\u015Fkek (City of Kyrgyzstan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bi\u015Fkek (City of Kyrgyzstan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bi\u015Fkek (City of Kyrgyzstan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bi\u015Fkek (City of Kyrgyzstan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bi\u015Fkek (City of Kyrgyzstan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bi\u015Fkek (City of Kyrgyzstan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bi\u015Fkek (City of Kyrgyzstan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bi\u015Fkek (City of Kyrgyzstan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bi\u015Fkek (City of Kyrgyzstan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bi\u015Fkek (City of Kyrgyzstan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Biskra (Province of Algeria)": [
            {
                "Region Name": "Biskra (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biskra (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biskra (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biskra (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biskra (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biskra (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biskra (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biskra (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Biskra (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biskra (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biskra (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Biskra (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Biskra (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Biskra (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biskra (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Biskra (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biskra (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biskra (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Biskra (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biskra (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biskra (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Biskra (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bissau (Autonomous Sector of Guinea-Bissau)": [
            {
                "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bissau (Autonomous Sector of Guinea-Bissau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bistri\u021Ba-N\u0103s\u0103ud (County of Romania)": [
            {
                "Region Name": "Bistri\u021Ba-N\u0103s\u0103ud (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bistri\u021Ba-N\u0103s\u0103ud (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bistri\u021Ba-N\u0103s\u0103ud (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bistri\u021Ba-N\u0103s\u0103ud (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bistri\u021Ba-N\u0103s\u0103ud (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bistri\u021Ba-N\u0103s\u0103ud (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bistri\u021Ba-N\u0103s\u0103ud (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bistri\u021Ba-N\u0103s\u0103ud (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bistri\u021Ba-N\u0103s\u0103ud (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bistri\u021Ba-N\u0103s\u0103ud (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bistri\u021Ba-N\u0103s\u0103ud (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bistri\u021Ba-N\u0103s\u0103ud (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bistri\u021Ba-N\u0103s\u0103ud (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bistri\u021Ba-N\u0103s\u0103ud (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bistri\u021Ba-N\u0103s\u0103ud (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bistri\u021Ba-N\u0103s\u0103ud (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bistri\u021Ba-N\u0103s\u0103ud (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bistri\u021Ba-N\u0103s\u0103ud (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bistri\u021Ba-N\u0103s\u0103ud (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bistri\u021Ba-N\u0103s\u0103ud (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bistri\u021Ba-N\u0103s\u0103ud (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bistri\u021Ba-N\u0103s\u0103ud (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bitlis (Province of Turkey)": [
            {
                "Region Name": "Bitlis (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bitlis (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bitlis (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bitlis (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bitlis (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bitlis (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bitlis (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bitlis (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bitlis (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bitlis (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bitlis (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bitlis (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bitlis (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bitlis (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bitlis (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bitlis (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bitlis (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bitlis (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bitlis (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bitlis (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bitlis (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bitlis (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bitola (Municipality of North Macedonia)": [
            {
                "Region Name": "Bitola (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bitola (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bitola (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bitola (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bitola (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bitola (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Bitola (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bitola (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bitola (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bitola (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bitola (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bitola (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Bitola (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bitola (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bitola (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bitola (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bitola (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bitola (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bitola (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bitola (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bitola (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bitola (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bizerte (Governorate of Tunisia)": [
            {
                "Region Name": "Bizerte (Governorate of Tunisia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bizerte (Governorate of Tunisia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bizerte (Governorate of Tunisia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bizerte (Governorate of Tunisia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bizerte (Governorate of Tunisia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bizerte (Governorate of Tunisia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bizerte (Governorate of Tunisia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bizerte (Governorate of Tunisia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bizerte (Governorate of Tunisia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bizerte (Governorate of Tunisia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bizerte (Governorate of Tunisia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bizerte (Governorate of Tunisia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Bizerte (Governorate of Tunisia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bizerte (Governorate of Tunisia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bizerte (Governorate of Tunisia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bizerte (Governorate of Tunisia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Bizerte (Governorate of Tunisia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bizerte (Governorate of Tunisia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bizerte (Governorate of Tunisia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bizerte (Governorate of Tunisia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bizerte (Governorate of Tunisia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bizerte (Governorate of Tunisia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Bjelovarska-Bilogorska (County of Croatia)": [
            {
                "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bjelovarska-Bilogorska (County of Croatia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Black Point (District of Bahamas)": [
            {
                "Region Name": "Black Point (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black Point (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black Point (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black Point (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black Point (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black Point (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black Point (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black Point (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black Point (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black Point (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black Point (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black Point (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black Point (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black Point (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black Point (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black Point (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black Point (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black Point (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black Point (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black Point (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black Point (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black Point (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Black River (District of Mauritius)": [
            {
                "Region Name": "Black River (District of Mauritius)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black River (District of Mauritius)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black River (District of Mauritius)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black River (District of Mauritius)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black River (District of Mauritius)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Black River (District of Mauritius)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black River (District of Mauritius)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black River (District of Mauritius)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black River (District of Mauritius)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black River (District of Mauritius)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black River (District of Mauritius)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black River (District of Mauritius)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black River (District of Mauritius)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black River (District of Mauritius)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black River (District of Mauritius)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black River (District of Mauritius)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black River (District of Mauritius)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black River (District of Mauritius)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black River (District of Mauritius)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black River (District of Mauritius)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black River (District of Mauritius)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Black River (District of Mauritius)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Blagoevgrad (Province of Bulgaria)": [
            {
                "Region Name": "Blagoevgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blagoevgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blagoevgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blagoevgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blagoevgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blagoevgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Blagoevgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Blagoevgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blagoevgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blagoevgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blagoevgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blagoevgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blagoevgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blagoevgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blagoevgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blagoevgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Blagoevgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blagoevgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Blagoevgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blagoevgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blagoevgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blagoevgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Blantyre (District of Malawi)": [
            {
                "Region Name": "Blantyre (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Blantyre (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Blantyre (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Blantyre (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Blantyre (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Blantyre (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Blantyre (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Blantyre (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Blantyre (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Blantyre (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Blantyre (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Blantyre (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Blantyre (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Blantyre (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Blantyre (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Blantyre (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Blantyre (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Blantyre (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Blantyre (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Blantyre (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Blantyre (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Blantyre (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Blekinge (County of Sweden)": [
            {
                "Region Name": "Blekinge (County of Sweden)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blekinge (County of Sweden)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blekinge (County of Sweden)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blekinge (County of Sweden)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blekinge (County of Sweden)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blekinge (County of Sweden)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blekinge (County of Sweden)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blekinge (County of Sweden)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blekinge (County of Sweden)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blekinge (County of Sweden)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blekinge (County of Sweden)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blekinge (County of Sweden)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blekinge (County of Sweden)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blekinge (County of Sweden)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blekinge (County of Sweden)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blekinge (County of Sweden)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blekinge (County of Sweden)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blekinge (County of Sweden)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blekinge (County of Sweden)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blekinge (County of Sweden)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blekinge (County of Sweden)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blekinge (County of Sweden)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Blida (Province of Algeria)": [
            {
                "Region Name": "Blida (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Blida (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Blida (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Blida (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Blida (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Blida (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Blida (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Blida (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Blida (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Blida (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Blida (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Blida (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Blida (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Blida (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Blida (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Blida (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Blida (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blida (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Blida (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Blida (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Blida (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Blida (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 16
            }
        ],
        "Blowing Point (District of Anguilla)": [
            {
                "Region Name": "Blowing Point (District of Anguilla)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blowing Point (District of Anguilla)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blowing Point (District of Anguilla)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blowing Point (District of Anguilla)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blowing Point (District of Anguilla)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blowing Point (District of Anguilla)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blowing Point (District of Anguilla)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blowing Point (District of Anguilla)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blowing Point (District of Anguilla)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blowing Point (District of Anguilla)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blowing Point (District of Anguilla)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blowing Point (District of Anguilla)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blowing Point (District of Anguilla)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blowing Point (District of Anguilla)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blowing Point (District of Anguilla)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blowing Point (District of Anguilla)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blowing Point (District of Anguilla)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blowing Point (District of Anguilla)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blowing Point (District of Anguilla)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blowing Point (District of Anguilla)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blowing Point (District of Anguilla)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Blowing Point (District of Anguilla)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Blue Nile (State of Sudan)": [
            {
                "Region Name": "Blue Nile (State of Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Blue Nile (State of Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Blue Nile (State of Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Blue Nile (State of Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Blue Nile (State of Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Blue Nile (State of Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Blue Nile (State of Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Blue Nile (State of Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Blue Nile (State of Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Blue Nile (State of Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Blue Nile (State of Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Blue Nile (State of Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Blue Nile (State of Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Blue Nile (State of Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Blue Nile (State of Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Blue Nile (State of Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Blue Nile (State of Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Blue Nile (State of Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Blue Nile (State of Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Blue Nile (State of Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Blue Nile (State of Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Blue Nile (State of Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Boa Vista (County of Cabo Verde)": [
            {
                "Region Name": "Boa Vista (County of Cabo Verde)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boa Vista (County of Cabo Verde)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boa Vista (County of Cabo Verde)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boa Vista (County of Cabo Verde)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boa Vista (County of Cabo Verde)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boa Vista (County of Cabo Verde)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boa Vista (County of Cabo Verde)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boa Vista (County of Cabo Verde)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boa Vista (County of Cabo Verde)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boa Vista (County of Cabo Verde)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boa Vista (County of Cabo Verde)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boa Vista (County of Cabo Verde)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boa Vista (County of Cabo Verde)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boa Vista (County of Cabo Verde)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boa Vista (County of Cabo Verde)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boa Vista (County of Cabo Verde)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boa Vista (County of Cabo Verde)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boa Vista (County of Cabo Verde)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boa Vista (County of Cabo Verde)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boa Vista (County of Cabo Verde)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boa Vista (County of Cabo Verde)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boa Vista (County of Cabo Verde)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Boaco (Department of Nicaragua)": [
            {
                "Region Name": "Boaco (Department of Nicaragua)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Boaco (Department of Nicaragua)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Boaco (Department of Nicaragua)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Boaco (Department of Nicaragua)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Boaco (Department of Nicaragua)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Boaco (Department of Nicaragua)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Boaco (Department of Nicaragua)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Boaco (Department of Nicaragua)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Boaco (Department of Nicaragua)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Boaco (Department of Nicaragua)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Boaco (Department of Nicaragua)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Boaco (Department of Nicaragua)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Boaco (Department of Nicaragua)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Boaco (Department of Nicaragua)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Boaco (Department of Nicaragua)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Boaco (Department of Nicaragua)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Boaco (Department of Nicaragua)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Boaco (Department of Nicaragua)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Boaco (Department of Nicaragua)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Boaco (Department of Nicaragua)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Boaco (Department of Nicaragua)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Boaco (Department of Nicaragua)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Bobonaro (District of Timor-Leste)": [
            {
                "Region Name": "Bobonaro (District of Timor-Leste)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bobonaro (District of Timor-Leste)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bobonaro (District of Timor-Leste)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bobonaro (District of Timor-Leste)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bobonaro (District of Timor-Leste)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bobonaro (District of Timor-Leste)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bobonaro (District of Timor-Leste)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bobonaro (District of Timor-Leste)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bobonaro (District of Timor-Leste)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bobonaro (District of Timor-Leste)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bobonaro (District of Timor-Leste)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bobonaro (District of Timor-Leste)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bobonaro (District of Timor-Leste)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bobonaro (District of Timor-Leste)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bobonaro (District of Timor-Leste)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bobonaro (District of Timor-Leste)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bobonaro (District of Timor-Leste)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bobonaro (District of Timor-Leste)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bobonaro (District of Timor-Leste)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bobonaro (District of Timor-Leste)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bobonaro (District of Timor-Leste)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bobonaro (District of Timor-Leste)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bocas del Toro (Province of Panama)": [
            {
                "Region Name": "Bocas del Toro (Province of Panama)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bocas del Toro (Province of Panama)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bocas del Toro (Province of Panama)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bocas del Toro (Province of Panama)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bocas del Toro (Province of Panama)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bocas del Toro (Province of Panama)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bocas del Toro (Province of Panama)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bocas del Toro (Province of Panama)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bocas del Toro (Province of Panama)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bocas del Toro (Province of Panama)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bocas del Toro (Province of Panama)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bocas del Toro (Province of Panama)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bocas del Toro (Province of Panama)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bocas del Toro (Province of Panama)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bocas del Toro (Province of Panama)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bocas del Toro (Province of Panama)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bocas del Toro (Province of Panama)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bocas del Toro (Province of Panama)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bocas del Toro (Province of Panama)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bocas del Toro (Province of Panama)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bocas del Toro (Province of Panama)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bocas del Toro (Province of Panama)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bodden Town (District of Cayman Islands)": [
            {
                "Region Name": "Bodden Town (District of Cayman Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bodden Town (District of Cayman Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bodden Town (District of Cayman Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bodden Town (District of Cayman Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bodden Town (District of Cayman Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bodden Town (District of Cayman Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bodden Town (District of Cayman Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bodden Town (District of Cayman Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bodden Town (District of Cayman Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bodden Town (District of Cayman Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bodden Town (District of Cayman Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bodden Town (District of Cayman Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bodden Town (District of Cayman Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bodden Town (District of Cayman Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bodden Town (District of Cayman Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bodden Town (District of Cayman Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bodden Town (District of Cayman Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bodden Town (District of Cayman Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bodden Town (District of Cayman Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bodden Town (District of Cayman Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bodden Town (District of Cayman Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bodden Town (District of Cayman Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Boe (District of Nauru)": [
            {
                "Region Name": "Boe (District of Nauru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boe (District of Nauru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boe (District of Nauru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boe (District of Nauru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boe (District of Nauru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boe (District of Nauru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boe (District of Nauru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boe (District of Nauru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boe (District of Nauru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boe (District of Nauru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boe (District of Nauru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boe (District of Nauru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boe (District of Nauru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boe (District of Nauru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boe (District of Nauru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boe (District of Nauru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boe (District of Nauru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boe (District of Nauru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boe (District of Nauru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boe (District of Nauru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boe (District of Nauru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boe (District of Nauru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bogdanci (Municipality of North Macedonia)": [
            {
                "Region Name": "Bogdanci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogdanci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogdanci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogdanci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogdanci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogdanci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogdanci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogdanci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogdanci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogdanci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogdanci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bogdanci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogdanci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogdanci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogdanci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bogdanci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogdanci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bogdanci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogdanci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogdanci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogdanci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogdanci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Bogot\xe1 D.C. (Capital District of Colombia)": [
            {
                "Region Name": "Bogot\xe1 D.C. (Capital District of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Bogot\xe1 D.C. (Capital District of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bogot\xe1 D.C. (Capital District of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bogot\xe1 D.C. (Capital District of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogot\xe1 D.C. (Capital District of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogot\xe1 D.C. (Capital District of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogot\xe1 D.C. (Capital District of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogot\xe1 D.C. (Capital District of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bogot\xe1 D.C. (Capital District of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogot\xe1 D.C. (Capital District of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogot\xe1 D.C. (Capital District of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogot\xe1 D.C. (Capital District of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogot\xe1 D.C. (Capital District of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogot\xe1 D.C. (Capital District of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogot\xe1 D.C. (Capital District of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogot\xe1 D.C. (Capital District of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogot\xe1 D.C. (Capital District of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogot\xe1 D.C. (Capital District of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogot\xe1 D.C. (Capital District of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogot\xe1 D.C. (Capital District of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogot\xe1 D.C. (Capital District of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogot\xe1 D.C. (Capital District of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bogovinje (Municipality of North Macedonia)": [
            {
                "Region Name": "Bogovinje (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogovinje (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogovinje (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogovinje (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogovinje (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogovinje (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogovinje (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogovinje (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogovinje (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogovinje (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bogovinje (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogovinje (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogovinje (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogovinje (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogovinje (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogovinje (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogovinje (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogovinje (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogovinje (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogovinje (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogovinje (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bogovinje (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bohol (Province of Philippines)": [
            {
                "Region Name": "Bohol (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bohol (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bohol (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bohol (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bohol (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bohol (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bohol (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bohol (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bohol (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bohol (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bohol (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bohol (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bohol (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bohol (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bohol (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bohol (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bohol (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bohol (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bohol (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bohol (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bohol (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bohol (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Bok\xe9 (Region of Guinea)": [
            {
                "Region Name": "Bok\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bok\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bok\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bok\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bok\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bok\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bok\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bok\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bok\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bok\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bok\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bok\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bok\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bok\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bok\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bok\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bok\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bok\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bok\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bok\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bok\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bok\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Bokeo (Province of Laos)": [
            {
                "Region Name": "Bokeo (Province of Laos)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bokeo (Province of Laos)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bokeo (Province of Laos)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bokeo (Province of Laos)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bokeo (Province of Laos)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bokeo (Province of Laos)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bokeo (Province of Laos)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bokeo (Province of Laos)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bokeo (Province of Laos)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bokeo (Province of Laos)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bokeo (Province of Laos)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bokeo (Province of Laos)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bokeo (Province of Laos)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bokeo (Province of Laos)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bokeo (Province of Laos)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bokeo (Province of Laos)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bokeo (Province of Laos)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bokeo (Province of Laos)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bokeo (Province of Laos)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bokeo (Province of Laos)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bokeo (Province of Laos)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bokeo (Province of Laos)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Bolama (Region of Guinea-Bissau)": [
            {
                "Region Name": "Bolama (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bolama (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bolama (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bolama (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bolama (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bolama (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bolama (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Bolama (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bolama (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bolama (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bolama (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bolama (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bolama (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Bolama (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bolama (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bolama (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bolama (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bolama (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Bolama (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bolama (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bolama (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Bolama (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Bolikhamxai (Province of Laos)": [
            {
                "Region Name": "Bolikhamxai (Province of Laos)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bolikhamxai (Province of Laos)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bolikhamxai (Province of Laos)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bolikhamxai (Province of Laos)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bolikhamxai (Province of Laos)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bolikhamxai (Province of Laos)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bolikhamxai (Province of Laos)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bolikhamxai (Province of Laos)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bolikhamxai (Province of Laos)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bolikhamxai (Province of Laos)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bolikhamxai (Province of Laos)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bolikhamxai (Province of Laos)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bolikhamxai (Province of Laos)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bolikhamxai (Province of Laos)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bolikhamxai (Province of Laos)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bolikhamxai (Province of Laos)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bolikhamxai (Province of Laos)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bolikhamxai (Province of Laos)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bolikhamxai (Province of Laos)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bolikhamxai (Province of Laos)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bolikhamxai (Province of Laos)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bolikhamxai (Province of Laos)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Bol\xedvar (Department of Colombia)": [
            {
                "Region Name": "Bol\xedvar (Department of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bol\xedvar (Department of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bol\xedvar (Department of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bol\xedvar (Department of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bol\xedvar (Department of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bol\xedvar (Department of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bol\xedvar (Department of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bol\xedvar (Department of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bol\xedvar (Department of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bol\xedvar (Department of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bol\xedvar (Department of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bol\xedvar (Department of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bol\xedvar (Department of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bol\xedvar (Department of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bol\xedvar (Department of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bol\xedvar (Department of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Bol\xedvar (Department of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bol\xedvar (Department of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bol\xedvar (Department of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bol\xedvar (Department of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bol\xedvar (Department of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bol\xedvar (Department of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Bolivar (Province of Ecuador)": [
            {
                "Region Name": "Bolivar (Province of Ecuador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bolivar (Province of Ecuador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bolivar (Province of Ecuador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bolivar (Province of Ecuador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bolivar (Province of Ecuador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolivar (Province of Ecuador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolivar (Province of Ecuador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolivar (Province of Ecuador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bolivar (Province of Ecuador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolivar (Province of Ecuador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolivar (Province of Ecuador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolivar (Province of Ecuador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolivar (Province of Ecuador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolivar (Province of Ecuador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bolivar (Province of Ecuador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolivar (Province of Ecuador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bolivar (Province of Ecuador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bolivar (Province of Ecuador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bolivar (Province of Ecuador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bolivar (Province of Ecuador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolivar (Province of Ecuador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bolivar (Province of Ecuador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Bol\xedvar (State of Venezuela)": [
            {
                "Region Name": "Bol\xedvar (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bol\xedvar (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bol\xedvar (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bol\xedvar (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bol\xedvar (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bol\xedvar (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bol\xedvar (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bol\xedvar (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bol\xedvar (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bol\xedvar (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bol\xedvar (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bol\xedvar (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bol\xedvar (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bol\xedvar (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bol\xedvar (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bol\xedvar (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bol\xedvar (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bol\xedvar (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bol\xedvar (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bol\xedvar (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bol\xedvar (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bol\xedvar (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Bolu (Province of Turkey)": [
            {
                "Region Name": "Bolu (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolu (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolu (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolu (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolu (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolu (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolu (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolu (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolu (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolu (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolu (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolu (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolu (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolu (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolu (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolu (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bolu (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bolu (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolu (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bolu (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolu (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bolu (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Bomet (County of Kenya)": [
            {
                "Region Name": "Bomet (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bomet (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bomet (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bomet (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bomet (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bomet (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bomet (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bomet (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bomet (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bomet (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bomet (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bomet (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bomet (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bomet (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bomet (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bomet (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bomet (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bomet (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bomet (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bomet (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bomet (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bomet (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bomi (County of Liberia)": [
            {
                "Region Name": "Bomi (County of Liberia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bomi (County of Liberia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bomi (County of Liberia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Bomi (County of Liberia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bomi (County of Liberia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bomi (County of Liberia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bomi (County of Liberia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bomi (County of Liberia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bomi (County of Liberia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bomi (County of Liberia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bomi (County of Liberia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bomi (County of Liberia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bomi (County of Liberia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bomi (County of Liberia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bomi (County of Liberia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bomi (County of Liberia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bomi (County of Liberia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bomi (County of Liberia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bomi (County of Liberia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bomi (County of Liberia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bomi (County of Liberia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bomi (County of Liberia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)": [
            {
                "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bonaire (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bong (County of Liberia)": [
            {
                "Region Name": "Bong (County of Liberia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bong (County of Liberia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bong (County of Liberia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bong (County of Liberia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bong (County of Liberia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bong (County of Liberia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bong (County of Liberia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bong (County of Liberia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bong (County of Liberia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bong (County of Liberia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bong (County of Liberia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bong (County of Liberia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bong (County of Liberia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bong (County of Liberia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bong (County of Liberia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bong (County of Liberia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bong (County of Liberia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bong (County of Liberia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bong (County of Liberia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bong (County of Liberia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bong (County of Liberia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bong (County of Liberia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Bono (Region of Ghana)": [
            {
                "Region Name": "Bono (Region of Ghana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 67
            },
            {
                "Region Name": "Bono (Region of Ghana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Bono (Region of Ghana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Bono (Region of Ghana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Bono (Region of Ghana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Bono (Region of Ghana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 72
            },
            {
                "Region Name": "Bono (Region of Ghana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Bono (Region of Ghana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Bono (Region of Ghana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Bono (Region of Ghana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Bono (Region of Ghana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Bono (Region of Ghana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Bono (Region of Ghana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Bono (Region of Ghana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Bono (Region of Ghana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Bono (Region of Ghana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Bono (Region of Ghana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Bono (Region of Ghana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Bono (Region of Ghana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Bono (Region of Ghana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Bono (Region of Ghana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bono (Region of Ghana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Bono East (Region of Ghana)": [
            {
                "Region Name": "Bono East (Region of Ghana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Bono East (Region of Ghana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Bono East (Region of Ghana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Bono East (Region of Ghana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Bono East (Region of Ghana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Bono East (Region of Ghana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Bono East (Region of Ghana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Bono East (Region of Ghana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Bono East (Region of Ghana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Bono East (Region of Ghana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Bono East (Region of Ghana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Bono East (Region of Ghana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Bono East (Region of Ghana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Bono East (Region of Ghana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Bono East (Region of Ghana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Bono East (Region of Ghana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Bono East (Region of Ghana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Bono East (Region of Ghana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Bono East (Region of Ghana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Bono East (Region of Ghana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Bono East (Region of Ghana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bono East (Region of Ghana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Boquer\xf3n (Department of Paraguay)": [
            {
                "Region Name": "Boquer\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Boquer\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Boquer\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Boquer\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Boquer\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Boquer\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Boquer\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Boquer\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Boquer\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Boquer\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Boquer\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Boquer\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Boquer\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Boquer\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Boquer\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Boquer\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Boquer\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Boquer\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Boquer\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Boquer\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Boquer\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Boquer\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Bordj Bou Arr\xe9ridj (Province of Algeria)": [
            {
                "Region Name": "Bordj Bou Arr\xe9ridj (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bordj Bou Arr\xe9ridj (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bordj Bou Arr\xe9ridj (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bordj Bou Arr\xe9ridj (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bordj Bou Arr\xe9ridj (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bordj Bou Arr\xe9ridj (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bordj Bou Arr\xe9ridj (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bordj Bou Arr\xe9ridj (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bordj Bou Arr\xe9ridj (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bordj Bou Arr\xe9ridj (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bordj Bou Arr\xe9ridj (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bordj Bou Arr\xe9ridj (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bordj Bou Arr\xe9ridj (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bordj Bou Arr\xe9ridj (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bordj Bou Arr\xe9ridj (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bordj Bou Arr\xe9ridj (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bordj Bou Arr\xe9ridj (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bordj Bou Arr\xe9ridj (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bordj Bou Arr\xe9ridj (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bordj Bou Arr\xe9ridj (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bordj Bou Arr\xe9ridj (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bordj Bou Arr\xe9ridj (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Borgo Maggiore (Municipality of San Marino)": [
            {
                "Region Name": "Borgo Maggiore (Municipality of San Marino)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borgo Maggiore (Municipality of San Marino)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borgo Maggiore (Municipality of San Marino)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borgo Maggiore (Municipality of San Marino)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borgo Maggiore (Municipality of San Marino)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borgo Maggiore (Municipality of San Marino)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borgo Maggiore (Municipality of San Marino)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borgo Maggiore (Municipality of San Marino)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borgo Maggiore (Municipality of San Marino)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borgo Maggiore (Municipality of San Marino)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borgo Maggiore (Municipality of San Marino)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borgo Maggiore (Municipality of San Marino)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borgo Maggiore (Municipality of San Marino)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borgo Maggiore (Municipality of San Marino)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borgo Maggiore (Municipality of San Marino)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borgo Maggiore (Municipality of San Marino)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borgo Maggiore (Municipality of San Marino)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borgo Maggiore (Municipality of San Marino)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borgo Maggiore (Municipality of San Marino)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borgo Maggiore (Municipality of San Marino)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borgo Maggiore (Municipality of San Marino)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borgo Maggiore (Municipality of San Marino)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Borgou (Department of Benin)": [
            {
                "Region Name": "Borgou (Department of Benin)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Borgou (Department of Benin)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Borgou (Department of Benin)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Borgou (Department of Benin)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Borgou (Department of Benin)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Borgou (Department of Benin)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Borgou (Department of Benin)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Borgou (Department of Benin)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Borgou (Department of Benin)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Borgou (Department of Benin)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Borgou (Department of Benin)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Borgou (Department of Benin)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Borgou (Department of Benin)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Borgou (Department of Benin)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Borgou (Department of Benin)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Borgou (Department of Benin)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Borgou (Department of Benin)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Borgou (Department of Benin)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Borgou (Department of Benin)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Borgou (Department of Benin)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Borgou (Department of Benin)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Borgou (Department of Benin)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Borkou (Region of Chad)": [
            {
                "Region Name": "Borkou (Region of Chad)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borkou (Region of Chad)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borkou (Region of Chad)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borkou (Region of Chad)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borkou (Region of Chad)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borkou (Region of Chad)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Borkou (Region of Chad)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borkou (Region of Chad)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borkou (Region of Chad)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borkou (Region of Chad)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borkou (Region of Chad)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Borkou (Region of Chad)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borkou (Region of Chad)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borkou (Region of Chad)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borkou (Region of Chad)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borkou (Region of Chad)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borkou (Region of Chad)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borkou (Region of Chad)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borkou (Region of Chad)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Borkou (Region of Chad)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borkou (Region of Chad)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 283
            },
            {
                "Region Name": "Borkou (Region of Chad)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Borno (State of Nigeria)": [
            {
                "Region Name": "Borno (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Borno (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Borno (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Borno (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Borno (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Borno (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Borno (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Borno (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Borno (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Borno (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Borno (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Borno (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Borno (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Borno (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Borno (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Borno (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Borno (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Borno (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Borno (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Borno (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Borno (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Borno (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 38
            }
        ],
        "Borski (District of Serbia)": [
            {
                "Region Name": "Borski (District of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Borski (District of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Borski (District of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Borski (District of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borski (District of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Borski (District of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Borski (District of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Borski (District of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Borski (District of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Borski (District of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Borski (District of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Borski (District of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Borski (District of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borski (District of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Borski (District of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Borski (District of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Borski (District of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Borski (District of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Borski (District of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borski (District of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Borski (District of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Borski (District of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Borsod-Aba\xfaj-Zempl\xe9n (County of Hungary)": [
            {
                "Region Name": "Borsod-Aba\xfaj-Zempl\xe9n (County of Hungary)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Borsod-Aba\xfaj-Zempl\xe9n (County of Hungary)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Borsod-Aba\xfaj-Zempl\xe9n (County of Hungary)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Borsod-Aba\xfaj-Zempl\xe9n (County of Hungary)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Borsod-Aba\xfaj-Zempl\xe9n (County of Hungary)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Borsod-Aba\xfaj-Zempl\xe9n (County of Hungary)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Borsod-Aba\xfaj-Zempl\xe9n (County of Hungary)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Borsod-Aba\xfaj-Zempl\xe9n (County of Hungary)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Borsod-Aba\xfaj-Zempl\xe9n (County of Hungary)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Borsod-Aba\xfaj-Zempl\xe9n (County of Hungary)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Borsod-Aba\xfaj-Zempl\xe9n (County of Hungary)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Borsod-Aba\xfaj-Zempl\xe9n (County of Hungary)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Borsod-Aba\xfaj-Zempl\xe9n (County of Hungary)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Borsod-Aba\xfaj-Zempl\xe9n (County of Hungary)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Borsod-Aba\xfaj-Zempl\xe9n (County of Hungary)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borsod-Aba\xfaj-Zempl\xe9n (County of Hungary)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Borsod-Aba\xfaj-Zempl\xe9n (County of Hungary)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borsod-Aba\xfaj-Zempl\xe9n (County of Hungary)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borsod-Aba\xfaj-Zempl\xe9n (County of Hungary)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Borsod-Aba\xfaj-Zempl\xe9n (County of Hungary)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Borsod-Aba\xfaj-Zempl\xe9n (County of Hungary)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Borsod-Aba\xfaj-Zempl\xe9n (County of Hungary)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bosilovo (Municipality of North Macedonia)": [
            {
                "Region Name": "Bosilovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bosilovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bosilovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bosilovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bosilovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bosilovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bosilovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bosilovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bosilovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bosilovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bosilovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bosilovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bosilovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bosilovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bosilovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bosilovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bosilovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bosilovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bosilovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bosilovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bosilovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bosilovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Boto\u0219ani (County of Romania)": [
            {
                "Region Name": "Boto\u0219ani (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boto\u0219ani (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boto\u0219ani (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boto\u0219ani (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boto\u0219ani (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boto\u0219ani (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Boto\u0219ani (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boto\u0219ani (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boto\u0219ani (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Boto\u0219ani (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Boto\u0219ani (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Boto\u0219ani (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Boto\u0219ani (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boto\u0219ani (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Boto\u0219ani (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boto\u0219ani (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boto\u0219ani (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Boto\u0219ani (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Boto\u0219ani (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Boto\u0219ani (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boto\u0219ani (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Boto\u0219ani (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Boucle du Mouhoun (Region of Burkina Faso)": [
            {
                "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Boucle du Mouhoun (Region of Burkina Faso)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Boueni (Commune of Mayotte)": [
            {
                "Region Name": "Boueni (Commune of Mayotte)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boueni (Commune of Mayotte)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boueni (Commune of Mayotte)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boueni (Commune of Mayotte)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boueni (Commune of Mayotte)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boueni (Commune of Mayotte)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boueni (Commune of Mayotte)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boueni (Commune of Mayotte)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boueni (Commune of Mayotte)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boueni (Commune of Mayotte)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boueni (Commune of Mayotte)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boueni (Commune of Mayotte)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boueni (Commune of Mayotte)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boueni (Commune of Mayotte)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boueni (Commune of Mayotte)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boueni (Commune of Mayotte)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boueni (Commune of Mayotte)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boueni (Commune of Mayotte)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boueni (Commune of Mayotte)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boueni (Commune of Mayotte)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boueni (Commune of Mayotte)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boueni (Commune of Mayotte)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bouenza (Region of Republic of the Congo)": [
            {
                "Region Name": "Bouenza (Region of Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bouenza (Region of Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bouenza (Region of Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bouenza (Region of Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bouenza (Region of Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bouenza (Region of Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bouenza (Region of Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bouenza (Region of Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bouenza (Region of Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bouenza (Region of Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bouenza (Region of Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bouenza (Region of Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bouenza (Region of Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bouenza (Region of Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bouenza (Region of Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bouenza (Region of Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bouenza (Region of Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bouenza (Region of Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bouenza (Region of Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bouenza (Region of Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bouenza (Region of Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bouenza (Region of Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Bougainville (Autonomous Region of Papua New Guinea)": [
            {
                "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bougainville (Autonomous Region of Papua New Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bouira (Province of Algeria)": [
            {
                "Region Name": "Bouira (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bouira (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bouira (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bouira (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bouira (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bouira (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bouira (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bouira (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bouira (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bouira (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bouira (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Bouira (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bouira (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bouira (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bouira (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bouira (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bouira (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bouira (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bouira (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bouira (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Bouira (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bouira (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 38
            }
        ],
        "Boujdour (Province of Western Sahara)": [
            {
                "Region Name": "Boujdour (Province of Western Sahara)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boujdour (Province of Western Sahara)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boujdour (Province of Western Sahara)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boujdour (Province of Western Sahara)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boujdour (Province of Western Sahara)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boujdour (Province of Western Sahara)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boujdour (Province of Western Sahara)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boujdour (Province of Western Sahara)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boujdour (Province of Western Sahara)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boujdour (Province of Western Sahara)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boujdour (Province of Western Sahara)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boujdour (Province of Western Sahara)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boujdour (Province of Western Sahara)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boujdour (Province of Western Sahara)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boujdour (Province of Western Sahara)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boujdour (Province of Western Sahara)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boujdour (Province of Western Sahara)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boujdour (Province of Western Sahara)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boujdour (Province of Western Sahara)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boujdour (Province of Western Sahara)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boujdour (Province of Western Sahara)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boujdour (Province of Western Sahara)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Boumerd\xe8s (Province of Algeria)": [
            {
                "Region Name": "Boumerd\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Boumerd\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Boumerd\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Boumerd\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Boumerd\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Boumerd\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Boumerd\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Boumerd\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Boumerd\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Boumerd\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boumerd\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Boumerd\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Boumerd\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Boumerd\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boumerd\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Boumerd\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Boumerd\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boumerd\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Boumerd\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Boumerd\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Boumerd\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boumerd\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 22
            }
        ],
        "Bourgogne-Franche-Comt\xe9 (Region of France)": [
            {
                "Region Name": "Bourgogne-Franche-Comt\xe9 (Region of France)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Bourgogne-Franche-Comt\xe9 (Region of France)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bourgogne-Franche-Comt\xe9 (Region of France)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bourgogne-Franche-Comt\xe9 (Region of France)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bourgogne-Franche-Comt\xe9 (Region of France)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Bourgogne-Franche-Comt\xe9 (Region of France)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bourgogne-Franche-Comt\xe9 (Region of France)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bourgogne-Franche-Comt\xe9 (Region of France)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bourgogne-Franche-Comt\xe9 (Region of France)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bourgogne-Franche-Comt\xe9 (Region of France)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bourgogne-Franche-Comt\xe9 (Region of France)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bourgogne-Franche-Comt\xe9 (Region of France)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bourgogne-Franche-Comt\xe9 (Region of France)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Bourgogne-Franche-Comt\xe9 (Region of France)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bourgogne-Franche-Comt\xe9 (Region of France)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bourgogne-Franche-Comt\xe9 (Region of France)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bourgogne-Franche-Comt\xe9 (Region of France)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bourgogne-Franche-Comt\xe9 (Region of France)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bourgogne-Franche-Comt\xe9 (Region of France)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bourgogne-Franche-Comt\xe9 (Region of France)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bourgogne-Franche-Comt\xe9 (Region of France)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bourgogne-Franche-Comt\xe9 (Region of France)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Boyac\xe1 (Department of Colombia)": [
            {
                "Region Name": "Boyac\xe1 (Department of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Boyac\xe1 (Department of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Boyac\xe1 (Department of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boyac\xe1 (Department of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Boyac\xe1 (Department of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Boyac\xe1 (Department of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Boyac\xe1 (Department of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Boyac\xe1 (Department of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Boyac\xe1 (Department of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Boyac\xe1 (Department of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Boyac\xe1 (Department of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Boyac\xe1 (Department of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Boyac\xe1 (Department of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Boyac\xe1 (Department of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Boyac\xe1 (Department of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Boyac\xe1 (Department of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Boyac\xe1 (Department of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Boyac\xe1 (Department of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Boyac\xe1 (Department of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Boyac\xe1 (Department of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Boyac\xe1 (Department of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Boyac\xe1 (Department of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Braddan (Parish District of Isle of Man)": [
            {
                "Region Name": "Braddan (Parish District of Isle of Man)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Braddan (Parish District of Isle of Man)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Braddan (Parish District of Isle of Man)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Braddan (Parish District of Isle of Man)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Braddan (Parish District of Isle of Man)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Braddan (Parish District of Isle of Man)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Braddan (Parish District of Isle of Man)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Braddan (Parish District of Isle of Man)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Braddan (Parish District of Isle of Man)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Braddan (Parish District of Isle of Man)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Braddan (Parish District of Isle of Man)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Braddan (Parish District of Isle of Man)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Braddan (Parish District of Isle of Man)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Braddan (Parish District of Isle of Man)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Braddan (Parish District of Isle of Man)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Braddan (Parish District of Isle of Man)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Braddan (Parish District of Isle of Man)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Braddan (Parish District of Isle of Man)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Braddan (Parish District of Isle of Man)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Braddan (Parish District of Isle of Man)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Braddan (Parish District of Isle of Man)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Braddan (Parish District of Isle of Man)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Braga (District of Portugal)": [
            {
                "Region Name": "Braga (District of Portugal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Braga (District of Portugal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Braga (District of Portugal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Braga (District of Portugal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Braga (District of Portugal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Braga (District of Portugal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Braga (District of Portugal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Braga (District of Portugal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Braga (District of Portugal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Braga (District of Portugal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Braga (District of Portugal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Braga (District of Portugal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Braga (District of Portugal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Braga (District of Portugal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Braga (District of Portugal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Braga (District of Portugal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Braga (District of Portugal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Braga (District of Portugal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Braga (District of Portugal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Braga (District of Portugal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Braga (District of Portugal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Braga (District of Portugal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bragan\xe7a (District of Portugal)": [
            {
                "Region Name": "Bragan\xe7a (District of Portugal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Bragan\xe7a (District of Portugal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Bragan\xe7a (District of Portugal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bragan\xe7a (District of Portugal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bragan\xe7a (District of Portugal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bragan\xe7a (District of Portugal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bragan\xe7a (District of Portugal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bragan\xe7a (District of Portugal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bragan\xe7a (District of Portugal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bragan\xe7a (District of Portugal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bragan\xe7a (District of Portugal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bragan\xe7a (District of Portugal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 80
            },
            {
                "Region Name": "Bragan\xe7a (District of Portugal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bragan\xe7a (District of Portugal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bragan\xe7a (District of Portugal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Bragan\xe7a (District of Portugal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Bragan\xe7a (District of Portugal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bragan\xe7a (District of Portugal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bragan\xe7a (District of Portugal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Bragan\xe7a (District of Portugal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bragan\xe7a (District of Portugal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Bragan\xe7a (District of Portugal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Br\u0103ila (County of Romania)": [
            {
                "Region Name": "Br\u0103ila (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Br\u0103ila (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Br\u0103ila (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Br\u0103ila (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Br\u0103ila (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Br\u0103ila (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Br\u0103ila (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Br\u0103ila (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Br\u0103ila (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Br\u0103ila (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Br\u0103ila (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Br\u0103ila (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Br\u0103ila (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Br\u0103ila (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Br\u0103ila (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Br\u0103ila (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Br\u0103ila (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Br\u0103ila (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Br\u0103ila (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Br\u0103ila (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Br\u0103ila (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Br\u0103ila (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Brakna (Region of Mauritania)": [
            {
                "Region Name": "Brakna (Region of Mauritania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brakna (Region of Mauritania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Brakna (Region of Mauritania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Brakna (Region of Mauritania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Brakna (Region of Mauritania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Brakna (Region of Mauritania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Brakna (Region of Mauritania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brakna (Region of Mauritania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Brakna (Region of Mauritania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Brakna (Region of Mauritania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Brakna (Region of Mauritania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Brakna (Region of Mauritania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Brakna (Region of Mauritania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brakna (Region of Mauritania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Brakna (Region of Mauritania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Brakna (Region of Mauritania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brakna (Region of Mauritania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Brakna (Region of Mauritania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Brakna (Region of Mauritania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brakna (Region of Mauritania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brakna (Region of Mauritania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Brakna (Region of Mauritania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Brandenburg (State of Germany)": [
            {
                "Region Name": "Brandenburg (State of Germany)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Brandenburg (State of Germany)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brandenburg (State of Germany)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brandenburg (State of Germany)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brandenburg (State of Germany)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Brandenburg (State of Germany)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brandenburg (State of Germany)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Brandenburg (State of Germany)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brandenburg (State of Germany)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brandenburg (State of Germany)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Brandenburg (State of Germany)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brandenburg (State of Germany)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brandenburg (State of Germany)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brandenburg (State of Germany)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Brandenburg (State of Germany)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Brandenburg (State of Germany)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brandenburg (State of Germany)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Brandenburg (State of Germany)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brandenburg (State of Germany)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brandenburg (State of Germany)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brandenburg (State of Germany)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Brandenburg (State of Germany)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Brani\u010Devski (District of Serbia)": [
            {
                "Region Name": "Brani\u010Devski (District of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brani\u010Devski (District of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brani\u010Devski (District of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Brani\u010Devski (District of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brani\u010Devski (District of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Brani\u010Devski (District of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Brani\u010Devski (District of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brani\u010Devski (District of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Brani\u010Devski (District of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Brani\u010Devski (District of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Brani\u010Devski (District of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brani\u010Devski (District of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brani\u010Devski (District of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brani\u010Devski (District of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Brani\u010Devski (District of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Brani\u010Devski (District of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Brani\u010Devski (District of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Brani\u010Devski (District of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Brani\u010Devski (District of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Brani\u010Devski (District of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brani\u010Devski (District of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brani\u010Devski (District of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bra\u0219ov (County of Romania)": [
            {
                "Region Name": "Bra\u0219ov (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bra\u0219ov (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bra\u0219ov (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bra\u0219ov (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bra\u0219ov (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bra\u0219ov (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bra\u0219ov (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bra\u0219ov (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bra\u0219ov (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bra\u0219ov (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bra\u0219ov (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bra\u0219ov (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bra\u0219ov (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bra\u0219ov (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bra\u0219ov (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bra\u0219ov (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bra\u0219ov (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bra\u0219ov (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bra\u0219ov (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bra\u0219ov (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bra\u0219ov (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bra\u0219ov (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Bratislavsk\xfd (Region of Slovakia)": [
            {
                "Region Name": "Bratislavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bratislavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bratislavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bratislavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bratislavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bratislavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bratislavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bratislavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bratislavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bratislavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bratislavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bratislavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bratislavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bratislavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bratislavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bratislavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bratislavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bratislavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bratislavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bratislavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bratislavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bratislavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Brava (County of Cabo Verde)": [
            {
                "Region Name": "Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Brazzaville (Region of Republic of the Congo)": [
            {
                "Region Name": "Brazzaville (Region of Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brazzaville (Region of Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brazzaville (Region of Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brazzaville (Region of Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brazzaville (Region of Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brazzaville (Region of Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brazzaville (Region of Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brazzaville (Region of Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brazzaville (Region of Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brazzaville (Region of Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brazzaville (Region of Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brazzaville (Region of Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brazzaville (Region of Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brazzaville (Region of Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brazzaville (Region of Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brazzaville (Region of Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brazzaville (Region of Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brazzaville (Region of Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brazzaville (Region of Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brazzaville (Region of Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brazzaville (Region of Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brazzaville (Region of Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Br\u010Dko (District of Bosnia and Herzegovina)": [
            {
                "Region Name": "Br\u010Dko (District of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Br\u010Dko (District of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Br\u010Dko (District of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Br\u010Dko (District of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Br\u010Dko (District of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Br\u010Dko (District of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Br\u010Dko (District of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Br\u010Dko (District of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Br\u010Dko (District of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Br\u010Dko (District of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Br\u010Dko (District of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Br\u010Dko (District of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Br\u010Dko (District of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Br\u010Dko (District of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Br\u010Dko (District of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Br\u010Dko (District of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Br\u010Dko (District of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Br\u010Dko (District of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Br\u010Dko (District of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Br\u010Dko (District of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Br\u010Dko (District of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Br\u010Dko (District of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bremen (State of Germany)": [
            {
                "Region Name": "Bremen (State of Germany)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bremen (State of Germany)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bremen (State of Germany)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bremen (State of Germany)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bremen (State of Germany)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bremen (State of Germany)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bremen (State of Germany)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bremen (State of Germany)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bremen (State of Germany)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bremen (State of Germany)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bremen (State of Germany)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bremen (State of Germany)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bremen (State of Germany)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bremen (State of Germany)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bremen (State of Germany)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bremen (State of Germany)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bremen (State of Germany)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bremen (State of Germany)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bremen (State of Germany)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bremen (State of Germany)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bremen (State of Germany)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bremen (State of Germany)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Brest (Region of Belarus)": [
            {
                "Region Name": "Brest (Region of Belarus)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Brest (Region of Belarus)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Brest (Region of Belarus)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Brest (Region of Belarus)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Brest (Region of Belarus)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Brest (Region of Belarus)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Brest (Region of Belarus)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Brest (Region of Belarus)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Brest (Region of Belarus)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Brest (Region of Belarus)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Brest (Region of Belarus)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Brest (Region of Belarus)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Brest (Region of Belarus)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Brest (Region of Belarus)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Brest (Region of Belarus)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Brest (Region of Belarus)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Brest (Region of Belarus)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Brest (Region of Belarus)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Brest (Region of Belarus)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Brest (Region of Belarus)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Brest (Region of Belarus)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Brest (Region of Belarus)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bretagne (Region of France)": [
            {
                "Region Name": "Bretagne (Region of France)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bretagne (Region of France)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bretagne (Region of France)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bretagne (Region of France)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bretagne (Region of France)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bretagne (Region of France)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bretagne (Region of France)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bretagne (Region of France)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bretagne (Region of France)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bretagne (Region of France)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bretagne (Region of France)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bretagne (Region of France)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bretagne (Region of France)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bretagne (Region of France)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bretagne (Region of France)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bretagne (Region of France)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bretagne (Region of France)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bretagne (Region of France)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bretagne (Region of France)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bretagne (Region of France)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bretagne (Region of France)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Bretagne (Region of France)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Briceni (District of Moldova)": [
            {
                "Region Name": "Briceni (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Briceni (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Briceni (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Briceni (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Briceni (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Briceni (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Briceni (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Briceni (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Briceni (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Briceni (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Briceni (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Briceni (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Briceni (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Briceni (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Briceni (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Briceni (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Briceni (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Briceni (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Briceni (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Briceni (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Briceni (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Briceni (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bride (Parish District of Isle of Man)": [
            {
                "Region Name": "Bride (Parish District of Isle of Man)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bride (Parish District of Isle of Man)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bride (Parish District of Isle of Man)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bride (Parish District of Isle of Man)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bride (Parish District of Isle of Man)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bride (Parish District of Isle of Man)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bride (Parish District of Isle of Man)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bride (Parish District of Isle of Man)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bride (Parish District of Isle of Man)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bride (Parish District of Isle of Man)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bride (Parish District of Isle of Man)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bride (Parish District of Isle of Man)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bride (Parish District of Isle of Man)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bride (Parish District of Isle of Man)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bride (Parish District of Isle of Man)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bride (Parish District of Isle of Man)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bride (Parish District of Isle of Man)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bride (Parish District of Isle of Man)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bride (Parish District of Isle of Man)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bride (Parish District of Isle of Man)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bride (Parish District of Isle of Man)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bride (Parish District of Isle of Man)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "British Columbia (Province of Canada)": [
            {
                "Region Name": "British Columbia (Province of Canada)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "British Columbia (Province of Canada)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "British Columbia (Province of Canada)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "British Columbia (Province of Canada)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "British Columbia (Province of Canada)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "British Columbia (Province of Canada)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "British Columbia (Province of Canada)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "British Columbia (Province of Canada)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "British Columbia (Province of Canada)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "British Columbia (Province of Canada)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "British Columbia (Province of Canada)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "British Columbia (Province of Canada)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "British Columbia (Province of Canada)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "British Columbia (Province of Canada)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "British Columbia (Province of Canada)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "British Columbia (Province of Canada)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "British Columbia (Province of Canada)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "British Columbia (Province of Canada)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "British Columbia (Province of Canada)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "British Columbia (Province of Canada)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "British Columbia (Province of Canada)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "British Columbia (Province of Canada)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 59
            }
        ],
        "Brodsko-Posavska (County of Croatia)": [
            {
                "Region Name": "Brodsko-Posavska (County of Croatia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brodsko-Posavska (County of Croatia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brodsko-Posavska (County of Croatia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brodsko-Posavska (County of Croatia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brodsko-Posavska (County of Croatia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brodsko-Posavska (County of Croatia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brodsko-Posavska (County of Croatia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Brodsko-Posavska (County of Croatia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Brodsko-Posavska (County of Croatia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brodsko-Posavska (County of Croatia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brodsko-Posavska (County of Croatia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Brodsko-Posavska (County of Croatia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brodsko-Posavska (County of Croatia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brodsko-Posavska (County of Croatia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brodsko-Posavska (County of Croatia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brodsko-Posavska (County of Croatia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Brodsko-Posavska (County of Croatia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brodsko-Posavska (County of Croatia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brodsko-Posavska (County of Croatia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Brodsko-Posavska (County of Croatia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brodsko-Posavska (County of Croatia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brodsko-Posavska (County of Croatia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Brokopondo (District of Suriname)": [
            {
                "Region Name": "Brokopondo (District of Suriname)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Brokopondo (District of Suriname)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Brokopondo (District of Suriname)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brokopondo (District of Suriname)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brokopondo (District of Suriname)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Brokopondo (District of Suriname)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brokopondo (District of Suriname)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Brokopondo (District of Suriname)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brokopondo (District of Suriname)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brokopondo (District of Suriname)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brokopondo (District of Suriname)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brokopondo (District of Suriname)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brokopondo (District of Suriname)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brokopondo (District of Suriname)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brokopondo (District of Suriname)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Brokopondo (District of Suriname)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brokopondo (District of Suriname)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Brokopondo (District of Suriname)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brokopondo (District of Suriname)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Brokopondo (District of Suriname)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brokopondo (District of Suriname)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brokopondo (District of Suriname)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Brunei and Muara (District of Brunei)": [
            {
                "Region Name": "Brunei and Muara (District of Brunei)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei and Muara (District of Brunei)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei and Muara (District of Brunei)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei and Muara (District of Brunei)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei and Muara (District of Brunei)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei and Muara (District of Brunei)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei and Muara (District of Brunei)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei and Muara (District of Brunei)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei and Muara (District of Brunei)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei and Muara (District of Brunei)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei and Muara (District of Brunei)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei and Muara (District of Brunei)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei and Muara (District of Brunei)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei and Muara (District of Brunei)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Brunei and Muara (District of Brunei)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei and Muara (District of Brunei)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei and Muara (District of Brunei)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei and Muara (District of Brunei)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei and Muara (District of Brunei)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei and Muara (District of Brunei)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei and Muara (District of Brunei)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brunei and Muara (District of Brunei)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bruxelles (Region of Belgium)": [
            {
                "Region Name": "Bruxelles (Region of Belgium)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bruxelles (Region of Belgium)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bruxelles (Region of Belgium)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bruxelles (Region of Belgium)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bruxelles (Region of Belgium)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bruxelles (Region of Belgium)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bruxelles (Region of Belgium)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bruxelles (Region of Belgium)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bruxelles (Region of Belgium)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bruxelles (Region of Belgium)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bruxelles (Region of Belgium)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bruxelles (Region of Belgium)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bruxelles (Region of Belgium)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bruxelles (Region of Belgium)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bruxelles (Region of Belgium)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bruxelles (Region of Belgium)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bruxelles (Region of Belgium)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bruxelles (Region of Belgium)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bruxelles (Region of Belgium)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bruxelles (Region of Belgium)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bruxelles (Region of Belgium)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bruxelles (Region of Belgium)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Brvenica (Municipality of North Macedonia)": [
            {
                "Region Name": "Brvenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brvenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brvenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brvenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brvenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brvenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Brvenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brvenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brvenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brvenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brvenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brvenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brvenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brvenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brvenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brvenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brvenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brvenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brvenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brvenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brvenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Brvenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bryansk (Region of Russia)": [
            {
                "Region Name": "Bryansk (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bryansk (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bryansk (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bryansk (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bryansk (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bryansk (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bryansk (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bryansk (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bryansk (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bryansk (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bryansk (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bryansk (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bryansk (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bryansk (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bryansk (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bryansk (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bryansk (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bryansk (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bryansk (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bryansk (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bryansk (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bryansk (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Buada (District of Nauru)": [
            {
                "Region Name": "Buada (District of Nauru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buada (District of Nauru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buada (District of Nauru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buada (District of Nauru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buada (District of Nauru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buada (District of Nauru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buada (District of Nauru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buada (District of Nauru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buada (District of Nauru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buada (District of Nauru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buada (District of Nauru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buada (District of Nauru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buada (District of Nauru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buada (District of Nauru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buada (District of Nauru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buada (District of Nauru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buada (District of Nauru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buada (District of Nauru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buada (District of Nauru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buada (District of Nauru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buada (District of Nauru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buada (District of Nauru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bubanza (Province of Burundi)": [
            {
                "Region Name": "Bubanza (Province of Burundi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Bubanza (Province of Burundi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bubanza (Province of Burundi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bubanza (Province of Burundi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bubanza (Province of Burundi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bubanza (Province of Burundi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bubanza (Province of Burundi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Bubanza (Province of Burundi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bubanza (Province of Burundi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bubanza (Province of Burundi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bubanza (Province of Burundi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bubanza (Province of Burundi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bubanza (Province of Burundi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bubanza (Province of Burundi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Bubanza (Province of Burundi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bubanza (Province of Burundi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bubanza (Province of Burundi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bubanza (Province of Burundi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bubanza (Province of Burundi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bubanza (Province of Burundi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bubanza (Province of Burundi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bubanza (Province of Burundi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Bucharest (Municipality of Romania)": [
            {
                "Region Name": "Bucharest (Municipality of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bucharest (Municipality of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bucharest (Municipality of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bucharest (Municipality of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bucharest (Municipality of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bucharest (Municipality of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bucharest (Municipality of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bucharest (Municipality of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bucharest (Municipality of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bucharest (Municipality of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bucharest (Municipality of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bucharest (Municipality of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bucharest (Municipality of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bucharest (Municipality of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bucharest (Municipality of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bucharest (Municipality of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bucharest (Municipality of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bucharest (Municipality of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bucharest (Municipality of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bucharest (Municipality of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bucharest (Municipality of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bucharest (Municipality of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Budapest (Capital City of Hungary)": [
            {
                "Region Name": "Budapest (Capital City of Hungary)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budapest (Capital City of Hungary)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budapest (Capital City of Hungary)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budapest (Capital City of Hungary)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budapest (Capital City of Hungary)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budapest (Capital City of Hungary)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budapest (Capital City of Hungary)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budapest (Capital City of Hungary)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budapest (Capital City of Hungary)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budapest (Capital City of Hungary)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budapest (Capital City of Hungary)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budapest (Capital City of Hungary)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budapest (Capital City of Hungary)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budapest (Capital City of Hungary)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budapest (Capital City of Hungary)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budapest (Capital City of Hungary)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budapest (Capital City of Hungary)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budapest (Capital City of Hungary)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budapest (Capital City of Hungary)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budapest (Capital City of Hungary)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budapest (Capital City of Hungary)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budapest (Capital City of Hungary)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Budva (Municipality of Montenegro)": [
            {
                "Region Name": "Budva (Municipality of Montenegro)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budva (Municipality of Montenegro)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budva (Municipality of Montenegro)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budva (Municipality of Montenegro)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budva (Municipality of Montenegro)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budva (Municipality of Montenegro)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Budva (Municipality of Montenegro)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budva (Municipality of Montenegro)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budva (Municipality of Montenegro)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budva (Municipality of Montenegro)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Budva (Municipality of Montenegro)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budva (Municipality of Montenegro)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budva (Municipality of Montenegro)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budva (Municipality of Montenegro)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budva (Municipality of Montenegro)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budva (Municipality of Montenegro)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Budva (Municipality of Montenegro)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Budva (Municipality of Montenegro)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budva (Municipality of Montenegro)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Budva (Municipality of Montenegro)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budva (Municipality of Montenegro)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Budva (Municipality of Montenegro)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bueng Kan (Province of Thailand)": [
            {
                "Region Name": "Bueng Kan (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bueng Kan (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bueng Kan (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bueng Kan (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bueng Kan (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bueng Kan (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bueng Kan (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bueng Kan (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bueng Kan (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bueng Kan (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bueng Kan (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bueng Kan (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bueng Kan (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bueng Kan (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bueng Kan (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bueng Kan (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bueng Kan (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bueng Kan (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bueng Kan (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bueng Kan (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bueng Kan (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bueng Kan (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Buenos Aires (Province of Argentina)": [
            {
                "Region Name": "Buenos Aires (Province of Argentina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Buenos Aires (Province of Argentina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Buenos Aires (Province of Argentina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Buenos Aires (Province of Argentina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Buenos Aires (Province of Argentina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Buenos Aires (Province of Argentina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Buenos Aires (Province of Argentina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Buenos Aires (Province of Argentina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Buenos Aires (Province of Argentina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Buenos Aires (Province of Argentina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Buenos Aires (Province of Argentina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Buenos Aires (Province of Argentina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Buenos Aires (Province of Argentina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Buenos Aires (Province of Argentina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Buenos Aires (Province of Argentina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Buenos Aires (Province of Argentina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Buenos Aires (Province of Argentina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Buenos Aires (Province of Argentina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Buenos Aires (Province of Argentina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Buenos Aires (Province of Argentina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Buenos Aires (Province of Argentina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Buenos Aires (Province of Argentina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Bugiri (District of Uganda)": [
            {
                "Region Name": "Bugiri (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bugiri (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bugiri (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bugiri (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bugiri (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bugiri (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bugiri (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bugiri (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bugiri (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bugiri (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bugiri (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bugiri (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bugiri (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bugiri (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bugiri (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bugiri (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bugiri (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bugiri (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bugiri (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bugiri (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bugiri (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bugiri (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bujumbura Mairie (Province of Burundi)": [
            {
                "Region Name": "Bujumbura Mairie (Province of Burundi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Mairie (Province of Burundi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Mairie (Province of Burundi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Mairie (Province of Burundi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Mairie (Province of Burundi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Mairie (Province of Burundi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Mairie (Province of Burundi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Mairie (Province of Burundi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Mairie (Province of Burundi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Mairie (Province of Burundi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Mairie (Province of Burundi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Mairie (Province of Burundi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Mairie (Province of Burundi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bujumbura Mairie (Province of Burundi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Mairie (Province of Burundi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bujumbura Mairie (Province of Burundi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bujumbura Mairie (Province of Burundi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Mairie (Province of Burundi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Mairie (Province of Burundi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Mairie (Province of Burundi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Mairie (Province of Burundi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Mairie (Province of Burundi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bujumbura Rural (Province of Burundi)": [
            {
                "Region Name": "Bujumbura Rural (Province of Burundi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bujumbura Rural (Province of Burundi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bujumbura Rural (Province of Burundi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Rural (Province of Burundi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bujumbura Rural (Province of Burundi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bujumbura Rural (Province of Burundi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Rural (Province of Burundi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bujumbura Rural (Province of Burundi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bujumbura Rural (Province of Burundi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Rural (Province of Burundi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Rural (Province of Burundi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Rural (Province of Burundi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bujumbura Rural (Province of Burundi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Rural (Province of Burundi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bujumbura Rural (Province of Burundi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Rural (Province of Burundi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bujumbura Rural (Province of Burundi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bujumbura Rural (Province of Burundi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Rural (Province of Burundi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bujumbura Rural (Province of Burundi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bujumbura Rural (Province of Burundi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bujumbura Rural (Province of Burundi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bukidnon (Province of Philippines)": [
            {
                "Region Name": "Bukidnon (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bukidnon (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bukidnon (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bukidnon (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bukidnon (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bukidnon (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bukidnon (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bukidnon (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bukidnon (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bukidnon (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bukidnon (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bukidnon (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bukidnon (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bukidnon (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bukidnon (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bukidnon (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bukidnon (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bukidnon (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bukidnon (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bukidnon (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bukidnon (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bukidnon (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bulacan (Province of Philippines)": [
            {
                "Region Name": "Bulacan (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bulacan (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bulacan (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bulacan (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bulacan (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bulacan (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bulacan (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bulacan (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bulacan (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bulacan (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bulacan (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bulacan (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bulacan (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bulacan (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bulacan (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bulacan (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bulacan (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bulacan (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bulacan (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bulacan (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bulacan (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bulacan (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Bulawayo (City of Zimbabwe)": [
            {
                "Region Name": "Bulawayo (City of Zimbabwe)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bulawayo (City of Zimbabwe)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bulawayo (City of Zimbabwe)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bulawayo (City of Zimbabwe)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bulawayo (City of Zimbabwe)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bulawayo (City of Zimbabwe)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bulawayo (City of Zimbabwe)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Bulawayo (City of Zimbabwe)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bulawayo (City of Zimbabwe)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bulawayo (City of Zimbabwe)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bulawayo (City of Zimbabwe)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bulawayo (City of Zimbabwe)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Bulawayo (City of Zimbabwe)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bulawayo (City of Zimbabwe)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bulawayo (City of Zimbabwe)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bulawayo (City of Zimbabwe)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bulawayo (City of Zimbabwe)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bulawayo (City of Zimbabwe)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bulawayo (City of Zimbabwe)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bulawayo (City of Zimbabwe)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bulawayo (City of Zimbabwe)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bulawayo (City of Zimbabwe)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Bulgan (Province of Mongolia)": [
            {
                "Region Name": "Bulgan (Province of Mongolia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Bulgan (Province of Mongolia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Bulgan (Province of Mongolia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bulgan (Province of Mongolia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Bulgan (Province of Mongolia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bulgan (Province of Mongolia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 133
            },
            {
                "Region Name": "Bulgan (Province of Mongolia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bulgan (Province of Mongolia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Bulgan (Province of Mongolia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bulgan (Province of Mongolia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bulgan (Province of Mongolia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Bulgan (Province of Mongolia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Bulgan (Province of Mongolia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bulgan (Province of Mongolia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Bulgan (Province of Mongolia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bulgan (Province of Mongolia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Bulgan (Province of Mongolia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bulgan (Province of Mongolia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Bulgan (Province of Mongolia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bulgan (Province of Mongolia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bulgan (Province of Mongolia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bulgan (Province of Mongolia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Bumthang (District of Bhutan)": [
            {
                "Region Name": "Bumthang (District of Bhutan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bumthang (District of Bhutan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bumthang (District of Bhutan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bumthang (District of Bhutan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bumthang (District of Bhutan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bumthang (District of Bhutan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bumthang (District of Bhutan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bumthang (District of Bhutan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bumthang (District of Bhutan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bumthang (District of Bhutan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bumthang (District of Bhutan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bumthang (District of Bhutan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bumthang (District of Bhutan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bumthang (District of Bhutan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bumthang (District of Bhutan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bumthang (District of Bhutan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bumthang (District of Bhutan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bumthang (District of Bhutan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bumthang (District of Bhutan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bumthang (District of Bhutan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bumthang (District of Bhutan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bumthang (District of Bhutan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bundibugyo (District of Uganda)": [
            {
                "Region Name": "Bundibugyo (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Bundibugyo (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Bundibugyo (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Bundibugyo (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bundibugyo (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Bundibugyo (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bundibugyo (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Bundibugyo (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bundibugyo (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bundibugyo (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bundibugyo (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Bundibugyo (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bundibugyo (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bundibugyo (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Bundibugyo (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Bundibugyo (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Bundibugyo (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Bundibugyo (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bundibugyo (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bundibugyo (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bundibugyo (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Bundibugyo (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Bungoma (County of Kenya)": [
            {
                "Region Name": "Bungoma (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bungoma (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Bungoma (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Bungoma (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Bungoma (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bungoma (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Bungoma (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bungoma (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Bungoma (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 67
            },
            {
                "Region Name": "Bungoma (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bungoma (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bungoma (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bungoma (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Bungoma (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bungoma (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Bungoma (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bungoma (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Bungoma (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bungoma (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bungoma (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bungoma (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bungoma (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bur Sa`id (Governorate of Egypt)": [
            {
                "Region Name": "Bur Sa`id (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bur Sa`id (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bur Sa`id (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bur Sa`id (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bur Sa`id (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bur Sa`id (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bur Sa`id (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bur Sa`id (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bur Sa`id (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bur Sa`id (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bur Sa`id (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bur Sa`id (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bur Sa`id (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bur Sa`id (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bur Sa`id (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bur Sa`id (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bur Sa`id (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bur Sa`id (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bur Sa`id (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Bur Sa`id (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bur Sa`id (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bur Sa`id (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Burdur (Province of Turkey)": [
            {
                "Region Name": "Burdur (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burdur (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burdur (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burdur (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burdur (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burdur (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burdur (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burdur (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burdur (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burdur (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Burdur (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burdur (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burdur (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burdur (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burdur (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Burdur (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Burdur (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burdur (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burdur (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Burdur (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Burdur (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burdur (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Burgas (Province of Bulgaria)": [
            {
                "Region Name": "Burgas (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Burgas (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Burgas (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Burgas (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Burgas (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Burgas (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Burgas (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Burgas (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Burgas (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Burgas (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Burgas (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Burgas (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Burgas (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Burgas (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Burgas (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Burgas (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Burgas (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Burgas (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Burgas (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Burgas (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burgas (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Burgas (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Burgenland (State of Austria)": [
            {
                "Region Name": "Burgenland (State of Austria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burgenland (State of Austria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burgenland (State of Austria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Burgenland (State of Austria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burgenland (State of Austria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burgenland (State of Austria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burgenland (State of Austria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Burgenland (State of Austria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burgenland (State of Austria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burgenland (State of Austria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Burgenland (State of Austria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burgenland (State of Austria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burgenland (State of Austria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burgenland (State of Austria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burgenland (State of Austria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burgenland (State of Austria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burgenland (State of Austria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burgenland (State of Austria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burgenland (State of Austria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burgenland (State of Austria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burgenland (State of Austria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Burgenland (State of Austria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Buri Ram (Province of Thailand)": [
            {
                "Region Name": "Buri Ram (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Buri Ram (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Buri Ram (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Buri Ram (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Buri Ram (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Buri Ram (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Buri Ram (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Buri Ram (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Buri Ram (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Buri Ram (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Buri Ram (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Buri Ram (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Buri Ram (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Buri Ram (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Buri Ram (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Buri Ram (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Buri Ram (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Buri Ram (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Buri Ram (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Buri Ram (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Buri Ram (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Buri Ram (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Bursa (Province of Turkey)": [
            {
                "Region Name": "Bursa (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bursa (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bursa (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bursa (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bursa (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bursa (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bursa (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bursa (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bursa (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bursa (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bursa (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bursa (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bursa (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bursa (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bursa (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bursa (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bursa (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bursa (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bursa (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bursa (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bursa (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bursa (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Bururi (Province of Burundi)": [
            {
                "Region Name": "Bururi (Province of Burundi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bururi (Province of Burundi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bururi (Province of Burundi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bururi (Province of Burundi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bururi (Province of Burundi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bururi (Province of Burundi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bururi (Province of Burundi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bururi (Province of Burundi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bururi (Province of Burundi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bururi (Province of Burundi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bururi (Province of Burundi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bururi (Province of Burundi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bururi (Province of Burundi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bururi (Province of Burundi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bururi (Province of Burundi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bururi (Province of Burundi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bururi (Province of Burundi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bururi (Province of Burundi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bururi (Province of Burundi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bururi (Province of Burundi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bururi (Province of Burundi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bururi (Province of Burundi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Buryat (Republic of Russia)": [
            {
                "Region Name": "Buryat (Republic of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Buryat (Republic of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Buryat (Republic of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Buryat (Republic of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Buryat (Republic of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Buryat (Republic of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Buryat (Republic of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Buryat (Republic of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Buryat (Republic of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Buryat (Republic of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Buryat (Republic of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Buryat (Republic of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Buryat (Republic of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Buryat (Republic of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Buryat (Republic of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Buryat (Republic of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Buryat (Republic of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Buryat (Republic of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Buryat (Republic of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Buryat (Republic of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Buryat (Republic of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Buryat (Republic of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Busan (Metropolitan City of South Korea)": [
            {
                "Region Name": "Busan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Bushehr (Province of Iran)": [
            {
                "Region Name": "Bushehr (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bushehr (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Bushehr (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bushehr (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bushehr (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bushehr (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bushehr (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Bushehr (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Bushehr (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 126
            },
            {
                "Region Name": "Bushehr (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Bushehr (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bushehr (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bushehr (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Bushehr (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bushehr (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Bushehr (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bushehr (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bushehr (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bushehr (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bushehr (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Bushehr (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Bushehr (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Bushenyi (District of Uganda)": [
            {
                "Region Name": "Bushenyi (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Bushenyi (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Bushenyi (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bushenyi (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Bushenyi (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Bushenyi (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Bushenyi (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Bushenyi (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bushenyi (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Bushenyi (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Bushenyi (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Bushenyi (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Bushenyi (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Bushenyi (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Bushenyi (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Bushenyi (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Bushenyi (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Bushenyi (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Bushenyi (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Bushenyi (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Bushenyi (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Bushenyi (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 22
            }
        ],
        "Busia (County of Kenya)": [
            {
                "Region Name": "Busia (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Busia (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Busia (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Busia (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Busia (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Busia (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Busia (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Busia (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Busia (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Busia (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Busia (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Busia (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Busia (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Busia (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Busia (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Busia (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Busia (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Busia (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busia (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Busia (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Busia (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Busia (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Busia (District of Uganda)": [
            {
                "Region Name": "Busia (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Busia (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busia (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Busia (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Busia (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busia (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busia (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busia (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busia (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Busia (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Busia (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busia (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busia (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busia (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Busia (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Busia (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busia (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busia (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busia (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Busia (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Busia (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Busia (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Buskerud (County of Norway)": [
            {
                "Region Name": "Buskerud (County of Norway)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buskerud (County of Norway)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buskerud (County of Norway)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buskerud (County of Norway)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buskerud (County of Norway)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buskerud (County of Norway)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buskerud (County of Norway)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buskerud (County of Norway)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buskerud (County of Norway)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buskerud (County of Norway)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buskerud (County of Norway)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buskerud (County of Norway)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buskerud (County of Norway)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buskerud (County of Norway)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buskerud (County of Norway)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buskerud (County of Norway)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buskerud (County of Norway)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buskerud (County of Norway)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buskerud (County of Norway)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buskerud (County of Norway)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buskerud (County of Norway)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buskerud (County of Norway)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Butel (Municipality of North Macedonia)": [
            {
                "Region Name": "Butel (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Butel (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Butel (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Butel (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Butel (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Butel (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Butel (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Butel (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Butel (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Butel (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Butel (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Butel (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Butel (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Butel (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Butel (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Butel (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Butel (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Butel (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Butel (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Butel (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Butel (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Butel (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Butha-Buthe (District of Lesotho)": [
            {
                "Region Name": "Butha-Buthe (District of Lesotho)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Butha-Buthe (District of Lesotho)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Butha-Buthe (District of Lesotho)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Butha-Buthe (District of Lesotho)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Butha-Buthe (District of Lesotho)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Butha-Buthe (District of Lesotho)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Butha-Buthe (District of Lesotho)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Butha-Buthe (District of Lesotho)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Butha-Buthe (District of Lesotho)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Butha-Buthe (District of Lesotho)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Butha-Buthe (District of Lesotho)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Butha-Buthe (District of Lesotho)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Butha-Buthe (District of Lesotho)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Butha-Buthe (District of Lesotho)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Butha-Buthe (District of Lesotho)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Butha-Buthe (District of Lesotho)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Butha-Buthe (District of Lesotho)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Butha-Buthe (District of Lesotho)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Butha-Buthe (District of Lesotho)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Butha-Buthe (District of Lesotho)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Butha-Buthe (District of Lesotho)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Butha-Buthe (District of Lesotho)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Buxoro (Region of Uzbekistan)": [
            {
                "Region Name": "Buxoro (Region of Uzbekistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Buxoro (Region of Uzbekistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Buxoro (Region of Uzbekistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Buxoro (Region of Uzbekistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Buxoro (Region of Uzbekistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Buxoro (Region of Uzbekistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Buxoro (Region of Uzbekistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Buxoro (Region of Uzbekistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Buxoro (Region of Uzbekistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Buxoro (Region of Uzbekistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Buxoro (Region of Uzbekistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Buxoro (Region of Uzbekistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Buxoro (Region of Uzbekistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Buxoro (Region of Uzbekistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Buxoro (Region of Uzbekistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Buxoro (Region of Uzbekistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Buxoro (Region of Uzbekistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Buxoro (Region of Uzbekistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Buxoro (Region of Uzbekistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Buxoro (Region of Uzbekistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Buxoro (Region of Uzbekistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Buxoro (Region of Uzbekistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Buz\u0103u (County of Romania)": [
            {
                "Region Name": "Buz\u0103u (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Buz\u0103u (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Buz\u0103u (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Buz\u0103u (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Buz\u0103u (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Buz\u0103u (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Buz\u0103u (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Buz\u0103u (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Buz\u0103u (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Buz\u0103u (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Buz\u0103u (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Buz\u0103u (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Buz\u0103u (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Buz\u0103u (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Buz\u0103u (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Buz\u0103u (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Buz\u0103u (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Buz\u0103u (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Buz\u0103u (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Buz\u0103u (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Buz\u0103u (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Buz\u0103u (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "C\xe0 Mau (Province of Vietnam)": [
            {
                "Region Name": "C\xe0 Mau (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "C\xe0 Mau (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "C\xe0 Mau (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "C\xe0 Mau (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "C\xe0 Mau (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "C\xe0 Mau (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "C\xe0 Mau (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "C\xe0 Mau (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "C\xe0 Mau (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "C\xe0 Mau (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "C\xe0 Mau (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "C\xe0 Mau (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "C\xe0 Mau (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "C\xe0 Mau (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "C\xe0 Mau (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "C\xe0 Mau (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "C\xe0 Mau (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "C\xe0 Mau (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "C\xe0 Mau (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "C\xe0 Mau (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "C\xe0 Mau (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "C\xe0 Mau (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Caaguaz\xfa (Department of Paraguay)": [
            {
                "Region Name": "Caaguaz\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Caaguaz\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Caaguaz\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Caaguaz\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Caaguaz\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Caaguaz\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Caaguaz\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Caaguaz\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Caaguaz\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Caaguaz\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Caaguaz\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Caaguaz\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Caaguaz\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Caaguaz\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Caaguaz\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Caaguaz\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Caaguaz\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Caaguaz\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Caaguaz\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Caaguaz\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Caaguaz\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Caaguaz\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Caazap\xe1 (Department of Paraguay)": [
            {
                "Region Name": "Caazap\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Caazap\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Caazap\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Caazap\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Caazap\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Caazap\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Caazap\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Caazap\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Caazap\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Caazap\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Caazap\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Caazap\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Caazap\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Caazap\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Caazap\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Caazap\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Caazap\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Caazap\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Caazap\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Caazap\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Caazap\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Caazap\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Caba\xf1as (Department of El Salvador)": [
            {
                "Region Name": "Caba\xf1as (Department of El Salvador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caba\xf1as (Department of El Salvador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caba\xf1as (Department of El Salvador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Caba\xf1as (Department of El Salvador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caba\xf1as (Department of El Salvador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caba\xf1as (Department of El Salvador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caba\xf1as (Department of El Salvador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caba\xf1as (Department of El Salvador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caba\xf1as (Department of El Salvador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caba\xf1as (Department of El Salvador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caba\xf1as (Department of El Salvador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caba\xf1as (Department of El Salvador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Caba\xf1as (Department of El Salvador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caba\xf1as (Department of El Salvador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caba\xf1as (Department of El Salvador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caba\xf1as (Department of El Salvador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Caba\xf1as (Department of El Salvador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caba\xf1as (Department of El Salvador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caba\xf1as (Department of El Salvador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caba\xf1as (Department of El Salvador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caba\xf1as (Department of El Salvador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caba\xf1as (Department of El Salvador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cabinda (Province of Angola)": [
            {
                "Region Name": "Cabinda (Province of Angola)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cabinda (Province of Angola)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cabinda (Province of Angola)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cabinda (Province of Angola)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cabinda (Province of Angola)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cabinda (Province of Angola)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cabinda (Province of Angola)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cabinda (Province of Angola)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cabinda (Province of Angola)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cabinda (Province of Angola)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cabinda (Province of Angola)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cabinda (Province of Angola)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cabinda (Province of Angola)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cabinda (Province of Angola)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cabinda (Province of Angola)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cabinda (Province of Angola)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cabinda (Province of Angola)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cabinda (Province of Angola)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cabinda (Province of Angola)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cabinda (Province of Angola)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cabinda (Province of Angola)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cabinda (Province of Angola)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Cabo Delgado (Province of Mozambique)": [
            {
                "Region Name": "Cabo Delgado (Province of Mozambique)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cabo Delgado (Province of Mozambique)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Cabo Delgado (Province of Mozambique)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cabo Delgado (Province of Mozambique)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cabo Delgado (Province of Mozambique)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cabo Delgado (Province of Mozambique)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cabo Delgado (Province of Mozambique)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cabo Delgado (Province of Mozambique)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cabo Delgado (Province of Mozambique)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cabo Delgado (Province of Mozambique)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Cabo Delgado (Province of Mozambique)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cabo Delgado (Province of Mozambique)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cabo Delgado (Province of Mozambique)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Cabo Delgado (Province of Mozambique)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cabo Delgado (Province of Mozambique)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cabo Delgado (Province of Mozambique)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Cabo Delgado (Province of Mozambique)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cabo Delgado (Province of Mozambique)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Cabo Delgado (Province of Mozambique)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cabo Delgado (Province of Mozambique)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cabo Delgado (Province of Mozambique)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Cabo Delgado (Province of Mozambique)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Cabo Rojo (Municipality of Puerto Rico)": [
            {
                "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cabo Rojo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cacheu (Region of Guinea-Bissau)": [
            {
                "Region Name": "Cacheu (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Cacheu (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cacheu (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cacheu (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cacheu (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cacheu (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cacheu (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cacheu (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cacheu (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cacheu (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cacheu (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cacheu (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cacheu (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cacheu (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cacheu (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cacheu (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cacheu (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cacheu (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cacheu (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cacheu (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cacheu (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cacheu (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Cagayan (Province of Philippines)": [
            {
                "Region Name": "Cagayan (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cagayan (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cagayan (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cagayan (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cagayan (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cagayan (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cagayan (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cagayan (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cagayan (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cagayan (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cagayan (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cagayan (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cagayan (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cagayan (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cagayan (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cagayan (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cagayan (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cagayan (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cagayan (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cagayan (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cagayan (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Cagayan (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Caguas (Municipality of Puerto Rico)": [
            {
                "Region Name": "Caguas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caguas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caguas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caguas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caguas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caguas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caguas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caguas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caguas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caguas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caguas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caguas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caguas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caguas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caguas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caguas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caguas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caguas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caguas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caguas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caguas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caguas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cahul (District of Moldova)": [
            {
                "Region Name": "Cahul (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cahul (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cahul (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cahul (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cahul (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cahul (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cahul (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cahul (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cahul (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cahul (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cahul (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cahul (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cahul (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cahul (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cahul (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cahul (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cahul (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cahul (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cahul (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cahul (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cahul (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cahul (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cajamarca (Region of Peru)": [
            {
                "Region Name": "Cajamarca (Region of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cajamarca (Region of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cajamarca (Region of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cajamarca (Region of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cajamarca (Region of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cajamarca (Region of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cajamarca (Region of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cajamarca (Region of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cajamarca (Region of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cajamarca (Region of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cajamarca (Region of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cajamarca (Region of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cajamarca (Region of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cajamarca (Region of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cajamarca (Region of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cajamarca (Region of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cajamarca (Region of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cajamarca (Region of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cajamarca (Region of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cajamarca (Region of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cajamarca (Region of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cajamarca (Region of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Calabria (Region of Italy)": [
            {
                "Region Name": "Calabria (Region of Italy)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Calabria (Region of Italy)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Calabria (Region of Italy)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Calabria (Region of Italy)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Calabria (Region of Italy)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Calabria (Region of Italy)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Calabria (Region of Italy)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Calabria (Region of Italy)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Calabria (Region of Italy)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Calabria (Region of Italy)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Calabria (Region of Italy)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Calabria (Region of Italy)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Calabria (Region of Italy)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Calabria (Region of Italy)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Calabria (Region of Italy)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Calabria (Region of Italy)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Calabria (Region of Italy)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Calabria (Region of Italy)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Calabria (Region of Italy)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Calabria (Region of Italy)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Calabria (Region of Italy)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Calabria (Region of Italy)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "C\u0103l\u0103ra\u0219i (County of Romania)": [
            {
                "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "C\u0103l\u0103ra\u0219i (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Calarasi (District of Moldova)": [
            {
                "Region Name": "Calarasi (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Calarasi (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Calarasi (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Calarasi (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Calarasi (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Calarasi (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Calarasi (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Calarasi (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Calarasi (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Calarasi (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Calarasi (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Calarasi (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Calarasi (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Calarasi (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Calarasi (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Calarasi (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Calarasi (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Calarasi (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Calarasi (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Calarasi (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Calarasi (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Calarasi (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Caldas (Department of Colombia)": [
            {
                "Region Name": "Caldas (Department of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Caldas (Department of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caldas (Department of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Caldas (Department of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Caldas (Department of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Caldas (Department of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Caldas (Department of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caldas (Department of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caldas (Department of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caldas (Department of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caldas (Department of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Caldas (Department of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caldas (Department of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Caldas (Department of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Caldas (Department of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caldas (Department of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caldas (Department of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caldas (Department of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caldas (Department of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caldas (Department of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caldas (Department of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Caldas (Department of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "California (State of United States)": [
            {
                "Region Name": "California (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "California (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "California (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "California (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "California (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "California (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "California (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "California (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "California (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "California (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "California (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "California (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "California (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "California (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "California (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "California (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "California (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 57
            },
            {
                "Region Name": "California (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "California (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 163
            },
            {
                "Region Name": "California (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 209
            },
            {
                "Region Name": "California (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "California (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 22
            }
        ],
        "Callao (Province of Peru)": [
            {
                "Region Name": "Callao (Province of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Callao (Province of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Callao (Province of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Callao (Province of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Callao (Province of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Callao (Province of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Callao (Province of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Callao (Province of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Callao (Province of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Callao (Province of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Callao (Province of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Callao (Province of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Callao (Province of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Callao (Province of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Callao (Province of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Callao (Province of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Callao (Province of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Callao (Province of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Callao (Province of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Callao (Province of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Callao (Province of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Callao (Province of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Camag\xfcey (Province of Cuba)": [
            {
                "Region Name": "Camag\xfcey (Province of Cuba)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Camag\xfcey (Province of Cuba)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Camag\xfcey (Province of Cuba)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Camag\xfcey (Province of Cuba)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Camag\xfcey (Province of Cuba)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Camag\xfcey (Province of Cuba)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Camag\xfcey (Province of Cuba)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Camag\xfcey (Province of Cuba)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Camag\xfcey (Province of Cuba)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Camag\xfcey (Province of Cuba)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Camag\xfcey (Province of Cuba)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Camag\xfcey (Province of Cuba)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Camag\xfcey (Province of Cuba)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Camag\xfcey (Province of Cuba)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Camag\xfcey (Province of Cuba)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Camag\xfcey (Province of Cuba)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Camag\xfcey (Province of Cuba)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Camag\xfcey (Province of Cuba)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Camag\xfcey (Province of Cuba)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Camag\xfcey (Province of Cuba)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Camag\xfcey (Province of Cuba)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Camag\xfcey (Province of Cuba)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Camarines Norte (Province of Philippines)": [
            {
                "Region Name": "Camarines Norte (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Norte (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Norte (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Norte (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Norte (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Norte (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Norte (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Norte (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Norte (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Camarines Norte (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Norte (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Norte (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Norte (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Camarines Norte (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Norte (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Norte (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Norte (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Norte (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Camarines Norte (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Norte (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Norte (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Norte (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Camarines Sur (Province of Philippines)": [
            {
                "Region Name": "Camarines Sur (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Camarines Sur (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Camarines Sur (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Sur (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Camarines Sur (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Camarines Sur (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Sur (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Sur (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Camarines Sur (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Camarines Sur (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Sur (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Sur (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Sur (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Camarines Sur (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Sur (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Camarines Sur (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Sur (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Sur (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Camarines Sur (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Sur (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Sur (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camarines Sur (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Camiguin (Province of Philippines)": [
            {
                "Region Name": "Camiguin (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camiguin (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camiguin (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camiguin (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camiguin (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camiguin (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camiguin (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camiguin (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camiguin (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camiguin (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camiguin (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camiguin (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camiguin (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camiguin (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camiguin (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Camiguin (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camiguin (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camiguin (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camiguin (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camiguin (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camiguin (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camiguin (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Campania (Region of Italy)": [
            {
                "Region Name": "Campania (Region of Italy)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Campania (Region of Italy)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Campania (Region of Italy)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Campania (Region of Italy)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Campania (Region of Italy)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Campania (Region of Italy)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Campania (Region of Italy)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Campania (Region of Italy)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Campania (Region of Italy)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Campania (Region of Italy)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Campania (Region of Italy)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Campania (Region of Italy)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Campania (Region of Italy)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Campania (Region of Italy)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Campania (Region of Italy)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Campania (Region of Italy)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Campania (Region of Italy)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Campania (Region of Italy)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Campania (Region of Italy)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Campania (Region of Italy)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Campania (Region of Italy)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Campania (Region of Italy)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Campeche (State of M\xe9xico)": [
            {
                "Region Name": "Campeche (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Campeche (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Campeche (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Campeche (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Campeche (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Campeche (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Campeche (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Campeche (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Campeche (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Campeche (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Campeche (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Campeche (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Campeche (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Campeche (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Campeche (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Campeche (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Campeche (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Campeche (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Campeche (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Campeche (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Campeche (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Campeche (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Camuy (Municipality of Puerto Rico)": [
            {
                "Region Name": "Camuy (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camuy (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camuy (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camuy (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camuy (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camuy (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camuy (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camuy (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camuy (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camuy (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camuy (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camuy (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camuy (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camuy (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camuy (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camuy (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camuy (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camuy (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camuy (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camuy (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camuy (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Camuy (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "C\u1EA7n Th\u01A1 (City of Vietnam)": [
            {
                "Region Name": "C\u1EA7n Th\u01A1 (City of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "C\u1EA7n Th\u01A1 (City of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "C\u1EA7n Th\u01A1 (City of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "C\u1EA7n Th\u01A1 (City of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "C\u1EA7n Th\u01A1 (City of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "C\u1EA7n Th\u01A1 (City of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "C\u1EA7n Th\u01A1 (City of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "C\u1EA7n Th\u01A1 (City of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "C\u1EA7n Th\u01A1 (City of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "C\u1EA7n Th\u01A1 (City of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "C\u1EA7n Th\u01A1 (City of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 79
            },
            {
                "Region Name": "C\u1EA7n Th\u01A1 (City of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "C\u1EA7n Th\u01A1 (City of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "C\u1EA7n Th\u01A1 (City of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "C\u1EA7n Th\u01A1 (City of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "C\u1EA7n Th\u01A1 (City of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "C\u1EA7n Th\u01A1 (City of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "C\u1EA7n Th\u01A1 (City of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "C\u1EA7n Th\u01A1 (City of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "C\u1EA7n Th\u01A1 (City of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "C\u1EA7n Th\u01A1 (City of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "C\u1EA7n Th\u01A1 (City of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 31
            }
        ],
        "Can\u221A\u2265vanas (Municipality of Puerto Rico)": [
            {
                "Region Name": "Can\u221A\u2265vanas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Can\u221A\u2265vanas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Can\u221A\u2265vanas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Can\u221A\u2265vanas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Can\u221A\u2265vanas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Can\u221A\u2265vanas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Can\u221A\u2265vanas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Can\u221A\u2265vanas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Can\u221A\u2265vanas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Can\u221A\u2265vanas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Can\u221A\u2265vanas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Can\u221A\u2265vanas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Can\u221A\u2265vanas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Can\u221A\u2265vanas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Can\u221A\u2265vanas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Can\u221A\u2265vanas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Can\u221A\u2265vanas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Can\u221A\u2265vanas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Can\u221A\u2265vanas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Can\u221A\u2265vanas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Can\u221A\u2265vanas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Can\u221A\u2265vanas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\xc7anakkale (Province of Turkey)": [
            {
                "Region Name": "\xc7anakkale (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xc7anakkale (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "\xc7anakkale (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "\xc7anakkale (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xc7anakkale (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xc7anakkale (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xc7anakkale (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "\xc7anakkale (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\xc7anakkale (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xc7anakkale (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xc7anakkale (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xc7anakkale (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xc7anakkale (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "\xc7anakkale (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xc7anakkale (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xc7anakkale (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xc7anakkale (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "\xc7anakkale (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xc7anakkale (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xc7anakkale (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xc7anakkale (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "\xc7anakkale (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 39
            }
        ],
        "Ca\xf1ar (Province of Ecuador)": [
            {
                "Region Name": "Ca\xf1ar (Province of Ecuador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ca\xf1ar (Province of Ecuador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ca\xf1ar (Province of Ecuador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ca\xf1ar (Province of Ecuador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ca\xf1ar (Province of Ecuador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ca\xf1ar (Province of Ecuador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ca\xf1ar (Province of Ecuador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ca\xf1ar (Province of Ecuador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ca\xf1ar (Province of Ecuador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ca\xf1ar (Province of Ecuador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ca\xf1ar (Province of Ecuador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ca\xf1ar (Province of Ecuador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ca\xf1ar (Province of Ecuador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ca\xf1ar (Province of Ecuador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ca\xf1ar (Province of Ecuador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ca\xf1ar (Province of Ecuador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ca\xf1ar (Province of Ecuador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ca\xf1ar (Province of Ecuador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ca\xf1ar (Province of Ecuador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ca\xf1ar (Province of Ecuador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ca\xf1ar (Province of Ecuador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ca\xf1ar (Province of Ecuador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Canaries (Quarter of Saint Lucia)": [
            {
                "Region Name": "Canaries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canaries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canaries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canaries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canaries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canaries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canaries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canaries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canaries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canaries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canaries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canaries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canaries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canaries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canaries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canaries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canaries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canaries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canaries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canaries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canaries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canaries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Canelones (Department of Uruguay)": [
            {
                "Region Name": "Canelones (Department of Uruguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canelones (Department of Uruguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Canelones (Department of Uruguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Canelones (Department of Uruguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Canelones (Department of Uruguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Canelones (Department of Uruguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Canelones (Department of Uruguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Canelones (Department of Uruguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Canelones (Department of Uruguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Canelones (Department of Uruguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Canelones (Department of Uruguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canelones (Department of Uruguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canelones (Department of Uruguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canelones (Department of Uruguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Canelones (Department of Uruguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Canelones (Department of Uruguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Canelones (Department of Uruguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canelones (Department of Uruguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canelones (Department of Uruguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Canelones (Department of Uruguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Canelones (Department of Uruguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Canelones (Department of Uruguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Canillo (Parish of Andorra)": [
            {
                "Region Name": "Canillo (Parish of Andorra)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canillo (Parish of Andorra)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canillo (Parish of Andorra)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canillo (Parish of Andorra)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canillo (Parish of Andorra)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canillo (Parish of Andorra)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canillo (Parish of Andorra)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canillo (Parish of Andorra)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canillo (Parish of Andorra)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canillo (Parish of Andorra)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canillo (Parish of Andorra)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canillo (Parish of Andorra)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canillo (Parish of Andorra)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canillo (Parish of Andorra)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canillo (Parish of Andorra)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canillo (Parish of Andorra)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canillo (Parish of Andorra)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canillo (Parish of Andorra)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canillo (Parish of Andorra)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canillo (Parish of Andorra)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canillo (Parish of Andorra)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canillo (Parish of Andorra)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Canindey\xfa (Department of Paraguay)": [
            {
                "Region Name": "Canindey\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Canindey\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Canindey\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Canindey\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Canindey\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Canindey\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Canindey\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Canindey\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Canindey\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Canindey\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Canindey\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Canindey\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Canindey\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Canindey\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Canindey\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Canindey\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Canindey\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Canindey\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Canindey\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Canindey\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Canindey\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Canindey\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "\xc7ank\u0131r\u0131 (Province of Turkey)": [
            {
                "Region Name": "\xc7ank\u0131r\u0131 (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xc7ank\u0131r\u0131 (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xc7ank\u0131r\u0131 (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xc7ank\u0131r\u0131 (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xc7ank\u0131r\u0131 (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\xc7ank\u0131r\u0131 (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xc7ank\u0131r\u0131 (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xc7ank\u0131r\u0131 (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\xc7ank\u0131r\u0131 (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xc7ank\u0131r\u0131 (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "\xc7ank\u0131r\u0131 (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xc7ank\u0131r\u0131 (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xc7ank\u0131r\u0131 (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xc7ank\u0131r\u0131 (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\xc7ank\u0131r\u0131 (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "\xc7ank\u0131r\u0131 (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xc7ank\u0131r\u0131 (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xc7ank\u0131r\u0131 (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\xc7ank\u0131r\u0131 (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "\xc7ank\u0131r\u0131 (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xc7ank\u0131r\u0131 (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xc7ank\u0131r\u0131 (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Cankuzo (Province of Burundi)": [
            {
                "Region Name": "Cankuzo (Province of Burundi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cankuzo (Province of Burundi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cankuzo (Province of Burundi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cankuzo (Province of Burundi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cankuzo (Province of Burundi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cankuzo (Province of Burundi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cankuzo (Province of Burundi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cankuzo (Province of Burundi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cankuzo (Province of Burundi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cankuzo (Province of Burundi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Cankuzo (Province of Burundi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cankuzo (Province of Burundi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cankuzo (Province of Burundi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cankuzo (Province of Burundi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cankuzo (Province of Burundi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cankuzo (Province of Burundi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cankuzo (Province of Burundi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Cankuzo (Province of Burundi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cankuzo (Province of Burundi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cankuzo (Province of Burundi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Cankuzo (Province of Burundi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cankuzo (Province of Burundi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Cantabria (Autonomous Community of Spain)": [
            {
                "Region Name": "Cantabria (Autonomous Community of Spain)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cantabria (Autonomous Community of Spain)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cantabria (Autonomous Community of Spain)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cantabria (Autonomous Community of Spain)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cantabria (Autonomous Community of Spain)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cantabria (Autonomous Community of Spain)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Cantabria (Autonomous Community of Spain)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cantabria (Autonomous Community of Spain)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cantabria (Autonomous Community of Spain)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cantabria (Autonomous Community of Spain)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cantabria (Autonomous Community of Spain)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cantabria (Autonomous Community of Spain)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cantabria (Autonomous Community of Spain)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cantabria (Autonomous Community of Spain)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cantabria (Autonomous Community of Spain)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cantabria (Autonomous Community of Spain)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cantabria (Autonomous Community of Spain)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cantabria (Autonomous Community of Spain)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cantabria (Autonomous Community of Spain)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cantabria (Autonomous Community of Spain)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cantabria (Autonomous Community of Spain)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cantabria (Autonomous Community of Spain)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Cantemir (District of Moldova)": [
            {
                "Region Name": "Cantemir (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cantemir (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cantemir (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cantemir (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cantemir (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cantemir (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cantemir (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cantemir (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cantemir (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cantemir (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cantemir (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cantemir (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cantemir (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cantemir (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cantemir (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cantemir (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cantemir (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cantemir (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cantemir (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cantemir (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cantemir (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cantemir (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Canterbury (Region of New Zealand)": [
            {
                "Region Name": "Canterbury (Region of New Zealand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canterbury (Region of New Zealand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Canterbury (Region of New Zealand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Canterbury (Region of New Zealand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Canterbury (Region of New Zealand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Canterbury (Region of New Zealand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Canterbury (Region of New Zealand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Canterbury (Region of New Zealand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canterbury (Region of New Zealand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canterbury (Region of New Zealand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canterbury (Region of New Zealand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Canterbury (Region of New Zealand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canterbury (Region of New Zealand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canterbury (Region of New Zealand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Canterbury (Region of New Zealand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Canterbury (Region of New Zealand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canterbury (Region of New Zealand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Canterbury (Region of New Zealand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Canterbury (Region of New Zealand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Canterbury (Region of New Zealand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Canterbury (Region of New Zealand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Canterbury (Region of New Zealand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Cao B\u1EB1ng (Province of Vietnam)": [
            {
                "Region Name": "Cao B\u1EB1ng (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cao B\u1EB1ng (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cao B\u1EB1ng (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cao B\u1EB1ng (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cao B\u1EB1ng (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cao B\u1EB1ng (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cao B\u1EB1ng (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cao B\u1EB1ng (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cao B\u1EB1ng (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cao B\u1EB1ng (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cao B\u1EB1ng (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cao B\u1EB1ng (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cao B\u1EB1ng (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cao B\u1EB1ng (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cao B\u1EB1ng (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cao B\u1EB1ng (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cao B\u1EB1ng (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cao B\u1EB1ng (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cao B\u1EB1ng (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cao B\u1EB1ng (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cao B\u1EB1ng (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cao B\u1EB1ng (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Capital (Governorate of Bahrain)": [
            {
                "Region Name": "Capital (Governorate of Bahrain)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capital (Governorate of Bahrain)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capital (Governorate of Bahrain)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capital (Governorate of Bahrain)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capital (Governorate of Bahrain)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capital (Governorate of Bahrain)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capital (Governorate of Bahrain)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capital (Governorate of Bahrain)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capital (Governorate of Bahrain)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capital (Governorate of Bahrain)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capital (Governorate of Bahrain)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capital (Governorate of Bahrain)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capital (Governorate of Bahrain)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capital (Governorate of Bahrain)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capital (Governorate of Bahrain)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capital (Governorate of Bahrain)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capital (Governorate of Bahrain)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capital (Governorate of Bahrain)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capital (Governorate of Bahrain)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capital (Governorate of Bahrain)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capital (Governorate of Bahrain)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capital (Governorate of Bahrain)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Capiz (Province of Philippines)": [
            {
                "Region Name": "Capiz (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capiz (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capiz (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Capiz (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capiz (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capiz (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Capiz (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capiz (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Capiz (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Capiz (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capiz (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Capiz (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capiz (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capiz (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capiz (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Capiz (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capiz (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Capiz (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Capiz (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Capiz (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capiz (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Capiz (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Caquet\xe1 (Intendancy of Colombia)": [
            {
                "Region Name": "Caquet\xe1 (Intendancy of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Caquet\xe1 (Intendancy of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Caquet\xe1 (Intendancy of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Caquet\xe1 (Intendancy of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Caquet\xe1 (Intendancy of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Caquet\xe1 (Intendancy of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Caquet\xe1 (Intendancy of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Caquet\xe1 (Intendancy of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Caquet\xe1 (Intendancy of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Caquet\xe1 (Intendancy of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Caquet\xe1 (Intendancy of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Caquet\xe1 (Intendancy of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Caquet\xe1 (Intendancy of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Caquet\xe1 (Intendancy of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Caquet\xe1 (Intendancy of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Caquet\xe1 (Intendancy of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Caquet\xe1 (Intendancy of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Caquet\xe1 (Intendancy of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Caquet\xe1 (Intendancy of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Caquet\xe1 (Intendancy of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Caquet\xe1 (Intendancy of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Caquet\xe1 (Intendancy of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Carabobo (State of Venezuela)": [
            {
                "Region Name": "Carabobo (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Carabobo (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Carabobo (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Carabobo (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Carabobo (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Carabobo (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Carabobo (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Carabobo (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Carabobo (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Carabobo (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Carabobo (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Carabobo (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Carabobo (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Carabobo (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Carabobo (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Carabobo (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Carabobo (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Carabobo (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Carabobo (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Carabobo (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Carabobo (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Carabobo (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Cara\u0219-Severin (County of Romania)": [
            {
                "Region Name": "Cara\u0219-Severin (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cara\u0219-Severin (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cara\u0219-Severin (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cara\u0219-Severin (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cara\u0219-Severin (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cara\u0219-Severin (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cara\u0219-Severin (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cara\u0219-Severin (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cara\u0219-Severin (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cara\u0219-Severin (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cara\u0219-Severin (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cara\u0219-Severin (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cara\u0219-Severin (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cara\u0219-Severin (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cara\u0219-Severin (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cara\u0219-Severin (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cara\u0219-Severin (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cara\u0219-Severin (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cara\u0219-Severin (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cara\u0219-Severin (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cara\u0219-Severin (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cara\u0219-Severin (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Carazo (Department of Nicaragua)": [
            {
                "Region Name": "Carazo (Department of Nicaragua)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Carazo (Department of Nicaragua)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carazo (Department of Nicaragua)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Carazo (Department of Nicaragua)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Carazo (Department of Nicaragua)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Carazo (Department of Nicaragua)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Carazo (Department of Nicaragua)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carazo (Department of Nicaragua)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carazo (Department of Nicaragua)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carazo (Department of Nicaragua)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Carazo (Department of Nicaragua)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Carazo (Department of Nicaragua)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Carazo (Department of Nicaragua)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Carazo (Department of Nicaragua)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Carazo (Department of Nicaragua)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carazo (Department of Nicaragua)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carazo (Department of Nicaragua)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Carazo (Department of Nicaragua)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Carazo (Department of Nicaragua)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Carazo (Department of Nicaragua)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carazo (Department of Nicaragua)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carazo (Department of Nicaragua)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Carchi (Province of Ecuador)": [
            {
                "Region Name": "Carchi (Province of Ecuador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Carchi (Province of Ecuador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Carchi (Province of Ecuador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Carchi (Province of Ecuador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Carchi (Province of Ecuador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Carchi (Province of Ecuador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carchi (Province of Ecuador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carchi (Province of Ecuador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Carchi (Province of Ecuador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carchi (Province of Ecuador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carchi (Province of Ecuador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Carchi (Province of Ecuador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carchi (Province of Ecuador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Carchi (Province of Ecuador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Carchi (Province of Ecuador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Carchi (Province of Ecuador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carchi (Province of Ecuador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Carchi (Province of Ecuador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Carchi (Province of Ecuador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carchi (Province of Ecuador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carchi (Province of Ecuador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carchi (Province of Ecuador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Carlow (County of Ireland)": [
            {
                "Region Name": "Carlow (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carlow (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Carlow (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carlow (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carlow (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carlow (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Carlow (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carlow (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carlow (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carlow (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carlow (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carlow (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carlow (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carlow (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carlow (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carlow (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carlow (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carlow (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carlow (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carlow (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carlow (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carlow (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Carolina (Municipality of Puerto Rico)": [
            {
                "Region Name": "Carolina (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carolina (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carolina (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carolina (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carolina (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carolina (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carolina (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carolina (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carolina (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carolina (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carolina (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carolina (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carolina (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carolina (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carolina (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carolina (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carolina (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carolina (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carolina (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carolina (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Carolina (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carolina (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Carriacou (Dependency of Grenada)": [
            {
                "Region Name": "Carriacou (Dependency of Grenada)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carriacou (Dependency of Grenada)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carriacou (Dependency of Grenada)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carriacou (Dependency of Grenada)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carriacou (Dependency of Grenada)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carriacou (Dependency of Grenada)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carriacou (Dependency of Grenada)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carriacou (Dependency of Grenada)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carriacou (Dependency of Grenada)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carriacou (Dependency of Grenada)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carriacou (Dependency of Grenada)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carriacou (Dependency of Grenada)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carriacou (Dependency of Grenada)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carriacou (Dependency of Grenada)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carriacou (Dependency of Grenada)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carriacou (Dependency of Grenada)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carriacou (Dependency of Grenada)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carriacou (Dependency of Grenada)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carriacou (Dependency of Grenada)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carriacou (Dependency of Grenada)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carriacou (Dependency of Grenada)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Carriacou (Dependency of Grenada)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cartago (Province of Costa Rica)": [
            {
                "Region Name": "Cartago (Province of Costa Rica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cartago (Province of Costa Rica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cartago (Province of Costa Rica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cartago (Province of Costa Rica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cartago (Province of Costa Rica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cartago (Province of Costa Rica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cartago (Province of Costa Rica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cartago (Province of Costa Rica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cartago (Province of Costa Rica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cartago (Province of Costa Rica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cartago (Province of Costa Rica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cartago (Province of Costa Rica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cartago (Province of Costa Rica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cartago (Province of Costa Rica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cartago (Province of Costa Rica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cartago (Province of Costa Rica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cartago (Province of Costa Rica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cartago (Province of Costa Rica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cartago (Province of Costa Rica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cartago (Province of Costa Rica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cartago (Province of Costa Rica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cartago (Province of Costa Rica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Casanare (Intendancy of Colombia)": [
            {
                "Region Name": "Casanare (Intendancy of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Casanare (Intendancy of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Casanare (Intendancy of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Casanare (Intendancy of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Casanare (Intendancy of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Casanare (Intendancy of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Casanare (Intendancy of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Casanare (Intendancy of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Casanare (Intendancy of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Casanare (Intendancy of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Casanare (Intendancy of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Casanare (Intendancy of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Casanare (Intendancy of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Casanare (Intendancy of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Casanare (Intendancy of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Casanare (Intendancy of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Casanare (Intendancy of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Casanare (Intendancy of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Casanare (Intendancy of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Casanare (Intendancy of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Casanare (Intendancy of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Casanare (Intendancy of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Cascade (District of Seychelles)": [
            {
                "Region Name": "Cascade (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cascade (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cascade (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cascade (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cascade (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cascade (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cascade (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cascade (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cascade (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cascade (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cascade (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cascade (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cascade (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cascade (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cascade (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cascade (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cascade (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cascade (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cascade (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cascade (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cascade (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cascade (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cascades (Region of Burkina Faso)": [
            {
                "Region Name": "Cascades (Region of Burkina Faso)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Cascades (Region of Burkina Faso)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Cascades (Region of Burkina Faso)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Cascades (Region of Burkina Faso)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cascades (Region of Burkina Faso)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cascades (Region of Burkina Faso)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cascades (Region of Burkina Faso)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cascades (Region of Burkina Faso)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Cascades (Region of Burkina Faso)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cascades (Region of Burkina Faso)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cascades (Region of Burkina Faso)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cascades (Region of Burkina Faso)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cascades (Region of Burkina Faso)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cascades (Region of Burkina Faso)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cascades (Region of Burkina Faso)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Cascades (Region of Burkina Faso)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Cascades (Region of Burkina Faso)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Cascades (Region of Burkina Faso)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Cascades (Region of Burkina Faso)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Cascades (Region of Burkina Faso)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cascades (Region of Burkina Faso)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cascades (Region of Burkina Faso)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 23
            }
        ],
        "Castel (Parish of Guernsey)": [
            {
                "Region Name": "Castel (Parish of Guernsey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castel (Parish of Guernsey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castel (Parish of Guernsey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castel (Parish of Guernsey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castel (Parish of Guernsey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castel (Parish of Guernsey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castel (Parish of Guernsey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castel (Parish of Guernsey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castel (Parish of Guernsey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castel (Parish of Guernsey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castel (Parish of Guernsey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castel (Parish of Guernsey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castel (Parish of Guernsey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castel (Parish of Guernsey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castel (Parish of Guernsey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castel (Parish of Guernsey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castel (Parish of Guernsey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castel (Parish of Guernsey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castel (Parish of Guernsey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castel (Parish of Guernsey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castel (Parish of Guernsey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castel (Parish of Guernsey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Castelo Branco (District of Portugal)": [
            {
                "Region Name": "Castelo Branco (District of Portugal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Castelo Branco (District of Portugal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 173
            },
            {
                "Region Name": "Castelo Branco (District of Portugal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Castelo Branco (District of Portugal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Castelo Branco (District of Portugal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Castelo Branco (District of Portugal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castelo Branco (District of Portugal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Castelo Branco (District of Portugal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castelo Branco (District of Portugal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Castelo Branco (District of Portugal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Castelo Branco (District of Portugal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Castelo Branco (District of Portugal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Castelo Branco (District of Portugal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castelo Branco (District of Portugal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Castelo Branco (District of Portugal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Castelo Branco (District of Portugal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 76
            },
            {
                "Region Name": "Castelo Branco (District of Portugal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castelo Branco (District of Portugal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Castelo Branco (District of Portugal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 68
            },
            {
                "Region Name": "Castelo Branco (District of Portugal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castelo Branco (District of Portugal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Castelo Branco (District of Portugal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 36
            }
        ],
        "Castilla-La Mancha (Autonomous Community of Spain)": [
            {
                "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Castilla-La Mancha (Autonomous Community of Spain)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Castilla y Le\xf3n (Autonomous Community of Spain)": [
            {
                "Region Name": "Castilla y Le\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Castilla y Le\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Castilla y Le\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Castilla y Le\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Castilla y Le\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Castilla y Le\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Castilla y Le\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Castilla y Le\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Castilla y Le\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Castilla y Le\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Castilla y Le\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Castilla y Le\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Castilla y Le\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Castilla y Le\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Castilla y Le\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Castilla y Le\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Castilla y Le\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Castilla y Le\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Castilla y Le\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Castilla y Le\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Castilla y Le\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 96
            },
            {
                "Region Name": "Castilla y Le\xf3n (Autonomous Community of Spain)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Castletown (Town District of Isle of Man)": [
            {
                "Region Name": "Castletown (Town District of Isle of Man)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castletown (Town District of Isle of Man)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castletown (Town District of Isle of Man)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castletown (Town District of Isle of Man)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castletown (Town District of Isle of Man)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castletown (Town District of Isle of Man)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castletown (Town District of Isle of Man)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castletown (Town District of Isle of Man)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castletown (Town District of Isle of Man)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castletown (Town District of Isle of Man)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castletown (Town District of Isle of Man)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castletown (Town District of Isle of Man)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castletown (Town District of Isle of Man)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castletown (Town District of Isle of Man)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castletown (Town District of Isle of Man)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castletown (Town District of Isle of Man)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castletown (Town District of Isle of Man)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castletown (Town District of Isle of Man)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castletown (Town District of Isle of Man)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castletown (Town District of Isle of Man)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castletown (Town District of Isle of Man)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castletown (Town District of Isle of Man)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Castries (Quarter of Saint Lucia)": [
            {
                "Region Name": "Castries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Castries (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cat Island (District of Bahamas)": [
            {
                "Region Name": "Cat Island (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cat Island (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cat Island (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cat Island (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cat Island (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cat Island (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cat Island (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cat Island (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cat Island (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cat Island (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cat Island (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cat Island (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cat Island (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cat Island (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cat Island (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cat Island (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cat Island (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cat Island (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cat Island (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cat Island (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cat Island (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cat Island (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cata\u221A\xb1o (Municipality of Puerto Rico)": [
            {
                "Region Name": "Cata\u221A\xb1o (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cata\u221A\xb1o (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cata\u221A\xb1o (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cata\u221A\xb1o (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cata\u221A\xb1o (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cata\u221A\xb1o (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cata\u221A\xb1o (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cata\u221A\xb1o (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cata\u221A\xb1o (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cata\u221A\xb1o (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cata\u221A\xb1o (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cata\u221A\xb1o (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cata\u221A\xb1o (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cata\u221A\xb1o (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cata\u221A\xb1o (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cata\u221A\xb1o (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cata\u221A\xb1o (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cata\u221A\xb1o (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cata\u221A\xb1o (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cata\u221A\xb1o (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cata\u221A\xb1o (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cata\u221A\xb1o (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Catalu\xf1a (Autonomous Community of Spain)": [
            {
                "Region Name": "Catalu\xf1a (Autonomous Community of Spain)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Catalu\xf1a (Autonomous Community of Spain)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Catalu\xf1a (Autonomous Community of Spain)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Catalu\xf1a (Autonomous Community of Spain)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Catalu\xf1a (Autonomous Community of Spain)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Catalu\xf1a (Autonomous Community of Spain)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Catalu\xf1a (Autonomous Community of Spain)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catalu\xf1a (Autonomous Community of Spain)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Catalu\xf1a (Autonomous Community of Spain)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Catalu\xf1a (Autonomous Community of Spain)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Catalu\xf1a (Autonomous Community of Spain)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Catalu\xf1a (Autonomous Community of Spain)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Catalu\xf1a (Autonomous Community of Spain)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Catalu\xf1a (Autonomous Community of Spain)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Catalu\xf1a (Autonomous Community of Spain)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Catalu\xf1a (Autonomous Community of Spain)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catalu\xf1a (Autonomous Community of Spain)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catalu\xf1a (Autonomous Community of Spain)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "Catalu\xf1a (Autonomous Community of Spain)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catalu\xf1a (Autonomous Community of Spain)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Catalu\xf1a (Autonomous Community of Spain)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Catalu\xf1a (Autonomous Community of Spain)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Catamarca (Province of Argentina)": [
            {
                "Region Name": "Catamarca (Province of Argentina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Catamarca (Province of Argentina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Catamarca (Province of Argentina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Catamarca (Province of Argentina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Catamarca (Province of Argentina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Catamarca (Province of Argentina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Catamarca (Province of Argentina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Catamarca (Province of Argentina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Catamarca (Province of Argentina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Catamarca (Province of Argentina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Catamarca (Province of Argentina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Catamarca (Province of Argentina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Catamarca (Province of Argentina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Catamarca (Province of Argentina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Catamarca (Province of Argentina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Catamarca (Province of Argentina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Catamarca (Province of Argentina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Catamarca (Province of Argentina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Catamarca (Province of Argentina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Catamarca (Province of Argentina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Catamarca (Province of Argentina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Catamarca (Province of Argentina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Catanduanes (Province of Philippines)": [
            {
                "Region Name": "Catanduanes (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catanduanes (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catanduanes (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catanduanes (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catanduanes (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catanduanes (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catanduanes (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catanduanes (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catanduanes (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catanduanes (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catanduanes (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catanduanes (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catanduanes (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catanduanes (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catanduanes (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catanduanes (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catanduanes (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catanduanes (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catanduanes (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catanduanes (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catanduanes (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Catanduanes (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cauca (Department of Colombia)": [
            {
                "Region Name": "Cauca (Department of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cauca (Department of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cauca (Department of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cauca (Department of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cauca (Department of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cauca (Department of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cauca (Department of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cauca (Department of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cauca (Department of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cauca (Department of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cauca (Department of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cauca (Department of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cauca (Department of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cauca (Department of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cauca (Department of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cauca (Department of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cauca (Department of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cauca (Department of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cauca (Department of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cauca (Department of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cauca (Department of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cauca (Department of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Causeni (District of Moldova)": [
            {
                "Region Name": "Causeni (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Causeni (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Causeni (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Causeni (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Causeni (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Causeni (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Causeni (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Causeni (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Causeni (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Causeni (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Causeni (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Causeni (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Causeni (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Causeni (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Causeni (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Causeni (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Causeni (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Causeni (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Causeni (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Causeni (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Causeni (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Causeni (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Cavan (County of Ireland)": [
            {
                "Region Name": "Cavan (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavan (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavan (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavan (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavan (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavan (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cavan (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavan (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavan (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavan (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cavan (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavan (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavan (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavan (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavan (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavan (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavan (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavan (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavan (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavan (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavan (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavan (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cavite (Province of Philippines)": [
            {
                "Region Name": "Cavite (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cavite (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavite (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavite (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cavite (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavite (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavite (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cavite (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavite (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavite (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavite (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavite (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavite (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavite (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavite (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavite (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavite (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavite (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavite (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cavite (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavite (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cavite (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cayenne (Arrondissement of French Guiana)": [
            {
                "Region Name": "Cayenne (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cayenne (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cayenne (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cayenne (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cayenne (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cayenne (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cayenne (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cayenne (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cayenne (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cayenne (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayenne (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cayenne (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cayenne (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cayenne (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cayenne (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cayenne (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayenne (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cayenne (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cayenne (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cayenne (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayenne (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cayenne (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Cayey (Municipality of Puerto Rico)": [
            {
                "Region Name": "Cayey (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayey (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayey (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayey (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayey (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayey (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayey (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayey (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayey (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayey (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayey (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayey (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayey (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayey (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayey (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayey (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayey (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayey (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayey (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayey (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayey (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cayey (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cayo (District of Belize)": [
            {
                "Region Name": "Cayo (District of Belize)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cayo (District of Belize)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cayo (District of Belize)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cayo (District of Belize)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cayo (District of Belize)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cayo (District of Belize)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Cayo (District of Belize)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cayo (District of Belize)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cayo (District of Belize)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cayo (District of Belize)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Cayo (District of Belize)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cayo (District of Belize)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cayo (District of Belize)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cayo (District of Belize)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cayo (District of Belize)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cayo (District of Belize)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cayo (District of Belize)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cayo (District of Belize)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cayo (District of Belize)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cayo (District of Belize)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cayo (District of Belize)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cayo (District of Belize)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Cear\xe1 (State of Brazil)": [
            {
                "Region Name": "Cear\xe1 (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cear\xe1 (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cear\xe1 (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cear\xe1 (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cear\xe1 (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cear\xe1 (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cear\xe1 (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cear\xe1 (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cear\xe1 (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cear\xe1 (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cear\xe1 (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cear\xe1 (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cear\xe1 (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cear\xe1 (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cear\xe1 (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cear\xe1 (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cear\xe1 (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cear\xe1 (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cear\xe1 (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cear\xe1 (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cear\xe1 (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cear\xe1 (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Cebu (Province of Philippines)": [
            {
                "Region Name": "Cebu (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cebu (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cebu (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cebu (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cebu (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cebu (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cebu (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cebu (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cebu (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cebu (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cebu (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cebu (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cebu (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cebu (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cebu (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cebu (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cebu (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cebu (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cebu (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cebu (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cebu (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cebu (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ceiba (Municipality of Puerto Rico)": [
            {
                "Region Name": "Ceiba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceiba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceiba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceiba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceiba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceiba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceiba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceiba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceiba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceiba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceiba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceiba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceiba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceiba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceiba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceiba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceiba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceiba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceiba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceiba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceiba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceiba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Centar (Municipality of North Macedonia)": [
            {
                "Region Name": "Centar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Centar \u017Dupa (Municipality of North Macedonia)": [
            {
                "Region Name": "Centar \u017Dupa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar \u017Dupa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar \u017Dupa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar \u017Dupa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar \u017Dupa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar \u017Dupa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar \u017Dupa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar \u017Dupa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar \u017Dupa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar \u017Dupa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar \u017Dupa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar \u017Dupa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar \u017Dupa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar \u017Dupa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar \u017Dupa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar \u017Dupa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar \u017Dupa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar \u017Dupa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar \u017Dupa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar \u017Dupa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar \u017Dupa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centar \u017Dupa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Central (Department of Paraguay)": [
            {
                "Region Name": "Central (Department of Paraguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Central (Department of Paraguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Central (Department of Paraguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Central (Department of Paraguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Central (Department of Paraguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Central (Department of Paraguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Central (Department of Paraguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Central (Department of Paraguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Central (Department of Paraguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Central (Department of Paraguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Central (Department of Paraguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Central (Department of Paraguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Central (Department of Paraguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Central (Department of Paraguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Central (Department of Paraguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Central (Department of Paraguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Central (Department of Paraguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Central (Department of Paraguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Central (Department of Paraguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Central (Department of Paraguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Central (Department of Paraguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Central (Department of Paraguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Central (Development Region of Nepal)": [
            {
                "Region Name": "Central (Development Region of Nepal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Central (Development Region of Nepal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Central (Development Region of Nepal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Central (Development Region of Nepal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Central (Development Region of Nepal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Central (Development Region of Nepal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Central (Development Region of Nepal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Central (Development Region of Nepal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Central (Development Region of Nepal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Central (Development Region of Nepal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Central (Development Region of Nepal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Central (Development Region of Nepal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Central (Development Region of Nepal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Central (Development Region of Nepal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Central (Development Region of Nepal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Central (Development Region of Nepal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Central (Development Region of Nepal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Central (Development Region of Nepal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Central (Development Region of Nepal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Central (Development Region of Nepal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Central (Development Region of Nepal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Central (Development Region of Nepal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 33
            }
        ],
        "Central (District of Botswana)": [
            {
                "Region Name": "Central (District of Botswana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 71
            },
            {
                "Region Name": "Central (District of Botswana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 128
            },
            {
                "Region Name": "Central (District of Botswana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Central (District of Botswana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 279
            },
            {
                "Region Name": "Central (District of Botswana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 88
            },
            {
                "Region Name": "Central (District of Botswana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Central (District of Botswana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 238
            },
            {
                "Region Name": "Central (District of Botswana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Central (District of Botswana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 384
            },
            {
                "Region Name": "Central (District of Botswana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 212
            },
            {
                "Region Name": "Central (District of Botswana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 190
            },
            {
                "Region Name": "Central (District of Botswana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 71
            },
            {
                "Region Name": "Central (District of Botswana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 119
            },
            {
                "Region Name": "Central (District of Botswana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Central (District of Botswana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 67
            },
            {
                "Region Name": "Central (District of Botswana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 135
            },
            {
                "Region Name": "Central (District of Botswana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 84
            },
            {
                "Region Name": "Central (District of Botswana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 87
            },
            {
                "Region Name": "Central (District of Botswana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Central (District of Botswana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 98
            },
            {
                "Region Name": "Central (District of Botswana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 161
            },
            {
                "Region Name": "Central (District of Botswana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 177
            }
        ],
        "Central (Division of Fiji)": [
            {
                "Region Name": "Central (Division of Fiji)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Division of Fiji)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Division of Fiji)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Division of Fiji)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Division of Fiji)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Division of Fiji)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Division of Fiji)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Division of Fiji)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Division of Fiji)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Division of Fiji)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Division of Fiji)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Division of Fiji)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Division of Fiji)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Division of Fiji)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Division of Fiji)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Division of Fiji)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Division of Fiji)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Division of Fiji)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Division of Fiji)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Division of Fiji)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Division of Fiji)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Division of Fiji)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Central (Province of Papua New Guinea)": [
            {
                "Region Name": "Central (Province of Papua New Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Central (Province of Papua New Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Central (Province of Papua New Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Central (Province of Papua New Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Central (Province of Papua New Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Central (Province of Papua New Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Central (Province of Papua New Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Central (Province of Papua New Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Central (Province of Papua New Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Central (Province of Papua New Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Central (Province of Papua New Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Central (Province of Papua New Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Central (Province of Papua New Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Central (Province of Papua New Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Central (Province of Papua New Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Central (Province of Papua New Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Central (Province of Papua New Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Central (Province of Papua New Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Central (Province of Papua New Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Central (Province of Papua New Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Central (Province of Papua New Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Central (Province of Papua New Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Central (Province of Solomon Islands)": [
            {
                "Region Name": "Central (Province of Solomon Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Province of Solomon Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Province of Solomon Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Province of Solomon Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Province of Solomon Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Province of Solomon Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Province of Solomon Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Province of Solomon Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Province of Solomon Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Province of Solomon Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Province of Solomon Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Province of Solomon Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Province of Solomon Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Province of Solomon Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Province of Solomon Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Province of Solomon Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Province of Solomon Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Province of Solomon Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Province of Solomon Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Province of Solomon Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Province of Solomon Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Province of Solomon Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Central (Province of Zambia)": [
            {
                "Region Name": "Central (Province of Zambia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Central (Province of Zambia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Central (Province of Zambia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Central (Province of Zambia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Central (Province of Zambia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Central (Province of Zambia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Central (Province of Zambia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Central (Province of Zambia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Central (Province of Zambia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Central (Province of Zambia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Central (Province of Zambia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Central (Province of Zambia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Central (Province of Zambia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Central (Province of Zambia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Central (Province of Zambia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Central (Province of Zambia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Central (Province of Zambia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Central (Province of Zambia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Central (Province of Zambia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Central (Province of Zambia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Central (Province of Zambia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Central (Province of Zambia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Central (Region of Ghana)": [
            {
                "Region Name": "Central (Region of Ghana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Central (Region of Ghana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Central (Region of Ghana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Central (Region of Ghana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Central (Region of Ghana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Central (Region of Ghana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Central (Region of Ghana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Central (Region of Ghana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Central (Region of Ghana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Central (Region of Ghana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Central (Region of Ghana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Central (Region of Ghana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Central (Region of Ghana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Central (Region of Ghana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Central (Region of Ghana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Central (Region of Ghana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Central (Region of Ghana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Central (Region of Ghana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Central (Region of Ghana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Central (Region of Ghana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Central (Region of Ghana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Central (Region of Ghana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Central (Region of Singapore)": [
            {
                "Region Name": "Central (Region of Singapore)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Region of Singapore)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Region of Singapore)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Region of Singapore)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Region of Singapore)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Region of Singapore)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Region of Singapore)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Region of Singapore)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Region of Singapore)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Region of Singapore)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Region of Singapore)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Region of Singapore)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Region of Singapore)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Region of Singapore)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Region of Singapore)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Region of Singapore)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Region of Singapore)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Region of Singapore)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Region of Singapore)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Region of Singapore)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Region of Singapore)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central (Region of Singapore)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Central Abaco (District of Bahamas)": [
            {
                "Region Name": "Central Abaco (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Abaco (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Central Abaco (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 63
            },
            {
                "Region Name": "Central Abaco (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Central Abaco (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Central Abaco (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Central Abaco (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Central Abaco (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Central Abaco (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Central Abaco (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Central Abaco (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Central Abaco (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Central Abaco (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Central Abaco (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Central Abaco (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Central Abaco (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Central Abaco (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Abaco (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Abaco (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Central Abaco (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Abaco (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Central Abaco (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Central Andros (District of Bahamas)": [
            {
                "Region Name": "Central Andros (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Central Andros (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Andros (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Andros (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Andros (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Andros (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Andros (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Central Andros (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Andros (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Andros (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Andros (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Central Andros (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Andros (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Andros (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Andros (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Andros (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Central Andros (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Andros (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Andros (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Andros (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Andros (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Andros (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Central Darfur (State of Sudan)": [
            {
                "Region Name": "Central Darfur (State of Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Central Darfur (State of Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Central Darfur (State of Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Central Darfur (State of Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Central Darfur (State of Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Central Darfur (State of Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Central Darfur (State of Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Central Darfur (State of Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Central Darfur (State of Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Central Darfur (State of Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Central Darfur (State of Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Central Darfur (State of Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 65
            },
            {
                "Region Name": "Central Darfur (State of Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Central Darfur (State of Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Central Darfur (State of Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Central Darfur (State of Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Central Darfur (State of Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Central Darfur (State of Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Central Darfur (State of Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Central Darfur (State of Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Central Darfur (State of Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Central Darfur (State of Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 32
            }
        ],
        "Central Eleuthera (District of Bahamas)": [
            {
                "Region Name": "Central Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Central Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Central Equatoria (State of South Sudan)": [
            {
                "Region Name": "Central Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Central Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Central Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Central Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 71
            },
            {
                "Region Name": "Central Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Central Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Central Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Central Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Central Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Central Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Central Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Central Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Central Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Central Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Central Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Central Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Central Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Central Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Central Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Central Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Central Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Central Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 29
            }
        ],
        "Centre-Est (Region of Burkina Faso)": [
            {
                "Region Name": "Centre-Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Centre-Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Centre-Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Centre-Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Centre-Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Centre-Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Centre-Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Centre-Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Centre-Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Centre-Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Centre-Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Centre-Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Centre-Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Centre-Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Centre-Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Centre-Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Centre-Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Centre-Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Centre-Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Centre-Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Centre-Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Centre-Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 43
            }
        ],
        "Centre-Nord (Region of Burkina Faso)": [
            {
                "Region Name": "Centre-Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Centre-Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Centre-Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Centre-Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Centre-Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Centre-Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Centre-Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Centre-Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Centre-Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Centre-Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Centre-Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Centre-Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centre-Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Centre-Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centre-Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Centre-Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Centre-Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Centre-Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Centre-Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Centre-Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 113
            },
            {
                "Region Name": "Centre-Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 73
            },
            {
                "Region Name": "Centre-Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 81
            }
        ],
        "Centre-Ouest (Region of Burkina Faso)": [
            {
                "Region Name": "Centre-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Centre-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Centre-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Centre-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Centre-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Centre-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Centre-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Centre-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Centre-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Centre-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Centre-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Centre-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Centre-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Centre-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Centre-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Centre-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Centre-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Centre-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Centre-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Centre-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Centre-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Centre-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Centre-Sud (Region of Burkina Faso)": [
            {
                "Region Name": "Centre-Sud (Region of Burkina Faso)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Centre-Sud (Region of Burkina Faso)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Centre-Sud (Region of Burkina Faso)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Centre-Sud (Region of Burkina Faso)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Centre-Sud (Region of Burkina Faso)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Centre-Sud (Region of Burkina Faso)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Centre-Sud (Region of Burkina Faso)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Centre-Sud (Region of Burkina Faso)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Centre-Sud (Region of Burkina Faso)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Centre-Sud (Region of Burkina Faso)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Centre-Sud (Region of Burkina Faso)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Centre-Sud (Region of Burkina Faso)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Centre-Sud (Region of Burkina Faso)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Centre-Sud (Region of Burkina Faso)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Centre-Sud (Region of Burkina Faso)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Centre-Sud (Region of Burkina Faso)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Centre-Sud (Region of Burkina Faso)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Centre-Sud (Region of Burkina Faso)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Centre-Sud (Region of Burkina Faso)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Centre-Sud (Region of Burkina Faso)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Centre-Sud (Region of Burkina Faso)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Centre-Sud (Region of Burkina Faso)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Centre-Val de Loire (Region of France)": [
            {
                "Region Name": "Centre-Val de Loire (Region of France)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Centre-Val de Loire (Region of France)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Centre-Val de Loire (Region of France)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Centre-Val de Loire (Region of France)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Centre-Val de Loire (Region of France)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Centre-Val de Loire (Region of France)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Centre-Val de Loire (Region of France)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Centre-Val de Loire (Region of France)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Centre-Val de Loire (Region of France)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Centre-Val de Loire (Region of France)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Centre-Val de Loire (Region of France)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Centre-Val de Loire (Region of France)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centre-Val de Loire (Region of France)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Centre-Val de Loire (Region of France)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Centre-Val de Loire (Region of France)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Centre-Val de Loire (Region of France)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Centre-Val de Loire (Region of France)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centre-Val de Loire (Region of France)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Centre-Val de Loire (Region of France)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Centre-Val de Loire (Region of France)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Centre-Val de Loire (Region of France)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Centre-Val de Loire (Region of France)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Centre (Department of Haiti)": [
            {
                "Region Name": "Centre (Department of Haiti)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Centre (Department of Haiti)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Centre (Department of Haiti)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Centre (Department of Haiti)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Centre (Department of Haiti)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Centre (Department of Haiti)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Centre (Department of Haiti)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Centre (Department of Haiti)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Centre (Department of Haiti)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Centre (Department of Haiti)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Centre (Department of Haiti)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Centre (Department of Haiti)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Centre (Department of Haiti)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centre (Department of Haiti)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Centre (Department of Haiti)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Centre (Department of Haiti)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Centre (Department of Haiti)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Centre (Department of Haiti)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Centre (Department of Haiti)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centre (Department of Haiti)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Centre (Department of Haiti)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Centre (Department of Haiti)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Centre (Region of Burkina Faso)": [
            {
                "Region Name": "Centre (Region of Burkina Faso)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Centre (Region of Burkina Faso)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Centre (Region of Burkina Faso)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Centre (Region of Burkina Faso)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Centre (Region of Burkina Faso)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Centre (Region of Burkina Faso)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Centre (Region of Burkina Faso)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Centre (Region of Burkina Faso)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Centre (Region of Burkina Faso)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Centre (Region of Burkina Faso)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Centre (Region of Burkina Faso)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Centre (Region of Burkina Faso)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Centre (Region of Burkina Faso)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Centre (Region of Burkina Faso)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Centre (Region of Burkina Faso)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Centre (Region of Burkina Faso)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Centre (Region of Burkina Faso)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Centre (Region of Burkina Faso)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Centre (Region of Burkina Faso)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Centre (Region of Burkina Faso)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Centre (Region of Burkina Faso)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Centre (Region of Burkina Faso)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Centre (Region of Cameroon)": [
            {
                "Region Name": "Centre (Region of Cameroon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Centre (Region of Cameroon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Centre (Region of Cameroon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Centre (Region of Cameroon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Centre (Region of Cameroon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Centre (Region of Cameroon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Centre (Region of Cameroon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Centre (Region of Cameroon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Centre (Region of Cameroon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Centre (Region of Cameroon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Centre (Region of Cameroon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Centre (Region of Cameroon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Centre (Region of Cameroon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Centre (Region of Cameroon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Centre (Region of Cameroon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Centre (Region of Cameroon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Centre (Region of Cameroon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Centre (Region of Cameroon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Centre (Region of Cameroon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Centre (Region of Cameroon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Centre (Region of Cameroon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Centre (Region of Cameroon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Centre (Region of Togo)": [
            {
                "Region Name": "Centre (Region of Togo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Centre (Region of Togo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Centre (Region of Togo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Centre (Region of Togo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Centre (Region of Togo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Centre (Region of Togo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Centre (Region of Togo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Centre (Region of Togo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Centre (Region of Togo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Centre (Region of Togo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Centre (Region of Togo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Centre (Region of Togo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Centre (Region of Togo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Centre (Region of Togo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Centre (Region of Togo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Centre (Region of Togo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Centre (Region of Togo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Centre (Region of Togo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Centre (Region of Togo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Centre (Region of Togo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Centre (Region of Togo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Centre (Region of Togo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Centro Sur (Province of Equatorial Guinea)": [
            {
                "Region Name": "Centro Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centro Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centro Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centro Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centro Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centro Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centro Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centro Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centro Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centro Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centro Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centro Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centro Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centro Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centro Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centro Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centro Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centro Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centro Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centro Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centro Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Centro Sur (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cerro Largo (Department of Uruguay)": [
            {
                "Region Name": "Cerro Largo (Department of Uruguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cerro Largo (Department of Uruguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cerro Largo (Department of Uruguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cerro Largo (Department of Uruguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cerro Largo (Department of Uruguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cerro Largo (Department of Uruguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cerro Largo (Department of Uruguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cerro Largo (Department of Uruguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cerro Largo (Department of Uruguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cerro Largo (Department of Uruguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cerro Largo (Department of Uruguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cerro Largo (Department of Uruguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cerro Largo (Department of Uruguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cerro Largo (Department of Uruguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cerro Largo (Department of Uruguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cerro Largo (Department of Uruguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cerro Largo (Department of Uruguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cerro Largo (Department of Uruguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cerro Largo (Department of Uruguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cerro Largo (Department of Uruguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cerro Largo (Department of Uruguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cerro Largo (Department of Uruguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Cesar (Department of Colombia)": [
            {
                "Region Name": "Cesar (Department of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Cesar (Department of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cesar (Department of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cesar (Department of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cesar (Department of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Cesar (Department of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cesar (Department of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cesar (Department of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cesar (Department of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cesar (Department of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cesar (Department of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cesar (Department of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cesar (Department of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cesar (Department of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cesar (Department of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cesar (Department of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Cesar (Department of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Cesar (Department of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cesar (Department of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Cesar (Department of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cesar (Department of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cesar (Department of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "\u010Ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)": [
            {
                "Region Name": "\u010Ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "\u010Ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u010Ce\u0161inovo-Oble\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Cetinje (Municipality of Montenegro)": [
            {
                "Region Name": "Cetinje (Municipality of Montenegro)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cetinje (Municipality of Montenegro)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cetinje (Municipality of Montenegro)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cetinje (Municipality of Montenegro)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cetinje (Municipality of Montenegro)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cetinje (Municipality of Montenegro)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cetinje (Municipality of Montenegro)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cetinje (Municipality of Montenegro)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cetinje (Municipality of Montenegro)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cetinje (Municipality of Montenegro)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cetinje (Municipality of Montenegro)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cetinje (Municipality of Montenegro)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cetinje (Municipality of Montenegro)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cetinje (Municipality of Montenegro)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cetinje (Municipality of Montenegro)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cetinje (Municipality of Montenegro)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cetinje (Municipality of Montenegro)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cetinje (Municipality of Montenegro)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cetinje (Municipality of Montenegro)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cetinje (Municipality of Montenegro)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Cetinje (Municipality of Montenegro)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cetinje (Municipality of Montenegro)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ceuta y Melilla (Autonomous City of Spain)": [
            {
                "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ceuta y Melilla (Autonomous City of Spain)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Chachoengsao (Province of Thailand)": [
            {
                "Region Name": "Chachoengsao (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chachoengsao (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chachoengsao (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chachoengsao (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chachoengsao (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chachoengsao (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chachoengsao (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chachoengsao (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chachoengsao (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chachoengsao (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Chachoengsao (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Chachoengsao (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chachoengsao (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chachoengsao (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chachoengsao (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chachoengsao (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chachoengsao (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chachoengsao (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chachoengsao (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chachoengsao (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chachoengsao (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chachoengsao (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Chaco (Province of Argentina)": [
            {
                "Region Name": "Chaco (Province of Argentina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chaco (Province of Argentina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chaco (Province of Argentina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chaco (Province of Argentina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chaco (Province of Argentina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chaco (Province of Argentina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chaco (Province of Argentina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chaco (Province of Argentina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chaco (Province of Argentina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chaco (Province of Argentina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chaco (Province of Argentina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chaco (Province of Argentina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chaco (Province of Argentina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chaco (Province of Argentina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chaco (Province of Argentina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chaco (Province of Argentina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chaco (Province of Argentina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chaco (Province of Argentina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chaco (Province of Argentina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chaco (Province of Argentina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chaco (Province of Argentina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chaco (Province of Argentina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Chagang-do (Province of North Korea)": [
            {
                "Region Name": "Chagang-do (Province of North Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chagang-do (Province of North Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chagang-do (Province of North Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chagang-do (Province of North Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chagang-do (Province of North Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chagang-do (Province of North Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chagang-do (Province of North Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chagang-do (Province of North Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chagang-do (Province of North Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chagang-do (Province of North Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Chagang-do (Province of North Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chagang-do (Province of North Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chagang-do (Province of North Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chagang-do (Province of North Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chagang-do (Province of North Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chagang-do (Province of North Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chagang-do (Province of North Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chagang-do (Province of North Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chagang-do (Province of North Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chagang-do (Province of North Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chagang-do (Province of North Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chagang-do (Province of North Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Chaguanas (Borough of Trinidad and Tobago)": [
            {
                "Region Name": "Chaguanas (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaguanas (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chaguanas (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaguanas (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chaguanas (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chaguanas (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaguanas (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaguanas (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaguanas (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaguanas (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaguanas (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaguanas (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaguanas (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaguanas (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaguanas (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaguanas (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaguanas (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaguanas (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaguanas (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaguanas (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaguanas (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaguanas (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Chahar Mahall and Bakhtiari (Province of Iran)": [
            {
                "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chahar Mahall and Bakhtiari (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Chai Nat (Province of Thailand)": [
            {
                "Region Name": "Chai Nat (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chai Nat (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chai Nat (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chai Nat (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chai Nat (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chai Nat (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Chai Nat (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chai Nat (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Chai Nat (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chai Nat (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chai Nat (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Chai Nat (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chai Nat (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chai Nat (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chai Nat (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chai Nat (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chai Nat (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chai Nat (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chai Nat (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chai Nat (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chai Nat (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chai Nat (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Chaiyaphum (Province of Thailand)": [
            {
                "Region Name": "Chaiyaphum (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chaiyaphum (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chaiyaphum (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chaiyaphum (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chaiyaphum (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chaiyaphum (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chaiyaphum (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chaiyaphum (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chaiyaphum (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chaiyaphum (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chaiyaphum (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chaiyaphum (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chaiyaphum (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chaiyaphum (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chaiyaphum (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chaiyaphum (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chaiyaphum (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chaiyaphum (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chaiyaphum (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Chaiyaphum (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Chaiyaphum (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chaiyaphum (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "Chalan-Pago-Ordot (Municipality of Guam)": [
            {
                "Region Name": "Chalan-Pago-Ordot (Municipality of Guam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalan-Pago-Ordot (Municipality of Guam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalan-Pago-Ordot (Municipality of Guam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalan-Pago-Ordot (Municipality of Guam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalan-Pago-Ordot (Municipality of Guam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalan-Pago-Ordot (Municipality of Guam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalan-Pago-Ordot (Municipality of Guam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalan-Pago-Ordot (Municipality of Guam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalan-Pago-Ordot (Municipality of Guam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalan-Pago-Ordot (Municipality of Guam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalan-Pago-Ordot (Municipality of Guam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalan-Pago-Ordot (Municipality of Guam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalan-Pago-Ordot (Municipality of Guam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalan-Pago-Ordot (Municipality of Guam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalan-Pago-Ordot (Municipality of Guam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalan-Pago-Ordot (Municipality of Guam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalan-Pago-Ordot (Municipality of Guam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalan-Pago-Ordot (Municipality of Guam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalan-Pago-Ordot (Municipality of Guam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalan-Pago-Ordot (Municipality of Guam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalan-Pago-Ordot (Municipality of Guam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalan-Pago-Ordot (Municipality of Guam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Chalatenango (Department of El Salvador)": [
            {
                "Region Name": "Chalatenango (Department of El Salvador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chalatenango (Department of El Salvador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chalatenango (Department of El Salvador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chalatenango (Department of El Salvador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalatenango (Department of El Salvador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chalatenango (Department of El Salvador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalatenango (Department of El Salvador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalatenango (Department of El Salvador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalatenango (Department of El Salvador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chalatenango (Department of El Salvador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalatenango (Department of El Salvador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalatenango (Department of El Salvador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chalatenango (Department of El Salvador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chalatenango (Department of El Salvador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chalatenango (Department of El Salvador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalatenango (Department of El Salvador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chalatenango (Department of El Salvador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chalatenango (Department of El Salvador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chalatenango (Department of El Salvador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chalatenango (Department of El Salvador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chalatenango (Department of El Salvador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chalatenango (Department of El Salvador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Champasak (Province of Laos)": [
            {
                "Region Name": "Champasak (Province of Laos)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Champasak (Province of Laos)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Champasak (Province of Laos)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Champasak (Province of Laos)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Champasak (Province of Laos)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Champasak (Province of Laos)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Champasak (Province of Laos)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Champasak (Province of Laos)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Champasak (Province of Laos)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Champasak (Province of Laos)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Champasak (Province of Laos)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Champasak (Province of Laos)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Champasak (Province of Laos)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Champasak (Province of Laos)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Champasak (Province of Laos)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Champasak (Province of Laos)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Champasak (Province of Laos)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Champasak (Province of Laos)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Champasak (Province of Laos)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Champasak (Province of Laos)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Champasak (Province of Laos)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Champasak (Province of Laos)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Chandigarh (Union Territory of India)": [
            {
                "Region Name": "Chandigarh (Union Territory of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chandigarh (Union Territory of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chandigarh (Union Territory of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chandigarh (Union Territory of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chandigarh (Union Territory of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chandigarh (Union Territory of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chandigarh (Union Territory of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chandigarh (Union Territory of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chandigarh (Union Territory of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chandigarh (Union Territory of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chandigarh (Union Territory of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chandigarh (Union Territory of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chandigarh (Union Territory of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chandigarh (Union Territory of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chandigarh (Union Territory of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chandigarh (Union Territory of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chandigarh (Union Territory of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chandigarh (Union Territory of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chandigarh (Union Territory of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chandigarh (Union Territory of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chandigarh (Union Territory of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chandigarh (Union Territory of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Chanthaburi (Province of Thailand)": [
            {
                "Region Name": "Chanthaburi (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chanthaburi (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chanthaburi (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chanthaburi (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chanthaburi (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chanthaburi (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chanthaburi (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chanthaburi (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chanthaburi (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chanthaburi (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chanthaburi (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chanthaburi (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chanthaburi (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chanthaburi (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chanthaburi (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chanthaburi (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chanthaburi (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chanthaburi (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chanthaburi (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chanthaburi (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chanthaburi (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chanthaburi (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Chaouia - Ouardigha (Region of Morocco)": [
            {
                "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chaouia - Ouardigha (Region of Morocco)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Chari-Baguirmi (Region of Chad)": [
            {
                "Region Name": "Chari-Baguirmi (Region of Chad)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Chari-Baguirmi (Region of Chad)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Chari-Baguirmi (Region of Chad)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Chari-Baguirmi (Region of Chad)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Chari-Baguirmi (Region of Chad)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Chari-Baguirmi (Region of Chad)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Chari-Baguirmi (Region of Chad)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Chari-Baguirmi (Region of Chad)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Chari-Baguirmi (Region of Chad)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Chari-Baguirmi (Region of Chad)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Chari-Baguirmi (Region of Chad)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Chari-Baguirmi (Region of Chad)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Chari-Baguirmi (Region of Chad)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Chari-Baguirmi (Region of Chad)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Chari-Baguirmi (Region of Chad)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Chari-Baguirmi (Region of Chad)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Chari-Baguirmi (Region of Chad)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Chari-Baguirmi (Region of Chad)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Chari-Baguirmi (Region of Chad)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Chari-Baguirmi (Region of Chad)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Chari-Baguirmi (Region of Chad)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Chari-Baguirmi (Region of Chad)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 16
            }
        ],
        "Charlotte (Parish of Saint Vincent and the Grenadines)": [
            {
                "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Charlotte (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Chatham Islands (Territory of New Zealand)": [
            {
                "Region Name": "Chatham Islands (Territory of New Zealand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chatham Islands (Territory of New Zealand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chatham Islands (Territory of New Zealand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chatham Islands (Territory of New Zealand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chatham Islands (Territory of New Zealand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chatham Islands (Territory of New Zealand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chatham Islands (Territory of New Zealand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chatham Islands (Territory of New Zealand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chatham Islands (Territory of New Zealand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chatham Islands (Territory of New Zealand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chatham Islands (Territory of New Zealand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chatham Islands (Territory of New Zealand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chatham Islands (Territory of New Zealand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chatham Islands (Territory of New Zealand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chatham Islands (Territory of New Zealand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chatham Islands (Territory of New Zealand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chatham Islands (Territory of New Zealand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chatham Islands (Territory of New Zealand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chatham Islands (Territory of New Zealand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chatham Islands (Territory of New Zealand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chatham Islands (Territory of New Zealand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chatham Islands (Territory of New Zealand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Chechnya (Republic of Russia)": [
            {
                "Region Name": "Chechnya (Republic of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Chechnya (Republic of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chechnya (Republic of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chechnya (Republic of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Chechnya (Republic of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Chechnya (Republic of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chechnya (Republic of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chechnya (Republic of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chechnya (Republic of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Chechnya (Republic of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chechnya (Republic of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chechnya (Republic of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chechnya (Republic of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chechnya (Republic of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chechnya (Republic of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chechnya (Republic of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chechnya (Republic of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chechnya (Republic of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chechnya (Republic of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chechnya (Republic of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chechnya (Republic of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chechnya (Republic of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Chelyabinsk (Region of Russia)": [
            {
                "Region Name": "Chelyabinsk (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chelyabinsk (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chelyabinsk (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chelyabinsk (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chelyabinsk (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chelyabinsk (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chelyabinsk (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chelyabinsk (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chelyabinsk (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chelyabinsk (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chelyabinsk (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chelyabinsk (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Chelyabinsk (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chelyabinsk (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chelyabinsk (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chelyabinsk (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chelyabinsk (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chelyabinsk (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chelyabinsk (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chelyabinsk (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Chelyabinsk (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chelyabinsk (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Cherkasy (Region of Ukraine)": [
            {
                "Region Name": "Cherkasy (Region of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cherkasy (Region of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cherkasy (Region of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cherkasy (Region of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cherkasy (Region of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cherkasy (Region of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cherkasy (Region of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cherkasy (Region of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cherkasy (Region of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cherkasy (Region of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cherkasy (Region of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cherkasy (Region of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cherkasy (Region of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cherkasy (Region of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cherkasy (Region of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cherkasy (Region of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cherkasy (Region of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cherkasy (Region of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cherkasy (Region of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cherkasy (Region of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cherkasy (Region of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cherkasy (Region of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Chernihiv (Region of Ukraine)": [
            {
                "Region Name": "Chernihiv (Region of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chernihiv (Region of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chernihiv (Region of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chernihiv (Region of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chernihiv (Region of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chernihiv (Region of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chernihiv (Region of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chernihiv (Region of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chernihiv (Region of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chernihiv (Region of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chernihiv (Region of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chernihiv (Region of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chernihiv (Region of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chernihiv (Region of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chernihiv (Region of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chernihiv (Region of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chernihiv (Region of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chernihiv (Region of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Chernihiv (Region of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chernihiv (Region of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chernihiv (Region of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chernihiv (Region of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Chernivtsi (Region of Ukraine)": [
            {
                "Region Name": "Chernivtsi (Region of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chernivtsi (Region of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chernivtsi (Region of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chernivtsi (Region of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chernivtsi (Region of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Chernivtsi (Region of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chernivtsi (Region of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chernivtsi (Region of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chernivtsi (Region of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chernivtsi (Region of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chernivtsi (Region of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chernivtsi (Region of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chernivtsi (Region of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chernivtsi (Region of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chernivtsi (Region of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chernivtsi (Region of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chernivtsi (Region of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chernivtsi (Region of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chernivtsi (Region of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chernivtsi (Region of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chernivtsi (Region of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chernivtsi (Region of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Chhattisgarh (State of India)": [
            {
                "Region Name": "Chhattisgarh (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Chhattisgarh (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Chhattisgarh (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Chhattisgarh (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Chhattisgarh (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Chhattisgarh (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Chhattisgarh (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Chhattisgarh (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Chhattisgarh (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Chhattisgarh (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Chhattisgarh (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Chhattisgarh (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Chhattisgarh (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Chhattisgarh (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Chhattisgarh (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Chhattisgarh (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Chhattisgarh (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Chhattisgarh (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Chhattisgarh (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Chhattisgarh (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Chhattisgarh (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Chhattisgarh (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Chhukha (District of Bhutan)": [
            {
                "Region Name": "Chhukha (District of Bhutan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chhukha (District of Bhutan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chhukha (District of Bhutan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chhukha (District of Bhutan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chhukha (District of Bhutan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chhukha (District of Bhutan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chhukha (District of Bhutan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chhukha (District of Bhutan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chhukha (District of Bhutan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chhukha (District of Bhutan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chhukha (District of Bhutan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chhukha (District of Bhutan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chhukha (District of Bhutan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chhukha (District of Bhutan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chhukha (District of Bhutan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chhukha (District of Bhutan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chhukha (District of Bhutan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chhukha (District of Bhutan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chhukha (District of Bhutan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chhukha (District of Bhutan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chhukha (District of Bhutan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chhukha (District of Bhutan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Chiang Mai (Province of Thailand)": [
            {
                "Region Name": "Chiang Mai (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chiang Mai (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chiang Mai (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chiang Mai (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chiang Mai (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chiang Mai (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chiang Mai (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chiang Mai (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chiang Mai (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chiang Mai (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chiang Mai (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chiang Mai (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chiang Mai (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chiang Mai (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chiang Mai (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chiang Mai (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chiang Mai (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Chiang Mai (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chiang Mai (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chiang Mai (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chiang Mai (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chiang Mai (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Chiang Rai (Province of Thailand)": [
            {
                "Region Name": "Chiang Rai (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chiang Rai (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chiang Rai (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chiang Rai (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chiang Rai (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chiang Rai (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chiang Rai (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chiang Rai (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chiang Rai (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chiang Rai (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chiang Rai (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chiang Rai (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chiang Rai (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chiang Rai (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chiang Rai (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Chiang Rai (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chiang Rai (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chiang Rai (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chiang Rai (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chiang Rai (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chiang Rai (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chiang Rai (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Chiapas (State of M\xe9xico)": [
            {
                "Region Name": "Chiapas (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Chiapas (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Chiapas (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Chiapas (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Chiapas (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chiapas (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chiapas (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Chiapas (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chiapas (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chiapas (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chiapas (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chiapas (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chiapas (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chiapas (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chiapas (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Chiapas (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chiapas (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chiapas (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Chiapas (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chiapas (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Chiapas (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Chiapas (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Chiba (Prefecture of Japan)": [
            {
                "Region Name": "Chiba (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiba (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiba (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiba (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chiba (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiba (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiba (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiba (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiba (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiba (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiba (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiba (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chiba (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiba (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiba (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiba (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiba (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiba (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiba (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Chiba (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiba (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiba (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Chiconi (Commune of Mayotte)": [
            {
                "Region Name": "Chiconi (Commune of Mayotte)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiconi (Commune of Mayotte)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiconi (Commune of Mayotte)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiconi (Commune of Mayotte)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiconi (Commune of Mayotte)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiconi (Commune of Mayotte)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiconi (Commune of Mayotte)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiconi (Commune of Mayotte)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiconi (Commune of Mayotte)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiconi (Commune of Mayotte)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiconi (Commune of Mayotte)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiconi (Commune of Mayotte)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiconi (Commune of Mayotte)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiconi (Commune of Mayotte)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiconi (Commune of Mayotte)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiconi (Commune of Mayotte)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiconi (Commune of Mayotte)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiconi (Commune of Mayotte)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiconi (Commune of Mayotte)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiconi (Commune of Mayotte)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiconi (Commune of Mayotte)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiconi (Commune of Mayotte)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Chiesanuova (Municipality of San Marino)": [
            {
                "Region Name": "Chiesanuova (Municipality of San Marino)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiesanuova (Municipality of San Marino)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiesanuova (Municipality of San Marino)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiesanuova (Municipality of San Marino)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiesanuova (Municipality of San Marino)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiesanuova (Municipality of San Marino)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiesanuova (Municipality of San Marino)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiesanuova (Municipality of San Marino)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiesanuova (Municipality of San Marino)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiesanuova (Municipality of San Marino)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiesanuova (Municipality of San Marino)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiesanuova (Municipality of San Marino)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiesanuova (Municipality of San Marino)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiesanuova (Municipality of San Marino)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiesanuova (Municipality of San Marino)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiesanuova (Municipality of San Marino)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiesanuova (Municipality of San Marino)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiesanuova (Municipality of San Marino)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiesanuova (Municipality of San Marino)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiesanuova (Municipality of San Marino)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiesanuova (Municipality of San Marino)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiesanuova (Municipality of San Marino)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Chihuahua (State of M\xe9xico)": [
            {
                "Region Name": "Chihuahua (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Chihuahua (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Chihuahua (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chihuahua (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chihuahua (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Chihuahua (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chihuahua (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Chihuahua (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Chihuahua (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Chihuahua (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Chihuahua (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Chihuahua (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Chihuahua (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Chihuahua (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chihuahua (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chihuahua (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Chihuahua (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Chihuahua (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chihuahua (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chihuahua (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Chihuahua (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Chihuahua (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 31
            }
        ],
        "Chikwawa (District of Malawi)": [
            {
                "Region Name": "Chikwawa (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Chikwawa (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Chikwawa (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Chikwawa (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chikwawa (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Chikwawa (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Chikwawa (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chikwawa (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chikwawa (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Chikwawa (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Chikwawa (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Chikwawa (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chikwawa (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chikwawa (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chikwawa (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Chikwawa (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chikwawa (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chikwawa (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chikwawa (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chikwawa (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chikwawa (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Chikwawa (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Chimaltenango (Department of Guatemala)": [
            {
                "Region Name": "Chimaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chimaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chimaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chimaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chimaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chimaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chimaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chimaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chimaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chimaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chimaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chimaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chimaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Chimborazo (Province of Ecuador)": [
            {
                "Region Name": "Chimborazo (Province of Ecuador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chimborazo (Province of Ecuador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chimborazo (Province of Ecuador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimborazo (Province of Ecuador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chimborazo (Province of Ecuador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimborazo (Province of Ecuador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimborazo (Province of Ecuador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimborazo (Province of Ecuador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chimborazo (Province of Ecuador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chimborazo (Province of Ecuador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimborazo (Province of Ecuador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chimborazo (Province of Ecuador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimborazo (Province of Ecuador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimborazo (Province of Ecuador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Chimborazo (Province of Ecuador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chimborazo (Province of Ecuador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimborazo (Province of Ecuador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chimborazo (Province of Ecuador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chimborazo (Province of Ecuador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chimborazo (Province of Ecuador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimborazo (Province of Ecuador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chimborazo (Province of Ecuador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Chimbu (Province of Papua New Guinea)": [
            {
                "Region Name": "Chimbu (Province of Papua New Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chimbu (Province of Papua New Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chimbu (Province of Papua New Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chimbu (Province of Papua New Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimbu (Province of Papua New Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimbu (Province of Papua New Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chimbu (Province of Papua New Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chimbu (Province of Papua New Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimbu (Province of Papua New Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chimbu (Province of Papua New Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimbu (Province of Papua New Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimbu (Province of Papua New Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimbu (Province of Papua New Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimbu (Province of Papua New Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chimbu (Province of Papua New Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimbu (Province of Papua New Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimbu (Province of Papua New Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chimbu (Province of Papua New Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimbu (Province of Papua New Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimbu (Province of Papua New Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chimbu (Province of Papua New Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chimbu (Province of Papua New Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Chin (State of Myanmar)": [
            {
                "Region Name": "Chin (State of Myanmar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Chin (State of Myanmar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Chin (State of Myanmar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Chin (State of Myanmar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chin (State of Myanmar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chin (State of Myanmar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Chin (State of Myanmar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Chin (State of Myanmar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Chin (State of Myanmar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Chin (State of Myanmar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Chin (State of Myanmar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Chin (State of Myanmar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Chin (State of Myanmar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Chin (State of Myanmar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Chin (State of Myanmar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Chin (State of Myanmar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chin (State of Myanmar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chin (State of Myanmar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chin (State of Myanmar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Chin (State of Myanmar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Chin (State of Myanmar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chin (State of Myanmar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "Chinandega (Department of Nicaragua)": [
            {
                "Region Name": "Chinandega (Department of Nicaragua)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chinandega (Department of Nicaragua)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chinandega (Department of Nicaragua)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chinandega (Department of Nicaragua)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chinandega (Department of Nicaragua)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chinandega (Department of Nicaragua)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chinandega (Department of Nicaragua)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chinandega (Department of Nicaragua)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chinandega (Department of Nicaragua)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chinandega (Department of Nicaragua)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chinandega (Department of Nicaragua)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chinandega (Department of Nicaragua)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chinandega (Department of Nicaragua)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chinandega (Department of Nicaragua)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chinandega (Department of Nicaragua)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chinandega (Department of Nicaragua)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chinandega (Department of Nicaragua)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chinandega (Department of Nicaragua)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chinandega (Department of Nicaragua)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chinandega (Department of Nicaragua)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chinandega (Department of Nicaragua)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chinandega (Department of Nicaragua)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Chiquimula (Department of Guatemala)": [
            {
                "Region Name": "Chiquimula (Department of Guatemala)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chiquimula (Department of Guatemala)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chiquimula (Department of Guatemala)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chiquimula (Department of Guatemala)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiquimula (Department of Guatemala)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chiquimula (Department of Guatemala)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chiquimula (Department of Guatemala)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiquimula (Department of Guatemala)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chiquimula (Department of Guatemala)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chiquimula (Department of Guatemala)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chiquimula (Department of Guatemala)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiquimula (Department of Guatemala)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chiquimula (Department of Guatemala)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiquimula (Department of Guatemala)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiquimula (Department of Guatemala)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chiquimula (Department of Guatemala)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chiquimula (Department of Guatemala)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chiquimula (Department of Guatemala)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiquimula (Department of Guatemala)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chiquimula (Department of Guatemala)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiquimula (Department of Guatemala)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiquimula (Department of Guatemala)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Chiradzulu (District of Malawi)": [
            {
                "Region Name": "Chiradzulu (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chiradzulu (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chiradzulu (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chiradzulu (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chiradzulu (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiradzulu (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chiradzulu (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiradzulu (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiradzulu (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chiradzulu (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chiradzulu (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chiradzulu (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chiradzulu (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chiradzulu (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chiradzulu (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiradzulu (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chiradzulu (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chiradzulu (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiradzulu (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chiradzulu (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiradzulu (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chiradzulu (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Chiriqu\xed (Province of Panama)": [
            {
                "Region Name": "Chiriqu\xed (Province of Panama)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chiriqu\xed (Province of Panama)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chiriqu\xed (Province of Panama)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chiriqu\xed (Province of Panama)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chiriqu\xed (Province of Panama)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chiriqu\xed (Province of Panama)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chiriqu\xed (Province of Panama)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chiriqu\xed (Province of Panama)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chiriqu\xed (Province of Panama)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chiriqu\xed (Province of Panama)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Chiriqu\xed (Province of Panama)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chiriqu\xed (Province of Panama)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chiriqu\xed (Province of Panama)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chiriqu\xed (Province of Panama)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chiriqu\xed (Province of Panama)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chiriqu\xed (Province of Panama)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chiriqu\xed (Province of Panama)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chiriqu\xed (Province of Panama)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chiriqu\xed (Province of Panama)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chiriqu\xed (Province of Panama)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chiriqu\xed (Province of Panama)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chiriqu\xed (Province of Panama)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Chirongui (Commune of Mayotte)": [
            {
                "Region Name": "Chirongui (Commune of Mayotte)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chirongui (Commune of Mayotte)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chirongui (Commune of Mayotte)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chirongui (Commune of Mayotte)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chirongui (Commune of Mayotte)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chirongui (Commune of Mayotte)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chirongui (Commune of Mayotte)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chirongui (Commune of Mayotte)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chirongui (Commune of Mayotte)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chirongui (Commune of Mayotte)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chirongui (Commune of Mayotte)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chirongui (Commune of Mayotte)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chirongui (Commune of Mayotte)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chirongui (Commune of Mayotte)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chirongui (Commune of Mayotte)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chirongui (Commune of Mayotte)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chirongui (Commune of Mayotte)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chirongui (Commune of Mayotte)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chirongui (Commune of Mayotte)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chirongui (Commune of Mayotte)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chirongui (Commune of Mayotte)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chirongui (Commune of Mayotte)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Chi\u0219in\u0103u (City of Moldova)": [
            {
                "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chi\u0219in\u0103u (City of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Chitipa (District of Malawi)": [
            {
                "Region Name": "Chitipa (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Chitipa (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Chitipa (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Chitipa (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Chitipa (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Chitipa (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chitipa (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Chitipa (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Chitipa (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Chitipa (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Chitipa (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Chitipa (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Chitipa (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Chitipa (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Chitipa (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Chitipa (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Chitipa (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Chitipa (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Chitipa (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Chitipa (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Chitipa (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Chitipa (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Chittagong (Division of Bangladesh)": [
            {
                "Region Name": "Chittagong (Division of Bangladesh)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chittagong (Division of Bangladesh)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chittagong (Division of Bangladesh)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chittagong (Division of Bangladesh)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chittagong (Division of Bangladesh)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chittagong (Division of Bangladesh)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chittagong (Division of Bangladesh)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chittagong (Division of Bangladesh)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Chittagong (Division of Bangladesh)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chittagong (Division of Bangladesh)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chittagong (Division of Bangladesh)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Chittagong (Division of Bangladesh)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Chittagong (Division of Bangladesh)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chittagong (Division of Bangladesh)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Chittagong (Division of Bangladesh)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chittagong (Division of Bangladesh)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chittagong (Division of Bangladesh)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chittagong (Division of Bangladesh)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chittagong (Division of Bangladesh)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chittagong (Division of Bangladesh)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Chittagong (Division of Bangladesh)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chittagong (Division of Bangladesh)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Chlef (Province of Algeria)": [
            {
                "Region Name": "Chlef (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chlef (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chlef (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chlef (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chlef (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chlef (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chlef (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chlef (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chlef (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chlef (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chlef (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Chlef (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chlef (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chlef (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chlef (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chlef (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chlef (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chlef (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chlef (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Chlef (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chlef (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chlef (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Chobe (District of Botswana)": [
            {
                "Region Name": "Chobe (District of Botswana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 121
            },
            {
                "Region Name": "Chobe (District of Botswana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 134
            },
            {
                "Region Name": "Chobe (District of Botswana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 288
            },
            {
                "Region Name": "Chobe (District of Botswana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 67
            },
            {
                "Region Name": "Chobe (District of Botswana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 152
            },
            {
                "Region Name": "Chobe (District of Botswana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 269
            },
            {
                "Region Name": "Chobe (District of Botswana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 199
            },
            {
                "Region Name": "Chobe (District of Botswana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 375
            },
            {
                "Region Name": "Chobe (District of Botswana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 514
            },
            {
                "Region Name": "Chobe (District of Botswana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 662
            },
            {
                "Region Name": "Chobe (District of Botswana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Chobe (District of Botswana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 99
            },
            {
                "Region Name": "Chobe (District of Botswana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 160
            },
            {
                "Region Name": "Chobe (District of Botswana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 89
            },
            {
                "Region Name": "Chobe (District of Botswana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 74
            },
            {
                "Region Name": "Chobe (District of Botswana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 445
            },
            {
                "Region Name": "Chobe (District of Botswana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 141
            },
            {
                "Region Name": "Chobe (District of Botswana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 71
            },
            {
                "Region Name": "Chobe (District of Botswana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Chobe (District of Botswana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 146
            },
            {
                "Region Name": "Chobe (District of Botswana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 324
            },
            {
                "Region Name": "Chobe (District of Botswana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 167
            }
        ],
        "Choc\xf3 (Department of Colombia)": [
            {
                "Region Name": "Choc\xf3 (Department of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choc\xf3 (Department of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Choc\xf3 (Department of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Choc\xf3 (Department of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choc\xf3 (Department of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Choc\xf3 (Department of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choc\xf3 (Department of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choc\xf3 (Department of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Choc\xf3 (Department of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choc\xf3 (Department of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Choc\xf3 (Department of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Choc\xf3 (Department of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Choc\xf3 (Department of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Choc\xf3 (Department of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Choc\xf3 (Department of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Choc\xf3 (Department of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choc\xf3 (Department of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Choc\xf3 (Department of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Choc\xf3 (Department of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Choc\xf3 (Department of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choc\xf3 (Department of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Choc\xf3 (Department of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Choiseul (Province of Solomon Islands)": [
            {
                "Region Name": "Choiseul (Province of Solomon Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Province of Solomon Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Province of Solomon Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Province of Solomon Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Province of Solomon Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Province of Solomon Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Province of Solomon Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Province of Solomon Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Province of Solomon Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Province of Solomon Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Province of Solomon Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Province of Solomon Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Province of Solomon Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Province of Solomon Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Province of Solomon Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Province of Solomon Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Province of Solomon Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Province of Solomon Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Province of Solomon Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Province of Solomon Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Province of Solomon Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Province of Solomon Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Choiseul (Quarter of Saint Lucia)": [
            {
                "Region Name": "Choiseul (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Choiseul (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Choluteca (Department of Honduras)": [
            {
                "Region Name": "Choluteca (Department of Honduras)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Choluteca (Department of Honduras)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Choluteca (Department of Honduras)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Choluteca (Department of Honduras)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Choluteca (Department of Honduras)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Choluteca (Department of Honduras)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Choluteca (Department of Honduras)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Choluteca (Department of Honduras)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Choluteca (Department of Honduras)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Choluteca (Department of Honduras)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Choluteca (Department of Honduras)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Choluteca (Department of Honduras)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Choluteca (Department of Honduras)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Choluteca (Department of Honduras)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Choluteca (Department of Honduras)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Choluteca (Department of Honduras)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Choluteca (Department of Honduras)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Choluteca (Department of Honduras)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Choluteca (Department of Honduras)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Choluteca (Department of Honduras)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Choluteca (Department of Honduras)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Choluteca (Department of Honduras)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Chon Buri (Province of Thailand)": [
            {
                "Region Name": "Chon Buri (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chon Buri (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chon Buri (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chon Buri (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chon Buri (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chon Buri (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chon Buri (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chon Buri (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chon Buri (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chon Buri (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chon Buri (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chon Buri (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chon Buri (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chon Buri (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chon Buri (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chon Buri (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chon Buri (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chon Buri (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chon Buri (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chon Buri (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chon Buri (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chon Buri (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Chongqing (Municipality of China)": [
            {
                "Region Name": "Chongqing (Municipality of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chongqing (Municipality of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chongqing (Municipality of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chongqing (Municipality of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chongqing (Municipality of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chongqing (Municipality of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chongqing (Municipality of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chongqing (Municipality of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chongqing (Municipality of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chongqing (Municipality of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Chongqing (Municipality of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chongqing (Municipality of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chongqing (Municipality of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Chongqing (Municipality of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chongqing (Municipality of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chongqing (Municipality of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chongqing (Municipality of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chongqing (Municipality of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chongqing (Municipality of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chongqing (Municipality of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chongqing (Municipality of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Chongqing (Municipality of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Chontales (Department of Nicaragua)": [
            {
                "Region Name": "Chontales (Department of Nicaragua)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chontales (Department of Nicaragua)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Chontales (Department of Nicaragua)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chontales (Department of Nicaragua)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chontales (Department of Nicaragua)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chontales (Department of Nicaragua)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chontales (Department of Nicaragua)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chontales (Department of Nicaragua)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chontales (Department of Nicaragua)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chontales (Department of Nicaragua)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chontales (Department of Nicaragua)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chontales (Department of Nicaragua)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chontales (Department of Nicaragua)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chontales (Department of Nicaragua)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chontales (Department of Nicaragua)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chontales (Department of Nicaragua)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chontales (Department of Nicaragua)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Chontales (Department of Nicaragua)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chontales (Department of Nicaragua)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chontales (Department of Nicaragua)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chontales (Department of Nicaragua)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chontales (Department of Nicaragua)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Christ Church (Parish of Barbados)": [
            {
                "Region Name": "Christ Church (Parish of Barbados)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church (Parish of Barbados)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church (Parish of Barbados)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church (Parish of Barbados)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church (Parish of Barbados)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church (Parish of Barbados)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church (Parish of Barbados)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church (Parish of Barbados)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Christ Church (Parish of Barbados)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church (Parish of Barbados)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church (Parish of Barbados)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church (Parish of Barbados)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church (Parish of Barbados)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church (Parish of Barbados)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church (Parish of Barbados)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church (Parish of Barbados)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church (Parish of Barbados)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church (Parish of Barbados)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church (Parish of Barbados)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church (Parish of Barbados)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church (Parish of Barbados)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church (Parish of Barbados)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Christ Church Nichola Town (Parish of Saint Kitts and Nevis)": [
            {
                "Region Name": "Christ Church Nichola Town (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church Nichola Town (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church Nichola Town (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church Nichola Town (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church Nichola Town (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church Nichola Town (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church Nichola Town (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church Nichola Town (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church Nichola Town (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church Nichola Town (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church Nichola Town (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church Nichola Town (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church Nichola Town (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church Nichola Town (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church Nichola Town (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church Nichola Town (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church Nichola Town (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church Nichola Town (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church Nichola Town (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church Nichola Town (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church Nichola Town (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Christ Church Nichola Town (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Chubut (Province of Argentina)": [
            {
                "Region Name": "Chubut (Province of Argentina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 79
            },
            {
                "Region Name": "Chubut (Province of Argentina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Chubut (Province of Argentina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Chubut (Province of Argentina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chubut (Province of Argentina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Chubut (Province of Argentina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Chubut (Province of Argentina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Chubut (Province of Argentina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chubut (Province of Argentina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chubut (Province of Argentina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Chubut (Province of Argentina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chubut (Province of Argentina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chubut (Province of Argentina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Chubut (Province of Argentina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Chubut (Province of Argentina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "Chubut (Province of Argentina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Chubut (Province of Argentina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Chubut (Province of Argentina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chubut (Province of Argentina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Chubut (Province of Argentina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 382
            },
            {
                "Region Name": "Chubut (Province of Argentina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Chubut (Province of Argentina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 77
            }
        ],
        "Chukot (Autonomous Province of Russia)": [
            {
                "Region Name": "Chukot (Autonomous Province of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Chukot (Autonomous Province of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Chukot (Autonomous Province of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chukot (Autonomous Province of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chukot (Autonomous Province of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chukot (Autonomous Province of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Chukot (Autonomous Province of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chukot (Autonomous Province of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chukot (Autonomous Province of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Chukot (Autonomous Province of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chukot (Autonomous Province of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chukot (Autonomous Province of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chukot (Autonomous Province of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chukot (Autonomous Province of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chukot (Autonomous Province of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chukot (Autonomous Province of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chukot (Autonomous Province of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chukot (Autonomous Province of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chukot (Autonomous Province of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chukot (Autonomous Province of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Chukot (Autonomous Province of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chukot (Autonomous Province of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Chumphon (Province of Thailand)": [
            {
                "Region Name": "Chumphon (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chumphon (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chumphon (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chumphon (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chumphon (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chumphon (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chumphon (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chumphon (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chumphon (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chumphon (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chumphon (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chumphon (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chumphon (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chumphon (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Chumphon (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chumphon (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chumphon (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chumphon (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chumphon (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chumphon (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chumphon (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chumphon (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Chungcheongbuk-do (Province of South Korea)": [
            {
                "Region Name": "Chungcheongbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chungcheongbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chungcheongbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chungcheongbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chungcheongbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chungcheongbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Chungcheongnam-do (Province of South Korea)": [
            {
                "Region Name": "Chungcheongnam-do (Province of South Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chungcheongnam-do (Province of South Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongnam-do (Province of South Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongnam-do (Province of South Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongnam-do (Province of South Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongnam-do (Province of South Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chungcheongnam-do (Province of South Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongnam-do (Province of South Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongnam-do (Province of South Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongnam-do (Province of South Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chungcheongnam-do (Province of South Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongnam-do (Province of South Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chungcheongnam-do (Province of South Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongnam-do (Province of South Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chungcheongnam-do (Province of South Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongnam-do (Province of South Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chungcheongnam-do (Province of South Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongnam-do (Province of South Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chungcheongnam-do (Province of South Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Chungcheongnam-do (Province of South Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chungcheongnam-do (Province of South Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chungcheongnam-do (Province of South Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Chuquisaca (Department of Bolivia)": [
            {
                "Region Name": "Chuquisaca (Department of Bolivia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chuquisaca (Department of Bolivia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chuquisaca (Department of Bolivia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chuquisaca (Department of Bolivia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chuquisaca (Department of Bolivia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Chuquisaca (Department of Bolivia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chuquisaca (Department of Bolivia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chuquisaca (Department of Bolivia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chuquisaca (Department of Bolivia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chuquisaca (Department of Bolivia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Chuquisaca (Department of Bolivia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chuquisaca (Department of Bolivia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chuquisaca (Department of Bolivia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chuquisaca (Department of Bolivia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chuquisaca (Department of Bolivia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chuquisaca (Department of Bolivia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chuquisaca (Department of Bolivia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chuquisaca (Department of Bolivia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Chuquisaca (Department of Bolivia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chuquisaca (Department of Bolivia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Chuquisaca (Department of Bolivia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Chuquisaca (Department of Bolivia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Chuuk (State of Micronesia)": [
            {
                "Region Name": "Chuuk (State of Micronesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chuuk (State of Micronesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chuuk (State of Micronesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chuuk (State of Micronesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chuuk (State of Micronesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chuuk (State of Micronesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chuuk (State of Micronesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chuuk (State of Micronesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chuuk (State of Micronesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chuuk (State of Micronesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chuuk (State of Micronesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chuuk (State of Micronesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chuuk (State of Micronesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chuuk (State of Micronesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chuuk (State of Micronesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chuuk (State of Micronesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chuuk (State of Micronesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chuuk (State of Micronesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chuuk (State of Micronesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chuuk (State of Micronesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chuuk (State of Micronesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chuuk (State of Micronesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Chuvash (Republic of Russia)": [
            {
                "Region Name": "Chuvash (Republic of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chuvash (Republic of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chuvash (Republic of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chuvash (Republic of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chuvash (Republic of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chuvash (Republic of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chuvash (Republic of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Chuvash (Republic of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chuvash (Republic of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chuvash (Republic of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chuvash (Republic of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Chuvash (Republic of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chuvash (Republic of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chuvash (Republic of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chuvash (Republic of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chuvash (Republic of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chuvash (Republic of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chuvash (Republic of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Chuvash (Republic of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Chuvash (Republic of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Chuvash (Republic of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Chuvash (Republic of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Ch\xfcy (Province of Kyrgyzstan)": [
            {
                "Region Name": "Ch\xfcy (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ch\xfcy (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ch\xfcy (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ch\xfcy (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ch\xfcy (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ch\xfcy (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Ch\xfcy (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ch\xfcy (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ch\xfcy (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ch\xfcy (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ch\xfcy (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ch\xfcy (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ch\xfcy (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ch\xfcy (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ch\xfcy (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ch\xfcy (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ch\xfcy (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ch\xfcy (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ch\xfcy (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ch\xfcy (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ch\xfcy (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ch\xfcy (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ciales (Municipality of Puerto Rico)": [
            {
                "Region Name": "Ciales (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciales (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciales (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciales (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciales (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciales (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciales (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciales (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciales (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciales (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciales (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciales (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciales (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciales (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciales (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciales (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciales (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciales (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciales (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciales (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciales (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciales (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cibitoke (Province of Burundi)": [
            {
                "Region Name": "Cibitoke (Province of Burundi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cibitoke (Province of Burundi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cibitoke (Province of Burundi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cibitoke (Province of Burundi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cibitoke (Province of Burundi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cibitoke (Province of Burundi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cibitoke (Province of Burundi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cibitoke (Province of Burundi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cibitoke (Province of Burundi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cibitoke (Province of Burundi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cibitoke (Province of Burundi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cibitoke (Province of Burundi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cibitoke (Province of Burundi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cibitoke (Province of Burundi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cibitoke (Province of Burundi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cibitoke (Province of Burundi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cibitoke (Province of Burundi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cibitoke (Province of Burundi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cibitoke (Province of Burundi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cibitoke (Province of Burundi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cibitoke (Province of Burundi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cibitoke (Province of Burundi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Cidra (Municipality of Puerto Rico)": [
            {
                "Region Name": "Cidra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cidra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cidra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cidra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cidra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cidra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cidra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cidra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cidra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cidra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cidra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cidra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cidra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cidra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cidra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cidra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cidra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cidra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cidra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cidra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cidra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cidra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ciego de \xc1vila (Province of Cuba)": [
            {
                "Region Name": "Ciego de \xc1vila (Province of Cuba)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ciego de \xc1vila (Province of Cuba)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ciego de \xc1vila (Province of Cuba)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ciego de \xc1vila (Province of Cuba)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ciego de \xc1vila (Province of Cuba)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ciego de \xc1vila (Province of Cuba)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ciego de \xc1vila (Province of Cuba)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ciego de \xc1vila (Province of Cuba)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ciego de \xc1vila (Province of Cuba)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ciego de \xc1vila (Province of Cuba)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ciego de \xc1vila (Province of Cuba)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ciego de \xc1vila (Province of Cuba)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ciego de \xc1vila (Province of Cuba)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ciego de \xc1vila (Province of Cuba)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ciego de \xc1vila (Province of Cuba)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ciego de \xc1vila (Province of Cuba)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ciego de \xc1vila (Province of Cuba)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ciego de \xc1vila (Province of Cuba)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ciego de \xc1vila (Province of Cuba)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ciego de \xc1vila (Province of Cuba)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ciego de \xc1vila (Province of Cuba)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ciego de \xc1vila (Province of Cuba)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Cienfuegos (Province of Cuba)": [
            {
                "Region Name": "Cienfuegos (Province of Cuba)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cienfuegos (Province of Cuba)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cienfuegos (Province of Cuba)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cienfuegos (Province of Cuba)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cienfuegos (Province of Cuba)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cienfuegos (Province of Cuba)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cienfuegos (Province of Cuba)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cienfuegos (Province of Cuba)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cienfuegos (Province of Cuba)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cienfuegos (Province of Cuba)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cienfuegos (Province of Cuba)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cienfuegos (Province of Cuba)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cienfuegos (Province of Cuba)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cienfuegos (Province of Cuba)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cienfuegos (Province of Cuba)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cienfuegos (Province of Cuba)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cienfuegos (Province of Cuba)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cienfuegos (Province of Cuba)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cienfuegos (Province of Cuba)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cienfuegos (Province of Cuba)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cienfuegos (Province of Cuba)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cienfuegos (Province of Cuba)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Cimi\u0219lia (District of Moldova)": [
            {
                "Region Name": "Cimi\u0219lia (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cimi\u0219lia (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cimi\u0219lia (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cimi\u0219lia (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cimi\u0219lia (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cimi\u0219lia (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cimi\u0219lia (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cimi\u0219lia (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cimi\u0219lia (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cimi\u0219lia (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cimi\u0219lia (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cimi\u0219lia (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cimi\u0219lia (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cimi\u0219lia (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cimi\u0219lia (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cimi\u0219lia (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cimi\u0219lia (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cimi\u0219lia (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cimi\u0219lia (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cimi\u0219lia (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cimi\u0219lia (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cimi\u0219lia (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "City of Freeport (District of Bahamas)": [
            {
                "Region Name": "City of Freeport (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of Freeport (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of Freeport (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of Freeport (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of Freeport (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of Freeport (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of Freeport (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of Freeport (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of Freeport (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of Freeport (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of Freeport (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of Freeport (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of Freeport (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of Freeport (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of Freeport (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of Freeport (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of Freeport (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of Freeport (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of Freeport (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of Freeport (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of Freeport (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of Freeport (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "City of St. Petersburg (City of Russia)": [
            {
                "Region Name": "City of St. Petersburg (City of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "City of St. Petersburg (City of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "City of St. Petersburg (City of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "City of St. Petersburg (City of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "City of St. Petersburg (City of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "City of St. Petersburg (City of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "City of St. Petersburg (City of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "City of St. Petersburg (City of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "City of St. Petersburg (City of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "City of St. Petersburg (City of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "City of St. Petersburg (City of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "City of St. Petersburg (City of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "City of St. Petersburg (City of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "City of St. Petersburg (City of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "City of St. Petersburg (City of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "City of St. Petersburg (City of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of St. Petersburg (City of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "City of St. Petersburg (City of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "City of St. Petersburg (City of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of St. Petersburg (City of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of St. Petersburg (City of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "City of St. Petersburg (City of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ciudad de Buenos Aires (Federal District of Argentina)": [
            {
                "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de Buenos Aires (Federal District of Argentina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ciudad de la Habana (Province of Cuba)": [
            {
                "Region Name": "Ciudad de la Habana (Province of Cuba)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de la Habana (Province of Cuba)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de la Habana (Province of Cuba)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de la Habana (Province of Cuba)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de la Habana (Province of Cuba)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ciudad de la Habana (Province of Cuba)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de la Habana (Province of Cuba)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de la Habana (Province of Cuba)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ciudad de la Habana (Province of Cuba)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ciudad de la Habana (Province of Cuba)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ciudad de la Habana (Province of Cuba)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de la Habana (Province of Cuba)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de la Habana (Province of Cuba)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de la Habana (Province of Cuba)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de la Habana (Province of Cuba)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de la Habana (Province of Cuba)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ciudad de la Habana (Province of Cuba)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de la Habana (Province of Cuba)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de la Habana (Province of Cuba)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ciudad de la Habana (Province of Cuba)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ciudad de la Habana (Province of Cuba)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ciudad de la Habana (Province of Cuba)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Clare (County of Ireland)": [
            {
                "Region Name": "Clare (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clare (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clare (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clare (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clare (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clare (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clare (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clare (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clare (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clare (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clare (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clare (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clare (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clare (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clare (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clare (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clare (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clare (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clare (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clare (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clare (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clare (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Clarendon (Parish of Jamaica)": [
            {
                "Region Name": "Clarendon (Parish of Jamaica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clarendon (Parish of Jamaica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clarendon (Parish of Jamaica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Clarendon (Parish of Jamaica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Clarendon (Parish of Jamaica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Clarendon (Parish of Jamaica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Clarendon (Parish of Jamaica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Clarendon (Parish of Jamaica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Clarendon (Parish of Jamaica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Clarendon (Parish of Jamaica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Clarendon (Parish of Jamaica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Clarendon (Parish of Jamaica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Clarendon (Parish of Jamaica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clarendon (Parish of Jamaica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clarendon (Parish of Jamaica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clarendon (Parish of Jamaica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Clarendon (Parish of Jamaica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Clarendon (Parish of Jamaica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Clarendon (Parish of Jamaica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Clarendon (Parish of Jamaica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clarendon (Parish of Jamaica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Clarendon (Parish of Jamaica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cluj (County of Romania)": [
            {
                "Region Name": "Cluj (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cluj (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cluj (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cluj (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cluj (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cluj (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cluj (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cluj (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cluj (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cluj (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cluj (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cluj (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cluj (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cluj (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cluj (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cluj (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cluj (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cluj (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cluj (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cluj (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cluj (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cluj (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Coahuila (State of M\xe9xico)": [
            {
                "Region Name": "Coahuila (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 61
            },
            {
                "Region Name": "Coahuila (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Coahuila (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Coahuila (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Coahuila (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Coahuila (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Coahuila (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Coahuila (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Coahuila (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Coahuila (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 399
            },
            {
                "Region Name": "Coahuila (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Coahuila (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Coahuila (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Coahuila (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Coahuila (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Coahuila (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Coahuila (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Coahuila (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Coahuila (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Coahuila (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Coahuila (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Coahuila (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Coamo (Municipality of Puerto Rico)": [
            {
                "Region Name": "Coamo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coamo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coamo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coamo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coamo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Coamo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coamo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coamo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coamo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coamo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coamo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coamo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coamo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coamo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coamo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coamo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Coamo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Coamo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Coamo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coamo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coamo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coamo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cochabamba (Department of Bolivia)": [
            {
                "Region Name": "Cochabamba (Department of Bolivia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cochabamba (Department of Bolivia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Cochabamba (Department of Bolivia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Cochabamba (Department of Bolivia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Cochabamba (Department of Bolivia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cochabamba (Department of Bolivia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cochabamba (Department of Bolivia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Cochabamba (Department of Bolivia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cochabamba (Department of Bolivia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Cochabamba (Department of Bolivia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "Cochabamba (Department of Bolivia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cochabamba (Department of Bolivia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Cochabamba (Department of Bolivia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Cochabamba (Department of Bolivia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cochabamba (Department of Bolivia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Cochabamba (Department of Bolivia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Cochabamba (Department of Bolivia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Cochabamba (Department of Bolivia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Cochabamba (Department of Bolivia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Cochabamba (Department of Bolivia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cochabamba (Department of Bolivia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Cochabamba (Department of Bolivia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 33
            }
        ],
        "Cocl\xe9 (Province of Panama)": [
            {
                "Region Name": "Cocl\xe9 (Province of Panama)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cocl\xe9 (Province of Panama)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cocl\xe9 (Province of Panama)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cocl\xe9 (Province of Panama)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cocl\xe9 (Province of Panama)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cocl\xe9 (Province of Panama)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cocl\xe9 (Province of Panama)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cocl\xe9 (Province of Panama)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cocl\xe9 (Province of Panama)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cocl\xe9 (Province of Panama)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cocl\xe9 (Province of Panama)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cocl\xe9 (Province of Panama)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cocl\xe9 (Province of Panama)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cocl\xe9 (Province of Panama)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cocl\xe9 (Province of Panama)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cocl\xe9 (Province of Panama)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cocl\xe9 (Province of Panama)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cocl\xe9 (Province of Panama)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cocl\xe9 (Province of Panama)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cocl\xe9 (Province of Panama)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cocl\xe9 (Province of Panama)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cocl\xe9 (Province of Panama)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Coimbra (District of Portugal)": [
            {
                "Region Name": "Coimbra (District of Portugal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Coimbra (District of Portugal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Coimbra (District of Portugal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coimbra (District of Portugal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 94
            },
            {
                "Region Name": "Coimbra (District of Portugal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Coimbra (District of Portugal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Coimbra (District of Portugal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coimbra (District of Portugal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Coimbra (District of Portugal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Coimbra (District of Portugal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coimbra (District of Portugal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Coimbra (District of Portugal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Coimbra (District of Portugal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Coimbra (District of Portugal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Coimbra (District of Portugal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Coimbra (District of Portugal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 384
            },
            {
                "Region Name": "Coimbra (District of Portugal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coimbra (District of Portugal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Coimbra (District of Portugal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Coimbra (District of Portugal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coimbra (District of Portugal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Coimbra (District of Portugal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cojedes (State of Venezuela)": [
            {
                "Region Name": "Cojedes (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Cojedes (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cojedes (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cojedes (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cojedes (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Cojedes (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cojedes (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cojedes (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Cojedes (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Cojedes (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Cojedes (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Cojedes (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Cojedes (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cojedes (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Cojedes (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cojedes (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Cojedes (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Cojedes (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cojedes (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Cojedes (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cojedes (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cojedes (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Colima (State of M\xe9xico)": [
            {
                "Region Name": "Colima (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Colima (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Colima (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Colima (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Colima (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Colima (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Colima (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Colima (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Colima (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Colima (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Colima (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Colima (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Colima (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Colima (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Colima (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Colima (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Colima (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Colima (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Colima (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Colima (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Colima (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Colima (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Collines (Department of Benin)": [
            {
                "Region Name": "Collines (Department of Benin)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Collines (Department of Benin)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Collines (Department of Benin)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Collines (Department of Benin)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Collines (Department of Benin)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Collines (Department of Benin)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Collines (Department of Benin)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Collines (Department of Benin)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Collines (Department of Benin)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Collines (Department of Benin)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Collines (Department of Benin)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Collines (Department of Benin)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Collines (Department of Benin)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Collines (Department of Benin)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Collines (Department of Benin)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Collines (Department of Benin)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Collines (Department of Benin)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Collines (Department of Benin)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Collines (Department of Benin)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Collines (Department of Benin)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Collines (Department of Benin)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Collines (Department of Benin)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Colombo (District of Sri Lanka)": [
            {
                "Region Name": "Colombo (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Colombo (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Colombo (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Colombo (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Colombo (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Colombo (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Colombo (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Colombo (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Colombo (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Colombo (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Colombo (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Colombo (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Colombo (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Colombo (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Colombo (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Colombo (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Colombo (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Colombo (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Colombo (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Colombo (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Colombo (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Colombo (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Col\xf3n (Department of Honduras)": [
            {
                "Region Name": "Col\xf3n (Department of Honduras)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Col\xf3n (Department of Honduras)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Col\xf3n (Department of Honduras)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Col\xf3n (Department of Honduras)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Col\xf3n (Department of Honduras)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Col\xf3n (Department of Honduras)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Col\xf3n (Department of Honduras)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Col\xf3n (Department of Honduras)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Col\xf3n (Department of Honduras)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Col\xf3n (Department of Honduras)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Col\xf3n (Department of Honduras)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Col\xf3n (Department of Honduras)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Col\xf3n (Department of Honduras)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Col\xf3n (Department of Honduras)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Col\xf3n (Department of Honduras)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Col\xf3n (Department of Honduras)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Col\xf3n (Department of Honduras)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Col\xf3n (Department of Honduras)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Col\xf3n (Department of Honduras)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Col\xf3n (Department of Honduras)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Col\xf3n (Department of Honduras)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Col\xf3n (Department of Honduras)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Col\xf3n (Province of Panama)": [
            {
                "Region Name": "Col\xf3n (Province of Panama)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Col\xf3n (Province of Panama)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Col\xf3n (Province of Panama)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Col\xf3n (Province of Panama)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Col\xf3n (Province of Panama)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Col\xf3n (Province of Panama)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Col\xf3n (Province of Panama)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Col\xf3n (Province of Panama)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Col\xf3n (Province of Panama)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Col\xf3n (Province of Panama)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Col\xf3n (Province of Panama)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Col\xf3n (Province of Panama)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Col\xf3n (Province of Panama)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Col\xf3n (Province of Panama)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Col\xf3n (Province of Panama)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Col\xf3n (Province of Panama)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Col\xf3n (Province of Panama)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Col\xf3n (Province of Panama)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Col\xf3n (Province of Panama)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Col\xf3n (Province of Panama)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Col\xf3n (Province of Panama)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Col\xf3n (Province of Panama)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Colonia (Department of Uruguay)": [
            {
                "Region Name": "Colonia (Department of Uruguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Colonia (Department of Uruguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Colonia (Department of Uruguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Colonia (Department of Uruguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Colonia (Department of Uruguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Colonia (Department of Uruguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Colonia (Department of Uruguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Colonia (Department of Uruguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Colonia (Department of Uruguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Colonia (Department of Uruguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Colonia (Department of Uruguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Colonia (Department of Uruguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Colonia (Department of Uruguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Colonia (Department of Uruguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Colonia (Department of Uruguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Colonia (Department of Uruguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Colonia (Department of Uruguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Colonia (Department of Uruguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Colonia (Department of Uruguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Colonia (Department of Uruguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Colonia (Department of Uruguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Colonia (Department of Uruguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Colorado (State of United States)": [
            {
                "Region Name": "Colorado (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Colorado (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Colorado (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Colorado (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Colorado (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Colorado (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Colorado (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Colorado (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Colorado (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Colorado (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Colorado (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Colorado (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Colorado (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Colorado (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Colorado (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Colorado (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Colorado (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Colorado (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Colorado (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Colorado (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Colorado (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Colorado (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Comayagua (Department of Honduras)": [
            {
                "Region Name": "Comayagua (Department of Honduras)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Comayagua (Department of Honduras)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Comayagua (Department of Honduras)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Comayagua (Department of Honduras)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Comayagua (Department of Honduras)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Comayagua (Department of Honduras)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Comayagua (Department of Honduras)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Comayagua (Department of Honduras)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Comayagua (Department of Honduras)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Comayagua (Department of Honduras)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Comayagua (Department of Honduras)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Comayagua (Department of Honduras)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Comayagua (Department of Honduras)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Comayagua (Department of Honduras)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Comayagua (Department of Honduras)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Comayagua (Department of Honduras)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Comayagua (Department of Honduras)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Comayagua (Department of Honduras)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Comayagua (Department of Honduras)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Comayagua (Department of Honduras)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comayagua (Department of Honduras)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Comayagua (Department of Honduras)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Comer\xedo (Municipality of Puerto Rico)": [
            {
                "Region Name": "Comer\xedo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comer\xedo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comer\xedo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comer\xedo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comer\xedo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comer\xedo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comer\xedo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comer\xedo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comer\xedo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comer\xedo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comer\xedo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comer\xedo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comer\xedo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comer\xedo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comer\xedo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comer\xedo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comer\xedo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comer\xedo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comer\xedo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comer\xedo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comer\xedo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comer\xedo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Commewijne (District of Suriname)": [
            {
                "Region Name": "Commewijne (District of Suriname)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Commewijne (District of Suriname)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Commewijne (District of Suriname)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Commewijne (District of Suriname)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Commewijne (District of Suriname)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Commewijne (District of Suriname)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Commewijne (District of Suriname)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Commewijne (District of Suriname)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Commewijne (District of Suriname)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Commewijne (District of Suriname)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Commewijne (District of Suriname)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Commewijne (District of Suriname)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Commewijne (District of Suriname)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Commewijne (District of Suriname)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Commewijne (District of Suriname)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Commewijne (District of Suriname)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Commewijne (District of Suriname)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Commewijne (District of Suriname)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Commewijne (District of Suriname)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Commewijne (District of Suriname)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Commewijne (District of Suriname)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Commewijne (District of Suriname)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Como\xe9 (District of C\xf4te d'Ivoire)": [
            {
                "Region Name": "Como\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Como\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Como\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Como\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Como\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Como\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Como\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Como\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Como\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Como\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Como\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Como\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Como\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Como\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Como\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Como\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Como\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Como\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Como\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Como\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Como\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Como\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Compostela Valley (Province of Philippines)": [
            {
                "Region Name": "Compostela Valley (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Compostela Valley (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Compostela Valley (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Compostela Valley (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Compostela Valley (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Compostela Valley (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Compostela Valley (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Compostela Valley (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Compostela Valley (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Compostela Valley (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Compostela Valley (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Compostela Valley (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Compostela Valley (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Compostela Valley (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Compostela Valley (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Compostela Valley (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Compostela Valley (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Compostela Valley (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Compostela Valley (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Compostela Valley (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Compostela Valley (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Compostela Valley (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Comunidad de Madrid (Autonomous Community of Spain)": [
            {
                "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Comunidad de Madrid (Autonomous Community of Spain)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Comunidad Foral de Navarra (Autonomous Community of Spain)": [
            {
                "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 75
            },
            {
                "Region Name": "Comunidad Foral de Navarra (Autonomous Community of Spain)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Comunidad Valenciana (Autonomous Community of Spain)": [
            {
                "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 63
            },
            {
                "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 266
            },
            {
                "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 180
            },
            {
                "Region Name": "Comunidad Valenciana (Autonomous Community of Spain)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Conakry (Region of Guinea)": [
            {
                "Region Name": "Conakry (Region of Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Conakry (Region of Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Conakry (Region of Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Conakry (Region of Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Conakry (Region of Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Conakry (Region of Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Conakry (Region of Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Conakry (Region of Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Conakry (Region of Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Conakry (Region of Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Conakry (Region of Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Conakry (Region of Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Conakry (Region of Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Conakry (Region of Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Conakry (Region of Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Conakry (Region of Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Conakry (Region of Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Conakry (Region of Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Conakry (Region of Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Conakry (Region of Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Conakry (Region of Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Conakry (Region of Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Concepci\xf3n (Department of Paraguay)": [
            {
                "Region Name": "Concepci\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Concepci\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Concepci\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Concepci\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Concepci\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Concepci\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Concepci\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Concepci\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Concepci\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Concepci\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Concepci\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Concepci\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Concepci\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Concepci\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Concepci\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Concepci\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Concepci\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Concepci\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Concepci\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Concepci\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Concepci\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Concepci\xf3n (Department of Paraguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Connecticut (State of United States)": [
            {
                "Region Name": "Connecticut (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Connecticut (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Connecticut (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Connecticut (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Connecticut (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Connecticut (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Connecticut (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Connecticut (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Connecticut (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Connecticut (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Connecticut (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Connecticut (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Connecticut (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Connecticut (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Connecticut (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Connecticut (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Connecticut (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Connecticut (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Connecticut (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Connecticut (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Connecticut (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Connecticut (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Constan\u021Ba (County of Romania)": [
            {
                "Region Name": "Constan\u021Ba (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Constan\u021Ba (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Constan\u021Ba (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Constan\u021Ba (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Constan\u021Ba (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Constan\u021Ba (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Constan\u021Ba (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Constan\u021Ba (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Constan\u021Ba (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Constan\u021Ba (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Constan\u021Ba (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Constan\u021Ba (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Constan\u021Ba (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Constan\u021Ba (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Constan\u021Ba (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Constan\u021Ba (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Constan\u021Ba (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Constan\u021Ba (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Constan\u021Ba (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Constan\u021Ba (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Constan\u021Ba (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Constan\u021Ba (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Constantine (Province of Algeria)": [
            {
                "Region Name": "Constantine (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Constantine (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Constantine (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Constantine (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Constantine (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Constantine (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Constantine (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Constantine (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Constantine (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Constantine (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Constantine (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Constantine (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Constantine (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Constantine (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Constantine (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Constantine (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Constantine (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Constantine (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Constantine (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Constantine (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Constantine (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Constantine (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cop\xe1n (Department of Honduras)": [
            {
                "Region Name": "Cop\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cop\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cop\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cop\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cop\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cop\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cop\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cop\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Cop\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cop\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cop\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cop\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cop\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cop\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cop\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cop\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cop\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cop\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cop\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cop\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cop\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cop\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Copperbelt (Province of Zambia)": [
            {
                "Region Name": "Copperbelt (Province of Zambia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Copperbelt (Province of Zambia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Copperbelt (Province of Zambia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Copperbelt (Province of Zambia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Copperbelt (Province of Zambia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Copperbelt (Province of Zambia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Copperbelt (Province of Zambia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Copperbelt (Province of Zambia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Copperbelt (Province of Zambia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Copperbelt (Province of Zambia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Copperbelt (Province of Zambia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Copperbelt (Province of Zambia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Copperbelt (Province of Zambia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Copperbelt (Province of Zambia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Copperbelt (Province of Zambia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Copperbelt (Province of Zambia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Copperbelt (Province of Zambia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Copperbelt (Province of Zambia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Copperbelt (Province of Zambia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Copperbelt (Province of Zambia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Copperbelt (Province of Zambia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Copperbelt (Province of Zambia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Coquimbo (Region of Chile)": [
            {
                "Region Name": "Coquimbo (Region of Chile)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Coquimbo (Region of Chile)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Coquimbo (Region of Chile)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coquimbo (Region of Chile)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Coquimbo (Region of Chile)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Coquimbo (Region of Chile)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coquimbo (Region of Chile)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coquimbo (Region of Chile)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Coquimbo (Region of Chile)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coquimbo (Region of Chile)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coquimbo (Region of Chile)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coquimbo (Region of Chile)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coquimbo (Region of Chile)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Coquimbo (Region of Chile)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coquimbo (Region of Chile)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Coquimbo (Region of Chile)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Coquimbo (Region of Chile)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coquimbo (Region of Chile)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Coquimbo (Region of Chile)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coquimbo (Region of Chile)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Coquimbo (Region of Chile)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coquimbo (Region of Chile)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Coral Sea Islands Territory (Territory of Australia)": [
            {
                "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coral Sea Islands Territory (Territory of Australia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cordillera (Department of Paraguay)": [
            {
                "Region Name": "Cordillera (Department of Paraguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cordillera (Department of Paraguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cordillera (Department of Paraguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cordillera (Department of Paraguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cordillera (Department of Paraguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cordillera (Department of Paraguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cordillera (Department of Paraguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cordillera (Department of Paraguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cordillera (Department of Paraguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cordillera (Department of Paraguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cordillera (Department of Paraguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cordillera (Department of Paraguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cordillera (Department of Paraguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cordillera (Department of Paraguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cordillera (Department of Paraguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cordillera (Department of Paraguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cordillera (Department of Paraguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cordillera (Department of Paraguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cordillera (Department of Paraguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cordillera (Department of Paraguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cordillera (Department of Paraguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cordillera (Department of Paraguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "C\xf3rdoba (Department of Colombia)": [
            {
                "Region Name": "C\xf3rdoba (Department of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "C\xf3rdoba (Department of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "C\xf3rdoba (Department of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "C\xf3rdoba (Department of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "C\xf3rdoba (Department of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "C\xf3rdoba (Department of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "C\xf3rdoba (Department of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "C\xf3rdoba (Department of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "C\xf3rdoba (Department of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "C\xf3rdoba (Department of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "C\xf3rdoba (Department of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "C\xf3rdoba (Department of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "C\xf3rdoba (Department of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "C\xf3rdoba (Department of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "C\xf3rdoba (Department of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "C\xf3rdoba (Department of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "C\xf3rdoba (Department of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "C\xf3rdoba (Department of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "C\xf3rdoba (Department of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "C\xf3rdoba (Department of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "C\xf3rdoba (Department of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "C\xf3rdoba (Department of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "C\xf3rdoba (Province of Argentina)": [
            {
                "Region Name": "C\xf3rdoba (Province of Argentina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "C\xf3rdoba (Province of Argentina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "C\xf3rdoba (Province of Argentina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "C\xf3rdoba (Province of Argentina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "C\xf3rdoba (Province of Argentina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "C\xf3rdoba (Province of Argentina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "C\xf3rdoba (Province of Argentina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "C\xf3rdoba (Province of Argentina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "C\xf3rdoba (Province of Argentina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "C\xf3rdoba (Province of Argentina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "C\xf3rdoba (Province of Argentina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "C\xf3rdoba (Province of Argentina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "C\xf3rdoba (Province of Argentina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "C\xf3rdoba (Province of Argentina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "C\xf3rdoba (Province of Argentina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "C\xf3rdoba (Province of Argentina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "C\xf3rdoba (Province of Argentina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "C\xf3rdoba (Province of Argentina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "C\xf3rdoba (Province of Argentina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "C\xf3rdoba (Province of Argentina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "C\xf3rdoba (Province of Argentina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "C\xf3rdoba (Province of Argentina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Cork (County of Ireland)": [
            {
                "Region Name": "Cork (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cork (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cork (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cork (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cork (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cork (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cork (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cork (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cork (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cork (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cork (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cork (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cork (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cork (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cork (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cork (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cork (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cork (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cork (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cork (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cork (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cork (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Coronie (District of Suriname)": [
            {
                "Region Name": "Coronie (District of Suriname)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Coronie (District of Suriname)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Coronie (District of Suriname)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Coronie (District of Suriname)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coronie (District of Suriname)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Coronie (District of Suriname)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coronie (District of Suriname)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coronie (District of Suriname)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coronie (District of Suriname)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coronie (District of Suriname)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Coronie (District of Suriname)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coronie (District of Suriname)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coronie (District of Suriname)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coronie (District of Suriname)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Coronie (District of Suriname)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coronie (District of Suriname)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coronie (District of Suriname)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coronie (District of Suriname)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Coronie (District of Suriname)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Coronie (District of Suriname)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coronie (District of Suriname)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Coronie (District of Suriname)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Corozal (District of Belize)": [
            {
                "Region Name": "Corozal (District of Belize)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (District of Belize)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Corozal (District of Belize)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Corozal (District of Belize)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Corozal (District of Belize)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (District of Belize)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Corozal (District of Belize)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (District of Belize)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Corozal (District of Belize)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (District of Belize)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Corozal (District of Belize)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Corozal (District of Belize)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Corozal (District of Belize)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (District of Belize)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Corozal (District of Belize)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (District of Belize)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Corozal (District of Belize)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (District of Belize)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Corozal (District of Belize)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Corozal (District of Belize)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Corozal (District of Belize)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Corozal (District of Belize)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Corozal (Municipality of Puerto Rico)": [
            {
                "Region Name": "Corozal (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corozal (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Corrientes (Province of Argentina)": [
            {
                "Region Name": "Corrientes (Province of Argentina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Corrientes (Province of Argentina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Corrientes (Province of Argentina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Corrientes (Province of Argentina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Corrientes (Province of Argentina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Corrientes (Province of Argentina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Corrientes (Province of Argentina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Corrientes (Province of Argentina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Corrientes (Province of Argentina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Corrientes (Province of Argentina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Corrientes (Province of Argentina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Corrientes (Province of Argentina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Corrientes (Province of Argentina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Corrientes (Province of Argentina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Corrientes (Province of Argentina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Corrientes (Province of Argentina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Corrientes (Province of Argentina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Corrientes (Province of Argentina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Corrientes (Province of Argentina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Corrientes (Province of Argentina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Corrientes (Province of Argentina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Corrientes (Province of Argentina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Corse (Region of France)": [
            {
                "Region Name": "Corse (Region of France)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Corse (Region of France)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Corse (Region of France)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Corse (Region of France)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Corse (Region of France)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Corse (Region of France)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corse (Region of France)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corse (Region of France)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Corse (Region of France)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corse (Region of France)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Corse (Region of France)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corse (Region of France)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corse (Region of France)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Corse (Region of France)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Corse (Region of France)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Corse (Region of France)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Corse (Region of France)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Corse (Region of France)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Corse (Region of France)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Corse (Region of France)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Corse (Region of France)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Corse (Region of France)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Cort\xe9s (Department of Honduras)": [
            {
                "Region Name": "Cort\xe9s (Department of Honduras)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cort\xe9s (Department of Honduras)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cort\xe9s (Department of Honduras)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cort\xe9s (Department of Honduras)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cort\xe9s (Department of Honduras)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cort\xe9s (Department of Honduras)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cort\xe9s (Department of Honduras)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cort\xe9s (Department of Honduras)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cort\xe9s (Department of Honduras)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cort\xe9s (Department of Honduras)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cort\xe9s (Department of Honduras)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cort\xe9s (Department of Honduras)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cort\xe9s (Department of Honduras)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cort\xe9s (Department of Honduras)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cort\xe9s (Department of Honduras)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cort\xe9s (Department of Honduras)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cort\xe9s (Department of Honduras)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cort\xe9s (Department of Honduras)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cort\xe9s (Department of Honduras)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cort\xe9s (Department of Honduras)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cort\xe9s (Department of Honduras)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cort\xe9s (Department of Honduras)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "\xc7orum (Province of Turkey)": [
            {
                "Region Name": "\xc7orum (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\xc7orum (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xc7orum (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\xc7orum (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\xc7orum (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\xc7orum (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xc7orum (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xc7orum (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "\xc7orum (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "\xc7orum (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "\xc7orum (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xc7orum (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "\xc7orum (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xc7orum (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\xc7orum (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\xc7orum (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xc7orum (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xc7orum (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xc7orum (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xc7orum (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xc7orum (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xc7orum (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Cotopaxi (Province of Ecuador)": [
            {
                "Region Name": "Cotopaxi (Province of Ecuador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cotopaxi (Province of Ecuador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cotopaxi (Province of Ecuador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cotopaxi (Province of Ecuador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cotopaxi (Province of Ecuador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cotopaxi (Province of Ecuador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cotopaxi (Province of Ecuador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cotopaxi (Province of Ecuador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cotopaxi (Province of Ecuador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cotopaxi (Province of Ecuador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cotopaxi (Province of Ecuador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Cotopaxi (Province of Ecuador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cotopaxi (Province of Ecuador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cotopaxi (Province of Ecuador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cotopaxi (Province of Ecuador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cotopaxi (Province of Ecuador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cotopaxi (Province of Ecuador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cotopaxi (Province of Ecuador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cotopaxi (Province of Ecuador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cotopaxi (Province of Ecuador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cotopaxi (Province of Ecuador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cotopaxi (Province of Ecuador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Countryside (Sub-Region of \xc5land)": [
            {
                "Region Name": "Countryside (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Countryside (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Countryside (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Countryside (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Countryside (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Countryside (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Countryside (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Countryside (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Countryside (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Countryside (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Countryside (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Countryside (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Countryside (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Countryside (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Countryside (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Countryside (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Countryside (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Countryside (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Countryside (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Countryside (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Countryside (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Countryside (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)": [
            {
                "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Couva-Tabaquite-Talparo (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Covalima (District of Timor-Leste)": [
            {
                "Region Name": "Covalima (District of Timor-Leste)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Covalima (District of Timor-Leste)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Covalima (District of Timor-Leste)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Covalima (District of Timor-Leste)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Covalima (District of Timor-Leste)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Covalima (District of Timor-Leste)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Covalima (District of Timor-Leste)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Covalima (District of Timor-Leste)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Covalima (District of Timor-Leste)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Covalima (District of Timor-Leste)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Covalima (District of Timor-Leste)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Covalima (District of Timor-Leste)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Covalima (District of Timor-Leste)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Covalima (District of Timor-Leste)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Covalima (District of Timor-Leste)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Covalima (District of Timor-Leste)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Covalima (District of Timor-Leste)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Covalima (District of Timor-Leste)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Covalima (District of Timor-Leste)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Covalima (District of Timor-Leste)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Covalima (District of Timor-Leste)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Covalima (District of Timor-Leste)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Covasna (County of Romania)": [
            {
                "Region Name": "Covasna (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Covasna (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Covasna (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Covasna (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Covasna (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Covasna (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Covasna (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Covasna (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Covasna (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Covasna (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Covasna (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Covasna (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Covasna (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Covasna (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Covasna (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Covasna (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Covasna (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Covasna (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Covasna (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Covasna (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Covasna (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Covasna (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Crete (Decentralized administration of Greece)": [
            {
                "Region Name": "Crete (Decentralized administration of Greece)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Crete (Decentralized administration of Greece)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Crete (Decentralized administration of Greece)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Crete (Decentralized administration of Greece)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Crete (Decentralized administration of Greece)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Crete (Decentralized administration of Greece)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Crete (Decentralized administration of Greece)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Crete (Decentralized administration of Greece)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Crete (Decentralized administration of Greece)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Crete (Decentralized administration of Greece)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Crete (Decentralized administration of Greece)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Crete (Decentralized administration of Greece)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Crete (Decentralized administration of Greece)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Crete (Decentralized administration of Greece)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Crete (Decentralized administration of Greece)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Crete (Decentralized administration of Greece)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Crete (Decentralized administration of Greece)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Crete (Decentralized administration of Greece)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Crete (Decentralized administration of Greece)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Crete (Decentralized administration of Greece)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Crete (Decentralized administration of Greece)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Crete (Decentralized administration of Greece)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Crimea (Autonomous Republic of Ukraine)": [
            {
                "Region Name": "Crimea (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Crimea (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Crimea (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Crimea (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Crimea (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Crimea (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Crimea (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Crimea (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Crimea (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Crimea (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Crimea (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Crimea (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Crimea (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Crimea (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Crimea (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Crimea (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Crimea (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Crimea (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Crimea (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Crimea (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Crimea (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Crimea (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Criuleni (District of Moldova)": [
            {
                "Region Name": "Criuleni (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Criuleni (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Criuleni (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Criuleni (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Criuleni (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Criuleni (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Criuleni (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Criuleni (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Criuleni (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Criuleni (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Criuleni (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Criuleni (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Criuleni (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Criuleni (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Criuleni (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Criuleni (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Criuleni (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Criuleni (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Criuleni (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Criuleni (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Criuleni (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Criuleni (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Crooked Island (District of Bahamas)": [
            {
                "Region Name": "Crooked Island (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Crooked Island (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Crooked Island (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Crooked Island (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Crooked Island (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Crooked Island (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Crooked Island (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Crooked Island (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Crooked Island (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Crooked Island (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Crooked Island (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Crooked Island (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Crooked Island (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Crooked Island (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Crooked Island (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Crooked Island (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Crooked Island (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Crooked Island (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Crooked Island (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Crooked Island (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Crooked Island (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Crooked Island (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cross River (State of Nigeria)": [
            {
                "Region Name": "Cross River (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Cross River (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Cross River (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Cross River (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cross River (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cross River (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cross River (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cross River (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cross River (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Cross River (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cross River (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cross River (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cross River (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Cross River (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cross River (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cross River (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cross River (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cross River (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Cross River (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cross River (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cross River (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cross River (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Csongr\xe1d (County of Hungary)": [
            {
                "Region Name": "Csongr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Csongr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Csongr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Csongr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Csongr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Csongr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Csongr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Csongr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Csongr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Csongr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Csongr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Csongr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Csongr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Csongr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Csongr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Csongr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Csongr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Csongr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Csongr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Csongr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Csongr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Csongr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cuando Cubango (Province of Angola)": [
            {
                "Region Name": "Cuando Cubango (Province of Angola)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Cuando Cubango (Province of Angola)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Cuando Cubango (Province of Angola)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Cuando Cubango (Province of Angola)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Cuando Cubango (Province of Angola)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Cuando Cubango (Province of Angola)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Cuando Cubango (Province of Angola)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Cuando Cubango (Province of Angola)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Cuando Cubango (Province of Angola)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Cuando Cubango (Province of Angola)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Cuando Cubango (Province of Angola)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Cuando Cubango (Province of Angola)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Cuando Cubango (Province of Angola)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Cuando Cubango (Province of Angola)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Cuando Cubango (Province of Angola)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Cuando Cubango (Province of Angola)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Cuando Cubango (Province of Angola)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Cuando Cubango (Province of Angola)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Cuando Cubango (Province of Angola)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Cuando Cubango (Province of Angola)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Cuando Cubango (Province of Angola)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Cuando Cubango (Province of Angola)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 27
            }
        ],
        "Cuanza Norte (Province of Angola)": [
            {
                "Region Name": "Cuanza Norte (Province of Angola)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cuanza Norte (Province of Angola)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Cuanza Norte (Province of Angola)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cuanza Norte (Province of Angola)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cuanza Norte (Province of Angola)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cuanza Norte (Province of Angola)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cuanza Norte (Province of Angola)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cuanza Norte (Province of Angola)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cuanza Norte (Province of Angola)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cuanza Norte (Province of Angola)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cuanza Norte (Province of Angola)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cuanza Norte (Province of Angola)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cuanza Norte (Province of Angola)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cuanza Norte (Province of Angola)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cuanza Norte (Province of Angola)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cuanza Norte (Province of Angola)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cuanza Norte (Province of Angola)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Cuanza Norte (Province of Angola)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cuanza Norte (Province of Angola)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cuanza Norte (Province of Angola)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cuanza Norte (Province of Angola)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cuanza Norte (Province of Angola)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Cuanza Sul (Province of Angola)": [
            {
                "Region Name": "Cuanza Sul (Province of Angola)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Cuanza Sul (Province of Angola)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Cuanza Sul (Province of Angola)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Cuanza Sul (Province of Angola)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Cuanza Sul (Province of Angola)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Cuanza Sul (Province of Angola)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Cuanza Sul (Province of Angola)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Cuanza Sul (Province of Angola)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Cuanza Sul (Province of Angola)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Cuanza Sul (Province of Angola)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Cuanza Sul (Province of Angola)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Cuanza Sul (Province of Angola)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Cuanza Sul (Province of Angola)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Cuanza Sul (Province of Angola)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Cuanza Sul (Province of Angola)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Cuanza Sul (Province of Angola)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Cuanza Sul (Province of Angola)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Cuanza Sul (Province of Angola)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Cuanza Sul (Province of Angola)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Cuanza Sul (Province of Angola)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Cuanza Sul (Province of Angola)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Cuanza Sul (Province of Angola)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 20
            }
        ],
        "\u010Cu\u010Der-Sandevo (Municipality of North Macedonia)": [
            {
                "Region Name": "\u010Cu\u010Der-Sandevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Cu\u010Der-Sandevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Cu\u010Der-Sandevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Cu\u010Der-Sandevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Cu\u010Der-Sandevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Cu\u010Der-Sandevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Cu\u010Der-Sandevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Cu\u010Der-Sandevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Cu\u010Der-Sandevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Cu\u010Der-Sandevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Cu\u010Der-Sandevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Cu\u010Der-Sandevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Cu\u010Der-Sandevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Cu\u010Der-Sandevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Cu\u010Der-Sandevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Cu\u010Der-Sandevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Cu\u010Der-Sandevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Cu\u010Der-Sandevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Cu\u010Der-Sandevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Cu\u010Der-Sandevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Cu\u010Der-Sandevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u010Cu\u010Der-Sandevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Culebra (Municipality of Puerto Rico)": [
            {
                "Region Name": "Culebra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Culebra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Culebra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Culebra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Culebra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Culebra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Culebra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Culebra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Culebra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Culebra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Culebra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Culebra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Culebra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Culebra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Culebra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Culebra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Culebra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Culebra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Culebra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Culebra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Culebra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Culebra (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cundinamarca (Department of Colombia)": [
            {
                "Region Name": "Cundinamarca (Department of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cundinamarca (Department of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cundinamarca (Department of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cundinamarca (Department of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cundinamarca (Department of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cundinamarca (Department of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Cundinamarca (Department of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cundinamarca (Department of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cundinamarca (Department of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cundinamarca (Department of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cundinamarca (Department of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cundinamarca (Department of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cundinamarca (Department of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cundinamarca (Department of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cundinamarca (Department of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cundinamarca (Department of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cundinamarca (Department of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cundinamarca (Department of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cundinamarca (Department of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cundinamarca (Department of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cundinamarca (Department of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cundinamarca (Department of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Cunene (Province of Angola)": [
            {
                "Region Name": "Cunene (Province of Angola)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "Cunene (Province of Angola)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Cunene (Province of Angola)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Cunene (Province of Angola)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Cunene (Province of Angola)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Cunene (Province of Angola)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Cunene (Province of Angola)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Cunene (Province of Angola)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Cunene (Province of Angola)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Cunene (Province of Angola)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Cunene (Province of Angola)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Cunene (Province of Angola)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Cunene (Province of Angola)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Cunene (Province of Angola)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Cunene (Province of Angola)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Cunene (Province of Angola)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Cunene (Province of Angola)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Cunene (Province of Angola)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Cunene (Province of Angola)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Cunene (Province of Angola)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Cunene (Province of Angola)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Cunene (Province of Angola)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 26
            }
        ],
        "Cuscatl\xe1n (Department of El Salvador)": [
            {
                "Region Name": "Cuscatl\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cuscatl\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cuscatl\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cuscatl\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cuscatl\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cuscatl\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cuscatl\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cuscatl\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cuscatl\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cuscatl\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cuscatl\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cuscatl\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cuscatl\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cuscatl\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cuscatl\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cuscatl\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cuscatl\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cuscatl\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cuscatl\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cuscatl\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cuscatl\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cuscatl\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Cusco (Region of Peru)": [
            {
                "Region Name": "Cusco (Region of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cusco (Region of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cusco (Region of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cusco (Region of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cusco (Region of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cusco (Region of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cusco (Region of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cusco (Region of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cusco (Region of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cusco (Region of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cusco (Region of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cusco (Region of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cusco (Region of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cusco (Region of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cusco (Region of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cusco (Region of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cusco (Region of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cusco (Region of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cusco (Region of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cusco (Region of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Cusco (Region of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Cusco (Region of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Cuvette-Ouest (Region of Republic of the Congo)": [
            {
                "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuvette-Ouest (Region of Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Cuvette (Region of Republic of the Congo)": [
            {
                "Region Name": "Cuvette (Region of Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cuvette (Region of Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cuvette (Region of Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuvette (Region of Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuvette (Region of Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuvette (Region of Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuvette (Region of Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cuvette (Region of Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cuvette (Region of Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Cuvette (Region of Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cuvette (Region of Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuvette (Region of Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuvette (Region of Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuvette (Region of Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Cuvette (Region of Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuvette (Region of Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuvette (Region of Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuvette (Region of Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuvette (Region of Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuvette (Region of Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Cuvette (Region of Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Cuvette (Region of Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Cuyuni-Mazaruni (Region of Guyana)": [
            {
                "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Cuyuni-Mazaruni (Region of Guyana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "\u0110\xe0 N\u1EB5ng (City of Vietnam)": [
            {
                "Region Name": "\u0110\xe0 N\u1EB5ng (City of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110\xe0 N\u1EB5ng (City of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110\xe0 N\u1EB5ng (City of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0110\xe0 N\u1EB5ng (City of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0110\xe0 N\u1EB5ng (City of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0110\xe0 N\u1EB5ng (City of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110\xe0 N\u1EB5ng (City of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0110\xe0 N\u1EB5ng (City of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110\xe0 N\u1EB5ng (City of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "\u0110\xe0 N\u1EB5ng (City of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110\xe0 N\u1EB5ng (City of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0110\xe0 N\u1EB5ng (City of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110\xe0 N\u1EB5ng (City of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0110\xe0 N\u1EB5ng (City of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0110\xe0 N\u1EB5ng (City of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110\xe0 N\u1EB5ng (City of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0110\xe0 N\u1EB5ng (City of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110\xe0 N\u1EB5ng (City of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110\xe0 N\u1EB5ng (City of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110\xe0 N\u1EB5ng (City of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0110\xe0 N\u1EB5ng (City of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110\xe0 N\u1EB5ng (City of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dadra and Nagar Haveli (Union Territory of India)": [
            {
                "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dadra and Nagar Haveli (Union Territory of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Daegu (Metropolitan City of South Korea)": [
            {
                "Region Name": "Daegu (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daegu (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daegu (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daegu (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daegu (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daegu (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daegu (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daegu (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daegu (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daegu (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daegu (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daegu (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daegu (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daegu (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daegu (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daegu (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daegu (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daegu (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daegu (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daegu (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daegu (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daegu (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Daejeon (Metropolitan City of South Korea)": [
            {
                "Region Name": "Daejeon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daejeon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daejeon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daejeon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daejeon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daejeon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daejeon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daejeon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daejeon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daejeon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daejeon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daejeon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daejeon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daejeon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daejeon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daejeon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daejeon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daejeon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daejeon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daejeon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daejeon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daejeon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dagana (District of Bhutan)": [
            {
                "Region Name": "Dagana (District of Bhutan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dagana (District of Bhutan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dagana (District of Bhutan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dagana (District of Bhutan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dagana (District of Bhutan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dagana (District of Bhutan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dagana (District of Bhutan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dagana (District of Bhutan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dagana (District of Bhutan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dagana (District of Bhutan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dagana (District of Bhutan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dagana (District of Bhutan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dagana (District of Bhutan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dagana (District of Bhutan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dagana (District of Bhutan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dagana (District of Bhutan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dagana (District of Bhutan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dagana (District of Bhutan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dagana (District of Bhutan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dagana (District of Bhutan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dagana (District of Bhutan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dagana (District of Bhutan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dagestan (Republic of Russia)": [
            {
                "Region Name": "Dagestan (Republic of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dagestan (Republic of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dagestan (Republic of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dagestan (Republic of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Dagestan (Republic of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Dagestan (Republic of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Dagestan (Republic of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dagestan (Republic of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dagestan (Republic of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Dagestan (Republic of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Dagestan (Republic of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Dagestan (Republic of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Dagestan (Republic of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dagestan (Republic of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dagestan (Republic of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Dagestan (Republic of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Dagestan (Republic of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Dagestan (Republic of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Dagestan (Republic of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Dagestan (Republic of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dagestan (Republic of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Dagestan (Republic of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Daglig-Shirvan (Region of Azerbaijan)": [
            {
                "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Daglig-Shirvan (Region of Azerbaijan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dajab\xf3n (Province of Dominican Republic)": [
            {
                "Region Name": "Dajab\xf3n (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dajab\xf3n (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dajab\xf3n (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dajab\xf3n (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dajab\xf3n (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dajab\xf3n (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dajab\xf3n (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dajab\xf3n (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dajab\xf3n (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dajab\xf3n (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dajab\xf3n (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dajab\xf3n (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dajab\xf3n (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dajab\xf3n (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dajab\xf3n (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dajab\xf3n (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dajab\xf3n (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dajab\xf3n (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dajab\xf3n (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dajab\xf3n (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dajab\xf3n (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dajab\xf3n (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\u0110\u1EAFk L\u1EAFk (Province of Vietnam)": [
            {
                "Region Name": "\u0110\u1EAFk L\u1EAFk (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "\u0110\u1EAFk L\u1EAFk (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "\u0110\u1EAFk L\u1EAFk (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "\u0110\u1EAFk L\u1EAFk (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "\u0110\u1EAFk L\u1EAFk (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "\u0110\u1EAFk L\u1EAFk (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "\u0110\u1EAFk L\u1EAFk (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "\u0110\u1EAFk L\u1EAFk (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "\u0110\u1EAFk L\u1EAFk (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "\u0110\u1EAFk L\u1EAFk (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "\u0110\u1EAFk L\u1EAFk (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "\u0110\u1EAFk L\u1EAFk (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "\u0110\u1EAFk L\u1EAFk (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "\u0110\u1EAFk L\u1EAFk (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "\u0110\u1EAFk L\u1EAFk (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "\u0110\u1EAFk L\u1EAFk (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "\u0110\u1EAFk L\u1EAFk (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "\u0110\u1EAFk L\u1EAFk (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "\u0110\u1EAFk L\u1EAFk (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "\u0110\u1EAFk L\u1EAFk (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "\u0110\u1EAFk L\u1EAFk (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "\u0110\u1EAFk L\u1EAFk (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "\u0110\u1EAFk N\xf4ng (Province of Vietnam)": [
            {
                "Region Name": "\u0110\u1EAFk N\xf4ng (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0110\u1EAFk N\xf4ng (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0110\u1EAFk N\xf4ng (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0110\u1EAFk N\xf4ng (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0110\u1EAFk N\xf4ng (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\u0110\u1EAFk N\xf4ng (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0110\u1EAFk N\xf4ng (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0110\u1EAFk N\xf4ng (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0110\u1EAFk N\xf4ng (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0110\u1EAFk N\xf4ng (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0110\u1EAFk N\xf4ng (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0110\u1EAFk N\xf4ng (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0110\u1EAFk N\xf4ng (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0110\u1EAFk N\xf4ng (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\u0110\u1EAFk N\xf4ng (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0110\u1EAFk N\xf4ng (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "\u0110\u1EAFk N\xf4ng (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\u0110\u1EAFk N\xf4ng (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "\u0110\u1EAFk N\xf4ng (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "\u0110\u1EAFk N\xf4ng (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "\u0110\u1EAFk N\xf4ng (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "\u0110\u1EAFk N\xf4ng (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Dakar (Region of Senegal)": [
            {
                "Region Name": "Dakar (Region of Senegal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakar (Region of Senegal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakar (Region of Senegal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakar (Region of Senegal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakar (Region of Senegal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakar (Region of Senegal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakar (Region of Senegal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakar (Region of Senegal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakar (Region of Senegal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakar (Region of Senegal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakar (Region of Senegal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakar (Region of Senegal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakar (Region of Senegal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakar (Region of Senegal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakar (Region of Senegal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakar (Region of Senegal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakar (Region of Senegal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakar (Region of Senegal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakar (Region of Senegal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakar (Region of Senegal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakar (Region of Senegal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakar (Region of Senegal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dakhlet Nouadhibou (Region of Mauritania)": [
            {
                "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dakhlet Nouadhibou (Region of Mauritania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\u0110akovica (District of Kosovo)": [
            {
                "Region Name": "\u0110akovica (District of Kosovo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110akovica (District of Kosovo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\u0110akovica (District of Kosovo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110akovica (District of Kosovo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110akovica (District of Kosovo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110akovica (District of Kosovo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "\u0110akovica (District of Kosovo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110akovica (District of Kosovo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110akovica (District of Kosovo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110akovica (District of Kosovo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110akovica (District of Kosovo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "\u0110akovica (District of Kosovo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110akovica (District of Kosovo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110akovica (District of Kosovo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0110akovica (District of Kosovo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110akovica (District of Kosovo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110akovica (District of Kosovo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110akovica (District of Kosovo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "\u0110akovica (District of Kosovo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0110akovica (District of Kosovo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0110akovica (District of Kosovo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0110akovica (District of Kosovo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Dalarna (County of Sweden)": [
            {
                "Region Name": "Dalarna (County of Sweden)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dalarna (County of Sweden)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dalarna (County of Sweden)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dalarna (County of Sweden)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dalarna (County of Sweden)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dalarna (County of Sweden)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dalarna (County of Sweden)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dalarna (County of Sweden)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dalarna (County of Sweden)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dalarna (County of Sweden)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dalarna (County of Sweden)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dalarna (County of Sweden)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dalarna (County of Sweden)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dalarna (County of Sweden)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dalarna (County of Sweden)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dalarna (County of Sweden)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dalarna (County of Sweden)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Dalarna (County of Sweden)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dalarna (County of Sweden)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dalarna (County of Sweden)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dalarna (County of Sweden)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dalarna (County of Sweden)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Daman and Diu (Union Territory of India)": [
            {
                "Region Name": "Daman and Diu (Union Territory of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daman and Diu (Union Territory of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daman and Diu (Union Territory of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daman and Diu (Union Territory of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daman and Diu (Union Territory of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daman and Diu (Union Territory of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daman and Diu (Union Territory of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daman and Diu (Union Territory of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daman and Diu (Union Territory of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daman and Diu (Union Territory of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daman and Diu (Union Territory of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daman and Diu (Union Territory of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daman and Diu (Union Territory of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daman and Diu (Union Territory of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daman and Diu (Union Territory of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daman and Diu (Union Territory of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daman and Diu (Union Territory of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daman and Diu (Union Territory of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daman and Diu (Union Territory of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daman and Diu (Union Territory of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daman and Diu (Union Territory of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daman and Diu (Union Territory of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Damascus (Governorate of Syria)": [
            {
                "Region Name": "Damascus (Governorate of Syria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Damascus (Governorate of Syria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Damascus (Governorate of Syria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Damascus (Governorate of Syria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Damascus (Governorate of Syria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Damascus (Governorate of Syria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Damascus (Governorate of Syria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Damascus (Governorate of Syria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Damascus (Governorate of Syria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Damascus (Governorate of Syria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Damascus (Governorate of Syria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Damascus (Governorate of Syria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Damascus (Governorate of Syria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Damascus (Governorate of Syria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Damascus (Governorate of Syria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Damascus (Governorate of Syria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Damascus (Governorate of Syria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Damascus (Governorate of Syria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Damascus (Governorate of Syria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Damascus (Governorate of Syria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Damascus (Governorate of Syria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Damascus (Governorate of Syria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "D\xe2mbovi\u021Ba (County of Romania)": [
            {
                "Region Name": "D\xe2mbovi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xe2mbovi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xe2mbovi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xe2mbovi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "D\xe2mbovi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "D\xe2mbovi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xe2mbovi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "D\xe2mbovi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xe2mbovi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xe2mbovi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "D\xe2mbovi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "D\xe2mbovi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "D\xe2mbovi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "D\xe2mbovi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xe2mbovi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "D\xe2mbovi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xe2mbovi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "D\xe2mbovi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "D\xe2mbovi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "D\xe2mbovi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "D\xe2mbovi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "D\xe2mbovi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Danilovgrad (Municipality of Montenegro)": [
            {
                "Region Name": "Danilovgrad (Municipality of Montenegro)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Danilovgrad (Municipality of Montenegro)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Danilovgrad (Municipality of Montenegro)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Danilovgrad (Municipality of Montenegro)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Danilovgrad (Municipality of Montenegro)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Danilovgrad (Municipality of Montenegro)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Danilovgrad (Municipality of Montenegro)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Danilovgrad (Municipality of Montenegro)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Danilovgrad (Municipality of Montenegro)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Danilovgrad (Municipality of Montenegro)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Danilovgrad (Municipality of Montenegro)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Danilovgrad (Municipality of Montenegro)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Danilovgrad (Municipality of Montenegro)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Danilovgrad (Municipality of Montenegro)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Danilovgrad (Municipality of Montenegro)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Danilovgrad (Municipality of Montenegro)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Danilovgrad (Municipality of Montenegro)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Danilovgrad (Municipality of Montenegro)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Danilovgrad (Municipality of Montenegro)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Danilovgrad (Municipality of Montenegro)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Danilovgrad (Municipality of Montenegro)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Danilovgrad (Municipality of Montenegro)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dar es Salaam (Region of Tanzania)": [
            {
                "Region Name": "Dar es Salaam (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dar es Salaam (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dar es Salaam (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dar es Salaam (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dar es Salaam (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dar es Salaam (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dar es Salaam (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dar es Salaam (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dar es Salaam (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dar es Salaam (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Dar es Salaam (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dar es Salaam (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dar es Salaam (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dar es Salaam (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dar es Salaam (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dar es Salaam (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dar es Salaam (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dar es Salaam (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dar es Salaam (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dar es Salaam (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dar es Salaam (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dar es Salaam (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Dar`a (Governorate of Syria)": [
            {
                "Region Name": "Dar`a (Governorate of Syria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dar`a (Governorate of Syria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dar`a (Governorate of Syria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dar`a (Governorate of Syria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dar`a (Governorate of Syria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dar`a (Governorate of Syria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dar`a (Governorate of Syria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dar`a (Governorate of Syria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dar`a (Governorate of Syria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dar`a (Governorate of Syria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dar`a (Governorate of Syria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dar`a (Governorate of Syria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dar`a (Governorate of Syria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dar`a (Governorate of Syria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dar`a (Governorate of Syria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dar`a (Governorate of Syria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Dar`a (Governorate of Syria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dar`a (Governorate of Syria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dar`a (Governorate of Syria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dar`a (Governorate of Syria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dar`a (Governorate of Syria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dar`a (Governorate of Syria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Darhan-Uul (Municipality of Mongolia)": [
            {
                "Region Name": "Darhan-Uul (Municipality of Mongolia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Darhan-Uul (Municipality of Mongolia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darhan-Uul (Municipality of Mongolia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Darhan-Uul (Municipality of Mongolia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darhan-Uul (Municipality of Mongolia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Darhan-Uul (Municipality of Mongolia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 284
            },
            {
                "Region Name": "Darhan-Uul (Municipality of Mongolia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Darhan-Uul (Municipality of Mongolia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Darhan-Uul (Municipality of Mongolia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Darhan-Uul (Municipality of Mongolia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darhan-Uul (Municipality of Mongolia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darhan-Uul (Municipality of Mongolia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darhan-Uul (Municipality of Mongolia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darhan-Uul (Municipality of Mongolia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Darhan-Uul (Municipality of Mongolia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darhan-Uul (Municipality of Mongolia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darhan-Uul (Municipality of Mongolia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darhan-Uul (Municipality of Mongolia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darhan-Uul (Municipality of Mongolia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darhan-Uul (Municipality of Mongolia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darhan-Uul (Municipality of Mongolia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Darhan-Uul (Municipality of Mongolia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dari\xe9n (Province of Panama)": [
            {
                "Region Name": "Dari\xe9n (Province of Panama)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dari\xe9n (Province of Panama)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Dari\xe9n (Province of Panama)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dari\xe9n (Province of Panama)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dari\xe9n (Province of Panama)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dari\xe9n (Province of Panama)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dari\xe9n (Province of Panama)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dari\xe9n (Province of Panama)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dari\xe9n (Province of Panama)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dari\xe9n (Province of Panama)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dari\xe9n (Province of Panama)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dari\xe9n (Province of Panama)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dari\xe9n (Province of Panama)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dari\xe9n (Province of Panama)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dari\xe9n (Province of Panama)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Dari\xe9n (Province of Panama)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dari\xe9n (Province of Panama)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dari\xe9n (Province of Panama)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dari\xe9n (Province of Panama)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Dari\xe9n (Province of Panama)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dari\xe9n (Province of Panama)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dari\xe9n (Province of Panama)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Darnah (District of Libya)": [
            {
                "Region Name": "Darnah (District of Libya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Darnah (District of Libya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnah (District of Libya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnah (District of Libya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnah (District of Libya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnah (District of Libya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnah (District of Libya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnah (District of Libya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnah (District of Libya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnah (District of Libya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnah (District of Libya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnah (District of Libya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Darnah (District of Libya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnah (District of Libya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnah (District of Libya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnah (District of Libya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnah (District of Libya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnah (District of Libya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnah (District of Libya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnah (District of Libya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnah (District of Libya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnah (District of Libya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Darnytskyi (Distict of Ukraine)": [
            {
                "Region Name": "Darnytskyi (Distict of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnytskyi (Distict of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnytskyi (Distict of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnytskyi (Distict of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Darnytskyi (Distict of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnytskyi (Distict of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnytskyi (Distict of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnytskyi (Distict of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnytskyi (Distict of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnytskyi (Distict of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Darnytskyi (Distict of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnytskyi (Distict of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnytskyi (Distict of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnytskyi (Distict of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnytskyi (Distict of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnytskyi (Distict of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnytskyi (Distict of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnytskyi (Distict of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnytskyi (Distict of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnytskyi (Distict of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnytskyi (Distict of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Darnytskyi (Distict of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Da\u015Foguz (Province of Turkmenistan)": [
            {
                "Region Name": "Da\u015Foguz (Province of Turkmenistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Da\u015Foguz (Province of Turkmenistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Da\u015Foguz (Province of Turkmenistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Da\u015Foguz (Province of Turkmenistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Da\u015Foguz (Province of Turkmenistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Da\u015Foguz (Province of Turkmenistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Da\u015Foguz (Province of Turkmenistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Da\u015Foguz (Province of Turkmenistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Da\u015Foguz (Province of Turkmenistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Da\u015Foguz (Province of Turkmenistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Da\u015Foguz (Province of Turkmenistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Da\u015Foguz (Province of Turkmenistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Da\u015Foguz (Province of Turkmenistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Da\u015Foguz (Province of Turkmenistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Da\u015Foguz (Province of Turkmenistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Da\u015Foguz (Province of Turkmenistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Da\u015Foguz (Province of Turkmenistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Da\u015Foguz (Province of Turkmenistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Da\u015Foguz (Province of Turkmenistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Da\u015Foguz (Province of Turkmenistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Da\u015Foguz (Province of Turkmenistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Da\u015Foguz (Province of Turkmenistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Davao del Norte (Province of Philippines)": [
            {
                "Region Name": "Davao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Davao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Davao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Davao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Davao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Davao del Sur (Province of Philippines)": [
            {
                "Region Name": "Davao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Davao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Davao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Davao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Davao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Davao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Davao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Davao Oriental (Province of Philippines)": [
            {
                "Region Name": "Davao Oriental (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao Oriental (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao Oriental (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Davao Oriental (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao Oriental (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao Oriental (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao Oriental (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao Oriental (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao Oriental (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao Oriental (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao Oriental (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao Oriental (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao Oriental (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao Oriental (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao Oriental (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Davao Oriental (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao Oriental (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao Oriental (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao Oriental (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao Oriental (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao Oriental (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Davao Oriental (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Daykundi (Province of Afghanistan)": [
            {
                "Region Name": "Daykundi (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daykundi (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daykundi (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daykundi (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daykundi (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daykundi (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daykundi (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daykundi (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daykundi (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daykundi (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daykundi (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daykundi (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daykundi (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daykundi (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daykundi (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daykundi (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daykundi (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daykundi (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daykundi (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daykundi (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daykundi (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Daykundi (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Dayr Az Zawr (Governorate of Syria)": [
            {
                "Region Name": "Dayr Az Zawr (Governorate of Syria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dayr Az Zawr (Governorate of Syria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dayr Az Zawr (Governorate of Syria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dayr Az Zawr (Governorate of Syria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dayr Az Zawr (Governorate of Syria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dayr Az Zawr (Governorate of Syria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dayr Az Zawr (Governorate of Syria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dayr Az Zawr (Governorate of Syria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dayr Az Zawr (Governorate of Syria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dayr Az Zawr (Governorate of Syria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dayr Az Zawr (Governorate of Syria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Dayr Az Zawr (Governorate of Syria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dayr Az Zawr (Governorate of Syria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dayr Az Zawr (Governorate of Syria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dayr Az Zawr (Governorate of Syria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Dayr Az Zawr (Governorate of Syria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dayr Az Zawr (Governorate of Syria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dayr Az Zawr (Governorate of Syria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dayr Az Zawr (Governorate of Syria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dayr Az Zawr (Governorate of Syria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dayr Az Zawr (Governorate of Syria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dayr Az Zawr (Governorate of Syria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Debar (Municipality of North Macedonia)": [
            {
                "Region Name": "Debar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Debarca (Municipality of North Macedonia)": [
            {
                "Region Name": "Debarca (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debarca (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debarca (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debarca (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debarca (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debarca (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debarca (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debarca (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debarca (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debarca (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debarca (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debarca (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debarca (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debarca (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debarca (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debarca (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debarca (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Debarca (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Debarca (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debarca (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debarca (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debarca (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Debub (Region of Eritrea)": [
            {
                "Region Name": "Debub (Region of Eritrea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Debub (Region of Eritrea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debub (Region of Eritrea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debub (Region of Eritrea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debub (Region of Eritrea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debub (Region of Eritrea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debub (Region of Eritrea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Debub (Region of Eritrea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debub (Region of Eritrea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debub (Region of Eritrea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debub (Region of Eritrea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debub (Region of Eritrea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debub (Region of Eritrea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Debub (Region of Eritrea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debub (Region of Eritrea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debub (Region of Eritrea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debub (Region of Eritrea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debub (Region of Eritrea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debub (Region of Eritrea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debub (Region of Eritrea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debub (Region of Eritrea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debub (Region of Eritrea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Debubawi Keyih Bahri (Region of Eritrea)": [
            {
                "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "Debubawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Dededo (Municipality of Guam)": [
            {
                "Region Name": "Dededo (Municipality of Guam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dededo (Municipality of Guam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dededo (Municipality of Guam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dededo (Municipality of Guam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dededo (Municipality of Guam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dededo (Municipality of Guam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dededo (Municipality of Guam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dededo (Municipality of Guam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dededo (Municipality of Guam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dededo (Municipality of Guam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dededo (Municipality of Guam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dededo (Municipality of Guam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dededo (Municipality of Guam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dededo (Municipality of Guam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dededo (Municipality of Guam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dededo (Municipality of Guam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dededo (Municipality of Guam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dededo (Municipality of Guam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dededo (Municipality of Guam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dededo (Municipality of Guam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dededo (Municipality of Guam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dededo (Municipality of Guam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dedza (District of Malawi)": [
            {
                "Region Name": "Dedza (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dedza (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dedza (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dedza (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dedza (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dedza (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dedza (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dedza (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dedza (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dedza (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dedza (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dedza (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dedza (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dedza (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dedza (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dedza (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dedza (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Dedza (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dedza (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dedza (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dedza (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dedza (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Delaware (State of United States)": [
            {
                "Region Name": "Delaware (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Delaware (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Delaware (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Delaware (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Delaware (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Delaware (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Delaware (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Delaware (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Delaware (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Delaware (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Delaware (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Delaware (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Delaware (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Delaware (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Delaware (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Delaware (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Delaware (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Delaware (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Delaware (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Delaware (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Delaware (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Delaware (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Del\u010Devo (Municipality of North Macedonia)": [
            {
                "Region Name": "Del\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Del\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Del\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Del\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Del\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Del\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Del\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Del\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Del\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Del\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Del\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Del\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Del\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Del\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Del\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Del\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Del\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Del\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Del\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Del\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Del\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Del\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Delta (State of Nigeria)": [
            {
                "Region Name": "Delta (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Delta (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Delta (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Delta (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Delta (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Delta (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Delta (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Delta (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Delta (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Delta (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Delta (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Delta (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Delta (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Delta (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Delta (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Delta (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Delta (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Delta (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Delta (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Delta (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Delta (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Delta (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Delta Amacuro (State of Venezuela)": [
            {
                "Region Name": "Delta Amacuro (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Delta Amacuro (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Delta Amacuro (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Delta Amacuro (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Delta Amacuro (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Delta Amacuro (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Delta Amacuro (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Delta Amacuro (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Delta Amacuro (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Delta Amacuro (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Delta Amacuro (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Delta Amacuro (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Delta Amacuro (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Delta Amacuro (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Delta Amacuro (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Delta Amacuro (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Delta Amacuro (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Delta Amacuro (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Delta Amacuro (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Delta Amacuro (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Delta Amacuro (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 59
            },
            {
                "Region Name": "Delta Amacuro (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Dembeni (Commune of Mayotte)": [
            {
                "Region Name": "Dembeni (Commune of Mayotte)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dembeni (Commune of Mayotte)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dembeni (Commune of Mayotte)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dembeni (Commune of Mayotte)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dembeni (Commune of Mayotte)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dembeni (Commune of Mayotte)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dembeni (Commune of Mayotte)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dembeni (Commune of Mayotte)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dembeni (Commune of Mayotte)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dembeni (Commune of Mayotte)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dembeni (Commune of Mayotte)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dembeni (Commune of Mayotte)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dembeni (Commune of Mayotte)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dembeni (Commune of Mayotte)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dembeni (Commune of Mayotte)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dembeni (Commune of Mayotte)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dembeni (Commune of Mayotte)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dembeni (Commune of Mayotte)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dembeni (Commune of Mayotte)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dembeni (Commune of Mayotte)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dembeni (Commune of Mayotte)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dembeni (Commune of Mayotte)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Demerara-Mahaica (Region of Guyana)": [
            {
                "Region Name": "Demerara-Mahaica (Region of Guyana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Demerara-Mahaica (Region of Guyana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Demerara-Mahaica (Region of Guyana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Demerara-Mahaica (Region of Guyana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Demerara-Mahaica (Region of Guyana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Demerara-Mahaica (Region of Guyana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Demerara-Mahaica (Region of Guyana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Demerara-Mahaica (Region of Guyana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Demerara-Mahaica (Region of Guyana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Demerara-Mahaica (Region of Guyana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demerara-Mahaica (Region of Guyana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Demerara-Mahaica (Region of Guyana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Demerara-Mahaica (Region of Guyana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Demerara-Mahaica (Region of Guyana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Demerara-Mahaica (Region of Guyana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Demerara-Mahaica (Region of Guyana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Demerara-Mahaica (Region of Guyana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Demerara-Mahaica (Region of Guyana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Demerara-Mahaica (Region of Guyana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Demerara-Mahaica (Region of Guyana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Demerara-Mahaica (Region of Guyana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Demerara-Mahaica (Region of Guyana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Demir Hisar (Municipality of North Macedonia)": [
            {
                "Region Name": "Demir Hisar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Hisar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Hisar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Hisar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Hisar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Hisar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Demir Hisar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Hisar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Hisar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Hisar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Hisar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Demir Hisar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Hisar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Hisar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Hisar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Hisar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Hisar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Hisar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Hisar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Hisar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Hisar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Hisar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Demir Kapija (Municipality of North Macedonia)": [
            {
                "Region Name": "Demir Kapija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Kapija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Kapija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Kapija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Kapija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Kapija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Demir Kapija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Kapija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Kapija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Kapija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Kapija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Kapija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Kapija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Kapija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Kapija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Kapija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Kapija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Kapija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Kapija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Kapija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Kapija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Demir Kapija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dengu\xe9l\xe9 (District of C\xf4te d'Ivoire)": [
            {
                "Region Name": "Dengu\xe9l\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Dengu\xe9l\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Dengu\xe9l\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Dengu\xe9l\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Dengu\xe9l\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Dengu\xe9l\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Dengu\xe9l\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Dengu\xe9l\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Dengu\xe9l\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Dengu\xe9l\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Dengu\xe9l\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dengu\xe9l\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dengu\xe9l\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dengu\xe9l\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dengu\xe9l\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dengu\xe9l\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dengu\xe9l\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dengu\xe9l\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dengu\xe9l\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dengu\xe9l\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dengu\xe9l\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dengu\xe9l\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Denigomodu (District of Nauru)": [
            {
                "Region Name": "Denigomodu (District of Nauru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denigomodu (District of Nauru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denigomodu (District of Nauru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denigomodu (District of Nauru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denigomodu (District of Nauru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denigomodu (District of Nauru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denigomodu (District of Nauru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denigomodu (District of Nauru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denigomodu (District of Nauru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denigomodu (District of Nauru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denigomodu (District of Nauru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denigomodu (District of Nauru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denigomodu (District of Nauru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denigomodu (District of Nauru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denigomodu (District of Nauru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denigomodu (District of Nauru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denigomodu (District of Nauru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denigomodu (District of Nauru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denigomodu (District of Nauru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denigomodu (District of Nauru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denigomodu (District of Nauru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denigomodu (District of Nauru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Denizli (Province of Turkey)": [
            {
                "Region Name": "Denizli (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denizli (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Denizli (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Denizli (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Denizli (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Denizli (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denizli (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denizli (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denizli (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denizli (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Denizli (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Denizli (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Denizli (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denizli (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Denizli (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Denizli (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Denizli (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Denizli (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Denizli (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Denizli (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Denizli (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Denizli (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dennery (Quarter of Saint Lucia)": [
            {
                "Region Name": "Dennery (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dennery (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dennery (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dennery (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dennery (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dennery (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dennery (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dennery (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dennery (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dennery (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dennery (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dennery (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dennery (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dennery (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dennery (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dennery (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dennery (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dennery (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dennery (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dennery (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dennery (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dennery (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dependencias Federales (State of Venezuela)": [
            {
                "Region Name": "Dependencias Federales (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dependencias Federales (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dependencias Federales (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dependencias Federales (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dependencias Federales (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dependencias Federales (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dependencias Federales (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dependencias Federales (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dependencias Federales (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dependencias Federales (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dependencias Federales (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dependencias Federales (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dependencias Federales (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dependencias Federales (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dependencias Federales (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dependencias Federales (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dependencias Federales (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dependencias Federales (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dependencias Federales (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dependencias Federales (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dependencias Federales (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dependencias Federales (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Devonshire (Parish of Bermuda)": [
            {
                "Region Name": "Devonshire (Parish of Bermuda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Devonshire (Parish of Bermuda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Devonshire (Parish of Bermuda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Devonshire (Parish of Bermuda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Devonshire (Parish of Bermuda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Devonshire (Parish of Bermuda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Devonshire (Parish of Bermuda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Devonshire (Parish of Bermuda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Devonshire (Parish of Bermuda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Devonshire (Parish of Bermuda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Devonshire (Parish of Bermuda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Devonshire (Parish of Bermuda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Devonshire (Parish of Bermuda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Devonshire (Parish of Bermuda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Devonshire (Parish of Bermuda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Devonshire (Parish of Bermuda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Devonshire (Parish of Bermuda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Devonshire (Parish of Bermuda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Devonshire (Parish of Bermuda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Devonshire (Parish of Bermuda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Devonshire (Parish of Bermuda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Devonshire (Parish of Bermuda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dhaka (Division of Bangladesh)": [
            {
                "Region Name": "Dhaka (Division of Bangladesh)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dhaka (Division of Bangladesh)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhaka (Division of Bangladesh)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Dhaka (Division of Bangladesh)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dhaka (Division of Bangladesh)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Dhaka (Division of Bangladesh)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dhaka (Division of Bangladesh)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Dhaka (Division of Bangladesh)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dhaka (Division of Bangladesh)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Dhaka (Division of Bangladesh)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dhaka (Division of Bangladesh)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dhaka (Division of Bangladesh)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhaka (Division of Bangladesh)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dhaka (Division of Bangladesh)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhaka (Division of Bangladesh)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dhaka (Division of Bangladesh)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Dhaka (Division of Bangladesh)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhaka (Division of Bangladesh)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dhaka (Division of Bangladesh)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Dhaka (Division of Bangladesh)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhaka (Division of Bangladesh)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dhaka (Division of Bangladesh)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dhamar (Governorate of Yemen)": [
            {
                "Region Name": "Dhamar (Governorate of Yemen)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhamar (Governorate of Yemen)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhamar (Governorate of Yemen)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhamar (Governorate of Yemen)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhamar (Governorate of Yemen)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhamar (Governorate of Yemen)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhamar (Governorate of Yemen)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhamar (Governorate of Yemen)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhamar (Governorate of Yemen)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhamar (Governorate of Yemen)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhamar (Governorate of Yemen)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhamar (Governorate of Yemen)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhamar (Governorate of Yemen)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhamar (Governorate of Yemen)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhamar (Governorate of Yemen)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhamar (Governorate of Yemen)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhamar (Governorate of Yemen)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhamar (Governorate of Yemen)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhamar (Governorate of Yemen)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhamar (Governorate of Yemen)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhamar (Governorate of Yemen)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhamar (Governorate of Yemen)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)": [
            {
                "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhekelia (Sovereign Base Area of Akrotiri and Dhekelia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dhi-Qar (Province of Iraq)": [
            {
                "Region Name": "Dhi-Qar (Province of Iraq)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dhi-Qar (Province of Iraq)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhi-Qar (Province of Iraq)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dhi-Qar (Province of Iraq)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Dhi-Qar (Province of Iraq)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dhi-Qar (Province of Iraq)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dhi-Qar (Province of Iraq)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Dhi-Qar (Province of Iraq)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Dhi-Qar (Province of Iraq)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dhi-Qar (Province of Iraq)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhi-Qar (Province of Iraq)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dhi-Qar (Province of Iraq)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dhi-Qar (Province of Iraq)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dhi-Qar (Province of Iraq)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dhi-Qar (Province of Iraq)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dhi-Qar (Province of Iraq)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dhi-Qar (Province of Iraq)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dhi-Qar (Province of Iraq)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dhi-Qar (Province of Iraq)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dhi-Qar (Province of Iraq)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dhi-Qar (Province of Iraq)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dhi-Qar (Province of Iraq)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Dhofar (Province of Oman)": [
            {
                "Region Name": "Dhofar (Province of Oman)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhofar (Province of Oman)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhofar (Province of Oman)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhofar (Province of Oman)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhofar (Province of Oman)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhofar (Province of Oman)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhofar (Province of Oman)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhofar (Province of Oman)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhofar (Province of Oman)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhofar (Province of Oman)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhofar (Province of Oman)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhofar (Province of Oman)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhofar (Province of Oman)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhofar (Province of Oman)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhofar (Province of Oman)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhofar (Province of Oman)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhofar (Province of Oman)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhofar (Province of Oman)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhofar (Province of Oman)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhofar (Province of Oman)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhofar (Province of Oman)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dhofar (Province of Oman)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dib\xebr (County of Albania)": [
            {
                "Region Name": "Dib\xebr (County of Albania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dib\xebr (County of Albania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dib\xebr (County of Albania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dib\xebr (County of Albania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dib\xebr (County of Albania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dib\xebr (County of Albania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Dib\xebr (County of Albania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dib\xebr (County of Albania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dib\xebr (County of Albania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dib\xebr (County of Albania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dib\xebr (County of Albania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Dib\xebr (County of Albania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dib\xebr (County of Albania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dib\xebr (County of Albania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dib\xebr (County of Albania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dib\xebr (County of Albania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Dib\xebr (County of Albania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dib\xebr (County of Albania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dib\xebr (County of Albania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dib\xebr (County of Albania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dib\xebr (County of Albania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dib\xebr (County of Albania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Diego Martin (Region of Trinidad and Tobago)": [
            {
                "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diego Martin (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Diekirch (District of Luxembourg)": [
            {
                "Region Name": "Diekirch (District of Luxembourg)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diekirch (District of Luxembourg)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diekirch (District of Luxembourg)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diekirch (District of Luxembourg)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diekirch (District of Luxembourg)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diekirch (District of Luxembourg)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diekirch (District of Luxembourg)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diekirch (District of Luxembourg)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diekirch (District of Luxembourg)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diekirch (District of Luxembourg)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diekirch (District of Luxembourg)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diekirch (District of Luxembourg)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diekirch (District of Luxembourg)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diekirch (District of Luxembourg)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diekirch (District of Luxembourg)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diekirch (District of Luxembourg)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diekirch (District of Luxembourg)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diekirch (District of Luxembourg)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diekirch (District of Luxembourg)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diekirch (District of Luxembourg)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diekirch (District of Luxembourg)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diekirch (District of Luxembourg)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\u0110i\u1EC7n Bi\xean (Province of Vietnam)": [
            {
                "Region Name": "\u0110i\u1EC7n Bi\xean (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "\u0110i\u1EC7n Bi\xean (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\u0110i\u1EC7n Bi\xean (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\u0110i\u1EC7n Bi\xean (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\u0110i\u1EC7n Bi\xean (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "\u0110i\u1EC7n Bi\xean (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\u0110i\u1EC7n Bi\xean (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "\u0110i\u1EC7n Bi\xean (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0110i\u1EC7n Bi\xean (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\u0110i\u1EC7n Bi\xean (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "\u0110i\u1EC7n Bi\xean (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0110i\u1EC7n Bi\xean (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\u0110i\u1EC7n Bi\xean (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\u0110i\u1EC7n Bi\xean (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0110i\u1EC7n Bi\xean (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0110i\u1EC7n Bi\xean (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0110i\u1EC7n Bi\xean (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0110i\u1EC7n Bi\xean (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\u0110i\u1EC7n Bi\xean (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0110i\u1EC7n Bi\xean (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0110i\u1EC7n Bi\xean (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0110i\u1EC7n Bi\xean (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Diffa (Department of Niger)": [
            {
                "Region Name": "Diffa (Department of Niger)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Diffa (Department of Niger)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Diffa (Department of Niger)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 150
            },
            {
                "Region Name": "Diffa (Department of Niger)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Diffa (Department of Niger)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Diffa (Department of Niger)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Diffa (Department of Niger)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Diffa (Department of Niger)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Diffa (Department of Niger)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Diffa (Department of Niger)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Diffa (Department of Niger)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Diffa (Department of Niger)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Diffa (Department of Niger)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Diffa (Department of Niger)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Diffa (Department of Niger)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Diffa (Department of Niger)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Diffa (Department of Niger)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Diffa (Department of Niger)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Diffa (Department of Niger)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Diffa (Department of Niger)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Diffa (Department of Niger)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Diffa (Department of Niger)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Dihok (Province of Iraq)": [
            {
                "Region Name": "Dihok (Province of Iraq)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Dihok (Province of Iraq)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Dihok (Province of Iraq)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Dihok (Province of Iraq)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dihok (Province of Iraq)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dihok (Province of Iraq)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Dihok (Province of Iraq)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Dihok (Province of Iraq)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dihok (Province of Iraq)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Dihok (Province of Iraq)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Dihok (Province of Iraq)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Dihok (Province of Iraq)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dihok (Province of Iraq)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Dihok (Province of Iraq)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Dihok (Province of Iraq)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Dihok (Province of Iraq)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Dihok (Province of Iraq)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dihok (Province of Iraq)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Dihok (Province of Iraq)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Dihok (Province of Iraq)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Dihok (Province of Iraq)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dihok (Province of Iraq)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Dikhil (Region of Djibouti)": [
            {
                "Region Name": "Dikhil (Region of Djibouti)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dikhil (Region of Djibouti)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dikhil (Region of Djibouti)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dikhil (Region of Djibouti)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dikhil (Region of Djibouti)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dikhil (Region of Djibouti)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dikhil (Region of Djibouti)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dikhil (Region of Djibouti)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dikhil (Region of Djibouti)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dikhil (Region of Djibouti)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dikhil (Region of Djibouti)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dikhil (Region of Djibouti)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dikhil (Region of Djibouti)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dikhil (Region of Djibouti)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dikhil (Region of Djibouti)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dikhil (Region of Djibouti)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dikhil (Region of Djibouti)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dikhil (Region of Djibouti)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dikhil (Region of Djibouti)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dikhil (Region of Djibouti)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dikhil (Region of Djibouti)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dikhil (Region of Djibouti)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Dili (District of Timor-Leste)": [
            {
                "Region Name": "Dili (District of Timor-Leste)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dili (District of Timor-Leste)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dili (District of Timor-Leste)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dili (District of Timor-Leste)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dili (District of Timor-Leste)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dili (District of Timor-Leste)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dili (District of Timor-Leste)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dili (District of Timor-Leste)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dili (District of Timor-Leste)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dili (District of Timor-Leste)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dili (District of Timor-Leste)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dili (District of Timor-Leste)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dili (District of Timor-Leste)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dili (District of Timor-Leste)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dili (District of Timor-Leste)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dili (District of Timor-Leste)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dili (District of Timor-Leste)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dili (District of Timor-Leste)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dili (District of Timor-Leste)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dili (District of Timor-Leste)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dili (District of Timor-Leste)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dili (District of Timor-Leste)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dinagat Islands (Province of Philippines)": [
            {
                "Region Name": "Dinagat Islands (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dinagat Islands (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dinagat Islands (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dinagat Islands (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dinagat Islands (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dinagat Islands (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dinagat Islands (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dinagat Islands (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dinagat Islands (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dinagat Islands (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dinagat Islands (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dinagat Islands (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dinagat Islands (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dinagat Islands (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dinagat Islands (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dinagat Islands (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dinagat Islands (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dinagat Islands (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dinagat Islands (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dinagat Islands (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dinagat Islands (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dinagat Islands (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Diourbel (Region of Senegal)": [
            {
                "Region Name": "Diourbel (Region of Senegal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diourbel (Region of Senegal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Diourbel (Region of Senegal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Diourbel (Region of Senegal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Diourbel (Region of Senegal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diourbel (Region of Senegal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Diourbel (Region of Senegal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Diourbel (Region of Senegal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Diourbel (Region of Senegal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Diourbel (Region of Senegal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diourbel (Region of Senegal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Diourbel (Region of Senegal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diourbel (Region of Senegal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diourbel (Region of Senegal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diourbel (Region of Senegal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diourbel (Region of Senegal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diourbel (Region of Senegal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diourbel (Region of Senegal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diourbel (Region of Senegal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diourbel (Region of Senegal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diourbel (Region of Senegal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diourbel (Region of Senegal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dire Dawa (City of Ethiopia)": [
            {
                "Region Name": "Dire Dawa (City of Ethiopia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dire Dawa (City of Ethiopia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dire Dawa (City of Ethiopia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dire Dawa (City of Ethiopia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dire Dawa (City of Ethiopia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dire Dawa (City of Ethiopia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dire Dawa (City of Ethiopia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dire Dawa (City of Ethiopia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dire Dawa (City of Ethiopia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dire Dawa (City of Ethiopia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dire Dawa (City of Ethiopia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dire Dawa (City of Ethiopia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dire Dawa (City of Ethiopia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dire Dawa (City of Ethiopia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dire Dawa (City of Ethiopia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dire Dawa (City of Ethiopia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dire Dawa (City of Ethiopia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dire Dawa (City of Ethiopia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dire Dawa (City of Ethiopia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dire Dawa (City of Ethiopia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dire Dawa (City of Ethiopia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dire Dawa (City of Ethiopia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "District of Columbia (Federal District of United States)": [
            {
                "Region Name": "District of Columbia (Federal District of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "District of Columbia (Federal District of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "District of Columbia (Federal District of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "District of Columbia (Federal District of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "District of Columbia (Federal District of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "District of Columbia (Federal District of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "District of Columbia (Federal District of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "District of Columbia (Federal District of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "District of Columbia (Federal District of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "District of Columbia (Federal District of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "District of Columbia (Federal District of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "District of Columbia (Federal District of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "District of Columbia (Federal District of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "District of Columbia (Federal District of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "District of Columbia (Federal District of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "District of Columbia (Federal District of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "District of Columbia (Federal District of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "District of Columbia (Federal District of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "District of Columbia (Federal District of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "District of Columbia (Federal District of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "District of Columbia (Federal District of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "District of Columbia (Federal District of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)": [
            {
                "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Districts of Republican Subordin (Districts of Republican Subordin of Tajikistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Distrito Capital (State of Venezuela)": [
            {
                "Region Name": "Distrito Capital (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Distrito Capital (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Capital (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Capital (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Capital (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Capital (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Distrito Capital (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Capital (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Capital (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Capital (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Capital (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Capital (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Capital (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Capital (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Distrito Capital (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Capital (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Capital (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Distrito Capital (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Capital (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Distrito Capital (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Capital (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Capital (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Distrito Federal (Federal District of Brazil)": [
            {
                "Region Name": "Distrito Federal (Federal District of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Distrito Federal (Federal District of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Distrito Federal (Federal District of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Distrito Federal (Federal District of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Distrito Federal (Federal District of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Distrito Federal (Federal District of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Distrito Federal (Federal District of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Distrito Federal (Federal District of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Distrito Federal (Federal District of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Distrito Federal (Federal District of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Distrito Federal (Federal District of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Distrito Federal (Federal District of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Distrito Federal (Federal District of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Distrito Federal (Federal District of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Distrito Federal (Federal District of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Distrito Federal (Federal District of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Distrito Federal (Federal District of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Distrito Federal (Federal District of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Distrito Federal (Federal District of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Distrito Federal (Federal District of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Distrito Federal (Federal District of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Distrito Federal (Federal District of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Distrito Federal (Federal District of M\xe9xico)": [
            {
                "Region Name": "Distrito Federal (Federal District of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Federal (Federal District of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Distrito Federal (Federal District of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Federal (Federal District of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Distrito Federal (Federal District of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Federal (Federal District of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Distrito Federal (Federal District of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Distrito Federal (Federal District of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Distrito Federal (Federal District of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Distrito Federal (Federal District of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Distrito Federal (Federal District of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Distrito Federal (Federal District of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Distrito Federal (Federal District of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Distrito Federal (Federal District of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Federal (Federal District of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Federal (Federal District of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Distrito Federal (Federal District of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Distrito Federal (Federal District of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Federal (Federal District of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Distrito Federal (Federal District of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Distrito Federal (Federal District of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Federal (Federal District of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Distrito Nacional (National District of Dominican Republic)": [
            {
                "Region Name": "Distrito Nacional (National District of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Nacional (National District of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Nacional (National District of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Nacional (National District of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Nacional (National District of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Nacional (National District of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Nacional (National District of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Nacional (National District of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Nacional (National District of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Nacional (National District of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Nacional (National District of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Nacional (National District of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Nacional (National District of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Nacional (National District of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Nacional (National District of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Nacional (National District of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Nacional (National District of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Nacional (National District of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Nacional (National District of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Nacional (National District of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Nacional (National District of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Distrito Nacional (National District of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Diyala (Province of Iraq)": [
            {
                "Region Name": "Diyala (Province of Iraq)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Diyala (Province of Iraq)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Diyala (Province of Iraq)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Diyala (Province of Iraq)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Diyala (Province of Iraq)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Diyala (Province of Iraq)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Diyala (Province of Iraq)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Diyala (Province of Iraq)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diyala (Province of Iraq)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Diyala (Province of Iraq)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Diyala (Province of Iraq)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Diyala (Province of Iraq)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Diyala (Province of Iraq)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Diyala (Province of Iraq)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Diyala (Province of Iraq)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Diyala (Province of Iraq)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Diyala (Province of Iraq)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Diyala (Province of Iraq)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Diyala (Province of Iraq)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Diyala (Province of Iraq)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Diyala (Province of Iraq)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Diyala (Province of Iraq)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Diyarbakir (Province of Turkey)": [
            {
                "Region Name": "Diyarbakir (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Diyarbakir (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Diyarbakir (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Diyarbakir (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Diyarbakir (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Diyarbakir (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Diyarbakir (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Diyarbakir (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Diyarbakir (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Diyarbakir (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Diyarbakir (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Diyarbakir (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Diyarbakir (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Diyarbakir (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Diyarbakir (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Diyarbakir (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Diyarbakir (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Diyarbakir (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Diyarbakir (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Diyarbakir (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Diyarbakir (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Diyarbakir (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Djelfa (Province of Algeria)": [
            {
                "Region Name": "Djelfa (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Djelfa (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Djelfa (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Djelfa (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Djelfa (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djelfa (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Djelfa (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djelfa (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djelfa (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Djelfa (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djelfa (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Djelfa (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Djelfa (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Djelfa (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Djelfa (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Djelfa (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Djelfa (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djelfa (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Djelfa (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djelfa (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Djelfa (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djelfa (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Djiboutii (Region of Djibouti)": [
            {
                "Region Name": "Djiboutii (Region of Djibouti)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djiboutii (Region of Djibouti)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djiboutii (Region of Djibouti)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djiboutii (Region of Djibouti)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djiboutii (Region of Djibouti)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djiboutii (Region of Djibouti)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djiboutii (Region of Djibouti)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djiboutii (Region of Djibouti)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djiboutii (Region of Djibouti)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djiboutii (Region of Djibouti)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djiboutii (Region of Djibouti)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djiboutii (Region of Djibouti)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djiboutii (Region of Djibouti)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djiboutii (Region of Djibouti)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djiboutii (Region of Djibouti)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djiboutii (Region of Djibouti)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djiboutii (Region of Djibouti)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djiboutii (Region of Djibouti)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djiboutii (Region of Djibouti)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djiboutii (Region of Djibouti)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djiboutii (Region of Djibouti)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Djiboutii (Region of Djibouti)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dnipropetrovs'k (Region of Ukraine)": [
            {
                "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Dnipropetrovs'k (Region of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Dobrich (Province of Bulgaria)": [
            {
                "Region Name": "Dobrich (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dobrich (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dobrich (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dobrich (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dobrich (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dobrich (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dobrich (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dobrich (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dobrich (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dobrich (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dobrich (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Dobrich (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dobrich (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dobrich (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dobrich (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dobrich (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dobrich (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dobrich (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Dobrich (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dobrich (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Dobrich (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dobrich (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dodoma (Region of Tanzania)": [
            {
                "Region Name": "Dodoma (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Dodoma (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dodoma (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Dodoma (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dodoma (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dodoma (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dodoma (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dodoma (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dodoma (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dodoma (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dodoma (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dodoma (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dodoma (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dodoma (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dodoma (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dodoma (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dodoma (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Dodoma (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dodoma (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dodoma (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dodoma (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dodoma (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Dog Island (Island of Anguilla)": [
            {
                "Region Name": "Dog Island (Island of Anguilla)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dog Island (Island of Anguilla)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dog Island (Island of Anguilla)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dog Island (Island of Anguilla)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dog Island (Island of Anguilla)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dog Island (Island of Anguilla)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dog Island (Island of Anguilla)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dog Island (Island of Anguilla)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dog Island (Island of Anguilla)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dog Island (Island of Anguilla)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dog Island (Island of Anguilla)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dog Island (Island of Anguilla)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dog Island (Island of Anguilla)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dog Island (Island of Anguilla)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dog Island (Island of Anguilla)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dog Island (Island of Anguilla)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dog Island (Island of Anguilla)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dog Island (Island of Anguilla)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dog Island (Island of Anguilla)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dog Island (Island of Anguilla)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dog Island (Island of Anguilla)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dog Island (Island of Anguilla)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dolj (County of Romania)": [
            {
                "Region Name": "Dolj (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dolj (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dolj (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dolj (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dolj (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Dolj (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dolj (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Dolj (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dolj (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dolj (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Dolj (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Dolj (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dolj (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dolj (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dolj (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dolj (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dolj (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dolj (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dolj (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dolj (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Dolj (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Dolj (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Dolneni (Municipality of North Macedonia)": [
            {
                "Region Name": "Dolneni (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dolneni (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dolneni (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dolneni (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dolneni (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dolneni (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dolneni (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dolneni (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dolneni (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dolneni (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dolneni (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dolneni (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dolneni (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dolneni (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dolneni (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dolneni (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Dolneni (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dolneni (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dolneni (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dolneni (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dolneni (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dolneni (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Dolno\u015Bl\u0105skie (Voivodeship of Poland)": [
            {
                "Region Name": "Dolno\u015Bl\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dolno\u015Bl\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dolno\u015Bl\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dolno\u015Bl\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Dolno\u015Bl\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dolno\u015Bl\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dolno\u015Bl\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dolno\u015Bl\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dolno\u015Bl\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dolno\u015Bl\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dolno\u015Bl\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dolno\u015Bl\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dolno\u015Bl\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dolno\u015Bl\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dolno\u015Bl\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Dolno\u015Bl\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dolno\u015Bl\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dolno\u015Bl\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dolno\u015Bl\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dolno\u015Bl\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dolno\u015Bl\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dolno\u015Bl\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Domagnano (Municipality of San Marino)": [
            {
                "Region Name": "Domagnano (Municipality of San Marino)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Domagnano (Municipality of San Marino)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Domagnano (Municipality of San Marino)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Domagnano (Municipality of San Marino)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Domagnano (Municipality of San Marino)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Domagnano (Municipality of San Marino)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Domagnano (Municipality of San Marino)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Domagnano (Municipality of San Marino)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Domagnano (Municipality of San Marino)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Domagnano (Municipality of San Marino)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Domagnano (Municipality of San Marino)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Domagnano (Municipality of San Marino)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Domagnano (Municipality of San Marino)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Domagnano (Municipality of San Marino)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Domagnano (Municipality of San Marino)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Domagnano (Municipality of San Marino)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Domagnano (Municipality of San Marino)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Domagnano (Municipality of San Marino)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Domagnano (Municipality of San Marino)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Domagnano (Municipality of San Marino)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Domagnano (Municipality of San Marino)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Domagnano (Municipality of San Marino)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Donduseni (District of Moldova)": [
            {
                "Region Name": "Donduseni (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Donduseni (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donduseni (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donduseni (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Donduseni (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Donduseni (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Donduseni (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Donduseni (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donduseni (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Donduseni (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donduseni (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donduseni (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donduseni (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donduseni (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donduseni (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donduseni (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Donduseni (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Donduseni (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donduseni (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donduseni (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Donduseni (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Donduseni (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Donegal (County of Ireland)": [
            {
                "Region Name": "Donegal (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donegal (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Donegal (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donegal (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donegal (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donegal (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donegal (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donegal (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donegal (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donegal (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Donegal (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donegal (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donegal (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donegal (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donegal (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donegal (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donegal (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donegal (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Donegal (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donegal (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donegal (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Donegal (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Donets'k (Region of Ukraine)": [
            {
                "Region Name": "Donets'k (Region of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Donets'k (Region of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Donets'k (Region of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Donets'k (Region of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Donets'k (Region of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Donets'k (Region of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Donets'k (Region of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Donets'k (Region of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Donets'k (Region of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Donets'k (Region of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Donets'k (Region of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Donets'k (Region of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Donets'k (Region of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Donets'k (Region of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Donets'k (Region of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Donets'k (Region of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Donets'k (Region of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Donets'k (Region of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Donets'k (Region of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Donets'k (Region of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Donets'k (Region of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Donets'k (Region of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "\u0110\u1ED3ng Nai (Province of Vietnam)": [
            {
                "Region Name": "\u0110\u1ED3ng Nai (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0110\u1ED3ng Nai (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0110\u1ED3ng Nai (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0110\u1ED3ng Nai (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0110\u1ED3ng Nai (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\u0110\u1ED3ng Nai (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "\u0110\u1ED3ng Nai (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0110\u1ED3ng Nai (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0110\u1ED3ng Nai (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0110\u1ED3ng Nai (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "\u0110\u1ED3ng Nai (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0110\u1ED3ng Nai (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "\u0110\u1ED3ng Nai (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0110\u1ED3ng Nai (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\u0110\u1ED3ng Nai (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0110\u1ED3ng Nai (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\u0110\u1ED3ng Nai (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0110\u1ED3ng Nai (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0110\u1ED3ng Nai (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0110\u1ED3ng Nai (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0110\u1ED3ng Nai (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0110\u1ED3ng Nai (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "\u0110\u1ED3ng Th\xe1p (Province of Vietnam)": [
            {
                "Region Name": "\u0110\u1ED3ng Th\xe1p (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "\u0110\u1ED3ng Th\xe1p (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "\u0110\u1ED3ng Th\xe1p (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "\u0110\u1ED3ng Th\xe1p (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "\u0110\u1ED3ng Th\xe1p (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "\u0110\u1ED3ng Th\xe1p (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "\u0110\u1ED3ng Th\xe1p (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "\u0110\u1ED3ng Th\xe1p (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "\u0110\u1ED3ng Th\xe1p (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "\u0110\u1ED3ng Th\xe1p (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "\u0110\u1ED3ng Th\xe1p (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "\u0110\u1ED3ng Th\xe1p (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "\u0110\u1ED3ng Th\xe1p (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "\u0110\u1ED3ng Th\xe1p (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "\u0110\u1ED3ng Th\xe1p (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "\u0110\u1ED3ng Th\xe1p (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "\u0110\u1ED3ng Th\xe1p (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "\u0110\u1ED3ng Th\xe1p (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "\u0110\u1ED3ng Th\xe1p (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "\u0110\u1ED3ng Th\xe1p (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "\u0110\u1ED3ng Th\xe1p (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "\u0110\u1ED3ng Th\xe1p (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Donga (Department of Benin)": [
            {
                "Region Name": "Donga (Department of Benin)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Donga (Department of Benin)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Donga (Department of Benin)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Donga (Department of Benin)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Donga (Department of Benin)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Donga (Department of Benin)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Donga (Department of Benin)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Donga (Department of Benin)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Donga (Department of Benin)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Donga (Department of Benin)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Donga (Department of Benin)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Donga (Department of Benin)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Donga (Department of Benin)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Donga (Department of Benin)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Donga (Department of Benin)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Donga (Department of Benin)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Donga (Department of Benin)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Donga (Department of Benin)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Donga (Department of Benin)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Donga (Department of Benin)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Donga (Department of Benin)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Donga (Department of Benin)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Dorado (Municipality of Puerto Rico)": [
            {
                "Region Name": "Dorado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dorado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dorado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dorado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dorado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dorado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dorado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dorado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dorado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dorado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dorado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dorado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dorado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dorado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dorado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dorado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dorado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dorado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dorado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dorado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dorado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dorado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dornod (Province of Mongolia)": [
            {
                "Region Name": "Dornod (Province of Mongolia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 127
            },
            {
                "Region Name": "Dornod (Province of Mongolia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 708
            },
            {
                "Region Name": "Dornod (Province of Mongolia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 146
            },
            {
                "Region Name": "Dornod (Province of Mongolia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 862
            },
            {
                "Region Name": "Dornod (Province of Mongolia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 74
            },
            {
                "Region Name": "Dornod (Province of Mongolia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 166
            },
            {
                "Region Name": "Dornod (Province of Mongolia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Dornod (Province of Mongolia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Dornod (Province of Mongolia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 73
            },
            {
                "Region Name": "Dornod (Province of Mongolia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 554
            },
            {
                "Region Name": "Dornod (Province of Mongolia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 64
            },
            {
                "Region Name": "Dornod (Province of Mongolia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 85
            },
            {
                "Region Name": "Dornod (Province of Mongolia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 124
            },
            {
                "Region Name": "Dornod (Province of Mongolia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 111
            },
            {
                "Region Name": "Dornod (Province of Mongolia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 186
            },
            {
                "Region Name": "Dornod (Province of Mongolia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 477
            },
            {
                "Region Name": "Dornod (Province of Mongolia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Dornod (Province of Mongolia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 178
            },
            {
                "Region Name": "Dornod (Province of Mongolia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 64
            },
            {
                "Region Name": "Dornod (Province of Mongolia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 439
            },
            {
                "Region Name": "Dornod (Province of Mongolia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 189
            },
            {
                "Region Name": "Dornod (Province of Mongolia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1343
            }
        ],
        "Dornogovi (Province of Mongolia)": [
            {
                "Region Name": "Dornogovi (Province of Mongolia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dornogovi (Province of Mongolia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dornogovi (Province of Mongolia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dornogovi (Province of Mongolia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dornogovi (Province of Mongolia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dornogovi (Province of Mongolia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dornogovi (Province of Mongolia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dornogovi (Province of Mongolia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dornogovi (Province of Mongolia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dornogovi (Province of Mongolia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dornogovi (Province of Mongolia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dornogovi (Province of Mongolia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dornogovi (Province of Mongolia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dornogovi (Province of Mongolia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dornogovi (Province of Mongolia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dornogovi (Province of Mongolia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dornogovi (Province of Mongolia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dornogovi (Province of Mongolia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dornogovi (Province of Mongolia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dornogovi (Province of Mongolia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dornogovi (Province of Mongolia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dornogovi (Province of Mongolia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dosso (Department of Niger)": [
            {
                "Region Name": "Dosso (Department of Niger)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Dosso (Department of Niger)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Dosso (Department of Niger)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Dosso (Department of Niger)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Dosso (Department of Niger)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Dosso (Department of Niger)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Dosso (Department of Niger)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dosso (Department of Niger)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Dosso (Department of Niger)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dosso (Department of Niger)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dosso (Department of Niger)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dosso (Department of Niger)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Dosso (Department of Niger)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dosso (Department of Niger)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dosso (Department of Niger)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dosso (Department of Niger)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dosso (Department of Niger)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dosso (Department of Niger)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dosso (Department of Niger)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Dosso (Department of Niger)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dosso (Department of Niger)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dosso (Department of Niger)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Douglas (Town District of Isle of Man)": [
            {
                "Region Name": "Douglas (Town District of Isle of Man)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Douglas (Town District of Isle of Man)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Douglas (Town District of Isle of Man)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Douglas (Town District of Isle of Man)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Douglas (Town District of Isle of Man)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Douglas (Town District of Isle of Man)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Douglas (Town District of Isle of Man)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Douglas (Town District of Isle of Man)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Douglas (Town District of Isle of Man)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Douglas (Town District of Isle of Man)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Douglas (Town District of Isle of Man)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Douglas (Town District of Isle of Man)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Douglas (Town District of Isle of Man)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Douglas (Town District of Isle of Man)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Douglas (Town District of Isle of Man)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Douglas (Town District of Isle of Man)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Douglas (Town District of Isle of Man)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Douglas (Town District of Isle of Man)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Douglas (Town District of Isle of Man)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Douglas (Town District of Isle of Man)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Douglas (Town District of Isle of Man)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Douglas (Town District of Isle of Man)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Doukkala - Abda (Region of Morocco)": [
            {
                "Region Name": "Doukkala - Abda (Region of Morocco)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Doukkala - Abda (Region of Morocco)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Doukkala - Abda (Region of Morocco)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Doukkala - Abda (Region of Morocco)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Doukkala - Abda (Region of Morocco)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Doukkala - Abda (Region of Morocco)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Doukkala - Abda (Region of Morocco)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Doukkala - Abda (Region of Morocco)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Doukkala - Abda (Region of Morocco)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Doukkala - Abda (Region of Morocco)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Doukkala - Abda (Region of Morocco)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Doukkala - Abda (Region of Morocco)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Doukkala - Abda (Region of Morocco)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Doukkala - Abda (Region of Morocco)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Doukkala - Abda (Region of Morocco)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Doukkala - Abda (Region of Morocco)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Doukkala - Abda (Region of Morocco)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Doukkala - Abda (Region of Morocco)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Doukkala - Abda (Region of Morocco)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Doukkala - Abda (Region of Morocco)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Doukkala - Abda (Region of Morocco)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Doukkala - Abda (Region of Morocco)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dowa (District of Malawi)": [
            {
                "Region Name": "Dowa (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dowa (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dowa (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dowa (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dowa (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dowa (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dowa (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dowa (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dowa (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dowa (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dowa (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dowa (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dowa (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dowa (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dowa (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dowa (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dowa (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dowa (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dowa (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dowa (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dowa (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dowa (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Drenthe (Province of Netherlands)": [
            {
                "Region Name": "Drenthe (Province of Netherlands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drenthe (Province of Netherlands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drenthe (Province of Netherlands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drenthe (Province of Netherlands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drenthe (Province of Netherlands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drenthe (Province of Netherlands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drenthe (Province of Netherlands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drenthe (Province of Netherlands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drenthe (Province of Netherlands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drenthe (Province of Netherlands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drenthe (Province of Netherlands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drenthe (Province of Netherlands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drenthe (Province of Netherlands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drenthe (Province of Netherlands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drenthe (Province of Netherlands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drenthe (Province of Netherlands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drenthe (Province of Netherlands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drenthe (Province of Netherlands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drenthe (Province of Netherlands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drenthe (Province of Netherlands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drenthe (Province of Netherlands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drenthe (Province of Netherlands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Drochia (District of Moldova)": [
            {
                "Region Name": "Drochia (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Drochia (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drochia (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drochia (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drochia (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Drochia (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Drochia (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Drochia (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Drochia (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drochia (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Drochia (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Drochia (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drochia (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drochia (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drochia (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drochia (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drochia (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drochia (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drochia (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drochia (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Drochia (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Drochia (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Duarte (Province of Dominican Republic)": [
            {
                "Region Name": "Duarte (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Duarte (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Duarte (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Duarte (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Duarte (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Duarte (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Duarte (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Duarte (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Duarte (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Duarte (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Duarte (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Duarte (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Duarte (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Duarte (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Duarte (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Duarte (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Duarte (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Duarte (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Duarte (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Duarte (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Duarte (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Duarte (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dubai (Emirate of United Arab Emirates)": [
            {
                "Region Name": "Dubai (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubai (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubai (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubai (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubai (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubai (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubai (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubai (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubai (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubai (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubai (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubai (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubai (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubai (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubai (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubai (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubai (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubai (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubai (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubai (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubai (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubai (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dub\u0103sari (District of Moldova)": [
            {
                "Region Name": "Dub\u0103sari (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dub\u0103sari (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dub\u0103sari (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dub\u0103sari (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dub\u0103sari (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dub\u0103sari (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dub\u0103sari (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dub\u0103sari (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dub\u0103sari (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dub\u0103sari (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Dub\u0103sari (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dub\u0103sari (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dub\u0103sari (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dub\u0103sari (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dub\u0103sari (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dub\u0103sari (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dub\u0103sari (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dub\u0103sari (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dub\u0103sari (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dub\u0103sari (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dub\u0103sari (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dub\u0103sari (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dublin (Region of Ireland)": [
            {
                "Region Name": "Dublin (Region of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dublin (Region of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dublin (Region of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dublin (Region of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dublin (Region of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dublin (Region of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dublin (Region of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dublin (Region of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dublin (Region of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dublin (Region of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dublin (Region of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dublin (Region of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dublin (Region of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dublin (Region of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dublin (Region of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dublin (Region of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dublin (Region of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dublin (Region of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dublin (Region of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dublin (Region of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dublin (Region of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dublin (Region of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dubrovacko-Neretvanska (County of Croatia)": [
            {
                "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dubrovacko-Neretvanska (County of Croatia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Dumyat (Governorate of Egypt)": [
            {
                "Region Name": "Dumyat (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dumyat (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dumyat (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dumyat (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dumyat (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dumyat (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Dumyat (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dumyat (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dumyat (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Dumyat (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dumyat (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dumyat (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dumyat (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Dumyat (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dumyat (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dumyat (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dumyat (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dumyat (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dumyat (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Dumyat (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dumyat (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dumyat (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dundgovi (Province of Mongolia)": [
            {
                "Region Name": "Dundgovi (Province of Mongolia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dundgovi (Province of Mongolia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dundgovi (Province of Mongolia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dundgovi (Province of Mongolia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dundgovi (Province of Mongolia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dundgovi (Province of Mongolia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dundgovi (Province of Mongolia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dundgovi (Province of Mongolia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dundgovi (Province of Mongolia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dundgovi (Province of Mongolia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dundgovi (Province of Mongolia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dundgovi (Province of Mongolia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dundgovi (Province of Mongolia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dundgovi (Province of Mongolia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dundgovi (Province of Mongolia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dundgovi (Province of Mongolia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dundgovi (Province of Mongolia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dundgovi (Province of Mongolia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dundgovi (Province of Mongolia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dundgovi (Province of Mongolia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dundgovi (Province of Mongolia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dundgovi (Province of Mongolia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Durango (State of M\xe9xico)": [
            {
                "Region Name": "Durango (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Durango (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Durango (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Durango (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Durango (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Durango (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Durango (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Durango (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Durango (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Durango (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Durango (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Durango (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Durango (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Durango (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Durango (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Durango (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Durango (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Durango (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Durango (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Durango (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Durango (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Durango (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "Durazno (Department of Uruguay)": [
            {
                "Region Name": "Durazno (Department of Uruguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Durazno (Department of Uruguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Durazno (Department of Uruguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Durazno (Department of Uruguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Durazno (Department of Uruguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Durazno (Department of Uruguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Durazno (Department of Uruguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Durazno (Department of Uruguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Durazno (Department of Uruguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Durazno (Department of Uruguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Durazno (Department of Uruguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Durazno (Department of Uruguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Durazno (Department of Uruguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Durazno (Department of Uruguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Durazno (Department of Uruguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Durazno (Department of Uruguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Durazno (Department of Uruguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Durazno (Department of Uruguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Durazno (Department of Uruguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Durazno (Department of Uruguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Durazno (Department of Uruguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Durazno (Department of Uruguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Durr\xebs (County of Albania)": [
            {
                "Region Name": "Durr\xebs (County of Albania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Durr\xebs (County of Albania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Durr\xebs (County of Albania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Durr\xebs (County of Albania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Durr\xebs (County of Albania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Durr\xebs (County of Albania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Durr\xebs (County of Albania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Durr\xebs (County of Albania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Durr\xebs (County of Albania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Durr\xebs (County of Albania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Durr\xebs (County of Albania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Durr\xebs (County of Albania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Durr\xebs (County of Albania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Durr\xebs (County of Albania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Durr\xebs (County of Albania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Durr\xebs (County of Albania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Durr\xebs (County of Albania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Durr\xebs (County of Albania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Durr\xebs (County of Albania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Durr\xebs (County of Albania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Durr\xebs (County of Albania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Durr\xebs (County of Albania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dushanbe (City of Tajikistan)": [
            {
                "Region Name": "Dushanbe (City of Tajikistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dushanbe (City of Tajikistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dushanbe (City of Tajikistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dushanbe (City of Tajikistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dushanbe (City of Tajikistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dushanbe (City of Tajikistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dushanbe (City of Tajikistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dushanbe (City of Tajikistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dushanbe (City of Tajikistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dushanbe (City of Tajikistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dushanbe (City of Tajikistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dushanbe (City of Tajikistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dushanbe (City of Tajikistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dushanbe (City of Tajikistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dushanbe (City of Tajikistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dushanbe (City of Tajikistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dushanbe (City of Tajikistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dushanbe (City of Tajikistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dushanbe (City of Tajikistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dushanbe (City of Tajikistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dushanbe (City of Tajikistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dushanbe (City of Tajikistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "D\xfczce (Province of Turkey)": [
            {
                "Region Name": "D\xfczce (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xfczce (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xfczce (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xfczce (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xfczce (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xfczce (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xfczce (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xfczce (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xfczce (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "D\xfczce (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xfczce (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xfczce (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xfczce (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xfczce (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xfczce (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xfczce (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xfczce (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xfczce (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xfczce (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xfczce (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xfczce (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "D\xfczce (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dzaoudzi (Commune of Mayotte)": [
            {
                "Region Name": "Dzaoudzi (Commune of Mayotte)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzaoudzi (Commune of Mayotte)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzaoudzi (Commune of Mayotte)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzaoudzi (Commune of Mayotte)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzaoudzi (Commune of Mayotte)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzaoudzi (Commune of Mayotte)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzaoudzi (Commune of Mayotte)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzaoudzi (Commune of Mayotte)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzaoudzi (Commune of Mayotte)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzaoudzi (Commune of Mayotte)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzaoudzi (Commune of Mayotte)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzaoudzi (Commune of Mayotte)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzaoudzi (Commune of Mayotte)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzaoudzi (Commune of Mayotte)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzaoudzi (Commune of Mayotte)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzaoudzi (Commune of Mayotte)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzaoudzi (Commune of Mayotte)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzaoudzi (Commune of Mayotte)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzaoudzi (Commune of Mayotte)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzaoudzi (Commune of Mayotte)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzaoudzi (Commune of Mayotte)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzaoudzi (Commune of Mayotte)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Dzavhan (Province of Mongolia)": [
            {
                "Region Name": "Dzavhan (Province of Mongolia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 185
            },
            {
                "Region Name": "Dzavhan (Province of Mongolia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dzavhan (Province of Mongolia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzavhan (Province of Mongolia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dzavhan (Province of Mongolia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dzavhan (Province of Mongolia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dzavhan (Province of Mongolia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzavhan (Province of Mongolia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzavhan (Province of Mongolia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dzavhan (Province of Mongolia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzavhan (Province of Mongolia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Dzavhan (Province of Mongolia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzavhan (Province of Mongolia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Dzavhan (Province of Mongolia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzavhan (Province of Mongolia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzavhan (Province of Mongolia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzavhan (Province of Mongolia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzavhan (Province of Mongolia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzavhan (Province of Mongolia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzavhan (Province of Mongolia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Dzavhan (Province of Mongolia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Dzavhan (Province of Mongolia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "East (Development Region of Nepal)": [
            {
                "Region Name": "East (Development Region of Nepal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "East (Development Region of Nepal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "East (Development Region of Nepal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "East (Development Region of Nepal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "East (Development Region of Nepal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "East (Development Region of Nepal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "East (Development Region of Nepal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "East (Development Region of Nepal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "East (Development Region of Nepal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "East (Development Region of Nepal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "East (Development Region of Nepal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "East (Development Region of Nepal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "East (Development Region of Nepal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "East (Development Region of Nepal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "East (Development Region of Nepal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "East (Development Region of Nepal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "East (Development Region of Nepal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "East (Development Region of Nepal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "East (Development Region of Nepal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "East (Development Region of Nepal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "East (Development Region of Nepal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "East (Development Region of Nepal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "East (Region of Singapore)": [
            {
                "Region Name": "East (Region of Singapore)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East (Region of Singapore)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East (Region of Singapore)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East (Region of Singapore)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East (Region of Singapore)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East (Region of Singapore)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East (Region of Singapore)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East (Region of Singapore)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East (Region of Singapore)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East (Region of Singapore)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East (Region of Singapore)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East (Region of Singapore)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East (Region of Singapore)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East (Region of Singapore)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East (Region of Singapore)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East (Region of Singapore)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East (Region of Singapore)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East (Region of Singapore)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East (Region of Singapore)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East (Region of Singapore)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East (Region of Singapore)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East (Region of Singapore)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "East Azarbaijan (Province of Iran)": [
            {
                "Region Name": "East Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "East Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "East Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "East Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "East Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "East Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "East Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "East Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "East Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "East Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "East Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "East Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "East Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "East Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "East Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "East Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "East Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "East Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "East Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "East Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "East Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "East Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "East Berbice-Corentyne (Region of Guyana)": [
            {
                "Region Name": "East Berbice-Corentyne (Region of Guyana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "East Berbice-Corentyne (Region of Guyana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "East Berbice-Corentyne (Region of Guyana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "East Berbice-Corentyne (Region of Guyana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "East Berbice-Corentyne (Region of Guyana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "East Berbice-Corentyne (Region of Guyana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "East Berbice-Corentyne (Region of Guyana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "East Berbice-Corentyne (Region of Guyana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "East Berbice-Corentyne (Region of Guyana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "East Berbice-Corentyne (Region of Guyana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "East Berbice-Corentyne (Region of Guyana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "East Berbice-Corentyne (Region of Guyana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "East Berbice-Corentyne (Region of Guyana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "East Berbice-Corentyne (Region of Guyana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "East Berbice-Corentyne (Region of Guyana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "East Berbice-Corentyne (Region of Guyana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "East Berbice-Corentyne (Region of Guyana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "East Berbice-Corentyne (Region of Guyana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "East Berbice-Corentyne (Region of Guyana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "East Berbice-Corentyne (Region of Guyana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "East Berbice-Corentyne (Region of Guyana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "East Berbice-Corentyne (Region of Guyana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "East Darfur (State of Sudan)": [
            {
                "Region Name": "East Darfur (State of Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "East Darfur (State of Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "East Darfur (State of Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "East Darfur (State of Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "East Darfur (State of Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "East Darfur (State of Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "East Darfur (State of Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "East Darfur (State of Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "East Darfur (State of Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "East Darfur (State of Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "East Darfur (State of Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "East Darfur (State of Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "East Darfur (State of Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "East Darfur (State of Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "East Darfur (State of Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "East Darfur (State of Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "East Darfur (State of Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "East Darfur (State of Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "East Darfur (State of Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "East Darfur (State of Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "East Darfur (State of Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "East Darfur (State of Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 28
            }
        ],
        "East End (District of Anguilla)": [
            {
                "Region Name": "East End (District of Anguilla)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Anguilla)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Anguilla)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Anguilla)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Anguilla)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Anguilla)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Anguilla)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Anguilla)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Anguilla)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Anguilla)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Anguilla)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Anguilla)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Anguilla)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Anguilla)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Anguilla)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Anguilla)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Anguilla)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Anguilla)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Anguilla)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Anguilla)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Anguilla)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Anguilla)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "East End (District of Cayman Islands)": [
            {
                "Region Name": "East End (District of Cayman Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Cayman Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Cayman Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Cayman Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Cayman Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Cayman Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Cayman Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Cayman Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Cayman Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Cayman Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Cayman Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Cayman Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Cayman Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Cayman Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Cayman Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Cayman Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Cayman Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Cayman Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Cayman Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Cayman Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Cayman Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East End (District of Cayman Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "East Grand Bahama (District of Bahamas)": [
            {
                "Region Name": "East Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "East Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "East Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "East Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "East Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "East Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "East Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "East Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "East Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "East Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "East Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "East Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "East Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "East Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "East Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "East Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "East Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "East Kazakhstan (Region of Kazakhstan)": [
            {
                "Region Name": "East Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 150
            },
            {
                "Region Name": "East Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "East Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "East Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "East Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 84
            },
            {
                "Region Name": "East Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 68
            },
            {
                "Region Name": "East Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "East Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "East Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "East Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "East Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "East Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "East Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 73
            },
            {
                "Region Name": "East Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 166
            },
            {
                "Region Name": "East Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "East Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 67
            },
            {
                "Region Name": "East Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "East Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "East Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "East Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "East Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "East Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 40
            }
        ],
        "East New Britain (Province of Papua New Guinea)": [
            {
                "Region Name": "East New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "East New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "East New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "East New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "East New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "East Sepik (Province of Papua New Guinea)": [
            {
                "Region Name": "East Sepik (Province of Papua New Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "East Sepik (Province of Papua New Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "East Sepik (Province of Papua New Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "East Sepik (Province of Papua New Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "East Sepik (Province of Papua New Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "East Sepik (Province of Papua New Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "East Sepik (Province of Papua New Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "East Sepik (Province of Papua New Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "East Sepik (Province of Papua New Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "East Sepik (Province of Papua New Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "East Sepik (Province of Papua New Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "East Sepik (Province of Papua New Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "East Sepik (Province of Papua New Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "East Sepik (Province of Papua New Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "East Sepik (Province of Papua New Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "East Sepik (Province of Papua New Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "East Sepik (Province of Papua New Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "East Sepik (Province of Papua New Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "East Sepik (Province of Papua New Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "East Sepik (Province of Papua New Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "East Sepik (Province of Papua New Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "East Sepik (Province of Papua New Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Eastern (District of American Samoa)": [
            {
                "Region Name": "Eastern (District of American Samoa)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (District of American Samoa)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (District of American Samoa)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (District of American Samoa)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (District of American Samoa)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (District of American Samoa)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (District of American Samoa)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (District of American Samoa)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (District of American Samoa)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (District of American Samoa)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (District of American Samoa)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (District of American Samoa)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (District of American Samoa)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (District of American Samoa)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (District of American Samoa)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (District of American Samoa)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (District of American Samoa)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (District of American Samoa)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (District of American Samoa)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (District of American Samoa)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (District of American Samoa)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (District of American Samoa)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Eastern (Division of Fiji)": [
            {
                "Region Name": "Eastern (Division of Fiji)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (Division of Fiji)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (Division of Fiji)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (Division of Fiji)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (Division of Fiji)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (Division of Fiji)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (Division of Fiji)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (Division of Fiji)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (Division of Fiji)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (Division of Fiji)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (Division of Fiji)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (Division of Fiji)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (Division of Fiji)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Eastern (Division of Fiji)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (Division of Fiji)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (Division of Fiji)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (Division of Fiji)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (Division of Fiji)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (Division of Fiji)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (Division of Fiji)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (Division of Fiji)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern (Division of Fiji)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Eastern (Province of Sierra Leone)": [
            {
                "Region Name": "Eastern (Province of Sierra Leone)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Eastern (Province of Sierra Leone)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Eastern (Province of Sierra Leone)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Eastern (Province of Sierra Leone)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Eastern (Province of Sierra Leone)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Eastern (Province of Sierra Leone)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Eastern (Province of Sierra Leone)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Eastern (Province of Sierra Leone)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Eastern (Province of Sierra Leone)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Eastern (Province of Sierra Leone)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Eastern (Province of Sierra Leone)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Eastern (Province of Sierra Leone)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Eastern (Province of Sierra Leone)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Eastern (Province of Sierra Leone)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Eastern (Province of Sierra Leone)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Eastern (Province of Sierra Leone)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Eastern (Province of Sierra Leone)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Eastern (Province of Sierra Leone)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Eastern (Province of Sierra Leone)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Eastern (Province of Sierra Leone)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Eastern (Province of Sierra Leone)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Eastern (Province of Sierra Leone)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Eastern (Province of Zambia)": [
            {
                "Region Name": "Eastern (Province of Zambia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Eastern (Province of Zambia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Eastern (Province of Zambia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Eastern (Province of Zambia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Eastern (Province of Zambia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Eastern (Province of Zambia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Eastern (Province of Zambia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Eastern (Province of Zambia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Eastern (Province of Zambia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Eastern (Province of Zambia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Eastern (Province of Zambia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Eastern (Province of Zambia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Eastern (Province of Zambia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Eastern (Province of Zambia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Eastern (Province of Zambia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Eastern (Province of Zambia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Eastern (Province of Zambia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Eastern (Province of Zambia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Eastern (Province of Zambia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Eastern (Province of Zambia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Eastern (Province of Zambia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Eastern (Province of Zambia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Eastern (Region of Ghana)": [
            {
                "Region Name": "Eastern (Region of Ghana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Eastern (Region of Ghana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Eastern (Region of Ghana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Eastern (Region of Ghana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Eastern (Region of Ghana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Eastern (Region of Ghana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Eastern (Region of Ghana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Eastern (Region of Ghana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Eastern (Region of Ghana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Eastern (Region of Ghana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Eastern (Region of Ghana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Eastern (Region of Ghana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Eastern (Region of Ghana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Eastern (Region of Ghana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Eastern (Region of Ghana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Eastern (Region of Ghana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Eastern (Region of Ghana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Eastern (Region of Ghana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Eastern (Region of Ghana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Eastern (Region of Ghana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Eastern (Region of Ghana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Eastern (Region of Ghana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Eastern Cape (Province of South Africa)": [
            {
                "Region Name": "Eastern Cape (Province of South Africa)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Eastern Cape (Province of South Africa)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Eastern Cape (Province of South Africa)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Eastern Cape (Province of South Africa)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Eastern Cape (Province of South Africa)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Eastern Cape (Province of South Africa)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Eastern Cape (Province of South Africa)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Eastern Cape (Province of South Africa)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Eastern Cape (Province of South Africa)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Eastern Cape (Province of South Africa)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Eastern Cape (Province of South Africa)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Eastern Cape (Province of South Africa)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Eastern Cape (Province of South Africa)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Eastern Cape (Province of South Africa)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Eastern Cape (Province of South Africa)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Eastern Cape (Province of South Africa)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Eastern Cape (Province of South Africa)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Eastern Cape (Province of South Africa)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Eastern Cape (Province of South Africa)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Eastern Cape (Province of South Africa)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Eastern Cape (Province of South Africa)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Eastern Cape (Province of South Africa)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Eastern Equatoria (State of South Sudan)": [
            {
                "Region Name": "Eastern Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Eastern Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Eastern Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Eastern Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 63
            },
            {
                "Region Name": "Eastern Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Eastern Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Eastern Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "Eastern Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Eastern Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Eastern Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Eastern Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Eastern Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Eastern Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Eastern Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Eastern Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Eastern Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Eastern Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Eastern Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Eastern Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Eastern Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Eastern Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Eastern Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 32
            }
        ],
        "Eastern Finland (Province of Finland)": [
            {
                "Region Name": "Eastern Finland (Province of Finland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Finland (Province of Finland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Eastern Finland (Province of Finland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Finland (Province of Finland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Finland (Province of Finland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Eastern Finland (Province of Finland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Eastern Finland (Province of Finland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Finland (Province of Finland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Eastern Finland (Province of Finland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Finland (Province of Finland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Eastern Finland (Province of Finland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Finland (Province of Finland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Finland (Province of Finland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Finland (Province of Finland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Finland (Province of Finland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Finland (Province of Finland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Finland (Province of Finland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Eastern Finland (Province of Finland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Finland (Province of Finland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Finland (Province of Finland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Eastern Finland (Province of Finland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Finland (Province of Finland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Eastern Highlands (Province of Papua New Guinea)": [
            {
                "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Eastern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Eastern Samar (Province of Philippines)": [
            {
                "Region Name": "Eastern Samar (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Samar (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Samar (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Samar (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Samar (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Samar (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Eastern Samar (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Samar (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Samar (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Samar (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Samar (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Samar (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Eastern Samar (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Eastern Samar (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Samar (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Samar (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Samar (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Eastern Samar (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Eastern Samar (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Eastern Samar (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Samar (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eastern Samar (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ebon (Atol of Marshall Islands)": [
            {
                "Region Name": "Ebon (Atol of Marshall Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ebon (Atol of Marshall Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ebon (Atol of Marshall Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ebon (Atol of Marshall Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ebon (Atol of Marshall Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ebon (Atol of Marshall Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ebon (Atol of Marshall Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ebon (Atol of Marshall Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ebon (Atol of Marshall Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ebon (Atol of Marshall Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ebon (Atol of Marshall Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ebon (Atol of Marshall Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ebon (Atol of Marshall Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ebon (Atol of Marshall Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ebon (Atol of Marshall Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ebon (Atol of Marshall Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ebon (Atol of Marshall Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ebon (Atol of Marshall Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ebon (Atol of Marshall Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ebon (Atol of Marshall Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ebon (Atol of Marshall Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ebon (Atol of Marshall Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ebonyi (State of Nigeria)": [
            {
                "Region Name": "Ebonyi (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ebonyi (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ebonyi (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ebonyi (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ebonyi (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ebonyi (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ebonyi (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ebonyi (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ebonyi (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ebonyi (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ebonyi (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ebonyi (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ebonyi (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ebonyi (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ebonyi (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ebonyi (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ebonyi (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ebonyi (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ebonyi (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ebonyi (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ebonyi (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ebonyi (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Edine\u021B (District of Moldova)": [
            {
                "Region Name": "Edine\u021B (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Edine\u021B (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Edine\u021B (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Edine\u021B (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Edine\u021B (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Edine\u021B (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Edine\u021B (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Edine\u021B (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Edine\u021B (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Edine\u021B (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Edine\u021B (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Edine\u021B (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Edine\u021B (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Edine\u021B (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Edine\u021B (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Edine\u021B (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Edine\u021B (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Edine\u021B (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Edine\u021B (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Edine\u021B (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Edine\u021B (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Edine\u021B (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Edirne (Province of Turkey)": [
            {
                "Region Name": "Edirne (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Edirne (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Edirne (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Edirne (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Edirne (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Edirne (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Edirne (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Edirne (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Edirne (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Edirne (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Edirne (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Edirne (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Edirne (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Edirne (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Edirne (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Edirne (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Edirne (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Edirne (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Edirne (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Edirne (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Edirne (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Edirne (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Edo (State of Nigeria)": [
            {
                "Region Name": "Edo (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Edo (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Edo (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Edo (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Edo (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Edo (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Edo (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Edo (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Edo (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Edo (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Edo (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Edo (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Edo (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Edo (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Edo (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Edo (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Edo (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Edo (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Edo (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Edo (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Edo (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Edo (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Ehime (Prefecture of Japan)": [
            {
                "Region Name": "Ehime (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ehime (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ehime (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ehime (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ehime (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ehime (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ehime (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ehime (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ehime (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ehime (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ehime (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ehime (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ehime (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ehime (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ehime (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ehime (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ehime (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ehime (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ehime (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ehime (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ehime (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ehime (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ekiti (State of Nigeria)": [
            {
                "Region Name": "Ekiti (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ekiti (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ekiti (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ekiti (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ekiti (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ekiti (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ekiti (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ekiti (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ekiti (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ekiti (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ekiti (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ekiti (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ekiti (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ekiti (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ekiti (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ekiti (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ekiti (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ekiti (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ekiti (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ekiti (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ekiti (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ekiti (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "El Bayadh (Province of Algeria)": [
            {
                "Region Name": "El Bayadh (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "El Bayadh (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "El Bayadh (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Bayadh (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Bayadh (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "El Bayadh (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Bayadh (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "El Bayadh (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Bayadh (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Bayadh (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Bayadh (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Bayadh (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Bayadh (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Bayadh (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Bayadh (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Bayadh (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "El Bayadh (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Bayadh (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Bayadh (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Bayadh (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Bayadh (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Bayadh (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "El Oro (Province of Ecuador)": [
            {
                "Region Name": "El Oro (Province of Ecuador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "El Oro (Province of Ecuador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "El Oro (Province of Ecuador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "El Oro (Province of Ecuador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "El Oro (Province of Ecuador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "El Oro (Province of Ecuador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "El Oro (Province of Ecuador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oro (Province of Ecuador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "El Oro (Province of Ecuador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oro (Province of Ecuador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "El Oro (Province of Ecuador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "El Oro (Province of Ecuador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "El Oro (Province of Ecuador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "El Oro (Province of Ecuador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "El Oro (Province of Ecuador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "El Oro (Province of Ecuador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oro (Province of Ecuador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "El Oro (Province of Ecuador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oro (Province of Ecuador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "El Oro (Province of Ecuador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oro (Province of Ecuador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "El Oro (Province of Ecuador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "El Oued (Province of Algeria)": [
            {
                "Region Name": "El Oued (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oued (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oued (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oued (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oued (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oued (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oued (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oued (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oued (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oued (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oued (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oued (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oued (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oued (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oued (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oued (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "El Oued (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oued (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oued (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oued (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oued (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Oued (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "El Para\xedso (Department of Honduras)": [
            {
                "Region Name": "El Para\xedso (Department of Honduras)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "El Para\xedso (Department of Honduras)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "El Para\xedso (Department of Honduras)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "El Para\xedso (Department of Honduras)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "El Para\xedso (Department of Honduras)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "El Para\xedso (Department of Honduras)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "El Para\xedso (Department of Honduras)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "El Para\xedso (Department of Honduras)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "El Para\xedso (Department of Honduras)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "El Para\xedso (Department of Honduras)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "El Para\xedso (Department of Honduras)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "El Para\xedso (Department of Honduras)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "El Para\xedso (Department of Honduras)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "El Para\xedso (Department of Honduras)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "El Para\xedso (Department of Honduras)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "El Para\xedso (Department of Honduras)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "El Para\xedso (Department of Honduras)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "El Para\xedso (Department of Honduras)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "El Para\xedso (Department of Honduras)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "El Para\xedso (Department of Honduras)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "El Para\xedso (Department of Honduras)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "El Para\xedso (Department of Honduras)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "El Progreso (Department of Guatemala)": [
            {
                "Region Name": "El Progreso (Department of Guatemala)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Progreso (Department of Guatemala)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "El Progreso (Department of Guatemala)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Progreso (Department of Guatemala)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Progreso (Department of Guatemala)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Progreso (Department of Guatemala)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "El Progreso (Department of Guatemala)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "El Progreso (Department of Guatemala)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "El Progreso (Department of Guatemala)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "El Progreso (Department of Guatemala)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Progreso (Department of Guatemala)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Progreso (Department of Guatemala)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "El Progreso (Department of Guatemala)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "El Progreso (Department of Guatemala)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "El Progreso (Department of Guatemala)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Progreso (Department of Guatemala)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "El Progreso (Department of Guatemala)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Progreso (Department of Guatemala)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "El Progreso (Department of Guatemala)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "El Progreso (Department of Guatemala)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "El Progreso (Department of Guatemala)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "El Progreso (Department of Guatemala)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "El Seybo (Province of Dominican Republic)": [
            {
                "Region Name": "El Seybo (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Seybo (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "El Seybo (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "El Seybo (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Seybo (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "El Seybo (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Seybo (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Seybo (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Seybo (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "El Seybo (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "El Seybo (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "El Seybo (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "El Seybo (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Seybo (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "El Seybo (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Seybo (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Seybo (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "El Seybo (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Seybo (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "El Seybo (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "El Seybo (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Seybo (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "El Tarf (Province of Algeria)": [
            {
                "Region Name": "El Tarf (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "El Tarf (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "El Tarf (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Tarf (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "El Tarf (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "El Tarf (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "El Tarf (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "El Tarf (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "El Tarf (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "El Tarf (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "El Tarf (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "El Tarf (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "El Tarf (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "El Tarf (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "El Tarf (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "El Tarf (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "El Tarf (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "El Tarf (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "El Tarf (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "El Tarf (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "El Tarf (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "El Tarf (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 22
            }
        ],
        "Elaz\u0131\u011F (Province of Turkey)": [
            {
                "Region Name": "Elaz\u0131\u011F (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Elaz\u0131\u011F (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Elaz\u0131\u011F (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Elaz\u0131\u011F (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elaz\u0131\u011F (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Elaz\u0131\u011F (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elaz\u0131\u011F (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elaz\u0131\u011F (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Elaz\u0131\u011F (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Elaz\u0131\u011F (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Elaz\u0131\u011F (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Elaz\u0131\u011F (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Elaz\u0131\u011F (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Elaz\u0131\u011F (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Elaz\u0131\u011F (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Elaz\u0131\u011F (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elaz\u0131\u011F (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Elaz\u0131\u011F (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Elaz\u0131\u011F (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Elaz\u0131\u011F (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Elaz\u0131\u011F (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elaz\u0131\u011F (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Elbasan (County of Albania)": [
            {
                "Region Name": "Elbasan (County of Albania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elbasan (County of Albania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elbasan (County of Albania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elbasan (County of Albania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elbasan (County of Albania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elbasan (County of Albania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Elbasan (County of Albania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elbasan (County of Albania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elbasan (County of Albania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elbasan (County of Albania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Elbasan (County of Albania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Elbasan (County of Albania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elbasan (County of Albania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elbasan (County of Albania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elbasan (County of Albania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elbasan (County of Albania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Elbasan (County of Albania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elbasan (County of Albania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elbasan (County of Albania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elbasan (County of Albania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elbasan (County of Albania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elbasan (County of Albania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Elgeyo-Marakwet (County of Kenya)": [
            {
                "Region Name": "Elgeyo-Marakwet (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Elgeyo-Marakwet (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elgeyo-Marakwet (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elgeyo-Marakwet (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elgeyo-Marakwet (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elgeyo-Marakwet (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Elgeyo-Marakwet (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Elgeyo-Marakwet (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Elgeyo-Marakwet (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elgeyo-Marakwet (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elgeyo-Marakwet (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elgeyo-Marakwet (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elgeyo-Marakwet (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Elgeyo-Marakwet (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Elgeyo-Marakwet (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elgeyo-Marakwet (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Elgeyo-Marakwet (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elgeyo-Marakwet (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Elgeyo-Marakwet (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elgeyo-Marakwet (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Elgeyo-Marakwet (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Elgeyo-Marakwet (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ember\xe1 (Indigenous Territory of Panama)": [
            {
                "Region Name": "Ember\xe1 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ember\xe1 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ember\xe1 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ember\xe1 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ember\xe1 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ember\xe1 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ember\xe1 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ember\xe1 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ember\xe1 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ember\xe1 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ember\xe1 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ember\xe1 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ember\xe1 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ember\xe1 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ember\xe1 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ember\xe1 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ember\xe1 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ember\xe1 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ember\xe1 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ember\xe1 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ember\xe1 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ember\xe1 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Embu (County of Kenya)": [
            {
                "Region Name": "Embu (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Embu (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Embu (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Embu (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Embu (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Embu (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Embu (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Embu (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Embu (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Embu (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Embu (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Embu (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Embu (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Embu (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Embu (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Embu (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Embu (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Embu (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Embu (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Embu (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Embu (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Embu (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Emilia-Romagna (Region of Italy)": [
            {
                "Region Name": "Emilia-Romagna (Region of Italy)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Emilia-Romagna (Region of Italy)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Emilia-Romagna (Region of Italy)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Emilia-Romagna (Region of Italy)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Emilia-Romagna (Region of Italy)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Emilia-Romagna (Region of Italy)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Emilia-Romagna (Region of Italy)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Emilia-Romagna (Region of Italy)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Emilia-Romagna (Region of Italy)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Emilia-Romagna (Region of Italy)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Emilia-Romagna (Region of Italy)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Emilia-Romagna (Region of Italy)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Emilia-Romagna (Region of Italy)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Emilia-Romagna (Region of Italy)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Emilia-Romagna (Region of Italy)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Emilia-Romagna (Region of Italy)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Emilia-Romagna (Region of Italy)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Emilia-Romagna (Region of Italy)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Emilia-Romagna (Region of Italy)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Emilia-Romagna (Region of Italy)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Emilia-Romagna (Region of Italy)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Emilia-Romagna (Region of Italy)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Encamp (Parish of Andorra)": [
            {
                "Region Name": "Encamp (Parish of Andorra)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Encamp (Parish of Andorra)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Encamp (Parish of Andorra)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Encamp (Parish of Andorra)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Encamp (Parish of Andorra)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Encamp (Parish of Andorra)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Encamp (Parish of Andorra)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Encamp (Parish of Andorra)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Encamp (Parish of Andorra)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Encamp (Parish of Andorra)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Encamp (Parish of Andorra)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Encamp (Parish of Andorra)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Encamp (Parish of Andorra)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Encamp (Parish of Andorra)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Encamp (Parish of Andorra)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Encamp (Parish of Andorra)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Encamp (Parish of Andorra)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Encamp (Parish of Andorra)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Encamp (Parish of Andorra)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Encamp (Parish of Andorra)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Encamp (Parish of Andorra)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Encamp (Parish of Andorra)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Enewetok (Atol of Marshall Islands)": [
            {
                "Region Name": "Enewetok (Atol of Marshall Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Enewetok (Atol of Marshall Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Enewetok (Atol of Marshall Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Enewetok (Atol of Marshall Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Enewetok (Atol of Marshall Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Enewetok (Atol of Marshall Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Enewetok (Atol of Marshall Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Enewetok (Atol of Marshall Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Enewetok (Atol of Marshall Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Enewetok (Atol of Marshall Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Enewetok (Atol of Marshall Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Enewetok (Atol of Marshall Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Enewetok (Atol of Marshall Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Enewetok (Atol of Marshall Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Enewetok (Atol of Marshall Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Enewetok (Atol of Marshall Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Enewetok (Atol of Marshall Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Enewetok (Atol of Marshall Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Enewetok (Atol of Marshall Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Enewetok (Atol of Marshall Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Enewetok (Atol of Marshall Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Enewetok (Atol of Marshall Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Enga (Province of Papua New Guinea)": [
            {
                "Region Name": "Enga (Province of Papua New Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Enga (Province of Papua New Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Enga (Province of Papua New Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Enga (Province of Papua New Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Enga (Province of Papua New Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Enga (Province of Papua New Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Enga (Province of Papua New Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Enga (Province of Papua New Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Enga (Province of Papua New Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Enga (Province of Papua New Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Enga (Province of Papua New Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Enga (Province of Papua New Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Enga (Province of Papua New Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Enga (Province of Papua New Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Enga (Province of Papua New Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Enga (Province of Papua New Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Enga (Province of Papua New Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Enga (Province of Papua New Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Enga (Province of Papua New Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Enga (Province of Papua New Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Enga (Province of Papua New Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Enga (Province of Papua New Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "England (Constituent Country of United Kingdom)": [
            {
                "Region Name": "England (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "England (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "England (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "England (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "England (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "England (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "England (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "England (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "England (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "England (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "England (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "England (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "England (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "England (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "England (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "England (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "England (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "England (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "England (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "England (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "England (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "England (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "English River (District of Seychelles)": [
            {
                "Region Name": "English River (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "English River (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "English River (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "English River (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "English River (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "English River (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "English River (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "English River (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "English River (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "English River (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "English River (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "English River (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "English River (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "English River (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "English River (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "English River (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "English River (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "English River (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "English River (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "English River (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "English River (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "English River (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ennedi Est (Region of Chad)": [
            {
                "Region Name": "Ennedi Est (Region of Chad)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Est (Region of Chad)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Est (Region of Chad)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Est (Region of Chad)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Est (Region of Chad)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Est (Region of Chad)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Est (Region of Chad)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Est (Region of Chad)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Est (Region of Chad)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Est (Region of Chad)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Est (Region of Chad)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Est (Region of Chad)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Est (Region of Chad)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Est (Region of Chad)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Est (Region of Chad)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Est (Region of Chad)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Est (Region of Chad)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Est (Region of Chad)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Est (Region of Chad)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Est (Region of Chad)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Est (Region of Chad)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Est (Region of Chad)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ennedi Ouest (Region of Chad)": [
            {
                "Region Name": "Ennedi Ouest (Region of Chad)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Ouest (Region of Chad)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Ouest (Region of Chad)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Ouest (Region of Chad)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Ouest (Region of Chad)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Ouest (Region of Chad)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ennedi Ouest (Region of Chad)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Ouest (Region of Chad)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Ouest (Region of Chad)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Ouest (Region of Chad)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Ouest (Region of Chad)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ennedi Ouest (Region of Chad)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ennedi Ouest (Region of Chad)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ennedi Ouest (Region of Chad)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Ennedi Ouest (Region of Chad)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Ouest (Region of Chad)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Ouest (Region of Chad)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Ouest (Region of Chad)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Ouest (Region of Chad)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Ouest (Region of Chad)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ennedi Ouest (Region of Chad)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ennedi Ouest (Region of Chad)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Entre R\xedos (Province of Argentina)": [
            {
                "Region Name": "Entre R\xedos (Province of Argentina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Entre R\xedos (Province of Argentina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Entre R\xedos (Province of Argentina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Entre R\xedos (Province of Argentina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Entre R\xedos (Province of Argentina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Entre R\xedos (Province of Argentina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Entre R\xedos (Province of Argentina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Entre R\xedos (Province of Argentina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Entre R\xedos (Province of Argentina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Entre R\xedos (Province of Argentina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Entre R\xedos (Province of Argentina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Entre R\xedos (Province of Argentina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Entre R\xedos (Province of Argentina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Entre R\xedos (Province of Argentina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Entre R\xedos (Province of Argentina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Entre R\xedos (Province of Argentina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Entre R\xedos (Province of Argentina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Entre R\xedos (Province of Argentina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Entre R\xedos (Province of Argentina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Entre R\xedos (Province of Argentina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Entre R\xedos (Province of Argentina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Entre R\xedos (Province of Argentina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Enugu (State of Nigeria)": [
            {
                "Region Name": "Enugu (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Enugu (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Enugu (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Enugu (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Enugu (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Enugu (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Enugu (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Enugu (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Enugu (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Enugu (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Enugu (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Enugu (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Enugu (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Enugu (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Enugu (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Enugu (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Enugu (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Enugu (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Enugu (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Enugu (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Enugu (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Enugu (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Epirus and Western Macedonia (Decentralized administration of Greece)": [
            {
                "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Epirus and Western Macedonia (Decentralized administration of Greece)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\xc9quateur (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "\xc9quateur (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\xc9quateur (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\xc9quateur (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xc9quateur (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xc9quateur (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "\xc9quateur (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xc9quateur (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "\xc9quateur (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xc9quateur (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xc9quateur (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xc9quateur (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xc9quateur (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xc9quateur (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "\xc9quateur (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xc9quateur (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\xc9quateur (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\xc9quateur (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\xc9quateur (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xc9quateur (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\xc9quateur (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xc9quateur (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xc9quateur (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Erevan (City of Armenia)": [
            {
                "Region Name": "Erevan (City of Armenia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erevan (City of Armenia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erevan (City of Armenia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erevan (City of Armenia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erevan (City of Armenia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erevan (City of Armenia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erevan (City of Armenia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erevan (City of Armenia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erevan (City of Armenia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erevan (City of Armenia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erevan (City of Armenia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erevan (City of Armenia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erevan (City of Armenia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erevan (City of Armenia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erevan (City of Armenia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erevan (City of Armenia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erevan (City of Armenia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erevan (City of Armenia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erevan (City of Armenia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erevan (City of Armenia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erevan (City of Armenia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erevan (City of Armenia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ermera (District of Timor-Leste)": [
            {
                "Region Name": "Ermera (District of Timor-Leste)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ermera (District of Timor-Leste)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ermera (District of Timor-Leste)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ermera (District of Timor-Leste)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ermera (District of Timor-Leste)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ermera (District of Timor-Leste)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ermera (District of Timor-Leste)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ermera (District of Timor-Leste)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ermera (District of Timor-Leste)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ermera (District of Timor-Leste)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ermera (District of Timor-Leste)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ermera (District of Timor-Leste)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ermera (District of Timor-Leste)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ermera (District of Timor-Leste)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ermera (District of Timor-Leste)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ermera (District of Timor-Leste)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ermera (District of Timor-Leste)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ermera (District of Timor-Leste)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ermera (District of Timor-Leste)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ermera (District of Timor-Leste)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ermera (District of Timor-Leste)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ermera (District of Timor-Leste)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Erongo (Region of Namibia)": [
            {
                "Region Name": "Erongo (Region of Namibia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Erongo (Region of Namibia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erongo (Region of Namibia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Erongo (Region of Namibia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Erongo (Region of Namibia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 148
            },
            {
                "Region Name": "Erongo (Region of Namibia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Erongo (Region of Namibia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Erongo (Region of Namibia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Erongo (Region of Namibia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Erongo (Region of Namibia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 114
            },
            {
                "Region Name": "Erongo (Region of Namibia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 131
            },
            {
                "Region Name": "Erongo (Region of Namibia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Erongo (Region of Namibia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erongo (Region of Namibia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Erongo (Region of Namibia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erongo (Region of Namibia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erongo (Region of Namibia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Erongo (Region of Namibia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erongo (Region of Namibia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erongo (Region of Namibia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Erongo (Region of Namibia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Erongo (Region of Namibia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Erzincan (Province of Turkey)": [
            {
                "Region Name": "Erzincan (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Erzincan (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erzincan (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erzincan (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Erzincan (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Erzincan (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erzincan (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Erzincan (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Erzincan (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Erzincan (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Erzincan (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erzincan (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Erzincan (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erzincan (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Erzincan (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Erzincan (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Erzincan (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Erzincan (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Erzincan (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erzincan (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erzincan (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erzincan (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Erzurum (Province of Turkey)": [
            {
                "Region Name": "Erzurum (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Erzurum (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erzurum (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erzurum (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Erzurum (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erzurum (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Erzurum (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Erzurum (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erzurum (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erzurum (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Erzurum (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Erzurum (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Erzurum (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erzurum (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Erzurum (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Erzurum (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Erzurum (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erzurum (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erzurum (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erzurum (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Erzurum (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Erzurum (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Es Semara (Province of Western Sahara)": [
            {
                "Region Name": "Es Semara (Province of Western Sahara)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Es Semara (Province of Western Sahara)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Es Semara (Province of Western Sahara)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Es Semara (Province of Western Sahara)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Es Semara (Province of Western Sahara)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Es Semara (Province of Western Sahara)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Es Semara (Province of Western Sahara)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Es Semara (Province of Western Sahara)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Es Semara (Province of Western Sahara)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Es Semara (Province of Western Sahara)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Es Semara (Province of Western Sahara)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Es Semara (Province of Western Sahara)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Es Semara (Province of Western Sahara)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Es Semara (Province of Western Sahara)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Es Semara (Province of Western Sahara)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Es Semara (Province of Western Sahara)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Es Semara (Province of Western Sahara)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Es Semara (Province of Western Sahara)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Es Semara (Province of Western Sahara)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Es Semara (Province of Western Sahara)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Es Semara (Province of Western Sahara)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Es Semara (Province of Western Sahara)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Escaldes-Engordany (Parish of Andorra)": [
            {
                "Region Name": "Escaldes-Engordany (Parish of Andorra)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Escaldes-Engordany (Parish of Andorra)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Escaldes-Engordany (Parish of Andorra)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Escaldes-Engordany (Parish of Andorra)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Escaldes-Engordany (Parish of Andorra)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Escaldes-Engordany (Parish of Andorra)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Escaldes-Engordany (Parish of Andorra)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Escaldes-Engordany (Parish of Andorra)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Escaldes-Engordany (Parish of Andorra)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Escaldes-Engordany (Parish of Andorra)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Escaldes-Engordany (Parish of Andorra)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Escaldes-Engordany (Parish of Andorra)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Escaldes-Engordany (Parish of Andorra)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Escaldes-Engordany (Parish of Andorra)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Escaldes-Engordany (Parish of Andorra)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Escaldes-Engordany (Parish of Andorra)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Escaldes-Engordany (Parish of Andorra)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Escaldes-Engordany (Parish of Andorra)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Escaldes-Engordany (Parish of Andorra)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Escaldes-Engordany (Parish of Andorra)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Escaldes-Engordany (Parish of Andorra)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Escaldes-Engordany (Parish of Andorra)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Eschen (Commune of Liechtenstein)": [
            {
                "Region Name": "Eschen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eschen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eschen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eschen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eschen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eschen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eschen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eschen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eschen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eschen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eschen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eschen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eschen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eschen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eschen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eschen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eschen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eschen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eschen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eschen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eschen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eschen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Escuintla (Department of Guatemala)": [
            {
                "Region Name": "Escuintla (Department of Guatemala)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Escuintla (Department of Guatemala)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Escuintla (Department of Guatemala)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Escuintla (Department of Guatemala)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Escuintla (Department of Guatemala)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Escuintla (Department of Guatemala)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Escuintla (Department of Guatemala)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Escuintla (Department of Guatemala)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Escuintla (Department of Guatemala)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Escuintla (Department of Guatemala)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Escuintla (Department of Guatemala)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Escuintla (Department of Guatemala)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Escuintla (Department of Guatemala)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Escuintla (Department of Guatemala)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Escuintla (Department of Guatemala)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Escuintla (Department of Guatemala)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Escuintla (Department of Guatemala)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Escuintla (Department of Guatemala)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Escuintla (Department of Guatemala)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Escuintla (Department of Guatemala)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Escuintla (Department of Guatemala)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Escuintla (Department of Guatemala)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Esfahan (Province of Iran)": [
            {
                "Region Name": "Esfahan (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Esfahan (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Esfahan (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Esfahan (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Esfahan (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Esfahan (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Esfahan (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Esfahan (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Esfahan (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Esfahan (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Esfahan (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Esfahan (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Esfahan (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Esfahan (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Esfahan (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Esfahan (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Esfahan (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Esfahan (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Esfahan (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Esfahan (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Esfahan (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Esfahan (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Eskisehir (Province of Turkey)": [
            {
                "Region Name": "Eskisehir (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Eskisehir (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eskisehir (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Eskisehir (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Eskisehir (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eskisehir (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eskisehir (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eskisehir (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Eskisehir (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Eskisehir (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Eskisehir (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Eskisehir (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Eskisehir (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eskisehir (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Eskisehir (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eskisehir (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eskisehir (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Eskisehir (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Eskisehir (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eskisehir (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eskisehir (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eskisehir (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Esmeraldas (Province of Ecuador)": [
            {
                "Region Name": "Esmeraldas (Province of Ecuador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Esmeraldas (Province of Ecuador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Esmeraldas (Province of Ecuador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Esmeraldas (Province of Ecuador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Esmeraldas (Province of Ecuador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Esmeraldas (Province of Ecuador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Esmeraldas (Province of Ecuador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Esmeraldas (Province of Ecuador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Esmeraldas (Province of Ecuador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Esmeraldas (Province of Ecuador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Esmeraldas (Province of Ecuador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Esmeraldas (Province of Ecuador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Esmeraldas (Province of Ecuador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Esmeraldas (Province of Ecuador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Esmeraldas (Province of Ecuador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Esmeraldas (Province of Ecuador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Esmeraldas (Province of Ecuador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Esmeraldas (Province of Ecuador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Esmeraldas (Province of Ecuador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Esmeraldas (Province of Ecuador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Esmeraldas (Province of Ecuador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Esmeraldas (Province of Ecuador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Espaillat (Province of Dominican Republic)": [
            {
                "Region Name": "Espaillat (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Espaillat (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Espaillat (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Espaillat (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Espaillat (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Espaillat (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Espaillat (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Espaillat (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Espaillat (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Espaillat (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Espaillat (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Espaillat (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Espaillat (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Espaillat (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Espaillat (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Espaillat (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Espaillat (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Espaillat (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Espaillat (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Espaillat (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Espaillat (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Espaillat (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Esp\xedrito Santo (State of Brazil)": [
            {
                "Region Name": "Esp\xedrito Santo (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Esp\xedrito Santo (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Esp\xedrito Santo (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Esp\xedrito Santo (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Esp\xedrito Santo (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Esp\xedrito Santo (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Esp\xedrito Santo (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Esp\xedrito Santo (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Esp\xedrito Santo (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Esp\xedrito Santo (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Esp\xedrito Santo (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Esp\xedrito Santo (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Esp\xedrito Santo (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Esp\xedrito Santo (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Esp\xedrito Santo (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Esp\xedrito Santo (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Esp\xedrito Santo (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Esp\xedrito Santo (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Esp\xedrito Santo (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Esp\xedrito Santo (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Esp\xedrito Santo (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Esp\xedrito Santo (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Essequibo Islands-West Demerara (Region of Guyana)": [
            {
                "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Essequibo Islands-West Demerara (Region of Guyana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Est (Region of Burkina Faso)": [
            {
                "Region Name": "Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Est (Region of Burkina Faso)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 37
            }
        ],
        "Est (Region of Cameroon)": [
            {
                "Region Name": "Est (Region of Cameroon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Est (Region of Cameroon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Est (Region of Cameroon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Est (Region of Cameroon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Est (Region of Cameroon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Est (Region of Cameroon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Est (Region of Cameroon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Est (Region of Cameroon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Est (Region of Cameroon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Est (Region of Cameroon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Est (Region of Cameroon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Est (Region of Cameroon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Est (Region of Cameroon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Est (Region of Cameroon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Est (Region of Cameroon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Est (Region of Cameroon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Est (Region of Cameroon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Est (Region of Cameroon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Est (Region of Cameroon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Est (Region of Cameroon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Est (Region of Cameroon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Est (Region of Cameroon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Estel\xed (Department of Nicaragua)": [
            {
                "Region Name": "Estel\xed (Department of Nicaragua)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Estel\xed (Department of Nicaragua)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Estel\xed (Department of Nicaragua)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Estel\xed (Department of Nicaragua)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Estel\xed (Department of Nicaragua)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Estel\xed (Department of Nicaragua)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Estel\xed (Department of Nicaragua)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Estel\xed (Department of Nicaragua)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Estel\xed (Department of Nicaragua)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Estel\xed (Department of Nicaragua)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Estel\xed (Department of Nicaragua)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Estel\xed (Department of Nicaragua)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Estel\xed (Department of Nicaragua)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Estel\xed (Department of Nicaragua)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Estel\xed (Department of Nicaragua)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Estel\xed (Department of Nicaragua)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Estel\xed (Department of Nicaragua)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Estel\xed (Department of Nicaragua)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Estel\xed (Department of Nicaragua)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Estel\xed (Department of Nicaragua)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Estel\xed (Department of Nicaragua)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Estel\xed (Department of Nicaragua)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Estuaire (Province of Gabon)": [
            {
                "Region Name": "Estuaire (Province of Gabon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Estuaire (Province of Gabon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Estuaire (Province of Gabon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Estuaire (Province of Gabon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Estuaire (Province of Gabon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Estuaire (Province of Gabon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Estuaire (Province of Gabon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Estuaire (Province of Gabon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Estuaire (Province of Gabon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Estuaire (Province of Gabon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Estuaire (Province of Gabon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Estuaire (Province of Gabon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Estuaire (Province of Gabon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Estuaire (Province of Gabon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Estuaire (Province of Gabon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Estuaire (Province of Gabon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Estuaire (Province of Gabon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Estuaire (Province of Gabon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Estuaire (Province of Gabon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Estuaire (Province of Gabon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Estuaire (Province of Gabon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Estuaire (Province of Gabon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\xc9vora (District of Portugal)": [
            {
                "Region Name": "\xc9vora (District of Portugal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xc9vora (District of Portugal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "\xc9vora (District of Portugal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "\xc9vora (District of Portugal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\xc9vora (District of Portugal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "\xc9vora (District of Portugal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xc9vora (District of Portugal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xc9vora (District of Portugal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xc9vora (District of Portugal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "\xc9vora (District of Portugal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xc9vora (District of Portugal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xc9vora (District of Portugal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "\xc9vora (District of Portugal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xc9vora (District of Portugal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\xc9vora (District of Portugal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "\xc9vora (District of Portugal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xc9vora (District of Portugal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xc9vora (District of Portugal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xc9vora (District of Portugal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xc9vora (District of Portugal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xc9vora (District of Portugal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\xc9vora (District of Portugal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ewa (District of Nauru)": [
            {
                "Region Name": "Ewa (District of Nauru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ewa (District of Nauru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ewa (District of Nauru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ewa (District of Nauru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ewa (District of Nauru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ewa (District of Nauru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ewa (District of Nauru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ewa (District of Nauru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ewa (District of Nauru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ewa (District of Nauru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ewa (District of Nauru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ewa (District of Nauru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ewa (District of Nauru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ewa (District of Nauru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ewa (District of Nauru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ewa (District of Nauru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ewa (District of Nauru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ewa (District of Nauru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ewa (District of Nauru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ewa (District of Nauru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ewa (District of Nauru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ewa (District of Nauru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Extremadura (Autonomous Community of Spain)": [
            {
                "Region Name": "Extremadura (Autonomous Community of Spain)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Extremadura (Autonomous Community of Spain)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Extremadura (Autonomous Community of Spain)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Extremadura (Autonomous Community of Spain)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Extremadura (Autonomous Community of Spain)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Extremadura (Autonomous Community of Spain)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Extremadura (Autonomous Community of Spain)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Extremadura (Autonomous Community of Spain)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Extremadura (Autonomous Community of Spain)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Extremadura (Autonomous Community of Spain)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Extremadura (Autonomous Community of Spain)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Extremadura (Autonomous Community of Spain)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Extremadura (Autonomous Community of Spain)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Extremadura (Autonomous Community of Spain)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Extremadura (Autonomous Community of Spain)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Extremadura (Autonomous Community of Spain)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Extremadura (Autonomous Community of Spain)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Extremadura (Autonomous Community of Spain)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Extremadura (Autonomous Community of Spain)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Extremadura (Autonomous Community of Spain)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Extremadura (Autonomous Community of Spain)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 75
            },
            {
                "Region Name": "Extremadura (Autonomous Community of Spain)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 92
            }
        ],
        "Extr\xeame-Nord (Region of Cameroon)": [
            {
                "Region Name": "Extr\xeame-Nord (Region of Cameroon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Extr\xeame-Nord (Region of Cameroon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Extr\xeame-Nord (Region of Cameroon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Extr\xeame-Nord (Region of Cameroon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Extr\xeame-Nord (Region of Cameroon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Extr\xeame-Nord (Region of Cameroon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Extr\xeame-Nord (Region of Cameroon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Extr\xeame-Nord (Region of Cameroon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Extr\xeame-Nord (Region of Cameroon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Extr\xeame-Nord (Region of Cameroon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Extr\xeame-Nord (Region of Cameroon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Extr\xeame-Nord (Region of Cameroon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Extr\xeame-Nord (Region of Cameroon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Extr\xeame-Nord (Region of Cameroon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Extr\xeame-Nord (Region of Cameroon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Extr\xeame-Nord (Region of Cameroon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Extr\xeame-Nord (Region of Cameroon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Extr\xeame-Nord (Region of Cameroon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Extr\xeame-Nord (Region of Cameroon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Extr\xeame-Nord (Region of Cameroon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Extr\xeame-Nord (Region of Cameroon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Extr\xeame-Nord (Region of Cameroon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Exuma (District of Bahamas)": [
            {
                "Region Name": "Exuma (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Exuma (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Exuma (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Exuma (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Exuma (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Exuma (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Exuma (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Exuma (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Exuma (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Exuma (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Exuma (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Exuma (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Exuma (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Exuma (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Exuma (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Exuma (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Exuma (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Exuma (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Exuma (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Exuma (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Exuma (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Exuma (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Eysturoyar (Region of Faroe Islands)": [
            {
                "Region Name": "Eysturoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eysturoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eysturoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eysturoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eysturoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eysturoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eysturoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eysturoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eysturoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eysturoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eysturoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eysturoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eysturoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eysturoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eysturoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eysturoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eysturoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eysturoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eysturoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eysturoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eysturoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Eysturoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Fa'asaleleaga (District of Samoa)": [
            {
                "Region Name": "Fa'asaleleaga (District of Samoa)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fa'asaleleaga (District of Samoa)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fa'asaleleaga (District of Samoa)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fa'asaleleaga (District of Samoa)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fa'asaleleaga (District of Samoa)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fa'asaleleaga (District of Samoa)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fa'asaleleaga (District of Samoa)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fa'asaleleaga (District of Samoa)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fa'asaleleaga (District of Samoa)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fa'asaleleaga (District of Samoa)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fa'asaleleaga (District of Samoa)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fa'asaleleaga (District of Samoa)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fa'asaleleaga (District of Samoa)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fa'asaleleaga (District of Samoa)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fa'asaleleaga (District of Samoa)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fa'asaleleaga (District of Samoa)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fa'asaleleaga (District of Samoa)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fa'asaleleaga (District of Samoa)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fa'asaleleaga (District of Samoa)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fa'asaleleaga (District of Samoa)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fa'asaleleaga (District of Samoa)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fa'asaleleaga (District of Samoa)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\u0192\xe5air (Municipality of North Macedonia)": [
            {
                "Region Name": "\u0192\xe5air (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe5air (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe5air (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe5air (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe5air (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe5air (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe5air (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe5air (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe5air (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe5air (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe5air (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe5air (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe5air (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe5air (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe5air (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe5air (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe5air (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe5air (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe5air (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe5air (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe5air (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe5air (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\u0192\xe4entrali (Region of Malta)": [
            {
                "Region Name": "\u0192\xe4entrali (Region of Malta)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe4entrali (Region of Malta)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe4entrali (Region of Malta)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe4entrali (Region of Malta)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe4entrali (Region of Malta)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe4entrali (Region of Malta)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe4entrali (Region of Malta)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe4entrali (Region of Malta)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe4entrali (Region of Malta)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe4entrali (Region of Malta)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe4entrali (Region of Malta)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe4entrali (Region of Malta)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe4entrali (Region of Malta)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe4entrali (Region of Malta)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe4entrali (Region of Malta)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe4entrali (Region of Malta)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe4entrali (Region of Malta)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe4entrali (Region of Malta)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe4entrali (Region of Malta)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe4entrali (Region of Malta)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe4entrali (Region of Malta)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0192\xe4entrali (Region of Malta)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Faetano (Municipality of San Marino)": [
            {
                "Region Name": "Faetano (Municipality of San Marino)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faetano (Municipality of San Marino)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faetano (Municipality of San Marino)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faetano (Municipality of San Marino)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faetano (Municipality of San Marino)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faetano (Municipality of San Marino)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faetano (Municipality of San Marino)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faetano (Municipality of San Marino)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faetano (Municipality of San Marino)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faetano (Municipality of San Marino)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faetano (Municipality of San Marino)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faetano (Municipality of San Marino)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faetano (Municipality of San Marino)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faetano (Municipality of San Marino)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faetano (Municipality of San Marino)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faetano (Municipality of San Marino)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faetano (Municipality of San Marino)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faetano (Municipality of San Marino)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faetano (Municipality of San Marino)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faetano (Municipality of San Marino)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faetano (Municipality of San Marino)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faetano (Municipality of San Marino)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Fajardo (Municipality of Puerto Rico)": [
            {
                "Region Name": "Fajardo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fajardo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fajardo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fajardo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fajardo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fajardo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fajardo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fajardo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fajardo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fajardo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fajardo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fajardo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fajardo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fajardo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fajardo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fajardo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fajardo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fajardo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fajardo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fajardo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fajardo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fajardo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Fakaofo (Atoll of Tokelau)": [
            {
                "Region Name": "Fakaofo (Atoll of Tokelau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fakaofo (Atoll of Tokelau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fakaofo (Atoll of Tokelau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fakaofo (Atoll of Tokelau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fakaofo (Atoll of Tokelau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fakaofo (Atoll of Tokelau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fakaofo (Atoll of Tokelau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fakaofo (Atoll of Tokelau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fakaofo (Atoll of Tokelau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fakaofo (Atoll of Tokelau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fakaofo (Atoll of Tokelau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fakaofo (Atoll of Tokelau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fakaofo (Atoll of Tokelau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fakaofo (Atoll of Tokelau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fakaofo (Atoll of Tokelau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fakaofo (Atoll of Tokelau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fakaofo (Atoll of Tokelau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fakaofo (Atoll of Tokelau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fakaofo (Atoll of Tokelau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fakaofo (Atoll of Tokelau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fakaofo (Atoll of Tokelau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fakaofo (Atoll of Tokelau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Falc\xf3n (State of Venezuela)": [
            {
                "Region Name": "Falc\xf3n (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Falc\xf3n (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Falc\xf3n (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Falc\xf3n (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Falc\xf3n (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Falc\xf3n (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Falc\xf3n (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Falc\xf3n (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Falc\xf3n (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Falc\xf3n (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Falc\xf3n (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Falc\xf3n (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Falc\xf3n (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Falc\xf3n (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Falc\xf3n (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Falc\xf3n (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Falc\xf3n (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Falc\xf3n (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Falc\xf3n (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Falc\xf3n (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Falc\xf3n (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Falc\xf3n (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "F\u0103le\u0219ti (District of Moldova)": [
            {
                "Region Name": "F\u0103le\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "F\u0103le\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "F\u0103le\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "F\u0103le\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "F\u0103le\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "F\u0103le\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "F\u0103le\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "F\u0103le\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "F\u0103le\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "F\u0103le\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "F\u0103le\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "F\u0103le\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "F\u0103le\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "F\u0103le\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "F\u0103le\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "F\u0103le\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "F\u0103le\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "F\u0103le\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "F\u0103le\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "F\u0103le\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "F\u0103le\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "F\u0103le\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Famagusta (District of Cyprus)": [
            {
                "Region Name": "Famagusta (District of Cyprus)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Famagusta (District of Cyprus)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Famagusta (District of Cyprus)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Famagusta (District of Cyprus)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Famagusta (District of Cyprus)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Famagusta (District of Cyprus)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Famagusta (District of Cyprus)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Famagusta (District of Cyprus)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Famagusta (District of Cyprus)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Famagusta (District of Cyprus)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Famagusta (District of Cyprus)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Famagusta (District of Cyprus)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Famagusta (District of Cyprus)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Famagusta (District of Cyprus)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Famagusta (District of Cyprus)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Famagusta (District of Cyprus)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Famagusta (District of Cyprus)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Famagusta (District of Cyprus)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Famagusta (District of Cyprus)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Famagusta (District of Cyprus)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Famagusta (District of Cyprus)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Famagusta (District of Cyprus)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Far-Western (Development Region of Nepal)": [
            {
                "Region Name": "Far-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Far-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Far-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Far-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Far-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Far-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Far-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Far-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Far-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Far-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Far-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Far-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Far-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Far-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Far-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Far-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Far-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Far-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Far-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Far-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Far-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Far-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 21
            }
        ],
        "Farah (Province of Afghanistan)": [
            {
                "Region Name": "Farah (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farah (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farah (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farah (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farah (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farah (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farah (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farah (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farah (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farah (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farah (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farah (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farah (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farah (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farah (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farah (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farah (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farah (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farah (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Farah (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farah (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farah (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Faranah (Region of Guinea)": [
            {
                "Region Name": "Faranah (Region of Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Faranah (Region of Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Faranah (Region of Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Faranah (Region of Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Faranah (Region of Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Faranah (Region of Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Faranah (Region of Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Faranah (Region of Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Faranah (Region of Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Faranah (Region of Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Faranah (Region of Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Faranah (Region of Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Faranah (Region of Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Faranah (Region of Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Faranah (Region of Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Faranah (Region of Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Faranah (Region of Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Faranah (Region of Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Faranah (Region of Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Faranah (Region of Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Faranah (Region of Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Faranah (Region of Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Farg'ona (Region of Uzbekistan)": [
            {
                "Region Name": "Farg'ona (Region of Uzbekistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farg'ona (Region of Uzbekistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farg'ona (Region of Uzbekistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farg'ona (Region of Uzbekistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farg'ona (Region of Uzbekistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farg'ona (Region of Uzbekistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farg'ona (Region of Uzbekistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farg'ona (Region of Uzbekistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farg'ona (Region of Uzbekistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farg'ona (Region of Uzbekistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farg'ona (Region of Uzbekistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farg'ona (Region of Uzbekistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Farg'ona (Region of Uzbekistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farg'ona (Region of Uzbekistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Farg'ona (Region of Uzbekistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farg'ona (Region of Uzbekistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farg'ona (Region of Uzbekistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farg'ona (Region of Uzbekistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farg'ona (Region of Uzbekistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farg'ona (Region of Uzbekistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farg'ona (Region of Uzbekistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Farg'ona (Region of Uzbekistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Faro (District of Portugal)": [
            {
                "Region Name": "Faro (District of Portugal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Faro (District of Portugal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 277
            },
            {
                "Region Name": "Faro (District of Portugal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 212
            },
            {
                "Region Name": "Faro (District of Portugal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Faro (District of Portugal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faro (District of Portugal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Faro (District of Portugal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faro (District of Portugal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Faro (District of Portugal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faro (District of Portugal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faro (District of Portugal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 234
            },
            {
                "Region Name": "Faro (District of Portugal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Faro (District of Portugal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Faro (District of Portugal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faro (District of Portugal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Faro (District of Portugal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faro (District of Portugal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 286
            },
            {
                "Region Name": "Faro (District of Portugal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Faro (District of Portugal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Faro (District of Portugal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Faro (District of Portugal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Faro (District of Portugal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Fars (Province of Iran)": [
            {
                "Region Name": "Fars (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Fars (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Fars (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Fars (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Fars (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Fars (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Fars (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Fars (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Fars (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Fars (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Fars (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Fars (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Fars (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Fars (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Fars (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Fars (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Fars (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Fars (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Fars (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Fars (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Fars (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Fars (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Faryab (Province of Afghanistan)": [
            {
                "Region Name": "Faryab (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faryab (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 74
            },
            {
                "Region Name": "Faryab (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Faryab (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Faryab (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faryab (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faryab (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faryab (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Faryab (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 87
            },
            {
                "Region Name": "Faryab (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faryab (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Faryab (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faryab (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faryab (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Faryab (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faryab (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faryab (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faryab (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Faryab (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Faryab (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faryab (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Faryab (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Fatick (Region of Senegal)": [
            {
                "Region Name": "Fatick (Region of Senegal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Fatick (Region of Senegal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Fatick (Region of Senegal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Fatick (Region of Senegal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Fatick (Region of Senegal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Fatick (Region of Senegal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Fatick (Region of Senegal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Fatick (Region of Senegal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Fatick (Region of Senegal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Fatick (Region of Senegal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Fatick (Region of Senegal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Fatick (Region of Senegal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Fatick (Region of Senegal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Fatick (Region of Senegal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Fatick (Region of Senegal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Fatick (Region of Senegal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Fatick (Region of Senegal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Fatick (Region of Senegal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Fatick (Region of Senegal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Fatick (Region of Senegal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Fatick (Region of Senegal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Fatick (Region of Senegal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 22
            }
        ],
        "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)": [
            {
                "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Federacija Bosna i Hercegovina (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Federal Capital Territory (State of Nigeria)": [
            {
                "Region Name": "Federal Capital Territory (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Federal Capital Territory (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Federal Capital Territory (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Federal Capital Territory (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Federal Capital Territory (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Federal Capital Territory (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Federal Capital Territory (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Federal Capital Territory (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Federal Capital Territory (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Federal Capital Territory (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Federal Capital Territory (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Federal Capital Territory (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Federal Capital Territory (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Federal Capital Territory (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Federal Capital Territory (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Federal Capital Territory (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Federal Capital Territory (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Federal Capital Territory (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Federal Capital Territory (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Federal Capital Territory (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Federal Capital Territory (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Federal Capital Territory (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Federally Administered Tribal Ar (Territory of Pakistan)": [
            {
                "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Federally Administered Tribal Ar (Territory of Pakistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Fej\xe9r (County of Hungary)": [
            {
                "Region Name": "Fej\xe9r (County of Hungary)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Fej\xe9r (County of Hungary)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Fej\xe9r (County of Hungary)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Fej\xe9r (County of Hungary)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Fej\xe9r (County of Hungary)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Fej\xe9r (County of Hungary)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Fej\xe9r (County of Hungary)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Fej\xe9r (County of Hungary)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fej\xe9r (County of Hungary)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Fej\xe9r (County of Hungary)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Fej\xe9r (County of Hungary)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fej\xe9r (County of Hungary)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fej\xe9r (County of Hungary)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Fej\xe9r (County of Hungary)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Fej\xe9r (County of Hungary)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fej\xe9r (County of Hungary)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Fej\xe9r (County of Hungary)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fej\xe9r (County of Hungary)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fej\xe9r (County of Hungary)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Fej\xe9r (County of Hungary)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fej\xe9r (County of Hungary)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fej\xe9r (County of Hungary)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "F\xe8s - Boulemane (Region of Morocco)": [
            {
                "Region Name": "F\xe8s - Boulemane (Region of Morocco)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "F\xe8s - Boulemane (Region of Morocco)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "F\xe8s - Boulemane (Region of Morocco)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "F\xe8s - Boulemane (Region of Morocco)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "F\xe8s - Boulemane (Region of Morocco)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "F\xe8s - Boulemane (Region of Morocco)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "F\xe8s - Boulemane (Region of Morocco)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "F\xe8s - Boulemane (Region of Morocco)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "F\xe8s - Boulemane (Region of Morocco)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "F\xe8s - Boulemane (Region of Morocco)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "F\xe8s - Boulemane (Region of Morocco)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "F\xe8s - Boulemane (Region of Morocco)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "F\xe8s - Boulemane (Region of Morocco)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "F\xe8s - Boulemane (Region of Morocco)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "F\xe8s - Boulemane (Region of Morocco)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "F\xe8s - Boulemane (Region of Morocco)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "F\xe8s - Boulemane (Region of Morocco)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "F\xe8s - Boulemane (Region of Morocco)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "F\xe8s - Boulemane (Region of Morocco)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "F\xe8s - Boulemane (Region of Morocco)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "F\xe8s - Boulemane (Region of Morocco)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "F\xe8s - Boulemane (Region of Morocco)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Fianarantsoa (NA of Madagascar)": [
            {
                "Region Name": "Fianarantsoa (NA of Madagascar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Fianarantsoa (NA of Madagascar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Fianarantsoa (NA of Madagascar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Fianarantsoa (NA of Madagascar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Fianarantsoa (NA of Madagascar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Fianarantsoa (NA of Madagascar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Fianarantsoa (NA of Madagascar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Fianarantsoa (NA of Madagascar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Fianarantsoa (NA of Madagascar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Fianarantsoa (NA of Madagascar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Fianarantsoa (NA of Madagascar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Fianarantsoa (NA of Madagascar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Fianarantsoa (NA of Madagascar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Fianarantsoa (NA of Madagascar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Fianarantsoa (NA of Madagascar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Fianarantsoa (NA of Madagascar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Fianarantsoa (NA of Madagascar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Fianarantsoa (NA of Madagascar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Fianarantsoa (NA of Madagascar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Fianarantsoa (NA of Madagascar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Fianarantsoa (NA of Madagascar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Fianarantsoa (NA of Madagascar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Fier (County of Albania)": [
            {
                "Region Name": "Fier (County of Albania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fier (County of Albania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fier (County of Albania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fier (County of Albania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fier (County of Albania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fier (County of Albania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fier (County of Albania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fier (County of Albania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fier (County of Albania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fier (County of Albania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Fier (County of Albania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fier (County of Albania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fier (County of Albania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fier (County of Albania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Fier (County of Albania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fier (County of Albania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Fier (County of Albania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Fier (County of Albania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fier (County of Albania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Fier (County of Albania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fier (County of Albania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fier (County of Albania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Finnmark (County of Norway)": [
            {
                "Region Name": "Finnmark (County of Norway)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finnmark (County of Norway)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finnmark (County of Norway)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finnmark (County of Norway)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finnmark (County of Norway)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finnmark (County of Norway)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finnmark (County of Norway)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finnmark (County of Norway)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finnmark (County of Norway)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finnmark (County of Norway)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finnmark (County of Norway)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finnmark (County of Norway)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finnmark (County of Norway)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finnmark (County of Norway)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finnmark (County of Norway)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finnmark (County of Norway)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finnmark (County of Norway)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finnmark (County of Norway)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finnmark (County of Norway)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finnmark (County of Norway)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finnmark (County of Norway)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Finnmark (County of Norway)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Fiorentino (Municipality of San Marino)": [
            {
                "Region Name": "Fiorentino (Municipality of San Marino)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiorentino (Municipality of San Marino)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiorentino (Municipality of San Marino)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiorentino (Municipality of San Marino)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiorentino (Municipality of San Marino)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiorentino (Municipality of San Marino)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiorentino (Municipality of San Marino)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiorentino (Municipality of San Marino)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiorentino (Municipality of San Marino)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiorentino (Municipality of San Marino)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiorentino (Municipality of San Marino)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiorentino (Municipality of San Marino)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiorentino (Municipality of San Marino)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiorentino (Municipality of San Marino)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiorentino (Municipality of San Marino)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiorentino (Municipality of San Marino)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiorentino (Municipality of San Marino)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiorentino (Municipality of San Marino)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiorentino (Municipality of San Marino)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiorentino (Municipality of San Marino)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiorentino (Municipality of San Marino)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fiorentino (Municipality of San Marino)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Flacq (District of Mauritius)": [
            {
                "Region Name": "Flacq (District of Mauritius)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flacq (District of Mauritius)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flacq (District of Mauritius)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flacq (District of Mauritius)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flacq (District of Mauritius)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flacq (District of Mauritius)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flacq (District of Mauritius)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flacq (District of Mauritius)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flacq (District of Mauritius)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Flacq (District of Mauritius)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flacq (District of Mauritius)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flacq (District of Mauritius)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Flacq (District of Mauritius)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Flacq (District of Mauritius)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flacq (District of Mauritius)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flacq (District of Mauritius)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flacq (District of Mauritius)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Flacq (District of Mauritius)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flacq (District of Mauritius)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flacq (District of Mauritius)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flacq (District of Mauritius)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flacq (District of Mauritius)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Flevoland (Province of Netherlands)": [
            {
                "Region Name": "Flevoland (Province of Netherlands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flevoland (Province of Netherlands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flevoland (Province of Netherlands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flevoland (Province of Netherlands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flevoland (Province of Netherlands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Flevoland (Province of Netherlands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flevoland (Province of Netherlands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flevoland (Province of Netherlands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flevoland (Province of Netherlands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flevoland (Province of Netherlands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flevoland (Province of Netherlands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flevoland (Province of Netherlands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flevoland (Province of Netherlands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flevoland (Province of Netherlands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flevoland (Province of Netherlands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flevoland (Province of Netherlands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flevoland (Province of Netherlands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flevoland (Province of Netherlands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flevoland (Province of Netherlands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flevoland (Province of Netherlands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flevoland (Province of Netherlands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Flevoland (Province of Netherlands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Flores (Department of Uruguay)": [
            {
                "Region Name": "Flores (Department of Uruguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flores (Department of Uruguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Flores (Department of Uruguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Flores (Department of Uruguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flores (Department of Uruguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Flores (Department of Uruguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Flores (Department of Uruguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Flores (Department of Uruguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Flores (Department of Uruguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Flores (Department of Uruguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Flores (Department of Uruguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flores (Department of Uruguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Flores (Department of Uruguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flores (Department of Uruguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Flores (Department of Uruguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flores (Department of Uruguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flores (Department of Uruguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Flores (Department of Uruguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flores (Department of Uruguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Flores (Department of Uruguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flores (Department of Uruguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Flores (Department of Uruguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Flore\u0219ti (District of Moldova)": [
            {
                "Region Name": "Flore\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flore\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Flore\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flore\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Flore\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Flore\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flore\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Flore\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Flore\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Flore\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Flore\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Flore\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Flore\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Flore\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Flore\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Flore\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Flore\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flore\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flore\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Flore\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Flore\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Flore\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Florida (Department of Uruguay)": [
            {
                "Region Name": "Florida (Department of Uruguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Department of Uruguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Florida (Department of Uruguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Florida (Department of Uruguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Department of Uruguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Florida (Department of Uruguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Department of Uruguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Florida (Department of Uruguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Florida (Department of Uruguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Florida (Department of Uruguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Florida (Department of Uruguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Florida (Department of Uruguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Florida (Department of Uruguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Department of Uruguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Florida (Department of Uruguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Florida (Department of Uruguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Florida (Department of Uruguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Department of Uruguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Florida (Department of Uruguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Florida (Department of Uruguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Florida (Department of Uruguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Florida (Department of Uruguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Florida (Municipality of Puerto Rico)": [
            {
                "Region Name": "Florida (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Florida (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Florida (State of United States)": [
            {
                "Region Name": "Florida (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Florida (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Florida (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Florida (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Florida (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Florida (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Florida (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Florida (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Florida (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Florida (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Florida (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Florida (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Florida (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Florida (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Florida (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Florida (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Florida (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Florida (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Florida (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Florida (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Florida (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Florida (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Forest (Parish of Guernsey)": [
            {
                "Region Name": "Forest (Parish of Guernsey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Forest (Parish of Guernsey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Forest (Parish of Guernsey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Forest (Parish of Guernsey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Forest (Parish of Guernsey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Forest (Parish of Guernsey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Forest (Parish of Guernsey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Forest (Parish of Guernsey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Forest (Parish of Guernsey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Forest (Parish of Guernsey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Forest (Parish of Guernsey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Forest (Parish of Guernsey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Forest (Parish of Guernsey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Forest (Parish of Guernsey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Forest (Parish of Guernsey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Forest (Parish of Guernsey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Forest (Parish of Guernsey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Forest (Parish of Guernsey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Forest (Parish of Guernsey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Forest (Parish of Guernsey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Forest (Parish of Guernsey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Forest (Parish of Guernsey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Formosa (Province of Argentina)": [
            {
                "Region Name": "Formosa (Province of Argentina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Formosa (Province of Argentina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Formosa (Province of Argentina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Formosa (Province of Argentina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Formosa (Province of Argentina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Formosa (Province of Argentina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Formosa (Province of Argentina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Formosa (Province of Argentina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Formosa (Province of Argentina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Formosa (Province of Argentina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Formosa (Province of Argentina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Formosa (Province of Argentina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Formosa (Province of Argentina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Formosa (Province of Argentina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Formosa (Province of Argentina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Formosa (Province of Argentina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Formosa (Province of Argentina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Formosa (Province of Argentina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Formosa (Province of Argentina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Formosa (Province of Argentina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Formosa (Province of Argentina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Formosa (Province of Argentina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Fort-de-France (Arrondissement of Martinique)": [
            {
                "Region Name": "Fort-de-France (Arrondissement of Martinique)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fort-de-France (Arrondissement of Martinique)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fort-de-France (Arrondissement of Martinique)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fort-de-France (Arrondissement of Martinique)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fort-de-France (Arrondissement of Martinique)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fort-de-France (Arrondissement of Martinique)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fort-de-France (Arrondissement of Martinique)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fort-de-France (Arrondissement of Martinique)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fort-de-France (Arrondissement of Martinique)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fort-de-France (Arrondissement of Martinique)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fort-de-France (Arrondissement of Martinique)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fort-de-France (Arrondissement of Martinique)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fort-de-France (Arrondissement of Martinique)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fort-de-France (Arrondissement of Martinique)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fort-de-France (Arrondissement of Martinique)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fort-de-France (Arrondissement of Martinique)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fort-de-France (Arrondissement of Martinique)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fort-de-France (Arrondissement of Martinique)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fort-de-France (Arrondissement of Martinique)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fort-de-France (Arrondissement of Martinique)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fort-de-France (Arrondissement of Martinique)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fort-de-France (Arrondissement of Martinique)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Francisco Moraz\xe1n (Department of Honduras)": [
            {
                "Region Name": "Francisco Moraz\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Francisco Moraz\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Francisco Moraz\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Francisco Moraz\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Francisco Moraz\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Francisco Moraz\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Francisco Moraz\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Francisco Moraz\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Francisco Moraz\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Francisco Moraz\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Francisco Moraz\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Francisco Moraz\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Francisco Moraz\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Francisco Moraz\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Francisco Moraz\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Francisco Moraz\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Francisco Moraz\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Francisco Moraz\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Francisco Moraz\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Francisco Moraz\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Francisco Moraz\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Francisco Moraz\xe1n (Department of Honduras)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Francistown (City of Botswana)": [
            {
                "Region Name": "Francistown (City of Botswana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Francistown (City of Botswana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Francistown (City of Botswana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Francistown (City of Botswana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Francistown (City of Botswana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Francistown (City of Botswana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Francistown (City of Botswana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Francistown (City of Botswana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Francistown (City of Botswana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Francistown (City of Botswana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Francistown (City of Botswana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Francistown (City of Botswana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Francistown (City of Botswana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Francistown (City of Botswana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Francistown (City of Botswana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Francistown (City of Botswana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Francistown (City of Botswana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Francistown (City of Botswana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Francistown (City of Botswana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Francistown (City of Botswana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Francistown (City of Botswana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Francistown (City of Botswana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Free State (Province of South Africa)": [
            {
                "Region Name": "Free State (Province of South Africa)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Free State (Province of South Africa)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Free State (Province of South Africa)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Free State (Province of South Africa)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Free State (Province of South Africa)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Free State (Province of South Africa)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Free State (Province of South Africa)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Free State (Province of South Africa)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Free State (Province of South Africa)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Free State (Province of South Africa)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Free State (Province of South Africa)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Free State (Province of South Africa)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Free State (Province of South Africa)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Free State (Province of South Africa)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Free State (Province of South Africa)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Free State (Province of South Africa)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Free State (Province of South Africa)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Free State (Province of South Africa)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Free State (Province of South Africa)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Free State (Province of South Africa)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Free State (Province of South Africa)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Free State (Province of South Africa)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 36
            }
        ],
        "Fribourg (Canton of Switzerland)": [
            {
                "Region Name": "Fribourg (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fribourg (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fribourg (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fribourg (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fribourg (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fribourg (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fribourg (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fribourg (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fribourg (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fribourg (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fribourg (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fribourg (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fribourg (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fribourg (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fribourg (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fribourg (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fribourg (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fribourg (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fribourg (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fribourg (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fribourg (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fribourg (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Friuli-Venezia Giulia (Autonomous Region of Italy)": [
            {
                "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Friuli-Venezia Giulia (Autonomous Region of Italy)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Frysl\xe2n (Province of Netherlands)": [
            {
                "Region Name": "Frysl\xe2n (Province of Netherlands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Frysl\xe2n (Province of Netherlands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Frysl\xe2n (Province of Netherlands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Frysl\xe2n (Province of Netherlands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Frysl\xe2n (Province of Netherlands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Frysl\xe2n (Province of Netherlands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Frysl\xe2n (Province of Netherlands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Frysl\xe2n (Province of Netherlands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Frysl\xe2n (Province of Netherlands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Frysl\xe2n (Province of Netherlands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Frysl\xe2n (Province of Netherlands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Frysl\xe2n (Province of Netherlands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Frysl\xe2n (Province of Netherlands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Frysl\xe2n (Province of Netherlands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Frysl\xe2n (Province of Netherlands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Frysl\xe2n (Province of Netherlands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Frysl\xe2n (Province of Netherlands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Frysl\xe2n (Province of Netherlands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Frysl\xe2n (Province of Netherlands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Frysl\xe2n (Province of Netherlands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Frysl\xe2n (Province of Netherlands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Frysl\xe2n (Province of Netherlands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Fujairah (Emirate of United Arab Emirates)": [
            {
                "Region Name": "Fujairah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujairah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujairah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujairah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujairah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujairah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujairah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujairah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujairah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujairah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujairah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujairah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujairah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujairah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujairah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujairah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujairah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujairah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujairah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujairah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujairah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujairah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Fujian (Province of China)": [
            {
                "Region Name": "Fujian (Province of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Fujian (Province of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Fujian (Province of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Fujian (Province of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Fujian (Province of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Fujian (Province of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Fujian (Province of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Fujian (Province of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Fujian (Province of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Fujian (Province of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Fujian (Province of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Fujian (Province of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Fujian (Province of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Fujian (Province of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Fujian (Province of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Fujian (Province of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Fujian (Province of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Fujian (Province of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Fujian (Province of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Fujian (Province of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Fujian (Province of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Fujian (Province of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Fujian (Province of Taiwan)": [
            {
                "Region Name": "Fujian (Province of Taiwan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujian (Province of Taiwan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujian (Province of Taiwan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujian (Province of Taiwan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujian (Province of Taiwan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujian (Province of Taiwan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujian (Province of Taiwan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujian (Province of Taiwan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujian (Province of Taiwan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujian (Province of Taiwan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujian (Province of Taiwan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujian (Province of Taiwan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujian (Province of Taiwan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujian (Province of Taiwan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujian (Province of Taiwan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujian (Province of Taiwan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujian (Province of Taiwan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujian (Province of Taiwan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujian (Province of Taiwan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujian (Province of Taiwan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujian (Province of Taiwan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fujian (Province of Taiwan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Fukui (Prefecture of Japan)": [
            {
                "Region Name": "Fukui (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukui (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukui (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukui (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukui (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukui (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukui (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukui (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukui (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukui (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukui (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukui (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Fukui (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukui (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukui (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukui (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukui (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukui (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukui (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukui (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Fukui (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Fukui (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Fukuoka (Prefecture of Japan)": [
            {
                "Region Name": "Fukuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Fukuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Fukuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Fukuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Fukuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Fukuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Fukuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Fukuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Fukuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Fukushima (Prefecture of Japan)": [
            {
                "Region Name": "Fukushima (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukushima (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukushima (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukushima (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukushima (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukushima (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukushima (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Fukushima (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukushima (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukushima (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Fukushima (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukushima (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Fukushima (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukushima (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Fukushima (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukushima (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukushima (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukushima (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukushima (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukushima (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Fukushima (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Fukushima (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Funafuti (Town Council of Tuvalu)": [
            {
                "Region Name": "Funafuti (Town Council of Tuvalu)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Funafuti (Town Council of Tuvalu)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Funafuti (Town Council of Tuvalu)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Funafuti (Town Council of Tuvalu)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Funafuti (Town Council of Tuvalu)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Funafuti (Town Council of Tuvalu)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Funafuti (Town Council of Tuvalu)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Funafuti (Town Council of Tuvalu)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Funafuti (Town Council of Tuvalu)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Funafuti (Town Council of Tuvalu)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Funafuti (Town Council of Tuvalu)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Funafuti (Town Council of Tuvalu)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Funafuti (Town Council of Tuvalu)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Funafuti (Town Council of Tuvalu)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Funafuti (Town Council of Tuvalu)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Funafuti (Town Council of Tuvalu)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Funafuti (Town Council of Tuvalu)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Funafuti (Town Council of Tuvalu)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Funafuti (Town Council of Tuvalu)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Funafuti (Town Council of Tuvalu)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Funafuti (Town Council of Tuvalu)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Funafuti (Town Council of Tuvalu)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gab\xe8s (Governorate of Tunisia)": [
            {
                "Region Name": "Gab\xe8s (Governorate of Tunisia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gab\xe8s (Governorate of Tunisia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gab\xe8s (Governorate of Tunisia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gab\xe8s (Governorate of Tunisia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gab\xe8s (Governorate of Tunisia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gab\xe8s (Governorate of Tunisia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gab\xe8s (Governorate of Tunisia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gab\xe8s (Governorate of Tunisia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gab\xe8s (Governorate of Tunisia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gab\xe8s (Governorate of Tunisia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gab\xe8s (Governorate of Tunisia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gab\xe8s (Governorate of Tunisia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gab\xe8s (Governorate of Tunisia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gab\xe8s (Governorate of Tunisia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gab\xe8s (Governorate of Tunisia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gab\xe8s (Governorate of Tunisia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gab\xe8s (Governorate of Tunisia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gab\xe8s (Governorate of Tunisia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gab\xe8s (Governorate of Tunisia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gab\xe8s (Governorate of Tunisia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gab\xe8s (Governorate of Tunisia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gab\xe8s (Governorate of Tunisia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gaborone (City of Botswana)": [
            {
                "Region Name": "Gaborone (City of Botswana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaborone (City of Botswana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaborone (City of Botswana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaborone (City of Botswana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaborone (City of Botswana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaborone (City of Botswana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaborone (City of Botswana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaborone (City of Botswana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaborone (City of Botswana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gaborone (City of Botswana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaborone (City of Botswana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaborone (City of Botswana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaborone (City of Botswana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaborone (City of Botswana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaborone (City of Botswana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaborone (City of Botswana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaborone (City of Botswana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaborone (City of Botswana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaborone (City of Botswana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaborone (City of Botswana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaborone (City of Botswana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaborone (City of Botswana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Gabrovo (Province of Bulgaria)": [
            {
                "Region Name": "Gabrovo (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gabrovo (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gabrovo (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gabrovo (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gabrovo (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gabrovo (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Gabrovo (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gabrovo (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gabrovo (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gabrovo (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gabrovo (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gabrovo (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gabrovo (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gabrovo (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gabrovo (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gabrovo (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gabrovo (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gabrovo (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gabrovo (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gabrovo (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gabrovo (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gabrovo (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gab\xfa (Region of Guinea-Bissau)": [
            {
                "Region Name": "Gab\xfa (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Gab\xfa (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Gab\xfa (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Gab\xfa (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Gab\xfa (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Gab\xfa (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Gab\xfa (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gab\xfa (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gab\xfa (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gab\xfa (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Gab\xfa (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gab\xfa (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Gab\xfa (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Gab\xfa (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gab\xfa (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Gab\xfa (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Gab\xfa (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Gab\xfa (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Gab\xfa (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Gab\xfa (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Gab\xfa (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gab\xfa (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Gafsa (Governorate of Tunisia)": [
            {
                "Region Name": "Gafsa (Governorate of Tunisia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gafsa (Governorate of Tunisia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gafsa (Governorate of Tunisia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gafsa (Governorate of Tunisia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gafsa (Governorate of Tunisia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gafsa (Governorate of Tunisia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gafsa (Governorate of Tunisia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gafsa (Governorate of Tunisia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gafsa (Governorate of Tunisia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gafsa (Governorate of Tunisia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gafsa (Governorate of Tunisia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gafsa (Governorate of Tunisia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gafsa (Governorate of Tunisia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gafsa (Governorate of Tunisia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gafsa (Governorate of Tunisia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gafsa (Governorate of Tunisia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gafsa (Governorate of Tunisia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gafsa (Governorate of Tunisia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gafsa (Governorate of Tunisia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gafsa (Governorate of Tunisia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gafsa (Governorate of Tunisia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gafsa (Governorate of Tunisia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gaga'emauga (District of Samoa)": [
            {
                "Region Name": "Gaga'emauga (District of Samoa)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaga'emauga (District of Samoa)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaga'emauga (District of Samoa)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaga'emauga (District of Samoa)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaga'emauga (District of Samoa)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaga'emauga (District of Samoa)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaga'emauga (District of Samoa)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaga'emauga (District of Samoa)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaga'emauga (District of Samoa)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaga'emauga (District of Samoa)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaga'emauga (District of Samoa)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaga'emauga (District of Samoa)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaga'emauga (District of Samoa)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaga'emauga (District of Samoa)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaga'emauga (District of Samoa)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaga'emauga (District of Samoa)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaga'emauga (District of Samoa)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaga'emauga (District of Samoa)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaga'emauga (District of Samoa)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaga'emauga (District of Samoa)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaga'emauga (District of Samoa)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaga'emauga (District of Samoa)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gagaifomauga (District of Samoa)": [
            {
                "Region Name": "Gagaifomauga (District of Samoa)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gagaifomauga (District of Samoa)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gagaifomauga (District of Samoa)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gagaifomauga (District of Samoa)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gagaifomauga (District of Samoa)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gagaifomauga (District of Samoa)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gagaifomauga (District of Samoa)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gagaifomauga (District of Samoa)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gagaifomauga (District of Samoa)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gagaifomauga (District of Samoa)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gagaifomauga (District of Samoa)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gagaifomauga (District of Samoa)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gagaifomauga (District of Samoa)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gagaifomauga (District of Samoa)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gagaifomauga (District of Samoa)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gagaifomauga (District of Samoa)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gagaifomauga (District of Samoa)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gagaifomauga (District of Samoa)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gagaifomauga (District of Samoa)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gagaifomauga (District of Samoa)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gagaifomauga (District of Samoa)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gagaifomauga (District of Samoa)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "G\u0103g\u0103uzia (Autonomous Territory of Moldova)": [
            {
                "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "G\u0103g\u0103uzia (Autonomous Territory of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Gal\xe1pagos (Province of Ecuador)": [
            {
                "Region Name": "Gal\xe1pagos (Province of Ecuador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gal\xe1pagos (Province of Ecuador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gal\xe1pagos (Province of Ecuador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gal\xe1pagos (Province of Ecuador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gal\xe1pagos (Province of Ecuador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gal\xe1pagos (Province of Ecuador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gal\xe1pagos (Province of Ecuador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gal\xe1pagos (Province of Ecuador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gal\xe1pagos (Province of Ecuador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gal\xe1pagos (Province of Ecuador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gal\xe1pagos (Province of Ecuador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gal\xe1pagos (Province of Ecuador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gal\xe1pagos (Province of Ecuador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gal\xe1pagos (Province of Ecuador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gal\xe1pagos (Province of Ecuador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gal\xe1pagos (Province of Ecuador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Gal\xe1pagos (Province of Ecuador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gal\xe1pagos (Province of Ecuador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gal\xe1pagos (Province of Ecuador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gal\xe1pagos (Province of Ecuador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gal\xe1pagos (Province of Ecuador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gal\xe1pagos (Province of Ecuador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gala\u021Bi (County of Romania)": [
            {
                "Region Name": "Gala\u021Bi (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gala\u021Bi (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gala\u021Bi (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gala\u021Bi (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gala\u021Bi (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gala\u021Bi (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gala\u021Bi (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gala\u021Bi (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gala\u021Bi (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gala\u021Bi (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gala\u021Bi (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gala\u021Bi (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gala\u021Bi (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gala\u021Bi (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gala\u021Bi (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gala\u021Bi (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gala\u021Bi (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gala\u021Bi (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gala\u021Bi (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gala\u021Bi (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gala\u021Bi (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gala\u021Bi (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Galguduud (Region of Somalia)": [
            {
                "Region Name": "Galguduud (Region of Somalia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galguduud (Region of Somalia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galguduud (Region of Somalia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galguduud (Region of Somalia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galguduud (Region of Somalia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galguduud (Region of Somalia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galguduud (Region of Somalia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galguduud (Region of Somalia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galguduud (Region of Somalia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galguduud (Region of Somalia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galguduud (Region of Somalia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galguduud (Region of Somalia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Galguduud (Region of Somalia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galguduud (Region of Somalia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galguduud (Region of Somalia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galguduud (Region of Somalia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galguduud (Region of Somalia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galguduud (Region of Somalia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galguduud (Region of Somalia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Galguduud (Region of Somalia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galguduud (Region of Somalia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galguduud (Region of Somalia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Galicia (Autonomous Community of Spain)": [
            {
                "Region Name": "Galicia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Galicia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Galicia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Galicia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Galicia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Galicia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Galicia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Galicia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Galicia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Galicia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Galicia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Galicia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Galicia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Galicia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Galicia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Galicia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Galicia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Galicia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Galicia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Galicia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Galicia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 74
            },
            {
                "Region Name": "Galicia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Galle (District of Sri Lanka)": [
            {
                "Region Name": "Galle (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galle (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galle (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galle (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galle (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galle (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galle (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galle (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galle (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galle (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galle (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galle (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galle (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galle (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galle (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galle (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galle (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galle (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galle (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galle (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galle (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galle (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Galway (County of Ireland)": [
            {
                "Region Name": "Galway (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galway (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galway (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galway (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galway (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Galway (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Galway (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galway (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galway (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Galway (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Galway (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galway (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galway (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galway (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Galway (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Galway (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Galway (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Galway (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galway (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galway (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Galway (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Galway (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gambela Peoples (State of Ethiopia)": [
            {
                "Region Name": "Gambela Peoples (State of Ethiopia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Gambela Peoples (State of Ethiopia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Gambela Peoples (State of Ethiopia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Gambela Peoples (State of Ethiopia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "Gambela Peoples (State of Ethiopia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Gambela Peoples (State of Ethiopia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Gambela Peoples (State of Ethiopia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Gambela Peoples (State of Ethiopia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "Gambela Peoples (State of Ethiopia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Gambela Peoples (State of Ethiopia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "Gambela Peoples (State of Ethiopia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Gambela Peoples (State of Ethiopia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Gambela Peoples (State of Ethiopia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Gambela Peoples (State of Ethiopia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Gambela Peoples (State of Ethiopia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Gambela Peoples (State of Ethiopia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Gambela Peoples (State of Ethiopia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Gambela Peoples (State of Ethiopia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Gambela Peoples (State of Ethiopia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Gambela Peoples (State of Ethiopia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Gambela Peoples (State of Ethiopia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Gambela Peoples (State of Ethiopia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 23
            }
        ],
        "Gampaha (District of Sri Lanka)": [
            {
                "Region Name": "Gampaha (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gampaha (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gampaha (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gampaha (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gampaha (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gampaha (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gampaha (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gampaha (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gampaha (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gampaha (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gampaha (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gampaha (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gampaha (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gampaha (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gampaha (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gampaha (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gampaha (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gampaha (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gampaha (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gampaha (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gampaha (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gampaha (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gamprin (Commune of Liechtenstein)": [
            {
                "Region Name": "Gamprin (Commune of Liechtenstein)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gamprin (Commune of Liechtenstein)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gamprin (Commune of Liechtenstein)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gamprin (Commune of Liechtenstein)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gamprin (Commune of Liechtenstein)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gamprin (Commune of Liechtenstein)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gamprin (Commune of Liechtenstein)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gamprin (Commune of Liechtenstein)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gamprin (Commune of Liechtenstein)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gamprin (Commune of Liechtenstein)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gamprin (Commune of Liechtenstein)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gamprin (Commune of Liechtenstein)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gamprin (Commune of Liechtenstein)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gamprin (Commune of Liechtenstein)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gamprin (Commune of Liechtenstein)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gamprin (Commune of Liechtenstein)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gamprin (Commune of Liechtenstein)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gamprin (Commune of Liechtenstein)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gamprin (Commune of Liechtenstein)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gamprin (Commune of Liechtenstein)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gamprin (Commune of Liechtenstein)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gamprin (Commune of Liechtenstein)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gangwon-do (Province of South Korea)": [
            {
                "Region Name": "Gangwon-do (Province of South Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gangwon-do (Province of South Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Gangwon-do (Province of South Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gangwon-do (Province of South Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Gangwon-do (Province of South Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gangwon-do (Province of South Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Gangwon-do (Province of South Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gangwon-do (Province of South Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gangwon-do (Province of South Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gangwon-do (Province of South Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Gangwon-do (Province of South Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gangwon-do (Province of South Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gangwon-do (Province of South Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Gangwon-do (Province of South Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gangwon-do (Province of South Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gangwon-do (Province of South Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gangwon-do (Province of South Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gangwon-do (Province of South Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gangwon-do (Province of South Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gangwon-do (Province of South Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gangwon-do (Province of South Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Gangwon-do (Province of South Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ganja-Qazakh (Region of Azerbaijan)": [
            {
                "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ganja-Qazakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Gansu (Province of China)": [
            {
                "Region Name": "Gansu (Province of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Gansu (Province of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Gansu (Province of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gansu (Province of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gansu (Province of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Gansu (Province of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Gansu (Province of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gansu (Province of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Gansu (Province of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gansu (Province of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gansu (Province of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gansu (Province of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gansu (Province of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gansu (Province of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gansu (Province of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gansu (Province of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gansu (Province of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gansu (Province of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gansu (Province of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gansu (Province of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gansu (Province of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gansu (Province of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Gao (Region of Mali)": [
            {
                "Region Name": "Gao (Region of Mali)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "Gao (Region of Mali)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Gao (Region of Mali)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Gao (Region of Mali)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 61
            },
            {
                "Region Name": "Gao (Region of Mali)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Gao (Region of Mali)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Gao (Region of Mali)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Gao (Region of Mali)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Gao (Region of Mali)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Gao (Region of Mali)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "Gao (Region of Mali)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Gao (Region of Mali)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Gao (Region of Mali)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Gao (Region of Mali)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Gao (Region of Mali)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gao (Region of Mali)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 74
            },
            {
                "Region Name": "Gao (Region of Mali)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Gao (Region of Mali)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 59
            },
            {
                "Region Name": "Gao (Region of Mali)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 101
            },
            {
                "Region Name": "Gao (Region of Mali)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 88
            },
            {
                "Region Name": "Gao (Region of Mali)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 120
            },
            {
                "Region Name": "Gao (Region of Mali)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 150
            }
        ],
        "Garff (Parish District of Isle of Man)": [
            {
                "Region Name": "Garff (Parish District of Isle of Man)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Garff (Parish District of Isle of Man)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Garff (Parish District of Isle of Man)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Garff (Parish District of Isle of Man)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Garff (Parish District of Isle of Man)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Garff (Parish District of Isle of Man)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Garff (Parish District of Isle of Man)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Garff (Parish District of Isle of Man)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Garff (Parish District of Isle of Man)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Garff (Parish District of Isle of Man)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Garff (Parish District of Isle of Man)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Garff (Parish District of Isle of Man)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Garff (Parish District of Isle of Man)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Garff (Parish District of Isle of Man)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Garff (Parish District of Isle of Man)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Garff (Parish District of Isle of Man)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Garff (Parish District of Isle of Man)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Garff (Parish District of Isle of Man)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Garff (Parish District of Isle of Man)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Garff (Parish District of Isle of Man)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Garff (Parish District of Isle of Man)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Garff (Parish District of Isle of Man)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Garissa (County of Kenya)": [
            {
                "Region Name": "Garissa (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Garissa (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Garissa (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Garissa (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Garissa (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Garissa (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Garissa (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Garissa (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Garissa (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Garissa (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Garissa (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Garissa (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Garissa (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Garissa (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Garissa (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Garissa (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Garissa (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Garissa (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Garissa (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Garissa (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Garissa (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Garissa (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Gasa (District of Bhutan)": [
            {
                "Region Name": "Gasa (District of Bhutan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gasa (District of Bhutan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gasa (District of Bhutan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gasa (District of Bhutan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gasa (District of Bhutan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gasa (District of Bhutan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gasa (District of Bhutan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gasa (District of Bhutan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gasa (District of Bhutan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gasa (District of Bhutan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gasa (District of Bhutan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gasa (District of Bhutan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gasa (District of Bhutan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gasa (District of Bhutan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gasa (District of Bhutan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gasa (District of Bhutan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gasa (District of Bhutan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gasa (District of Bhutan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gasa (District of Bhutan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gasa (District of Bhutan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gasa (District of Bhutan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gasa (District of Bhutan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gash Barka (Region of Eritrea)": [
            {
                "Region Name": "Gash Barka (Region of Eritrea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Gash Barka (Region of Eritrea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Gash Barka (Region of Eritrea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 76
            },
            {
                "Region Name": "Gash Barka (Region of Eritrea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Gash Barka (Region of Eritrea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Gash Barka (Region of Eritrea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Gash Barka (Region of Eritrea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Gash Barka (Region of Eritrea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Gash Barka (Region of Eritrea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Gash Barka (Region of Eritrea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gash Barka (Region of Eritrea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Gash Barka (Region of Eritrea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Gash Barka (Region of Eritrea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Gash Barka (Region of Eritrea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Gash Barka (Region of Eritrea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Gash Barka (Region of Eritrea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Gash Barka (Region of Eritrea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Gash Barka (Region of Eritrea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Gash Barka (Region of Eritrea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Gash Barka (Region of Eritrea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Gash Barka (Region of Eritrea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Gash Barka (Region of Eritrea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Gauteng (Province of South Africa)": [
            {
                "Region Name": "Gauteng (Province of South Africa)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gauteng (Province of South Africa)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gauteng (Province of South Africa)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gauteng (Province of South Africa)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Gauteng (Province of South Africa)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Gauteng (Province of South Africa)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gauteng (Province of South Africa)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gauteng (Province of South Africa)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gauteng (Province of South Africa)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gauteng (Province of South Africa)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gauteng (Province of South Africa)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gauteng (Province of South Africa)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gauteng (Province of South Africa)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gauteng (Province of South Africa)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gauteng (Province of South Africa)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gauteng (Province of South Africa)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gauteng (Province of South Africa)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gauteng (Province of South Africa)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gauteng (Province of South Africa)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gauteng (Province of South Africa)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gauteng (Province of South Africa)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gauteng (Province of South Africa)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "G\xe4vleborg (County of Sweden)": [
            {
                "Region Name": "G\xe4vleborg (County of Sweden)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xe4vleborg (County of Sweden)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xe4vleborg (County of Sweden)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xe4vleborg (County of Sweden)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xe4vleborg (County of Sweden)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xe4vleborg (County of Sweden)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xe4vleborg (County of Sweden)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "G\xe4vleborg (County of Sweden)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xe4vleborg (County of Sweden)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xe4vleborg (County of Sweden)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xe4vleborg (County of Sweden)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xe4vleborg (County of Sweden)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xe4vleborg (County of Sweden)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xe4vleborg (County of Sweden)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xe4vleborg (County of Sweden)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xe4vleborg (County of Sweden)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xe4vleborg (County of Sweden)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "G\xe4vleborg (County of Sweden)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xe4vleborg (County of Sweden)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xe4vleborg (County of Sweden)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xe4vleborg (County of Sweden)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xe4vleborg (County of Sweden)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gaza (District of Palestine)": [
            {
                "Region Name": "Gaza (District of Palestine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaza (District of Palestine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaza (District of Palestine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaza (District of Palestine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaza (District of Palestine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaza (District of Palestine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaza (District of Palestine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaza (District of Palestine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaza (District of Palestine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaza (District of Palestine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaza (District of Palestine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaza (District of Palestine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaza (District of Palestine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaza (District of Palestine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaza (District of Palestine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaza (District of Palestine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaza (District of Palestine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaza (District of Palestine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaza (District of Palestine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaza (District of Palestine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaza (District of Palestine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gaza (District of Palestine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gaza (Province of Mozambique)": [
            {
                "Region Name": "Gaza (Province of Mozambique)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Gaza (Province of Mozambique)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Gaza (Province of Mozambique)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Gaza (Province of Mozambique)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Gaza (Province of Mozambique)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Gaza (Province of Mozambique)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Gaza (Province of Mozambique)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Gaza (Province of Mozambique)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Gaza (Province of Mozambique)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Gaza (Province of Mozambique)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Gaza (Province of Mozambique)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Gaza (Province of Mozambique)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Gaza (Province of Mozambique)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Gaza (Province of Mozambique)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Gaza (Province of Mozambique)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Gaza (Province of Mozambique)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Gaza (Province of Mozambique)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Gaza (Province of Mozambique)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Gaza (Province of Mozambique)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gaza (Province of Mozambique)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Gaza (Province of Mozambique)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Gaza (Province of Mozambique)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 19
            }
        ],
        "Gazi Baba (Municipality of North Macedonia)": [
            {
                "Region Name": "Gazi Baba (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazi Baba (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazi Baba (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gazi Baba (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazi Baba (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazi Baba (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazi Baba (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazi Baba (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazi Baba (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazi Baba (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazi Baba (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazi Baba (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazi Baba (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazi Baba (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazi Baba (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazi Baba (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazi Baba (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazi Baba (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazi Baba (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazi Baba (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazi Baba (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazi Baba (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gaziantep (Province of Turkey)": [
            {
                "Region Name": "Gaziantep (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gaziantep (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gaziantep (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gaziantep (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gaziantep (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gaziantep (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gaziantep (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gaziantep (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gaziantep (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gaziantep (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gaziantep (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gaziantep (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gaziantep (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gaziantep (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gaziantep (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gaziantep (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gaziantep (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gaziantep (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gaziantep (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gaziantep (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gaziantep (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gaziantep (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Gazima\u011Fusa (District of Northern Cyprus)": [
            {
                "Region Name": "Gazima\u011Fusa (District of Northern Cyprus)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazima\u011Fusa (District of Northern Cyprus)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gazima\u011Fusa (District of Northern Cyprus)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazima\u011Fusa (District of Northern Cyprus)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Gazima\u011Fusa (District of Northern Cyprus)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazima\u011Fusa (District of Northern Cyprus)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazima\u011Fusa (District of Northern Cyprus)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazima\u011Fusa (District of Northern Cyprus)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazima\u011Fusa (District of Northern Cyprus)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gazima\u011Fusa (District of Northern Cyprus)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gazima\u011Fusa (District of Northern Cyprus)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gazima\u011Fusa (District of Northern Cyprus)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazima\u011Fusa (District of Northern Cyprus)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazima\u011Fusa (District of Northern Cyprus)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazima\u011Fusa (District of Northern Cyprus)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazima\u011Fusa (District of Northern Cyprus)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazima\u011Fusa (District of Northern Cyprus)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazima\u011Fusa (District of Northern Cyprus)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazima\u011Fusa (District of Northern Cyprus)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazima\u011Fusa (District of Northern Cyprus)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazima\u011Fusa (District of Northern Cyprus)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gazima\u011Fusa (District of Northern Cyprus)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gbapolu (County of Liberia)": [
            {
                "Region Name": "Gbapolu (County of Liberia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gbapolu (County of Liberia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gbapolu (County of Liberia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gbapolu (County of Liberia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gbapolu (County of Liberia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gbapolu (County of Liberia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gbapolu (County of Liberia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gbapolu (County of Liberia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gbapolu (County of Liberia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gbapolu (County of Liberia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gbapolu (County of Liberia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gbapolu (County of Liberia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gbapolu (County of Liberia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gbapolu (County of Liberia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gbapolu (County of Liberia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gbapolu (County of Liberia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gbapolu (County of Liberia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gbapolu (County of Liberia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gbapolu (County of Liberia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gbapolu (County of Liberia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gbapolu (County of Liberia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gbapolu (County of Liberia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Gedo (Region of Somalia)": [
            {
                "Region Name": "Gedo (Region of Somalia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gedo (Region of Somalia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Gedo (Region of Somalia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gedo (Region of Somalia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gedo (Region of Somalia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gedo (Region of Somalia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Gedo (Region of Somalia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gedo (Region of Somalia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gedo (Region of Somalia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gedo (Region of Somalia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Gedo (Region of Somalia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gedo (Region of Somalia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gedo (Region of Somalia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gedo (Region of Somalia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gedo (Region of Somalia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gedo (Region of Somalia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gedo (Region of Somalia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gedo (Region of Somalia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gedo (Region of Somalia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gedo (Region of Somalia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gedo (Region of Somalia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gedo (Region of Somalia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Gegharkunik (Province of Armenia)": [
            {
                "Region Name": "Gegharkunik (Province of Armenia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gegharkunik (Province of Armenia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gegharkunik (Province of Armenia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gegharkunik (Province of Armenia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Gegharkunik (Province of Armenia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gegharkunik (Province of Armenia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gegharkunik (Province of Armenia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gegharkunik (Province of Armenia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gegharkunik (Province of Armenia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Gegharkunik (Province of Armenia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gegharkunik (Province of Armenia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gegharkunik (Province of Armenia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gegharkunik (Province of Armenia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gegharkunik (Province of Armenia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gegharkunik (Province of Armenia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gegharkunik (Province of Armenia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gegharkunik (Province of Armenia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gegharkunik (Province of Armenia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gegharkunik (Province of Armenia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gegharkunik (Province of Armenia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gegharkunik (Province of Armenia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Gegharkunik (Province of Armenia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Geita (Region of Tanzania)": [
            {
                "Region Name": "Geita (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Geita (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Geita (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Geita (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Geita (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Geita (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Geita (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Geita (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Geita (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Geita (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Geita (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Geita (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Geita (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Geita (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Geita (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Geita (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Geita (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Geita (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Geita (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Geita (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Geita (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Geita (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Gelderland (Province of Netherlands)": [
            {
                "Region Name": "Gelderland (Province of Netherlands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gelderland (Province of Netherlands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gelderland (Province of Netherlands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gelderland (Province of Netherlands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gelderland (Province of Netherlands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gelderland (Province of Netherlands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gelderland (Province of Netherlands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gelderland (Province of Netherlands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gelderland (Province of Netherlands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gelderland (Province of Netherlands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gelderland (Province of Netherlands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gelderland (Province of Netherlands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gelderland (Province of Netherlands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gelderland (Province of Netherlands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gelderland (Province of Netherlands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gelderland (Province of Netherlands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gelderland (Province of Netherlands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gelderland (Province of Netherlands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gelderland (Province of Netherlands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gelderland (Province of Netherlands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gelderland (Province of Netherlands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gelderland (Province of Netherlands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gen\xe8ve (Canton of Switzerland)": [
            {
                "Region Name": "Gen\xe8ve (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gen\xe8ve (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gen\xe8ve (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gen\xe8ve (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gen\xe8ve (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gen\xe8ve (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gen\xe8ve (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gen\xe8ve (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gen\xe8ve (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gen\xe8ve (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gen\xe8ve (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gen\xe8ve (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gen\xe8ve (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gen\xe8ve (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gen\xe8ve (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gen\xe8ve (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gen\xe8ve (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gen\xe8ve (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gen\xe8ve (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gen\xe8ve (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gen\xe8ve (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gen\xe8ve (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "George Hill (District of Anguilla)": [
            {
                "Region Name": "George Hill (District of Anguilla)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Hill (District of Anguilla)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Hill (District of Anguilla)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Hill (District of Anguilla)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Hill (District of Anguilla)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Hill (District of Anguilla)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Hill (District of Anguilla)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Hill (District of Anguilla)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Hill (District of Anguilla)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Hill (District of Anguilla)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Hill (District of Anguilla)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Hill (District of Anguilla)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Hill (District of Anguilla)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Hill (District of Anguilla)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Hill (District of Anguilla)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Hill (District of Anguilla)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Hill (District of Anguilla)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Hill (District of Anguilla)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Hill (District of Anguilla)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Hill (District of Anguilla)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Hill (District of Anguilla)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Hill (District of Anguilla)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "George Town (District of Cayman Islands)": [
            {
                "Region Name": "George Town (District of Cayman Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Town (District of Cayman Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Town (District of Cayman Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Town (District of Cayman Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Town (District of Cayman Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Town (District of Cayman Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Town (District of Cayman Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Town (District of Cayman Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Town (District of Cayman Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Town (District of Cayman Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Town (District of Cayman Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Town (District of Cayman Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Town (District of Cayman Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Town (District of Cayman Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Town (District of Cayman Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Town (District of Cayman Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Town (District of Cayman Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Town (District of Cayman Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Town (District of Cayman Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Town (District of Cayman Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Town (District of Cayman Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "George Town (District of Cayman Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Georgia (State of United States)": [
            {
                "Region Name": "Georgia (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Georgia (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Georgia (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Georgia (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Georgia (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Georgia (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Georgia (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Georgia (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Georgia (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Georgia (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Georgia (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Georgia (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Georgia (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Georgia (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Georgia (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Georgia (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Georgia (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Georgia (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Georgia (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Georgia (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Georgia (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Georgia (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "German (Parish District of Isle of Man)": [
            {
                "Region Name": "German (Parish District of Isle of Man)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "German (Parish District of Isle of Man)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "German (Parish District of Isle of Man)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "German (Parish District of Isle of Man)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "German (Parish District of Isle of Man)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "German (Parish District of Isle of Man)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "German (Parish District of Isle of Man)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "German (Parish District of Isle of Man)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "German (Parish District of Isle of Man)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "German (Parish District of Isle of Man)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "German (Parish District of Isle of Man)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "German (Parish District of Isle of Man)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "German (Parish District of Isle of Man)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "German (Parish District of Isle of Man)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "German (Parish District of Isle of Man)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "German (Parish District of Isle of Man)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "German (Parish District of Isle of Man)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "German (Parish District of Isle of Man)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "German (Parish District of Isle of Man)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "German (Parish District of Isle of Man)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "German (Parish District of Isle of Man)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "German (Parish District of Isle of Man)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gevgelija (Municipality of North Macedonia)": [
            {
                "Region Name": "Gevgelija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gevgelija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gevgelija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gevgelija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gevgelija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gevgelija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gevgelija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gevgelija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gevgelija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gevgelija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gevgelija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gevgelija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gevgelija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gevgelija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gevgelija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gevgelija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gevgelija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gevgelija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gevgelija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gevgelija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gevgelija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gevgelija (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Ghanzi (District of Botswana)": [
            {
                "Region Name": "Ghanzi (District of Botswana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 378
            },
            {
                "Region Name": "Ghanzi (District of Botswana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Ghanzi (District of Botswana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 146
            },
            {
                "Region Name": "Ghanzi (District of Botswana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 460
            },
            {
                "Region Name": "Ghanzi (District of Botswana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 144
            },
            {
                "Region Name": "Ghanzi (District of Botswana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 116
            },
            {
                "Region Name": "Ghanzi (District of Botswana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 420
            },
            {
                "Region Name": "Ghanzi (District of Botswana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 74
            },
            {
                "Region Name": "Ghanzi (District of Botswana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1333
            },
            {
                "Region Name": "Ghanzi (District of Botswana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 572
            },
            {
                "Region Name": "Ghanzi (District of Botswana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 230
            },
            {
                "Region Name": "Ghanzi (District of Botswana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 473
            },
            {
                "Region Name": "Ghanzi (District of Botswana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 95
            },
            {
                "Region Name": "Ghanzi (District of Botswana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 246
            },
            {
                "Region Name": "Ghanzi (District of Botswana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 212
            },
            {
                "Region Name": "Ghanzi (District of Botswana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 452
            },
            {
                "Region Name": "Ghanzi (District of Botswana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 77
            },
            {
                "Region Name": "Ghanzi (District of Botswana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 145
            },
            {
                "Region Name": "Ghanzi (District of Botswana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 164
            },
            {
                "Region Name": "Ghanzi (District of Botswana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 385
            },
            {
                "Region Name": "Ghanzi (District of Botswana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 587
            },
            {
                "Region Name": "Ghanzi (District of Botswana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 401
            }
        ],
        "Gharb - Chrarda - B\xe9ni Hssen (Region of Morocco)": [
            {
                "Region Name": "Gharb - Chrarda - B\xe9ni Hssen (Region of Morocco)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharb - Chrarda - B\xe9ni Hssen (Region of Morocco)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharb - Chrarda - B\xe9ni Hssen (Region of Morocco)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gharb - Chrarda - B\xe9ni Hssen (Region of Morocco)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gharb - Chrarda - B\xe9ni Hssen (Region of Morocco)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharb - Chrarda - B\xe9ni Hssen (Region of Morocco)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharb - Chrarda - B\xe9ni Hssen (Region of Morocco)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gharb - Chrarda - B\xe9ni Hssen (Region of Morocco)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharb - Chrarda - B\xe9ni Hssen (Region of Morocco)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Gharb - Chrarda - B\xe9ni Hssen (Region of Morocco)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gharb - Chrarda - B\xe9ni Hssen (Region of Morocco)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gharb - Chrarda - B\xe9ni Hssen (Region of Morocco)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharb - Chrarda - B\xe9ni Hssen (Region of Morocco)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gharb - Chrarda - B\xe9ni Hssen (Region of Morocco)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Gharb - Chrarda - B\xe9ni Hssen (Region of Morocco)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gharb - Chrarda - B\xe9ni Hssen (Region of Morocco)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharb - Chrarda - B\xe9ni Hssen (Region of Morocco)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharb - Chrarda - B\xe9ni Hssen (Region of Morocco)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gharb - Chrarda - B\xe9ni Hssen (Region of Morocco)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharb - Chrarda - B\xe9ni Hssen (Region of Morocco)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gharb - Chrarda - B\xe9ni Hssen (Region of Morocco)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gharb - Chrarda - B\xe9ni Hssen (Region of Morocco)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gharda\xefa (Province of Algeria)": [
            {
                "Region Name": "Gharda\xefa (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharda\xefa (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharda\xefa (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharda\xefa (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharda\xefa (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharda\xefa (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharda\xefa (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharda\xefa (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharda\xefa (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharda\xefa (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharda\xefa (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharda\xefa (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharda\xefa (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharda\xefa (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharda\xefa (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharda\xefa (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharda\xefa (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharda\xefa (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharda\xefa (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharda\xefa (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharda\xefa (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gharda\xefa (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Ghat (District of Libya)": [
            {
                "Region Name": "Ghat (District of Libya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ghat (District of Libya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghat (District of Libya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghat (District of Libya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghat (District of Libya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghat (District of Libya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghat (District of Libya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghat (District of Libya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghat (District of Libya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghat (District of Libya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghat (District of Libya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghat (District of Libya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghat (District of Libya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghat (District of Libya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghat (District of Libya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghat (District of Libya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghat (District of Libya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghat (District of Libya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghat (District of Libya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghat (District of Libya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghat (District of Libya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghat (District of Libya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "G\u0127awdex (Region of Malta)": [
            {
                "Region Name": "G\u0127awdex (Region of Malta)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\u0127awdex (Region of Malta)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\u0127awdex (Region of Malta)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\u0127awdex (Region of Malta)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\u0127awdex (Region of Malta)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\u0127awdex (Region of Malta)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\u0127awdex (Region of Malta)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\u0127awdex (Region of Malta)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\u0127awdex (Region of Malta)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\u0127awdex (Region of Malta)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\u0127awdex (Region of Malta)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\u0127awdex (Region of Malta)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\u0127awdex (Region of Malta)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\u0127awdex (Region of Malta)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\u0127awdex (Region of Malta)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\u0127awdex (Region of Malta)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\u0127awdex (Region of Malta)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\u0127awdex (Region of Malta)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\u0127awdex (Region of Malta)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\u0127awdex (Region of Malta)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\u0127awdex (Region of Malta)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\u0127awdex (Region of Malta)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ghazni (Province of Afghanistan)": [
            {
                "Region Name": "Ghazni (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghazni (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghazni (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghazni (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghazni (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghazni (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghazni (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghazni (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghazni (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ghazni (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghazni (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghazni (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ghazni (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghazni (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghazni (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghazni (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghazni (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghazni (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghazni (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghazni (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghazni (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghazni (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ghor (Province of Afghanistan)": [
            {
                "Region Name": "Ghor (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghor (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghor (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghor (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghor (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghor (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghor (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghor (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghor (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghor (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghor (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghor (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghor (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghor (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghor (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghor (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghor (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghor (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghor (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghor (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghor (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ghor (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gia Lai (Province of Vietnam)": [
            {
                "Region Name": "Gia Lai (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gia Lai (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gia Lai (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gia Lai (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gia Lai (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gia Lai (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gia Lai (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gia Lai (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gia Lai (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gia Lai (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gia Lai (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gia Lai (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gia Lai (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gia Lai (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gia Lai (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gia Lai (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gia Lai (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gia Lai (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gia Lai (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gia Lai (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gia Lai (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gia Lai (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Gifu (Prefecture of Japan)": [
            {
                "Region Name": "Gifu (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gifu (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gifu (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gifu (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gifu (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gifu (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gifu (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gifu (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gifu (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gifu (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gifu (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gifu (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gifu (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gifu (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gifu (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gifu (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gifu (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gifu (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gifu (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gifu (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gifu (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gifu (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gilan (Province of Iran)": [
            {
                "Region Name": "Gilan (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gilan (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gilan (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gilan (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gilan (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gilan (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gilan (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gilan (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gilan (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gilan (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gilan (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gilan (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gilan (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gilan (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gilan (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gilan (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gilan (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gilan (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gilan (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gilan (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gilan (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gilan (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Gilgit-Baltistan (Centrally Administered Area of Pakistan)": [
            {
                "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gilgit-Baltistan (Centrally Administered Area of Pakistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Giresun (Province of Turkey)": [
            {
                "Region Name": "Giresun (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Giresun (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Giresun (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Giresun (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Giresun (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Giresun (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Giresun (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Giresun (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Giresun (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Giresun (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Giresun (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Giresun (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Giresun (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Giresun (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Giresun (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Giresun (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Giresun (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Giresun (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Giresun (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Giresun (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Giresun (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Giresun (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Girne (District of Northern Cyprus)": [
            {
                "Region Name": "Girne (District of Northern Cyprus)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Girne (District of Northern Cyprus)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Girne (District of Northern Cyprus)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Girne (District of Northern Cyprus)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Girne (District of Northern Cyprus)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Girne (District of Northern Cyprus)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Girne (District of Northern Cyprus)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Girne (District of Northern Cyprus)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Girne (District of Northern Cyprus)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Girne (District of Northern Cyprus)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Girne (District of Northern Cyprus)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Girne (District of Northern Cyprus)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Girne (District of Northern Cyprus)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Girne (District of Northern Cyprus)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Girne (District of Northern Cyprus)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Girne (District of Northern Cyprus)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Girne (District of Northern Cyprus)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Girne (District of Northern Cyprus)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Girne (District of Northern Cyprus)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Girne (District of Northern Cyprus)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Girne (District of Northern Cyprus)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Girne (District of Northern Cyprus)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gisborne (Region of New Zealand)": [
            {
                "Region Name": "Gisborne (Region of New Zealand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gisborne (Region of New Zealand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gisborne (Region of New Zealand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gisborne (Region of New Zealand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gisborne (Region of New Zealand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gisborne (Region of New Zealand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gisborne (Region of New Zealand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gisborne (Region of New Zealand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gisborne (Region of New Zealand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gisborne (Region of New Zealand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gisborne (Region of New Zealand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gisborne (Region of New Zealand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gisborne (Region of New Zealand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gisborne (Region of New Zealand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gisborne (Region of New Zealand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gisborne (Region of New Zealand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gisborne (Region of New Zealand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gisborne (Region of New Zealand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gisborne (Region of New Zealand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gisborne (Region of New Zealand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gisborne (Region of New Zealand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gisborne (Region of New Zealand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gitega (Province of Burundi)": [
            {
                "Region Name": "Gitega (Province of Burundi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gitega (Province of Burundi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gitega (Province of Burundi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gitega (Province of Burundi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gitega (Province of Burundi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gitega (Province of Burundi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gitega (Province of Burundi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gitega (Province of Burundi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gitega (Province of Burundi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gitega (Province of Burundi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gitega (Province of Burundi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gitega (Province of Burundi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gitega (Province of Burundi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gitega (Province of Burundi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gitega (Province of Burundi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gitega (Province of Burundi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gitega (Province of Burundi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gitega (Province of Burundi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gitega (Province of Burundi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gitega (Province of Burundi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gitega (Province of Burundi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gitega (Province of Burundi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Giurgiu (County of Romania)": [
            {
                "Region Name": "Giurgiu (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Giurgiu (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Giurgiu (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Giurgiu (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Giurgiu (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Giurgiu (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Giurgiu (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Giurgiu (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Giurgiu (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Giurgiu (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Giurgiu (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Giurgiu (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Giurgiu (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Giurgiu (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Giurgiu (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Giurgiu (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Giurgiu (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Giurgiu (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Giurgiu (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Giurgiu (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Giurgiu (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Giurgiu (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Gjirokast\xebr (County of Albania)": [
            {
                "Region Name": "Gjirokast\xebr (County of Albania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjirokast\xebr (County of Albania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Gjirokast\xebr (County of Albania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gjirokast\xebr (County of Albania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gjirokast\xebr (County of Albania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjirokast\xebr (County of Albania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Gjirokast\xebr (County of Albania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gjirokast\xebr (County of Albania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gjirokast\xebr (County of Albania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Gjirokast\xebr (County of Albania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gjirokast\xebr (County of Albania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gjirokast\xebr (County of Albania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gjirokast\xebr (County of Albania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjirokast\xebr (County of Albania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjirokast\xebr (County of Albania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjirokast\xebr (County of Albania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gjirokast\xebr (County of Albania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjirokast\xebr (County of Albania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gjirokast\xebr (County of Albania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjirokast\xebr (County of Albania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Gjirokast\xebr (County of Albania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Gjirokast\xebr (County of Albania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gjor\u010De Petrov (Municipality of North Macedonia)": [
            {
                "Region Name": "Gjor\u010De Petrov (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjor\u010De Petrov (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjor\u010De Petrov (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjor\u010De Petrov (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjor\u010De Petrov (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjor\u010De Petrov (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjor\u010De Petrov (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gjor\u010De Petrov (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjor\u010De Petrov (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjor\u010De Petrov (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjor\u010De Petrov (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gjor\u010De Petrov (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjor\u010De Petrov (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjor\u010De Petrov (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjor\u010De Petrov (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjor\u010De Petrov (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjor\u010De Petrov (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjor\u010De Petrov (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjor\u010De Petrov (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjor\u010De Petrov (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjor\u010De Petrov (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gjor\u010De Petrov (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Glacis (District of Seychelles)": [
            {
                "Region Name": "Glacis (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glacis (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glacis (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glacis (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glacis (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glacis (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glacis (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glacis (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glacis (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glacis (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glacis (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glacis (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glacis (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glacis (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glacis (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glacis (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glacis (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glacis (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glacis (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glacis (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glacis (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glacis (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Glarus (Canton of Switzerland)": [
            {
                "Region Name": "Glarus (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glarus (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glarus (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glarus (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glarus (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glarus (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glarus (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glarus (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glarus (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glarus (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glarus (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glarus (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glarus (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glarus (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glarus (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glarus (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Glarus (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glarus (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glarus (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glarus (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glarus (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glarus (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Glodeni (District of Moldova)": [
            {
                "Region Name": "Glodeni (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Glodeni (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glodeni (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glodeni (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Glodeni (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glodeni (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glodeni (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Glodeni (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Glodeni (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Glodeni (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glodeni (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glodeni (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glodeni (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Glodeni (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Glodeni (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Glodeni (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glodeni (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glodeni (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glodeni (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glodeni (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glodeni (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Glodeni (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Gnjilane (District of Kosovo)": [
            {
                "Region Name": "Gnjilane (District of Kosovo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gnjilane (District of Kosovo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gnjilane (District of Kosovo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gnjilane (District of Kosovo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gnjilane (District of Kosovo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gnjilane (District of Kosovo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gnjilane (District of Kosovo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gnjilane (District of Kosovo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gnjilane (District of Kosovo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gnjilane (District of Kosovo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gnjilane (District of Kosovo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gnjilane (District of Kosovo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gnjilane (District of Kosovo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gnjilane (District of Kosovo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gnjilane (District of Kosovo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gnjilane (District of Kosovo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gnjilane (District of Kosovo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gnjilane (District of Kosovo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gnjilane (District of Kosovo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gnjilane (District of Kosovo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gnjilane (District of Kosovo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gnjilane (District of Kosovo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Goa (State of India)": [
            {
                "Region Name": "Goa (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Goa (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Goa (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Goa (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Goa (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Goa (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Goa (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Goa (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Goa (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Goa (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Goa (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Goa (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Goa (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Goa (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Goa (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Goa (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Goa (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Goa (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Goa (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Goa (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Goa (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Goa (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "G\xf4h-Djiboua (District of C\xf4te d'Ivoire)": [
            {
                "Region Name": "G\xf4h-Djiboua (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "G\xf4h-Djiboua (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "G\xf4h-Djiboua (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "G\xf4h-Djiboua (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "G\xf4h-Djiboua (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "G\xf4h-Djiboua (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "G\xf4h-Djiboua (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "G\xf4h-Djiboua (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "G\xf4h-Djiboua (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "G\xf4h-Djiboua (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "G\xf4h-Djiboua (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "G\xf4h-Djiboua (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "G\xf4h-Djiboua (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "G\xf4h-Djiboua (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "G\xf4h-Djiboua (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "G\xf4h-Djiboua (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "G\xf4h-Djiboua (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "G\xf4h-Djiboua (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "G\xf4h-Djiboua (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "G\xf4h-Djiboua (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "G\xf4h-Djiboua (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "G\xf4h-Djiboua (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Goi\xe1s (State of Brazil)": [
            {
                "Region Name": "Goi\xe1s (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Goi\xe1s (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Goi\xe1s (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Goi\xe1s (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Goi\xe1s (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Goi\xe1s (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Goi\xe1s (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Goi\xe1s (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Goi\xe1s (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Goi\xe1s (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Goi\xe1s (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Goi\xe1s (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Goi\xe1s (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Goi\xe1s (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Goi\xe1s (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Goi\xe1s (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Goi\xe1s (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Goi\xe1s (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Goi\xe1s (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Goi\xe1s (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Goi\xe1s (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Goi\xe1s (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Golan (District of Israel)": [
            {
                "Region Name": "Golan (District of Israel)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Golan (District of Israel)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Golan (District of Israel)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Golan (District of Israel)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Golan (District of Israel)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Golan (District of Israel)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Golan (District of Israel)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Golan (District of Israel)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Golan (District of Israel)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Golan (District of Israel)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Golan (District of Israel)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Golan (District of Israel)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Golan (District of Israel)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Golan (District of Israel)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Golan (District of Israel)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Golan (District of Israel)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Golan (District of Israel)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Golan (District of Israel)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Golan (District of Israel)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Golan (District of Israel)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Golan (District of Israel)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Golan (District of Israel)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Golestan (Province of Iran)": [
            {
                "Region Name": "Golestan (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Golestan (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Golestan (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Golestan (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Golestan (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Golestan (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Golestan (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Golestan (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Golestan (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Golestan (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Golestan (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Golestan (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Golestan (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Golestan (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Golestan (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Golestan (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Golestan (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Golestan (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Golestan (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Golestan (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Golestan (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Golestan (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Gombe (State of Nigeria)": [
            {
                "Region Name": "Gombe (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Gombe (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Gombe (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Gombe (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Gombe (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Gombe (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Gombe (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Gombe (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Gombe (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Gombe (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Gombe (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Gombe (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Gombe (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Gombe (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Gombe (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gombe (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Gombe (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gombe (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Gombe (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Gombe (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Gombe (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Gombe (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Gomel (Region of Belarus)": [
            {
                "Region Name": "Gomel (Region of Belarus)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gomel (Region of Belarus)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Gomel (Region of Belarus)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gomel (Region of Belarus)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gomel (Region of Belarus)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gomel (Region of Belarus)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gomel (Region of Belarus)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gomel (Region of Belarus)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gomel (Region of Belarus)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gomel (Region of Belarus)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gomel (Region of Belarus)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Gomel (Region of Belarus)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gomel (Region of Belarus)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gomel (Region of Belarus)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gomel (Region of Belarus)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gomel (Region of Belarus)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gomel (Region of Belarus)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gomel (Region of Belarus)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gomel (Region of Belarus)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Gomel (Region of Belarus)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gomel (Region of Belarus)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gomel (Region of Belarus)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Gorenjska (Statistical Region of Slovenia)": [
            {
                "Region Name": "Gorenjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorenjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorenjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorenjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorenjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorenjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorenjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorenjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gorenjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorenjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorenjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gorenjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorenjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gorenjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorenjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gorenjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorenjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorenjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorenjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorenjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorenjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorenjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gorgol (Region of Mauritania)": [
            {
                "Region Name": "Gorgol (Region of Mauritania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Gorgol (Region of Mauritania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gorgol (Region of Mauritania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gorgol (Region of Mauritania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Gorgol (Region of Mauritania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Gorgol (Region of Mauritania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 111
            },
            {
                "Region Name": "Gorgol (Region of Mauritania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gorgol (Region of Mauritania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Gorgol (Region of Mauritania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Gorgol (Region of Mauritania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Gorgol (Region of Mauritania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Gorgol (Region of Mauritania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Gorgol (Region of Mauritania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gorgol (Region of Mauritania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gorgol (Region of Mauritania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "Gorgol (Region of Mauritania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gorgol (Region of Mauritania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gorgol (Region of Mauritania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Gorgol (Region of Mauritania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Gorgol (Region of Mauritania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Gorgol (Region of Mauritania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 138
            },
            {
                "Region Name": "Gorgol (Region of Mauritania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 16
            }
        ],
        "Gori\u0161ka (Statistical Region of Slovenia)": [
            {
                "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Gori\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gorj (County of Romania)": [
            {
                "Region Name": "Gorj (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorj (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorj (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorj (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorj (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gorj (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gorj (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorj (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gorj (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gorj (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gorj (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gorj (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorj (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorj (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorj (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gorj (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gorj (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorj (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gorj (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gorj (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gorj (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gorj (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Gorno-Altay (Republic of Russia)": [
            {
                "Region Name": "Gorno-Altay (Republic of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gorno-Altay (Republic of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gorno-Altay (Republic of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gorno-Altay (Republic of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gorno-Altay (Republic of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gorno-Altay (Republic of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Gorno-Altay (Republic of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gorno-Altay (Republic of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gorno-Altay (Republic of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gorno-Altay (Republic of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Gorno-Altay (Republic of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gorno-Altay (Republic of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gorno-Altay (Republic of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Gorno-Altay (Republic of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gorno-Altay (Republic of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gorno-Altay (Republic of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gorno-Altay (Republic of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gorno-Altay (Republic of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gorno-Altay (Republic of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gorno-Altay (Republic of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gorno-Altay (Republic of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gorno-Altay (Republic of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Gorno-Badakhshan (Autonomous Region of Tajikistan)": [
            {
                "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorno-Badakhshan (Autonomous Region of Tajikistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gorontalo (Province of Indonesia)": [
            {
                "Region Name": "Gorontalo (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gorontalo (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gorontalo (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gorontalo (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gorontalo (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gorontalo (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gorontalo (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorontalo (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gorontalo (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorontalo (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorontalo (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gorontalo (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorontalo (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gorontalo (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gorontalo (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorontalo (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorontalo (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gorontalo (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gorontalo (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorontalo (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorontalo (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gorontalo (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gostivar (Municipality of North Macedonia)": [
            {
                "Region Name": "Gostivar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gostivar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gostivar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gostivar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gostivar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gostivar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gostivar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gostivar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gostivar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gostivar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gostivar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gostivar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gostivar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gostivar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gostivar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gostivar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gostivar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gostivar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gostivar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gostivar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gostivar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gostivar (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gotland (County of Sweden)": [
            {
                "Region Name": "Gotland (County of Sweden)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gotland (County of Sweden)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gotland (County of Sweden)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gotland (County of Sweden)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gotland (County of Sweden)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gotland (County of Sweden)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gotland (County of Sweden)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gotland (County of Sweden)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gotland (County of Sweden)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gotland (County of Sweden)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gotland (County of Sweden)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gotland (County of Sweden)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gotland (County of Sweden)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gotland (County of Sweden)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gotland (County of Sweden)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gotland (County of Sweden)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gotland (County of Sweden)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gotland (County of Sweden)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gotland (County of Sweden)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gotland (County of Sweden)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gotland (County of Sweden)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gotland (County of Sweden)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Govi-Altay (Province of Mongolia)": [
            {
                "Region Name": "Govi-Altay (Province of Mongolia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Govi-Altay (Province of Mongolia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govi-Altay (Province of Mongolia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govi-Altay (Province of Mongolia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govi-Altay (Province of Mongolia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govi-Altay (Province of Mongolia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govi-Altay (Province of Mongolia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govi-Altay (Province of Mongolia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govi-Altay (Province of Mongolia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govi-Altay (Province of Mongolia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govi-Altay (Province of Mongolia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govi-Altay (Province of Mongolia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govi-Altay (Province of Mongolia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govi-Altay (Province of Mongolia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govi-Altay (Province of Mongolia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govi-Altay (Province of Mongolia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govi-Altay (Province of Mongolia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govi-Altay (Province of Mongolia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govi-Altay (Province of Mongolia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govi-Altay (Province of Mongolia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govi-Altay (Province of Mongolia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govi-Altay (Province of Mongolia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Govis\xfcmber (Municipality of Mongolia)": [
            {
                "Region Name": "Govis\xfcmber (Municipality of Mongolia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govis\xfcmber (Municipality of Mongolia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govis\xfcmber (Municipality of Mongolia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govis\xfcmber (Municipality of Mongolia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govis\xfcmber (Municipality of Mongolia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govis\xfcmber (Municipality of Mongolia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govis\xfcmber (Municipality of Mongolia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govis\xfcmber (Municipality of Mongolia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govis\xfcmber (Municipality of Mongolia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govis\xfcmber (Municipality of Mongolia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govis\xfcmber (Municipality of Mongolia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govis\xfcmber (Municipality of Mongolia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govis\xfcmber (Municipality of Mongolia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Govis\xfcmber (Municipality of Mongolia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Govis\xfcmber (Municipality of Mongolia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govis\xfcmber (Municipality of Mongolia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govis\xfcmber (Municipality of Mongolia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govis\xfcmber (Municipality of Mongolia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govis\xfcmber (Municipality of Mongolia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govis\xfcmber (Municipality of Mongolia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govis\xfcmber (Municipality of Mongolia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Govis\xfcmber (Municipality of Mongolia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gracias a Dios (Department of Honduras)": [
            {
                "Region Name": "Gracias a Dios (Department of Honduras)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gracias a Dios (Department of Honduras)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Gracias a Dios (Department of Honduras)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Gracias a Dios (Department of Honduras)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Gracias a Dios (Department of Honduras)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Gracias a Dios (Department of Honduras)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Gracias a Dios (Department of Honduras)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gracias a Dios (Department of Honduras)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Gracias a Dios (Department of Honduras)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gracias a Dios (Department of Honduras)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gracias a Dios (Department of Honduras)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gracias a Dios (Department of Honduras)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Gracias a Dios (Department of Honduras)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Gracias a Dios (Department of Honduras)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gracias a Dios (Department of Honduras)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gracias a Dios (Department of Honduras)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gracias a Dios (Department of Honduras)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Gracias a Dios (Department of Honduras)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gracias a Dios (Department of Honduras)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Gracias a Dios (Department of Honduras)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gracias a Dios (Department of Honduras)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gracias a Dios (Department of Honduras)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Grad Beograd (City of Serbia)": [
            {
                "Region Name": "Grad Beograd (City of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grad Beograd (City of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Beograd (City of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grad Beograd (City of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grad Beograd (City of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grad Beograd (City of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grad Beograd (City of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grad Beograd (City of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Grad Beograd (City of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Beograd (City of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Grad Beograd (City of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Grad Beograd (City of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Beograd (City of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Beograd (City of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Grad Beograd (City of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Beograd (City of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Grad Beograd (City of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grad Beograd (City of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grad Beograd (City of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Beograd (City of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grad Beograd (City of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grad Beograd (City of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Grad Sofiya (Province of Bulgaria)": [
            {
                "Region Name": "Grad Sofiya (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Sofiya (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Sofiya (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Sofiya (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Sofiya (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Sofiya (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grad Sofiya (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Sofiya (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Sofiya (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Sofiya (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Grad Sofiya (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Sofiya (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Sofiya (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Sofiya (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Sofiya (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Sofiya (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Sofiya (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Sofiya (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Sofiya (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Sofiya (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Sofiya (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Sofiya (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Grad Zagreb (City of Croatia)": [
            {
                "Region Name": "Grad Zagreb (City of Croatia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Zagreb (City of Croatia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Zagreb (City of Croatia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Zagreb (City of Croatia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Zagreb (City of Croatia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Zagreb (City of Croatia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Zagreb (City of Croatia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Zagreb (City of Croatia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Zagreb (City of Croatia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Zagreb (City of Croatia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Zagreb (City of Croatia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Zagreb (City of Croatia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Zagreb (City of Croatia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Zagreb (City of Croatia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Zagreb (City of Croatia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Zagreb (City of Croatia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Zagreb (City of Croatia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Zagreb (City of Croatia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Zagreb (City of Croatia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Zagreb (City of Croatia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Zagreb (City of Croatia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grad Zagreb (City of Croatia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gradsko (Municipality of North Macedonia)": [
            {
                "Region Name": "Gradsko (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gradsko (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gradsko (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gradsko (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gradsko (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gradsko (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gradsko (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gradsko (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gradsko (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gradsko (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gradsko (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gradsko (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gradsko (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gradsko (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gradsko (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gradsko (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gradsko (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gradsko (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gradsko (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gradsko (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gradsko (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gradsko (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Granada (Department of Nicaragua)": [
            {
                "Region Name": "Granada (Department of Nicaragua)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Granada (Department of Nicaragua)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Granada (Department of Nicaragua)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Granada (Department of Nicaragua)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Granada (Department of Nicaragua)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Granada (Department of Nicaragua)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Granada (Department of Nicaragua)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Granada (Department of Nicaragua)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Granada (Department of Nicaragua)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Granada (Department of Nicaragua)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Granada (Department of Nicaragua)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Granada (Department of Nicaragua)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Granada (Department of Nicaragua)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Granada (Department of Nicaragua)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Granada (Department of Nicaragua)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Granada (Department of Nicaragua)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Granada (Department of Nicaragua)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Granada (Department of Nicaragua)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Granada (Department of Nicaragua)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Granada (Department of Nicaragua)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Granada (Department of Nicaragua)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Granada (Department of Nicaragua)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Grand' Anse (District of Seychelles)": [
            {
                "Region Name": "Grand' Anse (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand' Anse (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand' Anse (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand' Anse (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand' Anse (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand' Anse (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand' Anse (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand' Anse (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand' Anse (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand' Anse (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand' Anse (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand' Anse (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand' Anse (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand' Anse (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand' Anse (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand' Anse (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand' Anse (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand' Anse (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand' Anse (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand' Anse (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand' Anse (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand' Anse (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Grand'Anse (Department of Haiti)": [
            {
                "Region Name": "Grand'Anse (Department of Haiti)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse (Department of Haiti)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse (Department of Haiti)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse (Department of Haiti)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse (Department of Haiti)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse (Department of Haiti)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse (Department of Haiti)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse (Department of Haiti)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse (Department of Haiti)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse (Department of Haiti)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse (Department of Haiti)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse (Department of Haiti)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse (Department of Haiti)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse (Department of Haiti)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse (Department of Haiti)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse (Department of Haiti)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse (Department of Haiti)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse (Department of Haiti)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse (Department of Haiti)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse (Department of Haiti)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse (Department of Haiti)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse (Department of Haiti)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Grand'Anse Praslin (District of Seychelles)": [
            {
                "Region Name": "Grand'Anse Praslin (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse Praslin (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse Praslin (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse Praslin (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse Praslin (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse Praslin (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse Praslin (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse Praslin (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse Praslin (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse Praslin (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse Praslin (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse Praslin (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse Praslin (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse Praslin (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse Praslin (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse Praslin (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse Praslin (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse Praslin (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse Praslin (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse Praslin (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse Praslin (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand'Anse Praslin (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Grand Bassa (County of Liberia)": [
            {
                "Region Name": "Grand Bassa (County of Liberia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Bassa (County of Liberia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Bassa (County of Liberia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Grand Bassa (County of Liberia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Bassa (County of Liberia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Bassa (County of Liberia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Grand Bassa (County of Liberia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Bassa (County of Liberia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Grand Bassa (County of Liberia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Bassa (County of Liberia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Grand Bassa (County of Liberia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Grand Bassa (County of Liberia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Grand Bassa (County of Liberia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Grand Bassa (County of Liberia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Bassa (County of Liberia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Bassa (County of Liberia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Bassa (County of Liberia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Grand Bassa (County of Liberia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Grand Bassa (County of Liberia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Bassa (County of Liberia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Grand Bassa (County of Liberia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Bassa (County of Liberia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Grand Cape Mount (County of Liberia)": [
            {
                "Region Name": "Grand Cape Mount (County of Liberia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cape Mount (County of Liberia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Cape Mount (County of Liberia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Cape Mount (County of Liberia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Cape Mount (County of Liberia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Cape Mount (County of Liberia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cape Mount (County of Liberia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Cape Mount (County of Liberia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Grand Cape Mount (County of Liberia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cape Mount (County of Liberia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Cape Mount (County of Liberia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Cape Mount (County of Liberia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Cape Mount (County of Liberia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Cape Mount (County of Liberia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Cape Mount (County of Liberia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cape Mount (County of Liberia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Cape Mount (County of Liberia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Cape Mount (County of Liberia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Cape Mount (County of Liberia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cape Mount (County of Liberia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Grand Cape Mount (County of Liberia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Cape Mount (County of Liberia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Grand Casablanca (Region of Morocco)": [
            {
                "Region Name": "Grand Casablanca (Region of Morocco)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Casablanca (Region of Morocco)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Casablanca (Region of Morocco)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Casablanca (Region of Morocco)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Casablanca (Region of Morocco)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Casablanca (Region of Morocco)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Casablanca (Region of Morocco)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Casablanca (Region of Morocco)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Casablanca (Region of Morocco)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Casablanca (Region of Morocco)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Casablanca (Region of Morocco)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Casablanca (Region of Morocco)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Casablanca (Region of Morocco)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Casablanca (Region of Morocco)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Casablanca (Region of Morocco)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Casablanca (Region of Morocco)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Casablanca (Region of Morocco)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Casablanca (Region of Morocco)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Casablanca (Region of Morocco)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Casablanca (Region of Morocco)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Casablanca (Region of Morocco)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Casablanca (Region of Morocco)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Grand Cay (District of Bahamas)": [
            {
                "Region Name": "Grand Cay (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cay (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cay (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cay (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cay (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cay (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cay (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cay (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cay (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cay (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cay (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cay (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cay (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cay (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cay (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cay (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cay (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cay (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cay (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cay (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cay (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Cay (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Grand Est (Region of France)": [
            {
                "Region Name": "Grand Est (Region of France)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Grand Est (Region of France)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Grand Est (Region of France)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Grand Est (Region of France)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Grand Est (Region of France)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Grand Est (Region of France)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Est (Region of France)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Est (Region of France)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Est (Region of France)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Grand Est (Region of France)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Est (Region of France)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Est (Region of France)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Est (Region of France)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Est (Region of France)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Grand Est (Region of France)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Grand Est (Region of France)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Grand Est (Region of France)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Est (Region of France)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Est (Region of France)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Est (Region of France)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Est (Region of France)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Grand Est (Region of France)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Grand Gedeh (County of Liberia)": [
            {
                "Region Name": "Grand Gedeh (County of Liberia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Gedeh (County of Liberia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Gedeh (County of Liberia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Gedeh (County of Liberia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Gedeh (County of Liberia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Gedeh (County of Liberia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Gedeh (County of Liberia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Gedeh (County of Liberia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Gedeh (County of Liberia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Gedeh (County of Liberia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Gedeh (County of Liberia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Gedeh (County of Liberia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Gedeh (County of Liberia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Gedeh (County of Liberia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Grand Gedeh (County of Liberia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Gedeh (County of Liberia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Grand Gedeh (County of Liberia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Gedeh (County of Liberia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Grand Gedeh (County of Liberia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Gedeh (County of Liberia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Gedeh (County of Liberia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Gedeh (County of Liberia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Grand Kru (County of Liberia)": [
            {
                "Region Name": "Grand Kru (County of Liberia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Kru (County of Liberia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Kru (County of Liberia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Kru (County of Liberia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Kru (County of Liberia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Grand Kru (County of Liberia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Kru (County of Liberia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Kru (County of Liberia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Kru (County of Liberia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Kru (County of Liberia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Kru (County of Liberia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Kru (County of Liberia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Kru (County of Liberia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Kru (County of Liberia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Kru (County of Liberia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Kru (County of Liberia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Kru (County of Liberia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grand Kru (County of Liberia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Kru (County of Liberia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Kru (County of Liberia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Kru (County of Liberia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Grand Kru (County of Liberia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Grand Port (District of Mauritius)": [
            {
                "Region Name": "Grand Port (District of Mauritius)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Port (District of Mauritius)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Port (District of Mauritius)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Port (District of Mauritius)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Port (District of Mauritius)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Port (District of Mauritius)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Port (District of Mauritius)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Port (District of Mauritius)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Port (District of Mauritius)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Port (District of Mauritius)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Port (District of Mauritius)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grand Port (District of Mauritius)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Port (District of Mauritius)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Port (District of Mauritius)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Port (District of Mauritius)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Port (District of Mauritius)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Port (District of Mauritius)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Port (District of Mauritius)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Port (District of Mauritius)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Port (District of Mauritius)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Port (District of Mauritius)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Port (District of Mauritius)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Grand Turk (District of Turks and Caicos Islands)": [
            {
                "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grand Turk (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Granma (Province of Cuba)": [
            {
                "Region Name": "Granma (Province of Cuba)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Granma (Province of Cuba)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Granma (Province of Cuba)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Granma (Province of Cuba)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Granma (Province of Cuba)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Granma (Province of Cuba)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Granma (Province of Cuba)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Granma (Province of Cuba)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Granma (Province of Cuba)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Granma (Province of Cuba)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Granma (Province of Cuba)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Granma (Province of Cuba)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Granma (Province of Cuba)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Granma (Province of Cuba)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Granma (Province of Cuba)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Granma (Province of Cuba)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Granma (Province of Cuba)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Granma (Province of Cuba)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Granma (Province of Cuba)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Granma (Province of Cuba)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Granma (Province of Cuba)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Granma (Province of Cuba)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Graub\xfcnden (Canton of Switzerland)": [
            {
                "Region Name": "Graub\xfcnden (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Graub\xfcnden (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Graub\xfcnden (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Graub\xfcnden (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Graub\xfcnden (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Graub\xfcnden (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Graub\xfcnden (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Graub\xfcnden (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Graub\xfcnden (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Graub\xfcnden (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Graub\xfcnden (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Graub\xfcnden (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Graub\xfcnden (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Graub\xfcnden (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Graub\xfcnden (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Graub\xfcnden (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Graub\xfcnden (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Graub\xfcnden (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Graub\xfcnden (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Graub\xfcnden (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Graub\xfcnden (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Graub\xfcnden (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Greater Accra (Region of Ghana)": [
            {
                "Region Name": "Greater Accra (Region of Ghana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Greater Accra (Region of Ghana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Greater Accra (Region of Ghana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Greater Accra (Region of Ghana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Greater Accra (Region of Ghana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Greater Accra (Region of Ghana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Greater Accra (Region of Ghana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Greater Accra (Region of Ghana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Greater Accra (Region of Ghana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Greater Accra (Region of Ghana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Greater Accra (Region of Ghana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Greater Accra (Region of Ghana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Greater Accra (Region of Ghana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Greater Accra (Region of Ghana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Greater Accra (Region of Ghana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Greater Accra (Region of Ghana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Greater Accra (Region of Ghana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Greater Accra (Region of Ghana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Greater Accra (Region of Ghana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Greater Accra (Region of Ghana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Greater Accra (Region of Ghana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Greater Accra (Region of Ghana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Grenadines (Parish of Saint Vincent and the Grenadines)": [
            {
                "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grenadines (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Grevenmacher (District of Luxembourg)": [
            {
                "Region Name": "Grevenmacher (District of Luxembourg)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grevenmacher (District of Luxembourg)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grevenmacher (District of Luxembourg)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grevenmacher (District of Luxembourg)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grevenmacher (District of Luxembourg)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grevenmacher (District of Luxembourg)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grevenmacher (District of Luxembourg)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grevenmacher (District of Luxembourg)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grevenmacher (District of Luxembourg)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grevenmacher (District of Luxembourg)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grevenmacher (District of Luxembourg)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grevenmacher (District of Luxembourg)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grevenmacher (District of Luxembourg)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grevenmacher (District of Luxembourg)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grevenmacher (District of Luxembourg)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grevenmacher (District of Luxembourg)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grevenmacher (District of Luxembourg)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grevenmacher (District of Luxembourg)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grevenmacher (District of Luxembourg)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grevenmacher (District of Luxembourg)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grevenmacher (District of Luxembourg)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grevenmacher (District of Luxembourg)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Grodno (Region of Belarus)": [
            {
                "Region Name": "Grodno (Region of Belarus)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Grodno (Region of Belarus)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Grodno (Region of Belarus)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Grodno (Region of Belarus)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Grodno (Region of Belarus)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grodno (Region of Belarus)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Grodno (Region of Belarus)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Grodno (Region of Belarus)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grodno (Region of Belarus)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Grodno (Region of Belarus)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Grodno (Region of Belarus)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grodno (Region of Belarus)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Grodno (Region of Belarus)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Grodno (Region of Belarus)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grodno (Region of Belarus)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grodno (Region of Belarus)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grodno (Region of Belarus)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Grodno (Region of Belarus)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Grodno (Region of Belarus)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Grodno (Region of Belarus)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Grodno (Region of Belarus)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Grodno (Region of Belarus)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Groningen (Province of Netherlands)": [
            {
                "Region Name": "Groningen (Province of Netherlands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Groningen (Province of Netherlands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Groningen (Province of Netherlands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Groningen (Province of Netherlands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Groningen (Province of Netherlands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Groningen (Province of Netherlands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Groningen (Province of Netherlands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Groningen (Province of Netherlands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Groningen (Province of Netherlands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Groningen (Province of Netherlands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Groningen (Province of Netherlands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Groningen (Province of Netherlands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Groningen (Province of Netherlands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Groningen (Province of Netherlands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Groningen (Province of Netherlands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Groningen (Province of Netherlands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Groningen (Province of Netherlands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Groningen (Province of Netherlands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Groningen (Province of Netherlands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Groningen (Province of Netherlands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Groningen (Province of Netherlands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Groningen (Province of Netherlands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gros Islet (Quarter of Saint Lucia)": [
            {
                "Region Name": "Gros Islet (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gros Islet (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gros Islet (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gros Islet (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gros Islet (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gros Islet (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gros Islet (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gros Islet (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gros Islet (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gros Islet (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gros Islet (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gros Islet (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gros Islet (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gros Islet (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gros Islet (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gros Islet (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gros Islet (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gros Islet (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gros Islet (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gros Islet (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gros Islet (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gros Islet (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Grouville (Parish of Jersey)": [
            {
                "Region Name": "Grouville (Parish of Jersey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grouville (Parish of Jersey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grouville (Parish of Jersey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grouville (Parish of Jersey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grouville (Parish of Jersey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grouville (Parish of Jersey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grouville (Parish of Jersey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grouville (Parish of Jersey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grouville (Parish of Jersey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grouville (Parish of Jersey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grouville (Parish of Jersey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grouville (Parish of Jersey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grouville (Parish of Jersey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grouville (Parish of Jersey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grouville (Parish of Jersey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grouville (Parish of Jersey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grouville (Parish of Jersey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grouville (Parish of Jersey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grouville (Parish of Jersey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grouville (Parish of Jersey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grouville (Parish of Jersey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Grouville (Parish of Jersey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Guadalcanal (Province of Solomon Islands)": [
            {
                "Region Name": "Guadalcanal (Province of Solomon Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guadalcanal (Province of Solomon Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guadalcanal (Province of Solomon Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guadalcanal (Province of Solomon Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guadalcanal (Province of Solomon Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guadalcanal (Province of Solomon Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guadalcanal (Province of Solomon Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guadalcanal (Province of Solomon Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guadalcanal (Province of Solomon Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guadalcanal (Province of Solomon Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guadalcanal (Province of Solomon Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guadalcanal (Province of Solomon Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guadalcanal (Province of Solomon Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guadalcanal (Province of Solomon Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guadalcanal (Province of Solomon Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guadalcanal (Province of Solomon Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guadalcanal (Province of Solomon Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guadalcanal (Province of Solomon Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guadalcanal (Province of Solomon Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guadalcanal (Province of Solomon Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guadalcanal (Province of Solomon Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guadalcanal (Province of Solomon Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Guain\xeda (Commissiary of Colombia)": [
            {
                "Region Name": "Guain\xeda (Commissiary of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guain\xeda (Commissiary of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guain\xeda (Commissiary of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guain\xeda (Commissiary of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guain\xeda (Commissiary of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Guain\xeda (Commissiary of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guain\xeda (Commissiary of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guain\xeda (Commissiary of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guain\xeda (Commissiary of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guain\xeda (Commissiary of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guain\xeda (Commissiary of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guain\xeda (Commissiary of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Guain\xeda (Commissiary of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guain\xeda (Commissiary of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Guain\xeda (Commissiary of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guain\xeda (Commissiary of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guain\xeda (Commissiary of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guain\xeda (Commissiary of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guain\xeda (Commissiary of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guain\xeda (Commissiary of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guain\xeda (Commissiary of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guain\xeda (Commissiary of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Guair\xe1 (Department of Paraguay)": [
            {
                "Region Name": "Guair\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guair\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guair\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guair\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guair\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guair\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guair\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guair\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guair\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guair\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guair\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guair\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guair\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guair\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guair\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guair\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guair\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guair\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guair\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guair\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guair\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guair\xe1 (Department of Paraguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Guanacaste (Province of Costa Rica)": [
            {
                "Region Name": "Guanacaste (Province of Costa Rica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guanacaste (Province of Costa Rica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Guanacaste (Province of Costa Rica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guanacaste (Province of Costa Rica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guanacaste (Province of Costa Rica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guanacaste (Province of Costa Rica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guanacaste (Province of Costa Rica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Guanacaste (Province of Costa Rica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guanacaste (Province of Costa Rica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guanacaste (Province of Costa Rica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guanacaste (Province of Costa Rica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guanacaste (Province of Costa Rica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guanacaste (Province of Costa Rica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guanacaste (Province of Costa Rica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guanacaste (Province of Costa Rica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Guanacaste (Province of Costa Rica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guanacaste (Province of Costa Rica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Guanacaste (Province of Costa Rica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guanacaste (Province of Costa Rica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Guanacaste (Province of Costa Rica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Guanacaste (Province of Costa Rica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Guanacaste (Province of Costa Rica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Guanajuato (State of M\xe9xico)": [
            {
                "Region Name": "Guanajuato (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Guanajuato (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Guanajuato (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Guanajuato (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guanajuato (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Guanajuato (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Guanajuato (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Guanajuato (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Guanajuato (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guanajuato (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Guanajuato (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Guanajuato (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Guanajuato (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guanajuato (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Guanajuato (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Guanajuato (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Guanajuato (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Guanajuato (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Guanajuato (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guanajuato (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guanajuato (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Guanajuato (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Guangdong (Province of China)": [
            {
                "Region Name": "Guangdong (Province of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guangdong (Province of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guangdong (Province of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guangdong (Province of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guangdong (Province of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guangdong (Province of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guangdong (Province of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guangdong (Province of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guangdong (Province of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guangdong (Province of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guangdong (Province of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guangdong (Province of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guangdong (Province of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guangdong (Province of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guangdong (Province of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guangdong (Province of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guangdong (Province of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guangdong (Province of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guangdong (Province of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guangdong (Province of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guangdong (Province of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guangdong (Province of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Guangxi (Autonomous Region of China)": [
            {
                "Region Name": "Guangxi (Autonomous Region of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guangxi (Autonomous Region of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guangxi (Autonomous Region of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guangxi (Autonomous Region of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guangxi (Autonomous Region of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guangxi (Autonomous Region of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guangxi (Autonomous Region of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guangxi (Autonomous Region of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Guangxi (Autonomous Region of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guangxi (Autonomous Region of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guangxi (Autonomous Region of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guangxi (Autonomous Region of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guangxi (Autonomous Region of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guangxi (Autonomous Region of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guangxi (Autonomous Region of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guangxi (Autonomous Region of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guangxi (Autonomous Region of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guangxi (Autonomous Region of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guangxi (Autonomous Region of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guangxi (Autonomous Region of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guangxi (Autonomous Region of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guangxi (Autonomous Region of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Gu\xe1nica (Municipality of Puerto Rico)": [
            {
                "Region Name": "Gu\xe1nica (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gu\xe1nica (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gu\xe1nica (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gu\xe1nica (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gu\xe1nica (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gu\xe1nica (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gu\xe1nica (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gu\xe1nica (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gu\xe1nica (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gu\xe1nica (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gu\xe1nica (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gu\xe1nica (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gu\xe1nica (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gu\xe1nica (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gu\xe1nica (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gu\xe1nica (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gu\xe1nica (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gu\xe1nica (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gu\xe1nica (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gu\xe1nica (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gu\xe1nica (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gu\xe1nica (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Guant\xe1namo (Province of Cuba)": [
            {
                "Region Name": "Guant\xe1namo (Province of Cuba)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guant\xe1namo (Province of Cuba)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Guant\xe1namo (Province of Cuba)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guant\xe1namo (Province of Cuba)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guant\xe1namo (Province of Cuba)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guant\xe1namo (Province of Cuba)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guant\xe1namo (Province of Cuba)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guant\xe1namo (Province of Cuba)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guant\xe1namo (Province of Cuba)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guant\xe1namo (Province of Cuba)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guant\xe1namo (Province of Cuba)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guant\xe1namo (Province of Cuba)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guant\xe1namo (Province of Cuba)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guant\xe1namo (Province of Cuba)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guant\xe1namo (Province of Cuba)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Guant\xe1namo (Province of Cuba)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guant\xe1namo (Province of Cuba)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guant\xe1namo (Province of Cuba)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guant\xe1namo (Province of Cuba)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guant\xe1namo (Province of Cuba)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Guant\xe1namo (Province of Cuba)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guant\xe1namo (Province of Cuba)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Guarda (District of Portugal)": [
            {
                "Region Name": "Guarda (District of Portugal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guarda (District of Portugal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Guarda (District of Portugal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guarda (District of Portugal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Guarda (District of Portugal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guarda (District of Portugal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guarda (District of Portugal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guarda (District of Portugal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Guarda (District of Portugal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "Guarda (District of Portugal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guarda (District of Portugal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Guarda (District of Portugal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Guarda (District of Portugal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Guarda (District of Portugal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Guarda (District of Portugal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Guarda (District of Portugal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Guarda (District of Portugal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guarda (District of Portugal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guarda (District of Portugal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guarda (District of Portugal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guarda (District of Portugal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 126
            },
            {
                "Region Name": "Guarda (District of Portugal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gu\xe1rico (State of Venezuela)": [
            {
                "Region Name": "Gu\xe1rico (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Gu\xe1rico (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Gu\xe1rico (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Gu\xe1rico (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Gu\xe1rico (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Gu\xe1rico (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gu\xe1rico (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Gu\xe1rico (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Gu\xe1rico (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Gu\xe1rico (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gu\xe1rico (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gu\xe1rico (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gu\xe1rico (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Gu\xe1rico (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Gu\xe1rico (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Gu\xe1rico (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gu\xe1rico (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Gu\xe1rico (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Gu\xe1rico (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Gu\xe1rico (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gu\xe1rico (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gu\xe1rico (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Guatemala (Department of Guatemala)": [
            {
                "Region Name": "Guatemala (Department of Guatemala)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guatemala (Department of Guatemala)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guatemala (Department of Guatemala)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guatemala (Department of Guatemala)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guatemala (Department of Guatemala)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guatemala (Department of Guatemala)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guatemala (Department of Guatemala)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guatemala (Department of Guatemala)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guatemala (Department of Guatemala)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guatemala (Department of Guatemala)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guatemala (Department of Guatemala)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guatemala (Department of Guatemala)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guatemala (Department of Guatemala)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guatemala (Department of Guatemala)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guatemala (Department of Guatemala)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guatemala (Department of Guatemala)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guatemala (Department of Guatemala)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guatemala (Department of Guatemala)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guatemala (Department of Guatemala)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guatemala (Department of Guatemala)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Guatemala (Department of Guatemala)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guatemala (Department of Guatemala)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Guaviare (Commissiary of Colombia)": [
            {
                "Region Name": "Guaviare (Commissiary of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guaviare (Commissiary of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guaviare (Commissiary of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guaviare (Commissiary of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guaviare (Commissiary of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guaviare (Commissiary of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guaviare (Commissiary of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guaviare (Commissiary of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guaviare (Commissiary of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guaviare (Commissiary of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guaviare (Commissiary of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guaviare (Commissiary of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guaviare (Commissiary of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guaviare (Commissiary of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guaviare (Commissiary of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guaviare (Commissiary of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guaviare (Commissiary of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guaviare (Commissiary of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guaviare (Commissiary of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guaviare (Commissiary of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guaviare (Commissiary of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guaviare (Commissiary of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Guayama (Municipality of Puerto Rico)": [
            {
                "Region Name": "Guayama (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayama (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayama (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guayama (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guayama (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guayama (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayama (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guayama (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guayama (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guayama (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guayama (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayama (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayama (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayama (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayama (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayama (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayama (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayama (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayama (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayama (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayama (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayama (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Guayanilla (Municipality of Puerto Rico)": [
            {
                "Region Name": "Guayanilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayanilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayanilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayanilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayanilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayanilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayanilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayanilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayanilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayanilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayanilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayanilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayanilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayanilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayanilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayanilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayanilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayanilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayanilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayanilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayanilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guayanilla (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Guayas (Province of Ecuador)": [
            {
                "Region Name": "Guayas (Province of Ecuador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guayas (Province of Ecuador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guayas (Province of Ecuador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guayas (Province of Ecuador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guayas (Province of Ecuador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guayas (Province of Ecuador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guayas (Province of Ecuador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guayas (Province of Ecuador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guayas (Province of Ecuador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guayas (Province of Ecuador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guayas (Province of Ecuador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guayas (Province of Ecuador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guayas (Province of Ecuador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guayas (Province of Ecuador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guayas (Province of Ecuador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guayas (Province of Ecuador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guayas (Province of Ecuador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guayas (Province of Ecuador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guayas (Province of Ecuador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guayas (Province of Ecuador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guayas (Province of Ecuador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guayas (Province of Ecuador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Guaynabo (Municipality of Puerto Rico)": [
            {
                "Region Name": "Guaynabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guaynabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guaynabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guaynabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guaynabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guaynabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guaynabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guaynabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guaynabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guaynabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guaynabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guaynabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guaynabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guaynabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guaynabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guaynabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guaynabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guaynabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guaynabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guaynabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guaynabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guaynabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Guelma (Province of Algeria)": [
            {
                "Region Name": "Guelma (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guelma (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guelma (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guelma (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guelma (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guelma (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guelma (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guelma (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guelma (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guelma (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guelma (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Guelma (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Guelma (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guelma (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guelma (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guelma (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guelma (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guelma (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Guelma (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guelma (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Guelma (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Guelma (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Guelmim - Es-Semara (Region of Morocco)": [
            {
                "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guelmim - Es-Semara (Region of Morocco)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gu\xe9ra (Region of Chad)": [
            {
                "Region Name": "Gu\xe9ra (Region of Chad)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Gu\xe9ra (Region of Chad)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Gu\xe9ra (Region of Chad)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Gu\xe9ra (Region of Chad)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Gu\xe9ra (Region of Chad)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Gu\xe9ra (Region of Chad)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Gu\xe9ra (Region of Chad)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Gu\xe9ra (Region of Chad)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Gu\xe9ra (Region of Chad)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Gu\xe9ra (Region of Chad)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Gu\xe9ra (Region of Chad)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Gu\xe9ra (Region of Chad)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Gu\xe9ra (Region of Chad)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Gu\xe9ra (Region of Chad)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Gu\xe9ra (Region of Chad)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Gu\xe9ra (Region of Chad)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Gu\xe9ra (Region of Chad)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Gu\xe9ra (Region of Chad)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Gu\xe9ra (Region of Chad)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Gu\xe9ra (Region of Chad)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Gu\xe9ra (Region of Chad)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Gu\xe9ra (Region of Chad)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "Guerrero (State of M\xe9xico)": [
            {
                "Region Name": "Guerrero (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guerrero (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guerrero (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guerrero (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Guerrero (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guerrero (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Guerrero (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guerrero (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guerrero (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guerrero (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guerrero (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guerrero (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guerrero (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Guerrero (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guerrero (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guerrero (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Guerrero (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Guerrero (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Guerrero (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Guerrero (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Guerrero (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guerrero (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Guidimaka (Region of Mauritania)": [
            {
                "Region Name": "Guidimaka (Region of Mauritania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 71
            },
            {
                "Region Name": "Guidimaka (Region of Mauritania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guidimaka (Region of Mauritania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Guidimaka (Region of Mauritania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Guidimaka (Region of Mauritania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Guidimaka (Region of Mauritania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Guidimaka (Region of Mauritania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Guidimaka (Region of Mauritania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Guidimaka (Region of Mauritania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Guidimaka (Region of Mauritania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Guidimaka (Region of Mauritania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guidimaka (Region of Mauritania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Guidimaka (Region of Mauritania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Guidimaka (Region of Mauritania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Guidimaka (Region of Mauritania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Guidimaka (Region of Mauritania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Guidimaka (Region of Mauritania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guidimaka (Region of Mauritania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guidimaka (Region of Mauritania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Guidimaka (Region of Mauritania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Guidimaka (Region of Mauritania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Guidimaka (Region of Mauritania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 48
            }
        ],
        "Guimaras (Province of Philippines)": [
            {
                "Region Name": "Guimaras (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guimaras (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guimaras (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guimaras (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guimaras (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guimaras (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guimaras (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guimaras (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guimaras (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guimaras (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guimaras (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guimaras (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guimaras (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guimaras (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guimaras (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guimaras (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guimaras (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guimaras (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guimaras (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guimaras (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guimaras (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guimaras (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Guizhou (Province of China)": [
            {
                "Region Name": "Guizhou (Province of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guizhou (Province of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guizhou (Province of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guizhou (Province of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guizhou (Province of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guizhou (Province of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guizhou (Province of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guizhou (Province of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Guizhou (Province of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guizhou (Province of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guizhou (Province of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guizhou (Province of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guizhou (Province of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guizhou (Province of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Guizhou (Province of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guizhou (Province of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guizhou (Province of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guizhou (Province of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guizhou (Province of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Guizhou (Province of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guizhou (Province of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Guizhou (Province of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Gujarat (State of India)": [
            {
                "Region Name": "Gujarat (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gujarat (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gujarat (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gujarat (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gujarat (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gujarat (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gujarat (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gujarat (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gujarat (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gujarat (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gujarat (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gujarat (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gujarat (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gujarat (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gujarat (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gujarat (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gujarat (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gujarat (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gujarat (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gujarat (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gujarat (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gujarat (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Gulf (Province of Papua New Guinea)": [
            {
                "Region Name": "Gulf (Province of Papua New Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Gulf (Province of Papua New Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Gulf (Province of Papua New Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gulf (Province of Papua New Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gulf (Province of Papua New Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gulf (Province of Papua New Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gulf (Province of Papua New Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gulf (Province of Papua New Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gulf (Province of Papua New Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Gulf (Province of Papua New Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gulf (Province of Papua New Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gulf (Province of Papua New Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gulf (Province of Papua New Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gulf (Province of Papua New Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gulf (Province of Papua New Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gulf (Province of Papua New Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gulf (Province of Papua New Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gulf (Province of Papua New Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gulf (Province of Papua New Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gulf (Province of Papua New Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gulf (Province of Papua New Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Gulf (Province of Papua New Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Gulu (District of Uganda)": [
            {
                "Region Name": "Gulu (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Gulu (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Gulu (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Gulu (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 57
            },
            {
                "Region Name": "Gulu (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Gulu (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Gulu (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Gulu (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Gulu (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Gulu (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Gulu (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Gulu (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Gulu (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Gulu (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Gulu (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Gulu (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Gulu (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gulu (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Gulu (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gulu (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Gulu (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Gulu (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "G\xfcm\xfc\u015Fhane (Province of Turkey)": [
            {
                "Region Name": "G\xfcm\xfc\u015Fhane (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfcm\xfc\u015Fhane (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfcm\xfc\u015Fhane (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfcm\xfc\u015Fhane (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfcm\xfc\u015Fhane (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfcm\xfc\u015Fhane (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfcm\xfc\u015Fhane (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfcm\xfc\u015Fhane (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfcm\xfc\u015Fhane (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfcm\xfc\u015Fhane (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfcm\xfc\u015Fhane (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfcm\xfc\u015Fhane (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfcm\xfc\u015Fhane (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfcm\xfc\u015Fhane (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfcm\xfc\u015Fhane (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfcm\xfc\u015Fhane (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfcm\xfc\u015Fhane (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfcm\xfc\u015Fhane (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfcm\xfc\u015Fhane (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfcm\xfc\u015Fhane (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "G\xfcm\xfc\u015Fhane (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfcm\xfc\u015Fhane (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gunma (Prefecture of Japan)": [
            {
                "Region Name": "Gunma (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gunma (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gunma (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gunma (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gunma (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gunma (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gunma (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gunma (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gunma (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gunma (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gunma (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gunma (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gunma (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gunma (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gunma (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gunma (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gunma (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gunma (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gunma (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gunma (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gunma (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gunma (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gurabo (Municipality of Puerto Rico)": [
            {
                "Region Name": "Gurabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gurabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gurabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gurabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gurabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gurabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gurabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gurabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gurabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gurabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gurabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gurabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gurabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gurabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gurabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gurabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gurabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gurabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gurabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gurabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gurabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gurabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Guria (Region of Georgia)": [
            {
                "Region Name": "Guria (Region of Georgia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guria (Region of Georgia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guria (Region of Georgia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Guria (Region of Georgia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guria (Region of Georgia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guria (Region of Georgia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guria (Region of Georgia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guria (Region of Georgia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guria (Region of Georgia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guria (Region of Georgia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guria (Region of Georgia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guria (Region of Georgia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guria (Region of Georgia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guria (Region of Georgia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Guria (Region of Georgia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Guria (Region of Georgia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guria (Region of Georgia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guria (Region of Georgia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guria (Region of Georgia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Guria (Region of Georgia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Guria (Region of Georgia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Guria (Region of Georgia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "G\xfczelyurt (District of Northern Cyprus)": [
            {
                "Region Name": "G\xfczelyurt (District of Northern Cyprus)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfczelyurt (District of Northern Cyprus)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfczelyurt (District of Northern Cyprus)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfczelyurt (District of Northern Cyprus)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfczelyurt (District of Northern Cyprus)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfczelyurt (District of Northern Cyprus)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfczelyurt (District of Northern Cyprus)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfczelyurt (District of Northern Cyprus)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfczelyurt (District of Northern Cyprus)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfczelyurt (District of Northern Cyprus)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfczelyurt (District of Northern Cyprus)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfczelyurt (District of Northern Cyprus)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfczelyurt (District of Northern Cyprus)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfczelyurt (District of Northern Cyprus)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfczelyurt (District of Northern Cyprus)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfczelyurt (District of Northern Cyprus)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfczelyurt (District of Northern Cyprus)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfczelyurt (District of Northern Cyprus)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfczelyurt (District of Northern Cyprus)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfczelyurt (District of Northern Cyprus)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfczelyurt (District of Northern Cyprus)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "G\xfczelyurt (District of Northern Cyprus)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gwangju (Metropolitan City of South Korea)": [
            {
                "Region Name": "Gwangju (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gwangju (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gwangju (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gwangju (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gwangju (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gwangju (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gwangju (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gwangju (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gwangju (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gwangju (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gwangju (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gwangju (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gwangju (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gwangju (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gwangju (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gwangju (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gwangju (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gwangju (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gwangju (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gwangju (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gwangju (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gwangju (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gyeonggi-do (Province of South Korea)": [
            {
                "Region Name": "Gyeonggi-do (Province of South Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeonggi-do (Province of South Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gyeonggi-do (Province of South Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gyeonggi-do (Province of South Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Gyeonggi-do (Province of South Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeonggi-do (Province of South Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeonggi-do (Province of South Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Gyeonggi-do (Province of South Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 61
            },
            {
                "Region Name": "Gyeonggi-do (Province of South Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Gyeonggi-do (Province of South Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Gyeonggi-do (Province of South Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeonggi-do (Province of South Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gyeonggi-do (Province of South Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Gyeonggi-do (Province of South Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Gyeonggi-do (Province of South Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gyeonggi-do (Province of South Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Gyeonggi-do (Province of South Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeonggi-do (Province of South Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Gyeonggi-do (Province of South Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Gyeonggi-do (Province of South Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeonggi-do (Province of South Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Gyeonggi-do (Province of South Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gyeongsangbuk-do (Province of South Korea)": [
            {
                "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 109
            },
            {
                "Region Name": "Gyeongsangbuk-do (Province of South Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gyeongsangnam-do (Province of South Korea)": [
            {
                "Region Name": "Gyeongsangnam-do (Province of South Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangnam-do (Province of South Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gyeongsangnam-do (Province of South Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangnam-do (Province of South Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangnam-do (Province of South Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangnam-do (Province of South Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gyeongsangnam-do (Province of South Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangnam-do (Province of South Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gyeongsangnam-do (Province of South Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangnam-do (Province of South Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gyeongsangnam-do (Province of South Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangnam-do (Province of South Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangnam-do (Province of South Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangnam-do (Province of South Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangnam-do (Province of South Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangnam-do (Province of South Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangnam-do (Province of South Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangnam-do (Province of South Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangnam-do (Province of South Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangnam-do (Province of South Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyeongsangnam-do (Province of South Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gyeongsangnam-do (Province of South Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Gyor-Moson-Sopron (County of Hungary)": [
            {
                "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Gyor-Moson-Sopron (County of Hungary)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Ha'apai (Island Group of Tonga)": [
            {
                "Region Name": "Ha'apai (Island Group of Tonga)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ha'apai (Island Group of Tonga)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ha'apai (Island Group of Tonga)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ha'apai (Island Group of Tonga)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ha'apai (Island Group of Tonga)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ha'apai (Island Group of Tonga)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ha'apai (Island Group of Tonga)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ha'apai (Island Group of Tonga)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ha'apai (Island Group of Tonga)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ha'apai (Island Group of Tonga)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ha'apai (Island Group of Tonga)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ha'apai (Island Group of Tonga)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ha'apai (Island Group of Tonga)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ha'apai (Island Group of Tonga)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ha'apai (Island Group of Tonga)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ha'apai (Island Group of Tonga)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ha'apai (Island Group of Tonga)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ha'apai (Island Group of Tonga)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ha'apai (Island Group of Tonga)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ha'apai (Island Group of Tonga)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ha'apai (Island Group of Tonga)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ha'apai (Island Group of Tonga)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "H\xe0 Giang (Province of Vietnam)": [
            {
                "Region Name": "H\xe0 Giang (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xe0 Giang (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "H\xe0 Giang (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "H\xe0 Giang (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xe0 Giang (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xe0 Giang (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "H\xe0 Giang (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "H\xe0 Giang (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "H\xe0 Giang (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "H\xe0 Giang (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xe0 Giang (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xe0 Giang (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "H\xe0 Giang (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 Giang (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 Giang (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xe0 Giang (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xe0 Giang (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 Giang (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "H\xe0 Giang (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 Giang (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xe0 Giang (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "H\xe0 Giang (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "H\xe0 Nam (Province of Vietnam)": [
            {
                "Region Name": "H\xe0 Nam (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 Nam (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 Nam (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 Nam (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 Nam (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 Nam (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 Nam (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 Nam (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 Nam (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 Nam (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 Nam (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 Nam (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 Nam (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 Nam (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 Nam (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 Nam (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 Nam (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 Nam (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 Nam (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 Nam (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 Nam (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xe0 Nam (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "H\xe0 N\u1ED9i (City of Vietnam)": [
            {
                "Region Name": "H\xe0 N\u1ED9i (City of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 N\u1ED9i (City of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 N\u1ED9i (City of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 N\u1ED9i (City of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 N\u1ED9i (City of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "H\xe0 N\u1ED9i (City of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "H\xe0 N\u1ED9i (City of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 N\u1ED9i (City of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 N\u1ED9i (City of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 N\u1ED9i (City of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 N\u1ED9i (City of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 N\u1ED9i (City of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 N\u1ED9i (City of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xe0 N\u1ED9i (City of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 N\u1ED9i (City of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 N\u1ED9i (City of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 N\u1ED9i (City of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 N\u1ED9i (City of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 N\u1ED9i (City of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 N\u1ED9i (City of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 N\u1ED9i (City of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 N\u1ED9i (City of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "H\xe0 T\u0129nh (Province of Vietnam)": [
            {
                "Region Name": "H\xe0 T\u0129nh (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 T\u0129nh (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 T\u0129nh (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "H\xe0 T\u0129nh (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "H\xe0 T\u0129nh (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "H\xe0 T\u0129nh (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xe0 T\u0129nh (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xe0 T\u0129nh (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 T\u0129nh (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "H\xe0 T\u0129nh (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "H\xe0 T\u0129nh (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xe0 T\u0129nh (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 T\u0129nh (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "H\xe0 T\u0129nh (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "H\xe0 T\u0129nh (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xe0 T\u0129nh (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "H\xe0 T\u0129nh (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "H\xe0 T\u0129nh (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "H\xe0 T\u0129nh (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "H\xe0 T\u0129nh (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xe0 T\u0129nh (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xe0 T\u0129nh (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Haa (District of Bhutan)": [
            {
                "Region Name": "Haa (District of Bhutan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haa (District of Bhutan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haa (District of Bhutan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haa (District of Bhutan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Haa (District of Bhutan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haa (District of Bhutan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haa (District of Bhutan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Haa (District of Bhutan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haa (District of Bhutan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Haa (District of Bhutan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haa (District of Bhutan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haa (District of Bhutan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Haa (District of Bhutan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haa (District of Bhutan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haa (District of Bhutan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haa (District of Bhutan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Haa (District of Bhutan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haa (District of Bhutan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haa (District of Bhutan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haa (District of Bhutan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haa (District of Bhutan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Haa (District of Bhutan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "HaDarom (District of Israel)": [
            {
                "Region Name": "HaDarom (District of Israel)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "HaDarom (District of Israel)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "HaDarom (District of Israel)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "HaDarom (District of Israel)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "HaDarom (District of Israel)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaDarom (District of Israel)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "HaDarom (District of Israel)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaDarom (District of Israel)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaDarom (District of Israel)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "HaDarom (District of Israel)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaDarom (District of Israel)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "HaDarom (District of Israel)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "HaDarom (District of Israel)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "HaDarom (District of Israel)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "HaDarom (District of Israel)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "HaDarom (District of Israel)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "HaDarom (District of Israel)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "HaDarom (District of Israel)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "HaDarom (District of Israel)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "HaDarom (District of Israel)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaDarom (District of Israel)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaDarom (District of Israel)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Hadjer-Lamis (Region of Chad)": [
            {
                "Region Name": "Hadjer-Lamis (Region of Chad)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Hadjer-Lamis (Region of Chad)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 68
            },
            {
                "Region Name": "Hadjer-Lamis (Region of Chad)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Hadjer-Lamis (Region of Chad)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 340
            },
            {
                "Region Name": "Hadjer-Lamis (Region of Chad)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Hadjer-Lamis (Region of Chad)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Hadjer-Lamis (Region of Chad)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 72
            },
            {
                "Region Name": "Hadjer-Lamis (Region of Chad)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Hadjer-Lamis (Region of Chad)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Hadjer-Lamis (Region of Chad)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Hadjer-Lamis (Region of Chad)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Hadjer-Lamis (Region of Chad)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Hadjer-Lamis (Region of Chad)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Hadjer-Lamis (Region of Chad)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Hadjer-Lamis (Region of Chad)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Hadjer-Lamis (Region of Chad)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hadjer-Lamis (Region of Chad)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Hadjer-Lamis (Region of Chad)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Hadjer-Lamis (Region of Chad)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Hadjer-Lamis (Region of Chad)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Hadjer-Lamis (Region of Chad)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Hadjer-Lamis (Region of Chad)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 25
            }
        ],
        "Hadramawt (Governorate of Yemen)": [
            {
                "Region Name": "Hadramawt (Governorate of Yemen)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hadramawt (Governorate of Yemen)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hadramawt (Governorate of Yemen)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hadramawt (Governorate of Yemen)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hadramawt (Governorate of Yemen)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hadramawt (Governorate of Yemen)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hadramawt (Governorate of Yemen)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hadramawt (Governorate of Yemen)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hadramawt (Governorate of Yemen)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hadramawt (Governorate of Yemen)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hadramawt (Governorate of Yemen)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hadramawt (Governorate of Yemen)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hadramawt (Governorate of Yemen)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hadramawt (Governorate of Yemen)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hadramawt (Governorate of Yemen)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hadramawt (Governorate of Yemen)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hadramawt (Governorate of Yemen)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hadramawt (Governorate of Yemen)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hadramawt (Governorate of Yemen)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hadramawt (Governorate of Yemen)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hadramawt (Governorate of Yemen)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hadramawt (Governorate of Yemen)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hag\u221A\u2022t\u221A\xb1a (Municipality of Guam)": [
            {
                "Region Name": "Hag\u221A\u2022t\u221A\xb1a (Municipality of Guam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hag\u221A\u2022t\u221A\xb1a (Municipality of Guam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hag\u221A\u2022t\u221A\xb1a (Municipality of Guam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hag\u221A\u2022t\u221A\xb1a (Municipality of Guam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hag\u221A\u2022t\u221A\xb1a (Municipality of Guam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hag\u221A\u2022t\u221A\xb1a (Municipality of Guam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hag\u221A\u2022t\u221A\xb1a (Municipality of Guam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hag\u221A\u2022t\u221A\xb1a (Municipality of Guam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hag\u221A\u2022t\u221A\xb1a (Municipality of Guam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hag\u221A\u2022t\u221A\xb1a (Municipality of Guam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hag\u221A\u2022t\u221A\xb1a (Municipality of Guam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hag\u221A\u2022t\u221A\xb1a (Municipality of Guam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hag\u221A\u2022t\u221A\xb1a (Municipality of Guam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hag\u221A\u2022t\u221A\xb1a (Municipality of Guam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hag\u221A\u2022t\u221A\xb1a (Municipality of Guam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hag\u221A\u2022t\u221A\xb1a (Municipality of Guam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hag\u221A\u2022t\u221A\xb1a (Municipality of Guam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hag\u221A\u2022t\u221A\xb1a (Municipality of Guam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hag\u221A\u2022t\u221A\xb1a (Municipality of Guam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hag\u221A\u2022t\u221A\xb1a (Municipality of Guam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hag\u221A\u2022t\u221A\xb1a (Municipality of Guam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hag\u221A\u2022t\u221A\xb1a (Municipality of Guam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "H\u1EA3i D\u01B0\u01A1ng (Province of Vietnam)": [
            {
                "Region Name": "H\u1EA3i D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\u1EA3i D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "H\u1EA3i D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\u1EA3i D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i D\u01B0\u01A1ng (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "H\u1EA3i Ph\xf2ng (City of Vietnam)": [
            {
                "Region Name": "H\u1EA3i Ph\xf2ng (City of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i Ph\xf2ng (City of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i Ph\xf2ng (City of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i Ph\xf2ng (City of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i Ph\xf2ng (City of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i Ph\xf2ng (City of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i Ph\xf2ng (City of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i Ph\xf2ng (City of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i Ph\xf2ng (City of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i Ph\xf2ng (City of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i Ph\xf2ng (City of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i Ph\xf2ng (City of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i Ph\xf2ng (City of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i Ph\xf2ng (City of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i Ph\xf2ng (City of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i Ph\xf2ng (City of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i Ph\xf2ng (City of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i Ph\xf2ng (City of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "H\u1EA3i Ph\xf2ng (City of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i Ph\xf2ng (City of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i Ph\xf2ng (City of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EA3i Ph\xf2ng (City of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Haifa (District of Israel)": [
            {
                "Region Name": "Haifa (District of Israel)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haifa (District of Israel)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haifa (District of Israel)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haifa (District of Israel)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haifa (District of Israel)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haifa (District of Israel)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haifa (District of Israel)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haifa (District of Israel)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haifa (District of Israel)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Haifa (District of Israel)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haifa (District of Israel)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haifa (District of Israel)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haifa (District of Israel)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haifa (District of Israel)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haifa (District of Israel)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haifa (District of Israel)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haifa (District of Israel)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haifa (District of Israel)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haifa (District of Israel)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haifa (District of Israel)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haifa (District of Israel)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haifa (District of Israel)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hainan (Province of China)": [
            {
                "Region Name": "Hainan (Province of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hainan (Province of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hainan (Province of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hainan (Province of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hainan (Province of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hainan (Province of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hainan (Province of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hainan (Province of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hainan (Province of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hainan (Province of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hainan (Province of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hainan (Province of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hainan (Province of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hainan (Province of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hainan (Province of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hainan (Province of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hainan (Province of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hainan (Province of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hainan (Province of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hainan (Province of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hainan (Province of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hainan (Province of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Hajd\xfa-Bihar (County of Hungary)": [
            {
                "Region Name": "Hajd\xfa-Bihar (County of Hungary)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Hajd\xfa-Bihar (County of Hungary)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Hajd\xfa-Bihar (County of Hungary)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajd\xfa-Bihar (County of Hungary)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hajd\xfa-Bihar (County of Hungary)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Hajd\xfa-Bihar (County of Hungary)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Hajd\xfa-Bihar (County of Hungary)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hajd\xfa-Bihar (County of Hungary)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hajd\xfa-Bihar (County of Hungary)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajd\xfa-Bihar (County of Hungary)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hajd\xfa-Bihar (County of Hungary)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hajd\xfa-Bihar (County of Hungary)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Hajd\xfa-Bihar (County of Hungary)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hajd\xfa-Bihar (County of Hungary)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajd\xfa-Bihar (County of Hungary)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajd\xfa-Bihar (County of Hungary)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajd\xfa-Bihar (County of Hungary)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajd\xfa-Bihar (County of Hungary)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajd\xfa-Bihar (County of Hungary)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajd\xfa-Bihar (County of Hungary)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajd\xfa-Bihar (County of Hungary)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajd\xfa-Bihar (County of Hungary)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hajjah (Governorate of Yemen)": [
            {
                "Region Name": "Hajjah (Governorate of Yemen)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajjah (Governorate of Yemen)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajjah (Governorate of Yemen)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajjah (Governorate of Yemen)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajjah (Governorate of Yemen)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajjah (Governorate of Yemen)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajjah (Governorate of Yemen)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajjah (Governorate of Yemen)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajjah (Governorate of Yemen)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajjah (Governorate of Yemen)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajjah (Governorate of Yemen)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajjah (Governorate of Yemen)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajjah (Governorate of Yemen)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajjah (Governorate of Yemen)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajjah (Governorate of Yemen)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajjah (Governorate of Yemen)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajjah (Governorate of Yemen)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajjah (Governorate of Yemen)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajjah (Governorate of Yemen)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajjah (Governorate of Yemen)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajjah (Governorate of Yemen)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hajjah (Governorate of Yemen)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hakkari (Province of Turkey)": [
            {
                "Region Name": "Hakkari (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hakkari (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hakkari (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hakkari (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hakkari (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hakkari (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hakkari (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hakkari (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hakkari (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hakkari (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hakkari (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hakkari (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hakkari (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hakkari (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Hakkari (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Hakkari (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hakkari (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hakkari (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hakkari (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hakkari (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Hakkari (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hakkari (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Halland (County of Sweden)": [
            {
                "Region Name": "Halland (County of Sweden)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Halland (County of Sweden)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Halland (County of Sweden)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Halland (County of Sweden)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Halland (County of Sweden)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Halland (County of Sweden)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Halland (County of Sweden)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Halland (County of Sweden)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Halland (County of Sweden)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Halland (County of Sweden)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Halland (County of Sweden)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Halland (County of Sweden)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Halland (County of Sweden)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Halland (County of Sweden)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Halland (County of Sweden)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Halland (County of Sweden)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Halland (County of Sweden)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Halland (County of Sweden)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Halland (County of Sweden)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Halland (County of Sweden)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Halland (County of Sweden)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Halland (County of Sweden)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hamadan (Province of Iran)": [
            {
                "Region Name": "Hamadan (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hamadan (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hamadan (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hamadan (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hamadan (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hamadan (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hamadan (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamadan (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hamadan (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hamadan (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hamadan (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hamadan (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hamadan (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hamadan (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamadan (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hamadan (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hamadan (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hamadan (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hamadan (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hamadan (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamadan (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamadan (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Hamah (Governorate of Syria)": [
            {
                "Region Name": "Hamah (Governorate of Syria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamah (Governorate of Syria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hamah (Governorate of Syria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamah (Governorate of Syria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamah (Governorate of Syria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hamah (Governorate of Syria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamah (Governorate of Syria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamah (Governorate of Syria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamah (Governorate of Syria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hamah (Governorate of Syria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamah (Governorate of Syria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hamah (Governorate of Syria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hamah (Governorate of Syria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hamah (Governorate of Syria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hamah (Governorate of Syria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hamah (Governorate of Syria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Hamah (Governorate of Syria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hamah (Governorate of Syria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Hamah (Governorate of Syria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Hamah (Governorate of Syria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 63
            },
            {
                "Region Name": "Hamah (Governorate of Syria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Hamah (Governorate of Syria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 46
            }
        ],
        "Hambantota (District of Sri Lanka)": [
            {
                "Region Name": "Hambantota (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hambantota (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hambantota (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hambantota (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hambantota (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hambantota (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hambantota (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hambantota (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hambantota (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hambantota (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hambantota (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hambantota (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hambantota (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hambantota (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hambantota (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hambantota (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hambantota (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hambantota (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hambantota (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hambantota (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Hambantota (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Hambantota (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Hamburg (State of Germany)": [
            {
                "Region Name": "Hamburg (State of Germany)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamburg (State of Germany)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamburg (State of Germany)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamburg (State of Germany)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamburg (State of Germany)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamburg (State of Germany)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamburg (State of Germany)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamburg (State of Germany)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamburg (State of Germany)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamburg (State of Germany)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamburg (State of Germany)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamburg (State of Germany)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamburg (State of Germany)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamburg (State of Germany)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamburg (State of Germany)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamburg (State of Germany)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamburg (State of Germany)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamburg (State of Germany)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamburg (State of Germany)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamburg (State of Germany)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamburg (State of Germany)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamburg (State of Germany)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "HaMerkaz (District of Israel)": [
            {
                "Region Name": "HaMerkaz (District of Israel)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaMerkaz (District of Israel)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "HaMerkaz (District of Israel)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaMerkaz (District of Israel)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaMerkaz (District of Israel)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaMerkaz (District of Israel)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "HaMerkaz (District of Israel)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaMerkaz (District of Israel)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaMerkaz (District of Israel)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaMerkaz (District of Israel)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaMerkaz (District of Israel)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaMerkaz (District of Israel)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "HaMerkaz (District of Israel)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaMerkaz (District of Israel)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaMerkaz (District of Israel)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "HaMerkaz (District of Israel)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaMerkaz (District of Israel)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaMerkaz (District of Israel)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "HaMerkaz (District of Israel)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "HaMerkaz (District of Israel)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "HaMerkaz (District of Israel)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaMerkaz (District of Israel)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Hamgy\u014Fng-bukto (Province of North Korea)": [
            {
                "Region Name": "Hamgy\u014Fng-bukto (Province of North Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamgy\u014Fng-bukto (Province of North Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hamgy\u014Fng-bukto (Province of North Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Hamgy\u014Fng-bukto (Province of North Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hamgy\u014Fng-bukto (Province of North Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hamgy\u014Fng-bukto (Province of North Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Hamgy\u014Fng-bukto (Province of North Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Hamgy\u014Fng-bukto (Province of North Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hamgy\u014Fng-bukto (Province of North Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hamgy\u014Fng-bukto (Province of North Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hamgy\u014Fng-bukto (Province of North Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Hamgy\u014Fng-bukto (Province of North Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hamgy\u014Fng-bukto (Province of North Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hamgy\u014Fng-bukto (Province of North Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hamgy\u014Fng-bukto (Province of North Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hamgy\u014Fng-bukto (Province of North Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hamgy\u014Fng-bukto (Province of North Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hamgy\u014Fng-bukto (Province of North Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hamgy\u014Fng-bukto (Province of North Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Hamgy\u014Fng-bukto (Province of North Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Hamgy\u014Fng-bukto (Province of North Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Hamgy\u014Fng-bukto (Province of North Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Hamgy\u014Fng-namdo (Province of North Korea)": [
            {
                "Region Name": "Hamgy\u014Fng-namdo (Province of North Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Hamgy\u014Fng-namdo (Province of North Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hamgy\u014Fng-namdo (Province of North Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Hamgy\u014Fng-namdo (Province of North Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hamgy\u014Fng-namdo (Province of North Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hamgy\u014Fng-namdo (Province of North Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hamgy\u014Fng-namdo (Province of North Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Hamgy\u014Fng-namdo (Province of North Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hamgy\u014Fng-namdo (Province of North Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamgy\u014Fng-namdo (Province of North Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hamgy\u014Fng-namdo (Province of North Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Hamgy\u014Fng-namdo (Province of North Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hamgy\u014Fng-namdo (Province of North Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Hamgy\u014Fng-namdo (Province of North Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Hamgy\u014Fng-namdo (Province of North Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hamgy\u014Fng-namdo (Province of North Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hamgy\u014Fng-namdo (Province of North Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hamgy\u014Fng-namdo (Province of North Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hamgy\u014Fng-namdo (Province of North Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hamgy\u014Fng-namdo (Province of North Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamgy\u014Fng-namdo (Province of North Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamgy\u014Fng-namdo (Province of North Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hamilton (Parish of Bermuda)": [
            {
                "Region Name": "Hamilton (Parish of Bermuda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton (Parish of Bermuda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton (Parish of Bermuda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton (Parish of Bermuda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton (Parish of Bermuda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton (Parish of Bermuda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton (Parish of Bermuda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton (Parish of Bermuda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton (Parish of Bermuda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton (Parish of Bermuda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton (Parish of Bermuda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton (Parish of Bermuda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton (Parish of Bermuda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton (Parish of Bermuda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton (Parish of Bermuda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton (Parish of Bermuda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton (Parish of Bermuda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton (Parish of Bermuda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton (Parish of Bermuda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton (Parish of Bermuda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton (Parish of Bermuda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton (Parish of Bermuda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hamilton Municipality (Municipality of Bermuda)": [
            {
                "Region Name": "Hamilton Municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton Municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton Municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton Municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton Municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton Municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton Municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton Municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton Municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton Municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton Municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton Municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton Municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton Municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton Municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton Municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton Municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton Municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton Municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton Municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton Municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hamilton Municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hanover (Parish of Jamaica)": [
            {
                "Region Name": "Hanover (Parish of Jamaica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hanover (Parish of Jamaica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hanover (Parish of Jamaica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hanover (Parish of Jamaica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hanover (Parish of Jamaica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hanover (Parish of Jamaica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hanover (Parish of Jamaica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hanover (Parish of Jamaica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hanover (Parish of Jamaica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hanover (Parish of Jamaica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hanover (Parish of Jamaica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hanover (Parish of Jamaica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hanover (Parish of Jamaica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hanover (Parish of Jamaica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hanover (Parish of Jamaica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hanover (Parish of Jamaica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hanover (Parish of Jamaica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hanover (Parish of Jamaica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hanover (Parish of Jamaica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hanover (Parish of Jamaica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hanover (Parish of Jamaica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hanover (Parish of Jamaica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Harare (City of Zimbabwe)": [
            {
                "Region Name": "Harare (City of Zimbabwe)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Harare (City of Zimbabwe)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Harare (City of Zimbabwe)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Harare (City of Zimbabwe)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Harare (City of Zimbabwe)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Harare (City of Zimbabwe)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Harare (City of Zimbabwe)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Harare (City of Zimbabwe)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Harare (City of Zimbabwe)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Harare (City of Zimbabwe)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Harare (City of Zimbabwe)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Harare (City of Zimbabwe)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Harare (City of Zimbabwe)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Harare (City of Zimbabwe)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Harare (City of Zimbabwe)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Harare (City of Zimbabwe)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Harare (City of Zimbabwe)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harare (City of Zimbabwe)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Harare (City of Zimbabwe)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Harare (City of Zimbabwe)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Harare (City of Zimbabwe)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Harare (City of Zimbabwe)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Harari People (State of Ethiopia)": [
            {
                "Region Name": "Harari People (State of Ethiopia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harari People (State of Ethiopia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harari People (State of Ethiopia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harari People (State of Ethiopia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harari People (State of Ethiopia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harari People (State of Ethiopia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harari People (State of Ethiopia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harari People (State of Ethiopia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harari People (State of Ethiopia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harari People (State of Ethiopia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harari People (State of Ethiopia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harari People (State of Ethiopia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harari People (State of Ethiopia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harari People (State of Ethiopia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harari People (State of Ethiopia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harari People (State of Ethiopia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harari People (State of Ethiopia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harari People (State of Ethiopia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harari People (State of Ethiopia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harari People (State of Ethiopia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harari People (State of Ethiopia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harari People (State of Ethiopia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Harbour Island (District of Bahamas)": [
            {
                "Region Name": "Harbour Island (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harbour Island (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harbour Island (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harbour Island (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harbour Island (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harbour Island (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harbour Island (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harbour Island (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harbour Island (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harbour Island (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harbour Island (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harbour Island (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harbour Island (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harbour Island (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harbour Island (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harbour Island (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harbour Island (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harbour Island (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harbour Island (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harbour Island (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harbour Island (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harbour Island (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hardap (Region of Namibia)": [
            {
                "Region Name": "Hardap (Region of Namibia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Hardap (Region of Namibia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hardap (Region of Namibia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hardap (Region of Namibia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hardap (Region of Namibia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Hardap (Region of Namibia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Hardap (Region of Namibia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Hardap (Region of Namibia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Hardap (Region of Namibia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Hardap (Region of Namibia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Hardap (Region of Namibia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Hardap (Region of Namibia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hardap (Region of Namibia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Hardap (Region of Namibia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Hardap (Region of Namibia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hardap (Region of Namibia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Hardap (Region of Namibia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hardap (Region of Namibia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hardap (Region of Namibia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hardap (Region of Namibia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Hardap (Region of Namibia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 64
            },
            {
                "Region Name": "Hardap (Region of Namibia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 25
            }
        ],
        "Harghita (County of Romania)": [
            {
                "Region Name": "Harghita (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harghita (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harghita (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Harghita (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Harghita (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Harghita (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Harghita (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harghita (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Harghita (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harghita (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Harghita (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Harghita (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Harghita (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harghita (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harghita (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harghita (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harghita (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harghita (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harghita (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Harghita (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harghita (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Harghita (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Harju (County of Estonia)": [
            {
                "Region Name": "Harju (County of Estonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Harju (County of Estonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harju (County of Estonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Harju (County of Estonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harju (County of Estonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Harju (County of Estonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harju (County of Estonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Harju (County of Estonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harju (County of Estonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harju (County of Estonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harju (County of Estonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harju (County of Estonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harju (County of Estonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harju (County of Estonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harju (County of Estonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harju (County of Estonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harju (County of Estonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harju (County of Estonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harju (County of Estonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harju (County of Estonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harju (County of Estonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Harju (County of Estonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Haryana (State of India)": [
            {
                "Region Name": "Haryana (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Haryana (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Haryana (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Haryana (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Haryana (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Haryana (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Haryana (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Haryana (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Haryana (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Haryana (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Haryana (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Haryana (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Haryana (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Haryana (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Haryana (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Haryana (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Haryana (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Haryana (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Haryana (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Haryana (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Haryana (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Haryana (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Haskovo (Province of Bulgaria)": [
            {
                "Region Name": "Haskovo (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Haskovo (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Haskovo (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Haskovo (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Haskovo (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Haskovo (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Haskovo (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Haskovo (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Haskovo (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Haskovo (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Haskovo (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Haskovo (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Haskovo (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haskovo (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haskovo (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Haskovo (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Haskovo (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Haskovo (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Haskovo (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Haskovo (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Haskovo (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Haskovo (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Hatay (Province of Turkey)": [
            {
                "Region Name": "Hatay (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hatay (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Hatay (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Hatay (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Hatay (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hatay (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hatay (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hatay (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hatay (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hatay (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hatay (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Hatay (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Hatay (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatay (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hatay (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hatay (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hatay (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hatay (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hatay (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Hatay (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hatay (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hatay (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Hatillo (Municipality of Puerto Rico)": [
            {
                "Region Name": "Hatillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hato Mayor (Province of Dominican Republic)": [
            {
                "Region Name": "Hato Mayor (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hato Mayor (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hato Mayor (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hato Mayor (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hato Mayor (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hato Mayor (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hato Mayor (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hato Mayor (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hato Mayor (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hato Mayor (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hato Mayor (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hato Mayor (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hato Mayor (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hato Mayor (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hato Mayor (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hato Mayor (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hato Mayor (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hato Mayor (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hato Mayor (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hato Mayor (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hato Mayor (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hato Mayor (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hatohobei (State of Palau)": [
            {
                "Region Name": "Hatohobei (State of Palau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatohobei (State of Palau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatohobei (State of Palau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatohobei (State of Palau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatohobei (State of Palau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatohobei (State of Palau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatohobei (State of Palau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatohobei (State of Palau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatohobei (State of Palau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatohobei (State of Palau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatohobei (State of Palau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatohobei (State of Palau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatohobei (State of Palau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatohobei (State of Palau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatohobei (State of Palau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatohobei (State of Palau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatohobei (State of Palau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatohobei (State of Palau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatohobei (State of Palau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatohobei (State of Palau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatohobei (State of Palau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hatohobei (State of Palau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "H\u1EADu Giang (Province of Vietnam)": [
            {
                "Region Name": "H\u1EADu Giang (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "H\u1EADu Giang (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\u1EADu Giang (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "H\u1EADu Giang (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "H\u1EADu Giang (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "H\u1EADu Giang (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "H\u1EADu Giang (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "H\u1EADu Giang (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "H\u1EADu Giang (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "H\u1EADu Giang (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "H\u1EADu Giang (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "H\u1EADu Giang (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "H\u1EADu Giang (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "H\u1EADu Giang (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "H\u1EADu Giang (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1EADu Giang (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "H\u1EADu Giang (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "H\u1EADu Giang (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "H\u1EADu Giang (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "H\u1EADu Giang (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "H\u1EADu Giang (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "H\u1EADu Giang (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Haut-Bassins (Region of Burkina Faso)": [
            {
                "Region Name": "Haut-Bassins (Region of Burkina Faso)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Haut-Bassins (Region of Burkina Faso)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Haut-Bassins (Region of Burkina Faso)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Haut-Bassins (Region of Burkina Faso)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Haut-Bassins (Region of Burkina Faso)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Haut-Bassins (Region of Burkina Faso)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Haut-Bassins (Region of Burkina Faso)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Haut-Bassins (Region of Burkina Faso)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Haut-Bassins (Region of Burkina Faso)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Haut-Bassins (Region of Burkina Faso)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Haut-Bassins (Region of Burkina Faso)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Haut-Bassins (Region of Burkina Faso)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Haut-Bassins (Region of Burkina Faso)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Haut-Bassins (Region of Burkina Faso)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Haut-Bassins (Region of Burkina Faso)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Haut-Bassins (Region of Burkina Faso)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Haut-Bassins (Region of Burkina Faso)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Haut-Bassins (Region of Burkina Faso)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Haut-Bassins (Region of Burkina Faso)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Haut-Bassins (Region of Burkina Faso)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Haut-Bassins (Region of Burkina Faso)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Haut-Bassins (Region of Burkina Faso)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Haut-Katanga (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Haut-Katanga (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Haut-Lomami (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Haut-Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 19
            }
        ],
        "Haut-Mbomou (Prefecture of Central African Republic)": [
            {
                "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Haut-Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 40
            }
        ],
        "Haut-Ogoou\xe9 (Province of Gabon)": [
            {
                "Region Name": "Haut-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Haut-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Haut-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Haut-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Haut-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Haut-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Haut-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Haut-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Haut-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Haut-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Haut-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Haut-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Haut-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Haut-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Haut-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Haut-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Haut-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Haut-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Haut-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Haut-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Haut-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Haut-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "Haut-Uele (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Haut-Uele (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Haute-Kotto (Prefecture of Central African Republic)": [
            {
                "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 73
            },
            {
                "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Haute-Kotto (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 30
            }
        ],
        "Hauts-de-France (Region of France)": [
            {
                "Region Name": "Hauts-de-France (Region of France)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Hauts-de-France (Region of France)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hauts-de-France (Region of France)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Hauts-de-France (Region of France)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hauts-de-France (Region of France)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hauts-de-France (Region of France)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hauts-de-France (Region of France)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hauts-de-France (Region of France)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hauts-de-France (Region of France)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hauts-de-France (Region of France)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hauts-de-France (Region of France)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hauts-de-France (Region of France)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hauts-de-France (Region of France)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hauts-de-France (Region of France)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Hauts-de-France (Region of France)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hauts-de-France (Region of France)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hauts-de-France (Region of France)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hauts-de-France (Region of France)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hauts-de-France (Region of France)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hauts-de-France (Region of France)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hauts-de-France (Region of France)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hauts-de-France (Region of France)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hawaii (State of United States)": [
            {
                "Region Name": "Hawaii (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hawaii (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Hawaii (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hawaii (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Hawaii (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Hawaii (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Hawaii (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Hawaii (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Hawaii (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Hawaii (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hawaii (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hawaii (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawaii (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawaii (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Hawaii (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Hawaii (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawaii (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "Hawaii (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Hawaii (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Hawaii (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 109
            },
            {
                "Region Name": "Hawaii (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Hawaii (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Hawalli (Province of Kuwait)": [
            {
                "Region Name": "Hawalli (Province of Kuwait)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawalli (Province of Kuwait)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawalli (Province of Kuwait)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawalli (Province of Kuwait)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawalli (Province of Kuwait)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawalli (Province of Kuwait)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawalli (Province of Kuwait)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawalli (Province of Kuwait)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawalli (Province of Kuwait)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawalli (Province of Kuwait)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawalli (Province of Kuwait)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawalli (Province of Kuwait)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawalli (Province of Kuwait)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawalli (Province of Kuwait)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawalli (Province of Kuwait)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawalli (Province of Kuwait)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawalli (Province of Kuwait)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawalli (Province of Kuwait)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawalli (Province of Kuwait)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawalli (Province of Kuwait)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawalli (Province of Kuwait)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawalli (Province of Kuwait)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hawke's Bay (Region of New Zealand)": [
            {
                "Region Name": "Hawke's Bay (Region of New Zealand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawke's Bay (Region of New Zealand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawke's Bay (Region of New Zealand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawke's Bay (Region of New Zealand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawke's Bay (Region of New Zealand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawke's Bay (Region of New Zealand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawke's Bay (Region of New Zealand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawke's Bay (Region of New Zealand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawke's Bay (Region of New Zealand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawke's Bay (Region of New Zealand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawke's Bay (Region of New Zealand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawke's Bay (Region of New Zealand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawke's Bay (Region of New Zealand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawke's Bay (Region of New Zealand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawke's Bay (Region of New Zealand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawke's Bay (Region of New Zealand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawke's Bay (Region of New Zealand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawke's Bay (Region of New Zealand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hawke's Bay (Region of New Zealand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawke's Bay (Region of New Zealand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawke's Bay (Region of New Zealand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hawke's Bay (Region of New Zealand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "HaZafon (District of Israel)": [
            {
                "Region Name": "HaZafon (District of Israel)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaZafon (District of Israel)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "HaZafon (District of Israel)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "HaZafon (District of Israel)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "HaZafon (District of Israel)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "HaZafon (District of Israel)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "HaZafon (District of Israel)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "HaZafon (District of Israel)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaZafon (District of Israel)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "HaZafon (District of Israel)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "HaZafon (District of Israel)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "HaZafon (District of Israel)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "HaZafon (District of Israel)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaZafon (District of Israel)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "HaZafon (District of Israel)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaZafon (District of Israel)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "HaZafon (District of Israel)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaZafon (District of Israel)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "HaZafon (District of Israel)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "HaZafon (District of Israel)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "HaZafon (District of Israel)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "HaZafon (District of Israel)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Hebei (Province of China)": [
            {
                "Region Name": "Hebei (Province of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Hebei (Province of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Hebei (Province of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Hebei (Province of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Hebei (Province of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Hebei (Province of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Hebei (Province of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Hebei (Province of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Hebei (Province of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hebei (Province of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Hebei (Province of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Hebei (Province of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Hebei (Province of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Hebei (Province of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Hebei (Province of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Hebei (Province of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Hebei (Province of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Hebei (Province of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hebei (Province of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hebei (Province of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hebei (Province of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Hebei (Province of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Hedmark (County of Norway)": [
            {
                "Region Name": "Hedmark (County of Norway)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hedmark (County of Norway)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hedmark (County of Norway)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hedmark (County of Norway)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hedmark (County of Norway)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hedmark (County of Norway)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hedmark (County of Norway)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hedmark (County of Norway)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hedmark (County of Norway)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hedmark (County of Norway)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hedmark (County of Norway)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hedmark (County of Norway)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hedmark (County of Norway)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hedmark (County of Norway)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hedmark (County of Norway)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hedmark (County of Norway)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hedmark (County of Norway)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hedmark (County of Norway)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hedmark (County of Norway)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hedmark (County of Norway)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hedmark (County of Norway)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hedmark (County of Norway)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Heilongjiang (Province of China)": [
            {
                "Region Name": "Heilongjiang (Province of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Heilongjiang (Province of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Heilongjiang (Province of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Heilongjiang (Province of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Heilongjiang (Province of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Heilongjiang (Province of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Heilongjiang (Province of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Heilongjiang (Province of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Heilongjiang (Province of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Heilongjiang (Province of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Heilongjiang (Province of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Heilongjiang (Province of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Heilongjiang (Province of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Heilongjiang (Province of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Heilongjiang (Province of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Heilongjiang (Province of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Heilongjiang (Province of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Heilongjiang (Province of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Heilongjiang (Province of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Heilongjiang (Province of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Heilongjiang (Province of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Heilongjiang (Province of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "Hela (Province of Papua New Guinea)": [
            {
                "Region Name": "Hela (Province of Papua New Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hela (Province of Papua New Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hela (Province of Papua New Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hela (Province of Papua New Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hela (Province of Papua New Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hela (Province of Papua New Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hela (Province of Papua New Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hela (Province of Papua New Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hela (Province of Papua New Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hela (Province of Papua New Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hela (Province of Papua New Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hela (Province of Papua New Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hela (Province of Papua New Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hela (Province of Papua New Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hela (Province of Papua New Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hela (Province of Papua New Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hela (Province of Papua New Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hela (Province of Papua New Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hela (Province of Papua New Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hela (Province of Papua New Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hela (Province of Papua New Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hela (Province of Papua New Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Henan (Province of China)": [
            {
                "Region Name": "Henan (Province of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Henan (Province of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Henan (Province of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Henan (Province of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Henan (Province of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Henan (Province of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Henan (Province of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 94
            },
            {
                "Region Name": "Henan (Province of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 66
            },
            {
                "Region Name": "Henan (Province of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 64
            },
            {
                "Region Name": "Henan (Province of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Henan (Province of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Henan (Province of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Henan (Province of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Henan (Province of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Henan (Province of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Henan (Province of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Henan (Province of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Henan (Province of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Henan (Province of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Henan (Province of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Henan (Province of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Henan (Province of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 40
            }
        ],
        "Hentiy (Province of Mongolia)": [
            {
                "Region Name": "Hentiy (Province of Mongolia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 81
            },
            {
                "Region Name": "Hentiy (Province of Mongolia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hentiy (Province of Mongolia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Hentiy (Province of Mongolia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Hentiy (Province of Mongolia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 381
            },
            {
                "Region Name": "Hentiy (Province of Mongolia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "Hentiy (Province of Mongolia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 155
            },
            {
                "Region Name": "Hentiy (Province of Mongolia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 68
            },
            {
                "Region Name": "Hentiy (Province of Mongolia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Hentiy (Province of Mongolia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 132
            },
            {
                "Region Name": "Hentiy (Province of Mongolia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 95
            },
            {
                "Region Name": "Hentiy (Province of Mongolia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 64
            },
            {
                "Region Name": "Hentiy (Province of Mongolia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 76
            },
            {
                "Region Name": "Hentiy (Province of Mongolia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "Hentiy (Province of Mongolia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Hentiy (Province of Mongolia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Hentiy (Province of Mongolia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hentiy (Province of Mongolia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Hentiy (Province of Mongolia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Hentiy (Province of Mongolia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hentiy (Province of Mongolia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hentiy (Province of Mongolia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Herceg Novi (Municipality of Montenegro)": [
            {
                "Region Name": "Herceg Novi (Municipality of Montenegro)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Herceg Novi (Municipality of Montenegro)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Herceg Novi (Municipality of Montenegro)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Herceg Novi (Municipality of Montenegro)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Herceg Novi (Municipality of Montenegro)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Herceg Novi (Municipality of Montenegro)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Herceg Novi (Municipality of Montenegro)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Herceg Novi (Municipality of Montenegro)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Herceg Novi (Municipality of Montenegro)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Herceg Novi (Municipality of Montenegro)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Herceg Novi (Municipality of Montenegro)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Herceg Novi (Municipality of Montenegro)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Herceg Novi (Municipality of Montenegro)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Herceg Novi (Municipality of Montenegro)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Herceg Novi (Municipality of Montenegro)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Herceg Novi (Municipality of Montenegro)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Herceg Novi (Municipality of Montenegro)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Herceg Novi (Municipality of Montenegro)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Herceg Novi (Municipality of Montenegro)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Herceg Novi (Municipality of Montenegro)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Herceg Novi (Municipality of Montenegro)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Herceg Novi (Municipality of Montenegro)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Heredia (Province of Costa Rica)": [
            {
                "Region Name": "Heredia (Province of Costa Rica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heredia (Province of Costa Rica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heredia (Province of Costa Rica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heredia (Province of Costa Rica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Heredia (Province of Costa Rica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heredia (Province of Costa Rica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heredia (Province of Costa Rica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heredia (Province of Costa Rica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heredia (Province of Costa Rica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heredia (Province of Costa Rica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heredia (Province of Costa Rica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heredia (Province of Costa Rica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heredia (Province of Costa Rica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heredia (Province of Costa Rica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heredia (Province of Costa Rica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heredia (Province of Costa Rica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heredia (Province of Costa Rica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heredia (Province of Costa Rica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heredia (Province of Costa Rica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heredia (Province of Costa Rica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heredia (Province of Costa Rica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heredia (Province of Costa Rica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Herrera (Province of Panama)": [
            {
                "Region Name": "Herrera (Province of Panama)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Herrera (Province of Panama)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Herrera (Province of Panama)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Herrera (Province of Panama)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Herrera (Province of Panama)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Herrera (Province of Panama)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Herrera (Province of Panama)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Herrera (Province of Panama)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Herrera (Province of Panama)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Herrera (Province of Panama)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Herrera (Province of Panama)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Herrera (Province of Panama)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Herrera (Province of Panama)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Herrera (Province of Panama)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Herrera (Province of Panama)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Herrera (Province of Panama)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Herrera (Province of Panama)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Herrera (Province of Panama)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Herrera (Province of Panama)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Herrera (Province of Panama)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Herrera (Province of Panama)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Herrera (Province of Panama)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Hessen (State of Germany)": [
            {
                "Region Name": "Hessen (State of Germany)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hessen (State of Germany)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hessen (State of Germany)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hessen (State of Germany)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hessen (State of Germany)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hessen (State of Germany)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hessen (State of Germany)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hessen (State of Germany)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hessen (State of Germany)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hessen (State of Germany)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hessen (State of Germany)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hessen (State of Germany)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hessen (State of Germany)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hessen (State of Germany)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hessen (State of Germany)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hessen (State of Germany)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hessen (State of Germany)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hessen (State of Germany)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hessen (State of Germany)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hessen (State of Germany)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hessen (State of Germany)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hessen (State of Germany)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Heves (County of Hungary)": [
            {
                "Region Name": "Heves (County of Hungary)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heves (County of Hungary)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heves (County of Hungary)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Heves (County of Hungary)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Heves (County of Hungary)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Heves (County of Hungary)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Heves (County of Hungary)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Heves (County of Hungary)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Heves (County of Hungary)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heves (County of Hungary)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Heves (County of Hungary)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heves (County of Hungary)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Heves (County of Hungary)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Heves (County of Hungary)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heves (County of Hungary)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heves (County of Hungary)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heves (County of Hungary)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heves (County of Hungary)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heves (County of Hungary)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heves (County of Hungary)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heves (County of Hungary)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Heves (County of Hungary)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hhohho (District of Swaziland)": [
            {
                "Region Name": "Hhohho (District of Swaziland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hhohho (District of Swaziland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Hhohho (District of Swaziland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Hhohho (District of Swaziland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Hhohho (District of Swaziland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hhohho (District of Swaziland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Hhohho (District of Swaziland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Hhohho (District of Swaziland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Hhohho (District of Swaziland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Hhohho (District of Swaziland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Hhohho (District of Swaziland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Hhohho (District of Swaziland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Hhohho (District of Swaziland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Hhohho (District of Swaziland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hhohho (District of Swaziland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Hhohho (District of Swaziland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Hhohho (District of Swaziland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hhohho (District of Swaziland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Hhohho (District of Swaziland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Hhohho (District of Swaziland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Hhohho (District of Swaziland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Hhohho (District of Swaziland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Hidalgo (State of M\xe9xico)": [
            {
                "Region Name": "Hidalgo (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hidalgo (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hidalgo (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hidalgo (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hidalgo (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hidalgo (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hidalgo (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hidalgo (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hidalgo (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hidalgo (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hidalgo (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hidalgo (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hidalgo (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hidalgo (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hidalgo (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hidalgo (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hidalgo (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hidalgo (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hidalgo (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hidalgo (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hidalgo (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hidalgo (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Hiiraan (Region of Somalia)": [
            {
                "Region Name": "Hiiraan (Region of Somalia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiraan (Region of Somalia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiraan (Region of Somalia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiraan (Region of Somalia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Hiiraan (Region of Somalia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hiiraan (Region of Somalia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiraan (Region of Somalia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiraan (Region of Somalia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiraan (Region of Somalia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiraan (Region of Somalia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiraan (Region of Somalia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Hiiraan (Region of Somalia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Hiiraan (Region of Somalia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Hiiraan (Region of Somalia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiraan (Region of Somalia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiraan (Region of Somalia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiraan (Region of Somalia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hiiraan (Region of Somalia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Hiiraan (Region of Somalia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Hiiraan (Region of Somalia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hiiraan (Region of Somalia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiraan (Region of Somalia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hiiu (County of Estonia)": [
            {
                "Region Name": "Hiiu (County of Estonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hiiu (County of Estonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiu (County of Estonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiu (County of Estonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiu (County of Estonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiu (County of Estonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiu (County of Estonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiu (County of Estonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiu (County of Estonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiu (County of Estonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiu (County of Estonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiu (County of Estonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiu (County of Estonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiu (County of Estonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiu (County of Estonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiu (County of Estonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiu (County of Estonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiu (County of Estonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiu (County of Estonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiu (County of Estonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiu (County of Estonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiiu (County of Estonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hilmand (Province of Afghanistan)": [
            {
                "Region Name": "Hilmand (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hilmand (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hilmand (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hilmand (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hilmand (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hilmand (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hilmand (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hilmand (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hilmand (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hilmand (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hilmand (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hilmand (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hilmand (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hilmand (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hilmand (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hilmand (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hilmand (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hilmand (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hilmand (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hilmand (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hilmand (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hilmand (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Himachal Pradesh (Union Territory of India)": [
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Himachal Pradesh (Union Territory of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hims (Governorate of Syria)": [
            {
                "Region Name": "Hims (Governorate of Syria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hims (Governorate of Syria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hims (Governorate of Syria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hims (Governorate of Syria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hims (Governorate of Syria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hims (Governorate of Syria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hims (Governorate of Syria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hims (Governorate of Syria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hims (Governorate of Syria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hims (Governorate of Syria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hims (Governorate of Syria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hims (Governorate of Syria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hims (Governorate of Syria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Hims (Governorate of Syria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Hims (Governorate of Syria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hims (Governorate of Syria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hims (Governorate of Syria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hims (Governorate of Syria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Hims (Governorate of Syria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Hims (Governorate of Syria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hims (Governorate of Syria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hims (Governorate of Syria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "H\xeence\u0219ti (District of Moldova)": [
            {
                "Region Name": "H\xeence\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xeence\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xeence\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xeence\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "H\xeence\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xeence\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xeence\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "H\xeence\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "H\xeence\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xeence\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xeence\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "H\xeence\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "H\xeence\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xeence\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xeence\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "H\xeence\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "H\xeence\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xeence\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xeence\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xeence\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xeence\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xeence\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hirat (Province of Afghanistan)": [
            {
                "Region Name": "Hirat (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hirat (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Hirat (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hirat (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hirat (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hirat (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hirat (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hirat (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hirat (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hirat (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hirat (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hirat (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hirat (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hirat (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hirat (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hirat (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hirat (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hirat (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hirat (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hirat (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hirat (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hirat (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hiroshima (Prefecture of Japan)": [
            {
                "Region Name": "Hiroshima (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiroshima (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiroshima (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiroshima (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiroshima (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiroshima (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiroshima (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiroshima (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiroshima (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hiroshima (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiroshima (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiroshima (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiroshima (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiroshima (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiroshima (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiroshima (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiroshima (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiroshima (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiroshima (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiroshima (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiroshima (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hiroshima (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "H\u1ED3 Ch\xed Minh (City of Vietnam)": [
            {
                "Region Name": "H\u1ED3 Ch\xed Minh (City of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1ED3 Ch\xed Minh (City of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1ED3 Ch\xed Minh (City of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1ED3 Ch\xed Minh (City of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1ED3 Ch\xed Minh (City of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1ED3 Ch\xed Minh (City of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1ED3 Ch\xed Minh (City of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1ED3 Ch\xed Minh (City of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "H\u1ED3 Ch\xed Minh (City of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1ED3 Ch\xed Minh (City of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1ED3 Ch\xed Minh (City of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1ED3 Ch\xed Minh (City of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1ED3 Ch\xed Minh (City of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\u1ED3 Ch\xed Minh (City of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1ED3 Ch\xed Minh (City of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1ED3 Ch\xed Minh (City of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1ED3 Ch\xed Minh (City of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1ED3 Ch\xed Minh (City of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1ED3 Ch\xed Minh (City of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1ED3 Ch\xed Minh (City of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u1ED3 Ch\xed Minh (City of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "H\u1ED3 Ch\xed Minh (City of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "H\xf2a B\xecnh (Province of Vietnam)": [
            {
                "Region Name": "H\xf2a B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "H\xf2a B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "H\xf2a B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf2a B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "H\xf2a B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "H\xf2a B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xf2a B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf2a B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf2a B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xf2a B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf2a B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf2a B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf2a B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf2a B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "H\xf2a B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf2a B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf2a B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf2a B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "H\xf2a B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf2a B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf2a B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf2a B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Hodh ech Chargui (Region of Mauritania)": [
            {
                "Region Name": "Hodh ech Chargui (Region of Mauritania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hodh ech Chargui (Region of Mauritania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Hodh ech Chargui (Region of Mauritania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "Hodh ech Chargui (Region of Mauritania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 82
            },
            {
                "Region Name": "Hodh ech Chargui (Region of Mauritania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 161
            },
            {
                "Region Name": "Hodh ech Chargui (Region of Mauritania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 139
            },
            {
                "Region Name": "Hodh ech Chargui (Region of Mauritania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 116
            },
            {
                "Region Name": "Hodh ech Chargui (Region of Mauritania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 118
            },
            {
                "Region Name": "Hodh ech Chargui (Region of Mauritania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 233
            },
            {
                "Region Name": "Hodh ech Chargui (Region of Mauritania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 199
            },
            {
                "Region Name": "Hodh ech Chargui (Region of Mauritania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 178
            },
            {
                "Region Name": "Hodh ech Chargui (Region of Mauritania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 102
            },
            {
                "Region Name": "Hodh ech Chargui (Region of Mauritania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Hodh ech Chargui (Region of Mauritania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Hodh ech Chargui (Region of Mauritania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Hodh ech Chargui (Region of Mauritania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Hodh ech Chargui (Region of Mauritania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Hodh ech Chargui (Region of Mauritania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 226
            },
            {
                "Region Name": "Hodh ech Chargui (Region of Mauritania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 105
            },
            {
                "Region Name": "Hodh ech Chargui (Region of Mauritania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 185
            },
            {
                "Region Name": "Hodh ech Chargui (Region of Mauritania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 87
            },
            {
                "Region Name": "Hodh ech Chargui (Region of Mauritania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 33
            }
        ],
        "Hodh el Gharbi (Region of Mauritania)": [
            {
                "Region Name": "Hodh el Gharbi (Region of Mauritania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hodh el Gharbi (Region of Mauritania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Hodh el Gharbi (Region of Mauritania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 92
            },
            {
                "Region Name": "Hodh el Gharbi (Region of Mauritania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Hodh el Gharbi (Region of Mauritania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Hodh el Gharbi (Region of Mauritania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 274
            },
            {
                "Region Name": "Hodh el Gharbi (Region of Mauritania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Hodh el Gharbi (Region of Mauritania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 71
            },
            {
                "Region Name": "Hodh el Gharbi (Region of Mauritania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Hodh el Gharbi (Region of Mauritania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Hodh el Gharbi (Region of Mauritania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hodh el Gharbi (Region of Mauritania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hodh el Gharbi (Region of Mauritania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Hodh el Gharbi (Region of Mauritania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 78
            },
            {
                "Region Name": "Hodh el Gharbi (Region of Mauritania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Hodh el Gharbi (Region of Mauritania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Hodh el Gharbi (Region of Mauritania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hodh el Gharbi (Region of Mauritania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hodh el Gharbi (Region of Mauritania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Hodh el Gharbi (Region of Mauritania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Hodh el Gharbi (Region of Mauritania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hodh el Gharbi (Region of Mauritania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 49
            }
        ],
        "H\xf6fu\xf0borgarsv\xe6\xf0i\xf0 (Region of Iceland)": [
            {
                "Region Name": "H\xf6fu\xf0borgarsv\xe6\xf0i\xf0 (Region of Iceland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf6fu\xf0borgarsv\xe6\xf0i\xf0 (Region of Iceland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf6fu\xf0borgarsv\xe6\xf0i\xf0 (Region of Iceland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf6fu\xf0borgarsv\xe6\xf0i\xf0 (Region of Iceland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf6fu\xf0borgarsv\xe6\xf0i\xf0 (Region of Iceland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf6fu\xf0borgarsv\xe6\xf0i\xf0 (Region of Iceland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf6fu\xf0borgarsv\xe6\xf0i\xf0 (Region of Iceland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf6fu\xf0borgarsv\xe6\xf0i\xf0 (Region of Iceland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf6fu\xf0borgarsv\xe6\xf0i\xf0 (Region of Iceland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf6fu\xf0borgarsv\xe6\xf0i\xf0 (Region of Iceland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf6fu\xf0borgarsv\xe6\xf0i\xf0 (Region of Iceland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf6fu\xf0borgarsv\xe6\xf0i\xf0 (Region of Iceland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf6fu\xf0borgarsv\xe6\xf0i\xf0 (Region of Iceland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf6fu\xf0borgarsv\xe6\xf0i\xf0 (Region of Iceland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf6fu\xf0borgarsv\xe6\xf0i\xf0 (Region of Iceland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf6fu\xf0borgarsv\xe6\xf0i\xf0 (Region of Iceland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf6fu\xf0borgarsv\xe6\xf0i\xf0 (Region of Iceland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf6fu\xf0borgarsv\xe6\xf0i\xf0 (Region of Iceland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf6fu\xf0borgarsv\xe6\xf0i\xf0 (Region of Iceland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf6fu\xf0borgarsv\xe6\xf0i\xf0 (Region of Iceland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf6fu\xf0borgarsv\xe6\xf0i\xf0 (Region of Iceland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf6fu\xf0borgarsv\xe6\xf0i\xf0 (Region of Iceland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hoima (District of Uganda)": [
            {
                "Region Name": "Hoima (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hoima (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hoima (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hoima (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Hoima (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Hoima (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hoima (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hoima (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hoima (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hoima (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hoima (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hoima (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hoima (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hoima (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Hoima (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hoima (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hoima (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Hoima (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Hoima (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hoima (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hoima (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hoima (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Hokkaido (Circuit of Japan)": [
            {
                "Region Name": "Hokkaido (Circuit of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hokkaido (Circuit of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hokkaido (Circuit of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hokkaido (Circuit of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hokkaido (Circuit of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hokkaido (Circuit of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hokkaido (Circuit of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hokkaido (Circuit of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hokkaido (Circuit of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hokkaido (Circuit of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hokkaido (Circuit of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hokkaido (Circuit of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hokkaido (Circuit of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hokkaido (Circuit of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hokkaido (Circuit of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hokkaido (Circuit of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hokkaido (Circuit of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hokkaido (Circuit of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hokkaido (Circuit of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hokkaido (Circuit of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hokkaido (Circuit of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hokkaido (Circuit of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Holgu\xedn (Province of Cuba)": [
            {
                "Region Name": "Holgu\xedn (Province of Cuba)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Holgu\xedn (Province of Cuba)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Holgu\xedn (Province of Cuba)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Holgu\xedn (Province of Cuba)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Holgu\xedn (Province of Cuba)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Holgu\xedn (Province of Cuba)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Holgu\xedn (Province of Cuba)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Holgu\xedn (Province of Cuba)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Holgu\xedn (Province of Cuba)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Holgu\xedn (Province of Cuba)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Holgu\xedn (Province of Cuba)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Holgu\xedn (Province of Cuba)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Holgu\xedn (Province of Cuba)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Holgu\xedn (Province of Cuba)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Holgu\xedn (Province of Cuba)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Holgu\xedn (Province of Cuba)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Holgu\xedn (Province of Cuba)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Holgu\xedn (Province of Cuba)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Holgu\xedn (Province of Cuba)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Holgu\xedn (Province of Cuba)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Holgu\xedn (Province of Cuba)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Holgu\xedn (Province of Cuba)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Homa Bay (County of Kenya)": [
            {
                "Region Name": "Homa Bay (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Homa Bay (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Homa Bay (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Homa Bay (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Homa Bay (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Homa Bay (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Homa Bay (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Homa Bay (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Homa Bay (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Homa Bay (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Homa Bay (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Homa Bay (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Homa Bay (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Homa Bay (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Homa Bay (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Homa Bay (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Homa Bay (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Homa Bay (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Homa Bay (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Homa Bay (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Homa Bay (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Homa Bay (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hong Kong (Special Administrative Region of China)": [
            {
                "Region Name": "Hong Kong (Special Administrative Region of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hong Kong (Special Administrative Region of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hong Kong (Special Administrative Region of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hong Kong (Special Administrative Region of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hong Kong (Special Administrative Region of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Hong Kong (Special Administrative Region of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Hong Kong (Special Administrative Region of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hong Kong (Special Administrative Region of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hong Kong (Special Administrative Region of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hong Kong (Special Administrative Region of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hong Kong (Special Administrative Region of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hong Kong (Special Administrative Region of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hong Kong (Special Administrative Region of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hong Kong (Special Administrative Region of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Hong Kong (Special Administrative Region of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hong Kong (Special Administrative Region of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hong Kong (Special Administrative Region of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hong Kong (Special Administrative Region of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hong Kong (Special Administrative Region of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hong Kong (Special Administrative Region of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hong Kong (Special Administrative Region of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hong Kong (Special Administrative Region of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Honiara (Capital Territory of Solomon Islands)": [
            {
                "Region Name": "Honiara (Capital Territory of Solomon Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Honiara (Capital Territory of Solomon Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Honiara (Capital Territory of Solomon Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Honiara (Capital Territory of Solomon Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Honiara (Capital Territory of Solomon Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Honiara (Capital Territory of Solomon Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Honiara (Capital Territory of Solomon Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Honiara (Capital Territory of Solomon Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Honiara (Capital Territory of Solomon Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Honiara (Capital Territory of Solomon Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Honiara (Capital Territory of Solomon Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Honiara (Capital Territory of Solomon Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Honiara (Capital Territory of Solomon Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Honiara (Capital Territory of Solomon Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Honiara (Capital Territory of Solomon Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Honiara (Capital Territory of Solomon Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Honiara (Capital Territory of Solomon Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Honiara (Capital Territory of Solomon Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Honiara (Capital Territory of Solomon Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Honiara (Capital Territory of Solomon Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Honiara (Capital Territory of Solomon Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Honiara (Capital Territory of Solomon Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hope Town (District of Bahamas)": [
            {
                "Region Name": "Hope Town (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hope Town (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hope Town (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hope Town (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hope Town (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hope Town (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hope Town (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hope Town (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hope Town (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hope Town (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hope Town (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hope Town (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hope Town (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hope Town (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hope Town (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hope Town (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hope Town (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hope Town (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hope Town (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hope Town (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hope Town (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hope Town (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hordaland (County of Norway)": [
            {
                "Region Name": "Hordaland (County of Norway)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hordaland (County of Norway)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hordaland (County of Norway)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hordaland (County of Norway)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hordaland (County of Norway)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Hordaland (County of Norway)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hordaland (County of Norway)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hordaland (County of Norway)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hordaland (County of Norway)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hordaland (County of Norway)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hordaland (County of Norway)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hordaland (County of Norway)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hordaland (County of Norway)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hordaland (County of Norway)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hordaland (County of Norway)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hordaland (County of Norway)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hordaland (County of Norway)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hordaland (County of Norway)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hordaland (County of Norway)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hordaland (County of Norway)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hordaland (County of Norway)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hordaland (County of Norway)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hormigueros (Municipality of Puerto Rico)": [
            {
                "Region Name": "Hormigueros (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormigueros (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormigueros (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormigueros (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormigueros (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormigueros (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormigueros (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormigueros (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormigueros (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormigueros (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormigueros (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormigueros (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormigueros (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormigueros (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormigueros (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormigueros (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormigueros (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormigueros (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormigueros (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormigueros (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormigueros (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormigueros (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hormozgan (Province of Iran)": [
            {
                "Region Name": "Hormozgan (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hormozgan (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormozgan (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hormozgan (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hormozgan (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hormozgan (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hormozgan (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hormozgan (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hormozgan (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hormozgan (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormozgan (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormozgan (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hormozgan (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hormozgan (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormozgan (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hormozgan (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hormozgan (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormozgan (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hormozgan (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hormozgan (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormozgan (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hormozgan (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Houaphan (Province of Laos)": [
            {
                "Region Name": "Houaphan (Province of Laos)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Houaphan (Province of Laos)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Houaphan (Province of Laos)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Houaphan (Province of Laos)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Houaphan (Province of Laos)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Houaphan (Province of Laos)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Houaphan (Province of Laos)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Houaphan (Province of Laos)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Houaphan (Province of Laos)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Houaphan (Province of Laos)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Houaphan (Province of Laos)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Houaphan (Province of Laos)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Houaphan (Province of Laos)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Houaphan (Province of Laos)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Houaphan (Province of Laos)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Houaphan (Province of Laos)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Houaphan (Province of Laos)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Houaphan (Province of Laos)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Houaphan (Province of Laos)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Houaphan (Province of Laos)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Houaphan (Province of Laos)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Houaphan (Province of Laos)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Hovd (Province of Mongolia)": [
            {
                "Region Name": "Hovd (Province of Mongolia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hovd (Province of Mongolia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hovd (Province of Mongolia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovd (Province of Mongolia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hovd (Province of Mongolia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hovd (Province of Mongolia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Hovd (Province of Mongolia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Hovd (Province of Mongolia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Hovd (Province of Mongolia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Hovd (Province of Mongolia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovd (Province of Mongolia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Hovd (Province of Mongolia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovd (Province of Mongolia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovd (Province of Mongolia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovd (Province of Mongolia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovd (Province of Mongolia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hovd (Province of Mongolia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovd (Province of Mongolia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovd (Province of Mongolia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovd (Province of Mongolia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovd (Province of Mongolia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Hovd (Province of Mongolia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hovedstaden (Region of Denmark)": [
            {
                "Region Name": "Hovedstaden (Region of Denmark)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hovedstaden (Region of Denmark)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovedstaden (Region of Denmark)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hovedstaden (Region of Denmark)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovedstaden (Region of Denmark)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hovedstaden (Region of Denmark)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovedstaden (Region of Denmark)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovedstaden (Region of Denmark)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovedstaden (Region of Denmark)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovedstaden (Region of Denmark)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovedstaden (Region of Denmark)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovedstaden (Region of Denmark)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovedstaden (Region of Denmark)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovedstaden (Region of Denmark)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hovedstaden (Region of Denmark)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovedstaden (Region of Denmark)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovedstaden (Region of Denmark)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovedstaden (Region of Denmark)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovedstaden (Region of Denmark)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovedstaden (Region of Denmark)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovedstaden (Region of Denmark)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hovedstaden (Region of Denmark)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "H\xf6vsg\xf6l (Province of Mongolia)": [
            {
                "Region Name": "H\xf6vsg\xf6l (Province of Mongolia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "H\xf6vsg\xf6l (Province of Mongolia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "H\xf6vsg\xf6l (Province of Mongolia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xf6vsg\xf6l (Province of Mongolia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "H\xf6vsg\xf6l (Province of Mongolia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "H\xf6vsg\xf6l (Province of Mongolia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "H\xf6vsg\xf6l (Province of Mongolia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 76
            },
            {
                "Region Name": "H\xf6vsg\xf6l (Province of Mongolia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "H\xf6vsg\xf6l (Province of Mongolia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xf6vsg\xf6l (Province of Mongolia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "H\xf6vsg\xf6l (Province of Mongolia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 79
            },
            {
                "Region Name": "H\xf6vsg\xf6l (Province of Mongolia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xf6vsg\xf6l (Province of Mongolia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "H\xf6vsg\xf6l (Province of Mongolia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "H\xf6vsg\xf6l (Province of Mongolia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\xf6vsg\xf6l (Province of Mongolia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "H\xf6vsg\xf6l (Province of Mongolia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "H\xf6vsg\xf6l (Province of Mongolia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "H\xf6vsg\xf6l (Province of Mongolia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf6vsg\xf6l (Province of Mongolia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\xf6vsg\xf6l (Province of Mongolia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "H\xf6vsg\xf6l (Province of Mongolia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Howland (Island of United States Minor Outlying Isl)": [
            {
                "Region Name": "Howland (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Howland (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Howland (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Howland (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Howland (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Howland (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Howland (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Howland (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Howland (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Howland (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Howland (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Howland (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Howland (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Howland (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Howland (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Howland (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Howland (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Howland (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Howland (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Howland (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Howland (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Howland (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Huambo (Province of Angola)": [
            {
                "Region Name": "Huambo (Province of Angola)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Huambo (Province of Angola)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Huambo (Province of Angola)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Huambo (Province of Angola)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Huambo (Province of Angola)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Huambo (Province of Angola)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Huambo (Province of Angola)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Huambo (Province of Angola)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Huambo (Province of Angola)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Huambo (Province of Angola)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Huambo (Province of Angola)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Huambo (Province of Angola)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Huambo (Province of Angola)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Huambo (Province of Angola)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Huambo (Province of Angola)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Huambo (Province of Angola)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Huambo (Province of Angola)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Huambo (Province of Angola)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Huambo (Province of Angola)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Huambo (Province of Angola)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Huambo (Province of Angola)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Huambo (Province of Angola)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Huancavelica (Region of Peru)": [
            {
                "Region Name": "Huancavelica (Region of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Huancavelica (Region of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Huancavelica (Region of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Huancavelica (Region of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Huancavelica (Region of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Huancavelica (Region of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Huancavelica (Region of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Huancavelica (Region of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Huancavelica (Region of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Huancavelica (Region of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Huancavelica (Region of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Huancavelica (Region of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Huancavelica (Region of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Huancavelica (Region of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Huancavelica (Region of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Huancavelica (Region of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Huancavelica (Region of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Huancavelica (Region of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Huancavelica (Region of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Huancavelica (Region of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Huancavelica (Region of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Huancavelica (Region of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Hu\xe1nuco (Region of Peru)": [
            {
                "Region Name": "Hu\xe1nuco (Region of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hu\xe1nuco (Region of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hu\xe1nuco (Region of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hu\xe1nuco (Region of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hu\xe1nuco (Region of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hu\xe1nuco (Region of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hu\xe1nuco (Region of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hu\xe1nuco (Region of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hu\xe1nuco (Region of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hu\xe1nuco (Region of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hu\xe1nuco (Region of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hu\xe1nuco (Region of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hu\xe1nuco (Region of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hu\xe1nuco (Region of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hu\xe1nuco (Region of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hu\xe1nuco (Region of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hu\xe1nuco (Region of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hu\xe1nuco (Region of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hu\xe1nuco (Region of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hu\xe1nuco (Region of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hu\xe1nuco (Region of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hu\xe1nuco (Region of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Hubei (Province of China)": [
            {
                "Region Name": "Hubei (Province of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Hubei (Province of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Hubei (Province of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Hubei (Province of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Hubei (Province of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Hubei (Province of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Hubei (Province of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Hubei (Province of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Hubei (Province of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Hubei (Province of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Hubei (Province of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Hubei (Province of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Hubei (Province of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Hubei (Province of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Hubei (Province of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hubei (Province of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hubei (Province of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hubei (Province of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hubei (Province of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hubei (Province of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Hubei (Province of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hubei (Province of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Huehuetenango (Department of Guatemala)": [
            {
                "Region Name": "Huehuetenango (Department of Guatemala)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Huehuetenango (Department of Guatemala)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Huehuetenango (Department of Guatemala)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Huehuetenango (Department of Guatemala)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Huehuetenango (Department of Guatemala)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Huehuetenango (Department of Guatemala)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Huehuetenango (Department of Guatemala)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Huehuetenango (Department of Guatemala)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Huehuetenango (Department of Guatemala)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Huehuetenango (Department of Guatemala)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Huehuetenango (Department of Guatemala)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Huehuetenango (Department of Guatemala)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Huehuetenango (Department of Guatemala)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Huehuetenango (Department of Guatemala)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Huehuetenango (Department of Guatemala)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Huehuetenango (Department of Guatemala)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Huehuetenango (Department of Guatemala)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Huehuetenango (Department of Guatemala)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Huehuetenango (Department of Guatemala)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Huehuetenango (Department of Guatemala)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Huehuetenango (Department of Guatemala)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Huehuetenango (Department of Guatemala)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Huila (Department of Colombia)": [
            {
                "Region Name": "Huila (Department of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Huila (Department of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Huila (Department of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Huila (Department of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Huila (Department of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Huila (Department of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Huila (Department of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Huila (Department of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Huila (Department of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Huila (Department of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Huila (Department of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Huila (Department of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Huila (Department of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Huila (Department of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Huila (Department of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Huila (Department of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Huila (Department of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Huila (Department of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Huila (Department of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Huila (Department of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Huila (Department of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Huila (Department of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Hu\xedla (Province of Angola)": [
            {
                "Region Name": "Hu\xedla (Province of Angola)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Hu\xedla (Province of Angola)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Hu\xedla (Province of Angola)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Hu\xedla (Province of Angola)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Hu\xedla (Province of Angola)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Hu\xedla (Province of Angola)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Hu\xedla (Province of Angola)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Hu\xedla (Province of Angola)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Hu\xedla (Province of Angola)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Hu\xedla (Province of Angola)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Hu\xedla (Province of Angola)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Hu\xedla (Province of Angola)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Hu\xedla (Province of Angola)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Hu\xedla (Province of Angola)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Hu\xedla (Province of Angola)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Hu\xedla (Province of Angola)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Hu\xedla (Province of Angola)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Hu\xedla (Province of Angola)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Hu\xedla (Province of Angola)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Hu\xedla (Province of Angola)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Hu\xedla (Province of Angola)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Hu\xedla (Province of Angola)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 16
            }
        ],
        "Humacao (Municipality of Puerto Rico)": [
            {
                "Region Name": "Humacao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Humacao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Humacao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Humacao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Humacao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Humacao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Humacao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Humacao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Humacao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Humacao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Humacao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Humacao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Humacao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Humacao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Humacao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Humacao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Humacao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Humacao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Humacao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Humacao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Humacao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Humacao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hunan (Province of China)": [
            {
                "Region Name": "Hunan (Province of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hunan (Province of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hunan (Province of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hunan (Province of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hunan (Province of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hunan (Province of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hunan (Province of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hunan (Province of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hunan (Province of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hunan (Province of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hunan (Province of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Hunan (Province of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hunan (Province of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hunan (Province of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hunan (Province of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hunan (Province of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hunan (Province of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hunan (Province of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hunan (Province of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hunan (Province of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hunan (Province of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Hunan (Province of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Hunedoara (County of Romania)": [
            {
                "Region Name": "Hunedoara (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hunedoara (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hunedoara (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hunedoara (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hunedoara (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Hunedoara (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hunedoara (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hunedoara (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hunedoara (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hunedoara (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hunedoara (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hunedoara (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hunedoara (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hunedoara (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hunedoara (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hunedoara (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hunedoara (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hunedoara (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hunedoara (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Hunedoara (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hunedoara (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hunedoara (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "H\u01B0ng Y\xean (Province of Vietnam)": [
            {
                "Region Name": "H\u01B0ng Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u01B0ng Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\u01B0ng Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u01B0ng Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u01B0ng Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\u01B0ng Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "H\u01B0ng Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u01B0ng Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u01B0ng Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u01B0ng Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u01B0ng Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u01B0ng Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u01B0ng Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u01B0ng Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u01B0ng Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u01B0ng Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u01B0ng Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u01B0ng Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u01B0ng Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u01B0ng Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u01B0ng Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "H\u01B0ng Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Hwanghae-bukto (Province of North Korea)": [
            {
                "Region Name": "Hwanghae-bukto (Province of North Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hwanghae-bukto (Province of North Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hwanghae-bukto (Province of North Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hwanghae-bukto (Province of North Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hwanghae-bukto (Province of North Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Hwanghae-bukto (Province of North Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hwanghae-bukto (Province of North Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hwanghae-bukto (Province of North Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hwanghae-bukto (Province of North Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Hwanghae-bukto (Province of North Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hwanghae-bukto (Province of North Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hwanghae-bukto (Province of North Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hwanghae-bukto (Province of North Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Hwanghae-bukto (Province of North Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hwanghae-bukto (Province of North Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hwanghae-bukto (Province of North Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hwanghae-bukto (Province of North Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Hwanghae-bukto (Province of North Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hwanghae-bukto (Province of North Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hwanghae-bukto (Province of North Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hwanghae-bukto (Province of North Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hwanghae-bukto (Province of North Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hwanghae-namdo (Province of North Korea)": [
            {
                "Region Name": "Hwanghae-namdo (Province of North Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hwanghae-namdo (Province of North Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hwanghae-namdo (Province of North Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hwanghae-namdo (Province of North Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hwanghae-namdo (Province of North Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hwanghae-namdo (Province of North Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hwanghae-namdo (Province of North Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hwanghae-namdo (Province of North Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Hwanghae-namdo (Province of North Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Hwanghae-namdo (Province of North Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hwanghae-namdo (Province of North Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hwanghae-namdo (Province of North Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Hwanghae-namdo (Province of North Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hwanghae-namdo (Province of North Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Hwanghae-namdo (Province of North Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hwanghae-namdo (Province of North Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Hwanghae-namdo (Province of North Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hwanghae-namdo (Province of North Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Hwanghae-namdo (Province of North Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hwanghae-namdo (Province of North Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hwanghae-namdo (Province of North Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hwanghae-namdo (Province of North Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Hy\u014Dgo (Prefecture of Japan)": [
            {
                "Region Name": "Hy\u014Dgo (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hy\u014Dgo (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hy\u014Dgo (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hy\u014Dgo (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hy\u014Dgo (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hy\u014Dgo (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hy\u014Dgo (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hy\u014Dgo (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hy\u014Dgo (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hy\u014Dgo (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hy\u014Dgo (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hy\u014Dgo (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hy\u014Dgo (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hy\u014Dgo (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hy\u014Dgo (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hy\u014Dgo (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hy\u014Dgo (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hy\u014Dgo (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hy\u014Dgo (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hy\u014Dgo (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hy\u014Dgo (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Hy\u014Dgo (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ialomi\u021Ba (County of Romania)": [
            {
                "Region Name": "Ialomi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ialomi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ialomi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ialomi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ialomi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ialomi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ialomi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ialomi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ialomi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ialomi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ialomi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ialomi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ialomi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ialomi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ialomi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ialomi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ialomi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ialomi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Ialomi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ialomi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ialomi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ialomi\u021Ba (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Ialoveni (District of Moldova)": [
            {
                "Region Name": "Ialoveni (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ialoveni (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ialoveni (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ialoveni (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ialoveni (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ialoveni (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ialoveni (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ialoveni (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ialoveni (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ialoveni (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ialoveni (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ialoveni (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ialoveni (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ialoveni (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ialoveni (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ialoveni (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ialoveni (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ialoveni (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ialoveni (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ialoveni (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ialoveni (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ialoveni (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ia\u0219i (County of Romania)": [
            {
                "Region Name": "Ia\u0219i (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ia\u0219i (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ia\u0219i (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ia\u0219i (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ia\u0219i (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ia\u0219i (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ia\u0219i (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ia\u0219i (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ia\u0219i (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ia\u0219i (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ia\u0219i (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ia\u0219i (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ia\u0219i (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ia\u0219i (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ia\u0219i (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ia\u0219i (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ia\u0219i (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ia\u0219i (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ia\u0219i (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ia\u0219i (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ia\u0219i (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ia\u0219i (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Ibaraki (Prefecture of Japan)": [
            {
                "Region Name": "Ibaraki (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibaraki (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibaraki (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibaraki (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ibaraki (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibaraki (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibaraki (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Ibaraki (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibaraki (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibaraki (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibaraki (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibaraki (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibaraki (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibaraki (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibaraki (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibaraki (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibaraki (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibaraki (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibaraki (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ibaraki (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibaraki (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibaraki (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ibb (Governorate of Yemen)": [
            {
                "Region Name": "Ibb (Governorate of Yemen)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibb (Governorate of Yemen)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibb (Governorate of Yemen)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibb (Governorate of Yemen)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibb (Governorate of Yemen)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibb (Governorate of Yemen)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibb (Governorate of Yemen)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibb (Governorate of Yemen)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibb (Governorate of Yemen)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibb (Governorate of Yemen)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibb (Governorate of Yemen)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibb (Governorate of Yemen)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibb (Governorate of Yemen)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibb (Governorate of Yemen)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibb (Governorate of Yemen)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibb (Governorate of Yemen)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibb (Governorate of Yemen)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibb (Governorate of Yemen)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibb (Governorate of Yemen)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibb (Governorate of Yemen)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ibb (Governorate of Yemen)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ibb (Governorate of Yemen)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Iburasirazuba (Province of Rwanda)": [
            {
                "Region Name": "Iburasirazuba (Province of Rwanda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Iburasirazuba (Province of Rwanda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Iburasirazuba (Province of Rwanda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Iburasirazuba (Province of Rwanda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Iburasirazuba (Province of Rwanda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Iburasirazuba (Province of Rwanda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Iburasirazuba (Province of Rwanda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Iburasirazuba (Province of Rwanda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Iburasirazuba (Province of Rwanda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Iburasirazuba (Province of Rwanda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Iburasirazuba (Province of Rwanda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Iburasirazuba (Province of Rwanda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Iburasirazuba (Province of Rwanda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Iburasirazuba (Province of Rwanda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Iburasirazuba (Province of Rwanda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Iburasirazuba (Province of Rwanda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Iburasirazuba (Province of Rwanda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Iburasirazuba (Province of Rwanda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Iburasirazuba (Province of Rwanda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Iburasirazuba (Province of Rwanda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Iburasirazuba (Province of Rwanda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Iburasirazuba (Province of Rwanda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 23
            }
        ],
        "Iburengerazuba (Province of Rwanda)": [
            {
                "Region Name": "Iburengerazuba (Province of Rwanda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Iburengerazuba (Province of Rwanda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iburengerazuba (Province of Rwanda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Iburengerazuba (Province of Rwanda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Iburengerazuba (Province of Rwanda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iburengerazuba (Province of Rwanda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iburengerazuba (Province of Rwanda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iburengerazuba (Province of Rwanda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Iburengerazuba (Province of Rwanda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Iburengerazuba (Province of Rwanda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iburengerazuba (Province of Rwanda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iburengerazuba (Province of Rwanda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Iburengerazuba (Province of Rwanda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iburengerazuba (Province of Rwanda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Iburengerazuba (Province of Rwanda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Iburengerazuba (Province of Rwanda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Iburengerazuba (Province of Rwanda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Iburengerazuba (Province of Rwanda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Iburengerazuba (Province of Rwanda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iburengerazuba (Province of Rwanda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Iburengerazuba (Province of Rwanda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iburengerazuba (Province of Rwanda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Ica (Region of Peru)": [
            {
                "Region Name": "Ica (Region of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ica (Region of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ica (Region of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ica (Region of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ica (Region of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ica (Region of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ica (Region of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ica (Region of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ica (Region of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ica (Region of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ica (Region of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ica (Region of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ica (Region of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ica (Region of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ica (Region of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ica (Region of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ica (Region of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ica (Region of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ica (Region of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ica (Region of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ica (Region of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ica (Region of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ida-Viru (County of Estonia)": [
            {
                "Region Name": "Ida-Viru (County of Estonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ida-Viru (County of Estonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ida-Viru (County of Estonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ida-Viru (County of Estonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ida-Viru (County of Estonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ida-Viru (County of Estonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ida-Viru (County of Estonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ida-Viru (County of Estonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ida-Viru (County of Estonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ida-Viru (County of Estonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ida-Viru (County of Estonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ida-Viru (County of Estonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ida-Viru (County of Estonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ida-Viru (County of Estonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ida-Viru (County of Estonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ida-Viru (County of Estonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ida-Viru (County of Estonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ida-Viru (County of Estonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ida-Viru (County of Estonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ida-Viru (County of Estonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ida-Viru (County of Estonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ida-Viru (County of Estonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Idaho (State of United States)": [
            {
                "Region Name": "Idaho (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Idaho (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Idaho (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Idaho (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Idaho (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Idaho (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Idaho (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Idaho (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Idaho (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Idaho (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Idaho (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Idaho (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Idaho (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Idaho (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Idaho (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Idaho (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Idaho (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Idaho (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Idaho (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Idaho (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Idaho (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Idaho (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Idlib (Governorate of Syria)": [
            {
                "Region Name": "Idlib (Governorate of Syria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Idlib (Governorate of Syria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Idlib (Governorate of Syria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Idlib (Governorate of Syria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Idlib (Governorate of Syria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Idlib (Governorate of Syria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Idlib (Governorate of Syria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Idlib (Governorate of Syria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Idlib (Governorate of Syria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Idlib (Governorate of Syria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Idlib (Governorate of Syria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Idlib (Governorate of Syria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Idlib (Governorate of Syria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Idlib (Governorate of Syria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Idlib (Governorate of Syria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Idlib (Governorate of Syria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Idlib (Governorate of Syria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Idlib (Governorate of Syria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Idlib (Governorate of Syria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Idlib (Governorate of Syria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Idlib (Governorate of Syria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Idlib (Governorate of Syria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Ifugao (Province of Philippines)": [
            {
                "Region Name": "Ifugao (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ifugao (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ifugao (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ifugao (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ifugao (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ifugao (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ifugao (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ifugao (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ifugao (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ifugao (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ifugao (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ifugao (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ifugao (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ifugao (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ifugao (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ifugao (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ifugao (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ifugao (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ifugao (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ifugao (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ifugao (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ifugao (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Iganga (District of Uganda)": [
            {
                "Region Name": "Iganga (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Iganga (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Iganga (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Iganga (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Iganga (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Iganga (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Iganga (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Iganga (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Iganga (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Iganga (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Iganga (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iganga (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Iganga (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Iganga (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Iganga (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Iganga (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Iganga (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Iganga (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iganga (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iganga (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Iganga (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Iganga (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "I\u011Fd\u0131r (Province of Turkey)": [
            {
                "Region Name": "I\u011Fd\u0131r (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "I\u011Fd\u0131r (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "I\u011Fd\u0131r (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "I\u011Fd\u0131r (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "I\u011Fd\u0131r (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "I\u011Fd\u0131r (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "I\u011Fd\u0131r (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "I\u011Fd\u0131r (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "I\u011Fd\u0131r (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "I\u011Fd\u0131r (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "I\u011Fd\u0131r (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "I\u011Fd\u0131r (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "I\u011Fd\u0131r (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "I\u011Fd\u0131r (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "I\u011Fd\u0131r (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "I\u011Fd\u0131r (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "I\u011Fd\u0131r (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "I\u011Fd\u0131r (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "I\u011Fd\u0131r (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "I\u011Fd\u0131r (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "I\u011Fd\u0131r (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "I\u011Fd\u0131r (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "IJsselmeer (Water body of Netherlands)": [
            {
                "Region Name": "IJsselmeer (Water body of Netherlands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "IJsselmeer (Water body of Netherlands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "IJsselmeer (Water body of Netherlands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "IJsselmeer (Water body of Netherlands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "IJsselmeer (Water body of Netherlands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "IJsselmeer (Water body of Netherlands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "IJsselmeer (Water body of Netherlands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "IJsselmeer (Water body of Netherlands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "IJsselmeer (Water body of Netherlands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "IJsselmeer (Water body of Netherlands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "IJsselmeer (Water body of Netherlands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "IJsselmeer (Water body of Netherlands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "IJsselmeer (Water body of Netherlands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "IJsselmeer (Water body of Netherlands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "IJsselmeer (Water body of Netherlands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "IJsselmeer (Water body of Netherlands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "IJsselmeer (Water body of Netherlands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "IJsselmeer (Water body of Netherlands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "IJsselmeer (Water body of Netherlands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "IJsselmeer (Water body of Netherlands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "IJsselmeer (Water body of Netherlands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "IJsselmeer (Water body of Netherlands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ijuw (District of Nauru)": [
            {
                "Region Name": "Ijuw (District of Nauru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ijuw (District of Nauru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ijuw (District of Nauru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ijuw (District of Nauru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ijuw (District of Nauru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ijuw (District of Nauru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ijuw (District of Nauru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ijuw (District of Nauru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ijuw (District of Nauru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ijuw (District of Nauru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ijuw (District of Nauru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ijuw (District of Nauru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ijuw (District of Nauru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ijuw (District of Nauru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ijuw (District of Nauru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ijuw (District of Nauru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ijuw (District of Nauru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ijuw (District of Nauru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ijuw (District of Nauru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ijuw (District of Nauru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ijuw (District of Nauru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ijuw (District of Nauru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ilam (Province of Iran)": [
            {
                "Region Name": "Ilam (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ilam (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ilam (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ilam (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ilam (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ilam (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ilam (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ilam (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ilam (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ilam (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ilam (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ilam (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ilam (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ilam (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ilam (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ilam (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ilam (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ilam (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ilam (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ilam (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ilam (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ilam (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "\xcele-de-France (Region of France)": [
            {
                "Region Name": "\xcele-de-France (Region of France)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "\xcele-de-France (Region of France)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xcele-de-France (Region of France)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xcele-de-France (Region of France)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xcele-de-France (Region of France)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\xcele-de-France (Region of France)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xcele-de-France (Region of France)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xcele-de-France (Region of France)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xcele-de-France (Region of France)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xcele-de-France (Region of France)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xcele-de-France (Region of France)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xcele-de-France (Region of France)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xcele-de-France (Region of France)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\xcele-de-France (Region of France)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "\xcele-de-France (Region of France)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "\xcele-de-France (Region of France)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xcele-de-France (Region of France)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xcele-de-France (Region of France)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xcele-de-France (Region of France)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xcele-de-France (Region of France)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xcele-de-France (Region of France)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xcele-de-France (Region of France)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "\xceles Australes (Administrative subdivisions of French Polynesia)": [
            {
                "Region Name": "\xceles Australes (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Australes (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Australes (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Australes (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Australes (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Australes (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Australes (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Australes (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Australes (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Australes (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Australes (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Australes (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Australes (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Australes (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Australes (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Australes (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Australes (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Australes (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Australes (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Australes (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Australes (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Australes (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\xceles Crozet (District of French Southern Territories)": [
            {
                "Region Name": "\xceles Crozet (District of French Southern Territories)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Crozet (District of French Southern Territories)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Crozet (District of French Southern Territories)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Crozet (District of French Southern Territories)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Crozet (District of French Southern Territories)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Crozet (District of French Southern Territories)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Crozet (District of French Southern Territories)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Crozet (District of French Southern Territories)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Crozet (District of French Southern Territories)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Crozet (District of French Southern Territories)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Crozet (District of French Southern Territories)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Crozet (District of French Southern Territories)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Crozet (District of French Southern Territories)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Crozet (District of French Southern Territories)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Crozet (District of French Southern Territories)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Crozet (District of French Southern Territories)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Crozet (District of French Southern Territories)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Crozet (District of French Southern Territories)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Crozet (District of French Southern Territories)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Crozet (District of French Southern Territories)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Crozet (District of French Southern Territories)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Crozet (District of French Southern Territories)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\xceles du Vent (Administrative subdivisions of French Polynesia)": [
            {
                "Region Name": "\xceles du Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles du Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles du Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles du Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles du Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles du Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles du Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles du Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles du Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles du Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles du Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles du Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles du Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles du Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles du Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles du Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles du Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles du Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles du Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles du Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles du Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles du Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\xceles \xc9parses (District of French Southern Territories)": [
            {
                "Region Name": "\xceles \xc9parses (District of French Southern Territories)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles \xc9parses (District of French Southern Territories)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles \xc9parses (District of French Southern Territories)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles \xc9parses (District of French Southern Territories)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles \xc9parses (District of French Southern Territories)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles \xc9parses (District of French Southern Territories)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles \xc9parses (District of French Southern Territories)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles \xc9parses (District of French Southern Territories)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles \xc9parses (District of French Southern Territories)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles \xc9parses (District of French Southern Territories)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles \xc9parses (District of French Southern Territories)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles \xc9parses (District of French Southern Territories)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles \xc9parses (District of French Southern Territories)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles \xc9parses (District of French Southern Territories)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles \xc9parses (District of French Southern Territories)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles \xc9parses (District of French Southern Territories)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles \xc9parses (District of French Southern Territories)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles \xc9parses (District of French Southern Territories)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles \xc9parses (District of French Southern Territories)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles \xc9parses (District of French Southern Territories)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles \xc9parses (District of French Southern Territories)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles \xc9parses (District of French Southern Territories)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\xceles Loyaut\xe9 (Province of New Caledonia)": [
            {
                "Region Name": "\xceles Loyaut\xe9 (Province of New Caledonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Loyaut\xe9 (Province of New Caledonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Loyaut\xe9 (Province of New Caledonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Loyaut\xe9 (Province of New Caledonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Loyaut\xe9 (Province of New Caledonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Loyaut\xe9 (Province of New Caledonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Loyaut\xe9 (Province of New Caledonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Loyaut\xe9 (Province of New Caledonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Loyaut\xe9 (Province of New Caledonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Loyaut\xe9 (Province of New Caledonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Loyaut\xe9 (Province of New Caledonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Loyaut\xe9 (Province of New Caledonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Loyaut\xe9 (Province of New Caledonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Loyaut\xe9 (Province of New Caledonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Loyaut\xe9 (Province of New Caledonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Loyaut\xe9 (Province of New Caledonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Loyaut\xe9 (Province of New Caledonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Loyaut\xe9 (Province of New Caledonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Loyaut\xe9 (Province of New Caledonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Loyaut\xe9 (Province of New Caledonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Loyaut\xe9 (Province of New Caledonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Loyaut\xe9 (Province of New Caledonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\xceles Marquises (Administrative subdivisions of French Polynesia)": [
            {
                "Region Name": "\xceles Marquises (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Marquises (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Marquises (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Marquises (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Marquises (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Marquises (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Marquises (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Marquises (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Marquises (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Marquises (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Marquises (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Marquises (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Marquises (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Marquises (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Marquises (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Marquises (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Marquises (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Marquises (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Marquises (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Marquises (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Marquises (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Marquises (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\xceles Saint Paul et Amsterdam (District of French Southern Territories)": [
            {
                "Region Name": "\xceles Saint Paul et Amsterdam (District of French Southern Territories)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Saint Paul et Amsterdam (District of French Southern Territories)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Saint Paul et Amsterdam (District of French Southern Territories)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Saint Paul et Amsterdam (District of French Southern Territories)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Saint Paul et Amsterdam (District of French Southern Territories)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Saint Paul et Amsterdam (District of French Southern Territories)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Saint Paul et Amsterdam (District of French Southern Territories)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Saint Paul et Amsterdam (District of French Southern Territories)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Saint Paul et Amsterdam (District of French Southern Territories)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Saint Paul et Amsterdam (District of French Southern Territories)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Saint Paul et Amsterdam (District of French Southern Territories)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Saint Paul et Amsterdam (District of French Southern Territories)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Saint Paul et Amsterdam (District of French Southern Territories)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Saint Paul et Amsterdam (District of French Southern Territories)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Saint Paul et Amsterdam (District of French Southern Territories)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Saint Paul et Amsterdam (District of French Southern Territories)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Saint Paul et Amsterdam (District of French Southern Territories)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Saint Paul et Amsterdam (District of French Southern Territories)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Saint Paul et Amsterdam (District of French Southern Territories)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Saint Paul et Amsterdam (District of French Southern Territories)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Saint Paul et Amsterdam (District of French Southern Territories)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Saint Paul et Amsterdam (District of French Southern Territories)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\xceles Sous-le-Vent (Administrative subdivisions of French Polynesia)": [
            {
                "Region Name": "\xceles Sous-le-Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Sous-le-Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Sous-le-Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Sous-le-Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Sous-le-Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Sous-le-Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Sous-le-Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Sous-le-Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Sous-le-Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Sous-le-Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Sous-le-Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Sous-le-Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Sous-le-Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Sous-le-Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Sous-le-Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Sous-le-Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Sous-le-Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Sous-le-Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Sous-le-Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Sous-le-Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Sous-le-Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Sous-le-Vent (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\xceles Tuamotu-Gambier (Administrative subdivisions of French Polynesia)": [
            {
                "Region Name": "\xceles Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xceles Tuamotu-Gambier (Administrative subdivisions of French Polynesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ilfov (County of Romania)": [
            {
                "Region Name": "Ilfov (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ilfov (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ilfov (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ilfov (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ilfov (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ilfov (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilfov (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ilfov (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ilfov (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ilfov (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ilfov (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ilfov (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ilfov (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ilfov (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ilfov (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ilfov (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilfov (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilfov (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ilfov (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilfov (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilfov (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilfov (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ilinden (Municipality of North Macedonia)": [
            {
                "Region Name": "Ilinden (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilinden (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilinden (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilinden (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ilinden (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilinden (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilinden (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilinden (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilinden (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilinden (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilinden (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilinden (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ilinden (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilinden (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilinden (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilinden (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilinden (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilinden (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilinden (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilinden (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilinden (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilinden (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Illinois (State of United States)": [
            {
                "Region Name": "Illinois (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Illinois (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Illinois (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Illinois (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Illinois (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Illinois (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Illinois (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Illinois (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Illinois (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Illinois (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Illinois (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Illinois (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Illinois (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Illinois (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Illinois (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Illinois (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Illinois (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Illinois (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Illinois (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Illinois (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Illinois (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Illinois (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Illizi (Province of Algeria)": [
            {
                "Region Name": "Illizi (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Illizi (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Illizi (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Illizi (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Illizi (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Illizi (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Illizi (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Illizi (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Illizi (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Illizi (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Illizi (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Illizi (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Illizi (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Illizi (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Illizi (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Illizi (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Illizi (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Illizi (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Illizi (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Illizi (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Illizi (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Illizi (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ilocos Norte (Province of Philippines)": [
            {
                "Region Name": "Ilocos Norte (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ilocos Norte (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ilocos Norte (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ilocos Norte (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ilocos Norte (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ilocos Norte (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ilocos Norte (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ilocos Norte (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ilocos Norte (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ilocos Norte (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ilocos Norte (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ilocos Norte (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ilocos Norte (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ilocos Norte (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ilocos Norte (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ilocos Norte (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ilocos Norte (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ilocos Norte (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ilocos Norte (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ilocos Norte (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ilocos Norte (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ilocos Norte (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Ilocos Sur (Province of Philippines)": [
            {
                "Region Name": "Ilocos Sur (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ilocos Sur (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilocos Sur (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ilocos Sur (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ilocos Sur (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilocos Sur (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ilocos Sur (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilocos Sur (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ilocos Sur (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ilocos Sur (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilocos Sur (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ilocos Sur (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ilocos Sur (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ilocos Sur (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilocos Sur (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilocos Sur (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilocos Sur (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ilocos Sur (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ilocos Sur (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilocos Sur (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilocos Sur (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ilocos Sur (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Iloilo (Province of Philippines)": [
            {
                "Region Name": "Iloilo (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Iloilo (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Iloilo (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Iloilo (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Iloilo (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Iloilo (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iloilo (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iloilo (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Iloilo (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Iloilo (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iloilo (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Iloilo (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iloilo (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Iloilo (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Iloilo (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iloilo (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iloilo (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iloilo (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Iloilo (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iloilo (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iloilo (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iloilo (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Imbabura (Province of Ecuador)": [
            {
                "Region Name": "Imbabura (Province of Ecuador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Imbabura (Province of Ecuador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Imbabura (Province of Ecuador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Imbabura (Province of Ecuador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Imbabura (Province of Ecuador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Imbabura (Province of Ecuador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imbabura (Province of Ecuador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imbabura (Province of Ecuador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Imbabura (Province of Ecuador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imbabura (Province of Ecuador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imbabura (Province of Ecuador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Imbabura (Province of Ecuador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imbabura (Province of Ecuador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Imbabura (Province of Ecuador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Imbabura (Province of Ecuador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imbabura (Province of Ecuador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Imbabura (Province of Ecuador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Imbabura (Province of Ecuador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Imbabura (Province of Ecuador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imbabura (Province of Ecuador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imbabura (Province of Ecuador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imbabura (Province of Ecuador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Imereti (Region of Georgia)": [
            {
                "Region Name": "Imereti (Region of Georgia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imereti (Region of Georgia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imereti (Region of Georgia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imereti (Region of Georgia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imereti (Region of Georgia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imereti (Region of Georgia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imereti (Region of Georgia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imereti (Region of Georgia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imereti (Region of Georgia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Imereti (Region of Georgia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imereti (Region of Georgia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Imereti (Region of Georgia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Imereti (Region of Georgia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imereti (Region of Georgia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imereti (Region of Georgia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imereti (Region of Georgia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imereti (Region of Georgia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imereti (Region of Georgia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imereti (Region of Georgia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Imereti (Region of Georgia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imereti (Region of Georgia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imereti (Region of Georgia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Imo (State of Nigeria)": [
            {
                "Region Name": "Imo (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Imo (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Imo (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Imo (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Imo (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Imo (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Imo (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imo (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imo (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Imo (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Imo (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Imo (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Imo (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Imo (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Imo (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Imo (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Imo (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Imo (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Imo (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Imo (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Imo (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Imo (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Inagua (District of Bahamas)": [
            {
                "Region Name": "Inagua (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inagua (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inagua (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inagua (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inagua (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inagua (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inagua (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inagua (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inagua (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inagua (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inagua (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inagua (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inagua (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inagua (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inagua (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inagua (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inagua (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inagua (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inagua (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inagua (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inagua (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inagua (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Inarajan (Municipality of Guam)": [
            {
                "Region Name": "Inarajan (Municipality of Guam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inarajan (Municipality of Guam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inarajan (Municipality of Guam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inarajan (Municipality of Guam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inarajan (Municipality of Guam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inarajan (Municipality of Guam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inarajan (Municipality of Guam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inarajan (Municipality of Guam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inarajan (Municipality of Guam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inarajan (Municipality of Guam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inarajan (Municipality of Guam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inarajan (Municipality of Guam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inarajan (Municipality of Guam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inarajan (Municipality of Guam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inarajan (Municipality of Guam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inarajan (Municipality of Guam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inarajan (Municipality of Guam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inarajan (Municipality of Guam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inarajan (Municipality of Guam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inarajan (Municipality of Guam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inarajan (Municipality of Guam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inarajan (Municipality of Guam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Incheon (Metropolitan City of South Korea)": [
            {
                "Region Name": "Incheon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Incheon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Incheon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Incheon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Incheon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Incheon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Incheon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Incheon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Incheon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Incheon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Incheon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Incheon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Incheon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Incheon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Incheon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Incheon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Incheon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Incheon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Incheon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Incheon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Incheon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Incheon (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Inchiri (Region of Mauritania)": [
            {
                "Region Name": "Inchiri (Region of Mauritania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inchiri (Region of Mauritania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inchiri (Region of Mauritania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inchiri (Region of Mauritania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inchiri (Region of Mauritania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inchiri (Region of Mauritania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inchiri (Region of Mauritania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inchiri (Region of Mauritania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inchiri (Region of Mauritania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inchiri (Region of Mauritania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inchiri (Region of Mauritania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inchiri (Region of Mauritania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inchiri (Region of Mauritania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inchiri (Region of Mauritania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inchiri (Region of Mauritania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inchiri (Region of Mauritania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inchiri (Region of Mauritania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inchiri (Region of Mauritania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inchiri (Region of Mauritania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inchiri (Region of Mauritania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inchiri (Region of Mauritania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Inchiri (Region of Mauritania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Independencia (Province of Dominican Republic)": [
            {
                "Region Name": "Independencia (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Independencia (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Independencia (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Independencia (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Independencia (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Independencia (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Independencia (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Independencia (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Independencia (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Independencia (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Independencia (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Independencia (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Independencia (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Independencia (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Independencia (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Independencia (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Independencia (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Independencia (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Independencia (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Independencia (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Independencia (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Independencia (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Indiana (State of United States)": [
            {
                "Region Name": "Indiana (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Indiana (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Indiana (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Indiana (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Indiana (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Indiana (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Indiana (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Indiana (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Indiana (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Indiana (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Indiana (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Indiana (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Indiana (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Indiana (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Indiana (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Indiana (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Indiana (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Indiana (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Indiana (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Indiana (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Indiana (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Indiana (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Ingush (Republic of Russia)": [
            {
                "Region Name": "Ingush (Republic of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ingush (Republic of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ingush (Republic of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ingush (Republic of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ingush (Republic of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Ingush (Republic of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ingush (Republic of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ingush (Republic of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ingush (Republic of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ingush (Republic of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ingush (Republic of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ingush (Republic of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ingush (Republic of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ingush (Republic of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ingush (Republic of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ingush (Republic of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ingush (Republic of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ingush (Republic of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ingush (Republic of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ingush (Republic of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ingush (Republic of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ingush (Republic of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Inhambane (Province of Mozambique)": [
            {
                "Region Name": "Inhambane (Province of Mozambique)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Inhambane (Province of Mozambique)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Inhambane (Province of Mozambique)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Inhambane (Province of Mozambique)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Inhambane (Province of Mozambique)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Inhambane (Province of Mozambique)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Inhambane (Province of Mozambique)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Inhambane (Province of Mozambique)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Inhambane (Province of Mozambique)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Inhambane (Province of Mozambique)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Inhambane (Province of Mozambique)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Inhambane (Province of Mozambique)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Inhambane (Province of Mozambique)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Inhambane (Province of Mozambique)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Inhambane (Province of Mozambique)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Inhambane (Province of Mozambique)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Inhambane (Province of Mozambique)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Inhambane (Province of Mozambique)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Inhambane (Province of Mozambique)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Inhambane (Province of Mozambique)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Inhambane (Province of Mozambique)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Inhambane (Province of Mozambique)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Intibuc\xe1 (Department of Honduras)": [
            {
                "Region Name": "Intibuc\xe1 (Department of Honduras)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Intibuc\xe1 (Department of Honduras)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Intibuc\xe1 (Department of Honduras)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Intibuc\xe1 (Department of Honduras)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Intibuc\xe1 (Department of Honduras)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Intibuc\xe1 (Department of Honduras)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Intibuc\xe1 (Department of Honduras)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Intibuc\xe1 (Department of Honduras)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Intibuc\xe1 (Department of Honduras)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Intibuc\xe1 (Department of Honduras)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Intibuc\xe1 (Department of Honduras)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Intibuc\xe1 (Department of Honduras)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Intibuc\xe1 (Department of Honduras)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Intibuc\xe1 (Department of Honduras)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Intibuc\xe1 (Department of Honduras)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Intibuc\xe1 (Department of Honduras)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Intibuc\xe1 (Department of Honduras)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Intibuc\xe1 (Department of Honduras)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Intibuc\xe1 (Department of Honduras)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Intibuc\xe1 (Department of Honduras)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Intibuc\xe1 (Department of Honduras)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Intibuc\xe1 (Department of Honduras)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Iowa (State of United States)": [
            {
                "Region Name": "Iowa (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Iowa (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Iowa (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Iowa (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Iowa (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Iowa (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Iowa (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Iowa (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Iowa (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Iowa (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Iowa (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Iowa (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Iowa (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Iowa (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Iowa (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Iowa (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Iowa (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Iowa (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Iowa (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Iowa (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Iowa (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Iowa (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Irbid (Province of Jordan)": [
            {
                "Region Name": "Irbid (Province of Jordan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Irbid (Province of Jordan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Irbid (Province of Jordan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Irbid (Province of Jordan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Irbid (Province of Jordan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Irbid (Province of Jordan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Irbid (Province of Jordan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Irbid (Province of Jordan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Irbid (Province of Jordan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Irbid (Province of Jordan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Irbid (Province of Jordan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Irbid (Province of Jordan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Irbid (Province of Jordan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Irbid (Province of Jordan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Irbid (Province of Jordan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Irbid (Province of Jordan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Irbid (Province of Jordan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Irbid (Province of Jordan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Irbid (Province of Jordan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Irbid (Province of Jordan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Irbid (Province of Jordan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Irbid (Province of Jordan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Iringa (Region of Tanzania)": [
            {
                "Region Name": "Iringa (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Iringa (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Iringa (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Iringa (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Iringa (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Iringa (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Iringa (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Iringa (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Iringa (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Iringa (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Iringa (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Iringa (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Iringa (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Iringa (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Iringa (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Iringa (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Iringa (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Iringa (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Iringa (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Iringa (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Iringa (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Iringa (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Irkutsk (Region of Russia)": [
            {
                "Region Name": "Irkutsk (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Irkutsk (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Irkutsk (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Irkutsk (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Irkutsk (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Irkutsk (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Irkutsk (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Irkutsk (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Irkutsk (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Irkutsk (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Irkutsk (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Irkutsk (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Irkutsk (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Irkutsk (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Irkutsk (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Irkutsk (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Irkutsk (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Irkutsk (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Irkutsk (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Irkutsk (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Irkutsk (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Irkutsk (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Isabel (Province of Solomon Islands)": [
            {
                "Region Name": "Isabel (Province of Solomon Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabel (Province of Solomon Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabel (Province of Solomon Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabel (Province of Solomon Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabel (Province of Solomon Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabel (Province of Solomon Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabel (Province of Solomon Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabel (Province of Solomon Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabel (Province of Solomon Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabel (Province of Solomon Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabel (Province of Solomon Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabel (Province of Solomon Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabel (Province of Solomon Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabel (Province of Solomon Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabel (Province of Solomon Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabel (Province of Solomon Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabel (Province of Solomon Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabel (Province of Solomon Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabel (Province of Solomon Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabel (Province of Solomon Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabel (Province of Solomon Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabel (Province of Solomon Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Isabela (Municipality of Puerto Rico)": [
            {
                "Region Name": "Isabela (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabela (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabela (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabela (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabela (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabela (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabela (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabela (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabela (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabela (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabela (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabela (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabela (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabela (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabela (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabela (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabela (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabela (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabela (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabela (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabela (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isabela (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Isabela (Province of Philippines)": [
            {
                "Region Name": "Isabela (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Isabela (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Isabela (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Isabela (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Isabela (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Isabela (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Isabela (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Isabela (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Isabela (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Isabela (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Isabela (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Isabela (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Isabela (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Isabela (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Isabela (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Isabela (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Isabela (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Isabela (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Isabela (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Isabela (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Isabela (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Isabela (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Ishikawa (Prefecture of Japan)": [
            {
                "Region Name": "Ishikawa (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ishikawa (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ishikawa (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ishikawa (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ishikawa (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ishikawa (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ishikawa (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ishikawa (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ishikawa (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ishikawa (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ishikawa (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ishikawa (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ishikawa (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ishikawa (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ishikawa (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ishikawa (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ishikawa (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ishikawa (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ishikawa (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ishikawa (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ishikawa (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ishikawa (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Isiolo (County of Kenya)": [
            {
                "Region Name": "Isiolo (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Isiolo (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Isiolo (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Isiolo (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Isiolo (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isiolo (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Isiolo (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Isiolo (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Isiolo (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Isiolo (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isiolo (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Isiolo (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Isiolo (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Isiolo (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Isiolo (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Isiolo (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Isiolo (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Isiolo (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Isiolo (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Isiolo (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Isiolo (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isiolo (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Iskele (District of Northern Cyprus)": [
            {
                "Region Name": "Iskele (District of Northern Cyprus)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iskele (District of Northern Cyprus)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iskele (District of Northern Cyprus)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iskele (District of Northern Cyprus)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iskele (District of Northern Cyprus)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iskele (District of Northern Cyprus)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iskele (District of Northern Cyprus)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iskele (District of Northern Cyprus)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iskele (District of Northern Cyprus)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iskele (District of Northern Cyprus)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iskele (District of Northern Cyprus)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iskele (District of Northern Cyprus)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iskele (District of Northern Cyprus)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iskele (District of Northern Cyprus)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iskele (District of Northern Cyprus)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iskele (District of Northern Cyprus)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iskele (District of Northern Cyprus)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iskele (District of Northern Cyprus)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iskele (District of Northern Cyprus)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iskele (District of Northern Cyprus)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iskele (District of Northern Cyprus)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Iskele (District of Northern Cyprus)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Isla de la Juventud (Province of Cuba)": [
            {
                "Region Name": "Isla de la Juventud (Province of Cuba)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Isla de la Juventud (Province of Cuba)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Isla de la Juventud (Province of Cuba)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Isla de la Juventud (Province of Cuba)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Isla de la Juventud (Province of Cuba)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Isla de la Juventud (Province of Cuba)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Isla de la Juventud (Province of Cuba)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Isla de la Juventud (Province of Cuba)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Isla de la Juventud (Province of Cuba)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Isla de la Juventud (Province of Cuba)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Isla de la Juventud (Province of Cuba)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Isla de la Juventud (Province of Cuba)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Isla de la Juventud (Province of Cuba)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Isla de la Juventud (Province of Cuba)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Isla de la Juventud (Province of Cuba)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Isla de la Juventud (Province of Cuba)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Isla de la Juventud (Province of Cuba)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Isla de la Juventud (Province of Cuba)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Isla de la Juventud (Province of Cuba)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Isla de la Juventud (Province of Cuba)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Isla de la Juventud (Province of Cuba)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Isla de la Juventud (Province of Cuba)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Islamabad (Capital Territory of Pakistan)": [
            {
                "Region Name": "Islamabad (Capital Territory of Pakistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Islamabad (Capital Territory of Pakistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islamabad (Capital Territory of Pakistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islamabad (Capital Territory of Pakistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Islamabad (Capital Territory of Pakistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Islamabad (Capital Territory of Pakistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islamabad (Capital Territory of Pakistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islamabad (Capital Territory of Pakistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Islamabad (Capital Territory of Pakistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islamabad (Capital Territory of Pakistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islamabad (Capital Territory of Pakistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islamabad (Capital Territory of Pakistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islamabad (Capital Territory of Pakistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islamabad (Capital Territory of Pakistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islamabad (Capital Territory of Pakistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Islamabad (Capital Territory of Pakistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islamabad (Capital Territory of Pakistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Islamabad (Capital Territory of Pakistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islamabad (Capital Territory of Pakistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Islamabad (Capital Territory of Pakistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Islamabad (Capital Territory of Pakistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islamabad (Capital Territory of Pakistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Island Harbour (District of Anguilla)": [
            {
                "Region Name": "Island Harbour (District of Anguilla)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Island Harbour (District of Anguilla)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Island Harbour (District of Anguilla)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Island Harbour (District of Anguilla)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Island Harbour (District of Anguilla)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Island Harbour (District of Anguilla)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Island Harbour (District of Anguilla)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Island Harbour (District of Anguilla)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Island Harbour (District of Anguilla)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Island Harbour (District of Anguilla)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Island Harbour (District of Anguilla)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Island Harbour (District of Anguilla)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Island Harbour (District of Anguilla)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Island Harbour (District of Anguilla)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Island Harbour (District of Anguilla)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Island Harbour (District of Anguilla)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Island Harbour (District of Anguilla)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Island Harbour (District of Anguilla)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Island Harbour (District of Anguilla)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Island Harbour (District of Anguilla)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Island Harbour (District of Anguilla)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Island Harbour (District of Anguilla)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Islas Baleares (Autonomous Community of Spain)": [
            {
                "Region Name": "Islas Baleares (Autonomous Community of Spain)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas Baleares (Autonomous Community of Spain)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas Baleares (Autonomous Community of Spain)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas Baleares (Autonomous Community of Spain)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas Baleares (Autonomous Community of Spain)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Islas Baleares (Autonomous Community of Spain)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas Baleares (Autonomous Community of Spain)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas Baleares (Autonomous Community of Spain)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas Baleares (Autonomous Community of Spain)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Islas Baleares (Autonomous Community of Spain)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Islas Baleares (Autonomous Community of Spain)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas Baleares (Autonomous Community of Spain)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Islas Baleares (Autonomous Community of Spain)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas Baleares (Autonomous Community of Spain)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Islas Baleares (Autonomous Community of Spain)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas Baleares (Autonomous Community of Spain)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas Baleares (Autonomous Community of Spain)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas Baleares (Autonomous Community of Spain)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas Baleares (Autonomous Community of Spain)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Islas Baleares (Autonomous Community of Spain)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas Baleares (Autonomous Community of Spain)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas Baleares (Autonomous Community of Spain)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Islas Canarias (Autonomous Community of Spain)": [
            {
                "Region Name": "Islas Canarias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas Canarias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas Canarias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas Canarias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Islas Canarias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Islas Canarias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 126
            },
            {
                "Region Name": "Islas Canarias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas Canarias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Islas Canarias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas Canarias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas Canarias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 57
            },
            {
                "Region Name": "Islas Canarias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas Canarias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas Canarias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas Canarias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Islas Canarias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Islas Canarias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Islas Canarias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 82
            },
            {
                "Region Name": "Islas Canarias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Islas Canarias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Islas Canarias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Islas Canarias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 41
            }
        ],
        "Islas de la Bah\xeda (Department of Honduras)": [
            {
                "Region Name": "Islas de la Bah\xeda (Department of Honduras)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Islas de la Bah\xeda (Department of Honduras)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas de la Bah\xeda (Department of Honduras)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas de la Bah\xeda (Department of Honduras)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Islas de la Bah\xeda (Department of Honduras)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas de la Bah\xeda (Department of Honduras)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas de la Bah\xeda (Department of Honduras)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas de la Bah\xeda (Department of Honduras)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas de la Bah\xeda (Department of Honduras)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas de la Bah\xeda (Department of Honduras)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas de la Bah\xeda (Department of Honduras)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas de la Bah\xeda (Department of Honduras)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Islas de la Bah\xeda (Department of Honduras)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas de la Bah\xeda (Department of Honduras)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas de la Bah\xeda (Department of Honduras)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas de la Bah\xeda (Department of Honduras)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas de la Bah\xeda (Department of Honduras)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas de la Bah\xeda (Department of Honduras)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas de la Bah\xeda (Department of Honduras)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas de la Bah\xeda (Department of Honduras)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas de la Bah\xeda (Department of Honduras)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Islas de la Bah\xeda (Department of Honduras)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Isparta (Province of Turkey)": [
            {
                "Region Name": "Isparta (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isparta (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isparta (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isparta (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Isparta (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isparta (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isparta (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isparta (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Isparta (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Isparta (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Isparta (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isparta (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Isparta (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isparta (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Isparta (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isparta (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isparta (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isparta (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isparta (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isparta (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Isparta (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Isparta (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Istanbul (Province of Turkey)": [
            {
                "Region Name": "Istanbul (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istanbul (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Istanbul (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istanbul (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istanbul (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istanbul (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Istanbul (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istanbul (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Istanbul (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Istanbul (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Istanbul (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istanbul (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istanbul (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istanbul (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istanbul (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istanbul (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istanbul (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istanbul (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istanbul (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istanbul (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istanbul (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istanbul (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Istarska (County of Croatia)": [
            {
                "Region Name": "Istarska (County of Croatia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istarska (County of Croatia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Istarska (County of Croatia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istarska (County of Croatia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istarska (County of Croatia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istarska (County of Croatia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istarska (County of Croatia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istarska (County of Croatia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istarska (County of Croatia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istarska (County of Croatia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istarska (County of Croatia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Istarska (County of Croatia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istarska (County of Croatia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istarska (County of Croatia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istarska (County of Croatia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istarska (County of Croatia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istarska (County of Croatia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istarska (County of Croatia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istarska (County of Croatia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istarska (County of Croatia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istarska (County of Croatia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Istarska (County of Croatia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Itap\xfaa (Department of Paraguay)": [
            {
                "Region Name": "Itap\xfaa (Department of Paraguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Itap\xfaa (Department of Paraguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Itap\xfaa (Department of Paraguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Itap\xfaa (Department of Paraguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Itap\xfaa (Department of Paraguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Itap\xfaa (Department of Paraguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Itap\xfaa (Department of Paraguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Itap\xfaa (Department of Paraguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Itap\xfaa (Department of Paraguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Itap\xfaa (Department of Paraguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Itap\xfaa (Department of Paraguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Itap\xfaa (Department of Paraguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Itap\xfaa (Department of Paraguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Itap\xfaa (Department of Paraguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Itap\xfaa (Department of Paraguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Itap\xfaa (Department of Paraguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Itap\xfaa (Department of Paraguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Itap\xfaa (Department of Paraguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Itap\xfaa (Department of Paraguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Itap\xfaa (Department of Paraguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Itap\xfaa (Department of Paraguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Itap\xfaa (Department of Paraguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Ituri (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ituri (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Ivano-Frankivs'k (Region of Ukraine)": [
            {
                "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ivano-Frankivs'k (Region of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Ivanovo (Region of Russia)": [
            {
                "Region Name": "Ivanovo (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ivanovo (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ivanovo (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ivanovo (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ivanovo (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ivanovo (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ivanovo (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ivanovo (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ivanovo (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Ivanovo (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ivanovo (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ivanovo (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ivanovo (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ivanovo (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ivanovo (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ivanovo (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ivanovo (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Ivanovo (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ivanovo (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ivanovo (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ivanovo (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Ivanovo (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Iwate (Prefecture of Japan)": [
            {
                "Region Name": "Iwate (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iwate (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iwate (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iwate (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iwate (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iwate (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iwate (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iwate (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iwate (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iwate (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iwate (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iwate (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Iwate (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iwate (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iwate (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iwate (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iwate (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Iwate (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iwate (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iwate (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iwate (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Iwate (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Izabal (Department of Guatemala)": [
            {
                "Region Name": "Izabal (Department of Guatemala)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Izabal (Department of Guatemala)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Izabal (Department of Guatemala)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Izabal (Department of Guatemala)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Izabal (Department of Guatemala)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Izabal (Department of Guatemala)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Izabal (Department of Guatemala)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Izabal (Department of Guatemala)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Izabal (Department of Guatemala)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Izabal (Department of Guatemala)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Izabal (Department of Guatemala)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Izabal (Department of Guatemala)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Izabal (Department of Guatemala)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Izabal (Department of Guatemala)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Izabal (Department of Guatemala)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Izabal (Department of Guatemala)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Izabal (Department of Guatemala)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Izabal (Department of Guatemala)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Izabal (Department of Guatemala)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Izabal (Department of Guatemala)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Izabal (Department of Guatemala)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Izabal (Department of Guatemala)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Izmir (Province of Turkey)": [
            {
                "Region Name": "Izmir (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Izmir (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Izmir (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Izmir (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Izmir (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Izmir (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Izmir (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Izmir (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Izmir (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Izmir (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Izmir (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Izmir (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Izmir (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Izmir (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Izmir (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Izmir (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Izmir (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Izmir (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Izmir (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Izmir (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Izmir (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Izmir (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Jabat (Island of Marshall Islands)": [
            {
                "Region Name": "Jabat (Island of Marshall Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jabat (Island of Marshall Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jabat (Island of Marshall Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jabat (Island of Marshall Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jabat (Island of Marshall Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jabat (Island of Marshall Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jabat (Island of Marshall Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jabat (Island of Marshall Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jabat (Island of Marshall Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jabat (Island of Marshall Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jabat (Island of Marshall Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jabat (Island of Marshall Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jabat (Island of Marshall Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jabat (Island of Marshall Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jabat (Island of Marshall Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jabat (Island of Marshall Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jabat (Island of Marshall Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jabat (Island of Marshall Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jabat (Island of Marshall Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jabat (Island of Marshall Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jabat (Island of Marshall Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jabat (Island of Marshall Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jablani\u010Dki (District of Serbia)": [
            {
                "Region Name": "Jablani\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jablani\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jablani\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jablani\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jablani\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jablani\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Jablani\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jablani\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jablani\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jablani\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jablani\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jablani\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jablani\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jablani\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jablani\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jablani\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jablani\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jablani\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jablani\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jablani\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jablani\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jablani\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jaffna (District of Sri Lanka)": [
            {
                "Region Name": "Jaffna (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaffna (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaffna (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaffna (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaffna (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaffna (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaffna (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaffna (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaffna (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaffna (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaffna (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaffna (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaffna (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaffna (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaffna (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaffna (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaffna (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaffna (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaffna (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaffna (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaffna (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaffna (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jakarta Raya (Province of Indonesia)": [
            {
                "Region Name": "Jakarta Raya (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jakarta Raya (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jakarta Raya (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jakarta Raya (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jakarta Raya (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jakarta Raya (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jakarta Raya (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jakarta Raya (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jakarta Raya (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jakarta Raya (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jakarta Raya (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jakarta Raya (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jakarta Raya (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jakarta Raya (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jakarta Raya (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jakarta Raya (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jakarta Raya (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jakarta Raya (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jakarta Raya (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jakarta Raya (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jakarta Raya (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jakarta Raya (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jalal-Abad (Province of Kyrgyzstan)": [
            {
                "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jalal-Abad (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jalapa (Department of Guatemala)": [
            {
                "Region Name": "Jalapa (Department of Guatemala)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jalapa (Department of Guatemala)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jalapa (Department of Guatemala)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jalapa (Department of Guatemala)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jalapa (Department of Guatemala)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jalapa (Department of Guatemala)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jalapa (Department of Guatemala)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jalapa (Department of Guatemala)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jalapa (Department of Guatemala)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jalapa (Department of Guatemala)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jalapa (Department of Guatemala)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jalapa (Department of Guatemala)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jalapa (Department of Guatemala)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jalapa (Department of Guatemala)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jalapa (Department of Guatemala)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jalapa (Department of Guatemala)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jalapa (Department of Guatemala)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jalapa (Department of Guatemala)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jalapa (Department of Guatemala)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Jalapa (Department of Guatemala)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jalapa (Department of Guatemala)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jalapa (Department of Guatemala)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jalisco (State of M\xe9xico)": [
            {
                "Region Name": "Jalisco (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Jalisco (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Jalisco (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jalisco (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Jalisco (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Jalisco (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jalisco (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Jalisco (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jalisco (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jalisco (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Jalisco (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jalisco (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jalisco (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jalisco (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jalisco (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jalisco (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Jalisco (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jalisco (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Jalisco (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jalisco (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jalisco (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jalisco (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Jaluit (Atol of Marshall Islands)": [
            {
                "Region Name": "Jaluit (Atol of Marshall Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaluit (Atol of Marshall Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaluit (Atol of Marshall Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaluit (Atol of Marshall Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaluit (Atol of Marshall Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaluit (Atol of Marshall Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaluit (Atol of Marshall Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaluit (Atol of Marshall Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaluit (Atol of Marshall Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaluit (Atol of Marshall Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaluit (Atol of Marshall Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaluit (Atol of Marshall Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaluit (Atol of Marshall Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaluit (Atol of Marshall Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaluit (Atol of Marshall Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaluit (Atol of Marshall Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaluit (Atol of Marshall Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaluit (Atol of Marshall Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaluit (Atol of Marshall Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaluit (Atol of Marshall Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaluit (Atol of Marshall Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jaluit (Atol of Marshall Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jambi (Province of Indonesia)": [
            {
                "Region Name": "Jambi (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jambi (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jambi (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Jambi (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jambi (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jambi (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jambi (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jambi (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jambi (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jambi (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Jambi (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jambi (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jambi (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jambi (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jambi (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jambi (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jambi (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jambi (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Jambi (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jambi (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jambi (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jambi (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Jammu and Kashmir (State of India)": [
            {
                "Region Name": "Jammu and Kashmir (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jammu and Kashmir (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Jammu and Kashmir (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jammu and Kashmir (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Jammu and Kashmir (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Jammu and Kashmir (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Jammu and Kashmir (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jammu and Kashmir (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jammu and Kashmir (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jammu and Kashmir (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Jammu and Kashmir (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jammu and Kashmir (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Jammu and Kashmir (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Jammu and Kashmir (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jammu and Kashmir (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Jammu and Kashmir (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Jammu and Kashmir (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Jammu and Kashmir (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Jammu and Kashmir (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Jammu and Kashmir (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jammu and Kashmir (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Jammu and Kashmir (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "J\xe4mtland (County of Sweden)": [
            {
                "Region Name": "J\xe4mtland (County of Sweden)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4mtland (County of Sweden)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4mtland (County of Sweden)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4mtland (County of Sweden)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4mtland (County of Sweden)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "J\xe4mtland (County of Sweden)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4mtland (County of Sweden)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4mtland (County of Sweden)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4mtland (County of Sweden)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4mtland (County of Sweden)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4mtland (County of Sweden)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4mtland (County of Sweden)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4mtland (County of Sweden)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4mtland (County of Sweden)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4mtland (County of Sweden)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4mtland (County of Sweden)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4mtland (County of Sweden)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "J\xe4mtland (County of Sweden)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4mtland (County of Sweden)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4mtland (County of Sweden)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4mtland (County of Sweden)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4mtland (County of Sweden)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jan Mayen (Territory of Svalbard and Jan Mayen)": [
            {
                "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jan Mayen (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Janub Sina' (Governorate of Egypt)": [
            {
                "Region Name": "Janub Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Janub Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Janub Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Janub Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Janub Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Janub Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Janub Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Janub Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Janub Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Janub Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Janub Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Janub Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Janub Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Janub Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Janub Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Janub Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Janub Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Janub Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Janub Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Janub Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Janub Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Janub Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jarash (Province of Jordan)": [
            {
                "Region Name": "Jarash (Province of Jordan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarash (Province of Jordan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarash (Province of Jordan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarash (Province of Jordan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarash (Province of Jordan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarash (Province of Jordan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarash (Province of Jordan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarash (Province of Jordan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarash (Province of Jordan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarash (Province of Jordan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarash (Province of Jordan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarash (Province of Jordan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarash (Province of Jordan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarash (Province of Jordan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarash (Province of Jordan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarash (Province of Jordan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarash (Province of Jordan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarash (Province of Jordan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarash (Province of Jordan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jarash (Province of Jordan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarash (Province of Jordan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarash (Province of Jordan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "J\xe4rva (County of Estonia)": [
            {
                "Region Name": "J\xe4rva (County of Estonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4rva (County of Estonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4rva (County of Estonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4rva (County of Estonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4rva (County of Estonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4rva (County of Estonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4rva (County of Estonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4rva (County of Estonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4rva (County of Estonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4rva (County of Estonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4rva (County of Estonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4rva (County of Estonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4rva (County of Estonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4rva (County of Estonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4rva (County of Estonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4rva (County of Estonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "J\xe4rva (County of Estonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4rva (County of Estonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4rva (County of Estonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4rva (County of Estonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4rva (County of Estonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe4rva (County of Estonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Jarvis island (Island of United States Minor Outlying Isl)": [
            {
                "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jarvis island (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "J\xe1sz-Nagykun-Szolnok (County of Hungary)": [
            {
                "Region Name": "J\xe1sz-Nagykun-Szolnok (County of Hungary)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "J\xe1sz-Nagykun-Szolnok (County of Hungary)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "J\xe1sz-Nagykun-Szolnok (County of Hungary)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "J\xe1sz-Nagykun-Szolnok (County of Hungary)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "J\xe1sz-Nagykun-Szolnok (County of Hungary)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "J\xe1sz-Nagykun-Szolnok (County of Hungary)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "J\xe1sz-Nagykun-Szolnok (County of Hungary)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "J\xe1sz-Nagykun-Szolnok (County of Hungary)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "J\xe1sz-Nagykun-Szolnok (County of Hungary)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "J\xe1sz-Nagykun-Szolnok (County of Hungary)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "J\xe1sz-Nagykun-Szolnok (County of Hungary)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "J\xe1sz-Nagykun-Szolnok (County of Hungary)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe1sz-Nagykun-Szolnok (County of Hungary)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe1sz-Nagykun-Szolnok (County of Hungary)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe1sz-Nagykun-Szolnok (County of Hungary)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe1sz-Nagykun-Szolnok (County of Hungary)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "J\xe1sz-Nagykun-Szolnok (County of Hungary)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe1sz-Nagykun-Szolnok (County of Hungary)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "J\xe1sz-Nagykun-Szolnok (County of Hungary)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "J\xe1sz-Nagykun-Szolnok (County of Hungary)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xe1sz-Nagykun-Szolnok (County of Hungary)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "J\xe1sz-Nagykun-Szolnok (County of Hungary)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jawa Barat (Province of Indonesia)": [
            {
                "Region Name": "Jawa Barat (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jawa Barat (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Jawa Barat (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jawa Barat (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jawa Barat (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Jawa Barat (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jawa Barat (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Jawa Barat (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jawa Barat (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jawa Barat (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jawa Barat (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jawa Barat (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jawa Barat (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jawa Barat (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jawa Barat (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jawa Barat (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Jawa Barat (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jawa Barat (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jawa Barat (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jawa Barat (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jawa Barat (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jawa Barat (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Jawa Tengah (Province of Indonesia)": [
            {
                "Region Name": "Jawa Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jawa Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jawa Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Jawa Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Jawa Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Jawa Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Jawa Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jawa Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jawa Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jawa Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Jawa Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jawa Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jawa Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jawa Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Jawa Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jawa Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jawa Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jawa Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jawa Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jawa Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jawa Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jawa Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Jawa Timur (Province of Indonesia)": [
            {
                "Region Name": "Jawa Timur (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Jawa Timur (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jawa Timur (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jawa Timur (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jawa Timur (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jawa Timur (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jawa Timur (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jawa Timur (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jawa Timur (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jawa Timur (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jawa Timur (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Jawa Timur (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jawa Timur (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jawa Timur (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jawa Timur (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jawa Timur (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jawa Timur (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Jawa Timur (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Jawa Timur (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jawa Timur (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jawa Timur (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jawa Timur (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Jawzjan (Province of Afghanistan)": [
            {
                "Region Name": "Jawzjan (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jawzjan (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Jawzjan (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jawzjan (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Jawzjan (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jawzjan (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jawzjan (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jawzjan (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jawzjan (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jawzjan (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jawzjan (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jawzjan (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jawzjan (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jawzjan (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jawzjan (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jawzjan (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jawzjan (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jawzjan (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jawzjan (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jawzjan (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jawzjan (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jawzjan (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jayuya (Municipality of Puerto Rico)": [
            {
                "Region Name": "Jayuya (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jayuya (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jayuya (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jayuya (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jayuya (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jayuya (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jayuya (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jayuya (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jayuya (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jayuya (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jayuya (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jayuya (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jayuya (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jayuya (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jayuya (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jayuya (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jayuya (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jayuya (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jayuya (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jayuya (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jayuya (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jayuya (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jegunovtse (Municipality of North Macedonia)": [
            {
                "Region Name": "Jegunovtse (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jegunovtse (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jegunovtse (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jegunovtse (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jegunovtse (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jegunovtse (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Jegunovtse (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jegunovtse (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jegunovtse (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jegunovtse (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jegunovtse (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Jegunovtse (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jegunovtse (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jegunovtse (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jegunovtse (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jegunovtse (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jegunovtse (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jegunovtse (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jegunovtse (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jegunovtse (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jegunovtse (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jegunovtse (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jeju (Province of South Korea)": [
            {
                "Region Name": "Jeju (Province of South Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeju (Province of South Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeju (Province of South Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeju (Province of South Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeju (Province of South Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeju (Province of South Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeju (Province of South Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeju (Province of South Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeju (Province of South Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeju (Province of South Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeju (Province of South Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeju (Province of South Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeju (Province of South Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeju (Province of South Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeju (Province of South Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeju (Province of South Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeju (Province of South Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeju (Province of South Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeju (Province of South Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeju (Province of South Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeju (Province of South Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeju (Province of South Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jendouba (Governorate of Tunisia)": [
            {
                "Region Name": "Jendouba (Governorate of Tunisia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jendouba (Governorate of Tunisia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jendouba (Governorate of Tunisia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jendouba (Governorate of Tunisia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jendouba (Governorate of Tunisia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jendouba (Governorate of Tunisia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jendouba (Governorate of Tunisia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jendouba (Governorate of Tunisia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jendouba (Governorate of Tunisia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jendouba (Governorate of Tunisia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Jendouba (Governorate of Tunisia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jendouba (Governorate of Tunisia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jendouba (Governorate of Tunisia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jendouba (Governorate of Tunisia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jendouba (Governorate of Tunisia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jendouba (Governorate of Tunisia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Jendouba (Governorate of Tunisia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jendouba (Governorate of Tunisia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jendouba (Governorate of Tunisia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jendouba (Governorate of Tunisia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Jendouba (Governorate of Tunisia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jendouba (Governorate of Tunisia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "Jeollabuk-do (Province of South Korea)": [
            {
                "Region Name": "Jeollabuk-do (Province of South Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollabuk-do (Province of South Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Jeollabuk-do (Province of South Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jeollabuk-do (Province of South Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollabuk-do (Province of South Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollabuk-do (Province of South Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollabuk-do (Province of South Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollabuk-do (Province of South Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollabuk-do (Province of South Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollabuk-do (Province of South Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Jeollabuk-do (Province of South Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollabuk-do (Province of South Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jeollabuk-do (Province of South Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollabuk-do (Province of South Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Jeollabuk-do (Province of South Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jeollabuk-do (Province of South Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollabuk-do (Province of South Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollabuk-do (Province of South Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jeollabuk-do (Province of South Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jeollabuk-do (Province of South Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollabuk-do (Province of South Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollabuk-do (Province of South Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Jeollanam-do (Province of South Korea)": [
            {
                "Region Name": "Jeollanam-do (Province of South Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollanam-do (Province of South Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Jeollanam-do (Province of South Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollanam-do (Province of South Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jeollanam-do (Province of South Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jeollanam-do (Province of South Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollanam-do (Province of South Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollanam-do (Province of South Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollanam-do (Province of South Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollanam-do (Province of South Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollanam-do (Province of South Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollanam-do (Province of South Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jeollanam-do (Province of South Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Jeollanam-do (Province of South Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollanam-do (Province of South Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jeollanam-do (Province of South Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollanam-do (Province of South Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollanam-do (Province of South Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollanam-do (Province of South Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollanam-do (Province of South Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jeollanam-do (Province of South Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Jeollanam-do (Province of South Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jerusalem (District of Israel)": [
            {
                "Region Name": "Jerusalem (District of Israel)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jerusalem (District of Israel)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jerusalem (District of Israel)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jerusalem (District of Israel)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jerusalem (District of Israel)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jerusalem (District of Israel)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jerusalem (District of Israel)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jerusalem (District of Israel)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jerusalem (District of Israel)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jerusalem (District of Israel)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jerusalem (District of Israel)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jerusalem (District of Israel)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jerusalem (District of Israel)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jerusalem (District of Israel)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jerusalem (District of Israel)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jerusalem (District of Israel)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jerusalem (District of Israel)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jerusalem (District of Israel)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jerusalem (District of Israel)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jerusalem (District of Israel)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Jerusalem (District of Israel)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jerusalem (District of Israel)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jervis Bay Territory (Territory of Australia)": [
            {
                "Region Name": "Jervis Bay Territory (Territory of Australia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jervis Bay Territory (Territory of Australia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Jervis Bay Territory (Territory of Australia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jervis Bay Territory (Territory of Australia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jervis Bay Territory (Territory of Australia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jervis Bay Territory (Territory of Australia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jervis Bay Territory (Territory of Australia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jervis Bay Territory (Territory of Australia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jervis Bay Territory (Territory of Australia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jervis Bay Territory (Territory of Australia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jervis Bay Territory (Territory of Australia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jervis Bay Territory (Territory of Australia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jervis Bay Territory (Territory of Australia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jervis Bay Territory (Territory of Australia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jervis Bay Territory (Territory of Australia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jervis Bay Territory (Territory of Australia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Jervis Bay Territory (Territory of Australia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jervis Bay Territory (Territory of Australia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jervis Bay Territory (Territory of Australia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jervis Bay Territory (Territory of Australia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jervis Bay Territory (Territory of Australia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jervis Bay Territory (Territory of Australia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jharkhand (State of India)": [
            {
                "Region Name": "Jharkhand (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jharkhand (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Jharkhand (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Jharkhand (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Jharkhand (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Jharkhand (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Jharkhand (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Jharkhand (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Jharkhand (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Jharkhand (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Jharkhand (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jharkhand (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Jharkhand (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Jharkhand (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Jharkhand (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jharkhand (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Jharkhand (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jharkhand (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jharkhand (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Jharkhand (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Jharkhand (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Jharkhand (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Jiangsu (Province of China)": [
            {
                "Region Name": "Jiangsu (Province of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Jiangsu (Province of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Jiangsu (Province of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Jiangsu (Province of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Jiangsu (Province of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Jiangsu (Province of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Jiangsu (Province of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Jiangsu (Province of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Jiangsu (Province of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Jiangsu (Province of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Jiangsu (Province of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Jiangsu (Province of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Jiangsu (Province of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Jiangsu (Province of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Jiangsu (Province of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jiangsu (Province of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Jiangsu (Province of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Jiangsu (Province of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jiangsu (Province of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Jiangsu (Province of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Jiangsu (Province of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Jiangsu (Province of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Jiangxi (Province of China)": [
            {
                "Region Name": "Jiangxi (Province of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jiangxi (Province of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jiangxi (Province of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jiangxi (Province of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jiangxi (Province of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jiangxi (Province of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jiangxi (Province of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Jiangxi (Province of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jiangxi (Province of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jiangxi (Province of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jiangxi (Province of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jiangxi (Province of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jiangxi (Province of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jiangxi (Province of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jiangxi (Province of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jiangxi (Province of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jiangxi (Province of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Jiangxi (Province of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Jiangxi (Province of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jiangxi (Province of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jiangxi (Province of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jiangxi (Province of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Jigawa (State of Nigeria)": [
            {
                "Region Name": "Jigawa (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Jigawa (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Jigawa (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jigawa (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Jigawa (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Jigawa (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jigawa (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Jigawa (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Jigawa (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jigawa (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jigawa (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Jigawa (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jigawa (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jigawa (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jigawa (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Jigawa (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jigawa (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jigawa (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jigawa (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jigawa (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jigawa (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jigawa (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Jiho\u010Desk\xfd (Region of Czechia)": [
            {
                "Region Name": "Jiho\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiho\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiho\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiho\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiho\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiho\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jiho\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiho\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jiho\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiho\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiho\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jiho\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiho\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jiho\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiho\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jiho\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jiho\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jiho\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jiho\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiho\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jiho\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiho\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jihomoravsk\xfd (Region of Czechia)": [
            {
                "Region Name": "Jihomoravsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jihomoravsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jihomoravsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jihomoravsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jihomoravsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jihomoravsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jihomoravsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jihomoravsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jihomoravsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jihomoravsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jihomoravsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jihomoravsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jihomoravsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jihomoravsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jihomoravsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jihomoravsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jihomoravsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jihomoravsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jihomoravsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jihomoravsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jihomoravsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jihomoravsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jijel (Province of Algeria)": [
            {
                "Region Name": "Jijel (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jijel (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Jijel (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jijel (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jijel (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jijel (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Jijel (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Jijel (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Jijel (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jijel (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Jijel (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Jijel (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jijel (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jijel (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jijel (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jijel (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jijel (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jijel (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jijel (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jijel (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Jijel (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jijel (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Jilin (Province of China)": [
            {
                "Region Name": "Jilin (Province of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Jilin (Province of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Jilin (Province of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jilin (Province of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jilin (Province of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jilin (Province of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jilin (Province of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jilin (Province of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jilin (Province of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jilin (Province of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jilin (Province of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jilin (Province of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jilin (Province of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jilin (Province of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jilin (Province of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jilin (Province of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Jilin (Province of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Jilin (Province of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Jilin (Province of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Jilin (Province of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Jilin (Province of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Jilin (Province of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 20
            }
        ],
        "Jinja (District of Uganda)": [
            {
                "Region Name": "Jinja (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jinja (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jinja (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jinja (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jinja (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jinja (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jinja (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jinja (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jinja (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jinja (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jinja (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jinja (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jinja (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jinja (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jinja (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jinja (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jinja (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jinja (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jinja (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jinja (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jinja (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jinja (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jinotega (Department of Nicaragua)": [
            {
                "Region Name": "Jinotega (Department of Nicaragua)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jinotega (Department of Nicaragua)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jinotega (Department of Nicaragua)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jinotega (Department of Nicaragua)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jinotega (Department of Nicaragua)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jinotega (Department of Nicaragua)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jinotega (Department of Nicaragua)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jinotega (Department of Nicaragua)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jinotega (Department of Nicaragua)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jinotega (Department of Nicaragua)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jinotega (Department of Nicaragua)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jinotega (Department of Nicaragua)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jinotega (Department of Nicaragua)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jinotega (Department of Nicaragua)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jinotega (Department of Nicaragua)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jinotega (Department of Nicaragua)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jinotega (Department of Nicaragua)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jinotega (Department of Nicaragua)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jinotega (Department of Nicaragua)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jinotega (Department of Nicaragua)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jinotega (Department of Nicaragua)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jinotega (Department of Nicaragua)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Jiwaka (Province of Papua New Guinea)": [
            {
                "Region Name": "Jiwaka (Province of Papua New Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiwaka (Province of Papua New Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiwaka (Province of Papua New Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jiwaka (Province of Papua New Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiwaka (Province of Papua New Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiwaka (Province of Papua New Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jiwaka (Province of Papua New Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiwaka (Province of Papua New Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiwaka (Province of Papua New Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jiwaka (Province of Papua New Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiwaka (Province of Papua New Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiwaka (Province of Papua New Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiwaka (Province of Papua New Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiwaka (Province of Papua New Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiwaka (Province of Papua New Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiwaka (Province of Papua New Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiwaka (Province of Papua New Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiwaka (Province of Papua New Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiwaka (Province of Papua New Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jiwaka (Province of Papua New Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiwaka (Province of Papua New Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jiwaka (Province of Papua New Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jizan (Province of Saudi Arabia)": [
            {
                "Region Name": "Jizan (Province of Saudi Arabia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizan (Province of Saudi Arabia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizan (Province of Saudi Arabia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizan (Province of Saudi Arabia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizan (Province of Saudi Arabia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizan (Province of Saudi Arabia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizan (Province of Saudi Arabia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizan (Province of Saudi Arabia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizan (Province of Saudi Arabia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizan (Province of Saudi Arabia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizan (Province of Saudi Arabia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizan (Province of Saudi Arabia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizan (Province of Saudi Arabia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizan (Province of Saudi Arabia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizan (Province of Saudi Arabia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jizan (Province of Saudi Arabia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizan (Province of Saudi Arabia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizan (Province of Saudi Arabia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizan (Province of Saudi Arabia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizan (Province of Saudi Arabia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizan (Province of Saudi Arabia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jizan (Province of Saudi Arabia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jizzax (Region of Uzbekistan)": [
            {
                "Region Name": "Jizzax (Region of Uzbekistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Jizzax (Region of Uzbekistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jizzax (Region of Uzbekistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Jizzax (Region of Uzbekistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Jizzax (Region of Uzbekistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Jizzax (Region of Uzbekistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizzax (Region of Uzbekistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizzax (Region of Uzbekistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jizzax (Region of Uzbekistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizzax (Region of Uzbekistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizzax (Region of Uzbekistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizzax (Region of Uzbekistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jizzax (Region of Uzbekistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Jizzax (Region of Uzbekistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 71
            },
            {
                "Region Name": "Jizzax (Region of Uzbekistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizzax (Region of Uzbekistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Jizzax (Region of Uzbekistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizzax (Region of Uzbekistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizzax (Region of Uzbekistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jizzax (Region of Uzbekistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizzax (Region of Uzbekistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jizzax (Region of Uzbekistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "J\xf5geva (County of Estonia)": [
            {
                "Region Name": "J\xf5geva (County of Estonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf5geva (County of Estonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf5geva (County of Estonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf5geva (County of Estonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf5geva (County of Estonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf5geva (County of Estonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf5geva (County of Estonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf5geva (County of Estonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf5geva (County of Estonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf5geva (County of Estonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf5geva (County of Estonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf5geva (County of Estonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "J\xf5geva (County of Estonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf5geva (County of Estonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "J\xf5geva (County of Estonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf5geva (County of Estonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf5geva (County of Estonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf5geva (County of Estonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "J\xf5geva (County of Estonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf5geva (County of Estonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf5geva (County of Estonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf5geva (County of Estonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Johnston (Atoll of United States Minor Outlying Isl)": [
            {
                "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johnston (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Johor (State of Malaysia)": [
            {
                "Region Name": "Johor (State of Malaysia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Johor (State of Malaysia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Johor (State of Malaysia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Johor (State of Malaysia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Johor (State of Malaysia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Johor (State of Malaysia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johor (State of Malaysia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Johor (State of Malaysia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Johor (State of Malaysia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Johor (State of Malaysia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Johor (State of Malaysia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johor (State of Malaysia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Johor (State of Malaysia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Johor (State of Malaysia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Johor (State of Malaysia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Johor (State of Malaysia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Johor (State of Malaysia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Johor (State of Malaysia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Johor (State of Malaysia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johor (State of Malaysia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Johor (State of Malaysia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Johor (State of Malaysia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "J\xf6nk\xf6ping (County of Sweden)": [
            {
                "Region Name": "J\xf6nk\xf6ping (County of Sweden)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf6nk\xf6ping (County of Sweden)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf6nk\xf6ping (County of Sweden)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf6nk\xf6ping (County of Sweden)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf6nk\xf6ping (County of Sweden)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf6nk\xf6ping (County of Sweden)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf6nk\xf6ping (County of Sweden)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf6nk\xf6ping (County of Sweden)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf6nk\xf6ping (County of Sweden)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf6nk\xf6ping (County of Sweden)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf6nk\xf6ping (County of Sweden)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf6nk\xf6ping (County of Sweden)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf6nk\xf6ping (County of Sweden)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf6nk\xf6ping (County of Sweden)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf6nk\xf6ping (County of Sweden)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf6nk\xf6ping (County of Sweden)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf6nk\xf6ping (County of Sweden)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf6nk\xf6ping (County of Sweden)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf6nk\xf6ping (County of Sweden)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf6nk\xf6ping (County of Sweden)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf6nk\xf6ping (County of Sweden)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "J\xf6nk\xf6ping (County of Sweden)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jost Van Dyke (District of British Virgin Islands)": [
            {
                "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jost Van Dyke (District of British Virgin Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Juana D\xedaz (Municipality of Puerto Rico)": [
            {
                "Region Name": "Juana D\xedaz (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juana D\xedaz (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juana D\xedaz (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juana D\xedaz (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juana D\xedaz (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juana D\xedaz (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juana D\xedaz (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juana D\xedaz (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juana D\xedaz (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juana D\xedaz (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juana D\xedaz (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juana D\xedaz (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juana D\xedaz (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juana D\xedaz (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juana D\xedaz (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juana D\xedaz (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juana D\xedaz (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juana D\xedaz (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juana D\xedaz (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juana D\xedaz (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juana D\xedaz (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juana D\xedaz (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jubbada Dhexe (Region of Somalia)": [
            {
                "Region Name": "Jubbada Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jubbada Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jubbada Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jubbada Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jubbada Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jubbada Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jubbada Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jubbada Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jubbada Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jubbada Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jubbada Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jubbada Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Jubbada Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jubbada Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jubbada Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jubbada Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jubbada Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jubbada Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jubbada Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jubbada Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jubbada Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jubbada Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jubbada Hoose (Region of Somalia)": [
            {
                "Region Name": "Jubbada Hoose (Region of Somalia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Jubbada Hoose (Region of Somalia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jubbada Hoose (Region of Somalia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Jubbada Hoose (Region of Somalia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jubbada Hoose (Region of Somalia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Jubbada Hoose (Region of Somalia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Jubbada Hoose (Region of Somalia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jubbada Hoose (Region of Somalia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jubbada Hoose (Region of Somalia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jubbada Hoose (Region of Somalia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Jubbada Hoose (Region of Somalia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Jubbada Hoose (Region of Somalia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jubbada Hoose (Region of Somalia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jubbada Hoose (Region of Somalia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jubbada Hoose (Region of Somalia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jubbada Hoose (Region of Somalia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jubbada Hoose (Region of Somalia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jubbada Hoose (Region of Somalia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jubbada Hoose (Region of Somalia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Jubbada Hoose (Region of Somalia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jubbada Hoose (Region of Somalia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jubbada Hoose (Region of Somalia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jugovzhodna Slovenija (Statistical Region of Slovenia)": [
            {
                "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jugovzhodna Slovenija (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jujuy (Province of Argentina)": [
            {
                "Region Name": "Jujuy (Province of Argentina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jujuy (Province of Argentina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jujuy (Province of Argentina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jujuy (Province of Argentina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jujuy (Province of Argentina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jujuy (Province of Argentina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jujuy (Province of Argentina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jujuy (Province of Argentina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jujuy (Province of Argentina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jujuy (Province of Argentina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jujuy (Province of Argentina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jujuy (Province of Argentina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jujuy (Province of Argentina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jujuy (Province of Argentina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jujuy (Province of Argentina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jujuy (Province of Argentina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jujuy (Province of Argentina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jujuy (Province of Argentina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jujuy (Province of Argentina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jujuy (Province of Argentina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jujuy (Province of Argentina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jujuy (Province of Argentina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Juncos (Municipality of Puerto Rico)": [
            {
                "Region Name": "Juncos (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juncos (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juncos (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juncos (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juncos (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juncos (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juncos (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juncos (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juncos (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juncos (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juncos (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juncos (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juncos (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juncos (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juncos (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juncos (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juncos (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juncos (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juncos (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juncos (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juncos (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Juncos (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jungoli (State of South Sudan)": [
            {
                "Region Name": "Jungoli (State of South Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 65
            },
            {
                "Region Name": "Jungoli (State of South Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 67
            },
            {
                "Region Name": "Jungoli (State of South Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 65
            },
            {
                "Region Name": "Jungoli (State of South Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 78
            },
            {
                "Region Name": "Jungoli (State of South Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 65
            },
            {
                "Region Name": "Jungoli (State of South Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 74
            },
            {
                "Region Name": "Jungoli (State of South Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "Jungoli (State of South Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "Jungoli (State of South Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 65
            },
            {
                "Region Name": "Jungoli (State of South Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 70
            },
            {
                "Region Name": "Jungoli (State of South Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 76
            },
            {
                "Region Name": "Jungoli (State of South Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "Jungoli (State of South Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 68
            },
            {
                "Region Name": "Jungoli (State of South Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "Jungoli (State of South Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 65
            },
            {
                "Region Name": "Jungoli (State of South Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 66
            },
            {
                "Region Name": "Jungoli (State of South Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 61
            },
            {
                "Region Name": "Jungoli (State of South Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Jungoli (State of South Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 65
            },
            {
                "Region Name": "Jungoli (State of South Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 78
            },
            {
                "Region Name": "Jungoli (State of South Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 73
            },
            {
                "Region Name": "Jungoli (State of South Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 70
            }
        ],
        "Jun\xedn (Region of Peru)": [
            {
                "Region Name": "Jun\xedn (Region of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jun\xedn (Region of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jun\xedn (Region of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jun\xedn (Region of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jun\xedn (Region of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jun\xedn (Region of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jun\xedn (Region of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Jun\xedn (Region of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jun\xedn (Region of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Jun\xedn (Region of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jun\xedn (Region of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jun\xedn (Region of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jun\xedn (Region of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jun\xedn (Region of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jun\xedn (Region of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Jun\xedn (Region of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jun\xedn (Region of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jun\xedn (Region of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jun\xedn (Region of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jun\xedn (Region of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jun\xedn (Region of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Jun\xedn (Region of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Jura (Canton of Switzerland)": [
            {
                "Region Name": "Jura (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jura (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jura (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jura (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jura (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jura (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jura (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jura (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jura (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jura (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jura (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jura (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jura (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jura (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jura (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jura (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jura (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jura (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jura (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jura (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jura (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jura (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jurby (Parish District of Isle of Man)": [
            {
                "Region Name": "Jurby (Parish District of Isle of Man)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jurby (Parish District of Isle of Man)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jurby (Parish District of Isle of Man)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jurby (Parish District of Isle of Man)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jurby (Parish District of Isle of Man)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jurby (Parish District of Isle of Man)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jurby (Parish District of Isle of Man)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jurby (Parish District of Isle of Man)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jurby (Parish District of Isle of Man)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jurby (Parish District of Isle of Man)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jurby (Parish District of Isle of Man)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jurby (Parish District of Isle of Man)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jurby (Parish District of Isle of Man)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jurby (Parish District of Isle of Man)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jurby (Parish District of Isle of Man)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jurby (Parish District of Isle of Man)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jurby (Parish District of Isle of Man)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jurby (Parish District of Isle of Man)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jurby (Parish District of Isle of Man)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jurby (Parish District of Isle of Man)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jurby (Parish District of Isle of Man)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jurby (Parish District of Isle of Man)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jutiapa (Department of Guatemala)": [
            {
                "Region Name": "Jutiapa (Department of Guatemala)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Jutiapa (Department of Guatemala)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jutiapa (Department of Guatemala)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jutiapa (Department of Guatemala)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jutiapa (Department of Guatemala)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jutiapa (Department of Guatemala)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jutiapa (Department of Guatemala)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Jutiapa (Department of Guatemala)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jutiapa (Department of Guatemala)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jutiapa (Department of Guatemala)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jutiapa (Department of Guatemala)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jutiapa (Department of Guatemala)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jutiapa (Department of Guatemala)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jutiapa (Department of Guatemala)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Jutiapa (Department of Guatemala)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jutiapa (Department of Guatemala)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jutiapa (Department of Guatemala)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Jutiapa (Department of Guatemala)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Jutiapa (Department of Guatemala)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Jutiapa (Department of Guatemala)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Jutiapa (Department of Guatemala)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Jutiapa (Department of Guatemala)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Ju\u017Eno-Ba\u010Dki (District of Serbia)": [
            {
                "Region Name": "Ju\u017Eno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ju\u017Eno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Ju\u017Eno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ju\u017Eno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ju\u017Eno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ju\u017Eno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ju\u017Eno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ju\u017Eno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ju\u017Eno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ju\u017Eno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Ju\u017Eno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ju\u017Eno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ju\u017Eno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ju\u017Eno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ju\u017Eno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ju\u017Eno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ju\u017Eno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ju\u017Eno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ju\u017Eno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Ju\u017Eno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ju\u017Eno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ju\u017Eno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Ju\u017Eno-Banatski (District of Serbia)": [
            {
                "Region Name": "Ju\u017Eno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ju\u017Eno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Ju\u017Eno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ju\u017Eno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ju\u017Eno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ju\u017Eno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ju\u017Eno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ju\u017Eno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ju\u017Eno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ju\u017Eno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ju\u017Eno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Ju\u017Eno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ju\u017Eno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ju\u017Eno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ju\u017Eno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ju\u017Eno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ju\u017Eno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ju\u017Eno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ju\u017Eno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ju\u017Eno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Ju\u017Eno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Ju\u017Eno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Jwaneng (Town of Botswana)": [
            {
                "Region Name": "Jwaneng (Town of Botswana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jwaneng (Town of Botswana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jwaneng (Town of Botswana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jwaneng (Town of Botswana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jwaneng (Town of Botswana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jwaneng (Town of Botswana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jwaneng (Town of Botswana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jwaneng (Town of Botswana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jwaneng (Town of Botswana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jwaneng (Town of Botswana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jwaneng (Town of Botswana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jwaneng (Town of Botswana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jwaneng (Town of Botswana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jwaneng (Town of Botswana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jwaneng (Town of Botswana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jwaneng (Town of Botswana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jwaneng (Town of Botswana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jwaneng (Town of Botswana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jwaneng (Town of Botswana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jwaneng (Town of Botswana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jwaneng (Town of Botswana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Jwaneng (Town of Botswana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "K. Maras (Province of Turkey)": [
            {
                "Region Name": "K. Maras (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "K. Maras (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "K. Maras (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "K. Maras (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "K. Maras (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K. Maras (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "K. Maras (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "K. Maras (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "K. Maras (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "K. Maras (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K. Maras (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K. Maras (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "K. Maras (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K. Maras (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "K. Maras (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "K. Maras (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K. Maras (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K. Maras (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "K. Maras (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "K. Maras (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "K. Maras (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "K. Maras (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Kabale (District of Uganda)": [
            {
                "Region Name": "Kabale (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kabale (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabale (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kabale (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabale (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabale (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabale (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabale (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kabale (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabale (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabale (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabale (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabale (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kabale (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabale (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabale (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabale (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabale (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabale (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabale (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kabale (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabale (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Kabardin-Balkar (Republic of Russia)": [
            {
                "Region Name": "Kabardin-Balkar (Republic of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kabardin-Balkar (Republic of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kabardin-Balkar (Republic of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kabardin-Balkar (Republic of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kabardin-Balkar (Republic of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kabardin-Balkar (Republic of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kabardin-Balkar (Republic of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kabardin-Balkar (Republic of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kabardin-Balkar (Republic of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kabardin-Balkar (Republic of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kabardin-Balkar (Republic of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kabardin-Balkar (Republic of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kabardin-Balkar (Republic of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kabardin-Balkar (Republic of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kabardin-Balkar (Republic of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kabardin-Balkar (Republic of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kabardin-Balkar (Republic of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kabardin-Balkar (Republic of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kabardin-Balkar (Republic of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kabardin-Balkar (Republic of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kabardin-Balkar (Republic of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kabardin-Balkar (Republic of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Kabarole (District of Uganda)": [
            {
                "Region Name": "Kabarole (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kabarole (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Kabarole (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kabarole (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kabarole (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kabarole (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kabarole (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kabarole (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kabarole (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kabarole (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Kabarole (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kabarole (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kabarole (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kabarole (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kabarole (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kabarole (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kabarole (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kabarole (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kabarole (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kabarole (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Kabarole (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kabarole (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Kaberamaido (District of Uganda)": [
            {
                "Region Name": "Kaberamaido (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kaberamaido (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kaberamaido (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kaberamaido (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kaberamaido (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kaberamaido (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kaberamaido (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kaberamaido (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kaberamaido (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kaberamaido (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kaberamaido (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kaberamaido (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kaberamaido (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kaberamaido (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaberamaido (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kaberamaido (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kaberamaido (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kaberamaido (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaberamaido (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaberamaido (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kaberamaido (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kaberamaido (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kabul (Province of Afghanistan)": [
            {
                "Region Name": "Kabul (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabul (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabul (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabul (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabul (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabul (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabul (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabul (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabul (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabul (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabul (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabul (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabul (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabul (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabul (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabul (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabul (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabul (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabul (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabul (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabul (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kabul (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kachin (State of Myanmar)": [
            {
                "Region Name": "Kachin (State of Myanmar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kachin (State of Myanmar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kachin (State of Myanmar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kachin (State of Myanmar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kachin (State of Myanmar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kachin (State of Myanmar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kachin (State of Myanmar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kachin (State of Myanmar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kachin (State of Myanmar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kachin (State of Myanmar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kachin (State of Myanmar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kachin (State of Myanmar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kachin (State of Myanmar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kachin (State of Myanmar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kachin (State of Myanmar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kachin (State of Myanmar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kachin (State of Myanmar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kachin (State of Myanmar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kachin (State of Myanmar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kachin (State of Myanmar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kachin (State of Myanmar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kachin (State of Myanmar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Kaduna (State of Nigeria)": [
            {
                "Region Name": "Kaduna (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kaduna (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kaduna (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kaduna (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kaduna (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kaduna (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kaduna (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kaduna (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kaduna (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kaduna (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kaduna (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kaduna (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kaduna (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kaduna (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kaduna (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kaduna (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kaduna (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kaduna (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kaduna (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kaduna (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Kaduna (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kaduna (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 16
            }
        ],
        "Kaes\u014Fng (Special Administrative Region of North Korea)": [
            {
                "Region Name": "Kaes\u014Fng (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaes\u014Fng (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kaes\u014Fng (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Kaes\u014Fng (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kaes\u014Fng (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kaes\u014Fng (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Kaes\u014Fng (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kaes\u014Fng (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kaes\u014Fng (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kaes\u014Fng (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Kaes\u014Fng (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaes\u014Fng (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kaes\u014Fng (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Kaes\u014Fng (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kaes\u014Fng (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kaes\u014Fng (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kaes\u014Fng (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kaes\u014Fng (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kaes\u014Fng (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kaes\u014Fng (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaes\u014Fng (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kaes\u014Fng (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kaffrine (Region of Senegal)": [
            {
                "Region Name": "Kaffrine (Region of Senegal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Kaffrine (Region of Senegal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Kaffrine (Region of Senegal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kaffrine (Region of Senegal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Kaffrine (Region of Senegal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Kaffrine (Region of Senegal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Kaffrine (Region of Senegal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Kaffrine (Region of Senegal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Kaffrine (Region of Senegal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Kaffrine (Region of Senegal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kaffrine (Region of Senegal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Kaffrine (Region of Senegal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kaffrine (Region of Senegal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kaffrine (Region of Senegal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Kaffrine (Region of Senegal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Kaffrine (Region of Senegal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Kaffrine (Region of Senegal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kaffrine (Region of Senegal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Kaffrine (Region of Senegal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Kaffrine (Region of Senegal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kaffrine (Region of Senegal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kaffrine (Region of Senegal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 16
            }
        ],
        "Kafr ash Shaykh (Governorate of Egypt)": [
            {
                "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kafr ash Shaykh (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Kagawa (Prefecture of Japan)": [
            {
                "Region Name": "Kagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kagera (Region of Tanzania)": [
            {
                "Region Name": "Kagera (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kagera (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kagera (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kagera (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Kagera (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kagera (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kagera (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kagera (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kagera (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kagera (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kagera (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kagera (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kagera (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kagera (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kagera (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kagera (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kagera (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kagera (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Kagera (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kagera (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Kagera (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kagera (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Kagoshima (Prefecture of Japan)": [
            {
                "Region Name": "Kagoshima (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagoshima (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kagoshima (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagoshima (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagoshima (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kagoshima (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kagoshima (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagoshima (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagoshima (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagoshima (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagoshima (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagoshima (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kagoshima (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagoshima (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagoshima (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kagoshima (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kagoshima (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagoshima (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagoshima (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagoshima (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagoshima (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kagoshima (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kairouan (Governorate of Tunisia)": [
            {
                "Region Name": "Kairouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kairouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kairouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kairouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kairouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kairouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kairouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kairouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kairouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kairouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kairouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kairouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kairouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kairouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kairouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kairouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kairouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kairouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kairouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kairouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kairouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kairouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Kajiado (County of Kenya)": [
            {
                "Region Name": "Kajiado (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kajiado (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Kajiado (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kajiado (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kajiado (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kajiado (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Kajiado (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kajiado (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kajiado (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Kajiado (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kajiado (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kajiado (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kajiado (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kajiado (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kajiado (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kajiado (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kajiado (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kajiado (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kajiado (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kajiado (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kajiado (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kajiado (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Kakamega (County of Kenya)": [
            {
                "Region Name": "Kakamega (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kakamega (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kakamega (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kakamega (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kakamega (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kakamega (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kakamega (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kakamega (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kakamega (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kakamega (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kakamega (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kakamega (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kakamega (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kakamega (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kakamega (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kakamega (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kakamega (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kakamega (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kakamega (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kakamega (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kakamega (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kakamega (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kakheti (Region of Georgia)": [
            {
                "Region Name": "Kakheti (Region of Georgia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kakheti (Region of Georgia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kakheti (Region of Georgia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kakheti (Region of Georgia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Kakheti (Region of Georgia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kakheti (Region of Georgia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kakheti (Region of Georgia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kakheti (Region of Georgia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kakheti (Region of Georgia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kakheti (Region of Georgia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kakheti (Region of Georgia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kakheti (Region of Georgia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kakheti (Region of Georgia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kakheti (Region of Georgia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kakheti (Region of Georgia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kakheti (Region of Georgia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kakheti (Region of Georgia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kakheti (Region of Georgia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Kakheti (Region of Georgia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Kakheti (Region of Georgia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kakheti (Region of Georgia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kakheti (Region of Georgia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Kalangala (District of Uganda)": [
            {
                "Region Name": "Kalangala (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kalangala (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalangala (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kalangala (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalangala (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalangala (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalangala (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalangala (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalangala (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalangala (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalangala (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalangala (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalangala (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalangala (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalangala (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalangala (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalangala (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalangala (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalangala (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalangala (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalangala (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalangala (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kalasin (Province of Thailand)": [
            {
                "Region Name": "Kalasin (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kalasin (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kalasin (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kalasin (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kalasin (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalasin (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kalasin (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalasin (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kalasin (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kalasin (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kalasin (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kalasin (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kalasin (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kalasin (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kalasin (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kalasin (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kalasin (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kalasin (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kalasin (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kalasin (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kalasin (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kalasin (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Kalbajar-Lachin (Region of Azerbaijan)": [
            {
                "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Kalbajar-Lachin (Region of Azerbaijan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kalimantan Barat (Province of Indonesia)": [
            {
                "Region Name": "Kalimantan Barat (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kalimantan Barat (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kalimantan Barat (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kalimantan Barat (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kalimantan Barat (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kalimantan Barat (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kalimantan Barat (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kalimantan Barat (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kalimantan Barat (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalimantan Barat (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kalimantan Barat (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kalimantan Barat (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kalimantan Barat (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kalimantan Barat (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kalimantan Barat (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kalimantan Barat (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kalimantan Barat (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kalimantan Barat (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kalimantan Barat (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kalimantan Barat (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kalimantan Barat (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kalimantan Barat (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Kalimantan Selatan (Province of Indonesia)": [
            {
                "Region Name": "Kalimantan Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kalimantan Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kalimantan Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kalimantan Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kalimantan Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kalimantan Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kalimantan Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalimantan Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kalimantan Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalimantan Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kalimantan Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kalimantan Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kalimantan Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kalimantan Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kalimantan Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kalimantan Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kalimantan Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kalimantan Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kalimantan Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kalimantan Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kalimantan Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kalimantan Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Kalimantan Tengah (Province of Indonesia)": [
            {
                "Region Name": "Kalimantan Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kalimantan Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kalimantan Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kalimantan Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kalimantan Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kalimantan Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kalimantan Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kalimantan Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kalimantan Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kalimantan Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kalimantan Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kalimantan Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kalimantan Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kalimantan Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kalimantan Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalimantan Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kalimantan Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kalimantan Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kalimantan Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kalimantan Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kalimantan Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kalimantan Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "Kalimantan Timur (Province of Indonesia)": [
            {
                "Region Name": "Kalimantan Timur (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kalimantan Timur (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kalimantan Timur (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kalimantan Timur (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kalimantan Timur (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kalimantan Timur (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalimantan Timur (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalimantan Timur (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kalimantan Timur (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kalimantan Timur (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kalimantan Timur (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kalimantan Timur (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kalimantan Timur (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kalimantan Timur (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kalimantan Timur (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kalimantan Timur (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kalimantan Timur (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kalimantan Timur (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kalimantan Timur (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kalimantan Timur (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalimantan Timur (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kalimantan Timur (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Kalimantan Utara (Province of Indonesia)": [
            {
                "Region Name": "Kalimantan Utara (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kalimantan Utara (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalimantan Utara (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kalimantan Utara (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalimantan Utara (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalimantan Utara (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kalimantan Utara (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kalimantan Utara (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalimantan Utara (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalimantan Utara (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalimantan Utara (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalimantan Utara (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalimantan Utara (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalimantan Utara (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kalimantan Utara (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalimantan Utara (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kalimantan Utara (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kalimantan Utara (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Kalimantan Utara (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kalimantan Utara (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalimantan Utara (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalimantan Utara (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Kalinga (Province of Philippines)": [
            {
                "Region Name": "Kalinga (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kalinga (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalinga (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalinga (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalinga (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kalinga (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kalinga (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kalinga (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalinga (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kalinga (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kalinga (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kalinga (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalinga (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalinga (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kalinga (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kalinga (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kalinga (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kalinga (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalinga (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalinga (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kalinga (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kalinga (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Kaliningrad (Region of Russia)": [
            {
                "Region Name": "Kaliningrad (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kaliningrad (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kaliningrad (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kaliningrad (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kaliningrad (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kaliningrad (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kaliningrad (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kaliningrad (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kaliningrad (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kaliningrad (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kaliningrad (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kaliningrad (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kaliningrad (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kaliningrad (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kaliningrad (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kaliningrad (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kaliningrad (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Kaliningrad (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kaliningrad (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kaliningrad (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kaliningrad (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kaliningrad (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Kalmar (County of Sweden)": [
            {
                "Region Name": "Kalmar (County of Sweden)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalmar (County of Sweden)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalmar (County of Sweden)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalmar (County of Sweden)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalmar (County of Sweden)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalmar (County of Sweden)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalmar (County of Sweden)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalmar (County of Sweden)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalmar (County of Sweden)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalmar (County of Sweden)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalmar (County of Sweden)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalmar (County of Sweden)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalmar (County of Sweden)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalmar (County of Sweden)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalmar (County of Sweden)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalmar (County of Sweden)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalmar (County of Sweden)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalmar (County of Sweden)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalmar (County of Sweden)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalmar (County of Sweden)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalmar (County of Sweden)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalmar (County of Sweden)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kalmyk (Republic of Russia)": [
            {
                "Region Name": "Kalmyk (Republic of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Kalmyk (Republic of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Kalmyk (Republic of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Kalmyk (Republic of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Kalmyk (Republic of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Kalmyk (Republic of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Kalmyk (Republic of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kalmyk (Republic of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kalmyk (Republic of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kalmyk (Republic of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 63
            },
            {
                "Region Name": "Kalmyk (Republic of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kalmyk (Republic of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Kalmyk (Republic of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kalmyk (Republic of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Kalmyk (Republic of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kalmyk (Republic of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kalmyk (Republic of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Kalmyk (Republic of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kalmyk (Republic of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kalmyk (Republic of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kalmyk (Republic of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Kalmyk (Republic of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Kaluga (Region of Russia)": [
            {
                "Region Name": "Kaluga (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kaluga (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kaluga (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kaluga (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kaluga (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kaluga (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kaluga (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kaluga (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kaluga (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kaluga (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kaluga (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kaluga (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kaluga (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kaluga (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kaluga (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kaluga (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kaluga (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kaluga (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kaluga (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kaluga (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kaluga (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kaluga (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Kalutara (District of Sri Lanka)": [
            {
                "Region Name": "Kalutara (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalutara (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalutara (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalutara (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalutara (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalutara (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalutara (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalutara (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalutara (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalutara (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalutara (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalutara (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalutara (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalutara (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalutara (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalutara (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalutara (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalutara (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalutara (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalutara (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalutara (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kalutara (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kamchatka (Territory of Russia)": [
            {
                "Region Name": "Kamchatka (Territory of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Kamchatka (Territory of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Kamchatka (Territory of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kamchatka (Territory of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kamchatka (Territory of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 76
            },
            {
                "Region Name": "Kamchatka (Territory of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Kamchatka (Territory of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kamchatka (Territory of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kamchatka (Territory of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 173
            },
            {
                "Region Name": "Kamchatka (Territory of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kamchatka (Territory of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kamchatka (Territory of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kamchatka (Territory of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kamchatka (Territory of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kamchatka (Territory of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Kamchatka (Territory of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kamchatka (Territory of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kamchatka (Territory of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Kamchatka (Territory of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kamchatka (Territory of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "Kamchatka (Territory of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kamchatka (Territory of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Kampala (District of Uganda)": [
            {
                "Region Name": "Kampala (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kampala (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kampala (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kampala (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kampala (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kampala (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kampala (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kampala (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kampala (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kampala (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kampala (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kampala (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kampala (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kampala (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kampala (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kampala (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kampala (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kampala (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kampala (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kampala (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kampala (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kampala (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kamphaeng Phet (Province of Thailand)": [
            {
                "Region Name": "Kamphaeng Phet (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kamphaeng Phet (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kamphaeng Phet (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kamphaeng Phet (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kamphaeng Phet (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kamphaeng Phet (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kamphaeng Phet (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kamphaeng Phet (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kamphaeng Phet (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kamphaeng Phet (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kamphaeng Phet (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kamphaeng Phet (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kamphaeng Phet (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kamphaeng Phet (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kamphaeng Phet (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kamphaeng Phet (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kamphaeng Phet (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kamphaeng Phet (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kamphaeng Phet (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kamphaeng Phet (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kamphaeng Phet (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kamphaeng Phet (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "K\xe2mp\xf3ng Cham (Province of Cambodia)": [
            {
                "Region Name": "K\xe2mp\xf3ng Cham (Province of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2mp\xf3ng Cham (Province of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "K\xe2mp\xf3ng Cham (Province of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2mp\xf3ng Cham (Province of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "K\xe2mp\xf3ng Cham (Province of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "K\xe2mp\xf3ng Cham (Province of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "K\xe2mp\xf3ng Cham (Province of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2mp\xf3ng Cham (Province of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "K\xe2mp\xf3ng Cham (Province of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2mp\xf3ng Cham (Province of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "K\xe2mp\xf3ng Cham (Province of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2mp\xf3ng Cham (Province of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "K\xe2mp\xf3ng Cham (Province of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2mp\xf3ng Cham (Province of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2mp\xf3ng Cham (Province of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2mp\xf3ng Cham (Province of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2mp\xf3ng Cham (Province of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2mp\xf3ng Cham (Province of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2mp\xf3ng Cham (Province of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "K\xe2mp\xf3ng Cham (Province of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "K\xe2mp\xf3ng Cham (Province of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "K\xe2mp\xf3ng Cham (Province of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "K\xe2mp\xf3ng Chhnang (Province of Cambodia)": [
            {
                "Region Name": "K\xe2mp\xf3ng Chhnang (Province of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "K\xe2mp\xf3ng Chhnang (Province of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "K\xe2mp\xf3ng Chhnang (Province of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "K\xe2mp\xf3ng Chhnang (Province of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "K\xe2mp\xf3ng Chhnang (Province of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "K\xe2mp\xf3ng Chhnang (Province of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2mp\xf3ng Chhnang (Province of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "K\xe2mp\xf3ng Chhnang (Province of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "K\xe2mp\xf3ng Chhnang (Province of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "K\xe2mp\xf3ng Chhnang (Province of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "K\xe2mp\xf3ng Chhnang (Province of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2mp\xf3ng Chhnang (Province of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "K\xe2mp\xf3ng Chhnang (Province of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "K\xe2mp\xf3ng Chhnang (Province of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "K\xe2mp\xf3ng Chhnang (Province of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "K\xe2mp\xf3ng Chhnang (Province of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "K\xe2mp\xf3ng Chhnang (Province of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "K\xe2mp\xf3ng Chhnang (Province of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2mp\xf3ng Chhnang (Province of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2mp\xf3ng Chhnang (Province of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "K\xe2mp\xf3ng Chhnang (Province of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2mp\xf3ng Chhnang (Province of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "K\xe2mp\xf3ng Sp\u0153 (Province of Cambodia)": [
            {
                "Region Name": "K\xe2mp\xf3ng Sp\u0153 (Province of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "K\xe2mp\xf3ng Sp\u0153 (Province of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "K\xe2mp\xf3ng Sp\u0153 (Province of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "K\xe2mp\xf3ng Sp\u0153 (Province of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "K\xe2mp\xf3ng Sp\u0153 (Province of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "K\xe2mp\xf3ng Sp\u0153 (Province of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "K\xe2mp\xf3ng Sp\u0153 (Province of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "K\xe2mp\xf3ng Sp\u0153 (Province of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "K\xe2mp\xf3ng Sp\u0153 (Province of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "K\xe2mp\xf3ng Sp\u0153 (Province of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "K\xe2mp\xf3ng Sp\u0153 (Province of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "K\xe2mp\xf3ng Sp\u0153 (Province of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "K\xe2mp\xf3ng Sp\u0153 (Province of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "K\xe2mp\xf3ng Sp\u0153 (Province of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "K\xe2mp\xf3ng Sp\u0153 (Province of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "K\xe2mp\xf3ng Sp\u0153 (Province of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "K\xe2mp\xf3ng Sp\u0153 (Province of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "K\xe2mp\xf3ng Sp\u0153 (Province of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "K\xe2mp\xf3ng Sp\u0153 (Province of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "K\xe2mp\xf3ng Sp\u0153 (Province of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2mp\xf3ng Sp\u0153 (Province of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2mp\xf3ng Sp\u0153 (Province of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "K\xe2mp\xf3ng Thum (Province of Cambodia)": [
            {
                "Region Name": "K\xe2mp\xf3ng Thum (Province of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2mp\xf3ng Thum (Province of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2mp\xf3ng Thum (Province of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2mp\xf3ng Thum (Province of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2mp\xf3ng Thum (Province of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2mp\xf3ng Thum (Province of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2mp\xf3ng Thum (Province of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2mp\xf3ng Thum (Province of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "K\xe2mp\xf3ng Thum (Province of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2mp\xf3ng Thum (Province of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2mp\xf3ng Thum (Province of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2mp\xf3ng Thum (Province of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2mp\xf3ng Thum (Province of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2mp\xf3ng Thum (Province of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2mp\xf3ng Thum (Province of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2mp\xf3ng Thum (Province of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2mp\xf3ng Thum (Province of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2mp\xf3ng Thum (Province of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2mp\xf3ng Thum (Province of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2mp\xf3ng Thum (Province of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2mp\xf3ng Thum (Province of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "K\xe2mp\xf3ng Thum (Province of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "K\xe2mp\xf4t (Province of Cambodia)": [
            {
                "Region Name": "K\xe2mp\xf4t (Province of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "K\xe2mp\xf4t (Province of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "K\xe2mp\xf4t (Province of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "K\xe2mp\xf4t (Province of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "K\xe2mp\xf4t (Province of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "K\xe2mp\xf4t (Province of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "K\xe2mp\xf4t (Province of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2mp\xf4t (Province of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "K\xe2mp\xf4t (Province of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "K\xe2mp\xf4t (Province of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2mp\xf4t (Province of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "K\xe2mp\xf4t (Province of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "K\xe2mp\xf4t (Province of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "K\xe2mp\xf4t (Province of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "K\xe2mp\xf4t (Province of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2mp\xf4t (Province of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2mp\xf4t (Province of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2mp\xf4t (Province of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "K\xe2mp\xf4t (Province of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2mp\xf4t (Province of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2mp\xf4t (Province of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "K\xe2mp\xf4t (Province of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Kamuli (District of Uganda)": [
            {
                "Region Name": "Kamuli (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kamuli (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kamuli (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kamuli (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kamuli (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kamuli (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kamuli (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kamuli (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kamuli (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kamuli (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kamuli (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kamuli (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kamuli (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kamuli (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kamuli (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kamuli (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kamuli (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kamuli (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kamuli (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kamuli (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kamuli (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kamuli (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kamwenge (District of Uganda)": [
            {
                "Region Name": "Kamwenge (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kamwenge (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kamwenge (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kamwenge (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kamwenge (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kamwenge (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kamwenge (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kamwenge (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kamwenge (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kamwenge (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kamwenge (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kamwenge (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kamwenge (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kamwenge (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kamwenge (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kamwenge (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kamwenge (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kamwenge (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kamwenge (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kamwenge (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kamwenge (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kamwenge (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Kanagawa (Prefecture of Japan)": [
            {
                "Region Name": "Kanagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kanagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kanagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kanagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kanagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kanagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kanagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kanagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kanagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kanagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kanagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kanagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kanagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kanagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kanagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kanagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kanagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kanagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kanagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kanagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kanagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kanagawa (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kanchanaburi (Province of Thailand)": [
            {
                "Region Name": "Kanchanaburi (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kanchanaburi (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kanchanaburi (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kanchanaburi (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kanchanaburi (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kanchanaburi (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kanchanaburi (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kanchanaburi (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kanchanaburi (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kanchanaburi (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kanchanaburi (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kanchanaburi (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kanchanaburi (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kanchanaburi (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kanchanaburi (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kanchanaburi (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kanchanaburi (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kanchanaburi (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kanchanaburi (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kanchanaburi (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kanchanaburi (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kanchanaburi (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Kandahar (Province of Afghanistan)": [
            {
                "Region Name": "Kandahar (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandahar (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandahar (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandahar (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandahar (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandahar (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandahar (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandahar (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandahar (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandahar (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandahar (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandahar (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandahar (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandahar (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandahar (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandahar (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandahar (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandahar (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandahar (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kandahar (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandahar (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandahar (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "K\xe2ndal (Province of Cambodia)": [
            {
                "Region Name": "K\xe2ndal (Province of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xe2ndal (Province of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "K\xe2ndal (Province of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2ndal (Province of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2ndal (Province of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "K\xe2ndal (Province of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2ndal (Province of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2ndal (Province of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "K\xe2ndal (Province of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "K\xe2ndal (Province of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "K\xe2ndal (Province of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xe2ndal (Province of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "K\xe2ndal (Province of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "K\xe2ndal (Province of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "K\xe2ndal (Province of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "K\xe2ndal (Province of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "K\xe2ndal (Province of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2ndal (Province of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xe2ndal (Province of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "K\xe2ndal (Province of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "K\xe2ndal (Province of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "K\xe2ndal (Province of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Kandy (District of Sri Lanka)": [
            {
                "Region Name": "Kandy (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandy (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandy (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kandy (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandy (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandy (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kandy (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandy (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kandy (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandy (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandy (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandy (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandy (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandy (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandy (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kandy (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandy (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandy (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandy (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandy (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandy (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kandy (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kanem (Region of Chad)": [
            {
                "Region Name": "Kanem (Region of Chad)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kanem (Region of Chad)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kanem (Region of Chad)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 213
            },
            {
                "Region Name": "Kanem (Region of Chad)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Kanem (Region of Chad)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 84
            },
            {
                "Region Name": "Kanem (Region of Chad)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 88
            },
            {
                "Region Name": "Kanem (Region of Chad)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 84
            },
            {
                "Region Name": "Kanem (Region of Chad)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kanem (Region of Chad)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 155
            },
            {
                "Region Name": "Kanem (Region of Chad)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Kanem (Region of Chad)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Kanem (Region of Chad)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Kanem (Region of Chad)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kanem (Region of Chad)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Kanem (Region of Chad)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Kanem (Region of Chad)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 72
            },
            {
                "Region Name": "Kanem (Region of Chad)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Kanem (Region of Chad)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "Kanem (Region of Chad)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 106
            },
            {
                "Region Name": "Kanem (Region of Chad)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 101
            },
            {
                "Region Name": "Kanem (Region of Chad)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 57
            },
            {
                "Region Name": "Kanem (Region of Chad)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 45
            }
        ],
        "Kangw\u014Fn-do (Province of North Korea)": [
            {
                "Region Name": "Kangw\u014Fn-do (Province of North Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kangw\u014Fn-do (Province of North Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kangw\u014Fn-do (Province of North Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kangw\u014Fn-do (Province of North Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kangw\u014Fn-do (Province of North Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kangw\u014Fn-do (Province of North Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kangw\u014Fn-do (Province of North Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kangw\u014Fn-do (Province of North Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kangw\u014Fn-do (Province of North Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kangw\u014Fn-do (Province of North Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kangw\u014Fn-do (Province of North Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kangw\u014Fn-do (Province of North Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kangw\u014Fn-do (Province of North Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kangw\u014Fn-do (Province of North Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kangw\u014Fn-do (Province of North Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kangw\u014Fn-do (Province of North Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Kangw\u014Fn-do (Province of North Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Kangw\u014Fn-do (Province of North Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kangw\u014Fn-do (Province of North Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kangw\u014Fn-do (Province of North Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kangw\u014Fn-do (Province of North Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kangw\u014Fn-do (Province of North Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kani-Keli (Commune of Mayotte)": [
            {
                "Region Name": "Kani-Keli (Commune of Mayotte)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kani-Keli (Commune of Mayotte)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kani-Keli (Commune of Mayotte)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kani-Keli (Commune of Mayotte)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kani-Keli (Commune of Mayotte)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kani-Keli (Commune of Mayotte)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kani-Keli (Commune of Mayotte)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kani-Keli (Commune of Mayotte)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kani-Keli (Commune of Mayotte)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kani-Keli (Commune of Mayotte)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kani-Keli (Commune of Mayotte)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kani-Keli (Commune of Mayotte)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kani-Keli (Commune of Mayotte)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kani-Keli (Commune of Mayotte)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kani-Keli (Commune of Mayotte)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kani-Keli (Commune of Mayotte)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kani-Keli (Commune of Mayotte)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kani-Keli (Commune of Mayotte)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kani-Keli (Commune of Mayotte)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kani-Keli (Commune of Mayotte)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kani-Keli (Commune of Mayotte)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kani-Keli (Commune of Mayotte)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kankan (Region of Guinea)": [
            {
                "Region Name": "Kankan (Region of Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kankan (Region of Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kankan (Region of Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kankan (Region of Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kankan (Region of Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kankan (Region of Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kankan (Region of Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kankan (Region of Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kankan (Region of Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kankan (Region of Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kankan (Region of Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kankan (Region of Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kankan (Region of Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kankan (Region of Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kankan (Region of Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kankan (Region of Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kankan (Region of Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kankan (Region of Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kankan (Region of Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kankan (Region of Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kankan (Region of Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kankan (Region of Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Kano (State of Nigeria)": [
            {
                "Region Name": "Kano (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kano (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Kano (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kano (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kano (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kano (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kano (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kano (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kano (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kano (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kano (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kano (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kano (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kano (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kano (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kano (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kano (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kano (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kano (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kano (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kano (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kano (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Kansas (State of United States)": [
            {
                "Region Name": "Kansas (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kansas (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kansas (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kansas (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kansas (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kansas (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kansas (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kansas (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Kansas (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kansas (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kansas (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kansas (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kansas (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Kansas (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kansas (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Kansas (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kansas (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kansas (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kansas (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kansas (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kansas (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Kansas (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Kanungu (District of Uganda)": [
            {
                "Region Name": "Kanungu (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kanungu (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kanungu (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Kanungu (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kanungu (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Kanungu (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kanungu (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kanungu (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kanungu (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kanungu (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kanungu (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kanungu (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Kanungu (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Kanungu (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Kanungu (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kanungu (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kanungu (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Kanungu (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kanungu (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Kanungu (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kanungu (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kanungu (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Ka\xf4h Kong (Province of Cambodia)": [
            {
                "Region Name": "Ka\xf4h Kong (Province of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ka\xf4h Kong (Province of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ka\xf4h Kong (Province of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ka\xf4h Kong (Province of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ka\xf4h Kong (Province of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ka\xf4h Kong (Province of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ka\xf4h Kong (Province of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ka\xf4h Kong (Province of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ka\xf4h Kong (Province of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ka\xf4h Kong (Province of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ka\xf4h Kong (Province of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ka\xf4h Kong (Province of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ka\xf4h Kong (Province of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ka\xf4h Kong (Province of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ka\xf4h Kong (Province of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ka\xf4h Kong (Province of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ka\xf4h Kong (Province of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ka\xf4h Kong (Province of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ka\xf4h Kong (Province of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ka\xf4h Kong (Province of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ka\xf4h Kong (Province of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ka\xf4h Kong (Province of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Kaohsiung (Special Municipality of Taiwan)": [
            {
                "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaohsiung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kaolack (Region of Senegal)": [
            {
                "Region Name": "Kaolack (Region of Senegal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kaolack (Region of Senegal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kaolack (Region of Senegal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kaolack (Region of Senegal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kaolack (Region of Senegal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kaolack (Region of Senegal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kaolack (Region of Senegal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kaolack (Region of Senegal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kaolack (Region of Senegal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kaolack (Region of Senegal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kaolack (Region of Senegal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kaolack (Region of Senegal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kaolack (Region of Senegal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaolack (Region of Senegal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kaolack (Region of Senegal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kaolack (Region of Senegal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kaolack (Region of Senegal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kaolack (Region of Senegal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kaolack (Region of Senegal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kaolack (Region of Senegal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kaolack (Region of Senegal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kaolack (Region of Senegal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Kapchorwa (District of Uganda)": [
            {
                "Region Name": "Kapchorwa (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kapchorwa (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kapchorwa (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kapchorwa (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Kapchorwa (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Kapchorwa (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kapchorwa (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Kapchorwa (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kapchorwa (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kapchorwa (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Kapchorwa (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kapchorwa (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kapchorwa (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kapchorwa (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kapchorwa (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kapchorwa (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kapchorwa (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kapchorwa (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kapchorwa (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kapchorwa (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kapchorwa (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kapchorwa (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Kapisa (Province of Afghanistan)": [
            {
                "Region Name": "Kapisa (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kapisa (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kapisa (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kapisa (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kapisa (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kapisa (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kapisa (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kapisa (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kapisa (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kapisa (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kapisa (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kapisa (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kapisa (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kapisa (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kapisa (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kapisa (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kapisa (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kapisa (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kapisa (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kapisa (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kapisa (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kapisa (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kara (Region of Togo)": [
            {
                "Region Name": "Kara (Region of Togo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Kara (Region of Togo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kara (Region of Togo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kara (Region of Togo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kara (Region of Togo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kara (Region of Togo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kara (Region of Togo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kara (Region of Togo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kara (Region of Togo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kara (Region of Togo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Kara (Region of Togo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kara (Region of Togo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kara (Region of Togo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kara (Region of Togo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kara (Region of Togo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kara (Region of Togo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kara (Region of Togo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kara (Region of Togo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kara (Region of Togo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kara (Region of Togo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kara (Region of Togo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kara (Region of Togo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Karab\xfck (Province of Turkey)": [
            {
                "Region Name": "Karab\xfck (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karab\xfck (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Karab\xfck (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karab\xfck (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karab\xfck (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karab\xfck (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karab\xfck (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karab\xfck (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karab\xfck (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karab\xfck (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karab\xfck (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karab\xfck (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Karab\xfck (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karab\xfck (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karab\xfck (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karab\xfck (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karab\xfck (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karab\xfck (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karab\xfck (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karab\xfck (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karab\xfck (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karab\xfck (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Karachay-Cherkess (Republic of Russia)": [
            {
                "Region Name": "Karachay-Cherkess (Republic of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Karachay-Cherkess (Republic of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Karachay-Cherkess (Republic of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Karachay-Cherkess (Republic of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Karachay-Cherkess (Republic of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Karachay-Cherkess (Republic of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Karachay-Cherkess (Republic of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Karachay-Cherkess (Republic of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Karachay-Cherkess (Republic of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Karachay-Cherkess (Republic of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Karachay-Cherkess (Republic of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Karachay-Cherkess (Republic of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Karachay-Cherkess (Republic of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Karachay-Cherkess (Republic of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Karachay-Cherkess (Republic of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Karachay-Cherkess (Republic of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Karachay-Cherkess (Republic of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Karachay-Cherkess (Republic of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Karachay-Cherkess (Republic of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Karachay-Cherkess (Republic of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Karachay-Cherkess (Republic of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Karachay-Cherkess (Republic of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Karak (Province of Jordan)": [
            {
                "Region Name": "Karak (Province of Jordan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karak (Province of Jordan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karak (Province of Jordan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karak (Province of Jordan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karak (Province of Jordan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karak (Province of Jordan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karak (Province of Jordan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karak (Province of Jordan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karak (Province of Jordan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karak (Province of Jordan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karak (Province of Jordan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karak (Province of Jordan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karak (Province of Jordan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karak (Province of Jordan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karak (Province of Jordan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karak (Province of Jordan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karak (Province of Jordan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karak (Province of Jordan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karak (Province of Jordan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karak (Province of Jordan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karak (Province of Jordan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karak (Province of Jordan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Karaman (Province of Turkey)": [
            {
                "Region Name": "Karaman (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Karaman (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Karaman (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karaman (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karaman (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Karaman (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karaman (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karaman (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Karaman (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Karaman (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Karaman (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Karaman (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Karaman (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Karaman (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Karaman (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Karaman (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Karaman (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Karaman (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karaman (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Karaman (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Karaman (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Karaman (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Karas (Region of Namibia)": [
            {
                "Region Name": "Karas (Region of Namibia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Karas (Region of Namibia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karas (Region of Namibia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Karas (Region of Namibia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karas (Region of Namibia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Karas (Region of Namibia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karas (Region of Namibia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Karas (Region of Namibia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Karas (Region of Namibia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karas (Region of Namibia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Karas (Region of Namibia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Karas (Region of Namibia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Karas (Region of Namibia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Karas (Region of Namibia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Karas (Region of Namibia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karas (Region of Namibia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karas (Region of Namibia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Karas (Region of Namibia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karas (Region of Namibia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karas (Region of Namibia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Karas (Region of Namibia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Karas (Region of Namibia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Karbala' (Province of Iraq)": [
            {
                "Region Name": "Karbala' (Province of Iraq)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbala' (Province of Iraq)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbala' (Province of Iraq)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbala' (Province of Iraq)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Karbala' (Province of Iraq)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbala' (Province of Iraq)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbala' (Province of Iraq)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbala' (Province of Iraq)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbala' (Province of Iraq)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbala' (Province of Iraq)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbala' (Province of Iraq)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbala' (Province of Iraq)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbala' (Province of Iraq)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbala' (Province of Iraq)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Karbala' (Province of Iraq)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbala' (Province of Iraq)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbala' (Province of Iraq)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbala' (Province of Iraq)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbala' (Province of Iraq)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Karbala' (Province of Iraq)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Karbala' (Province of Iraq)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Karbala' (Province of Iraq)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Karbinci (Municipality of North Macedonia)": [
            {
                "Region Name": "Karbinci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbinci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Karbinci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbinci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbinci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbinci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbinci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbinci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbinci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Karbinci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbinci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbinci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbinci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbinci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbinci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Karbinci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbinci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbinci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbinci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbinci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbinci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karbinci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kardzhali (Province of Bulgaria)": [
            {
                "Region Name": "Kardzhali (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kardzhali (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kardzhali (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kardzhali (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kardzhali (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kardzhali (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kardzhali (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kardzhali (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kardzhali (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kardzhali (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kardzhali (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kardzhali (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kardzhali (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kardzhali (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kardzhali (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kardzhali (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kardzhali (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kardzhali (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kardzhali (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kardzhali (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kardzhali (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kardzhali (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Karelia (Republic of Russia)": [
            {
                "Region Name": "Karelia (Republic of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Karelia (Republic of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Karelia (Republic of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Karelia (Republic of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Karelia (Republic of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Karelia (Republic of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Karelia (Republic of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Karelia (Republic of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Karelia (Republic of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Karelia (Republic of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Karelia (Republic of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Karelia (Republic of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Karelia (Republic of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Karelia (Republic of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karelia (Republic of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Karelia (Republic of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karelia (Republic of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Karelia (Republic of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karelia (Republic of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karelia (Republic of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Karelia (Republic of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karelia (Republic of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Karlovacka (County of Croatia)": [
            {
                "Region Name": "Karlovacka (County of Croatia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Karlovacka (County of Croatia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Karlovacka (County of Croatia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovacka (County of Croatia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Karlovacka (County of Croatia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovacka (County of Croatia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Karlovacka (County of Croatia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovacka (County of Croatia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovacka (County of Croatia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovacka (County of Croatia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Karlovacka (County of Croatia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Karlovacka (County of Croatia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovacka (County of Croatia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovacka (County of Croatia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovacka (County of Croatia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovacka (County of Croatia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Karlovacka (County of Croatia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovacka (County of Croatia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovacka (County of Croatia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Karlovacka (County of Croatia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovacka (County of Croatia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Karlovacka (County of Croatia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Karlovarsk\xfd (Region of Czechia)": [
            {
                "Region Name": "Karlovarsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovarsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovarsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovarsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovarsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovarsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovarsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovarsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovarsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovarsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovarsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovarsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovarsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Karlovarsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovarsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovarsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovarsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovarsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Karlovarsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovarsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovarsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karlovarsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Karnataka (State of India)": [
            {
                "Region Name": "Karnataka (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Karnataka (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Karnataka (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Karnataka (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Karnataka (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Karnataka (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Karnataka (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Karnataka (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Karnataka (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Karnataka (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Karnataka (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Karnataka (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Karnataka (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Karnataka (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Karnataka (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Karnataka (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Karnataka (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Karnataka (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Karnataka (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Karnataka (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Karnataka (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Karnataka (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "K\xe4rnten (State of Austria)": [
            {
                "Region Name": "K\xe4rnten (State of Austria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xe4rnten (State of Austria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "K\xe4rnten (State of Austria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xe4rnten (State of Austria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xe4rnten (State of Austria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xe4rnten (State of Austria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xe4rnten (State of Austria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xe4rnten (State of Austria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xe4rnten (State of Austria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xe4rnten (State of Austria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xe4rnten (State of Austria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xe4rnten (State of Austria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xe4rnten (State of Austria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "K\xe4rnten (State of Austria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xe4rnten (State of Austria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xe4rnten (State of Austria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "K\xe4rnten (State of Austria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "K\xe4rnten (State of Austria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xe4rnten (State of Austria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xe4rnten (State of Austria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xe4rnten (State of Austria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xe4rnten (State of Austria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Karonga (District of Malawi)": [
            {
                "Region Name": "Karonga (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Karonga (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Karonga (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Karonga (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Karonga (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Karonga (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Karonga (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Karonga (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Karonga (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Karonga (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Karonga (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Karonga (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Karonga (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Karonga (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Karonga (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Karonga (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Karonga (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Karonga (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Karonga (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Karonga (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Karonga (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Karonga (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Karpo\u2248\xb0 (Municipality of North Macedonia)": [
            {
                "Region Name": "Karpo\u2248\xb0 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karpo\u2248\xb0 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karpo\u2248\xb0 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karpo\u2248\xb0 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karpo\u2248\xb0 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karpo\u2248\xb0 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karpo\u2248\xb0 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karpo\u2248\xb0 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karpo\u2248\xb0 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karpo\u2248\xb0 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karpo\u2248\xb0 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karpo\u2248\xb0 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karpo\u2248\xb0 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karpo\u2248\xb0 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karpo\u2248\xb0 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karpo\u2248\xb0 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karpo\u2248\xb0 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karpo\u2248\xb0 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karpo\u2248\xb0 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karpo\u2248\xb0 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karpo\u2248\xb0 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Karpo\u2248\xb0 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kars (Province of Turkey)": [
            {
                "Region Name": "Kars (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kars (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kars (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kars (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kars (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kars (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kars (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kars (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kars (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kars (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kars (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kars (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kars (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kars (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kars (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kars (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kars (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kars (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kars (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kars (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kars (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kars (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Karuzi (Province of Burundi)": [
            {
                "Region Name": "Karuzi (Province of Burundi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Karuzi (Province of Burundi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Karuzi (Province of Burundi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Karuzi (Province of Burundi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Karuzi (Province of Burundi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Karuzi (Province of Burundi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Karuzi (Province of Burundi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Karuzi (Province of Burundi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Karuzi (Province of Burundi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Karuzi (Province of Burundi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Karuzi (Province of Burundi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Karuzi (Province of Burundi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Karuzi (Province of Burundi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Karuzi (Province of Burundi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Karuzi (Province of Burundi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Karuzi (Province of Burundi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Karuzi (Province of Burundi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Karuzi (Province of Burundi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Karuzi (Province of Burundi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Karuzi (Province of Burundi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Karuzi (Province of Burundi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Karuzi (Province of Burundi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Kasa\xef-Central (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Kasa\xef-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kasa\xef-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kasa\xef-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kasa\xef-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kasa\xef-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kasa\xef-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kasa\xef-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kasa\xef-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kasa\xef-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kasa\xef-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kasa\xef-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kasa\xef-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kasa\xef-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kasa\xef-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kasa\xef-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kasa\xef-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kasa\xef-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kasa\xef-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kasa\xef-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kasa\xef-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kasa\xef-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kasa\xef-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Kasa\xef-Oriental (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Kasa\xef-Oriental (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kasa\xef-Oriental (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kasa\xef-Oriental (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kasa\xef-Oriental (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kasa\xef-Oriental (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kasa\xef-Oriental (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kasa\xef-Oriental (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kasa\xef-Oriental (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kasa\xef-Oriental (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kasa\xef-Oriental (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kasa\xef-Oriental (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kasa\xef-Oriental (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kasa\xef-Oriental (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kasa\xef-Oriental (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kasa\xef-Oriental (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kasa\xef-Oriental (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kasa\xef-Oriental (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kasa\xef-Oriental (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kasa\xef-Oriental (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kasa\xef-Oriental (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kasa\xef-Oriental (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kasa\xef-Oriental (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Kasa\xef (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Kasa\xef (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Kasa\xef (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kasa\xef (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kasa\xef (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kasa\xef (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kasa\xef (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kasa\xef (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kasa\xef (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kasa\xef (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kasa\xef (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kasa\xef (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kasa\xef (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kasa\xef (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kasa\xef (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kasa\xef (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kasa\xef (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kasa\xef (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kasa\xef (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kasa\xef (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kasa\xef (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kasa\xef (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kasa\xef (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Kasese (District of Uganda)": [
            {
                "Region Name": "Kasese (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kasese (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Kasese (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kasese (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kasese (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kasese (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kasese (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kasese (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kasese (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kasese (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Kasese (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Kasese (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kasese (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kasese (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kasese (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kasese (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kasese (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kasese (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Kasese (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Kasese (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kasese (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kasese (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Kaskazini Pemba (Region of Tanzania)": [
            {
                "Region Name": "Kaskazini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kaskazini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kaskazini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kaskazini Unguja (Region of Tanzania)": [
            {
                "Region Name": "Kaskazini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kaskazini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kaskazini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kaskazini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kaskazini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kassala (State of Sudan)": [
            {
                "Region Name": "Kassala (State of Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kassala (State of Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kassala (State of Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kassala (State of Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kassala (State of Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kassala (State of Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kassala (State of Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kassala (State of Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kassala (State of Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kassala (State of Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kassala (State of Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kassala (State of Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kassala (State of Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kassala (State of Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kassala (State of Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kassala (State of Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kassala (State of Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kassala (State of Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kassala (State of Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kassala (State of Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kassala (State of Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kassala (State of Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Kasserine (Governorate of Tunisia)": [
            {
                "Region Name": "Kasserine (Governorate of Tunisia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kasserine (Governorate of Tunisia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kasserine (Governorate of Tunisia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kasserine (Governorate of Tunisia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kasserine (Governorate of Tunisia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kasserine (Governorate of Tunisia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kasserine (Governorate of Tunisia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kasserine (Governorate of Tunisia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kasserine (Governorate of Tunisia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kasserine (Governorate of Tunisia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kasserine (Governorate of Tunisia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kasserine (Governorate of Tunisia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Kasserine (Governorate of Tunisia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kasserine (Governorate of Tunisia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kasserine (Governorate of Tunisia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kasserine (Governorate of Tunisia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kasserine (Governorate of Tunisia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kasserine (Governorate of Tunisia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kasserine (Governorate of Tunisia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kasserine (Governorate of Tunisia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Kasserine (Governorate of Tunisia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kasserine (Governorate of Tunisia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kastamonu (Province of Turkey)": [
            {
                "Region Name": "Kastamonu (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kastamonu (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kastamonu (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kastamonu (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kastamonu (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kastamonu (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kastamonu (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kastamonu (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kastamonu (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kastamonu (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kastamonu (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kastamonu (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kastamonu (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kastamonu (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kastamonu (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kastamonu (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kastamonu (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kastamonu (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kastamonu (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kastamonu (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kastamonu (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kastamonu (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kasungu (District of Malawi)": [
            {
                "Region Name": "Kasungu (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kasungu (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kasungu (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kasungu (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kasungu (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kasungu (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kasungu (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kasungu (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kasungu (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kasungu (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kasungu (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kasungu (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kasungu (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kasungu (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kasungu (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kasungu (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kasungu (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kasungu (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kasungu (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kasungu (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kasungu (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kasungu (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Katakwi (District of Uganda)": [
            {
                "Region Name": "Katakwi (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Katakwi (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Katakwi (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Katakwi (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Katakwi (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Katakwi (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Katakwi (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Katakwi (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Katakwi (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Katakwi (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Katakwi (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Katakwi (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Katakwi (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Katakwi (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Katakwi (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Katakwi (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Katakwi (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Katakwi (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Katakwi (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Katakwi (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Katakwi (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Katakwi (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Katavi (Region of Tanzania)": [
            {
                "Region Name": "Katavi (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Katavi (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Katavi (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Katavi (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Katavi (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Katavi (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Katavi (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Katavi (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Katavi (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Katavi (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Katavi (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Katavi (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Katavi (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Katavi (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Katavi (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Katavi (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Katavi (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Katavi (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Katavi (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Katavi (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Katavi (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Katavi (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 21
            }
        ],
        "Katsina (State of Nigeria)": [
            {
                "Region Name": "Katsina (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Katsina (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Katsina (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Katsina (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Katsina (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Katsina (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Katsina (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Katsina (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Katsina (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Katsina (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Katsina (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Katsina (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Katsina (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Katsina (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Katsina (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Katsina (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Katsina (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Katsina (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Katsina (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Katsina (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Katsina (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Katsina (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 21
            }
        ],
        "Kauno (County of Lithuania)": [
            {
                "Region Name": "Kauno (County of Lithuania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kauno (County of Lithuania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kauno (County of Lithuania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kauno (County of Lithuania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kauno (County of Lithuania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kauno (County of Lithuania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kauno (County of Lithuania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kauno (County of Lithuania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kauno (County of Lithuania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kauno (County of Lithuania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kauno (County of Lithuania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kauno (County of Lithuania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kauno (County of Lithuania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kauno (County of Lithuania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kauno (County of Lithuania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kauno (County of Lithuania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kauno (County of Lithuania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kauno (County of Lithuania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kauno (County of Lithuania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kauno (County of Lithuania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kauno (County of Lithuania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kauno (County of Lithuania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Kavadartsi (Municipality of North Macedonia)": [
            {
                "Region Name": "Kavadartsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kavadartsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kavadartsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kavadartsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kavadartsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kavadartsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kavadartsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kavadartsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kavadartsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kavadartsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kavadartsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kavadartsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kavadartsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kavadartsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kavadartsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kavadartsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kavadartsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kavadartsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kavadartsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kavadartsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kavadartsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kavadartsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kavango (Region of Namibia)": [
            {
                "Region Name": "Kavango (Region of Namibia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 87
            },
            {
                "Region Name": "Kavango (Region of Namibia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 108
            },
            {
                "Region Name": "Kavango (Region of Namibia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 123
            },
            {
                "Region Name": "Kavango (Region of Namibia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 170
            },
            {
                "Region Name": "Kavango (Region of Namibia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 136
            },
            {
                "Region Name": "Kavango (Region of Namibia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 141
            },
            {
                "Region Name": "Kavango (Region of Namibia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 119
            },
            {
                "Region Name": "Kavango (Region of Namibia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 98
            },
            {
                "Region Name": "Kavango (Region of Namibia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 96
            },
            {
                "Region Name": "Kavango (Region of Namibia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 108
            },
            {
                "Region Name": "Kavango (Region of Namibia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 114
            },
            {
                "Region Name": "Kavango (Region of Namibia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 129
            },
            {
                "Region Name": "Kavango (Region of Namibia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 73
            },
            {
                "Region Name": "Kavango (Region of Namibia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 87
            },
            {
                "Region Name": "Kavango (Region of Namibia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 98
            },
            {
                "Region Name": "Kavango (Region of Namibia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 81
            },
            {
                "Region Name": "Kavango (Region of Namibia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "Kavango (Region of Namibia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 100
            },
            {
                "Region Name": "Kavango (Region of Namibia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 101
            },
            {
                "Region Name": "Kavango (Region of Namibia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Kavango (Region of Namibia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Kavango (Region of Namibia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 48
            }
        ],
        "Kayah (State of Myanmar)": [
            {
                "Region Name": "Kayah (State of Myanmar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Kayah (State of Myanmar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Kayah (State of Myanmar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Kayah (State of Myanmar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kayah (State of Myanmar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Kayah (State of Myanmar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kayah (State of Myanmar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Kayah (State of Myanmar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kayah (State of Myanmar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Kayah (State of Myanmar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Kayah (State of Myanmar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kayah (State of Myanmar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Kayah (State of Myanmar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Kayah (State of Myanmar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kayah (State of Myanmar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Kayah (State of Myanmar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Kayah (State of Myanmar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Kayah (State of Myanmar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Kayah (State of Myanmar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Kayah (State of Myanmar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kayah (State of Myanmar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kayah (State of Myanmar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 16
            }
        ],
        "Kayangel (State of Palau)": [
            {
                "Region Name": "Kayangel (State of Palau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayangel (State of Palau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayangel (State of Palau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayangel (State of Palau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayangel (State of Palau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayangel (State of Palau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayangel (State of Palau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayangel (State of Palau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayangel (State of Palau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayangel (State of Palau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayangel (State of Palau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayangel (State of Palau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayangel (State of Palau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayangel (State of Palau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayangel (State of Palau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayangel (State of Palau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayangel (State of Palau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayangel (State of Palau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayangel (State of Palau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayangel (State of Palau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayangel (State of Palau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayangel (State of Palau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kayanza (Province of Burundi)": [
            {
                "Region Name": "Kayanza (Province of Burundi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kayanza (Province of Burundi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayanza (Province of Burundi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayanza (Province of Burundi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayanza (Province of Burundi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayanza (Province of Burundi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayanza (Province of Burundi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayanza (Province of Burundi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayanza (Province of Burundi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kayanza (Province of Burundi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayanza (Province of Burundi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayanza (Province of Burundi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayanza (Province of Burundi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayanza (Province of Burundi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kayanza (Province of Burundi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayanza (Province of Burundi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayanza (Province of Burundi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayanza (Province of Burundi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayanza (Province of Burundi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayanza (Province of Burundi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayanza (Province of Burundi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayanza (Province of Burundi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kayes (Region of Mali)": [
            {
                "Region Name": "Kayes (Region of Mali)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Kayes (Region of Mali)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kayes (Region of Mali)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Kayes (Region of Mali)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Kayes (Region of Mali)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Kayes (Region of Mali)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Kayes (Region of Mali)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Kayes (Region of Mali)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kayes (Region of Mali)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kayes (Region of Mali)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Kayes (Region of Mali)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kayes (Region of Mali)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kayes (Region of Mali)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kayes (Region of Mali)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Kayes (Region of Mali)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Kayes (Region of Mali)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kayes (Region of Mali)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kayes (Region of Mali)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kayes (Region of Mali)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kayes (Region of Mali)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kayes (Region of Mali)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kayes (Region of Mali)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "Kayin (State of Myanmar)": [
            {
                "Region Name": "Kayin (State of Myanmar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kayin (State of Myanmar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kayin (State of Myanmar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kayin (State of Myanmar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kayin (State of Myanmar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kayin (State of Myanmar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kayin (State of Myanmar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kayin (State of Myanmar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kayin (State of Myanmar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kayin (State of Myanmar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kayin (State of Myanmar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kayin (State of Myanmar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kayin (State of Myanmar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kayin (State of Myanmar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kayin (State of Myanmar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kayin (State of Myanmar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kayin (State of Myanmar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kayin (State of Myanmar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kayin (State of Myanmar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kayin (State of Myanmar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kayin (State of Myanmar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kayin (State of Myanmar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Kayseri (Province of Turkey)": [
            {
                "Region Name": "Kayseri (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayseri (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kayseri (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayseri (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kayseri (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kayseri (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kayseri (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kayseri (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kayseri (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kayseri (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kayseri (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kayseri (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kayseri (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayseri (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kayseri (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kayseri (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kayseri (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kayseri (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kayseri (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayseri (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayseri (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayseri (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Kayunga (District of Uganda)": [
            {
                "Region Name": "Kayunga (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayunga (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kayunga (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kayunga (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kayunga (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kayunga (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kayunga (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kayunga (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayunga (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kayunga (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kayunga (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kayunga (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kayunga (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kayunga (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kayunga (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kayunga (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kayunga (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kayunga (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kayunga (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kayunga (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kayunga (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kayunga (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Kebbi (State of Nigeria)": [
            {
                "Region Name": "Kebbi (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Kebbi (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Kebbi (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Kebbi (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Kebbi (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Kebbi (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Kebbi (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kebbi (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Kebbi (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Kebbi (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kebbi (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kebbi (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kebbi (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kebbi (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kebbi (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kebbi (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kebbi (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kebbi (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kebbi (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kebbi (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Kebbi (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kebbi (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "Kebili (Governorate of Tunisia)": [
            {
                "Region Name": "Kebili (Governorate of Tunisia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kebili (Governorate of Tunisia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kebili (Governorate of Tunisia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kebili (Governorate of Tunisia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kebili (Governorate of Tunisia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kebili (Governorate of Tunisia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kebili (Governorate of Tunisia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kebili (Governorate of Tunisia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kebili (Governorate of Tunisia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kebili (Governorate of Tunisia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kebili (Governorate of Tunisia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kebili (Governorate of Tunisia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kebili (Governorate of Tunisia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kebili (Governorate of Tunisia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kebili (Governorate of Tunisia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kebili (Governorate of Tunisia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kebili (Governorate of Tunisia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kebili (Governorate of Tunisia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kebili (Governorate of Tunisia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kebili (Governorate of Tunisia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kebili (Governorate of Tunisia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kebili (Governorate of Tunisia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kedah (State of Malaysia)": [
            {
                "Region Name": "Kedah (State of Malaysia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kedah (State of Malaysia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kedah (State of Malaysia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Kedah (State of Malaysia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kedah (State of Malaysia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kedah (State of Malaysia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kedah (State of Malaysia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Kedah (State of Malaysia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kedah (State of Malaysia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Kedah (State of Malaysia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kedah (State of Malaysia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kedah (State of Malaysia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kedah (State of Malaysia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kedah (State of Malaysia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kedah (State of Malaysia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kedah (State of Malaysia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kedah (State of Malaysia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kedah (State of Malaysia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kedah (State of Malaysia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kedah (State of Malaysia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kedah (State of Malaysia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Kedah (State of Malaysia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "K\xe9dougou (Region of Senegal)": [
            {
                "Region Name": "K\xe9dougou (Region of Senegal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "K\xe9dougou (Region of Senegal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "K\xe9dougou (Region of Senegal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "K\xe9dougou (Region of Senegal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "K\xe9dougou (Region of Senegal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "K\xe9dougou (Region of Senegal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "K\xe9dougou (Region of Senegal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "K\xe9dougou (Region of Senegal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "K\xe9dougou (Region of Senegal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "K\xe9dougou (Region of Senegal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "K\xe9dougou (Region of Senegal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "K\xe9dougou (Region of Senegal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "K\xe9dougou (Region of Senegal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "K\xe9dougou (Region of Senegal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "K\xe9dougou (Region of Senegal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "K\xe9dougou (Region of Senegal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "K\xe9dougou (Region of Senegal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "K\xe9dougou (Region of Senegal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "K\xe9dougou (Region of Senegal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "K\xe9dougou (Region of Senegal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "K\xe9dougou (Region of Senegal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "K\xe9dougou (Region of Senegal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Kegalle (District of Sri Lanka)": [
            {
                "Region Name": "Kegalle (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kegalle (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kegalle (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kegalle (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kegalle (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kegalle (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kegalle (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kegalle (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kegalle (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kegalle (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kegalle (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kegalle (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kegalle (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kegalle (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kegalle (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kegalle (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kegalle (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kegalle (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kegalle (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kegalle (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kegalle (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kegalle (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kelantan (State of Malaysia)": [
            {
                "Region Name": "Kelantan (State of Malaysia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kelantan (State of Malaysia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kelantan (State of Malaysia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kelantan (State of Malaysia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kelantan (State of Malaysia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kelantan (State of Malaysia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kelantan (State of Malaysia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kelantan (State of Malaysia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kelantan (State of Malaysia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kelantan (State of Malaysia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kelantan (State of Malaysia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kelantan (State of Malaysia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kelantan (State of Malaysia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kelantan (State of Malaysia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kelantan (State of Malaysia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kelantan (State of Malaysia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kelantan (State of Malaysia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kelantan (State of Malaysia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kelantan (State of Malaysia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kelantan (State of Malaysia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kelantan (State of Malaysia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kelantan (State of Malaysia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kemerovo (Region of Russia)": [
            {
                "Region Name": "Kemerovo (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kemerovo (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kemerovo (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kemerovo (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kemerovo (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kemerovo (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kemerovo (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kemerovo (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kemerovo (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kemerovo (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kemerovo (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kemerovo (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kemerovo (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kemerovo (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kemerovo (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kemerovo (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kemerovo (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kemerovo (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kemerovo (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kemerovo (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kemerovo (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Kemerovo (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "K\xe9mo (Prefecture of Central African Republic)": [
            {
                "Region Name": "K\xe9mo (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "K\xe9mo (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "K\xe9mo (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "K\xe9mo (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "K\xe9mo (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "K\xe9mo (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "K\xe9mo (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "K\xe9mo (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "K\xe9mo (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "K\xe9mo (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "K\xe9mo (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "K\xe9mo (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "K\xe9mo (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "K\xe9mo (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "K\xe9mo (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "K\xe9mo (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "K\xe9mo (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "K\xe9mo (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "K\xe9mo (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "K\xe9mo (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "K\xe9mo (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "K\xe9mo (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Kentucky (State of United States)": [
            {
                "Region Name": "Kentucky (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kentucky (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kentucky (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kentucky (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kentucky (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kentucky (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kentucky (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kentucky (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kentucky (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kentucky (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kentucky (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kentucky (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kentucky (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kentucky (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kentucky (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kentucky (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kentucky (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kentucky (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kentucky (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kentucky (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kentucky (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kentucky (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Kep (Province of Cambodia)": [
            {
                "Region Name": "Kep (Province of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kep (Province of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kep (Province of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kep (Province of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kep (Province of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kep (Province of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kep (Province of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kep (Province of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kep (Province of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kep (Province of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kep (Province of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kep (Province of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kep (Province of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kep (Province of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kep (Province of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kep (Province of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kep (Province of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kep (Province of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kep (Province of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kep (Province of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kep (Province of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kep (Province of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kepulauan Riau (Province of Indonesia)": [
            {
                "Region Name": "Kepulauan Riau (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kepulauan Riau (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kepulauan Riau (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kepulauan Riau (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kepulauan Riau (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kepulauan Riau (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kepulauan Riau (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kepulauan Riau (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kepulauan Riau (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kepulauan Riau (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kepulauan Riau (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kepulauan Riau (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kepulauan Riau (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kepulauan Riau (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kepulauan Riau (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kepulauan Riau (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kepulauan Riau (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kepulauan Riau (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kepulauan Riau (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Kepulauan Riau (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kepulauan Riau (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kepulauan Riau (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Kerala (State of India)": [
            {
                "Region Name": "Kerala (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kerala (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kerala (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kerala (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kerala (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kerala (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kerala (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kerala (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Kerala (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kerala (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kerala (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kerala (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kerala (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kerala (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerala (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kerala (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kerala (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kerala (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kerala (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kerala (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerala (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kerala (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Kerguelen (District of French Southern Territories)": [
            {
                "Region Name": "Kerguelen (District of French Southern Territories)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerguelen (District of French Southern Territories)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerguelen (District of French Southern Territories)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerguelen (District of French Southern Territories)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerguelen (District of French Southern Territories)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerguelen (District of French Southern Territories)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerguelen (District of French Southern Territories)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerguelen (District of French Southern Territories)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerguelen (District of French Southern Territories)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerguelen (District of French Southern Territories)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerguelen (District of French Southern Territories)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerguelen (District of French Southern Territories)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerguelen (District of French Southern Territories)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerguelen (District of French Southern Territories)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerguelen (District of French Southern Territories)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerguelen (District of French Southern Territories)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerguelen (District of French Southern Territories)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerguelen (District of French Southern Territories)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerguelen (District of French Southern Territories)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerguelen (District of French Southern Territories)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerguelen (District of French Southern Territories)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerguelen (District of French Southern Territories)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kericho (County of Kenya)": [
            {
                "Region Name": "Kericho (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kericho (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kericho (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kericho (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kericho (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kericho (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kericho (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kericho (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kericho (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Kericho (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kericho (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kericho (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kericho (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kericho (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kericho (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kericho (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kericho (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kericho (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kericho (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kericho (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kericho (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kericho (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kerman (Province of Iran)": [
            {
                "Region Name": "Kerman (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kerman (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kerman (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kerman (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kerman (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kerman (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kerman (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kerman (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kerman (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kerman (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kerman (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerman (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kerman (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kerman (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kerman (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kerman (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kerman (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerman (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kerman (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kerman (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kerman (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kerman (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Kermanshah (Province of Iran)": [
            {
                "Region Name": "Kermanshah (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kermanshah (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kermanshah (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kermanshah (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kermanshah (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kermanshah (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kermanshah (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kermanshah (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kermanshah (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kermanshah (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kermanshah (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kermanshah (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kermanshah (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kermanshah (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Kermanshah (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kermanshah (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kermanshah (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kermanshah (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kermanshah (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kermanshah (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kermanshah (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kermanshah (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Kerry (County of Ireland)": [
            {
                "Region Name": "Kerry (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerry (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerry (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerry (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerry (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerry (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kerry (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerry (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerry (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kerry (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerry (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerry (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerry (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerry (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kerry (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerry (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kerry (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerry (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerry (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerry (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerry (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kerry (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kgalagadi (District of Botswana)": [
            {
                "Region Name": "Kgalagadi (District of Botswana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 152
            },
            {
                "Region Name": "Kgalagadi (District of Botswana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kgalagadi (District of Botswana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kgalagadi (District of Botswana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 92
            },
            {
                "Region Name": "Kgalagadi (District of Botswana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 318
            },
            {
                "Region Name": "Kgalagadi (District of Botswana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 234
            },
            {
                "Region Name": "Kgalagadi (District of Botswana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 72
            },
            {
                "Region Name": "Kgalagadi (District of Botswana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 78
            },
            {
                "Region Name": "Kgalagadi (District of Botswana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 469
            },
            {
                "Region Name": "Kgalagadi (District of Botswana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 377
            },
            {
                "Region Name": "Kgalagadi (District of Botswana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 116
            },
            {
                "Region Name": "Kgalagadi (District of Botswana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 78
            },
            {
                "Region Name": "Kgalagadi (District of Botswana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 181
            },
            {
                "Region Name": "Kgalagadi (District of Botswana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 117
            },
            {
                "Region Name": "Kgalagadi (District of Botswana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 86
            },
            {
                "Region Name": "Kgalagadi (District of Botswana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 152
            },
            {
                "Region Name": "Kgalagadi (District of Botswana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 119
            },
            {
                "Region Name": "Kgalagadi (District of Botswana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kgalagadi (District of Botswana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 138
            },
            {
                "Region Name": "Kgalagadi (District of Botswana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 355
            },
            {
                "Region Name": "Kgalagadi (District of Botswana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 118
            },
            {
                "Region Name": "Kgalagadi (District of Botswana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 210
            }
        ],
        "Kgatleng (District of Botswana)": [
            {
                "Region Name": "Kgatleng (District of Botswana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 155
            },
            {
                "Region Name": "Kgatleng (District of Botswana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kgatleng (District of Botswana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kgatleng (District of Botswana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kgatleng (District of Botswana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kgatleng (District of Botswana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kgatleng (District of Botswana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 453
            },
            {
                "Region Name": "Kgatleng (District of Botswana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Kgatleng (District of Botswana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 73
            },
            {
                "Region Name": "Kgatleng (District of Botswana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 196
            },
            {
                "Region Name": "Kgatleng (District of Botswana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kgatleng (District of Botswana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 79
            },
            {
                "Region Name": "Kgatleng (District of Botswana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kgatleng (District of Botswana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kgatleng (District of Botswana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kgatleng (District of Botswana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kgatleng (District of Botswana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kgatleng (District of Botswana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kgatleng (District of Botswana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kgatleng (District of Botswana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Kgatleng (District of Botswana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 292
            },
            {
                "Region Name": "Kgatleng (District of Botswana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 277
            }
        ],
        "Khabarovsk (Territory of Russia)": [
            {
                "Region Name": "Khabarovsk (Territory of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Khabarovsk (Territory of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Khabarovsk (Territory of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khabarovsk (Territory of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Khabarovsk (Territory of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Khabarovsk (Territory of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Khabarovsk (Territory of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Khabarovsk (Territory of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Khabarovsk (Territory of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Khabarovsk (Territory of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Khabarovsk (Territory of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Khabarovsk (Territory of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Khabarovsk (Territory of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Khabarovsk (Territory of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Khabarovsk (Territory of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Khabarovsk (Territory of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Khabarovsk (Territory of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Khabarovsk (Territory of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Khabarovsk (Territory of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Khabarovsk (Territory of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Khabarovsk (Territory of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Khabarovsk (Territory of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 30
            }
        ],
        "Khakass (Republic of Russia)": [
            {
                "Region Name": "Khakass (Republic of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Khakass (Republic of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Khakass (Republic of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Khakass (Republic of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Khakass (Republic of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Khakass (Republic of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Khakass (Republic of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Khakass (Republic of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Khakass (Republic of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Khakass (Republic of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Khakass (Republic of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Khakass (Republic of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khakass (Republic of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Khakass (Republic of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Khakass (Republic of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khakass (Republic of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khakass (Republic of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Khakass (Republic of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Khakass (Republic of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khakass (Republic of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Khakass (Republic of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Khakass (Republic of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Khammouan (Province of Laos)": [
            {
                "Region Name": "Khammouan (Province of Laos)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Khammouan (Province of Laos)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khammouan (Province of Laos)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Khammouan (Province of Laos)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khammouan (Province of Laos)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khammouan (Province of Laos)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Khammouan (Province of Laos)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khammouan (Province of Laos)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khammouan (Province of Laos)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Khammouan (Province of Laos)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khammouan (Province of Laos)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Khammouan (Province of Laos)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khammouan (Province of Laos)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Khammouan (Province of Laos)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khammouan (Province of Laos)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khammouan (Province of Laos)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khammouan (Province of Laos)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khammouan (Province of Laos)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Khammouan (Province of Laos)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khammouan (Province of Laos)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khammouan (Province of Laos)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khammouan (Province of Laos)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Kh\xe1nh H\xf2a (Province of Vietnam)": [
            {
                "Region Name": "Kh\xe1nh H\xf2a (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kh\xe1nh H\xf2a (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kh\xe1nh H\xf2a (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kh\xe1nh H\xf2a (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kh\xe1nh H\xf2a (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kh\xe1nh H\xf2a (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kh\xe1nh H\xf2a (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kh\xe1nh H\xf2a (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kh\xe1nh H\xf2a (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kh\xe1nh H\xf2a (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kh\xe1nh H\xf2a (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kh\xe1nh H\xf2a (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kh\xe1nh H\xf2a (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kh\xe1nh H\xf2a (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kh\xe1nh H\xf2a (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kh\xe1nh H\xf2a (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kh\xe1nh H\xf2a (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kh\xe1nh H\xf2a (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kh\xe1nh H\xf2a (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kh\xe1nh H\xf2a (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kh\xe1nh H\xf2a (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kh\xe1nh H\xf2a (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Khanty-Mansiy (Autonomous Province of Russia)": [
            {
                "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Khanty-Mansiy (Autonomous Province of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Kharkiv (Region of Ukraine)": [
            {
                "Region Name": "Kharkiv (Region of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kharkiv (Region of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kharkiv (Region of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kharkiv (Region of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kharkiv (Region of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kharkiv (Region of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kharkiv (Region of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kharkiv (Region of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kharkiv (Region of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kharkiv (Region of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kharkiv (Region of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kharkiv (Region of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kharkiv (Region of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kharkiv (Region of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kharkiv (Region of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kharkiv (Region of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kharkiv (Region of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kharkiv (Region of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kharkiv (Region of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kharkiv (Region of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kharkiv (Region of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kharkiv (Region of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Khartoum (State of Sudan)": [
            {
                "Region Name": "Khartoum (State of Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khartoum (State of Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Khartoum (State of Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khartoum (State of Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khartoum (State of Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khartoum (State of Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Khartoum (State of Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khartoum (State of Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khartoum (State of Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khartoum (State of Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khartoum (State of Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khartoum (State of Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khartoum (State of Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Khartoum (State of Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Khartoum (State of Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khartoum (State of Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khartoum (State of Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khartoum (State of Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Khartoum (State of Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Khartoum (State of Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Khartoum (State of Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Khartoum (State of Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Khatlon (Region of Tajikistan)": [
            {
                "Region Name": "Khatlon (Region of Tajikistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khatlon (Region of Tajikistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Khatlon (Region of Tajikistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Khatlon (Region of Tajikistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Khatlon (Region of Tajikistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Khatlon (Region of Tajikistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Khatlon (Region of Tajikistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Khatlon (Region of Tajikistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Khatlon (Region of Tajikistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Khatlon (Region of Tajikistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Khatlon (Region of Tajikistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khatlon (Region of Tajikistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Khatlon (Region of Tajikistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Khatlon (Region of Tajikistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Khatlon (Region of Tajikistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khatlon (Region of Tajikistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khatlon (Region of Tajikistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khatlon (Region of Tajikistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khatlon (Region of Tajikistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Khatlon (Region of Tajikistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khatlon (Region of Tajikistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Khatlon (Region of Tajikistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Khenchela (Province of Algeria)": [
            {
                "Region Name": "Khenchela (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khenchela (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khenchela (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khenchela (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khenchela (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khenchela (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khenchela (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Khenchela (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 72
            },
            {
                "Region Name": "Khenchela (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khenchela (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khenchela (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 171
            },
            {
                "Region Name": "Khenchela (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khenchela (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Khenchela (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khenchela (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khenchela (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khenchela (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khenchela (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khenchela (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khenchela (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 78
            },
            {
                "Region Name": "Khenchela (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khenchela (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Kherson (Region of Ukraine)": [
            {
                "Region Name": "Kherson (Region of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kherson (Region of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kherson (Region of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kherson (Region of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kherson (Region of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kherson (Region of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kherson (Region of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kherson (Region of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kherson (Region of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kherson (Region of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kherson (Region of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kherson (Region of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kherson (Region of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kherson (Region of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kherson (Region of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kherson (Region of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kherson (Region of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kherson (Region of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kherson (Region of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kherson (Region of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kherson (Region of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kherson (Region of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Khmel'nyts'kyy (Region of Ukraine)": [
            {
                "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Khmel'nyts'kyy (Region of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Khomas (Region of Namibia)": [
            {
                "Region Name": "Khomas (Region of Namibia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Khomas (Region of Namibia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Khomas (Region of Namibia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khomas (Region of Namibia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Khomas (Region of Namibia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 92
            },
            {
                "Region Name": "Khomas (Region of Namibia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Khomas (Region of Namibia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Khomas (Region of Namibia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Khomas (Region of Namibia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Khomas (Region of Namibia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Khomas (Region of Namibia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Khomas (Region of Namibia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Khomas (Region of Namibia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Khomas (Region of Namibia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Khomas (Region of Namibia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 57
            },
            {
                "Region Name": "Khomas (Region of Namibia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Khomas (Region of Namibia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Khomas (Region of Namibia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khomas (Region of Namibia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "Khomas (Region of Namibia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 166
            },
            {
                "Region Name": "Khomas (Region of Namibia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Khomas (Region of Namibia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 56
            }
        ],
        "Khon Kaen (Province of Thailand)": [
            {
                "Region Name": "Khon Kaen (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khon Kaen (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Khon Kaen (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Khon Kaen (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khon Kaen (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Khon Kaen (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khon Kaen (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khon Kaen (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khon Kaen (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khon Kaen (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Khon Kaen (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Khon Kaen (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khon Kaen (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khon Kaen (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khon Kaen (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khon Kaen (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khon Kaen (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Khon Kaen (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khon Kaen (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Khon Kaen (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khon Kaen (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khon Kaen (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Khost (Province of Afghanistan)": [
            {
                "Region Name": "Khost (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khost (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Khost (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khost (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Khost (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khost (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khost (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khost (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Khost (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khost (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Khost (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khost (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khost (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khost (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khost (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Khost (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khost (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khost (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khost (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Khost (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khost (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khost (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Khulna (Division of Bangladesh)": [
            {
                "Region Name": "Khulna (Division of Bangladesh)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Khulna (Division of Bangladesh)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Khulna (Division of Bangladesh)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khulna (Division of Bangladesh)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Khulna (Division of Bangladesh)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Khulna (Division of Bangladesh)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khulna (Division of Bangladesh)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Khulna (Division of Bangladesh)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Khulna (Division of Bangladesh)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Khulna (Division of Bangladesh)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Khulna (Division of Bangladesh)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khulna (Division of Bangladesh)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Khulna (Division of Bangladesh)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Khulna (Division of Bangladesh)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khulna (Division of Bangladesh)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khulna (Division of Bangladesh)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Khulna (Division of Bangladesh)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khulna (Division of Bangladesh)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khulna (Division of Bangladesh)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khulna (Division of Bangladesh)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Khulna (Division of Bangladesh)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Khulna (Division of Bangladesh)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Khuzestan (Province of Iran)": [
            {
                "Region Name": "Khuzestan (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khuzestan (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Khuzestan (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khuzestan (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khuzestan (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khuzestan (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khuzestan (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khuzestan (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khuzestan (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khuzestan (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khuzestan (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khuzestan (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khuzestan (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khuzestan (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khuzestan (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khuzestan (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khuzestan (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khuzestan (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khuzestan (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khuzestan (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khuzestan (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khuzestan (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Khyber-Pakhtunkhwa (Province of Pakistan)": [
            {
                "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Khyber-Pakhtunkhwa (Province of Pakistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Kiambu (County of Kenya)": [
            {
                "Region Name": "Kiambu (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kiambu (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kiambu (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kiambu (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kiambu (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiambu (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kiambu (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiambu (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiambu (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kiambu (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiambu (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kiambu (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kiambu (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kiambu (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiambu (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kiambu (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiambu (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiambu (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiambu (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kiambu (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kiambu (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiambu (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Kibale (District of Uganda)": [
            {
                "Region Name": "Kibale (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kibale (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kibale (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kibale (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kibale (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kibale (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kibale (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kibale (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kibale (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kibale (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kibale (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kibale (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kibale (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kibale (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kibale (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kibale (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kibale (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kibale (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kibale (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kibale (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kibale (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kibale (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Kiboga (District of Uganda)": [
            {
                "Region Name": "Kiboga (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kiboga (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kiboga (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kiboga (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kiboga (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kiboga (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kiboga (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kiboga (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kiboga (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kiboga (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kiboga (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kiboga (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kiboga (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kiboga (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kiboga (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kiboga (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kiboga (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kiboga (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kiboga (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kiboga (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kiboga (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kiboga (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Ki\u010Devo (Municipality of North Macedonia)": [
            {
                "Region Name": "Ki\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ki\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ki\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ki\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ki\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ki\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ki\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ki\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kidal (Region of Mali)": [
            {
                "Region Name": "Kidal (Region of Mali)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kidal (Region of Mali)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kidal (Region of Mali)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kidal (Region of Mali)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kidal (Region of Mali)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kidal (Region of Mali)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kidal (Region of Mali)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kidal (Region of Mali)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kidal (Region of Mali)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kidal (Region of Mali)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kidal (Region of Mali)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kidal (Region of Mali)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kidal (Region of Mali)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kidal (Region of Mali)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kidal (Region of Mali)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kidal (Region of Mali)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kidal (Region of Mali)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kidal (Region of Mali)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kidal (Region of Mali)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kidal (Region of Mali)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kidal (Region of Mali)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kidal (Region of Mali)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ki\xe9-Ntem (Province of Equatorial Guinea)": [
            {
                "Region Name": "Ki\xe9-Ntem (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\xe9-Ntem (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\xe9-Ntem (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\xe9-Ntem (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\xe9-Ntem (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\xe9-Ntem (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\xe9-Ntem (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\xe9-Ntem (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\xe9-Ntem (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\xe9-Ntem (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\xe9-Ntem (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\xe9-Ntem (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\xe9-Ntem (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\xe9-Ntem (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\xe9-Ntem (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\xe9-Ntem (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\xe9-Ntem (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\xe9-Ntem (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\xe9-Ntem (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\xe9-Ntem (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\xe9-Ntem (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ki\xe9-Ntem (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Ki\xean Giang (Province of Vietnam)": [
            {
                "Region Name": "Ki\xean Giang (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ki\xean Giang (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Ki\xean Giang (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ki\xean Giang (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ki\xean Giang (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ki\xean Giang (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ki\xean Giang (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Ki\xean Giang (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Ki\xean Giang (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ki\xean Giang (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Ki\xean Giang (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Ki\xean Giang (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Ki\xean Giang (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Ki\xean Giang (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Ki\xean Giang (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Ki\xean Giang (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ki\xean Giang (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Ki\xean Giang (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Ki\xean Giang (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Ki\xean Giang (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Ki\xean Giang (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Ki\xean Giang (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 19
            }
        ],
        "Kiev (Region of Ukraine)": [
            {
                "Region Name": "Kiev (Region of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kiev (Region of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kiev (Region of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kiev (Region of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kiev (Region of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kiev (Region of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kiev (Region of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kiev (Region of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kiev (Region of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kiev (Region of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kiev (Region of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kiev (Region of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kiev (Region of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kiev (Region of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kiev (Region of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kiev (Region of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kiev (Region of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kiev (Region of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kiev (Region of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Kiev (Region of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kiev (Region of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kiev (Region of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Kiev City (Independent City of Ukraine)": [
            {
                "Region Name": "Kiev City (Independent City of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiev City (Independent City of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiev City (Independent City of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiev City (Independent City of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kiev City (Independent City of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiev City (Independent City of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiev City (Independent City of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiev City (Independent City of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiev City (Independent City of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiev City (Independent City of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiev City (Independent City of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kiev City (Independent City of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiev City (Independent City of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kiev City (Independent City of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kiev City (Independent City of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiev City (Independent City of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiev City (Independent City of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiev City (Independent City of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiev City (Independent City of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiev City (Independent City of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiev City (Independent City of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kiev City (Independent City of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kigoma (Region of Tanzania)": [
            {
                "Region Name": "Kigoma (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Kigoma (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Kigoma (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Kigoma (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Kigoma (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Kigoma (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kigoma (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kigoma (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Kigoma (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kigoma (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Kigoma (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Kigoma (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kigoma (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kigoma (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Kigoma (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kigoma (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Kigoma (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kigoma (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kigoma (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kigoma (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kigoma (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Kigoma (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 24
            }
        ],
        "Kildare (County of Ireland)": [
            {
                "Region Name": "Kildare (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kildare (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kildare (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kildare (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kildare (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kildare (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kildare (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kildare (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kildare (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kildare (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kildare (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kildare (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kildare (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kildare (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kildare (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kildare (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kildare (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kildare (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kildare (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kildare (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kildare (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kildare (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kilifi (County of Kenya)": [
            {
                "Region Name": "Kilifi (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kilifi (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kilifi (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kilifi (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kilifi (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Kilifi (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kilifi (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kilifi (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kilifi (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kilifi (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilifi (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kilifi (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kilifi (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kilifi (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kilifi (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kilifi (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilifi (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilifi (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kilifi (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kilifi (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilifi (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kilifi (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Kilimanjaro (Region of Tanzania)": [
            {
                "Region Name": "Kilimanjaro (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kilimanjaro (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kilimanjaro (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kilimanjaro (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kilimanjaro (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kilimanjaro (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kilimanjaro (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kilimanjaro (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kilimanjaro (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kilimanjaro (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kilimanjaro (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kilimanjaro (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kilimanjaro (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kilimanjaro (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kilimanjaro (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kilimanjaro (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kilimanjaro (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kilimanjaro (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kilimanjaro (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Kilimanjaro (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kilimanjaro (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kilimanjaro (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 21
            }
        ],
        "Kilinochchi (District of Sri Lanka)": [
            {
                "Region Name": "Kilinochchi (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilinochchi (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kilinochchi (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilinochchi (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kilinochchi (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilinochchi (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilinochchi (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kilinochchi (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kilinochchi (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kilinochchi (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilinochchi (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilinochchi (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kilinochchi (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilinochchi (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilinochchi (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilinochchi (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilinochchi (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilinochchi (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilinochchi (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kilinochchi (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilinochchi (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilinochchi (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Kilis (Province of Turkey)": [
            {
                "Region Name": "Kilis (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kilis (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kilis (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilis (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilis (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kilis (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilis (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilis (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kilis (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilis (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilis (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilis (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kilis (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilis (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kilis (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilis (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilis (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilis (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilis (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kilis (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kilis (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilis (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kilkenny (County of Ireland)": [
            {
                "Region Name": "Kilkenny (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilkenny (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilkenny (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilkenny (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilkenny (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilkenny (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilkenny (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilkenny (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilkenny (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilkenny (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilkenny (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilkenny (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilkenny (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilkenny (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kilkenny (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilkenny (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilkenny (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilkenny (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilkenny (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilkenny (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilkenny (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kilkenny (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kindia (Region of Guinea)": [
            {
                "Region Name": "Kindia (Region of Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kindia (Region of Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kindia (Region of Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kindia (Region of Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kindia (Region of Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kindia (Region of Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kindia (Region of Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kindia (Region of Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kindia (Region of Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kindia (Region of Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kindia (Region of Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kindia (Region of Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kindia (Region of Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kindia (Region of Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kindia (Region of Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kindia (Region of Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kindia (Region of Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kindia (Region of Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kindia (Region of Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kindia (Region of Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kindia (Region of Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kindia (Region of Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Kingman Reef (Reef of United States Minor Outlying Isl)": [
            {
                "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingman Reef (Reef of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kingston (Parish of Jamaica)": [
            {
                "Region Name": "Kingston (Parish of Jamaica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingston (Parish of Jamaica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingston (Parish of Jamaica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingston (Parish of Jamaica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingston (Parish of Jamaica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingston (Parish of Jamaica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingston (Parish of Jamaica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingston (Parish of Jamaica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingston (Parish of Jamaica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingston (Parish of Jamaica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingston (Parish of Jamaica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingston (Parish of Jamaica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingston (Parish of Jamaica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingston (Parish of Jamaica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingston (Parish of Jamaica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingston (Parish of Jamaica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingston (Parish of Jamaica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingston (Parish of Jamaica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingston (Parish of Jamaica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingston (Parish of Jamaica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingston (Parish of Jamaica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kingston (Parish of Jamaica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kinkkale (Province of Turkey)": [
            {
                "Region Name": "Kinkkale (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kinkkale (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kinkkale (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kinkkale (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kinkkale (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kinkkale (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kinkkale (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kinkkale (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kinkkale (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kinkkale (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kinkkale (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kinkkale (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kinkkale (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kinkkale (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kinkkale (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kinkkale (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kinkkale (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kinkkale (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kinkkale (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kinkkale (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kinkkale (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kinkkale (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kinshasa (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kinshasa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Kirinyaga (County of Kenya)": [
            {
                "Region Name": "Kirinyaga (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kirinyaga (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirinyaga (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirinyaga (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kirinyaga (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirinyaga (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kirinyaga (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kirinyaga (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirinyaga (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kirinyaga (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirinyaga (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirinyaga (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirinyaga (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirinyaga (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirinyaga (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirinyaga (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirinyaga (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kirinyaga (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirinyaga (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirinyaga (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirinyaga (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kirinyaga (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Kirklareli (Province of Turkey)": [
            {
                "Region Name": "Kirklareli (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirklareli (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kirklareli (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirklareli (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirklareli (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirklareli (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kirklareli (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirklareli (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kirklareli (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kirklareli (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kirklareli (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirklareli (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirklareli (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kirklareli (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kirklareli (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kirklareli (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kirklareli (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirklareli (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kirklareli (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirklareli (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirklareli (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kirklareli (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Kirov (Region of Russia)": [
            {
                "Region Name": "Kirov (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kirov (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kirov (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kirov (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kirov (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kirov (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kirov (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kirov (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kirov (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kirov (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kirov (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kirov (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kirov (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kirov (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kirov (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirov (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kirov (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kirov (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kirov (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kirov (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kirov (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kirov (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Kirovohrad (Region of Ukraine)": [
            {
                "Region Name": "Kirovohrad (Region of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kirovohrad (Region of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kirovohrad (Region of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kirovohrad (Region of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kirovohrad (Region of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kirovohrad (Region of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kirovohrad (Region of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kirovohrad (Region of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kirovohrad (Region of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kirovohrad (Region of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kirovohrad (Region of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kirovohrad (Region of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kirovohrad (Region of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kirovohrad (Region of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kirovohrad (Region of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kirovohrad (Region of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kirovohrad (Region of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kirovohrad (Region of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kirovohrad (Region of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kirovohrad (Region of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kirovohrad (Region of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kirovohrad (Region of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Kirsehir (Province of Turkey)": [
            {
                "Region Name": "Kirsehir (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kirsehir (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kirsehir (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kirsehir (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kirsehir (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kirsehir (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kirsehir (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirsehir (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kirsehir (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kirsehir (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kirsehir (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirsehir (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kirsehir (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirsehir (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kirsehir (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kirsehir (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kirsehir (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kirsehir (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kirsehir (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kirsehir (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kirsehir (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kirsehir (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Kirundo (Province of Burundi)": [
            {
                "Region Name": "Kirundo (Province of Burundi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kirundo (Province of Burundi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kirundo (Province of Burundi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kirundo (Province of Burundi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirundo (Province of Burundi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirundo (Province of Burundi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirundo (Province of Burundi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kirundo (Province of Burundi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirundo (Province of Burundi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirundo (Province of Burundi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirundo (Province of Burundi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirundo (Province of Burundi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirundo (Province of Burundi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirundo (Province of Burundi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirundo (Province of Burundi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirundo (Province of Burundi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kirundo (Province of Burundi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirundo (Province of Burundi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirundo (Province of Burundi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirundo (Province of Burundi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirundo (Province of Burundi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kirundo (Province of Burundi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kisela Voda (Municipality of North Macedonia)": [
            {
                "Region Name": "Kisela Voda (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisela Voda (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisela Voda (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisela Voda (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisela Voda (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisela Voda (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisela Voda (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisela Voda (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisela Voda (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisela Voda (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisela Voda (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisela Voda (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisela Voda (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisela Voda (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisela Voda (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisela Voda (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisela Voda (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisela Voda (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisela Voda (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisela Voda (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisela Voda (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisela Voda (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kisii (County of Kenya)": [
            {
                "Region Name": "Kisii (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisii (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisii (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisii (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisii (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisii (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisii (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisii (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisii (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisii (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisii (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisii (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisii (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisii (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisii (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisii (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisii (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisii (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisii (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisii (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisii (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisii (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kisoro (District of Uganda)": [
            {
                "Region Name": "Kisoro (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisoro (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisoro (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisoro (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kisoro (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisoro (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kisoro (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisoro (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kisoro (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisoro (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisoro (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kisoro (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kisoro (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisoro (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kisoro (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisoro (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisoro (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisoro (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisoro (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kisoro (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisoro (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisoro (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kisumu (County of Kenya)": [
            {
                "Region Name": "Kisumu (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kisumu (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kisumu (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kisumu (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kisumu (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisumu (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kisumu (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kisumu (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisumu (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kisumu (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kisumu (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kisumu (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kisumu (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kisumu (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kisumu (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kisumu (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kisumu (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisumu (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kisumu (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kisumu (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kisumu (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kisumu (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kitgum (District of Uganda)": [
            {
                "Region Name": "Kitgum (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Kitgum (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Kitgum (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Kitgum (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 128
            },
            {
                "Region Name": "Kitgum (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "Kitgum (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Kitgum (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Kitgum (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Kitgum (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Kitgum (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Kitgum (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kitgum (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kitgum (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kitgum (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Kitgum (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Kitgum (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Kitgum (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kitgum (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Kitgum (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kitgum (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Kitgum (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kitgum (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Kitui (County of Kenya)": [
            {
                "Region Name": "Kitui (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kitui (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kitui (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kitui (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kitui (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kitui (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kitui (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kitui (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kitui (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kitui (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kitui (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kitui (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kitui (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kitui (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kitui (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kitui (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kitui (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kitui (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kitui (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kitui (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kitui (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kitui (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Klaipedos (County of Lithuania)": [
            {
                "Region Name": "Klaipedos (County of Lithuania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Klaipedos (County of Lithuania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Klaipedos (County of Lithuania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Klaipedos (County of Lithuania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Klaipedos (County of Lithuania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Klaipedos (County of Lithuania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Klaipedos (County of Lithuania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Klaipedos (County of Lithuania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Klaipedos (County of Lithuania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Klaipedos (County of Lithuania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Klaipedos (County of Lithuania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Klaipedos (County of Lithuania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Klaipedos (County of Lithuania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Klaipedos (County of Lithuania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Klaipedos (County of Lithuania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Klaipedos (County of Lithuania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Klaipedos (County of Lithuania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Klaipedos (County of Lithuania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Klaipedos (County of Lithuania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Klaipedos (County of Lithuania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Klaipedos (County of Lithuania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Klaipedos (County of Lithuania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kocaeli (Province of Turkey)": [
            {
                "Region Name": "Kocaeli (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kocaeli (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kocaeli (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kocaeli (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kocaeli (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kocaeli (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kocaeli (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kocaeli (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kocaeli (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kocaeli (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kocaeli (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kocaeli (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kocaeli (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kocaeli (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kocaeli (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kocaeli (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kocaeli (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kocaeli (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kocaeli (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kocaeli (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kocaeli (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kocaeli (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ko\u010Dani (Municipality of North Macedonia)": [
            {
                "Region Name": "Ko\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ko\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ko\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ko\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ko\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ko\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ko\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ko\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ko\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ko\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ko\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ko\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ko\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ko\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ko\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ko\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ko\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ko\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ko\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ko\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ko\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ko\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Kochi (Prefecture of Japan)": [
            {
                "Region Name": "Kochi (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kochi (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kochi (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kochi (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kochi (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kochi (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kochi (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kochi (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kochi (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kochi (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kochi (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kochi (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kochi (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kochi (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kochi (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kochi (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kochi (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kochi (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kochi (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kochi (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kochi (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kochi (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kogi (State of Nigeria)": [
            {
                "Region Name": "Kogi (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kogi (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kogi (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kogi (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kogi (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kogi (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kogi (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kogi (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kogi (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kogi (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kogi (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kogi (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kogi (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kogi (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kogi (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kogi (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kogi (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kogi (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kogi (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kogi (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kogi (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kogi (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Kohgiluyeh and Buyer Ahmad (Province of Iran)": [
            {
                "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kohgiluyeh and Buyer Ahmad (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Kola\u0161in (Municipality of Montenegro)": [
            {
                "Region Name": "Kola\u0161in (Municipality of Montenegro)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kola\u0161in (Municipality of Montenegro)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kola\u0161in (Municipality of Montenegro)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kola\u0161in (Municipality of Montenegro)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kola\u0161in (Municipality of Montenegro)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kola\u0161in (Municipality of Montenegro)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kola\u0161in (Municipality of Montenegro)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kola\u0161in (Municipality of Montenegro)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kola\u0161in (Municipality of Montenegro)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kola\u0161in (Municipality of Montenegro)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kola\u0161in (Municipality of Montenegro)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kola\u0161in (Municipality of Montenegro)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kola\u0161in (Municipality of Montenegro)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kola\u0161in (Municipality of Montenegro)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kola\u0161in (Municipality of Montenegro)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kola\u0161in (Municipality of Montenegro)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kola\u0161in (Municipality of Montenegro)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kola\u0161in (Municipality of Montenegro)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kola\u0161in (Municipality of Montenegro)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kola\u0161in (Municipality of Montenegro)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kola\u0161in (Municipality of Montenegro)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kola\u0161in (Municipality of Montenegro)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kolda (Region of Senegal)": [
            {
                "Region Name": "Kolda (Region of Senegal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Kolda (Region of Senegal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Kolda (Region of Senegal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Kolda (Region of Senegal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Kolda (Region of Senegal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Kolda (Region of Senegal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Kolda (Region of Senegal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kolda (Region of Senegal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Kolda (Region of Senegal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Kolda (Region of Senegal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Kolda (Region of Senegal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Kolda (Region of Senegal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Kolda (Region of Senegal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Kolda (Region of Senegal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Kolda (Region of Senegal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Kolda (Region of Senegal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Kolda (Region of Senegal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Kolda (Region of Senegal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Kolda (Region of Senegal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Kolda (Region of Senegal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Kolda (Region of Senegal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Kolda (Region of Senegal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 22
            }
        ],
        "Kolubarski (District of Serbia)": [
            {
                "Region Name": "Kolubarski (District of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kolubarski (District of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kolubarski (District of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kolubarski (District of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kolubarski (District of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kolubarski (District of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kolubarski (District of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kolubarski (District of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kolubarski (District of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kolubarski (District of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kolubarski (District of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kolubarski (District of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kolubarski (District of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kolubarski (District of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kolubarski (District of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kolubarski (District of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kolubarski (District of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kolubarski (District of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kolubarski (District of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kolubarski (District of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kolubarski (District of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kolubarski (District of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kom\xe1rom-Esztergom (County of Hungary)": [
            {
                "Region Name": "Kom\xe1rom-Esztergom (County of Hungary)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kom\xe1rom-Esztergom (County of Hungary)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kom\xe1rom-Esztergom (County of Hungary)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kom\xe1rom-Esztergom (County of Hungary)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kom\xe1rom-Esztergom (County of Hungary)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kom\xe1rom-Esztergom (County of Hungary)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kom\xe1rom-Esztergom (County of Hungary)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kom\xe1rom-Esztergom (County of Hungary)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kom\xe1rom-Esztergom (County of Hungary)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kom\xe1rom-Esztergom (County of Hungary)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kom\xe1rom-Esztergom (County of Hungary)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kom\xe1rom-Esztergom (County of Hungary)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kom\xe1rom-Esztergom (County of Hungary)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kom\xe1rom-Esztergom (County of Hungary)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kom\xe1rom-Esztergom (County of Hungary)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kom\xe1rom-Esztergom (County of Hungary)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kom\xe1rom-Esztergom (County of Hungary)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kom\xe1rom-Esztergom (County of Hungary)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kom\xe1rom-Esztergom (County of Hungary)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kom\xe1rom-Esztergom (County of Hungary)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kom\xe1rom-Esztergom (County of Hungary)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kom\xe1rom-Esztergom (County of Hungary)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Komi (Republic of Russia)": [
            {
                "Region Name": "Komi (Republic of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Komi (Republic of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Komi (Republic of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Komi (Republic of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Komi (Republic of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Komi (Republic of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Komi (Republic of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Komi (Republic of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Komi (Republic of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Komi (Republic of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Komi (Republic of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Komi (Republic of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Komi (Republic of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Komi (Republic of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Komi (Republic of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Komi (Republic of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Komi (Republic of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Komi (Republic of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Komi (Republic of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Komi (Republic of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Komi (Republic of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Komi (Republic of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Kon Tum (Province of Vietnam)": [
            {
                "Region Name": "Kon Tum (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kon Tum (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kon Tum (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kon Tum (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kon Tum (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kon Tum (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kon Tum (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kon Tum (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kon Tum (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kon Tum (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kon Tum (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kon Tum (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kon Tum (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kon Tum (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kon Tum (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kon Tum (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kon Tum (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kon Tum (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kon Tum (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kon Tum (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kon Tum (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kon Tum (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Kon\u010De (Municipality of North Macedonia)": [
            {
                "Region Name": "Kon\u010De (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kon\u010De (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kon\u010De (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kon\u010De (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kon\u010De (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kon\u010De (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kon\u010De (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kon\u010De (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kon\u010De (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kon\u010De (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kon\u010De (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kon\u010De (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kon\u010De (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kon\u010De (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kon\u010De (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kon\u010De (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kon\u010De (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kon\u010De (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kon\u010De (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kon\u010De (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kon\u010De (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kon\u010De (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kongo-Central (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kongo-Central (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Konya (Province of Turkey)": [
            {
                "Region Name": "Konya (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Konya (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Konya (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Konya (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Konya (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Konya (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Konya (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Konya (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Konya (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Konya (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Konya (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Konya (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Konya (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Konya (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Konya (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Konya (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Konya (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Konya (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Konya (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Konya (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Konya (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Konya (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Koprivni\u010Dko-Kri\u017Eeva\u010Dka (County of Croatia)": [
            {
                "Region Name": "Koprivni\u010Dko-Kri\u017Eeva\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koprivni\u010Dko-Kri\u017Eeva\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koprivni\u010Dko-Kri\u017Eeva\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koprivni\u010Dko-Kri\u017Eeva\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koprivni\u010Dko-Kri\u017Eeva\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koprivni\u010Dko-Kri\u017Eeva\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koprivni\u010Dko-Kri\u017Eeva\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koprivni\u010Dko-Kri\u017Eeva\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koprivni\u010Dko-Kri\u017Eeva\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koprivni\u010Dko-Kri\u017Eeva\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koprivni\u010Dko-Kri\u017Eeva\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koprivni\u010Dko-Kri\u017Eeva\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koprivni\u010Dko-Kri\u017Eeva\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koprivni\u010Dko-Kri\u017Eeva\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koprivni\u010Dko-Kri\u017Eeva\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koprivni\u010Dko-Kri\u017Eeva\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koprivni\u010Dko-Kri\u017Eeva\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koprivni\u010Dko-Kri\u017Eeva\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koprivni\u010Dko-Kri\u017Eeva\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koprivni\u010Dko-Kri\u017Eeva\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koprivni\u010Dko-Kri\u017Eeva\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koprivni\u010Dko-Kri\u017Eeva\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kor\xe7\xeb (County of Albania)": [
            {
                "Region Name": "Kor\xe7\xeb (County of Albania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kor\xe7\xeb (County of Albania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kor\xe7\xeb (County of Albania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kor\xe7\xeb (County of Albania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kor\xe7\xeb (County of Albania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kor\xe7\xeb (County of Albania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Kor\xe7\xeb (County of Albania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kor\xe7\xeb (County of Albania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kor\xe7\xeb (County of Albania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kor\xe7\xeb (County of Albania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kor\xe7\xeb (County of Albania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kor\xe7\xeb (County of Albania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kor\xe7\xeb (County of Albania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kor\xe7\xeb (County of Albania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kor\xe7\xeb (County of Albania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kor\xe7\xeb (County of Albania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kor\xe7\xeb (County of Albania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kor\xe7\xeb (County of Albania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kor\xe7\xeb (County of Albania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kor\xe7\xeb (County of Albania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kor\xe7\xeb (County of Albania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kor\xe7\xeb (County of Albania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Kordestan (Province of Iran)": [
            {
                "Region Name": "Kordestan (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kordestan (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kordestan (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kordestan (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kordestan (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kordestan (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kordestan (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kordestan (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kordestan (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kordestan (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kordestan (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kordestan (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kordestan (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kordestan (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kordestan (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kordestan (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kordestan (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kordestan (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kordestan (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kordestan (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kordestan (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kordestan (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Koror (State of Palau)": [
            {
                "Region Name": "Koror (State of Palau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koror (State of Palau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koror (State of Palau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koror (State of Palau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koror (State of Palau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koror (State of Palau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koror (State of Palau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koror (State of Palau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koror (State of Palau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koror (State of Palau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koror (State of Palau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koror (State of Palau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koror (State of Palau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koror (State of Palau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koror (State of Palau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koror (State of Palau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koror (State of Palau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koror (State of Palau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koror (State of Palau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koror (State of Palau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koror (State of Palau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koror (State of Palau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Koro\u0161ka (Statistical Region of Slovenia)": [
            {
                "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koro\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ko\u0161ick\xfd (Region of Slovakia)": [
            {
                "Region Name": "Ko\u0161ick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ko\u0161ick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ko\u0161ick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ko\u0161ick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ko\u0161ick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ko\u0161ick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ko\u0161ick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ko\u0161ick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ko\u0161ick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ko\u0161ick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ko\u0161ick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ko\u0161ick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ko\u0161ick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ko\u0161ick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ko\u0161ick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ko\u0161ick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ko\u0161ick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ko\u0161ick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ko\u0161ick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ko\u0161ick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ko\u0161ick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ko\u0161ick\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kosovska Mitrovica (District of Kosovo)": [
            {
                "Region Name": "Kosovska Mitrovica (District of Kosovo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosovska Mitrovica (District of Kosovo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosovska Mitrovica (District of Kosovo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kosovska Mitrovica (District of Kosovo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosovska Mitrovica (District of Kosovo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosovska Mitrovica (District of Kosovo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kosovska Mitrovica (District of Kosovo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosovska Mitrovica (District of Kosovo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosovska Mitrovica (District of Kosovo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kosovska Mitrovica (District of Kosovo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kosovska Mitrovica (District of Kosovo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kosovska Mitrovica (District of Kosovo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosovska Mitrovica (District of Kosovo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosovska Mitrovica (District of Kosovo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosovska Mitrovica (District of Kosovo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosovska Mitrovica (District of Kosovo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kosovska Mitrovica (District of Kosovo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosovska Mitrovica (District of Kosovo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kosovska Mitrovica (District of Kosovo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kosovska Mitrovica (District of Kosovo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosovska Mitrovica (District of Kosovo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosovska Mitrovica (District of Kosovo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Kosrae (State of Micronesia)": [
            {
                "Region Name": "Kosrae (State of Micronesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosrae (State of Micronesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosrae (State of Micronesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosrae (State of Micronesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosrae (State of Micronesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosrae (State of Micronesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosrae (State of Micronesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosrae (State of Micronesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosrae (State of Micronesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosrae (State of Micronesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosrae (State of Micronesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosrae (State of Micronesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosrae (State of Micronesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosrae (State of Micronesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosrae (State of Micronesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosrae (State of Micronesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosrae (State of Micronesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosrae (State of Micronesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosrae (State of Micronesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosrae (State of Micronesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosrae (State of Micronesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kosrae (State of Micronesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kostroma (Region of Russia)": [
            {
                "Region Name": "Kostroma (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kostroma (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kostroma (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kostroma (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kostroma (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kostroma (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kostroma (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kostroma (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Kostroma (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kostroma (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kostroma (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kostroma (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kostroma (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kostroma (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kostroma (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kostroma (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kostroma (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kostroma (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kostroma (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kostroma (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kostroma (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kostroma (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Kotayk (Province of Armenia)": [
            {
                "Region Name": "Kotayk (Province of Armenia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotayk (Province of Armenia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotayk (Province of Armenia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kotayk (Province of Armenia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotayk (Province of Armenia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kotayk (Province of Armenia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotayk (Province of Armenia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kotayk (Province of Armenia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotayk (Province of Armenia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kotayk (Province of Armenia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kotayk (Province of Armenia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kotayk (Province of Armenia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kotayk (Province of Armenia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kotayk (Province of Armenia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotayk (Province of Armenia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotayk (Province of Armenia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kotayk (Province of Armenia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kotayk (Province of Armenia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotayk (Province of Armenia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotayk (Province of Armenia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotayk (Province of Armenia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kotayk (Province of Armenia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kotido (District of Uganda)": [
            {
                "Region Name": "Kotido (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Kotido (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Kotido (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Kotido (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Kotido (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Kotido (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Kotido (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Kotido (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Kotido (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Kotido (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 63
            },
            {
                "Region Name": "Kotido (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Kotido (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Kotido (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Kotido (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Kotido (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Kotido (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Kotido (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kotido (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Kotido (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Kotido (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Kotido (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Kotido (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 16
            }
        ],
        "Kotor (Municipality of Montenegro)": [
            {
                "Region Name": "Kotor (Municipality of Montenegro)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotor (Municipality of Montenegro)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotor (Municipality of Montenegro)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotor (Municipality of Montenegro)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotor (Municipality of Montenegro)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotor (Municipality of Montenegro)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotor (Municipality of Montenegro)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kotor (Municipality of Montenegro)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotor (Municipality of Montenegro)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotor (Municipality of Montenegro)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kotor (Municipality of Montenegro)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kotor (Municipality of Montenegro)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotor (Municipality of Montenegro)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotor (Municipality of Montenegro)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kotor (Municipality of Montenegro)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotor (Municipality of Montenegro)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kotor (Municipality of Montenegro)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotor (Municipality of Montenegro)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotor (Municipality of Montenegro)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotor (Municipality of Montenegro)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotor (Municipality of Montenegro)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kotor (Municipality of Montenegro)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kouffo (Department of Benin)": [
            {
                "Region Name": "Kouffo (Department of Benin)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kouffo (Department of Benin)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kouffo (Department of Benin)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kouffo (Department of Benin)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kouffo (Department of Benin)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kouffo (Department of Benin)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kouffo (Department of Benin)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kouffo (Department of Benin)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kouffo (Department of Benin)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kouffo (Department of Benin)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kouffo (Department of Benin)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kouffo (Department of Benin)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kouffo (Department of Benin)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kouffo (Department of Benin)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kouffo (Department of Benin)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kouffo (Department of Benin)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kouffo (Department of Benin)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kouffo (Department of Benin)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kouffo (Department of Benin)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kouffo (Department of Benin)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kouffo (Department of Benin)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kouffo (Department of Benin)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Kouilou (Region of Republic of the Congo)": [
            {
                "Region Name": "Kouilou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kouilou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kouilou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kouilou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kouilou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kouilou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kouilou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kouilou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Kouilou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kouilou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kouilou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kouilou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kouilou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kouilou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kouilou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kouilou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kouilou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kouilou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kouilou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kouilou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kouilou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kouilou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Koulikoro (Region of Mali)": [
            {
                "Region Name": "Koulikoro (Region of Mali)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Koulikoro (Region of Mali)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Koulikoro (Region of Mali)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Koulikoro (Region of Mali)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Koulikoro (Region of Mali)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Koulikoro (Region of Mali)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Koulikoro (Region of Mali)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Koulikoro (Region of Mali)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Koulikoro (Region of Mali)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Koulikoro (Region of Mali)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Koulikoro (Region of Mali)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Koulikoro (Region of Mali)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Koulikoro (Region of Mali)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Koulikoro (Region of Mali)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Koulikoro (Region of Mali)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Koulikoro (Region of Mali)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Koulikoro (Region of Mali)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Koulikoro (Region of Mali)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Koulikoro (Region of Mali)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Koulikoro (Region of Mali)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Koulikoro (Region of Mali)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Koulikoro (Region of Mali)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Koungou (Commune of Mayotte)": [
            {
                "Region Name": "Koungou (Commune of Mayotte)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koungou (Commune of Mayotte)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koungou (Commune of Mayotte)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koungou (Commune of Mayotte)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koungou (Commune of Mayotte)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koungou (Commune of Mayotte)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koungou (Commune of Mayotte)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koungou (Commune of Mayotte)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koungou (Commune of Mayotte)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koungou (Commune of Mayotte)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koungou (Commune of Mayotte)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koungou (Commune of Mayotte)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koungou (Commune of Mayotte)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koungou (Commune of Mayotte)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koungou (Commune of Mayotte)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koungou (Commune of Mayotte)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koungou (Commune of Mayotte)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koungou (Commune of Mayotte)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koungou (Commune of Mayotte)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koungou (Commune of Mayotte)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koungou (Commune of Mayotte)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Koungou (Commune of Mayotte)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Krabi (Province of Thailand)": [
            {
                "Region Name": "Krabi (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Krabi (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krabi (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krabi (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Krabi (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krabi (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krabi (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Krabi (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krabi (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krabi (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krabi (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krabi (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krabi (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krabi (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krabi (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krabi (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krabi (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krabi (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krabi (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krabi (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krabi (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krabi (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kr\xe2ch\xe9h (Province of Cambodia)": [
            {
                "Region Name": "Kr\xe2ch\xe9h (Province of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Kr\xe2ch\xe9h (Province of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Kr\xe2ch\xe9h (Province of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Kr\xe2ch\xe9h (Province of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Kr\xe2ch\xe9h (Province of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Kr\xe2ch\xe9h (Province of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Kr\xe2ch\xe9h (Province of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Kr\xe2ch\xe9h (Province of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Kr\xe2ch\xe9h (Province of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Kr\xe2ch\xe9h (Province of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kr\xe2ch\xe9h (Province of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kr\xe2ch\xe9h (Province of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kr\xe2ch\xe9h (Province of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kr\xe2ch\xe9h (Province of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kr\xe2ch\xe9h (Province of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Kr\xe2ch\xe9h (Province of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kr\xe2ch\xe9h (Province of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kr\xe2ch\xe9h (Province of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kr\xe2ch\xe9h (Province of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kr\xe2ch\xe9h (Province of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kr\xe2ch\xe9h (Province of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kr\xe2ch\xe9h (Province of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Kraj Vyso\u010Dina (Region of Czechia)": [
            {
                "Region Name": "Kraj Vyso\u010Dina (Region of Czechia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kraj Vyso\u010Dina (Region of Czechia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kraj Vyso\u010Dina (Region of Czechia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kraj Vyso\u010Dina (Region of Czechia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kraj Vyso\u010Dina (Region of Czechia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kraj Vyso\u010Dina (Region of Czechia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kraj Vyso\u010Dina (Region of Czechia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kraj Vyso\u010Dina (Region of Czechia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kraj Vyso\u010Dina (Region of Czechia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kraj Vyso\u010Dina (Region of Czechia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kraj Vyso\u010Dina (Region of Czechia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kraj Vyso\u010Dina (Region of Czechia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kraj Vyso\u010Dina (Region of Czechia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kraj Vyso\u010Dina (Region of Czechia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kraj Vyso\u010Dina (Region of Czechia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kraj Vyso\u010Dina (Region of Czechia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kraj Vyso\u010Dina (Region of Czechia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kraj Vyso\u010Dina (Region of Czechia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kraj Vyso\u010Dina (Region of Czechia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kraj Vyso\u010Dina (Region of Czechia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kraj Vyso\u010Dina (Region of Czechia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kraj Vyso\u010Dina (Region of Czechia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kr\xe1lov\xe9hradeck\xfd (Region of Czechia)": [
            {
                "Region Name": "Kr\xe1lov\xe9hradeck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kr\xe1lov\xe9hradeck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kr\xe1lov\xe9hradeck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kr\xe1lov\xe9hradeck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kr\xe1lov\xe9hradeck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kr\xe1lov\xe9hradeck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kr\xe1lov\xe9hradeck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kr\xe1lov\xe9hradeck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kr\xe1lov\xe9hradeck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kr\xe1lov\xe9hradeck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kr\xe1lov\xe9hradeck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kr\xe1lov\xe9hradeck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kr\xe1lov\xe9hradeck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kr\xe1lov\xe9hradeck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kr\xe1lov\xe9hradeck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kr\xe1lov\xe9hradeck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kr\xe1lov\xe9hradeck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kr\xe1lov\xe9hradeck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kr\xe1lov\xe9hradeck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kr\xe1lov\xe9hradeck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kr\xe1lov\xe9hradeck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kr\xe1lov\xe9hradeck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Krapinsko-Zagorska (County of Croatia)": [
            {
                "Region Name": "Krapinsko-Zagorska (County of Croatia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krapinsko-Zagorska (County of Croatia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krapinsko-Zagorska (County of Croatia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krapinsko-Zagorska (County of Croatia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krapinsko-Zagorska (County of Croatia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krapinsko-Zagorska (County of Croatia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krapinsko-Zagorska (County of Croatia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krapinsko-Zagorska (County of Croatia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krapinsko-Zagorska (County of Croatia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krapinsko-Zagorska (County of Croatia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krapinsko-Zagorska (County of Croatia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krapinsko-Zagorska (County of Croatia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krapinsko-Zagorska (County of Croatia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krapinsko-Zagorska (County of Croatia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krapinsko-Zagorska (County of Croatia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krapinsko-Zagorska (County of Croatia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krapinsko-Zagorska (County of Croatia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krapinsko-Zagorska (County of Croatia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krapinsko-Zagorska (County of Croatia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krapinsko-Zagorska (County of Croatia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krapinsko-Zagorska (County of Croatia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krapinsko-Zagorska (County of Croatia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Krasnodar (Territory of Russia)": [
            {
                "Region Name": "Krasnodar (Territory of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Krasnodar (Territory of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Krasnodar (Territory of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Krasnodar (Territory of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Krasnodar (Territory of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Krasnodar (Territory of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Krasnodar (Territory of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Krasnodar (Territory of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Krasnodar (Territory of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Krasnodar (Territory of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Krasnodar (Territory of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Krasnodar (Territory of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Krasnodar (Territory of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Krasnodar (Territory of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Krasnodar (Territory of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Krasnodar (Territory of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Krasnodar (Territory of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Krasnodar (Territory of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Krasnodar (Territory of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Krasnodar (Territory of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Krasnodar (Territory of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Krasnodar (Territory of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Krasnoyarsk (Territory of Russia)": [
            {
                "Region Name": "Krasnoyarsk (Territory of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Krasnoyarsk (Territory of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Krasnoyarsk (Territory of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Krasnoyarsk (Territory of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Krasnoyarsk (Territory of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Krasnoyarsk (Territory of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Krasnoyarsk (Territory of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Krasnoyarsk (Territory of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Krasnoyarsk (Territory of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Krasnoyarsk (Territory of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Krasnoyarsk (Territory of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Krasnoyarsk (Territory of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Krasnoyarsk (Territory of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Krasnoyarsk (Territory of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Krasnoyarsk (Territory of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Krasnoyarsk (Territory of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Krasnoyarsk (Territory of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Krasnoyarsk (Territory of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Krasnoyarsk (Territory of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Krasnoyarsk (Territory of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Krasnoyarsk (Territory of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Krasnoyarsk (Territory of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Kratovo (Municipality of North Macedonia)": [
            {
                "Region Name": "Kratovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kratovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kratovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kratovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kratovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kratovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kratovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kratovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kratovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kratovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kratovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kratovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kratovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kratovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kratovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kratovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kratovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kratovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kratovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kratovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kratovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kratovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kriva Palanka (Municipality of North Macedonia)": [
            {
                "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kriva Palanka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Krivoga\u0161tani (Municipality of North Macedonia)": [
            {
                "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krivoga\u0161tani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Krong Pailin (Municipality of Cambodia)": [
            {
                "Region Name": "Krong Pailin (Municipality of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Krong Pailin (Municipality of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Krong Pailin (Municipality of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Krong Pailin (Municipality of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Krong Pailin (Municipality of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Krong Pailin (Municipality of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Krong Pailin (Municipality of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Krong Pailin (Municipality of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Krong Pailin (Municipality of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Krong Pailin (Municipality of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Krong Pailin (Municipality of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Krong Pailin (Municipality of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Krong Pailin (Municipality of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Krong Pailin (Municipality of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Krong Pailin (Municipality of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Krong Pailin (Municipality of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Krong Pailin (Municipality of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Krong Pailin (Municipality of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Krong Pailin (Municipality of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Krong Pailin (Municipality of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Krong Pailin (Municipality of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Krong Pailin (Municipality of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Krong Preah Sihanouk (Municipality of Cambodia)": [
            {
                "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Krong Preah Sihanouk (Municipality of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Kronoberg (County of Sweden)": [
            {
                "Region Name": "Kronoberg (County of Sweden)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kronoberg (County of Sweden)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kronoberg (County of Sweden)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kronoberg (County of Sweden)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kronoberg (County of Sweden)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kronoberg (County of Sweden)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kronoberg (County of Sweden)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kronoberg (County of Sweden)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kronoberg (County of Sweden)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kronoberg (County of Sweden)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kronoberg (County of Sweden)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kronoberg (County of Sweden)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kronoberg (County of Sweden)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kronoberg (County of Sweden)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kronoberg (County of Sweden)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kronoberg (County of Sweden)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kronoberg (County of Sweden)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kronoberg (County of Sweden)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kronoberg (County of Sweden)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kronoberg (County of Sweden)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kronoberg (County of Sweden)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kronoberg (County of Sweden)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kru\u0161evo (Municipality of North Macedonia)": [
            {
                "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kru\u0161evo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kuala Lumpur (Federal Territory of Malaysia)": [
            {
                "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuala Lumpur (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kujalleq (Commune of Greenland)": [
            {
                "Region Name": "Kujalleq (Commune of Greenland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujalleq (Commune of Greenland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujalleq (Commune of Greenland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujalleq (Commune of Greenland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujalleq (Commune of Greenland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujalleq (Commune of Greenland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujalleq (Commune of Greenland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujalleq (Commune of Greenland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujalleq (Commune of Greenland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujalleq (Commune of Greenland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujalleq (Commune of Greenland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujalleq (Commune of Greenland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujalleq (Commune of Greenland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujalleq (Commune of Greenland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujalleq (Commune of Greenland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujalleq (Commune of Greenland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujalleq (Commune of Greenland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujalleq (Commune of Greenland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujalleq (Commune of Greenland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujalleq (Commune of Greenland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujalleq (Commune of Greenland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujalleq (Commune of Greenland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kujawsko-Pomorskie (Voivodeship of Poland)": [
            {
                "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kujawsko-Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kuk\xebs (County of Albania)": [
            {
                "Region Name": "Kuk\xebs (County of Albania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuk\xebs (County of Albania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kuk\xebs (County of Albania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuk\xebs (County of Albania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuk\xebs (County of Albania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuk\xebs (County of Albania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Kuk\xebs (County of Albania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuk\xebs (County of Albania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kuk\xebs (County of Albania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuk\xebs (County of Albania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Kuk\xebs (County of Albania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kuk\xebs (County of Albania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuk\xebs (County of Albania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuk\xebs (County of Albania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kuk\xebs (County of Albania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuk\xebs (County of Albania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuk\xebs (County of Albania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kuk\xebs (County of Albania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuk\xebs (County of Albania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuk\xebs (County of Albania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Kuk\xebs (County of Albania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kuk\xebs (County of Albania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kumamoto (Prefecture of Japan)": [
            {
                "Region Name": "Kumamoto (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kumamoto (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kumamoto (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kumamoto (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kumamoto (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kumamoto (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kumamoto (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kumamoto (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kumamoto (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kumamoto (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kumamoto (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kumamoto (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kumamoto (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kumamoto (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kumamoto (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kumamoto (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kumamoto (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kumamoto (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kumamoto (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kumamoto (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kumamoto (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kumamoto (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Kumanovo (Municipality of North Macedonia)": [
            {
                "Region Name": "Kumanovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kumanovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kumanovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kumanovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kumanovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kumanovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kumanovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kumanovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kumanovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kumanovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kumanovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kumanovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kumanovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kumanovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kumanovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kumanovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kumanovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kumanovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kumanovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kumanovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kumanovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kumanovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Kumgangsan (Special Administrative Region of North Korea)": [
            {
                "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kumgangsan (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kumi (District of Uganda)": [
            {
                "Region Name": "Kumi (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kumi (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kumi (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kumi (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kumi (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kumi (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kumi (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kumi (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kumi (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kumi (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kumi (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kumi (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kumi (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kumi (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kumi (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kumi (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kumi (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kumi (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kumi (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kumi (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kumi (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kumi (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Kuna Yala (Indigenous Territory of Panama)": [
            {
                "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kuna Yala (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kunar (Province of Afghanistan)": [
            {
                "Region Name": "Kunar (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunar (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunar (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunar (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunar (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kunar (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kunar (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kunar (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunar (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunar (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunar (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunar (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunar (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunar (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kunar (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunar (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kunar (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunar (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunar (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunar (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunar (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kunar (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kunduz (Province of Afghanistan)": [
            {
                "Region Name": "Kunduz (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunduz (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Kunduz (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kunduz (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kunduz (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunduz (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Kunduz (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kunduz (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunduz (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kunduz (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunduz (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Kunduz (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunduz (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunduz (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunduz (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunduz (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunduz (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunduz (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunduz (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunduz (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunduz (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunduz (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kunene (Region of Namibia)": [
            {
                "Region Name": "Kunene (Region of Namibia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 79
            },
            {
                "Region Name": "Kunene (Region of Namibia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 196
            },
            {
                "Region Name": "Kunene (Region of Namibia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Kunene (Region of Namibia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kunene (Region of Namibia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 180
            },
            {
                "Region Name": "Kunene (Region of Namibia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kunene (Region of Namibia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kunene (Region of Namibia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 88
            },
            {
                "Region Name": "Kunene (Region of Namibia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Kunene (Region of Namibia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 74
            },
            {
                "Region Name": "Kunene (Region of Namibia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 130
            },
            {
                "Region Name": "Kunene (Region of Namibia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kunene (Region of Namibia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Kunene (Region of Namibia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kunene (Region of Namibia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kunene (Region of Namibia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 70
            },
            {
                "Region Name": "Kunene (Region of Namibia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 94
            },
            {
                "Region Name": "Kunene (Region of Namibia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kunene (Region of Namibia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Kunene (Region of Namibia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 347
            },
            {
                "Region Name": "Kunene (Region of Namibia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 78
            },
            {
                "Region Name": "Kunene (Region of Namibia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 51
            }
        ],
        "Kurgan (Region of Russia)": [
            {
                "Region Name": "Kurgan (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kurgan (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kurgan (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kurgan (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kurgan (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kurgan (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kurgan (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kurgan (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kurgan (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kurgan (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kurgan (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kurgan (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kurgan (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kurgan (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kurgan (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kurgan (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kurgan (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kurgan (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kurgan (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kurgan (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Kurgan (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kurgan (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 20
            }
        ],
        "Kursk (Region of Russia)": [
            {
                "Region Name": "Kursk (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kursk (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kursk (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kursk (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kursk (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kursk (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kursk (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kursk (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kursk (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kursk (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kursk (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kursk (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kursk (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kursk (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kursk (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kursk (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kursk (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kursk (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kursk (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kursk (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kursk (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kursk (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Kurunegala (District of Sri Lanka)": [
            {
                "Region Name": "Kurunegala (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kurunegala (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kurunegala (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kurunegala (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kurunegala (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kurunegala (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kurunegala (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kurunegala (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kurunegala (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kurunegala (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kurunegala (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kurunegala (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kurunegala (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kurunegala (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kurunegala (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kurunegala (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kurunegala (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kurunegala (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kurunegala (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kurunegala (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kurunegala (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kurunegala (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Kurzeme (Province of Latvia)": [
            {
                "Region Name": "Kurzeme (Province of Latvia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kurzeme (Province of Latvia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kurzeme (Province of Latvia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kurzeme (Province of Latvia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kurzeme (Province of Latvia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kurzeme (Province of Latvia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kurzeme (Province of Latvia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kurzeme (Province of Latvia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kurzeme (Province of Latvia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kurzeme (Province of Latvia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kurzeme (Province of Latvia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kurzeme (Province of Latvia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kurzeme (Province of Latvia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kurzeme (Province of Latvia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kurzeme (Province of Latvia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kurzeme (Province of Latvia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kurzeme (Province of Latvia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kurzeme (Province of Latvia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kurzeme (Province of Latvia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kurzeme (Province of Latvia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kurzeme (Province of Latvia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kurzeme (Province of Latvia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kusini Pemba (Region of Tanzania)": [
            {
                "Region Name": "Kusini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kusini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Pemba (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kusini Unguja (Region of Tanzania)": [
            {
                "Region Name": "Kusini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kusini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kusini Unguja (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "K\xfctahya (Province of Turkey)": [
            {
                "Region Name": "K\xfctahya (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xfctahya (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xfctahya (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "K\xfctahya (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xfctahya (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "K\xfctahya (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "K\xfctahya (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xfctahya (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "K\xfctahya (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xfctahya (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "K\xfctahya (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "K\xfctahya (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "K\xfctahya (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xfctahya (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xfctahya (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "K\xfctahya (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "K\xfctahya (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xfctahya (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "K\xfctahya (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xfctahya (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xfctahya (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "K\xfctahya (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kvemo Kartli (Region of Georgia)": [
            {
                "Region Name": "Kvemo Kartli (Region of Georgia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kvemo Kartli (Region of Georgia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kvemo Kartli (Region of Georgia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kvemo Kartli (Region of Georgia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kvemo Kartli (Region of Georgia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Kvemo Kartli (Region of Georgia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kvemo Kartli (Region of Georgia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kvemo Kartli (Region of Georgia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kvemo Kartli (Region of Georgia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kvemo Kartli (Region of Georgia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kvemo Kartli (Region of Georgia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kvemo Kartli (Region of Georgia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kvemo Kartli (Region of Georgia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kvemo Kartli (Region of Georgia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kvemo Kartli (Region of Georgia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kvemo Kartli (Region of Georgia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kvemo Kartli (Region of Georgia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kvemo Kartli (Region of Georgia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kvemo Kartli (Region of Georgia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kvemo Kartli (Region of Georgia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kvemo Kartli (Region of Georgia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kvemo Kartli (Region of Georgia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kwajalein (Atol of Marshall Islands)": [
            {
                "Region Name": "Kwajalein (Atol of Marshall Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kwajalein (Atol of Marshall Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kwajalein (Atol of Marshall Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kwajalein (Atol of Marshall Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kwajalein (Atol of Marshall Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kwajalein (Atol of Marshall Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kwajalein (Atol of Marshall Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kwajalein (Atol of Marshall Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kwajalein (Atol of Marshall Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kwajalein (Atol of Marshall Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kwajalein (Atol of Marshall Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kwajalein (Atol of Marshall Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kwajalein (Atol of Marshall Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kwajalein (Atol of Marshall Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kwajalein (Atol of Marshall Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kwajalein (Atol of Marshall Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kwajalein (Atol of Marshall Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kwajalein (Atol of Marshall Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kwajalein (Atol of Marshall Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kwajalein (Atol of Marshall Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kwajalein (Atol of Marshall Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kwajalein (Atol of Marshall Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kwale (County of Kenya)": [
            {
                "Region Name": "Kwale (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kwale (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kwale (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kwale (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kwale (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kwale (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kwale (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kwale (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kwale (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kwale (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kwale (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kwale (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kwale (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kwale (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kwale (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kwale (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kwale (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kwale (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kwale (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kwale (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kwale (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kwale (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Kwango (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Kwango (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 20
            }
        ],
        "Kwara (State of Nigeria)": [
            {
                "Region Name": "Kwara (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kwara (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Kwara (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Kwara (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kwara (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kwara (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kwara (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kwara (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kwara (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kwara (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kwara (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kwara (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kwara (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kwara (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Kwara (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kwara (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kwara (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kwara (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kwara (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Kwara (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kwara (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kwara (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "KwaZulu-Natal (Province of South Africa)": [
            {
                "Region Name": "KwaZulu-Natal (Province of South Africa)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "KwaZulu-Natal (Province of South Africa)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "KwaZulu-Natal (Province of South Africa)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "KwaZulu-Natal (Province of South Africa)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "KwaZulu-Natal (Province of South Africa)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "KwaZulu-Natal (Province of South Africa)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "KwaZulu-Natal (Province of South Africa)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "KwaZulu-Natal (Province of South Africa)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "KwaZulu-Natal (Province of South Africa)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "KwaZulu-Natal (Province of South Africa)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "KwaZulu-Natal (Province of South Africa)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "KwaZulu-Natal (Province of South Africa)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "KwaZulu-Natal (Province of South Africa)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "KwaZulu-Natal (Province of South Africa)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "KwaZulu-Natal (Province of South Africa)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "KwaZulu-Natal (Province of South Africa)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "KwaZulu-Natal (Province of South Africa)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "KwaZulu-Natal (Province of South Africa)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "KwaZulu-Natal (Province of South Africa)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "KwaZulu-Natal (Province of South Africa)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "KwaZulu-Natal (Province of South Africa)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "KwaZulu-Natal (Province of South Africa)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Kweneng (District of Botswana)": [
            {
                "Region Name": "Kweneng (District of Botswana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 153
            },
            {
                "Region Name": "Kweneng (District of Botswana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 84
            },
            {
                "Region Name": "Kweneng (District of Botswana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "Kweneng (District of Botswana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 412
            },
            {
                "Region Name": "Kweneng (District of Botswana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 127
            },
            {
                "Region Name": "Kweneng (District of Botswana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "Kweneng (District of Botswana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 253
            },
            {
                "Region Name": "Kweneng (District of Botswana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Kweneng (District of Botswana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 385
            },
            {
                "Region Name": "Kweneng (District of Botswana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 111
            },
            {
                "Region Name": "Kweneng (District of Botswana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Kweneng (District of Botswana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 595
            },
            {
                "Region Name": "Kweneng (District of Botswana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 63
            },
            {
                "Region Name": "Kweneng (District of Botswana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 286
            },
            {
                "Region Name": "Kweneng (District of Botswana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kweneng (District of Botswana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Kweneng (District of Botswana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1128
            },
            {
                "Region Name": "Kweneng (District of Botswana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "Kweneng (District of Botswana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 252
            },
            {
                "Region Name": "Kweneng (District of Botswana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 122
            },
            {
                "Region Name": "Kweneng (District of Botswana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 252
            },
            {
                "Region Name": "Kweneng (District of Botswana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 231
            }
        ],
        "Kwilu (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Kwilu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Kyenjojo (District of Uganda)": [
            {
                "Region Name": "Kyenjojo (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kyenjojo (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kyenjojo (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kyenjojo (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kyenjojo (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kyenjojo (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kyenjojo (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Kyenjojo (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kyenjojo (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kyenjojo (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kyenjojo (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kyenjojo (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kyenjojo (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kyenjojo (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Kyenjojo (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Kyenjojo (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Kyenjojo (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Kyenjojo (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kyenjojo (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Kyenjojo (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Kyenjojo (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Kyenjojo (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Kyoto (Urban Prefecture of Japan)": [
            {
                "Region Name": "Kyoto (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyoto (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyoto (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyoto (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyoto (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyoto (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyoto (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyoto (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyoto (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyoto (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyoto (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyoto (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyoto (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyoto (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyoto (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyoto (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyoto (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyoto (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyoto (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyoto (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyoto (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyoto (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Kyustendil (Province of Bulgaria)": [
            {
                "Region Name": "Kyustendil (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyustendil (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyustendil (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kyustendil (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyustendil (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kyustendil (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kyustendil (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyustendil (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyustendil (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kyustendil (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kyustendil (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Kyustendil (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyustendil (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyustendil (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyustendil (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kyustendil (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyustendil (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyustendil (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Kyustendil (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Kyustendil (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyustendil (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Kyustendil (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "L'Artibonite (Department of Haiti)": [
            {
                "Region Name": "L'Artibonite (Department of Haiti)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L'Artibonite (Department of Haiti)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "L'Artibonite (Department of Haiti)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "L'Artibonite (Department of Haiti)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "L'Artibonite (Department of Haiti)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L'Artibonite (Department of Haiti)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "L'Artibonite (Department of Haiti)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L'Artibonite (Department of Haiti)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "L'Artibonite (Department of Haiti)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L'Artibonite (Department of Haiti)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "L'Artibonite (Department of Haiti)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "L'Artibonite (Department of Haiti)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "L'Artibonite (Department of Haiti)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "L'Artibonite (Department of Haiti)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "L'Artibonite (Department of Haiti)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "L'Artibonite (Department of Haiti)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "L'Artibonite (Department of Haiti)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "L'Artibonite (Department of Haiti)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L'Artibonite (Department of Haiti)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L'Artibonite (Department of Haiti)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L'Artibonite (Department of Haiti)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "L'Artibonite (Department of Haiti)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "L'viv (Region of Ukraine)": [
            {
                "Region Name": "L'viv (Region of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "L'viv (Region of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "L'viv (Region of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L'viv (Region of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "L'viv (Region of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "L'viv (Region of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "L'viv (Region of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "L'viv (Region of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "L'viv (Region of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "L'viv (Region of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "L'viv (Region of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "L'viv (Region of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "L'viv (Region of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "L'viv (Region of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "L'viv (Region of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "L'viv (Region of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "L'viv (Region of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "L'viv (Region of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "L'viv (Region of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "L'viv (Region of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "L'viv (Region of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "L'viv (Region of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "La Altagracia (Province of Dominican Republic)": [
            {
                "Region Name": "La Altagracia (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Altagracia (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Altagracia (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Altagracia (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Altagracia (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Altagracia (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "La Altagracia (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Altagracia (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Altagracia (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Altagracia (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Altagracia (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Altagracia (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Altagracia (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Altagracia (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Altagracia (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Altagracia (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Altagracia (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Altagracia (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Altagracia (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Altagracia (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Altagracia (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Altagracia (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "La Digue and Inner Islands (District of Seychelles)": [
            {
                "Region Name": "La Digue and Inner Islands (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Digue and Inner Islands (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Digue and Inner Islands (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Digue and Inner Islands (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Digue and Inner Islands (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Digue and Inner Islands (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Digue and Inner Islands (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Digue and Inner Islands (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Digue and Inner Islands (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Digue and Inner Islands (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Digue and Inner Islands (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Digue and Inner Islands (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Digue and Inner Islands (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Digue and Inner Islands (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Digue and Inner Islands (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Digue and Inner Islands (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Digue and Inner Islands (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Digue and Inner Islands (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Digue and Inner Islands (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Digue and Inner Islands (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Digue and Inner Islands (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Digue and Inner Islands (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "La Estrelleta (Province of Dominican Republic)": [
            {
                "Region Name": "La Estrelleta (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Estrelleta (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Estrelleta (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Estrelleta (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "La Estrelleta (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Estrelleta (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "La Estrelleta (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "La Estrelleta (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "La Estrelleta (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Estrelleta (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Estrelleta (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Estrelleta (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Estrelleta (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "La Estrelleta (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "La Estrelleta (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Estrelleta (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Estrelleta (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "La Estrelleta (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "La Estrelleta (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Estrelleta (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "La Estrelleta (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Estrelleta (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "La Guajira (Department of Colombia)": [
            {
                "Region Name": "La Guajira (Department of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "La Guajira (Department of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "La Guajira (Department of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Guajira (Department of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "La Guajira (Department of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Guajira (Department of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Guajira (Department of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "La Guajira (Department of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "La Guajira (Department of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Guajira (Department of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Guajira (Department of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "La Guajira (Department of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Guajira (Department of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "La Guajira (Department of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "La Guajira (Department of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "La Guajira (Department of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "La Guajira (Department of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "La Guajira (Department of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "La Guajira (Department of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "La Guajira (Department of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "La Guajira (Department of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "La Guajira (Department of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "La Habana (Province of Cuba)": [
            {
                "Region Name": "La Habana (Province of Cuba)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "La Habana (Province of Cuba)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "La Habana (Province of Cuba)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "La Habana (Province of Cuba)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Habana (Province of Cuba)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Habana (Province of Cuba)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "La Habana (Province of Cuba)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Habana (Province of Cuba)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Habana (Province of Cuba)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Habana (Province of Cuba)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Habana (Province of Cuba)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Habana (Province of Cuba)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Habana (Province of Cuba)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Habana (Province of Cuba)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Habana (Province of Cuba)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "La Habana (Province of Cuba)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Habana (Province of Cuba)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Habana (Province of Cuba)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Habana (Province of Cuba)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "La Habana (Province of Cuba)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Habana (Province of Cuba)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "La Habana (Province of Cuba)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "La Libertad (Department of El Salvador)": [
            {
                "Region Name": "La Libertad (Department of El Salvador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Libertad (Department of El Salvador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Libertad (Department of El Salvador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Libertad (Department of El Salvador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Libertad (Department of El Salvador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Libertad (Department of El Salvador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Libertad (Department of El Salvador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Libertad (Department of El Salvador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "La Libertad (Department of El Salvador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Libertad (Department of El Salvador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Libertad (Department of El Salvador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "La Libertad (Department of El Salvador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "La Libertad (Department of El Salvador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "La Libertad (Department of El Salvador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Libertad (Department of El Salvador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Libertad (Department of El Salvador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "La Libertad (Department of El Salvador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Libertad (Department of El Salvador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "La Libertad (Department of El Salvador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Libertad (Department of El Salvador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Libertad (Department of El Salvador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Libertad (Department of El Salvador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "La Libertad (Region of Peru)": [
            {
                "Region Name": "La Libertad (Region of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Libertad (Region of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "La Libertad (Region of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Libertad (Region of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "La Libertad (Region of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "La Libertad (Region of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Libertad (Region of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Libertad (Region of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Libertad (Region of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Libertad (Region of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "La Libertad (Region of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "La Libertad (Region of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Libertad (Region of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Libertad (Region of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Libertad (Region of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "La Libertad (Region of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Libertad (Region of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Libertad (Region of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Libertad (Region of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "La Libertad (Region of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "La Libertad (Region of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Libertad (Region of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "La Massana (Parish of Andorra)": [
            {
                "Region Name": "La Massana (Parish of Andorra)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Massana (Parish of Andorra)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Massana (Parish of Andorra)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Massana (Parish of Andorra)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Massana (Parish of Andorra)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Massana (Parish of Andorra)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Massana (Parish of Andorra)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Massana (Parish of Andorra)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Massana (Parish of Andorra)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Massana (Parish of Andorra)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Massana (Parish of Andorra)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Massana (Parish of Andorra)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Massana (Parish of Andorra)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Massana (Parish of Andorra)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Massana (Parish of Andorra)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Massana (Parish of Andorra)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Massana (Parish of Andorra)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Massana (Parish of Andorra)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Massana (Parish of Andorra)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Massana (Parish of Andorra)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Massana (Parish of Andorra)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Massana (Parish of Andorra)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "La Pampa (Province of Argentina)": [
            {
                "Region Name": "La Pampa (Province of Argentina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 61
            },
            {
                "Region Name": "La Pampa (Province of Argentina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "La Pampa (Province of Argentina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "La Pampa (Province of Argentina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "La Pampa (Province of Argentina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "La Pampa (Province of Argentina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "La Pampa (Province of Argentina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "La Pampa (Province of Argentina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Pampa (Province of Argentina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "La Pampa (Province of Argentina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 61
            },
            {
                "Region Name": "La Pampa (Province of Argentina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "La Pampa (Province of Argentina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "La Pampa (Province of Argentina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 63
            },
            {
                "Region Name": "La Pampa (Province of Argentina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "La Pampa (Province of Argentina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 161
            },
            {
                "Region Name": "La Pampa (Province of Argentina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 95
            },
            {
                "Region Name": "La Pampa (Province of Argentina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "La Pampa (Province of Argentina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "La Pampa (Province of Argentina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "La Pampa (Province of Argentina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "La Pampa (Province of Argentina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "La Pampa (Province of Argentina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 28
            }
        ],
        "La Paz (Department of Bolivia)": [
            {
                "Region Name": "La Paz (Department of Bolivia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "La Paz (Department of Bolivia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "La Paz (Department of Bolivia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "La Paz (Department of Bolivia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "La Paz (Department of Bolivia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "La Paz (Department of Bolivia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "La Paz (Department of Bolivia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "La Paz (Department of Bolivia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "La Paz (Department of Bolivia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "La Paz (Department of Bolivia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "La Paz (Department of Bolivia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "La Paz (Department of Bolivia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "La Paz (Department of Bolivia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "La Paz (Department of Bolivia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "La Paz (Department of Bolivia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "La Paz (Department of Bolivia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "La Paz (Department of Bolivia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "La Paz (Department of Bolivia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "La Paz (Department of Bolivia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "La Paz (Department of Bolivia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "La Paz (Department of Bolivia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "La Paz (Department of Bolivia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 36
            }
        ],
        "La Paz (Department of El Salvador)": [
            {
                "Region Name": "La Paz (Department of El Salvador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "La Paz (Department of El Salvador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "La Paz (Department of El Salvador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Paz (Department of El Salvador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "La Paz (Department of El Salvador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Paz (Department of El Salvador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Paz (Department of El Salvador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Paz (Department of El Salvador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Paz (Department of El Salvador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Paz (Department of El Salvador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Paz (Department of El Salvador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Paz (Department of El Salvador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "La Paz (Department of El Salvador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Paz (Department of El Salvador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Paz (Department of El Salvador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Paz (Department of El Salvador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "La Paz (Department of El Salvador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "La Paz (Department of El Salvador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Paz (Department of El Salvador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "La Paz (Department of El Salvador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Paz (Department of El Salvador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Paz (Department of El Salvador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "La Paz (Department of Honduras)": [
            {
                "Region Name": "La Paz (Department of Honduras)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "La Paz (Department of Honduras)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Paz (Department of Honduras)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Paz (Department of Honduras)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Paz (Department of Honduras)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "La Paz (Department of Honduras)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "La Paz (Department of Honduras)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Paz (Department of Honduras)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Paz (Department of Honduras)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Paz (Department of Honduras)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "La Paz (Department of Honduras)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Paz (Department of Honduras)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "La Paz (Department of Honduras)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "La Paz (Department of Honduras)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Paz (Department of Honduras)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Paz (Department of Honduras)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "La Paz (Department of Honduras)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "La Paz (Department of Honduras)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "La Paz (Department of Honduras)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "La Paz (Department of Honduras)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "La Paz (Department of Honduras)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "La Paz (Department of Honduras)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "La Rioja (Autonomous Community of Spain)": [
            {
                "Region Name": "La Rioja (Autonomous Community of Spain)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Rioja (Autonomous Community of Spain)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Rioja (Autonomous Community of Spain)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Rioja (Autonomous Community of Spain)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Rioja (Autonomous Community of Spain)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "La Rioja (Autonomous Community of Spain)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Rioja (Autonomous Community of Spain)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Rioja (Autonomous Community of Spain)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Rioja (Autonomous Community of Spain)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Rioja (Autonomous Community of Spain)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Rioja (Autonomous Community of Spain)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Rioja (Autonomous Community of Spain)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Rioja (Autonomous Community of Spain)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Rioja (Autonomous Community of Spain)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "La Rioja (Autonomous Community of Spain)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Rioja (Autonomous Community of Spain)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Rioja (Autonomous Community of Spain)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Rioja (Autonomous Community of Spain)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Rioja (Autonomous Community of Spain)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Rioja (Autonomous Community of Spain)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Rioja (Autonomous Community of Spain)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Rioja (Autonomous Community of Spain)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "La Rioja (Province of Argentina)": [
            {
                "Region Name": "La Rioja (Province of Argentina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "La Rioja (Province of Argentina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "La Rioja (Province of Argentina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "La Rioja (Province of Argentina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "La Rioja (Province of Argentina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "La Rioja (Province of Argentina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "La Rioja (Province of Argentina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "La Rioja (Province of Argentina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "La Rioja (Province of Argentina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "La Rioja (Province of Argentina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "La Rioja (Province of Argentina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "La Rioja (Province of Argentina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "La Rioja (Province of Argentina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "La Rioja (Province of Argentina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "La Rioja (Province of Argentina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "La Rioja (Province of Argentina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 124
            },
            {
                "Region Name": "La Rioja (Province of Argentina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "La Rioja (Province of Argentina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "La Rioja (Province of Argentina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "La Rioja (Province of Argentina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "La Rioja (Province of Argentina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "La Rioja (Province of Argentina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "La Romana (Province of Dominican Republic)": [
            {
                "Region Name": "La Romana (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Romana (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Romana (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Romana (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Romana (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Romana (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Romana (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Romana (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "La Romana (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Romana (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Romana (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Romana (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Romana (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Romana (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "La Romana (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Romana (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Romana (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "La Romana (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Romana (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Romana (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Romana (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Romana (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "La Uni\xf3n (Department of El Salvador)": [
            {
                "Region Name": "La Uni\xf3n (Department of El Salvador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Uni\xf3n (Department of El Salvador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Uni\xf3n (Department of El Salvador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Uni\xf3n (Department of El Salvador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Uni\xf3n (Department of El Salvador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "La Uni\xf3n (Department of El Salvador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Uni\xf3n (Department of El Salvador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Uni\xf3n (Department of El Salvador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Uni\xf3n (Department of El Salvador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Uni\xf3n (Department of El Salvador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Uni\xf3n (Department of El Salvador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "La Uni\xf3n (Department of El Salvador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "La Uni\xf3n (Department of El Salvador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Uni\xf3n (Department of El Salvador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "La Uni\xf3n (Department of El Salvador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Uni\xf3n (Department of El Salvador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "La Uni\xf3n (Department of El Salvador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "La Uni\xf3n (Department of El Salvador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "La Uni\xf3n (Department of El Salvador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "La Uni\xf3n (Department of El Salvador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "La Uni\xf3n (Department of El Salvador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Uni\xf3n (Department of El Salvador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "La Union (Province of Philippines)": [
            {
                "Region Name": "La Union (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Union (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Union (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Union (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Union (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Union (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Union (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Union (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Union (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Union (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Union (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Union (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Union (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Union (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Union (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Union (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Union (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Union (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Union (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Union (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Union (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Union (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "La Vega (Province of Dominican Republic)": [
            {
                "Region Name": "La Vega (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Vega (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Vega (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Vega (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Vega (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "La Vega (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "La Vega (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Vega (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Vega (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "La Vega (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Vega (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Vega (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Vega (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "La Vega (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "La Vega (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Vega (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Vega (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Vega (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Vega (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La Vega (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "La Vega (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "La Vega (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "L\xe4\xe4ne-Viru (County of Estonia)": [
            {
                "Region Name": "L\xe4\xe4ne-Viru (County of Estonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\xe4\xe4ne-Viru (County of Estonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne-Viru (County of Estonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\xe4\xe4ne-Viru (County of Estonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne-Viru (County of Estonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne-Viru (County of Estonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne-Viru (County of Estonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne-Viru (County of Estonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne-Viru (County of Estonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne-Viru (County of Estonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne-Viru (County of Estonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne-Viru (County of Estonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne-Viru (County of Estonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne-Viru (County of Estonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne-Viru (County of Estonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne-Viru (County of Estonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "L\xe4\xe4ne-Viru (County of Estonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "L\xe4\xe4ne-Viru (County of Estonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne-Viru (County of Estonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne-Viru (County of Estonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne-Viru (County of Estonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\xe4\xe4ne-Viru (County of Estonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "L\xe4\xe4ne (County of Estonia)": [
            {
                "Region Name": "L\xe4\xe4ne (County of Estonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "L\xe4\xe4ne (County of Estonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne (County of Estonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne (County of Estonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne (County of Estonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne (County of Estonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne (County of Estonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne (County of Estonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne (County of Estonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne (County of Estonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne (County of Estonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne (County of Estonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "L\xe4\xe4ne (County of Estonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne (County of Estonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne (County of Estonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne (County of Estonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne (County of Estonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne (County of Estonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne (County of Estonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne (County of Estonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne (County of Estonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe4\xe4ne (County of Estonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "La\xe2youne - Boujdour - Sakia El Hamra (Region of Morocco)": [
            {
                "Region Name": "La\xe2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La\xe2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La\xe2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La\xe2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La\xe2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La\xe2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La\xe2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La\xe2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La\xe2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La\xe2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La\xe2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La\xe2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La\xe2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La\xe2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La\xe2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La\xe2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La\xe2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La\xe2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La\xe2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La\xe2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La\xe2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "La\xe2youne - Boujdour - Sakia El Hamra (Region of Morocco)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Laayoune (Province of Western Sahara)": [
            {
                "Region Name": "Laayoune (Province of Western Sahara)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laayoune (Province of Western Sahara)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laayoune (Province of Western Sahara)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laayoune (Province of Western Sahara)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laayoune (Province of Western Sahara)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laayoune (Province of Western Sahara)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laayoune (Province of Western Sahara)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laayoune (Province of Western Sahara)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laayoune (Province of Western Sahara)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laayoune (Province of Western Sahara)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laayoune (Province of Western Sahara)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laayoune (Province of Western Sahara)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laayoune (Province of Western Sahara)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laayoune (Province of Western Sahara)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laayoune (Province of Western Sahara)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laayoune (Province of Western Sahara)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laayoune (Province of Western Sahara)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laayoune (Province of Western Sahara)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laayoune (Province of Western Sahara)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laayoune (Province of Western Sahara)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laayoune (Province of Western Sahara)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laayoune (Province of Western Sahara)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lab\xe9 (Region of Guinea)": [
            {
                "Region Name": "Lab\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Lab\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lab\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lab\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lab\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lab\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lab\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lab\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lab\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lab\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lab\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lab\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lab\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lab\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lab\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lab\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lab\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lab\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lab\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lab\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lab\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lab\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Laborie (Quarter of Saint Lucia)": [
            {
                "Region Name": "Laborie (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laborie (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laborie (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laborie (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laborie (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laborie (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laborie (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laborie (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laborie (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laborie (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laborie (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laborie (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laborie (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laborie (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laborie (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laborie (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laborie (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laborie (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laborie (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laborie (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laborie (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laborie (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Labuan (Federal Territory of Malaysia)": [
            {
                "Region Name": "Labuan (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Labuan (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Labuan (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Labuan (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Labuan (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Labuan (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Labuan (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Labuan (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Labuan (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Labuan (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Labuan (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Labuan (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Labuan (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Labuan (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Labuan (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Labuan (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Labuan (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Labuan (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Labuan (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Labuan (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Labuan (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Labuan (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lac (Region of Chad)": [
            {
                "Region Name": "Lac (Region of Chad)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lac (Region of Chad)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Lac (Region of Chad)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Lac (Region of Chad)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Lac (Region of Chad)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Lac (Region of Chad)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Lac (Region of Chad)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Lac (Region of Chad)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lac (Region of Chad)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lac (Region of Chad)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Lac (Region of Chad)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lac (Region of Chad)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lac (Region of Chad)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lac (Region of Chad)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lac (Region of Chad)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Lac (Region of Chad)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Lac (Region of Chad)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Lac (Region of Chad)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Lac (Region of Chad)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lac (Region of Chad)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lac (Region of Chad)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lac (Region of Chad)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Lacs (District of C\xf4te d'Ivoire)": [
            {
                "Region Name": "Lacs (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lacs (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lacs (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lacs (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lacs (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lacs (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Lacs (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lacs (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lacs (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lacs (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lacs (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lacs (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lacs (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lacs (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lacs (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lacs (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lacs (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lacs (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lacs (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lacs (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lacs (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lacs (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Lae (Atol of Marshall Islands)": [
            {
                "Region Name": "Lae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Laghman (Province of Afghanistan)": [
            {
                "Region Name": "Laghman (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghman (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghman (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghman (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghman (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghman (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghman (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghman (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghman (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghman (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghman (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghman (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghman (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghman (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghman (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghman (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghman (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghman (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghman (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghman (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghman (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghman (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Laghouat (Province of Algeria)": [
            {
                "Region Name": "Laghouat (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghouat (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghouat (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghouat (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Laghouat (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghouat (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghouat (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghouat (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghouat (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghouat (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghouat (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghouat (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghouat (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghouat (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghouat (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghouat (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghouat (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghouat (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghouat (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Laghouat (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghouat (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laghouat (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lago Nicaragua (Water body of Nicaragua)": [
            {
                "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lago Nicaragua (Water body of Nicaragua)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lagos (State of Nigeria)": [
            {
                "Region Name": "Lagos (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lagos (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lagos (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lagos (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lagos (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lagos (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lagos (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lagos (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lagos (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lagos (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lagos (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lagos (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lagos (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lagos (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lagos (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lagos (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lagos (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lagos (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lagos (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lagos (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lagos (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lagos (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Laguna (Province of Philippines)": [
            {
                "Region Name": "Laguna (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Laguna (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Laguna (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Laguna (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Laguna (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Laguna (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laguna (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laguna (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laguna (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Laguna (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Laguna (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laguna (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Laguna (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Laguna (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laguna (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Laguna (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laguna (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laguna (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laguna (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laguna (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laguna (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laguna (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lagunes (District of C\xf4te d'Ivoire)": [
            {
                "Region Name": "Lagunes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lagunes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lagunes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lagunes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lagunes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lagunes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lagunes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lagunes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lagunes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lagunes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lagunes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lagunes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lagunes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lagunes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lagunes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lagunes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lagunes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lagunes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lagunes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lagunes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lagunes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lagunes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Lahij (Governorate of Yemen)": [
            {
                "Region Name": "Lahij (Governorate of Yemen)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lahij (Governorate of Yemen)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lahij (Governorate of Yemen)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lahij (Governorate of Yemen)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lahij (Governorate of Yemen)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lahij (Governorate of Yemen)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lahij (Governorate of Yemen)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lahij (Governorate of Yemen)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lahij (Governorate of Yemen)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lahij (Governorate of Yemen)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lahij (Governorate of Yemen)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lahij (Governorate of Yemen)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lahij (Governorate of Yemen)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lahij (Governorate of Yemen)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lahij (Governorate of Yemen)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lahij (Governorate of Yemen)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lahij (Governorate of Yemen)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lahij (Governorate of Yemen)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lahij (Governorate of Yemen)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lahij (Governorate of Yemen)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lahij (Governorate of Yemen)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lahij (Governorate of Yemen)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lai Ch\xe2u (Province of Vietnam)": [
            {
                "Region Name": "Lai Ch\xe2u (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Lai Ch\xe2u (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lai Ch\xe2u (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lai Ch\xe2u (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lai Ch\xe2u (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lai Ch\xe2u (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lai Ch\xe2u (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lai Ch\xe2u (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lai Ch\xe2u (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lai Ch\xe2u (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lai Ch\xe2u (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lai Ch\xe2u (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lai Ch\xe2u (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lai Ch\xe2u (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lai Ch\xe2u (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lai Ch\xe2u (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lai Ch\xe2u (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lai Ch\xe2u (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lai Ch\xe2u (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lai Ch\xe2u (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lai Ch\xe2u (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lai Ch\xe2u (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Laikipia (County of Kenya)": [
            {
                "Region Name": "Laikipia (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Laikipia (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Laikipia (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Laikipia (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Laikipia (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laikipia (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Laikipia (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Laikipia (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Laikipia (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Laikipia (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Laikipia (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Laikipia (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Laikipia (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Laikipia (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Laikipia (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Laikipia (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laikipia (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 68
            },
            {
                "Region Name": "Laikipia (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Laikipia (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Laikipia (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Laikipia (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laikipia (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lajas (Municipality of Puerto Rico)": [
            {
                "Region Name": "Lajas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lajas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lajas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lajas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lajas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lajas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lajas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lajas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lajas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lajas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lajas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lajas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lajas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lajas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lajas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lajas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lajas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lajas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lajas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lajas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lajas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lajas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Lake Albert (Water body of Uganda)": [
            {
                "Region Name": "Lake Albert (Water body of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lake Albert (Water body of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Albert (Water body of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lake Albert (Water body of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Albert (Water body of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Albert (Water body of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Albert (Water body of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Albert (Water body of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Albert (Water body of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Albert (Water body of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lake Albert (Water body of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Albert (Water body of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lake Albert (Water body of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Albert (Water body of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Albert (Water body of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lake Albert (Water body of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lake Albert (Water body of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Albert (Water body of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Albert (Water body of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Albert (Water body of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Albert (Water body of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lake Albert (Water body of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lake Ohrid (Water body of North Macedonia)": [
            {
                "Region Name": "Lake Ohrid (Water body of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Ohrid (Water body of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Ohrid (Water body of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Ohrid (Water body of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Ohrid (Water body of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Ohrid (Water body of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Ohrid (Water body of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Ohrid (Water body of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Ohrid (Water body of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Ohrid (Water body of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Ohrid (Water body of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Ohrid (Water body of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Ohrid (Water body of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Ohrid (Water body of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Ohrid (Water body of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Ohrid (Water body of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Ohrid (Water body of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Ohrid (Water body of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Ohrid (Water body of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Ohrid (Water body of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Ohrid (Water body of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Ohrid (Water body of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lake Victoria (Water body of Uganda)": [
            {
                "Region Name": "Lake Victoria (Water body of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Victoria (Water body of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Victoria (Water body of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lake Victoria (Water body of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lake Victoria (Water body of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lake Victoria (Water body of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lake Victoria (Water body of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lake Victoria (Water body of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lake Victoria (Water body of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lake Victoria (Water body of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Victoria (Water body of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Victoria (Water body of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Victoria (Water body of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Victoria (Water body of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Victoria (Water body of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Victoria (Water body of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lake Victoria (Water body of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Victoria (Water body of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lake Victoria (Water body of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Victoria (Water body of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lake Victoria (Water body of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lake Victoria (Water body of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lakes (State of South Sudan)": [
            {
                "Region Name": "Lakes (State of South Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Lakes (State of South Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Lakes (State of South Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Lakes (State of South Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Lakes (State of South Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Lakes (State of South Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Lakes (State of South Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Lakes (State of South Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Lakes (State of South Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Lakes (State of South Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Lakes (State of South Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Lakes (State of South Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Lakes (State of South Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Lakes (State of South Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Lakes (State of South Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Lakes (State of South Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Lakes (State of South Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Lakes (State of South Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Lakes (State of South Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Lakes (State of South Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Lakes (State of South Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Lakes (State of South Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 40
            }
        ],
        "Lakshadweep (Union Territory of India)": [
            {
                "Region Name": "Lakshadweep (Union Territory of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lakshadweep (Union Territory of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lakshadweep (Union Territory of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lakshadweep (Union Territory of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lakshadweep (Union Territory of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lakshadweep (Union Territory of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lakshadweep (Union Territory of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lakshadweep (Union Territory of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lakshadweep (Union Territory of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lakshadweep (Union Territory of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lakshadweep (Union Territory of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lakshadweep (Union Territory of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lakshadweep (Union Territory of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lakshadweep (Union Territory of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lakshadweep (Union Territory of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lakshadweep (Union Territory of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lakshadweep (Union Territory of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lakshadweep (Union Territory of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lakshadweep (Union Territory of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lakshadweep (Union Territory of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lakshadweep (Union Territory of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lakshadweep (Union Territory of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "L\xe2m \u0110\u1ED3ng (Province of Vietnam)": [
            {
                "Region Name": "L\xe2m \u0110\u1ED3ng (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\xe2m \u0110\u1ED3ng (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\xe2m \u0110\u1ED3ng (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "L\xe2m \u0110\u1ED3ng (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\xe2m \u0110\u1ED3ng (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\xe2m \u0110\u1ED3ng (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "L\xe2m \u0110\u1ED3ng (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\xe2m \u0110\u1ED3ng (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "L\xe2m \u0110\u1ED3ng (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "L\xe2m \u0110\u1ED3ng (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "L\xe2m \u0110\u1ED3ng (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\xe2m \u0110\u1ED3ng (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "L\xe2m \u0110\u1ED3ng (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "L\xe2m \u0110\u1ED3ng (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "L\xe2m \u0110\u1ED3ng (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "L\xe2m \u0110\u1ED3ng (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\xe2m \u0110\u1ED3ng (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "L\xe2m \u0110\u1ED3ng (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\xe2m \u0110\u1ED3ng (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\xe2m \u0110\u1ED3ng (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\xe2m \u0110\u1ED3ng (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\xe2m \u0110\u1ED3ng (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Lambayeque (Region of Peru)": [
            {
                "Region Name": "Lambayeque (Region of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lambayeque (Region of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lambayeque (Region of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lambayeque (Region of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lambayeque (Region of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lambayeque (Region of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lambayeque (Region of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lambayeque (Region of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lambayeque (Region of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lambayeque (Region of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lambayeque (Region of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lambayeque (Region of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lambayeque (Region of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lambayeque (Region of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lambayeque (Region of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lambayeque (Region of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lambayeque (Region of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lambayeque (Region of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lambayeque (Region of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lambayeque (Region of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lambayeque (Region of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lambayeque (Region of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 21
            }
        ],
        "Lampang (Province of Thailand)": [
            {
                "Region Name": "Lampang (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lampang (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lampang (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lampang (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lampang (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lampang (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lampang (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lampang (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lampang (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lampang (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lampang (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lampang (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lampang (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lampang (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lampang (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lampang (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lampang (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lampang (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lampang (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lampang (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lampang (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lampang (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Lamphun (Province of Thailand)": [
            {
                "Region Name": "Lamphun (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Lamphun (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lamphun (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lamphun (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lamphun (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lamphun (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lamphun (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lamphun (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lamphun (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lamphun (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lamphun (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lamphun (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lamphun (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Lamphun (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lamphun (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Lamphun (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lamphun (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Lamphun (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lamphun (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Lamphun (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lamphun (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lamphun (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Lampung (Province of Indonesia)": [
            {
                "Region Name": "Lampung (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lampung (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lampung (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lampung (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lampung (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lampung (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lampung (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Lampung (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lampung (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lampung (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lampung (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lampung (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lampung (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lampung (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lampung (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lampung (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lampung (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lampung (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lampung (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lampung (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lampung (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lampung (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Lamu (County of Kenya)": [
            {
                "Region Name": "Lamu (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lamu (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lamu (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lamu (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lamu (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lamu (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lamu (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lamu (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lamu (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lamu (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lamu (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lamu (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lamu (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lamu (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lamu (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lamu (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lamu (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lamu (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lamu (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lamu (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lamu (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lamu (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Lanao del Norte (Province of Philippines)": [
            {
                "Region Name": "Lanao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lanao del Sur (Province of Philippines)": [
            {
                "Region Name": "Lanao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lanao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lanao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lanao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lanao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lanao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lanao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lanao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lanao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lanao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lanao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "L\u1EA1ng S\u01A1n (Province of Vietnam)": [
            {
                "Region Name": "L\u1EA1ng S\u01A1n (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "L\u1EA1ng S\u01A1n (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "L\u1EA1ng S\u01A1n (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\u1EA1ng S\u01A1n (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\u1EA1ng S\u01A1n (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "L\u1EA1ng S\u01A1n (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "L\u1EA1ng S\u01A1n (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\u1EA1ng S\u01A1n (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\u1EA1ng S\u01A1n (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "L\u1EA1ng S\u01A1n (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\u1EA1ng S\u01A1n (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\u1EA1ng S\u01A1n (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\u1EA1ng S\u01A1n (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\u1EA1ng S\u01A1n (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\u1EA1ng S\u01A1n (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\u1EA1ng S\u01A1n (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\u1EA1ng S\u01A1n (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\u1EA1ng S\u01A1n (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\u1EA1ng S\u01A1n (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\u1EA1ng S\u01A1n (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\u1EA1ng S\u01A1n (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "L\u1EA1ng S\u01A1n (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lankaran (Region of Azerbaijan)": [
            {
                "Region Name": "Lankaran (Region of Azerbaijan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lankaran (Region of Azerbaijan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lankaran (Region of Azerbaijan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Lankaran (Region of Azerbaijan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lankaran (Region of Azerbaijan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lankaran (Region of Azerbaijan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lankaran (Region of Azerbaijan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lankaran (Region of Azerbaijan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Lankaran (Region of Azerbaijan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lankaran (Region of Azerbaijan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lankaran (Region of Azerbaijan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lankaran (Region of Azerbaijan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lankaran (Region of Azerbaijan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lankaran (Region of Azerbaijan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lankaran (Region of Azerbaijan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lankaran (Region of Azerbaijan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lankaran (Region of Azerbaijan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lankaran (Region of Azerbaijan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lankaran (Region of Azerbaijan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lankaran (Region of Azerbaijan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Lankaran (Region of Azerbaijan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lankaran (Region of Azerbaijan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "L\xe0o Cai (Province of Vietnam)": [
            {
                "Region Name": "L\xe0o Cai (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "L\xe0o Cai (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "L\xe0o Cai (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\xe0o Cai (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "L\xe0o Cai (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\xe0o Cai (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "L\xe0o Cai (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\xe0o Cai (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "L\xe0o Cai (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\xe0o Cai (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "L\xe0o Cai (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "L\xe0o Cai (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "L\xe0o Cai (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe0o Cai (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "L\xe0o Cai (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\xe0o Cai (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe0o Cai (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\xe0o Cai (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "L\xe0o Cai (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "L\xe0o Cai (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "L\xe0o Cai (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "L\xe0o Cai (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Laois (County of Ireland)": [
            {
                "Region Name": "Laois (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laois (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laois (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laois (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laois (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laois (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laois (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laois (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laois (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laois (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laois (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laois (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laois (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laois (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laois (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laois (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Laois (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laois (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laois (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laois (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laois (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laois (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lapland (Province of Finland)": [
            {
                "Region Name": "Lapland (Province of Finland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lapland (Province of Finland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lapland (Province of Finland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lapland (Province of Finland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lapland (Province of Finland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lapland (Province of Finland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lapland (Province of Finland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lapland (Province of Finland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lapland (Province of Finland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lapland (Province of Finland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lapland (Province of Finland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lapland (Province of Finland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lapland (Province of Finland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lapland (Province of Finland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lapland (Province of Finland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lapland (Province of Finland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lapland (Province of Finland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Lapland (Province of Finland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lapland (Province of Finland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lapland (Province of Finland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lapland (Province of Finland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lapland (Province of Finland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lara (State of Venezuela)": [
            {
                "Region Name": "Lara (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lara (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lara (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lara (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lara (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lara (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lara (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lara (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lara (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lara (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lara (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lara (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lara (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lara (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lara (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lara (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lara (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lara (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lara (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lara (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lara (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lara (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Lares (Municipality of Puerto Rico)": [
            {
                "Region Name": "Lares (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lares (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lares (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lares (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lares (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lares (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lares (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lares (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lares (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lares (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lares (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lares (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lares (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lares (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lares (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lares (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lares (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lares (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lares (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lares (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lares (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lares (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Larnaca (District of Cyprus)": [
            {
                "Region Name": "Larnaca (District of Cyprus)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Larnaca (District of Cyprus)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Larnaca (District of Cyprus)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Larnaca (District of Cyprus)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Larnaca (District of Cyprus)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Larnaca (District of Cyprus)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Larnaca (District of Cyprus)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Larnaca (District of Cyprus)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Larnaca (District of Cyprus)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Larnaca (District of Cyprus)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Larnaca (District of Cyprus)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Larnaca (District of Cyprus)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Larnaca (District of Cyprus)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Larnaca (District of Cyprus)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Larnaca (District of Cyprus)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Larnaca (District of Cyprus)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Larnaca (District of Cyprus)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Larnaca (District of Cyprus)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Larnaca (District of Cyprus)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Larnaca (District of Cyprus)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Larnaca (District of Cyprus)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Larnaca (District of Cyprus)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Las Mar\xedas (Municipality of Puerto Rico)": [
            {
                "Region Name": "Las Mar\xedas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Mar\xedas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Mar\xedas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Mar\xedas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Mar\xedas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Mar\xedas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Mar\xedas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Mar\xedas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Mar\xedas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Mar\xedas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Mar\xedas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Mar\xedas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Mar\xedas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Mar\xedas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Mar\xedas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Mar\xedas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Mar\xedas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Mar\xedas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Mar\xedas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Mar\xedas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Mar\xedas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Mar\xedas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Las Piedras (Municipality of Puerto Rico)": [
            {
                "Region Name": "Las Piedras (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Piedras (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Piedras (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Piedras (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Piedras (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Piedras (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Piedras (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Piedras (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Piedras (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Piedras (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Piedras (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Piedras (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Piedras (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Piedras (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Piedras (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Piedras (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Piedras (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Piedras (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Piedras (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Piedras (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Piedras (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Las Piedras (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Las Tunas (Province of Cuba)": [
            {
                "Region Name": "Las Tunas (Province of Cuba)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Las Tunas (Province of Cuba)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Las Tunas (Province of Cuba)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Las Tunas (Province of Cuba)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Las Tunas (Province of Cuba)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Las Tunas (Province of Cuba)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Las Tunas (Province of Cuba)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Las Tunas (Province of Cuba)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Las Tunas (Province of Cuba)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Las Tunas (Province of Cuba)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Las Tunas (Province of Cuba)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Las Tunas (Province of Cuba)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Las Tunas (Province of Cuba)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Las Tunas (Province of Cuba)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Las Tunas (Province of Cuba)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Las Tunas (Province of Cuba)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Las Tunas (Province of Cuba)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Las Tunas (Province of Cuba)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Las Tunas (Province of Cuba)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Las Tunas (Province of Cuba)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Las Tunas (Province of Cuba)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Las Tunas (Province of Cuba)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Latgale (Province of Latvia)": [
            {
                "Region Name": "Latgale (Province of Latvia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Latgale (Province of Latvia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Latgale (Province of Latvia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Latgale (Province of Latvia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Latgale (Province of Latvia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Latgale (Province of Latvia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Latgale (Province of Latvia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Latgale (Province of Latvia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Latgale (Province of Latvia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Latgale (Province of Latvia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Latgale (Province of Latvia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Latgale (Province of Latvia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Latgale (Province of Latvia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Latgale (Province of Latvia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Latgale (Province of Latvia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Latgale (Province of Latvia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Latgale (Province of Latvia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Latgale (Province of Latvia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Latgale (Province of Latvia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Latgale (Province of Latvia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Latgale (Province of Latvia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Latgale (Province of Latvia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lattakia (Governorate of Syria)": [
            {
                "Region Name": "Lattakia (Governorate of Syria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lattakia (Governorate of Syria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lattakia (Governorate of Syria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Lattakia (Governorate of Syria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lattakia (Governorate of Syria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lattakia (Governorate of Syria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Lattakia (Governorate of Syria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lattakia (Governorate of Syria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lattakia (Governorate of Syria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lattakia (Governorate of Syria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lattakia (Governorate of Syria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Lattakia (Governorate of Syria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lattakia (Governorate of Syria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lattakia (Governorate of Syria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lattakia (Governorate of Syria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lattakia (Governorate of Syria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lattakia (Governorate of Syria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lattakia (Governorate of Syria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lattakia (Governorate of Syria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Lattakia (Governorate of Syria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lattakia (Governorate of Syria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lattakia (Governorate of Syria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 35
            }
        ],
        "Laut\xe9m (District of Timor-Leste)": [
            {
                "Region Name": "Laut\xe9m (District of Timor-Leste)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laut\xe9m (District of Timor-Leste)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laut\xe9m (District of Timor-Leste)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laut\xe9m (District of Timor-Leste)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laut\xe9m (District of Timor-Leste)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laut\xe9m (District of Timor-Leste)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laut\xe9m (District of Timor-Leste)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laut\xe9m (District of Timor-Leste)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laut\xe9m (District of Timor-Leste)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laut\xe9m (District of Timor-Leste)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laut\xe9m (District of Timor-Leste)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laut\xe9m (District of Timor-Leste)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laut\xe9m (District of Timor-Leste)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laut\xe9m (District of Timor-Leste)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laut\xe9m (District of Timor-Leste)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laut\xe9m (District of Timor-Leste)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laut\xe9m (District of Timor-Leste)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Laut\xe9m (District of Timor-Leste)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laut\xe9m (District of Timor-Leste)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laut\xe9m (District of Timor-Leste)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laut\xe9m (District of Timor-Leste)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Laut\xe9m (District of Timor-Leste)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lavalleja (Department of Uruguay)": [
            {
                "Region Name": "Lavalleja (Department of Uruguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lavalleja (Department of Uruguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lavalleja (Department of Uruguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lavalleja (Department of Uruguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lavalleja (Department of Uruguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lavalleja (Department of Uruguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lavalleja (Department of Uruguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lavalleja (Department of Uruguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lavalleja (Department of Uruguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lavalleja (Department of Uruguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lavalleja (Department of Uruguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lavalleja (Department of Uruguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lavalleja (Department of Uruguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lavalleja (Department of Uruguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lavalleja (Department of Uruguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lavalleja (Department of Uruguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lavalleja (Department of Uruguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lavalleja (Department of Uruguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lavalleja (Department of Uruguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lavalleja (Department of Uruguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lavalleja (Department of Uruguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lavalleja (Department of Uruguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lazio (Region of Italy)": [
            {
                "Region Name": "Lazio (Region of Italy)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lazio (Region of Italy)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lazio (Region of Italy)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lazio (Region of Italy)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lazio (Region of Italy)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lazio (Region of Italy)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lazio (Region of Italy)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lazio (Region of Italy)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lazio (Region of Italy)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lazio (Region of Italy)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lazio (Region of Italy)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lazio (Region of Italy)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lazio (Region of Italy)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lazio (Region of Italy)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lazio (Region of Italy)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lazio (Region of Italy)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lazio (Region of Italy)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lazio (Region of Italy)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lazio (Region of Italy)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lazio (Region of Italy)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lazio (Region of Italy)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lazio (Region of Italy)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Le Kef (Governorate of Tunisia)": [
            {
                "Region Name": "Le Kef (Governorate of Tunisia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Kef (Governorate of Tunisia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Kef (Governorate of Tunisia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Kef (Governorate of Tunisia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Kef (Governorate of Tunisia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Kef (Governorate of Tunisia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Le Kef (Governorate of Tunisia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Le Kef (Governorate of Tunisia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Kef (Governorate of Tunisia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Kef (Governorate of Tunisia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Le Kef (Governorate of Tunisia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Le Kef (Governorate of Tunisia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Le Kef (Governorate of Tunisia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Le Kef (Governorate of Tunisia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Le Kef (Governorate of Tunisia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Le Kef (Governorate of Tunisia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Le Kef (Governorate of Tunisia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Le Kef (Governorate of Tunisia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Kef (Governorate of Tunisia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Le Kef (Governorate of Tunisia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Le Kef (Governorate of Tunisia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Le Kef (Governorate of Tunisia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Le Marin (Arrondissement of Martinique)": [
            {
                "Region Name": "Le Marin (Arrondissement of Martinique)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Marin (Arrondissement of Martinique)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Marin (Arrondissement of Martinique)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Marin (Arrondissement of Martinique)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Marin (Arrondissement of Martinique)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Marin (Arrondissement of Martinique)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Marin (Arrondissement of Martinique)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Marin (Arrondissement of Martinique)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Marin (Arrondissement of Martinique)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Marin (Arrondissement of Martinique)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Marin (Arrondissement of Martinique)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Marin (Arrondissement of Martinique)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Marin (Arrondissement of Martinique)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Marin (Arrondissement of Martinique)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Marin (Arrondissement of Martinique)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Marin (Arrondissement of Martinique)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Marin (Arrondissement of Martinique)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Marin (Arrondissement of Martinique)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Marin (Arrondissement of Martinique)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Marin (Arrondissement of Martinique)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Marin (Arrondissement of Martinique)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Marin (Arrondissement of Martinique)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Le Trinit\xe9 (Arrondissement of Martinique)": [
            {
                "Region Name": "Le Trinit\xe9 (Arrondissement of Martinique)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Trinit\xe9 (Arrondissement of Martinique)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Trinit\xe9 (Arrondissement of Martinique)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Trinit\xe9 (Arrondissement of Martinique)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Trinit\xe9 (Arrondissement of Martinique)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Trinit\xe9 (Arrondissement of Martinique)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Trinit\xe9 (Arrondissement of Martinique)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Trinit\xe9 (Arrondissement of Martinique)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Trinit\xe9 (Arrondissement of Martinique)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Trinit\xe9 (Arrondissement of Martinique)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Trinit\xe9 (Arrondissement of Martinique)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Trinit\xe9 (Arrondissement of Martinique)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Trinit\xe9 (Arrondissement of Martinique)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Trinit\xe9 (Arrondissement of Martinique)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Trinit\xe9 (Arrondissement of Martinique)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Trinit\xe9 (Arrondissement of Martinique)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Trinit\xe9 (Arrondissement of Martinique)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Trinit\xe9 (Arrondissement of Martinique)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Trinit\xe9 (Arrondissement of Martinique)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Trinit\xe9 (Arrondissement of Martinique)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Trinit\xe9 (Arrondissement of Martinique)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Le Trinit\xe9 (Arrondissement of Martinique)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lebap (Province of Turkmenistan)": [
            {
                "Region Name": "Lebap (Province of Turkmenistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Lebap (Province of Turkmenistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lebap (Province of Turkmenistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Lebap (Province of Turkmenistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Lebap (Province of Turkmenistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lebap (Province of Turkmenistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lebap (Province of Turkmenistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lebap (Province of Turkmenistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lebap (Province of Turkmenistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lebap (Province of Turkmenistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lebap (Province of Turkmenistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lebap (Province of Turkmenistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lebap (Province of Turkmenistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lebap (Province of Turkmenistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lebap (Province of Turkmenistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lebap (Province of Turkmenistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lebap (Province of Turkmenistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lebap (Province of Turkmenistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lebap (Province of Turkmenistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lebap (Province of Turkmenistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lebap (Province of Turkmenistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lebap (Province of Turkmenistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Leiria (District of Portugal)": [
            {
                "Region Name": "Leiria (District of Portugal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Leiria (District of Portugal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Leiria (District of Portugal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Leiria (District of Portugal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Leiria (District of Portugal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Leiria (District of Portugal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Leiria (District of Portugal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leiria (District of Portugal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Leiria (District of Portugal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Leiria (District of Portugal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Leiria (District of Portugal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "Leiria (District of Portugal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Leiria (District of Portugal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leiria (District of Portugal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Leiria (District of Portugal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Leiria (District of Portugal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 258
            },
            {
                "Region Name": "Leiria (District of Portugal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leiria (District of Portugal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leiria (District of Portugal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Leiria (District of Portugal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leiria (District of Portugal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Leiria (District of Portugal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Leitrim (County of Ireland)": [
            {
                "Region Name": "Leitrim (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leitrim (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leitrim (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leitrim (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leitrim (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leitrim (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leitrim (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leitrim (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leitrim (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leitrim (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leitrim (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leitrim (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leitrim (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leitrim (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leitrim (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leitrim (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leitrim (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leitrim (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leitrim (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leitrim (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leitrim (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leitrim (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "L\xe9koumou (Region of Republic of the Congo)": [
            {
                "Region Name": "L\xe9koumou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "L\xe9koumou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "L\xe9koumou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "L\xe9koumou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "L\xe9koumou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "L\xe9koumou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "L\xe9koumou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "L\xe9koumou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "L\xe9koumou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "L\xe9koumou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "L\xe9koumou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "L\xe9koumou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "L\xe9koumou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "L\xe9koumou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "L\xe9koumou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "L\xe9koumou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "L\xe9koumou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "L\xe9koumou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "L\xe9koumou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "L\xe9koumou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "L\xe9koumou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "L\xe9koumou (Region of Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Lempira (Department of Honduras)": [
            {
                "Region Name": "Lempira (Department of Honduras)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lempira (Department of Honduras)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lempira (Department of Honduras)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lempira (Department of Honduras)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lempira (Department of Honduras)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lempira (Department of Honduras)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lempira (Department of Honduras)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lempira (Department of Honduras)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lempira (Department of Honduras)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lempira (Department of Honduras)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lempira (Department of Honduras)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lempira (Department of Honduras)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lempira (Department of Honduras)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lempira (Department of Honduras)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lempira (Department of Honduras)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lempira (Department of Honduras)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lempira (Department of Honduras)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lempira (Department of Honduras)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lempira (Department of Honduras)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lempira (Department of Honduras)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lempira (Department of Honduras)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lempira (Department of Honduras)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Leningrad (Region of Russia)": [
            {
                "Region Name": "Leningrad (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Leningrad (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Leningrad (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Leningrad (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Leningrad (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Leningrad (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Leningrad (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Leningrad (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Leningrad (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Leningrad (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Leningrad (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Leningrad (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Leningrad (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Leningrad (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Leningrad (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Leningrad (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Leningrad (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Leningrad (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Leningrad (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Leningrad (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Leningrad (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Leningrad (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Le\xf3n (Department of Nicaragua)": [
            {
                "Region Name": "Le\xf3n (Department of Nicaragua)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Le\xf3n (Department of Nicaragua)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Le\xf3n (Department of Nicaragua)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Le\xf3n (Department of Nicaragua)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Le\xf3n (Department of Nicaragua)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Le\xf3n (Department of Nicaragua)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Le\xf3n (Department of Nicaragua)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Le\xf3n (Department of Nicaragua)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Le\xf3n (Department of Nicaragua)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Le\xf3n (Department of Nicaragua)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Le\xf3n (Department of Nicaragua)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Le\xf3n (Department of Nicaragua)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Le\xf3n (Department of Nicaragua)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Le\xf3n (Department of Nicaragua)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Le\xf3n (Department of Nicaragua)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Le\xf3n (Department of Nicaragua)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Le\xf3n (Department of Nicaragua)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Le\xf3n (Department of Nicaragua)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Le\xf3n (Department of Nicaragua)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Le\xf3n (Department of Nicaragua)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Le\xf3n (Department of Nicaragua)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Le\xf3n (Department of Nicaragua)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Leova (District of Moldova)": [
            {
                "Region Name": "Leova (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leova (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leova (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Leova (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Leova (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Leova (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Leova (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Leova (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leova (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leova (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leova (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leova (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leova (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leova (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leova (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Leova (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leova (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leova (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leova (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leova (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leova (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leova (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Leribe (District of Lesotho)": [
            {
                "Region Name": "Leribe (District of Lesotho)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Leribe (District of Lesotho)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Leribe (District of Lesotho)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Leribe (District of Lesotho)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Leribe (District of Lesotho)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Leribe (District of Lesotho)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Leribe (District of Lesotho)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Leribe (District of Lesotho)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Leribe (District of Lesotho)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Leribe (District of Lesotho)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leribe (District of Lesotho)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Leribe (District of Lesotho)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Leribe (District of Lesotho)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Leribe (District of Lesotho)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Leribe (District of Lesotho)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leribe (District of Lesotho)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Leribe (District of Lesotho)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Leribe (District of Lesotho)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Leribe (District of Lesotho)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Leribe (District of Lesotho)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Leribe (District of Lesotho)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Leribe (District of Lesotho)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Les Mamelles (District of Seychelles)": [
            {
                "Region Name": "Les Mamelles (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Les Mamelles (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Les Mamelles (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Les Mamelles (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Les Mamelles (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Les Mamelles (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Les Mamelles (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Les Mamelles (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Les Mamelles (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Les Mamelles (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Les Mamelles (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Les Mamelles (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Les Mamelles (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Les Mamelles (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Les Mamelles (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Les Mamelles (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Les Mamelles (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Les Mamelles (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Les Mamelles (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Les Mamelles (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Les Mamelles (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Les Mamelles (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Leyte (Province of Philippines)": [
            {
                "Region Name": "Leyte (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leyte (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leyte (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Leyte (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leyte (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Leyte (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Leyte (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leyte (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leyte (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leyte (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leyte (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leyte (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leyte (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leyte (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leyte (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leyte (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leyte (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leyte (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Leyte (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leyte (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leyte (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Leyte (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Lezayre (Parish District of Isle of Man)": [
            {
                "Region Name": "Lezayre (Parish District of Isle of Man)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezayre (Parish District of Isle of Man)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezayre (Parish District of Isle of Man)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezayre (Parish District of Isle of Man)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezayre (Parish District of Isle of Man)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezayre (Parish District of Isle of Man)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezayre (Parish District of Isle of Man)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezayre (Parish District of Isle of Man)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezayre (Parish District of Isle of Man)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezayre (Parish District of Isle of Man)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezayre (Parish District of Isle of Man)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezayre (Parish District of Isle of Man)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezayre (Parish District of Isle of Man)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezayre (Parish District of Isle of Man)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezayre (Parish District of Isle of Man)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezayre (Parish District of Isle of Man)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezayre (Parish District of Isle of Man)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezayre (Parish District of Isle of Man)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezayre (Parish District of Isle of Man)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezayre (Parish District of Isle of Man)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezayre (Parish District of Isle of Man)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezayre (Parish District of Isle of Man)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lezh\xeb (County of Albania)": [
            {
                "Region Name": "Lezh\xeb (County of Albania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezh\xeb (County of Albania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lezh\xeb (County of Albania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezh\xeb (County of Albania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezh\xeb (County of Albania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezh\xeb (County of Albania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Lezh\xeb (County of Albania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezh\xeb (County of Albania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lezh\xeb (County of Albania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezh\xeb (County of Albania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lezh\xeb (County of Albania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Lezh\xeb (County of Albania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezh\xeb (County of Albania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezh\xeb (County of Albania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lezh\xeb (County of Albania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lezh\xeb (County of Albania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Lezh\xeb (County of Albania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezh\xeb (County of Albania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lezh\xeb (County of Albania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Lezh\xeb (County of Albania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lezh\xeb (County of Albania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lezh\xeb (County of Albania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lhuentse (District of Bhutan)": [
            {
                "Region Name": "Lhuentse (District of Bhutan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lhuentse (District of Bhutan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lhuentse (District of Bhutan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lhuentse (District of Bhutan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lhuentse (District of Bhutan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lhuentse (District of Bhutan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lhuentse (District of Bhutan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lhuentse (District of Bhutan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lhuentse (District of Bhutan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lhuentse (District of Bhutan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lhuentse (District of Bhutan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lhuentse (District of Bhutan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lhuentse (District of Bhutan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lhuentse (District of Bhutan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lhuentse (District of Bhutan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lhuentse (District of Bhutan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lhuentse (District of Bhutan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lhuentse (District of Bhutan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lhuentse (District of Bhutan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lhuentse (District of Bhutan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lhuentse (District of Bhutan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lhuentse (District of Bhutan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Liaoning (Province of China)": [
            {
                "Region Name": "Liaoning (Province of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Liaoning (Province of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Liaoning (Province of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Liaoning (Province of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Liaoning (Province of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Liaoning (Province of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Liaoning (Province of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Liaoning (Province of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Liaoning (Province of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Liaoning (Province of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Liaoning (Province of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Liaoning (Province of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Liaoning (Province of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Liaoning (Province of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Liaoning (Province of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Liaoning (Province of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Liaoning (Province of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Liaoning (Province of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Liaoning (Province of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Liaoning (Province of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Liaoning (Province of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Liaoning (Province of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Lib (Island of Marshall Islands)": [
            {
                "Region Name": "Lib (Island of Marshall Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lib (Island of Marshall Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lib (Island of Marshall Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lib (Island of Marshall Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lib (Island of Marshall Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lib (Island of Marshall Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lib (Island of Marshall Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lib (Island of Marshall Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lib (Island of Marshall Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lib (Island of Marshall Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lib (Island of Marshall Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lib (Island of Marshall Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lib (Island of Marshall Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lib (Island of Marshall Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lib (Island of Marshall Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lib (Island of Marshall Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lib (Island of Marshall Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lib (Island of Marshall Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lib (Island of Marshall Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lib (Island of Marshall Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lib (Island of Marshall Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lib (Island of Marshall Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Libereck\xfd (Region of Czechia)": [
            {
                "Region Name": "Libereck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libereck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libereck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libereck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Libereck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libereck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libereck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libereck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libereck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libereck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libereck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libereck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libereck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libereck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libereck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libereck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libereck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libereck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libereck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libereck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libereck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Libereck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Libertador General Bernardo O'Hi (Region of Chile)": [
            {
                "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 151
            },
            {
                "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Libertador General Bernardo O'Hi (Region of Chile)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 29
            }
        ],
        "Licko-Senjska (County of Croatia)": [
            {
                "Region Name": "Licko-Senjska (County of Croatia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Licko-Senjska (County of Croatia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Licko-Senjska (County of Croatia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Licko-Senjska (County of Croatia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Licko-Senjska (County of Croatia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Licko-Senjska (County of Croatia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Licko-Senjska (County of Croatia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Licko-Senjska (County of Croatia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Licko-Senjska (County of Croatia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Licko-Senjska (County of Croatia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Licko-Senjska (County of Croatia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Licko-Senjska (County of Croatia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Licko-Senjska (County of Croatia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Licko-Senjska (County of Croatia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Licko-Senjska (County of Croatia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Licko-Senjska (County of Croatia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Licko-Senjska (County of Croatia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Licko-Senjska (County of Croatia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Licko-Senjska (County of Croatia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Licko-Senjska (County of Croatia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Licko-Senjska (County of Croatia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Licko-Senjska (County of Croatia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Liguria (Region of Italy)": [
            {
                "Region Name": "Liguria (Region of Italy)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liguria (Region of Italy)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Liguria (Region of Italy)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Liguria (Region of Italy)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liguria (Region of Italy)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Liguria (Region of Italy)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Liguria (Region of Italy)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liguria (Region of Italy)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Liguria (Region of Italy)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liguria (Region of Italy)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Liguria (Region of Italy)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liguria (Region of Italy)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liguria (Region of Italy)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liguria (Region of Italy)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Liguria (Region of Italy)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Liguria (Region of Italy)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Liguria (Region of Italy)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liguria (Region of Italy)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liguria (Region of Italy)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liguria (Region of Italy)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liguria (Region of Italy)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Liguria (Region of Italy)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Likiep (Atol of Marshall Islands)": [
            {
                "Region Name": "Likiep (Atol of Marshall Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likiep (Atol of Marshall Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likiep (Atol of Marshall Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likiep (Atol of Marshall Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likiep (Atol of Marshall Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likiep (Atol of Marshall Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likiep (Atol of Marshall Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likiep (Atol of Marshall Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likiep (Atol of Marshall Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likiep (Atol of Marshall Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likiep (Atol of Marshall Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likiep (Atol of Marshall Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likiep (Atol of Marshall Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likiep (Atol of Marshall Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likiep (Atol of Marshall Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likiep (Atol of Marshall Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likiep (Atol of Marshall Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likiep (Atol of Marshall Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likiep (Atol of Marshall Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likiep (Atol of Marshall Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likiep (Atol of Marshall Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likiep (Atol of Marshall Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Likoma (District of Malawi)": [
            {
                "Region Name": "Likoma (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likoma (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likoma (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likoma (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likoma (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likoma (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likoma (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likoma (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likoma (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likoma (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likoma (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likoma (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likoma (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likoma (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likoma (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likoma (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likoma (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likoma (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likoma (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likoma (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likoma (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Likoma (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Likouala (Region of Republic of the Congo)": [
            {
                "Region Name": "Likouala (Region of Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Likouala (Region of Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Likouala (Region of Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Likouala (Region of Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Likouala (Region of Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Likouala (Region of Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Likouala (Region of Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Likouala (Region of Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Likouala (Region of Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Likouala (Region of Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Likouala (Region of Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Likouala (Region of Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Likouala (Region of Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Likouala (Region of Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Likouala (Region of Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Likouala (Region of Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Likouala (Region of Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Likouala (Region of Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Likouala (Region of Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Likouala (Region of Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Likouala (Region of Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Likouala (Region of Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Lilongwe (District of Malawi)": [
            {
                "Region Name": "Lilongwe (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lilongwe (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lilongwe (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lilongwe (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lilongwe (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lilongwe (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lilongwe (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lilongwe (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lilongwe (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lilongwe (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lilongwe (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lilongwe (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lilongwe (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lilongwe (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lilongwe (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lilongwe (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lilongwe (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lilongwe (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lilongwe (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lilongwe (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lilongwe (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lilongwe (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Lima (Region of Peru)": [
            {
                "Region Name": "Lima (Region of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lima (Region of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lima (Region of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima (Region of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lima (Region of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lima (Region of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lima (Region of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima (Region of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima (Region of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lima (Region of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima (Region of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lima (Region of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lima (Region of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lima (Region of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lima (Region of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lima (Region of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lima (Region of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima (Region of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lima (Region of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lima (Region of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lima (Region of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lima (Region of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Lima Province (Province of Peru)": [
            {
                "Region Name": "Lima Province (Province of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lima Province (Province of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima Province (Province of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima Province (Province of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima Province (Province of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima Province (Province of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima Province (Province of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima Province (Province of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima Province (Province of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima Province (Province of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima Province (Province of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima Province (Province of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima Province (Province of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima Province (Province of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima Province (Province of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima Province (Province of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima Province (Province of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima Province (Province of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima Province (Province of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima Province (Province of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima Province (Province of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lima Province (Province of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Limassol (District of Cyprus)": [
            {
                "Region Name": "Limassol (District of Cyprus)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Limassol (District of Cyprus)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limassol (District of Cyprus)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limassol (District of Cyprus)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limassol (District of Cyprus)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limassol (District of Cyprus)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Limassol (District of Cyprus)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Limassol (District of Cyprus)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limassol (District of Cyprus)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Limassol (District of Cyprus)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Limassol (District of Cyprus)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Limassol (District of Cyprus)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limassol (District of Cyprus)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Limassol (District of Cyprus)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limassol (District of Cyprus)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limassol (District of Cyprus)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limassol (District of Cyprus)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limassol (District of Cyprus)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limassol (District of Cyprus)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limassol (District of Cyprus)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Limassol (District of Cyprus)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limassol (District of Cyprus)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Limburg (Province of Netherlands)": [
            {
                "Region Name": "Limburg (Province of Netherlands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limburg (Province of Netherlands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limburg (Province of Netherlands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limburg (Province of Netherlands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limburg (Province of Netherlands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limburg (Province of Netherlands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limburg (Province of Netherlands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limburg (Province of Netherlands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limburg (Province of Netherlands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limburg (Province of Netherlands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limburg (Province of Netherlands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limburg (Province of Netherlands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limburg (Province of Netherlands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limburg (Province of Netherlands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limburg (Province of Netherlands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limburg (Province of Netherlands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limburg (Province of Netherlands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limburg (Province of Netherlands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limburg (Province of Netherlands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limburg (Province of Netherlands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limburg (Province of Netherlands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Limburg (Province of Netherlands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Limerick (County of Ireland)": [
            {
                "Region Name": "Limerick (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limerick (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limerick (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limerick (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limerick (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limerick (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limerick (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limerick (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limerick (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limerick (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limerick (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limerick (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limerick (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limerick (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limerick (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limerick (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limerick (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limerick (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limerick (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limerick (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limerick (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Limerick (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lim\xf3n (Province of Costa Rica)": [
            {
                "Region Name": "Lim\xf3n (Province of Costa Rica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lim\xf3n (Province of Costa Rica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lim\xf3n (Province of Costa Rica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lim\xf3n (Province of Costa Rica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lim\xf3n (Province of Costa Rica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lim\xf3n (Province of Costa Rica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lim\xf3n (Province of Costa Rica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lim\xf3n (Province of Costa Rica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lim\xf3n (Province of Costa Rica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lim\xf3n (Province of Costa Rica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lim\xf3n (Province of Costa Rica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lim\xf3n (Province of Costa Rica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lim\xf3n (Province of Costa Rica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lim\xf3n (Province of Costa Rica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lim\xf3n (Province of Costa Rica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lim\xf3n (Province of Costa Rica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lim\xf3n (Province of Costa Rica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lim\xf3n (Province of Costa Rica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lim\xf3n (Province of Costa Rica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lim\xf3n (Province of Costa Rica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lim\xf3n (Province of Costa Rica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lim\xf3n (Province of Costa Rica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Limpopo (Province of South Africa)": [
            {
                "Region Name": "Limpopo (Province of South Africa)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Limpopo (Province of South Africa)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Limpopo (Province of South Africa)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Limpopo (Province of South Africa)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Limpopo (Province of South Africa)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Limpopo (Province of South Africa)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Limpopo (Province of South Africa)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Limpopo (Province of South Africa)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Limpopo (Province of South Africa)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Limpopo (Province of South Africa)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Limpopo (Province of South Africa)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Limpopo (Province of South Africa)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Limpopo (Province of South Africa)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Limpopo (Province of South Africa)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Limpopo (Province of South Africa)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Limpopo (Province of South Africa)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Limpopo (Province of South Africa)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Limpopo (Province of South Africa)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Limpopo (Province of South Africa)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Limpopo (Province of South Africa)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Limpopo (Province of South Africa)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Limpopo (Province of South Africa)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 24
            }
        ],
        "Lindi (Region of Tanzania)": [
            {
                "Region Name": "Lindi (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Lindi (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Lindi (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Lindi (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Lindi (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lindi (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Lindi (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Lindi (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Lindi (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Lindi (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Lindi (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Lindi (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Lindi (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Lindi (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Lindi (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Lindi (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Lindi (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Lindi (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Lindi (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Lindi (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Lindi (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lindi (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Lipetsk (Region of Russia)": [
            {
                "Region Name": "Lipetsk (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lipetsk (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lipetsk (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lipetsk (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lipetsk (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lipetsk (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lipetsk (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lipetsk (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lipetsk (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lipetsk (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lipetsk (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lipetsk (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lipetsk (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lipetsk (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lipetsk (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lipetsk (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lipetsk (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lipetsk (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lipetsk (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lipetsk (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lipetsk (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lipetsk (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Lipkovo (Municipality of North Macedonia)": [
            {
                "Region Name": "Lipkovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lipkovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lipkovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lipkovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lipkovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lipkovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lipkovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lipkovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lipkovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lipkovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lipkovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lipkovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lipkovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lipkovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lipkovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lipkovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lipkovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lipkovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lipkovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lipkovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lipkovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lipkovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Liqui\xe7\xe1 (District of Timor-Leste)": [
            {
                "Region Name": "Liqui\xe7\xe1 (District of Timor-Leste)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Liqui\xe7\xe1 (District of Timor-Leste)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liqui\xe7\xe1 (District of Timor-Leste)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Liqui\xe7\xe1 (District of Timor-Leste)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liqui\xe7\xe1 (District of Timor-Leste)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Liqui\xe7\xe1 (District of Timor-Leste)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liqui\xe7\xe1 (District of Timor-Leste)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Liqui\xe7\xe1 (District of Timor-Leste)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liqui\xe7\xe1 (District of Timor-Leste)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liqui\xe7\xe1 (District of Timor-Leste)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liqui\xe7\xe1 (District of Timor-Leste)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Liqui\xe7\xe1 (District of Timor-Leste)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liqui\xe7\xe1 (District of Timor-Leste)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Liqui\xe7\xe1 (District of Timor-Leste)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Liqui\xe7\xe1 (District of Timor-Leste)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liqui\xe7\xe1 (District of Timor-Leste)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liqui\xe7\xe1 (District of Timor-Leste)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liqui\xe7\xe1 (District of Timor-Leste)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Liqui\xe7\xe1 (District of Timor-Leste)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liqui\xe7\xe1 (District of Timor-Leste)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liqui\xe7\xe1 (District of Timor-Leste)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Liqui\xe7\xe1 (District of Timor-Leste)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lira (District of Uganda)": [
            {
                "Region Name": "Lira (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lira (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Lira (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lira (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Lira (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lira (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lira (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lira (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lira (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lira (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lira (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lira (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lira (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lira (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lira (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lira (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lira (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lira (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lira (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lira (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lira (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lira (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Lisboa (District of Portugal)": [
            {
                "Region Name": "Lisboa (District of Portugal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lisboa (District of Portugal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Lisboa (District of Portugal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lisboa (District of Portugal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lisboa (District of Portugal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lisboa (District of Portugal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lisboa (District of Portugal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lisboa (District of Portugal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lisboa (District of Portugal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lisboa (District of Portugal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lisboa (District of Portugal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lisboa (District of Portugal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lisboa (District of Portugal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lisboa (District of Portugal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lisboa (District of Portugal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lisboa (District of Portugal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lisboa (District of Portugal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lisboa (District of Portugal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lisboa (District of Portugal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lisboa (District of Portugal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lisboa (District of Portugal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lisboa (District of Portugal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Litoral (Province of Equatorial Guinea)": [
            {
                "Region Name": "Litoral (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Litoral (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Litoral (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Litoral (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Litoral (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Litoral (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Litoral (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Litoral (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Litoral (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Litoral (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Litoral (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Litoral (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Litoral (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Litoral (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Litoral (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Litoral (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Litoral (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Litoral (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Litoral (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Litoral (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Litoral (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Litoral (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Littoral (Department of Benin)": [
            {
                "Region Name": "Littoral (Department of Benin)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Littoral (Department of Benin)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Littoral (Department of Benin)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Littoral (Department of Benin)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Littoral (Department of Benin)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Littoral (Department of Benin)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Littoral (Department of Benin)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Littoral (Department of Benin)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Littoral (Department of Benin)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Littoral (Department of Benin)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Littoral (Department of Benin)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Littoral (Department of Benin)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Littoral (Department of Benin)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Littoral (Department of Benin)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Littoral (Department of Benin)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Littoral (Department of Benin)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Littoral (Department of Benin)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Littoral (Department of Benin)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Littoral (Department of Benin)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Littoral (Department of Benin)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Littoral (Department of Benin)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Littoral (Department of Benin)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Littoral (Region of Cameroon)": [
            {
                "Region Name": "Littoral (Region of Cameroon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Littoral (Region of Cameroon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Littoral (Region of Cameroon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Littoral (Region of Cameroon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Littoral (Region of Cameroon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Littoral (Region of Cameroon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Littoral (Region of Cameroon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Littoral (Region of Cameroon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Littoral (Region of Cameroon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Littoral (Region of Cameroon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Littoral (Region of Cameroon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Littoral (Region of Cameroon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Littoral (Region of Cameroon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Littoral (Region of Cameroon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Littoral (Region of Cameroon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Littoral (Region of Cameroon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Littoral (Region of Cameroon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Littoral (Region of Cameroon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Littoral (Region of Cameroon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Littoral (Region of Cameroon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Littoral (Region of Cameroon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Littoral (Region of Cameroon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Lobatse (Town of Botswana)": [
            {
                "Region Name": "Lobatse (Town of Botswana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lobatse (Town of Botswana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lobatse (Town of Botswana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lobatse (Town of Botswana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lobatse (Town of Botswana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lobatse (Town of Botswana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lobatse (Town of Botswana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lobatse (Town of Botswana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lobatse (Town of Botswana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lobatse (Town of Botswana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lobatse (Town of Botswana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lobatse (Town of Botswana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lobatse (Town of Botswana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lobatse (Town of Botswana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lobatse (Town of Botswana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lobatse (Town of Botswana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lobatse (Town of Botswana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lobatse (Town of Botswana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lobatse (Town of Botswana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lobatse (Town of Botswana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lobatse (Town of Botswana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lobatse (Town of Botswana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Lobaye (Prefecture of Central African Republic)": [
            {
                "Region Name": "Lobaye (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Lobaye (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lobaye (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lobaye (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lobaye (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lobaye (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lobaye (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lobaye (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lobaye (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lobaye (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Lobaye (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lobaye (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lobaye (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lobaye (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lobaye (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lobaye (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lobaye (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lobaye (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lobaye (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lobaye (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lobaye (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lobaye (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "\u0141\xf3dzkie (Voivodeship of Poland)": [
            {
                "Region Name": "\u0141\xf3dzkie (Voivodeship of Poland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0141\xf3dzkie (Voivodeship of Poland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0141\xf3dzkie (Voivodeship of Poland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0141\xf3dzkie (Voivodeship of Poland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0141\xf3dzkie (Voivodeship of Poland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0141\xf3dzkie (Voivodeship of Poland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0141\xf3dzkie (Voivodeship of Poland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0141\xf3dzkie (Voivodeship of Poland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0141\xf3dzkie (Voivodeship of Poland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0141\xf3dzkie (Voivodeship of Poland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0141\xf3dzkie (Voivodeship of Poland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0141\xf3dzkie (Voivodeship of Poland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0141\xf3dzkie (Voivodeship of Poland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0141\xf3dzkie (Voivodeship of Poland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0141\xf3dzkie (Voivodeship of Poland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0141\xf3dzkie (Voivodeship of Poland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0141\xf3dzkie (Voivodeship of Poland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0141\xf3dzkie (Voivodeship of Poland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0141\xf3dzkie (Voivodeship of Poland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0141\xf3dzkie (Voivodeship of Poland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0141\xf3dzkie (Voivodeship of Poland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0141\xf3dzkie (Voivodeship of Poland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Loei (Province of Thailand)": [
            {
                "Region Name": "Loei (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Loei (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Loei (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Loei (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Loei (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Loei (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Loei (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Loei (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Loei (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Loei (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Loei (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Loei (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Loei (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Loei (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Loei (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Loei (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Loei (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Loei (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Loei (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Loei (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Loei (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Loei (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Lofa (County of Liberia)": [
            {
                "Region Name": "Lofa (County of Liberia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lofa (County of Liberia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lofa (County of Liberia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lofa (County of Liberia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lofa (County of Liberia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lofa (County of Liberia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lofa (County of Liberia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lofa (County of Liberia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lofa (County of Liberia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lofa (County of Liberia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lofa (County of Liberia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lofa (County of Liberia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lofa (County of Liberia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lofa (County of Liberia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lofa (County of Liberia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lofa (County of Liberia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lofa (County of Liberia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lofa (County of Liberia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lofa (County of Liberia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lofa (County of Liberia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lofa (County of Liberia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lofa (County of Liberia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Logar (Province of Afghanistan)": [
            {
                "Region Name": "Logar (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Logar (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Logar (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Logar (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Logar (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Logar (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Logar (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Logar (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Logar (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Logar (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Logar (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Logar (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Logar (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Logar (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Logar (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Logar (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Logar (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Logar (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Logar (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Logar (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Logar (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Logar (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Logone Occidental (Region of Chad)": [
            {
                "Region Name": "Logone Occidental (Region of Chad)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Logone Occidental (Region of Chad)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Logone Occidental (Region of Chad)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Logone Occidental (Region of Chad)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Logone Occidental (Region of Chad)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Logone Occidental (Region of Chad)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Logone Occidental (Region of Chad)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Logone Occidental (Region of Chad)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Logone Occidental (Region of Chad)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Logone Occidental (Region of Chad)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Logone Occidental (Region of Chad)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Logone Occidental (Region of Chad)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Logone Occidental (Region of Chad)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Logone Occidental (Region of Chad)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Logone Occidental (Region of Chad)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Logone Occidental (Region of Chad)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Logone Occidental (Region of Chad)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Logone Occidental (Region of Chad)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Logone Occidental (Region of Chad)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Logone Occidental (Region of Chad)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Logone Occidental (Region of Chad)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Logone Occidental (Region of Chad)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Logone Oriental (Region of Chad)": [
            {
                "Region Name": "Logone Oriental (Region of Chad)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Logone Oriental (Region of Chad)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Logone Oriental (Region of Chad)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Logone Oriental (Region of Chad)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Logone Oriental (Region of Chad)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Logone Oriental (Region of Chad)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Logone Oriental (Region of Chad)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Logone Oriental (Region of Chad)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Logone Oriental (Region of Chad)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Logone Oriental (Region of Chad)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Logone Oriental (Region of Chad)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Logone Oriental (Region of Chad)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Logone Oriental (Region of Chad)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Logone Oriental (Region of Chad)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Logone Oriental (Region of Chad)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Logone Oriental (Region of Chad)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Logone Oriental (Region of Chad)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Logone Oriental (Region of Chad)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Logone Oriental (Region of Chad)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Logone Oriental (Region of Chad)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Logone Oriental (Region of Chad)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Logone Oriental (Region of Chad)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Lo\xedza (Municipality of Puerto Rico)": [
            {
                "Region Name": "Lo\xedza (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lo\xedza (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lo\xedza (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lo\xedza (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lo\xedza (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lo\xedza (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lo\xedza (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lo\xedza (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lo\xedza (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lo\xedza (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lo\xedza (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lo\xedza (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lo\xedza (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lo\xedza (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lo\xedza (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lo\xedza (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lo\xedza (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lo\xedza (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lo\xedza (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lo\xedza (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lo\xedza (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lo\xedza (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Loja (Province of Ecuador)": [
            {
                "Region Name": "Loja (Province of Ecuador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Loja (Province of Ecuador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Loja (Province of Ecuador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Loja (Province of Ecuador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Loja (Province of Ecuador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Loja (Province of Ecuador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Loja (Province of Ecuador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Loja (Province of Ecuador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Loja (Province of Ecuador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Loja (Province of Ecuador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Loja (Province of Ecuador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Loja (Province of Ecuador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Loja (Province of Ecuador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Loja (Province of Ecuador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Loja (Province of Ecuador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Loja (Province of Ecuador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Loja (Province of Ecuador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Loja (Province of Ecuador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "Loja (Province of Ecuador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Loja (Province of Ecuador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Loja (Province of Ecuador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Loja (Province of Ecuador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Lomami (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lomami (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Lombardia (Region of Italy)": [
            {
                "Region Name": "Lombardia (Region of Italy)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lombardia (Region of Italy)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lombardia (Region of Italy)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lombardia (Region of Italy)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lombardia (Region of Italy)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Lombardia (Region of Italy)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lombardia (Region of Italy)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lombardia (Region of Italy)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lombardia (Region of Italy)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lombardia (Region of Italy)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lombardia (Region of Italy)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lombardia (Region of Italy)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lombardia (Region of Italy)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lombardia (Region of Italy)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lombardia (Region of Italy)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lombardia (Region of Italy)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lombardia (Region of Italy)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lombardia (Region of Italy)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lombardia (Region of Italy)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lombardia (Region of Italy)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lombardia (Region of Italy)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lombardia (Region of Italy)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Long An (Province of Vietnam)": [
            {
                "Region Name": "Long An (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Long An (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Long An (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Long An (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Long An (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Long An (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Long An (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Long An (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Long An (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Long An (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Long An (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Long An (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Long An (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Long An (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Long An (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Long An (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Long An (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Long An (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Long An (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Long An (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Long An (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Long An (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Long Island (District of Bahamas)": [
            {
                "Region Name": "Long Island (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Long Island (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Long Island (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Long Island (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Long Island (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Long Island (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Long Island (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Long Island (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Long Island (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Long Island (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Long Island (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Long Island (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Long Island (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Long Island (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Long Island (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Long Island (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Long Island (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Long Island (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Long Island (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Long Island (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Long Island (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Long Island (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Longford (County of Ireland)": [
            {
                "Region Name": "Longford (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Longford (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Longford (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Longford (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Longford (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Longford (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Longford (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Longford (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Longford (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Longford (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Longford (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Longford (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Longford (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Longford (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Longford (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Longford (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Longford (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Longford (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Longford (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Longford (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Longford (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Longford (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lop Buri (Province of Thailand)": [
            {
                "Region Name": "Lop Buri (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lop Buri (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lop Buri (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lop Buri (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lop Buri (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lop Buri (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lop Buri (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lop Buri (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lop Buri (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lop Buri (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lop Buri (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lop Buri (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lop Buri (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lop Buri (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lop Buri (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lop Buri (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lop Buri (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lop Buri (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lop Buri (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lop Buri (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lop Buri (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lop Buri (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Lorestan (Province of Iran)": [
            {
                "Region Name": "Lorestan (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lorestan (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lorestan (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lorestan (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lorestan (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lorestan (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lorestan (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lorestan (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lorestan (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lorestan (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lorestan (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lorestan (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lorestan (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lorestan (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lorestan (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lorestan (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lorestan (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lorestan (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Lorestan (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Lorestan (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lorestan (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lorestan (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Loreto (Region of Peru)": [
            {
                "Region Name": "Loreto (Region of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Loreto (Region of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Loreto (Region of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Loreto (Region of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Loreto (Region of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Loreto (Region of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Loreto (Region of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Loreto (Region of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Loreto (Region of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Loreto (Region of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Loreto (Region of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Loreto (Region of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Loreto (Region of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Loreto (Region of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Loreto (Region of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Loreto (Region of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Loreto (Region of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Loreto (Region of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Loreto (Region of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Loreto (Region of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Loreto (Region of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Loreto (Region of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Lori (Province of Armenia)": [
            {
                "Region Name": "Lori (Province of Armenia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lori (Province of Armenia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lori (Province of Armenia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lori (Province of Armenia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lori (Province of Armenia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lori (Province of Armenia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lori (Province of Armenia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lori (Province of Armenia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lori (Province of Armenia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Lori (Province of Armenia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Lori (Province of Armenia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lori (Province of Armenia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lori (Province of Armenia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lori (Province of Armenia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lori (Province of Armenia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lori (Province of Armenia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lori (Province of Armenia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lori (Province of Armenia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lori (Province of Armenia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lori (Province of Armenia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lori (Province of Armenia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lori (Province of Armenia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Los Lagos (Region of Chile)": [
            {
                "Region Name": "Los Lagos (Region of Chile)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Los Lagos (Region of Chile)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Los Lagos (Region of Chile)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Los Lagos (Region of Chile)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Los Lagos (Region of Chile)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Los Lagos (Region of Chile)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Los Lagos (Region of Chile)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Los Lagos (Region of Chile)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Los Lagos (Region of Chile)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Los Lagos (Region of Chile)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Los Lagos (Region of Chile)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Los Lagos (Region of Chile)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Los Lagos (Region of Chile)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Los Lagos (Region of Chile)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Los Lagos (Region of Chile)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Los Lagos (Region of Chile)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Los Lagos (Region of Chile)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Los Lagos (Region of Chile)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Los Lagos (Region of Chile)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Los Lagos (Region of Chile)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Los Lagos (Region of Chile)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Los Lagos (Region of Chile)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Los Rios (Province of Ecuador)": [
            {
                "Region Name": "Los Rios (Province of Ecuador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Los Rios (Province of Ecuador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Los Rios (Province of Ecuador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Los Rios (Province of Ecuador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Los Rios (Province of Ecuador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Los Rios (Province of Ecuador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Los Rios (Province of Ecuador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Los Rios (Province of Ecuador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Los Rios (Province of Ecuador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Los Rios (Province of Ecuador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Los Rios (Province of Ecuador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Los Rios (Province of Ecuador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Los Rios (Province of Ecuador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Los Rios (Province of Ecuador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Los Rios (Province of Ecuador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Los Rios (Province of Ecuador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Los Rios (Province of Ecuador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Los Rios (Province of Ecuador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Los Rios (Province of Ecuador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Los Rios (Province of Ecuador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Los Rios (Province of Ecuador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Los Rios (Province of Ecuador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Los R\xedos (Region of Chile)": [
            {
                "Region Name": "Los R\xedos (Region of Chile)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Los R\xedos (Region of Chile)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Los R\xedos (Region of Chile)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Los R\xedos (Region of Chile)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Los R\xedos (Region of Chile)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Los R\xedos (Region of Chile)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Los R\xedos (Region of Chile)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Los R\xedos (Region of Chile)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Los R\xedos (Region of Chile)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Los R\xedos (Region of Chile)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Los R\xedos (Region of Chile)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Los R\xedos (Region of Chile)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Los R\xedos (Region of Chile)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Los R\xedos (Region of Chile)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Los R\xedos (Region of Chile)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Los R\xedos (Region of Chile)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Los R\xedos (Region of Chile)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Los R\xedos (Region of Chile)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Los R\xedos (Region of Chile)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Los R\xedos (Region of Chile)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Los R\xedos (Region of Chile)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Los R\xedos (Region of Chile)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Los Santos (Province of Panama)": [
            {
                "Region Name": "Los Santos (Province of Panama)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Los Santos (Province of Panama)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Los Santos (Province of Panama)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Los Santos (Province of Panama)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Los Santos (Province of Panama)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Los Santos (Province of Panama)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Los Santos (Province of Panama)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Los Santos (Province of Panama)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Los Santos (Province of Panama)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Los Santos (Province of Panama)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Los Santos (Province of Panama)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Los Santos (Province of Panama)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Los Santos (Province of Panama)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Los Santos (Province of Panama)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Los Santos (Province of Panama)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Los Santos (Province of Panama)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Los Santos (Province of Panama)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Los Santos (Province of Panama)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Los Santos (Province of Panama)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Los Santos (Province of Panama)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Los Santos (Province of Panama)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Los Santos (Province of Panama)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Louang Namtha (Province of Laos)": [
            {
                "Region Name": "Louang Namtha (Province of Laos)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Louang Namtha (Province of Laos)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Louang Namtha (Province of Laos)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Louang Namtha (Province of Laos)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Louang Namtha (Province of Laos)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Louang Namtha (Province of Laos)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Louang Namtha (Province of Laos)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Louang Namtha (Province of Laos)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Louang Namtha (Province of Laos)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Louang Namtha (Province of Laos)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Louang Namtha (Province of Laos)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Louang Namtha (Province of Laos)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Louang Namtha (Province of Laos)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Louang Namtha (Province of Laos)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Louang Namtha (Province of Laos)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Louang Namtha (Province of Laos)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Louang Namtha (Province of Laos)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Louang Namtha (Province of Laos)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Louang Namtha (Province of Laos)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Louang Namtha (Province of Laos)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Louang Namtha (Province of Laos)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Louang Namtha (Province of Laos)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Louangphrabang (Province of Laos)": [
            {
                "Region Name": "Louangphrabang (Province of Laos)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Louangphrabang (Province of Laos)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Louangphrabang (Province of Laos)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Louangphrabang (Province of Laos)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Louangphrabang (Province of Laos)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Louangphrabang (Province of Laos)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Louangphrabang (Province of Laos)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Louangphrabang (Province of Laos)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Louangphrabang (Province of Laos)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Louangphrabang (Province of Laos)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Louangphrabang (Province of Laos)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Louangphrabang (Province of Laos)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Louangphrabang (Province of Laos)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Louangphrabang (Province of Laos)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Louangphrabang (Province of Laos)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Louangphrabang (Province of Laos)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Louangphrabang (Province of Laos)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Louangphrabang (Province of Laos)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Louangphrabang (Province of Laos)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Louangphrabang (Province of Laos)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Louangphrabang (Province of Laos)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Louangphrabang (Province of Laos)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Louga (Region of Senegal)": [
            {
                "Region Name": "Louga (Region of Senegal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 320
            },
            {
                "Region Name": "Louga (Region of Senegal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Louga (Region of Senegal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Louga (Region of Senegal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 126
            },
            {
                "Region Name": "Louga (Region of Senegal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Louga (Region of Senegal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Louga (Region of Senegal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 73
            },
            {
                "Region Name": "Louga (Region of Senegal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Louga (Region of Senegal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Louga (Region of Senegal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Louga (Region of Senegal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Louga (Region of Senegal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Louga (Region of Senegal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Louga (Region of Senegal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Louga (Region of Senegal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Louga (Region of Senegal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 83
            },
            {
                "Region Name": "Louga (Region of Senegal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Louga (Region of Senegal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Louga (Region of Senegal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Louga (Region of Senegal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Louga (Region of Senegal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Louga (Region of Senegal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 23
            }
        ],
        "Louisiana (State of United States)": [
            {
                "Region Name": "Louisiana (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Louisiana (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Louisiana (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Louisiana (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Louisiana (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Louisiana (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Louisiana (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Louisiana (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Louisiana (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Louisiana (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Louisiana (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Louisiana (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Louisiana (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Louisiana (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Louisiana (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Louisiana (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Louisiana (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Louisiana (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Louisiana (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Louisiana (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Louisiana (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Louisiana (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Louth (County of Ireland)": [
            {
                "Region Name": "Louth (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Louth (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Louth (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Louth (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Louth (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Louth (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Louth (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Louth (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Louth (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Louth (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Louth (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Louth (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Louth (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Louth (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Louth (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Louth (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Louth (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Louth (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Louth (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Louth (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Louth (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Louth (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lovech (Province of Bulgaria)": [
            {
                "Region Name": "Lovech (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lovech (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lovech (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lovech (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lovech (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lovech (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Lovech (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lovech (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lovech (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lovech (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lovech (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lovech (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lovech (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lovech (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lovech (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lovech (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lovech (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lovech (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lovech (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lovech (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lovech (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lovech (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Lower River (Division of Gambia)": [
            {
                "Region Name": "Lower River (Division of Gambia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 75
            },
            {
                "Region Name": "Lower River (Division of Gambia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Lower River (Division of Gambia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Lower River (Division of Gambia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Lower River (Division of Gambia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Lower River (Division of Gambia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Lower River (Division of Gambia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Lower River (Division of Gambia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Lower River (Division of Gambia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Lower River (Division of Gambia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Lower River (Division of Gambia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Lower River (Division of Gambia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Lower River (Division of Gambia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Lower River (Division of Gambia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "Lower River (Division of Gambia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Lower River (Division of Gambia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Lower River (Division of Gambia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Lower River (Division of Gambia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Lower River (Division of Gambia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Lower River (Division of Gambia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Lower River (Division of Gambia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Lower River (Division of Gambia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 36
            }
        ],
        "Lozovo (Municipality of North Macedonia)": [
            {
                "Region Name": "Lozovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lozovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lozovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lozovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lozovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lozovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lozovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lozovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lozovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lozovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lozovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lozovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lozovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lozovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lozovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lozovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lozovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lozovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lozovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lozovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lozovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lozovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Lualaba (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lualaba (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Luanda (Province of Angola)": [
            {
                "Region Name": "Luanda (Province of Angola)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Luanda (Province of Angola)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Luanda (Province of Angola)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Luanda (Province of Angola)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Luanda (Province of Angola)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Luanda (Province of Angola)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Luanda (Province of Angola)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Luanda (Province of Angola)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Luanda (Province of Angola)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Luanda (Province of Angola)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Luanda (Province of Angola)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Luanda (Province of Angola)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luanda (Province of Angola)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Luanda (Province of Angola)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Luanda (Province of Angola)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Luanda (Province of Angola)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Luanda (Province of Angola)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Luanda (Province of Angola)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Luanda (Province of Angola)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Luanda (Province of Angola)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Luanda (Province of Angola)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luanda (Province of Angola)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Luapula (Province of Zambia)": [
            {
                "Region Name": "Luapula (Province of Zambia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Luapula (Province of Zambia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Luapula (Province of Zambia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Luapula (Province of Zambia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Luapula (Province of Zambia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Luapula (Province of Zambia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Luapula (Province of Zambia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Luapula (Province of Zambia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Luapula (Province of Zambia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Luapula (Province of Zambia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Luapula (Province of Zambia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Luapula (Province of Zambia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Luapula (Province of Zambia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Luapula (Province of Zambia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Luapula (Province of Zambia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Luapula (Province of Zambia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Luapula (Province of Zambia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Luapula (Province of Zambia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Luapula (Province of Zambia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Luapula (Province of Zambia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Luapula (Province of Zambia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Luapula (Province of Zambia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 44
            }
        ],
        "Lubelskie (Voivodeship of Poland)": [
            {
                "Region Name": "Lubelskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Lubelskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lubelskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lubelskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lubelskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lubelskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lubelskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lubelskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lubelskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lubelskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lubelskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lubelskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lubelskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lubelskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lubelskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lubelskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lubelskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lubelskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lubelskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lubelskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lubelskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lubelskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lubombo (District of Swaziland)": [
            {
                "Region Name": "Lubombo (District of Swaziland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lubombo (District of Swaziland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lubombo (District of Swaziland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lubombo (District of Swaziland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lubombo (District of Swaziland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lubombo (District of Swaziland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lubombo (District of Swaziland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lubombo (District of Swaziland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lubombo (District of Swaziland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lubombo (District of Swaziland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lubombo (District of Swaziland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lubombo (District of Swaziland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lubombo (District of Swaziland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lubombo (District of Swaziland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lubombo (District of Swaziland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lubombo (District of Swaziland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lubombo (District of Swaziland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lubombo (District of Swaziland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lubombo (District of Swaziland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Lubombo (District of Swaziland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lubombo (District of Swaziland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Lubombo (District of Swaziland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Lubuskie (Voivodeship of Poland)": [
            {
                "Region Name": "Lubuskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lubuskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lubuskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lubuskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lubuskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lubuskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lubuskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Lubuskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lubuskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lubuskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lubuskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lubuskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lubuskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lubuskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Lubuskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Lubuskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lubuskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lubuskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lubuskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lubuskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lubuskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lubuskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lucerne (Canton of Switzerland)": [
            {
                "Region Name": "Lucerne (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lucerne (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lucerne (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lucerne (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lucerne (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lucerne (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lucerne (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lucerne (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lucerne (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lucerne (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lucerne (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lucerne (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lucerne (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Lucerne (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lucerne (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lucerne (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lucerne (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lucerne (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lucerne (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lucerne (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lucerne (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Lucerne (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Luhans'k (Region of Ukraine)": [
            {
                "Region Name": "Luhans'k (Region of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Luhans'k (Region of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Luhans'k (Region of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Luhans'k (Region of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Luhans'k (Region of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Luhans'k (Region of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Luhans'k (Region of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Luhans'k (Region of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Luhans'k (Region of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Luhans'k (Region of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Luhans'k (Region of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Luhans'k (Region of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Luhans'k (Region of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Luhans'k (Region of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Luhans'k (Region of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Luhans'k (Region of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Luhans'k (Region of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Luhans'k (Region of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Luhans'k (Region of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Luhans'k (Region of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Luhans'k (Region of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Luhans'k (Region of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Lunda Norte (Province of Angola)": [
            {
                "Region Name": "Lunda Norte (Province of Angola)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Lunda Norte (Province of Angola)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Lunda Norte (Province of Angola)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Lunda Norte (Province of Angola)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Lunda Norte (Province of Angola)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Lunda Norte (Province of Angola)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Lunda Norte (Province of Angola)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Lunda Norte (Province of Angola)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Lunda Norte (Province of Angola)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Lunda Norte (Province of Angola)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Lunda Norte (Province of Angola)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Lunda Norte (Province of Angola)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Lunda Norte (Province of Angola)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Lunda Norte (Province of Angola)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Lunda Norte (Province of Angola)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Lunda Norte (Province of Angola)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Lunda Norte (Province of Angola)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Lunda Norte (Province of Angola)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Lunda Norte (Province of Angola)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Lunda Norte (Province of Angola)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Lunda Norte (Province of Angola)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Lunda Norte (Province of Angola)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 28
            }
        ],
        "Lunda Sul (Province of Angola)": [
            {
                "Region Name": "Lunda Sul (Province of Angola)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "Lunda Sul (Province of Angola)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Lunda Sul (Province of Angola)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Lunda Sul (Province of Angola)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Lunda Sul (Province of Angola)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Lunda Sul (Province of Angola)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Lunda Sul (Province of Angola)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Lunda Sul (Province of Angola)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Lunda Sul (Province of Angola)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Lunda Sul (Province of Angola)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Lunda Sul (Province of Angola)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Lunda Sul (Province of Angola)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Lunda Sul (Province of Angola)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Lunda Sul (Province of Angola)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Lunda Sul (Province of Angola)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Lunda Sul (Province of Angola)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Lunda Sul (Province of Angola)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Lunda Sul (Province of Angola)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Lunda Sul (Province of Angola)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Lunda Sul (Province of Angola)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Lunda Sul (Province of Angola)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Lunda Sul (Province of Angola)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 31
            }
        ],
        "Luquillo (Municipality of Puerto Rico)": [
            {
                "Region Name": "Luquillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luquillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luquillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luquillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luquillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luquillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luquillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luquillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luquillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luquillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luquillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luquillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luquillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luquillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luquillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luquillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luquillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luquillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luquillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luquillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luquillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luquillo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Lusaka (Province of Zambia)": [
            {
                "Region Name": "Lusaka (Province of Zambia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lusaka (Province of Zambia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lusaka (Province of Zambia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lusaka (Province of Zambia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lusaka (Province of Zambia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lusaka (Province of Zambia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Lusaka (Province of Zambia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lusaka (Province of Zambia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lusaka (Province of Zambia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lusaka (Province of Zambia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lusaka (Province of Zambia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lusaka (Province of Zambia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lusaka (Province of Zambia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Lusaka (Province of Zambia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Lusaka (Province of Zambia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Lusaka (Province of Zambia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Lusaka (Province of Zambia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Lusaka (Province of Zambia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Lusaka (Province of Zambia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Lusaka (Province of Zambia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Lusaka (Province of Zambia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Lusaka (Province of Zambia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Luwero (District of Uganda)": [
            {
                "Region Name": "Luwero (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Luwero (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Luwero (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Luwero (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Luwero (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luwero (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Luwero (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Luwero (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Luwero (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Luwero (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Luwero (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Luwero (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Luwero (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Luwero (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Luwero (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Luwero (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Luwero (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Luwero (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Luwero (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Luwero (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Luwero (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Luwero (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Luxembourg (District of Luxembourg)": [
            {
                "Region Name": "Luxembourg (District of Luxembourg)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg (District of Luxembourg)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg (District of Luxembourg)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg (District of Luxembourg)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg (District of Luxembourg)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg (District of Luxembourg)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg (District of Luxembourg)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg (District of Luxembourg)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg (District of Luxembourg)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg (District of Luxembourg)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg (District of Luxembourg)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg (District of Luxembourg)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg (District of Luxembourg)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg (District of Luxembourg)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg (District of Luxembourg)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg (District of Luxembourg)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg (District of Luxembourg)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg (District of Luxembourg)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg (District of Luxembourg)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg (District of Luxembourg)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg (District of Luxembourg)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Luxembourg (District of Luxembourg)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "M'Sila (Province of Algeria)": [
            {
                "Region Name": "M'Sila (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "M'Sila (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "M'Sila (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "M'Sila (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "M'Sila (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "M'Sila (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "M'Sila (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'Sila (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'Sila (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "M'Sila (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "M'Sila (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "M'Sila (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "M'Sila (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "M'Sila (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "M'Sila (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'Sila (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "M'Sila (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'Sila (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "M'Sila (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'Sila (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "M'Sila (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'Sila (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "M'tsangamouji (Commune of Mayotte)": [
            {
                "Region Name": "M'tsangamouji (Commune of Mayotte)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'tsangamouji (Commune of Mayotte)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'tsangamouji (Commune of Mayotte)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'tsangamouji (Commune of Mayotte)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'tsangamouji (Commune of Mayotte)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'tsangamouji (Commune of Mayotte)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'tsangamouji (Commune of Mayotte)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'tsangamouji (Commune of Mayotte)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'tsangamouji (Commune of Mayotte)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'tsangamouji (Commune of Mayotte)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'tsangamouji (Commune of Mayotte)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'tsangamouji (Commune of Mayotte)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'tsangamouji (Commune of Mayotte)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'tsangamouji (Commune of Mayotte)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'tsangamouji (Commune of Mayotte)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'tsangamouji (Commune of Mayotte)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'tsangamouji (Commune of Mayotte)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'tsangamouji (Commune of Mayotte)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'tsangamouji (Commune of Mayotte)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'tsangamouji (Commune of Mayotte)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'tsangamouji (Commune of Mayotte)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M'tsangamouji (Commune of Mayotte)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ma'rib (Governorate of Yemen)": [
            {
                "Region Name": "Ma'rib (Governorate of Yemen)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma'rib (Governorate of Yemen)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma'rib (Governorate of Yemen)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma'rib (Governorate of Yemen)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma'rib (Governorate of Yemen)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma'rib (Governorate of Yemen)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma'rib (Governorate of Yemen)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma'rib (Governorate of Yemen)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma'rib (Governorate of Yemen)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma'rib (Governorate of Yemen)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma'rib (Governorate of Yemen)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma'rib (Governorate of Yemen)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma'rib (Governorate of Yemen)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma'rib (Governorate of Yemen)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma'rib (Governorate of Yemen)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma'rib (Governorate of Yemen)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma'rib (Governorate of Yemen)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma'rib (Governorate of Yemen)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma'rib (Governorate of Yemen)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma'rib (Governorate of Yemen)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma'rib (Governorate of Yemen)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma'rib (Governorate of Yemen)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ma`an (Province of Jordan)": [
            {
                "Region Name": "Ma`an (Province of Jordan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ma`an (Province of Jordan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ma`an (Province of Jordan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma`an (Province of Jordan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ma`an (Province of Jordan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma`an (Province of Jordan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma`an (Province of Jordan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma`an (Province of Jordan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma`an (Province of Jordan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma`an (Province of Jordan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma`an (Province of Jordan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma`an (Province of Jordan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma`an (Province of Jordan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma`an (Province of Jordan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma`an (Province of Jordan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ma`an (Province of Jordan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma`an (Province of Jordan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma`an (Province of Jordan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma`an (Province of Jordan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma`an (Province of Jordan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma`an (Province of Jordan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma`an (Province of Jordan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Macau (Special Administrative Region of China)": [
            {
                "Region Name": "Macau (Special Administrative Region of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau (Special Administrative Region of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau (Special Administrative Region of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau (Special Administrative Region of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau (Special Administrative Region of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau (Special Administrative Region of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau (Special Administrative Region of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau (Special Administrative Region of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau (Special Administrative Region of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau (Special Administrative Region of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau (Special Administrative Region of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau (Special Administrative Region of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau (Special Administrative Region of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau (Special Administrative Region of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau (Special Administrative Region of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau (Special Administrative Region of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau (Special Administrative Region of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau (Special Administrative Region of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau (Special Administrative Region of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau (Special Administrative Region of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau (Special Administrative Region of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Macau (Special Administrative Region of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Maccarthy Island (Division of Gambia)": [
            {
                "Region Name": "Maccarthy Island (Division of Gambia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Maccarthy Island (Division of Gambia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Maccarthy Island (Division of Gambia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Maccarthy Island (Division of Gambia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Maccarthy Island (Division of Gambia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Maccarthy Island (Division of Gambia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Maccarthy Island (Division of Gambia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Maccarthy Island (Division of Gambia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Maccarthy Island (Division of Gambia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Maccarthy Island (Division of Gambia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Maccarthy Island (Division of Gambia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Maccarthy Island (Division of Gambia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Maccarthy Island (Division of Gambia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Maccarthy Island (Division of Gambia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Maccarthy Island (Division of Gambia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Maccarthy Island (Division of Gambia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Maccarthy Island (Division of Gambia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Maccarthy Island (Division of Gambia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Maccarthy Island (Division of Gambia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Maccarthy Island (Division of Gambia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Maccarthy Island (Division of Gambia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Maccarthy Island (Division of Gambia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "Macedonia and Thrace (Decentralized administration of Greece)": [
            {
                "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Macedonia and Thrace (Decentralized administration of Greece)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 402
            }
        ],
        "Machakos (County of Kenya)": [
            {
                "Region Name": "Machakos (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Machakos (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Machakos (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Machakos (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Machakos (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Machakos (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Machakos (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Machakos (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Machakos (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Machakos (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Machakos (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Machakos (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Machakos (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Machakos (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Machakos (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Machakos (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Machakos (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Machakos (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Machakos (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Machakos (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Machakos (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Machakos (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Machinga (District of Malawi)": [
            {
                "Region Name": "Machinga (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Machinga (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Machinga (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Machinga (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Machinga (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Machinga (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Machinga (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Machinga (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Machinga (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Machinga (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Machinga (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Machinga (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Machinga (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Machinga (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Machinga (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Machinga (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Machinga (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Machinga (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Machinga (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Machinga (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Machinga (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Machinga (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Ma\u010Dvanski (District of Serbia)": [
            {
                "Region Name": "Ma\u010Dvanski (District of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u010Dvanski (District of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u010Dvanski (District of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u010Dvanski (District of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u010Dvanski (District of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u010Dvanski (District of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ma\u010Dvanski (District of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u010Dvanski (District of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u010Dvanski (District of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ma\u010Dvanski (District of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u010Dvanski (District of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u010Dvanski (District of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u010Dvanski (District of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u010Dvanski (District of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u010Dvanski (District of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u010Dvanski (District of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u010Dvanski (District of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u010Dvanski (District of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u010Dvanski (District of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u010Dvanski (District of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u010Dvanski (District of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u010Dvanski (District of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Madaba (Province of Jordan)": [
            {
                "Region Name": "Madaba (Province of Jordan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madaba (Province of Jordan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madaba (Province of Jordan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madaba (Province of Jordan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madaba (Province of Jordan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madaba (Province of Jordan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madaba (Province of Jordan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madaba (Province of Jordan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madaba (Province of Jordan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madaba (Province of Jordan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madaba (Province of Jordan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madaba (Province of Jordan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madaba (Province of Jordan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madaba (Province of Jordan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madaba (Province of Jordan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madaba (Province of Jordan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madaba (Province of Jordan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madaba (Province of Jordan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madaba (Province of Jordan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madaba (Province of Jordan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madaba (Province of Jordan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madaba (Province of Jordan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Madang (Province of Papua New Guinea)": [
            {
                "Region Name": "Madang (Province of Papua New Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Madang (Province of Papua New Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Madang (Province of Papua New Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Madang (Province of Papua New Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Madang (Province of Papua New Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Madang (Province of Papua New Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Madang (Province of Papua New Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Madang (Province of Papua New Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Madang (Province of Papua New Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Madang (Province of Papua New Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Madang (Province of Papua New Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Madang (Province of Papua New Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Madang (Province of Papua New Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Madang (Province of Papua New Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Madang (Province of Papua New Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Madang (Province of Papua New Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Madang (Province of Papua New Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Madang (Province of Papua New Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Madang (Province of Papua New Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Madang (Province of Papua New Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Madang (Province of Papua New Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Madang (Province of Papua New Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Madeira ('Autonomous Region' of Portugal)": [
            {
                "Region Name": "Madeira ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madeira ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Madeira ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madeira ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madeira ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Madeira ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madeira ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madeira ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madeira ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 63
            },
            {
                "Region Name": "Madeira ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madeira ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Madeira ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Madeira ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madeira ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madeira ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Madeira ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Madeira ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madeira ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Madeira ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madeira ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madeira ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madeira ('Autonomous Region' of Portugal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 35
            }
        ],
        "Madhya Pradesh (State of India)": [
            {
                "Region Name": "Madhya Pradesh (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Madhya Pradesh (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Madhya Pradesh (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Madhya Pradesh (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Madhya Pradesh (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Madhya Pradesh (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Madhya Pradesh (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Madhya Pradesh (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Madhya Pradesh (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Madhya Pradesh (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Madhya Pradesh (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Madhya Pradesh (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Madhya Pradesh (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Madhya Pradesh (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Madhya Pradesh (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Madhya Pradesh (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Madhya Pradesh (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Madhya Pradesh (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Madhya Pradesh (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Madhya Pradesh (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Madhya Pradesh (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Madhya Pradesh (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Madinat ash Shamal (Municipality of Qatar)": [
            {
                "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madinat ash Shamal (Municipality of Qatar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Madre de Dios (Region of Peru)": [
            {
                "Region Name": "Madre de Dios (Region of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Madre de Dios (Region of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Madre de Dios (Region of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Madre de Dios (Region of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Madre de Dios (Region of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Madre de Dios (Region of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Madre de Dios (Region of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Madre de Dios (Region of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Madre de Dios (Region of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Madre de Dios (Region of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Madre de Dios (Region of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Madre de Dios (Region of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Madre de Dios (Region of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Madre de Dios (Region of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Madre de Dios (Region of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Madre de Dios (Region of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Madre de Dios (Region of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Madre de Dios (Region of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Madre de Dios (Region of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Madre de Dios (Region of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Madre de Dios (Region of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Madre de Dios (Region of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Madriz (Department of Nicaragua)": [
            {
                "Region Name": "Madriz (Department of Nicaragua)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Madriz (Department of Nicaragua)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madriz (Department of Nicaragua)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Madriz (Department of Nicaragua)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Madriz (Department of Nicaragua)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Madriz (Department of Nicaragua)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madriz (Department of Nicaragua)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madriz (Department of Nicaragua)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Madriz (Department of Nicaragua)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madriz (Department of Nicaragua)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madriz (Department of Nicaragua)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madriz (Department of Nicaragua)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Madriz (Department of Nicaragua)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Madriz (Department of Nicaragua)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madriz (Department of Nicaragua)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madriz (Department of Nicaragua)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madriz (Department of Nicaragua)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Madriz (Department of Nicaragua)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Madriz (Department of Nicaragua)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Madriz (Department of Nicaragua)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madriz (Department of Nicaragua)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Madriz (Department of Nicaragua)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Mae Hong Son (Province of Thailand)": [
            {
                "Region Name": "Mae Hong Son (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mae Hong Son (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mae Hong Son (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mae Hong Son (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mae Hong Son (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Mae Hong Son (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mae Hong Son (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mae Hong Son (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mae Hong Son (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mae Hong Son (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Mae Hong Son (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mae Hong Son (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mae Hong Son (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Mae Hong Son (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mae Hong Son (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mae Hong Son (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mae Hong Son (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mae Hong Son (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mae Hong Son (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mae Hong Son (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mae Hong Son (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mae Hong Son (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Maekel (Region of Eritrea)": [
            {
                "Region Name": "Maekel (Region of Eritrea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maekel (Region of Eritrea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maekel (Region of Eritrea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maekel (Region of Eritrea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maekel (Region of Eritrea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maekel (Region of Eritrea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maekel (Region of Eritrea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maekel (Region of Eritrea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maekel (Region of Eritrea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maekel (Region of Eritrea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maekel (Region of Eritrea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maekel (Region of Eritrea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maekel (Region of Eritrea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maekel (Region of Eritrea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maekel (Region of Eritrea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maekel (Region of Eritrea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maekel (Region of Eritrea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maekel (Region of Eritrea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maekel (Region of Eritrea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maekel (Region of Eritrea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maekel (Region of Eritrea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maekel (Region of Eritrea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mafeteng (District of Lesotho)": [
            {
                "Region Name": "Mafeteng (District of Lesotho)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafeteng (District of Lesotho)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mafeteng (District of Lesotho)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafeteng (District of Lesotho)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafeteng (District of Lesotho)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mafeteng (District of Lesotho)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mafeteng (District of Lesotho)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafeteng (District of Lesotho)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mafeteng (District of Lesotho)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mafeteng (District of Lesotho)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafeteng (District of Lesotho)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafeteng (District of Lesotho)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mafeteng (District of Lesotho)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mafeteng (District of Lesotho)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mafeteng (District of Lesotho)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafeteng (District of Lesotho)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafeteng (District of Lesotho)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafeteng (District of Lesotho)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mafeteng (District of Lesotho)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafeteng (District of Lesotho)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mafeteng (District of Lesotho)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafeteng (District of Lesotho)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Mafraq (Province of Jordan)": [
            {
                "Region Name": "Mafraq (Province of Jordan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafraq (Province of Jordan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafraq (Province of Jordan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafraq (Province of Jordan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mafraq (Province of Jordan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafraq (Province of Jordan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafraq (Province of Jordan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafraq (Province of Jordan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafraq (Province of Jordan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafraq (Province of Jordan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafraq (Province of Jordan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafraq (Province of Jordan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafraq (Province of Jordan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafraq (Province of Jordan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafraq (Province of Jordan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafraq (Province of Jordan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mafraq (Province of Jordan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafraq (Province of Jordan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafraq (Province of Jordan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafraq (Province of Jordan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafraq (Province of Jordan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mafraq (Province of Jordan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Magadan (Region of Russia)": [
            {
                "Region Name": "Magadan (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Magadan (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Magadan (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Magadan (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Magadan (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Magadan (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Magadan (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Magadan (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Magadan (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Magadan (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Magadan (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Magadan (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Magadan (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Magadan (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Magadan (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Magadan (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Magadan (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Magadan (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Magadan (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Magadan (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Magadan (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Magadan (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 16
            }
        ],
        "Magallanes y Ant\xe1rtica Chilena (Region of Chile)": [
            {
                "Region Name": "Magallanes y Ant\xe1rtica Chilena (Region of Chile)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Magallanes y Ant\xe1rtica Chilena (Region of Chile)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Magallanes y Ant\xe1rtica Chilena (Region of Chile)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Magallanes y Ant\xe1rtica Chilena (Region of Chile)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Magallanes y Ant\xe1rtica Chilena (Region of Chile)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Magallanes y Ant\xe1rtica Chilena (Region of Chile)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Magallanes y Ant\xe1rtica Chilena (Region of Chile)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Magallanes y Ant\xe1rtica Chilena (Region of Chile)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Magallanes y Ant\xe1rtica Chilena (Region of Chile)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Magallanes y Ant\xe1rtica Chilena (Region of Chile)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 120
            },
            {
                "Region Name": "Magallanes y Ant\xe1rtica Chilena (Region of Chile)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Magallanes y Ant\xe1rtica Chilena (Region of Chile)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Magallanes y Ant\xe1rtica Chilena (Region of Chile)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Magallanes y Ant\xe1rtica Chilena (Region of Chile)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Magallanes y Ant\xe1rtica Chilena (Region of Chile)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Magallanes y Ant\xe1rtica Chilena (Region of Chile)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Magallanes y Ant\xe1rtica Chilena (Region of Chile)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Magallanes y Ant\xe1rtica Chilena (Region of Chile)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Magallanes y Ant\xe1rtica Chilena (Region of Chile)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Magallanes y Ant\xe1rtica Chilena (Region of Chile)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Magallanes y Ant\xe1rtica Chilena (Region of Chile)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Magallanes y Ant\xe1rtica Chilena (Region of Chile)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Magdalena (Department of Colombia)": [
            {
                "Region Name": "Magdalena (Department of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Magdalena (Department of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Magdalena (Department of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Magdalena (Department of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Magdalena (Department of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Magdalena (Department of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Magdalena (Department of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Magdalena (Department of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Magdalena (Department of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Magdalena (Department of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Magdalena (Department of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Magdalena (Department of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Magdalena (Department of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Magdalena (Department of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Magdalena (Department of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Magdalena (Department of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Magdalena (Department of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Magdalena (Department of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Magdalena (Department of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Magdalena (Department of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Magdalena (Department of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Magdalena (Department of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Maguindanao (Province of Philippines)": [
            {
                "Region Name": "Maguindanao (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maguindanao (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maguindanao (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maguindanao (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maguindanao (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maguindanao (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maguindanao (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maguindanao (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maguindanao (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maguindanao (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maguindanao (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maguindanao (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maguindanao (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maguindanao (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maguindanao (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Maguindanao (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maguindanao (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maguindanao (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maguindanao (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maguindanao (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maguindanao (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maguindanao (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Magway (Division of Myanmar)": [
            {
                "Region Name": "Magway (Division of Myanmar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Magway (Division of Myanmar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Magway (Division of Myanmar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Magway (Division of Myanmar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Magway (Division of Myanmar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Magway (Division of Myanmar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Magway (Division of Myanmar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Magway (Division of Myanmar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Magway (Division of Myanmar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Magway (Division of Myanmar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Magway (Division of Myanmar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Magway (Division of Myanmar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Magway (Division of Myanmar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Magway (Division of Myanmar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Magway (Division of Myanmar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Magway (Division of Myanmar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Magway (Division of Myanmar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Magway (Division of Myanmar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Magway (Division of Myanmar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Magway (Division of Myanmar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Magway (Division of Myanmar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Magway (Division of Myanmar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Maha Sarakham (Province of Thailand)": [
            {
                "Region Name": "Maha Sarakham (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maha Sarakham (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Maha Sarakham (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maha Sarakham (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Maha Sarakham (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maha Sarakham (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maha Sarakham (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maha Sarakham (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maha Sarakham (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maha Sarakham (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maha Sarakham (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maha Sarakham (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Maha Sarakham (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maha Sarakham (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maha Sarakham (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maha Sarakham (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maha Sarakham (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Maha Sarakham (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Maha Sarakham (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maha Sarakham (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maha Sarakham (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maha Sarakham (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Mahaica-Berbice (Region of Guyana)": [
            {
                "Region Name": "Mahaica-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mahaica-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mahaica-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mahaica-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mahaica-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mahaica-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mahaica-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mahaica-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mahaica-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mahaica-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mahaica-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mahaica-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mahaica-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mahaica-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mahaica-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mahaica-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mahaica-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mahaica-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mahaica-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mahaica-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mahaica-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mahaica-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Mahajanga (NA of Madagascar)": [
            {
                "Region Name": "Mahajanga (NA of Madagascar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mahajanga (NA of Madagascar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mahajanga (NA of Madagascar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mahajanga (NA of Madagascar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mahajanga (NA of Madagascar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mahajanga (NA of Madagascar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mahajanga (NA of Madagascar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mahajanga (NA of Madagascar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mahajanga (NA of Madagascar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mahajanga (NA of Madagascar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mahajanga (NA of Madagascar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mahajanga (NA of Madagascar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mahajanga (NA of Madagascar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mahajanga (NA of Madagascar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mahajanga (NA of Madagascar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mahajanga (NA of Madagascar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mahajanga (NA of Madagascar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mahajanga (NA of Madagascar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mahajanga (NA of Madagascar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mahajanga (NA of Madagascar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mahajanga (NA of Madagascar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mahajanga (NA of Madagascar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Maharashtra (State of India)": [
            {
                "Region Name": "Maharashtra (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Maharashtra (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Maharashtra (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Maharashtra (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Maharashtra (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Maharashtra (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Maharashtra (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Maharashtra (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Maharashtra (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Maharashtra (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Maharashtra (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Maharashtra (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Maharashtra (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Maharashtra (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Maharashtra (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Maharashtra (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Maharashtra (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Maharashtra (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Maharashtra (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Maharashtra (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Maharashtra (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Maharashtra (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Mahdia (Governorate of Tunisia)": [
            {
                "Region Name": "Mahdia (Governorate of Tunisia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mahdia (Governorate of Tunisia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mahdia (Governorate of Tunisia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mahdia (Governorate of Tunisia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mahdia (Governorate of Tunisia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mahdia (Governorate of Tunisia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mahdia (Governorate of Tunisia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mahdia (Governorate of Tunisia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mahdia (Governorate of Tunisia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mahdia (Governorate of Tunisia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mahdia (Governorate of Tunisia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mahdia (Governorate of Tunisia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mahdia (Governorate of Tunisia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mahdia (Governorate of Tunisia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mahdia (Governorate of Tunisia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mahdia (Governorate of Tunisia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mahdia (Governorate of Tunisia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mahdia (Governorate of Tunisia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mahdia (Governorate of Tunisia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mahdia (Governorate of Tunisia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mahdia (Governorate of Tunisia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mahdia (Governorate of Tunisia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mai-Ndombe (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mai-Ndombe (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Maine (State of United States)": [
            {
                "Region Name": "Maine (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maine (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maine (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maine (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maine (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maine (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maine (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maine (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Maine (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maine (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maine (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maine (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maine (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maine (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maine (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maine (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maine (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maine (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maine (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maine (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maine (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maine (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Maio (County of Cabo Verde)": [
            {
                "Region Name": "Maio (County of Cabo Verde)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maio (County of Cabo Verde)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maio (County of Cabo Verde)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maio (County of Cabo Verde)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maio (County of Cabo Verde)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maio (County of Cabo Verde)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maio (County of Cabo Verde)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maio (County of Cabo Verde)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maio (County of Cabo Verde)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maio (County of Cabo Verde)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maio (County of Cabo Verde)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maio (County of Cabo Verde)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maio (County of Cabo Verde)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maio (County of Cabo Verde)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maio (County of Cabo Verde)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maio (County of Cabo Verde)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maio (County of Cabo Verde)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maio (County of Cabo Verde)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maio (County of Cabo Verde)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maio (County of Cabo Verde)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maio (County of Cabo Verde)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maio (County of Cabo Verde)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Majuro (Atol of Marshall Islands)": [
            {
                "Region Name": "Majuro (Atol of Marshall Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Majuro (Atol of Marshall Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Majuro (Atol of Marshall Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Majuro (Atol of Marshall Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Majuro (Atol of Marshall Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Majuro (Atol of Marshall Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Majuro (Atol of Marshall Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Majuro (Atol of Marshall Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Majuro (Atol of Marshall Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Majuro (Atol of Marshall Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Majuro (Atol of Marshall Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Majuro (Atol of Marshall Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Majuro (Atol of Marshall Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Majuro (Atol of Marshall Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Majuro (Atol of Marshall Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Majuro (Atol of Marshall Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Majuro (Atol of Marshall Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Majuro (Atol of Marshall Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Majuro (Atol of Marshall Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Majuro (Atol of Marshall Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Majuro (Atol of Marshall Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Majuro (Atol of Marshall Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Makamba (Province of Burundi)": [
            {
                "Region Name": "Makamba (Province of Burundi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Makamba (Province of Burundi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Makamba (Province of Burundi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Makamba (Province of Burundi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Makamba (Province of Burundi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Makamba (Province of Burundi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makamba (Province of Burundi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Makamba (Province of Burundi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Makamba (Province of Burundi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Makamba (Province of Burundi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Makamba (Province of Burundi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makamba (Province of Burundi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Makamba (Province of Burundi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Makamba (Province of Burundi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Makamba (Province of Burundi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Makamba (Province of Burundi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Makamba (Province of Burundi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Makamba (Province of Burundi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Makamba (Province of Burundi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Makamba (Province of Burundi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makamba (Province of Burundi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Makamba (Province of Burundi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Makedonska Kamenica (Municipality of North Macedonia)": [
            {
                "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonska Kamenica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Makedonski Brod (Municipality of North Macedonia)": [
            {
                "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Makedonski Brod (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Makira Ulawa (Province of Solomon Islands)": [
            {
                "Region Name": "Makira Ulawa (Province of Solomon Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makira Ulawa (Province of Solomon Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makira Ulawa (Province of Solomon Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makira Ulawa (Province of Solomon Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makira Ulawa (Province of Solomon Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makira Ulawa (Province of Solomon Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makira Ulawa (Province of Solomon Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makira Ulawa (Province of Solomon Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makira Ulawa (Province of Solomon Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makira Ulawa (Province of Solomon Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makira Ulawa (Province of Solomon Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makira Ulawa (Province of Solomon Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makira Ulawa (Province of Solomon Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makira Ulawa (Province of Solomon Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makira Ulawa (Province of Solomon Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makira Ulawa (Province of Solomon Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makira Ulawa (Province of Solomon Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makira Ulawa (Province of Solomon Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makira Ulawa (Province of Solomon Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makira Ulawa (Province of Solomon Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makira Ulawa (Province of Solomon Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makira Ulawa (Province of Solomon Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Makkah (Province of Saudi Arabia)": [
            {
                "Region Name": "Makkah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Makkah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Makkah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Makkah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Makkah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makkah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Makkah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makkah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Makkah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Makkah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makkah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Makkah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makkah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makkah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makkah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Makkah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makkah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makkah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makkah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Makkah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Makkah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Makkah (Province of Saudi Arabia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Makueni (County of Kenya)": [
            {
                "Region Name": "Makueni (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Makueni (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Makueni (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Makueni (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Makueni (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Makueni (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Makueni (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Makueni (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Makueni (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Makueni (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Makueni (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Makueni (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Makueni (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Makueni (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Makueni (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Makueni (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Makueni (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Makueni (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Makueni (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Makueni (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Makueni (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Makueni (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Malaita (Province of Solomon Islands)": [
            {
                "Region Name": "Malaita (Province of Solomon Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malaita (Province of Solomon Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malaita (Province of Solomon Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malaita (Province of Solomon Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malaita (Province of Solomon Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malaita (Province of Solomon Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malaita (Province of Solomon Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malaita (Province of Solomon Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malaita (Province of Solomon Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malaita (Province of Solomon Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malaita (Province of Solomon Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malaita (Province of Solomon Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malaita (Province of Solomon Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malaita (Province of Solomon Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malaita (Province of Solomon Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malaita (Province of Solomon Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malaita (Province of Solomon Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malaita (Province of Solomon Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malaita (Province of Solomon Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malaita (Province of Solomon Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malaita (Province of Solomon Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malaita (Province of Solomon Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Malampa (Province of Vanuatu)": [
            {
                "Region Name": "Malampa (Province of Vanuatu)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malampa (Province of Vanuatu)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Malampa (Province of Vanuatu)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malampa (Province of Vanuatu)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Malampa (Province of Vanuatu)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malampa (Province of Vanuatu)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malampa (Province of Vanuatu)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malampa (Province of Vanuatu)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malampa (Province of Vanuatu)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malampa (Province of Vanuatu)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malampa (Province of Vanuatu)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malampa (Province of Vanuatu)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malampa (Province of Vanuatu)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malampa (Province of Vanuatu)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Malampa (Province of Vanuatu)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malampa (Province of Vanuatu)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Malampa (Province of Vanuatu)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malampa (Province of Vanuatu)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malampa (Province of Vanuatu)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malampa (Province of Vanuatu)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malampa (Province of Vanuatu)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malampa (Province of Vanuatu)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Malanje (Province of Angola)": [
            {
                "Region Name": "Malanje (Province of Angola)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Malanje (Province of Angola)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Malanje (Province of Angola)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Malanje (Province of Angola)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Malanje (Province of Angola)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Malanje (Province of Angola)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Malanje (Province of Angola)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Malanje (Province of Angola)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Malanje (Province of Angola)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Malanje (Province of Angola)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Malanje (Province of Angola)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Malanje (Province of Angola)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Malanje (Province of Angola)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Malanje (Province of Angola)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Malanje (Province of Angola)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Malanje (Province of Angola)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Malanje (Province of Angola)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Malanje (Province of Angola)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Malanje (Province of Angola)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Malanje (Province of Angola)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Malanje (Province of Angola)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Malanje (Province of Angola)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Malatya (Province of Turkey)": [
            {
                "Region Name": "Malatya (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malatya (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Malatya (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Malatya (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Malatya (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Malatya (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malatya (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malatya (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malatya (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Malatya (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Malatya (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malatya (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malatya (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Malatya (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Malatya (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Malatya (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malatya (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malatya (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Malatya (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malatya (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malatya (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malatya (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Maldonado (Department of Uruguay)": [
            {
                "Region Name": "Maldonado (Department of Uruguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maldonado (Department of Uruguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldonado (Department of Uruguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Maldonado (Department of Uruguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldonado (Department of Uruguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maldonado (Department of Uruguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldonado (Department of Uruguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maldonado (Department of Uruguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldonado (Department of Uruguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maldonado (Department of Uruguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maldonado (Department of Uruguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maldonado (Department of Uruguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maldonado (Department of Uruguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maldonado (Department of Uruguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maldonado (Department of Uruguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldonado (Department of Uruguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maldonado (Department of Uruguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maldonado (Department of Uruguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maldonado (Department of Uruguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maldonado (Department of Uruguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maldonado (Department of Uruguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maldonado (Department of Uruguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Malew (Parish District of Isle of Man)": [
            {
                "Region Name": "Malew (Parish District of Isle of Man)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malew (Parish District of Isle of Man)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malew (Parish District of Isle of Man)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malew (Parish District of Isle of Man)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malew (Parish District of Isle of Man)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malew (Parish District of Isle of Man)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malew (Parish District of Isle of Man)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malew (Parish District of Isle of Man)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malew (Parish District of Isle of Man)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malew (Parish District of Isle of Man)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malew (Parish District of Isle of Man)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malew (Parish District of Isle of Man)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malew (Parish District of Isle of Man)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malew (Parish District of Isle of Man)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malew (Parish District of Isle of Man)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malew (Parish District of Isle of Man)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malew (Parish District of Isle of Man)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malew (Parish District of Isle of Man)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malew (Parish District of Isle of Man)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malew (Parish District of Isle of Man)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malew (Parish District of Isle of Man)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Malew (Parish District of Isle of Man)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Maloelap (Atol of Marshall Islands)": [
            {
                "Region Name": "Maloelap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maloelap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maloelap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maloelap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maloelap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maloelap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maloelap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maloelap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maloelap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maloelap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maloelap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maloelap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maloelap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maloelap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maloelap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maloelap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maloelap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maloelap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maloelap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maloelap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maloelap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maloelap (Atol of Marshall Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ma\u0142opolskie (Voivodeship of Poland)": [
            {
                "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ma\u0142opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Maluku (Province of Indonesia)": [
            {
                "Region Name": "Maluku (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Maluku (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Maluku (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Maluku (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maluku (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Maluku (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maluku (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Maluku (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Maluku (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maluku (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Maluku (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Maluku (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Maluku (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Maluku (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Maluku (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Maluku (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Maluku (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Maluku (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Maluku (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Maluku (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Maluku (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maluku (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Maluku Utara (Province of Indonesia)": [
            {
                "Region Name": "Maluku Utara (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Maluku Utara (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maluku Utara (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maluku Utara (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maluku Utara (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Maluku Utara (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maluku Utara (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maluku Utara (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maluku Utara (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maluku Utara (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maluku Utara (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maluku Utara (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maluku Utara (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maluku Utara (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Maluku Utara (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maluku Utara (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maluku Utara (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maluku Utara (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Maluku Utara (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maluku Utara (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maluku Utara (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maluku Utara (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mamb\xe9r\xe9-Kad\xe9\xef (Prefecture of Central African Republic)": [
            {
                "Region Name": "Mamb\xe9r\xe9-Kad\xe9\xef (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Mamb\xe9r\xe9-Kad\xe9\xef (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Mamb\xe9r\xe9-Kad\xe9\xef (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Mamb\xe9r\xe9-Kad\xe9\xef (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mamb\xe9r\xe9-Kad\xe9\xef (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Mamb\xe9r\xe9-Kad\xe9\xef (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mamb\xe9r\xe9-Kad\xe9\xef (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mamb\xe9r\xe9-Kad\xe9\xef (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Mamb\xe9r\xe9-Kad\xe9\xef (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Mamb\xe9r\xe9-Kad\xe9\xef (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Mamb\xe9r\xe9-Kad\xe9\xef (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Mamb\xe9r\xe9-Kad\xe9\xef (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mamb\xe9r\xe9-Kad\xe9\xef (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Mamb\xe9r\xe9-Kad\xe9\xef (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Mamb\xe9r\xe9-Kad\xe9\xef (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Mamb\xe9r\xe9-Kad\xe9\xef (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Mamb\xe9r\xe9-Kad\xe9\xef (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Mamb\xe9r\xe9-Kad\xe9\xef (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Mamb\xe9r\xe9-Kad\xe9\xef (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mamb\xe9r\xe9-Kad\xe9\xef (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mamb\xe9r\xe9-Kad\xe9\xef (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mamb\xe9r\xe9-Kad\xe9\xef (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Mamou (Region of Guinea)": [
            {
                "Region Name": "Mamou (Region of Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mamou (Region of Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mamou (Region of Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mamou (Region of Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mamou (Region of Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mamou (Region of Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mamou (Region of Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mamou (Region of Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mamou (Region of Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mamou (Region of Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mamou (Region of Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mamou (Region of Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mamou (Region of Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mamou (Region of Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mamou (Region of Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mamou (Region of Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mamou (Region of Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mamou (Region of Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mamou (Region of Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mamou (Region of Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mamou (Region of Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mamou (Region of Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Mamoudzou (Commune of Mayotte)": [
            {
                "Region Name": "Mamoudzou (Commune of Mayotte)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mamoudzou (Commune of Mayotte)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mamoudzou (Commune of Mayotte)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mamoudzou (Commune of Mayotte)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mamoudzou (Commune of Mayotte)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mamoudzou (Commune of Mayotte)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mamoudzou (Commune of Mayotte)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mamoudzou (Commune of Mayotte)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mamoudzou (Commune of Mayotte)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mamoudzou (Commune of Mayotte)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mamoudzou (Commune of Mayotte)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mamoudzou (Commune of Mayotte)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mamoudzou (Commune of Mayotte)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mamoudzou (Commune of Mayotte)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mamoudzou (Commune of Mayotte)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mamoudzou (Commune of Mayotte)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mamoudzou (Commune of Mayotte)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mamoudzou (Commune of Mayotte)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mamoudzou (Commune of Mayotte)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mamoudzou (Commune of Mayotte)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mamoudzou (Commune of Mayotte)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mamoudzou (Commune of Mayotte)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Manabi (Province of Ecuador)": [
            {
                "Region Name": "Manabi (Province of Ecuador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manabi (Province of Ecuador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Manabi (Province of Ecuador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Manabi (Province of Ecuador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Manabi (Province of Ecuador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Manabi (Province of Ecuador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Manabi (Province of Ecuador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Manabi (Province of Ecuador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Manabi (Province of Ecuador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manabi (Province of Ecuador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Manabi (Province of Ecuador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Manabi (Province of Ecuador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Manabi (Province of Ecuador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Manabi (Province of Ecuador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Manabi (Province of Ecuador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Manabi (Province of Ecuador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Manabi (Province of Ecuador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Manabi (Province of Ecuador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Manabi (Province of Ecuador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Manabi (Province of Ecuador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manabi (Province of Ecuador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Manabi (Province of Ecuador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Managua (Department of Nicaragua)": [
            {
                "Region Name": "Managua (Department of Nicaragua)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Managua (Department of Nicaragua)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Managua (Department of Nicaragua)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Managua (Department of Nicaragua)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Managua (Department of Nicaragua)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Managua (Department of Nicaragua)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Managua (Department of Nicaragua)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Managua (Department of Nicaragua)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Managua (Department of Nicaragua)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Managua (Department of Nicaragua)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Managua (Department of Nicaragua)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Managua (Department of Nicaragua)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Managua (Department of Nicaragua)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Managua (Department of Nicaragua)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Managua (Department of Nicaragua)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Managua (Department of Nicaragua)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Managua (Department of Nicaragua)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Managua (Department of Nicaragua)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Managua (Department of Nicaragua)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Managua (Department of Nicaragua)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Managua (Department of Nicaragua)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Managua (Department of Nicaragua)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Manat\xed (Municipality of Puerto Rico)": [
            {
                "Region Name": "Manat\xed (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manat\xed (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manat\xed (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manat\xed (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manat\xed (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manat\xed (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manat\xed (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manat\xed (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manat\xed (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manat\xed (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manat\xed (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manat\xed (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manat\xed (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manat\xed (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manat\xed (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manat\xed (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manat\xed (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manat\xed (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manat\xed (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manat\xed (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manat\xed (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manat\xed (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Manatuto (District of Timor-Leste)": [
            {
                "Region Name": "Manatuto (District of Timor-Leste)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Manatuto (District of Timor-Leste)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Manatuto (District of Timor-Leste)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Manatuto (District of Timor-Leste)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Manatuto (District of Timor-Leste)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Manatuto (District of Timor-Leste)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Manatuto (District of Timor-Leste)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Manatuto (District of Timor-Leste)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Manatuto (District of Timor-Leste)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manatuto (District of Timor-Leste)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Manatuto (District of Timor-Leste)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Manatuto (District of Timor-Leste)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Manatuto (District of Timor-Leste)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Manatuto (District of Timor-Leste)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Manatuto (District of Timor-Leste)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manatuto (District of Timor-Leste)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Manatuto (District of Timor-Leste)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Manatuto (District of Timor-Leste)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Manatuto (District of Timor-Leste)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Manatuto (District of Timor-Leste)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manatuto (District of Timor-Leste)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manatuto (District of Timor-Leste)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Manawatu-Wanganui (Region of New Zealand)": [
            {
                "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manawatu-Wanganui (Region of New Zealand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Manchester (Parish of Jamaica)": [
            {
                "Region Name": "Manchester (Parish of Jamaica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manchester (Parish of Jamaica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manchester (Parish of Jamaica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Manchester (Parish of Jamaica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Manchester (Parish of Jamaica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manchester (Parish of Jamaica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manchester (Parish of Jamaica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manchester (Parish of Jamaica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manchester (Parish of Jamaica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manchester (Parish of Jamaica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manchester (Parish of Jamaica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manchester (Parish of Jamaica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manchester (Parish of Jamaica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Manchester (Parish of Jamaica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manchester (Parish of Jamaica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manchester (Parish of Jamaica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manchester (Parish of Jamaica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manchester (Parish of Jamaica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manchester (Parish of Jamaica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manchester (Parish of Jamaica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manchester (Parish of Jamaica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manchester (Parish of Jamaica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mandalay (Division of Myanmar)": [
            {
                "Region Name": "Mandalay (Division of Myanmar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Mandalay (Division of Myanmar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mandalay (Division of Myanmar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mandalay (Division of Myanmar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mandalay (Division of Myanmar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mandalay (Division of Myanmar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mandalay (Division of Myanmar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mandalay (Division of Myanmar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mandalay (Division of Myanmar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mandalay (Division of Myanmar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mandalay (Division of Myanmar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mandalay (Division of Myanmar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mandalay (Division of Myanmar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mandalay (Division of Myanmar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mandalay (Division of Myanmar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mandalay (Division of Myanmar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mandalay (Division of Myanmar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mandalay (Division of Myanmar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mandalay (Division of Myanmar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mandalay (Division of Myanmar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mandalay (Division of Myanmar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mandalay (Division of Myanmar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Mandera (County of Kenya)": [
            {
                "Region Name": "Mandera (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mandera (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mandera (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mandera (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mandera (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mandera (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mandera (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mandera (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mandera (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mandera (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mandera (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Mandera (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Mandera (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mandera (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mandera (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mandera (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mandera (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mandera (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mandera (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mandera (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mandera (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mandera (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Mandoul (Region of Chad)": [
            {
                "Region Name": "Mandoul (Region of Chad)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Mandoul (Region of Chad)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Mandoul (Region of Chad)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Mandoul (Region of Chad)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Mandoul (Region of Chad)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Mandoul (Region of Chad)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Mandoul (Region of Chad)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mandoul (Region of Chad)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Mandoul (Region of Chad)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Mandoul (Region of Chad)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Mandoul (Region of Chad)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Mandoul (Region of Chad)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Mandoul (Region of Chad)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mandoul (Region of Chad)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Mandoul (Region of Chad)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Mandoul (Region of Chad)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Mandoul (Region of Chad)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Mandoul (Region of Chad)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Mandoul (Region of Chad)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mandoul (Region of Chad)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mandoul (Region of Chad)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mandoul (Region of Chad)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Mangaia (Island Council of Cook Islands)": [
            {
                "Region Name": "Mangaia (Island Council of Cook Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangaia (Island Council of Cook Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangaia (Island Council of Cook Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangaia (Island Council of Cook Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangaia (Island Council of Cook Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangaia (Island Council of Cook Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangaia (Island Council of Cook Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangaia (Island Council of Cook Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangaia (Island Council of Cook Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangaia (Island Council of Cook Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangaia (Island Council of Cook Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangaia (Island Council of Cook Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangaia (Island Council of Cook Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangaia (Island Council of Cook Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangaia (Island Council of Cook Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangaia (Island Council of Cook Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangaia (Island Council of Cook Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangaia (Island Council of Cook Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangaia (Island Council of Cook Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangaia (Island Council of Cook Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangaia (Island Council of Cook Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangaia (Island Council of Cook Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mangghystau (Region of Kazakhstan)": [
            {
                "Region Name": "Mangghystau (Region of Kazakhstan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mangghystau (Region of Kazakhstan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mangghystau (Region of Kazakhstan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mangghystau (Region of Kazakhstan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 93
            },
            {
                "Region Name": "Mangghystau (Region of Kazakhstan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Mangghystau (Region of Kazakhstan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 212
            },
            {
                "Region Name": "Mangghystau (Region of Kazakhstan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mangghystau (Region of Kazakhstan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Mangghystau (Region of Kazakhstan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 85
            },
            {
                "Region Name": "Mangghystau (Region of Kazakhstan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangghystau (Region of Kazakhstan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mangghystau (Region of Kazakhstan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mangghystau (Region of Kazakhstan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangghystau (Region of Kazakhstan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangghystau (Region of Kazakhstan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Mangghystau (Region of Kazakhstan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mangghystau (Region of Kazakhstan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "Mangghystau (Region of Kazakhstan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangghystau (Region of Kazakhstan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Mangghystau (Region of Kazakhstan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangghystau (Region of Kazakhstan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangghystau (Region of Kazakhstan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Mangilao (Municipality of Guam)": [
            {
                "Region Name": "Mangilao (Municipality of Guam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangilao (Municipality of Guam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangilao (Municipality of Guam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangilao (Municipality of Guam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangilao (Municipality of Guam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangilao (Municipality of Guam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangilao (Municipality of Guam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangilao (Municipality of Guam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangilao (Municipality of Guam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangilao (Municipality of Guam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangilao (Municipality of Guam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangilao (Municipality of Guam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangilao (Municipality of Guam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangilao (Municipality of Guam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangilao (Municipality of Guam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangilao (Municipality of Guam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangilao (Municipality of Guam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangilao (Municipality of Guam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangilao (Municipality of Guam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangilao (Municipality of Guam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangilao (Municipality of Guam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangilao (Municipality of Guam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mangochi (District of Malawi)": [
            {
                "Region Name": "Mangochi (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mangochi (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mangochi (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mangochi (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mangochi (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mangochi (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mangochi (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mangochi (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mangochi (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mangochi (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mangochi (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mangochi (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mangochi (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mangochi (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mangochi (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mangochi (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mangochi (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mangochi (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mangochi (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mangochi (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mangochi (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mangochi (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Mangrove Cay (District of Bahamas)": [
            {
                "Region Name": "Mangrove Cay (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangrove Cay (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangrove Cay (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mangrove Cay (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangrove Cay (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangrove Cay (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangrove Cay (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mangrove Cay (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mangrove Cay (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangrove Cay (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Mangrove Cay (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangrove Cay (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangrove Cay (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangrove Cay (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangrove Cay (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mangrove Cay (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangrove Cay (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangrove Cay (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangrove Cay (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangrove Cay (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangrove Cay (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mangrove Cay (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Manica (Province of Mozambique)": [
            {
                "Region Name": "Manica (Province of Mozambique)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Manica (Province of Mozambique)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Manica (Province of Mozambique)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Manica (Province of Mozambique)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Manica (Province of Mozambique)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Manica (Province of Mozambique)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Manica (Province of Mozambique)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Manica (Province of Mozambique)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Manica (Province of Mozambique)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Manica (Province of Mozambique)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Manica (Province of Mozambique)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Manica (Province of Mozambique)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Manica (Province of Mozambique)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Manica (Province of Mozambique)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Manica (Province of Mozambique)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Manica (Province of Mozambique)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Manica (Province of Mozambique)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Manica (Province of Mozambique)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Manica (Province of Mozambique)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Manica (Province of Mozambique)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Manica (Province of Mozambique)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Manica (Province of Mozambique)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "Manicaland (Province of Zimbabwe)": [
            {
                "Region Name": "Manicaland (Province of Zimbabwe)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Manicaland (Province of Zimbabwe)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Manicaland (Province of Zimbabwe)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Manicaland (Province of Zimbabwe)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Manicaland (Province of Zimbabwe)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Manicaland (Province of Zimbabwe)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Manicaland (Province of Zimbabwe)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Manicaland (Province of Zimbabwe)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Manicaland (Province of Zimbabwe)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Manicaland (Province of Zimbabwe)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Manicaland (Province of Zimbabwe)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Manicaland (Province of Zimbabwe)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Manicaland (Province of Zimbabwe)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Manicaland (Province of Zimbabwe)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Manicaland (Province of Zimbabwe)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Manicaland (Province of Zimbabwe)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Manicaland (Province of Zimbabwe)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Manicaland (Province of Zimbabwe)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Manicaland (Province of Zimbabwe)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Manicaland (Province of Zimbabwe)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Manicaland (Province of Zimbabwe)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Manicaland (Province of Zimbabwe)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Maniema (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Maniema (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Manihiki (Island Council of Cook Islands)": [
            {
                "Region Name": "Manihiki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manihiki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manihiki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manihiki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manihiki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manihiki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manihiki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manihiki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manihiki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manihiki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manihiki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manihiki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manihiki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manihiki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manihiki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manihiki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manihiki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manihiki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manihiki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manihiki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manihiki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manihiki (Island Council of Cook Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Manipur (State of India)": [
            {
                "Region Name": "Manipur (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Manipur (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Manipur (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Manipur (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Manipur (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Manipur (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Manipur (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Manipur (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Manipur (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Manipur (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Manipur (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Manipur (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Manipur (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Manipur (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Manipur (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Manipur (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Manipur (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Manipur (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Manipur (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Manipur (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Manipur (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Manipur (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Manisa (Province of Turkey)": [
            {
                "Region Name": "Manisa (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manisa (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Manisa (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Manisa (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Manisa (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Manisa (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Manisa (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Manisa (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manisa (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Manisa (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Manisa (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Manisa (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Manisa (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Manisa (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Manisa (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Manisa (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Manisa (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manisa (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Manisa (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Manisa (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Manisa (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manisa (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Manitoba (Province of Canada)": [
            {
                "Region Name": "Manitoba (Province of Canada)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Manitoba (Province of Canada)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Manitoba (Province of Canada)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Manitoba (Province of Canada)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Manitoba (Province of Canada)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Manitoba (Province of Canada)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Manitoba (Province of Canada)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Manitoba (Province of Canada)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Manitoba (Province of Canada)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Manitoba (Province of Canada)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Manitoba (Province of Canada)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Manitoba (Province of Canada)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Manitoba (Province of Canada)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Manitoba (Province of Canada)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Manitoba (Province of Canada)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Manitoba (Province of Canada)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Manitoba (Province of Canada)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Manitoba (Province of Canada)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Manitoba (Province of Canada)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Manitoba (Province of Canada)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "Manitoba (Province of Canada)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 99
            },
            {
                "Region Name": "Manitoba (Province of Canada)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 41
            }
        ],
        "Mannar (District of Sri Lanka)": [
            {
                "Region Name": "Mannar (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mannar (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mannar (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mannar (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mannar (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mannar (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mannar (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mannar (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mannar (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mannar (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mannar (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mannar (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mannar (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mannar (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mannar (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mannar (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mannar (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mannar (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mannar (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mannar (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mannar (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mannar (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Manu'a (District of American Samoa)": [
            {
                "Region Name": "Manu'a (District of American Samoa)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manu'a (District of American Samoa)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manu'a (District of American Samoa)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manu'a (District of American Samoa)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manu'a (District of American Samoa)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manu'a (District of American Samoa)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manu'a (District of American Samoa)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manu'a (District of American Samoa)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manu'a (District of American Samoa)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manu'a (District of American Samoa)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manu'a (District of American Samoa)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manu'a (District of American Samoa)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manu'a (District of American Samoa)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manu'a (District of American Samoa)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manu'a (District of American Samoa)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manu'a (District of American Samoa)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manu'a (District of American Samoa)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manu'a (District of American Samoa)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manu'a (District of American Samoa)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manu'a (District of American Samoa)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manu'a (District of American Samoa)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manu'a (District of American Samoa)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Manubah (Governorate of Tunisia)": [
            {
                "Region Name": "Manubah (Governorate of Tunisia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manubah (Governorate of Tunisia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manubah (Governorate of Tunisia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Manubah (Governorate of Tunisia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manubah (Governorate of Tunisia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manubah (Governorate of Tunisia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manubah (Governorate of Tunisia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manubah (Governorate of Tunisia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manubah (Governorate of Tunisia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manubah (Governorate of Tunisia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manubah (Governorate of Tunisia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Manubah (Governorate of Tunisia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manubah (Governorate of Tunisia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Manubah (Governorate of Tunisia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Manubah (Governorate of Tunisia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manubah (Governorate of Tunisia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manubah (Governorate of Tunisia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manubah (Governorate of Tunisia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manubah (Governorate of Tunisia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manubah (Governorate of Tunisia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manubah (Governorate of Tunisia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manubah (Governorate of Tunisia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Manufahi (District of Timor-Leste)": [
            {
                "Region Name": "Manufahi (District of Timor-Leste)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Manufahi (District of Timor-Leste)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manufahi (District of Timor-Leste)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Manufahi (District of Timor-Leste)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Manufahi (District of Timor-Leste)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Manufahi (District of Timor-Leste)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Manufahi (District of Timor-Leste)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Manufahi (District of Timor-Leste)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Manufahi (District of Timor-Leste)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manufahi (District of Timor-Leste)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Manufahi (District of Timor-Leste)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Manufahi (District of Timor-Leste)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manufahi (District of Timor-Leste)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Manufahi (District of Timor-Leste)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Manufahi (District of Timor-Leste)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Manufahi (District of Timor-Leste)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manufahi (District of Timor-Leste)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Manufahi (District of Timor-Leste)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Manufahi (District of Timor-Leste)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Manufahi (District of Timor-Leste)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manufahi (District of Timor-Leste)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manufahi (District of Timor-Leste)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Manus (Province of Papua New Guinea)": [
            {
                "Region Name": "Manus (Province of Papua New Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manus (Province of Papua New Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manus (Province of Papua New Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manus (Province of Papua New Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manus (Province of Papua New Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Manus (Province of Papua New Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manus (Province of Papua New Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manus (Province of Papua New Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manus (Province of Papua New Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manus (Province of Papua New Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manus (Province of Papua New Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manus (Province of Papua New Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manus (Province of Papua New Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manus (Province of Papua New Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manus (Province of Papua New Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manus (Province of Papua New Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manus (Province of Papua New Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manus (Province of Papua New Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Manus (Province of Papua New Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manus (Province of Papua New Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Manus (Province of Papua New Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Manus (Province of Papua New Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Manyara (Region of Tanzania)": [
            {
                "Region Name": "Manyara (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Manyara (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Manyara (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Manyara (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Manyara (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Manyara (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Manyara (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Manyara (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Manyara (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Manyara (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Manyara (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Manyara (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Manyara (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Manyara (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Manyara (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Manyara (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Manyara (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Manyara (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Manyara (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Manyara (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Manyara (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Manyara (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Manzini (District of Swaziland)": [
            {
                "Region Name": "Manzini (District of Swaziland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Manzini (District of Swaziland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Manzini (District of Swaziland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Manzini (District of Swaziland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Manzini (District of Swaziland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Manzini (District of Swaziland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Manzini (District of Swaziland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Manzini (District of Swaziland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Manzini (District of Swaziland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Manzini (District of Swaziland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Manzini (District of Swaziland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Manzini (District of Swaziland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Manzini (District of Swaziland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Manzini (District of Swaziland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Manzini (District of Swaziland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Manzini (District of Swaziland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Manzini (District of Swaziland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Manzini (District of Swaziland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Manzini (District of Swaziland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Manzini (District of Swaziland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Manzini (District of Swaziland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Manzini (District of Swaziland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Maputo (Province of Mozambique)": [
            {
                "Region Name": "Maputo (Province of Mozambique)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Maputo (Province of Mozambique)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Maputo (Province of Mozambique)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Maputo (Province of Mozambique)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Maputo (Province of Mozambique)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Maputo (Province of Mozambique)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Maputo (Province of Mozambique)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Maputo (Province of Mozambique)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Maputo (Province of Mozambique)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Maputo (Province of Mozambique)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Maputo (Province of Mozambique)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Maputo (Province of Mozambique)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Maputo (Province of Mozambique)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Maputo (Province of Mozambique)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Maputo (Province of Mozambique)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Maputo (Province of Mozambique)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Maputo (Province of Mozambique)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Maputo (Province of Mozambique)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Maputo (Province of Mozambique)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Maputo (Province of Mozambique)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Maputo (Province of Mozambique)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Maputo (Province of Mozambique)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Maputo City (Province of Mozambique)": [
            {
                "Region Name": "Maputo City (Province of Mozambique)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maputo City (Province of Mozambique)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maputo City (Province of Mozambique)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maputo City (Province of Mozambique)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maputo City (Province of Mozambique)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maputo City (Province of Mozambique)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Maputo City (Province of Mozambique)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Maputo City (Province of Mozambique)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Maputo City (Province of Mozambique)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Maputo City (Province of Mozambique)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Maputo City (Province of Mozambique)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Maputo City (Province of Mozambique)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maputo City (Province of Mozambique)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maputo City (Province of Mozambique)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maputo City (Province of Mozambique)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maputo City (Province of Mozambique)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maputo City (Province of Mozambique)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maputo City (Province of Mozambique)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maputo City (Province of Mozambique)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Maputo City (Province of Mozambique)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maputo City (Province of Mozambique)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maputo City (Province of Mozambique)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mara (Region of Tanzania)": [
            {
                "Region Name": "Mara (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Mara (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Mara (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "Mara (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Mara (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Mara (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Mara (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Mara (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Mara (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 67
            },
            {
                "Region Name": "Mara (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Mara (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Mara (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Mara (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Mara (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Mara (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 71
            },
            {
                "Region Name": "Mara (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Mara (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Mara (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Mara (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 64
            },
            {
                "Region Name": "Mara (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 59
            },
            {
                "Region Name": "Mara (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 63
            },
            {
                "Region Name": "Mara (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 88
            }
        ],
        "Maradi (Department of Niger)": [
            {
                "Region Name": "Maradi (Department of Niger)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Maradi (Department of Niger)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 382
            },
            {
                "Region Name": "Maradi (Department of Niger)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maradi (Department of Niger)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Maradi (Department of Niger)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Maradi (Department of Niger)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Maradi (Department of Niger)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Maradi (Department of Niger)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maradi (Department of Niger)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 182
            },
            {
                "Region Name": "Maradi (Department of Niger)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 229
            },
            {
                "Region Name": "Maradi (Department of Niger)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Maradi (Department of Niger)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 95
            },
            {
                "Region Name": "Maradi (Department of Niger)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "Maradi (Department of Niger)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Maradi (Department of Niger)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maradi (Department of Niger)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maradi (Department of Niger)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Maradi (Department of Niger)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 59
            },
            {
                "Region Name": "Maradi (Department of Niger)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Maradi (Department of Niger)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 64
            },
            {
                "Region Name": "Maradi (Department of Niger)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Maradi (Department of Niger)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "Maramure\u0219 (County of Romania)": [
            {
                "Region Name": "Maramure\u0219 (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maramure\u0219 (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maramure\u0219 (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maramure\u0219 (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maramure\u0219 (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maramure\u0219 (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maramure\u0219 (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maramure\u0219 (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Maramure\u0219 (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maramure\u0219 (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maramure\u0219 (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maramure\u0219 (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Maramure\u0219 (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maramure\u0219 (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maramure\u0219 (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maramure\u0219 (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maramure\u0219 (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maramure\u0219 (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maramure\u0219 (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Maramure\u0219 (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maramure\u0219 (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maramure\u0219 (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Maranh\xe3o (State of Brazil)": [
            {
                "Region Name": "Maranh\xe3o (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maranh\xe3o (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Maranh\xe3o (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maranh\xe3o (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Maranh\xe3o (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maranh\xe3o (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Maranh\xe3o (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maranh\xe3o (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Maranh\xe3o (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Maranh\xe3o (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Maranh\xe3o (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Maranh\xe3o (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Maranh\xe3o (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Maranh\xe3o (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Maranh\xe3o (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Maranh\xe3o (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Maranh\xe3o (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Maranh\xe3o (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Maranh\xe3o (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Maranh\xe3o (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Maranh\xe3o (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Maranh\xe3o (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Marche (Region of Italy)": [
            {
                "Region Name": "Marche (Region of Italy)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marche (Region of Italy)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marche (Region of Italy)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marche (Region of Italy)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marche (Region of Italy)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marche (Region of Italy)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Marche (Region of Italy)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marche (Region of Italy)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marche (Region of Italy)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marche (Region of Italy)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marche (Region of Italy)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marche (Region of Italy)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Marche (Region of Italy)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marche (Region of Italy)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marche (Region of Italy)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marche (Region of Italy)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Marche (Region of Italy)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marche (Region of Italy)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marche (Region of Italy)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marche (Region of Italy)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marche (Region of Italy)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marche (Region of Italy)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mardin (Province of Turkey)": [
            {
                "Region Name": "Mardin (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mardin (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mardin (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mardin (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mardin (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mardin (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mardin (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mardin (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Mardin (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mardin (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mardin (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Mardin (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mardin (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mardin (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mardin (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mardin (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mardin (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mardin (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mardin (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mardin (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mardin (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mardin (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Margibi (County of Liberia)": [
            {
                "Region Name": "Margibi (County of Liberia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Margibi (County of Liberia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Margibi (County of Liberia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Margibi (County of Liberia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Margibi (County of Liberia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Margibi (County of Liberia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Margibi (County of Liberia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Margibi (County of Liberia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Margibi (County of Liberia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Margibi (County of Liberia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Margibi (County of Liberia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Margibi (County of Liberia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Margibi (County of Liberia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Margibi (County of Liberia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Margibi (County of Liberia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Margibi (County of Liberia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Margibi (County of Liberia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Margibi (County of Liberia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Margibi (County of Liberia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Margibi (County of Liberia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Margibi (County of Liberia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Margibi (County of Liberia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mar\xeda Trinidad S\xe1nchez (Province of Dominican Republic)": [
            {
                "Region Name": "Mar\xeda Trinidad S\xe1nchez (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mar\xeda Trinidad S\xe1nchez (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mar\xeda Trinidad S\xe1nchez (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mar\xeda Trinidad S\xe1nchez (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mar\xeda Trinidad S\xe1nchez (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mar\xeda Trinidad S\xe1nchez (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mar\xeda Trinidad S\xe1nchez (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mar\xeda Trinidad S\xe1nchez (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mar\xeda Trinidad S\xe1nchez (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mar\xeda Trinidad S\xe1nchez (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mar\xeda Trinidad S\xe1nchez (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mar\xeda Trinidad S\xe1nchez (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mar\xeda Trinidad S\xe1nchez (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mar\xeda Trinidad S\xe1nchez (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mar\xeda Trinidad S\xe1nchez (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mar\xeda Trinidad S\xe1nchez (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mar\xeda Trinidad S\xe1nchez (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mar\xeda Trinidad S\xe1nchez (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mar\xeda Trinidad S\xe1nchez (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mar\xeda Trinidad S\xe1nchez (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mar\xeda Trinidad S\xe1nchez (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mar\xeda Trinidad S\xe1nchez (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Maricao (Municipality of Puerto Rico)": [
            {
                "Region Name": "Maricao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maricao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maricao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maricao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maricao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maricao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maricao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maricao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maricao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maricao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maricao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maricao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maricao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maricao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maricao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maricao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maricao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maricao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maricao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maricao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maricao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maricao (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mariehamn (Sub-Region of \xc5land)": [
            {
                "Region Name": "Mariehamn (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mariehamn (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mariehamn (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mariehamn (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mariehamn (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mariehamn (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mariehamn (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mariehamn (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mariehamn (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mariehamn (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mariehamn (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mariehamn (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mariehamn (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mariehamn (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mariehamn (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mariehamn (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mariehamn (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mariehamn (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mariehamn (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mariehamn (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mariehamn (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mariehamn (Sub-Region of \xc5land)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Marijampoles (County of Lithuania)": [
            {
                "Region Name": "Marijampoles (County of Lithuania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Marijampoles (County of Lithuania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Marijampoles (County of Lithuania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Marijampoles (County of Lithuania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marijampoles (County of Lithuania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marijampoles (County of Lithuania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Marijampoles (County of Lithuania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marijampoles (County of Lithuania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marijampoles (County of Lithuania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marijampoles (County of Lithuania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marijampoles (County of Lithuania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marijampoles (County of Lithuania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marijampoles (County of Lithuania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marijampoles (County of Lithuania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Marijampoles (County of Lithuania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marijampoles (County of Lithuania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marijampoles (County of Lithuania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marijampoles (County of Lithuania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marijampoles (County of Lithuania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Marijampoles (County of Lithuania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marijampoles (County of Lithuania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marijampoles (County of Lithuania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Marinduque (Province of Philippines)": [
            {
                "Region Name": "Marinduque (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Marinduque (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marinduque (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Marinduque (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marinduque (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marinduque (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marinduque (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marinduque (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marinduque (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Marinduque (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marinduque (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marinduque (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Marinduque (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marinduque (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marinduque (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marinduque (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marinduque (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marinduque (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marinduque (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marinduque (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marinduque (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marinduque (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Maritime (Region of Togo)": [
            {
                "Region Name": "Maritime (Region of Togo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Maritime (Region of Togo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Maritime (Region of Togo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 105
            },
            {
                "Region Name": "Maritime (Region of Togo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Maritime (Region of Togo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Maritime (Region of Togo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Maritime (Region of Togo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Maritime (Region of Togo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Maritime (Region of Togo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 79
            },
            {
                "Region Name": "Maritime (Region of Togo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Maritime (Region of Togo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Maritime (Region of Togo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maritime (Region of Togo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Maritime (Region of Togo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Maritime (Region of Togo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Maritime (Region of Togo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Maritime (Region of Togo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Maritime (Region of Togo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Maritime (Region of Togo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Maritime (Region of Togo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Maritime (Region of Togo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Maritime (Region of Togo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Mariy-El (Republic of Russia)": [
            {
                "Region Name": "Mariy-El (Republic of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mariy-El (Republic of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mariy-El (Republic of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mariy-El (Republic of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mariy-El (Republic of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mariy-El (Republic of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mariy-El (Republic of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mariy-El (Republic of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mariy-El (Republic of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 71
            },
            {
                "Region Name": "Mariy-El (Republic of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mariy-El (Republic of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mariy-El (Republic of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mariy-El (Republic of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mariy-El (Republic of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mariy-El (Republic of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mariy-El (Republic of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mariy-El (Republic of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mariy-El (Republic of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mariy-El (Republic of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mariy-El (Republic of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Mariy-El (Republic of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mariy-El (Republic of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Markazi (Province of Iran)": [
            {
                "Region Name": "Markazi (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Markazi (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Markazi (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Markazi (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Markazi (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Markazi (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Markazi (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Markazi (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Markazi (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Markazi (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Markazi (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Markazi (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Markazi (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Markazi (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Markazi (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Markazi (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Markazi (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Markazi (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Markazi (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Markazi (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Markazi (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Markazi (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Marlborough (Region of New Zealand)": [
            {
                "Region Name": "Marlborough (Region of New Zealand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marlborough (Region of New Zealand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marlborough (Region of New Zealand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marlborough (Region of New Zealand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marlborough (Region of New Zealand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marlborough (Region of New Zealand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marlborough (Region of New Zealand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marlborough (Region of New Zealand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marlborough (Region of New Zealand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marlborough (Region of New Zealand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marlborough (Region of New Zealand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marlborough (Region of New Zealand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marlborough (Region of New Zealand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marlborough (Region of New Zealand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marlborough (Region of New Zealand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marlborough (Region of New Zealand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marlborough (Region of New Zealand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marlborough (Region of New Zealand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marlborough (Region of New Zealand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marlborough (Region of New Zealand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marlborough (Region of New Zealand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marlborough (Region of New Zealand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Marowijne (District of Suriname)": [
            {
                "Region Name": "Marowijne (District of Suriname)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marowijne (District of Suriname)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Marowijne (District of Suriname)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Marowijne (District of Suriname)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marowijne (District of Suriname)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marowijne (District of Suriname)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marowijne (District of Suriname)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Marowijne (District of Suriname)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marowijne (District of Suriname)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marowijne (District of Suriname)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marowijne (District of Suriname)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marowijne (District of Suriname)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marowijne (District of Suriname)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marowijne (District of Suriname)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Marowijne (District of Suriname)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marowijne (District of Suriname)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marowijne (District of Suriname)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marowijne (District of Suriname)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Marowijne (District of Suriname)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marowijne (District of Suriname)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marowijne (District of Suriname)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marowijne (District of Suriname)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Marown (Parish District of Isle of Man)": [
            {
                "Region Name": "Marown (Parish District of Isle of Man)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marown (Parish District of Isle of Man)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marown (Parish District of Isle of Man)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marown (Parish District of Isle of Man)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marown (Parish District of Isle of Man)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marown (Parish District of Isle of Man)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marown (Parish District of Isle of Man)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marown (Parish District of Isle of Man)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marown (Parish District of Isle of Man)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marown (Parish District of Isle of Man)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marown (Parish District of Isle of Man)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marown (Parish District of Isle of Man)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marown (Parish District of Isle of Man)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marown (Parish District of Isle of Man)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marown (Parish District of Isle of Man)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marown (Parish District of Isle of Man)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marown (Parish District of Isle of Man)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marown (Parish District of Isle of Man)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marown (Parish District of Isle of Man)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marown (Parish District of Isle of Man)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marown (Parish District of Isle of Man)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marown (Parish District of Isle of Man)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Marrakech - Tensift - Al Haouz (Region of Morocco)": [
            {
                "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Marrakech - Tensift - Al Haouz (Region of Morocco)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Marsabit (County of Kenya)": [
            {
                "Region Name": "Marsabit (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Marsabit (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Marsabit (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Marsabit (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Marsabit (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Marsabit (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Marsabit (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Marsabit (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Marsabit (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Marsabit (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Marsabit (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Marsabit (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Marsabit (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Marsabit (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Marsabit (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Marsabit (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Marsabit (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Marsabit (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Marsabit (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Marsabit (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Marsabit (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Marsabit (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Mary (Province of Turkmenistan)": [
            {
                "Region Name": "Mary (Province of Turkmenistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mary (Province of Turkmenistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 80
            },
            {
                "Region Name": "Mary (Province of Turkmenistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Mary (Province of Turkmenistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Mary (Province of Turkmenistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mary (Province of Turkmenistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 125
            },
            {
                "Region Name": "Mary (Province of Turkmenistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mary (Province of Turkmenistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mary (Province of Turkmenistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 92
            },
            {
                "Region Name": "Mary (Province of Turkmenistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Mary (Province of Turkmenistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Mary (Province of Turkmenistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Mary (Province of Turkmenistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mary (Province of Turkmenistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Mary (Province of Turkmenistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Mary (Province of Turkmenistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mary (Province of Turkmenistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mary (Province of Turkmenistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mary (Province of Turkmenistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Mary (Province of Turkmenistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mary (Province of Turkmenistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mary (Province of Turkmenistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Maryland (County of Liberia)": [
            {
                "Region Name": "Maryland (County of Liberia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (County of Liberia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maryland (County of Liberia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Maryland (County of Liberia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (County of Liberia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (County of Liberia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (County of Liberia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (County of Liberia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maryland (County of Liberia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (County of Liberia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maryland (County of Liberia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Maryland (County of Liberia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (County of Liberia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maryland (County of Liberia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (County of Liberia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (County of Liberia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maryland (County of Liberia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (County of Liberia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (County of Liberia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maryland (County of Liberia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (County of Liberia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (County of Liberia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Maryland (State of United States)": [
            {
                "Region Name": "Maryland (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maryland (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maryland (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Maryland (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maryland (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maryland (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maryland (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maryland (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Maryland (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maryland (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Masaka (District of Uganda)": [
            {
                "Region Name": "Masaka (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Masaka (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Masaka (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Masaka (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Masaka (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Masaka (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Masaka (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Masaka (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Masaka (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Masaka (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Masaka (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Masaka (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Masaka (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Masaka (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Masaka (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Masaka (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Masaka (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Masaka (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Masaka (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Masaka (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Masaka (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Masaka (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Masaya (Department of Nicaragua)": [
            {
                "Region Name": "Masaya (Department of Nicaragua)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Masaya (Department of Nicaragua)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Masaya (Department of Nicaragua)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Masaya (Department of Nicaragua)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Masaya (Department of Nicaragua)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Masaya (Department of Nicaragua)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Masaya (Department of Nicaragua)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Masaya (Department of Nicaragua)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Masaya (Department of Nicaragua)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Masaya (Department of Nicaragua)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Masaya (Department of Nicaragua)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Masaya (Department of Nicaragua)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Masaya (Department of Nicaragua)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Masaya (Department of Nicaragua)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Masaya (Department of Nicaragua)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Masaya (Department of Nicaragua)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Masaya (Department of Nicaragua)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Masaya (Department of Nicaragua)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Masaya (Department of Nicaragua)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Masaya (Department of Nicaragua)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Masaya (Department of Nicaragua)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Masaya (Department of Nicaragua)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Masbate (Province of Philippines)": [
            {
                "Region Name": "Masbate (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Masbate (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Masbate (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Masbate (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Masbate (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Masbate (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Masbate (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Masbate (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Masbate (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Masbate (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Masbate (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Masbate (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Masbate (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Masbate (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Masbate (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Masbate (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Masbate (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Masbate (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Masbate (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Masbate (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Masbate (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Masbate (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Mascara (Province of Algeria)": [
            {
                "Region Name": "Mascara (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mascara (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 97
            },
            {
                "Region Name": "Mascara (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mascara (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mascara (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Mascara (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mascara (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mascara (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mascara (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mascara (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mascara (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mascara (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mascara (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Mascara (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mascara (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mascara (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mascara (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mascara (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mascara (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mascara (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mascara (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mascara (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Maseru (District of Lesotho)": [
            {
                "Region Name": "Maseru (District of Lesotho)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Maseru (District of Lesotho)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Maseru (District of Lesotho)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maseru (District of Lesotho)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Maseru (District of Lesotho)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Maseru (District of Lesotho)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maseru (District of Lesotho)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maseru (District of Lesotho)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maseru (District of Lesotho)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Maseru (District of Lesotho)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maseru (District of Lesotho)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maseru (District of Lesotho)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Maseru (District of Lesotho)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maseru (District of Lesotho)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Maseru (District of Lesotho)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maseru (District of Lesotho)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maseru (District of Lesotho)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Maseru (District of Lesotho)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Maseru (District of Lesotho)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maseru (District of Lesotho)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maseru (District of Lesotho)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Maseru (District of Lesotho)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Mashonaland Central (Province of Zimbabwe)": [
            {
                "Region Name": "Mashonaland Central (Province of Zimbabwe)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mashonaland Central (Province of Zimbabwe)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mashonaland Central (Province of Zimbabwe)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mashonaland Central (Province of Zimbabwe)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mashonaland Central (Province of Zimbabwe)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mashonaland Central (Province of Zimbabwe)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mashonaland Central (Province of Zimbabwe)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mashonaland Central (Province of Zimbabwe)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mashonaland Central (Province of Zimbabwe)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mashonaland Central (Province of Zimbabwe)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mashonaland Central (Province of Zimbabwe)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mashonaland Central (Province of Zimbabwe)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mashonaland Central (Province of Zimbabwe)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mashonaland Central (Province of Zimbabwe)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mashonaland Central (Province of Zimbabwe)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mashonaland Central (Province of Zimbabwe)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mashonaland Central (Province of Zimbabwe)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mashonaland Central (Province of Zimbabwe)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mashonaland Central (Province of Zimbabwe)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mashonaland Central (Province of Zimbabwe)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mashonaland Central (Province of Zimbabwe)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mashonaland Central (Province of Zimbabwe)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Mashonaland East (Province of Zimbabwe)": [
            {
                "Region Name": "Mashonaland East (Province of Zimbabwe)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mashonaland East (Province of Zimbabwe)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mashonaland East (Province of Zimbabwe)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mashonaland East (Province of Zimbabwe)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mashonaland East (Province of Zimbabwe)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mashonaland East (Province of Zimbabwe)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mashonaland East (Province of Zimbabwe)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mashonaland East (Province of Zimbabwe)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mashonaland East (Province of Zimbabwe)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mashonaland East (Province of Zimbabwe)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mashonaland East (Province of Zimbabwe)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mashonaland East (Province of Zimbabwe)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mashonaland East (Province of Zimbabwe)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mashonaland East (Province of Zimbabwe)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mashonaland East (Province of Zimbabwe)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mashonaland East (Province of Zimbabwe)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mashonaland East (Province of Zimbabwe)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mashonaland East (Province of Zimbabwe)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mashonaland East (Province of Zimbabwe)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mashonaland East (Province of Zimbabwe)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mashonaland East (Province of Zimbabwe)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mashonaland East (Province of Zimbabwe)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Mashonaland West (Province of Zimbabwe)": [
            {
                "Region Name": "Mashonaland West (Province of Zimbabwe)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mashonaland West (Province of Zimbabwe)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mashonaland West (Province of Zimbabwe)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mashonaland West (Province of Zimbabwe)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mashonaland West (Province of Zimbabwe)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mashonaland West (Province of Zimbabwe)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Mashonaland West (Province of Zimbabwe)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mashonaland West (Province of Zimbabwe)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mashonaland West (Province of Zimbabwe)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Mashonaland West (Province of Zimbabwe)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mashonaland West (Province of Zimbabwe)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mashonaland West (Province of Zimbabwe)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mashonaland West (Province of Zimbabwe)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mashonaland West (Province of Zimbabwe)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mashonaland West (Province of Zimbabwe)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mashonaland West (Province of Zimbabwe)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mashonaland West (Province of Zimbabwe)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mashonaland West (Province of Zimbabwe)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mashonaland West (Province of Zimbabwe)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mashonaland West (Province of Zimbabwe)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mashonaland West (Province of Zimbabwe)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mashonaland West (Province of Zimbabwe)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Masindi (District of Uganda)": [
            {
                "Region Name": "Masindi (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Masindi (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Masindi (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Masindi (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Masindi (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Masindi (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Masindi (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Masindi (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Masindi (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Masindi (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Masindi (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Masindi (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Masindi (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Masindi (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Masindi (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Masindi (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Masindi (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Masindi (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Masindi (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Masindi (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Masindi (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Masindi (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Massachusetts (State of United States)": [
            {
                "Region Name": "Massachusetts (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Massachusetts (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Massachusetts (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Massachusetts (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Massachusetts (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Massachusetts (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Massachusetts (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Massachusetts (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Massachusetts (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Massachusetts (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Massachusetts (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Massachusetts (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Massachusetts (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Massachusetts (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Massachusetts (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Massachusetts (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Massachusetts (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Massachusetts (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Massachusetts (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Massachusetts (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Massachusetts (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Massachusetts (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Masvingo (Province of Zimbabwe)": [
            {
                "Region Name": "Masvingo (Province of Zimbabwe)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Masvingo (Province of Zimbabwe)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Masvingo (Province of Zimbabwe)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Masvingo (Province of Zimbabwe)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Masvingo (Province of Zimbabwe)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Masvingo (Province of Zimbabwe)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Masvingo (Province of Zimbabwe)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Masvingo (Province of Zimbabwe)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Masvingo (Province of Zimbabwe)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Masvingo (Province of Zimbabwe)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Masvingo (Province of Zimbabwe)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Masvingo (Province of Zimbabwe)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Masvingo (Province of Zimbabwe)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Masvingo (Province of Zimbabwe)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Masvingo (Province of Zimbabwe)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Masvingo (Province of Zimbabwe)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Masvingo (Province of Zimbabwe)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Masvingo (Province of Zimbabwe)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Masvingo (Province of Zimbabwe)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Masvingo (Province of Zimbabwe)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Masvingo (Province of Zimbabwe)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Masvingo (Province of Zimbabwe)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Matabeleland North (Province of Zimbabwe)": [
            {
                "Region Name": "Matabeleland North (Province of Zimbabwe)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Matabeleland North (Province of Zimbabwe)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Matabeleland North (Province of Zimbabwe)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Matabeleland North (Province of Zimbabwe)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 57
            },
            {
                "Region Name": "Matabeleland North (Province of Zimbabwe)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Matabeleland North (Province of Zimbabwe)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Matabeleland North (Province of Zimbabwe)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Matabeleland North (Province of Zimbabwe)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Matabeleland North (Province of Zimbabwe)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Matabeleland North (Province of Zimbabwe)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Matabeleland North (Province of Zimbabwe)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Matabeleland North (Province of Zimbabwe)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Matabeleland North (Province of Zimbabwe)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Matabeleland North (Province of Zimbabwe)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Matabeleland North (Province of Zimbabwe)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 61
            },
            {
                "Region Name": "Matabeleland North (Province of Zimbabwe)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "Matabeleland North (Province of Zimbabwe)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Matabeleland North (Province of Zimbabwe)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "Matabeleland North (Province of Zimbabwe)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Matabeleland North (Province of Zimbabwe)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Matabeleland North (Province of Zimbabwe)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Matabeleland North (Province of Zimbabwe)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 47
            }
        ],
        "Matabeleland South (Province of Zimbabwe)": [
            {
                "Region Name": "Matabeleland South (Province of Zimbabwe)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Matabeleland South (Province of Zimbabwe)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Matabeleland South (Province of Zimbabwe)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Matabeleland South (Province of Zimbabwe)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Matabeleland South (Province of Zimbabwe)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Matabeleland South (Province of Zimbabwe)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "Matabeleland South (Province of Zimbabwe)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "Matabeleland South (Province of Zimbabwe)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Matabeleland South (Province of Zimbabwe)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 59
            },
            {
                "Region Name": "Matabeleland South (Province of Zimbabwe)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Matabeleland South (Province of Zimbabwe)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Matabeleland South (Province of Zimbabwe)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Matabeleland South (Province of Zimbabwe)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Matabeleland South (Province of Zimbabwe)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Matabeleland South (Province of Zimbabwe)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Matabeleland South (Province of Zimbabwe)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Matabeleland South (Province of Zimbabwe)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Matabeleland South (Province of Zimbabwe)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Matabeleland South (Province of Zimbabwe)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Matabeleland South (Province of Zimbabwe)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Matabeleland South (Province of Zimbabwe)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Matabeleland South (Province of Zimbabwe)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 16
            }
        ],
        "Matagalpa (Department of Nicaragua)": [
            {
                "Region Name": "Matagalpa (Department of Nicaragua)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Matagalpa (Department of Nicaragua)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Matagalpa (Department of Nicaragua)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Matagalpa (Department of Nicaragua)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Matagalpa (Department of Nicaragua)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Matagalpa (Department of Nicaragua)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Matagalpa (Department of Nicaragua)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Matagalpa (Department of Nicaragua)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matagalpa (Department of Nicaragua)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Matagalpa (Department of Nicaragua)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Matagalpa (Department of Nicaragua)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Matagalpa (Department of Nicaragua)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Matagalpa (Department of Nicaragua)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Matagalpa (Department of Nicaragua)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Matagalpa (Department of Nicaragua)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Matagalpa (Department of Nicaragua)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Matagalpa (Department of Nicaragua)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Matagalpa (Department of Nicaragua)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Matagalpa (Department of Nicaragua)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Matagalpa (Department of Nicaragua)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Matagalpa (Department of Nicaragua)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Matagalpa (Department of Nicaragua)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Matale (District of Sri Lanka)": [
            {
                "Region Name": "Matale (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Matale (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Matale (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Matale (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Matale (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matale (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matale (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matale (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matale (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matale (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Matale (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matale (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Matale (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Matale (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matale (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Matale (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matale (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matale (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Matale (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matale (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matale (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matale (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Matam (Region of Senegal)": [
            {
                "Region Name": "Matam (Region of Senegal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 77
            },
            {
                "Region Name": "Matam (Region of Senegal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 99
            },
            {
                "Region Name": "Matam (Region of Senegal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "Matam (Region of Senegal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 110
            },
            {
                "Region Name": "Matam (Region of Senegal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 61
            },
            {
                "Region Name": "Matam (Region of Senegal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 110
            },
            {
                "Region Name": "Matam (Region of Senegal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 315
            },
            {
                "Region Name": "Matam (Region of Senegal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 133
            },
            {
                "Region Name": "Matam (Region of Senegal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 100
            },
            {
                "Region Name": "Matam (Region of Senegal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 64
            },
            {
                "Region Name": "Matam (Region of Senegal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "Matam (Region of Senegal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 64
            },
            {
                "Region Name": "Matam (Region of Senegal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Matam (Region of Senegal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "Matam (Region of Senegal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "Matam (Region of Senegal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 64
            },
            {
                "Region Name": "Matam (Region of Senegal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "Matam (Region of Senegal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 99
            },
            {
                "Region Name": "Matam (Region of Senegal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 120
            },
            {
                "Region Name": "Matam (Region of Senegal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 148
            },
            {
                "Region Name": "Matam (Region of Senegal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 105
            },
            {
                "Region Name": "Matam (Region of Senegal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 114
            }
        ],
        "Matanzas (Province of Cuba)": [
            {
                "Region Name": "Matanzas (Province of Cuba)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Matanzas (Province of Cuba)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Matanzas (Province of Cuba)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Matanzas (Province of Cuba)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Matanzas (Province of Cuba)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Matanzas (Province of Cuba)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Matanzas (Province of Cuba)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Matanzas (Province of Cuba)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Matanzas (Province of Cuba)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Matanzas (Province of Cuba)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Matanzas (Province of Cuba)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Matanzas (Province of Cuba)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Matanzas (Province of Cuba)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Matanzas (Province of Cuba)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Matanzas (Province of Cuba)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Matanzas (Province of Cuba)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Matanzas (Province of Cuba)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Matanzas (Province of Cuba)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Matanzas (Province of Cuba)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Matanzas (Province of Cuba)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Matanzas (Province of Cuba)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Matanzas (Province of Cuba)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Matara (District of Sri Lanka)": [
            {
                "Region Name": "Matara (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matara (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matara (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matara (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matara (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matara (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matara (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matara (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matara (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matara (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matara (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matara (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matara (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matara (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matara (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matara (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matara (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matara (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matara (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matara (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matara (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matara (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mato Grosso (State of Brazil)": [
            {
                "Region Name": "Mato Grosso (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mato Grosso (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mato Grosso (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mato Grosso (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mato Grosso (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mato Grosso (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Mato Grosso (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mato Grosso (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mato Grosso (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Mato Grosso (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mato Grosso (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Mato Grosso (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mato Grosso (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mato Grosso (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mato Grosso (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Mato Grosso (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Mato Grosso (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mato Grosso (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Mato Grosso (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Mato Grosso (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Mato Grosso (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mato Grosso (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "Mato Grosso do Sul (State of Brazil)": [
            {
                "Region Name": "Mato Grosso do Sul (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Mato Grosso do Sul (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mato Grosso do Sul (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mato Grosso do Sul (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Mato Grosso do Sul (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mato Grosso do Sul (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mato Grosso do Sul (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mato Grosso do Sul (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mato Grosso do Sul (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mato Grosso do Sul (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mato Grosso do Sul (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mato Grosso do Sul (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mato Grosso do Sul (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mato Grosso do Sul (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mato Grosso do Sul (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mato Grosso do Sul (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mato Grosso do Sul (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mato Grosso do Sul (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Mato Grosso do Sul (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Mato Grosso do Sul (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Mato Grosso do Sul (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mato Grosso do Sul (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "Matrouh (Governorate of Egypt)": [
            {
                "Region Name": "Matrouh (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matrouh (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matrouh (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matrouh (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matrouh (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matrouh (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matrouh (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matrouh (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matrouh (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matrouh (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matrouh (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matrouh (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matrouh (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matrouh (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matrouh (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matrouh (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matrouh (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matrouh (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matrouh (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matrouh (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Matrouh (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Matrouh (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Mauke (Island Council of Cook Islands)": [
            {
                "Region Name": "Mauke (Island Council of Cook Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauke (Island Council of Cook Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauke (Island Council of Cook Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauke (Island Council of Cook Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauke (Island Council of Cook Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauke (Island Council of Cook Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauke (Island Council of Cook Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauke (Island Council of Cook Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauke (Island Council of Cook Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauke (Island Council of Cook Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauke (Island Council of Cook Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauke (Island Council of Cook Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauke (Island Council of Cook Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauke (Island Council of Cook Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauke (Island Council of Cook Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauke (Island Council of Cook Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauke (Island Council of Cook Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauke (Island Council of Cook Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauke (Island Council of Cook Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauke (Island Council of Cook Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauke (Island Council of Cook Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauke (Island Council of Cook Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Maule (Region of Chile)": [
            {
                "Region Name": "Maule (Region of Chile)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Maule (Region of Chile)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maule (Region of Chile)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maule (Region of Chile)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Maule (Region of Chile)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Maule (Region of Chile)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maule (Region of Chile)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Maule (Region of Chile)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Maule (Region of Chile)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Maule (Region of Chile)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maule (Region of Chile)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maule (Region of Chile)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Maule (Region of Chile)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Maule (Region of Chile)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Maule (Region of Chile)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 242
            },
            {
                "Region Name": "Maule (Region of Chile)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Maule (Region of Chile)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Maule (Region of Chile)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Maule (Region of Chile)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Maule (Region of Chile)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Maule (Region of Chile)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Maule (Region of Chile)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Maunabo (Municipality of Puerto Rico)": [
            {
                "Region Name": "Maunabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maunabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maunabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maunabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maunabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maunabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maunabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maunabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maunabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maunabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maunabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maunabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maunabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maunabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maunabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maunabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maunabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maunabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maunabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maunabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maunabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Maunabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mauren (Commune of Liechtenstein)": [
            {
                "Region Name": "Mauren (Commune of Liechtenstein)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauren (Commune of Liechtenstein)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauren (Commune of Liechtenstein)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauren (Commune of Liechtenstein)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauren (Commune of Liechtenstein)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauren (Commune of Liechtenstein)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauren (Commune of Liechtenstein)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauren (Commune of Liechtenstein)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauren (Commune of Liechtenstein)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauren (Commune of Liechtenstein)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauren (Commune of Liechtenstein)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauren (Commune of Liechtenstein)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauren (Commune of Liechtenstein)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauren (Commune of Liechtenstein)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauren (Commune of Liechtenstein)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauren (Commune of Liechtenstein)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauren (Commune of Liechtenstein)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauren (Commune of Liechtenstein)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauren (Commune of Liechtenstein)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauren (Commune of Liechtenstein)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauren (Commune of Liechtenstein)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mauren (Commune of Liechtenstein)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)": [
            {
                "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mavrovo and Rostu\u0161a (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mayabeque (Province of Cuba)": [
            {
                "Region Name": "Mayabeque (Province of Cuba)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mayabeque (Province of Cuba)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mayabeque (Province of Cuba)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mayabeque (Province of Cuba)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mayabeque (Province of Cuba)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mayabeque (Province of Cuba)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mayabeque (Province of Cuba)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mayabeque (Province of Cuba)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mayabeque (Province of Cuba)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mayabeque (Province of Cuba)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mayabeque (Province of Cuba)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mayabeque (Province of Cuba)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mayabeque (Province of Cuba)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mayabeque (Province of Cuba)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mayabeque (Province of Cuba)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mayabeque (Province of Cuba)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mayabeque (Province of Cuba)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mayabeque (Province of Cuba)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mayabeque (Province of Cuba)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mayabeque (Province of Cuba)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mayabeque (Province of Cuba)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mayabeque (Province of Cuba)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Mayaguana (District of Bahamas)": [
            {
                "Region Name": "Mayaguana (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaguana (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaguana (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaguana (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaguana (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaguana (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaguana (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaguana (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaguana (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaguana (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaguana (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaguana (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaguana (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaguana (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaguana (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaguana (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaguana (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaguana (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaguana (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaguana (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaguana (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaguana (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mayag\xfcez (Municipality of Puerto Rico)": [
            {
                "Region Name": "Mayag\xfcez (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayag\xfcez (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayag\xfcez (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayag\xfcez (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayag\xfcez (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayag\xfcez (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayag\xfcez (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayag\xfcez (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayag\xfcez (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayag\xfcez (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayag\xfcez (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayag\xfcez (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayag\xfcez (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayag\xfcez (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayag\xfcez (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayag\xfcez (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayag\xfcez (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayag\xfcez (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayag\xfcez (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayag\xfcez (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayag\xfcez (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayag\xfcez (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mayaro/Rio Claro (Region of Trinidad and Tobago)": [
            {
                "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayaro/Rio Claro (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mayo-Kebbi Est (Region of Chad)": [
            {
                "Region Name": "Mayo-Kebbi Est (Region of Chad)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mayo-Kebbi Est (Region of Chad)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mayo-Kebbi Est (Region of Chad)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mayo-Kebbi Est (Region of Chad)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mayo-Kebbi Est (Region of Chad)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mayo-Kebbi Est (Region of Chad)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mayo-Kebbi Est (Region of Chad)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mayo-Kebbi Est (Region of Chad)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mayo-Kebbi Est (Region of Chad)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mayo-Kebbi Est (Region of Chad)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mayo-Kebbi Est (Region of Chad)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mayo-Kebbi Est (Region of Chad)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mayo-Kebbi Est (Region of Chad)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mayo-Kebbi Est (Region of Chad)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mayo-Kebbi Est (Region of Chad)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mayo-Kebbi Est (Region of Chad)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mayo-Kebbi Est (Region of Chad)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mayo-Kebbi Est (Region of Chad)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mayo-Kebbi Est (Region of Chad)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mayo-Kebbi Est (Region of Chad)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mayo-Kebbi Est (Region of Chad)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mayo-Kebbi Est (Region of Chad)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Mayo-Kebbi Ouest (Region of Chad)": [
            {
                "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Mayo-Kebbi Ouest (Region of Chad)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Mayo (County of Ireland)": [
            {
                "Region Name": "Mayo (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayo (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayo (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayo (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayo (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayo (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayo (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayo (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayo (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mayo (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayo (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayo (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayo (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayo (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayo (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayo (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayo (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mayo (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayo (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayo (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayo (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mayo (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Maysan (Province of Iraq)": [
            {
                "Region Name": "Maysan (Province of Iraq)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maysan (Province of Iraq)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Maysan (Province of Iraq)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Maysan (Province of Iraq)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Maysan (Province of Iraq)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Maysan (Province of Iraq)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Maysan (Province of Iraq)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Maysan (Province of Iraq)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Maysan (Province of Iraq)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maysan (Province of Iraq)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Maysan (Province of Iraq)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Maysan (Province of Iraq)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Maysan (Province of Iraq)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Maysan (Province of Iraq)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Maysan (Province of Iraq)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Maysan (Province of Iraq)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Maysan (Province of Iraq)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Maysan (Province of Iraq)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Maysan (Province of Iraq)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Maysan (Province of Iraq)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Maysan (Province of Iraq)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Maysan (Province of Iraq)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Mayuge (District of Uganda)": [
            {
                "Region Name": "Mayuge (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mayuge (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayuge (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mayuge (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayuge (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayuge (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayuge (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayuge (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayuge (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayuge (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mayuge (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayuge (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mayuge (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayuge (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayuge (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayuge (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayuge (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayuge (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayuge (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mayuge (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mayuge (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mayuge (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mazandaran (Province of Iran)": [
            {
                "Region Name": "Mazandaran (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mazandaran (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mazandaran (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mazandaran (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mazandaran (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mazandaran (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mazandaran (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mazandaran (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mazandaran (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mazandaran (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mazandaran (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mazandaran (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mazandaran (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mazandaran (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mazandaran (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mazandaran (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mazandaran (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mazandaran (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mazandaran (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mazandaran (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mazandaran (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mazandaran (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Mazowieckie (Voivodeship of Poland)": [
            {
                "Region Name": "Mazowieckie (Voivodeship of Poland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mazowieckie (Voivodeship of Poland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mazowieckie (Voivodeship of Poland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mazowieckie (Voivodeship of Poland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mazowieckie (Voivodeship of Poland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mazowieckie (Voivodeship of Poland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mazowieckie (Voivodeship of Poland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mazowieckie (Voivodeship of Poland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mazowieckie (Voivodeship of Poland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mazowieckie (Voivodeship of Poland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mazowieckie (Voivodeship of Poland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mazowieckie (Voivodeship of Poland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mazowieckie (Voivodeship of Poland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mazowieckie (Voivodeship of Poland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mazowieckie (Voivodeship of Poland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mazowieckie (Voivodeship of Poland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mazowieckie (Voivodeship of Poland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mazowieckie (Voivodeship of Poland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mazowieckie (Voivodeship of Poland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mazowieckie (Voivodeship of Poland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mazowieckie (Voivodeship of Poland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mazowieckie (Voivodeship of Poland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mbale (District of Uganda)": [
            {
                "Region Name": "Mbale (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mbale (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mbale (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mbale (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mbale (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mbale (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mbale (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mbale (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mbale (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mbale (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mbale (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mbale (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mbale (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mbale (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mbale (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mbale (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mbale (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mbale (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mbale (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mbale (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mbale (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mbale (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mbarara (District of Uganda)": [
            {
                "Region Name": "Mbarara (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mbarara (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mbarara (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mbarara (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Mbarara (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mbarara (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mbarara (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mbarara (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mbarara (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mbarara (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mbarara (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mbarara (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mbarara (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mbarara (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mbarara (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mbarara (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mbarara (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Mbarara (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mbarara (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mbarara (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mbarara (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mbarara (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Mbeya (Region of Tanzania)": [
            {
                "Region Name": "Mbeya (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mbeya (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mbeya (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mbeya (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mbeya (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mbeya (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Mbeya (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mbeya (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mbeya (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Mbeya (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mbeya (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mbeya (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Mbeya (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Mbeya (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mbeya (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Mbeya (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Mbeya (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Mbeya (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mbeya (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Mbeya (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Mbeya (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mbeya (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Mbomou (Prefecture of Central African Republic)": [
            {
                "Region Name": "Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mbomou (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Mchinji (District of Malawi)": [
            {
                "Region Name": "Mchinji (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mchinji (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mchinji (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mchinji (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mchinji (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mchinji (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mchinji (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mchinji (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mchinji (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mchinji (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mchinji (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mchinji (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mchinji (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mchinji (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mchinji (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mchinji (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mchinji (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mchinji (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mchinji (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mchinji (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mchinji (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mchinji (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Meath (County of Ireland)": [
            {
                "Region Name": "Meath (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meath (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meath (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meath (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meath (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meath (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meath (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meath (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meath (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meath (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meath (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meath (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meath (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meath (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meath (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meath (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meath (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Meath (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meath (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meath (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meath (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meath (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mecklenburg-Vorpommern (State of Germany)": [
            {
                "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mecklenburg-Vorpommern (State of Germany)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "M\xe9d\xe9a (Province of Algeria)": [
            {
                "Region Name": "M\xe9d\xe9a (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "M\xe9d\xe9a (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "M\xe9d\xe9a (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "M\xe9d\xe9a (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "M\xe9d\xe9a (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "M\xe9d\xe9a (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "M\xe9d\xe9a (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "M\xe9d\xe9a (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "M\xe9d\xe9a (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "M\xe9d\xe9a (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "M\xe9d\xe9a (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "M\xe9d\xe9a (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "M\xe9d\xe9a (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "M\xe9d\xe9a (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "M\xe9d\xe9a (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "M\xe9d\xe9a (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "M\xe9d\xe9a (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "M\xe9d\xe9a (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "M\xe9d\xe9a (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "M\xe9d\xe9a (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9d\xe9a (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9d\xe9a (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "M\xe9denine (Governorate of Tunisia)": [
            {
                "Region Name": "M\xe9denine (Governorate of Tunisia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9denine (Governorate of Tunisia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9denine (Governorate of Tunisia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9denine (Governorate of Tunisia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9denine (Governorate of Tunisia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9denine (Governorate of Tunisia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9denine (Governorate of Tunisia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9denine (Governorate of Tunisia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9denine (Governorate of Tunisia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9denine (Governorate of Tunisia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9denine (Governorate of Tunisia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9denine (Governorate of Tunisia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9denine (Governorate of Tunisia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9denine (Governorate of Tunisia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9denine (Governorate of Tunisia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9denine (Governorate of Tunisia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9denine (Governorate of Tunisia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9denine (Governorate of Tunisia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9denine (Governorate of Tunisia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9denine (Governorate of Tunisia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9denine (Governorate of Tunisia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9denine (Governorate of Tunisia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Medimurska (County of Croatia)": [
            {
                "Region Name": "Medimurska (County of Croatia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Medimurska (County of Croatia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Medimurska (County of Croatia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Medimurska (County of Croatia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Medimurska (County of Croatia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Medimurska (County of Croatia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Medimurska (County of Croatia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Medimurska (County of Croatia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Medimurska (County of Croatia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Medimurska (County of Croatia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Medimurska (County of Croatia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Medimurska (County of Croatia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Medimurska (County of Croatia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Medimurska (County of Croatia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Medimurska (County of Croatia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Medimurska (County of Croatia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Medimurska (County of Croatia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Medimurska (County of Croatia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Medimurska (County of Croatia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Medimurska (County of Croatia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Medimurska (County of Croatia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Medimurska (County of Croatia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Meghalaya (State of India)": [
            {
                "Region Name": "Meghalaya (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Meghalaya (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Meghalaya (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Meghalaya (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Meghalaya (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Meghalaya (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Meghalaya (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Meghalaya (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Meghalaya (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Meghalaya (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Meghalaya (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Meghalaya (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Meghalaya (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Meghalaya (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Meghalaya (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Meghalaya (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Meghalaya (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Meghalaya (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Meghalaya (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Meghalaya (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Meghalaya (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Meghalaya (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Mehedin\u021Bi (County of Romania)": [
            {
                "Region Name": "Mehedin\u021Bi (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mehedin\u021Bi (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mehedin\u021Bi (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mehedin\u021Bi (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mehedin\u021Bi (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mehedin\u021Bi (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mehedin\u021Bi (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mehedin\u021Bi (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mehedin\u021Bi (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mehedin\u021Bi (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mehedin\u021Bi (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mehedin\u021Bi (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mehedin\u021Bi (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mehedin\u021Bi (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mehedin\u021Bi (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mehedin\u021Bi (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mehedin\u021Bi (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mehedin\u021Bi (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mehedin\u021Bi (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mehedin\u021Bi (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mehedin\u021Bi (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mehedin\u021Bi (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Mejit (Island of Marshall Islands)": [
            {
                "Region Name": "Mejit (Island of Marshall Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mejit (Island of Marshall Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mejit (Island of Marshall Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mejit (Island of Marshall Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mejit (Island of Marshall Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mejit (Island of Marshall Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mejit (Island of Marshall Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mejit (Island of Marshall Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mejit (Island of Marshall Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mejit (Island of Marshall Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mejit (Island of Marshall Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mejit (Island of Marshall Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mejit (Island of Marshall Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mejit (Island of Marshall Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mejit (Island of Marshall Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mejit (Island of Marshall Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mejit (Island of Marshall Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mejit (Island of Marshall Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mejit (Island of Marshall Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mejit (Island of Marshall Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mejit (Island of Marshall Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mejit (Island of Marshall Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mekn\xe8s - Tafilalet (Region of Morocco)": [
            {
                "Region Name": "Mekn\xe8s - Tafilalet (Region of Morocco)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mekn\xe8s - Tafilalet (Region of Morocco)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mekn\xe8s - Tafilalet (Region of Morocco)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mekn\xe8s - Tafilalet (Region of Morocco)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mekn\xe8s - Tafilalet (Region of Morocco)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mekn\xe8s - Tafilalet (Region of Morocco)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mekn\xe8s - Tafilalet (Region of Morocco)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mekn\xe8s - Tafilalet (Region of Morocco)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mekn\xe8s - Tafilalet (Region of Morocco)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mekn\xe8s - Tafilalet (Region of Morocco)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mekn\xe8s - Tafilalet (Region of Morocco)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mekn\xe8s - Tafilalet (Region of Morocco)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mekn\xe8s - Tafilalet (Region of Morocco)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mekn\xe8s - Tafilalet (Region of Morocco)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mekn\xe8s - Tafilalet (Region of Morocco)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mekn\xe8s - Tafilalet (Region of Morocco)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mekn\xe8s - Tafilalet (Region of Morocco)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mekn\xe8s - Tafilalet (Region of Morocco)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mekn\xe8s - Tafilalet (Region of Morocco)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mekn\xe8s - Tafilalet (Region of Morocco)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mekn\xe8s - Tafilalet (Region of Morocco)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mekn\xe8s - Tafilalet (Region of Morocco)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Melaka (State of Malaysia)": [
            {
                "Region Name": "Melaka (State of Malaysia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melaka (State of Malaysia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melaka (State of Malaysia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melaka (State of Malaysia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melaka (State of Malaysia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melaka (State of Malaysia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melaka (State of Malaysia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melaka (State of Malaysia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melaka (State of Malaysia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melaka (State of Malaysia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melaka (State of Malaysia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melaka (State of Malaysia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melaka (State of Malaysia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melaka (State of Malaysia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melaka (State of Malaysia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melaka (State of Malaysia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melaka (State of Malaysia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melaka (State of Malaysia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melaka (State of Malaysia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melaka (State of Malaysia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melaka (State of Malaysia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melaka (State of Malaysia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Melekeok (State of Palau)": [
            {
                "Region Name": "Melekeok (State of Palau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melekeok (State of Palau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melekeok (State of Palau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melekeok (State of Palau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melekeok (State of Palau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melekeok (State of Palau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melekeok (State of Palau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melekeok (State of Palau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melekeok (State of Palau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melekeok (State of Palau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melekeok (State of Palau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melekeok (State of Palau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melekeok (State of Palau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melekeok (State of Palau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melekeok (State of Palau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melekeok (State of Palau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melekeok (State of Palau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melekeok (State of Palau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melekeok (State of Palau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melekeok (State of Palau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melekeok (State of Palau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Melekeok (State of Palau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mendoza (Province of Argentina)": [
            {
                "Region Name": "Mendoza (Province of Argentina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Mendoza (Province of Argentina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 206
            },
            {
                "Region Name": "Mendoza (Province of Argentina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mendoza (Province of Argentina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mendoza (Province of Argentina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Mendoza (Province of Argentina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mendoza (Province of Argentina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mendoza (Province of Argentina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mendoza (Province of Argentina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mendoza (Province of Argentina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mendoza (Province of Argentina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mendoza (Province of Argentina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Mendoza (Province of Argentina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mendoza (Province of Argentina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mendoza (Province of Argentina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 101
            },
            {
                "Region Name": "Mendoza (Province of Argentina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 77
            },
            {
                "Region Name": "Mendoza (Province of Argentina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Mendoza (Province of Argentina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Mendoza (Province of Argentina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mendoza (Province of Argentina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Mendoza (Province of Argentina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mendoza (Province of Argentina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Meneng (District of Nauru)": [
            {
                "Region Name": "Meneng (District of Nauru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meneng (District of Nauru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meneng (District of Nauru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meneng (District of Nauru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meneng (District of Nauru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meneng (District of Nauru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meneng (District of Nauru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meneng (District of Nauru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meneng (District of Nauru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meneng (District of Nauru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meneng (District of Nauru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meneng (District of Nauru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meneng (District of Nauru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meneng (District of Nauru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meneng (District of Nauru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meneng (District of Nauru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meneng (District of Nauru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meneng (District of Nauru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meneng (District of Nauru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meneng (District of Nauru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meneng (District of Nauru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meneng (District of Nauru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "M\xe9rida (State of Venezuela)": [
            {
                "Region Name": "M\xe9rida (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "M\xe9rida (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "M\xe9rida (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "M\xe9rida (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "M\xe9rida (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "M\xe9rida (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9rida (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9rida (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "M\xe9rida (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "M\xe9rida (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "M\xe9rida (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "M\xe9rida (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "M\xe9rida (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "M\xe9rida (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "M\xe9rida (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "M\xe9rida (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9rida (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "M\xe9rida (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "M\xe9rida (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "M\xe9rida (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9rida (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xe9rida (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Merizo (Municipality of Guam)": [
            {
                "Region Name": "Merizo (Municipality of Guam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Merizo (Municipality of Guam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Merizo (Municipality of Guam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Merizo (Municipality of Guam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Merizo (Municipality of Guam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Merizo (Municipality of Guam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Merizo (Municipality of Guam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Merizo (Municipality of Guam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Merizo (Municipality of Guam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Merizo (Municipality of Guam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Merizo (Municipality of Guam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Merizo (Municipality of Guam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Merizo (Municipality of Guam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Merizo (Municipality of Guam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Merizo (Municipality of Guam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Merizo (Municipality of Guam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Merizo (Municipality of Guam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Merizo (Municipality of Guam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Merizo (Municipality of Guam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Merizo (Municipality of Guam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Merizo (Municipality of Guam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Merizo (Municipality of Guam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mersin (Province of Turkey)": [
            {
                "Region Name": "Mersin (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mersin (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mersin (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mersin (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mersin (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mersin (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mersin (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Mersin (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mersin (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mersin (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mersin (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mersin (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mersin (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mersin (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mersin (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mersin (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mersin (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mersin (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mersin (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mersin (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Mersin (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Mersin (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Meru (County of Kenya)": [
            {
                "Region Name": "Meru (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Meru (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Meru (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Meru (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Meru (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Meru (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Meru (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Meru (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Meru (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Meru (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Meru (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Meru (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Meru (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Meru (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Meru (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Meru (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Meru (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 103
            },
            {
                "Region Name": "Meru (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Meru (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Meru (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Meru (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Meru (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Meta (Department of Colombia)": [
            {
                "Region Name": "Meta (Department of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Meta (Department of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Meta (Department of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Meta (Department of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Meta (Department of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Meta (Department of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Meta (Department of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Meta (Department of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Meta (Department of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Meta (Department of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Meta (Department of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Meta (Department of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Meta (Department of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Meta (Department of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Meta (Department of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Meta (Department of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Meta (Department of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Meta (Department of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Meta (Department of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Meta (Department of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Meta (Department of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Meta (Department of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Metropolitan Manila (Province of Philippines)": [
            {
                "Region Name": "Metropolitan Manila (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Metropolitan Manila (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Metropolitan Manila (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Metropolitan Manila (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Metropolitan Manila (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Metropolitan Manila (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Metropolitan Manila (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Metropolitan Manila (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Metropolitan Manila (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Metropolitan Manila (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Metropolitan Manila (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Metropolitan Manila (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Metropolitan Manila (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Metropolitan Manila (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Metropolitan Manila (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Metropolitan Manila (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Metropolitan Manila (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Metropolitan Manila (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Metropolitan Manila (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Metropolitan Manila (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Metropolitan Manila (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Metropolitan Manila (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "M\xe9xico (State of M\xe9xico)": [
            {
                "Region Name": "M\xe9xico (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "M\xe9xico (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "M\xe9xico (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "M\xe9xico (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "M\xe9xico (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "M\xe9xico (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "M\xe9xico (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "M\xe9xico (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "M\xe9xico (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "M\xe9xico (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "M\xe9xico (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "M\xe9xico (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "M\xe9xico (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "M\xe9xico (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "M\xe9xico (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "M\xe9xico (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "M\xe9xico (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "M\xe9xico (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "M\xe9xico (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "M\xe9xico (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "M\xe9xico (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "M\xe9xico (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Michael (District of Isle of Man)": [
            {
                "Region Name": "Michael (District of Isle of Man)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Michael (District of Isle of Man)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Michael (District of Isle of Man)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Michael (District of Isle of Man)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Michael (District of Isle of Man)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Michael (District of Isle of Man)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Michael (District of Isle of Man)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Michael (District of Isle of Man)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Michael (District of Isle of Man)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Michael (District of Isle of Man)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Michael (District of Isle of Man)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Michael (District of Isle of Man)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Michael (District of Isle of Man)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Michael (District of Isle of Man)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Michael (District of Isle of Man)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Michael (District of Isle of Man)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Michael (District of Isle of Man)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Michael (District of Isle of Man)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Michael (District of Isle of Man)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Michael (District of Isle of Man)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Michael (District of Isle of Man)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Michael (District of Isle of Man)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Michigan (State of United States)": [
            {
                "Region Name": "Michigan (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Michigan (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Michigan (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Michigan (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Michigan (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Michigan (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "Michigan (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Michigan (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Michigan (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Michigan (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Michigan (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Michigan (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Michigan (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Michigan (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Michigan (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Michigan (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Michigan (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Michigan (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Michigan (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Michigan (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Michigan (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Michigan (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Michoac\xe1n (State of M\xe9xico)": [
            {
                "Region Name": "Michoac\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Michoac\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Michoac\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Michoac\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Michoac\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Michoac\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Michoac\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Michoac\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Michoac\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Michoac\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Michoac\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Michoac\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Michoac\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Michoac\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Michoac\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Michoac\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Michoac\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Michoac\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Michoac\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Michoac\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Michoac\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Michoac\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Micoud (Quarter of Saint Lucia)": [
            {
                "Region Name": "Micoud (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micoud (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micoud (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micoud (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micoud (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micoud (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micoud (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micoud (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micoud (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micoud (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micoud (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micoud (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micoud (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micoud (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micoud (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micoud (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micoud (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micoud (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micoud (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micoud (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micoud (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Micoud (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mid-Western (Development Region of Nepal)": [
            {
                "Region Name": "Mid-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mid-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Mid-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Mid-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mid-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mid-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mid-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Mid-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Mid-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Mid-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Mid-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Mid-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Mid-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Mid-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mid-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Mid-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Mid-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mid-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Mid-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mid-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Mid-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Mid-Western (Development Region of Nepal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 20
            }
        ],
        "Middle Caicos (District of Turks and Caicos Islands)": [
            {
                "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Middle Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Midlands (Province of Zimbabwe)": [
            {
                "Region Name": "Midlands (Province of Zimbabwe)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Midlands (Province of Zimbabwe)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Midlands (Province of Zimbabwe)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Midlands (Province of Zimbabwe)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Midlands (Province of Zimbabwe)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Midlands (Province of Zimbabwe)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Midlands (Province of Zimbabwe)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Midlands (Province of Zimbabwe)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Midlands (Province of Zimbabwe)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Midlands (Province of Zimbabwe)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Midlands (Province of Zimbabwe)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Midlands (Province of Zimbabwe)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Midlands (Province of Zimbabwe)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Midlands (Province of Zimbabwe)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Midlands (Province of Zimbabwe)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Midlands (Province of Zimbabwe)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Midlands (Province of Zimbabwe)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Midlands (Province of Zimbabwe)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Midlands (Province of Zimbabwe)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Midlands (Province of Zimbabwe)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Midlands (Province of Zimbabwe)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Midlands (Province of Zimbabwe)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Midtjylland (Region of Denmark)": [
            {
                "Region Name": "Midtjylland (Region of Denmark)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midtjylland (Region of Denmark)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Midtjylland (Region of Denmark)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Midtjylland (Region of Denmark)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midtjylland (Region of Denmark)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Midtjylland (Region of Denmark)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Midtjylland (Region of Denmark)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Midtjylland (Region of Denmark)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Midtjylland (Region of Denmark)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midtjylland (Region of Denmark)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midtjylland (Region of Denmark)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midtjylland (Region of Denmark)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midtjylland (Region of Denmark)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midtjylland (Region of Denmark)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midtjylland (Region of Denmark)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midtjylland (Region of Denmark)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midtjylland (Region of Denmark)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midtjylland (Region of Denmark)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midtjylland (Region of Denmark)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midtjylland (Region of Denmark)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midtjylland (Region of Denmark)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midtjylland (Region of Denmark)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Midway (Island of United States Minor Outlying Isl)": [
            {
                "Region Name": "Midway (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midway (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midway (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midway (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midway (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midway (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midway (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midway (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midway (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midway (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midway (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midway (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midway (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midway (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midway (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midway (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midway (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midway (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midway (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midway (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midway (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Midway (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mie (Prefecture of Japan)": [
            {
                "Region Name": "Mie (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mie (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mie (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mie (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mie (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mie (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mie (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mie (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mie (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mie (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mie (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mie (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mie (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mie (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mie (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mie (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mie (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mie (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mie (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mie (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mie (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mie (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Migori (County of Kenya)": [
            {
                "Region Name": "Migori (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Migori (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Migori (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Migori (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Migori (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Migori (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Migori (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Migori (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Migori (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Migori (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Migori (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Migori (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Migori (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Migori (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Migori (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Migori (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Migori (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Migori (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Migori (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Migori (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Migori (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Migori (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mila (Province of Algeria)": [
            {
                "Region Name": "Mila (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mila (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mila (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mila (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mila (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mila (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mila (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mila (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mila (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mila (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mila (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mila (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mila (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mila (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mila (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mila (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mila (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mila (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mila (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mila (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mila (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mila (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mili (Atol of Marshall Islands)": [
            {
                "Region Name": "Mili (Atol of Marshall Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mili (Atol of Marshall Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mili (Atol of Marshall Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mili (Atol of Marshall Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mili (Atol of Marshall Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mili (Atol of Marshall Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mili (Atol of Marshall Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mili (Atol of Marshall Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mili (Atol of Marshall Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mili (Atol of Marshall Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mili (Atol of Marshall Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mili (Atol of Marshall Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mili (Atol of Marshall Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mili (Atol of Marshall Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mili (Atol of Marshall Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mili (Atol of Marshall Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mili (Atol of Marshall Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mili (Atol of Marshall Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mili (Atol of Marshall Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mili (Atol of Marshall Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mili (Atol of Marshall Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mili (Atol of Marshall Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Milne Bay (Province of Papua New Guinea)": [
            {
                "Region Name": "Milne Bay (Province of Papua New Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Milne Bay (Province of Papua New Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Milne Bay (Province of Papua New Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Milne Bay (Province of Papua New Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Milne Bay (Province of Papua New Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Milne Bay (Province of Papua New Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Milne Bay (Province of Papua New Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Milne Bay (Province of Papua New Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Milne Bay (Province of Papua New Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Milne Bay (Province of Papua New Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Milne Bay (Province of Papua New Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Milne Bay (Province of Papua New Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Milne Bay (Province of Papua New Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Milne Bay (Province of Papua New Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Milne Bay (Province of Papua New Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Milne Bay (Province of Papua New Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Milne Bay (Province of Papua New Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Milne Bay (Province of Papua New Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Milne Bay (Province of Papua New Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Milne Bay (Province of Papua New Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Milne Bay (Province of Papua New Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Milne Bay (Province of Papua New Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Minas Gerais (State of Brazil)": [
            {
                "Region Name": "Minas Gerais (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Minas Gerais (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Minas Gerais (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Minas Gerais (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Minas Gerais (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Minas Gerais (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Minas Gerais (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Minas Gerais (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Minas Gerais (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Minas Gerais (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Minas Gerais (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Minas Gerais (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Minas Gerais (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Minas Gerais (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Minas Gerais (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Minas Gerais (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Minas Gerais (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Minas Gerais (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Minas Gerais (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Minas Gerais (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Minas Gerais (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Minas Gerais (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Minnesota (State of United States)": [
            {
                "Region Name": "Minnesota (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Minnesota (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Minnesota (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Minnesota (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Minnesota (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Minnesota (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Minnesota (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Minnesota (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Minnesota (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Minnesota (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Minnesota (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Minnesota (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Minnesota (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Minnesota (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Minnesota (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Minnesota (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Minnesota (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Minnesota (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Minnesota (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Minnesota (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Minnesota (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Minnesota (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Minsk (City of Belarus)": [
            {
                "Region Name": "Minsk (City of Belarus)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Minsk (City of Belarus)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Minsk (City of Belarus)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Minsk (City of Belarus)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Minsk (City of Belarus)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Minsk (City of Belarus)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Minsk (City of Belarus)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Minsk (City of Belarus)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Minsk (City of Belarus)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Minsk (City of Belarus)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Minsk (City of Belarus)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Minsk (City of Belarus)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Minsk (City of Belarus)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Minsk (City of Belarus)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Minsk (City of Belarus)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Minsk (City of Belarus)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Minsk (City of Belarus)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Minsk (City of Belarus)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Minsk (City of Belarus)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Minsk (City of Belarus)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Minsk (City of Belarus)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Minsk (City of Belarus)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Minsk (Region of Belarus)": [
            {
                "Region Name": "Minsk (Region of Belarus)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Minsk (Region of Belarus)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Minsk (Region of Belarus)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Minsk (Region of Belarus)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Minsk (Region of Belarus)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Minsk (Region of Belarus)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Minsk (Region of Belarus)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Minsk (Region of Belarus)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Minsk (Region of Belarus)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Minsk (Region of Belarus)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Minsk (Region of Belarus)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Minsk (Region of Belarus)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Minsk (Region of Belarus)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Minsk (Region of Belarus)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Minsk (Region of Belarus)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Minsk (Region of Belarus)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Minsk (Region of Belarus)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Minsk (Region of Belarus)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Minsk (Region of Belarus)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Minsk (Region of Belarus)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Minsk (Region of Belarus)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Minsk (Region of Belarus)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)": [
            {
                "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miquelon-Langlade (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Miranda (State of Venezuela)": [
            {
                "Region Name": "Miranda (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Miranda (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Miranda (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Miranda (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Miranda (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Miranda (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Miranda (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Miranda (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Miranda (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Miranda (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miranda (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miranda (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Miranda (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Miranda (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Miranda (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Miranda (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Miranda (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Miranda (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Miranda (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Miranda (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Miranda (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Miranda (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Misamis Occidental (Province of Philippines)": [
            {
                "Region Name": "Misamis Occidental (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Occidental (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Occidental (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Occidental (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Occidental (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Occidental (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Occidental (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Occidental (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Occidental (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Occidental (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Occidental (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Occidental (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Occidental (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Occidental (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Occidental (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Occidental (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Occidental (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Occidental (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Occidental (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Occidental (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Occidental (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Occidental (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Misamis Oriental (Province of Philippines)": [
            {
                "Region Name": "Misamis Oriental (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Oriental (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Misamis Oriental (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Oriental (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Misamis Oriental (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Oriental (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Misamis Oriental (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Oriental (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Misamis Oriental (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Misamis Oriental (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Oriental (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Oriental (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Misamis Oriental (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Oriental (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Misamis Oriental (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Oriental (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Oriental (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Misamis Oriental (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Misamis Oriental (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Misamis Oriental (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Oriental (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misamis Oriental (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Misiones (Department of Paraguay)": [
            {
                "Region Name": "Misiones (Department of Paraguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Misiones (Department of Paraguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Misiones (Department of Paraguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Misiones (Department of Paraguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Misiones (Department of Paraguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Misiones (Department of Paraguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Misiones (Department of Paraguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Misiones (Department of Paraguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Misiones (Department of Paraguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Misiones (Department of Paraguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Misiones (Department of Paraguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Misiones (Department of Paraguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Misiones (Department of Paraguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Misiones (Department of Paraguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Misiones (Department of Paraguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Misiones (Department of Paraguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Misiones (Department of Paraguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Misiones (Department of Paraguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Misiones (Department of Paraguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Misiones (Department of Paraguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Misiones (Department of Paraguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Misiones (Department of Paraguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Misiones (Province of Argentina)": [
            {
                "Region Name": "Misiones (Province of Argentina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Misiones (Province of Argentina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Misiones (Province of Argentina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Misiones (Province of Argentina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Misiones (Province of Argentina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Misiones (Province of Argentina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Misiones (Province of Argentina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Misiones (Province of Argentina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Misiones (Province of Argentina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Misiones (Province of Argentina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Misiones (Province of Argentina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Misiones (Province of Argentina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Misiones (Province of Argentina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Misiones (Province of Argentina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Misiones (Province of Argentina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Misiones (Province of Argentina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Misiones (Province of Argentina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Misiones (Province of Argentina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Misiones (Province of Argentina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Misiones (Province of Argentina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Misiones (Province of Argentina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Misiones (Province of Argentina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Misratah (District of Libya)": [
            {
                "Region Name": "Misratah (District of Libya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misratah (District of Libya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misratah (District of Libya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misratah (District of Libya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misratah (District of Libya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misratah (District of Libya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misratah (District of Libya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misratah (District of Libya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misratah (District of Libya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misratah (District of Libya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misratah (District of Libya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misratah (District of Libya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misratah (District of Libya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misratah (District of Libya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misratah (District of Libya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misratah (District of Libya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misratah (District of Libya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misratah (District of Libya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misratah (District of Libya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misratah (District of Libya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misratah (District of Libya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Misratah (District of Libya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mississippi (State of United States)": [
            {
                "Region Name": "Mississippi (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mississippi (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mississippi (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mississippi (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mississippi (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mississippi (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mississippi (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mississippi (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mississippi (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mississippi (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mississippi (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mississippi (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mississippi (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mississippi (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mississippi (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mississippi (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mississippi (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mississippi (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mississippi (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mississippi (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mississippi (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mississippi (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Missouri (State of United States)": [
            {
                "Region Name": "Missouri (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Missouri (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Missouri (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Missouri (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Missouri (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Missouri (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Missouri (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Missouri (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Missouri (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Missouri (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Missouri (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Missouri (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Missouri (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Missouri (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Missouri (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Missouri (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Missouri (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Missouri (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Missouri (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Missouri (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Missouri (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Missouri (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Mitiaro (Island Council of Cook Islands)": [
            {
                "Region Name": "Mitiaro (Island Council of Cook Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mitiaro (Island Council of Cook Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mitiaro (Island Council of Cook Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mitiaro (Island Council of Cook Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mitiaro (Island Council of Cook Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mitiaro (Island Council of Cook Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mitiaro (Island Council of Cook Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mitiaro (Island Council of Cook Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mitiaro (Island Council of Cook Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mitiaro (Island Council of Cook Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mitiaro (Island Council of Cook Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mitiaro (Island Council of Cook Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mitiaro (Island Council of Cook Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mitiaro (Island Council of Cook Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mitiaro (Island Council of Cook Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mitiaro (Island Council of Cook Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mitiaro (Island Council of Cook Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mitiaro (Island Council of Cook Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mitiaro (Island Council of Cook Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mitiaro (Island Council of Cook Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mitiaro (Island Council of Cook Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mitiaro (Island Council of Cook Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Miyagi (Prefecture of Japan)": [
            {
                "Region Name": "Miyagi (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyagi (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyagi (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyagi (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyagi (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyagi (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyagi (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Miyagi (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyagi (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyagi (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Miyagi (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyagi (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyagi (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Miyagi (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Miyagi (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyagi (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyagi (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyagi (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyagi (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyagi (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyagi (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Miyagi (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Miyazaki (Prefecture of Japan)": [
            {
                "Region Name": "Miyazaki (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyazaki (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Miyazaki (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyazaki (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyazaki (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyazaki (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyazaki (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyazaki (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyazaki (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyazaki (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyazaki (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyazaki (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Miyazaki (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyazaki (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Miyazaki (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyazaki (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyazaki (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyazaki (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Miyazaki (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyazaki (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyazaki (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Miyazaki (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mizoram (State of India)": [
            {
                "Region Name": "Mizoram (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mizoram (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mizoram (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mizoram (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mizoram (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mizoram (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mizoram (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mizoram (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mizoram (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mizoram (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mizoram (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mizoram (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mizoram (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mizoram (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mizoram (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mizoram (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mizoram (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mizoram (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mizoram (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mizoram (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mizoram (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mizoram (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Mjini Magharibi (Region of Tanzania)": [
            {
                "Region Name": "Mjini Magharibi (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mjini Magharibi (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mjini Magharibi (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mjini Magharibi (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mjini Magharibi (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mjini Magharibi (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mjini Magharibi (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mjini Magharibi (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mjini Magharibi (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mjini Magharibi (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mjini Magharibi (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mjini Magharibi (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mjini Magharibi (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mjini Magharibi (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mjini Magharibi (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mjini Magharibi (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mjini Magharibi (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mjini Magharibi (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mjini Magharibi (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mjini Magharibi (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mjini Magharibi (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mjini Magharibi (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Moca (Municipality of Puerto Rico)": [
            {
                "Region Name": "Moca (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moca (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moca (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moca (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moca (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moca (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moca (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moca (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moca (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moca (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moca (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moca (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moca (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moca (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moca (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moca (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moca (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moca (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moca (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moca (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moca (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moca (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mogila (Municipality of North Macedonia)": [
            {
                "Region Name": "Mogila (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mogila (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mogila (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mogila (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mogila (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mogila (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mogila (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mogila (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mogila (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mogila (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mogila (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mogila (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mogila (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mogila (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mogila (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mogila (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mogila (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mogila (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mogila (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mogila (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mogila (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mogila (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Mogilev (Region of Belarus)": [
            {
                "Region Name": "Mogilev (Region of Belarus)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mogilev (Region of Belarus)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mogilev (Region of Belarus)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mogilev (Region of Belarus)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mogilev (Region of Belarus)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mogilev (Region of Belarus)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mogilev (Region of Belarus)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mogilev (Region of Belarus)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mogilev (Region of Belarus)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mogilev (Region of Belarus)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mogilev (Region of Belarus)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mogilev (Region of Belarus)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mogilev (Region of Belarus)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mogilev (Region of Belarus)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mogilev (Region of Belarus)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mogilev (Region of Belarus)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mogilev (Region of Belarus)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mogilev (Region of Belarus)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mogilev (Region of Belarus)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mogilev (Region of Belarus)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mogilev (Region of Belarus)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mogilev (Region of Belarus)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Mohale's Hoek (District of Lesotho)": [
            {
                "Region Name": "Mohale's Hoek (District of Lesotho)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mohale's Hoek (District of Lesotho)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mohale's Hoek (District of Lesotho)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mohale's Hoek (District of Lesotho)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mohale's Hoek (District of Lesotho)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mohale's Hoek (District of Lesotho)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mohale's Hoek (District of Lesotho)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mohale's Hoek (District of Lesotho)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mohale's Hoek (District of Lesotho)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mohale's Hoek (District of Lesotho)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mohale's Hoek (District of Lesotho)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mohale's Hoek (District of Lesotho)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mohale's Hoek (District of Lesotho)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mohale's Hoek (District of Lesotho)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mohale's Hoek (District of Lesotho)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mohale's Hoek (District of Lesotho)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mohale's Hoek (District of Lesotho)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mohale's Hoek (District of Lesotho)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mohale's Hoek (District of Lesotho)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mohale's Hoek (District of Lesotho)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mohale's Hoek (District of Lesotho)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mohale's Hoek (District of Lesotho)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Mojkovac (Municipality of Montenegro)": [
            {
                "Region Name": "Mojkovac (Municipality of Montenegro)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mojkovac (Municipality of Montenegro)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mojkovac (Municipality of Montenegro)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mojkovac (Municipality of Montenegro)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mojkovac (Municipality of Montenegro)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mojkovac (Municipality of Montenegro)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mojkovac (Municipality of Montenegro)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mojkovac (Municipality of Montenegro)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mojkovac (Municipality of Montenegro)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mojkovac (Municipality of Montenegro)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mojkovac (Municipality of Montenegro)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mojkovac (Municipality of Montenegro)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mojkovac (Municipality of Montenegro)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mojkovac (Municipality of Montenegro)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mojkovac (Municipality of Montenegro)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mojkovac (Municipality of Montenegro)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mojkovac (Municipality of Montenegro)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mojkovac (Municipality of Montenegro)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mojkovac (Municipality of Montenegro)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mojkovac (Municipality of Montenegro)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mojkovac (Municipality of Montenegro)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mojkovac (Municipality of Montenegro)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Moka (District of Mauritius)": [
            {
                "Region Name": "Moka (District of Mauritius)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moka (District of Mauritius)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moka (District of Mauritius)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moka (District of Mauritius)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moka (District of Mauritius)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moka (District of Mauritius)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moka (District of Mauritius)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moka (District of Mauritius)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moka (District of Mauritius)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moka (District of Mauritius)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moka (District of Mauritius)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moka (District of Mauritius)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moka (District of Mauritius)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moka (District of Mauritius)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moka (District of Mauritius)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moka (District of Mauritius)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moka (District of Mauritius)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moka (District of Mauritius)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moka (District of Mauritius)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moka (District of Mauritius)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moka (District of Mauritius)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moka (District of Mauritius)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mokhotlong (District of Lesotho)": [
            {
                "Region Name": "Mokhotlong (District of Lesotho)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mokhotlong (District of Lesotho)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Mokhotlong (District of Lesotho)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mokhotlong (District of Lesotho)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Mokhotlong (District of Lesotho)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mokhotlong (District of Lesotho)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mokhotlong (District of Lesotho)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mokhotlong (District of Lesotho)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mokhotlong (District of Lesotho)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mokhotlong (District of Lesotho)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Mokhotlong (District of Lesotho)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mokhotlong (District of Lesotho)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mokhotlong (District of Lesotho)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mokhotlong (District of Lesotho)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mokhotlong (District of Lesotho)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Mokhotlong (District of Lesotho)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mokhotlong (District of Lesotho)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mokhotlong (District of Lesotho)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mokhotlong (District of Lesotho)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mokhotlong (District of Lesotho)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mokhotlong (District of Lesotho)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mokhotlong (District of Lesotho)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Molise (Region of Italy)": [
            {
                "Region Name": "Molise (Region of Italy)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Molise (Region of Italy)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Molise (Region of Italy)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Molise (Region of Italy)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Molise (Region of Italy)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Molise (Region of Italy)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Molise (Region of Italy)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Molise (Region of Italy)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Molise (Region of Italy)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Molise (Region of Italy)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Molise (Region of Italy)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Molise (Region of Italy)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Molise (Region of Italy)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Molise (Region of Italy)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Molise (Region of Italy)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Molise (Region of Italy)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Molise (Region of Italy)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Molise (Region of Italy)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Molise (Region of Italy)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Molise (Region of Italy)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Molise (Region of Italy)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Molise (Region of Italy)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Mombasa (County of Kenya)": [
            {
                "Region Name": "Mombasa (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mombasa (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mombasa (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mombasa (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mombasa (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mombasa (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mombasa (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mombasa (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mombasa (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mombasa (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mombasa (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mombasa (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mombasa (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mombasa (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mombasa (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mombasa (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mombasa (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mombasa (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mombasa (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mombasa (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mombasa (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mombasa (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mon (State of Myanmar)": [
            {
                "Region Name": "Mon (State of Myanmar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mon (State of Myanmar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mon (State of Myanmar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mon (State of Myanmar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mon (State of Myanmar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mon (State of Myanmar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mon (State of Myanmar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mon (State of Myanmar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mon (State of Myanmar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mon (State of Myanmar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mon (State of Myanmar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mon (State of Myanmar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mon (State of Myanmar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mon (State of Myanmar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mon (State of Myanmar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mon (State of Myanmar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mon (State of Myanmar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mon (State of Myanmar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mon (State of Myanmar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mon (State of Myanmar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mon (State of Myanmar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mon (State of Myanmar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Monagas (State of Venezuela)": [
            {
                "Region Name": "Monagas (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Monagas (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Monagas (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Monagas (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Monagas (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Monagas (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Monagas (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Monagas (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Monagas (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Monagas (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Monagas (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Monagas (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Monagas (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Monagas (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Monagas (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Monagas (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Monagas (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Monagas (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Monagas (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Monagas (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Monagas (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Monagas (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Monaghan (County of Ireland)": [
            {
                "Region Name": "Monaghan (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monaghan (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monaghan (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monaghan (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monaghan (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monaghan (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monaghan (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monaghan (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monaghan (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monaghan (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monaghan (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monaghan (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monaghan (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monaghan (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monaghan (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monaghan (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monaghan (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monaghan (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monaghan (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monaghan (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monaghan (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monaghan (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Monastir (Governorate of Tunisia)": [
            {
                "Region Name": "Monastir (Governorate of Tunisia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monastir (Governorate of Tunisia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monastir (Governorate of Tunisia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monastir (Governorate of Tunisia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monastir (Governorate of Tunisia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monastir (Governorate of Tunisia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monastir (Governorate of Tunisia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monastir (Governorate of Tunisia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monastir (Governorate of Tunisia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monastir (Governorate of Tunisia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monastir (Governorate of Tunisia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monastir (Governorate of Tunisia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monastir (Governorate of Tunisia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Monastir (Governorate of Tunisia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monastir (Governorate of Tunisia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monastir (Governorate of Tunisia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monastir (Governorate of Tunisia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Monastir (Governorate of Tunisia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monastir (Governorate of Tunisia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monastir (Governorate of Tunisia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monastir (Governorate of Tunisia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monastir (Governorate of Tunisia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "M\xf4nd\xf3l Kiri (Province of Cambodia)": [
            {
                "Region Name": "M\xf4nd\xf3l Kiri (Province of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "M\xf4nd\xf3l Kiri (Province of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "M\xf4nd\xf3l Kiri (Province of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "M\xf4nd\xf3l Kiri (Province of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "M\xf4nd\xf3l Kiri (Province of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "M\xf4nd\xf3l Kiri (Province of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "M\xf4nd\xf3l Kiri (Province of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "M\xf4nd\xf3l Kiri (Province of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "M\xf4nd\xf3l Kiri (Province of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "M\xf4nd\xf3l Kiri (Province of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "M\xf4nd\xf3l Kiri (Province of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "M\xf4nd\xf3l Kiri (Province of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "M\xf4nd\xf3l Kiri (Province of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "M\xf4nd\xf3l Kiri (Province of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "M\xf4nd\xf3l Kiri (Province of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "M\xf4nd\xf3l Kiri (Province of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "M\xf4nd\xf3l Kiri (Province of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "M\xf4nd\xf3l Kiri (Province of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "M\xf4nd\xf3l Kiri (Province of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "M\xf4nd\xf3l Kiri (Province of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "M\xf4nd\xf3l Kiri (Province of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "M\xf4nd\xf3l Kiri (Province of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 19
            }
        ],
        "Moneragala (District of Sri Lanka)": [
            {
                "Region Name": "Moneragala (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Moneragala (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Moneragala (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Moneragala (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Moneragala (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Moneragala (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Moneragala (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Moneragala (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Moneragala (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Moneragala (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Moneragala (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Moneragala (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Moneragala (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Moneragala (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Moneragala (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Moneragala (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moneragala (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moneragala (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Moneragala (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moneragala (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Moneragala (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Moneragala (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Mongala (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mongala (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Monggar (District of Bhutan)": [
            {
                "Region Name": "Monggar (District of Bhutan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Monggar (District of Bhutan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Monggar (District of Bhutan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Monggar (District of Bhutan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Monggar (District of Bhutan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monggar (District of Bhutan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Monggar (District of Bhutan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Monggar (District of Bhutan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Monggar (District of Bhutan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Monggar (District of Bhutan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Monggar (District of Bhutan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Monggar (District of Bhutan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monggar (District of Bhutan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Monggar (District of Bhutan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Monggar (District of Bhutan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Monggar (District of Bhutan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monggar (District of Bhutan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Monggar (District of Bhutan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Monggar (District of Bhutan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monggar (District of Bhutan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Monggar (District of Bhutan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Monggar (District of Bhutan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 36
            }
        ],
        "Mongmong-Toto-Maite (Municipality of Guam)": [
            {
                "Region Name": "Mongmong-Toto-Maite (Municipality of Guam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mongmong-Toto-Maite (Municipality of Guam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mongmong-Toto-Maite (Municipality of Guam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mongmong-Toto-Maite (Municipality of Guam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mongmong-Toto-Maite (Municipality of Guam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mongmong-Toto-Maite (Municipality of Guam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mongmong-Toto-Maite (Municipality of Guam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mongmong-Toto-Maite (Municipality of Guam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mongmong-Toto-Maite (Municipality of Guam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mongmong-Toto-Maite (Municipality of Guam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mongmong-Toto-Maite (Municipality of Guam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mongmong-Toto-Maite (Municipality of Guam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mongmong-Toto-Maite (Municipality of Guam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mongmong-Toto-Maite (Municipality of Guam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mongmong-Toto-Maite (Municipality of Guam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mongmong-Toto-Maite (Municipality of Guam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mongmong-Toto-Maite (Municipality of Guam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mongmong-Toto-Maite (Municipality of Guam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mongmong-Toto-Maite (Municipality of Guam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mongmong-Toto-Maite (Municipality of Guam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mongmong-Toto-Maite (Municipality of Guam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mongmong-Toto-Maite (Municipality of Guam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mono (Department of Benin)": [
            {
                "Region Name": "Mono (Department of Benin)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mono (Department of Benin)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mono (Department of Benin)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mono (Department of Benin)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mono (Department of Benin)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mono (Department of Benin)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mono (Department of Benin)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mono (Department of Benin)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mono (Department of Benin)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mono (Department of Benin)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mono (Department of Benin)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mono (Department of Benin)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mono (Department of Benin)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mono (Department of Benin)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mono (Department of Benin)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mono (Department of Benin)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mono (Department of Benin)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mono (Department of Benin)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mono (Department of Benin)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Mono (Department of Benin)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mono (Department of Benin)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mono (Department of Benin)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Monse\xf1or Nouel (Province of Dominican Republic)": [
            {
                "Region Name": "Monse\xf1or Nouel (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monse\xf1or Nouel (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Monse\xf1or Nouel (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monse\xf1or Nouel (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monse\xf1or Nouel (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monse\xf1or Nouel (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monse\xf1or Nouel (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monse\xf1or Nouel (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monse\xf1or Nouel (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monse\xf1or Nouel (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monse\xf1or Nouel (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monse\xf1or Nouel (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monse\xf1or Nouel (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monse\xf1or Nouel (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monse\xf1or Nouel (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monse\xf1or Nouel (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monse\xf1or Nouel (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monse\xf1or Nouel (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monse\xf1or Nouel (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monse\xf1or Nouel (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monse\xf1or Nouel (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monse\xf1or Nouel (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mont Buxton (District of Seychelles)": [
            {
                "Region Name": "Mont Buxton (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Buxton (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Buxton (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Buxton (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Buxton (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Buxton (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Buxton (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Buxton (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Buxton (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Buxton (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Buxton (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Buxton (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Buxton (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Buxton (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Buxton (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Buxton (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Buxton (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Buxton (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Buxton (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Buxton (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Buxton (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Buxton (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mont Fleuri (District of Seychelles)": [
            {
                "Region Name": "Mont Fleuri (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Fleuri (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Fleuri (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Fleuri (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Fleuri (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Fleuri (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Fleuri (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Fleuri (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Fleuri (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Fleuri (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Fleuri (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Fleuri (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Fleuri (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Fleuri (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Fleuri (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Fleuri (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Fleuri (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Fleuri (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Fleuri (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Fleuri (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Fleuri (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mont Fleuri (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Montagnes (District of C\xf4te d'Ivoire)": [
            {
                "Region Name": "Montagnes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Montagnes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Montagnes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Montagnes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Montagnes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Montagnes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Montagnes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Montagnes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Montagnes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Montagnes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Montagnes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Montagnes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Montagnes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Montagnes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Montagnes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Montagnes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Montagnes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Montagnes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Montagnes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Montagnes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Montagnes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Montagnes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "Montana (Province of Bulgaria)": [
            {
                "Region Name": "Montana (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montana (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Montana (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Montana (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Montana (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Montana (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Montana (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Montana (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Montana (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Montana (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Montana (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Montana (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Montana (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Montana (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Montana (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Montana (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Montana (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Montana (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Montana (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Montana (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Montana (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Montana (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Montana (State of United States)": [
            {
                "Region Name": "Montana (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Montana (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Montana (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Montana (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Montana (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 65
            },
            {
                "Region Name": "Montana (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "Montana (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Montana (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Montana (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Montana (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Montana (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Montana (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Montana (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Montana (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Montana (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Montana (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 78
            },
            {
                "Region Name": "Montana (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Montana (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Montana (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Montana (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Montana (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Montana (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Monte Cristi (Province of Dominican Republic)": [
            {
                "Region Name": "Monte Cristi (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Monte Cristi (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monte Cristi (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monte Cristi (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monte Cristi (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Monte Cristi (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Monte Cristi (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monte Cristi (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Monte Cristi (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Monte Cristi (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monte Cristi (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monte Cristi (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monte Cristi (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Monte Cristi (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monte Cristi (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monte Cristi (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Monte Cristi (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Monte Cristi (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Monte Cristi (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monte Cristi (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Monte Cristi (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monte Cristi (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Monte Plata (Province of Dominican Republic)": [
            {
                "Region Name": "Monte Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Monte Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Monte Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Monte Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Monte Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Monte Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Monte Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Monte Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Monte Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Monte Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Monte Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Monte Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monte Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Monte Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Monte Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Monte Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monte Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Monte Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Monte Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Monte Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Monte Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Monte Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Montegiardino (Municipality of San Marino)": [
            {
                "Region Name": "Montegiardino (Municipality of San Marino)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montegiardino (Municipality of San Marino)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montegiardino (Municipality of San Marino)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montegiardino (Municipality of San Marino)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montegiardino (Municipality of San Marino)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montegiardino (Municipality of San Marino)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montegiardino (Municipality of San Marino)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montegiardino (Municipality of San Marino)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montegiardino (Municipality of San Marino)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montegiardino (Municipality of San Marino)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montegiardino (Municipality of San Marino)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montegiardino (Municipality of San Marino)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montegiardino (Municipality of San Marino)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montegiardino (Municipality of San Marino)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montegiardino (Municipality of San Marino)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montegiardino (Municipality of San Marino)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montegiardino (Municipality of San Marino)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montegiardino (Municipality of San Marino)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montegiardino (Municipality of San Marino)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montegiardino (Municipality of San Marino)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montegiardino (Municipality of San Marino)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montegiardino (Municipality of San Marino)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Montevideo (Department of Uruguay)": [
            {
                "Region Name": "Montevideo (Department of Uruguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montevideo (Department of Uruguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montevideo (Department of Uruguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montevideo (Department of Uruguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montevideo (Department of Uruguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Montevideo (Department of Uruguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montevideo (Department of Uruguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Montevideo (Department of Uruguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montevideo (Department of Uruguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Montevideo (Department of Uruguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montevideo (Department of Uruguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montevideo (Department of Uruguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montevideo (Department of Uruguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montevideo (Department of Uruguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montevideo (Department of Uruguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montevideo (Department of Uruguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montevideo (Department of Uruguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montevideo (Department of Uruguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Montevideo (Department of Uruguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montevideo (Department of Uruguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Montevideo (Department of Uruguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montevideo (Department of Uruguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Montserrado (County of Liberia)": [
            {
                "Region Name": "Montserrado (County of Liberia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Montserrado (County of Liberia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Montserrado (County of Liberia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrado (County of Liberia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Montserrado (County of Liberia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrado (County of Liberia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrado (County of Liberia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Montserrado (County of Liberia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Montserrado (County of Liberia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrado (County of Liberia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Montserrado (County of Liberia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Montserrado (County of Liberia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Montserrado (County of Liberia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Montserrado (County of Liberia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Montserrado (County of Liberia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrado (County of Liberia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Montserrado (County of Liberia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Montserrado (County of Liberia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Montserrado (County of Liberia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Montserrado (County of Liberia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Montserrado (County of Liberia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Montserrado (County of Liberia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Moore's Island (District of Bahamas)": [
            {
                "Region Name": "Moore's Island (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moore's Island (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moore's Island (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moore's Island (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Moore's Island (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moore's Island (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moore's Island (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moore's Island (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moore's Island (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moore's Island (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moore's Island (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moore's Island (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moore's Island (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moore's Island (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moore's Island (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moore's Island (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moore's Island (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moore's Island (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moore's Island (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moore's Island (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moore's Island (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moore's Island (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mopti (Region of Mali)": [
            {
                "Region Name": "Mopti (Region of Mali)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mopti (Region of Mali)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Mopti (Region of Mali)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mopti (Region of Mali)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Mopti (Region of Mali)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Mopti (Region of Mali)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Mopti (Region of Mali)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Mopti (Region of Mali)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mopti (Region of Mali)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Mopti (Region of Mali)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mopti (Region of Mali)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Mopti (Region of Mali)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mopti (Region of Mali)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mopti (Region of Mali)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mopti (Region of Mali)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mopti (Region of Mali)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mopti (Region of Mali)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mopti (Region of Mali)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Mopti (Region of Mali)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Mopti (Region of Mali)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Mopti (Region of Mali)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Mopti (Region of Mali)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 23
            }
        ],
        "Moquegua (Region of Peru)": [
            {
                "Region Name": "Moquegua (Region of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Moquegua (Region of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Moquegua (Region of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Moquegua (Region of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moquegua (Region of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moquegua (Region of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moquegua (Region of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moquegua (Region of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Moquegua (Region of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moquegua (Region of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Moquegua (Region of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moquegua (Region of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Moquegua (Region of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moquegua (Region of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Moquegua (Region of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Moquegua (Region of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moquegua (Region of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Moquegua (Region of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Moquegua (Region of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Moquegua (Region of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Moquegua (Region of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Moquegua (Region of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Moravi\u010Dki (District of Serbia)": [
            {
                "Region Name": "Moravi\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravi\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravi\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravi\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravi\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Moravi\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravi\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravi\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravi\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravi\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravi\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Moravi\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravi\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravi\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravi\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravi\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravi\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravi\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravi\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravi\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravi\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravi\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Moravskoslezsk\xfd (Region of Czechia)": [
            {
                "Region Name": "Moravskoslezsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Moravskoslezsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravskoslezsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravskoslezsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Moravskoslezsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravskoslezsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Moravskoslezsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravskoslezsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravskoslezsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravskoslezsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravskoslezsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravskoslezsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravskoslezsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Moravskoslezsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravskoslezsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravskoslezsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Moravskoslezsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravskoslezsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravskoslezsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravskoslezsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravskoslezsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moravskoslezsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Moraz\xe1n (Department of El Salvador)": [
            {
                "Region Name": "Moraz\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moraz\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moraz\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moraz\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Moraz\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moraz\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moraz\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moraz\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moraz\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moraz\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moraz\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Moraz\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moraz\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moraz\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moraz\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moraz\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moraz\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Moraz\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moraz\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moraz\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moraz\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moraz\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mordovia (Republic of Russia)": [
            {
                "Region Name": "Mordovia (Republic of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mordovia (Republic of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mordovia (Republic of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mordovia (Republic of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mordovia (Republic of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mordovia (Republic of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mordovia (Republic of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mordovia (Republic of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mordovia (Republic of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mordovia (Republic of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mordovia (Republic of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mordovia (Republic of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mordovia (Republic of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mordovia (Republic of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mordovia (Republic of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mordovia (Republic of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mordovia (Republic of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mordovia (Republic of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mordovia (Republic of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mordovia (Republic of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mordovia (Republic of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mordovia (Republic of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "M\xf8re og Romsdal (County of Norway)": [
            {
                "Region Name": "M\xf8re og Romsdal (County of Norway)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xf8re og Romsdal (County of Norway)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xf8re og Romsdal (County of Norway)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xf8re og Romsdal (County of Norway)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xf8re og Romsdal (County of Norway)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xf8re og Romsdal (County of Norway)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xf8re og Romsdal (County of Norway)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xf8re og Romsdal (County of Norway)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xf8re og Romsdal (County of Norway)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xf8re og Romsdal (County of Norway)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xf8re og Romsdal (County of Norway)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xf8re og Romsdal (County of Norway)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xf8re og Romsdal (County of Norway)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xf8re og Romsdal (County of Norway)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xf8re og Romsdal (County of Norway)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xf8re og Romsdal (County of Norway)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xf8re og Romsdal (County of Norway)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "M\xf8re og Romsdal (County of Norway)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xf8re og Romsdal (County of Norway)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xf8re og Romsdal (County of Norway)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xf8re og Romsdal (County of Norway)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "M\xf8re og Romsdal (County of Norway)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Morelos (State of M\xe9xico)": [
            {
                "Region Name": "Morelos (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Morelos (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Morelos (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Morelos (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Morelos (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Morelos (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Morelos (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Morelos (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Morelos (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Morelos (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Morelos (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Morelos (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Morelos (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Morelos (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Morelos (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Morelos (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Morelos (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Morelos (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Morelos (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Morelos (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Morelos (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Morelos (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Morobe (Province of Papua New Guinea)": [
            {
                "Region Name": "Morobe (Province of Papua New Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Morobe (Province of Papua New Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Morobe (Province of Papua New Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Morobe (Province of Papua New Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Morobe (Province of Papua New Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Morobe (Province of Papua New Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Morobe (Province of Papua New Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Morobe (Province of Papua New Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Morobe (Province of Papua New Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Morobe (Province of Papua New Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Morobe (Province of Papua New Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Morobe (Province of Papua New Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Morobe (Province of Papua New Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Morobe (Province of Papua New Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Morobe (Province of Papua New Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Morobe (Province of Papua New Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Morobe (Province of Papua New Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Morobe (Province of Papua New Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Morobe (Province of Papua New Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Morobe (Province of Papua New Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Morobe (Province of Papua New Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Morobe (Province of Papua New Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Morogoro (Region of Tanzania)": [
            {
                "Region Name": "Morogoro (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Morogoro (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Morogoro (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Morogoro (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Morogoro (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Morogoro (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Morogoro (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Morogoro (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Morogoro (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Morogoro (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Morogoro (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Morogoro (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Morogoro (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Morogoro (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Morogoro (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Morogoro (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Morogoro (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Morogoro (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Morogoro (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Morogoro (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Morogoro (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Morogoro (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Morona Santiago (Province of Ecuador)": [
            {
                "Region Name": "Morona Santiago (Province of Ecuador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morona Santiago (Province of Ecuador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morona Santiago (Province of Ecuador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morona Santiago (Province of Ecuador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morona Santiago (Province of Ecuador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morona Santiago (Province of Ecuador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morona Santiago (Province of Ecuador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morona Santiago (Province of Ecuador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morona Santiago (Province of Ecuador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morona Santiago (Province of Ecuador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morona Santiago (Province of Ecuador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morona Santiago (Province of Ecuador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morona Santiago (Province of Ecuador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morona Santiago (Province of Ecuador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morona Santiago (Province of Ecuador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morona Santiago (Province of Ecuador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morona Santiago (Province of Ecuador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morona Santiago (Province of Ecuador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morona Santiago (Province of Ecuador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morona Santiago (Province of Ecuador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morona Santiago (Province of Ecuador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morona Santiago (Province of Ecuador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Moroto (District of Uganda)": [
            {
                "Region Name": "Moroto (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Moroto (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Moroto (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Moroto (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Moroto (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Moroto (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Moroto (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Moroto (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Moroto (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Moroto (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Moroto (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Moroto (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Moroto (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Moroto (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Moroto (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Moroto (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Moroto (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Moroto (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Moroto (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Moroto (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Moroto (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Moroto (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 25
            }
        ],
        "Morovis (Municipality of Puerto Rico)": [
            {
                "Region Name": "Morovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Morovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Moscow City (City of Russia)": [
            {
                "Region Name": "Moscow City (City of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moscow City (City of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moscow City (City of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Moscow City (City of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moscow City (City of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moscow City (City of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moscow City (City of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moscow City (City of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Moscow City (City of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Moscow City (City of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moscow City (City of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moscow City (City of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moscow City (City of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moscow City (City of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moscow City (City of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moscow City (City of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moscow City (City of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moscow City (City of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moscow City (City of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moscow City (City of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moscow City (City of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moscow City (City of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Moskva (Region of Russia)": [
            {
                "Region Name": "Moskva (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Moskva (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Moskva (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Moskva (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Moskva (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Moskva (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Moskva (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Moskva (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Moskva (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Moskva (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Moskva (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Moskva (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Moskva (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Moskva (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Moskva (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Moskva (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moskva (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Moskva (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Moskva (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Moskva (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Moskva (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Moskva (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "Mostaganem (Province of Algeria)": [
            {
                "Region Name": "Mostaganem (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mostaganem (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mostaganem (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mostaganem (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mostaganem (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mostaganem (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mostaganem (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mostaganem (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mostaganem (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mostaganem (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mostaganem (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mostaganem (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mostaganem (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mostaganem (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mostaganem (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mostaganem (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mostaganem (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mostaganem (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mostaganem (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mostaganem (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mostaganem (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mostaganem (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mosteiros (County of Cabo Verde)": [
            {
                "Region Name": "Mosteiros (County of Cabo Verde)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mosteiros (County of Cabo Verde)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mosteiros (County of Cabo Verde)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mosteiros (County of Cabo Verde)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mosteiros (County of Cabo Verde)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mosteiros (County of Cabo Verde)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mosteiros (County of Cabo Verde)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mosteiros (County of Cabo Verde)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mosteiros (County of Cabo Verde)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mosteiros (County of Cabo Verde)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mosteiros (County of Cabo Verde)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mosteiros (County of Cabo Verde)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mosteiros (County of Cabo Verde)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mosteiros (County of Cabo Verde)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mosteiros (County of Cabo Verde)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mosteiros (County of Cabo Verde)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mosteiros (County of Cabo Verde)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mosteiros (County of Cabo Verde)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mosteiros (County of Cabo Verde)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mosteiros (County of Cabo Verde)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mosteiros (County of Cabo Verde)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mosteiros (County of Cabo Verde)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mount Lebanon (Governorate of Lebanon)": [
            {
                "Region Name": "Mount Lebanon (Governorate of Lebanon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mount Lebanon (Governorate of Lebanon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mount Lebanon (Governorate of Lebanon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mount Lebanon (Governorate of Lebanon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mount Lebanon (Governorate of Lebanon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mount Lebanon (Governorate of Lebanon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mount Lebanon (Governorate of Lebanon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mount Lebanon (Governorate of Lebanon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mount Lebanon (Governorate of Lebanon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mount Lebanon (Governorate of Lebanon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mount Lebanon (Governorate of Lebanon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mount Lebanon (Governorate of Lebanon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mount Lebanon (Governorate of Lebanon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mount Lebanon (Governorate of Lebanon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mount Lebanon (Governorate of Lebanon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mount Lebanon (Governorate of Lebanon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mount Lebanon (Governorate of Lebanon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mount Lebanon (Governorate of Lebanon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mount Lebanon (Governorate of Lebanon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mount Lebanon (Governorate of Lebanon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mount Lebanon (Governorate of Lebanon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mount Lebanon (Governorate of Lebanon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mountain Province (Province of Philippines)": [
            {
                "Region Name": "Mountain Province (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mountain Province (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mountain Province (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mountain Province (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mountain Province (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mountain Province (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mountain Province (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mountain Province (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mountain Province (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mountain Province (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mountain Province (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mountain Province (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mountain Province (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mountain Province (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mountain Province (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mountain Province (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mountain Province (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mountain Province (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mountain Province (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mountain Province (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mountain Province (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mountain Province (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Moxico (Province of Angola)": [
            {
                "Region Name": "Moxico (Province of Angola)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Moxico (Province of Angola)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Moxico (Province of Angola)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Moxico (Province of Angola)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Moxico (Province of Angola)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Moxico (Province of Angola)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Moxico (Province of Angola)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Moxico (Province of Angola)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Moxico (Province of Angola)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Moxico (Province of Angola)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Moxico (Province of Angola)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Moxico (Province of Angola)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Moxico (Province of Angola)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Moxico (Province of Angola)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Moxico (Province of Angola)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Moxico (Province of Angola)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Moxico (Province of Angola)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Moxico (Province of Angola)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Moxico (Province of Angola)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Moxico (Province of Angola)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Moxico (Province of Angola)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Moxico (Province of Angola)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "Moyen-Chari (Region of Chad)": [
            {
                "Region Name": "Moyen-Chari (Region of Chad)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Moyen-Chari (Region of Chad)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Moyen-Chari (Region of Chad)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Moyen-Chari (Region of Chad)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Moyen-Chari (Region of Chad)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Moyen-Chari (Region of Chad)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Moyen-Chari (Region of Chad)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Moyen-Chari (Region of Chad)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Moyen-Chari (Region of Chad)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Moyen-Chari (Region of Chad)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Moyen-Chari (Region of Chad)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Moyen-Chari (Region of Chad)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Moyen-Chari (Region of Chad)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Moyen-Chari (Region of Chad)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Moyen-Chari (Region of Chad)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Moyen-Chari (Region of Chad)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Moyen-Chari (Region of Chad)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Moyen-Chari (Region of Chad)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Moyen-Chari (Region of Chad)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Moyen-Chari (Region of Chad)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Moyen-Chari (Region of Chad)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Moyen-Chari (Region of Chad)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 16
            }
        ],
        "Moyen-Ogoou\xe9 (Province of Gabon)": [
            {
                "Region Name": "Moyen-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moyen-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moyen-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moyen-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Moyen-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moyen-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moyen-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moyen-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moyen-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moyen-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moyen-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moyen-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Moyen-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moyen-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moyen-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moyen-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Moyen-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moyen-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moyen-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Moyen-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Moyen-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Moyen-Ogoou\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Moyo (District of Uganda)": [
            {
                "Region Name": "Moyo (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Moyo (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Moyo (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Moyo (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Moyo (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Moyo (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Moyo (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Moyo (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Moyo (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Moyo (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Moyo (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Moyo (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Moyo (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Moyo (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Moyo (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Moyo (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Moyo (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Moyo (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Moyo (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Moyo (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Moyo (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Moyo (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Mpigi (District of Uganda)": [
            {
                "Region Name": "Mpigi (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mpigi (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mpigi (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mpigi (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mpigi (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mpigi (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mpigi (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mpigi (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mpigi (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mpigi (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mpigi (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mpigi (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mpigi (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mpigi (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mpigi (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mpigi (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mpigi (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mpigi (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mpigi (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mpigi (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mpigi (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mpigi (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Mpumalanga (Province of South Africa)": [
            {
                "Region Name": "Mpumalanga (Province of South Africa)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mpumalanga (Province of South Africa)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mpumalanga (Province of South Africa)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mpumalanga (Province of South Africa)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Mpumalanga (Province of South Africa)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mpumalanga (Province of South Africa)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mpumalanga (Province of South Africa)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mpumalanga (Province of South Africa)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mpumalanga (Province of South Africa)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mpumalanga (Province of South Africa)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mpumalanga (Province of South Africa)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mpumalanga (Province of South Africa)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mpumalanga (Province of South Africa)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mpumalanga (Province of South Africa)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mpumalanga (Province of South Africa)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mpumalanga (Province of South Africa)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mpumalanga (Province of South Africa)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mpumalanga (Province of South Africa)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mpumalanga (Province of South Africa)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mpumalanga (Province of South Africa)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mpumalanga (Province of South Africa)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mpumalanga (Province of South Africa)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Mtsamboro (Commune of Mayotte)": [
            {
                "Region Name": "Mtsamboro (Commune of Mayotte)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtsamboro (Commune of Mayotte)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtsamboro (Commune of Mayotte)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtsamboro (Commune of Mayotte)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtsamboro (Commune of Mayotte)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtsamboro (Commune of Mayotte)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtsamboro (Commune of Mayotte)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtsamboro (Commune of Mayotte)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtsamboro (Commune of Mayotte)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtsamboro (Commune of Mayotte)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtsamboro (Commune of Mayotte)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtsamboro (Commune of Mayotte)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtsamboro (Commune of Mayotte)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtsamboro (Commune of Mayotte)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtsamboro (Commune of Mayotte)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtsamboro (Commune of Mayotte)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtsamboro (Commune of Mayotte)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtsamboro (Commune of Mayotte)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtsamboro (Commune of Mayotte)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtsamboro (Commune of Mayotte)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtsamboro (Commune of Mayotte)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtsamboro (Commune of Mayotte)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mtskheta-Mtianeti (Region of Georgia)": [
            {
                "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mtskheta-Mtianeti (Region of Georgia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Mtwara (Region of Tanzania)": [
            {
                "Region Name": "Mtwara (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mtwara (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mtwara (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mtwara (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mtwara (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mtwara (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mtwara (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mtwara (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mtwara (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mtwara (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mtwara (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mtwara (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mtwara (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mtwara (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mtwara (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mtwara (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mtwara (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mtwara (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mtwara (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mtwara (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mtwara (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mtwara (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Mubarak Al-Kabeer (Province of Kuwait)": [
            {
                "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mubarak Al-Kabeer (Province of Kuwait)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mubende (District of Uganda)": [
            {
                "Region Name": "Mubende (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mubende (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mubende (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mubende (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mubende (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mubende (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Mubende (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mubende (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mubende (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mubende (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mubende (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mubende (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mubende (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mubende (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mubende (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mubende (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mubende (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mubende (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mubende (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mubende (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mubende (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mubende (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Muchinga (Province of Zambia)": [
            {
                "Region Name": "Muchinga (Province of Zambia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Muchinga (Province of Zambia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Muchinga (Province of Zambia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Muchinga (Province of Zambia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Muchinga (Province of Zambia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Muchinga (Province of Zambia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Muchinga (Province of Zambia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Muchinga (Province of Zambia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Muchinga (Province of Zambia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Muchinga (Province of Zambia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Muchinga (Province of Zambia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Muchinga (Province of Zambia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Muchinga (Province of Zambia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Muchinga (Province of Zambia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Muchinga (Province of Zambia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Muchinga (Province of Zambia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Muchinga (Province of Zambia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Muchinga (Province of Zambia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Muchinga (Province of Zambia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Muchinga (Province of Zambia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Muchinga (Province of Zambia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Muchinga (Province of Zambia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 24
            }
        ],
        "Mudug (Region of Somalia)": [
            {
                "Region Name": "Mudug (Region of Somalia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mudug (Region of Somalia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mudug (Region of Somalia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mudug (Region of Somalia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mudug (Region of Somalia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mudug (Region of Somalia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mudug (Region of Somalia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mudug (Region of Somalia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mudug (Region of Somalia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mudug (Region of Somalia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mudug (Region of Somalia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mudug (Region of Somalia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mudug (Region of Somalia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mudug (Region of Somalia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mudug (Region of Somalia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mudug (Region of Somalia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mudug (Region of Somalia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mudug (Region of Somalia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mudug (Region of Somalia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mudug (Region of Somalia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mudug (Region of Somalia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mudug (Region of Somalia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mugla (Province of Turkey)": [
            {
                "Region Name": "Mugla (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mugla (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mugla (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mugla (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mugla (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Mugla (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mugla (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mugla (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mugla (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mugla (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mugla (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mugla (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mugla (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mugla (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mugla (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mugla (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mugla (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mugla (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mugla (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mugla (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 142
            },
            {
                "Region Name": "Mugla (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Mugla (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Muharraq (Governorate of Bahrain)": [
            {
                "Region Name": "Muharraq (Governorate of Bahrain)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muharraq (Governorate of Bahrain)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muharraq (Governorate of Bahrain)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muharraq (Governorate of Bahrain)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muharraq (Governorate of Bahrain)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muharraq (Governorate of Bahrain)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muharraq (Governorate of Bahrain)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muharraq (Governorate of Bahrain)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muharraq (Governorate of Bahrain)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muharraq (Governorate of Bahrain)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muharraq (Governorate of Bahrain)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muharraq (Governorate of Bahrain)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muharraq (Governorate of Bahrain)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muharraq (Governorate of Bahrain)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muharraq (Governorate of Bahrain)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muharraq (Governorate of Bahrain)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muharraq (Governorate of Bahrain)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muharraq (Governorate of Bahrain)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muharraq (Governorate of Bahrain)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muharraq (Governorate of Bahrain)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muharraq (Governorate of Bahrain)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muharraq (Governorate of Bahrain)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mukdahan (Province of Thailand)": [
            {
                "Region Name": "Mukdahan (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mukdahan (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mukdahan (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mukdahan (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mukdahan (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mukdahan (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mukdahan (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mukdahan (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mukdahan (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mukdahan (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mukdahan (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mukdahan (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mukdahan (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mukdahan (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mukdahan (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mukdahan (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mukdahan (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mukdahan (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mukdahan (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mukdahan (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mukdahan (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mukdahan (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Mukono (District of Uganda)": [
            {
                "Region Name": "Mukono (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mukono (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mukono (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mukono (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mukono (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mukono (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mukono (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mukono (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mukono (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mukono (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mukono (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mukono (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mukono (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mukono (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mukono (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mukono (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mukono (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mukono (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mukono (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mukono (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mukono (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mukono (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mulanje (District of Malawi)": [
            {
                "Region Name": "Mulanje (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mulanje (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mulanje (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mulanje (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mulanje (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mulanje (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mulanje (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mulanje (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mulanje (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mulanje (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mulanje (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mulanje (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mulanje (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mulanje (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mulanje (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mulanje (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mulanje (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mulanje (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mulanje (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mulanje (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mulanje (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mulanje (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Mullaitivu (District of Sri Lanka)": [
            {
                "Region Name": "Mullaitivu (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mullaitivu (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mullaitivu (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mullaitivu (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mullaitivu (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mullaitivu (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mullaitivu (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mullaitivu (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mullaitivu (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mullaitivu (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mullaitivu (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mullaitivu (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mullaitivu (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mullaitivu (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mullaitivu (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mullaitivu (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mullaitivu (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mullaitivu (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mullaitivu (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mullaitivu (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mullaitivu (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mullaitivu (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Muramvya (Province of Burundi)": [
            {
                "Region Name": "Muramvya (Province of Burundi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muramvya (Province of Burundi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muramvya (Province of Burundi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muramvya (Province of Burundi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muramvya (Province of Burundi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Muramvya (Province of Burundi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muramvya (Province of Burundi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muramvya (Province of Burundi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muramvya (Province of Burundi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muramvya (Province of Burundi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muramvya (Province of Burundi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muramvya (Province of Burundi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muramvya (Province of Burundi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muramvya (Province of Burundi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muramvya (Province of Burundi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Muramvya (Province of Burundi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Muramvya (Province of Burundi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muramvya (Province of Burundi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muramvya (Province of Burundi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muramvya (Province of Burundi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muramvya (Province of Burundi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muramvya (Province of Burundi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Murang'a (County of Kenya)": [
            {
                "Region Name": "Murang'a (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Murang'a (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Murang'a (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Murang'a (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Murang'a (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Murang'a (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Murang'a (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Murang'a (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Murang'a (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Murang'a (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Murang'a (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murang'a (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Murang'a (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Murang'a (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murang'a (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Murang'a (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murang'a (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murang'a (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Murang'a (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murang'a (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murang'a (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murang'a (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mure\u0219 (County of Romania)": [
            {
                "Region Name": "Mure\u0219 (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mure\u0219 (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mure\u0219 (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mure\u0219 (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mure\u0219 (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mure\u0219 (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mure\u0219 (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mure\u0219 (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mure\u0219 (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mure\u0219 (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mure\u0219 (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mure\u0219 (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mure\u0219 (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mure\u0219 (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mure\u0219 (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mure\u0219 (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mure\u0219 (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mure\u0219 (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mure\u0219 (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Mure\u0219 (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mure\u0219 (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mure\u0219 (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Murmansk (Region of Russia)": [
            {
                "Region Name": "Murmansk (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Murmansk (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Murmansk (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Murmansk (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Murmansk (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Murmansk (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murmansk (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murmansk (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murmansk (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murmansk (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murmansk (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murmansk (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Murmansk (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murmansk (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murmansk (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murmansk (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Murmansk (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Murmansk (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murmansk (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murmansk (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Murmansk (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murmansk (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Murzuq (District of Libya)": [
            {
                "Region Name": "Murzuq (District of Libya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murzuq (District of Libya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murzuq (District of Libya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murzuq (District of Libya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murzuq (District of Libya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murzuq (District of Libya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murzuq (District of Libya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murzuq (District of Libya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murzuq (District of Libya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murzuq (District of Libya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Murzuq (District of Libya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murzuq (District of Libya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murzuq (District of Libya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murzuq (District of Libya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murzuq (District of Libya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murzuq (District of Libya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murzuq (District of Libya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murzuq (District of Libya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Murzuq (District of Libya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murzuq (District of Libya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murzuq (District of Libya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Murzuq (District of Libya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mus (Province of Turkey)": [
            {
                "Region Name": "Mus (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mus (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mus (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mus (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mus (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mus (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mus (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mus (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mus (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Mus (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mus (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mus (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mus (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mus (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mus (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mus (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mus (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mus (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mus (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mus (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mus (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mus (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Musandam (Province of Oman)": [
            {
                "Region Name": "Musandam (Province of Oman)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Musandam (Province of Oman)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Musandam (Province of Oman)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Musandam (Province of Oman)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Musandam (Province of Oman)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Musandam (Province of Oman)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Musandam (Province of Oman)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Musandam (Province of Oman)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Musandam (Province of Oman)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Musandam (Province of Oman)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Musandam (Province of Oman)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Musandam (Province of Oman)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Musandam (Province of Oman)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Musandam (Province of Oman)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Musandam (Province of Oman)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Musandam (Province of Oman)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Musandam (Province of Oman)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Musandam (Province of Oman)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Musandam (Province of Oman)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Musandam (Province of Oman)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Musandam (Province of Oman)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Musandam (Province of Oman)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Muscat (Province of Oman)": [
            {
                "Region Name": "Muscat (Province of Oman)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muscat (Province of Oman)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muscat (Province of Oman)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muscat (Province of Oman)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muscat (Province of Oman)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muscat (Province of Oman)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muscat (Province of Oman)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muscat (Province of Oman)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muscat (Province of Oman)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muscat (Province of Oman)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muscat (Province of Oman)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muscat (Province of Oman)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muscat (Province of Oman)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muscat (Province of Oman)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muscat (Province of Oman)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muscat (Province of Oman)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muscat (Province of Oman)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muscat (Province of Oman)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muscat (Province of Oman)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muscat (Province of Oman)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muscat (Province of Oman)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Muscat (Province of Oman)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Muyinga (Province of Burundi)": [
            {
                "Region Name": "Muyinga (Province of Burundi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Muyinga (Province of Burundi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Muyinga (Province of Burundi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Muyinga (Province of Burundi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Muyinga (Province of Burundi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Muyinga (Province of Burundi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Muyinga (Province of Burundi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Muyinga (Province of Burundi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Muyinga (Province of Burundi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Muyinga (Province of Burundi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Muyinga (Province of Burundi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Muyinga (Province of Burundi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Muyinga (Province of Burundi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Muyinga (Province of Burundi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Muyinga (Province of Burundi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Muyinga (Province of Burundi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Muyinga (Province of Burundi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Muyinga (Province of Burundi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Muyinga (Province of Burundi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Muyinga (Province of Burundi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Muyinga (Province of Burundi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Muyinga (Province of Burundi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Mwali (Autonomous Island of Comoros)": [
            {
                "Region Name": "Mwali (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwali (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwali (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwali (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwali (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwali (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwali (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwali (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwali (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwali (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwali (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwali (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwali (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwali (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwali (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwali (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwali (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwali (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwali (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwali (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwali (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwali (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mwanza (District of Malawi)": [
            {
                "Region Name": "Mwanza (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mwanza (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mwanza (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mwanza (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mwanza (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Mwanza (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Mwanza (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Mwanza (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mwanza (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Mwanza (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mwanza (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mwanza (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Mwanza (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mwanza (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mwanza (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mwanza (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mwanza (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mwanza (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mwanza (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mwanza (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mwanza (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mwanza (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Mwanza (Region of Tanzania)": [
            {
                "Region Name": "Mwanza (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mwanza (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mwanza (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mwanza (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mwanza (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mwanza (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mwanza (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mwanza (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mwanza (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mwanza (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwanza (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mwanza (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mwanza (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwanza (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwanza (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mwanza (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mwanza (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Mwanza (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mwanza (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mwanza (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Mwanza (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Mwanza (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Mwaro (Province of Burundi)": [
            {
                "Region Name": "Mwaro (Province of Burundi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwaro (Province of Burundi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwaro (Province of Burundi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwaro (Province of Burundi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwaro (Province of Burundi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwaro (Province of Burundi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwaro (Province of Burundi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwaro (Province of Burundi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwaro (Province of Burundi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwaro (Province of Burundi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwaro (Province of Burundi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwaro (Province of Burundi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwaro (Province of Burundi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwaro (Province of Burundi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwaro (Province of Burundi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwaro (Province of Burundi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwaro (Province of Burundi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwaro (Province of Burundi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwaro (Province of Burundi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwaro (Province of Burundi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mwaro (Province of Burundi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mwaro (Province of Burundi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mykolayiv (Region of Ukraine)": [
            {
                "Region Name": "Mykolayiv (Region of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mykolayiv (Region of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mykolayiv (Region of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mykolayiv (Region of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mykolayiv (Region of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mykolayiv (Region of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mykolayiv (Region of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mykolayiv (Region of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mykolayiv (Region of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mykolayiv (Region of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mykolayiv (Region of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mykolayiv (Region of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mykolayiv (Region of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mykolayiv (Region of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mykolayiv (Region of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mykolayiv (Region of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mykolayiv (Region of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mykolayiv (Region of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mykolayiv (Region of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mykolayiv (Region of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mykolayiv (Region of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mykolayiv (Region of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Mymensingh (Division of Bangladesh)": [
            {
                "Region Name": "Mymensingh (Division of Bangladesh)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mymensingh (Division of Bangladesh)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mymensingh (Division of Bangladesh)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mymensingh (Division of Bangladesh)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mymensingh (Division of Bangladesh)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mymensingh (Division of Bangladesh)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mymensingh (Division of Bangladesh)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mymensingh (Division of Bangladesh)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mymensingh (Division of Bangladesh)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mymensingh (Division of Bangladesh)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mymensingh (Division of Bangladesh)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mymensingh (Division of Bangladesh)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mymensingh (Division of Bangladesh)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mymensingh (Division of Bangladesh)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mymensingh (Division of Bangladesh)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mymensingh (Division of Bangladesh)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mymensingh (Division of Bangladesh)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mymensingh (Division of Bangladesh)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mymensingh (Division of Bangladesh)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Mymensingh (Division of Bangladesh)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mymensingh (Division of Bangladesh)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Mymensingh (Division of Bangladesh)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Mzimba (District of Malawi)": [
            {
                "Region Name": "Mzimba (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mzimba (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mzimba (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mzimba (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mzimba (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mzimba (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mzimba (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mzimba (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mzimba (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Mzimba (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mzimba (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Mzimba (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mzimba (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mzimba (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Mzimba (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mzimba (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mzimba (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Mzimba (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Mzimba (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mzimba (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Mzimba (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Mzimba (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "NA (Atol of Marshall Islands)": [
            {
                "Region Name": "NA (Atol of Marshall Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (Atol of Marshall Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (Atol of Marshall Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (Atol of Marshall Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (Atol of Marshall Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (Atol of Marshall Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (Atol of Marshall Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (Atol of Marshall Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (Atol of Marshall Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (Atol of Marshall Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (Atol of Marshall Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (Atol of Marshall Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (Atol of Marshall Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (Atol of Marshall Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (Atol of Marshall Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (Atol of Marshall Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (Atol of Marshall Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (Atol of Marshall Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (Atol of Marshall Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (Atol of Marshall Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (Atol of Marshall Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (Atol of Marshall Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "NA (NA of NA)": [
            {
                "Region Name": "NA (NA of NA)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of NA)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of NA)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of NA)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of NA)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of NA)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of NA)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of NA)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of NA)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of NA)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of NA)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of NA)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of NA)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of NA)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of NA)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of NA)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of NA)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of NA)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of NA)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of NA)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of NA)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of NA)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "NA (NA of Netherlands)": [
            {
                "Region Name": "NA (NA of Netherlands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of Netherlands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of Netherlands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of Netherlands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of Netherlands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of Netherlands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of Netherlands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of Netherlands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of Netherlands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of Netherlands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of Netherlands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of Netherlands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of Netherlands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of Netherlands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of Netherlands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of Netherlands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of Netherlands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of Netherlands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of Netherlands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of Netherlands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of Netherlands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NA (NA of Netherlands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Na\xe2ma (Province of Algeria)": [
            {
                "Region Name": "Na\xe2ma (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Na\xe2ma (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Na\xe2ma (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Na\xe2ma (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Na\xe2ma (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Na\xe2ma (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Na\xe2ma (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Na\xe2ma (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Na\xe2ma (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Na\xe2ma (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Na\xe2ma (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Na\xe2ma (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Na\xe2ma (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Na\xe2ma (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Na\xe2ma (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Na\xe2ma (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Na\xe2ma (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Na\xe2ma (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Na\xe2ma (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Na\xe2ma (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Na\xe2ma (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Na\xe2ma (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nabatiyeh (Governorate of Lebanon)": [
            {
                "Region Name": "Nabatiyeh (Governorate of Lebanon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabatiyeh (Governorate of Lebanon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabatiyeh (Governorate of Lebanon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabatiyeh (Governorate of Lebanon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabatiyeh (Governorate of Lebanon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nabatiyeh (Governorate of Lebanon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nabatiyeh (Governorate of Lebanon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabatiyeh (Governorate of Lebanon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabatiyeh (Governorate of Lebanon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabatiyeh (Governorate of Lebanon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabatiyeh (Governorate of Lebanon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabatiyeh (Governorate of Lebanon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabatiyeh (Governorate of Lebanon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabatiyeh (Governorate of Lebanon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabatiyeh (Governorate of Lebanon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabatiyeh (Governorate of Lebanon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabatiyeh (Governorate of Lebanon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabatiyeh (Governorate of Lebanon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabatiyeh (Governorate of Lebanon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nabatiyeh (Governorate of Lebanon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabatiyeh (Governorate of Lebanon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabatiyeh (Governorate of Lebanon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nabeul (Governorate of Tunisia)": [
            {
                "Region Name": "Nabeul (Governorate of Tunisia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nabeul (Governorate of Tunisia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nabeul (Governorate of Tunisia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabeul (Governorate of Tunisia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabeul (Governorate of Tunisia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabeul (Governorate of Tunisia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabeul (Governorate of Tunisia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabeul (Governorate of Tunisia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabeul (Governorate of Tunisia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabeul (Governorate of Tunisia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nabeul (Governorate of Tunisia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nabeul (Governorate of Tunisia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nabeul (Governorate of Tunisia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nabeul (Governorate of Tunisia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabeul (Governorate of Tunisia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabeul (Governorate of Tunisia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nabeul (Governorate of Tunisia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabeul (Governorate of Tunisia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nabeul (Governorate of Tunisia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nabeul (Governorate of Tunisia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nabeul (Governorate of Tunisia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nabeul (Governorate of Tunisia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Nagaland (State of India)": [
            {
                "Region Name": "Nagaland (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nagaland (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nagaland (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nagaland (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nagaland (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nagaland (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nagaland (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nagaland (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nagaland (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nagaland (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nagaland (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nagaland (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nagaland (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nagaland (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nagaland (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nagaland (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nagaland (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nagaland (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nagaland (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nagaland (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nagaland (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nagaland (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Nagano (Prefecture of Japan)": [
            {
                "Region Name": "Nagano (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nagano (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nagano (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nagano (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nagano (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nagano (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nagano (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nagano (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nagano (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nagano (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nagano (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nagano (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nagano (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nagano (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nagano (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nagano (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nagano (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nagano (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nagano (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nagano (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nagano (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nagano (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Naguabo (Municipality of Puerto Rico)": [
            {
                "Region Name": "Naguabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naguabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naguabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naguabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naguabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naguabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naguabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naguabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naguabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naguabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naguabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naguabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naguabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naguabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naguabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naguabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naguabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naguabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naguabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naguabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naguabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naguabo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nairobi (County of Kenya)": [
            {
                "Region Name": "Nairobi (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nairobi (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nairobi (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nairobi (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nairobi (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nairobi (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nairobi (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nairobi (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nairobi (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nairobi (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nairobi (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nairobi (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nairobi (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nairobi (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nairobi (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nairobi (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nairobi (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nairobi (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nairobi (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nairobi (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nairobi (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nairobi (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Najran (Province of Saudi Arabia)": [
            {
                "Region Name": "Najran (Province of Saudi Arabia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Najran (Province of Saudi Arabia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Najran (Province of Saudi Arabia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Najran (Province of Saudi Arabia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Najran (Province of Saudi Arabia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Najran (Province of Saudi Arabia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Najran (Province of Saudi Arabia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Najran (Province of Saudi Arabia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Najran (Province of Saudi Arabia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Najran (Province of Saudi Arabia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Najran (Province of Saudi Arabia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Najran (Province of Saudi Arabia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Najran (Province of Saudi Arabia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Najran (Province of Saudi Arabia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Najran (Province of Saudi Arabia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Najran (Province of Saudi Arabia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Najran (Province of Saudi Arabia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Najran (Province of Saudi Arabia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Najran (Province of Saudi Arabia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Najran (Province of Saudi Arabia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Najran (Province of Saudi Arabia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Najran (Province of Saudi Arabia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nakapiripirit (District of Uganda)": [
            {
                "Region Name": "Nakapiripirit (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Nakapiripirit (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Nakapiripirit (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Nakapiripirit (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Nakapiripirit (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Nakapiripirit (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Nakapiripirit (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Nakapiripirit (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Nakapiripirit (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Nakapiripirit (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Nakapiripirit (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Nakapiripirit (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nakapiripirit (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nakapiripirit (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nakapiripirit (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nakapiripirit (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Nakapiripirit (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nakapiripirit (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Nakapiripirit (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Nakapiripirit (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Nakapiripirit (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Nakapiripirit (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 19
            }
        ],
        "Nakasongola (District of Uganda)": [
            {
                "Region Name": "Nakasongola (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nakasongola (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakasongola (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nakasongola (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nakasongola (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nakasongola (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nakasongola (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nakasongola (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakasongola (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakasongola (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nakasongola (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakasongola (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakasongola (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nakasongola (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nakasongola (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakasongola (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nakasongola (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nakasongola (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakasongola (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakasongola (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakasongola (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nakasongola (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Nakhchivan (Region of Azerbaijan)": [
            {
                "Region Name": "Nakhchivan (Region of Azerbaijan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nakhchivan (Region of Azerbaijan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nakhchivan (Region of Azerbaijan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nakhchivan (Region of Azerbaijan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nakhchivan (Region of Azerbaijan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nakhchivan (Region of Azerbaijan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nakhchivan (Region of Azerbaijan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nakhchivan (Region of Azerbaijan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nakhchivan (Region of Azerbaijan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nakhchivan (Region of Azerbaijan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nakhchivan (Region of Azerbaijan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nakhchivan (Region of Azerbaijan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Nakhchivan (Region of Azerbaijan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nakhchivan (Region of Azerbaijan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nakhchivan (Region of Azerbaijan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nakhchivan (Region of Azerbaijan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nakhchivan (Region of Azerbaijan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nakhchivan (Region of Azerbaijan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nakhchivan (Region of Azerbaijan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nakhchivan (Region of Azerbaijan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhchivan (Region of Azerbaijan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nakhchivan (Region of Azerbaijan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nakhon Nayok (Province of Thailand)": [
            {
                "Region Name": "Nakhon Nayok (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nakhon Nayok (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Nayok (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakhon Nayok (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nakhon Nayok (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nakhon Nayok (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakhon Nayok (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Nayok (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nakhon Nayok (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakhon Nayok (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Nayok (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Nakhon Nayok (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nakhon Nayok (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nakhon Nayok (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Nayok (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Nayok (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nakhon Nayok (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nakhon Nayok (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Nayok (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Nayok (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Nayok (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nakhon Nayok (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Nakhon Pathom (Province of Thailand)": [
            {
                "Region Name": "Nakhon Pathom (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakhon Pathom (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nakhon Pathom (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nakhon Pathom (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nakhon Pathom (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Pathom (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Nakhon Pathom (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nakhon Pathom (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nakhon Pathom (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nakhon Pathom (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakhon Pathom (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nakhon Pathom (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Pathom (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Pathom (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Pathom (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nakhon Pathom (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nakhon Pathom (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Pathom (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nakhon Pathom (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nakhon Pathom (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nakhon Pathom (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nakhon Pathom (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Nakhon Phanom (Province of Thailand)": [
            {
                "Region Name": "Nakhon Phanom (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakhon Phanom (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Phanom (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nakhon Phanom (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Phanom (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakhon Phanom (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nakhon Phanom (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Phanom (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nakhon Phanom (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Phanom (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nakhon Phanom (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Phanom (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nakhon Phanom (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nakhon Phanom (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nakhon Phanom (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Phanom (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Phanom (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Phanom (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Phanom (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nakhon Phanom (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Phanom (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nakhon Phanom (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Nakhon Ratchasima (Province of Thailand)": [
            {
                "Region Name": "Nakhon Ratchasima (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Ratchasima (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nakhon Ratchasima (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakhon Ratchasima (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nakhon Ratchasima (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakhon Ratchasima (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakhon Ratchasima (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Ratchasima (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakhon Ratchasima (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakhon Ratchasima (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakhon Ratchasima (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nakhon Ratchasima (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Ratchasima (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nakhon Ratchasima (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakhon Ratchasima (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakhon Ratchasima (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakhon Ratchasima (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakhon Ratchasima (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nakhon Ratchasima (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nakhon Ratchasima (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Ratchasima (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nakhon Ratchasima (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Nakhon Sawan (Province of Thailand)": [
            {
                "Region Name": "Nakhon Sawan (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Sawan (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nakhon Sawan (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nakhon Sawan (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nakhon Sawan (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakhon Sawan (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakhon Sawan (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakhon Sawan (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nakhon Sawan (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nakhon Sawan (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nakhon Sawan (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nakhon Sawan (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakhon Sawan (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nakhon Sawan (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nakhon Sawan (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakhon Sawan (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nakhon Sawan (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nakhon Sawan (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nakhon Sawan (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Sawan (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakhon Sawan (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nakhon Sawan (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Nakhon Si Thammarat (Province of Thailand)": [
            {
                "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nakhon Si Thammarat (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nakuru (County of Kenya)": [
            {
                "Region Name": "Nakuru (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nakuru (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakuru (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakuru (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nakuru (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nakuru (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nakuru (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakuru (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakuru (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Nakuru (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakuru (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakuru (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakuru (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nakuru (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakuru (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakuru (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nakuru (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nakuru (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakuru (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nakuru (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nakuru (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nakuru (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Nalut (District of Libya)": [
            {
                "Region Name": "Nalut (District of Libya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nalut (District of Libya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nalut (District of Libya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nalut (District of Libya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nalut (District of Libya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nalut (District of Libya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nalut (District of Libya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nalut (District of Libya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nalut (District of Libya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nalut (District of Libya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nalut (District of Libya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nalut (District of Libya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nalut (District of Libya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nalut (District of Libya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nalut (District of Libya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nalut (District of Libya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nalut (District of Libya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nalut (District of Libya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nalut (District of Libya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nalut (District of Libya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nalut (District of Libya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nalut (District of Libya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nam \u0110\u1ECBnh (Province of Vietnam)": [
            {
                "Region Name": "Nam \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nam \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nam \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nam \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nam \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nam \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nam \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nam \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nam \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nam \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nam \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nam \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nam \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nam \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nam \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nam \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nam \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nam \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nam \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nam \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nam \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nam \u0110\u1ECBnh (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Namangan (Region of Uzbekistan)": [
            {
                "Region Name": "Namangan (Region of Uzbekistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Namangan (Region of Uzbekistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namangan (Region of Uzbekistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Namangan (Region of Uzbekistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Namangan (Region of Uzbekistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namangan (Region of Uzbekistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namangan (Region of Uzbekistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namangan (Region of Uzbekistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namangan (Region of Uzbekistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namangan (Region of Uzbekistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namangan (Region of Uzbekistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namangan (Region of Uzbekistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namangan (Region of Uzbekistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namangan (Region of Uzbekistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namangan (Region of Uzbekistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namangan (Region of Uzbekistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namangan (Region of Uzbekistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namangan (Region of Uzbekistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namangan (Region of Uzbekistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namangan (Region of Uzbekistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namangan (Region of Uzbekistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namangan (Region of Uzbekistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Namibe (Province of Angola)": [
            {
                "Region Name": "Namibe (Province of Angola)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Namibe (Province of Angola)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Namibe (Province of Angola)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Namibe (Province of Angola)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Namibe (Province of Angola)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namibe (Province of Angola)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Namibe (Province of Angola)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Namibe (Province of Angola)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Namibe (Province of Angola)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Namibe (Province of Angola)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Namibe (Province of Angola)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Namibe (Province of Angola)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Namibe (Province of Angola)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Namibe (Province of Angola)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Namibe (Province of Angola)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Namibe (Province of Angola)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Namibe (Province of Angola)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Namibe (Province of Angola)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Namibe (Province of Angola)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Namibe (Province of Angola)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Namibe (Province of Angola)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Namibe (Province of Angola)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Namorik (Atol of Marshall Islands)": [
            {
                "Region Name": "Namorik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namorik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namorik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namorik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namorik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namorik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namorik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namorik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namorik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namorik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namorik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namorik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namorik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namorik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namorik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namorik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namorik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namorik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namorik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namorik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namorik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namorik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nampula (Province of Mozambique)": [
            {
                "Region Name": "Nampula (Province of Mozambique)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Nampula (Province of Mozambique)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Nampula (Province of Mozambique)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Nampula (Province of Mozambique)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Nampula (Province of Mozambique)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Nampula (Province of Mozambique)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Nampula (Province of Mozambique)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Nampula (Province of Mozambique)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Nampula (Province of Mozambique)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Nampula (Province of Mozambique)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Nampula (Province of Mozambique)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Nampula (Province of Mozambique)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Nampula (Province of Mozambique)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Nampula (Province of Mozambique)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Nampula (Province of Mozambique)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Nampula (Province of Mozambique)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Nampula (Province of Mozambique)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Nampula (Province of Mozambique)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Nampula (Province of Mozambique)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Nampula (Province of Mozambique)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nampula (Province of Mozambique)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Nampula (Province of Mozambique)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 22
            }
        ],
        "Namu (Atol of Marshall Islands)": [
            {
                "Region Name": "Namu (Atol of Marshall Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namu (Atol of Marshall Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namu (Atol of Marshall Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namu (Atol of Marshall Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namu (Atol of Marshall Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namu (Atol of Marshall Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namu (Atol of Marshall Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namu (Atol of Marshall Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namu (Atol of Marshall Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namu (Atol of Marshall Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namu (Atol of Marshall Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namu (Atol of Marshall Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namu (Atol of Marshall Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namu (Atol of Marshall Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namu (Atol of Marshall Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namu (Atol of Marshall Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namu (Atol of Marshall Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namu (Atol of Marshall Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namu (Atol of Marshall Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namu (Atol of Marshall Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namu (Atol of Marshall Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Namu (Atol of Marshall Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nan (Province of Thailand)": [
            {
                "Region Name": "Nan (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nan (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nan (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nan (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nan (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nan (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nan (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nan (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nan (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nan (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nan (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nan (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nan (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nan (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nan (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nan (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nan (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nan (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nan (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nan (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nan (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nan (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Nana-Gr\xe9bizi (Economic Prefecture of Central African Republic)": [
            {
                "Region Name": "Nana-Gr\xe9bizi (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Nana-Gr\xe9bizi (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nana-Gr\xe9bizi (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nana-Gr\xe9bizi (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nana-Gr\xe9bizi (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Nana-Gr\xe9bizi (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nana-Gr\xe9bizi (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nana-Gr\xe9bizi (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nana-Gr\xe9bizi (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nana-Gr\xe9bizi (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nana-Gr\xe9bizi (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nana-Gr\xe9bizi (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nana-Gr\xe9bizi (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nana-Gr\xe9bizi (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Nana-Gr\xe9bizi (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nana-Gr\xe9bizi (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nana-Gr\xe9bizi (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nana-Gr\xe9bizi (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Nana-Gr\xe9bizi (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nana-Gr\xe9bizi (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Nana-Gr\xe9bizi (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nana-Gr\xe9bizi (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Nana-Mamb\xe9r\xe9 (Prefecture of Central African Republic)": [
            {
                "Region Name": "Nana-Mamb\xe9r\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Nana-Mamb\xe9r\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Nana-Mamb\xe9r\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nana-Mamb\xe9r\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nana-Mamb\xe9r\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Nana-Mamb\xe9r\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nana-Mamb\xe9r\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nana-Mamb\xe9r\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nana-Mamb\xe9r\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nana-Mamb\xe9r\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nana-Mamb\xe9r\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nana-Mamb\xe9r\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nana-Mamb\xe9r\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nana-Mamb\xe9r\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nana-Mamb\xe9r\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Nana-Mamb\xe9r\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nana-Mamb\xe9r\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nana-Mamb\xe9r\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nana-Mamb\xe9r\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nana-Mamb\xe9r\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nana-Mamb\xe9r\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nana-Mamb\xe9r\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Nandi (County of Kenya)": [
            {
                "Region Name": "Nandi (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nandi (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nandi (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nandi (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nandi (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nandi (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nandi (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nandi (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nandi (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nandi (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nandi (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nandi (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nandi (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nandi (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nandi (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nandi (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nandi (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nandi (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nandi (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nandi (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nandi (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nandi (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nangarhar (Province of Afghanistan)": [
            {
                "Region Name": "Nangarhar (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nangarhar (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nangarhar (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nangarhar (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nangarhar (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nangarhar (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nangarhar (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nangarhar (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nangarhar (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nangarhar (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nangarhar (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nangarhar (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nangarhar (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nangarhar (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nangarhar (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nangarhar (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nangarhar (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nangarhar (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nangarhar (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nangarhar (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nangarhar (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nangarhar (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nanumanga (Island Council of Tuvalu)": [
            {
                "Region Name": "Nanumanga (Island Council of Tuvalu)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumanga (Island Council of Tuvalu)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumanga (Island Council of Tuvalu)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumanga (Island Council of Tuvalu)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumanga (Island Council of Tuvalu)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumanga (Island Council of Tuvalu)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumanga (Island Council of Tuvalu)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumanga (Island Council of Tuvalu)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumanga (Island Council of Tuvalu)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumanga (Island Council of Tuvalu)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumanga (Island Council of Tuvalu)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumanga (Island Council of Tuvalu)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumanga (Island Council of Tuvalu)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumanga (Island Council of Tuvalu)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumanga (Island Council of Tuvalu)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumanga (Island Council of Tuvalu)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumanga (Island Council of Tuvalu)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumanga (Island Council of Tuvalu)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumanga (Island Council of Tuvalu)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumanga (Island Council of Tuvalu)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumanga (Island Council of Tuvalu)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumanga (Island Council of Tuvalu)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nanumea (Island Council of Tuvalu)": [
            {
                "Region Name": "Nanumea (Island Council of Tuvalu)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumea (Island Council of Tuvalu)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumea (Island Council of Tuvalu)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumea (Island Council of Tuvalu)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumea (Island Council of Tuvalu)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumea (Island Council of Tuvalu)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumea (Island Council of Tuvalu)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumea (Island Council of Tuvalu)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumea (Island Council of Tuvalu)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumea (Island Council of Tuvalu)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumea (Island Council of Tuvalu)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumea (Island Council of Tuvalu)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumea (Island Council of Tuvalu)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumea (Island Council of Tuvalu)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumea (Island Council of Tuvalu)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumea (Island Council of Tuvalu)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumea (Island Council of Tuvalu)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumea (Island Council of Tuvalu)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumea (Island Council of Tuvalu)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumea (Island Council of Tuvalu)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumea (Island Council of Tuvalu)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nanumea (Island Council of Tuvalu)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Naoasaki (Prefecture of Japan)": [
            {
                "Region Name": "Naoasaki (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naoasaki (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naoasaki (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naoasaki (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Naoasaki (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naoasaki (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Naoasaki (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naoasaki (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Naoasaki (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naoasaki (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naoasaki (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naoasaki (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Naoasaki (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naoasaki (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Naoasaki (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naoasaki (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naoasaki (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naoasaki (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Naoasaki (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naoasaki (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naoasaki (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naoasaki (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Napo (Province of Ecuador)": [
            {
                "Region Name": "Napo (Province of Ecuador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Napo (Province of Ecuador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Napo (Province of Ecuador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Napo (Province of Ecuador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Napo (Province of Ecuador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Napo (Province of Ecuador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Napo (Province of Ecuador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Napo (Province of Ecuador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Napo (Province of Ecuador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Napo (Province of Ecuador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Napo (Province of Ecuador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Napo (Province of Ecuador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Napo (Province of Ecuador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Napo (Province of Ecuador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Napo (Province of Ecuador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Napo (Province of Ecuador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Napo (Province of Ecuador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Napo (Province of Ecuador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Napo (Province of Ecuador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Napo (Province of Ecuador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Napo (Province of Ecuador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Napo (Province of Ecuador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nara (Prefecture of Japan)": [
            {
                "Region Name": "Nara (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nara (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nara (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nara (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nara (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nara (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nara (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nara (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nara (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nara (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nara (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nara (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nara (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nara (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nara (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nara (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nara (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nara (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nara (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nara (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nara (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nara (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Naranjito (Municipality of Puerto Rico)": [
            {
                "Region Name": "Naranjito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naranjito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naranjito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naranjito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naranjito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naranjito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naranjito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naranjito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naranjito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naranjito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naranjito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naranjito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naranjito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naranjito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naranjito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naranjito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naranjito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naranjito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naranjito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naranjito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naranjito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naranjito (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Narathiwat (Province of Thailand)": [
            {
                "Region Name": "Narathiwat (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Narathiwat (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Narathiwat (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Narathiwat (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Narathiwat (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Narathiwat (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Narathiwat (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Narathiwat (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Narathiwat (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Narathiwat (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Narathiwat (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Narathiwat (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Narathiwat (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Narathiwat (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Narathiwat (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Narathiwat (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Narathiwat (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Narathiwat (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Narathiwat (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Narathiwat (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Narathiwat (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Narathiwat (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nari\xf1o (Department of Colombia)": [
            {
                "Region Name": "Nari\xf1o (Department of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nari\xf1o (Department of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nari\xf1o (Department of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nari\xf1o (Department of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nari\xf1o (Department of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nari\xf1o (Department of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nari\xf1o (Department of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nari\xf1o (Department of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nari\xf1o (Department of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nari\xf1o (Department of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nari\xf1o (Department of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nari\xf1o (Department of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nari\xf1o (Department of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nari\xf1o (Department of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nari\xf1o (Department of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nari\xf1o (Department of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nari\xf1o (Department of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nari\xf1o (Department of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nari\xf1o (Department of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nari\xf1o (Department of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nari\xf1o (Department of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nari\xf1o (Department of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Narok (County of Kenya)": [
            {
                "Region Name": "Narok (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Narok (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Narok (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Narok (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Narok (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Narok (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Narok (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Narok (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Narok (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Narok (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Narok (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Narok (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Narok (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Narok (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Narok (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Narok (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Narok (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Narok (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Narok (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Narok (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Narok (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Narok (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 60
            }
        ],
        "Naryn (Province of Kyrgyzstan)": [
            {
                "Region Name": "Naryn (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Naryn (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Naryn (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Naryn (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Naryn (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Naryn (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Naryn (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naryn (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naryn (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Naryn (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Naryn (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Naryn (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Naryn (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Naryn (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Naryn (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Naryn (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Naryn (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naryn (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naryn (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Naryn (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Naryn (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Naryn (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nasarawa (State of Nigeria)": [
            {
                "Region Name": "Nasarawa (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nasarawa (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nasarawa (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Nasarawa (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nasarawa (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nasarawa (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nasarawa (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nasarawa (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nasarawa (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nasarawa (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nasarawa (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nasarawa (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nasarawa (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nasarawa (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nasarawa (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nasarawa (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nasarawa (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nasarawa (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nasarawa (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nasarawa (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nasarawa (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nasarawa (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Nassa (Province of Mozambique)": [
            {
                "Region Name": "Nassa (Province of Mozambique)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Nassa (Province of Mozambique)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Nassa (Province of Mozambique)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nassa (Province of Mozambique)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Nassa (Province of Mozambique)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Nassa (Province of Mozambique)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Nassa (Province of Mozambique)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Nassa (Province of Mozambique)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Nassa (Province of Mozambique)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Nassa (Province of Mozambique)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Nassa (Province of Mozambique)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nassa (Province of Mozambique)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nassa (Province of Mozambique)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Nassa (Province of Mozambique)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nassa (Province of Mozambique)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nassa (Province of Mozambique)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nassa (Province of Mozambique)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Nassa (Province of Mozambique)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Nassa (Province of Mozambique)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Nassa (Province of Mozambique)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Nassa (Province of Mozambique)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Nassa (Province of Mozambique)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "National Capital District (District of Papua New Guinea)": [
            {
                "Region Name": "National Capital District (District of Papua New Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "National Capital District (District of Papua New Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "National Capital District (District of Papua New Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "National Capital District (District of Papua New Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "National Capital District (District of Papua New Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "National Capital District (District of Papua New Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "National Capital District (District of Papua New Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "National Capital District (District of Papua New Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "National Capital District (District of Papua New Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "National Capital District (District of Papua New Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "National Capital District (District of Papua New Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "National Capital District (District of Papua New Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "National Capital District (District of Papua New Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "National Capital District (District of Papua New Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "National Capital District (District of Papua New Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "National Capital District (District of Papua New Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "National Capital District (District of Papua New Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "National Capital District (District of Papua New Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "National Capital District (District of Papua New Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "National Capital District (District of Papua New Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "National Capital District (District of Papua New Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "National Capital District (District of Papua New Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Navassa (Island of United States Minor Outlying Isl)": [
            {
                "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navassa (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Navoiy (Region of Uzbekistan)": [
            {
                "Region Name": "Navoiy (Region of Uzbekistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Navoiy (Region of Uzbekistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Navoiy (Region of Uzbekistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Navoiy (Region of Uzbekistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Navoiy (Region of Uzbekistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navoiy (Region of Uzbekistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navoiy (Region of Uzbekistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navoiy (Region of Uzbekistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navoiy (Region of Uzbekistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Navoiy (Region of Uzbekistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navoiy (Region of Uzbekistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navoiy (Region of Uzbekistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Navoiy (Region of Uzbekistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navoiy (Region of Uzbekistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Navoiy (Region of Uzbekistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "Navoiy (Region of Uzbekistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navoiy (Region of Uzbekistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navoiy (Region of Uzbekistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Navoiy (Region of Uzbekistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navoiy (Region of Uzbekistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navoiy (Region of Uzbekistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Navoiy (Region of Uzbekistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nayarit (State of M\xe9xico)": [
            {
                "Region Name": "Nayarit (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nayarit (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nayarit (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nayarit (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Nayarit (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nayarit (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Nayarit (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nayarit (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nayarit (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nayarit (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Nayarit (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Nayarit (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nayarit (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nayarit (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nayarit (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nayarit (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Nayarit (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nayarit (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Nayarit (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nayarit (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nayarit (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nayarit (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Naypyitaw (Union territory of Myanmar)": [
            {
                "Region Name": "Naypyitaw (Union territory of Myanmar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naypyitaw (Union territory of Myanmar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naypyitaw (Union territory of Myanmar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naypyitaw (Union territory of Myanmar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naypyitaw (Union territory of Myanmar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naypyitaw (Union territory of Myanmar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naypyitaw (Union territory of Myanmar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naypyitaw (Union territory of Myanmar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naypyitaw (Union territory of Myanmar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naypyitaw (Union territory of Myanmar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naypyitaw (Union territory of Myanmar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naypyitaw (Union territory of Myanmar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naypyitaw (Union territory of Myanmar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naypyitaw (Union territory of Myanmar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naypyitaw (Union territory of Myanmar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naypyitaw (Union territory of Myanmar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naypyitaw (Union territory of Myanmar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naypyitaw (Union territory of Myanmar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naypyitaw (Union territory of Myanmar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naypyitaw (Union territory of Myanmar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naypyitaw (Union territory of Myanmar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Naypyitaw (Union territory of Myanmar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "NCT of Delhi (Union Territory of India)": [
            {
                "Region Name": "NCT of Delhi (Union Territory of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "NCT of Delhi (Union Territory of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "NCT of Delhi (Union Territory of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "NCT of Delhi (Union Territory of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "NCT of Delhi (Union Territory of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NCT of Delhi (Union Territory of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NCT of Delhi (Union Territory of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NCT of Delhi (Union Territory of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NCT of Delhi (Union Territory of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NCT of Delhi (Union Territory of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NCT of Delhi (Union Territory of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "NCT of Delhi (Union Territory of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "NCT of Delhi (Union Territory of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NCT of Delhi (Union Territory of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NCT of Delhi (Union Territory of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "NCT of Delhi (Union Territory of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "NCT of Delhi (Union Territory of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "NCT of Delhi (Union Territory of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "NCT of Delhi (Union Territory of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "NCT of Delhi (Union Territory of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "NCT of Delhi (Union Territory of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "NCT of Delhi (Union Territory of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Neam\u021B (County of Romania)": [
            {
                "Region Name": "Neam\u021B (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neam\u021B (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Neam\u021B (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neam\u021B (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neam\u021B (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Neam\u021B (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neam\u021B (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Neam\u021B (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Neam\u021B (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Neam\u021B (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Neam\u021B (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Neam\u021B (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Neam\u021B (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neam\u021B (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Neam\u021B (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neam\u021B (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neam\u021B (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neam\u021B (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Neam\u021B (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neam\u021B (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Neam\u021B (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Neam\u021B (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nebbi (District of Uganda)": [
            {
                "Region Name": "Nebbi (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nebbi (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nebbi (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nebbi (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Nebbi (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nebbi (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nebbi (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nebbi (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nebbi (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nebbi (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nebbi (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nebbi (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nebbi (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Nebbi (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nebbi (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nebbi (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nebbi (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nebbi (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nebbi (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nebbi (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Nebbi (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nebbi (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Nebraska (State of United States)": [
            {
                "Region Name": "Nebraska (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nebraska (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nebraska (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nebraska (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nebraska (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nebraska (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nebraska (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nebraska (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nebraska (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nebraska (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nebraska (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Nebraska (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nebraska (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nebraska (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nebraska (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nebraska (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nebraska (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nebraska (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nebraska (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nebraska (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nebraska (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Nebraska (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "\xd1eembuc\xfa (Department of Paraguay)": [
            {
                "Region Name": "\xd1eembuc\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "\xd1eembuc\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "\xd1eembuc\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "\xd1eembuc\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\xd1eembuc\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "\xd1eembuc\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xd1eembuc\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\xd1eembuc\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "\xd1eembuc\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xd1eembuc\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\xd1eembuc\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\xd1eembuc\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\xd1eembuc\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xd1eembuc\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xd1eembuc\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xd1eembuc\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "\xd1eembuc\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "\xd1eembuc\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "\xd1eembuc\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "\xd1eembuc\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "\xd1eembuc\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "\xd1eembuc\xfa (Department of Paraguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Negeri Sembilan (State of Malaysia)": [
            {
                "Region Name": "Negeri Sembilan (State of Malaysia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Negeri Sembilan (State of Malaysia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negeri Sembilan (State of Malaysia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Negeri Sembilan (State of Malaysia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negeri Sembilan (State of Malaysia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negeri Sembilan (State of Malaysia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Negeri Sembilan (State of Malaysia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negeri Sembilan (State of Malaysia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negeri Sembilan (State of Malaysia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Negeri Sembilan (State of Malaysia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negeri Sembilan (State of Malaysia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negeri Sembilan (State of Malaysia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negeri Sembilan (State of Malaysia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negeri Sembilan (State of Malaysia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negeri Sembilan (State of Malaysia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negeri Sembilan (State of Malaysia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negeri Sembilan (State of Malaysia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negeri Sembilan (State of Malaysia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negeri Sembilan (State of Malaysia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negeri Sembilan (State of Malaysia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negeri Sembilan (State of Malaysia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negeri Sembilan (State of Malaysia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Negotino (Municipality of North Macedonia)": [
            {
                "Region Name": "Negotino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negotino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Negotino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negotino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negotino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negotino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negotino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negotino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negotino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negotino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Negotino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negotino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negotino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negotino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negotino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Negotino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negotino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negotino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Negotino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negotino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Negotino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Negotino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Negros Occidental (Province of Philippines)": [
            {
                "Region Name": "Negros Occidental (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Negros Occidental (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Negros Occidental (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Negros Occidental (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Negros Occidental (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Negros Occidental (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Negros Occidental (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negros Occidental (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Negros Occidental (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Negros Occidental (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Negros Occidental (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Negros Occidental (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Negros Occidental (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Negros Occidental (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Negros Occidental (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Negros Occidental (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Negros Occidental (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Negros Occidental (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Negros Occidental (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Negros Occidental (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Negros Occidental (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negros Occidental (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Negros Oriental (Province of Philippines)": [
            {
                "Region Name": "Negros Oriental (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Negros Oriental (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Negros Oriental (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Negros Oriental (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Negros Oriental (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Negros Oriental (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Negros Oriental (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negros Oriental (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Negros Oriental (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Negros Oriental (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negros Oriental (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negros Oriental (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Negros Oriental (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Negros Oriental (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Negros Oriental (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negros Oriental (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negros Oriental (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negros Oriental (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negros Oriental (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Negros Oriental (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negros Oriental (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Negros Oriental (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nei Mongol (Autonomous Region of China)": [
            {
                "Region Name": "Nei Mongol (Autonomous Region of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nei Mongol (Autonomous Region of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Nei Mongol (Autonomous Region of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nei Mongol (Autonomous Region of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nei Mongol (Autonomous Region of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nei Mongol (Autonomous Region of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Nei Mongol (Autonomous Region of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Nei Mongol (Autonomous Region of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nei Mongol (Autonomous Region of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nei Mongol (Autonomous Region of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nei Mongol (Autonomous Region of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nei Mongol (Autonomous Region of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nei Mongol (Autonomous Region of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nei Mongol (Autonomous Region of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nei Mongol (Autonomous Region of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nei Mongol (Autonomous Region of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nei Mongol (Autonomous Region of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nei Mongol (Autonomous Region of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nei Mongol (Autonomous Region of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nei Mongol (Autonomous Region of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nei Mongol (Autonomous Region of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nei Mongol (Autonomous Region of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Nelson (Region of New Zealand)": [
            {
                "Region Name": "Nelson (Region of New Zealand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nelson (Region of New Zealand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nelson (Region of New Zealand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nelson (Region of New Zealand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nelson (Region of New Zealand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nelson (Region of New Zealand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nelson (Region of New Zealand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nelson (Region of New Zealand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nelson (Region of New Zealand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nelson (Region of New Zealand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nelson (Region of New Zealand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nelson (Region of New Zealand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nelson (Region of New Zealand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nelson (Region of New Zealand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nelson (Region of New Zealand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nelson (Region of New Zealand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nelson (Region of New Zealand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nelson (Region of New Zealand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nelson (Region of New Zealand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nelson (Region of New Zealand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nelson (Region of New Zealand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nelson (Region of New Zealand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nenets (Autonomous Province of Russia)": [
            {
                "Region Name": "Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Neno (District of Malawi)": [
            {
                "Region Name": "Neno (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Neno (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Neno (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Neno (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Neno (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Neno (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Neno (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Neno (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Neno (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Neno (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Neno (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Neno (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Neno (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Neno (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Neno (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Neno (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Neno (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Neno (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Neno (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Neno (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Neno (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Neno (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Neuch\xe2tel (Canton of Switzerland)": [
            {
                "Region Name": "Neuch\xe2tel (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neuch\xe2tel (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neuch\xe2tel (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neuch\xe2tel (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neuch\xe2tel (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neuch\xe2tel (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neuch\xe2tel (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neuch\xe2tel (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neuch\xe2tel (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neuch\xe2tel (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neuch\xe2tel (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neuch\xe2tel (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neuch\xe2tel (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neuch\xe2tel (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neuch\xe2tel (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neuch\xe2tel (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neuch\xe2tel (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neuch\xe2tel (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neuch\xe2tel (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neuch\xe2tel (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neuch\xe2tel (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Neuch\xe2tel (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Neuqu\xe9n (Province of Argentina)": [
            {
                "Region Name": "Neuqu\xe9n (Province of Argentina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Neuqu\xe9n (Province of Argentina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Neuqu\xe9n (Province of Argentina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Neuqu\xe9n (Province of Argentina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Neuqu\xe9n (Province of Argentina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Neuqu\xe9n (Province of Argentina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Neuqu\xe9n (Province of Argentina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Neuqu\xe9n (Province of Argentina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Neuqu\xe9n (Province of Argentina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Neuqu\xe9n (Province of Argentina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Neuqu\xe9n (Province of Argentina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Neuqu\xe9n (Province of Argentina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Neuqu\xe9n (Province of Argentina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Neuqu\xe9n (Province of Argentina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Neuqu\xe9n (Province of Argentina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Neuqu\xe9n (Province of Argentina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Neuqu\xe9n (Province of Argentina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Neuqu\xe9n (Province of Argentina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Neuqu\xe9n (Province of Argentina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Neuqu\xe9n (Province of Argentina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Neuqu\xe9n (Province of Argentina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Neuqu\xe9n (Province of Argentina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Nevada (State of United States)": [
            {
                "Region Name": "Nevada (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nevada (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nevada (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nevada (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 89
            },
            {
                "Region Name": "Nevada (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 86
            },
            {
                "Region Name": "Nevada (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 106
            },
            {
                "Region Name": "Nevada (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nevada (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nevada (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nevada (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 114
            },
            {
                "Region Name": "Nevada (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Nevada (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Nevada (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Nevada (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nevada (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Nevada (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 87
            },
            {
                "Region Name": "Nevada (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Nevada (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nevada (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Nevada (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nevada (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nevada (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Nevsehir (Province of Turkey)": [
            {
                "Region Name": "Nevsehir (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Nevsehir (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nevsehir (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nevsehir (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Nevsehir (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Nevsehir (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nevsehir (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nevsehir (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nevsehir (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Nevsehir (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nevsehir (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nevsehir (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Nevsehir (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nevsehir (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nevsehir (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nevsehir (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nevsehir (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nevsehir (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nevsehir (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nevsehir (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nevsehir (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nevsehir (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "New Brunswick (Province of Canada)": [
            {
                "Region Name": "New Brunswick (Province of Canada)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Brunswick (Province of Canada)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Brunswick (Province of Canada)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "New Brunswick (Province of Canada)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Brunswick (Province of Canada)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "New Brunswick (Province of Canada)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Brunswick (Province of Canada)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "New Brunswick (Province of Canada)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "New Brunswick (Province of Canada)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "New Brunswick (Province of Canada)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Brunswick (Province of Canada)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "New Brunswick (Province of Canada)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "New Brunswick (Province of Canada)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Brunswick (Province of Canada)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "New Brunswick (Province of Canada)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Brunswick (Province of Canada)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "New Brunswick (Province of Canada)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "New Brunswick (Province of Canada)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Brunswick (Province of Canada)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Brunswick (Province of Canada)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Brunswick (Province of Canada)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Brunswick (Province of Canada)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "New Hampshire (State of United States)": [
            {
                "Region Name": "New Hampshire (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Hampshire (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Hampshire (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Hampshire (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "New Hampshire (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Hampshire (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Hampshire (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Hampshire (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Hampshire (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Hampshire (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Hampshire (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Hampshire (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Hampshire (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Hampshire (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Hampshire (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Hampshire (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Hampshire (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Hampshire (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Hampshire (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Hampshire (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Hampshire (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Hampshire (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "New Ireland (Province of Papua New Guinea)": [
            {
                "Region Name": "New Ireland (Province of Papua New Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "New Ireland (Province of Papua New Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Ireland (Province of Papua New Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Ireland (Province of Papua New Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Ireland (Province of Papua New Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Ireland (Province of Papua New Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Ireland (Province of Papua New Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Ireland (Province of Papua New Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Ireland (Province of Papua New Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Ireland (Province of Papua New Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Ireland (Province of Papua New Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Ireland (Province of Papua New Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Ireland (Province of Papua New Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Ireland (Province of Papua New Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "New Ireland (Province of Papua New Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Ireland (Province of Papua New Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Ireland (Province of Papua New Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "New Ireland (Province of Papua New Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Ireland (Province of Papua New Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Ireland (Province of Papua New Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Ireland (Province of Papua New Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "New Ireland (Province of Papua New Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "New Jersey (State of United States)": [
            {
                "Region Name": "New Jersey (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "New Jersey (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Jersey (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Jersey (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "New Jersey (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "New Jersey (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "New Jersey (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "New Jersey (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Jersey (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "New Jersey (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "New Jersey (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "New Jersey (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Jersey (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "New Jersey (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Jersey (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "New Jersey (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "New Jersey (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "New Jersey (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "New Jersey (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "New Jersey (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "New Jersey (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "New Jersey (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "New Mexico (State of United States)": [
            {
                "Region Name": "New Mexico (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "New Mexico (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "New Mexico (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "New Mexico (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "New Mexico (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "New Mexico (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "New Mexico (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "New Mexico (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "New Mexico (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "New Mexico (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 86
            },
            {
                "Region Name": "New Mexico (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 91
            },
            {
                "Region Name": "New Mexico (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "New Mexico (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "New Mexico (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "New Mexico (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "New Mexico (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "New Mexico (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "New Mexico (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "New Mexico (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "New Mexico (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "New Mexico (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 182
            },
            {
                "Region Name": "New Mexico (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "New Providence (District of Bahamas)": [
            {
                "Region Name": "New Providence (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Providence (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Providence (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Providence (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "New Providence (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "New Providence (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Providence (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "New Providence (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Providence (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Providence (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Providence (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Providence (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Providence (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Providence (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Providence (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "New Providence (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "New Providence (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Providence (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Providence (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Providence (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Providence (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Providence (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "New South Wales (State of Australia)": [
            {
                "Region Name": "New South Wales (State of Australia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "New South Wales (State of Australia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "New South Wales (State of Australia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "New South Wales (State of Australia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "New South Wales (State of Australia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "New South Wales (State of Australia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "New South Wales (State of Australia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "New South Wales (State of Australia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "New South Wales (State of Australia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "New South Wales (State of Australia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "New South Wales (State of Australia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "New South Wales (State of Australia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "New South Wales (State of Australia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "New South Wales (State of Australia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "New South Wales (State of Australia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "New South Wales (State of Australia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "New South Wales (State of Australia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "New South Wales (State of Australia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 109
            },
            {
                "Region Name": "New South Wales (State of Australia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "New South Wales (State of Australia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "New South Wales (State of Australia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "New South Wales (State of Australia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "New Taipei (Special Municipality of Taiwan)": [
            {
                "Region Name": "New Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "New Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "New York (State of United States)": [
            {
                "Region Name": "New York (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New York (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New York (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New York (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New York (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New York (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New York (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "New York (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New York (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "New York (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New York (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "New York (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New York (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New York (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New York (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "New York (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New York (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "New York (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New York (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "New York (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New York (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "New York (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Newfoundland and Labrador (Province of Canada)": [
            {
                "Region Name": "Newfoundland and Labrador (Province of Canada)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Newfoundland and Labrador (Province of Canada)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Newfoundland and Labrador (Province of Canada)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Newfoundland and Labrador (Province of Canada)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Newfoundland and Labrador (Province of Canada)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Newfoundland and Labrador (Province of Canada)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Newfoundland and Labrador (Province of Canada)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Newfoundland and Labrador (Province of Canada)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Newfoundland and Labrador (Province of Canada)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Newfoundland and Labrador (Province of Canada)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Newfoundland and Labrador (Province of Canada)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Newfoundland and Labrador (Province of Canada)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Newfoundland and Labrador (Province of Canada)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Newfoundland and Labrador (Province of Canada)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Newfoundland and Labrador (Province of Canada)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Newfoundland and Labrador (Province of Canada)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Newfoundland and Labrador (Province of Canada)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Newfoundland and Labrador (Province of Canada)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Newfoundland and Labrador (Province of Canada)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Newfoundland and Labrador (Province of Canada)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Newfoundland and Labrador (Province of Canada)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Newfoundland and Labrador (Province of Canada)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 19
            }
        ],
        "Ngaraard (State of Palau)": [
            {
                "Region Name": "Ngaraard (State of Palau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngaraard (State of Palau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngaraard (State of Palau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngaraard (State of Palau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngaraard (State of Palau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngaraard (State of Palau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngaraard (State of Palau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngaraard (State of Palau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngaraard (State of Palau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngaraard (State of Palau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngaraard (State of Palau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngaraard (State of Palau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngaraard (State of Palau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngaraard (State of Palau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngaraard (State of Palau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngaraard (State of Palau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngaraard (State of Palau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngaraard (State of Palau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngaraard (State of Palau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngaraard (State of Palau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngaraard (State of Palau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngaraard (State of Palau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ngarchelong (State of Palau)": [
            {
                "Region Name": "Ngarchelong (State of Palau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngarchelong (State of Palau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngarchelong (State of Palau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngarchelong (State of Palau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngarchelong (State of Palau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngarchelong (State of Palau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngarchelong (State of Palau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngarchelong (State of Palau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngarchelong (State of Palau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngarchelong (State of Palau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngarchelong (State of Palau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngarchelong (State of Palau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngarchelong (State of Palau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngarchelong (State of Palau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngarchelong (State of Palau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngarchelong (State of Palau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngarchelong (State of Palau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngarchelong (State of Palau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngarchelong (State of Palau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngarchelong (State of Palau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngarchelong (State of Palau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngarchelong (State of Palau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ngardmau (State of Palau)": [
            {
                "Region Name": "Ngardmau (State of Palau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngardmau (State of Palau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngardmau (State of Palau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngardmau (State of Palau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngardmau (State of Palau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngardmau (State of Palau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngardmau (State of Palau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngardmau (State of Palau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngardmau (State of Palau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngardmau (State of Palau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngardmau (State of Palau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngardmau (State of Palau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngardmau (State of Palau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngardmau (State of Palau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngardmau (State of Palau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngardmau (State of Palau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngardmau (State of Palau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngardmau (State of Palau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngardmau (State of Palau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngardmau (State of Palau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngardmau (State of Palau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngardmau (State of Palau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ngatpang (State of Palau)": [
            {
                "Region Name": "Ngatpang (State of Palau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngatpang (State of Palau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngatpang (State of Palau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngatpang (State of Palau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngatpang (State of Palau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngatpang (State of Palau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngatpang (State of Palau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngatpang (State of Palau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngatpang (State of Palau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngatpang (State of Palau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngatpang (State of Palau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngatpang (State of Palau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngatpang (State of Palau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngatpang (State of Palau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngatpang (State of Palau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngatpang (State of Palau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngatpang (State of Palau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngatpang (State of Palau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngatpang (State of Palau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngatpang (State of Palau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngatpang (State of Palau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngatpang (State of Palau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ngchesar (State of Palau)": [
            {
                "Region Name": "Ngchesar (State of Palau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngchesar (State of Palau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngchesar (State of Palau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngchesar (State of Palau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngchesar (State of Palau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngchesar (State of Palau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngchesar (State of Palau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngchesar (State of Palau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngchesar (State of Palau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngchesar (State of Palau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngchesar (State of Palau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngchesar (State of Palau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngchesar (State of Palau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngchesar (State of Palau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngchesar (State of Palau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngchesar (State of Palau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngchesar (State of Palau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngchesar (State of Palau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngchesar (State of Palau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngchesar (State of Palau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngchesar (State of Palau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngchesar (State of Palau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ngeremlengui (State of Palau)": [
            {
                "Region Name": "Ngeremlengui (State of Palau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngeremlengui (State of Palau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngeremlengui (State of Palau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngeremlengui (State of Palau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngeremlengui (State of Palau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngeremlengui (State of Palau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngeremlengui (State of Palau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngeremlengui (State of Palau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngeremlengui (State of Palau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngeremlengui (State of Palau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngeremlengui (State of Palau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngeremlengui (State of Palau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngeremlengui (State of Palau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngeremlengui (State of Palau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngeremlengui (State of Palau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngeremlengui (State of Palau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngeremlengui (State of Palau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngeremlengui (State of Palau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngeremlengui (State of Palau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngeremlengui (State of Palau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngeremlengui (State of Palau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngeremlengui (State of Palau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ngh\u1EC7 An (Province of Vietnam)": [
            {
                "Region Name": "Ngh\u1EC7 An (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ngh\u1EC7 An (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ngh\u1EC7 An (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ngh\u1EC7 An (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ngh\u1EC7 An (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ngh\u1EC7 An (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ngh\u1EC7 An (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ngh\u1EC7 An (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ngh\u1EC7 An (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ngh\u1EC7 An (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ngh\u1EC7 An (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ngh\u1EC7 An (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ngh\u1EC7 An (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ngh\u1EC7 An (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ngh\u1EC7 An (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ngh\u1EC7 An (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ngh\u1EC7 An (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ngh\u1EC7 An (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ngh\u1EC7 An (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ngh\u1EC7 An (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ngh\u1EC7 An (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ngh\u1EC7 An (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Ngiwal (State of Palau)": [
            {
                "Region Name": "Ngiwal (State of Palau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngiwal (State of Palau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngiwal (State of Palau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngiwal (State of Palau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngiwal (State of Palau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngiwal (State of Palau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngiwal (State of Palau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngiwal (State of Palau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngiwal (State of Palau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngiwal (State of Palau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngiwal (State of Palau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngiwal (State of Palau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngiwal (State of Palau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngiwal (State of Palau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngiwal (State of Palau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngiwal (State of Palau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngiwal (State of Palau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngiwal (State of Palau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngiwal (State of Palau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngiwal (State of Palau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngiwal (State of Palau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngiwal (State of Palau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ng\xf6be Bugl\xe9 (Indigenous Territory of Panama)": [
            {
                "Region Name": "Ng\xf6be Bugl\xe9 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ng\xf6be Bugl\xe9 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ng\xf6be Bugl\xe9 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ng\xf6be Bugl\xe9 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ng\xf6be Bugl\xe9 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ng\xf6be Bugl\xe9 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ng\xf6be Bugl\xe9 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ng\xf6be Bugl\xe9 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ng\xf6be Bugl\xe9 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ng\xf6be Bugl\xe9 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ng\xf6be Bugl\xe9 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ng\xf6be Bugl\xe9 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ng\xf6be Bugl\xe9 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ng\xf6be Bugl\xe9 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ng\xf6be Bugl\xe9 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ng\xf6be Bugl\xe9 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ng\xf6be Bugl\xe9 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ng\xf6be Bugl\xe9 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ng\xf6be Bugl\xe9 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ng\xf6be Bugl\xe9 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ng\xf6be Bugl\xe9 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ng\xf6be Bugl\xe9 (Indigenous Territory of Panama)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ngouni\xe9 (Province of Gabon)": [
            {
                "Region Name": "Ngouni\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ngouni\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ngouni\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ngouni\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ngouni\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ngouni\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ngouni\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ngouni\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ngouni\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ngouni\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ngouni\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ngouni\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ngouni\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ngouni\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ngouni\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ngouni\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ngouni\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ngouni\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ngouni\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngouni\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ngouni\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ngouni\xe9 (Province of Gabon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Ngozi (Province of Burundi)": [
            {
                "Region Name": "Ngozi (Province of Burundi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ngozi (Province of Burundi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngozi (Province of Burundi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ngozi (Province of Burundi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngozi (Province of Burundi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngozi (Province of Burundi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngozi (Province of Burundi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ngozi (Province of Burundi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ngozi (Province of Burundi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ngozi (Province of Burundi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngozi (Province of Burundi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngozi (Province of Burundi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngozi (Province of Burundi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngozi (Province of Burundi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ngozi (Province of Burundi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ngozi (Province of Burundi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngozi (Province of Burundi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngozi (Province of Burundi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngozi (Province of Burundi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngozi (Province of Burundi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ngozi (Province of Burundi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ngozi (Province of Burundi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Niamey (Capital District of Niger)": [
            {
                "Region Name": "Niamey (Capital District of Niger)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niamey (Capital District of Niger)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niamey (Capital District of Niger)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niamey (Capital District of Niger)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niamey (Capital District of Niger)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niamey (Capital District of Niger)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niamey (Capital District of Niger)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niamey (Capital District of Niger)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niamey (Capital District of Niger)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niamey (Capital District of Niger)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niamey (Capital District of Niger)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niamey (Capital District of Niger)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niamey (Capital District of Niger)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niamey (Capital District of Niger)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niamey (Capital District of Niger)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niamey (Capital District of Niger)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niamey (Capital District of Niger)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niamey (Capital District of Niger)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niamey (Capital District of Niger)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niamey (Capital District of Niger)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niamey (Capital District of Niger)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niamey (Capital District of Niger)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Niari (Region of Republic of the Congo)": [
            {
                "Region Name": "Niari (Region of Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Niari (Region of Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Niari (Region of Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Niari (Region of Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Niari (Region of Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Niari (Region of Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Niari (Region of Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Niari (Region of Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Niari (Region of Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Niari (Region of Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Niari (Region of Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Niari (Region of Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Niari (Region of Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Niari (Region of Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Niari (Region of Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Niari (Region of Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Niari (Region of Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Niari (Region of Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Niari (Region of Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Niari (Region of Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Niari (Region of Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Niari (Region of Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Nibok (District of Nauru)": [
            {
                "Region Name": "Nibok (District of Nauru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nibok (District of Nauru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nibok (District of Nauru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nibok (District of Nauru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nibok (District of Nauru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nibok (District of Nauru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nibok (District of Nauru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nibok (District of Nauru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nibok (District of Nauru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nibok (District of Nauru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nibok (District of Nauru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nibok (District of Nauru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nibok (District of Nauru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nibok (District of Nauru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nibok (District of Nauru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nibok (District of Nauru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nibok (District of Nauru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nibok (District of Nauru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nibok (District of Nauru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nibok (District of Nauru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nibok (District of Nauru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nibok (District of Nauru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nickerie (District of Suriname)": [
            {
                "Region Name": "Nickerie (District of Suriname)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nickerie (District of Suriname)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nickerie (District of Suriname)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nickerie (District of Suriname)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nickerie (District of Suriname)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nickerie (District of Suriname)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nickerie (District of Suriname)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nickerie (District of Suriname)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nickerie (District of Suriname)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nickerie (District of Suriname)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nickerie (District of Suriname)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nickerie (District of Suriname)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nickerie (District of Suriname)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nickerie (District of Suriname)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nickerie (District of Suriname)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nickerie (District of Suriname)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nickerie (District of Suriname)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nickerie (District of Suriname)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nickerie (District of Suriname)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nickerie (District of Suriname)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nickerie (District of Suriname)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nickerie (District of Suriname)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Nicosia (District of Cyprus)": [
            {
                "Region Name": "Nicosia (District of Cyprus)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nicosia (District of Cyprus)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nicosia (District of Cyprus)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nicosia (District of Cyprus)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nicosia (District of Cyprus)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Cyprus)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Cyprus)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Cyprus)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Cyprus)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Cyprus)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Cyprus)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Cyprus)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nicosia (District of Cyprus)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Cyprus)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nicosia (District of Cyprus)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Nicosia (District of Cyprus)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Cyprus)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Cyprus)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Cyprus)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Cyprus)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Cyprus)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Cyprus)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nicosia (District of Northern Cyprus)": [
            {
                "Region Name": "Nicosia (District of Northern Cyprus)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Northern Cyprus)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nicosia (District of Northern Cyprus)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Northern Cyprus)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Northern Cyprus)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Northern Cyprus)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Northern Cyprus)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Northern Cyprus)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Northern Cyprus)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nicosia (District of Northern Cyprus)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Northern Cyprus)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Northern Cyprus)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Northern Cyprus)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Northern Cyprus)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Northern Cyprus)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Northern Cyprus)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Northern Cyprus)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Northern Cyprus)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Northern Cyprus)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Northern Cyprus)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Northern Cyprus)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nicosia (District of Northern Cyprus)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nidwalden (Canton of Switzerland)": [
            {
                "Region Name": "Nidwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nidwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nidwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nidwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nidwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nidwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nidwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nidwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nidwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nidwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nidwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nidwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nidwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nidwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nidwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nidwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nidwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nidwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nidwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nidwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nidwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nidwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nieder\xf6sterreich (State of Austria)": [
            {
                "Region Name": "Nieder\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nieder\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nieder\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Nieder\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Nieder\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nieder\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nieder\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nieder\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nieder\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nieder\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nieder\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nieder\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nieder\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nieder\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nieder\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nieder\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nieder\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nieder\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nieder\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nieder\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nieder\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nieder\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Niedersachsen (State of Germany)": [
            {
                "Region Name": "Niedersachsen (State of Germany)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Niedersachsen (State of Germany)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Niedersachsen (State of Germany)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niedersachsen (State of Germany)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niedersachsen (State of Germany)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Niedersachsen (State of Germany)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niedersachsen (State of Germany)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Niedersachsen (State of Germany)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niedersachsen (State of Germany)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niedersachsen (State of Germany)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niedersachsen (State of Germany)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niedersachsen (State of Germany)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niedersachsen (State of Germany)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niedersachsen (State of Germany)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niedersachsen (State of Germany)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niedersachsen (State of Germany)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niedersachsen (State of Germany)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Niedersachsen (State of Germany)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niedersachsen (State of Germany)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niedersachsen (State of Germany)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niedersachsen (State of Germany)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niedersachsen (State of Germany)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nigde (Province of Turkey)": [
            {
                "Region Name": "Nigde (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nigde (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nigde (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nigde (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nigde (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nigde (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nigde (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nigde (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nigde (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nigde (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nigde (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nigde (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nigde (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nigde (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nigde (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nigde (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nigde (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nigde (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nigde (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nigde (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nigde (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nigde (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Niger (State of Nigeria)": [
            {
                "Region Name": "Niger (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Niger (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Niger (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Niger (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Niger (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Niger (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Niger (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Niger (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Niger (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Niger (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Niger (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Niger (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Niger (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Niger (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Niger (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Niger (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Niger (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Niger (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Niger (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Niger (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Niger (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Niger (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 20
            }
        ],
        "Niigata (Prefecture of Japan)": [
            {
                "Region Name": "Niigata (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niigata (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Niigata (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niigata (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niigata (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niigata (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Niigata (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niigata (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Niigata (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niigata (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niigata (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niigata (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Niigata (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Niigata (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niigata (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niigata (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niigata (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Niigata (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Niigata (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niigata (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Niigata (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Niigata (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nik\u0161i\u0107 (Municipality of Montenegro)": [
            {
                "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nik\u0161i\u0107 (Municipality of Montenegro)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nimba (County of Liberia)": [
            {
                "Region Name": "Nimba (County of Liberia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nimba (County of Liberia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nimba (County of Liberia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nimba (County of Liberia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nimba (County of Liberia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nimba (County of Liberia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nimba (County of Liberia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nimba (County of Liberia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nimba (County of Liberia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nimba (County of Liberia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nimba (County of Liberia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nimba (County of Liberia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nimba (County of Liberia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nimba (County of Liberia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nimba (County of Liberia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nimba (County of Liberia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nimba (County of Liberia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nimba (County of Liberia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nimba (County of Liberia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nimba (County of Liberia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nimba (County of Liberia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nimba (County of Liberia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Nimroz (Province of Afghanistan)": [
            {
                "Region Name": "Nimroz (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nimroz (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nimroz (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nimroz (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Nimroz (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Nimroz (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nimroz (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Nimroz (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nimroz (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Nimroz (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Nimroz (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nimroz (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nimroz (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nimroz (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nimroz (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nimroz (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nimroz (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nimroz (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nimroz (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nimroz (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nimroz (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nimroz (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ninawa (Province of Iraq)": [
            {
                "Region Name": "Ninawa (Province of Iraq)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ninawa (Province of Iraq)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ninawa (Province of Iraq)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ninawa (Province of Iraq)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ninawa (Province of Iraq)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ninawa (Province of Iraq)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ninawa (Province of Iraq)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ninawa (Province of Iraq)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ninawa (Province of Iraq)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Ninawa (Province of Iraq)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ninawa (Province of Iraq)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ninawa (Province of Iraq)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ninawa (Province of Iraq)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ninawa (Province of Iraq)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Ninawa (Province of Iraq)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ninawa (Province of Iraq)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ninawa (Province of Iraq)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ninawa (Province of Iraq)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Ninawa (Province of Iraq)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Ninawa (Province of Iraq)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ninawa (Province of Iraq)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ninawa (Province of Iraq)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Ningxia Hui (Autonomous Region of China)": [
            {
                "Region Name": "Ningxia Hui (Autonomous Region of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ningxia Hui (Autonomous Region of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ningxia Hui (Autonomous Region of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ningxia Hui (Autonomous Region of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ningxia Hui (Autonomous Region of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ningxia Hui (Autonomous Region of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Ningxia Hui (Autonomous Region of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ningxia Hui (Autonomous Region of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ningxia Hui (Autonomous Region of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ningxia Hui (Autonomous Region of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Ningxia Hui (Autonomous Region of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ningxia Hui (Autonomous Region of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ningxia Hui (Autonomous Region of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ningxia Hui (Autonomous Region of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ningxia Hui (Autonomous Region of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ningxia Hui (Autonomous Region of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ningxia Hui (Autonomous Region of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ningxia Hui (Autonomous Region of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ningxia Hui (Autonomous Region of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ningxia Hui (Autonomous Region of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ningxia Hui (Autonomous Region of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ningxia Hui (Autonomous Region of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Ninh B\xecnh (Province of Vietnam)": [
            {
                "Region Name": "Ninh B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ninh B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ninh B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ninh B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ninh B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ninh B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ninh B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ninh B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ninh B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ninh B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ninh B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ninh B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ninh B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ninh B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ninh B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ninh B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ninh B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ninh B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ninh B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ninh B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ninh B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ninh B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Ninh Thu\u1EADn (Province of Vietnam)": [
            {
                "Region Name": "Ninh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ninh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ninh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ninh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ninh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ninh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ninh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ninh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ninh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ninh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ninh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ninh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ninh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ninh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ninh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ninh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ninh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ninh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ninh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ninh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ninh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ninh Thu\u1EADn (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Nippes (Department of Haiti)": [
            {
                "Region Name": "Nippes (Department of Haiti)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nippes (Department of Haiti)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nippes (Department of Haiti)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nippes (Department of Haiti)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nippes (Department of Haiti)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nippes (Department of Haiti)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nippes (Department of Haiti)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nippes (Department of Haiti)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nippes (Department of Haiti)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nippes (Department of Haiti)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nippes (Department of Haiti)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nippes (Department of Haiti)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nippes (Department of Haiti)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nippes (Department of Haiti)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nippes (Department of Haiti)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nippes (Department of Haiti)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nippes (Department of Haiti)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nippes (Department of Haiti)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nippes (Department of Haiti)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nippes (Department of Haiti)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nippes (Department of Haiti)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nippes (Department of Haiti)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ni\u0161avski (District of Serbia)": [
            {
                "Region Name": "Ni\u0161avski (District of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ni\u0161avski (District of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ni\u0161avski (District of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ni\u0161avski (District of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ni\u0161avski (District of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ni\u0161avski (District of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Ni\u0161avski (District of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ni\u0161avski (District of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ni\u0161avski (District of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ni\u0161avski (District of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ni\u0161avski (District of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ni\u0161avski (District of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ni\u0161avski (District of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ni\u0161avski (District of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ni\u0161avski (District of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ni\u0161avski (District of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ni\u0161avski (District of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ni\u0161avski (District of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ni\u0161avski (District of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ni\u0161avski (District of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ni\u0161avski (District of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ni\u0161avski (District of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nisporeni (District of Moldova)": [
            {
                "Region Name": "Nisporeni (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nisporeni (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nisporeni (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nisporeni (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nisporeni (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nisporeni (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nisporeni (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nisporeni (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nisporeni (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nisporeni (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nisporeni (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nisporeni (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nisporeni (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nisporeni (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nisporeni (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nisporeni (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nisporeni (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nisporeni (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nisporeni (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nisporeni (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nisporeni (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nisporeni (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nitriansky (Region of Slovakia)": [
            {
                "Region Name": "Nitriansky (Region of Slovakia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nitriansky (Region of Slovakia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nitriansky (Region of Slovakia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nitriansky (Region of Slovakia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nitriansky (Region of Slovakia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nitriansky (Region of Slovakia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nitriansky (Region of Slovakia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nitriansky (Region of Slovakia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nitriansky (Region of Slovakia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nitriansky (Region of Slovakia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nitriansky (Region of Slovakia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nitriansky (Region of Slovakia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nitriansky (Region of Slovakia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nitriansky (Region of Slovakia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nitriansky (Region of Slovakia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nitriansky (Region of Slovakia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nitriansky (Region of Slovakia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nitriansky (Region of Slovakia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nitriansky (Region of Slovakia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nitriansky (Region of Slovakia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nitriansky (Region of Slovakia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nitriansky (Region of Slovakia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Niuas (Island Group of Tonga)": [
            {
                "Region Name": "Niuas (Island Group of Tonga)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niuas (Island Group of Tonga)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niuas (Island Group of Tonga)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niuas (Island Group of Tonga)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niuas (Island Group of Tonga)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niuas (Island Group of Tonga)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niuas (Island Group of Tonga)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niuas (Island Group of Tonga)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niuas (Island Group of Tonga)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niuas (Island Group of Tonga)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niuas (Island Group of Tonga)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niuas (Island Group of Tonga)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niuas (Island Group of Tonga)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niuas (Island Group of Tonga)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niuas (Island Group of Tonga)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niuas (Island Group of Tonga)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niuas (Island Group of Tonga)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niuas (Island Group of Tonga)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niuas (Island Group of Tonga)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niuas (Island Group of Tonga)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niuas (Island Group of Tonga)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niuas (Island Group of Tonga)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Niulakita (Island Council of Tuvalu)": [
            {
                "Region Name": "Niulakita (Island Council of Tuvalu)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niulakita (Island Council of Tuvalu)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niulakita (Island Council of Tuvalu)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niulakita (Island Council of Tuvalu)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niulakita (Island Council of Tuvalu)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niulakita (Island Council of Tuvalu)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niulakita (Island Council of Tuvalu)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niulakita (Island Council of Tuvalu)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niulakita (Island Council of Tuvalu)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niulakita (Island Council of Tuvalu)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niulakita (Island Council of Tuvalu)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niulakita (Island Council of Tuvalu)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niulakita (Island Council of Tuvalu)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niulakita (Island Council of Tuvalu)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niulakita (Island Council of Tuvalu)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niulakita (Island Council of Tuvalu)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niulakita (Island Council of Tuvalu)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niulakita (Island Council of Tuvalu)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niulakita (Island Council of Tuvalu)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niulakita (Island Council of Tuvalu)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niulakita (Island Council of Tuvalu)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niulakita (Island Council of Tuvalu)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Niutao (Island Council of Tuvalu)": [
            {
                "Region Name": "Niutao (Island Council of Tuvalu)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niutao (Island Council of Tuvalu)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niutao (Island Council of Tuvalu)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niutao (Island Council of Tuvalu)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niutao (Island Council of Tuvalu)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niutao (Island Council of Tuvalu)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niutao (Island Council of Tuvalu)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niutao (Island Council of Tuvalu)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niutao (Island Council of Tuvalu)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niutao (Island Council of Tuvalu)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niutao (Island Council of Tuvalu)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niutao (Island Council of Tuvalu)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niutao (Island Council of Tuvalu)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niutao (Island Council of Tuvalu)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niutao (Island Council of Tuvalu)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niutao (Island Council of Tuvalu)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niutao (Island Council of Tuvalu)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niutao (Island Council of Tuvalu)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niutao (Island Council of Tuvalu)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niutao (Island Council of Tuvalu)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niutao (Island Council of Tuvalu)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Niutao (Island Council of Tuvalu)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nizhegorod (Region of Russia)": [
            {
                "Region Name": "Nizhegorod (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nizhegorod (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nizhegorod (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nizhegorod (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nizhegorod (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nizhegorod (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nizhegorod (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nizhegorod (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nizhegorod (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Nizhegorod (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nizhegorod (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nizhegorod (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nizhegorod (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nizhegorod (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nizhegorod (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nizhegorod (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nizhegorod (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nizhegorod (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nizhegorod (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nizhegorod (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nizhegorod (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 76
            },
            {
                "Region Name": "Nizhegorod (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Njaz\xeddja (Autonomous Island of Comoros)": [
            {
                "Region Name": "Njaz\xeddja (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Njaz\xeddja (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Njaz\xeddja (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Njaz\xeddja (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Njaz\xeddja (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Njaz\xeddja (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Njaz\xeddja (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Njaz\xeddja (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Njaz\xeddja (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Njaz\xeddja (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Njaz\xeddja (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Njaz\xeddja (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Njaz\xeddja (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Njaz\xeddja (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Njaz\xeddja (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Njaz\xeddja (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Njaz\xeddja (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Njaz\xeddja (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Njaz\xeddja (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Njaz\xeddja (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Njaz\xeddja (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Njaz\xeddja (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Njombe (Region of Tanzania)": [
            {
                "Region Name": "Njombe (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Njombe (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Njombe (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Njombe (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Njombe (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Njombe (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Njombe (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Njombe (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Njombe (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Njombe (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Njombe (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Njombe (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Njombe (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Njombe (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Njombe (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Njombe (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Njombe (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Njombe (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Njombe (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Njombe (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Njombe (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Njombe (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Nkhata Bay (District of Malawi)": [
            {
                "Region Name": "Nkhata Bay (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nkhata Bay (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nkhata Bay (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nkhata Bay (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nkhata Bay (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nkhata Bay (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nkhata Bay (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nkhata Bay (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nkhata Bay (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nkhata Bay (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nkhata Bay (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Nkhata Bay (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nkhata Bay (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nkhata Bay (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nkhata Bay (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nkhata Bay (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nkhata Bay (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nkhata Bay (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nkhata Bay (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nkhata Bay (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nkhata Bay (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nkhata Bay (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Nkhotakota (District of Malawi)": [
            {
                "Region Name": "Nkhotakota (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nkhotakota (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nkhotakota (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nkhotakota (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nkhotakota (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nkhotakota (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nkhotakota (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nkhotakota (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nkhotakota (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nkhotakota (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nkhotakota (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nkhotakota (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nkhotakota (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nkhotakota (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nkhotakota (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Nkhotakota (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nkhotakota (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Nkhotakota (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Nkhotakota (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Nkhotakota (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nkhotakota (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nkhotakota (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Nofsinhar (Region of Malta)": [
            {
                "Region Name": "Nofsinhar (Region of Malta)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nofsinhar (Region of Malta)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nofsinhar (Region of Malta)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nofsinhar (Region of Malta)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nofsinhar (Region of Malta)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nofsinhar (Region of Malta)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nofsinhar (Region of Malta)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nofsinhar (Region of Malta)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nofsinhar (Region of Malta)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nofsinhar (Region of Malta)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nofsinhar (Region of Malta)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nofsinhar (Region of Malta)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nofsinhar (Region of Malta)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nofsinhar (Region of Malta)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nofsinhar (Region of Malta)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nofsinhar (Region of Malta)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nofsinhar (Region of Malta)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nofsinhar (Region of Malta)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nofsinhar (Region of Malta)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nofsinhar (Region of Malta)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nofsinhar (Region of Malta)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nofsinhar (Region of Malta)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "N\xf3gr\xe1d (County of Hungary)": [
            {
                "Region Name": "N\xf3gr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "N\xf3gr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "N\xf3gr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "N\xf3gr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "N\xf3gr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "N\xf3gr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "N\xf3gr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "N\xf3gr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "N\xf3gr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "N\xf3gr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "N\xf3gr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "N\xf3gr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "N\xf3gr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "N\xf3gr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "N\xf3gr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "N\xf3gr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "N\xf3gr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "N\xf3gr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "N\xf3gr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "N\xf3gr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "N\xf3gr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "N\xf3gr\xe1d (County of Hungary)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nong Bua Lam Phu (Province of Thailand)": [
            {
                "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nong Bua Lam Phu (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Nong Khai (Province of Thailand)": [
            {
                "Region Name": "Nong Khai (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nong Khai (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nong Khai (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nong Khai (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nong Khai (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nong Khai (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nong Khai (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nong Khai (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nong Khai (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nong Khai (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nong Khai (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nong Khai (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nong Khai (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nong Khai (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nong Khai (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nong Khai (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nong Khai (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nong Khai (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nong Khai (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nong Khai (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nong Khai (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nong Khai (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Nonthaburi (Province of Thailand)": [
            {
                "Region Name": "Nonthaburi (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nonthaburi (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nonthaburi (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nonthaburi (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nonthaburi (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nonthaburi (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nonthaburi (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nonthaburi (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nonthaburi (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nonthaburi (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nonthaburi (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nonthaburi (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nonthaburi (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nonthaburi (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nonthaburi (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nonthaburi (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nonthaburi (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nonthaburi (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nonthaburi (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nonthaburi (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nonthaburi (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nonthaburi (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Noord-Brabant (Province of Netherlands)": [
            {
                "Region Name": "Noord-Brabant (Province of Netherlands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Brabant (Province of Netherlands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Brabant (Province of Netherlands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Brabant (Province of Netherlands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Brabant (Province of Netherlands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Brabant (Province of Netherlands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Noord-Brabant (Province of Netherlands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Brabant (Province of Netherlands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Brabant (Province of Netherlands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Brabant (Province of Netherlands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Brabant (Province of Netherlands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Brabant (Province of Netherlands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Brabant (Province of Netherlands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Brabant (Province of Netherlands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Brabant (Province of Netherlands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Brabant (Province of Netherlands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Brabant (Province of Netherlands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Brabant (Province of Netherlands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Brabant (Province of Netherlands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Brabant (Province of Netherlands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Brabant (Province of Netherlands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Brabant (Province of Netherlands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Noord-Holland (Province of Netherlands)": [
            {
                "Region Name": "Noord-Holland (Province of Netherlands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Holland (Province of Netherlands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Holland (Province of Netherlands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Holland (Province of Netherlands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Holland (Province of Netherlands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Holland (Province of Netherlands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Holland (Province of Netherlands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Holland (Province of Netherlands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Holland (Province of Netherlands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Holland (Province of Netherlands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Holland (Province of Netherlands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Holland (Province of Netherlands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Holland (Province of Netherlands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Holland (Province of Netherlands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Holland (Province of Netherlands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Holland (Province of Netherlands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Holland (Province of Netherlands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Holland (Province of Netherlands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Holland (Province of Netherlands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Holland (Province of Netherlands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Holland (Province of Netherlands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Noord-Holland (Province of Netherlands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nord-Est (Department of Haiti)": [
            {
                "Region Name": "Nord-Est (Department of Haiti)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Est (Department of Haiti)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Est (Department of Haiti)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Est (Department of Haiti)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Est (Department of Haiti)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nord-Est (Department of Haiti)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Est (Department of Haiti)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Est (Department of Haiti)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Est (Department of Haiti)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Est (Department of Haiti)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nord-Est (Department of Haiti)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nord-Est (Department of Haiti)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Est (Department of Haiti)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Est (Department of Haiti)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nord-Est (Department of Haiti)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Est (Department of Haiti)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Est (Department of Haiti)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nord-Est (Department of Haiti)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nord-Est (Department of Haiti)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Est (Department of Haiti)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Est (Department of Haiti)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Est (Department of Haiti)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nord-Kivu (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nord-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Nord-Ouest (Department of Haiti)": [
            {
                "Region Name": "Nord-Ouest (Department of Haiti)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Ouest (Department of Haiti)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Ouest (Department of Haiti)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Ouest (Department of Haiti)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Ouest (Department of Haiti)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Ouest (Department of Haiti)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Ouest (Department of Haiti)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Ouest (Department of Haiti)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Ouest (Department of Haiti)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Ouest (Department of Haiti)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nord-Ouest (Department of Haiti)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Ouest (Department of Haiti)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Ouest (Department of Haiti)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Ouest (Department of Haiti)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Ouest (Department of Haiti)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Ouest (Department of Haiti)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Ouest (Department of Haiti)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Ouest (Department of Haiti)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Ouest (Department of Haiti)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Ouest (Department of Haiti)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Ouest (Department of Haiti)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Ouest (Department of Haiti)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nord-Ouest (Region of Cameroon)": [
            {
                "Region Name": "Nord-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nord-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nord-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nord-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nord-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nord-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nord-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nord-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nord-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nord-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nord-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nord-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nord-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nord-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nord-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nord-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nord-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nord-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nord-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nord-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nord-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nord-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Nord-Tr\xf8ndelag (County of Norway)": [
            {
                "Region Name": "Nord-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nord-Ubangi (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nord-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Nord (Department of Haiti)": [
            {
                "Region Name": "Nord (Department of Haiti)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Department of Haiti)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Department of Haiti)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Department of Haiti)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Department of Haiti)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Department of Haiti)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Department of Haiti)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Department of Haiti)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Department of Haiti)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Department of Haiti)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Department of Haiti)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Department of Haiti)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Department of Haiti)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Department of Haiti)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Department of Haiti)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Department of Haiti)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Department of Haiti)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Department of Haiti)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nord (Department of Haiti)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Department of Haiti)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Department of Haiti)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Department of Haiti)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nord (Province of New Caledonia)": [
            {
                "Region Name": "Nord (Province of New Caledonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Nord (Province of New Caledonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Nord (Province of New Caledonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Nord (Province of New Caledonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nord (Province of New Caledonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Nord (Province of New Caledonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Province of New Caledonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Province of New Caledonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Province of New Caledonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Province of New Caledonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nord (Province of New Caledonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Province of New Caledonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nord (Province of New Caledonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Province of New Caledonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nord (Province of New Caledonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Province of New Caledonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nord (Province of New Caledonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nord (Province of New Caledonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nord (Province of New Caledonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Province of New Caledonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nord (Province of New Caledonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nord (Province of New Caledonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Nord (Region of Burkina Faso)": [
            {
                "Region Name": "Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Nord (Region of Burkina Faso)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 34
            }
        ],
        "Nord (Region of Cameroon)": [
            {
                "Region Name": "Nord (Region of Cameroon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Nord (Region of Cameroon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Nord (Region of Cameroon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Nord (Region of Cameroon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Nord (Region of Cameroon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Nord (Region of Cameroon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Nord (Region of Cameroon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Nord (Region of Cameroon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Nord (Region of Cameroon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Nord (Region of Cameroon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nord (Region of Cameroon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Nord (Region of Cameroon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Nord (Region of Cameroon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Nord (Region of Cameroon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Nord (Region of Cameroon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Nord (Region of Cameroon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Nord (Region of Cameroon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nord (Region of Cameroon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nord (Region of Cameroon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nord (Region of Cameroon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Nord (Region of Cameroon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nord (Region of Cameroon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "Norder\xf8erne (Region of Faroe Islands)": [
            {
                "Region Name": "Norder\xf8erne (Region of Faroe Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norder\xf8erne (Region of Faroe Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norder\xf8erne (Region of Faroe Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norder\xf8erne (Region of Faroe Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norder\xf8erne (Region of Faroe Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norder\xf8erne (Region of Faroe Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norder\xf8erne (Region of Faroe Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norder\xf8erne (Region of Faroe Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norder\xf8erne (Region of Faroe Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norder\xf8erne (Region of Faroe Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norder\xf8erne (Region of Faroe Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norder\xf8erne (Region of Faroe Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norder\xf8erne (Region of Faroe Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norder\xf8erne (Region of Faroe Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norder\xf8erne (Region of Faroe Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norder\xf8erne (Region of Faroe Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norder\xf8erne (Region of Faroe Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norder\xf8erne (Region of Faroe Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norder\xf8erne (Region of Faroe Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norder\xf8erne (Region of Faroe Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norder\xf8erne (Region of Faroe Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norder\xf8erne (Region of Faroe Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nordjylland (Region of Denmark)": [
            {
                "Region Name": "Nordjylland (Region of Denmark)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordjylland (Region of Denmark)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordjylland (Region of Denmark)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nordjylland (Region of Denmark)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordjylland (Region of Denmark)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordjylland (Region of Denmark)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordjylland (Region of Denmark)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nordjylland (Region of Denmark)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordjylland (Region of Denmark)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordjylland (Region of Denmark)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordjylland (Region of Denmark)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordjylland (Region of Denmark)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordjylland (Region of Denmark)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordjylland (Region of Denmark)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nordjylland (Region of Denmark)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordjylland (Region of Denmark)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordjylland (Region of Denmark)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nordjylland (Region of Denmark)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordjylland (Region of Denmark)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordjylland (Region of Denmark)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordjylland (Region of Denmark)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordjylland (Region of Denmark)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nordland (County of Norway)": [
            {
                "Region Name": "Nordland (County of Norway)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordland (County of Norway)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordland (County of Norway)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordland (County of Norway)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordland (County of Norway)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordland (County of Norway)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordland (County of Norway)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordland (County of Norway)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordland (County of Norway)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordland (County of Norway)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordland (County of Norway)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordland (County of Norway)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordland (County of Norway)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordland (County of Norway)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordland (County of Norway)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordland (County of Norway)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordland (County of Norway)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordland (County of Norway)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordland (County of Norway)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordland (County of Norway)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordland (County of Norway)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordland (County of Norway)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nordrhein-Westfalen (State of Germany)": [
            {
                "Region Name": "Nordrhein-Westfalen (State of Germany)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordrhein-Westfalen (State of Germany)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordrhein-Westfalen (State of Germany)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordrhein-Westfalen (State of Germany)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordrhein-Westfalen (State of Germany)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nordrhein-Westfalen (State of Germany)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordrhein-Westfalen (State of Germany)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordrhein-Westfalen (State of Germany)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordrhein-Westfalen (State of Germany)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordrhein-Westfalen (State of Germany)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordrhein-Westfalen (State of Germany)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordrhein-Westfalen (State of Germany)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordrhein-Westfalen (State of Germany)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordrhein-Westfalen (State of Germany)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nordrhein-Westfalen (State of Germany)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nordrhein-Westfalen (State of Germany)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordrhein-Westfalen (State of Germany)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nordrhein-Westfalen (State of Germany)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nordrhein-Westfalen (State of Germany)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nordrhein-Westfalen (State of Germany)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordrhein-Westfalen (State of Germany)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nordrhein-Westfalen (State of Germany)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nor\xf0urland eystra (Region of Iceland)": [
            {
                "Region Name": "Nor\xf0urland eystra (Region of Iceland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland eystra (Region of Iceland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland eystra (Region of Iceland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland eystra (Region of Iceland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland eystra (Region of Iceland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland eystra (Region of Iceland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland eystra (Region of Iceland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland eystra (Region of Iceland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland eystra (Region of Iceland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland eystra (Region of Iceland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland eystra (Region of Iceland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland eystra (Region of Iceland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland eystra (Region of Iceland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland eystra (Region of Iceland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland eystra (Region of Iceland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland eystra (Region of Iceland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland eystra (Region of Iceland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland eystra (Region of Iceland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland eystra (Region of Iceland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland eystra (Region of Iceland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland eystra (Region of Iceland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland eystra (Region of Iceland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nor\xf0urland vestra (Region of Iceland)": [
            {
                "Region Name": "Nor\xf0urland vestra (Region of Iceland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland vestra (Region of Iceland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland vestra (Region of Iceland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland vestra (Region of Iceland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland vestra (Region of Iceland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland vestra (Region of Iceland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland vestra (Region of Iceland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland vestra (Region of Iceland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland vestra (Region of Iceland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland vestra (Region of Iceland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland vestra (Region of Iceland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland vestra (Region of Iceland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland vestra (Region of Iceland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland vestra (Region of Iceland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland vestra (Region of Iceland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland vestra (Region of Iceland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland vestra (Region of Iceland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland vestra (Region of Iceland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland vestra (Region of Iceland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland vestra (Region of Iceland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland vestra (Region of Iceland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nor\xf0urland vestra (Region of Iceland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Normandie (Region of France)": [
            {
                "Region Name": "Normandie (Region of France)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Normandie (Region of France)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Normandie (Region of France)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Normandie (Region of France)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Normandie (Region of France)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Normandie (Region of France)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Normandie (Region of France)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Normandie (Region of France)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Normandie (Region of France)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Normandie (Region of France)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Normandie (Region of France)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Normandie (Region of France)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Normandie (Region of France)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Normandie (Region of France)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Normandie (Region of France)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Normandie (Region of France)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Normandie (Region of France)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Normandie (Region of France)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Normandie (Region of France)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Normandie (Region of France)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Normandie (Region of France)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Normandie (Region of France)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Norrbotten (County of Sweden)": [
            {
                "Region Name": "Norrbotten (County of Sweden)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norrbotten (County of Sweden)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norrbotten (County of Sweden)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norrbotten (County of Sweden)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norrbotten (County of Sweden)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Norrbotten (County of Sweden)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norrbotten (County of Sweden)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norrbotten (County of Sweden)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norrbotten (County of Sweden)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norrbotten (County of Sweden)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norrbotten (County of Sweden)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norrbotten (County of Sweden)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norrbotten (County of Sweden)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norrbotten (County of Sweden)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norrbotten (County of Sweden)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norrbotten (County of Sweden)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norrbotten (County of Sweden)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Norrbotten (County of Sweden)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norrbotten (County of Sweden)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norrbotten (County of Sweden)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norrbotten (County of Sweden)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norrbotten (County of Sweden)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Norte de Santander (Department of Colombia)": [
            {
                "Region Name": "Norte de Santander (Department of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Norte de Santander (Department of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Norte de Santander (Department of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Norte de Santander (Department of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Norte de Santander (Department of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Norte de Santander (Department of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Norte de Santander (Department of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Norte de Santander (Department of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Norte de Santander (Department of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Norte de Santander (Department of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Norte de Santander (Department of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Norte de Santander (Department of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Norte de Santander (Department of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Norte de Santander (Department of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Norte de Santander (Department of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Norte de Santander (Department of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Norte de Santander (Department of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Norte de Santander (Department of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Norte de Santander (Department of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Norte de Santander (Department of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Norte de Santander (Department of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Norte de Santander (Department of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "North-East (District of Botswana)": [
            {
                "Region Name": "North-East (District of Botswana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North-East (District of Botswana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (District of Botswana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (District of Botswana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (District of Botswana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "North-East (District of Botswana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North-East (District of Botswana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North-East (District of Botswana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "North-East (District of Botswana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "North-East (District of Botswana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "North-East (District of Botswana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 78
            },
            {
                "Region Name": "North-East (District of Botswana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "North-East (District of Botswana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "North-East (District of Botswana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "North-East (District of Botswana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (District of Botswana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "North-East (District of Botswana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North-East (District of Botswana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (District of Botswana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (District of Botswana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "North-East (District of Botswana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North-East (District of Botswana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "North-East (Region of Singapore)": [
            {
                "Region Name": "North-East (Region of Singapore)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (Region of Singapore)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (Region of Singapore)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (Region of Singapore)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (Region of Singapore)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (Region of Singapore)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (Region of Singapore)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (Region of Singapore)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (Region of Singapore)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (Region of Singapore)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (Region of Singapore)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (Region of Singapore)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (Region of Singapore)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (Region of Singapore)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (Region of Singapore)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (Region of Singapore)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (Region of Singapore)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (Region of Singapore)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (Region of Singapore)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (Region of Singapore)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (Region of Singapore)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North-East (Region of Singapore)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "North-West (District of Botswana)": [
            {
                "Region Name": "North-West (District of Botswana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 121
            },
            {
                "Region Name": "North-West (District of Botswana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 65
            },
            {
                "Region Name": "North-West (District of Botswana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 114
            },
            {
                "Region Name": "North-West (District of Botswana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 85
            },
            {
                "Region Name": "North-West (District of Botswana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 127
            },
            {
                "Region Name": "North-West (District of Botswana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 98
            },
            {
                "Region Name": "North-West (District of Botswana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 210
            },
            {
                "Region Name": "North-West (District of Botswana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 79
            },
            {
                "Region Name": "North-West (District of Botswana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 337
            },
            {
                "Region Name": "North-West (District of Botswana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 269
            },
            {
                "Region Name": "North-West (District of Botswana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 240
            },
            {
                "Region Name": "North-West (District of Botswana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 135
            },
            {
                "Region Name": "North-West (District of Botswana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 139
            },
            {
                "Region Name": "North-West (District of Botswana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 59
            },
            {
                "Region Name": "North-West (District of Botswana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 92
            },
            {
                "Region Name": "North-West (District of Botswana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 102
            },
            {
                "Region Name": "North-West (District of Botswana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 101
            },
            {
                "Region Name": "North-West (District of Botswana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "North-West (District of Botswana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 145
            },
            {
                "Region Name": "North-West (District of Botswana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 100
            },
            {
                "Region Name": "North-West (District of Botswana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 92
            },
            {
                "Region Name": "North-West (District of Botswana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 139
            }
        ],
        "North-Western (Province of Zambia)": [
            {
                "Region Name": "North-Western (Province of Zambia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North-Western (Province of Zambia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "North-Western (Province of Zambia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "North-Western (Province of Zambia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North-Western (Province of Zambia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North-Western (Province of Zambia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "North-Western (Province of Zambia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North-Western (Province of Zambia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North-Western (Province of Zambia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North-Western (Province of Zambia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North-Western (Province of Zambia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North-Western (Province of Zambia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North-Western (Province of Zambia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North-Western (Province of Zambia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "North-Western (Province of Zambia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North-Western (Province of Zambia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "North-Western (Province of Zambia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "North-Western (Province of Zambia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "North-Western (Province of Zambia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "North-Western (Province of Zambia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "North-Western (Province of Zambia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "North-Western (Province of Zambia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "North (Governorate of Lebanon)": [
            {
                "Region Name": "North (Governorate of Lebanon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Governorate of Lebanon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Governorate of Lebanon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Governorate of Lebanon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Governorate of Lebanon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Governorate of Lebanon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Governorate of Lebanon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Governorate of Lebanon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Governorate of Lebanon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Governorate of Lebanon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Governorate of Lebanon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Governorate of Lebanon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Governorate of Lebanon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Governorate of Lebanon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Governorate of Lebanon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Governorate of Lebanon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Governorate of Lebanon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Governorate of Lebanon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Governorate of Lebanon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Governorate of Lebanon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Governorate of Lebanon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Governorate of Lebanon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "North (Region of Singapore)": [
            {
                "Region Name": "North (Region of Singapore)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Region of Singapore)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Region of Singapore)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Region of Singapore)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Region of Singapore)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Region of Singapore)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Region of Singapore)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Region of Singapore)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Region of Singapore)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Region of Singapore)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Region of Singapore)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Region of Singapore)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Region of Singapore)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Region of Singapore)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Region of Singapore)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Region of Singapore)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Region of Singapore)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Region of Singapore)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Region of Singapore)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Region of Singapore)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Region of Singapore)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North (Region of Singapore)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "North Abaco (District of Bahamas)": [
            {
                "Region Name": "North Abaco (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "North Abaco (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Abaco (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "North Abaco (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North Abaco (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Abaco (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "North Abaco (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "North Abaco (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Abaco (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North Abaco (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "North Abaco (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North Abaco (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North Abaco (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Abaco (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Abaco (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North Abaco (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "North Abaco (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North Abaco (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "North Abaco (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "North Abaco (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Abaco (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Abaco (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "North Andros (District of Bahamas)": [
            {
                "Region Name": "North Andros (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Andros (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "North Andros (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "North Andros (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North Andros (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "North Andros (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North Andros (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North Andros (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North Andros (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North Andros (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "North Andros (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Andros (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "North Andros (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "North Andros (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Andros (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "North Andros (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "North Andros (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "North Andros (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North Andros (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "North Andros (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North Andros (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "North Andros (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "North Bahr-al-Ghazal (State of South Sudan)": [
            {
                "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "North Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "North Bank (Division of Gambia)": [
            {
                "Region Name": "North Bank (Division of Gambia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "North Bank (Division of Gambia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "North Bank (Division of Gambia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "North Bank (Division of Gambia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "North Bank (Division of Gambia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "North Bank (Division of Gambia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "North Bank (Division of Gambia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "North Bank (Division of Gambia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "North Bank (Division of Gambia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "North Bank (Division of Gambia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North Bank (Division of Gambia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North Bank (Division of Gambia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North Bank (Division of Gambia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Bank (Division of Gambia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North Bank (Division of Gambia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North Bank (Division of Gambia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Bank (Division of Gambia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "North Bank (Division of Gambia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Bank (Division of Gambia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "North Bank (Division of Gambia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Bank (Division of Gambia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "North Bank (Division of Gambia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "North Caicos (District of Turks and Caicos Islands)": [
            {
                "Region Name": "North Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "North Carolina (State of United States)": [
            {
                "Region Name": "North Carolina (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "North Carolina (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Carolina (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Carolina (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Carolina (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North Carolina (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Carolina (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Carolina (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Carolina (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North Carolina (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North Carolina (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North Carolina (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Carolina (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Carolina (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North Carolina (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "North Carolina (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North Carolina (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Carolina (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Carolina (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Carolina (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "North Carolina (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Carolina (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "North Cotabato (Province of Philippines)": [
            {
                "Region Name": "North Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "North Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "North Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "North Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "North Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "North Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "North Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "North Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "North Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "North Dakota (State of United States)": [
            {
                "Region Name": "North Dakota (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North Dakota (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Dakota (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Dakota (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Dakota (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Dakota (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Dakota (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "North Dakota (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North Dakota (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North Dakota (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Dakota (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Dakota (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Dakota (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Dakota (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Dakota (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Dakota (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North Dakota (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Dakota (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "North Dakota (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North Dakota (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Dakota (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Dakota (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "North Darfur (State of Sudan)": [
            {
                "Region Name": "North Darfur (State of Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "North Darfur (State of Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 125
            },
            {
                "Region Name": "North Darfur (State of Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "North Darfur (State of Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 167
            },
            {
                "Region Name": "North Darfur (State of Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "North Darfur (State of Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 105
            },
            {
                "Region Name": "North Darfur (State of Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 59
            },
            {
                "Region Name": "North Darfur (State of Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 83
            },
            {
                "Region Name": "North Darfur (State of Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "North Darfur (State of Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "North Darfur (State of Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 105
            },
            {
                "Region Name": "North Darfur (State of Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 82
            },
            {
                "Region Name": "North Darfur (State of Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "North Darfur (State of Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "North Darfur (State of Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 96
            },
            {
                "Region Name": "North Darfur (State of Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 73
            },
            {
                "Region Name": "North Darfur (State of Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 103
            },
            {
                "Region Name": "North Darfur (State of Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "North Darfur (State of Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 82
            },
            {
                "Region Name": "North Darfur (State of Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "North Darfur (State of Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "North Darfur (State of Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 29
            }
        ],
        "North East (Region of Ghana)": [
            {
                "Region Name": "North East (Region of Ghana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "North East (Region of Ghana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "North East (Region of Ghana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "North East (Region of Ghana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "North East (Region of Ghana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "North East (Region of Ghana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "North East (Region of Ghana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "North East (Region of Ghana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "North East (Region of Ghana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "North East (Region of Ghana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "North East (Region of Ghana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "North East (Region of Ghana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "North East (Region of Ghana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "North East (Region of Ghana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "North East (Region of Ghana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "North East (Region of Ghana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "North East (Region of Ghana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "North East (Region of Ghana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "North East (Region of Ghana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "North East (Region of Ghana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "North East (Region of Ghana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "North East (Region of Ghana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 20
            }
        ],
        "North Eleuthera (District of Bahamas)": [
            {
                "Region Name": "North Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "North Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "North Hill (District of Anguilla)": [
            {
                "Region Name": "North Hill (District of Anguilla)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Hill (District of Anguilla)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Hill (District of Anguilla)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Hill (District of Anguilla)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Hill (District of Anguilla)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Hill (District of Anguilla)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Hill (District of Anguilla)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Hill (District of Anguilla)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Hill (District of Anguilla)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Hill (District of Anguilla)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Hill (District of Anguilla)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Hill (District of Anguilla)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Hill (District of Anguilla)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Hill (District of Anguilla)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Hill (District of Anguilla)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Hill (District of Anguilla)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Hill (District of Anguilla)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Hill (District of Anguilla)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Hill (District of Anguilla)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Hill (District of Anguilla)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Hill (District of Anguilla)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Hill (District of Anguilla)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "North Kazakhstan (Region of Kazakhstan)": [
            {
                "Region Name": "North Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "North Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "North Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "North Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "North Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "North Khorasan (Province of Iran)": [
            {
                "Region Name": "North Khorasan (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "North Khorasan (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "North Khorasan (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North Khorasan (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Khorasan (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "North Khorasan (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "North Khorasan (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Khorasan (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Khorasan (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North Khorasan (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "North Khorasan (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Khorasan (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "North Khorasan (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Khorasan (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Khorasan (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "North Khorasan (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "North Khorasan (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "North Khorasan (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "North Khorasan (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Khorasan (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "North Khorasan (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Khorasan (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "North Kurdufan (State of Sudan)": [
            {
                "Region Name": "North Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "North Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "North Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "North Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "North Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "North Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "North Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "North Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "North Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 57
            },
            {
                "Region Name": "North Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "North Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "North Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "North Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "North Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 67
            },
            {
                "Region Name": "North Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "North Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "North Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "North Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "North Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "North Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "North Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 19
            }
        ],
        "North Ossetia (Republic of Russia)": [
            {
                "Region Name": "North Ossetia (Republic of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North Ossetia (Republic of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North Ossetia (Republic of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North Ossetia (Republic of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Ossetia (Republic of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North Ossetia (Republic of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North Ossetia (Republic of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Ossetia (Republic of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North Ossetia (Republic of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Ossetia (Republic of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North Ossetia (Republic of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "North Ossetia (Republic of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Ossetia (Republic of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "North Ossetia (Republic of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North Ossetia (Republic of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Ossetia (Republic of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Ossetia (Republic of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North Ossetia (Republic of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North Ossetia (Republic of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North Ossetia (Republic of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "North Ossetia (Republic of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North Ossetia (Republic of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "North Side (District of Anguilla)": [
            {
                "Region Name": "North Side (District of Anguilla)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Anguilla)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Anguilla)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Anguilla)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Anguilla)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Anguilla)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Anguilla)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Anguilla)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Anguilla)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Anguilla)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Anguilla)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Anguilla)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Anguilla)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Anguilla)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Anguilla)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Anguilla)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Anguilla)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Anguilla)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Anguilla)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Anguilla)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Anguilla)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Anguilla)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "North Side (District of Cayman Islands)": [
            {
                "Region Name": "North Side (District of Cayman Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Cayman Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Cayman Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Cayman Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Cayman Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Cayman Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Cayman Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Cayman Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Cayman Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Cayman Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Cayman Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Cayman Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Cayman Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Cayman Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Cayman Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Cayman Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Cayman Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Cayman Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Cayman Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Cayman Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Cayman Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "North Side (District of Cayman Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "North West (Province of South Africa)": [
            {
                "Region Name": "North West (Province of South Africa)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "North West (Province of South Africa)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "North West (Province of South Africa)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "North West (Province of South Africa)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "North West (Province of South Africa)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "North West (Province of South Africa)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "North West (Province of South Africa)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "North West (Province of South Africa)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "North West (Province of South Africa)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "North West (Province of South Africa)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "North West (Province of South Africa)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "North West (Province of South Africa)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "North West (Province of South Africa)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "North West (Province of South Africa)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "North West (Province of South Africa)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "North West (Province of South Africa)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "North West (Province of South Africa)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "North West (Province of South Africa)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "North West (Province of South Africa)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "North West (Province of South Africa)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "North West (Province of South Africa)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "North West (Province of South Africa)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 38
            }
        ],
        "Northeast Greenland National Par (National Park of Greenland)": [
            {
                "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northeast Greenland National Par (National Park of Greenland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Northern (Division of Fiji)": [
            {
                "Region Name": "Northern (Division of Fiji)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Division of Fiji)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Northern (Division of Fiji)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Division of Fiji)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Division of Fiji)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Division of Fiji)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Division of Fiji)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Division of Fiji)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Division of Fiji)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Division of Fiji)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Division of Fiji)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Division of Fiji)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Division of Fiji)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Northern (Division of Fiji)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Division of Fiji)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Division of Fiji)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Division of Fiji)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Northern (Division of Fiji)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Northern (Division of Fiji)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Division of Fiji)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Division of Fiji)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Division of Fiji)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Northern (Governorate of Bahrain)": [
            {
                "Region Name": "Northern (Governorate of Bahrain)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Governorate of Bahrain)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Governorate of Bahrain)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Governorate of Bahrain)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Governorate of Bahrain)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Governorate of Bahrain)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Governorate of Bahrain)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Governorate of Bahrain)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Governorate of Bahrain)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Governorate of Bahrain)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Governorate of Bahrain)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Governorate of Bahrain)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Governorate of Bahrain)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Governorate of Bahrain)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Governorate of Bahrain)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Governorate of Bahrain)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Governorate of Bahrain)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Governorate of Bahrain)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Governorate of Bahrain)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Governorate of Bahrain)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Governorate of Bahrain)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (Governorate of Bahrain)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Northern (Province of Sierra Leone)": [
            {
                "Region Name": "Northern (Province of Sierra Leone)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Northern (Province of Sierra Leone)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Northern (Province of Sierra Leone)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Northern (Province of Sierra Leone)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Northern (Province of Sierra Leone)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Northern (Province of Sierra Leone)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Northern (Province of Sierra Leone)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Northern (Province of Sierra Leone)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Northern (Province of Sierra Leone)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Northern (Province of Sierra Leone)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Northern (Province of Sierra Leone)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Northern (Province of Sierra Leone)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Northern (Province of Sierra Leone)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Northern (Province of Sierra Leone)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Northern (Province of Sierra Leone)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Northern (Province of Sierra Leone)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Northern (Province of Sierra Leone)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Northern (Province of Sierra Leone)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Northern (Province of Sierra Leone)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Northern (Province of Sierra Leone)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Northern (Province of Sierra Leone)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Northern (Province of Sierra Leone)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Northern (Province of Zambia)": [
            {
                "Region Name": "Northern (Province of Zambia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Northern (Province of Zambia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Northern (Province of Zambia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Northern (Province of Zambia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Northern (Province of Zambia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Northern (Province of Zambia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Northern (Province of Zambia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Northern (Province of Zambia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Northern (Province of Zambia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Northern (Province of Zambia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Northern (Province of Zambia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Northern (Province of Zambia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Northern (Province of Zambia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Northern (Province of Zambia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Northern (Province of Zambia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Northern (Province of Zambia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Northern (Province of Zambia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Northern (Province of Zambia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Northern (Province of Zambia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Northern (Province of Zambia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Northern (Province of Zambia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Northern (Province of Zambia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 26
            }
        ],
        "Northern (Region of Ghana)": [
            {
                "Region Name": "Northern (Region of Ghana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Northern (Region of Ghana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Northern (Region of Ghana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Northern (Region of Ghana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Northern (Region of Ghana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Northern (Region of Ghana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Northern (Region of Ghana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Northern (Region of Ghana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Northern (Region of Ghana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Northern (Region of Ghana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Northern (Region of Ghana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Northern (Region of Ghana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Northern (Region of Ghana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Northern (Region of Ghana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Northern (Region of Ghana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Northern (Region of Ghana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Northern (Region of Ghana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Northern (Region of Ghana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Northern (Region of Ghana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Northern (Region of Ghana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Northern (Region of Ghana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Northern (Region of Ghana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 20
            }
        ],
        "Northern (State of Sudan)": [
            {
                "Region Name": "Northern (State of Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (State of Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (State of Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (State of Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (State of Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (State of Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (State of Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Northern (State of Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (State of Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (State of Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (State of Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (State of Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (State of Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Northern (State of Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (State of Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Northern (State of Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (State of Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern (State of Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Northern (State of Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Northern (State of Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Northern (State of Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Northern (State of Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Northern Cape (Province of South Africa)": [
            {
                "Region Name": "Northern Cape (Province of South Africa)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Northern Cape (Province of South Africa)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Northern Cape (Province of South Africa)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Northern Cape (Province of South Africa)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Northern Cape (Province of South Africa)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Northern Cape (Province of South Africa)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Northern Cape (Province of South Africa)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Northern Cape (Province of South Africa)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Northern Cape (Province of South Africa)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Northern Cape (Province of South Africa)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Northern Cape (Province of South Africa)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Northern Cape (Province of South Africa)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Northern Cape (Province of South Africa)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Northern Cape (Province of South Africa)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Northern Cape (Province of South Africa)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Northern Cape (Province of South Africa)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Northern Cape (Province of South Africa)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Northern Cape (Province of South Africa)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Northern Cape (Province of South Africa)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Northern Cape (Province of South Africa)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Northern Cape (Province of South Africa)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Northern Cape (Province of South Africa)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 42
            }
        ],
        "Northern Ireland (Constituent Country of United Kingdom)": [
            {
                "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Ireland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Northern Islands (Group of islands of New Zealand)": [
            {
                "Region Name": "Northern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Northern Islands (Municipality of Northern Mariana Islands)": [
            {
                "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Islands (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Northern Samar (Province of Philippines)": [
            {
                "Region Name": "Northern Samar (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Samar (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Samar (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Samar (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Samar (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Samar (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Samar (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Samar (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Samar (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Northern Samar (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Samar (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Samar (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Samar (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Samar (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Samar (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Northern Samar (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Samar (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Samar (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Samar (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Samar (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Samar (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northern Samar (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Northern Territory (Territory of Australia)": [
            {
                "Region Name": "Northern Territory (Territory of Australia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 120
            },
            {
                "Region Name": "Northern Territory (Territory of Australia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Northern Territory (Territory of Australia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 98
            },
            {
                "Region Name": "Northern Territory (Territory of Australia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Northern Territory (Territory of Australia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 72
            },
            {
                "Region Name": "Northern Territory (Territory of Australia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "Northern Territory (Territory of Australia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "Northern Territory (Territory of Australia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Northern Territory (Territory of Australia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Northern Territory (Territory of Australia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 83
            },
            {
                "Region Name": "Northern Territory (Territory of Australia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 90
            },
            {
                "Region Name": "Northern Territory (Territory of Australia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Northern Territory (Territory of Australia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 63
            },
            {
                "Region Name": "Northern Territory (Territory of Australia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 76
            },
            {
                "Region Name": "Northern Territory (Territory of Australia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Northern Territory (Territory of Australia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "Northern Territory (Territory of Australia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 61
            },
            {
                "Region Name": "Northern Territory (Territory of Australia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Northern Territory (Territory of Australia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Northern Territory (Territory of Australia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Northern Territory (Territory of Australia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Northern Territory (Territory of Australia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 61
            }
        ],
        "Northland (Region of New Zealand)": [
            {
                "Region Name": "Northland (Region of New Zealand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northland (Region of New Zealand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northland (Region of New Zealand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northland (Region of New Zealand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northland (Region of New Zealand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northland (Region of New Zealand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northland (Region of New Zealand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northland (Region of New Zealand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northland (Region of New Zealand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northland (Region of New Zealand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northland (Region of New Zealand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northland (Region of New Zealand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northland (Region of New Zealand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northland (Region of New Zealand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northland (Region of New Zealand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northland (Region of New Zealand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northland (Region of New Zealand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northland (Region of New Zealand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northland (Region of New Zealand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northland (Region of New Zealand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Northland (Region of New Zealand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Northland (Region of New Zealand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Northwest Territories (Territory of Canada)": [
            {
                "Region Name": "Northwest Territories (Territory of Canada)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Northwest Territories (Territory of Canada)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Northwest Territories (Territory of Canada)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Northwest Territories (Territory of Canada)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Northwest Territories (Territory of Canada)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Northwest Territories (Territory of Canada)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Northwest Territories (Territory of Canada)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Northwest Territories (Territory of Canada)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Northwest Territories (Territory of Canada)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Northwest Territories (Territory of Canada)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Northwest Territories (Territory of Canada)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Northwest Territories (Territory of Canada)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Northwest Territories (Territory of Canada)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Northwest Territories (Territory of Canada)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Northwest Territories (Territory of Canada)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Northwest Territories (Territory of Canada)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "Northwest Territories (Territory of Canada)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Northwest Territories (Territory of Canada)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Northwest Territories (Territory of Canada)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Northwest Territories (Territory of Canada)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Northwest Territories (Territory of Canada)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Northwest Territories (Territory of Canada)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 37
            }
        ],
        "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)": [
            {
                "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Notranjsko-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nouakchott (District of Mauritania)": [
            {
                "Region Name": "Nouakchott (District of Mauritania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nouakchott (District of Mauritania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nouakchott (District of Mauritania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nouakchott (District of Mauritania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nouakchott (District of Mauritania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nouakchott (District of Mauritania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nouakchott (District of Mauritania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nouakchott (District of Mauritania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nouakchott (District of Mauritania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nouakchott (District of Mauritania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nouakchott (District of Mauritania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nouakchott (District of Mauritania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nouakchott (District of Mauritania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nouakchott (District of Mauritania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nouakchott (District of Mauritania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nouakchott (District of Mauritania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nouakchott (District of Mauritania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nouakchott (District of Mauritania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nouakchott (District of Mauritania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nouakchott (District of Mauritania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nouakchott (District of Mauritania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nouakchott (District of Mauritania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nouvelle-Aquitaine (Region of France)": [
            {
                "Region Name": "Nouvelle-Aquitaine (Region of France)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nouvelle-Aquitaine (Region of France)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nouvelle-Aquitaine (Region of France)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nouvelle-Aquitaine (Region of France)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nouvelle-Aquitaine (Region of France)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nouvelle-Aquitaine (Region of France)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nouvelle-Aquitaine (Region of France)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nouvelle-Aquitaine (Region of France)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nouvelle-Aquitaine (Region of France)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nouvelle-Aquitaine (Region of France)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nouvelle-Aquitaine (Region of France)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nouvelle-Aquitaine (Region of France)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nouvelle-Aquitaine (Region of France)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nouvelle-Aquitaine (Region of France)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nouvelle-Aquitaine (Region of France)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nouvelle-Aquitaine (Region of France)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nouvelle-Aquitaine (Region of France)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nouvelle-Aquitaine (Region of France)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nouvelle-Aquitaine (Region of France)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nouvelle-Aquitaine (Region of France)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nouvelle-Aquitaine (Region of France)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nouvelle-Aquitaine (Region of France)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Nova Scotia (Province of Canada)": [
            {
                "Region Name": "Nova Scotia (Province of Canada)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nova Scotia (Province of Canada)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nova Scotia (Province of Canada)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nova Scotia (Province of Canada)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nova Scotia (Province of Canada)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nova Scotia (Province of Canada)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nova Scotia (Province of Canada)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nova Scotia (Province of Canada)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Nova Scotia (Province of Canada)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nova Scotia (Province of Canada)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nova Scotia (Province of Canada)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nova Scotia (Province of Canada)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nova Scotia (Province of Canada)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nova Scotia (Province of Canada)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nova Scotia (Province of Canada)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nova Scotia (Province of Canada)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nova Scotia (Province of Canada)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nova Scotia (Province of Canada)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nova Scotia (Province of Canada)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nova Scotia (Province of Canada)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nova Scotia (Province of Canada)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nova Scotia (Province of Canada)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 103
            }
        ],
        "Novatsi (Municipality of North Macedonia)": [
            {
                "Region Name": "Novatsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Novatsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Novatsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novatsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Novatsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Novatsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Novatsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Novatsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Novatsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novatsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Novatsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Novatsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Novatsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Novatsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novatsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Novatsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Novatsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novatsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Novatsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novatsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novatsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novatsi (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Novgorod (Region of Russia)": [
            {
                "Region Name": "Novgorod (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Novgorod (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Novgorod (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Novgorod (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Novgorod (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Novgorod (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Novgorod (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Novgorod (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Novgorod (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Novgorod (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Novgorod (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Novgorod (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Novgorod (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Novgorod (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Novgorod (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Novgorod (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Novgorod (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Novgorod (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Novgorod (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Novgorod (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Novgorod (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novgorod (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Novo Selo (Municipality of North Macedonia)": [
            {
                "Region Name": "Novo Selo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novo Selo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novo Selo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novo Selo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novo Selo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novo Selo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novo Selo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novo Selo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novo Selo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novo Selo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novo Selo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novo Selo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novo Selo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novo Selo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novo Selo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novo Selo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novo Selo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novo Selo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novo Selo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novo Selo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novo Selo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Novo Selo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Novosibirsk (Region of Russia)": [
            {
                "Region Name": "Novosibirsk (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Novosibirsk (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Novosibirsk (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Novosibirsk (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Novosibirsk (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Novosibirsk (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Novosibirsk (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Novosibirsk (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Novosibirsk (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Novosibirsk (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Novosibirsk (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Novosibirsk (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Novosibirsk (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Novosibirsk (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Novosibirsk (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Novosibirsk (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Novosibirsk (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Novosibirsk (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Novosibirsk (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Novosibirsk (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Novosibirsk (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Novosibirsk (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Nsanje (District of Malawi)": [
            {
                "Region Name": "Nsanje (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nsanje (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nsanje (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nsanje (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nsanje (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nsanje (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nsanje (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nsanje (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nsanje (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nsanje (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Nsanje (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nsanje (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nsanje (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nsanje (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nsanje (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nsanje (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nsanje (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nsanje (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nsanje (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nsanje (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nsanje (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nsanje (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Ntcheu (District of Malawi)": [
            {
                "Region Name": "Ntcheu (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ntcheu (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ntcheu (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ntcheu (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ntcheu (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ntcheu (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ntcheu (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ntcheu (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ntcheu (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ntcheu (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ntcheu (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ntcheu (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ntcheu (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ntcheu (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ntcheu (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ntcheu (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ntcheu (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ntcheu (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ntcheu (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ntcheu (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ntcheu (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ntcheu (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Ntchisi (District of Malawi)": [
            {
                "Region Name": "Ntchisi (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ntchisi (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ntchisi (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ntchisi (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ntchisi (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ntchisi (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ntchisi (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ntchisi (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ntchisi (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ntchisi (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ntchisi (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ntchisi (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ntchisi (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ntchisi (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ntchisi (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ntchisi (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ntchisi (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ntchisi (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ntchisi (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ntchisi (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ntchisi (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ntchisi (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Ntungamo (District of Uganda)": [
            {
                "Region Name": "Ntungamo (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ntungamo (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ntungamo (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ntungamo (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ntungamo (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ntungamo (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ntungamo (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ntungamo (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ntungamo (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ntungamo (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ntungamo (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ntungamo (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ntungamo (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ntungamo (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ntungamo (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ntungamo (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ntungamo (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ntungamo (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ntungamo (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ntungamo (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ntungamo (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ntungamo (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "\xd1uble (Region of Chile)": [
            {
                "Region Name": "\xd1uble (Region of Chile)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xd1uble (Region of Chile)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xd1uble (Region of Chile)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xd1uble (Region of Chile)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xd1uble (Region of Chile)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "\xd1uble (Region of Chile)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xd1uble (Region of Chile)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\xd1uble (Region of Chile)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "\xd1uble (Region of Chile)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "\xd1uble (Region of Chile)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "\xd1uble (Region of Chile)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xd1uble (Region of Chile)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xd1uble (Region of Chile)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\xd1uble (Region of Chile)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\xd1uble (Region of Chile)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "\xd1uble (Region of Chile)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xd1uble (Region of Chile)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "\xd1uble (Region of Chile)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "\xd1uble (Region of Chile)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\xd1uble (Region of Chile)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "\xd1uble (Region of Chile)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "\xd1uble (Region of Chile)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Nueva Ecija (Province of Philippines)": [
            {
                "Region Name": "Nueva Ecija (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nueva Ecija (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nueva Ecija (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nueva Ecija (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nueva Ecija (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nueva Ecija (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nueva Ecija (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nueva Ecija (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nueva Ecija (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nueva Ecija (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nueva Ecija (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nueva Ecija (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nueva Ecija (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nueva Ecija (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nueva Ecija (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nueva Ecija (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nueva Ecija (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nueva Ecija (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nueva Ecija (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nueva Ecija (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nueva Ecija (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nueva Ecija (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Nueva Esparta (State of Venezuela)": [
            {
                "Region Name": "Nueva Esparta (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nueva Esparta (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nueva Esparta (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nueva Esparta (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nueva Esparta (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nueva Esparta (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nueva Esparta (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nueva Esparta (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nueva Esparta (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nueva Esparta (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nueva Esparta (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nueva Esparta (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nueva Esparta (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nueva Esparta (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nueva Esparta (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nueva Esparta (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nueva Esparta (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nueva Esparta (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nueva Esparta (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nueva Esparta (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nueva Esparta (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nueva Esparta (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nueva Segovia (Department of Nicaragua)": [
            {
                "Region Name": "Nueva Segovia (Department of Nicaragua)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nueva Segovia (Department of Nicaragua)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nueva Segovia (Department of Nicaragua)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nueva Segovia (Department of Nicaragua)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nueva Segovia (Department of Nicaragua)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nueva Segovia (Department of Nicaragua)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nueva Segovia (Department of Nicaragua)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nueva Segovia (Department of Nicaragua)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nueva Segovia (Department of Nicaragua)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nueva Segovia (Department of Nicaragua)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nueva Segovia (Department of Nicaragua)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nueva Segovia (Department of Nicaragua)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nueva Segovia (Department of Nicaragua)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nueva Segovia (Department of Nicaragua)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nueva Segovia (Department of Nicaragua)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nueva Segovia (Department of Nicaragua)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nueva Segovia (Department of Nicaragua)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nueva Segovia (Department of Nicaragua)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nueva Segovia (Department of Nicaragua)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nueva Segovia (Department of Nicaragua)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nueva Segovia (Department of Nicaragua)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nueva Segovia (Department of Nicaragua)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Nueva Vizcaya (Province of Philippines)": [
            {
                "Region Name": "Nueva Vizcaya (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nueva Vizcaya (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nueva Vizcaya (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nueva Vizcaya (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nueva Vizcaya (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nueva Vizcaya (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nueva Vizcaya (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nueva Vizcaya (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nueva Vizcaya (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nueva Vizcaya (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nueva Vizcaya (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nueva Vizcaya (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nueva Vizcaya (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nueva Vizcaya (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nueva Vizcaya (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nueva Vizcaya (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nueva Vizcaya (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nueva Vizcaya (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nueva Vizcaya (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nueva Vizcaya (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nueva Vizcaya (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nueva Vizcaya (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Nuevo Le\xf3n (State of M\xe9xico)": [
            {
                "Region Name": "Nuevo Le\xf3n (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nuevo Le\xf3n (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nuevo Le\xf3n (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nuevo Le\xf3n (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nuevo Le\xf3n (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nuevo Le\xf3n (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nuevo Le\xf3n (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nuevo Le\xf3n (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nuevo Le\xf3n (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nuevo Le\xf3n (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Nuevo Le\xf3n (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nuevo Le\xf3n (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nuevo Le\xf3n (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nuevo Le\xf3n (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nuevo Le\xf3n (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nuevo Le\xf3n (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nuevo Le\xf3n (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nuevo Le\xf3n (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nuevo Le\xf3n (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nuevo Le\xf3n (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Nuevo Le\xf3n (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Nuevo Le\xf3n (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "Nugaal (Region of Somalia)": [
            {
                "Region Name": "Nugaal (Region of Somalia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nugaal (Region of Somalia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nugaal (Region of Somalia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nugaal (Region of Somalia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nugaal (Region of Somalia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nugaal (Region of Somalia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nugaal (Region of Somalia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nugaal (Region of Somalia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nugaal (Region of Somalia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nugaal (Region of Somalia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nugaal (Region of Somalia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nugaal (Region of Somalia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nugaal (Region of Somalia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nugaal (Region of Somalia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nugaal (Region of Somalia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nugaal (Region of Somalia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nugaal (Region of Somalia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nugaal (Region of Somalia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nugaal (Region of Somalia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nugaal (Region of Somalia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nugaal (Region of Somalia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nugaal (Region of Somalia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nui (Island Council of Tuvalu)": [
            {
                "Region Name": "Nui (Island Council of Tuvalu)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nui (Island Council of Tuvalu)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nui (Island Council of Tuvalu)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nui (Island Council of Tuvalu)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nui (Island Council of Tuvalu)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nui (Island Council of Tuvalu)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nui (Island Council of Tuvalu)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nui (Island Council of Tuvalu)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nui (Island Council of Tuvalu)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nui (Island Council of Tuvalu)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nui (Island Council of Tuvalu)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nui (Island Council of Tuvalu)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nui (Island Council of Tuvalu)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nui (Island Council of Tuvalu)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nui (Island Council of Tuvalu)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nui (Island Council of Tuvalu)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nui (Island Council of Tuvalu)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nui (Island Council of Tuvalu)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nui (Island Council of Tuvalu)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nui (Island Council of Tuvalu)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nui (Island Council of Tuvalu)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nui (Island Council of Tuvalu)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nukufetau (Island Council of Tuvalu)": [
            {
                "Region Name": "Nukufetau (Island Council of Tuvalu)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukufetau (Island Council of Tuvalu)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukufetau (Island Council of Tuvalu)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukufetau (Island Council of Tuvalu)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukufetau (Island Council of Tuvalu)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukufetau (Island Council of Tuvalu)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukufetau (Island Council of Tuvalu)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukufetau (Island Council of Tuvalu)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukufetau (Island Council of Tuvalu)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukufetau (Island Council of Tuvalu)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukufetau (Island Council of Tuvalu)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukufetau (Island Council of Tuvalu)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukufetau (Island Council of Tuvalu)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukufetau (Island Council of Tuvalu)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukufetau (Island Council of Tuvalu)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukufetau (Island Council of Tuvalu)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukufetau (Island Council of Tuvalu)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukufetau (Island Council of Tuvalu)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukufetau (Island Council of Tuvalu)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukufetau (Island Council of Tuvalu)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukufetau (Island Council of Tuvalu)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukufetau (Island Council of Tuvalu)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nukulaelae (Island Council of Tuvalu)": [
            {
                "Region Name": "Nukulaelae (Island Council of Tuvalu)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukulaelae (Island Council of Tuvalu)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukulaelae (Island Council of Tuvalu)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukulaelae (Island Council of Tuvalu)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukulaelae (Island Council of Tuvalu)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukulaelae (Island Council of Tuvalu)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukulaelae (Island Council of Tuvalu)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukulaelae (Island Council of Tuvalu)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukulaelae (Island Council of Tuvalu)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukulaelae (Island Council of Tuvalu)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukulaelae (Island Council of Tuvalu)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukulaelae (Island Council of Tuvalu)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukulaelae (Island Council of Tuvalu)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukulaelae (Island Council of Tuvalu)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukulaelae (Island Council of Tuvalu)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukulaelae (Island Council of Tuvalu)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukulaelae (Island Council of Tuvalu)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukulaelae (Island Council of Tuvalu)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukulaelae (Island Council of Tuvalu)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukulaelae (Island Council of Tuvalu)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukulaelae (Island Council of Tuvalu)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukulaelae (Island Council of Tuvalu)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nukunonu (Atoll of Tokelau)": [
            {
                "Region Name": "Nukunonu (Atoll of Tokelau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukunonu (Atoll of Tokelau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukunonu (Atoll of Tokelau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukunonu (Atoll of Tokelau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukunonu (Atoll of Tokelau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukunonu (Atoll of Tokelau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukunonu (Atoll of Tokelau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukunonu (Atoll of Tokelau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukunonu (Atoll of Tokelau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukunonu (Atoll of Tokelau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukunonu (Atoll of Tokelau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukunonu (Atoll of Tokelau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukunonu (Atoll of Tokelau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukunonu (Atoll of Tokelau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukunonu (Atoll of Tokelau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukunonu (Atoll of Tokelau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukunonu (Atoll of Tokelau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukunonu (Atoll of Tokelau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukunonu (Atoll of Tokelau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukunonu (Atoll of Tokelau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukunonu (Atoll of Tokelau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nukunonu (Atoll of Tokelau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nunavut (Territory of Canada)": [
            {
                "Region Name": "Nunavut (Territory of Canada)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nunavut (Territory of Canada)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nunavut (Territory of Canada)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nunavut (Territory of Canada)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nunavut (Territory of Canada)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nunavut (Territory of Canada)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nunavut (Territory of Canada)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Nunavut (Territory of Canada)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nunavut (Territory of Canada)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Nunavut (Territory of Canada)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nunavut (Territory of Canada)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nunavut (Territory of Canada)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nunavut (Territory of Canada)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nunavut (Territory of Canada)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nunavut (Territory of Canada)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nunavut (Territory of Canada)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nunavut (Territory of Canada)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nunavut (Territory of Canada)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nunavut (Territory of Canada)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nunavut (Territory of Canada)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nunavut (Territory of Canada)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nunavut (Territory of Canada)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Nuristan (Province of Afghanistan)": [
            {
                "Region Name": "Nuristan (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuristan (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuristan (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuristan (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuristan (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nuristan (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuristan (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuristan (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuristan (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuristan (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuristan (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuristan (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuristan (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuristan (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuristan (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuristan (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuristan (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuristan (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuristan (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuristan (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuristan (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuristan (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nusa Tenggara Barat (Province of Indonesia)": [
            {
                "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nusa Tenggara Barat (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 19
            }
        ],
        "Nusa Tenggara Timur (Province of Indonesia)": [
            {
                "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nusa Tenggara Timur (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Nuwara Eliya (District of Sri Lanka)": [
            {
                "Region Name": "Nuwara Eliya (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuwara Eliya (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuwara Eliya (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuwara Eliya (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuwara Eliya (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuwara Eliya (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuwara Eliya (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuwara Eliya (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nuwara Eliya (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuwara Eliya (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nuwara Eliya (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuwara Eliya (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuwara Eliya (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuwara Eliya (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuwara Eliya (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nuwara Eliya (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuwara Eliya (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuwara Eliya (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuwara Eliya (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuwara Eliya (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nuwara Eliya (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nuwara Eliya (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Nyamira (County of Kenya)": [
            {
                "Region Name": "Nyamira (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyamira (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyamira (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyamira (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyamira (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyamira (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyamira (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyamira (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyamira (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyamira (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyamira (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyamira (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyamira (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyamira (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyamira (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyamira (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyamira (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyamira (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyamira (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyamira (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyamira (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyamira (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nyandarua (County of Kenya)": [
            {
                "Region Name": "Nyandarua (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nyandarua (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nyandarua (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nyandarua (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nyandarua (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyandarua (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Nyandarua (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nyandarua (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nyandarua (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nyandarua (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Nyandarua (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 131
            },
            {
                "Region Name": "Nyandarua (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nyandarua (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nyandarua (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Nyandarua (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyandarua (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyandarua (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Nyandarua (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nyandarua (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyandarua (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyandarua (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Nyandarua (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nyanga (Province of Gabon)": [
            {
                "Region Name": "Nyanga (Province of Gabon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nyanga (Province of Gabon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nyanga (Province of Gabon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nyanga (Province of Gabon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nyanga (Province of Gabon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nyanga (Province of Gabon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nyanga (Province of Gabon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nyanga (Province of Gabon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nyanga (Province of Gabon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nyanga (Province of Gabon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nyanga (Province of Gabon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nyanga (Province of Gabon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nyanga (Province of Gabon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nyanga (Province of Gabon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nyanga (Province of Gabon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nyanga (Province of Gabon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nyanga (Province of Gabon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nyanga (Province of Gabon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nyanga (Province of Gabon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Nyanga (Province of Gabon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nyanga (Province of Gabon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nyanga (Province of Gabon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Nyeri (County of Kenya)": [
            {
                "Region Name": "Nyeri (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Nyeri (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nyeri (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyeri (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Nyeri (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyeri (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyeri (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Nyeri (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyeri (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nyeri (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Nyeri (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Nyeri (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyeri (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Nyeri (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyeri (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 57
            },
            {
                "Region Name": "Nyeri (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyeri (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyeri (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nyeri (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nyeri (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Nyeri (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 85
            },
            {
                "Region Name": "Nyeri (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Nz\xe9r\xe9kor\xe9 (Region of Guinea)": [
            {
                "Region Name": "Nz\xe9r\xe9kor\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Nz\xe9r\xe9kor\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nz\xe9r\xe9kor\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nz\xe9r\xe9kor\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nz\xe9r\xe9kor\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nz\xe9r\xe9kor\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nz\xe9r\xe9kor\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Nz\xe9r\xe9kor\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nz\xe9r\xe9kor\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nz\xe9r\xe9kor\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nz\xe9r\xe9kor\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nz\xe9r\xe9kor\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nz\xe9r\xe9kor\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Nz\xe9r\xe9kor\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Nz\xe9r\xe9kor\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nz\xe9r\xe9kor\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Nz\xe9r\xe9kor\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Nz\xe9r\xe9kor\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Nz\xe9r\xe9kor\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nz\xe9r\xe9kor\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Nz\xe9r\xe9kor\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Nz\xe9r\xe9kor\xe9 (Region of Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Nzwani (Autonomous Island of Comoros)": [
            {
                "Region Name": "Nzwani (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nzwani (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nzwani (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nzwani (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nzwani (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nzwani (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nzwani (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nzwani (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nzwani (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nzwani (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nzwani (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nzwani (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nzwani (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nzwani (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nzwani (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nzwani (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nzwani (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nzwani (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nzwani (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nzwani (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nzwani (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Nzwani (Autonomous Island of Comoros)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Oaxaca (State of M\xe9xico)": [
            {
                "Region Name": "Oaxaca (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oaxaca (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oaxaca (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oaxaca (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oaxaca (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oaxaca (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oaxaca (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oaxaca (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oaxaca (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oaxaca (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oaxaca (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oaxaca (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oaxaca (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oaxaca (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oaxaca (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oaxaca (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oaxaca (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oaxaca (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oaxaca (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oaxaca (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oaxaca (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oaxaca (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Obalno-kra\u0161ka (Statistical Region of Slovenia)": [
            {
                "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obalno-kra\u0161ka (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ober\xf6sterreich (State of Austria)": [
            {
                "Region Name": "Ober\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ober\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ober\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ober\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ober\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Ober\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ober\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ober\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ober\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ober\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ober\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ober\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ober\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ober\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ober\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ober\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ober\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ober\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ober\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ober\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ober\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ober\xf6sterreich (State of Austria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Obock (Region of Djibouti)": [
            {
                "Region Name": "Obock (Region of Djibouti)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obock (Region of Djibouti)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obock (Region of Djibouti)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obock (Region of Djibouti)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obock (Region of Djibouti)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obock (Region of Djibouti)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obock (Region of Djibouti)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obock (Region of Djibouti)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obock (Region of Djibouti)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obock (Region of Djibouti)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obock (Region of Djibouti)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obock (Region of Djibouti)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obock (Region of Djibouti)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obock (Region of Djibouti)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obock (Region of Djibouti)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obock (Region of Djibouti)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obock (Region of Djibouti)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obock (Region of Djibouti)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obock (Region of Djibouti)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obock (Region of Djibouti)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obock (Region of Djibouti)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obock (Region of Djibouti)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Obwalden (Canton of Switzerland)": [
            {
                "Region Name": "Obwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Obwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Obwalden (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Occidental Mindoro (Province of Philippines)": [
            {
                "Region Name": "Occidental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Occidental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Occidental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Occidental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Occidental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Occidental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Occidental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Occidental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Occidental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Occidental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Occidental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Occidental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Occidental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Occidental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Occidental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Occidental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Occidental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Occidental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Occidental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Occidental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Occidental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Occidental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Occitanie (Region of France)": [
            {
                "Region Name": "Occitanie (Region of France)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Occitanie (Region of France)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Occitanie (Region of France)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Occitanie (Region of France)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Occitanie (Region of France)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Occitanie (Region of France)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Occitanie (Region of France)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Occitanie (Region of France)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Occitanie (Region of France)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Occitanie (Region of France)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Occitanie (Region of France)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Occitanie (Region of France)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Occitanie (Region of France)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Occitanie (Region of France)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Occitanie (Region of France)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Occitanie (Region of France)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Occitanie (Region of France)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Occitanie (Region of France)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Occitanie (Region of France)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Occitanie (Region of France)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Occitanie (Region of France)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Occitanie (Region of France)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Ocni\u021Ba (District of Moldova)": [
            {
                "Region Name": "Ocni\u021Ba (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocni\u021Ba (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocni\u021Ba (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocni\u021Ba (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocni\u021Ba (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocni\u021Ba (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocni\u021Ba (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ocni\u021Ba (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocni\u021Ba (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ocni\u021Ba (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocni\u021Ba (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocni\u021Ba (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ocni\u021Ba (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocni\u021Ba (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocni\u021Ba (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ocni\u021Ba (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ocni\u021Ba (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ocni\u021Ba (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocni\u021Ba (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ocni\u021Ba (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocni\u021Ba (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ocni\u021Ba (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ocotepeque (Department of Honduras)": [
            {
                "Region Name": "Ocotepeque (Department of Honduras)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ocotepeque (Department of Honduras)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ocotepeque (Department of Honduras)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ocotepeque (Department of Honduras)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocotepeque (Department of Honduras)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ocotepeque (Department of Honduras)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocotepeque (Department of Honduras)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocotepeque (Department of Honduras)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ocotepeque (Department of Honduras)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocotepeque (Department of Honduras)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocotepeque (Department of Honduras)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocotepeque (Department of Honduras)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocotepeque (Department of Honduras)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ocotepeque (Department of Honduras)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocotepeque (Department of Honduras)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocotepeque (Department of Honduras)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ocotepeque (Department of Honduras)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ocotepeque (Department of Honduras)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocotepeque (Department of Honduras)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocotepeque (Department of Honduras)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ocotepeque (Department of Honduras)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ocotepeque (Department of Honduras)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Odessa (Region of Ukraine)": [
            {
                "Region Name": "Odessa (Region of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Odessa (Region of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Odessa (Region of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Odessa (Region of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Odessa (Region of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Odessa (Region of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Odessa (Region of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Odessa (Region of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Odessa (Region of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Odessa (Region of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Odessa (Region of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Odessa (Region of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Odessa (Region of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Odessa (Region of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Odessa (Region of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Odessa (Region of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Odessa (Region of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Odessa (Region of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Odessa (Region of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Odessa (Region of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Odessa (Region of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Odessa (Region of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Odisha (State of India)": [
            {
                "Region Name": "Odisha (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Odisha (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Odisha (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Odisha (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Odisha (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Odisha (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Odisha (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Odisha (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Odisha (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Odisha (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Odisha (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Odisha (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Odisha (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Odisha (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Odisha (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Odisha (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Odisha (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Odisha (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Odisha (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Odisha (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Odisha (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Odisha (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Offaly (County of Ireland)": [
            {
                "Region Name": "Offaly (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Offaly (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Offaly (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Offaly (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Offaly (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Offaly (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Offaly (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Offaly (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Offaly (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Offaly (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Offaly (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Offaly (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Offaly (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Offaly (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Offaly (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Offaly (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Offaly (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Offaly (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Offaly (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Offaly (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Offaly (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Offaly (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ogoou\xe9-Ivindo (Province of Gabon)": [
            {
                "Region Name": "Ogoou\xe9-Ivindo (Province of Gabon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ogoou\xe9-Ivindo (Province of Gabon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ogoou\xe9-Ivindo (Province of Gabon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ogoou\xe9-Ivindo (Province of Gabon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ogoou\xe9-Ivindo (Province of Gabon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ogoou\xe9-Ivindo (Province of Gabon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ogoou\xe9-Ivindo (Province of Gabon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ogoou\xe9-Ivindo (Province of Gabon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ogoou\xe9-Ivindo (Province of Gabon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Ivindo (Province of Gabon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ogoou\xe9-Ivindo (Province of Gabon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Ivindo (Province of Gabon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Ivindo (Province of Gabon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Ivindo (Province of Gabon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ogoou\xe9-Ivindo (Province of Gabon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Ivindo (Province of Gabon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Ivindo (Province of Gabon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Ivindo (Province of Gabon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ogoou\xe9-Ivindo (Province of Gabon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ogoou\xe9-Ivindo (Province of Gabon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Ivindo (Province of Gabon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Ivindo (Province of Gabon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Ogoou\xe9-Lolo (Province of Gabon)": [
            {
                "Region Name": "Ogoou\xe9-Lolo (Province of Gabon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ogoou\xe9-Lolo (Province of Gabon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ogoou\xe9-Lolo (Province of Gabon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Lolo (Province of Gabon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Lolo (Province of Gabon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ogoou\xe9-Lolo (Province of Gabon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Lolo (Province of Gabon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Lolo (Province of Gabon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ogoou\xe9-Lolo (Province of Gabon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Lolo (Province of Gabon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ogoou\xe9-Lolo (Province of Gabon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Lolo (Province of Gabon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ogoou\xe9-Lolo (Province of Gabon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ogoou\xe9-Lolo (Province of Gabon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ogoou\xe9-Lolo (Province of Gabon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Lolo (Province of Gabon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Lolo (Province of Gabon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Lolo (Province of Gabon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Lolo (Province of Gabon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Lolo (Province of Gabon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ogoou\xe9-Lolo (Province of Gabon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Lolo (Province of Gabon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Ogoou\xe9-Maritime (Province of Gabon)": [
            {
                "Region Name": "Ogoou\xe9-Maritime (Province of Gabon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ogoou\xe9-Maritime (Province of Gabon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ogoou\xe9-Maritime (Province of Gabon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ogoou\xe9-Maritime (Province of Gabon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ogoou\xe9-Maritime (Province of Gabon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Maritime (Province of Gabon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ogoou\xe9-Maritime (Province of Gabon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ogoou\xe9-Maritime (Province of Gabon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Maritime (Province of Gabon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Maritime (Province of Gabon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ogoou\xe9-Maritime (Province of Gabon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ogoou\xe9-Maritime (Province of Gabon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ogoou\xe9-Maritime (Province of Gabon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ogoou\xe9-Maritime (Province of Gabon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ogoou\xe9-Maritime (Province of Gabon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ogoou\xe9-Maritime (Province of Gabon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ogoou\xe9-Maritime (Province of Gabon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ogoou\xe9-Maritime (Province of Gabon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ogoou\xe9-Maritime (Province of Gabon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ogoou\xe9-Maritime (Province of Gabon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ogoou\xe9-Maritime (Province of Gabon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ogoou\xe9-Maritime (Province of Gabon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Ogun (State of Nigeria)": [
            {
                "Region Name": "Ogun (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ogun (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ogun (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Ogun (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ogun (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ogun (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ogun (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ogun (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ogun (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ogun (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ogun (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ogun (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ogun (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ogun (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ogun (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ogun (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ogun (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ogun (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ogun (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ogun (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ogun (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ogun (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Ohangwena (Region of Namibia)": [
            {
                "Region Name": "Ohangwena (Region of Namibia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 425
            },
            {
                "Region Name": "Ohangwena (Region of Namibia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 164
            },
            {
                "Region Name": "Ohangwena (Region of Namibia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Ohangwena (Region of Namibia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 67
            },
            {
                "Region Name": "Ohangwena (Region of Namibia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ohangwena (Region of Namibia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Ohangwena (Region of Namibia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Ohangwena (Region of Namibia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Ohangwena (Region of Namibia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ohangwena (Region of Namibia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ohangwena (Region of Namibia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Ohangwena (Region of Namibia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Ohangwena (Region of Namibia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ohangwena (Region of Namibia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ohangwena (Region of Namibia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 114
            },
            {
                "Region Name": "Ohangwena (Region of Namibia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ohangwena (Region of Namibia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohangwena (Region of Namibia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohangwena (Region of Namibia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ohangwena (Region of Namibia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ohangwena (Region of Namibia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohangwena (Region of Namibia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ohio (State of United States)": [
            {
                "Region Name": "Ohio (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ohio (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ohio (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ohio (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ohio (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ohio (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ohio (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ohio (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ohio (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ohio (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohio (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ohio (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ohio (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ohio (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ohio (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ohio (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohio (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohio (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ohio (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ohio (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ohio (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ohio (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Ohrid (Municipality of North Macedonia)": [
            {
                "Region Name": "Ohrid (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohrid (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohrid (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohrid (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohrid (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohrid (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ohrid (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohrid (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohrid (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohrid (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohrid (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohrid (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohrid (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohrid (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohrid (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohrid (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohrid (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohrid (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohrid (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohrid (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ohrid (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ohrid (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Oio (Region of Guinea-Bissau)": [
            {
                "Region Name": "Oio (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Oio (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Oio (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Oio (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Oio (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Oio (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Oio (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Oio (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Oio (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Oio (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Oio (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oio (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Oio (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Oio (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Oio (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Oio (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Oio (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Oio (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Oio (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Oio (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Oio (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oio (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Oita (Prefecture of Japan)": [
            {
                "Region Name": "Oita (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oita (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Oita (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oita (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Oita (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oita (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oita (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oita (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Oita (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oita (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Oita (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oita (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oita (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oita (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oita (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oita (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oita (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oita (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Oita (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Oita (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oita (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oita (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Okayama (Prefecture of Japan)": [
            {
                "Region Name": "Okayama (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okayama (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okayama (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okayama (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okayama (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okayama (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okayama (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okayama (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okayama (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okayama (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okayama (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okayama (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okayama (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okayama (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okayama (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okayama (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okayama (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okayama (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okayama (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okayama (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okayama (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okayama (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Okinawa (Prefecture of Japan)": [
            {
                "Region Name": "Okinawa (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okinawa (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okinawa (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okinawa (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okinawa (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okinawa (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okinawa (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okinawa (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okinawa (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okinawa (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okinawa (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okinawa (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okinawa (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okinawa (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okinawa (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okinawa (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okinawa (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okinawa (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okinawa (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okinawa (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okinawa (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Okinawa (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Oklahoma (State of United States)": [
            {
                "Region Name": "Oklahoma (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Oklahoma (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Oklahoma (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Oklahoma (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Oklahoma (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Oklahoma (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Oklahoma (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Oklahoma (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Oklahoma (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Oklahoma (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Oklahoma (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Oklahoma (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oklahoma (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Oklahoma (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Oklahoma (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Oklahoma (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Oklahoma (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Oklahoma (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Oklahoma (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Oklahoma (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Oklahoma (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Oklahoma (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Olancho (Department of Honduras)": [
            {
                "Region Name": "Olancho (Department of Honduras)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Olancho (Department of Honduras)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Olancho (Department of Honduras)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Olancho (Department of Honduras)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Olancho (Department of Honduras)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Olancho (Department of Honduras)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Olancho (Department of Honduras)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Olancho (Department of Honduras)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Olancho (Department of Honduras)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Olancho (Department of Honduras)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Olancho (Department of Honduras)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Olancho (Department of Honduras)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Olancho (Department of Honduras)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Olancho (Department of Honduras)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Olancho (Department of Honduras)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Olancho (Department of Honduras)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Olancho (Department of Honduras)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Olancho (Department of Honduras)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Olancho (Department of Honduras)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Olancho (Department of Honduras)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Olancho (Department of Honduras)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Olancho (Department of Honduras)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Olomouck\xfd (Region of Czechia)": [
            {
                "Region Name": "Olomouck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Olomouck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Olomouck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Olomouck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Olomouck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Olomouck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Olomouck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Olomouck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Olomouck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Olomouck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Olomouck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Olomouck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Olomouck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Olomouck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Olomouck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Olomouck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Olomouck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Olomouck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Olomouck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Olomouck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Olomouck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Olomouck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Olt (County of Romania)": [
            {
                "Region Name": "Olt (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Olt (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Olt (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Olt (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Olt (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Olt (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Olt (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Olt (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Olt (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Olt (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Olt (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Olt (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Olt (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Olt (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Olt (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Olt (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Olt (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Olt (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Olt (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Olt (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Olt (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Olt (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Omaheke (Region of Namibia)": [
            {
                "Region Name": "Omaheke (Region of Namibia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 61
            },
            {
                "Region Name": "Omaheke (Region of Namibia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 269
            },
            {
                "Region Name": "Omaheke (Region of Namibia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Omaheke (Region of Namibia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 67
            },
            {
                "Region Name": "Omaheke (Region of Namibia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Omaheke (Region of Namibia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Omaheke (Region of Namibia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 81
            },
            {
                "Region Name": "Omaheke (Region of Namibia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 141
            },
            {
                "Region Name": "Omaheke (Region of Namibia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 100
            },
            {
                "Region Name": "Omaheke (Region of Namibia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 217
            },
            {
                "Region Name": "Omaheke (Region of Namibia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 205
            },
            {
                "Region Name": "Omaheke (Region of Namibia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 190
            },
            {
                "Region Name": "Omaheke (Region of Namibia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Omaheke (Region of Namibia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Omaheke (Region of Namibia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 241
            },
            {
                "Region Name": "Omaheke (Region of Namibia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Omaheke (Region of Namibia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 94
            },
            {
                "Region Name": "Omaheke (Region of Namibia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Omaheke (Region of Namibia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 193
            },
            {
                "Region Name": "Omaheke (Region of Namibia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Omaheke (Region of Namibia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Omaheke (Region of Namibia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 294
            }
        ],
        "Ombella-M'Poko (Prefecture of Central African Republic)": [
            {
                "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ombella-M'Poko (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "\xd6mn\xf6govi (Province of Mongolia)": [
            {
                "Region Name": "\xd6mn\xf6govi (Province of Mongolia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6mn\xf6govi (Province of Mongolia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6mn\xf6govi (Province of Mongolia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6mn\xf6govi (Province of Mongolia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6mn\xf6govi (Province of Mongolia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6mn\xf6govi (Province of Mongolia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6mn\xf6govi (Province of Mongolia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6mn\xf6govi (Province of Mongolia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6mn\xf6govi (Province of Mongolia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6mn\xf6govi (Province of Mongolia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6mn\xf6govi (Province of Mongolia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6mn\xf6govi (Province of Mongolia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6mn\xf6govi (Province of Mongolia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6mn\xf6govi (Province of Mongolia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6mn\xf6govi (Province of Mongolia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6mn\xf6govi (Province of Mongolia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6mn\xf6govi (Province of Mongolia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6mn\xf6govi (Province of Mongolia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6mn\xf6govi (Province of Mongolia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6mn\xf6govi (Province of Mongolia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6mn\xf6govi (Province of Mongolia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6mn\xf6govi (Province of Mongolia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Omsk (Region of Russia)": [
            {
                "Region Name": "Omsk (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Omsk (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Omsk (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Omsk (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Omsk (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Omsk (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Omsk (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Omsk (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Omsk (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Omsk (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Omsk (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Omsk (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Omsk (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Omsk (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Omsk (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Omsk (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Omsk (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Omsk (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Omsk (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Omsk (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Omsk (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Omsk (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 21
            }
        ],
        "Omusati (Region of Namibia)": [
            {
                "Region Name": "Omusati (Region of Namibia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 264
            },
            {
                "Region Name": "Omusati (Region of Namibia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Omusati (Region of Namibia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 510
            },
            {
                "Region Name": "Omusati (Region of Namibia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 153
            },
            {
                "Region Name": "Omusati (Region of Namibia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2301
            },
            {
                "Region Name": "Omusati (Region of Namibia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 278
            },
            {
                "Region Name": "Omusati (Region of Namibia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 96
            },
            {
                "Region Name": "Omusati (Region of Namibia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 934
            },
            {
                "Region Name": "Omusati (Region of Namibia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 193
            },
            {
                "Region Name": "Omusati (Region of Namibia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 476
            },
            {
                "Region Name": "Omusati (Region of Namibia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 262
            },
            {
                "Region Name": "Omusati (Region of Namibia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Omusati (Region of Namibia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 166
            },
            {
                "Region Name": "Omusati (Region of Namibia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 362
            },
            {
                "Region Name": "Omusati (Region of Namibia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Omusati (Region of Namibia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "Omusati (Region of Namibia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Omusati (Region of Namibia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Omusati (Region of Namibia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 66
            },
            {
                "Region Name": "Omusati (Region of Namibia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 147
            },
            {
                "Region Name": "Omusati (Region of Namibia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 599
            },
            {
                "Region Name": "Omusati (Region of Namibia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Onchan (District of Isle of Man)": [
            {
                "Region Name": "Onchan (District of Isle of Man)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Onchan (District of Isle of Man)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Onchan (District of Isle of Man)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Onchan (District of Isle of Man)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Onchan (District of Isle of Man)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Onchan (District of Isle of Man)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Onchan (District of Isle of Man)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Onchan (District of Isle of Man)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Onchan (District of Isle of Man)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Onchan (District of Isle of Man)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Onchan (District of Isle of Man)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Onchan (District of Isle of Man)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Onchan (District of Isle of Man)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Onchan (District of Isle of Man)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Onchan (District of Isle of Man)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Onchan (District of Isle of Man)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Onchan (District of Isle of Man)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Onchan (District of Isle of Man)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Onchan (District of Isle of Man)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Onchan (District of Isle of Man)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Onchan (District of Isle of Man)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Onchan (District of Isle of Man)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ondo (State of Nigeria)": [
            {
                "Region Name": "Ondo (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ondo (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ondo (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ondo (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ondo (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ondo (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ondo (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ondo (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ondo (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ondo (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ondo (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ondo (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ondo (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ondo (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ondo (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ondo (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ondo (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ondo (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ondo (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ondo (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ondo (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ondo (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Ontario (Province of Canada)": [
            {
                "Region Name": "Ontario (Province of Canada)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Ontario (Province of Canada)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Ontario (Province of Canada)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ontario (Province of Canada)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Ontario (Province of Canada)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Ontario (Province of Canada)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ontario (Province of Canada)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ontario (Province of Canada)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ontario (Province of Canada)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Ontario (Province of Canada)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 65
            },
            {
                "Region Name": "Ontario (Province of Canada)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Ontario (Province of Canada)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ontario (Province of Canada)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ontario (Province of Canada)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Ontario (Province of Canada)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Ontario (Province of Canada)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Ontario (Province of Canada)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 64
            },
            {
                "Region Name": "Ontario (Province of Canada)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 59
            },
            {
                "Region Name": "Ontario (Province of Canada)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ontario (Province of Canada)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 132
            },
            {
                "Region Name": "Ontario (Province of Canada)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ontario (Province of Canada)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 48
            }
        ],
        "Opolskie (Voivodeship of Poland)": [
            {
                "Region Name": "Opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Opolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Oppland (County of Norway)": [
            {
                "Region Name": "Oppland (County of Norway)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oppland (County of Norway)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oppland (County of Norway)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oppland (County of Norway)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oppland (County of Norway)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oppland (County of Norway)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oppland (County of Norway)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oppland (County of Norway)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oppland (County of Norway)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oppland (County of Norway)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oppland (County of Norway)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oppland (County of Norway)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oppland (County of Norway)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oppland (County of Norway)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oppland (County of Norway)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oppland (County of Norway)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oppland (County of Norway)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oppland (County of Norway)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oppland (County of Norway)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oppland (County of Norway)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oppland (County of Norway)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oppland (County of Norway)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Oran (Province of Algeria)": [
            {
                "Region Name": "Oran (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Oran (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oran (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oran (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oran (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oran (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oran (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oran (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Oran (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oran (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oran (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oran (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oran (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Oran (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oran (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oran (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oran (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oran (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oran (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oran (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oran (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oran (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Orange Walk (District of Belize)": [
            {
                "Region Name": "Orange Walk (District of Belize)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Orange Walk (District of Belize)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Orange Walk (District of Belize)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Orange Walk (District of Belize)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Orange Walk (District of Belize)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Orange Walk (District of Belize)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Orange Walk (District of Belize)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Orange Walk (District of Belize)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Orange Walk (District of Belize)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Orange Walk (District of Belize)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Orange Walk (District of Belize)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Orange Walk (District of Belize)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Orange Walk (District of Belize)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Orange Walk (District of Belize)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Orange Walk (District of Belize)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Orange Walk (District of Belize)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Orange Walk (District of Belize)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Orange Walk (District of Belize)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Orange Walk (District of Belize)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Orange Walk (District of Belize)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Orange Walk (District of Belize)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Orange Walk (District of Belize)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Ordino (Parish of Andorra)": [
            {
                "Region Name": "Ordino (Parish of Andorra)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordino (Parish of Andorra)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordino (Parish of Andorra)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordino (Parish of Andorra)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordino (Parish of Andorra)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordino (Parish of Andorra)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordino (Parish of Andorra)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordino (Parish of Andorra)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordino (Parish of Andorra)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordino (Parish of Andorra)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordino (Parish of Andorra)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordino (Parish of Andorra)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordino (Parish of Andorra)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordino (Parish of Andorra)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordino (Parish of Andorra)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordino (Parish of Andorra)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordino (Parish of Andorra)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordino (Parish of Andorra)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordino (Parish of Andorra)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordino (Parish of Andorra)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordino (Parish of Andorra)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordino (Parish of Andorra)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ordu (Province of Turkey)": [
            {
                "Region Name": "Ordu (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordu (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordu (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordu (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordu (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordu (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordu (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordu (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordu (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordu (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordu (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordu (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordu (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordu (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordu (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordu (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordu (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordu (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ordu (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordu (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ordu (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ordu (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Orebro (County of Sweden)": [
            {
                "Region Name": "Orebro (County of Sweden)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orebro (County of Sweden)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orebro (County of Sweden)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orebro (County of Sweden)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orebro (County of Sweden)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orebro (County of Sweden)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orebro (County of Sweden)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orebro (County of Sweden)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orebro (County of Sweden)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orebro (County of Sweden)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orebro (County of Sweden)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orebro (County of Sweden)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orebro (County of Sweden)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orebro (County of Sweden)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orebro (County of Sweden)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orebro (County of Sweden)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orebro (County of Sweden)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orebro (County of Sweden)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orebro (County of Sweden)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orebro (County of Sweden)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orebro (County of Sweden)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orebro (County of Sweden)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Oregon (State of United States)": [
            {
                "Region Name": "Oregon (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Oregon (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oregon (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oregon (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oregon (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Oregon (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Oregon (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oregon (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oregon (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Oregon (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Oregon (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Oregon (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Oregon (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Oregon (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Oregon (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oregon (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Oregon (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Oregon (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oregon (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "Oregon (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Oregon (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Oregon (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Orel (Region of Russia)": [
            {
                "Region Name": "Orel (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Orel (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Orel (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Orel (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Orel (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Orel (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Orel (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Orel (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Orel (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Orel (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Orel (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Orel (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Orel (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Orel (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Orel (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Orel (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Orel (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Orel (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Orel (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Orel (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Orel (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Orel (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Orellana (Province of Ecuador)": [
            {
                "Region Name": "Orellana (Province of Ecuador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orellana (Province of Ecuador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orellana (Province of Ecuador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orellana (Province of Ecuador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orellana (Province of Ecuador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orellana (Province of Ecuador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orellana (Province of Ecuador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orellana (Province of Ecuador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orellana (Province of Ecuador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orellana (Province of Ecuador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orellana (Province of Ecuador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orellana (Province of Ecuador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orellana (Province of Ecuador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orellana (Province of Ecuador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orellana (Province of Ecuador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orellana (Province of Ecuador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orellana (Province of Ecuador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orellana (Province of Ecuador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orellana (Province of Ecuador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Orellana (Province of Ecuador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orellana (Province of Ecuador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orellana (Province of Ecuador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Orenburg (Region of Russia)": [
            {
                "Region Name": "Orenburg (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Orenburg (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Orenburg (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Orenburg (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Orenburg (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Orenburg (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Orenburg (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Orenburg (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Orenburg (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Orenburg (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Orenburg (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Orenburg (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Orenburg (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Orenburg (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Orenburg (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Orenburg (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Orenburg (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Orenburg (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Orenburg (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Orenburg (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Orenburg (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Orenburg (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 43
            }
        ],
        "Orhei (District of Moldova)": [
            {
                "Region Name": "Orhei (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhei (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhei (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhei (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhei (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Orhei (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Orhei (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Orhei (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhei (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Orhei (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhei (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhei (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Orhei (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Orhei (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhei (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Orhei (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Orhei (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhei (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Orhei (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhei (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Orhei (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Orhei (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Orhon (Municipality of Mongolia)": [
            {
                "Region Name": "Orhon (Municipality of Mongolia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Orhon (Municipality of Mongolia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhon (Municipality of Mongolia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhon (Municipality of Mongolia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhon (Municipality of Mongolia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhon (Municipality of Mongolia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhon (Municipality of Mongolia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhon (Municipality of Mongolia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhon (Municipality of Mongolia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhon (Municipality of Mongolia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhon (Municipality of Mongolia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhon (Municipality of Mongolia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhon (Municipality of Mongolia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhon (Municipality of Mongolia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhon (Municipality of Mongolia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhon (Municipality of Mongolia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhon (Municipality of Mongolia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhon (Municipality of Mongolia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhon (Municipality of Mongolia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhon (Municipality of Mongolia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhon (Municipality of Mongolia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orhon (Municipality of Mongolia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Oriental (Region of Morocco)": [
            {
                "Region Name": "Oriental (Region of Morocco)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oriental (Region of Morocco)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oriental (Region of Morocco)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oriental (Region of Morocco)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oriental (Region of Morocco)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oriental (Region of Morocco)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oriental (Region of Morocco)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oriental (Region of Morocco)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oriental (Region of Morocco)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oriental (Region of Morocco)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oriental (Region of Morocco)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Oriental (Region of Morocco)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oriental (Region of Morocco)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oriental (Region of Morocco)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oriental (Region of Morocco)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oriental (Region of Morocco)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Oriental (Region of Morocco)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oriental (Region of Morocco)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Oriental (Region of Morocco)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oriental (Region of Morocco)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oriental (Region of Morocco)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oriental (Region of Morocco)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 29
            }
        ],
        "Oriental Mindoro (Province of Philippines)": [
            {
                "Region Name": "Oriental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oriental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oriental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oriental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oriental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oriental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oriental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oriental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oriental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oriental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oriental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oriental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oriental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oriental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oriental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oriental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oriental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oriental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oriental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oriental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oriental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oriental Mindoro (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Oro (Province of Papua New Guinea)": [
            {
                "Region Name": "Oro (Province of Papua New Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oro (Province of Papua New Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oro (Province of Papua New Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oro (Province of Papua New Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Oro (Province of Papua New Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oro (Province of Papua New Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Oro (Province of Papua New Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oro (Province of Papua New Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oro (Province of Papua New Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oro (Province of Papua New Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oro (Province of Papua New Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oro (Province of Papua New Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oro (Province of Papua New Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oro (Province of Papua New Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oro (Province of Papua New Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oro (Province of Papua New Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oro (Province of Papua New Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oro (Province of Papua New Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oro (Province of Papua New Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oro (Province of Papua New Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oro (Province of Papua New Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oro (Province of Papua New Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Orocovis (Municipality of Puerto Rico)": [
            {
                "Region Name": "Orocovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orocovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orocovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orocovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orocovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orocovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orocovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orocovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orocovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orocovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orocovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orocovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orocovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orocovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orocovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orocovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orocovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orocovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orocovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orocovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orocovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Orocovis (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Oromia (State of Ethiopia)": [
            {
                "Region Name": "Oromia (State of Ethiopia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Oromia (State of Ethiopia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Oromia (State of Ethiopia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Oromia (State of Ethiopia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Oromia (State of Ethiopia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Oromia (State of Ethiopia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Oromia (State of Ethiopia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Oromia (State of Ethiopia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Oromia (State of Ethiopia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Oromia (State of Ethiopia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Oromia (State of Ethiopia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Oromia (State of Ethiopia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Oromia (State of Ethiopia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Oromia (State of Ethiopia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Oromia (State of Ethiopia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Oromia (State of Ethiopia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Oromia (State of Ethiopia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Oromia (State of Ethiopia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Oromia (State of Ethiopia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Oromia (State of Ethiopia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Oromia (State of Ethiopia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Oromia (State of Ethiopia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Oruro (Department of Bolivia)": [
            {
                "Region Name": "Oruro (Department of Bolivia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oruro (Department of Bolivia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oruro (Department of Bolivia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oruro (Department of Bolivia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Oruro (Department of Bolivia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oruro (Department of Bolivia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oruro (Department of Bolivia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oruro (Department of Bolivia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oruro (Department of Bolivia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oruro (Department of Bolivia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oruro (Department of Bolivia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oruro (Department of Bolivia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oruro (Department of Bolivia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oruro (Department of Bolivia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Oruro (Department of Bolivia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oruro (Department of Bolivia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oruro (Department of Bolivia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oruro (Department of Bolivia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oruro (Department of Bolivia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oruro (Department of Bolivia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oruro (Department of Bolivia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oruro (Department of Bolivia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Osaka (Urban Prefecture of Japan)": [
            {
                "Region Name": "Osaka (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osaka (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osaka (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osaka (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osaka (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osaka (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osaka (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osaka (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osaka (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osaka (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osaka (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osaka (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osaka (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osaka (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osaka (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osaka (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osaka (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osaka (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osaka (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osaka (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osaka (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osaka (Urban Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Osh (city) (City of Kyrgyzstan)": [
            {
                "Region Name": "Osh (city) (City of Kyrgyzstan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (city) (City of Kyrgyzstan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (city) (City of Kyrgyzstan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (city) (City of Kyrgyzstan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (city) (City of Kyrgyzstan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (city) (City of Kyrgyzstan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (city) (City of Kyrgyzstan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (city) (City of Kyrgyzstan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (city) (City of Kyrgyzstan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (city) (City of Kyrgyzstan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (city) (City of Kyrgyzstan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (city) (City of Kyrgyzstan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (city) (City of Kyrgyzstan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (city) (City of Kyrgyzstan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (city) (City of Kyrgyzstan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (city) (City of Kyrgyzstan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (city) (City of Kyrgyzstan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (city) (City of Kyrgyzstan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (city) (City of Kyrgyzstan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (city) (City of Kyrgyzstan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (city) (City of Kyrgyzstan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (city) (City of Kyrgyzstan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Osh (Province of Kyrgyzstan)": [
            {
                "Region Name": "Osh (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Osh (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Osh (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Osh (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Osh (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Osh (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Osh (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Osh (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Osh (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Osh (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Osh (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Osh (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Osh (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Osh (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Osh (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Osh (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Osh (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osh (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Oshana (Region of Namibia)": [
            {
                "Region Name": "Oshana (Region of Namibia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 234
            },
            {
                "Region Name": "Oshana (Region of Namibia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Oshana (Region of Namibia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Oshana (Region of Namibia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 212
            },
            {
                "Region Name": "Oshana (Region of Namibia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 292
            },
            {
                "Region Name": "Oshana (Region of Namibia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 199
            },
            {
                "Region Name": "Oshana (Region of Namibia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 353
            },
            {
                "Region Name": "Oshana (Region of Namibia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 164
            },
            {
                "Region Name": "Oshana (Region of Namibia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 67
            },
            {
                "Region Name": "Oshana (Region of Namibia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 85
            },
            {
                "Region Name": "Oshana (Region of Namibia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 154
            },
            {
                "Region Name": "Oshana (Region of Namibia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Oshana (Region of Namibia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 172
            },
            {
                "Region Name": "Oshana (Region of Namibia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oshana (Region of Namibia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oshana (Region of Namibia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 93
            },
            {
                "Region Name": "Oshana (Region of Namibia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "Oshana (Region of Namibia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oshana (Region of Namibia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Oshana (Region of Namibia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 63
            },
            {
                "Region Name": "Oshana (Region of Namibia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oshana (Region of Namibia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Oshikoto (Region of Namibia)": [
            {
                "Region Name": "Oshikoto (Region of Namibia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Oshikoto (Region of Namibia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Oshikoto (Region of Namibia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 72
            },
            {
                "Region Name": "Oshikoto (Region of Namibia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 218
            },
            {
                "Region Name": "Oshikoto (Region of Namibia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 74
            },
            {
                "Region Name": "Oshikoto (Region of Namibia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Oshikoto (Region of Namibia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Oshikoto (Region of Namibia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 66
            },
            {
                "Region Name": "Oshikoto (Region of Namibia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Oshikoto (Region of Namibia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Oshikoto (Region of Namibia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 178
            },
            {
                "Region Name": "Oshikoto (Region of Namibia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Oshikoto (Region of Namibia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Oshikoto (Region of Namibia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 100
            },
            {
                "Region Name": "Oshikoto (Region of Namibia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 283
            },
            {
                "Region Name": "Oshikoto (Region of Namibia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Oshikoto (Region of Namibia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Oshikoto (Region of Namibia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oshikoto (Region of Namibia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "Oshikoto (Region of Namibia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "Oshikoto (Region of Namibia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Oshikoto (Region of Namibia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 19
            }
        ],
        "Osjecko-Baranjska (County of Croatia)": [
            {
                "Region Name": "Osjecko-Baranjska (County of Croatia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Osjecko-Baranjska (County of Croatia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Osjecko-Baranjska (County of Croatia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Osjecko-Baranjska (County of Croatia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Osjecko-Baranjska (County of Croatia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Osjecko-Baranjska (County of Croatia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Osjecko-Baranjska (County of Croatia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Osjecko-Baranjska (County of Croatia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Osjecko-Baranjska (County of Croatia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Osjecko-Baranjska (County of Croatia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Osjecko-Baranjska (County of Croatia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Osjecko-Baranjska (County of Croatia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osjecko-Baranjska (County of Croatia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osjecko-Baranjska (County of Croatia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osjecko-Baranjska (County of Croatia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osjecko-Baranjska (County of Croatia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osjecko-Baranjska (County of Croatia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Osjecko-Baranjska (County of Croatia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osjecko-Baranjska (County of Croatia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Osjecko-Baranjska (County of Croatia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osjecko-Baranjska (County of Croatia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osjecko-Baranjska (County of Croatia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Oslo (County of Norway)": [
            {
                "Region Name": "Oslo (County of Norway)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oslo (County of Norway)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oslo (County of Norway)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oslo (County of Norway)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oslo (County of Norway)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oslo (County of Norway)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oslo (County of Norway)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oslo (County of Norway)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oslo (County of Norway)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oslo (County of Norway)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oslo (County of Norway)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oslo (County of Norway)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oslo (County of Norway)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oslo (County of Norway)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oslo (County of Norway)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oslo (County of Norway)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oslo (County of Norway)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oslo (County of Norway)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oslo (County of Norway)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oslo (County of Norway)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oslo (County of Norway)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oslo (County of Norway)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Osmaniye (Province of Turkey)": [
            {
                "Region Name": "Osmaniye (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Osmaniye (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Osmaniye (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 76
            },
            {
                "Region Name": "Osmaniye (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Osmaniye (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Osmaniye (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Osmaniye (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Osmaniye (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Osmaniye (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Osmaniye (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Osmaniye (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Osmaniye (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Osmaniye (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Osmaniye (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Osmaniye (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Osmaniye (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Osmaniye (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Osmaniye (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Osmaniye (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Osmaniye (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Osmaniye (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Osmaniye (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Osrednjeslovenska (Statistical Region of Slovenia)": [
            {
                "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Osrednjeslovenska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\xd6sterg\xf6tland (County of Sweden)": [
            {
                "Region Name": "\xd6sterg\xf6tland (County of Sweden)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xd6sterg\xf6tland (County of Sweden)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6sterg\xf6tland (County of Sweden)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6sterg\xf6tland (County of Sweden)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xd6sterg\xf6tland (County of Sweden)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xd6sterg\xf6tland (County of Sweden)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xd6sterg\xf6tland (County of Sweden)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6sterg\xf6tland (County of Sweden)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6sterg\xf6tland (County of Sweden)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6sterg\xf6tland (County of Sweden)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6sterg\xf6tland (County of Sweden)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6sterg\xf6tland (County of Sweden)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6sterg\xf6tland (County of Sweden)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6sterg\xf6tland (County of Sweden)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xd6sterg\xf6tland (County of Sweden)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6sterg\xf6tland (County of Sweden)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6sterg\xf6tland (County of Sweden)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6sterg\xf6tland (County of Sweden)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6sterg\xf6tland (County of Sweden)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6sterg\xf6tland (County of Sweden)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6sterg\xf6tland (County of Sweden)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6sterg\xf6tland (County of Sweden)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\xd8stfold (County of Norway)": [
            {
                "Region Name": "\xd8stfold (County of Norway)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd8stfold (County of Norway)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd8stfold (County of Norway)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd8stfold (County of Norway)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd8stfold (County of Norway)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd8stfold (County of Norway)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd8stfold (County of Norway)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd8stfold (County of Norway)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd8stfold (County of Norway)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd8stfold (County of Norway)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd8stfold (County of Norway)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd8stfold (County of Norway)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd8stfold (County of Norway)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd8stfold (County of Norway)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd8stfold (County of Norway)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd8stfold (County of Norway)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd8stfold (County of Norway)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd8stfold (County of Norway)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd8stfold (County of Norway)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd8stfold (County of Norway)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd8stfold (County of Norway)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd8stfold (County of Norway)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Osun (State of Nigeria)": [
            {
                "Region Name": "Osun (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Osun (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Osun (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Osun (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Osun (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Osun (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Osun (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Osun (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Osun (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Osun (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Osun (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Osun (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Osun (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Osun (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Osun (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Osun (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Osun (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Osun (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Osun (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Osun (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Osun (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Osun (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Otago (Region of New Zealand)": [
            {
                "Region Name": "Otago (Region of New Zealand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Otago (Region of New Zealand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Otago (Region of New Zealand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Otago (Region of New Zealand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Otago (Region of New Zealand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Otago (Region of New Zealand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Otago (Region of New Zealand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Otago (Region of New Zealand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Otago (Region of New Zealand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Otago (Region of New Zealand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Otago (Region of New Zealand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Otago (Region of New Zealand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Otago (Region of New Zealand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Otago (Region of New Zealand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Otago (Region of New Zealand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Otago (Region of New Zealand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Otago (Region of New Zealand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Otago (Region of New Zealand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Otago (Region of New Zealand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Otago (Region of New Zealand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Otago (Region of New Zealand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Otago (Region of New Zealand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Otdar Mean Chey (Province of Cambodia)": [
            {
                "Region Name": "Otdar Mean Chey (Province of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Otdar Mean Chey (Province of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Otdar Mean Chey (Province of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Otdar Mean Chey (Province of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Otdar Mean Chey (Province of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Otdar Mean Chey (Province of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Otdar Mean Chey (Province of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Otdar Mean Chey (Province of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Otdar Mean Chey (Province of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Otdar Mean Chey (Province of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Otdar Mean Chey (Province of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Otdar Mean Chey (Province of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Otdar Mean Chey (Province of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Otdar Mean Chey (Province of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Otdar Mean Chey (Province of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Otdar Mean Chey (Province of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Otdar Mean Chey (Province of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Otdar Mean Chey (Province of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Otdar Mean Chey (Province of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Otdar Mean Chey (Province of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Otdar Mean Chey (Province of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Otdar Mean Chey (Province of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Other Islands (District of British Virgin Islands)": [
            {
                "Region Name": "Other Islands (District of British Virgin Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Other Islands (District of British Virgin Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Other Islands (District of British Virgin Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Other Islands (District of British Virgin Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Other Islands (District of British Virgin Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Other Islands (District of British Virgin Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Other Islands (District of British Virgin Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Other Islands (District of British Virgin Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Other Islands (District of British Virgin Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Other Islands (District of British Virgin Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Other Islands (District of British Virgin Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Other Islands (District of British Virgin Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Other Islands (District of British Virgin Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Other Islands (District of British Virgin Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Other Islands (District of British Virgin Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Other Islands (District of British Virgin Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Other Islands (District of British Virgin Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Other Islands (District of British Virgin Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Other Islands (District of British Virgin Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Other Islands (District of British Virgin Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Other Islands (District of British Virgin Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Other Islands (District of British Virgin Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Oti (Region of Ghana)": [
            {
                "Region Name": "Oti (Region of Ghana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Oti (Region of Ghana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Oti (Region of Ghana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Oti (Region of Ghana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oti (Region of Ghana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Oti (Region of Ghana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Oti (Region of Ghana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Oti (Region of Ghana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Oti (Region of Ghana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Oti (Region of Ghana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Oti (Region of Ghana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Oti (Region of Ghana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oti (Region of Ghana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Oti (Region of Ghana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Oti (Region of Ghana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oti (Region of Ghana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oti (Region of Ghana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oti (Region of Ghana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Oti (Region of Ghana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Oti (Region of Ghana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Oti (Region of Ghana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Oti (Region of Ghana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Otjozondjupa (Region of Namibia)": [
            {
                "Region Name": "Otjozondjupa (Region of Namibia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Otjozondjupa (Region of Namibia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Otjozondjupa (Region of Namibia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Otjozondjupa (Region of Namibia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 126
            },
            {
                "Region Name": "Otjozondjupa (Region of Namibia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Otjozondjupa (Region of Namibia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "Otjozondjupa (Region of Namibia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Otjozondjupa (Region of Namibia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 99
            },
            {
                "Region Name": "Otjozondjupa (Region of Namibia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 142
            },
            {
                "Region Name": "Otjozondjupa (Region of Namibia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 101
            },
            {
                "Region Name": "Otjozondjupa (Region of Namibia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 138
            },
            {
                "Region Name": "Otjozondjupa (Region of Namibia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "Otjozondjupa (Region of Namibia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Otjozondjupa (Region of Namibia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Otjozondjupa (Region of Namibia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Otjozondjupa (Region of Namibia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Otjozondjupa (Region of Namibia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Otjozondjupa (Region of Namibia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Otjozondjupa (Region of Namibia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Otjozondjupa (Region of Namibia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Otjozondjupa (Region of Namibia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Otjozondjupa (Region of Namibia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 55
            }
        ],
        "Ouadda\xef (Region of Chad)": [
            {
                "Region Name": "Ouadda\xef (Region of Chad)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ouadda\xef (Region of Chad)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Ouadda\xef (Region of Chad)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Ouadda\xef (Region of Chad)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Ouadda\xef (Region of Chad)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Ouadda\xef (Region of Chad)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Ouadda\xef (Region of Chad)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ouadda\xef (Region of Chad)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ouadda\xef (Region of Chad)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ouadda\xef (Region of Chad)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ouadda\xef (Region of Chad)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ouadda\xef (Region of Chad)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Ouadda\xef (Region of Chad)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Ouadda\xef (Region of Chad)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ouadda\xef (Region of Chad)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ouadda\xef (Region of Chad)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ouadda\xef (Region of Chad)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Ouadda\xef (Region of Chad)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Ouadda\xef (Region of Chad)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ouadda\xef (Region of Chad)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Ouadda\xef (Region of Chad)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ouadda\xef (Region of Chad)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 29
            }
        ],
        "Ouaka (Prefecture of Central African Republic)": [
            {
                "Region Name": "Ouaka (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ouaka (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Ouaka (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ouaka (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ouaka (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Ouaka (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ouaka (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ouaka (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ouaka (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ouaka (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ouaka (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ouaka (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ouaka (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ouaka (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ouaka (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ouaka (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ouaka (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ouaka (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ouaka (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ouaka (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ouaka (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ouaka (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Ouangani (Commune of Mayotte)": [
            {
                "Region Name": "Ouangani (Commune of Mayotte)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouangani (Commune of Mayotte)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouangani (Commune of Mayotte)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouangani (Commune of Mayotte)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouangani (Commune of Mayotte)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouangani (Commune of Mayotte)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouangani (Commune of Mayotte)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouangani (Commune of Mayotte)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouangani (Commune of Mayotte)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouangani (Commune of Mayotte)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouangani (Commune of Mayotte)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouangani (Commune of Mayotte)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouangani (Commune of Mayotte)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouangani (Commune of Mayotte)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouangani (Commune of Mayotte)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouangani (Commune of Mayotte)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouangani (Commune of Mayotte)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouangani (Commune of Mayotte)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouangani (Commune of Mayotte)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouangani (Commune of Mayotte)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouangani (Commune of Mayotte)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouangani (Commune of Mayotte)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ouargla (Province of Algeria)": [
            {
                "Region Name": "Ouargla (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouargla (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouargla (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouargla (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouargla (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouargla (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouargla (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouargla (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouargla (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouargla (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ouargla (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouargla (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouargla (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouargla (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ouargla (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ouargla (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouargla (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouargla (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouargla (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ouargla (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouargla (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouargla (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Oud\xf4mxai (Province of Laos)": [
            {
                "Region Name": "Oud\xf4mxai (Province of Laos)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oud\xf4mxai (Province of Laos)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oud\xf4mxai (Province of Laos)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Oud\xf4mxai (Province of Laos)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oud\xf4mxai (Province of Laos)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oud\xf4mxai (Province of Laos)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oud\xf4mxai (Province of Laos)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oud\xf4mxai (Province of Laos)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oud\xf4mxai (Province of Laos)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oud\xf4mxai (Province of Laos)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oud\xf4mxai (Province of Laos)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oud\xf4mxai (Province of Laos)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oud\xf4mxai (Province of Laos)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oud\xf4mxai (Province of Laos)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oud\xf4mxai (Province of Laos)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oud\xf4mxai (Province of Laos)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oud\xf4mxai (Province of Laos)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oud\xf4mxai (Province of Laos)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oud\xf4mxai (Province of Laos)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Oud\xf4mxai (Province of Laos)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oud\xf4mxai (Province of Laos)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oud\xf4mxai (Province of Laos)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 16
            }
        ],
        "Oued el Dahab (Province of Western Sahara)": [
            {
                "Region Name": "Oued el Dahab (Province of Western Sahara)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oued el Dahab (Province of Western Sahara)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oued el Dahab (Province of Western Sahara)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oued el Dahab (Province of Western Sahara)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oued el Dahab (Province of Western Sahara)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oued el Dahab (Province of Western Sahara)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oued el Dahab (Province of Western Sahara)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oued el Dahab (Province of Western Sahara)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oued el Dahab (Province of Western Sahara)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oued el Dahab (Province of Western Sahara)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oued el Dahab (Province of Western Sahara)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oued el Dahab (Province of Western Sahara)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oued el Dahab (Province of Western Sahara)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oued el Dahab (Province of Western Sahara)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oued el Dahab (Province of Western Sahara)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oued el Dahab (Province of Western Sahara)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oued el Dahab (Province of Western Sahara)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oued el Dahab (Province of Western Sahara)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oued el Dahab (Province of Western Sahara)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oued el Dahab (Province of Western Sahara)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oued el Dahab (Province of Western Sahara)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oued el Dahab (Province of Western Sahara)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ou\xe9m\xe9 (Department of Benin)": [
            {
                "Region Name": "Ou\xe9m\xe9 (Department of Benin)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ou\xe9m\xe9 (Department of Benin)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Ou\xe9m\xe9 (Department of Benin)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ou\xe9m\xe9 (Department of Benin)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ou\xe9m\xe9 (Department of Benin)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ou\xe9m\xe9 (Department of Benin)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ou\xe9m\xe9 (Department of Benin)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ou\xe9m\xe9 (Department of Benin)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ou\xe9m\xe9 (Department of Benin)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ou\xe9m\xe9 (Department of Benin)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ou\xe9m\xe9 (Department of Benin)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ou\xe9m\xe9 (Department of Benin)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ou\xe9m\xe9 (Department of Benin)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ou\xe9m\xe9 (Department of Benin)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Ou\xe9m\xe9 (Department of Benin)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ou\xe9m\xe9 (Department of Benin)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Ou\xe9m\xe9 (Department of Benin)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ou\xe9m\xe9 (Department of Benin)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ou\xe9m\xe9 (Department of Benin)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ou\xe9m\xe9 (Department of Benin)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ou\xe9m\xe9 (Department of Benin)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ou\xe9m\xe9 (Department of Benin)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Ouest (Department of Haiti)": [
            {
                "Region Name": "Ouest (Department of Haiti)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouest (Department of Haiti)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouest (Department of Haiti)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ouest (Department of Haiti)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ouest (Department of Haiti)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ouest (Department of Haiti)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ouest (Department of Haiti)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ouest (Department of Haiti)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ouest (Department of Haiti)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouest (Department of Haiti)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ouest (Department of Haiti)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ouest (Department of Haiti)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouest (Department of Haiti)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouest (Department of Haiti)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ouest (Department of Haiti)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ouest (Department of Haiti)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ouest (Department of Haiti)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouest (Department of Haiti)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ouest (Department of Haiti)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ouest (Department of Haiti)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ouest (Department of Haiti)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ouest (Department of Haiti)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Ouest (Region of Cameroon)": [
            {
                "Region Name": "Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Ouham-Pend\xe9 (Prefecture of Central African Republic)": [
            {
                "Region Name": "Ouham-Pend\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ouham-Pend\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ouham-Pend\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ouham-Pend\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ouham-Pend\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ouham-Pend\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ouham-Pend\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ouham-Pend\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ouham-Pend\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ouham-Pend\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ouham-Pend\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ouham-Pend\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ouham-Pend\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ouham-Pend\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ouham-Pend\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ouham-Pend\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ouham-Pend\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ouham-Pend\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ouham-Pend\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ouham-Pend\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ouham-Pend\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ouham-Pend\xe9 (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Ouham (Prefecture of Central African Republic)": [
            {
                "Region Name": "Ouham (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Ouham (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Ouham (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Ouham (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Ouham (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Ouham (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Ouham (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ouham (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Ouham (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ouham (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ouham (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ouham (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ouham (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ouham (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Ouham (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Ouham (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ouham (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Ouham (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Ouham (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ouham (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Ouham (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ouham (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Oulu (Province of Finland)": [
            {
                "Region Name": "Oulu (Province of Finland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oulu (Province of Finland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oulu (Province of Finland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oulu (Province of Finland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oulu (Province of Finland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oulu (Province of Finland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oulu (Province of Finland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oulu (Province of Finland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oulu (Province of Finland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oulu (Province of Finland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oulu (Province of Finland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oulu (Province of Finland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oulu (Province of Finland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oulu (Province of Finland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oulu (Province of Finland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oulu (Province of Finland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oulu (Province of Finland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oulu (Province of Finland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oulu (Province of Finland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oulu (Province of Finland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oulu (Province of Finland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oulu (Province of Finland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Oum el Bouaghi (Province of Algeria)": [
            {
                "Region Name": "Oum el Bouaghi (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oum el Bouaghi (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oum el Bouaghi (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oum el Bouaghi (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oum el Bouaghi (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oum el Bouaghi (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oum el Bouaghi (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oum el Bouaghi (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oum el Bouaghi (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oum el Bouaghi (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oum el Bouaghi (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Oum el Bouaghi (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oum el Bouaghi (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oum el Bouaghi (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oum el Bouaghi (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oum el Bouaghi (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oum el Bouaghi (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oum el Bouaghi (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oum el Bouaghi (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oum el Bouaghi (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oum el Bouaghi (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oum el Bouaghi (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Outer Islands (Outer Islands of Seychelles)": [
            {
                "Region Name": "Outer Islands (Outer Islands of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Outer Islands (Outer Islands of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Outer Islands (Outer Islands of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Outer Islands (Outer Islands of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Outer Islands (Outer Islands of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Outer Islands (Outer Islands of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Outer Islands (Outer Islands of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Outer Islands (Outer Islands of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Outer Islands (Outer Islands of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Outer Islands (Outer Islands of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Outer Islands (Outer Islands of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Outer Islands (Outer Islands of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Outer Islands (Outer Islands of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Outer Islands (Outer Islands of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Outer Islands (Outer Islands of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Outer Islands (Outer Islands of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Outer Islands (Outer Islands of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Outer Islands (Outer Islands of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Outer Islands (Outer Islands of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Outer Islands (Outer Islands of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Outer Islands (Outer Islands of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Outer Islands (Outer Islands of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Overijssel (Province of Netherlands)": [
            {
                "Region Name": "Overijssel (Province of Netherlands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Overijssel (Province of Netherlands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Overijssel (Province of Netherlands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Overijssel (Province of Netherlands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Overijssel (Province of Netherlands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Overijssel (Province of Netherlands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Overijssel (Province of Netherlands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Overijssel (Province of Netherlands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Overijssel (Province of Netherlands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Overijssel (Province of Netherlands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Overijssel (Province of Netherlands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Overijssel (Province of Netherlands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Overijssel (Province of Netherlands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Overijssel (Province of Netherlands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Overijssel (Province of Netherlands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Overijssel (Province of Netherlands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Overijssel (Province of Netherlands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Overijssel (Province of Netherlands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Overijssel (Province of Netherlands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Overijssel (Province of Netherlands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Overijssel (Province of Netherlands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Overijssel (Province of Netherlands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\xd6v\xf6rkhangay (Province of Mongolia)": [
            {
                "Region Name": "\xd6v\xf6rkhangay (Province of Mongolia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xd6v\xf6rkhangay (Province of Mongolia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\xd6v\xf6rkhangay (Province of Mongolia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6v\xf6rkhangay (Province of Mongolia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6v\xf6rkhangay (Province of Mongolia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6v\xf6rkhangay (Province of Mongolia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6v\xf6rkhangay (Province of Mongolia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6v\xf6rkhangay (Province of Mongolia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6v\xf6rkhangay (Province of Mongolia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xd6v\xf6rkhangay (Province of Mongolia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6v\xf6rkhangay (Province of Mongolia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6v\xf6rkhangay (Province of Mongolia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xd6v\xf6rkhangay (Province of Mongolia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6v\xf6rkhangay (Province of Mongolia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6v\xf6rkhangay (Province of Mongolia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6v\xf6rkhangay (Province of Mongolia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xd6v\xf6rkhangay (Province of Mongolia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6v\xf6rkhangay (Province of Mongolia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6v\xf6rkhangay (Province of Mongolia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6v\xf6rkhangay (Province of Mongolia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xd6v\xf6rkhangay (Province of Mongolia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\xd6v\xf6rkhangay (Province of Mongolia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Oyo (State of Nigeria)": [
            {
                "Region Name": "Oyo (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oyo (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Oyo (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Oyo (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oyo (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oyo (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oyo (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oyo (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oyo (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oyo (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Oyo (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oyo (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Oyo (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oyo (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Oyo (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Oyo (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oyo (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oyo (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oyo (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Oyo (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oyo (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Oyo (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "P'y\u014Fngan-bukto (Province of North Korea)": [
            {
                "Region Name": "P'y\u014Fngan-bukto (Province of North Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "P'y\u014Fngan-bukto (Province of North Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "P'y\u014Fngan-bukto (Province of North Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "P'y\u014Fngan-bukto (Province of North Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "P'y\u014Fngan-bukto (Province of North Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "P'y\u014Fngan-bukto (Province of North Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "P'y\u014Fngan-bukto (Province of North Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "P'y\u014Fngan-bukto (Province of North Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "P'y\u014Fngan-bukto (Province of North Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "P'y\u014Fngan-bukto (Province of North Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "P'y\u014Fngan-bukto (Province of North Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "P'y\u014Fngan-bukto (Province of North Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "P'y\u014Fngan-bukto (Province of North Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "P'y\u014Fngan-bukto (Province of North Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "P'y\u014Fngan-bukto (Province of North Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "P'y\u014Fngan-bukto (Province of North Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "P'y\u014Fngan-bukto (Province of North Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "P'y\u014Fngan-bukto (Province of North Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "P'y\u014Fngan-bukto (Province of North Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "P'y\u014Fngan-bukto (Province of North Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "P'y\u014Fngan-bukto (Province of North Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "P'y\u014Fngan-bukto (Province of North Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 16
            }
        ],
        "P'y\u014Fngan-namdo (Province of North Korea)": [
            {
                "Region Name": "P'y\u014Fngan-namdo (Province of North Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "P'y\u014Fngan-namdo (Province of North Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "P'y\u014Fngan-namdo (Province of North Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "P'y\u014Fngan-namdo (Province of North Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "P'y\u014Fngan-namdo (Province of North Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "P'y\u014Fngan-namdo (Province of North Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P'y\u014Fngan-namdo (Province of North Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P'y\u014Fngan-namdo (Province of North Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "P'y\u014Fngan-namdo (Province of North Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "P'y\u014Fngan-namdo (Province of North Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P'y\u014Fngan-namdo (Province of North Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "P'y\u014Fngan-namdo (Province of North Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "P'y\u014Fngan-namdo (Province of North Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "P'y\u014Fngan-namdo (Province of North Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "P'y\u014Fngan-namdo (Province of North Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P'y\u014Fngan-namdo (Province of North Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "P'y\u014Fngan-namdo (Province of North Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "P'y\u014Fngan-namdo (Province of North Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "P'y\u014Fngan-namdo (Province of North Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "P'y\u014Fngan-namdo (Province of North Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P'y\u014Fngan-namdo (Province of North Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "P'y\u014Fngan-namdo (Province of North Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "P'y\u014Fngyang (Special City of North Korea)": [
            {
                "Region Name": "P'y\u014Fngyang (Special City of North Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "P'y\u014Fngyang (Special City of North Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P'y\u014Fngyang (Special City of North Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P'y\u014Fngyang (Special City of North Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P'y\u014Fngyang (Special City of North Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P'y\u014Fngyang (Special City of North Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P'y\u014Fngyang (Special City of North Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P'y\u014Fngyang (Special City of North Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "P'y\u014Fngyang (Special City of North Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P'y\u014Fngyang (Special City of North Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "P'y\u014Fngyang (Special City of North Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P'y\u014Fngyang (Special City of North Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "P'y\u014Fngyang (Special City of North Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P'y\u014Fngyang (Special City of North Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P'y\u014Fngyang (Special City of North Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P'y\u014Fngyang (Special City of North Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P'y\u014Fngyang (Special City of North Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P'y\u014Fngyang (Special City of North Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "P'y\u014Fngyang (Special City of North Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "P'y\u014Fngyang (Special City of North Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P'y\u014Fngyang (Special City of North Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P'y\u014Fngyang (Special City of North Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pader (District of Uganda)": [
            {
                "Region Name": "Pader (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Pader (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Pader (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Pader (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 253
            },
            {
                "Region Name": "Pader (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Pader (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Pader (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Pader (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Pader (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pader (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Pader (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Pader (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pader (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pader (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pader (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Pader (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Pader (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pader (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pader (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pader (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pader (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pader (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Paget (Parish of Bermuda)": [
            {
                "Region Name": "Paget (Parish of Bermuda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paget (Parish of Bermuda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paget (Parish of Bermuda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paget (Parish of Bermuda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paget (Parish of Bermuda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paget (Parish of Bermuda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paget (Parish of Bermuda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paget (Parish of Bermuda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paget (Parish of Bermuda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paget (Parish of Bermuda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paget (Parish of Bermuda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paget (Parish of Bermuda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paget (Parish of Bermuda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paget (Parish of Bermuda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paget (Parish of Bermuda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paget (Parish of Bermuda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paget (Parish of Bermuda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paget (Parish of Bermuda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paget (Parish of Bermuda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paget (Parish of Bermuda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paget (Parish of Bermuda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paget (Parish of Bermuda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pahang (State of Malaysia)": [
            {
                "Region Name": "Pahang (State of Malaysia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pahang (State of Malaysia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pahang (State of Malaysia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pahang (State of Malaysia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pahang (State of Malaysia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pahang (State of Malaysia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Pahang (State of Malaysia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pahang (State of Malaysia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pahang (State of Malaysia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pahang (State of Malaysia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pahang (State of Malaysia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pahang (State of Malaysia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Pahang (State of Malaysia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pahang (State of Malaysia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pahang (State of Malaysia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pahang (State of Malaysia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Pahang (State of Malaysia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pahang (State of Malaysia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pahang (State of Malaysia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pahang (State of Malaysia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pahang (State of Malaysia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pahang (State of Malaysia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Pa\xeds Vasco (Autonomous Community of Spain)": [
            {
                "Region Name": "Pa\xeds Vasco (Autonomous Community of Spain)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xeds Vasco (Autonomous Community of Spain)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pa\xeds Vasco (Autonomous Community of Spain)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xeds Vasco (Autonomous Community of Spain)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xeds Vasco (Autonomous Community of Spain)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xeds Vasco (Autonomous Community of Spain)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pa\xeds Vasco (Autonomous Community of Spain)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xeds Vasco (Autonomous Community of Spain)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pa\xeds Vasco (Autonomous Community of Spain)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xeds Vasco (Autonomous Community of Spain)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pa\xeds Vasco (Autonomous Community of Spain)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xeds Vasco (Autonomous Community of Spain)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xeds Vasco (Autonomous Community of Spain)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pa\xeds Vasco (Autonomous Community of Spain)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pa\xeds Vasco (Autonomous Community of Spain)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xeds Vasco (Autonomous Community of Spain)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xeds Vasco (Autonomous Community of Spain)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xeds Vasco (Autonomous Community of Spain)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xeds Vasco (Autonomous Community of Spain)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xeds Vasco (Autonomous Community of Spain)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xeds Vasco (Autonomous Community of Spain)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pa\xeds Vasco (Autonomous Community of Spain)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Paktika (Province of Afghanistan)": [
            {
                "Region Name": "Paktika (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktika (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktika (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktika (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktika (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktika (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktika (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktika (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktika (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktika (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktika (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktika (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktika (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktika (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktika (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktika (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktika (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktika (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktika (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktika (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktika (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktika (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Paktya (Province of Afghanistan)": [
            {
                "Region Name": "Paktya (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktya (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktya (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktya (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktya (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktya (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktya (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktya (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktya (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktya (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktya (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktya (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktya (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktya (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktya (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Paktya (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktya (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktya (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktya (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Paktya (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktya (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paktya (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Palauli (District of Samoa)": [
            {
                "Region Name": "Palauli (District of Samoa)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palauli (District of Samoa)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palauli (District of Samoa)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palauli (District of Samoa)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palauli (District of Samoa)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palauli (District of Samoa)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palauli (District of Samoa)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palauli (District of Samoa)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palauli (District of Samoa)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palauli (District of Samoa)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Palauli (District of Samoa)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palauli (District of Samoa)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palauli (District of Samoa)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palauli (District of Samoa)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palauli (District of Samoa)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palauli (District of Samoa)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palauli (District of Samoa)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palauli (District of Samoa)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palauli (District of Samoa)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palauli (District of Samoa)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palauli (District of Samoa)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palauli (District of Samoa)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Palawan (Province of Philippines)": [
            {
                "Region Name": "Palawan (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Palawan (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Palawan (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Palawan (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Palawan (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Palawan (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Palawan (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Palawan (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Palawan (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Palawan (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Palawan (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Palawan (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Palawan (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Palawan (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Palawan (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Palawan (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Palawan (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Palawan (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Palawan (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Palawan (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Palawan (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Palawan (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Pallisa (District of Uganda)": [
            {
                "Region Name": "Pallisa (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pallisa (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pallisa (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pallisa (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pallisa (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pallisa (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pallisa (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pallisa (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pallisa (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pallisa (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pallisa (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pallisa (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pallisa (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pallisa (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Pallisa (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pallisa (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pallisa (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pallisa (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pallisa (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pallisa (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pallisa (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pallisa (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Palmerston (Island Council of Cook Islands)": [
            {
                "Region Name": "Palmerston (Island Council of Cook Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmerston (Island Council of Cook Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmerston (Island Council of Cook Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmerston (Island Council of Cook Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmerston (Island Council of Cook Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmerston (Island Council of Cook Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmerston (Island Council of Cook Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmerston (Island Council of Cook Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmerston (Island Council of Cook Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmerston (Island Council of Cook Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmerston (Island Council of Cook Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmerston (Island Council of Cook Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmerston (Island Council of Cook Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmerston (Island Council of Cook Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmerston (Island Council of Cook Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmerston (Island Council of Cook Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmerston (Island Council of Cook Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmerston (Island Council of Cook Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmerston (Island Council of Cook Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmerston (Island Council of Cook Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmerston (Island Council of Cook Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmerston (Island Council of Cook Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Palmyra (Atoll of United States Minor Outlying Isl)": [
            {
                "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Palmyra (Atoll of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pamandzi (Commune of Mayotte)": [
            {
                "Region Name": "Pamandzi (Commune of Mayotte)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamandzi (Commune of Mayotte)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamandzi (Commune of Mayotte)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamandzi (Commune of Mayotte)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamandzi (Commune of Mayotte)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamandzi (Commune of Mayotte)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamandzi (Commune of Mayotte)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamandzi (Commune of Mayotte)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamandzi (Commune of Mayotte)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamandzi (Commune of Mayotte)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamandzi (Commune of Mayotte)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamandzi (Commune of Mayotte)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamandzi (Commune of Mayotte)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamandzi (Commune of Mayotte)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamandzi (Commune of Mayotte)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamandzi (Commune of Mayotte)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamandzi (Commune of Mayotte)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamandzi (Commune of Mayotte)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamandzi (Commune of Mayotte)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamandzi (Commune of Mayotte)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamandzi (Commune of Mayotte)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamandzi (Commune of Mayotte)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pampanga (Province of Philippines)": [
            {
                "Region Name": "Pampanga (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pampanga (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pampanga (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pampanga (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pampanga (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pampanga (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pampanga (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pampanga (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pampanga (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pampanga (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pampanga (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pampanga (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pampanga (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pampanga (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pampanga (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pampanga (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pampanga (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pampanga (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pampanga (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pampanga (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pampanga (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pampanga (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Pamplemousses (District of Mauritius)": [
            {
                "Region Name": "Pamplemousses (District of Mauritius)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pamplemousses (District of Mauritius)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pamplemousses (District of Mauritius)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamplemousses (District of Mauritius)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamplemousses (District of Mauritius)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pamplemousses (District of Mauritius)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamplemousses (District of Mauritius)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamplemousses (District of Mauritius)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamplemousses (District of Mauritius)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pamplemousses (District of Mauritius)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamplemousses (District of Mauritius)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pamplemousses (District of Mauritius)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pamplemousses (District of Mauritius)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pamplemousses (District of Mauritius)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamplemousses (District of Mauritius)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamplemousses (District of Mauritius)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamplemousses (District of Mauritius)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamplemousses (District of Mauritius)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamplemousses (District of Mauritius)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamplemousses (District of Mauritius)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamplemousses (District of Mauritius)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pamplemousses (District of Mauritius)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Panam\xe1 (Province of Panama)": [
            {
                "Region Name": "Panam\xe1 (Province of Panama)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Panam\xe1 (Province of Panama)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Panam\xe1 (Province of Panama)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Panam\xe1 (Province of Panama)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Panam\xe1 (Province of Panama)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Panam\xe1 (Province of Panama)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Panam\xe1 (Province of Panama)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Panam\xe1 (Province of Panama)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Panam\xe1 (Province of Panama)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Panam\xe1 (Province of Panama)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panam\xe1 (Province of Panama)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Panam\xe1 (Province of Panama)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Panam\xe1 (Province of Panama)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Panam\xe1 (Province of Panama)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Panam\xe1 (Province of Panama)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Panam\xe1 (Province of Panama)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Panam\xe1 (Province of Panama)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Panam\xe1 (Province of Panama)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Panam\xe1 (Province of Panama)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Panam\xe1 (Province of Panama)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Panam\xe1 (Province of Panama)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Panam\xe1 (Province of Panama)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Panam\xe1 Oeste (Province of Panama)": [
            {
                "Region Name": "Panam\xe1 Oeste (Province of Panama)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Panam\xe1 Oeste (Province of Panama)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Panam\xe1 Oeste (Province of Panama)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Panam\xe1 Oeste (Province of Panama)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Panam\xe1 Oeste (Province of Panama)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Panam\xe1 Oeste (Province of Panama)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Panam\xe1 Oeste (Province of Panama)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Panam\xe1 Oeste (Province of Panama)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Panam\xe1 Oeste (Province of Panama)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Panam\xe1 Oeste (Province of Panama)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Panam\xe1 Oeste (Province of Panama)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Panam\xe1 Oeste (Province of Panama)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Panam\xe1 Oeste (Province of Panama)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Panam\xe1 Oeste (Province of Panama)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Panam\xe1 Oeste (Province of Panama)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Panam\xe1 Oeste (Province of Panama)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panam\xe1 Oeste (Province of Panama)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Panam\xe1 Oeste (Province of Panama)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Panam\xe1 Oeste (Province of Panama)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Panam\xe1 Oeste (Province of Panama)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Panam\xe1 Oeste (Province of Panama)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panam\xe1 Oeste (Province of Panama)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Pando (Department of Bolivia)": [
            {
                "Region Name": "Pando (Department of Bolivia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pando (Department of Bolivia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pando (Department of Bolivia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pando (Department of Bolivia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Pando (Department of Bolivia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pando (Department of Bolivia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pando (Department of Bolivia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pando (Department of Bolivia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pando (Department of Bolivia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Pando (Department of Bolivia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pando (Department of Bolivia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pando (Department of Bolivia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Pando (Department of Bolivia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pando (Department of Bolivia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pando (Department of Bolivia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pando (Department of Bolivia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pando (Department of Bolivia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pando (Department of Bolivia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pando (Department of Bolivia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pando (Department of Bolivia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pando (Department of Bolivia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pando (Department of Bolivia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Panevezio (County of Lithuania)": [
            {
                "Region Name": "Panevezio (County of Lithuania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Panevezio (County of Lithuania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Panevezio (County of Lithuania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Panevezio (County of Lithuania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Panevezio (County of Lithuania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panevezio (County of Lithuania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panevezio (County of Lithuania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panevezio (County of Lithuania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Panevezio (County of Lithuania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panevezio (County of Lithuania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panevezio (County of Lithuania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Panevezio (County of Lithuania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panevezio (County of Lithuania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panevezio (County of Lithuania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Panevezio (County of Lithuania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Panevezio (County of Lithuania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panevezio (County of Lithuania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Panevezio (County of Lithuania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panevezio (County of Lithuania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panevezio (County of Lithuania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panevezio (County of Lithuania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panevezio (County of Lithuania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pangasinan (Province of Philippines)": [
            {
                "Region Name": "Pangasinan (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pangasinan (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pangasinan (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pangasinan (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pangasinan (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pangasinan (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pangasinan (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pangasinan (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pangasinan (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pangasinan (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pangasinan (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pangasinan (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pangasinan (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pangasinan (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pangasinan (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pangasinan (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pangasinan (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pangasinan (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pangasinan (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pangasinan (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pangasinan (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pangasinan (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Panjshir (Province of Afghanistan)": [
            {
                "Region Name": "Panjshir (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panjshir (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panjshir (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panjshir (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panjshir (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panjshir (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panjshir (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panjshir (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panjshir (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panjshir (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panjshir (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panjshir (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panjshir (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panjshir (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panjshir (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panjshir (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panjshir (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panjshir (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panjshir (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panjshir (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panjshir (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Panjshir (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Paphos (District of Cyprus)": [
            {
                "Region Name": "Paphos (District of Cyprus)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paphos (District of Cyprus)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paphos (District of Cyprus)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paphos (District of Cyprus)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Paphos (District of Cyprus)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paphos (District of Cyprus)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Paphos (District of Cyprus)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paphos (District of Cyprus)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paphos (District of Cyprus)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paphos (District of Cyprus)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paphos (District of Cyprus)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paphos (District of Cyprus)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Paphos (District of Cyprus)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paphos (District of Cyprus)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Paphos (District of Cyprus)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paphos (District of Cyprus)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paphos (District of Cyprus)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paphos (District of Cyprus)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Paphos (District of Cyprus)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Paphos (District of Cyprus)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Paphos (District of Cyprus)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paphos (District of Cyprus)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Papua (Province of Indonesia)": [
            {
                "Region Name": "Papua (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Papua (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Papua (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Papua (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Papua (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Papua (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Papua (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Papua (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Papua (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Papua (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Papua (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Papua (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Papua (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Papua (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Papua (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Papua (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Papua (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Papua (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Papua (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Papua (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Papua (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Papua (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Papua Barat (Province of Indonesia)": [
            {
                "Region Name": "Papua Barat (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Papua Barat (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Papua Barat (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Papua Barat (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Papua Barat (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Papua Barat (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Papua Barat (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Papua Barat (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Papua Barat (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Papua Barat (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Papua Barat (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Papua Barat (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Papua Barat (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Papua Barat (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Papua Barat (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Papua Barat (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Papua Barat (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Papua Barat (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Papua Barat (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Papua Barat (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Papua Barat (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Papua Barat (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Para (District of Suriname)": [
            {
                "Region Name": "Para (District of Suriname)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Para (District of Suriname)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Para (District of Suriname)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Para (District of Suriname)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Para (District of Suriname)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Para (District of Suriname)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Para (District of Suriname)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Para (District of Suriname)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Para (District of Suriname)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Para (District of Suriname)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Para (District of Suriname)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Para (District of Suriname)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Para (District of Suriname)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Para (District of Suriname)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Para (District of Suriname)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Para (District of Suriname)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Para (District of Suriname)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Para (District of Suriname)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Para (District of Suriname)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Para (District of Suriname)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Para (District of Suriname)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Para (District of Suriname)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Par\xe1 (State of Brazil)": [
            {
                "Region Name": "Par\xe1 (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Par\xe1 (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Par\xe1 (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Par\xe1 (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Par\xe1 (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Par\xe1 (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Par\xe1 (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Par\xe1 (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Par\xe1 (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Par\xe1 (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Par\xe1 (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Par\xe1 (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Par\xe1 (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Par\xe1 (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Par\xe1 (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Par\xe1 (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Par\xe1 (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Par\xe1 (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Par\xe1 (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Par\xe1 (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Par\xe1 (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Par\xe1 (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Paraguar\xed (Department of Paraguay)": [
            {
                "Region Name": "Paraguar\xed (Department of Paraguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Paraguar\xed (Department of Paraguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paraguar\xed (Department of Paraguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Paraguar\xed (Department of Paraguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Paraguar\xed (Department of Paraguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paraguar\xed (Department of Paraguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paraguar\xed (Department of Paraguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paraguar\xed (Department of Paraguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Paraguar\xed (Department of Paraguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Paraguar\xed (Department of Paraguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Paraguar\xed (Department of Paraguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Paraguar\xed (Department of Paraguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Paraguar\xed (Department of Paraguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paraguar\xed (Department of Paraguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Paraguar\xed (Department of Paraguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paraguar\xed (Department of Paraguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Paraguar\xed (Department of Paraguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Paraguar\xed (Department of Paraguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Paraguar\xed (Department of Paraguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Paraguar\xed (Department of Paraguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Paraguar\xed (Department of Paraguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Paraguar\xed (Department of Paraguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Para\xedba (State of Brazil)": [
            {
                "Region Name": "Para\xedba (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Para\xedba (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Para\xedba (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Para\xedba (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Para\xedba (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Para\xedba (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Para\xedba (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Para\xedba (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Para\xedba (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Para\xedba (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Para\xedba (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Para\xedba (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Para\xedba (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Para\xedba (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Para\xedba (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Para\xedba (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Para\xedba (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Para\xedba (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Para\xedba (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Para\xedba (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Para\xedba (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Para\xedba (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Paramaribo (District of Suriname)": [
            {
                "Region Name": "Paramaribo (District of Suriname)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paramaribo (District of Suriname)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paramaribo (District of Suriname)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paramaribo (District of Suriname)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paramaribo (District of Suriname)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paramaribo (District of Suriname)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paramaribo (District of Suriname)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paramaribo (District of Suriname)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paramaribo (District of Suriname)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paramaribo (District of Suriname)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paramaribo (District of Suriname)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paramaribo (District of Suriname)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paramaribo (District of Suriname)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paramaribo (District of Suriname)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paramaribo (District of Suriname)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paramaribo (District of Suriname)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paramaribo (District of Suriname)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paramaribo (District of Suriname)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paramaribo (District of Suriname)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paramaribo (District of Suriname)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paramaribo (District of Suriname)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paramaribo (District of Suriname)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Paran\xe1 (State of Brazil)": [
            {
                "Region Name": "Paran\xe1 (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Paran\xe1 (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Paran\xe1 (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paran\xe1 (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paran\xe1 (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paran\xe1 (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paran\xe1 (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paran\xe1 (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Paran\xe1 (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paran\xe1 (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Paran\xe1 (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Paran\xe1 (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paran\xe1 (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paran\xe1 (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Paran\xe1 (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Paran\xe1 (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paran\xe1 (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paran\xe1 (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paran\xe1 (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Paran\xe1 (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paran\xe1 (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Paran\xe1 (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Pardubick\xfd (Region of Czechia)": [
            {
                "Region Name": "Pardubick\xfd (Region of Czechia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pardubick\xfd (Region of Czechia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pardubick\xfd (Region of Czechia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pardubick\xfd (Region of Czechia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pardubick\xfd (Region of Czechia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pardubick\xfd (Region of Czechia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pardubick\xfd (Region of Czechia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pardubick\xfd (Region of Czechia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pardubick\xfd (Region of Czechia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pardubick\xfd (Region of Czechia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pardubick\xfd (Region of Czechia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pardubick\xfd (Region of Czechia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pardubick\xfd (Region of Czechia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pardubick\xfd (Region of Czechia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pardubick\xfd (Region of Czechia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pardubick\xfd (Region of Czechia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pardubick\xfd (Region of Czechia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pardubick\xfd (Region of Czechia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pardubick\xfd (Region of Czechia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pardubick\xfd (Region of Czechia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pardubick\xfd (Region of Czechia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pardubick\xfd (Region of Czechia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "P\xe4rnu (County of Estonia)": [
            {
                "Region Name": "P\xe4rnu (County of Estonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "P\xe4rnu (County of Estonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xe4rnu (County of Estonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xe4rnu (County of Estonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xe4rnu (County of Estonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xe4rnu (County of Estonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xe4rnu (County of Estonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xe4rnu (County of Estonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xe4rnu (County of Estonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xe4rnu (County of Estonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xe4rnu (County of Estonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xe4rnu (County of Estonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xe4rnu (County of Estonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xe4rnu (County of Estonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xe4rnu (County of Estonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xe4rnu (County of Estonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xe4rnu (County of Estonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xe4rnu (County of Estonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "P\xe4rnu (County of Estonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xe4rnu (County of Estonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xe4rnu (County of Estonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xe4rnu (County of Estonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Paro (District of Bhutan)": [
            {
                "Region Name": "Paro (District of Bhutan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paro (District of Bhutan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paro (District of Bhutan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paro (District of Bhutan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paro (District of Bhutan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paro (District of Bhutan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Paro (District of Bhutan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paro (District of Bhutan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paro (District of Bhutan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paro (District of Bhutan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paro (District of Bhutan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paro (District of Bhutan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paro (District of Bhutan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paro (District of Bhutan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Paro (District of Bhutan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paro (District of Bhutan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paro (District of Bhutan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paro (District of Bhutan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paro (District of Bhutan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paro (District of Bhutan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paro (District of Bhutan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paro (District of Bhutan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Parwan (Province of Afghanistan)": [
            {
                "Region Name": "Parwan (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Parwan (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Parwan (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Parwan (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Parwan (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Parwan (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Parwan (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Parwan (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Parwan (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Parwan (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Parwan (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Parwan (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Parwan (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Parwan (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Parwan (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Parwan (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Parwan (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Parwan (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Parwan (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Parwan (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Parwan (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Parwan (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pasco (Region of Peru)": [
            {
                "Region Name": "Pasco (Region of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pasco (Region of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pasco (Region of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pasco (Region of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pasco (Region of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pasco (Region of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pasco (Region of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pasco (Region of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pasco (Region of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pasco (Region of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pasco (Region of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pasco (Region of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pasco (Region of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pasco (Region of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pasco (Region of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pasco (Region of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pasco (Region of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pasco (Region of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pasco (Region of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pasco (Region of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pasco (Region of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pasco (Region of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Pastaza (Province of Ecuador)": [
            {
                "Region Name": "Pastaza (Province of Ecuador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pastaza (Province of Ecuador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pastaza (Province of Ecuador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pastaza (Province of Ecuador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pastaza (Province of Ecuador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pastaza (Province of Ecuador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pastaza (Province of Ecuador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pastaza (Province of Ecuador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pastaza (Province of Ecuador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pastaza (Province of Ecuador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pastaza (Province of Ecuador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pastaza (Province of Ecuador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pastaza (Province of Ecuador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pastaza (Province of Ecuador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pastaza (Province of Ecuador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pastaza (Province of Ecuador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pastaza (Province of Ecuador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pastaza (Province of Ecuador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pastaza (Province of Ecuador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pastaza (Province of Ecuador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pastaza (Province of Ecuador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pastaza (Province of Ecuador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pathum Thani (Province of Thailand)": [
            {
                "Region Name": "Pathum Thani (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pathum Thani (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pathum Thani (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pathum Thani (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pathum Thani (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pathum Thani (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pathum Thani (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pathum Thani (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pathum Thani (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pathum Thani (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pathum Thani (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Pathum Thani (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pathum Thani (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pathum Thani (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pathum Thani (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pathum Thani (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pathum Thani (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pathum Thani (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pathum Thani (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pathum Thani (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pathum Thani (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pathum Thani (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Patillas (Municipality of Puerto Rico)": [
            {
                "Region Name": "Patillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Patrick (Parish District of Isle of Man)": [
            {
                "Region Name": "Patrick (Parish District of Isle of Man)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patrick (Parish District of Isle of Man)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patrick (Parish District of Isle of Man)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patrick (Parish District of Isle of Man)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patrick (Parish District of Isle of Man)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patrick (Parish District of Isle of Man)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patrick (Parish District of Isle of Man)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patrick (Parish District of Isle of Man)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patrick (Parish District of Isle of Man)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patrick (Parish District of Isle of Man)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patrick (Parish District of Isle of Man)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patrick (Parish District of Isle of Man)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patrick (Parish District of Isle of Man)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patrick (Parish District of Isle of Man)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patrick (Parish District of Isle of Man)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patrick (Parish District of Isle of Man)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patrick (Parish District of Isle of Man)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patrick (Parish District of Isle of Man)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patrick (Parish District of Isle of Man)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patrick (Parish District of Isle of Man)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patrick (Parish District of Isle of Man)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Patrick (Parish District of Isle of Man)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pattani (Province of Thailand)": [
            {
                "Region Name": "Pattani (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pattani (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pattani (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pattani (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pattani (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pattani (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pattani (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pattani (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pattani (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pattani (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pattani (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pattani (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pattani (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pattani (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pattani (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pattani (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pattani (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pattani (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pattani (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pattani (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pattani (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pattani (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pa\xfal (County of Cabo Verde)": [
            {
                "Region Name": "Pa\xfal (County of Cabo Verde)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xfal (County of Cabo Verde)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xfal (County of Cabo Verde)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xfal (County of Cabo Verde)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xfal (County of Cabo Verde)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xfal (County of Cabo Verde)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xfal (County of Cabo Verde)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xfal (County of Cabo Verde)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xfal (County of Cabo Verde)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xfal (County of Cabo Verde)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xfal (County of Cabo Verde)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xfal (County of Cabo Verde)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xfal (County of Cabo Verde)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xfal (County of Cabo Verde)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xfal (County of Cabo Verde)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xfal (County of Cabo Verde)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xfal (County of Cabo Verde)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xfal (County of Cabo Verde)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xfal (County of Cabo Verde)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xfal (County of Cabo Verde)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xfal (County of Cabo Verde)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pa\xfal (County of Cabo Verde)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pavlodar (Region of Kazakhstan)": [
            {
                "Region Name": "Pavlodar (Region of Kazakhstan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 83
            },
            {
                "Region Name": "Pavlodar (Region of Kazakhstan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Pavlodar (Region of Kazakhstan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Pavlodar (Region of Kazakhstan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Pavlodar (Region of Kazakhstan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 86
            },
            {
                "Region Name": "Pavlodar (Region of Kazakhstan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 88
            },
            {
                "Region Name": "Pavlodar (Region of Kazakhstan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Pavlodar (Region of Kazakhstan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Pavlodar (Region of Kazakhstan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Pavlodar (Region of Kazakhstan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Pavlodar (Region of Kazakhstan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Pavlodar (Region of Kazakhstan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Pavlodar (Region of Kazakhstan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Pavlodar (Region of Kazakhstan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 96
            },
            {
                "Region Name": "Pavlodar (Region of Kazakhstan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Pavlodar (Region of Kazakhstan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Pavlodar (Region of Kazakhstan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Pavlodar (Region of Kazakhstan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Pavlodar (Region of Kazakhstan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Pavlodar (Region of Kazakhstan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 92
            },
            {
                "Region Name": "Pavlodar (Region of Kazakhstan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Pavlodar (Region of Kazakhstan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Pays de la Loire (Region of France)": [
            {
                "Region Name": "Pays de la Loire (Region of France)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pays de la Loire (Region of France)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pays de la Loire (Region of France)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pays de la Loire (Region of France)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pays de la Loire (Region of France)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pays de la Loire (Region of France)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pays de la Loire (Region of France)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pays de la Loire (Region of France)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pays de la Loire (Region of France)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pays de la Loire (Region of France)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pays de la Loire (Region of France)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pays de la Loire (Region of France)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pays de la Loire (Region of France)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pays de la Loire (Region of France)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pays de la Loire (Region of France)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pays de la Loire (Region of France)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pays de la Loire (Region of France)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pays de la Loire (Region of France)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pays de la Loire (Region of France)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pays de la Loire (Region of France)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pays de la Loire (Region of France)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Pays de la Loire (Region of France)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Paysand\xfa (Department of Uruguay)": [
            {
                "Region Name": "Paysand\xfa (Department of Uruguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Paysand\xfa (Department of Uruguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Paysand\xfa (Department of Uruguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Paysand\xfa (Department of Uruguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Paysand\xfa (Department of Uruguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Paysand\xfa (Department of Uruguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Paysand\xfa (Department of Uruguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Paysand\xfa (Department of Uruguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Paysand\xfa (Department of Uruguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Paysand\xfa (Department of Uruguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Paysand\xfa (Department of Uruguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Paysand\xfa (Department of Uruguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Paysand\xfa (Department of Uruguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paysand\xfa (Department of Uruguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Paysand\xfa (Department of Uruguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Paysand\xfa (Department of Uruguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Paysand\xfa (Department of Uruguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Paysand\xfa (Department of Uruguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Paysand\xfa (Department of Uruguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Paysand\xfa (Department of Uruguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Paysand\xfa (Department of Uruguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Paysand\xfa (Department of Uruguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Pazardzhik (Province of Bulgaria)": [
            {
                "Region Name": "Pazardzhik (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pazardzhik (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pazardzhik (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pazardzhik (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pazardzhik (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pazardzhik (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pazardzhik (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pazardzhik (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pazardzhik (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Pazardzhik (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pazardzhik (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pazardzhik (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pazardzhik (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pazardzhik (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pazardzhik (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pazardzhik (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pazardzhik (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pazardzhik (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pazardzhik (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pazardzhik (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pazardzhik (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pazardzhik (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "P\u010Dinjski (District of Serbia)": [
            {
                "Region Name": "P\u010Dinjski (District of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\u010Dinjski (District of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\u010Dinjski (District of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\u010Dinjski (District of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\u010Dinjski (District of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\u010Dinjski (District of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "P\u010Dinjski (District of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\u010Dinjski (District of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\u010Dinjski (District of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\u010Dinjski (District of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "P\u010Dinjski (District of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "P\u010Dinjski (District of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\u010Dinjski (District of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\u010Dinjski (District of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\u010Dinjski (District of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\u010Dinjski (District of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\u010Dinjski (District of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "P\u010Dinjski (District of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "P\u010Dinjski (District of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "P\u010Dinjski (District of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "P\u010Dinjski (District of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\u010Dinjski (District of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pe\u0107ki (District of Kosovo)": [
            {
                "Region Name": "Pe\u0107ki (District of Kosovo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\u0107ki (District of Kosovo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pe\u0107ki (District of Kosovo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\u0107ki (District of Kosovo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\u0107ki (District of Kosovo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\u0107ki (District of Kosovo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pe\u0107ki (District of Kosovo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\u0107ki (District of Kosovo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\u0107ki (District of Kosovo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\u0107ki (District of Kosovo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pe\u0107ki (District of Kosovo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pe\u0107ki (District of Kosovo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\u0107ki (District of Kosovo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\u0107ki (District of Kosovo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\u0107ki (District of Kosovo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\u0107ki (District of Kosovo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pe\u0107ki (District of Kosovo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\u0107ki (District of Kosovo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pe\u0107ki (District of Kosovo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\u0107ki (District of Kosovo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\u0107ki (District of Kosovo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\u0107ki (District of Kosovo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pedernales (Province of Dominican Republic)": [
            {
                "Region Name": "Pedernales (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pedernales (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Pedernales (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pedernales (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pedernales (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pedernales (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pedernales (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pedernales (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pedernales (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pedernales (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pedernales (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pedernales (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Pedernales (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pedernales (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pedernales (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pedernales (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pedernales (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pedernales (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pedernales (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Pedernales (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Pedernales (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pedernales (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Peel (Town District of Isle of Man)": [
            {
                "Region Name": "Peel (Town District of Isle of Man)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peel (Town District of Isle of Man)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peel (Town District of Isle of Man)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peel (Town District of Isle of Man)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peel (Town District of Isle of Man)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peel (Town District of Isle of Man)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peel (Town District of Isle of Man)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peel (Town District of Isle of Man)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peel (Town District of Isle of Man)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peel (Town District of Isle of Man)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peel (Town District of Isle of Man)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peel (Town District of Isle of Man)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peel (Town District of Isle of Man)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peel (Town District of Isle of Man)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peel (Town District of Isle of Man)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peel (Town District of Isle of Man)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peel (Town District of Isle of Man)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peel (Town District of Isle of Man)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peel (Town District of Isle of Man)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peel (Town District of Isle of Man)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peel (Town District of Isle of Man)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peel (Town District of Isle of Man)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Peh\u010Devo (Municipality of North Macedonia)": [
            {
                "Region Name": "Peh\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peh\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peh\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peh\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peh\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peh\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Peh\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peh\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peh\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peh\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peh\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peh\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peh\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peh\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Peh\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peh\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peh\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peh\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peh\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peh\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Peh\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peh\u010Devo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Peipsi (Water body of Estonia)": [
            {
                "Region Name": "Peipsi (Water body of Estonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peipsi (Water body of Estonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peipsi (Water body of Estonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peipsi (Water body of Estonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peipsi (Water body of Estonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peipsi (Water body of Estonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peipsi (Water body of Estonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peipsi (Water body of Estonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peipsi (Water body of Estonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peipsi (Water body of Estonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peipsi (Water body of Estonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peipsi (Water body of Estonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peipsi (Water body of Estonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peipsi (Water body of Estonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peipsi (Water body of Estonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peipsi (Water body of Estonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peipsi (Water body of Estonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peipsi (Water body of Estonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peipsi (Water body of Estonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peipsi (Water body of Estonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peipsi (Water body of Estonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peipsi (Water body of Estonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Peleliu (State of Palau)": [
            {
                "Region Name": "Peleliu (State of Palau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peleliu (State of Palau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peleliu (State of Palau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peleliu (State of Palau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peleliu (State of Palau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peleliu (State of Palau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peleliu (State of Palau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peleliu (State of Palau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peleliu (State of Palau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peleliu (State of Palau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peleliu (State of Palau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peleliu (State of Palau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peleliu (State of Palau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peleliu (State of Palau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peleliu (State of Palau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peleliu (State of Palau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peleliu (State of Palau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peleliu (State of Palau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peleliu (State of Palau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peleliu (State of Palau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peleliu (State of Palau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peleliu (State of Palau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Peloponnese, Western Greece and (Decentralized administration of Greece)": [
            {
                "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 232
            },
            {
                "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 141
            },
            {
                "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Peloponnese, Western Greece and (Decentralized administration of Greece)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 24
            }
        ],
        "Pema Gatshel (District of Bhutan)": [
            {
                "Region Name": "Pema Gatshel (District of Bhutan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pema Gatshel (District of Bhutan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pema Gatshel (District of Bhutan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pema Gatshel (District of Bhutan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pema Gatshel (District of Bhutan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pema Gatshel (District of Bhutan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pema Gatshel (District of Bhutan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pema Gatshel (District of Bhutan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pema Gatshel (District of Bhutan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pema Gatshel (District of Bhutan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pema Gatshel (District of Bhutan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pema Gatshel (District of Bhutan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pema Gatshel (District of Bhutan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pema Gatshel (District of Bhutan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pema Gatshel (District of Bhutan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pema Gatshel (District of Bhutan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pema Gatshel (District of Bhutan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pema Gatshel (District of Bhutan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pema Gatshel (District of Bhutan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pema Gatshel (District of Bhutan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pema Gatshel (District of Bhutan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pema Gatshel (District of Bhutan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pembroke (Parish of Bermuda)": [
            {
                "Region Name": "Pembroke (Parish of Bermuda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pembroke (Parish of Bermuda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pembroke (Parish of Bermuda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pembroke (Parish of Bermuda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pembroke (Parish of Bermuda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pembroke (Parish of Bermuda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pembroke (Parish of Bermuda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pembroke (Parish of Bermuda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pembroke (Parish of Bermuda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pembroke (Parish of Bermuda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pembroke (Parish of Bermuda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pembroke (Parish of Bermuda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pembroke (Parish of Bermuda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pembroke (Parish of Bermuda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pembroke (Parish of Bermuda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pembroke (Parish of Bermuda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pembroke (Parish of Bermuda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pembroke (Parish of Bermuda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pembroke (Parish of Bermuda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pembroke (Parish of Bermuda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pembroke (Parish of Bermuda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pembroke (Parish of Bermuda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Penal-Debe (Region of Trinidad and Tobago)": [
            {
                "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penal-Debe (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Penama (Province of Vanuatu)": [
            {
                "Region Name": "Penama (Province of Vanuatu)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penama (Province of Vanuatu)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penama (Province of Vanuatu)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penama (Province of Vanuatu)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penama (Province of Vanuatu)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penama (Province of Vanuatu)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penama (Province of Vanuatu)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penama (Province of Vanuatu)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penama (Province of Vanuatu)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penama (Province of Vanuatu)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penama (Province of Vanuatu)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penama (Province of Vanuatu)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penama (Province of Vanuatu)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penama (Province of Vanuatu)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penama (Province of Vanuatu)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penama (Province of Vanuatu)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Penama (Province of Vanuatu)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penama (Province of Vanuatu)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penama (Province of Vanuatu)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penama (Province of Vanuatu)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penama (Province of Vanuatu)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penama (Province of Vanuatu)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Penhryn (Island Council of Cook Islands)": [
            {
                "Region Name": "Penhryn (Island Council of Cook Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penhryn (Island Council of Cook Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penhryn (Island Council of Cook Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penhryn (Island Council of Cook Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penhryn (Island Council of Cook Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penhryn (Island Council of Cook Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penhryn (Island Council of Cook Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penhryn (Island Council of Cook Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penhryn (Island Council of Cook Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penhryn (Island Council of Cook Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penhryn (Island Council of Cook Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penhryn (Island Council of Cook Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penhryn (Island Council of Cook Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penhryn (Island Council of Cook Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penhryn (Island Council of Cook Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penhryn (Island Council of Cook Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penhryn (Island Council of Cook Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penhryn (Island Council of Cook Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penhryn (Island Council of Cook Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penhryn (Island Council of Cook Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penhryn (Island Council of Cook Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Penhryn (Island Council of Cook Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pennsylvania (State of United States)": [
            {
                "Region Name": "Pennsylvania (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pennsylvania (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pennsylvania (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pennsylvania (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pennsylvania (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pennsylvania (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pennsylvania (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pennsylvania (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pennsylvania (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pennsylvania (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pennsylvania (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pennsylvania (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pennsylvania (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pennsylvania (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pennsylvania (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Pennsylvania (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pennsylvania (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pennsylvania (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pennsylvania (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Pennsylvania (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pennsylvania (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pennsylvania (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Pe\xf1uelas (Municipality of Puerto Rico)": [
            {
                "Region Name": "Pe\xf1uelas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\xf1uelas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\xf1uelas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\xf1uelas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\xf1uelas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\xf1uelas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\xf1uelas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\xf1uelas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\xf1uelas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\xf1uelas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\xf1uelas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\xf1uelas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\xf1uelas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\xf1uelas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\xf1uelas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\xf1uelas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\xf1uelas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\xf1uelas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\xf1uelas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\xf1uelas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\xf1uelas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pe\xf1uelas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Penza (Region of Russia)": [
            {
                "Region Name": "Penza (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Penza (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Penza (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Penza (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Penza (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Penza (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Penza (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Penza (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Penza (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Penza (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Penza (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Penza (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Penza (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Penza (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Penza (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Penza (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Penza (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Penza (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Penza (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Penza (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Penza (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Penza (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Perak (State of Malaysia)": [
            {
                "Region Name": "Perak (State of Malaysia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Perak (State of Malaysia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Perak (State of Malaysia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Perak (State of Malaysia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Perak (State of Malaysia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Perak (State of Malaysia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Perak (State of Malaysia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Perak (State of Malaysia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Perak (State of Malaysia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Perak (State of Malaysia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Perak (State of Malaysia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Perak (State of Malaysia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Perak (State of Malaysia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Perak (State of Malaysia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Perak (State of Malaysia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Perak (State of Malaysia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Perak (State of Malaysia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Perak (State of Malaysia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Perak (State of Malaysia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Perak (State of Malaysia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Perak (State of Malaysia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Perak (State of Malaysia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Peravia (Province of Dominican Republic)": [
            {
                "Region Name": "Peravia (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Peravia (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peravia (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peravia (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peravia (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peravia (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peravia (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peravia (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peravia (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peravia (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peravia (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peravia (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peravia (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peravia (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peravia (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peravia (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peravia (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peravia (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peravia (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peravia (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peravia (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Peravia (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Perlis (State of Malaysia)": [
            {
                "Region Name": "Perlis (State of Malaysia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Perlis (State of Malaysia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Perlis (State of Malaysia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Perlis (State of Malaysia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Perlis (State of Malaysia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Perlis (State of Malaysia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Perlis (State of Malaysia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Perlis (State of Malaysia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Perlis (State of Malaysia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Perlis (State of Malaysia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Perlis (State of Malaysia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Perlis (State of Malaysia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Perlis (State of Malaysia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Perlis (State of Malaysia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Perlis (State of Malaysia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Perlis (State of Malaysia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Perlis (State of Malaysia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Perlis (State of Malaysia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Perlis (State of Malaysia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Perlis (State of Malaysia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Perlis (State of Malaysia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Perlis (State of Malaysia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Perm' (Territory of Russia)": [
            {
                "Region Name": "Perm' (Territory of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Perm' (Territory of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Perm' (Territory of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Perm' (Territory of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Perm' (Territory of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Perm' (Territory of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Perm' (Territory of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Perm' (Territory of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Perm' (Territory of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Perm' (Territory of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Perm' (Territory of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Perm' (Territory of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Perm' (Territory of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Perm' (Territory of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Perm' (Territory of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Perm' (Territory of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Perm' (Territory of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Perm' (Territory of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Perm' (Territory of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Perm' (Territory of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Perm' (Territory of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Perm' (Territory of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Pernambuco (State of Brazil)": [
            {
                "Region Name": "Pernambuco (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pernambuco (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pernambuco (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pernambuco (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pernambuco (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pernambuco (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pernambuco (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pernambuco (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pernambuco (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pernambuco (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pernambuco (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pernambuco (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pernambuco (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pernambuco (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pernambuco (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pernambuco (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pernambuco (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pernambuco (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pernambuco (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pernambuco (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pernambuco (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pernambuco (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Pernik (Province of Bulgaria)": [
            {
                "Region Name": "Pernik (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pernik (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pernik (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pernik (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pernik (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pernik (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pernik (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pernik (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pernik (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pernik (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pernik (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pernik (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pernik (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pernik (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pernik (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pernik (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pernik (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pernik (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pernik (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pernik (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pernik (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pernik (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pest (County of Hungary)": [
            {
                "Region Name": "Pest (County of Hungary)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pest (County of Hungary)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pest (County of Hungary)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pest (County of Hungary)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pest (County of Hungary)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pest (County of Hungary)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pest (County of Hungary)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pest (County of Hungary)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pest (County of Hungary)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pest (County of Hungary)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pest (County of Hungary)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pest (County of Hungary)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pest (County of Hungary)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pest (County of Hungary)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pest (County of Hungary)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pest (County of Hungary)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pest (County of Hungary)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pest (County of Hungary)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pest (County of Hungary)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pest (County of Hungary)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pest (County of Hungary)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pest (County of Hungary)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pet\xe9n (Department of Guatemala)": [
            {
                "Region Name": "Pet\xe9n (Department of Guatemala)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pet\xe9n (Department of Guatemala)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Pet\xe9n (Department of Guatemala)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pet\xe9n (Department of Guatemala)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Pet\xe9n (Department of Guatemala)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pet\xe9n (Department of Guatemala)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pet\xe9n (Department of Guatemala)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pet\xe9n (Department of Guatemala)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pet\xe9n (Department of Guatemala)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pet\xe9n (Department of Guatemala)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pet\xe9n (Department of Guatemala)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pet\xe9n (Department of Guatemala)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pet\xe9n (Department of Guatemala)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pet\xe9n (Department of Guatemala)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pet\xe9n (Department of Guatemala)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pet\xe9n (Department of Guatemala)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pet\xe9n (Department of Guatemala)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pet\xe9n (Department of Guatemala)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pet\xe9n (Department of Guatemala)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Pet\xe9n (Department of Guatemala)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pet\xe9n (Department of Guatemala)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pet\xe9n (Department of Guatemala)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Petrovec (Municipality of North Macedonia)": [
            {
                "Region Name": "Petrovec (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Petrovec (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Petrovec (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Petrovec (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Petrovec (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Petrovec (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Petrovec (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Petrovec (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Petrovec (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Petrovec (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Petrovec (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Petrovec (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Petrovec (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Petrovec (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Petrovec (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Petrovec (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Petrovec (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Petrovec (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Petrovec (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Petrovec (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Petrovec (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Petrovec (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Phalombe (District of Malawi)": [
            {
                "Region Name": "Phalombe (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Phalombe (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phalombe (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Phalombe (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phalombe (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Phalombe (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phalombe (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phalombe (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Phalombe (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Phalombe (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phalombe (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phalombe (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Phalombe (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Phalombe (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phalombe (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Phalombe (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Phalombe (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Phalombe (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phalombe (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Phalombe (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Phalombe (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phalombe (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Phangnga (Province of Thailand)": [
            {
                "Region Name": "Phangnga (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Phangnga (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phangnga (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phangnga (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phangnga (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Phangnga (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phangnga (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phangnga (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phangnga (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phangnga (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phangnga (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phangnga (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phangnga (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Phangnga (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phangnga (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Phangnga (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phangnga (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phangnga (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phangnga (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phangnga (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phangnga (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phangnga (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Phatthalung (Province of Thailand)": [
            {
                "Region Name": "Phatthalung (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Phatthalung (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phatthalung (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phatthalung (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phatthalung (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phatthalung (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phatthalung (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phatthalung (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phatthalung (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phatthalung (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phatthalung (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phatthalung (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phatthalung (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phatthalung (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phatthalung (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phatthalung (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phatthalung (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phatthalung (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phatthalung (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phatthalung (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phatthalung (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phatthalung (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Phayao (Province of Thailand)": [
            {
                "Region Name": "Phayao (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phayao (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phayao (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phayao (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phayao (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phayao (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phayao (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phayao (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Phayao (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phayao (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phayao (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phayao (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Phayao (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phayao (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Phayao (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phayao (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Phayao (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Phayao (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Phayao (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Phayao (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Phayao (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Phayao (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Phetchabun (Province of Thailand)": [
            {
                "Region Name": "Phetchabun (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Phetchabun (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Phetchabun (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Phetchabun (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phetchabun (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Phetchabun (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phetchabun (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phetchabun (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Phetchabun (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Phetchabun (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Phetchabun (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phetchabun (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Phetchabun (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phetchabun (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phetchabun (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Phetchabun (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phetchabun (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phetchabun (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phetchabun (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phetchabun (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phetchabun (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phetchabun (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Phetchaburi (Province of Thailand)": [
            {
                "Region Name": "Phetchaburi (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phetchaburi (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Phetchaburi (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phetchaburi (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Phetchaburi (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phetchaburi (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phetchaburi (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phetchaburi (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Phetchaburi (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phetchaburi (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phetchaburi (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phetchaburi (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Phetchaburi (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Phetchaburi (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Phetchaburi (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phetchaburi (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phetchaburi (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phetchaburi (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Phetchaburi (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phetchaburi (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Phetchaburi (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Phetchaburi (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Phichit (Province of Thailand)": [
            {
                "Region Name": "Phichit (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Phichit (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Phichit (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phichit (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phichit (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phichit (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phichit (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phichit (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phichit (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phichit (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Phichit (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Phichit (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phichit (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Phichit (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phichit (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Phichit (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phichit (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Phichit (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phichit (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Phichit (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Phichit (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Phichit (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Phitsanulok (Province of Thailand)": [
            {
                "Region Name": "Phitsanulok (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phitsanulok (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phitsanulok (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phitsanulok (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phitsanulok (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phitsanulok (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phitsanulok (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phitsanulok (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Phitsanulok (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phitsanulok (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phitsanulok (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phitsanulok (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phitsanulok (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Phitsanulok (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phitsanulok (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phitsanulok (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phitsanulok (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phitsanulok (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phitsanulok (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phitsanulok (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phitsanulok (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phitsanulok (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Phnom Penh (Municipality of Cambodia)": [
            {
                "Region Name": "Phnom Penh (Municipality of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Phnom Penh (Municipality of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phnom Penh (Municipality of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phnom Penh (Municipality of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Phnom Penh (Municipality of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phnom Penh (Municipality of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phnom Penh (Municipality of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Phnom Penh (Municipality of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Phnom Penh (Municipality of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phnom Penh (Municipality of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phnom Penh (Municipality of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phnom Penh (Municipality of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phnom Penh (Municipality of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phnom Penh (Municipality of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Phnom Penh (Municipality of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phnom Penh (Municipality of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phnom Penh (Municipality of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phnom Penh (Municipality of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phnom Penh (Municipality of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phnom Penh (Municipality of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phnom Penh (Municipality of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phnom Penh (Municipality of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ph\xf4ngsali (Province of Laos)": [
            {
                "Region Name": "Ph\xf4ngsali (Province of Laos)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ph\xf4ngsali (Province of Laos)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ph\xf4ngsali (Province of Laos)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ph\xf4ngsali (Province of Laos)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ph\xf4ngsali (Province of Laos)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ph\xf4ngsali (Province of Laos)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ph\xf4ngsali (Province of Laos)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ph\xf4ngsali (Province of Laos)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ph\xf4ngsali (Province of Laos)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ph\xf4ngsali (Province of Laos)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ph\xf4ngsali (Province of Laos)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ph\xf4ngsali (Province of Laos)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ph\xf4ngsali (Province of Laos)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ph\xf4ngsali (Province of Laos)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ph\xf4ngsali (Province of Laos)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ph\xf4ngsali (Province of Laos)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ph\xf4ngsali (Province of Laos)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ph\xf4ngsali (Province of Laos)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ph\xf4ngsali (Province of Laos)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ph\xf4ngsali (Province of Laos)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ph\xf4ngsali (Province of Laos)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ph\xf4ngsali (Province of Laos)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Phra Nakhon Si Ayutthaya (Province of Thailand)": [
            {
                "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Phra Nakhon Si Ayutthaya (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Phrae (Province of Thailand)": [
            {
                "Region Name": "Phrae (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Phrae (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phrae (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phrae (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phrae (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phrae (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phrae (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phrae (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phrae (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phrae (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Phrae (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phrae (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phrae (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Phrae (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Phrae (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phrae (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phrae (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Phrae (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phrae (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phrae (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Phrae (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Phrae (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Ph\xfa Th\u1ECD (Province of Vietnam)": [
            {
                "Region Name": "Ph\xfa Th\u1ECD (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ph\xfa Th\u1ECD (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ph\xfa Th\u1ECD (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ph\xfa Th\u1ECD (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ph\xfa Th\u1ECD (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ph\xfa Th\u1ECD (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ph\xfa Th\u1ECD (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ph\xfa Th\u1ECD (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ph\xfa Th\u1ECD (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ph\xfa Th\u1ECD (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ph\xfa Th\u1ECD (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ph\xfa Th\u1ECD (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ph\xfa Th\u1ECD (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ph\xfa Th\u1ECD (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ph\xfa Th\u1ECD (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ph\xfa Th\u1ECD (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ph\xfa Th\u1ECD (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ph\xfa Th\u1ECD (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ph\xfa Th\u1ECD (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ph\xfa Th\u1ECD (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ph\xfa Th\u1ECD (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ph\xfa Th\u1ECD (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Ph\xfa Y\xean (Province of Vietnam)": [
            {
                "Region Name": "Ph\xfa Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ph\xfa Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ph\xfa Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ph\xfa Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ph\xfa Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ph\xfa Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ph\xfa Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ph\xfa Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ph\xfa Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ph\xfa Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ph\xfa Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ph\xfa Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ph\xfa Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ph\xfa Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ph\xfa Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ph\xfa Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ph\xfa Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ph\xfa Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ph\xfa Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ph\xfa Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ph\xfa Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ph\xfa Y\xean (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Phuket (Province of Thailand)": [
            {
                "Region Name": "Phuket (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phuket (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phuket (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phuket (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phuket (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phuket (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phuket (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phuket (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phuket (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phuket (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phuket (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phuket (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phuket (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phuket (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phuket (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phuket (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phuket (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phuket (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phuket (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phuket (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phuket (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Phuket (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Piau\xed (State of Brazil)": [
            {
                "Region Name": "Piau\xed (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Piau\xed (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Piau\xed (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Piau\xed (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Piau\xed (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Piau\xed (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Piau\xed (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Piau\xed (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Piau\xed (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Piau\xed (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Piau\xed (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Piau\xed (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Piau\xed (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Piau\xed (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Piau\xed (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Piau\xed (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Piau\xed (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Piau\xed (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Piau\xed (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Piau\xed (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Piau\xed (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Piau\xed (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "Pichincha (Province of Ecuador)": [
            {
                "Region Name": "Pichincha (Province of Ecuador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pichincha (Province of Ecuador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pichincha (Province of Ecuador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pichincha (Province of Ecuador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pichincha (Province of Ecuador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pichincha (Province of Ecuador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pichincha (Province of Ecuador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pichincha (Province of Ecuador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pichincha (Province of Ecuador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pichincha (Province of Ecuador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pichincha (Province of Ecuador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pichincha (Province of Ecuador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pichincha (Province of Ecuador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pichincha (Province of Ecuador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pichincha (Province of Ecuador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pichincha (Province of Ecuador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pichincha (Province of Ecuador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pichincha (Province of Ecuador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pichincha (Province of Ecuador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pichincha (Province of Ecuador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pichincha (Province of Ecuador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pichincha (Province of Ecuador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Piemonte (Region of Italy)": [
            {
                "Region Name": "Piemonte (Region of Italy)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Piemonte (Region of Italy)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Piemonte (Region of Italy)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Piemonte (Region of Italy)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Piemonte (Region of Italy)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Piemonte (Region of Italy)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Piemonte (Region of Italy)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Piemonte (Region of Italy)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Piemonte (Region of Italy)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Piemonte (Region of Italy)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Piemonte (Region of Italy)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Piemonte (Region of Italy)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Piemonte (Region of Italy)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Piemonte (Region of Italy)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Piemonte (Region of Italy)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Piemonte (Region of Italy)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Piemonte (Region of Italy)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Piemonte (Region of Italy)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Piemonte (Region of Italy)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Piemonte (Region of Italy)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Piemonte (Region of Italy)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Piemonte (Region of Italy)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Pinar del R\xedo (Province of Cuba)": [
            {
                "Region Name": "Pinar del R\xedo (Province of Cuba)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pinar del R\xedo (Province of Cuba)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pinar del R\xedo (Province of Cuba)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pinar del R\xedo (Province of Cuba)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pinar del R\xedo (Province of Cuba)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pinar del R\xedo (Province of Cuba)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pinar del R\xedo (Province of Cuba)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pinar del R\xedo (Province of Cuba)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pinar del R\xedo (Province of Cuba)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pinar del R\xedo (Province of Cuba)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pinar del R\xedo (Province of Cuba)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pinar del R\xedo (Province of Cuba)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pinar del R\xedo (Province of Cuba)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pinar del R\xedo (Province of Cuba)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pinar del R\xedo (Province of Cuba)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pinar del R\xedo (Province of Cuba)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pinar del R\xedo (Province of Cuba)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pinar del R\xedo (Province of Cuba)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pinar del R\xedo (Province of Cuba)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pinar del R\xedo (Province of Cuba)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pinar del R\xedo (Province of Cuba)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pinar del R\xedo (Province of Cuba)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Pirotski (District of Serbia)": [
            {
                "Region Name": "Pirotski (District of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pirotski (District of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pirotski (District of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pirotski (District of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pirotski (District of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pirotski (District of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Pirotski (District of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pirotski (District of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pirotski (District of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pirotski (District of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Pirotski (District of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pirotski (District of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pirotski (District of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pirotski (District of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pirotski (District of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pirotski (District of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pirotski (District of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pirotski (District of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Pirotski (District of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pirotski (District of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pirotski (District of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pirotski (District of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Piti (Municipality of Guam)": [
            {
                "Region Name": "Piti (Municipality of Guam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Piti (Municipality of Guam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Piti (Municipality of Guam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Piti (Municipality of Guam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Piti (Municipality of Guam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Piti (Municipality of Guam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Piti (Municipality of Guam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Piti (Municipality of Guam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Piti (Municipality of Guam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Piti (Municipality of Guam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Piti (Municipality of Guam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Piti (Municipality of Guam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Piti (Municipality of Guam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Piti (Municipality of Guam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Piti (Municipality of Guam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Piti (Municipality of Guam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Piti (Municipality of Guam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Piti (Municipality of Guam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Piti (Municipality of Guam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Piti (Municipality of Guam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Piti (Municipality of Guam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Piti (Municipality of Guam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Piura (Region of Peru)": [
            {
                "Region Name": "Piura (Region of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Piura (Region of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Piura (Region of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Piura (Region of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Piura (Region of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Piura (Region of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Piura (Region of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Piura (Region of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Piura (Region of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Piura (Region of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Piura (Region of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Piura (Region of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Piura (Region of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Piura (Region of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Piura (Region of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Piura (Region of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Piura (Region of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Piura (Region of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Piura (Region of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Piura (Region of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Piura (Region of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Piura (Region of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 27
            }
        ],
        "Plaines Wilhems (District of Mauritius)": [
            {
                "Region Name": "Plaines Wilhems (District of Mauritius)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaines Wilhems (District of Mauritius)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaines Wilhems (District of Mauritius)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaines Wilhems (District of Mauritius)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaines Wilhems (District of Mauritius)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaines Wilhems (District of Mauritius)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaines Wilhems (District of Mauritius)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaines Wilhems (District of Mauritius)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaines Wilhems (District of Mauritius)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaines Wilhems (District of Mauritius)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaines Wilhems (District of Mauritius)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaines Wilhems (District of Mauritius)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaines Wilhems (District of Mauritius)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaines Wilhems (District of Mauritius)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaines Wilhems (District of Mauritius)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaines Wilhems (District of Mauritius)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaines Wilhems (District of Mauritius)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaines Wilhems (District of Mauritius)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaines Wilhems (District of Mauritius)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaines Wilhems (District of Mauritius)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaines Wilhems (District of Mauritius)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaines Wilhems (District of Mauritius)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Plaisance (District of Seychelles)": [
            {
                "Region Name": "Plaisance (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaisance (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaisance (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaisance (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaisance (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaisance (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaisance (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaisance (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaisance (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaisance (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaisance (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaisance (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaisance (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaisance (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaisance (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaisance (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaisance (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaisance (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaisance (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaisance (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaisance (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plaisance (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Planken (Commune of Liechtenstein)": [
            {
                "Region Name": "Planken (Commune of Liechtenstein)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Planken (Commune of Liechtenstein)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Planken (Commune of Liechtenstein)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Planken (Commune of Liechtenstein)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Planken (Commune of Liechtenstein)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Planken (Commune of Liechtenstein)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Planken (Commune of Liechtenstein)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Planken (Commune of Liechtenstein)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Planken (Commune of Liechtenstein)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Planken (Commune of Liechtenstein)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Planken (Commune of Liechtenstein)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Planken (Commune of Liechtenstein)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Planken (Commune of Liechtenstein)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Planken (Commune of Liechtenstein)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Planken (Commune of Liechtenstein)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Planken (Commune of Liechtenstein)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Planken (Commune of Liechtenstein)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Planken (Commune of Liechtenstein)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Planken (Commune of Liechtenstein)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Planken (Commune of Liechtenstein)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Planken (Commune of Liechtenstein)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Planken (Commune of Liechtenstein)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Plasnica (Municipality of North Macedonia)": [
            {
                "Region Name": "Plasnica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plasnica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plasnica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plasnica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plasnica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plasnica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plasnica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Plasnica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plasnica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plasnica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Plasnica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plasnica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plasnica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plasnica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plasnica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plasnica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Plasnica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plasnica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plasnica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plasnica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plasnica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plasnica (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Plateau-Central (Region of Burkina Faso)": [
            {
                "Region Name": "Plateau-Central (Region of Burkina Faso)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Plateau-Central (Region of Burkina Faso)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Plateau-Central (Region of Burkina Faso)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Plateau-Central (Region of Burkina Faso)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Plateau-Central (Region of Burkina Faso)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Plateau-Central (Region of Burkina Faso)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Plateau-Central (Region of Burkina Faso)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Plateau-Central (Region of Burkina Faso)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Plateau-Central (Region of Burkina Faso)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Plateau-Central (Region of Burkina Faso)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Plateau-Central (Region of Burkina Faso)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Plateau-Central (Region of Burkina Faso)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Plateau-Central (Region of Burkina Faso)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Plateau-Central (Region of Burkina Faso)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Plateau-Central (Region of Burkina Faso)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Plateau-Central (Region of Burkina Faso)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Plateau-Central (Region of Burkina Faso)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Plateau-Central (Region of Burkina Faso)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Plateau-Central (Region of Burkina Faso)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Plateau-Central (Region of Burkina Faso)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Plateau-Central (Region of Burkina Faso)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Plateau-Central (Region of Burkina Faso)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Plateau (Department of Benin)": [
            {
                "Region Name": "Plateau (Department of Benin)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Plateau (Department of Benin)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Plateau (Department of Benin)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Plateau (Department of Benin)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Plateau (Department of Benin)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Plateau (Department of Benin)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Plateau (Department of Benin)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Plateau (Department of Benin)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Plateau (Department of Benin)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Plateau (Department of Benin)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Plateau (Department of Benin)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Plateau (Department of Benin)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Plateau (Department of Benin)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Plateau (Department of Benin)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Plateau (Department of Benin)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Plateau (Department of Benin)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Plateau (Department of Benin)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Plateau (Department of Benin)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Plateau (Department of Benin)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Plateau (Department of Benin)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Plateau (Department of Benin)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Plateau (Department of Benin)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Plateau (State of Nigeria)": [
            {
                "Region Name": "Plateau (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Plateau (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Plateau (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Plateau (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Plateau (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Plateau (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Plateau (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Plateau (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Plateau (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Plateau (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Plateau (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Plateau (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Plateau (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Plateau (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Plateau (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Plateau (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Plateau (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Plateau (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Plateau (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Plateau (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Plateau (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Plateau (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Plateaux (Region of Republic of the Congo)": [
            {
                "Region Name": "Plateaux (Region of Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Plateaux (Region of Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Plateaux (Region of Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Plateaux (Region of Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Plateaux (Region of Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Plateaux (Region of Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Plateaux (Region of Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Plateaux (Region of Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Plateaux (Region of Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Plateaux (Region of Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Plateaux (Region of Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Plateaux (Region of Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Plateaux (Region of Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Plateaux (Region of Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Plateaux (Region of Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Plateaux (Region of Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Plateaux (Region of Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Plateaux (Region of Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Plateaux (Region of Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Plateaux (Region of Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Plateaux (Region of Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Plateaux (Region of Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Plateaux (Region of Togo)": [
            {
                "Region Name": "Plateaux (Region of Togo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Plateaux (Region of Togo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Plateaux (Region of Togo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Plateaux (Region of Togo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Plateaux (Region of Togo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Plateaux (Region of Togo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Plateaux (Region of Togo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Plateaux (Region of Togo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Plateaux (Region of Togo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Plateaux (Region of Togo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Plateaux (Region of Togo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Plateaux (Region of Togo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Plateaux (Region of Togo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Plateaux (Region of Togo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Plateaux (Region of Togo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Plateaux (Region of Togo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Plateaux (Region of Togo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Plateaux (Region of Togo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Plateaux (Region of Togo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Plateaux (Region of Togo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Plateaux (Region of Togo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Plateaux (Region of Togo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Plav (Municipality of Montenegro)": [
            {
                "Region Name": "Plav (Municipality of Montenegro)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plav (Municipality of Montenegro)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plav (Municipality of Montenegro)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plav (Municipality of Montenegro)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plav (Municipality of Montenegro)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plav (Municipality of Montenegro)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plav (Municipality of Montenegro)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plav (Municipality of Montenegro)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plav (Municipality of Montenegro)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plav (Municipality of Montenegro)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plav (Municipality of Montenegro)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plav (Municipality of Montenegro)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plav (Municipality of Montenegro)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plav (Municipality of Montenegro)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Plav (Municipality of Montenegro)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plav (Municipality of Montenegro)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Plav (Municipality of Montenegro)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plav (Municipality of Montenegro)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plav (Municipality of Montenegro)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plav (Municipality of Montenegro)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plav (Municipality of Montenegro)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plav (Municipality of Montenegro)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pleven (Province of Bulgaria)": [
            {
                "Region Name": "Pleven (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pleven (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pleven (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pleven (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pleven (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pleven (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pleven (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pleven (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Pleven (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pleven (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pleven (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Pleven (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pleven (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pleven (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Pleven (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Pleven (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pleven (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pleven (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pleven (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pleven (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pleven (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Pleven (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Pljevlja (Municipality of Montenegro)": [
            {
                "Region Name": "Pljevlja (Municipality of Montenegro)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pljevlja (Municipality of Montenegro)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pljevlja (Municipality of Montenegro)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pljevlja (Municipality of Montenegro)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pljevlja (Municipality of Montenegro)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pljevlja (Municipality of Montenegro)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pljevlja (Municipality of Montenegro)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pljevlja (Municipality of Montenegro)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pljevlja (Municipality of Montenegro)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pljevlja (Municipality of Montenegro)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pljevlja (Municipality of Montenegro)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Pljevlja (Municipality of Montenegro)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pljevlja (Municipality of Montenegro)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pljevlja (Municipality of Montenegro)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pljevlja (Municipality of Montenegro)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pljevlja (Municipality of Montenegro)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pljevlja (Municipality of Montenegro)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pljevlja (Municipality of Montenegro)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pljevlja (Municipality of Montenegro)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pljevlja (Municipality of Montenegro)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Pljevlja (Municipality of Montenegro)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pljevlja (Municipality of Montenegro)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Plovdiv (Province of Bulgaria)": [
            {
                "Region Name": "Plovdiv (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Plovdiv (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Plovdiv (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Plovdiv (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plovdiv (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Plovdiv (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Plovdiv (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Plovdiv (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Plovdiv (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Plovdiv (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Plovdiv (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Plovdiv (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Plovdiv (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plovdiv (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Plovdiv (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plovdiv (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plovdiv (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Plovdiv (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Plovdiv (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Plovdiv (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Plovdiv (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Plovdiv (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Plu\u017Eine (Municipality of Montenegro)": [
            {
                "Region Name": "Plu\u017Eine (Municipality of Montenegro)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plu\u017Eine (Municipality of Montenegro)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plu\u017Eine (Municipality of Montenegro)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plu\u017Eine (Municipality of Montenegro)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plu\u017Eine (Municipality of Montenegro)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plu\u017Eine (Municipality of Montenegro)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Plu\u017Eine (Municipality of Montenegro)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plu\u017Eine (Municipality of Montenegro)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plu\u017Eine (Municipality of Montenegro)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Plu\u017Eine (Municipality of Montenegro)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plu\u017Eine (Municipality of Montenegro)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Plu\u017Eine (Municipality of Montenegro)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plu\u017Eine (Municipality of Montenegro)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plu\u017Eine (Municipality of Montenegro)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plu\u017Eine (Municipality of Montenegro)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plu\u017Eine (Municipality of Montenegro)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Plu\u017Eine (Municipality of Montenegro)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plu\u017Eine (Municipality of Montenegro)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plu\u017Eine (Municipality of Montenegro)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plu\u017Eine (Municipality of Montenegro)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Plu\u017Eine (Municipality of Montenegro)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plu\u017Eine (Municipality of Montenegro)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Plze\u0148sk\xfd (Region of Czechia)": [
            {
                "Region Name": "Plze\u0148sk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plze\u0148sk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Plze\u0148sk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plze\u0148sk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plze\u0148sk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plze\u0148sk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Plze\u0148sk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plze\u0148sk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plze\u0148sk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plze\u0148sk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Plze\u0148sk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Plze\u0148sk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plze\u0148sk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Plze\u0148sk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plze\u0148sk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Plze\u0148sk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Plze\u0148sk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Plze\u0148sk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Plze\u0148sk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plze\u0148sk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plze\u0148sk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Plze\u0148sk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Podgorica (Municipality of Montenegro)": [
            {
                "Region Name": "Podgorica (Municipality of Montenegro)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podgorica (Municipality of Montenegro)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Podgorica (Municipality of Montenegro)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podgorica (Municipality of Montenegro)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podgorica (Municipality of Montenegro)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Podgorica (Municipality of Montenegro)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Podgorica (Municipality of Montenegro)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Podgorica (Municipality of Montenegro)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podgorica (Municipality of Montenegro)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podgorica (Municipality of Montenegro)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Podgorica (Municipality of Montenegro)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Podgorica (Municipality of Montenegro)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podgorica (Municipality of Montenegro)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podgorica (Municipality of Montenegro)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Podgorica (Municipality of Montenegro)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Podgorica (Municipality of Montenegro)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Podgorica (Municipality of Montenegro)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Podgorica (Municipality of Montenegro)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Podgorica (Municipality of Montenegro)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Podgorica (Municipality of Montenegro)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Podgorica (Municipality of Montenegro)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Podgorica (Municipality of Montenegro)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Podkarpackie (Voivodeship of Poland)": [
            {
                "Region Name": "Podkarpackie (Voivodeship of Poland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Podkarpackie (Voivodeship of Poland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Podkarpackie (Voivodeship of Poland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Podkarpackie (Voivodeship of Poland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podkarpackie (Voivodeship of Poland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Podkarpackie (Voivodeship of Poland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Podkarpackie (Voivodeship of Poland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Podkarpackie (Voivodeship of Poland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Podkarpackie (Voivodeship of Poland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Podkarpackie (Voivodeship of Poland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Podkarpackie (Voivodeship of Poland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Podkarpackie (Voivodeship of Poland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podkarpackie (Voivodeship of Poland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podkarpackie (Voivodeship of Poland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Podkarpackie (Voivodeship of Poland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podkarpackie (Voivodeship of Poland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podkarpackie (Voivodeship of Poland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podkarpackie (Voivodeship of Poland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Podkarpackie (Voivodeship of Poland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podkarpackie (Voivodeship of Poland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podkarpackie (Voivodeship of Poland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Podkarpackie (Voivodeship of Poland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Podlaskie (Voivodeship of Poland)": [
            {
                "Region Name": "Podlaskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Podlaskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Podlaskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podlaskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podlaskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podlaskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podlaskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podlaskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Podlaskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podlaskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Podlaskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podlaskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podlaskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podlaskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podlaskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podlaskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podlaskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podlaskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podlaskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Podlaskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podlaskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podlaskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Podravska (Statistical Region of Slovenia)": [
            {
                "Region Name": "Podravska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podravska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podravska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podravska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podravska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podravska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podravska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podravska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podravska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podravska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podravska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podravska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podravska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podravska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podravska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podravska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podravska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podravska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podravska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podravska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podravska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podravska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Podunavski (District of Serbia)": [
            {
                "Region Name": "Podunavski (District of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podunavski (District of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podunavski (District of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podunavski (District of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podunavski (District of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podunavski (District of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podunavski (District of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Podunavski (District of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podunavski (District of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podunavski (District of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Podunavski (District of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Podunavski (District of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Podunavski (District of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podunavski (District of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podunavski (District of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podunavski (District of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podunavski (District of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Podunavski (District of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Podunavski (District of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podunavski (District of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podunavski (District of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Podunavski (District of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pohnpei (State of Micronesia)": [
            {
                "Region Name": "Pohnpei (State of Micronesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pohnpei (State of Micronesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pohnpei (State of Micronesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pohnpei (State of Micronesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pohnpei (State of Micronesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pohnpei (State of Micronesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pohnpei (State of Micronesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pohnpei (State of Micronesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pohnpei (State of Micronesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pohnpei (State of Micronesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pohnpei (State of Micronesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pohnpei (State of Micronesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pohnpei (State of Micronesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pohnpei (State of Micronesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pohnpei (State of Micronesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pohnpei (State of Micronesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pohnpei (State of Micronesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pohnpei (State of Micronesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pohnpei (State of Micronesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pohnpei (State of Micronesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pohnpei (State of Micronesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pohnpei (State of Micronesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Point Fortin (Borough of Trinidad and Tobago)": [
            {
                "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Point Fortin (Borough of Trinidad and Tobago)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pointe-\xe0-Pitre (District of Guadeloupe)": [
            {
                "Region Name": "Pointe-\xe0-Pitre (District of Guadeloupe)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe-\xe0-Pitre (District of Guadeloupe)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe-\xe0-Pitre (District of Guadeloupe)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe-\xe0-Pitre (District of Guadeloupe)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe-\xe0-Pitre (District of Guadeloupe)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe-\xe0-Pitre (District of Guadeloupe)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe-\xe0-Pitre (District of Guadeloupe)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe-\xe0-Pitre (District of Guadeloupe)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe-\xe0-Pitre (District of Guadeloupe)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe-\xe0-Pitre (District of Guadeloupe)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe-\xe0-Pitre (District of Guadeloupe)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe-\xe0-Pitre (District of Guadeloupe)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe-\xe0-Pitre (District of Guadeloupe)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe-\xe0-Pitre (District of Guadeloupe)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe-\xe0-Pitre (District of Guadeloupe)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe-\xe0-Pitre (District of Guadeloupe)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe-\xe0-Pitre (District of Guadeloupe)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe-\xe0-Pitre (District of Guadeloupe)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe-\xe0-Pitre (District of Guadeloupe)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe-\xe0-Pitre (District of Guadeloupe)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe-\xe0-Pitre (District of Guadeloupe)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe-\xe0-Pitre (District of Guadeloupe)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pointe La Rue (District of Seychelles)": [
            {
                "Region Name": "Pointe La Rue (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe La Rue (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe La Rue (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe La Rue (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe La Rue (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe La Rue (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe La Rue (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe La Rue (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe La Rue (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe La Rue (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe La Rue (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe La Rue (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe La Rue (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe La Rue (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe La Rue (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe La Rue (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe La Rue (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe La Rue (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe La Rue (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe La Rue (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe La Rue (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe La Rue (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pointe Noire (Region of Republic of the Congo)": [
            {
                "Region Name": "Pointe Noire (Region of Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe Noire (Region of Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe Noire (Region of Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe Noire (Region of Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe Noire (Region of Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe Noire (Region of Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe Noire (Region of Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe Noire (Region of Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe Noire (Region of Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe Noire (Region of Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe Noire (Region of Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe Noire (Region of Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe Noire (Region of Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe Noire (Region of Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe Noire (Region of Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe Noire (Region of Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe Noire (Region of Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe Noire (Region of Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe Noire (Region of Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe Noire (Region of Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe Noire (Region of Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pointe Noire (Region of Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Polonnaruwa (District of Sri Lanka)": [
            {
                "Region Name": "Polonnaruwa (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Polonnaruwa (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Polonnaruwa (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Polonnaruwa (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Polonnaruwa (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Polonnaruwa (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Polonnaruwa (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Polonnaruwa (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Polonnaruwa (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Polonnaruwa (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Polonnaruwa (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Polonnaruwa (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Polonnaruwa (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Polonnaruwa (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Polonnaruwa (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Polonnaruwa (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Polonnaruwa (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Polonnaruwa (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Polonnaruwa (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Polonnaruwa (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Polonnaruwa (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Polonnaruwa (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Poltava (Region of Ukraine)": [
            {
                "Region Name": "Poltava (Region of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Poltava (Region of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Poltava (Region of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Poltava (Region of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Poltava (Region of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Poltava (Region of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Poltava (Region of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Poltava (Region of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Poltava (Region of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Poltava (Region of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Poltava (Region of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Poltava (Region of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Poltava (Region of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Poltava (Region of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Poltava (Region of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Poltava (Region of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Poltava (Region of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Poltava (Region of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Poltava (Region of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Poltava (Region of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Poltava (Region of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Poltava (Region of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "P\xf5lva (County of Estonia)": [
            {
                "Region Name": "P\xf5lva (County of Estonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xf5lva (County of Estonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "P\xf5lva (County of Estonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xf5lva (County of Estonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xf5lva (County of Estonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xf5lva (County of Estonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xf5lva (County of Estonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xf5lva (County of Estonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xf5lva (County of Estonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xf5lva (County of Estonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xf5lva (County of Estonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xf5lva (County of Estonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xf5lva (County of Estonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xf5lva (County of Estonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xf5lva (County of Estonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xf5lva (County of Estonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xf5lva (County of Estonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xf5lva (County of Estonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xf5lva (County of Estonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xf5lva (County of Estonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xf5lva (County of Estonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "P\xf5lva (County of Estonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pomeroon-Supenaam (Region of Guyana)": [
            {
                "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomeroon-Supenaam (Region of Guyana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Pomoravski (District of Serbia)": [
            {
                "Region Name": "Pomoravski (District of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomoravski (District of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pomoravski (District of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomoravski (District of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomoravski (District of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomoravski (District of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pomoravski (District of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomoravski (District of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pomoravski (District of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pomoravski (District of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomoravski (District of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomoravski (District of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomoravski (District of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomoravski (District of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomoravski (District of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomoravski (District of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomoravski (District of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pomoravski (District of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pomoravski (District of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomoravski (District of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomoravski (District of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pomoravski (District of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pomorskie (Voivodeship of Poland)": [
            {
                "Region Name": "Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Pomurska (Statistical Region of Slovenia)": [
            {
                "Region Name": "Pomurska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomurska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomurska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomurska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomurska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomurska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomurska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomurska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomurska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomurska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomurska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomurska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomurska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomurska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomurska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomurska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomurska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomurska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomurska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomurska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomurska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pomurska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ponce (Municipality of Puerto Rico)": [
            {
                "Region Name": "Ponce (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ponce (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ponce (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ponce (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ponce (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ponce (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ponce (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ponce (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ponce (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ponce (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ponce (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ponce (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ponce (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ponce (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ponce (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ponce (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ponce (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ponce (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ponce (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ponce (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ponce (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ponce (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pool (Region of Republic of the Congo)": [
            {
                "Region Name": "Pool (Region of Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Pool (Region of Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Pool (Region of Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pool (Region of Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Pool (Region of Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pool (Region of Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pool (Region of Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pool (Region of Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pool (Region of Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pool (Region of Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pool (Region of Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pool (Region of Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pool (Region of Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pool (Region of Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pool (Region of Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pool (Region of Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pool (Region of Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pool (Region of Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pool (Region of Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pool (Region of Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pool (Region of Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pool (Region of Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Port Erin (Village District of Isle of Man)": [
            {
                "Region Name": "Port Erin (Village District of Isle of Man)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Erin (Village District of Isle of Man)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Erin (Village District of Isle of Man)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Erin (Village District of Isle of Man)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Erin (Village District of Isle of Man)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Erin (Village District of Isle of Man)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Erin (Village District of Isle of Man)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Erin (Village District of Isle of Man)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Erin (Village District of Isle of Man)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Erin (Village District of Isle of Man)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Erin (Village District of Isle of Man)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Erin (Village District of Isle of Man)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Erin (Village District of Isle of Man)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Erin (Village District of Isle of Man)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Erin (Village District of Isle of Man)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Erin (Village District of Isle of Man)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Erin (Village District of Isle of Man)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Erin (Village District of Isle of Man)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Erin (Village District of Isle of Man)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Erin (Village District of Isle of Man)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Erin (Village District of Isle of Man)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Erin (Village District of Isle of Man)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Port Glaud (District of Seychelles)": [
            {
                "Region Name": "Port Glaud (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Glaud (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Glaud (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Glaud (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Glaud (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Glaud (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Glaud (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Glaud (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Glaud (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Glaud (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Glaud (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Glaud (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Glaud (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Glaud (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Glaud (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Glaud (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Glaud (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Glaud (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Glaud (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Glaud (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Glaud (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Glaud (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Port Louis (District of Mauritius)": [
            {
                "Region Name": "Port Louis (District of Mauritius)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Louis (District of Mauritius)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Louis (District of Mauritius)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Louis (District of Mauritius)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Louis (District of Mauritius)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Louis (District of Mauritius)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Louis (District of Mauritius)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Louis (District of Mauritius)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Louis (District of Mauritius)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Louis (District of Mauritius)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Louis (District of Mauritius)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Louis (District of Mauritius)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Louis (District of Mauritius)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Louis (District of Mauritius)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Louis (District of Mauritius)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Louis (District of Mauritius)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Louis (District of Mauritius)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Louis (District of Mauritius)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Louis (District of Mauritius)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Louis (District of Mauritius)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Louis (District of Mauritius)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Louis (District of Mauritius)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Port of Spain (City of Trinidad and Tobago)": [
            {
                "Region Name": "Port of Spain (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port of Spain (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port of Spain (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port of Spain (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port of Spain (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port of Spain (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port of Spain (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port of Spain (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port of Spain (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port of Spain (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port of Spain (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port of Spain (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port of Spain (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port of Spain (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port of Spain (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port of Spain (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port of Spain (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port of Spain (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port of Spain (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port of Spain (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port of Spain (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port of Spain (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Port Saint Mary (Village District of Isle of Man)": [
            {
                "Region Name": "Port Saint Mary (Village District of Isle of Man)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Saint Mary (Village District of Isle of Man)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Saint Mary (Village District of Isle of Man)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Saint Mary (Village District of Isle of Man)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Saint Mary (Village District of Isle of Man)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Saint Mary (Village District of Isle of Man)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Saint Mary (Village District of Isle of Man)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Saint Mary (Village District of Isle of Man)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Saint Mary (Village District of Isle of Man)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Saint Mary (Village District of Isle of Man)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Saint Mary (Village District of Isle of Man)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Saint Mary (Village District of Isle of Man)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Saint Mary (Village District of Isle of Man)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Saint Mary (Village District of Isle of Man)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Saint Mary (Village District of Isle of Man)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Saint Mary (Village District of Isle of Man)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Saint Mary (Village District of Isle of Man)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Saint Mary (Village District of Isle of Man)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Saint Mary (Village District of Isle of Man)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Saint Mary (Village District of Isle of Man)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Saint Mary (Village District of Isle of Man)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Port Saint Mary (Village District of Isle of Man)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Portalegre (District of Portugal)": [
            {
                "Region Name": "Portalegre (District of Portugal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Portalegre (District of Portugal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 84
            },
            {
                "Region Name": "Portalegre (District of Portugal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Portalegre (District of Portugal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Portalegre (District of Portugal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Portalegre (District of Portugal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portalegre (District of Portugal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Portalegre (District of Portugal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Portalegre (District of Portugal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Portalegre (District of Portugal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portalegre (District of Portugal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Portalegre (District of Portugal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Portalegre (District of Portugal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Portalegre (District of Portugal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Portalegre (District of Portugal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Portalegre (District of Portugal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 97
            },
            {
                "Region Name": "Portalegre (District of Portugal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portalegre (District of Portugal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Portalegre (District of Portugal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Portalegre (District of Portugal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portalegre (District of Portugal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Portalegre (District of Portugal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Portland (Parish of Jamaica)": [
            {
                "Region Name": "Portland (Parish of Jamaica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portland (Parish of Jamaica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portland (Parish of Jamaica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portland (Parish of Jamaica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portland (Parish of Jamaica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portland (Parish of Jamaica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portland (Parish of Jamaica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portland (Parish of Jamaica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portland (Parish of Jamaica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portland (Parish of Jamaica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portland (Parish of Jamaica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portland (Parish of Jamaica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portland (Parish of Jamaica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portland (Parish of Jamaica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portland (Parish of Jamaica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portland (Parish of Jamaica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portland (Parish of Jamaica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portland (Parish of Jamaica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portland (Parish of Jamaica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portland (Parish of Jamaica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portland (Parish of Jamaica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Portland (Parish of Jamaica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Porto (District of Portugal)": [
            {
                "Region Name": "Porto (District of Portugal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Porto (District of Portugal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Porto (District of Portugal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Porto (District of Portugal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Porto (District of Portugal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Porto (District of Portugal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Porto (District of Portugal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Porto (District of Portugal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Porto (District of Portugal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Porto (District of Portugal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Porto (District of Portugal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Porto (District of Portugal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Porto (District of Portugal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Porto (District of Portugal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Porto (District of Portugal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Porto (District of Portugal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Porto (District of Portugal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Porto (District of Portugal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Porto (District of Portugal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Porto (District of Portugal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Porto (District of Portugal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Porto (District of Portugal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Porto Novo (County of Cabo Verde)": [
            {
                "Region Name": "Porto Novo (County of Cabo Verde)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Porto Novo (County of Cabo Verde)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Porto Novo (County of Cabo Verde)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Porto Novo (County of Cabo Verde)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Porto Novo (County of Cabo Verde)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Porto Novo (County of Cabo Verde)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Porto Novo (County of Cabo Verde)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Porto Novo (County of Cabo Verde)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Porto Novo (County of Cabo Verde)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Porto Novo (County of Cabo Verde)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Porto Novo (County of Cabo Verde)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Porto Novo (County of Cabo Verde)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Porto Novo (County of Cabo Verde)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Porto Novo (County of Cabo Verde)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Porto Novo (County of Cabo Verde)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Porto Novo (County of Cabo Verde)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Porto Novo (County of Cabo Verde)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Porto Novo (County of Cabo Verde)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Porto Novo (County of Cabo Verde)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Porto Novo (County of Cabo Verde)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Porto Novo (County of Cabo Verde)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Porto Novo (County of Cabo Verde)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Portuguesa (State of Venezuela)": [
            {
                "Region Name": "Portuguesa (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Portuguesa (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Portuguesa (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Portuguesa (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Portuguesa (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Portuguesa (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Portuguesa (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Portuguesa (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Portuguesa (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Portuguesa (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Portuguesa (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Portuguesa (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Portuguesa (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Portuguesa (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Portuguesa (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Portuguesa (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Portuguesa (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Portuguesa (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Portuguesa (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Portuguesa (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Portuguesa (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Portuguesa (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Potaro-Siparuni (Region of Guyana)": [
            {
                "Region Name": "Potaro-Siparuni (Region of Guyana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Potaro-Siparuni (Region of Guyana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Potaro-Siparuni (Region of Guyana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Potaro-Siparuni (Region of Guyana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Potaro-Siparuni (Region of Guyana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Potaro-Siparuni (Region of Guyana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Potaro-Siparuni (Region of Guyana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Potaro-Siparuni (Region of Guyana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Potaro-Siparuni (Region of Guyana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Potaro-Siparuni (Region of Guyana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Potaro-Siparuni (Region of Guyana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Potaro-Siparuni (Region of Guyana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Potaro-Siparuni (Region of Guyana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Potaro-Siparuni (Region of Guyana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Potaro-Siparuni (Region of Guyana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Potaro-Siparuni (Region of Guyana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Potaro-Siparuni (Region of Guyana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Potaro-Siparuni (Region of Guyana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Potaro-Siparuni (Region of Guyana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Potaro-Siparuni (Region of Guyana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Potaro-Siparuni (Region of Guyana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Potaro-Siparuni (Region of Guyana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Potos\xed (Department of Bolivia)": [
            {
                "Region Name": "Potos\xed (Department of Bolivia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Potos\xed (Department of Bolivia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Potos\xed (Department of Bolivia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Potos\xed (Department of Bolivia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Potos\xed (Department of Bolivia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Potos\xed (Department of Bolivia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Potos\xed (Department of Bolivia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Potos\xed (Department of Bolivia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Potos\xed (Department of Bolivia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Potos\xed (Department of Bolivia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Potos\xed (Department of Bolivia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Potos\xed (Department of Bolivia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Potos\xed (Department of Bolivia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Potos\xed (Department of Bolivia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Potos\xed (Department of Bolivia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Potos\xed (Department of Bolivia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Potos\xed (Department of Bolivia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Potos\xed (Department of Bolivia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Potos\xed (Department of Bolivia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Potos\xed (Department of Bolivia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Potos\xed (Department of Bolivia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Potos\xed (Department of Bolivia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Pouthisat (Province of Cambodia)": [
            {
                "Region Name": "Pouthisat (Province of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Pouthisat (Province of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pouthisat (Province of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Pouthisat (Province of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Pouthisat (Province of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Pouthisat (Province of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pouthisat (Province of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Pouthisat (Province of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pouthisat (Province of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Pouthisat (Province of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pouthisat (Province of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Pouthisat (Province of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Pouthisat (Province of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pouthisat (Province of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Pouthisat (Province of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Pouthisat (Province of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Pouthisat (Province of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pouthisat (Province of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pouthisat (Province of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Pouthisat (Province of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pouthisat (Province of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pouthisat (Province of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Po\u017Ee\u0161ko-Slavonska (County of Croatia)": [
            {
                "Region Name": "Po\u017Ee\u0161ko-Slavonska (County of Croatia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Po\u017Ee\u0161ko-Slavonska (County of Croatia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Po\u017Ee\u0161ko-Slavonska (County of Croatia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Po\u017Ee\u0161ko-Slavonska (County of Croatia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Po\u017Ee\u0161ko-Slavonska (County of Croatia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Po\u017Ee\u0161ko-Slavonska (County of Croatia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Po\u017Ee\u0161ko-Slavonska (County of Croatia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Po\u017Ee\u0161ko-Slavonska (County of Croatia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Po\u017Ee\u0161ko-Slavonska (County of Croatia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Po\u017Ee\u0161ko-Slavonska (County of Croatia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Po\u017Ee\u0161ko-Slavonska (County of Croatia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Po\u017Ee\u0161ko-Slavonska (County of Croatia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Po\u017Ee\u0161ko-Slavonska (County of Croatia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Po\u017Ee\u0161ko-Slavonska (County of Croatia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Po\u017Ee\u0161ko-Slavonska (County of Croatia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Po\u017Ee\u0161ko-Slavonska (County of Croatia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Po\u017Ee\u0161ko-Slavonska (County of Croatia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Po\u017Ee\u0161ko-Slavonska (County of Croatia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Po\u017Ee\u0161ko-Slavonska (County of Croatia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Po\u017Ee\u0161ko-Slavonska (County of Croatia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Po\u017Ee\u0161ko-Slavonska (County of Croatia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Po\u017Ee\u0161ko-Slavonska (County of Croatia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Prachin Buri (Province of Thailand)": [
            {
                "Region Name": "Prachin Buri (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Prachin Buri (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Prachin Buri (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Prachin Buri (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Prachin Buri (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Prachin Buri (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Prachin Buri (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Prachin Buri (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Prachin Buri (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Prachin Buri (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Prachin Buri (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Prachin Buri (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Prachin Buri (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Prachin Buri (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Prachin Buri (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Prachin Buri (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Prachin Buri (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Prachin Buri (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Prachin Buri (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Prachin Buri (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Prachin Buri (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Prachin Buri (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Prachuap Khiri Khan (Province of Thailand)": [
            {
                "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prachuap Khiri Khan (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Prague (Region of Czechia)": [
            {
                "Region Name": "Prague (Region of Czechia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prague (Region of Czechia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prague (Region of Czechia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prague (Region of Czechia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prague (Region of Czechia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prague (Region of Czechia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prague (Region of Czechia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prague (Region of Czechia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prague (Region of Czechia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prague (Region of Czechia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prague (Region of Czechia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prague (Region of Czechia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prague (Region of Czechia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prague (Region of Czechia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prague (Region of Czechia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prague (Region of Czechia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prague (Region of Czechia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prague (Region of Czechia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prague (Region of Czechia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prague (Region of Czechia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prague (Region of Czechia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prague (Region of Czechia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Prahova (County of Romania)": [
            {
                "Region Name": "Prahova (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prahova (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Prahova (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Prahova (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Prahova (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Prahova (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Prahova (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Prahova (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prahova (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Prahova (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Prahova (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Prahova (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prahova (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Prahova (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prahova (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Prahova (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Prahova (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Prahova (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Prahova (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Prahova (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Prahova (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Prahova (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Praia (County of Cabo Verde)": [
            {
                "Region Name": "Praia (County of Cabo Verde)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Praia (County of Cabo Verde)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Praia (County of Cabo Verde)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Praia (County of Cabo Verde)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Praia (County of Cabo Verde)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Praia (County of Cabo Verde)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Praia (County of Cabo Verde)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Praia (County of Cabo Verde)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Praia (County of Cabo Verde)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Praia (County of Cabo Verde)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Praia (County of Cabo Verde)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Praia (County of Cabo Verde)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Praia (County of Cabo Verde)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Praia (County of Cabo Verde)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Praia (County of Cabo Verde)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Praia (County of Cabo Verde)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Praia (County of Cabo Verde)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Praia (County of Cabo Verde)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Praia (County of Cabo Verde)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Praia (County of Cabo Verde)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Praia (County of Cabo Verde)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Praia (County of Cabo Verde)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Preah Vih\xe9ar (Province of Cambodia)": [
            {
                "Region Name": "Preah Vih\xe9ar (Province of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Preah Vih\xe9ar (Province of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Preah Vih\xe9ar (Province of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Preah Vih\xe9ar (Province of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Preah Vih\xe9ar (Province of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Preah Vih\xe9ar (Province of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Preah Vih\xe9ar (Province of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Preah Vih\xe9ar (Province of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Preah Vih\xe9ar (Province of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Preah Vih\xe9ar (Province of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Preah Vih\xe9ar (Province of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Preah Vih\xe9ar (Province of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Preah Vih\xe9ar (Province of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Preah Vih\xe9ar (Province of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Preah Vih\xe9ar (Province of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Preah Vih\xe9ar (Province of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Preah Vih\xe9ar (Province of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Preah Vih\xe9ar (Province of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Preah Vih\xe9ar (Province of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Preah Vih\xe9ar (Province of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Preah Vih\xe9ar (Province of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Preah Vih\xe9ar (Province of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Presidente Hayes (Department of Paraguay)": [
            {
                "Region Name": "Presidente Hayes (Department of Paraguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Presidente Hayes (Department of Paraguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Presidente Hayes (Department of Paraguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Presidente Hayes (Department of Paraguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Presidente Hayes (Department of Paraguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Presidente Hayes (Department of Paraguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Presidente Hayes (Department of Paraguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Presidente Hayes (Department of Paraguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Presidente Hayes (Department of Paraguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Presidente Hayes (Department of Paraguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Presidente Hayes (Department of Paraguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Presidente Hayes (Department of Paraguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Presidente Hayes (Department of Paraguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Presidente Hayes (Department of Paraguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Presidente Hayes (Department of Paraguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Presidente Hayes (Department of Paraguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Presidente Hayes (Department of Paraguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Presidente Hayes (Department of Paraguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Presidente Hayes (Department of Paraguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Presidente Hayes (Department of Paraguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Presidente Hayes (Department of Paraguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Presidente Hayes (Department of Paraguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Pre\u0161ovsk\xfd (Region of Slovakia)": [
            {
                "Region Name": "Pre\u0161ovsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pre\u0161ovsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pre\u0161ovsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pre\u0161ovsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pre\u0161ovsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pre\u0161ovsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pre\u0161ovsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pre\u0161ovsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pre\u0161ovsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pre\u0161ovsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pre\u0161ovsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pre\u0161ovsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pre\u0161ovsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pre\u0161ovsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pre\u0161ovsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pre\u0161ovsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pre\u0161ovsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pre\u0161ovsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pre\u0161ovsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pre\u0161ovsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pre\u0161ovsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pre\u0161ovsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Prey V\xe9ng (Province of Cambodia)": [
            {
                "Region Name": "Prey V\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Prey V\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Prey V\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Prey V\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Prey V\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Prey V\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Prey V\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Prey V\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Prey V\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Prey V\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Prey V\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Prey V\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Prey V\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Prey V\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Prey V\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Prey V\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Prey V\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Prey V\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Prey V\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Prey V\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Prey V\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Prey V\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Pricly Pear Cays (Island of Anguilla)": [
            {
                "Region Name": "Pricly Pear Cays (Island of Anguilla)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pricly Pear Cays (Island of Anguilla)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pricly Pear Cays (Island of Anguilla)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pricly Pear Cays (Island of Anguilla)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pricly Pear Cays (Island of Anguilla)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pricly Pear Cays (Island of Anguilla)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pricly Pear Cays (Island of Anguilla)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pricly Pear Cays (Island of Anguilla)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pricly Pear Cays (Island of Anguilla)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pricly Pear Cays (Island of Anguilla)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pricly Pear Cays (Island of Anguilla)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pricly Pear Cays (Island of Anguilla)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pricly Pear Cays (Island of Anguilla)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pricly Pear Cays (Island of Anguilla)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pricly Pear Cays (Island of Anguilla)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pricly Pear Cays (Island of Anguilla)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pricly Pear Cays (Island of Anguilla)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pricly Pear Cays (Island of Anguilla)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pricly Pear Cays (Island of Anguilla)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pricly Pear Cays (Island of Anguilla)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pricly Pear Cays (Island of Anguilla)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pricly Pear Cays (Island of Anguilla)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Prilep (Municipality of North Macedonia)": [
            {
                "Region Name": "Prilep (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prilep (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Prilep (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Prilep (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prilep (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prilep (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Prilep (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Prilep (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prilep (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Prilep (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Prilep (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Prilep (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Prilep (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prilep (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prilep (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prilep (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Prilep (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prilep (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Prilep (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prilep (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Prilep (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prilep (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Primor'ye (Territory of Russia)": [
            {
                "Region Name": "Primor'ye (Territory of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Primor'ye (Territory of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Primor'ye (Territory of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Primor'ye (Territory of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Primor'ye (Territory of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Primor'ye (Territory of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Primor'ye (Territory of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Primor'ye (Territory of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Primor'ye (Territory of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Primor'ye (Territory of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Primor'ye (Territory of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Primor'ye (Territory of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Primor'ye (Territory of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Primor'ye (Territory of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Primor'ye (Territory of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Primor'ye (Territory of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Primor'ye (Territory of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Primor'ye (Territory of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Primor'ye (Territory of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Primor'ye (Territory of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Primor'ye (Territory of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Primor'ye (Territory of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Primorsko-Goranska (County of Croatia)": [
            {
                "Region Name": "Primorsko-Goranska (County of Croatia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Primorsko-Goranska (County of Croatia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Primorsko-Goranska (County of Croatia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Primorsko-Goranska (County of Croatia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Primorsko-Goranska (County of Croatia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Primorsko-Goranska (County of Croatia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Primorsko-Goranska (County of Croatia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Primorsko-Goranska (County of Croatia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Primorsko-Goranska (County of Croatia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Primorsko-Goranska (County of Croatia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Primorsko-Goranska (County of Croatia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Primorsko-Goranska (County of Croatia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Primorsko-Goranska (County of Croatia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Primorsko-Goranska (County of Croatia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Primorsko-Goranska (County of Croatia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Primorsko-Goranska (County of Croatia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Primorsko-Goranska (County of Croatia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Primorsko-Goranska (County of Croatia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Primorsko-Goranska (County of Croatia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Primorsko-Goranska (County of Croatia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Primorsko-Goranska (County of Croatia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Primorsko-Goranska (County of Croatia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Prince Edward Island (Province of Canada)": [
            {
                "Region Name": "Prince Edward Island (Province of Canada)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prince Edward Island (Province of Canada)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prince Edward Island (Province of Canada)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prince Edward Island (Province of Canada)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prince Edward Island (Province of Canada)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prince Edward Island (Province of Canada)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prince Edward Island (Province of Canada)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prince Edward Island (Province of Canada)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prince Edward Island (Province of Canada)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prince Edward Island (Province of Canada)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prince Edward Island (Province of Canada)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prince Edward Island (Province of Canada)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prince Edward Island (Province of Canada)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prince Edward Island (Province of Canada)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prince Edward Island (Province of Canada)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prince Edward Island (Province of Canada)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prince Edward Island (Province of Canada)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prince Edward Island (Province of Canada)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prince Edward Island (Province of Canada)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prince Edward Island (Province of Canada)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prince Edward Island (Province of Canada)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prince Edward Island (Province of Canada)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Princes Town (Region of Trinidad and Tobago)": [
            {
                "Region Name": "Princes Town (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Princes Town (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Princes Town (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Princes Town (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Princes Town (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Princes Town (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Princes Town (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Princes Town (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Princes Town (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Princes Town (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Princes Town (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Princes Town (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Princes Town (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Princes Town (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Princes Town (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Princes Town (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Princes Town (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Princes Town (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Princes Town (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Princes Town (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Princes Town (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Princes Town (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Principado de Asturias (Autonomous Community of Spain)": [
            {
                "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Principado de Asturias (Autonomous Community of Spain)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Pr\xedncipe (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)": [
            {
                "Region Name": "Pr\xedncipe (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pr\xedncipe (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pr\xedncipe (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pr\xedncipe (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pr\xedncipe (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pr\xedncipe (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pr\xedncipe (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pr\xedncipe (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pr\xedncipe (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pr\xedncipe (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pr\xedncipe (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pr\xedncipe (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pr\xedncipe (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pr\xedncipe (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pr\xedncipe (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pr\xedncipe (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pr\xedncipe (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pr\xedncipe (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pr\xedncipe (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pr\xedncipe (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pr\xedncipe (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pr\xedncipe (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pristina (District of Kosovo)": [
            {
                "Region Name": "Pristina (District of Kosovo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pristina (District of Kosovo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pristina (District of Kosovo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pristina (District of Kosovo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pristina (District of Kosovo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pristina (District of Kosovo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pristina (District of Kosovo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pristina (District of Kosovo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pristina (District of Kosovo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pristina (District of Kosovo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pristina (District of Kosovo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pristina (District of Kosovo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pristina (District of Kosovo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pristina (District of Kosovo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pristina (District of Kosovo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pristina (District of Kosovo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pristina (District of Kosovo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pristina (District of Kosovo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pristina (District of Kosovo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Pristina (District of Kosovo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pristina (District of Kosovo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pristina (District of Kosovo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Prizren (District of Kosovo)": [
            {
                "Region Name": "Prizren (District of Kosovo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prizren (District of Kosovo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Prizren (District of Kosovo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prizren (District of Kosovo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Prizren (District of Kosovo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prizren (District of Kosovo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Prizren (District of Kosovo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prizren (District of Kosovo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prizren (District of Kosovo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Prizren (District of Kosovo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Prizren (District of Kosovo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Prizren (District of Kosovo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prizren (District of Kosovo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prizren (District of Kosovo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Prizren (District of Kosovo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prizren (District of Kosovo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prizren (District of Kosovo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Prizren (District of Kosovo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Prizren (District of Kosovo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Prizren (District of Kosovo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Prizren (District of Kosovo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Prizren (District of Kosovo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Probi\u0161tip (Municipality of North Macedonia)": [
            {
                "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Probi\u0161tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Provence-Alpes-C\xf4te d'Azur (Region of France)": [
            {
                "Region Name": "Provence-Alpes-C\xf4te d'Azur (Region of France)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Provence-Alpes-C\xf4te d'Azur (Region of France)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Provence-Alpes-C\xf4te d'Azur (Region of France)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Provence-Alpes-C\xf4te d'Azur (Region of France)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Provence-Alpes-C\xf4te d'Azur (Region of France)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Provence-Alpes-C\xf4te d'Azur (Region of France)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Provence-Alpes-C\xf4te d'Azur (Region of France)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Provence-Alpes-C\xf4te d'Azur (Region of France)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Provence-Alpes-C\xf4te d'Azur (Region of France)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Provence-Alpes-C\xf4te d'Azur (Region of France)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Provence-Alpes-C\xf4te d'Azur (Region of France)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Provence-Alpes-C\xf4te d'Azur (Region of France)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Provence-Alpes-C\xf4te d'Azur (Region of France)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Provence-Alpes-C\xf4te d'Azur (Region of France)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Provence-Alpes-C\xf4te d'Azur (Region of France)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Provence-Alpes-C\xf4te d'Azur (Region of France)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Provence-Alpes-C\xf4te d'Azur (Region of France)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Provence-Alpes-C\xf4te d'Azur (Region of France)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Provence-Alpes-C\xf4te d'Azur (Region of France)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Provence-Alpes-C\xf4te d'Azur (Region of France)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 76
            },
            {
                "Region Name": "Provence-Alpes-C\xf4te d'Azur (Region of France)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Provence-Alpes-C\xf4te d'Azur (Region of France)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Providenciales and West Caicos (District of Turks and Caicos Islands)": [
            {
                "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Providenciales and West Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pskov (Region of Russia)": [
            {
                "Region Name": "Pskov (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Pskov (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pskov (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pskov (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pskov (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pskov (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pskov (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pskov (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pskov (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pskov (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pskov (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pskov (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Pskov (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Pskov (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pskov (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Pskov (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Pskov (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Pskov (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pskov (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Pskov (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Pskov (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pskov (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Puducherry (Union Territory of India)": [
            {
                "Region Name": "Puducherry (Union Territory of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puducherry (Union Territory of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puducherry (Union Territory of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puducherry (Union Territory of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puducherry (Union Territory of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puducherry (Union Territory of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puducherry (Union Territory of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puducherry (Union Territory of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puducherry (Union Territory of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puducherry (Union Territory of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puducherry (Union Territory of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puducherry (Union Territory of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puducherry (Union Territory of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puducherry (Union Territory of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puducherry (Union Territory of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puducherry (Union Territory of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puducherry (Union Territory of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puducherry (Union Territory of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puducherry (Union Territory of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puducherry (Union Territory of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puducherry (Union Territory of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puducherry (Union Territory of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Puebla (State of M\xe9xico)": [
            {
                "Region Name": "Puebla (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Puebla (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Puebla (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Puebla (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Puebla (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Puebla (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Puebla (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Puebla (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Puebla (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Puebla (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Puebla (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Puebla (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Puebla (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Puebla (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Puebla (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Puebla (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Puebla (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Puebla (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Puebla (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Puebla (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Puebla (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Puebla (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Puerto Plata (Province of Dominican Republic)": [
            {
                "Region Name": "Puerto Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puerto Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Puerto Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puerto Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puerto Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puerto Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puerto Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puerto Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Puerto Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Puerto Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Puerto Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Puerto Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puerto Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Puerto Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Puerto Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puerto Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puerto Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puerto Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puerto Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puerto Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puerto Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puerto Plata (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pukapuka (Island Council of Cook Islands)": [
            {
                "Region Name": "Pukapuka (Island Council of Cook Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pukapuka (Island Council of Cook Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pukapuka (Island Council of Cook Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pukapuka (Island Council of Cook Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pukapuka (Island Council of Cook Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pukapuka (Island Council of Cook Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pukapuka (Island Council of Cook Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pukapuka (Island Council of Cook Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pukapuka (Island Council of Cook Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pukapuka (Island Council of Cook Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pukapuka (Island Council of Cook Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pukapuka (Island Council of Cook Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pukapuka (Island Council of Cook Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pukapuka (Island Council of Cook Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pukapuka (Island Council of Cook Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pukapuka (Island Council of Cook Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pukapuka (Island Council of Cook Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pukapuka (Island Council of Cook Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pukapuka (Island Council of Cook Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pukapuka (Island Council of Cook Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pukapuka (Island Council of Cook Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pukapuka (Island Council of Cook Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Pulau Pinang (State of Malaysia)": [
            {
                "Region Name": "Pulau Pinang (State of Malaysia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Pulau Pinang (State of Malaysia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pulau Pinang (State of Malaysia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pulau Pinang (State of Malaysia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pulau Pinang (State of Malaysia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pulau Pinang (State of Malaysia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pulau Pinang (State of Malaysia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pulau Pinang (State of Malaysia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pulau Pinang (State of Malaysia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pulau Pinang (State of Malaysia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pulau Pinang (State of Malaysia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pulau Pinang (State of Malaysia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Pulau Pinang (State of Malaysia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pulau Pinang (State of Malaysia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pulau Pinang (State of Malaysia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pulau Pinang (State of Malaysia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pulau Pinang (State of Malaysia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pulau Pinang (State of Malaysia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pulau Pinang (State of Malaysia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pulau Pinang (State of Malaysia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pulau Pinang (State of Malaysia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Pulau Pinang (State of Malaysia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Punakha (District of Bhutan)": [
            {
                "Region Name": "Punakha (District of Bhutan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Punakha (District of Bhutan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Punakha (District of Bhutan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Punakha (District of Bhutan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Punakha (District of Bhutan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Punakha (District of Bhutan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Punakha (District of Bhutan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Punakha (District of Bhutan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Punakha (District of Bhutan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Punakha (District of Bhutan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Punakha (District of Bhutan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Punakha (District of Bhutan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Punakha (District of Bhutan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Punakha (District of Bhutan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Punakha (District of Bhutan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Punakha (District of Bhutan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Punakha (District of Bhutan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Punakha (District of Bhutan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Punakha (District of Bhutan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Punakha (District of Bhutan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Punakha (District of Bhutan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Punakha (District of Bhutan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Punjab (Province of Pakistan)": [
            {
                "Region Name": "Punjab (Province of Pakistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Punjab (Province of Pakistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Punjab (Province of Pakistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Punjab (Province of Pakistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Punjab (Province of Pakistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Punjab (Province of Pakistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Punjab (Province of Pakistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Punjab (Province of Pakistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Punjab (Province of Pakistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Punjab (Province of Pakistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Punjab (Province of Pakistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Punjab (Province of Pakistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Punjab (Province of Pakistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Punjab (Province of Pakistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Punjab (Province of Pakistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Punjab (Province of Pakistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Punjab (Province of Pakistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Punjab (Province of Pakistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Punjab (Province of Pakistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Punjab (Province of Pakistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Punjab (Province of Pakistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Punjab (Province of Pakistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Punjab (State of India)": [
            {
                "Region Name": "Punjab (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Punjab (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Punjab (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Punjab (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Punjab (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Punjab (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Punjab (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Punjab (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Punjab (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Punjab (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Punjab (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Punjab (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Punjab (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Punjab (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Punjab (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Punjab (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Punjab (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Punjab (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Punjab (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Punjab (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Punjab (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Punjab (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Puno (Region of Peru)": [
            {
                "Region Name": "Puno (Region of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Puno (Region of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Puno (Region of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Puno (Region of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Puno (Region of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Puno (Region of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Puno (Region of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Puno (Region of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Puno (Region of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Puno (Region of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Puno (Region of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Puno (Region of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Puno (Region of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Puno (Region of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Puno (Region of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Puno (Region of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Puno (Region of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Puno (Region of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Puno (Region of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Puno (Region of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Puno (Region of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Puno (Region of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Puntarenas (Province of Costa Rica)": [
            {
                "Region Name": "Puntarenas (Province of Costa Rica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Puntarenas (Province of Costa Rica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Puntarenas (Province of Costa Rica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Puntarenas (Province of Costa Rica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puntarenas (Province of Costa Rica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Puntarenas (Province of Costa Rica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Puntarenas (Province of Costa Rica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Puntarenas (Province of Costa Rica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Puntarenas (Province of Costa Rica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Puntarenas (Province of Costa Rica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Puntarenas (Province of Costa Rica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Puntarenas (Province of Costa Rica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Puntarenas (Province of Costa Rica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Puntarenas (Province of Costa Rica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Puntarenas (Province of Costa Rica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Puntarenas (Province of Costa Rica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Puntarenas (Province of Costa Rica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Puntarenas (Province of Costa Rica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Puntarenas (Province of Costa Rica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Puntarenas (Province of Costa Rica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Puntarenas (Province of Costa Rica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Puntarenas (Province of Costa Rica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Putrajaya (Federal Territory of Malaysia)": [
            {
                "Region Name": "Putrajaya (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Putrajaya (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Putrajaya (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Putrajaya (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Putrajaya (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Putrajaya (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Putrajaya (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Putrajaya (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Putrajaya (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Putrajaya (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Putrajaya (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Putrajaya (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Putrajaya (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Putrajaya (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Putrajaya (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Putrajaya (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Putrajaya (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Putrajaya (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Putrajaya (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Putrajaya (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Putrajaya (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Putrajaya (Federal Territory of Malaysia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Puttalam (District of Sri Lanka)": [
            {
                "Region Name": "Puttalam (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Puttalam (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Puttalam (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Puttalam (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Puttalam (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puttalam (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puttalam (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puttalam (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puttalam (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Puttalam (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puttalam (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Puttalam (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Puttalam (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Puttalam (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puttalam (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puttalam (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puttalam (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Puttalam (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puttalam (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puttalam (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puttalam (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Puttalam (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Putumayo (Intendancy of Colombia)": [
            {
                "Region Name": "Putumayo (Intendancy of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Putumayo (Intendancy of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Putumayo (Intendancy of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Putumayo (Intendancy of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Putumayo (Intendancy of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Putumayo (Intendancy of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Putumayo (Intendancy of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Putumayo (Intendancy of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Putumayo (Intendancy of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Putumayo (Intendancy of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Putumayo (Intendancy of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Putumayo (Intendancy of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Putumayo (Intendancy of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Putumayo (Intendancy of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Putumayo (Intendancy of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Putumayo (Intendancy of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Putumayo (Intendancy of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Putumayo (Intendancy of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Putumayo (Intendancy of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Putumayo (Intendancy of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Putumayo (Intendancy of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Putumayo (Intendancy of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Pwani (Region of Tanzania)": [
            {
                "Region Name": "Pwani (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pwani (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pwani (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pwani (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pwani (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pwani (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pwani (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pwani (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pwani (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Pwani (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pwani (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pwani (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pwani (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pwani (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Pwani (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pwani (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Pwani (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pwani (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Pwani (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Pwani (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Pwani (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Pwani (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Qaasuitsup (Commune of Greenland)": [
            {
                "Region Name": "Qaasuitsup (Commune of Greenland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qaasuitsup (Commune of Greenland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qaasuitsup (Commune of Greenland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qaasuitsup (Commune of Greenland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qaasuitsup (Commune of Greenland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qaasuitsup (Commune of Greenland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qaasuitsup (Commune of Greenland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qaasuitsup (Commune of Greenland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qaasuitsup (Commune of Greenland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qaasuitsup (Commune of Greenland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qaasuitsup (Commune of Greenland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qaasuitsup (Commune of Greenland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qaasuitsup (Commune of Greenland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qaasuitsup (Commune of Greenland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qaasuitsup (Commune of Greenland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qaasuitsup (Commune of Greenland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Qaasuitsup (Commune of Greenland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qaasuitsup (Commune of Greenland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qaasuitsup (Commune of Greenland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qaasuitsup (Commune of Greenland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qaasuitsup (Commune of Greenland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qaasuitsup (Commune of Greenland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Qacha's Nek (District of Lesotho)": [
            {
                "Region Name": "Qacha's Nek (District of Lesotho)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Qacha's Nek (District of Lesotho)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Qacha's Nek (District of Lesotho)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Qacha's Nek (District of Lesotho)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Qacha's Nek (District of Lesotho)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Qacha's Nek (District of Lesotho)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Qacha's Nek (District of Lesotho)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Qacha's Nek (District of Lesotho)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Qacha's Nek (District of Lesotho)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Qacha's Nek (District of Lesotho)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Qacha's Nek (District of Lesotho)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Qacha's Nek (District of Lesotho)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Qacha's Nek (District of Lesotho)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Qacha's Nek (District of Lesotho)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Qacha's Nek (District of Lesotho)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Qacha's Nek (District of Lesotho)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Qacha's Nek (District of Lesotho)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Qacha's Nek (District of Lesotho)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Qacha's Nek (District of Lesotho)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Qacha's Nek (District of Lesotho)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Qacha's Nek (District of Lesotho)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Qacha's Nek (District of Lesotho)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Qaraghandy (Region of Kazakhstan)": [
            {
                "Region Name": "Qaraghandy (Region of Kazakhstan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 158
            },
            {
                "Region Name": "Qaraghandy (Region of Kazakhstan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 65
            },
            {
                "Region Name": "Qaraghandy (Region of Kazakhstan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 88
            },
            {
                "Region Name": "Qaraghandy (Region of Kazakhstan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 177
            },
            {
                "Region Name": "Qaraghandy (Region of Kazakhstan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 82
            },
            {
                "Region Name": "Qaraghandy (Region of Kazakhstan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 63
            },
            {
                "Region Name": "Qaraghandy (Region of Kazakhstan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Qaraghandy (Region of Kazakhstan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Qaraghandy (Region of Kazakhstan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 94
            },
            {
                "Region Name": "Qaraghandy (Region of Kazakhstan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Qaraghandy (Region of Kazakhstan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Qaraghandy (Region of Kazakhstan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Qaraghandy (Region of Kazakhstan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 84
            },
            {
                "Region Name": "Qaraghandy (Region of Kazakhstan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 105
            },
            {
                "Region Name": "Qaraghandy (Region of Kazakhstan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 90
            },
            {
                "Region Name": "Qaraghandy (Region of Kazakhstan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 165
            },
            {
                "Region Name": "Qaraghandy (Region of Kazakhstan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Qaraghandy (Region of Kazakhstan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 142
            },
            {
                "Region Name": "Qaraghandy (Region of Kazakhstan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Qaraghandy (Region of Kazakhstan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "Qaraghandy (Region of Kazakhstan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Qaraghandy (Region of Kazakhstan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 37
            }
        ],
        "Qaraqalpaqstan (Autononous Region of Uzbekistan)": [
            {
                "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Qaraqalpaqstan (Autononous Region of Uzbekistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Qashqadaryo (Region of Uzbekistan)": [
            {
                "Region Name": "Qashqadaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qashqadaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Qashqadaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qashqadaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Qashqadaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qashqadaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Qashqadaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qashqadaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qashqadaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qashqadaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qashqadaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qashqadaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Qashqadaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Qashqadaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Qashqadaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qashqadaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qashqadaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qashqadaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qashqadaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qashqadaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qashqadaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qashqadaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Qazvin (Province of Iran)": [
            {
                "Region Name": "Qazvin (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qazvin (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qazvin (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qazvin (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qazvin (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qazvin (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qazvin (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qazvin (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qazvin (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qazvin (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Qazvin (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Qazvin (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qazvin (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qazvin (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qazvin (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Qazvin (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Qazvin (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Qazvin (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qazvin (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qazvin (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qazvin (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qazvin (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Qeqqata (Commune of Greenland)": [
            {
                "Region Name": "Qeqqata (Commune of Greenland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qeqqata (Commune of Greenland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qeqqata (Commune of Greenland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qeqqata (Commune of Greenland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qeqqata (Commune of Greenland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qeqqata (Commune of Greenland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qeqqata (Commune of Greenland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qeqqata (Commune of Greenland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qeqqata (Commune of Greenland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qeqqata (Commune of Greenland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qeqqata (Commune of Greenland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qeqqata (Commune of Greenland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qeqqata (Commune of Greenland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qeqqata (Commune of Greenland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qeqqata (Commune of Greenland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qeqqata (Commune of Greenland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qeqqata (Commune of Greenland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qeqqata (Commune of Greenland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qeqqata (Commune of Greenland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qeqqata (Commune of Greenland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qeqqata (Commune of Greenland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qeqqata (Commune of Greenland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Qina (Governorate of Egypt)": [
            {
                "Region Name": "Qina (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qina (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qina (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qina (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qina (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qina (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qina (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qina (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qina (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qina (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qina (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qina (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qina (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qina (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qina (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qina (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qina (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qina (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qina (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qina (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qina (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qina (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Qinghai (Province of China)": [
            {
                "Region Name": "Qinghai (Province of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qinghai (Province of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Qinghai (Province of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qinghai (Province of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Qinghai (Province of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qinghai (Province of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Qinghai (Province of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qinghai (Province of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Qinghai (Province of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qinghai (Province of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qinghai (Province of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Qinghai (Province of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qinghai (Province of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Qinghai (Province of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Qinghai (Province of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Qinghai (Province of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qinghai (Province of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qinghai (Province of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qinghai (Province of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Qinghai (Province of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qinghai (Province of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qinghai (Province of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Qom (Province of Iran)": [
            {
                "Region Name": "Qom (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qom (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qom (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qom (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Qom (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qom (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qom (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qom (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Qom (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qom (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qom (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qom (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qom (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qom (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qom (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qom (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qom (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qom (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qom (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qom (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qom (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qom (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Qostanay (Region of Kazakhstan)": [
            {
                "Region Name": "Qostanay (Region of Kazakhstan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 95
            },
            {
                "Region Name": "Qostanay (Region of Kazakhstan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Qostanay (Region of Kazakhstan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Qostanay (Region of Kazakhstan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Qostanay (Region of Kazakhstan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Qostanay (Region of Kazakhstan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Qostanay (Region of Kazakhstan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Qostanay (Region of Kazakhstan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Qostanay (Region of Kazakhstan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 66
            },
            {
                "Region Name": "Qostanay (Region of Kazakhstan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Qostanay (Region of Kazakhstan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Qostanay (Region of Kazakhstan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Qostanay (Region of Kazakhstan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "Qostanay (Region of Kazakhstan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Qostanay (Region of Kazakhstan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Qostanay (Region of Kazakhstan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Qostanay (Region of Kazakhstan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Qostanay (Region of Kazakhstan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Qostanay (Region of Kazakhstan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Qostanay (Region of Kazakhstan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 81
            },
            {
                "Region Name": "Qostanay (Region of Kazakhstan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Qostanay (Region of Kazakhstan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Qu\u1EA3ng B\xecnh (Province of Vietnam)": [
            {
                "Region Name": "Qu\u1EA3ng B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qu\u1EA3ng B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qu\u1EA3ng B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qu\u1EA3ng B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qu\u1EA3ng B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Qu\u1EA3ng B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Qu\u1EA3ng B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qu\u1EA3ng B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Qu\u1EA3ng Nam (Province of Vietnam)": [
            {
                "Region Name": "Qu\u1EA3ng Nam (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Qu\u1EA3ng Nam (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Nam (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qu\u1EA3ng Nam (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Nam (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Nam (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Nam (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Nam (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Nam (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Nam (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qu\u1EA3ng Nam (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Nam (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Nam (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Nam (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Nam (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Nam (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qu\u1EA3ng Nam (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qu\u1EA3ng Nam (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Nam (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qu\u1EA3ng Nam (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Nam (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Nam (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Qu\u1EA3ng Ng\xe3i (Province of Vietnam)": [
            {
                "Region Name": "Qu\u1EA3ng Ng\xe3i (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Qu\u1EA3ng Ng\xe3i (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Ng\xe3i (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Ng\xe3i (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Qu\u1EA3ng Ng\xe3i (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Ng\xe3i (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qu\u1EA3ng Ng\xe3i (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Ng\xe3i (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qu\u1EA3ng Ng\xe3i (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Ng\xe3i (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Ng\xe3i (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Ng\xe3i (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Ng\xe3i (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Ng\xe3i (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Ng\xe3i (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Ng\xe3i (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Ng\xe3i (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qu\u1EA3ng Ng\xe3i (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Ng\xe3i (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Ng\xe3i (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qu\u1EA3ng Ng\xe3i (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Ng\xe3i (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Qu\u1EA3ng Ninh (Province of Vietnam)": [
            {
                "Region Name": "Qu\u1EA3ng Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qu\u1EA3ng Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Qu\u1EA3ng Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qu\u1EA3ng Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qu\u1EA3ng Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qu\u1EA3ng Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qu\u1EA3ng Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qu\u1EA3ng Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Qu\u1EA3ng Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qu\u1EA3ng Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Qu\u1EA3ng Tr\u1ECB (Province of Vietnam)": [
            {
                "Region Name": "Qu\u1EA3ng Tr\u1ECB (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Qu\u1EA3ng Tr\u1ECB (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qu\u1EA3ng Tr\u1ECB (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qu\u1EA3ng Tr\u1ECB (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Qu\u1EA3ng Tr\u1ECB (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Tr\u1ECB (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Tr\u1ECB (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Tr\u1ECB (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Tr\u1ECB (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qu\u1EA3ng Tr\u1ECB (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Tr\u1ECB (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Tr\u1ECB (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qu\u1EA3ng Tr\u1ECB (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Tr\u1ECB (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Qu\u1EA3ng Tr\u1ECB (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qu\u1EA3ng Tr\u1ECB (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Qu\u1EA3ng Tr\u1ECB (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Qu\u1EA3ng Tr\u1ECB (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Tr\u1ECB (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qu\u1EA3ng Tr\u1ECB (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Tr\u1ECB (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Qu\u1EA3ng Tr\u1ECB (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Quba-Khachmaz (Region of Azerbaijan)": [
            {
                "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Quba-Khachmaz (Region of Azerbaijan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Qu\xe9bec (Province of Canada)": [
            {
                "Region Name": "Qu\xe9bec (Province of Canada)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 144
            },
            {
                "Region Name": "Qu\xe9bec (Province of Canada)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Qu\xe9bec (Province of Canada)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qu\xe9bec (Province of Canada)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 79
            },
            {
                "Region Name": "Qu\xe9bec (Province of Canada)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Qu\xe9bec (Province of Canada)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 97
            },
            {
                "Region Name": "Qu\xe9bec (Province of Canada)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Qu\xe9bec (Province of Canada)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Qu\xe9bec (Province of Canada)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 158
            },
            {
                "Region Name": "Qu\xe9bec (Province of Canada)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Qu\xe9bec (Province of Canada)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Qu\xe9bec (Province of Canada)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 284
            },
            {
                "Region Name": "Qu\xe9bec (Province of Canada)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Qu\xe9bec (Province of Canada)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Qu\xe9bec (Province of Canada)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Qu\xe9bec (Province of Canada)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Qu\xe9bec (Province of Canada)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Qu\xe9bec (Province of Canada)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Qu\xe9bec (Province of Canada)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 76
            },
            {
                "Region Name": "Qu\xe9bec (Province of Canada)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Qu\xe9bec (Province of Canada)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Qu\xe9bec (Province of Canada)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 219
            }
        ],
        "Quebradillas (Municipality of Puerto Rico)": [
            {
                "Region Name": "Quebradillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quebradillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quebradillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quebradillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quebradillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quebradillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quebradillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quebradillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quebradillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quebradillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quebradillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quebradillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quebradillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quebradillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quebradillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quebradillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quebradillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quebradillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quebradillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quebradillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quebradillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quebradillas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Queensland (State of Australia)": [
            {
                "Region Name": "Queensland (State of Australia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 64
            },
            {
                "Region Name": "Queensland (State of Australia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Queensland (State of Australia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Queensland (State of Australia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Queensland (State of Australia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "Queensland (State of Australia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Queensland (State of Australia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Queensland (State of Australia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "Queensland (State of Australia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Queensland (State of Australia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Queensland (State of Australia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Queensland (State of Australia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Queensland (State of Australia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Queensland (State of Australia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Queensland (State of Australia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Queensland (State of Australia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Queensland (State of Australia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Queensland (State of Australia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Queensland (State of Australia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Queensland (State of Australia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Queensland (State of Australia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Queensland (State of Australia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 39
            }
        ],
        "Quer\xe9taro (State of M\xe9xico)": [
            {
                "Region Name": "Quer\xe9taro (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quer\xe9taro (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Quer\xe9taro (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quer\xe9taro (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quer\xe9taro (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quer\xe9taro (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quer\xe9taro (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Quer\xe9taro (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quer\xe9taro (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Quer\xe9taro (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Quer\xe9taro (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Quer\xe9taro (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quer\xe9taro (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Quer\xe9taro (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quer\xe9taro (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Quer\xe9taro (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Quer\xe9taro (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quer\xe9taro (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Quer\xe9taro (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quer\xe9taro (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Quer\xe9taro (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quer\xe9taro (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Quezaltenango (Department of Guatemala)": [
            {
                "Region Name": "Quezaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quezaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quezaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quezaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quezaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezaltenango (Department of Guatemala)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Quezon (Province of Philippines)": [
            {
                "Region Name": "Quezon (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quezon (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezon (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quezon (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quezon (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quezon (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezon (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezon (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quezon (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quezon (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezon (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezon (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quezon (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quezon (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezon (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezon (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezon (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezon (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quezon (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezon (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezon (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quezon (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Quich\xe9 (Department of Guatemala)": [
            {
                "Region Name": "Quich\xe9 (Department of Guatemala)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Quich\xe9 (Department of Guatemala)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quich\xe9 (Department of Guatemala)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quich\xe9 (Department of Guatemala)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quich\xe9 (Department of Guatemala)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Quich\xe9 (Department of Guatemala)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Quich\xe9 (Department of Guatemala)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Quich\xe9 (Department of Guatemala)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quich\xe9 (Department of Guatemala)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Quich\xe9 (Department of Guatemala)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quich\xe9 (Department of Guatemala)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quich\xe9 (Department of Guatemala)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quich\xe9 (Department of Guatemala)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quich\xe9 (Department of Guatemala)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Quich\xe9 (Department of Guatemala)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Quich\xe9 (Department of Guatemala)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Quich\xe9 (Department of Guatemala)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quich\xe9 (Department of Guatemala)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Quich\xe9 (Department of Guatemala)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Quich\xe9 (Department of Guatemala)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quich\xe9 (Department of Guatemala)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Quich\xe9 (Department of Guatemala)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Quinara (Region of Guinea-Bissau)": [
            {
                "Region Name": "Quinara (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Quinara (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Quinara (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Quinara (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Quinara (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Quinara (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Quinara (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Quinara (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Quinara (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Quinara (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Quinara (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Quinara (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Quinara (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Quinara (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Quinara (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Quinara (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Quinara (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Quinara (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Quinara (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Quinara (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Quinara (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Quinara (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Quind\xedo (Department of Colombia)": [
            {
                "Region Name": "Quind\xedo (Department of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quind\xedo (Department of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quind\xedo (Department of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quind\xedo (Department of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quind\xedo (Department of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quind\xedo (Department of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quind\xedo (Department of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quind\xedo (Department of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Quind\xedo (Department of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quind\xedo (Department of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quind\xedo (Department of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quind\xedo (Department of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quind\xedo (Department of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quind\xedo (Department of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quind\xedo (Department of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quind\xedo (Department of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quind\xedo (Department of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quind\xedo (Department of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quind\xedo (Department of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quind\xedo (Department of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quind\xedo (Department of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quind\xedo (Department of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Quintana Roo (State of M\xe9xico)": [
            {
                "Region Name": "Quintana Roo (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Quintana Roo (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Quintana Roo (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Quintana Roo (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Quintana Roo (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "Quintana Roo (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Quintana Roo (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Quintana Roo (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Quintana Roo (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Quintana Roo (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Quintana Roo (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quintana Roo (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Quintana Roo (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quintana Roo (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Quintana Roo (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Quintana Roo (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Quintana Roo (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Quintana Roo (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Quintana Roo (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Quintana Roo (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quintana Roo (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Quintana Roo (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Quirino (Province of Philippines)": [
            {
                "Region Name": "Quirino (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Quirino (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quirino (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quirino (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quirino (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Quirino (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quirino (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quirino (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quirino (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quirino (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quirino (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quirino (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quirino (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quirino (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quirino (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quirino (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quirino (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quirino (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quirino (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quirino (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quirino (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quirino (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Quneitra (Governorate of Syria)": [
            {
                "Region Name": "Quneitra (Governorate of Syria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quneitra (Governorate of Syria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quneitra (Governorate of Syria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quneitra (Governorate of Syria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quneitra (Governorate of Syria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quneitra (Governorate of Syria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quneitra (Governorate of Syria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quneitra (Governorate of Syria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quneitra (Governorate of Syria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quneitra (Governorate of Syria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quneitra (Governorate of Syria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quneitra (Governorate of Syria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quneitra (Governorate of Syria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quneitra (Governorate of Syria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quneitra (Governorate of Syria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quneitra (Governorate of Syria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quneitra (Governorate of Syria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quneitra (Governorate of Syria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quneitra (Governorate of Syria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quneitra (Governorate of Syria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quneitra (Governorate of Syria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quneitra (Governorate of Syria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Quthing (District of Lesotho)": [
            {
                "Region Name": "Quthing (District of Lesotho)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Quthing (District of Lesotho)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Quthing (District of Lesotho)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quthing (District of Lesotho)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Quthing (District of Lesotho)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Quthing (District of Lesotho)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Quthing (District of Lesotho)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quthing (District of Lesotho)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Quthing (District of Lesotho)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Quthing (District of Lesotho)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Quthing (District of Lesotho)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Quthing (District of Lesotho)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quthing (District of Lesotho)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quthing (District of Lesotho)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Quthing (District of Lesotho)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Quthing (District of Lesotho)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quthing (District of Lesotho)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Quthing (District of Lesotho)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Quthing (District of Lesotho)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quthing (District of Lesotho)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quthing (District of Lesotho)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Quthing (District of Lesotho)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Qyzylorda (Region of Kazakhstan)": [
            {
                "Region Name": "Qyzylorda (Region of Kazakhstan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Qyzylorda (Region of Kazakhstan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Qyzylorda (Region of Kazakhstan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Qyzylorda (Region of Kazakhstan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Qyzylorda (Region of Kazakhstan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Qyzylorda (Region of Kazakhstan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Qyzylorda (Region of Kazakhstan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Qyzylorda (Region of Kazakhstan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Qyzylorda (Region of Kazakhstan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Qyzylorda (Region of Kazakhstan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Qyzylorda (Region of Kazakhstan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Qyzylorda (Region of Kazakhstan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Qyzylorda (Region of Kazakhstan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Qyzylorda (Region of Kazakhstan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Qyzylorda (Region of Kazakhstan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Qyzylorda (Region of Kazakhstan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Qyzylorda (Region of Kazakhstan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Qyzylorda (Region of Kazakhstan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 81
            },
            {
                "Region Name": "Qyzylorda (Region of Kazakhstan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Qyzylorda (Region of Kazakhstan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Qyzylorda (Region of Kazakhstan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Qyzylorda (Region of Kazakhstan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Rabat - Sal\xe9 - Zemmour - Zaer (Region of Morocco)": [
            {
                "Region Name": "Rabat - Sal\xe9 - Zemmour - Zaer (Region of Morocco)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rabat - Sal\xe9 - Zemmour - Zaer (Region of Morocco)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rabat - Sal\xe9 - Zemmour - Zaer (Region of Morocco)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Rabat - Sal\xe9 - Zemmour - Zaer (Region of Morocco)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rabat - Sal\xe9 - Zemmour - Zaer (Region of Morocco)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rabat - Sal\xe9 - Zemmour - Zaer (Region of Morocco)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rabat - Sal\xe9 - Zemmour - Zaer (Region of Morocco)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rabat - Sal\xe9 - Zemmour - Zaer (Region of Morocco)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rabat - Sal\xe9 - Zemmour - Zaer (Region of Morocco)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rabat - Sal\xe9 - Zemmour - Zaer (Region of Morocco)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rabat - Sal\xe9 - Zemmour - Zaer (Region of Morocco)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rabat - Sal\xe9 - Zemmour - Zaer (Region of Morocco)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rabat - Sal\xe9 - Zemmour - Zaer (Region of Morocco)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rabat - Sal\xe9 - Zemmour - Zaer (Region of Morocco)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rabat - Sal\xe9 - Zemmour - Zaer (Region of Morocco)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rabat - Sal\xe9 - Zemmour - Zaer (Region of Morocco)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rabat - Sal\xe9 - Zemmour - Zaer (Region of Morocco)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rabat - Sal\xe9 - Zemmour - Zaer (Region of Morocco)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rabat - Sal\xe9 - Zemmour - Zaer (Region of Morocco)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rabat - Sal\xe9 - Zemmour - Zaer (Region of Morocco)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rabat - Sal\xe9 - Zemmour - Zaer (Region of Morocco)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rabat - Sal\xe9 - Zemmour - Zaer (Region of Morocco)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)": [
            {
                "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Racha-Lechkhumi-Kvemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Radovi\u0161 (Municipality of North Macedonia)": [
            {
                "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Radovi\u0161 (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ragged Island (District of Bahamas)": [
            {
                "Region Name": "Ragged Island (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ragged Island (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ragged Island (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ragged Island (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ragged Island (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ragged Island (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ragged Island (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ragged Island (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ragged Island (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ragged Island (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ragged Island (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ragged Island (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ragged Island (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ragged Island (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ragged Island (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ragged Island (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ragged Island (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ragged Island (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ragged Island (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ragged Island (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ragged Island (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ragged Island (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rajasthan (State of India)": [
            {
                "Region Name": "Rajasthan (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Rajasthan (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rajasthan (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Rajasthan (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rajasthan (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rajasthan (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rajasthan (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rajasthan (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Rajasthan (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rajasthan (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Rajasthan (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Rajasthan (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Rajasthan (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Rajasthan (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rajasthan (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Rajasthan (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rajasthan (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Rajasthan (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Rajasthan (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Rajasthan (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rajasthan (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rajasthan (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Rajshahi (Division of Bangladesh)": [
            {
                "Region Name": "Rajshahi (Division of Bangladesh)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Rajshahi (Division of Bangladesh)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rajshahi (Division of Bangladesh)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Rajshahi (Division of Bangladesh)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rajshahi (Division of Bangladesh)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rajshahi (Division of Bangladesh)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rajshahi (Division of Bangladesh)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rajshahi (Division of Bangladesh)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rajshahi (Division of Bangladesh)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rajshahi (Division of Bangladesh)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rajshahi (Division of Bangladesh)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rajshahi (Division of Bangladesh)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rajshahi (Division of Bangladesh)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rajshahi (Division of Bangladesh)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rajshahi (Division of Bangladesh)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rajshahi (Division of Bangladesh)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rajshahi (Division of Bangladesh)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rajshahi (Division of Bangladesh)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rajshahi (Division of Bangladesh)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Rajshahi (Division of Bangladesh)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rajshahi (Division of Bangladesh)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rajshahi (Division of Bangladesh)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Rakahanga (Island Council of Cook Islands)": [
            {
                "Region Name": "Rakahanga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rakahanga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rakahanga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rakahanga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rakahanga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rakahanga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rakahanga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rakahanga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rakahanga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rakahanga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rakahanga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rakahanga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rakahanga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rakahanga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rakahanga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rakahanga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rakahanga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rakahanga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rakahanga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rakahanga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rakahanga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rakahanga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rakai (District of Uganda)": [
            {
                "Region Name": "Rakai (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rakai (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rakai (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rakai (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rakai (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rakai (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rakai (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rakai (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rakai (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rakai (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rakai (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rakai (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rakai (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rakai (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rakai (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rakai (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rakai (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rakai (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rakai (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rakai (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rakai (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rakai (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rakhine (State of Myanmar)": [
            {
                "Region Name": "Rakhine (State of Myanmar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Rakhine (State of Myanmar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rakhine (State of Myanmar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rakhine (State of Myanmar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rakhine (State of Myanmar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Rakhine (State of Myanmar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Rakhine (State of Myanmar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Rakhine (State of Myanmar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Rakhine (State of Myanmar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rakhine (State of Myanmar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Rakhine (State of Myanmar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rakhine (State of Myanmar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rakhine (State of Myanmar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rakhine (State of Myanmar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rakhine (State of Myanmar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rakhine (State of Myanmar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rakhine (State of Myanmar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rakhine (State of Myanmar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rakhine (State of Myanmar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rakhine (State of Myanmar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rakhine (State of Myanmar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rakhine (State of Myanmar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Ramsey (Town District of Isle of Man)": [
            {
                "Region Name": "Ramsey (Town District of Isle of Man)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ramsey (Town District of Isle of Man)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ramsey (Town District of Isle of Man)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ramsey (Town District of Isle of Man)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ramsey (Town District of Isle of Man)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ramsey (Town District of Isle of Man)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ramsey (Town District of Isle of Man)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ramsey (Town District of Isle of Man)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ramsey (Town District of Isle of Man)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ramsey (Town District of Isle of Man)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ramsey (Town District of Isle of Man)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ramsey (Town District of Isle of Man)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ramsey (Town District of Isle of Man)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ramsey (Town District of Isle of Man)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ramsey (Town District of Isle of Man)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ramsey (Town District of Isle of Man)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ramsey (Town District of Isle of Man)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ramsey (Town District of Isle of Man)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ramsey (Town District of Isle of Man)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ramsey (Town District of Isle of Man)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ramsey (Town District of Isle of Man)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ramsey (Town District of Isle of Man)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rangpur (Division of Bangladesh)": [
            {
                "Region Name": "Rangpur (Division of Bangladesh)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rangpur (Division of Bangladesh)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rangpur (Division of Bangladesh)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rangpur (Division of Bangladesh)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rangpur (Division of Bangladesh)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rangpur (Division of Bangladesh)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rangpur (Division of Bangladesh)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rangpur (Division of Bangladesh)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rangpur (Division of Bangladesh)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rangpur (Division of Bangladesh)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rangpur (Division of Bangladesh)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rangpur (Division of Bangladesh)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rangpur (Division of Bangladesh)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rangpur (Division of Bangladesh)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rangpur (Division of Bangladesh)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rangpur (Division of Bangladesh)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rangpur (Division of Bangladesh)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rangpur (Division of Bangladesh)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rangpur (Division of Bangladesh)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rangpur (Division of Bangladesh)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rangpur (Division of Bangladesh)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rangpur (Division of Bangladesh)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rankovce (Municipality of North Macedonia)": [
            {
                "Region Name": "Rankovce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rankovce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rankovce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rankovce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rankovce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rankovce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rankovce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rankovce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rankovce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rankovce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rankovce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rankovce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rankovce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rankovce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rankovce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rankovce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rankovce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rankovce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rankovce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rankovce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rankovce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rankovce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ranong (Province of Thailand)": [
            {
                "Region Name": "Ranong (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ranong (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ranong (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ranong (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ranong (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ranong (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ranong (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ranong (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ranong (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ranong (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ranong (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ranong (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ranong (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ranong (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ranong (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ranong (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ranong (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ranong (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ranong (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ranong (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ranong (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ranong (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rapla (County of Estonia)": [
            {
                "Region Name": "Rapla (County of Estonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rapla (County of Estonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rapla (County of Estonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rapla (County of Estonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rapla (County of Estonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rapla (County of Estonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rapla (County of Estonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rapla (County of Estonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rapla (County of Estonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rapla (County of Estonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rapla (County of Estonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rapla (County of Estonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rapla (County of Estonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rapla (County of Estonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rapla (County of Estonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rapla (County of Estonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rapla (County of Estonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rapla (County of Estonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rapla (County of Estonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rapla (County of Estonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rapla (County of Estonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rapla (County of Estonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Rarotonga (Island Council of Cook Islands)": [
            {
                "Region Name": "Rarotonga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rarotonga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rarotonga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rarotonga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rarotonga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rarotonga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rarotonga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rarotonga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rarotonga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rarotonga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rarotonga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rarotonga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rarotonga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rarotonga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rarotonga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rarotonga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rarotonga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rarotonga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rarotonga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rarotonga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rarotonga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rarotonga (Island Council of Cook Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ras Al-Khaimah (Emirate of United Arab Emirates)": [
            {
                "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras Al-Khaimah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rasinski (District of Serbia)": [
            {
                "Region Name": "Rasinski (District of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rasinski (District of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rasinski (District of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rasinski (District of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rasinski (District of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rasinski (District of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rasinski (District of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rasinski (District of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rasinski (District of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rasinski (District of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rasinski (District of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rasinski (District of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rasinski (District of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rasinski (District of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rasinski (District of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rasinski (District of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rasinski (District of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rasinski (District of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rasinski (District of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rasinski (District of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rasinski (District of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rasinski (District of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ra\u0161ki (District of Serbia)": [
            {
                "Region Name": "Ra\u0161ki (District of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ra\u0161ki (District of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ra\u0161ki (District of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ra\u0161ki (District of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ra\u0161ki (District of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ra\u0161ki (District of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ra\u0161ki (District of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ra\u0161ki (District of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ra\u0161ki (District of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ra\u0161ki (District of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ra\u0161ki (District of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ra\u0161ki (District of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ra\u0161ki (District of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ra\u0161ki (District of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ra\u0161ki (District of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ra\u0161ki (District of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ra\u0161ki (District of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ra\u0161ki (District of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ra\u0161ki (District of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ra\u0161ki (District of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ra\u0161ki (District of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ra\u0161ki (District of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ras\u014Fn (Directly Governed City of North Korea)": [
            {
                "Region Name": "Ras\u014Fn (Directly Governed City of North Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras\u014Fn (Directly Governed City of North Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ras\u014Fn (Directly Governed City of North Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ras\u014Fn (Directly Governed City of North Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ras\u014Fn (Directly Governed City of North Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras\u014Fn (Directly Governed City of North Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras\u014Fn (Directly Governed City of North Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras\u014Fn (Directly Governed City of North Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras\u014Fn (Directly Governed City of North Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras\u014Fn (Directly Governed City of North Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ras\u014Fn (Directly Governed City of North Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras\u014Fn (Directly Governed City of North Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras\u014Fn (Directly Governed City of North Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ras\u014Fn (Directly Governed City of North Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras\u014Fn (Directly Governed City of North Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras\u014Fn (Directly Governed City of North Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras\u014Fn (Directly Governed City of North Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras\u014Fn (Directly Governed City of North Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras\u014Fn (Directly Governed City of North Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras\u014Fn (Directly Governed City of North Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ras\u014Fn (Directly Governed City of North Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ras\u014Fn (Directly Governed City of North Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Ratchaburi (Province of Thailand)": [
            {
                "Region Name": "Ratchaburi (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ratchaburi (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ratchaburi (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ratchaburi (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ratchaburi (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ratchaburi (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ratchaburi (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ratchaburi (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ratchaburi (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ratchaburi (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ratchaburi (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ratchaburi (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ratchaburi (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ratchaburi (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ratchaburi (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ratchaburi (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ratchaburi (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ratchaburi (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ratchaburi (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ratchaburi (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ratchaburi (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ratchaburi (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Ratnapura (District of Sri Lanka)": [
            {
                "Region Name": "Ratnapura (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ratnapura (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ratnapura (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ratnapura (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ratnapura (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ratnapura (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ratnapura (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ratnapura (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ratnapura (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ratnapura (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ratnapura (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ratnapura (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ratnapura (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ratnapura (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ratnapura (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ratnapura (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ratnapura (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ratnapura (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ratnapura (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ratnapura (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ratnapura (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ratnapura (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Raymah (Governorate of Yemen)": [
            {
                "Region Name": "Raymah (Governorate of Yemen)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Raymah (Governorate of Yemen)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Raymah (Governorate of Yemen)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Raymah (Governorate of Yemen)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Raymah (Governorate of Yemen)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Raymah (Governorate of Yemen)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Raymah (Governorate of Yemen)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Raymah (Governorate of Yemen)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Raymah (Governorate of Yemen)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Raymah (Governorate of Yemen)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Raymah (Governorate of Yemen)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Raymah (Governorate of Yemen)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Raymah (Governorate of Yemen)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Raymah (Governorate of Yemen)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Raymah (Governorate of Yemen)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Raymah (Governorate of Yemen)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Raymah (Governorate of Yemen)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Raymah (Governorate of Yemen)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Raymah (Governorate of Yemen)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Raymah (Governorate of Yemen)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Raymah (Governorate of Yemen)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Raymah (Governorate of Yemen)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rayong (Province of Thailand)": [
            {
                "Region Name": "Rayong (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rayong (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rayong (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rayong (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rayong (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rayong (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Rayong (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rayong (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rayong (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rayong (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rayong (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rayong (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rayong (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Rayong (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rayong (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rayong (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rayong (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rayong (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rayong (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rayong (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rayong (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rayong (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Razavi Khorasan (Province of Iran)": [
            {
                "Region Name": "Razavi Khorasan (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Razavi Khorasan (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Razavi Khorasan (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Razavi Khorasan (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Razavi Khorasan (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Razavi Khorasan (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Razavi Khorasan (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Razavi Khorasan (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Razavi Khorasan (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Razavi Khorasan (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Razavi Khorasan (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Razavi Khorasan (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Razavi Khorasan (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Razavi Khorasan (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Razavi Khorasan (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Razavi Khorasan (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Razavi Khorasan (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Razavi Khorasan (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Razavi Khorasan (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Razavi Khorasan (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Razavi Khorasan (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Razavi Khorasan (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Razgrad (Province of Bulgaria)": [
            {
                "Region Name": "Razgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Razgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Razgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Razgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Razgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Razgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Razgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Razgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Razgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Razgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Razgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Razgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Razgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Razgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Razgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Razgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Razgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Razgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Razgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Razgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Razgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Razgrad (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Red Sea (State of Sudan)": [
            {
                "Region Name": "Red Sea (State of Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Red Sea (State of Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Red Sea (State of Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Red Sea (State of Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Red Sea (State of Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Red Sea (State of Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Red Sea (State of Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Red Sea (State of Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Red Sea (State of Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Red Sea (State of Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Red Sea (State of Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Red Sea (State of Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Red Sea (State of Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Red Sea (State of Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Red Sea (State of Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Red Sea (State of Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Red Sea (State of Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Red Sea (State of Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Red Sea (State of Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Red Sea (State of Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Red Sea (State of Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Red Sea (State of Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Redonda (Dependency of Antigua and Barbuda)": [
            {
                "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Redonda (Dependency of Antigua and Barbuda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Regi\xf3n de Murcia (Autonomous Community of Spain)": [
            {
                "Region Name": "Regi\xf3n de Murcia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Regi\xf3n de Murcia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Regi\xf3n de Murcia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Regi\xf3n de Murcia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Regi\xf3n de Murcia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Regi\xf3n de Murcia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Regi\xf3n de Murcia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Regi\xf3n de Murcia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Regi\xf3n de Murcia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Regi\xf3n de Murcia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Regi\xf3n de Murcia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Regi\xf3n de Murcia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Regi\xf3n de Murcia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Regi\xf3n de Murcia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Regi\xf3n de Murcia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Regi\xf3n de Murcia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Regi\xf3n de Murcia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Regi\xf3n de Murcia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Regi\xf3n de Murcia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Regi\xf3n de Murcia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Regi\xf3n de Murcia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Regi\xf3n de Murcia (Autonomous Community of Spain)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Relizane (Province of Algeria)": [
            {
                "Region Name": "Relizane (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Relizane (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Relizane (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Relizane (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Relizane (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Relizane (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Relizane (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Relizane (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Relizane (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Relizane (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Relizane (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Relizane (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Relizane (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Relizane (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Relizane (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Relizane (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Relizane (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Relizane (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Relizane (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Relizane (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Relizane (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Relizane (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rennell and Bellona (Province of Solomon Islands)": [
            {
                "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rennell and Bellona (Province of Solomon Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Repuplika Srpska (Entity of Bosnia and Herzegovina)": [
            {
                "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Repuplika Srpska (Entity of Bosnia and Herzegovina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Resen (Municipality of North Macedonia)": [
            {
                "Region Name": "Resen (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Resen (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Resen (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Resen (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Resen (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Resen (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Resen (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Resen (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Resen (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Resen (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Resen (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Resen (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Resen (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Resen (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Resen (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Resen (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Resen (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Resen (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Resen (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Resen (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Resen (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Resen (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Retalhuleu (Department of Guatemala)": [
            {
                "Region Name": "Retalhuleu (Department of Guatemala)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Retalhuleu (Department of Guatemala)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Retalhuleu (Department of Guatemala)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Retalhuleu (Department of Guatemala)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Retalhuleu (Department of Guatemala)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Retalhuleu (Department of Guatemala)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Retalhuleu (Department of Guatemala)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Retalhuleu (Department of Guatemala)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Retalhuleu (Department of Guatemala)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Retalhuleu (Department of Guatemala)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Retalhuleu (Department of Guatemala)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Retalhuleu (Department of Guatemala)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Retalhuleu (Department of Guatemala)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Retalhuleu (Department of Guatemala)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Retalhuleu (Department of Guatemala)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Retalhuleu (Department of Guatemala)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Retalhuleu (Department of Guatemala)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Retalhuleu (Department of Guatemala)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Retalhuleu (Department of Guatemala)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Retalhuleu (Department of Guatemala)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Retalhuleu (Department of Guatemala)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Retalhuleu (Department of Guatemala)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Rezina (District of Moldova)": [
            {
                "Region Name": "Rezina (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rezina (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rezina (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rezina (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rezina (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rezina (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rezina (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rezina (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rezina (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rezina (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rezina (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rezina (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rezina (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rezina (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rezina (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rezina (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rezina (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rezina (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rezina (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rezina (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rezina (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rezina (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rheinland-Pfalz (State of Germany)": [
            {
                "Region Name": "Rheinland-Pfalz (State of Germany)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rheinland-Pfalz (State of Germany)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rheinland-Pfalz (State of Germany)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rheinland-Pfalz (State of Germany)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rheinland-Pfalz (State of Germany)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rheinland-Pfalz (State of Germany)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rheinland-Pfalz (State of Germany)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rheinland-Pfalz (State of Germany)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rheinland-Pfalz (State of Germany)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rheinland-Pfalz (State of Germany)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rheinland-Pfalz (State of Germany)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rheinland-Pfalz (State of Germany)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rheinland-Pfalz (State of Germany)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rheinland-Pfalz (State of Germany)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rheinland-Pfalz (State of Germany)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rheinland-Pfalz (State of Germany)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rheinland-Pfalz (State of Germany)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rheinland-Pfalz (State of Germany)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rheinland-Pfalz (State of Germany)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rheinland-Pfalz (State of Germany)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rheinland-Pfalz (State of Germany)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rheinland-Pfalz (State of Germany)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rhode Island (State of United States)": [
            {
                "Region Name": "Rhode Island (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rhode Island (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rhode Island (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rhode Island (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rhode Island (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rhode Island (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rhode Island (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rhode Island (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rhode Island (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rhode Island (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rhode Island (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rhode Island (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rhode Island (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rhode Island (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rhode Island (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rhode Island (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rhode Island (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rhode Island (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rhode Island (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rhode Island (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rhode Island (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rhode Island (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Riau (Province of Indonesia)": [
            {
                "Region Name": "Riau (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Riau (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Riau (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Riau (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Riau (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Riau (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Riau (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Riau (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Riau (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Riau (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Riau (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Riau (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Riau (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Riau (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Riau (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Riau (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Riau (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Riau (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Riau (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Riau (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Riau (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Riau (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Ribeira Brava (County of Cabo Verde)": [
            {
                "Region Name": "Ribeira Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Brava (County of Cabo Verde)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ribeira Grande (County of Cabo Verde)": [
            {
                "Region Name": "Ribeira Grande (County of Cabo Verde)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande (County of Cabo Verde)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande (County of Cabo Verde)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande (County of Cabo Verde)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande (County of Cabo Verde)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande (County of Cabo Verde)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande (County of Cabo Verde)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande (County of Cabo Verde)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande (County of Cabo Verde)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande (County of Cabo Verde)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande (County of Cabo Verde)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande (County of Cabo Verde)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande (County of Cabo Verde)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande (County of Cabo Verde)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande (County of Cabo Verde)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande (County of Cabo Verde)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande (County of Cabo Verde)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande (County of Cabo Verde)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande (County of Cabo Verde)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande (County of Cabo Verde)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande (County of Cabo Verde)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande (County of Cabo Verde)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ribeira Grande de Santiago (County of Cabo Verde)": [
            {
                "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ribeira Grande de Santiago (County of Cabo Verde)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rif Dimashq (Governorate of Syria)": [
            {
                "Region Name": "Rif Dimashq (Governorate of Syria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rif Dimashq (Governorate of Syria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rif Dimashq (Governorate of Syria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rif Dimashq (Governorate of Syria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rif Dimashq (Governorate of Syria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rif Dimashq (Governorate of Syria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rif Dimashq (Governorate of Syria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rif Dimashq (Governorate of Syria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rif Dimashq (Governorate of Syria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rif Dimashq (Governorate of Syria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rif Dimashq (Governorate of Syria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rif Dimashq (Governorate of Syria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rif Dimashq (Governorate of Syria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rif Dimashq (Governorate of Syria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rif Dimashq (Governorate of Syria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rif Dimashq (Governorate of Syria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rif Dimashq (Governorate of Syria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rif Dimashq (Governorate of Syria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Rif Dimashq (Governorate of Syria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Rif Dimashq (Governorate of Syria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rif Dimashq (Governorate of Syria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rif Dimashq (Governorate of Syria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Riga (Province of Latvia)": [
            {
                "Region Name": "Riga (Province of Latvia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Riga (Province of Latvia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Riga (Province of Latvia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Riga (Province of Latvia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Riga (Province of Latvia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Riga (Province of Latvia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Riga (Province of Latvia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Riga (Province of Latvia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Riga (Province of Latvia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Riga (Province of Latvia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Riga (Province of Latvia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Riga (Province of Latvia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Riga (Province of Latvia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Riga (Province of Latvia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Riga (Province of Latvia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Riga (Province of Latvia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Riga (Province of Latvia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Riga (Province of Latvia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Riga (Province of Latvia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Riga (Province of Latvia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Riga (Province of Latvia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Riga (Province of Latvia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rinc\xf3n (Municipality of Puerto Rico)": [
            {
                "Region Name": "Rinc\xf3n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rinc\xf3n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rinc\xf3n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rinc\xf3n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rinc\xf3n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rinc\xf3n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rinc\xf3n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rinc\xf3n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rinc\xf3n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rinc\xf3n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rinc\xf3n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rinc\xf3n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rinc\xf3n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rinc\xf3n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rinc\xf3n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rinc\xf3n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rinc\xf3n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rinc\xf3n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rinc\xf3n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rinc\xf3n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rinc\xf3n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rinc\xf3n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rio de Janeiro (State of Brazil)": [
            {
                "Region Name": "Rio de Janeiro (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rio de Janeiro (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rio de Janeiro (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rio de Janeiro (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rio de Janeiro (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rio de Janeiro (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rio de Janeiro (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rio de Janeiro (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rio de Janeiro (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rio de Janeiro (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rio de Janeiro (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Rio de Janeiro (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rio de Janeiro (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Rio de Janeiro (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rio de Janeiro (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rio de Janeiro (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rio de Janeiro (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Rio de Janeiro (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rio de Janeiro (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rio de Janeiro (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rio de Janeiro (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rio de Janeiro (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "R\xedo Grande (Municipality of Puerto Rico)": [
            {
                "Region Name": "R\xedo Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rio Grande do Norte (State of Brazil)": [
            {
                "Region Name": "Rio Grande do Norte (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Rio Grande do Norte (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rio Grande do Norte (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rio Grande do Norte (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rio Grande do Norte (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Rio Grande do Norte (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Rio Grande do Norte (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rio Grande do Norte (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rio Grande do Norte (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rio Grande do Norte (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rio Grande do Norte (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rio Grande do Norte (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rio Grande do Norte (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rio Grande do Norte (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rio Grande do Norte (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rio Grande do Norte (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rio Grande do Norte (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rio Grande do Norte (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Rio Grande do Norte (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rio Grande do Norte (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Rio Grande do Norte (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rio Grande do Norte (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Rio Grande do Sul (State of Brazil)": [
            {
                "Region Name": "Rio Grande do Sul (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rio Grande do Sul (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Rio Grande do Sul (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rio Grande do Sul (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rio Grande do Sul (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rio Grande do Sul (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rio Grande do Sul (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rio Grande do Sul (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Rio Grande do Sul (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rio Grande do Sul (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rio Grande do Sul (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rio Grande do Sul (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rio Grande do Sul (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rio Grande do Sul (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rio Grande do Sul (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rio Grande do Sul (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rio Grande do Sul (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rio Grande do Sul (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rio Grande do Sul (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rio Grande do Sul (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rio Grande do Sul (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rio Grande do Sul (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "R\xedo Negro (Department of Uruguay)": [
            {
                "Region Name": "R\xedo Negro (Department of Uruguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "R\xedo Negro (Department of Uruguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "R\xedo Negro (Department of Uruguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "R\xedo Negro (Department of Uruguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "R\xedo Negro (Department of Uruguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "R\xedo Negro (Department of Uruguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "R\xedo Negro (Department of Uruguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "R\xedo Negro (Department of Uruguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "R\xedo Negro (Department of Uruguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "R\xedo Negro (Department of Uruguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "R\xedo Negro (Department of Uruguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "R\xedo Negro (Department of Uruguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "R\xedo Negro (Department of Uruguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "R\xedo Negro (Department of Uruguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "R\xedo Negro (Department of Uruguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo Negro (Department of Uruguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "R\xedo Negro (Department of Uruguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "R\xedo Negro (Department of Uruguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "R\xedo Negro (Department of Uruguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "R\xedo Negro (Department of Uruguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "R\xedo Negro (Department of Uruguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "R\xedo Negro (Department of Uruguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "R\xedo Negro (Province of Argentina)": [
            {
                "Region Name": "R\xedo Negro (Province of Argentina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 163
            },
            {
                "Region Name": "R\xedo Negro (Province of Argentina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "R\xedo Negro (Province of Argentina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "R\xedo Negro (Province of Argentina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "R\xedo Negro (Province of Argentina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "R\xedo Negro (Province of Argentina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "R\xedo Negro (Province of Argentina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "R\xedo Negro (Province of Argentina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo Negro (Province of Argentina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "R\xedo Negro (Province of Argentina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "R\xedo Negro (Province of Argentina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "R\xedo Negro (Province of Argentina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "R\xedo Negro (Province of Argentina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 221
            },
            {
                "Region Name": "R\xedo Negro (Province of Argentina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "R\xedo Negro (Province of Argentina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 203
            },
            {
                "Region Name": "R\xedo Negro (Province of Argentina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 73
            },
            {
                "Region Name": "R\xedo Negro (Province of Argentina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "R\xedo Negro (Province of Argentina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "R\xedo Negro (Province of Argentina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "R\xedo Negro (Province of Argentina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "R\xedo Negro (Province of Argentina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "R\xedo Negro (Province of Argentina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "R\xedo San Juan (Department of Nicaragua)": [
            {
                "Region Name": "R\xedo San Juan (Department of Nicaragua)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo San Juan (Department of Nicaragua)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "R\xedo San Juan (Department of Nicaragua)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "R\xedo San Juan (Department of Nicaragua)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "R\xedo San Juan (Department of Nicaragua)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "R\xedo San Juan (Department of Nicaragua)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "R\xedo San Juan (Department of Nicaragua)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "R\xedo San Juan (Department of Nicaragua)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "R\xedo San Juan (Department of Nicaragua)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "R\xedo San Juan (Department of Nicaragua)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "R\xedo San Juan (Department of Nicaragua)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "R\xedo San Juan (Department of Nicaragua)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "R\xedo San Juan (Department of Nicaragua)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "R\xedo San Juan (Department of Nicaragua)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "R\xedo San Juan (Department of Nicaragua)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "R\xedo San Juan (Department of Nicaragua)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "R\xedo San Juan (Department of Nicaragua)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "R\xedo San Juan (Department of Nicaragua)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "R\xedo San Juan (Department of Nicaragua)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "R\xedo San Juan (Department of Nicaragua)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo San Juan (Department of Nicaragua)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xedo San Juan (Department of Nicaragua)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Risaralda (Department of Colombia)": [
            {
                "Region Name": "Risaralda (Department of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Risaralda (Department of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Risaralda (Department of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Risaralda (Department of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Risaralda (Department of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Risaralda (Department of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Risaralda (Department of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Risaralda (Department of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Risaralda (Department of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Risaralda (Department of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Risaralda (Department of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Risaralda (Department of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Risaralda (Department of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Risaralda (Department of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Risaralda (Department of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Risaralda (Department of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Risaralda (Department of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Risaralda (Department of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Risaralda (Department of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Risaralda (Department of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Risaralda (Department of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Risaralda (Department of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "R\xee\u0219cani (District of Moldova)": [
            {
                "Region Name": "R\xee\u0219cani (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "R\xee\u0219cani (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xee\u0219cani (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xee\u0219cani (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "R\xee\u0219cani (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "R\xee\u0219cani (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xee\u0219cani (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "R\xee\u0219cani (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "R\xee\u0219cani (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "R\xee\u0219cani (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "R\xee\u0219cani (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xee\u0219cani (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "R\xee\u0219cani (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "R\xee\u0219cani (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "R\xee\u0219cani (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xee\u0219cani (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "R\xee\u0219cani (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xee\u0219cani (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "R\xee\u0219cani (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "R\xee\u0219cani (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "R\xee\u0219cani (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "R\xee\u0219cani (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rivas (Department of Nicaragua)": [
            {
                "Region Name": "Rivas (Department of Nicaragua)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rivas (Department of Nicaragua)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivas (Department of Nicaragua)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rivas (Department of Nicaragua)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rivas (Department of Nicaragua)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivas (Department of Nicaragua)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rivas (Department of Nicaragua)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rivas (Department of Nicaragua)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rivas (Department of Nicaragua)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rivas (Department of Nicaragua)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rivas (Department of Nicaragua)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivas (Department of Nicaragua)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rivas (Department of Nicaragua)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rivas (Department of Nicaragua)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rivas (Department of Nicaragua)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rivas (Department of Nicaragua)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivas (Department of Nicaragua)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rivas (Department of Nicaragua)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rivas (Department of Nicaragua)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivas (Department of Nicaragua)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rivas (Department of Nicaragua)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rivas (Department of Nicaragua)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "River Gee (County of Liberia)": [
            {
                "Region Name": "River Gee (County of Liberia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Gee (County of Liberia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Gee (County of Liberia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Gee (County of Liberia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Gee (County of Liberia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Gee (County of Liberia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Gee (County of Liberia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "River Gee (County of Liberia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Gee (County of Liberia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "River Gee (County of Liberia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Gee (County of Liberia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Gee (County of Liberia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Gee (County of Liberia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Gee (County of Liberia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "River Gee (County of Liberia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Gee (County of Liberia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Gee (County of Liberia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "River Gee (County of Liberia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "River Gee (County of Liberia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Gee (County of Liberia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Gee (County of Liberia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "River Gee (County of Liberia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "River Nile (State of Sudan)": [
            {
                "Region Name": "River Nile (State of Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Nile (State of Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "River Nile (State of Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Nile (State of Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Nile (State of Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Nile (State of Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "River Nile (State of Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "River Nile (State of Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "River Nile (State of Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Nile (State of Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Nile (State of Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Nile (State of Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Nile (State of Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Nile (State of Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "River Nile (State of Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "River Nile (State of Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "River Nile (State of Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "River Nile (State of Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 108
            },
            {
                "Region Name": "River Nile (State of Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "River Nile (State of Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "River Nile (State of Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "River Nile (State of Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rivera (Department of Uruguay)": [
            {
                "Region Name": "Rivera (Department of Uruguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rivera (Department of Uruguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rivera (Department of Uruguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rivera (Department of Uruguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rivera (Department of Uruguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivera (Department of Uruguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivera (Department of Uruguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rivera (Department of Uruguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rivera (Department of Uruguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rivera (Department of Uruguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rivera (Department of Uruguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rivera (Department of Uruguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rivera (Department of Uruguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rivera (Department of Uruguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Rivera (Department of Uruguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rivera (Department of Uruguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rivera (Department of Uruguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rivera (Department of Uruguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivera (Department of Uruguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rivera (Department of Uruguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivera (Department of Uruguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivera (Department of Uruguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rivercess (County of Liberia)": [
            {
                "Region Name": "Rivercess (County of Liberia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rivercess (County of Liberia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivercess (County of Liberia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rivercess (County of Liberia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rivercess (County of Liberia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rivercess (County of Liberia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rivercess (County of Liberia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rivercess (County of Liberia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivercess (County of Liberia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rivercess (County of Liberia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivercess (County of Liberia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rivercess (County of Liberia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rivercess (County of Liberia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivercess (County of Liberia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rivercess (County of Liberia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rivercess (County of Liberia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivercess (County of Liberia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rivercess (County of Liberia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rivercess (County of Liberia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rivercess (County of Liberia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rivercess (County of Liberia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rivercess (County of Liberia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Rivers (State of Nigeria)": [
            {
                "Region Name": "Rivers (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rivers (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rivers (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rivers (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivers (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivers (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rivers (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rivers (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rivers (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rivers (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivers (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rivers (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rivers (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rivers (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivers (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rivers (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rivers (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rivers (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rivers (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rivers (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rivers (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rivers (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Rivi\xe8re du Rempart (District of Mauritius)": [
            {
                "Region Name": "Rivi\xe8re du Rempart (District of Mauritius)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivi\xe8re du Rempart (District of Mauritius)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivi\xe8re du Rempart (District of Mauritius)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rivi\xe8re du Rempart (District of Mauritius)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rivi\xe8re du Rempart (District of Mauritius)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rivi\xe8re du Rempart (District of Mauritius)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rivi\xe8re du Rempart (District of Mauritius)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rivi\xe8re du Rempart (District of Mauritius)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rivi\xe8re du Rempart (District of Mauritius)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rivi\xe8re du Rempart (District of Mauritius)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rivi\xe8re du Rempart (District of Mauritius)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rivi\xe8re du Rempart (District of Mauritius)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivi\xe8re du Rempart (District of Mauritius)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rivi\xe8re du Rempart (District of Mauritius)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rivi\xe8re du Rempart (District of Mauritius)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rivi\xe8re du Rempart (District of Mauritius)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rivi\xe8re du Rempart (District of Mauritius)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rivi\xe8re du Rempart (District of Mauritius)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rivi\xe8re du Rempart (District of Mauritius)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rivi\xe8re du Rempart (District of Mauritius)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rivi\xe8re du Rempart (District of Mauritius)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rivi\xe8re du Rempart (District of Mauritius)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rivne (Region of Ukraine)": [
            {
                "Region Name": "Rivne (Region of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rivne (Region of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Rivne (Region of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rivne (Region of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivne (Region of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Rivne (Region of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivne (Region of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rivne (Region of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rivne (Region of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivne (Region of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rivne (Region of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Rivne (Region of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rivne (Region of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rivne (Region of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Rivne (Region of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rivne (Region of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rivne (Region of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rivne (Region of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rivne (Region of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rivne (Region of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Rivne (Region of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rivne (Region of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Rizal (Province of Philippines)": [
            {
                "Region Name": "Rizal (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rizal (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rizal (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rizal (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rizal (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rizal (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rizal (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rizal (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rizal (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rizal (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rizal (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rizal (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rizal (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rizal (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rizal (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rizal (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rizal (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rizal (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rizal (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rizal (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rizal (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rizal (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rize (Province of Turkey)": [
            {
                "Region Name": "Rize (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rize (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rize (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rize (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rize (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rize (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rize (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rize (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rize (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rize (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rize (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rize (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rize (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rize (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rize (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rize (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rize (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rize (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rize (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rize (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rize (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rize (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rocha (Department of Uruguay)": [
            {
                "Region Name": "Rocha (Department of Uruguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rocha (Department of Uruguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Rocha (Department of Uruguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Rocha (Department of Uruguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Rocha (Department of Uruguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rocha (Department of Uruguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rocha (Department of Uruguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Rocha (Department of Uruguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rocha (Department of Uruguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rocha (Department of Uruguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Rocha (Department of Uruguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rocha (Department of Uruguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rocha (Department of Uruguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rocha (Department of Uruguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rocha (Department of Uruguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rocha (Department of Uruguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rocha (Department of Uruguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rocha (Department of Uruguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Rocha (Department of Uruguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rocha (Department of Uruguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rocha (Department of Uruguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rocha (Department of Uruguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Roche Ca\xefman (District of Seychelles)": [
            {
                "Region Name": "Roche Ca\xefman (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roche Ca\xefman (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roche Ca\xefman (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roche Ca\xefman (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roche Ca\xefman (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roche Ca\xefman (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roche Ca\xefman (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roche Ca\xefman (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roche Ca\xefman (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roche Ca\xefman (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roche Ca\xefman (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roche Ca\xefman (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roche Ca\xefman (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roche Ca\xefman (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roche Ca\xefman (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roche Ca\xefman (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roche Ca\xefman (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roche Ca\xefman (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roche Ca\xefman (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roche Ca\xefman (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roche Ca\xefman (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roche Ca\xefman (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rodriguez (Autonomous island of Mauritius)": [
            {
                "Region Name": "Rodriguez (Autonomous island of Mauritius)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rodriguez (Autonomous island of Mauritius)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rodriguez (Autonomous island of Mauritius)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rodriguez (Autonomous island of Mauritius)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rodriguez (Autonomous island of Mauritius)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rodriguez (Autonomous island of Mauritius)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rodriguez (Autonomous island of Mauritius)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rodriguez (Autonomous island of Mauritius)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rodriguez (Autonomous island of Mauritius)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rodriguez (Autonomous island of Mauritius)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rodriguez (Autonomous island of Mauritius)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rodriguez (Autonomous island of Mauritius)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rodriguez (Autonomous island of Mauritius)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rodriguez (Autonomous island of Mauritius)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rodriguez (Autonomous island of Mauritius)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rodriguez (Autonomous island of Mauritius)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rodriguez (Autonomous island of Mauritius)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rodriguez (Autonomous island of Mauritius)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rodriguez (Autonomous island of Mauritius)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rodriguez (Autonomous island of Mauritius)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rodriguez (Autonomous island of Mauritius)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rodriguez (Autonomous island of Mauritius)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rogaland (County of Norway)": [
            {
                "Region Name": "Rogaland (County of Norway)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rogaland (County of Norway)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Rogaland (County of Norway)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rogaland (County of Norway)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rogaland (County of Norway)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rogaland (County of Norway)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rogaland (County of Norway)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rogaland (County of Norway)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rogaland (County of Norway)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rogaland (County of Norway)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rogaland (County of Norway)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rogaland (County of Norway)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rogaland (County of Norway)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rogaland (County of Norway)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rogaland (County of Norway)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rogaland (County of Norway)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rogaland (County of Norway)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rogaland (County of Norway)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rogaland (County of Norway)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rogaland (County of Norway)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rogaland (County of Norway)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rogaland (County of Norway)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Roi Et (Province of Thailand)": [
            {
                "Region Name": "Roi Et (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Roi Et (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Roi Et (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Roi Et (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Roi Et (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Roi Et (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Roi Et (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Roi Et (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Roi Et (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Roi Et (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Roi Et (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Roi Et (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Roi Et (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Roi Et (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Roi Et (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Roi Et (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Roi Et (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Roi Et (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Roi Et (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Roi Et (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Roi Et (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Roi Et (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Romblon (Province of Philippines)": [
            {
                "Region Name": "Romblon (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Romblon (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Romblon (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Romblon (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Romblon (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Romblon (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Romblon (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Romblon (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Romblon (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Romblon (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Romblon (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Romblon (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Romblon (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Romblon (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Romblon (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Romblon (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Romblon (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Romblon (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Romblon (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Romblon (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Romblon (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Romblon (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rond\xf4nia (State of Brazil)": [
            {
                "Region Name": "Rond\xf4nia (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rond\xf4nia (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rond\xf4nia (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rond\xf4nia (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Rond\xf4nia (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rond\xf4nia (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rond\xf4nia (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rond\xf4nia (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rond\xf4nia (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Rond\xf4nia (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Rond\xf4nia (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rond\xf4nia (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rond\xf4nia (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rond\xf4nia (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rond\xf4nia (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rond\xf4nia (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rond\xf4nia (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rond\xf4nia (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Rond\xf4nia (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rond\xf4nia (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Rond\xf4nia (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Rond\xf4nia (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Roraima (State of Brazil)": [
            {
                "Region Name": "Roraima (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Roraima (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Roraima (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Roraima (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Roraima (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Roraima (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Roraima (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Roraima (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Roraima (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Roraima (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Roraima (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Roraima (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Roraima (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Roraima (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Roraima (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Roraima (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Roraima (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Roraima (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Roraima (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Roraima (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Roraima (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Roraima (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Roscommon (County of Ireland)": [
            {
                "Region Name": "Roscommon (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roscommon (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roscommon (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roscommon (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roscommon (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roscommon (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roscommon (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roscommon (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roscommon (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roscommon (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Roscommon (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roscommon (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roscommon (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roscommon (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roscommon (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roscommon (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Roscommon (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roscommon (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roscommon (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roscommon (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roscommon (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Roscommon (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rosoman (Municipality of North Macedonia)": [
            {
                "Region Name": "Rosoman (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rosoman (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rosoman (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rosoman (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rosoman (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rosoman (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rosoman (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rosoman (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rosoman (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rosoman (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Rosoman (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rosoman (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rosoman (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rosoman (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rosoman (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rosoman (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rosoman (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rosoman (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rosoman (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rosoman (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rosoman (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rosoman (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rostov (Region of Russia)": [
            {
                "Region Name": "Rostov (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rostov (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rostov (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rostov (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rostov (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rostov (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rostov (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rostov (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rostov (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rostov (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rostov (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rostov (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rostov (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rostov (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rostov (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rostov (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rostov (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rostov (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rostov (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rostov (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rostov (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rostov (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Rota (Municipality of Northern Mariana Islands)": [
            {
                "Region Name": "Rota (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rota (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rota (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rota (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rota (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rota (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rota (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rota (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rota (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rota (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rota (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rota (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rota (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rota (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rota (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rota (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rota (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rota (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rota (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rota (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rota (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rota (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "R\xf4t\xe1n\xf4kiri (Province of Cambodia)": [
            {
                "Region Name": "R\xf4t\xe1n\xf4kiri (Province of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "R\xf4t\xe1n\xf4kiri (Province of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "R\xf4t\xe1n\xf4kiri (Province of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "R\xf4t\xe1n\xf4kiri (Province of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "R\xf4t\xe1n\xf4kiri (Province of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "R\xf4t\xe1n\xf4kiri (Province of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "R\xf4t\xe1n\xf4kiri (Province of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "R\xf4t\xe1n\xf4kiri (Province of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "R\xf4t\xe1n\xf4kiri (Province of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "R\xf4t\xe1n\xf4kiri (Province of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "R\xf4t\xe1n\xf4kiri (Province of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "R\xf4t\xe1n\xf4kiri (Province of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "R\xf4t\xe1n\xf4kiri (Province of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "R\xf4t\xe1n\xf4kiri (Province of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "R\xf4t\xe1n\xf4kiri (Province of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "R\xf4t\xe1n\xf4kiri (Province of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "R\xf4t\xe1n\xf4kiri (Province of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "R\xf4t\xe1n\xf4kiri (Province of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "R\xf4t\xe1n\xf4kiri (Province of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "R\xf4t\xe1n\xf4kiri (Province of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "R\xf4t\xe1n\xf4kiri (Province of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "R\xf4t\xe1n\xf4kiri (Province of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Rotuma (Division of Fiji)": [
            {
                "Region Name": "Rotuma (Division of Fiji)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rotuma (Division of Fiji)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rotuma (Division of Fiji)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rotuma (Division of Fiji)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rotuma (Division of Fiji)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rotuma (Division of Fiji)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rotuma (Division of Fiji)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rotuma (Division of Fiji)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rotuma (Division of Fiji)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rotuma (Division of Fiji)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rotuma (Division of Fiji)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rotuma (Division of Fiji)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rotuma (Division of Fiji)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rotuma (Division of Fiji)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rotuma (Division of Fiji)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rotuma (Division of Fiji)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rotuma (Division of Fiji)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rotuma (Division of Fiji)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rotuma (Division of Fiji)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rotuma (Division of Fiji)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rotuma (Division of Fiji)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rotuma (Division of Fiji)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ro\u017Eaje (Municipality of Montenegro)": [
            {
                "Region Name": "Ro\u017Eaje (Municipality of Montenegro)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ro\u017Eaje (Municipality of Montenegro)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ro\u017Eaje (Municipality of Montenegro)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ro\u017Eaje (Municipality of Montenegro)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ro\u017Eaje (Municipality of Montenegro)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ro\u017Eaje (Municipality of Montenegro)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ro\u017Eaje (Municipality of Montenegro)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ro\u017Eaje (Municipality of Montenegro)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ro\u017Eaje (Municipality of Montenegro)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ro\u017Eaje (Municipality of Montenegro)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ro\u017Eaje (Municipality of Montenegro)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ro\u017Eaje (Municipality of Montenegro)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ro\u017Eaje (Municipality of Montenegro)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ro\u017Eaje (Municipality of Montenegro)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ro\u017Eaje (Municipality of Montenegro)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ro\u017Eaje (Municipality of Montenegro)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ro\u017Eaje (Municipality of Montenegro)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ro\u017Eaje (Municipality of Montenegro)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ro\u017Eaje (Municipality of Montenegro)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ro\u017Eaje (Municipality of Montenegro)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ro\u017Eaje (Municipality of Montenegro)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ro\u017Eaje (Municipality of Montenegro)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ruggell (Commune of Liechtenstein)": [
            {
                "Region Name": "Ruggell (Commune of Liechtenstein)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ruggell (Commune of Liechtenstein)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ruggell (Commune of Liechtenstein)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ruggell (Commune of Liechtenstein)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ruggell (Commune of Liechtenstein)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ruggell (Commune of Liechtenstein)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ruggell (Commune of Liechtenstein)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ruggell (Commune of Liechtenstein)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ruggell (Commune of Liechtenstein)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ruggell (Commune of Liechtenstein)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ruggell (Commune of Liechtenstein)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ruggell (Commune of Liechtenstein)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ruggell (Commune of Liechtenstein)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ruggell (Commune of Liechtenstein)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ruggell (Commune of Liechtenstein)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ruggell (Commune of Liechtenstein)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ruggell (Commune of Liechtenstein)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ruggell (Commune of Liechtenstein)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ruggell (Commune of Liechtenstein)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ruggell (Commune of Liechtenstein)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ruggell (Commune of Liechtenstein)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ruggell (Commune of Liechtenstein)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rukungiri (District of Uganda)": [
            {
                "Region Name": "Rukungiri (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Rukungiri (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Rukungiri (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Rukungiri (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Rukungiri (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Rukungiri (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rukungiri (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rukungiri (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Rukungiri (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Rukungiri (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Rukungiri (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Rukungiri (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Rukungiri (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Rukungiri (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Rukungiri (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rukungiri (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Rukungiri (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Rukungiri (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rukungiri (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Rukungiri (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Rukungiri (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Rukungiri (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Rukwa (Region of Tanzania)": [
            {
                "Region Name": "Rukwa (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Rukwa (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Rukwa (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Rukwa (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Rukwa (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Rukwa (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rukwa (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Rukwa (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Rukwa (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rukwa (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Rukwa (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Rukwa (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Rukwa (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rukwa (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Rukwa (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Rukwa (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Rukwa (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Rukwa (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Rukwa (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Rukwa (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Rukwa (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Rukwa (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Rum Cay (District of Bahamas)": [
            {
                "Region Name": "Rum Cay (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rum Cay (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rum Cay (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rum Cay (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rum Cay (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rum Cay (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rum Cay (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rum Cay (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rum Cay (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rum Cay (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rum Cay (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rum Cay (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rum Cay (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rum Cay (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rum Cay (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rum Cay (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rum Cay (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rum Cay (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rum Cay (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rum Cay (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rum Cay (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rum Cay (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Rumphi (District of Malawi)": [
            {
                "Region Name": "Rumphi (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Rumphi (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Rumphi (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Rumphi (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Rumphi (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Rumphi (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Rumphi (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Rumphi (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Rumphi (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Rumphi (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Rumphi (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Rumphi (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Rumphi (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Rumphi (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Rumphi (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Rumphi (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Rumphi (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rumphi (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Rumphi (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Rumphi (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Rumphi (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Rumphi (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Ruse (Province of Bulgaria)": [
            {
                "Region Name": "Ruse (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ruse (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ruse (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ruse (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ruse (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ruse (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ruse (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ruse (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ruse (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ruse (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ruse (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ruse (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ruse (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ruse (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ruse (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ruse (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ruse (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ruse (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ruse (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ruse (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ruse (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ruse (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Rutana (Province of Burundi)": [
            {
                "Region Name": "Rutana (Province of Burundi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rutana (Province of Burundi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rutana (Province of Burundi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rutana (Province of Burundi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rutana (Province of Burundi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rutana (Province of Burundi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rutana (Province of Burundi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Rutana (Province of Burundi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rutana (Province of Burundi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rutana (Province of Burundi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rutana (Province of Burundi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rutana (Province of Burundi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rutana (Province of Burundi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rutana (Province of Burundi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rutana (Province of Burundi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Rutana (Province of Burundi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Rutana (Province of Burundi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Rutana (Province of Burundi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rutana (Province of Burundi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rutana (Province of Burundi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Rutana (Province of Burundi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Rutana (Province of Burundi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ruvuma (Region of Tanzania)": [
            {
                "Region Name": "Ruvuma (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ruvuma (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ruvuma (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ruvuma (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ruvuma (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ruvuma (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ruvuma (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ruvuma (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ruvuma (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ruvuma (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ruvuma (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ruvuma (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ruvuma (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ruvuma (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ruvuma (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ruvuma (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ruvuma (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ruvuma (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ruvuma (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ruvuma (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ruvuma (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ruvuma (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Ruyigi (Province of Burundi)": [
            {
                "Region Name": "Ruyigi (Province of Burundi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Ruyigi (Province of Burundi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ruyigi (Province of Burundi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ruyigi (Province of Burundi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ruyigi (Province of Burundi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ruyigi (Province of Burundi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ruyigi (Province of Burundi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ruyigi (Province of Burundi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ruyigi (Province of Burundi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ruyigi (Province of Burundi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ruyigi (Province of Burundi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ruyigi (Province of Burundi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ruyigi (Province of Burundi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ruyigi (Province of Burundi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ruyigi (Province of Burundi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ruyigi (Province of Burundi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ruyigi (Province of Burundi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Ruyigi (Province of Burundi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Ruyigi (Province of Burundi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ruyigi (Province of Burundi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ruyigi (Province of Burundi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ruyigi (Province of Burundi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Ryanggang (Province of North Korea)": [
            {
                "Region Name": "Ryanggang (Province of North Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ryanggang (Province of North Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ryanggang (Province of North Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ryanggang (Province of North Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ryanggang (Province of North Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ryanggang (Province of North Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ryanggang (Province of North Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ryanggang (Province of North Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ryanggang (Province of North Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ryanggang (Province of North Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ryanggang (Province of North Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ryanggang (Province of North Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ryanggang (Province of North Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ryanggang (Province of North Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ryanggang (Province of North Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ryanggang (Province of North Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ryanggang (Province of North Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Ryanggang (Province of North Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ryanggang (Province of North Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ryanggang (Province of North Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ryanggang (Province of North Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ryanggang (Province of North Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ryazan' (Region of Russia)": [
            {
                "Region Name": "Ryazan' (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ryazan' (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ryazan' (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ryazan' (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ryazan' (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ryazan' (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ryazan' (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ryazan' (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ryazan' (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ryazan' (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ryazan' (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ryazan' (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ryazan' (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ryazan' (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ryazan' (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ryazan' (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ryazan' (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ryazan' (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ryazan' (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ryazan' (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ryazan' (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 91
            },
            {
                "Region Name": "Ryazan' (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Sa Kaeo (Province of Thailand)": [
            {
                "Region Name": "Sa Kaeo (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sa Kaeo (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sa Kaeo (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sa Kaeo (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sa Kaeo (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sa Kaeo (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sa Kaeo (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sa Kaeo (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sa Kaeo (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sa Kaeo (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sa Kaeo (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sa Kaeo (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sa Kaeo (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sa Kaeo (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sa Kaeo (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sa Kaeo (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sa Kaeo (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sa Kaeo (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sa Kaeo (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sa Kaeo (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sa Kaeo (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sa Kaeo (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Sa`dah (Governorate of Yemen)": [
            {
                "Region Name": "Sa`dah (Governorate of Yemen)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa`dah (Governorate of Yemen)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa`dah (Governorate of Yemen)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa`dah (Governorate of Yemen)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa`dah (Governorate of Yemen)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa`dah (Governorate of Yemen)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa`dah (Governorate of Yemen)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa`dah (Governorate of Yemen)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa`dah (Governorate of Yemen)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa`dah (Governorate of Yemen)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa`dah (Governorate of Yemen)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa`dah (Governorate of Yemen)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa`dah (Governorate of Yemen)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa`dah (Governorate of Yemen)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa`dah (Governorate of Yemen)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa`dah (Governorate of Yemen)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa`dah (Governorate of Yemen)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa`dah (Governorate of Yemen)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa`dah (Governorate of Yemen)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa`dah (Governorate of Yemen)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa`dah (Governorate of Yemen)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa`dah (Governorate of Yemen)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Saare (County of Estonia)": [
            {
                "Region Name": "Saare (County of Estonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saare (County of Estonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saare (County of Estonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saare (County of Estonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saare (County of Estonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saare (County of Estonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saare (County of Estonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saare (County of Estonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saare (County of Estonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saare (County of Estonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saare (County of Estonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saare (County of Estonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saare (County of Estonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saare (County of Estonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saare (County of Estonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saare (County of Estonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saare (County of Estonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saare (County of Estonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saare (County of Estonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saare (County of Estonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saare (County of Estonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saare (County of Estonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saarland (State of Germany)": [
            {
                "Region Name": "Saarland (State of Germany)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saarland (State of Germany)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saarland (State of Germany)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saarland (State of Germany)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saarland (State of Germany)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Saarland (State of Germany)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saarland (State of Germany)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saarland (State of Germany)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saarland (State of Germany)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saarland (State of Germany)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saarland (State of Germany)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saarland (State of Germany)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saarland (State of Germany)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saarland (State of Germany)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saarland (State of Germany)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saarland (State of Germany)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saarland (State of Germany)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saarland (State of Germany)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saarland (State of Germany)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saarland (State of Germany)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saarland (State of Germany)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saarland (State of Germany)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saba (Municipality of Bonaire, Sint Eustatius and Saba)": [
            {
                "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saba (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sabah (State of Malaysia)": [
            {
                "Region Name": "Sabah (State of Malaysia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sabah (State of Malaysia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sabah (State of Malaysia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sabah (State of Malaysia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sabah (State of Malaysia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sabah (State of Malaysia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sabah (State of Malaysia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sabah (State of Malaysia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sabah (State of Malaysia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sabah (State of Malaysia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sabah (State of Malaysia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sabah (State of Malaysia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sabah (State of Malaysia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sabah (State of Malaysia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sabah (State of Malaysia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sabah (State of Malaysia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabah (State of Malaysia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sabah (State of Malaysia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sabah (State of Malaysia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sabah (State of Malaysia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabah (State of Malaysia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabah (State of Malaysia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Sabana Grande (Municipality of Puerto Rico)": [
            {
                "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabana Grande (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sabha (District of Libya)": [
            {
                "Region Name": "Sabha (District of Libya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabha (District of Libya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabha (District of Libya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabha (District of Libya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabha (District of Libya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabha (District of Libya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabha (District of Libya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabha (District of Libya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabha (District of Libya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabha (District of Libya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sabha (District of Libya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabha (District of Libya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabha (District of Libya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabha (District of Libya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabha (District of Libya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabha (District of Libya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabha (District of Libya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabha (District of Libya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sabha (District of Libya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabha (District of Libya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabha (District of Libya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sabha (District of Libya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sacatep\xe9quez (Department of Guatemala)": [
            {
                "Region Name": "Sacatep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sacatep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sacatep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sacatep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sacatep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sacatep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sacatep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sacatep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sacatep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sacatep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sacatep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sacatep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sacatep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sacatep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sacatep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sacatep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sacatep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sacatep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sacatep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sacatep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sacatep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sacatep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Sachsen-Anhalt (State of Germany)": [
            {
                "Region Name": "Sachsen-Anhalt (State of Germany)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen-Anhalt (State of Germany)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen-Anhalt (State of Germany)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen-Anhalt (State of Germany)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen-Anhalt (State of Germany)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sachsen-Anhalt (State of Germany)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen-Anhalt (State of Germany)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sachsen-Anhalt (State of Germany)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen-Anhalt (State of Germany)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen-Anhalt (State of Germany)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen-Anhalt (State of Germany)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen-Anhalt (State of Germany)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sachsen-Anhalt (State of Germany)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen-Anhalt (State of Germany)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sachsen-Anhalt (State of Germany)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen-Anhalt (State of Germany)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen-Anhalt (State of Germany)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sachsen-Anhalt (State of Germany)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sachsen-Anhalt (State of Germany)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen-Anhalt (State of Germany)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen-Anhalt (State of Germany)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen-Anhalt (State of Germany)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sachsen (State of Germany)": [
            {
                "Region Name": "Sachsen (State of Germany)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen (State of Germany)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sachsen (State of Germany)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen (State of Germany)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sachsen (State of Germany)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen (State of Germany)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen (State of Germany)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sachsen (State of Germany)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen (State of Germany)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen (State of Germany)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen (State of Germany)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen (State of Germany)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen (State of Germany)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen (State of Germany)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sachsen (State of Germany)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen (State of Germany)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen (State of Germany)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen (State of Germany)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen (State of Germany)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen (State of Germany)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sachsen (State of Germany)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sachsen (State of Germany)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sada (Commune of Mayotte)": [
            {
                "Region Name": "Sada (Commune of Mayotte)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sada (Commune of Mayotte)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sada (Commune of Mayotte)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sada (Commune of Mayotte)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sada (Commune of Mayotte)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sada (Commune of Mayotte)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sada (Commune of Mayotte)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sada (Commune of Mayotte)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sada (Commune of Mayotte)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sada (Commune of Mayotte)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sada (Commune of Mayotte)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sada (Commune of Mayotte)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sada (Commune of Mayotte)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sada (Commune of Mayotte)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sada (Commune of Mayotte)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sada (Commune of Mayotte)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sada (Commune of Mayotte)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sada (Commune of Mayotte)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sada (Commune of Mayotte)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sada (Commune of Mayotte)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sada (Commune of Mayotte)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sada (Commune of Mayotte)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saga (Prefecture of Japan)": [
            {
                "Region Name": "Saga (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saga (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saga (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saga (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saga (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saga (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saga (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saga (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saga (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saga (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saga (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saga (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saga (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Saga (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saga (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saga (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saga (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saga (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saga (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saga (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saga (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saga (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sagaing (Division of Myanmar)": [
            {
                "Region Name": "Sagaing (Division of Myanmar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Sagaing (Division of Myanmar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sagaing (Division of Myanmar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sagaing (Division of Myanmar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sagaing (Division of Myanmar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sagaing (Division of Myanmar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sagaing (Division of Myanmar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Sagaing (Division of Myanmar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sagaing (Division of Myanmar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Sagaing (Division of Myanmar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sagaing (Division of Myanmar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sagaing (Division of Myanmar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sagaing (Division of Myanmar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sagaing (Division of Myanmar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Sagaing (Division of Myanmar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sagaing (Division of Myanmar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sagaing (Division of Myanmar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sagaing (Division of Myanmar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sagaing (Division of Myanmar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Sagaing (Division of Myanmar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sagaing (Division of Myanmar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sagaing (Division of Myanmar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Sahel (Region of Burkina Faso)": [
            {
                "Region Name": "Sahel (Region of Burkina Faso)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sahel (Region of Burkina Faso)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sahel (Region of Burkina Faso)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sahel (Region of Burkina Faso)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sahel (Region of Burkina Faso)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sahel (Region of Burkina Faso)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sahel (Region of Burkina Faso)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sahel (Region of Burkina Faso)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sahel (Region of Burkina Faso)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sahel (Region of Burkina Faso)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sahel (Region of Burkina Faso)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sahel (Region of Burkina Faso)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sahel (Region of Burkina Faso)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sahel (Region of Burkina Faso)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sahel (Region of Burkina Faso)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sahel (Region of Burkina Faso)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sahel (Region of Burkina Faso)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sahel (Region of Burkina Faso)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Sahel (Region of Burkina Faso)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Sahel (Region of Burkina Faso)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 97
            },
            {
                "Region Name": "Sahel (Region of Burkina Faso)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Sahel (Region of Burkina Faso)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 78
            }
        ],
        "Sa\xefda (Province of Algeria)": [
            {
                "Region Name": "Sa\xefda (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sa\xefda (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Sa\xefda (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sa\xefda (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sa\xefda (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sa\xefda (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sa\xefda (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa\xefda (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Sa\xefda (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sa\xefda (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa\xefda (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sa\xefda (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Sa\xefda (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sa\xefda (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sa\xefda (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa\xefda (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sa\xefda (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa\xefda (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sa\xefda (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Sa\xefda (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa\xefda (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sa\xefda (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint-Beno\xeet (Arrondissement of R\xe9union)": [
            {
                "Region Name": "Saint-Beno\xeet (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Beno\xeet (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Beno\xeet (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Beno\xeet (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Beno\xeet (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Beno\xeet (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Beno\xeet (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Beno\xeet (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Beno\xeet (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Beno\xeet (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Beno\xeet (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Beno\xeet (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Beno\xeet (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Beno\xeet (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Beno\xeet (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Beno\xeet (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Beno\xeet (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Beno\xeet (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Beno\xeet (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Beno\xeet (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Beno\xeet (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Beno\xeet (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint-Denis (Arrondissement of R\xe9union)": [
            {
                "Region Name": "Saint-Denis (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Denis (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Denis (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Denis (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Denis (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Denis (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Denis (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Denis (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Denis (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Denis (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Denis (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Denis (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Denis (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Denis (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Denis (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Denis (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Denis (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Denis (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Denis (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Denis (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Denis (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Denis (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)": [
            {
                "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Laurent-du-Maroni (Arrondissement of French Guiana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Saint-Louis (Region of Senegal)": [
            {
                "Region Name": "Saint-Louis (Region of Senegal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Saint-Louis (Region of Senegal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Saint-Louis (Region of Senegal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Saint-Louis (Region of Senegal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 68
            },
            {
                "Region Name": "Saint-Louis (Region of Senegal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 106
            },
            {
                "Region Name": "Saint-Louis (Region of Senegal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Saint-Louis (Region of Senegal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Saint-Louis (Region of Senegal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Saint-Louis (Region of Senegal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Saint-Louis (Region of Senegal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 73
            },
            {
                "Region Name": "Saint-Louis (Region of Senegal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Saint-Louis (Region of Senegal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Saint-Louis (Region of Senegal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saint-Louis (Region of Senegal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Saint-Louis (Region of Senegal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Saint-Louis (Region of Senegal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Saint-Louis (Region of Senegal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Saint-Louis (Region of Senegal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Saint-Louis (Region of Senegal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Saint-Louis (Region of Senegal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Saint-Louis (Region of Senegal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Saint-Louis (Region of Senegal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Saint-Paul (Arrondissement of R\xe9union)": [
            {
                "Region Name": "Saint-Paul (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Paul (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Paul (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Paul (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Paul (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Paul (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Paul (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Paul (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Paul (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Saint-Paul (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Saint-Paul (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Paul (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Paul (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Paul (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Paul (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Paul (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Paul (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Paul (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Paul (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Paul (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Paul (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Paul (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint-Pierre (Arrondissement of Martinique)": [
            {
                "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of Martinique)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint-Pierre (Arrondissement of R\xe9union)": [
            {
                "Region Name": "Saint-Pierre (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Arrondissement of R\xe9union)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint-Pierre (Commune of Saint Pierre and Miquelon)": [
            {
                "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint-Pierre (Commune of Saint Pierre and Miquelon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Andrew (Parish of Barbados)": [
            {
                "Region Name": "Saint Andrew (Parish of Barbados)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Barbados)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Barbados)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Barbados)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Barbados)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Barbados)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Barbados)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Barbados)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Barbados)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Barbados)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Barbados)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Barbados)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Barbados)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Barbados)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Barbados)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Barbados)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Barbados)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Barbados)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Barbados)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Barbados)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Barbados)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Barbados)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Andrew (Parish of Dominica)": [
            {
                "Region Name": "Saint Andrew (Parish of Dominica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Dominica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Dominica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Dominica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Dominica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Dominica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Dominica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Dominica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Dominica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Dominica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Dominica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Dominica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Dominica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Dominica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Dominica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Dominica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Dominica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Dominica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Dominica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Dominica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Dominica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Dominica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Andrew (Parish of Grenada)": [
            {
                "Region Name": "Saint Andrew (Parish of Grenada)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Grenada)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Grenada)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Grenada)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Grenada)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Grenada)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Grenada)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Grenada)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Grenada)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Grenada)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Grenada)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Grenada)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Grenada)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Grenada)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Grenada)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Grenada)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Grenada)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Grenada)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Grenada)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Grenada)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Grenada)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Grenada)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Saint Andrew (Parish of Guernsey)": [
            {
                "Region Name": "Saint Andrew (Parish of Guernsey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Guernsey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Guernsey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Guernsey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Guernsey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Guernsey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Guernsey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Guernsey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Guernsey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Guernsey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Guernsey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Guernsey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Guernsey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Guernsey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Guernsey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Guernsey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Guernsey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Guernsey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Guernsey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Guernsey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Guernsey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Guernsey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Andrew (Parish of Jamaica)": [
            {
                "Region Name": "Saint Andrew (Parish of Jamaica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Jamaica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Jamaica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Jamaica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Jamaica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Jamaica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Jamaica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Jamaica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Jamaica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Jamaica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Jamaica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Jamaica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Jamaica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saint Andrew (Parish of Jamaica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saint Andrew (Parish of Jamaica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Jamaica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Jamaica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Jamaica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Jamaica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Jamaica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Jamaica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Jamaica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Andrew (Parish of Saint Vincent and the Grenadines)": [
            {
                "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Andrew (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Ann (Parish of Jamaica)": [
            {
                "Region Name": "Saint Ann (Parish of Jamaica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ann (Parish of Jamaica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ann (Parish of Jamaica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ann (Parish of Jamaica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ann (Parish of Jamaica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ann (Parish of Jamaica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ann (Parish of Jamaica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ann (Parish of Jamaica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ann (Parish of Jamaica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ann (Parish of Jamaica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ann (Parish of Jamaica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ann (Parish of Jamaica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ann (Parish of Jamaica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saint Ann (Parish of Jamaica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ann (Parish of Jamaica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ann (Parish of Jamaica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ann (Parish of Jamaica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ann (Parish of Jamaica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ann (Parish of Jamaica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ann (Parish of Jamaica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ann (Parish of Jamaica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ann (Parish of Jamaica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Anne Sandy Point (Parish of Saint Kitts and Nevis)": [
            {
                "Region Name": "Saint Anne Sandy Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anne Sandy Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anne Sandy Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anne Sandy Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anne Sandy Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anne Sandy Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anne Sandy Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anne Sandy Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anne Sandy Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anne Sandy Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anne Sandy Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anne Sandy Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anne Sandy Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anne Sandy Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anne Sandy Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anne Sandy Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anne Sandy Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anne Sandy Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anne Sandy Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anne Sandy Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anne Sandy Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anne Sandy Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Anthon (Parish of Montserrat)": [
            {
                "Region Name": "Saint Anthon (Parish of Montserrat)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anthon (Parish of Montserrat)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anthon (Parish of Montserrat)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anthon (Parish of Montserrat)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anthon (Parish of Montserrat)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anthon (Parish of Montserrat)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anthon (Parish of Montserrat)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anthon (Parish of Montserrat)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anthon (Parish of Montserrat)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anthon (Parish of Montserrat)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anthon (Parish of Montserrat)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anthon (Parish of Montserrat)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anthon (Parish of Montserrat)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anthon (Parish of Montserrat)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anthon (Parish of Montserrat)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anthon (Parish of Montserrat)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anthon (Parish of Montserrat)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anthon (Parish of Montserrat)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anthon (Parish of Montserrat)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anthon (Parish of Montserrat)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anthon (Parish of Montserrat)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Anthon (Parish of Montserrat)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Berlade (Parish of Jersey)": [
            {
                "Region Name": "Saint Berlade (Parish of Jersey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Berlade (Parish of Jersey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Berlade (Parish of Jersey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Berlade (Parish of Jersey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Berlade (Parish of Jersey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Berlade (Parish of Jersey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Berlade (Parish of Jersey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Berlade (Parish of Jersey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Berlade (Parish of Jersey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Berlade (Parish of Jersey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Berlade (Parish of Jersey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Berlade (Parish of Jersey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Berlade (Parish of Jersey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Berlade (Parish of Jersey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Berlade (Parish of Jersey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Berlade (Parish of Jersey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Berlade (Parish of Jersey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Berlade (Parish of Jersey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Berlade (Parish of Jersey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Berlade (Parish of Jersey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Berlade (Parish of Jersey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Berlade (Parish of Jersey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Brandon (Region of Mauritius)": [
            {
                "Region Name": "Saint Brandon (Region of Mauritius)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Brandon (Region of Mauritius)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Brandon (Region of Mauritius)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Brandon (Region of Mauritius)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Brandon (Region of Mauritius)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Brandon (Region of Mauritius)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Brandon (Region of Mauritius)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Brandon (Region of Mauritius)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Brandon (Region of Mauritius)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Brandon (Region of Mauritius)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Brandon (Region of Mauritius)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Brandon (Region of Mauritius)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Brandon (Region of Mauritius)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Brandon (Region of Mauritius)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Brandon (Region of Mauritius)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Brandon (Region of Mauritius)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Brandon (Region of Mauritius)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Brandon (Region of Mauritius)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Brandon (Region of Mauritius)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Brandon (Region of Mauritius)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Brandon (Region of Mauritius)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Brandon (Region of Mauritius)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Catherine (Parish of Jamaica)": [
            {
                "Region Name": "Saint Catherine (Parish of Jamaica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Saint Catherine (Parish of Jamaica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saint Catherine (Parish of Jamaica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Catherine (Parish of Jamaica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Saint Catherine (Parish of Jamaica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saint Catherine (Parish of Jamaica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Catherine (Parish of Jamaica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Catherine (Parish of Jamaica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Catherine (Parish of Jamaica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Catherine (Parish of Jamaica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saint Catherine (Parish of Jamaica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saint Catherine (Parish of Jamaica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Catherine (Parish of Jamaica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Catherine (Parish of Jamaica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Catherine (Parish of Jamaica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saint Catherine (Parish of Jamaica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saint Catherine (Parish of Jamaica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Saint Catherine (Parish of Jamaica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Saint Catherine (Parish of Jamaica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saint Catherine (Parish of Jamaica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Catherine (Parish of Jamaica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saint Catherine (Parish of Jamaica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Saint Clement (Parish of Jersey)": [
            {
                "Region Name": "Saint Clement (Parish of Jersey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Clement (Parish of Jersey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Clement (Parish of Jersey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Clement (Parish of Jersey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Clement (Parish of Jersey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Clement (Parish of Jersey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Clement (Parish of Jersey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Clement (Parish of Jersey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Clement (Parish of Jersey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Clement (Parish of Jersey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Clement (Parish of Jersey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Clement (Parish of Jersey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Clement (Parish of Jersey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Clement (Parish of Jersey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Clement (Parish of Jersey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Clement (Parish of Jersey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Clement (Parish of Jersey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Clement (Parish of Jersey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Clement (Parish of Jersey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Clement (Parish of Jersey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Clement (Parish of Jersey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Clement (Parish of Jersey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Croix (District of Virgin Islands, U.S.)": [
            {
                "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Croix (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint David (Parish of Dominica)": [
            {
                "Region Name": "Saint David (Parish of Dominica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Dominica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Dominica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Dominica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Dominica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Dominica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Dominica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Dominica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Dominica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Dominica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Dominica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Dominica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Dominica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Dominica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Dominica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Dominica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Dominica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Dominica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Dominica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Dominica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Dominica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Dominica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint David (Parish of Grenada)": [
            {
                "Region Name": "Saint David (Parish of Grenada)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Grenada)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Grenada)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Grenada)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Grenada)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Grenada)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Grenada)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Grenada)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Grenada)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Grenada)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Grenada)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Grenada)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Grenada)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Grenada)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Grenada)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Grenada)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Grenada)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Grenada)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Grenada)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Grenada)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Grenada)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Grenada)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint David (Parish of Saint Vincent and the Grenadines)": [
            {
                "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint David (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Elizabeth (Parish of Jamaica)": [
            {
                "Region Name": "Saint Elizabeth (Parish of Jamaica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saint Elizabeth (Parish of Jamaica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Elizabeth (Parish of Jamaica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Elizabeth (Parish of Jamaica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Saint Elizabeth (Parish of Jamaica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Saint Elizabeth (Parish of Jamaica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Elizabeth (Parish of Jamaica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Elizabeth (Parish of Jamaica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saint Elizabeth (Parish of Jamaica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Saint Elizabeth (Parish of Jamaica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saint Elizabeth (Parish of Jamaica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Saint Elizabeth (Parish of Jamaica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saint Elizabeth (Parish of Jamaica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saint Elizabeth (Parish of Jamaica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Elizabeth (Parish of Jamaica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Elizabeth (Parish of Jamaica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Elizabeth (Parish of Jamaica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Saint Elizabeth (Parish of Jamaica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Elizabeth (Parish of Jamaica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Elizabeth (Parish of Jamaica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Elizabeth (Parish of Jamaica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Elizabeth (Parish of Jamaica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint George's (Parish of Bermuda)": [
            {
                "Region Name": "Saint George's (Parish of Bermuda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George's (Parish of Bermuda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George's (Parish of Bermuda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George's (Parish of Bermuda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George's (Parish of Bermuda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George's (Parish of Bermuda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George's (Parish of Bermuda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George's (Parish of Bermuda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George's (Parish of Bermuda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George's (Parish of Bermuda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George's (Parish of Bermuda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George's (Parish of Bermuda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George's (Parish of Bermuda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George's (Parish of Bermuda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George's (Parish of Bermuda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George's (Parish of Bermuda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George's (Parish of Bermuda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George's (Parish of Bermuda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George's (Parish of Bermuda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George's (Parish of Bermuda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George's (Parish of Bermuda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George's (Parish of Bermuda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint George (Parish of Antigua and Barbuda)": [
            {
                "Region Name": "Saint George (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint George (Parish of Barbados)": [
            {
                "Region Name": "Saint George (Parish of Barbados)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Barbados)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Barbados)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Barbados)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Barbados)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Barbados)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Barbados)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Barbados)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Barbados)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Barbados)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Barbados)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Barbados)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Barbados)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Barbados)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Barbados)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Barbados)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Barbados)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Barbados)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Barbados)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Barbados)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Barbados)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Barbados)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint George (Parish of Dominica)": [
            {
                "Region Name": "Saint George (Parish of Dominica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Dominica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Dominica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Dominica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Dominica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Dominica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Dominica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Dominica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Dominica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Dominica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Dominica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Dominica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Dominica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Dominica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Dominica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Dominica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Dominica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Dominica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Dominica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Dominica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Dominica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Dominica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint George (Parish of Grenada)": [
            {
                "Region Name": "Saint George (Parish of Grenada)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Grenada)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Grenada)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Grenada)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Grenada)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Grenada)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Grenada)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Grenada)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Grenada)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Grenada)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Grenada)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Grenada)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Grenada)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Grenada)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Grenada)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Grenada)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Grenada)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Grenada)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Grenada)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Grenada)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Grenada)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Grenada)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint George (Parish of Saint Vincent and the Grenadines)": [
            {
                "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint George Basseterre (Parish of Saint Kitts and Nevis)": [
            {
                "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint George Gingerland (Parish of Saint Kitts and Nevis)": [
            {
                "Region Name": "Saint George Gingerland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Gingerland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Gingerland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Gingerland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Gingerland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Gingerland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Gingerland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Gingerland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Gingerland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Gingerland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Gingerland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Gingerland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Gingerland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Gingerland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Gingerland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Gingerland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Gingerland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Gingerland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Gingerland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Gingerland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Gingerland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George Gingerland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint George municipality (Municipality of Bermuda)": [
            {
                "Region Name": "Saint George municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint George municipality (Municipality of Bermuda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Georges (Parish of Montserrat)": [
            {
                "Region Name": "Saint Georges (Parish of Montserrat)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Georges (Parish of Montserrat)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Georges (Parish of Montserrat)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Georges (Parish of Montserrat)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Georges (Parish of Montserrat)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Georges (Parish of Montserrat)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Georges (Parish of Montserrat)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Georges (Parish of Montserrat)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Saint Georges (Parish of Montserrat)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Georges (Parish of Montserrat)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Georges (Parish of Montserrat)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Georges (Parish of Montserrat)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Georges (Parish of Montserrat)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Georges (Parish of Montserrat)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Georges (Parish of Montserrat)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Georges (Parish of Montserrat)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Georges (Parish of Montserrat)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Georges (Parish of Montserrat)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Georges (Parish of Montserrat)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Georges (Parish of Montserrat)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Georges (Parish of Montserrat)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Georges (Parish of Montserrat)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Helena (Dependency of Saint Helena, Ascension and Tris)": [
            {
                "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helena (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Helier (Parish of Jersey)": [
            {
                "Region Name": "Saint Helier (Parish of Jersey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helier (Parish of Jersey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helier (Parish of Jersey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helier (Parish of Jersey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helier (Parish of Jersey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helier (Parish of Jersey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helier (Parish of Jersey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helier (Parish of Jersey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helier (Parish of Jersey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helier (Parish of Jersey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helier (Parish of Jersey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helier (Parish of Jersey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helier (Parish of Jersey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helier (Parish of Jersey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helier (Parish of Jersey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helier (Parish of Jersey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helier (Parish of Jersey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helier (Parish of Jersey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helier (Parish of Jersey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helier (Parish of Jersey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helier (Parish of Jersey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Helier (Parish of Jersey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint James (Parish of Barbados)": [
            {
                "Region Name": "Saint James (Parish of Barbados)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Barbados)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Barbados)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Barbados)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Barbados)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Barbados)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Barbados)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Barbados)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Barbados)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Barbados)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Barbados)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Barbados)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Barbados)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Barbados)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Barbados)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Barbados)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Barbados)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Barbados)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Barbados)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Barbados)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Barbados)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Barbados)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint James (Parish of Jamaica)": [
            {
                "Region Name": "Saint James (Parish of Jamaica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Jamaica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Jamaica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Jamaica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Jamaica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Jamaica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Jamaica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Jamaica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Jamaica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Jamaica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Jamaica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Jamaica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Jamaica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Jamaica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Jamaica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Jamaica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Jamaica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Jamaica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Jamaica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saint James (Parish of Jamaica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Jamaica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James (Parish of Jamaica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Saint James Windward (Parish of Saint Kitts and Nevis)": [
            {
                "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint James Windward (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint John (District of Virgin Islands, U.S.)": [
            {
                "Region Name": "Saint John (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint John (Parish of Antigua and Barbuda)": [
            {
                "Region Name": "Saint John (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint John (Parish of Barbados)": [
            {
                "Region Name": "Saint John (Parish of Barbados)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Barbados)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Barbados)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Barbados)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Barbados)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Barbados)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Barbados)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Barbados)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Barbados)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Barbados)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Barbados)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Barbados)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Barbados)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Barbados)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Barbados)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Barbados)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Barbados)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Barbados)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Barbados)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Barbados)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Barbados)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Barbados)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Saint John (Parish of Dominica)": [
            {
                "Region Name": "Saint John (Parish of Dominica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Dominica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Dominica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Dominica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Dominica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Dominica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Dominica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Dominica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Dominica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Dominica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Dominica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Dominica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Dominica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Dominica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Dominica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Dominica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Dominica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Dominica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Dominica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Dominica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Dominica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Dominica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint John (Parish of Grenada)": [
            {
                "Region Name": "Saint John (Parish of Grenada)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Grenada)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Grenada)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Grenada)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Grenada)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Grenada)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Grenada)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Grenada)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Grenada)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Grenada)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Grenada)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Grenada)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Grenada)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Grenada)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Grenada)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Grenada)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Grenada)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Grenada)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Grenada)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Grenada)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Grenada)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Grenada)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint John (Parish of Jersey)": [
            {
                "Region Name": "Saint John (Parish of Jersey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Jersey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Jersey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Jersey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Jersey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Jersey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Jersey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Jersey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Jersey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Jersey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Jersey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Jersey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Jersey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Jersey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Jersey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Jersey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Jersey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Jersey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Jersey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Jersey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Jersey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John (Parish of Jersey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint John Capisterre (Parish of Saint Kitts and Nevis)": [
            {
                "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint John Figtree (Parish of Saint Kitts and Nevis)": [
            {
                "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint John Figtree (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Joseph (Parish of Barbados)": [
            {
                "Region Name": "Saint Joseph (Parish of Barbados)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Barbados)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Barbados)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Barbados)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Barbados)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Barbados)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Barbados)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Barbados)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Barbados)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Barbados)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Barbados)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Barbados)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Barbados)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Barbados)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Barbados)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Barbados)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Barbados)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Barbados)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Barbados)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Barbados)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Barbados)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Barbados)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Joseph (Parish of Dominica)": [
            {
                "Region Name": "Saint Joseph (Parish of Dominica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Dominica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Dominica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Dominica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Dominica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Dominica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Dominica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Dominica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Dominica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Dominica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Dominica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Dominica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Dominica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Dominica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Dominica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Dominica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Dominica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Dominica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Dominica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Dominica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Dominica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Joseph (Parish of Dominica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Lawrence (Parish of Jersey)": [
            {
                "Region Name": "Saint Lawrence (Parish of Jersey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lawrence (Parish of Jersey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lawrence (Parish of Jersey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lawrence (Parish of Jersey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lawrence (Parish of Jersey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lawrence (Parish of Jersey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lawrence (Parish of Jersey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lawrence (Parish of Jersey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lawrence (Parish of Jersey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lawrence (Parish of Jersey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lawrence (Parish of Jersey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lawrence (Parish of Jersey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lawrence (Parish of Jersey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lawrence (Parish of Jersey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lawrence (Parish of Jersey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lawrence (Parish of Jersey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lawrence (Parish of Jersey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lawrence (Parish of Jersey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lawrence (Parish of Jersey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lawrence (Parish of Jersey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lawrence (Parish of Jersey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lawrence (Parish of Jersey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Louis (District of Seychelles)": [
            {
                "Region Name": "Saint Louis (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Louis (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Louis (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Louis (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Louis (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Louis (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Louis (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Louis (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Louis (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Louis (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Louis (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Louis (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Louis (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Louis (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Louis (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Louis (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Louis (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Louis (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Louis (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Louis (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Louis (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Louis (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Lucy (Parish of Barbados)": [
            {
                "Region Name": "Saint Lucy (Parish of Barbados)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucy (Parish of Barbados)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucy (Parish of Barbados)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucy (Parish of Barbados)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucy (Parish of Barbados)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucy (Parish of Barbados)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucy (Parish of Barbados)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucy (Parish of Barbados)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucy (Parish of Barbados)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucy (Parish of Barbados)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucy (Parish of Barbados)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucy (Parish of Barbados)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucy (Parish of Barbados)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucy (Parish of Barbados)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucy (Parish of Barbados)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucy (Parish of Barbados)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucy (Parish of Barbados)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucy (Parish of Barbados)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucy (Parish of Barbados)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucy (Parish of Barbados)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucy (Parish of Barbados)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Lucy (Parish of Barbados)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Luke (Parish of Dominica)": [
            {
                "Region Name": "Saint Luke (Parish of Dominica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Luke (Parish of Dominica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Luke (Parish of Dominica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Luke (Parish of Dominica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Luke (Parish of Dominica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Luke (Parish of Dominica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Luke (Parish of Dominica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Luke (Parish of Dominica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Luke (Parish of Dominica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Luke (Parish of Dominica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Luke (Parish of Dominica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Luke (Parish of Dominica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Luke (Parish of Dominica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Luke (Parish of Dominica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Luke (Parish of Dominica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Luke (Parish of Dominica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Luke (Parish of Dominica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Luke (Parish of Dominica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Luke (Parish of Dominica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Luke (Parish of Dominica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Luke (Parish of Dominica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Luke (Parish of Dominica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Mark (Parish of Dominica)": [
            {
                "Region Name": "Saint Mark (Parish of Dominica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Dominica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Dominica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Dominica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Dominica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Dominica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Dominica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Dominica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Dominica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Dominica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Dominica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Dominica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Dominica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Dominica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Dominica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Dominica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Dominica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Dominica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Dominica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Dominica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Dominica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Dominica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Mark (Parish of Grenada)": [
            {
                "Region Name": "Saint Mark (Parish of Grenada)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Grenada)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Grenada)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Grenada)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Grenada)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Grenada)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Grenada)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Grenada)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Grenada)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Grenada)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Grenada)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Grenada)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Grenada)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Grenada)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Grenada)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Grenada)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Grenada)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Grenada)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Grenada)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Grenada)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Grenada)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mark (Parish of Grenada)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Martin (Parish of Guernsey)": [
            {
                "Region Name": "Saint Martin (Parish of Guernsey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Guernsey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Guernsey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Guernsey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Guernsey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Guernsey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Guernsey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Guernsey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Guernsey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Guernsey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Guernsey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Guernsey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Guernsey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Guernsey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Guernsey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Guernsey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Guernsey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Guernsey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Guernsey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Guernsey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Guernsey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Guernsey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Martin (Parish of Jersey)": [
            {
                "Region Name": "Saint Martin (Parish of Jersey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Jersey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Jersey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Jersey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Jersey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Jersey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Jersey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Jersey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Jersey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Jersey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Jersey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Jersey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Jersey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Jersey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Jersey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Jersey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Jersey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Jersey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Jersey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Jersey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Jersey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Martin (Parish of Jersey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Mary (Parish of Antigua and Barbuda)": [
            {
                "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Mary (Parish of Jamaica)": [
            {
                "Region Name": "Saint Mary (Parish of Jamaica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jamaica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jamaica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jamaica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jamaica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jamaica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jamaica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jamaica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jamaica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jamaica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jamaica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jamaica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jamaica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jamaica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jamaica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jamaica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jamaica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jamaica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jamaica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jamaica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jamaica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jamaica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Mary (Parish of Jersey)": [
            {
                "Region Name": "Saint Mary (Parish of Jersey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jersey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jersey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jersey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jersey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jersey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jersey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jersey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jersey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jersey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jersey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jersey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jersey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jersey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jersey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jersey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jersey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jersey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jersey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jersey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jersey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary (Parish of Jersey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Mary Cayon (Parish of Saint Kitts and Nevis)": [
            {
                "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Mary Cayon (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Michael (Parish of Barbados)": [
            {
                "Region Name": "Saint Michael (Parish of Barbados)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Michael (Parish of Barbados)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Michael (Parish of Barbados)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Michael (Parish of Barbados)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Michael (Parish of Barbados)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Michael (Parish of Barbados)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Michael (Parish of Barbados)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Michael (Parish of Barbados)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Michael (Parish of Barbados)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Michael (Parish of Barbados)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Michael (Parish of Barbados)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Michael (Parish of Barbados)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Michael (Parish of Barbados)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Michael (Parish of Barbados)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Michael (Parish of Barbados)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Michael (Parish of Barbados)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Michael (Parish of Barbados)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Michael (Parish of Barbados)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Michael (Parish of Barbados)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Michael (Parish of Barbados)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Michael (Parish of Barbados)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Michael (Parish of Barbados)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Ouen (Parish of Jersey)": [
            {
                "Region Name": "Saint Ouen (Parish of Jersey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ouen (Parish of Jersey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ouen (Parish of Jersey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ouen (Parish of Jersey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ouen (Parish of Jersey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ouen (Parish of Jersey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ouen (Parish of Jersey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ouen (Parish of Jersey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ouen (Parish of Jersey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ouen (Parish of Jersey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ouen (Parish of Jersey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ouen (Parish of Jersey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ouen (Parish of Jersey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ouen (Parish of Jersey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ouen (Parish of Jersey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ouen (Parish of Jersey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ouen (Parish of Jersey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ouen (Parish of Jersey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ouen (Parish of Jersey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ouen (Parish of Jersey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ouen (Parish of Jersey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Ouen (Parish of Jersey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Patrick (Parish of Dominica)": [
            {
                "Region Name": "Saint Patrick (Parish of Dominica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Dominica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Dominica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Dominica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Dominica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Dominica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Dominica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Dominica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Dominica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Dominica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Dominica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Dominica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Dominica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Dominica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Dominica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Dominica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Dominica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Dominica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Dominica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Dominica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Dominica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Dominica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Patrick (Parish of Grenada)": [
            {
                "Region Name": "Saint Patrick (Parish of Grenada)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Grenada)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Grenada)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Grenada)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Grenada)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Grenada)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Grenada)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Grenada)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Grenada)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Grenada)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Grenada)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Grenada)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Grenada)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Grenada)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Grenada)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Grenada)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Grenada)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Grenada)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Grenada)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Grenada)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Grenada)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Grenada)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Patrick (Parish of Saint Vincent and the Grenadines)": [
            {
                "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Patrick (Parish of Saint Vincent and the Grenadines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Paul (Parish of Antigua and Barbuda)": [
            {
                "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Paul (Parish of Dominica)": [
            {
                "Region Name": "Saint Paul (Parish of Dominica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Dominica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Dominica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Dominica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Dominica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Dominica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Dominica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Dominica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Dominica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Dominica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Dominica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Dominica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Dominica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Dominica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Dominica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Dominica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Dominica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Dominica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Dominica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Dominica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Dominica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul (Parish of Dominica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)": [
            {
                "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Capisterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Paul Charlestown (Parish of Saint Kitts and Nevis)": [
            {
                "Region Name": "Saint Paul Charlestown (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Charlestown (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Charlestown (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Charlestown (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Charlestown (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Charlestown (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Charlestown (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Charlestown (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Charlestown (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Charlestown (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Charlestown (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Charlestown (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Charlestown (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Charlestown (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Charlestown (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Charlestown (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Charlestown (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Charlestown (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Charlestown (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Charlestown (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Charlestown (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Paul Charlestown (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Peter (Parish of Antigua and Barbuda)": [
            {
                "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Peter (Parish of Barbados)": [
            {
                "Region Name": "Saint Peter (Parish of Barbados)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Barbados)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Barbados)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Barbados)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Barbados)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Barbados)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Barbados)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Barbados)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Barbados)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Barbados)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Barbados)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Barbados)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Barbados)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Barbados)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Barbados)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Barbados)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Barbados)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Barbados)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Barbados)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Barbados)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Barbados)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Barbados)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Peter (Parish of Dominica)": [
            {
                "Region Name": "Saint Peter (Parish of Dominica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Dominica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Dominica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Dominica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Dominica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Dominica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Dominica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Dominica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Dominica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Dominica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Dominica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Dominica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Dominica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Dominica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Dominica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Dominica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Dominica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Dominica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Dominica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Dominica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Dominica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Dominica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Peter (Parish of Jersey)": [
            {
                "Region Name": "Saint Peter (Parish of Jersey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Jersey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Jersey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Jersey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Jersey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Jersey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Jersey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Jersey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Jersey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Jersey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Jersey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Jersey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Jersey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Jersey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Jersey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Jersey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Jersey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Jersey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Jersey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Jersey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Jersey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Jersey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Peter (Parish of Montserrat)": [
            {
                "Region Name": "Saint Peter (Parish of Montserrat)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Montserrat)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Montserrat)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Montserrat)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Montserrat)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Montserrat)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Montserrat)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Montserrat)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Montserrat)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Montserrat)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Montserrat)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Montserrat)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Montserrat)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Montserrat)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Montserrat)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Montserrat)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Montserrat)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Montserrat)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Montserrat)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Montserrat)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Montserrat)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter (Parish of Montserrat)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)": [
            {
                "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Basseterre (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Peter Port (Parish of Guernsey)": [
            {
                "Region Name": "Saint Peter Port (Parish of Guernsey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Port (Parish of Guernsey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Port (Parish of Guernsey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Port (Parish of Guernsey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Port (Parish of Guernsey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Port (Parish of Guernsey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Port (Parish of Guernsey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Port (Parish of Guernsey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Port (Parish of Guernsey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Port (Parish of Guernsey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Port (Parish of Guernsey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Port (Parish of Guernsey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Port (Parish of Guernsey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Port (Parish of Guernsey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Port (Parish of Guernsey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Port (Parish of Guernsey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Port (Parish of Guernsey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Port (Parish of Guernsey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Port (Parish of Guernsey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Port (Parish of Guernsey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Port (Parish of Guernsey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Peter Port (Parish of Guernsey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Philip (Parish of Antigua and Barbuda)": [
            {
                "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Antigua and Barbuda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Philip (Parish of Barbados)": [
            {
                "Region Name": "Saint Philip (Parish of Barbados)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Barbados)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Barbados)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Barbados)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Barbados)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Barbados)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Barbados)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Barbados)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Barbados)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Barbados)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Barbados)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Barbados)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Barbados)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Barbados)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Barbados)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Barbados)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Barbados)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Barbados)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Barbados)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Barbados)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Barbados)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Philip (Parish of Barbados)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Saint Pierre du Bois (Parish of Guernsey)": [
            {
                "Region Name": "Saint Pierre du Bois (Parish of Guernsey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre du Bois (Parish of Guernsey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre du Bois (Parish of Guernsey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre du Bois (Parish of Guernsey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre du Bois (Parish of Guernsey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre du Bois (Parish of Guernsey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre du Bois (Parish of Guernsey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre du Bois (Parish of Guernsey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre du Bois (Parish of Guernsey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre du Bois (Parish of Guernsey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre du Bois (Parish of Guernsey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre du Bois (Parish of Guernsey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre du Bois (Parish of Guernsey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre du Bois (Parish of Guernsey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre du Bois (Parish of Guernsey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre du Bois (Parish of Guernsey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre du Bois (Parish of Guernsey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre du Bois (Parish of Guernsey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre du Bois (Parish of Guernsey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre du Bois (Parish of Guernsey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre du Bois (Parish of Guernsey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Pierre du Bois (Parish of Guernsey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Sampson (Parish of Guernsey)": [
            {
                "Region Name": "Saint Sampson (Parish of Guernsey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Sampson (Parish of Guernsey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Sampson (Parish of Guernsey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Sampson (Parish of Guernsey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Sampson (Parish of Guernsey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Sampson (Parish of Guernsey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Sampson (Parish of Guernsey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Sampson (Parish of Guernsey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Sampson (Parish of Guernsey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Sampson (Parish of Guernsey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Sampson (Parish of Guernsey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Sampson (Parish of Guernsey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Sampson (Parish of Guernsey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Sampson (Parish of Guernsey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Sampson (Parish of Guernsey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Sampson (Parish of Guernsey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Sampson (Parish of Guernsey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Sampson (Parish of Guernsey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Sampson (Parish of Guernsey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Sampson (Parish of Guernsey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Sampson (Parish of Guernsey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Sampson (Parish of Guernsey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Saviour (Parish of Guernsey)": [
            {
                "Region Name": "Saint Saviour (Parish of Guernsey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Guernsey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Guernsey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Guernsey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Guernsey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Guernsey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Guernsey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Guernsey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Guernsey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Guernsey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Guernsey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Guernsey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Guernsey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Guernsey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Guernsey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Guernsey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Guernsey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Guernsey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Guernsey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Guernsey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Guernsey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Guernsey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Saviour (Parish of Jersey)": [
            {
                "Region Name": "Saint Saviour (Parish of Jersey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Jersey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Jersey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Jersey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Jersey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Jersey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Jersey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Jersey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Jersey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Jersey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Jersey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Jersey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Jersey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Jersey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Jersey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Jersey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Jersey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Jersey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Jersey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Jersey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Jersey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Saviour (Parish of Jersey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Thomas (District of Virgin Islands, U.S.)": [
            {
                "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (District of Virgin Islands, U.S.)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Thomas (Parish of Barbados)": [
            {
                "Region Name": "Saint Thomas (Parish of Barbados)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Barbados)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Barbados)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Barbados)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Barbados)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Barbados)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Barbados)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Barbados)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Saint Thomas (Parish of Barbados)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Barbados)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Barbados)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Barbados)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Barbados)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Barbados)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Barbados)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Barbados)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Barbados)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Barbados)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Barbados)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Barbados)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Barbados)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Barbados)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Thomas (Parish of Jamaica)": [
            {
                "Region Name": "Saint Thomas (Parish of Jamaica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Jamaica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Jamaica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Jamaica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saint Thomas (Parish of Jamaica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Jamaica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Jamaica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Jamaica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Jamaica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Jamaica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Jamaica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Jamaica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Jamaica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Jamaica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Saint Thomas (Parish of Jamaica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Jamaica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Jamaica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Jamaica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saint Thomas (Parish of Jamaica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Jamaica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas (Parish of Jamaica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saint Thomas (Parish of Jamaica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)": [
            {
                "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Lowland (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)": [
            {
                "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saint Thomas Middle Island (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saipan (Municipality of Northern Mariana Islands)": [
            {
                "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saipan (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saitama (Prefecture of Japan)": [
            {
                "Region Name": "Saitama (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saitama (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saitama (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saitama (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saitama (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saitama (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saitama (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saitama (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saitama (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saitama (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saitama (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saitama (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saitama (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saitama (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saitama (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saitama (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saitama (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saitama (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saitama (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saitama (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saitama (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saitama (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sakarya (Province of Turkey)": [
            {
                "Region Name": "Sakarya (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sakarya (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sakarya (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sakarya (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sakarya (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sakarya (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sakarya (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sakarya (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sakarya (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sakarya (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sakarya (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sakarya (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sakarya (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sakarya (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sakarya (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sakarya (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sakarya (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sakarya (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sakarya (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sakarya (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sakarya (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sakarya (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Sakha (Republic of Russia)": [
            {
                "Region Name": "Sakha (Republic of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Sakha (Republic of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Sakha (Republic of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sakha (Republic of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sakha (Republic of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sakha (Republic of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sakha (Republic of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Sakha (Republic of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Sakha (Republic of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Sakha (Republic of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Sakha (Republic of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Sakha (Republic of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Sakha (Republic of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Sakha (Republic of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sakha (Republic of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sakha (Republic of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Sakha (Republic of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Sakha (Republic of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Sakha (Republic of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Sakha (Republic of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 80
            },
            {
                "Region Name": "Sakha (Republic of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Sakha (Republic of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 24
            }
        ],
        "Sakhalin (Region of Russia)": [
            {
                "Region Name": "Sakhalin (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sakhalin (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Sakhalin (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sakhalin (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sakhalin (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sakhalin (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sakhalin (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sakhalin (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sakhalin (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sakhalin (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sakhalin (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sakhalin (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sakhalin (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sakhalin (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sakhalin (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sakhalin (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Sakhalin (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sakhalin (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sakhalin (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sakhalin (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sakhalin (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Sakhalin (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Sakon Nakhon (Province of Thailand)": [
            {
                "Region Name": "Sakon Nakhon (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sakon Nakhon (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sakon Nakhon (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sakon Nakhon (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sakon Nakhon (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sakon Nakhon (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sakon Nakhon (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sakon Nakhon (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sakon Nakhon (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sakon Nakhon (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sakon Nakhon (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sakon Nakhon (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sakon Nakhon (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sakon Nakhon (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sakon Nakhon (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sakon Nakhon (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sakon Nakhon (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sakon Nakhon (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sakon Nakhon (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sakon Nakhon (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sakon Nakhon (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sakon Nakhon (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Sal (County of Cabo Verde)": [
            {
                "Region Name": "Sal (County of Cabo Verde)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sal (County of Cabo Verde)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sal (County of Cabo Verde)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sal (County of Cabo Verde)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sal (County of Cabo Verde)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sal (County of Cabo Verde)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sal (County of Cabo Verde)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sal (County of Cabo Verde)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sal (County of Cabo Verde)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sal (County of Cabo Verde)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sal (County of Cabo Verde)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sal (County of Cabo Verde)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sal (County of Cabo Verde)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sal (County of Cabo Verde)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sal (County of Cabo Verde)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sal (County of Cabo Verde)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sal (County of Cabo Verde)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sal (County of Cabo Verde)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sal (County of Cabo Verde)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sal (County of Cabo Verde)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sal (County of Cabo Verde)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sal (County of Cabo Verde)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sala ad-Din (Province of Iraq)": [
            {
                "Region Name": "Sala ad-Din (Province of Iraq)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sala ad-Din (Province of Iraq)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sala ad-Din (Province of Iraq)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sala ad-Din (Province of Iraq)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sala ad-Din (Province of Iraq)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sala ad-Din (Province of Iraq)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sala ad-Din (Province of Iraq)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sala ad-Din (Province of Iraq)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sala ad-Din (Province of Iraq)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sala ad-Din (Province of Iraq)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sala ad-Din (Province of Iraq)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sala ad-Din (Province of Iraq)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sala ad-Din (Province of Iraq)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sala ad-Din (Province of Iraq)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sala ad-Din (Province of Iraq)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sala ad-Din (Province of Iraq)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sala ad-Din (Province of Iraq)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sala ad-Din (Province of Iraq)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sala ad-Din (Province of Iraq)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sala ad-Din (Province of Iraq)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sala ad-Din (Province of Iraq)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sala ad-Din (Province of Iraq)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "S\u0103laj (County of Romania)": [
            {
                "Region Name": "S\u0103laj (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\u0103laj (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\u0103laj (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\u0103laj (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\u0103laj (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\u0103laj (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "S\u0103laj (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\u0103laj (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\u0103laj (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\u0103laj (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "S\u0103laj (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "S\u0103laj (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\u0103laj (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\u0103laj (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\u0103laj (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\u0103laj (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "S\u0103laj (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\u0103laj (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "S\u0103laj (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\u0103laj (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\u0103laj (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\u0103laj (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Salamat (Region of Chad)": [
            {
                "Region Name": "Salamat (Region of Chad)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Salamat (Region of Chad)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Salamat (Region of Chad)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Salamat (Region of Chad)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Salamat (Region of Chad)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Salamat (Region of Chad)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Salamat (Region of Chad)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Salamat (Region of Chad)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Salamat (Region of Chad)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Salamat (Region of Chad)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Salamat (Region of Chad)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Salamat (Region of Chad)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Salamat (Region of Chad)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Salamat (Region of Chad)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Salamat (Region of Chad)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Salamat (Region of Chad)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Salamat (Region of Chad)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Salamat (Region of Chad)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Salamat (Region of Chad)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Salamat (Region of Chad)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Salamat (Region of Chad)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Salamat (Region of Chad)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 24
            }
        ],
        "Salcedo (Province of Dominican Republic)": [
            {
                "Region Name": "Salcedo (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salcedo (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salcedo (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salcedo (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salcedo (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salcedo (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salcedo (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salcedo (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salcedo (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salcedo (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salcedo (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salcedo (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salcedo (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salcedo (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salcedo (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salcedo (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salcedo (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salcedo (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salcedo (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salcedo (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salcedo (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salcedo (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Salima (District of Malawi)": [
            {
                "Region Name": "Salima (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Salima (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Salima (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Salima (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Salima (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Salima (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Salima (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Salima (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Salima (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Salima (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Salima (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Salima (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Salima (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Salima (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Salima (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Salima (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Salima (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Salima (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Salima (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Salima (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Salima (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Salima (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Salinas (Municipality of Puerto Rico)": [
            {
                "Region Name": "Salinas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salinas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Salinas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Salinas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Salinas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Salinas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salinas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Salinas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Salinas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Salinas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Salinas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Salinas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salinas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salinas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Salinas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Salinas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Salinas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Salinas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Salinas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salinas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salinas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Salinas (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Salt Cay (District of Turks and Caicos Islands)": [
            {
                "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salt Cay (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Salta (Province of Argentina)": [
            {
                "Region Name": "Salta (Province of Argentina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Salta (Province of Argentina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Salta (Province of Argentina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Salta (Province of Argentina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Salta (Province of Argentina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Salta (Province of Argentina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Salta (Province of Argentina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Salta (Province of Argentina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Salta (Province of Argentina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Salta (Province of Argentina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Salta (Province of Argentina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Salta (Province of Argentina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Salta (Province of Argentina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Salta (Province of Argentina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Salta (Province of Argentina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Salta (Province of Argentina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Salta (Province of Argentina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Salta (Province of Argentina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Salta (Province of Argentina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Salta (Province of Argentina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Salta (Province of Argentina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Salta (Province of Argentina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Salto (Department of Uruguay)": [
            {
                "Region Name": "Salto (Department of Uruguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Salto (Department of Uruguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Salto (Department of Uruguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Salto (Department of Uruguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Salto (Department of Uruguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Salto (Department of Uruguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Salto (Department of Uruguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Salto (Department of Uruguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salto (Department of Uruguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Salto (Department of Uruguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Salto (Department of Uruguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Salto (Department of Uruguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Salto (Department of Uruguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Salto (Department of Uruguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Salto (Department of Uruguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Salto (Department of Uruguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salto (Department of Uruguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Salto (Department of Uruguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Salto (Department of Uruguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Salto (Department of Uruguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Salto (Department of Uruguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salto (Department of Uruguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Salzburg (State of Austria)": [
            {
                "Region Name": "Salzburg (State of Austria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salzburg (State of Austria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salzburg (State of Austria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salzburg (State of Austria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salzburg (State of Austria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salzburg (State of Austria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salzburg (State of Austria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salzburg (State of Austria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salzburg (State of Austria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salzburg (State of Austria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salzburg (State of Austria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salzburg (State of Austria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salzburg (State of Austria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Salzburg (State of Austria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salzburg (State of Austria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salzburg (State of Austria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Salzburg (State of Austria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salzburg (State of Austria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salzburg (State of Austria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salzburg (State of Austria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salzburg (State of Austria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Salzburg (State of Austria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saman\xe1 (Province of Dominican Republic)": [
            {
                "Region Name": "Saman\xe1 (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saman\xe1 (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saman\xe1 (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saman\xe1 (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saman\xe1 (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saman\xe1 (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saman\xe1 (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saman\xe1 (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saman\xe1 (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saman\xe1 (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saman\xe1 (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saman\xe1 (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saman\xe1 (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saman\xe1 (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Saman\xe1 (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saman\xe1 (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saman\xe1 (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saman\xe1 (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saman\xe1 (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saman\xe1 (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saman\xe1 (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saman\xe1 (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Samangan (Province of Afghanistan)": [
            {
                "Region Name": "Samangan (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samangan (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Samangan (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samangan (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samangan (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samangan (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samangan (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Samangan (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samangan (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samangan (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samangan (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samangan (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samangan (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samangan (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samangan (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samangan (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samangan (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samangan (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samangan (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samangan (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samangan (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samangan (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Samar (Province of Philippines)": [
            {
                "Region Name": "Samar (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samar (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samar (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samar (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samar (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samar (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samar (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samar (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samar (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samar (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samar (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samar (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Samar (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samar (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samar (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samar (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samar (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samar (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Samar (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Samar (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samar (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samar (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Samara (Region of Russia)": [
            {
                "Region Name": "Samara (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Samara (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Samara (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Samara (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Samara (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Samara (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Samara (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Samara (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Samara (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Samara (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Samara (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Samara (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Samara (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Samara (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Samara (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Samara (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Samara (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Samara (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Samara (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Samara (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Samara (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Samara (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Samarqand' (Region of Uzbekistan)": [
            {
                "Region Name": "Samarqand' (Region of Uzbekistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Samarqand' (Region of Uzbekistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Samarqand' (Region of Uzbekistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Samarqand' (Region of Uzbekistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Samarqand' (Region of Uzbekistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Samarqand' (Region of Uzbekistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samarqand' (Region of Uzbekistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Samarqand' (Region of Uzbekistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samarqand' (Region of Uzbekistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samarqand' (Region of Uzbekistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samarqand' (Region of Uzbekistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Samarqand' (Region of Uzbekistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samarqand' (Region of Uzbekistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samarqand' (Region of Uzbekistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samarqand' (Region of Uzbekistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samarqand' (Region of Uzbekistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samarqand' (Region of Uzbekistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samarqand' (Region of Uzbekistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Samarqand' (Region of Uzbekistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Samarqand' (Region of Uzbekistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samarqand' (Region of Uzbekistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samarqand' (Region of Uzbekistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Samburu (County of Kenya)": [
            {
                "Region Name": "Samburu (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Samburu (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Samburu (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Samburu (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Samburu (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samburu (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Samburu (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Samburu (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Samburu (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Samburu (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Samburu (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Samburu (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Samburu (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samburu (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Samburu (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samburu (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Samburu (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Samburu (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 59
            },
            {
                "Region Name": "Samburu (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Samburu (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Samburu (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Samburu (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Samdrup Jongkhar (District of Bhutan)": [
            {
                "Region Name": "Samdrup Jongkhar (District of Bhutan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samdrup Jongkhar (District of Bhutan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samdrup Jongkhar (District of Bhutan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samdrup Jongkhar (District of Bhutan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samdrup Jongkhar (District of Bhutan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samdrup Jongkhar (District of Bhutan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samdrup Jongkhar (District of Bhutan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samdrup Jongkhar (District of Bhutan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Samdrup Jongkhar (District of Bhutan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samdrup Jongkhar (District of Bhutan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samdrup Jongkhar (District of Bhutan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Samdrup Jongkhar (District of Bhutan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samdrup Jongkhar (District of Bhutan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Samdrup Jongkhar (District of Bhutan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samdrup Jongkhar (District of Bhutan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samdrup Jongkhar (District of Bhutan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samdrup Jongkhar (District of Bhutan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samdrup Jongkhar (District of Bhutan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samdrup Jongkhar (District of Bhutan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samdrup Jongkhar (District of Bhutan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samdrup Jongkhar (District of Bhutan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samdrup Jongkhar (District of Bhutan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Samegrelo-Zemo Svaneti (Region of Georgia)": [
            {
                "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Samegrelo-Zemo Svaneti (Region of Georgia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Samsun (Province of Turkey)": [
            {
                "Region Name": "Samsun (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samsun (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samsun (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samsun (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samsun (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samsun (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Samsun (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Samsun (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samsun (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samsun (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samsun (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samsun (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Samsun (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samsun (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samsun (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Samsun (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Samsun (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samsun (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samsun (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Samsun (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samsun (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Samsun (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Samtse (District of Bhutan)": [
            {
                "Region Name": "Samtse (District of Bhutan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtse (District of Bhutan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtse (District of Bhutan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtse (District of Bhutan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtse (District of Bhutan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtse (District of Bhutan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtse (District of Bhutan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtse (District of Bhutan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtse (District of Bhutan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtse (District of Bhutan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtse (District of Bhutan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtse (District of Bhutan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtse (District of Bhutan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtse (District of Bhutan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtse (District of Bhutan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtse (District of Bhutan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtse (District of Bhutan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtse (District of Bhutan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtse (District of Bhutan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtse (District of Bhutan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtse (District of Bhutan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtse (District of Bhutan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Samtskhe-Javakheti (Region of Georgia)": [
            {
                "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Samtskhe-Javakheti (Region of Georgia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Samut Prakan (Province of Thailand)": [
            {
                "Region Name": "Samut Prakan (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Samut Prakan (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Samut Prakan (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samut Prakan (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Prakan (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samut Prakan (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Samut Prakan (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Samut Prakan (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Samut Prakan (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Samut Prakan (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Samut Prakan (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Samut Prakan (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Prakan (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Samut Prakan (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Prakan (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Prakan (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Prakan (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Prakan (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Prakan (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Prakan (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Prakan (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Samut Prakan (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Samut Sakhon (Province of Thailand)": [
            {
                "Region Name": "Samut Sakhon (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Sakhon (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Sakhon (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Sakhon (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Sakhon (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Sakhon (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Sakhon (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Sakhon (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Sakhon (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Sakhon (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Sakhon (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Sakhon (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Sakhon (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Sakhon (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Sakhon (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Sakhon (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Sakhon (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Sakhon (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Sakhon (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Sakhon (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Sakhon (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Sakhon (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Samut Songkhram (Province of Thailand)": [
            {
                "Region Name": "Samut Songkhram (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Songkhram (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Songkhram (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Songkhram (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Songkhram (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Songkhram (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Songkhram (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Songkhram (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Songkhram (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Songkhram (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Songkhram (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Songkhram (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Songkhram (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Songkhram (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Songkhram (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Songkhram (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Songkhram (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Songkhram (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Songkhram (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Songkhram (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Songkhram (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Samut Songkhram (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "San Andr\xe9s y Providencia (Department of Colombia)": [
            {
                "Region Name": "San Andr\xe9s y Providencia (Department of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Andr\xe9s y Providencia (Department of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Andr\xe9s y Providencia (Department of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Andr\xe9s y Providencia (Department of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Andr\xe9s y Providencia (Department of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Andr\xe9s y Providencia (Department of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Andr\xe9s y Providencia (Department of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Andr\xe9s y Providencia (Department of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Andr\xe9s y Providencia (Department of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Andr\xe9s y Providencia (Department of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Andr\xe9s y Providencia (Department of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Andr\xe9s y Providencia (Department of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Andr\xe9s y Providencia (Department of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Andr\xe9s y Providencia (Department of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Andr\xe9s y Providencia (Department of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Andr\xe9s y Providencia (Department of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Andr\xe9s y Providencia (Department of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Andr\xe9s y Providencia (Department of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Andr\xe9s y Providencia (Department of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Andr\xe9s y Providencia (Department of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Andr\xe9s y Providencia (Department of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Andr\xe9s y Providencia (Department of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "San Crist\xf3bal (Province of Dominican Republic)": [
            {
                "Region Name": "San Crist\xf3bal (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Crist\xf3bal (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Crist\xf3bal (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Crist\xf3bal (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Crist\xf3bal (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Crist\xf3bal (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Crist\xf3bal (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Crist\xf3bal (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Crist\xf3bal (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Crist\xf3bal (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Crist\xf3bal (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Crist\xf3bal (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Crist\xf3bal (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Crist\xf3bal (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Crist\xf3bal (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Crist\xf3bal (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Crist\xf3bal (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Crist\xf3bal (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Crist\xf3bal (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Crist\xf3bal (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Crist\xf3bal (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Crist\xf3bal (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "San Fernando (City of Trinidad and Tobago)": [
            {
                "Region Name": "San Fernando (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Fernando (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Fernando (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Fernando (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Fernando (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Fernando (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Fernando (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Fernando (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Fernando (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Fernando (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Fernando (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Fernando (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Fernando (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Fernando (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Fernando (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Fernando (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Fernando (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Fernando (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Fernando (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Fernando (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Fernando (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Fernando (City of Trinidad and Tobago)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "San Germ\xe1n (Municipality of Puerto Rico)": [
            {
                "Region Name": "San Germ\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "San Germ\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Germ\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Germ\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "San Germ\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Germ\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Germ\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Germ\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Germ\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Germ\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Germ\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Germ\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Germ\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Germ\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Germ\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Germ\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Germ\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Germ\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Germ\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Germ\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Germ\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Germ\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "San Jos\xe9 (Department of Uruguay)": [
            {
                "Region Name": "San Jos\xe9 (Department of Uruguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 (Department of Uruguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Jos\xe9 (Department of Uruguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Jos\xe9 (Department of Uruguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 (Department of Uruguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Jos\xe9 (Department of Uruguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 (Department of Uruguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Jos\xe9 (Department of Uruguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Jos\xe9 (Department of Uruguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Jos\xe9 (Department of Uruguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Jos\xe9 (Department of Uruguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Jos\xe9 (Department of Uruguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Jos\xe9 (Department of Uruguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Jos\xe9 (Department of Uruguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Jos\xe9 (Department of Uruguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Jos\xe9 (Department of Uruguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "San Jos\xe9 (Department of Uruguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Jos\xe9 (Department of Uruguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Jos\xe9 (Department of Uruguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Jos\xe9 (Department of Uruguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Jos\xe9 (Department of Uruguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Jos\xe9 (Department of Uruguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "San Jos\xe9 (Province of Costa Rica)": [
            {
                "Region Name": "San Jos\xe9 (Province of Costa Rica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Jos\xe9 (Province of Costa Rica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 (Province of Costa Rica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 (Province of Costa Rica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 (Province of Costa Rica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Jos\xe9 (Province of Costa Rica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Jos\xe9 (Province of Costa Rica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 (Province of Costa Rica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 (Province of Costa Rica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 (Province of Costa Rica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 (Province of Costa Rica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 (Province of Costa Rica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Jos\xe9 (Province of Costa Rica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 (Province of Costa Rica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 (Province of Costa Rica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "San Jos\xe9 (Province of Costa Rica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Jos\xe9 (Province of Costa Rica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 (Province of Costa Rica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 (Province of Costa Rica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 (Province of Costa Rica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 (Province of Costa Rica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 (Province of Costa Rica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "San Jos\xe9 de Ocoa (Province of Dominican Republic)": [
            {
                "Region Name": "San Jos\xe9 de Ocoa (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 de Ocoa (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 de Ocoa (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 de Ocoa (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 de Ocoa (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 de Ocoa (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 de Ocoa (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 de Ocoa (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Jos\xe9 de Ocoa (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 de Ocoa (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 de Ocoa (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 de Ocoa (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 de Ocoa (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 de Ocoa (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 de Ocoa (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 de Ocoa (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 de Ocoa (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 de Ocoa (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 de Ocoa (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 de Ocoa (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 de Ocoa (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Jos\xe9 de Ocoa (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "San Juan-Laventille (Region of Trinidad and Tobago)": [
            {
                "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan-Laventille (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "San Juan (Municipality of Puerto Rico)": [
            {
                "Region Name": "San Juan (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "San Juan (Province of Argentina)": [
            {
                "Region Name": "San Juan (Province of Argentina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "San Juan (Province of Argentina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "San Juan (Province of Argentina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "San Juan (Province of Argentina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Juan (Province of Argentina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "San Juan (Province of Argentina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Juan (Province of Argentina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "San Juan (Province of Argentina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "San Juan (Province of Argentina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "San Juan (Province of Argentina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "San Juan (Province of Argentina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "San Juan (Province of Argentina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "San Juan (Province of Argentina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Juan (Province of Argentina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "San Juan (Province of Argentina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "San Juan (Province of Argentina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "San Juan (Province of Argentina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "San Juan (Province of Argentina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "San Juan (Province of Argentina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "San Juan (Province of Argentina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Juan (Province of Argentina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "San Juan (Province of Argentina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 20
            }
        ],
        "San Juan (Province of Dominican Republic)": [
            {
                "Region Name": "San Juan (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Juan (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Juan (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "San Juan (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "San Juan (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Juan (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Juan (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "San Juan (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "San Juan (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Juan (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Juan (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "San Juan (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Juan (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Juan (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Juan (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Juan (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Juan (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Juan (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Juan (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "San Juan (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Juan (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 16
            }
        ],
        "San Lorenzo (Municipality of Puerto Rico)": [
            {
                "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Lorenzo (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "San Luis (Province of Argentina)": [
            {
                "Region Name": "San Luis (Province of Argentina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "San Luis (Province of Argentina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "San Luis (Province of Argentina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "San Luis (Province of Argentina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "San Luis (Province of Argentina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "San Luis (Province of Argentina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "San Luis (Province of Argentina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "San Luis (Province of Argentina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "San Luis (Province of Argentina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "San Luis (Province of Argentina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "San Luis (Province of Argentina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "San Luis (Province of Argentina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "San Luis (Province of Argentina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "San Luis (Province of Argentina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "San Luis (Province of Argentina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "San Luis (Province of Argentina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "San Luis (Province of Argentina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "San Luis (Province of Argentina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "San Luis (Province of Argentina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "San Luis (Province of Argentina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "San Luis (Province of Argentina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "San Luis (Province of Argentina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 19
            }
        ],
        "San Luis Potos\xed (State of M\xe9xico)": [
            {
                "Region Name": "San Luis Potos\xed (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "San Luis Potos\xed (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Luis Potos\xed (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Luis Potos\xed (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Luis Potos\xed (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "San Luis Potos\xed (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Luis Potos\xed (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "San Luis Potos\xed (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "San Luis Potos\xed (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Luis Potos\xed (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "San Luis Potos\xed (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Luis Potos\xed (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "San Luis Potos\xed (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Luis Potos\xed (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Luis Potos\xed (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Luis Potos\xed (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Luis Potos\xed (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Luis Potos\xed (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "San Luis Potos\xed (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "San Luis Potos\xed (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "San Luis Potos\xed (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Luis Potos\xed (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "San Marcos (Department of Guatemala)": [
            {
                "Region Name": "San Marcos (Department of Guatemala)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Marcos (Department of Guatemala)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Marcos (Department of Guatemala)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Marcos (Department of Guatemala)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Marcos (Department of Guatemala)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marcos (Department of Guatemala)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Marcos (Department of Guatemala)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marcos (Department of Guatemala)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Marcos (Department of Guatemala)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marcos (Department of Guatemala)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marcos (Department of Guatemala)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marcos (Department of Guatemala)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Marcos (Department of Guatemala)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marcos (Department of Guatemala)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marcos (Department of Guatemala)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marcos (Department of Guatemala)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marcos (Department of Guatemala)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marcos (Department of Guatemala)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marcos (Department of Guatemala)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "San Marcos (Department of Guatemala)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marcos (Department of Guatemala)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Marcos (Department of Guatemala)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "San Marino (Municipality of San Marino)": [
            {
                "Region Name": "San Marino (Municipality of San Marino)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marino (Municipality of San Marino)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marino (Municipality of San Marino)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marino (Municipality of San Marino)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marino (Municipality of San Marino)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marino (Municipality of San Marino)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marino (Municipality of San Marino)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marino (Municipality of San Marino)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marino (Municipality of San Marino)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marino (Municipality of San Marino)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marino (Municipality of San Marino)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marino (Municipality of San Marino)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marino (Municipality of San Marino)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marino (Municipality of San Marino)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marino (Municipality of San Marino)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marino (Municipality of San Marino)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marino (Municipality of San Marino)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marino (Municipality of San Marino)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marino (Municipality of San Marino)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marino (Municipality of San Marino)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marino (Municipality of San Marino)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Marino (Municipality of San Marino)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "San Mart\xedn (Region of Peru)": [
            {
                "Region Name": "San Mart\xedn (Region of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Mart\xedn (Region of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Mart\xedn (Region of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Mart\xedn (Region of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Mart\xedn (Region of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Mart\xedn (Region of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Mart\xedn (Region of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Mart\xedn (Region of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Mart\xedn (Region of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Mart\xedn (Region of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Mart\xedn (Region of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Mart\xedn (Region of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Mart\xedn (Region of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Mart\xedn (Region of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Mart\xedn (Region of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Mart\xedn (Region of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Mart\xedn (Region of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Mart\xedn (Region of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Mart\xedn (Region of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Mart\xedn (Region of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Mart\xedn (Region of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Mart\xedn (Region of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "San Miguel (Department of El Salvador)": [
            {
                "Region Name": "San Miguel (Department of El Salvador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "San Miguel (Department of El Salvador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Miguel (Department of El Salvador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "San Miguel (Department of El Salvador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Miguel (Department of El Salvador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "San Miguel (Department of El Salvador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Miguel (Department of El Salvador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "San Miguel (Department of El Salvador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Miguel (Department of El Salvador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Miguel (Department of El Salvador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Miguel (Department of El Salvador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Miguel (Department of El Salvador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "San Miguel (Department of El Salvador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Miguel (Department of El Salvador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "San Miguel (Department of El Salvador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Miguel (Department of El Salvador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "San Miguel (Department of El Salvador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "San Miguel (Department of El Salvador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "San Miguel (Department of El Salvador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "San Miguel (Department of El Salvador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Miguel (Department of El Salvador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Miguel (Department of El Salvador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "San Pedro (Department of Paraguay)": [
            {
                "Region Name": "San Pedro (Department of Paraguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "San Pedro (Department of Paraguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "San Pedro (Department of Paraguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Pedro (Department of Paraguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Pedro (Department of Paraguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Pedro (Department of Paraguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "San Pedro (Department of Paraguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Pedro (Department of Paraguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Pedro (Department of Paraguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Pedro (Department of Paraguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Pedro (Department of Paraguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Pedro (Department of Paraguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Pedro (Department of Paraguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Pedro (Department of Paraguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "San Pedro (Department of Paraguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Pedro (Department of Paraguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "San Pedro (Department of Paraguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Pedro (Department of Paraguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "San Pedro (Department of Paraguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "San Pedro (Department of Paraguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "San Pedro (Department of Paraguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "San Pedro (Department of Paraguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "San Pedro de Macor\xeds (Province of Dominican Republic)": [
            {
                "Region Name": "San Pedro de Macor\xeds (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "San Pedro de Macor\xeds (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Pedro de Macor\xeds (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "San Pedro de Macor\xeds (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "San Pedro de Macor\xeds (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "San Pedro de Macor\xeds (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "San Pedro de Macor\xeds (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "San Pedro de Macor\xeds (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Pedro de Macor\xeds (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "San Pedro de Macor\xeds (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "San Pedro de Macor\xeds (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Pedro de Macor\xeds (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Pedro de Macor\xeds (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Pedro de Macor\xeds (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Pedro de Macor\xeds (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Pedro de Macor\xeds (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Pedro de Macor\xeds (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Pedro de Macor\xeds (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "San Pedro de Macor\xeds (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "San Pedro de Macor\xeds (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Pedro de Macor\xeds (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Pedro de Macor\xeds (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "San Salvador (Department of El Salvador)": [
            {
                "Region Name": "San Salvador (Department of El Salvador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (Department of El Salvador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (Department of El Salvador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Salvador (Department of El Salvador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Salvador (Department of El Salvador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Salvador (Department of El Salvador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (Department of El Salvador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (Department of El Salvador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (Department of El Salvador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (Department of El Salvador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Salvador (Department of El Salvador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Salvador (Department of El Salvador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Salvador (Department of El Salvador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (Department of El Salvador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Salvador (Department of El Salvador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Salvador (Department of El Salvador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Salvador (Department of El Salvador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Salvador (Department of El Salvador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Salvador (Department of El Salvador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (Department of El Salvador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Salvador (Department of El Salvador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Salvador (Department of El Salvador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "San Salvador (District of Bahamas)": [
            {
                "Region Name": "San Salvador (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Salvador (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "San Sebasti\xe1n (Municipality of Puerto Rico)": [
            {
                "Region Name": "San Sebasti\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Sebasti\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Sebasti\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Sebasti\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Sebasti\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Sebasti\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Sebasti\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Sebasti\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Sebasti\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Sebasti\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Sebasti\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Sebasti\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Sebasti\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Sebasti\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Sebasti\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Sebasti\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Sebasti\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Sebasti\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Sebasti\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Sebasti\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Sebasti\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Sebasti\xe1n (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "San Vicente (Department of El Salvador)": [
            {
                "Region Name": "San Vicente (Department of El Salvador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Vicente (Department of El Salvador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Vicente (Department of El Salvador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Vicente (Department of El Salvador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Vicente (Department of El Salvador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Vicente (Department of El Salvador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Vicente (Department of El Salvador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Vicente (Department of El Salvador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Vicente (Department of El Salvador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Vicente (Department of El Salvador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San Vicente (Department of El Salvador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Vicente (Department of El Salvador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Vicente (Department of El Salvador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Vicente (Department of El Salvador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Vicente (Department of El Salvador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Vicente (Department of El Salvador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Vicente (Department of El Salvador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Vicente (Department of El Salvador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "San Vicente (Department of El Salvador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "San Vicente (Department of El Salvador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "San Vicente (Department of El Salvador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "San Vicente (Department of El Salvador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "San`a' (City of Yemen)": [
            {
                "Region Name": "San`a' (City of Yemen)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San`a' (City of Yemen)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San`a' (City of Yemen)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San`a' (City of Yemen)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San`a' (City of Yemen)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San`a' (City of Yemen)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San`a' (City of Yemen)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San`a' (City of Yemen)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San`a' (City of Yemen)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San`a' (City of Yemen)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San`a' (City of Yemen)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San`a' (City of Yemen)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San`a' (City of Yemen)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San`a' (City of Yemen)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San`a' (City of Yemen)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San`a' (City of Yemen)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San`a' (City of Yemen)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San`a' (City of Yemen)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San`a' (City of Yemen)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San`a' (City of Yemen)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San`a' (City of Yemen)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "San`a' (City of Yemen)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sanaag (Region of Somalia)": [
            {
                "Region Name": "Sanaag (Region of Somalia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanaag (Region of Somalia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanaag (Region of Somalia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanaag (Region of Somalia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanaag (Region of Somalia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanaag (Region of Somalia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanaag (Region of Somalia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanaag (Region of Somalia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanaag (Region of Somalia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanaag (Region of Somalia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanaag (Region of Somalia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanaag (Region of Somalia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanaag (Region of Somalia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanaag (Region of Somalia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanaag (Region of Somalia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanaag (Region of Somalia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanaag (Region of Somalia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanaag (Region of Somalia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanaag (Region of Somalia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanaag (Region of Somalia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanaag (Region of Somalia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sanaag (Region of Somalia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "S\xe1nchez Ram\xedrez (Province of Dominican Republic)": [
            {
                "Region Name": "S\xe1nchez Ram\xedrez (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe1nchez Ram\xedrez (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe1nchez Ram\xedrez (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe1nchez Ram\xedrez (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "S\xe1nchez Ram\xedrez (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe1nchez Ram\xedrez (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe1nchez Ram\xedrez (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe1nchez Ram\xedrez (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "S\xe1nchez Ram\xedrez (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe1nchez Ram\xedrez (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe1nchez Ram\xedrez (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe1nchez Ram\xedrez (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe1nchez Ram\xedrez (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe1nchez Ram\xedrez (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe1nchez Ram\xedrez (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe1nchez Ram\xedrez (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe1nchez Ram\xedrez (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe1nchez Ram\xedrez (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "S\xe1nchez Ram\xedrez (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe1nchez Ram\xedrez (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe1nchez Ram\xedrez (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe1nchez Ram\xedrez (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Sancti Sp\xedritus (Province of Cuba)": [
            {
                "Region Name": "Sancti Sp\xedritus (Province of Cuba)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sancti Sp\xedritus (Province of Cuba)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sancti Sp\xedritus (Province of Cuba)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sancti Sp\xedritus (Province of Cuba)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sancti Sp\xedritus (Province of Cuba)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sancti Sp\xedritus (Province of Cuba)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sancti Sp\xedritus (Province of Cuba)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sancti Sp\xedritus (Province of Cuba)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sancti Sp\xedritus (Province of Cuba)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sancti Sp\xedritus (Province of Cuba)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sancti Sp\xedritus (Province of Cuba)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sancti Sp\xedritus (Province of Cuba)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sancti Sp\xedritus (Province of Cuba)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sancti Sp\xedritus (Province of Cuba)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sancti Sp\xedritus (Province of Cuba)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sancti Sp\xedritus (Province of Cuba)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sancti Sp\xedritus (Province of Cuba)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sancti Sp\xedritus (Province of Cuba)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sancti Sp\xedritus (Province of Cuba)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sancti Sp\xedritus (Province of Cuba)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sancti Sp\xedritus (Province of Cuba)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sancti Sp\xedritus (Province of Cuba)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Sandaun (Province of Papua New Guinea)": [
            {
                "Region Name": "Sandaun (Province of Papua New Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sandaun (Province of Papua New Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sandaun (Province of Papua New Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sandaun (Province of Papua New Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandaun (Province of Papua New Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sandaun (Province of Papua New Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sandaun (Province of Papua New Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sandaun (Province of Papua New Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sandaun (Province of Papua New Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sandaun (Province of Papua New Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sandaun (Province of Papua New Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sandaun (Province of Papua New Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sandaun (Province of Papua New Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sandaun (Province of Papua New Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sandaun (Province of Papua New Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sandaun (Province of Papua New Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sandaun (Province of Papua New Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sandaun (Province of Papua New Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sandaun (Province of Papua New Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sandaun (Province of Papua New Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sandaun (Province of Papua New Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sandaun (Province of Papua New Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Sandoyar (Region of Faroe Islands)": [
            {
                "Region Name": "Sandoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sandy Ground (District of Anguilla)": [
            {
                "Region Name": "Sandy Ground (District of Anguilla)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Ground (District of Anguilla)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Ground (District of Anguilla)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Ground (District of Anguilla)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Ground (District of Anguilla)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Ground (District of Anguilla)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Ground (District of Anguilla)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Ground (District of Anguilla)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Ground (District of Anguilla)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Ground (District of Anguilla)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Ground (District of Anguilla)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Ground (District of Anguilla)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Ground (District of Anguilla)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Ground (District of Anguilla)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Ground (District of Anguilla)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Ground (District of Anguilla)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Ground (District of Anguilla)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Ground (District of Anguilla)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Ground (District of Anguilla)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Ground (District of Anguilla)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Ground (District of Anguilla)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Ground (District of Anguilla)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sandy Hill (District of Anguilla)": [
            {
                "Region Name": "Sandy Hill (District of Anguilla)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Hill (District of Anguilla)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Hill (District of Anguilla)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Hill (District of Anguilla)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Hill (District of Anguilla)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Hill (District of Anguilla)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Hill (District of Anguilla)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Hill (District of Anguilla)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Hill (District of Anguilla)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Hill (District of Anguilla)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Hill (District of Anguilla)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Hill (District of Anguilla)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Hill (District of Anguilla)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Hill (District of Anguilla)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Hill (District of Anguilla)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Hill (District of Anguilla)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Hill (District of Anguilla)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Hill (District of Anguilla)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Hill (District of Anguilla)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Hill (District of Anguilla)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Hill (District of Anguilla)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandy Hill (District of Anguilla)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sandys (Parish of Bermuda)": [
            {
                "Region Name": "Sandys (Parish of Bermuda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandys (Parish of Bermuda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandys (Parish of Bermuda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandys (Parish of Bermuda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandys (Parish of Bermuda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandys (Parish of Bermuda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandys (Parish of Bermuda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandys (Parish of Bermuda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandys (Parish of Bermuda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandys (Parish of Bermuda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandys (Parish of Bermuda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandys (Parish of Bermuda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandys (Parish of Bermuda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandys (Parish of Bermuda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandys (Parish of Bermuda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandys (Parish of Bermuda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandys (Parish of Bermuda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandys (Parish of Bermuda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandys (Parish of Bermuda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandys (Parish of Bermuda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandys (Parish of Bermuda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sandys (Parish of Bermuda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sangha-Mba\xe9r\xe9 (Economic Prefecture of Central African Republic)": [
            {
                "Region Name": "Sangha-Mba\xe9r\xe9 (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sangha-Mba\xe9r\xe9 (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sangha-Mba\xe9r\xe9 (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sangha-Mba\xe9r\xe9 (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sangha-Mba\xe9r\xe9 (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sangha-Mba\xe9r\xe9 (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sangha-Mba\xe9r\xe9 (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sangha-Mba\xe9r\xe9 (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sangha-Mba\xe9r\xe9 (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sangha-Mba\xe9r\xe9 (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sangha-Mba\xe9r\xe9 (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sangha-Mba\xe9r\xe9 (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sangha-Mba\xe9r\xe9 (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sangha-Mba\xe9r\xe9 (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sangha-Mba\xe9r\xe9 (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sangha-Mba\xe9r\xe9 (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sangha-Mba\xe9r\xe9 (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sangha-Mba\xe9r\xe9 (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sangha-Mba\xe9r\xe9 (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sangha-Mba\xe9r\xe9 (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sangha-Mba\xe9r\xe9 (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sangha-Mba\xe9r\xe9 (Economic Prefecture of Central African Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Sangha (Region of Republic of the Congo)": [
            {
                "Region Name": "Sangha (Region of Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sangha (Region of Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sangha (Region of Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sangha (Region of Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sangha (Region of Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sangha (Region of Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Sangha (Region of Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sangha (Region of Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sangha (Region of Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sangha (Region of Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sangha (Region of Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sangha (Region of Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sangha (Region of Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sangha (Region of Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Sangha (Region of Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sangha (Region of Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sangha (Region of Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sangha (Region of Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sangha (Region of Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sangha (Region of Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sangha (Region of Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sangha (Region of Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Sangre Grande (Region of Trinidad and Tobago)": [
            {
                "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sangre Grande (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sankt Gallen (Canton of Switzerland)": [
            {
                "Region Name": "Sankt Gallen (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sankt Gallen (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sankt Gallen (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sankt Gallen (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sankt Gallen (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sankt Gallen (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sankt Gallen (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sankt Gallen (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sankt Gallen (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sankt Gallen (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sankt Gallen (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sankt Gallen (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sankt Gallen (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sankt Gallen (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sankt Gallen (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sankt Gallen (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sankt Gallen (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sankt Gallen (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sankt Gallen (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sankt Gallen (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sankt Gallen (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sankt Gallen (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sankuru (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sankuru (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Sanliurfa (Province of Turkey)": [
            {
                "Region Name": "Sanliurfa (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sanliurfa (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sanliurfa (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sanliurfa (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sanliurfa (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sanliurfa (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sanliurfa (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sanliurfa (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sanliurfa (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sanliurfa (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sanliurfa (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sanliurfa (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sanliurfa (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sanliurfa (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sanliurfa (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sanliurfa (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sanliurfa (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sanliurfa (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sanliurfa (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sanliurfa (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sanliurfa (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sanliurfa (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Sanma (Province of Vanuatu)": [
            {
                "Region Name": "Sanma (Province of Vanuatu)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanma (Province of Vanuatu)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanma (Province of Vanuatu)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanma (Province of Vanuatu)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanma (Province of Vanuatu)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanma (Province of Vanuatu)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanma (Province of Vanuatu)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanma (Province of Vanuatu)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanma (Province of Vanuatu)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanma (Province of Vanuatu)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanma (Province of Vanuatu)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanma (Province of Vanuatu)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanma (Province of Vanuatu)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanma (Province of Vanuatu)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanma (Province of Vanuatu)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanma (Province of Vanuatu)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanma (Province of Vanuatu)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanma (Province of Vanuatu)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanma (Province of Vanuatu)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanma (Province of Vanuatu)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanma (Province of Vanuatu)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sanma (Province of Vanuatu)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sant Juli\xe0 de L\xf2ria (Parish of Andorra)": [
            {
                "Region Name": "Sant Juli\xe0 de L\xf2ria (Parish of Andorra)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sant Juli\xe0 de L\xf2ria (Parish of Andorra)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sant Juli\xe0 de L\xf2ria (Parish of Andorra)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sant Juli\xe0 de L\xf2ria (Parish of Andorra)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sant Juli\xe0 de L\xf2ria (Parish of Andorra)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sant Juli\xe0 de L\xf2ria (Parish of Andorra)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sant Juli\xe0 de L\xf2ria (Parish of Andorra)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sant Juli\xe0 de L\xf2ria (Parish of Andorra)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sant Juli\xe0 de L\xf2ria (Parish of Andorra)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sant Juli\xe0 de L\xf2ria (Parish of Andorra)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sant Juli\xe0 de L\xf2ria (Parish of Andorra)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sant Juli\xe0 de L\xf2ria (Parish of Andorra)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sant Juli\xe0 de L\xf2ria (Parish of Andorra)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sant Juli\xe0 de L\xf2ria (Parish of Andorra)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sant Juli\xe0 de L\xf2ria (Parish of Andorra)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sant Juli\xe0 de L\xf2ria (Parish of Andorra)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sant Juli\xe0 de L\xf2ria (Parish of Andorra)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sant Juli\xe0 de L\xf2ria (Parish of Andorra)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sant Juli\xe0 de L\xf2ria (Parish of Andorra)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sant Juli\xe0 de L\xf2ria (Parish of Andorra)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sant Juli\xe0 de L\xf2ria (Parish of Andorra)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sant Juli\xe0 de L\xf2ria (Parish of Andorra)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Santa Ana (Department of El Salvador)": [
            {
                "Region Name": "Santa Ana (Department of El Salvador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santa Ana (Department of El Salvador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Ana (Department of El Salvador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Ana (Department of El Salvador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santa Ana (Department of El Salvador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Ana (Department of El Salvador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Ana (Department of El Salvador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Ana (Department of El Salvador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Ana (Department of El Salvador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Ana (Department of El Salvador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Ana (Department of El Salvador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Ana (Department of El Salvador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Ana (Department of El Salvador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Ana (Department of El Salvador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santa Ana (Department of El Salvador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santa Ana (Department of El Salvador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santa Ana (Department of El Salvador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santa Ana (Department of El Salvador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santa Ana (Department of El Salvador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Ana (Department of El Salvador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Ana (Department of El Salvador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santa Ana (Department of El Salvador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Santa B\xe1rbara (Department of Honduras)": [
            {
                "Region Name": "Santa B\xe1rbara (Department of Honduras)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santa B\xe1rbara (Department of Honduras)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa B\xe1rbara (Department of Honduras)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santa B\xe1rbara (Department of Honduras)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa B\xe1rbara (Department of Honduras)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santa B\xe1rbara (Department of Honduras)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santa B\xe1rbara (Department of Honduras)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santa B\xe1rbara (Department of Honduras)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa B\xe1rbara (Department of Honduras)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santa B\xe1rbara (Department of Honduras)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa B\xe1rbara (Department of Honduras)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa B\xe1rbara (Department of Honduras)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santa B\xe1rbara (Department of Honduras)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santa B\xe1rbara (Department of Honduras)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa B\xe1rbara (Department of Honduras)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa B\xe1rbara (Department of Honduras)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa B\xe1rbara (Department of Honduras)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santa B\xe1rbara (Department of Honduras)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa B\xe1rbara (Department of Honduras)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa B\xe1rbara (Department of Honduras)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santa B\xe1rbara (Department of Honduras)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa B\xe1rbara (Department of Honduras)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Santa Catarina (County of Cabo Verde)": [
            {
                "Region Name": "Santa Catarina (County of Cabo Verde)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina (County of Cabo Verde)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina (County of Cabo Verde)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina (County of Cabo Verde)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina (County of Cabo Verde)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina (County of Cabo Verde)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina (County of Cabo Verde)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina (County of Cabo Verde)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina (County of Cabo Verde)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina (County of Cabo Verde)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina (County of Cabo Verde)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina (County of Cabo Verde)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina (County of Cabo Verde)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina (County of Cabo Verde)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina (County of Cabo Verde)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina (County of Cabo Verde)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina (County of Cabo Verde)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina (County of Cabo Verde)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina (County of Cabo Verde)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina (County of Cabo Verde)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina (County of Cabo Verde)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina (County of Cabo Verde)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Santa Catarina (State of Brazil)": [
            {
                "Region Name": "Santa Catarina (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa Catarina (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santa Catarina (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa Catarina (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa Catarina (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa Catarina (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa Catarina (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa Catarina (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santa Catarina (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa Catarina (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa Catarina (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santa Catarina (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa Catarina (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa Catarina (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santa Catarina (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa Catarina (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa Catarina (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa Catarina (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa Catarina (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santa Catarina (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santa Catarina (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa Catarina (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Santa Catarina do Fogo (County of Cabo Verde)": [
            {
                "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Catarina do Fogo (County of Cabo Verde)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Santa Cruz (County of Cabo Verde)": [
            {
                "Region Name": "Santa Cruz (County of Cabo Verde)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Cruz (County of Cabo Verde)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Cruz (County of Cabo Verde)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Cruz (County of Cabo Verde)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Cruz (County of Cabo Verde)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Cruz (County of Cabo Verde)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Cruz (County of Cabo Verde)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Cruz (County of Cabo Verde)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Cruz (County of Cabo Verde)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Cruz (County of Cabo Verde)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Cruz (County of Cabo Verde)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Cruz (County of Cabo Verde)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Cruz (County of Cabo Verde)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Cruz (County of Cabo Verde)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Cruz (County of Cabo Verde)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Cruz (County of Cabo Verde)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Cruz (County of Cabo Verde)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Cruz (County of Cabo Verde)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Cruz (County of Cabo Verde)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Cruz (County of Cabo Verde)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Cruz (County of Cabo Verde)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Cruz (County of Cabo Verde)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Santa Cruz (Department of Bolivia)": [
            {
                "Region Name": "Santa Cruz (Department of Bolivia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Santa Cruz (Department of Bolivia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Santa Cruz (Department of Bolivia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Santa Cruz (Department of Bolivia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Santa Cruz (Department of Bolivia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Santa Cruz (Department of Bolivia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Santa Cruz (Department of Bolivia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Santa Cruz (Department of Bolivia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Santa Cruz (Department of Bolivia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Santa Cruz (Department of Bolivia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Santa Cruz (Department of Bolivia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Santa Cruz (Department of Bolivia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Santa Cruz (Department of Bolivia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santa Cruz (Department of Bolivia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Santa Cruz (Department of Bolivia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Santa Cruz (Department of Bolivia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Santa Cruz (Department of Bolivia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Santa Cruz (Department of Bolivia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Santa Cruz (Department of Bolivia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Santa Cruz (Department of Bolivia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Santa Cruz (Department of Bolivia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Santa Cruz (Department of Bolivia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Santa Cruz (Province of Argentina)": [
            {
                "Region Name": "Santa Cruz (Province of Argentina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santa Cruz (Province of Argentina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa Cruz (Province of Argentina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa Cruz (Province of Argentina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa Cruz (Province of Argentina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santa Cruz (Province of Argentina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santa Cruz (Province of Argentina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santa Cruz (Province of Argentina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Santa Cruz (Province of Argentina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Cruz (Province of Argentina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa Cruz (Province of Argentina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santa Cruz (Province of Argentina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa Cruz (Province of Argentina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa Cruz (Province of Argentina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santa Cruz (Province of Argentina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santa Cruz (Province of Argentina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santa Cruz (Province of Argentina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa Cruz (Province of Argentina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santa Cruz (Province of Argentina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa Cruz (Province of Argentina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa Cruz (Province of Argentina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Santa Cruz (Province of Argentina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Santa Elena (Province of Ecuador)": [
            {
                "Region Name": "Santa Elena (Province of Ecuador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Elena (Province of Ecuador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Elena (Province of Ecuador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santa Elena (Province of Ecuador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Elena (Province of Ecuador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Elena (Province of Ecuador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Elena (Province of Ecuador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Elena (Province of Ecuador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Santa Elena (Province of Ecuador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santa Elena (Province of Ecuador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa Elena (Province of Ecuador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Elena (Province of Ecuador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Elena (Province of Ecuador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Elena (Province of Ecuador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Elena (Province of Ecuador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santa Elena (Province of Ecuador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Elena (Province of Ecuador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Elena (Province of Ecuador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Elena (Province of Ecuador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Elena (Province of Ecuador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santa Elena (Province of Ecuador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santa Elena (Province of Ecuador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Santa Fe (Province of Argentina)": [
            {
                "Region Name": "Santa Fe (Province of Argentina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santa Fe (Province of Argentina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santa Fe (Province of Argentina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Santa Fe (Province of Argentina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santa Fe (Province of Argentina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santa Fe (Province of Argentina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Santa Fe (Province of Argentina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Santa Fe (Province of Argentina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santa Fe (Province of Argentina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Santa Fe (Province of Argentina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Santa Fe (Province of Argentina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Santa Fe (Province of Argentina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Santa Fe (Province of Argentina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa Fe (Province of Argentina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santa Fe (Province of Argentina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santa Fe (Province of Argentina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santa Fe (Province of Argentina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santa Fe (Province of Argentina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa Fe (Province of Argentina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Santa Fe (Province of Argentina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Santa Fe (Province of Argentina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Santa Fe (Province of Argentina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Santa Isabel (Municipality of Puerto Rico)": [
            {
                "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Isabel (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Santa Rita (Municipality of Guam)": [
            {
                "Region Name": "Santa Rita (Municipality of Guam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Rita (Municipality of Guam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Rita (Municipality of Guam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Rita (Municipality of Guam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Rita (Municipality of Guam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Rita (Municipality of Guam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Rita (Municipality of Guam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Rita (Municipality of Guam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Rita (Municipality of Guam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Rita (Municipality of Guam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Rita (Municipality of Guam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Rita (Municipality of Guam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Rita (Municipality of Guam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Rita (Municipality of Guam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Rita (Municipality of Guam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Rita (Municipality of Guam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Rita (Municipality of Guam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Rita (Municipality of Guam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Rita (Municipality of Guam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Rita (Municipality of Guam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Rita (Municipality of Guam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santa Rita (Municipality of Guam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Santa Rosa (Department of Guatemala)": [
            {
                "Region Name": "Santa Rosa (Department of Guatemala)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa Rosa (Department of Guatemala)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa Rosa (Department of Guatemala)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santa Rosa (Department of Guatemala)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa Rosa (Department of Guatemala)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santa Rosa (Department of Guatemala)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa Rosa (Department of Guatemala)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santa Rosa (Department of Guatemala)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santa Rosa (Department of Guatemala)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santa Rosa (Department of Guatemala)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa Rosa (Department of Guatemala)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa Rosa (Department of Guatemala)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa Rosa (Department of Guatemala)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa Rosa (Department of Guatemala)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa Rosa (Department of Guatemala)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santa Rosa (Department of Guatemala)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santa Rosa (Department of Guatemala)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa Rosa (Department of Guatemala)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santa Rosa (Department of Guatemala)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa Rosa (Department of Guatemala)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santa Rosa (Department of Guatemala)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santa Rosa (Department of Guatemala)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Santander (Department of Colombia)": [
            {
                "Region Name": "Santander (Department of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Santander (Department of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santander (Department of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santander (Department of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santander (Department of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santander (Department of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santander (Department of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santander (Department of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santander (Department of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santander (Department of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santander (Department of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santander (Department of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santander (Department of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santander (Department of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santander (Department of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santander (Department of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santander (Department of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santander (Department of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santander (Department of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santander (Department of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santander (Department of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santander (Department of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Santar\xe9m (District of Portugal)": [
            {
                "Region Name": "Santar\xe9m (District of Portugal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santar\xe9m (District of Portugal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 134
            },
            {
                "Region Name": "Santar\xe9m (District of Portugal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Santar\xe9m (District of Portugal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Santar\xe9m (District of Portugal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santar\xe9m (District of Portugal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Santar\xe9m (District of Portugal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santar\xe9m (District of Portugal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santar\xe9m (District of Portugal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santar\xe9m (District of Portugal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santar\xe9m (District of Portugal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Santar\xe9m (District of Portugal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santar\xe9m (District of Portugal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santar\xe9m (District of Portugal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Santar\xe9m (District of Portugal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Santar\xe9m (District of Portugal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 176
            },
            {
                "Region Name": "Santar\xe9m (District of Portugal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santar\xe9m (District of Portugal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 63
            },
            {
                "Region Name": "Santar\xe9m (District of Portugal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santar\xe9m (District of Portugal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santar\xe9m (District of Portugal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Santar\xe9m (District of Portugal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Santiago (Province of Dominican Republic)": [
            {
                "Region Name": "Santiago (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santiago (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santiago (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santiago (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Santiago de Cuba (Province of Cuba)": [
            {
                "Region Name": "Santiago de Cuba (Province of Cuba)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santiago de Cuba (Province of Cuba)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santiago de Cuba (Province of Cuba)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santiago de Cuba (Province of Cuba)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santiago de Cuba (Province of Cuba)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Santiago de Cuba (Province of Cuba)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santiago de Cuba (Province of Cuba)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santiago de Cuba (Province of Cuba)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Santiago de Cuba (Province of Cuba)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santiago de Cuba (Province of Cuba)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santiago de Cuba (Province of Cuba)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santiago de Cuba (Province of Cuba)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santiago de Cuba (Province of Cuba)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santiago de Cuba (Province of Cuba)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santiago de Cuba (Province of Cuba)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santiago de Cuba (Province of Cuba)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santiago de Cuba (Province of Cuba)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santiago de Cuba (Province of Cuba)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santiago de Cuba (Province of Cuba)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santiago de Cuba (Province of Cuba)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santiago de Cuba (Province of Cuba)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Santiago de Cuba (Province of Cuba)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Santiago del Estero (Province of Argentina)": [
            {
                "Region Name": "Santiago del Estero (Province of Argentina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Santiago del Estero (Province of Argentina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Santiago del Estero (Province of Argentina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santiago del Estero (Province of Argentina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santiago del Estero (Province of Argentina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santiago del Estero (Province of Argentina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Santiago del Estero (Province of Argentina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Santiago del Estero (Province of Argentina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santiago del Estero (Province of Argentina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Santiago del Estero (Province of Argentina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Santiago del Estero (Province of Argentina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santiago del Estero (Province of Argentina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santiago del Estero (Province of Argentina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santiago del Estero (Province of Argentina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Santiago del Estero (Province of Argentina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santiago del Estero (Province of Argentina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Santiago del Estero (Province of Argentina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santiago del Estero (Province of Argentina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santiago del Estero (Province of Argentina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Santiago del Estero (Province of Argentina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santiago del Estero (Province of Argentina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santiago del Estero (Province of Argentina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Santiago Metropolitan (Metropolian Region of Chile)": [
            {
                "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Santiago Metropolitan (Metropolian Region of Chile)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Santiago Rodr\xedguez (Province of Dominican Republic)": [
            {
                "Region Name": "Santiago Rodr\xedguez (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago Rodr\xedguez (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago Rodr\xedguez (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago Rodr\xedguez (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago Rodr\xedguez (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago Rodr\xedguez (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago Rodr\xedguez (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago Rodr\xedguez (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago Rodr\xedguez (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago Rodr\xedguez (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santiago Rodr\xedguez (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago Rodr\xedguez (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago Rodr\xedguez (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago Rodr\xedguez (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago Rodr\xedguez (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago Rodr\xedguez (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago Rodr\xedguez (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santiago Rodr\xedguez (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago Rodr\xedguez (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago Rodr\xedguez (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago Rodr\xedguez (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santiago Rodr\xedguez (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Santo Domingo (Province of Dominican Republic)": [
            {
                "Region Name": "Santo Domingo (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santo Domingo (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Santo Domingo (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santo Domingo (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santo Domingo (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Santo Domingo (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Santo Domingo (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Santo Domingo (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Santo Domingo (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Santo Domingo (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santo Domingo (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Santo Domingo (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santo Domingo (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santo Domingo (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santo Domingo (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santo Domingo (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Santo Domingo (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Santo Domingo (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Santo Domingo (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Santo Domingo (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santo Domingo (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santo Domingo (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Santo Domingo de los Tsachilas (Province of Ecuador)": [
            {
                "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santo Domingo de los Tsachilas (Province of Ecuador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Santon (Parish District of Isle of Man)": [
            {
                "Region Name": "Santon (Parish District of Isle of Man)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santon (Parish District of Isle of Man)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santon (Parish District of Isle of Man)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santon (Parish District of Isle of Man)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santon (Parish District of Isle of Man)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santon (Parish District of Isle of Man)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santon (Parish District of Isle of Man)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santon (Parish District of Isle of Man)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santon (Parish District of Isle of Man)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santon (Parish District of Isle of Man)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santon (Parish District of Isle of Man)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santon (Parish District of Isle of Man)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santon (Parish District of Isle of Man)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santon (Parish District of Isle of Man)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santon (Parish District of Isle of Man)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santon (Parish District of Isle of Man)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santon (Parish District of Isle of Man)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santon (Parish District of Isle of Man)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santon (Parish District of Isle of Man)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santon (Parish District of Isle of Man)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santon (Parish District of Isle of Man)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Santon (Parish District of Isle of Man)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "S\xe3o Domingos (County of Cabo Verde)": [
            {
                "Region Name": "S\xe3o Domingos (County of Cabo Verde)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Domingos (County of Cabo Verde)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Domingos (County of Cabo Verde)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Domingos (County of Cabo Verde)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Domingos (County of Cabo Verde)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Domingos (County of Cabo Verde)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Domingos (County of Cabo Verde)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Domingos (County of Cabo Verde)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Domingos (County of Cabo Verde)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Domingos (County of Cabo Verde)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Domingos (County of Cabo Verde)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Domingos (County of Cabo Verde)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Domingos (County of Cabo Verde)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Domingos (County of Cabo Verde)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Domingos (County of Cabo Verde)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Domingos (County of Cabo Verde)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Domingos (County of Cabo Verde)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Domingos (County of Cabo Verde)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Domingos (County of Cabo Verde)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Domingos (County of Cabo Verde)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Domingos (County of Cabo Verde)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Domingos (County of Cabo Verde)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "S\xe3o Filipe (County of Cabo Verde)": [
            {
                "Region Name": "S\xe3o Filipe (County of Cabo Verde)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Filipe (County of Cabo Verde)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Filipe (County of Cabo Verde)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Filipe (County of Cabo Verde)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Filipe (County of Cabo Verde)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Filipe (County of Cabo Verde)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Filipe (County of Cabo Verde)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Filipe (County of Cabo Verde)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Filipe (County of Cabo Verde)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Filipe (County of Cabo Verde)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Filipe (County of Cabo Verde)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Filipe (County of Cabo Verde)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Filipe (County of Cabo Verde)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Filipe (County of Cabo Verde)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Filipe (County of Cabo Verde)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Filipe (County of Cabo Verde)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Filipe (County of Cabo Verde)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Filipe (County of Cabo Verde)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Filipe (County of Cabo Verde)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Filipe (County of Cabo Verde)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Filipe (County of Cabo Verde)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Filipe (County of Cabo Verde)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "S\xe3o Louren\xe7o dos \xd3rg\xe3os (County of Cabo Verde)": [
            {
                "Region Name": "S\xe3o Louren\xe7o dos \xd3rg\xe3os (County of Cabo Verde)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Louren\xe7o dos \xd3rg\xe3os (County of Cabo Verde)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Louren\xe7o dos \xd3rg\xe3os (County of Cabo Verde)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Louren\xe7o dos \xd3rg\xe3os (County of Cabo Verde)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Louren\xe7o dos \xd3rg\xe3os (County of Cabo Verde)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Louren\xe7o dos \xd3rg\xe3os (County of Cabo Verde)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Louren\xe7o dos \xd3rg\xe3os (County of Cabo Verde)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Louren\xe7o dos \xd3rg\xe3os (County of Cabo Verde)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Louren\xe7o dos \xd3rg\xe3os (County of Cabo Verde)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Louren\xe7o dos \xd3rg\xe3os (County of Cabo Verde)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Louren\xe7o dos \xd3rg\xe3os (County of Cabo Verde)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Louren\xe7o dos \xd3rg\xe3os (County of Cabo Verde)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Louren\xe7o dos \xd3rg\xe3os (County of Cabo Verde)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Louren\xe7o dos \xd3rg\xe3os (County of Cabo Verde)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Louren\xe7o dos \xd3rg\xe3os (County of Cabo Verde)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Louren\xe7o dos \xd3rg\xe3os (County of Cabo Verde)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Louren\xe7o dos \xd3rg\xe3os (County of Cabo Verde)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Louren\xe7o dos \xd3rg\xe3os (County of Cabo Verde)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Louren\xe7o dos \xd3rg\xe3os (County of Cabo Verde)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Louren\xe7o dos \xd3rg\xe3os (County of Cabo Verde)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Louren\xe7o dos \xd3rg\xe3os (County of Cabo Verde)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Louren\xe7o dos \xd3rg\xe3os (County of Cabo Verde)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "S\xe3o Miguel (County of Cabo Verde)": [
            {
                "Region Name": "S\xe3o Miguel (County of Cabo Verde)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Miguel (County of Cabo Verde)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Miguel (County of Cabo Verde)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Miguel (County of Cabo Verde)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Miguel (County of Cabo Verde)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Miguel (County of Cabo Verde)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Miguel (County of Cabo Verde)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Miguel (County of Cabo Verde)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Miguel (County of Cabo Verde)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Miguel (County of Cabo Verde)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Miguel (County of Cabo Verde)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Miguel (County of Cabo Verde)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Miguel (County of Cabo Verde)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Miguel (County of Cabo Verde)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Miguel (County of Cabo Verde)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Miguel (County of Cabo Verde)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Miguel (County of Cabo Verde)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Miguel (County of Cabo Verde)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Miguel (County of Cabo Verde)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Miguel (County of Cabo Verde)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Miguel (County of Cabo Verde)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Miguel (County of Cabo Verde)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "S\xe3o Paulo (State of Brazil)": [
            {
                "Region Name": "S\xe3o Paulo (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "S\xe3o Paulo (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "S\xe3o Paulo (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "S\xe3o Paulo (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "S\xe3o Paulo (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "S\xe3o Paulo (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "S\xe3o Paulo (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "S\xe3o Paulo (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "S\xe3o Paulo (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "S\xe3o Paulo (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "S\xe3o Paulo (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "S\xe3o Paulo (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "S\xe3o Paulo (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "S\xe3o Paulo (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "S\xe3o Paulo (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "S\xe3o Paulo (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "S\xe3o Paulo (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "S\xe3o Paulo (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "S\xe3o Paulo (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "S\xe3o Paulo (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "S\xe3o Paulo (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "S\xe3o Paulo (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "S\xe3o Salvador do Mundo (County of Cabo Verde)": [
            {
                "Region Name": "S\xe3o Salvador do Mundo (County of Cabo Verde)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Salvador do Mundo (County of Cabo Verde)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Salvador do Mundo (County of Cabo Verde)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Salvador do Mundo (County of Cabo Verde)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Salvador do Mundo (County of Cabo Verde)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Salvador do Mundo (County of Cabo Verde)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Salvador do Mundo (County of Cabo Verde)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Salvador do Mundo (County of Cabo Verde)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Salvador do Mundo (County of Cabo Verde)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Salvador do Mundo (County of Cabo Verde)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Salvador do Mundo (County of Cabo Verde)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Salvador do Mundo (County of Cabo Verde)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Salvador do Mundo (County of Cabo Verde)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Salvador do Mundo (County of Cabo Verde)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Salvador do Mundo (County of Cabo Verde)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Salvador do Mundo (County of Cabo Verde)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Salvador do Mundo (County of Cabo Verde)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Salvador do Mundo (County of Cabo Verde)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Salvador do Mundo (County of Cabo Verde)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Salvador do Mundo (County of Cabo Verde)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Salvador do Mundo (County of Cabo Verde)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Salvador do Mundo (County of Cabo Verde)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "S\xe3o Tom\xe9 (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)": [
            {
                "Region Name": "S\xe3o Tom\xe9 (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Tom\xe9 (Municipality of S\xe3o Tom\xe9 and Pr\xedncipe)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "S\xe3o Vicente (County of Cabo Verde)": [
            {
                "Region Name": "S\xe3o Vicente (County of Cabo Verde)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Vicente (County of Cabo Verde)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Vicente (County of Cabo Verde)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Vicente (County of Cabo Verde)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Vicente (County of Cabo Verde)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Vicente (County of Cabo Verde)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Vicente (County of Cabo Verde)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Vicente (County of Cabo Verde)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Vicente (County of Cabo Verde)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Vicente (County of Cabo Verde)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Vicente (County of Cabo Verde)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Vicente (County of Cabo Verde)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Vicente (County of Cabo Verde)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Vicente (County of Cabo Verde)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Vicente (County of Cabo Verde)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Vicente (County of Cabo Verde)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Vicente (County of Cabo Verde)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Vicente (County of Cabo Verde)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Vicente (County of Cabo Verde)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Vicente (County of Cabo Verde)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Vicente (County of Cabo Verde)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe3o Vicente (County of Cabo Verde)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saraburi (Province of Thailand)": [
            {
                "Region Name": "Saraburi (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Saraburi (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Saraburi (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Saraburi (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saraburi (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saraburi (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Saraburi (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Saraburi (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Saraburi (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Saraburi (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saraburi (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Saraburi (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saraburi (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Saraburi (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Saraburi (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Saraburi (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Saraburi (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saraburi (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Saraburi (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saraburi (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saraburi (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saraburi (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Saraj (Municipality of North Macedonia)": [
            {
                "Region Name": "Saraj (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saraj (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saraj (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saraj (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saraj (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saraj (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Saraj (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saraj (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saraj (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saraj (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saraj (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saraj (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saraj (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saraj (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saraj (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saraj (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Saraj (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saraj (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saraj (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saraj (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saraj (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saraj (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saramacca (District of Suriname)": [
            {
                "Region Name": "Saramacca (District of Suriname)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saramacca (District of Suriname)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Saramacca (District of Suriname)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Saramacca (District of Suriname)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saramacca (District of Suriname)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saramacca (District of Suriname)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saramacca (District of Suriname)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Saramacca (District of Suriname)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saramacca (District of Suriname)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saramacca (District of Suriname)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saramacca (District of Suriname)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Saramacca (District of Suriname)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saramacca (District of Suriname)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saramacca (District of Suriname)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saramacca (District of Suriname)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saramacca (District of Suriname)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saramacca (District of Suriname)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saramacca (District of Suriname)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saramacca (District of Suriname)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Saramacca (District of Suriname)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saramacca (District of Suriname)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Saramacca (District of Suriname)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Sarangani (Province of Philippines)": [
            {
                "Region Name": "Sarangani (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sarangani (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sarangani (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sarangani (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sarangani (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sarangani (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sarangani (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sarangani (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sarangani (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sarangani (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sarangani (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sarangani (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sarangani (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sarangani (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sarangani (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sarangani (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sarangani (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sarangani (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sarangani (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sarangani (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sarangani (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sarangani (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Saratov (Region of Russia)": [
            {
                "Region Name": "Saratov (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Saratov (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Saratov (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Saratov (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Saratov (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Saratov (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Saratov (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Saratov (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Saratov (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Saratov (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Saratov (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Saratov (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Saratov (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Saratov (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Saratov (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Saratov (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Saratov (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Saratov (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Saratov (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Saratov (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Saratov (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Saratov (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Saravan (Province of Laos)": [
            {
                "Region Name": "Saravan (Province of Laos)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saravan (Province of Laos)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saravan (Province of Laos)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saravan (Province of Laos)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saravan (Province of Laos)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saravan (Province of Laos)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saravan (Province of Laos)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saravan (Province of Laos)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saravan (Province of Laos)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saravan (Province of Laos)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Saravan (Province of Laos)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saravan (Province of Laos)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saravan (Province of Laos)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saravan (Province of Laos)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saravan (Province of Laos)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Saravan (Province of Laos)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saravan (Province of Laos)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saravan (Province of Laos)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Saravan (Province of Laos)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Saravan (Province of Laos)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saravan (Province of Laos)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Saravan (Province of Laos)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Sarawak (State of Malaysia)": [
            {
                "Region Name": "Sarawak (State of Malaysia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sarawak (State of Malaysia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sarawak (State of Malaysia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sarawak (State of Malaysia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sarawak (State of Malaysia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sarawak (State of Malaysia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sarawak (State of Malaysia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sarawak (State of Malaysia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sarawak (State of Malaysia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sarawak (State of Malaysia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sarawak (State of Malaysia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sarawak (State of Malaysia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sarawak (State of Malaysia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sarawak (State of Malaysia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sarawak (State of Malaysia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sarawak (State of Malaysia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sarawak (State of Malaysia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sarawak (State of Malaysia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sarawak (State of Malaysia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sarawak (State of Malaysia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sarawak (State of Malaysia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sarawak (State of Malaysia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Sardegna (Autonomous Region of Italy)": [
            {
                "Region Name": "Sardegna (Autonomous Region of Italy)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sardegna (Autonomous Region of Italy)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sardegna (Autonomous Region of Italy)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sardegna (Autonomous Region of Italy)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sardegna (Autonomous Region of Italy)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sardegna (Autonomous Region of Italy)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sardegna (Autonomous Region of Italy)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sardegna (Autonomous Region of Italy)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Sardegna (Autonomous Region of Italy)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sardegna (Autonomous Region of Italy)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sardegna (Autonomous Region of Italy)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sardegna (Autonomous Region of Italy)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sardegna (Autonomous Region of Italy)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sardegna (Autonomous Region of Italy)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sardegna (Autonomous Region of Italy)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sardegna (Autonomous Region of Italy)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Sardegna (Autonomous Region of Italy)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sardegna (Autonomous Region of Italy)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sardegna (Autonomous Region of Italy)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sardegna (Autonomous Region of Italy)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sardegna (Autonomous Region of Italy)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sardegna (Autonomous Region of Italy)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Sari Pul (Province of Afghanistan)": [
            {
                "Region Name": "Sari Pul (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sari Pul (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sari Pul (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sari Pul (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sari Pul (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sari Pul (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sari Pul (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sari Pul (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sari Pul (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Sari Pul (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sari Pul (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sari Pul (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sari Pul (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sari Pul (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sari Pul (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sari Pul (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sari Pul (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sari Pul (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sari Pul (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sari Pul (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sari Pul (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sari Pul (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sark (Parish of Guernsey)": [
            {
                "Region Name": "Sark (Parish of Guernsey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sark (Parish of Guernsey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sark (Parish of Guernsey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sark (Parish of Guernsey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sark (Parish of Guernsey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sark (Parish of Guernsey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sark (Parish of Guernsey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sark (Parish of Guernsey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sark (Parish of Guernsey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sark (Parish of Guernsey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sark (Parish of Guernsey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sark (Parish of Guernsey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sark (Parish of Guernsey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sark (Parish of Guernsey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sark (Parish of Guernsey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sark (Parish of Guernsey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sark (Parish of Guernsey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sark (Parish of Guernsey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sark (Parish of Guernsey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sark (Parish of Guernsey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sark (Parish of Guernsey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sark (Parish of Guernsey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sarpang (District of Bhutan)": [
            {
                "Region Name": "Sarpang (District of Bhutan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sarpang (District of Bhutan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sarpang (District of Bhutan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sarpang (District of Bhutan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sarpang (District of Bhutan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sarpang (District of Bhutan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sarpang (District of Bhutan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sarpang (District of Bhutan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sarpang (District of Bhutan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sarpang (District of Bhutan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sarpang (District of Bhutan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sarpang (District of Bhutan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sarpang (District of Bhutan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sarpang (District of Bhutan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sarpang (District of Bhutan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sarpang (District of Bhutan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sarpang (District of Bhutan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sarpang (District of Bhutan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sarpang (District of Bhutan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sarpang (District of Bhutan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sarpang (District of Bhutan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sarpang (District of Bhutan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\u0160a\u0161ka (Municipality of North Macedonia)": [
            {
                "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160a\u0161ka (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Saskatchewan (Province of Canada)": [
            {
                "Region Name": "Saskatchewan (Province of Canada)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "Saskatchewan (Province of Canada)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Saskatchewan (Province of Canada)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Saskatchewan (Province of Canada)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Saskatchewan (Province of Canada)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 105
            },
            {
                "Region Name": "Saskatchewan (Province of Canada)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Saskatchewan (Province of Canada)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "Saskatchewan (Province of Canada)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Saskatchewan (Province of Canada)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "Saskatchewan (Province of Canada)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Saskatchewan (Province of Canada)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Saskatchewan (Province of Canada)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Saskatchewan (Province of Canada)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Saskatchewan (Province of Canada)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 82
            },
            {
                "Region Name": "Saskatchewan (Province of Canada)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Saskatchewan (Province of Canada)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Saskatchewan (Province of Canada)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Saskatchewan (Province of Canada)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Saskatchewan (Province of Canada)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Saskatchewan (Province of Canada)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 74
            },
            {
                "Region Name": "Saskatchewan (Province of Canada)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Saskatchewan (Province of Canada)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 34
            }
        ],
        "Sassandra-Marahou\xe9 (District of C\xf4te d'Ivoire)": [
            {
                "Region Name": "Sassandra-Marahou\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sassandra-Marahou\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sassandra-Marahou\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sassandra-Marahou\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sassandra-Marahou\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sassandra-Marahou\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sassandra-Marahou\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sassandra-Marahou\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sassandra-Marahou\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sassandra-Marahou\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sassandra-Marahou\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sassandra-Marahou\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sassandra-Marahou\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sassandra-Marahou\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sassandra-Marahou\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sassandra-Marahou\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sassandra-Marahou\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sassandra-Marahou\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sassandra-Marahou\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sassandra-Marahou\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sassandra-Marahou\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sassandra-Marahou\xe9 (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Satu Mare (County of Romania)": [
            {
                "Region Name": "Satu Mare (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Satu Mare (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Satu Mare (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Satu Mare (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Satu Mare (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satu Mare (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Satu Mare (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Satu Mare (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Satu Mare (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satu Mare (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Satu Mare (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Satu Mare (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Satu Mare (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Satu Mare (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satu Mare (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Satu Mare (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satu Mare (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satu Mare (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Satu Mare (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Satu Mare (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Satu Mare (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Satu Mare (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Satun (Province of Thailand)": [
            {
                "Region Name": "Satun (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satun (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Satun (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Satun (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satun (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satun (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satun (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satun (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satun (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satun (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satun (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satun (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satun (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satun (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satun (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satun (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satun (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satun (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satun (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satun (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satun (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satun (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Satupa'itea (District of Samoa)": [
            {
                "Region Name": "Satupa'itea (District of Samoa)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satupa'itea (District of Samoa)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satupa'itea (District of Samoa)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satupa'itea (District of Samoa)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satupa'itea (District of Samoa)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satupa'itea (District of Samoa)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satupa'itea (District of Samoa)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satupa'itea (District of Samoa)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satupa'itea (District of Samoa)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satupa'itea (District of Samoa)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satupa'itea (District of Samoa)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satupa'itea (District of Samoa)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satupa'itea (District of Samoa)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satupa'itea (District of Samoa)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satupa'itea (District of Samoa)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satupa'itea (District of Samoa)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satupa'itea (District of Samoa)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satupa'itea (District of Samoa)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satupa'itea (District of Samoa)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satupa'itea (District of Samoa)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satupa'itea (District of Samoa)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Satupa'itea (District of Samoa)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Savanes (District of C\xf4te d'Ivoire)": [
            {
                "Region Name": "Savanes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Savanes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Savanes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Savanes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Savanes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Savanes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Savanes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Savanes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Savanes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Savanes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Savanes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Savanes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Savanes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Savanes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Savanes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Savanes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Savanes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Savanes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Savanes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Savanes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Savanes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Savanes (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 26
            }
        ],
        "Savanes (Region of Togo)": [
            {
                "Region Name": "Savanes (Region of Togo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Savanes (Region of Togo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Savanes (Region of Togo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Savanes (Region of Togo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Savanes (Region of Togo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Savanes (Region of Togo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Savanes (Region of Togo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Savanes (Region of Togo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Savanes (Region of Togo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Savanes (Region of Togo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Savanes (Region of Togo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Savanes (Region of Togo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Savanes (Region of Togo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Savanes (Region of Togo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Savanes (Region of Togo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Savanes (Region of Togo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Savanes (Region of Togo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Savanes (Region of Togo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Savanes (Region of Togo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Savanes (Region of Togo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Savanes (Region of Togo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Savanes (Region of Togo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 16
            }
        ],
        "Savannah (Region of Ghana)": [
            {
                "Region Name": "Savannah (Region of Ghana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Savannah (Region of Ghana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Savannah (Region of Ghana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Savannah (Region of Ghana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Savannah (Region of Ghana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Savannah (Region of Ghana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Savannah (Region of Ghana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Savannah (Region of Ghana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Savannah (Region of Ghana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Savannah (Region of Ghana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Savannah (Region of Ghana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Savannah (Region of Ghana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Savannah (Region of Ghana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Savannah (Region of Ghana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Savannah (Region of Ghana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Savannah (Region of Ghana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Savannah (Region of Ghana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Savannah (Region of Ghana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Savannah (Region of Ghana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Savannah (Region of Ghana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Savannah (Region of Ghana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Savannah (Region of Ghana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 19
            }
        ],
        "Savannakh\xe9t (Province of Laos)": [
            {
                "Region Name": "Savannakh\xe9t (Province of Laos)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Savannakh\xe9t (Province of Laos)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Savannakh\xe9t (Province of Laos)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Savannakh\xe9t (Province of Laos)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Savannakh\xe9t (Province of Laos)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Savannakh\xe9t (Province of Laos)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Savannakh\xe9t (Province of Laos)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Savannakh\xe9t (Province of Laos)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Savannakh\xe9t (Province of Laos)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Savannakh\xe9t (Province of Laos)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Savannakh\xe9t (Province of Laos)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Savannakh\xe9t (Province of Laos)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Savannakh\xe9t (Province of Laos)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Savannakh\xe9t (Province of Laos)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Savannakh\xe9t (Province of Laos)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Savannakh\xe9t (Province of Laos)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Savannakh\xe9t (Province of Laos)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Savannakh\xe9t (Province of Laos)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Savannakh\xe9t (Province of Laos)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Savannakh\xe9t (Province of Laos)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Savannakh\xe9t (Province of Laos)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Savannakh\xe9t (Province of Laos)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Savanne (District of Mauritius)": [
            {
                "Region Name": "Savanne (District of Mauritius)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savanne (District of Mauritius)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savanne (District of Mauritius)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savanne (District of Mauritius)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savanne (District of Mauritius)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Savanne (District of Mauritius)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savanne (District of Mauritius)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savanne (District of Mauritius)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savanne (District of Mauritius)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Savanne (District of Mauritius)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savanne (District of Mauritius)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savanne (District of Mauritius)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savanne (District of Mauritius)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Savanne (District of Mauritius)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savanne (District of Mauritius)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savanne (District of Mauritius)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savanne (District of Mauritius)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savanne (District of Mauritius)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savanne (District of Mauritius)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savanne (District of Mauritius)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savanne (District of Mauritius)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savanne (District of Mauritius)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Savinjska (Statistical Region of Slovenia)": [
            {
                "Region Name": "Savinjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savinjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savinjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savinjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savinjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savinjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savinjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savinjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savinjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savinjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savinjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savinjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savinjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savinjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savinjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savinjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savinjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savinjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savinjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savinjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savinjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Savinjska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\u0160avnik (Municipality of Montenegro)": [
            {
                "Region Name": "\u0160avnik (Municipality of Montenegro)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160avnik (Municipality of Montenegro)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160avnik (Municipality of Montenegro)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160avnik (Municipality of Montenegro)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160avnik (Municipality of Montenegro)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160avnik (Municipality of Montenegro)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "\u0160avnik (Municipality of Montenegro)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160avnik (Municipality of Montenegro)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0160avnik (Municipality of Montenegro)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160avnik (Municipality of Montenegro)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160avnik (Municipality of Montenegro)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0160avnik (Municipality of Montenegro)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160avnik (Municipality of Montenegro)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160avnik (Municipality of Montenegro)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0160avnik (Municipality of Montenegro)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160avnik (Municipality of Montenegro)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160avnik (Municipality of Montenegro)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160avnik (Municipality of Montenegro)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160avnik (Municipality of Montenegro)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160avnik (Municipality of Montenegro)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160avnik (Municipality of Montenegro)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160avnik (Municipality of Montenegro)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Schaan (Commune of Liechtenstein)": [
            {
                "Region Name": "Schaan (Commune of Liechtenstein)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaan (Commune of Liechtenstein)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaan (Commune of Liechtenstein)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaan (Commune of Liechtenstein)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaan (Commune of Liechtenstein)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaan (Commune of Liechtenstein)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaan (Commune of Liechtenstein)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaan (Commune of Liechtenstein)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaan (Commune of Liechtenstein)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaan (Commune of Liechtenstein)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaan (Commune of Liechtenstein)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaan (Commune of Liechtenstein)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaan (Commune of Liechtenstein)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaan (Commune of Liechtenstein)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaan (Commune of Liechtenstein)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaan (Commune of Liechtenstein)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaan (Commune of Liechtenstein)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaan (Commune of Liechtenstein)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaan (Commune of Liechtenstein)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaan (Commune of Liechtenstein)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaan (Commune of Liechtenstein)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaan (Commune of Liechtenstein)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Schaffhausen (Canton of Switzerland)": [
            {
                "Region Name": "Schaffhausen (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaffhausen (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaffhausen (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaffhausen (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaffhausen (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaffhausen (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaffhausen (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaffhausen (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaffhausen (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaffhausen (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaffhausen (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaffhausen (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaffhausen (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaffhausen (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaffhausen (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaffhausen (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaffhausen (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaffhausen (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaffhausen (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaffhausen (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaffhausen (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schaffhausen (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Schellenberg (Commune of Liechtenstein)": [
            {
                "Region Name": "Schellenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schellenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schellenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schellenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schellenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schellenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schellenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schellenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schellenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schellenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schellenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schellenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schellenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schellenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schellenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schellenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schellenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schellenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schellenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schellenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schellenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schellenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Schleswig-Holstein (State of Germany)": [
            {
                "Region Name": "Schleswig-Holstein (State of Germany)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schleswig-Holstein (State of Germany)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schleswig-Holstein (State of Germany)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schleswig-Holstein (State of Germany)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Schleswig-Holstein (State of Germany)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Schleswig-Holstein (State of Germany)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schleswig-Holstein (State of Germany)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schleswig-Holstein (State of Germany)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schleswig-Holstein (State of Germany)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schleswig-Holstein (State of Germany)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schleswig-Holstein (State of Germany)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schleswig-Holstein (State of Germany)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schleswig-Holstein (State of Germany)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schleswig-Holstein (State of Germany)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schleswig-Holstein (State of Germany)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schleswig-Holstein (State of Germany)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schleswig-Holstein (State of Germany)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Schleswig-Holstein (State of Germany)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schleswig-Holstein (State of Germany)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Schleswig-Holstein (State of Germany)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schleswig-Holstein (State of Germany)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schleswig-Holstein (State of Germany)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Schwyz (Canton of Switzerland)": [
            {
                "Region Name": "Schwyz (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schwyz (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schwyz (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schwyz (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schwyz (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schwyz (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schwyz (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schwyz (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schwyz (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schwyz (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schwyz (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schwyz (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schwyz (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Schwyz (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schwyz (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schwyz (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schwyz (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schwyz (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schwyz (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schwyz (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schwyz (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Schwyz (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Scotland (Constituent Country of United Kingdom)": [
            {
                "Region Name": "Scotland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Scotland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Scotland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scotland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Scotland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Scotland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Scotland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scotland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Scotland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Scotland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Scotland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Scotland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scotland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scotland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Scotland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Scotland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Scotland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Scotland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Scotland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Scotland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scotland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Scotland (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "Scrub Island (Island of Anguilla)": [
            {
                "Region Name": "Scrub Island (Island of Anguilla)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scrub Island (Island of Anguilla)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scrub Island (Island of Anguilla)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scrub Island (Island of Anguilla)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scrub Island (Island of Anguilla)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scrub Island (Island of Anguilla)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scrub Island (Island of Anguilla)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scrub Island (Island of Anguilla)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scrub Island (Island of Anguilla)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scrub Island (Island of Anguilla)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scrub Island (Island of Anguilla)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scrub Island (Island of Anguilla)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scrub Island (Island of Anguilla)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scrub Island (Island of Anguilla)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scrub Island (Island of Anguilla)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scrub Island (Island of Anguilla)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scrub Island (Island of Anguilla)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scrub Island (Island of Anguilla)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scrub Island (Island of Anguilla)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scrub Island (Island of Anguilla)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scrub Island (Island of Anguilla)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Scrub Island (Island of Anguilla)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "S\xe9dhiou (Region of Senegal)": [
            {
                "Region Name": "S\xe9dhiou (Region of Senegal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "S\xe9dhiou (Region of Senegal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "S\xe9dhiou (Region of Senegal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "S\xe9dhiou (Region of Senegal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "S\xe9dhiou (Region of Senegal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "S\xe9dhiou (Region of Senegal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "S\xe9dhiou (Region of Senegal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "S\xe9dhiou (Region of Senegal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "S\xe9dhiou (Region of Senegal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "S\xe9dhiou (Region of Senegal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "S\xe9dhiou (Region of Senegal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "S\xe9dhiou (Region of Senegal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "S\xe9dhiou (Region of Senegal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "S\xe9dhiou (Region of Senegal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "S\xe9dhiou (Region of Senegal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "S\xe9dhiou (Region of Senegal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "S\xe9dhiou (Region of Senegal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "S\xe9dhiou (Region of Senegal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "S\xe9dhiou (Region of Senegal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "S\xe9dhiou (Region of Senegal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "S\xe9dhiou (Region of Senegal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "S\xe9dhiou (Region of Senegal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 34
            }
        ],
        "S\xe9gou (Region of Mali)": [
            {
                "Region Name": "S\xe9gou (Region of Mali)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "S\xe9gou (Region of Mali)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "S\xe9gou (Region of Mali)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "S\xe9gou (Region of Mali)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "S\xe9gou (Region of Mali)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "S\xe9gou (Region of Mali)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "S\xe9gou (Region of Mali)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "S\xe9gou (Region of Mali)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "S\xe9gou (Region of Mali)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "S\xe9gou (Region of Mali)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "S\xe9gou (Region of Mali)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "S\xe9gou (Region of Mali)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "S\xe9gou (Region of Mali)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "S\xe9gou (Region of Mali)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "S\xe9gou (Region of Mali)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "S\xe9gou (Region of Mali)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "S\xe9gou (Region of Mali)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "S\xe9gou (Region of Mali)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "S\xe9gou (Region of Mali)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "S\xe9gou (Region of Mali)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "S\xe9gou (Region of Mali)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "S\xe9gou (Region of Mali)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 29
            }
        ],
        "Sejong (Metropolitan Autonomous City of South Korea)": [
            {
                "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sejong (Metropolitan Autonomous City of South Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Selangor (State of Malaysia)": [
            {
                "Region Name": "Selangor (State of Malaysia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Selangor (State of Malaysia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Selangor (State of Malaysia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Selangor (State of Malaysia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Selangor (State of Malaysia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Selangor (State of Malaysia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Selangor (State of Malaysia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Selangor (State of Malaysia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Selangor (State of Malaysia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Selangor (State of Malaysia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Selangor (State of Malaysia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Selangor (State of Malaysia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Selangor (State of Malaysia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Selangor (State of Malaysia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Selangor (State of Malaysia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Selangor (State of Malaysia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Selangor (State of Malaysia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Selangor (State of Malaysia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Selangor (State of Malaysia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Selangor (State of Malaysia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Selangor (State of Malaysia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Selangor (State of Malaysia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Selenge (Province of Mongolia)": [
            {
                "Region Name": "Selenge (Province of Mongolia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Selenge (Province of Mongolia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Selenge (Province of Mongolia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Selenge (Province of Mongolia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Selenge (Province of Mongolia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Selenge (Province of Mongolia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Selenge (Province of Mongolia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Selenge (Province of Mongolia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Selenge (Province of Mongolia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Selenge (Province of Mongolia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Selenge (Province of Mongolia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Selenge (Province of Mongolia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Selenge (Province of Mongolia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Selenge (Province of Mongolia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Selenge (Province of Mongolia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Selenge (Province of Mongolia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Selenge (Province of Mongolia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Selenge (Province of Mongolia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Selenge (Province of Mongolia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Selenge (Province of Mongolia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Selenge (Province of Mongolia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Selenge (Province of Mongolia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Selibe Phikwe (Town of Botswana)": [
            {
                "Region Name": "Selibe Phikwe (Town of Botswana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Selibe Phikwe (Town of Botswana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Selibe Phikwe (Town of Botswana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Selibe Phikwe (Town of Botswana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Selibe Phikwe (Town of Botswana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Selibe Phikwe (Town of Botswana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Selibe Phikwe (Town of Botswana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Selibe Phikwe (Town of Botswana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Selibe Phikwe (Town of Botswana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Selibe Phikwe (Town of Botswana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Selibe Phikwe (Town of Botswana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Selibe Phikwe (Town of Botswana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Selibe Phikwe (Town of Botswana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Selibe Phikwe (Town of Botswana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Selibe Phikwe (Town of Botswana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Selibe Phikwe (Town of Botswana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Selibe Phikwe (Town of Botswana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Selibe Phikwe (Town of Botswana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Selibe Phikwe (Town of Botswana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Selibe Phikwe (Town of Botswana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Selibe Phikwe (Town of Botswana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Selibe Phikwe (Town of Botswana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sembabule (District of Uganda)": [
            {
                "Region Name": "Sembabule (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sembabule (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sembabule (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sembabule (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sembabule (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sembabule (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sembabule (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Sembabule (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sembabule (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sembabule (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Sembabule (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sembabule (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sembabule (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sembabule (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sembabule (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sembabule (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sembabule (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sembabule (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sembabule (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Sembabule (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sembabule (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sembabule (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Semenawi Keyih Bahri (Region of Eritrea)": [
            {
                "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Semenawi Keyih Bahri (Region of Eritrea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Semnan (Province of Iran)": [
            {
                "Region Name": "Semnan (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Semnan (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Semnan (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Semnan (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Semnan (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Semnan (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Semnan (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Semnan (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Semnan (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Semnan (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Semnan (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Semnan (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Semnan (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Semnan (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Semnan (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Semnan (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Semnan (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Semnan (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Semnan (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Semnan (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Semnan (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Semnan (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Sennar (State of Sudan)": [
            {
                "Region Name": "Sennar (State of Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Sennar (State of Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Sennar (State of Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Sennar (State of Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Sennar (State of Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Sennar (State of Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Sennar (State of Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Sennar (State of Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Sennar (State of Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sennar (State of Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Sennar (State of Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Sennar (State of Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Sennar (State of Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sennar (State of Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sennar (State of Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sennar (State of Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sennar (State of Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sennar (State of Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Sennar (State of Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Sennar (State of Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Sennar (State of Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Sennar (State of Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 19
            }
        ],
        "Seoul (Capital Metropolitan City of South Korea)": [
            {
                "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Seoul (Capital Metropolitan City of South Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sergipe (State of Brazil)": [
            {
                "Region Name": "Sergipe (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sergipe (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sergipe (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sergipe (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sergipe (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sergipe (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sergipe (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sergipe (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sergipe (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sergipe (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sergipe (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sergipe (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sergipe (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sergipe (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sergipe (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sergipe (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sergipe (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sergipe (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sergipe (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sergipe (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sergipe (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sergipe (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Sermersooq (Commune of Greenland)": [
            {
                "Region Name": "Sermersooq (Commune of Greenland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sermersooq (Commune of Greenland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sermersooq (Commune of Greenland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sermersooq (Commune of Greenland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sermersooq (Commune of Greenland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sermersooq (Commune of Greenland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sermersooq (Commune of Greenland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sermersooq (Commune of Greenland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sermersooq (Commune of Greenland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sermersooq (Commune of Greenland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sermersooq (Commune of Greenland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sermersooq (Commune of Greenland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sermersooq (Commune of Greenland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sermersooq (Commune of Greenland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sermersooq (Commune of Greenland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sermersooq (Commune of Greenland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sermersooq (Commune of Greenland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sermersooq (Commune of Greenland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sermersooq (Commune of Greenland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sermersooq (Commune of Greenland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sermersooq (Commune of Greenland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sermersooq (Commune of Greenland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Serravalle (Municipality of San Marino)": [
            {
                "Region Name": "Serravalle (Municipality of San Marino)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Serravalle (Municipality of San Marino)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Serravalle (Municipality of San Marino)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Serravalle (Municipality of San Marino)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Serravalle (Municipality of San Marino)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Serravalle (Municipality of San Marino)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Serravalle (Municipality of San Marino)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Serravalle (Municipality of San Marino)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Serravalle (Municipality of San Marino)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Serravalle (Municipality of San Marino)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Serravalle (Municipality of San Marino)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Serravalle (Municipality of San Marino)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Serravalle (Municipality of San Marino)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Serravalle (Municipality of San Marino)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Serravalle (Municipality of San Marino)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Serravalle (Municipality of San Marino)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Serravalle (Municipality of San Marino)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Serravalle (Municipality of San Marino)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Serravalle (Municipality of San Marino)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Serravalle (Municipality of San Marino)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Serravalle (Municipality of San Marino)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Serravalle (Municipality of San Marino)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "S\xe9tif (Province of Algeria)": [
            {
                "Region Name": "S\xe9tif (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe9tif (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "S\xe9tif (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "S\xe9tif (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "S\xe9tif (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "S\xe9tif (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "S\xe9tif (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "S\xe9tif (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "S\xe9tif (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "S\xe9tif (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "S\xe9tif (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "S\xe9tif (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "S\xe9tif (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "S\xe9tif (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "S\xe9tif (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "S\xe9tif (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "S\xe9tif (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xe9tif (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "S\xe9tif (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "S\xe9tif (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "S\xe9tif (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "S\xe9tif (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Set\xfabal (District of Portugal)": [
            {
                "Region Name": "Set\xfabal (District of Portugal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Set\xfabal (District of Portugal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Set\xfabal (District of Portugal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Set\xfabal (District of Portugal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Set\xfabal (District of Portugal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Set\xfabal (District of Portugal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Set\xfabal (District of Portugal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Set\xfabal (District of Portugal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Set\xfabal (District of Portugal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Set\xfabal (District of Portugal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Set\xfabal (District of Portugal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Set\xfabal (District of Portugal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Set\xfabal (District of Portugal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Set\xfabal (District of Portugal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Set\xfabal (District of Portugal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Set\xfabal (District of Portugal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Set\xfabal (District of Portugal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Set\xfabal (District of Portugal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Set\xfabal (District of Portugal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Set\xfabal (District of Portugal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Set\xfabal (District of Portugal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Set\xfabal (District of Portugal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sevastopol' (Autonomous Republic of Ukraine)": [
            {
                "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sevastopol' (Autonomous Republic of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Severno-Ba\u010Dki (District of Serbia)": [
            {
                "Region Name": "Severno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Severno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Severno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Severno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Severno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Severno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Severno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Severno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Severno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Severno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Severno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Severno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Severno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Severno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Severno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Severno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Severno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Severno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Severno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Severno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Severno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Severno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Severno-Banatski (District of Serbia)": [
            {
                "Region Name": "Severno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Severno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Severno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Severno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Severno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Severno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Severno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Severno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Severno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Severno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Severno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Severno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Severno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Severno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Severno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Severno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Severno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Severno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Severno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Severno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Severno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Severno-Banatski (District of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Sfax (Governorate of Tunisia)": [
            {
                "Region Name": "Sfax (Governorate of Tunisia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sfax (Governorate of Tunisia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sfax (Governorate of Tunisia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sfax (Governorate of Tunisia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sfax (Governorate of Tunisia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sfax (Governorate of Tunisia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sfax (Governorate of Tunisia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sfax (Governorate of Tunisia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sfax (Governorate of Tunisia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sfax (Governorate of Tunisia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sfax (Governorate of Tunisia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sfax (Governorate of Tunisia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sfax (Governorate of Tunisia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sfax (Governorate of Tunisia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sfax (Governorate of Tunisia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sfax (Governorate of Tunisia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sfax (Governorate of Tunisia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sfax (Governorate of Tunisia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sfax (Governorate of Tunisia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sfax (Governorate of Tunisia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sfax (Governorate of Tunisia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sfax (Governorate of Tunisia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Shaanxi (Province of China)": [
            {
                "Region Name": "Shaanxi (Province of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Shaanxi (Province of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Shaanxi (Province of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 94
            },
            {
                "Region Name": "Shaanxi (Province of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Shaanxi (Province of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 61
            },
            {
                "Region Name": "Shaanxi (Province of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Shaanxi (Province of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Shaanxi (Province of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Shaanxi (Province of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Shaanxi (Province of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Shaanxi (Province of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Shaanxi (Province of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Shaanxi (Province of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Shaanxi (Province of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Shaanxi (Province of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Shaanxi (Province of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Shaanxi (Province of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Shaanxi (Province of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Shaanxi (Province of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Shaanxi (Province of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Shaanxi (Province of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Shaanxi (Province of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Shabeellaha Dhexe (Region of Somalia)": [
            {
                "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabeellaha Dhexe (Region of Somalia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Shabeellaha Hoose (Region of Somalia)": [
            {
                "Region Name": "Shabeellaha Hoose (Region of Somalia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Shabeellaha Hoose (Region of Somalia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Shabeellaha Hoose (Region of Somalia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Shabeellaha Hoose (Region of Somalia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Shabeellaha Hoose (Region of Somalia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Shabeellaha Hoose (Region of Somalia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Shabeellaha Hoose (Region of Somalia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabeellaha Hoose (Region of Somalia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Shabeellaha Hoose (Region of Somalia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Shabeellaha Hoose (Region of Somalia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabeellaha Hoose (Region of Somalia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Shabeellaha Hoose (Region of Somalia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Shabeellaha Hoose (Region of Somalia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Shabeellaha Hoose (Region of Somalia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Shabeellaha Hoose (Region of Somalia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Shabeellaha Hoose (Region of Somalia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabeellaha Hoose (Region of Somalia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabeellaha Hoose (Region of Somalia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Shabeellaha Hoose (Region of Somalia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Shabeellaha Hoose (Region of Somalia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Shabeellaha Hoose (Region of Somalia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabeellaha Hoose (Region of Somalia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Shabwah (Governorate of Yemen)": [
            {
                "Region Name": "Shabwah (Governorate of Yemen)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabwah (Governorate of Yemen)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabwah (Governorate of Yemen)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabwah (Governorate of Yemen)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabwah (Governorate of Yemen)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabwah (Governorate of Yemen)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabwah (Governorate of Yemen)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabwah (Governorate of Yemen)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabwah (Governorate of Yemen)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabwah (Governorate of Yemen)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabwah (Governorate of Yemen)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabwah (Governorate of Yemen)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabwah (Governorate of Yemen)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Shabwah (Governorate of Yemen)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabwah (Governorate of Yemen)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabwah (Governorate of Yemen)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabwah (Governorate of Yemen)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabwah (Governorate of Yemen)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabwah (Governorate of Yemen)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabwah (Governorate of Yemen)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabwah (Governorate of Yemen)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shabwah (Governorate of Yemen)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Shaki-Zaqatala (Region of Azerbaijan)": [
            {
                "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Shaki-Zaqatala (Region of Azerbaijan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Shamal Sina' (Governorate of Egypt)": [
            {
                "Region Name": "Shamal Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shamal Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shamal Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shamal Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shamal Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shamal Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shamal Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shamal Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shamal Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shamal Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shamal Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shamal Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shamal Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shamal Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shamal Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shamal Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shamal Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shamal Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shamal Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shamal Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shamal Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Shamal Sina' (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Shan (State of Myanmar)": [
            {
                "Region Name": "Shan (State of Myanmar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Shan (State of Myanmar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Shan (State of Myanmar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Shan (State of Myanmar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Shan (State of Myanmar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Shan (State of Myanmar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Shan (State of Myanmar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Shan (State of Myanmar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Shan (State of Myanmar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Shan (State of Myanmar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Shan (State of Myanmar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Shan (State of Myanmar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Shan (State of Myanmar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Shan (State of Myanmar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Shan (State of Myanmar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Shan (State of Myanmar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Shan (State of Myanmar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Shan (State of Myanmar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Shan (State of Myanmar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Shan (State of Myanmar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Shan (State of Myanmar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Shan (State of Myanmar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Shandong (Province of China)": [
            {
                "Region Name": "Shandong (Province of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Shandong (Province of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Shandong (Province of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Shandong (Province of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Shandong (Province of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Shandong (Province of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Shandong (Province of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Shandong (Province of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Shandong (Province of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Shandong (Province of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Shandong (Province of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Shandong (Province of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Shandong (Province of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Shandong (Province of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Shandong (Province of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Shandong (Province of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Shandong (Province of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Shandong (Province of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Shandong (Province of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Shandong (Province of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Shandong (Province of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Shandong (Province of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Shanghai (Municipality of China)": [
            {
                "Region Name": "Shanghai (Municipality of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Shanghai (Municipality of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Shanghai (Municipality of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Shanghai (Municipality of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Shanghai (Municipality of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Shanghai (Municipality of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Shanghai (Municipality of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Shanghai (Municipality of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Shanghai (Municipality of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Shanghai (Municipality of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shanghai (Municipality of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Shanghai (Municipality of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Shanghai (Municipality of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shanghai (Municipality of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shanghai (Municipality of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shanghai (Municipality of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shanghai (Municipality of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shanghai (Municipality of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shanghai (Municipality of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shanghai (Municipality of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shanghai (Municipality of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shanghai (Municipality of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Shanxi (Province of China)": [
            {
                "Region Name": "Shanxi (Province of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Shanxi (Province of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Shanxi (Province of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Shanxi (Province of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Shanxi (Province of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Shanxi (Province of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Shanxi (Province of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Shanxi (Province of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Shanxi (Province of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Shanxi (Province of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Shanxi (Province of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Shanxi (Province of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Shanxi (Province of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Shanxi (Province of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Shanxi (Province of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Shanxi (Province of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Shanxi (Province of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Shanxi (Province of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Shanxi (Province of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Shanxi (Province of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Shanxi (Province of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Shanxi (Province of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Sharjah (Emirate of United Arab Emirates)": [
            {
                "Region Name": "Sharjah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sharjah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sharjah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sharjah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sharjah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sharjah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sharjah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sharjah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sharjah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sharjah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sharjah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sharjah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sharjah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sharjah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sharjah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sharjah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sharjah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sharjah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sharjah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sharjah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sharjah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sharjah (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Shefa (Province of Vanuatu)": [
            {
                "Region Name": "Shefa (Province of Vanuatu)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shefa (Province of Vanuatu)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shefa (Province of Vanuatu)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shefa (Province of Vanuatu)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shefa (Province of Vanuatu)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shefa (Province of Vanuatu)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shefa (Province of Vanuatu)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shefa (Province of Vanuatu)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shefa (Province of Vanuatu)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shefa (Province of Vanuatu)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shefa (Province of Vanuatu)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shefa (Province of Vanuatu)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shefa (Province of Vanuatu)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shefa (Province of Vanuatu)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shefa (Province of Vanuatu)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shefa (Province of Vanuatu)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shefa (Province of Vanuatu)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shefa (Province of Vanuatu)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shefa (Province of Vanuatu)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shefa (Province of Vanuatu)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shefa (Province of Vanuatu)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shefa (Province of Vanuatu)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Shida Kartli (Region of Georgia)": [
            {
                "Region Name": "Shida Kartli (Region of Georgia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shida Kartli (Region of Georgia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Shida Kartli (Region of Georgia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shida Kartli (Region of Georgia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shida Kartli (Region of Georgia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Shida Kartli (Region of Georgia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shida Kartli (Region of Georgia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shida Kartli (Region of Georgia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shida Kartli (Region of Georgia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shida Kartli (Region of Georgia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shida Kartli (Region of Georgia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shida Kartli (Region of Georgia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shida Kartli (Region of Georgia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shida Kartli (Region of Georgia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Shida Kartli (Region of Georgia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shida Kartli (Region of Georgia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shida Kartli (Region of Georgia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shida Kartli (Region of Georgia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Shida Kartli (Region of Georgia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shida Kartli (Region of Georgia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shida Kartli (Region of Georgia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shida Kartli (Region of Georgia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Shiga (Prefecture of Japan)": [
            {
                "Region Name": "Shiga (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shiga (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shiga (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shiga (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shiga (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shiga (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shiga (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shiga (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shiga (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shiga (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shiga (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shiga (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shiga (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shiga (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shiga (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shiga (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shiga (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shiga (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shiga (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shiga (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Shiga (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shiga (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Shimane (Prefecture of Japan)": [
            {
                "Region Name": "Shimane (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shimane (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shimane (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shimane (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shimane (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shimane (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shimane (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shimane (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shimane (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shimane (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shimane (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shimane (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shimane (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shimane (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shimane (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shimane (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shimane (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shimane (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shimane (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shimane (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shimane (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shimane (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Shinyanga (Region of Tanzania)": [
            {
                "Region Name": "Shinyanga (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Shinyanga (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Shinyanga (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Shinyanga (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Shinyanga (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Shinyanga (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Shinyanga (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Shinyanga (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Shinyanga (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Shinyanga (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Shinyanga (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Shinyanga (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Shinyanga (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Shinyanga (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Shinyanga (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Shinyanga (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 96
            },
            {
                "Region Name": "Shinyanga (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Shinyanga (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Shinyanga (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Shinyanga (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Shinyanga (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Shinyanga (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Shirak (Province of Armenia)": [
            {
                "Region Name": "Shirak (Province of Armenia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Shirak (Province of Armenia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shirak (Province of Armenia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shirak (Province of Armenia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shirak (Province of Armenia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Shirak (Province of Armenia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shirak (Province of Armenia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Shirak (Province of Armenia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Shirak (Province of Armenia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Shirak (Province of Armenia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Shirak (Province of Armenia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Shirak (Province of Armenia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Shirak (Province of Armenia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shirak (Province of Armenia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shirak (Province of Armenia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Shirak (Province of Armenia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Shirak (Province of Armenia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Shirak (Province of Armenia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shirak (Province of Armenia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shirak (Province of Armenia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shirak (Province of Armenia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Shirak (Province of Armenia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Shiselweni (District of Swaziland)": [
            {
                "Region Name": "Shiselweni (District of Swaziland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Shiselweni (District of Swaziland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Shiselweni (District of Swaziland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Shiselweni (District of Swaziland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Shiselweni (District of Swaziland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Shiselweni (District of Swaziland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Shiselweni (District of Swaziland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Shiselweni (District of Swaziland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Shiselweni (District of Swaziland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Shiselweni (District of Swaziland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Shiselweni (District of Swaziland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Shiselweni (District of Swaziland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Shiselweni (District of Swaziland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Shiselweni (District of Swaziland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Shiselweni (District of Swaziland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Shiselweni (District of Swaziland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Shiselweni (District of Swaziland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Shiselweni (District of Swaziland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Shiselweni (District of Swaziland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Shiselweni (District of Swaziland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Shiselweni (District of Swaziland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Shiselweni (District of Swaziland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Shizuoka (Prefecture of Japan)": [
            {
                "Region Name": "Shizuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Shizuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shizuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Shizuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Shizuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Shizuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shizuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Shizuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Shizuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Shizuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Shizuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Shizuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shizuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Shizuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Shizuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Shizuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Shizuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Shizuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Shizuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shizuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Shizuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Shizuoka (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 20
            }
        ],
        "Shkod\xebr (County of Albania)": [
            {
                "Region Name": "Shkod\xebr (County of Albania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shkod\xebr (County of Albania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Shkod\xebr (County of Albania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shkod\xebr (County of Albania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shkod\xebr (County of Albania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Shkod\xebr (County of Albania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Shkod\xebr (County of Albania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Shkod\xebr (County of Albania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shkod\xebr (County of Albania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Shkod\xebr (County of Albania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Shkod\xebr (County of Albania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Shkod\xebr (County of Albania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Shkod\xebr (County of Albania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shkod\xebr (County of Albania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Shkod\xebr (County of Albania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Shkod\xebr (County of Albania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Shkod\xebr (County of Albania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Shkod\xebr (County of Albania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Shkod\xebr (County of Albania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Shkod\xebr (County of Albania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Shkod\xebr (County of Albania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Shkod\xebr (County of Albania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Shumen (Province of Bulgaria)": [
            {
                "Region Name": "Shumen (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shumen (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shumen (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Shumen (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Shumen (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Shumen (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shumen (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Shumen (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shumen (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shumen (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Shumen (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Shumen (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shumen (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shumen (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shumen (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Shumen (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Shumen (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shumen (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Shumen (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shumen (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Shumen (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Shumen (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Si Sa Ket (Province of Thailand)": [
            {
                "Region Name": "Si Sa Ket (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Si Sa Ket (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Si Sa Ket (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Si Sa Ket (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Si Sa Ket (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Si Sa Ket (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Si Sa Ket (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Si Sa Ket (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Si Sa Ket (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Si Sa Ket (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Si Sa Ket (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Si Sa Ket (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Si Sa Ket (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Si Sa Ket (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Si Sa Ket (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Si Sa Ket (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Si Sa Ket (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Si Sa Ket (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Si Sa Ket (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Si Sa Ket (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Si Sa Ket (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Si Sa Ket (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "\u0160iauliai (County of Lithuania)": [
            {
                "Region Name": "\u0160iauliai (County of Lithuania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0160iauliai (County of Lithuania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0160iauliai (County of Lithuania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0160iauliai (County of Lithuania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0160iauliai (County of Lithuania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\u0160iauliai (County of Lithuania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0160iauliai (County of Lithuania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "\u0160iauliai (County of Lithuania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160iauliai (County of Lithuania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160iauliai (County of Lithuania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160iauliai (County of Lithuania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0160iauliai (County of Lithuania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160iauliai (County of Lithuania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160iauliai (County of Lithuania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160iauliai (County of Lithuania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160iauliai (County of Lithuania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160iauliai (County of Lithuania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0160iauliai (County of Lithuania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160iauliai (County of Lithuania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\u0160iauliai (County of Lithuania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160iauliai (County of Lithuania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160iauliai (County of Lithuania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Siaya (County of Kenya)": [
            {
                "Region Name": "Siaya (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Siaya (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Siaya (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Siaya (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Siaya (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Siaya (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Siaya (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Siaya (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Siaya (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Siaya (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Siaya (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siaya (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Siaya (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Siaya (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Siaya (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Siaya (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Siaya (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Siaya (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siaya (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Siaya (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Siaya (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Siaya (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "\u0160ibensko-Kninska (County of Croatia)": [
            {
                "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "\u0160ibensko-Kninska (County of Croatia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sibiu (County of Romania)": [
            {
                "Region Name": "Sibiu (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sibiu (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sibiu (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sibiu (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sibiu (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sibiu (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sibiu (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sibiu (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sibiu (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sibiu (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sibiu (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sibiu (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sibiu (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sibiu (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sibiu (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sibiu (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sibiu (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sibiu (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sibiu (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sibiu (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sibiu (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sibiu (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Sichuan (Province of China)": [
            {
                "Region Name": "Sichuan (Province of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sichuan (Province of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sichuan (Province of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sichuan (Province of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sichuan (Province of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sichuan (Province of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sichuan (Province of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sichuan (Province of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sichuan (Province of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sichuan (Province of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sichuan (Province of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sichuan (Province of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sichuan (Province of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sichuan (Province of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sichuan (Province of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sichuan (Province of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sichuan (Province of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sichuan (Province of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sichuan (Province of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sichuan (Province of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sichuan (Province of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sichuan (Province of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Sicily (Autonomous Region of Italy)": [
            {
                "Region Name": "Sicily (Autonomous Region of Italy)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sicily (Autonomous Region of Italy)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sicily (Autonomous Region of Italy)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sicily (Autonomous Region of Italy)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sicily (Autonomous Region of Italy)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sicily (Autonomous Region of Italy)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sicily (Autonomous Region of Italy)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sicily (Autonomous Region of Italy)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sicily (Autonomous Region of Italy)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sicily (Autonomous Region of Italy)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sicily (Autonomous Region of Italy)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sicily (Autonomous Region of Italy)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sicily (Autonomous Region of Italy)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sicily (Autonomous Region of Italy)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sicily (Autonomous Region of Italy)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sicily (Autonomous Region of Italy)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sicily (Autonomous Region of Italy)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sicily (Autonomous Region of Italy)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sicily (Autonomous Region of Italy)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sicily (Autonomous Region of Italy)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Sicily (Autonomous Region of Italy)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sicily (Autonomous Region of Italy)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Sidi Bel Abb\xe8s (Province of Algeria)": [
            {
                "Region Name": "Sidi Bel Abb\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sidi Bel Abb\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sidi Bel Abb\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bel Abb\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Sidi Bel Abb\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sidi Bel Abb\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Sidi Bel Abb\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bel Abb\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bel Abb\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bel Abb\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bel Abb\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Sidi Bel Abb\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sidi Bel Abb\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Sidi Bel Abb\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Sidi Bel Abb\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sidi Bel Abb\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sidi Bel Abb\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bel Abb\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sidi Bel Abb\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Sidi Bel Abb\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bel Abb\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bel Abb\xe8s (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sidi Bou Zid (Governorate of Tunisia)": [
            {
                "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sidi Bou Zid (Governorate of Tunisia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Siemr\xe9ab (Province of Cambodia)": [
            {
                "Region Name": "Siemr\xe9ab (Province of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Siemr\xe9ab (Province of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Siemr\xe9ab (Province of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Siemr\xe9ab (Province of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Siemr\xe9ab (Province of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Siemr\xe9ab (Province of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Siemr\xe9ab (Province of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Siemr\xe9ab (Province of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Siemr\xe9ab (Province of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Siemr\xe9ab (Province of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Siemr\xe9ab (Province of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Siemr\xe9ab (Province of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Siemr\xe9ab (Province of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Siemr\xe9ab (Province of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Siemr\xe9ab (Province of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Siemr\xe9ab (Province of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Siemr\xe9ab (Province of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Siemr\xe9ab (Province of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Siemr\xe9ab (Province of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Siemr\xe9ab (Province of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Siemr\xe9ab (Province of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Siemr\xe9ab (Province of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Siirt (Province of Turkey)": [
            {
                "Region Name": "Siirt (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Siirt (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Siirt (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Siirt (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Siirt (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Siirt (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Siirt (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Siirt (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Siirt (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Siirt (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Siirt (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Siirt (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Siirt (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Siirt (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Siirt (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Siirt (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Siirt (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Siirt (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Siirt (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Siirt (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Siirt (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siirt (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Sikasso (Region of Mali)": [
            {
                "Region Name": "Sikasso (Region of Mali)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sikasso (Region of Mali)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sikasso (Region of Mali)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Sikasso (Region of Mali)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sikasso (Region of Mali)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sikasso (Region of Mali)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sikasso (Region of Mali)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sikasso (Region of Mali)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sikasso (Region of Mali)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sikasso (Region of Mali)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sikasso (Region of Mali)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sikasso (Region of Mali)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sikasso (Region of Mali)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sikasso (Region of Mali)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sikasso (Region of Mali)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sikasso (Region of Mali)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sikasso (Region of Mali)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sikasso (Region of Mali)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sikasso (Region of Mali)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sikasso (Region of Mali)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sikasso (Region of Mali)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sikasso (Region of Mali)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Sikkim (State of India)": [
            {
                "Region Name": "Sikkim (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sikkim (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sikkim (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sikkim (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sikkim (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sikkim (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sikkim (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sikkim (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sikkim (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sikkim (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sikkim (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sikkim (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sikkim (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sikkim (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sikkim (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sikkim (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sikkim (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sikkim (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sikkim (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sikkim (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sikkim (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sikkim (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sila (Region of Chad)": [
            {
                "Region Name": "Sila (Region of Chad)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Sila (Region of Chad)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Sila (Region of Chad)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Sila (Region of Chad)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Sila (Region of Chad)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Sila (Region of Chad)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Sila (Region of Chad)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 57
            },
            {
                "Region Name": "Sila (Region of Chad)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Sila (Region of Chad)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 59
            },
            {
                "Region Name": "Sila (Region of Chad)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Sila (Region of Chad)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Sila (Region of Chad)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 67
            },
            {
                "Region Name": "Sila (Region of Chad)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Sila (Region of Chad)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Sila (Region of Chad)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 77
            },
            {
                "Region Name": "Sila (Region of Chad)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 57
            },
            {
                "Region Name": "Sila (Region of Chad)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 81
            },
            {
                "Region Name": "Sila (Region of Chad)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 106
            },
            {
                "Region Name": "Sila (Region of Chad)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 70
            },
            {
                "Region Name": "Sila (Region of Chad)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 57
            },
            {
                "Region Name": "Sila (Region of Chad)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Sila (Region of Chad)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 55
            }
        ],
        "Siliana (Governorate of Tunisia)": [
            {
                "Region Name": "Siliana (Governorate of Tunisia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siliana (Governorate of Tunisia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siliana (Governorate of Tunisia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siliana (Governorate of Tunisia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siliana (Governorate of Tunisia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Siliana (Governorate of Tunisia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Siliana (Governorate of Tunisia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siliana (Governorate of Tunisia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Siliana (Governorate of Tunisia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Siliana (Governorate of Tunisia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Siliana (Governorate of Tunisia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Siliana (Governorate of Tunisia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Siliana (Governorate of Tunisia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Siliana (Governorate of Tunisia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siliana (Governorate of Tunisia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Siliana (Governorate of Tunisia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Siliana (Governorate of Tunisia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Siliana (Governorate of Tunisia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siliana (Governorate of Tunisia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siliana (Governorate of Tunisia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siliana (Governorate of Tunisia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Siliana (Governorate of Tunisia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Silistra (Province of Bulgaria)": [
            {
                "Region Name": "Silistra (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Silistra (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Silistra (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Silistra (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Silistra (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Silistra (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Silistra (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Silistra (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Silistra (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Silistra (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Silistra (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Silistra (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Silistra (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Silistra (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Silistra (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Silistra (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Silistra (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Silistra (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Silistra (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Silistra (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Silistra (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Silistra (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Simiyu (Region of Tanzania)": [
            {
                "Region Name": "Simiyu (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 74
            },
            {
                "Region Name": "Simiyu (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Simiyu (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Simiyu (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Simiyu (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Simiyu (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Simiyu (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Simiyu (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "Simiyu (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "Simiyu (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Simiyu (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "Simiyu (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Simiyu (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Simiyu (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Simiyu (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Simiyu (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Simiyu (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Simiyu (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Simiyu (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 79
            },
            {
                "Region Name": "Simiyu (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 76
            },
            {
                "Region Name": "Simiyu (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Simiyu (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 54
            }
        ],
        "Sinajana (Municipality of Guam)": [
            {
                "Region Name": "Sinajana (Municipality of Guam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinajana (Municipality of Guam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinajana (Municipality of Guam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinajana (Municipality of Guam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinajana (Municipality of Guam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinajana (Municipality of Guam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinajana (Municipality of Guam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinajana (Municipality of Guam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinajana (Municipality of Guam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinajana (Municipality of Guam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinajana (Municipality of Guam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinajana (Municipality of Guam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinajana (Municipality of Guam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinajana (Municipality of Guam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinajana (Municipality of Guam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinajana (Municipality of Guam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinajana (Municipality of Guam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinajana (Municipality of Guam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinajana (Municipality of Guam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinajana (Municipality of Guam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinajana (Municipality of Guam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinajana (Municipality of Guam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sinaloa (State of M\xe9xico)": [
            {
                "Region Name": "Sinaloa (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sinaloa (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sinaloa (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sinaloa (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sinaloa (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sinaloa (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sinaloa (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Sinaloa (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sinaloa (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sinaloa (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sinaloa (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Sinaloa (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Sinaloa (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sinaloa (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sinaloa (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sinaloa (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sinaloa (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Sinaloa (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Sinaloa (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sinaloa (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Sinaloa (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sinaloa (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 16
            }
        ],
        "Sindh (Province of Pakistan)": [
            {
                "Region Name": "Sindh (Province of Pakistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sindh (Province of Pakistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sindh (Province of Pakistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sindh (Province of Pakistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sindh (Province of Pakistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sindh (Province of Pakistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sindh (Province of Pakistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sindh (Province of Pakistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sindh (Province of Pakistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sindh (Province of Pakistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sindh (Province of Pakistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sindh (Province of Pakistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sindh (Province of Pakistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sindh (Province of Pakistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sindh (Province of Pakistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sindh (Province of Pakistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sindh (Province of Pakistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sindh (Province of Pakistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sindh (Province of Pakistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sindh (Province of Pakistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sindh (Province of Pakistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sindh (Province of Pakistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Sing Buri (Province of Thailand)": [
            {
                "Region Name": "Sing Buri (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sing Buri (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sing Buri (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sing Buri (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sing Buri (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sing Buri (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sing Buri (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sing Buri (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Sing Buri (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sing Buri (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sing Buri (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sing Buri (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sing Buri (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sing Buri (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sing Buri (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sing Buri (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sing Buri (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sing Buri (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sing Buri (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sing Buri (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sing Buri (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sing Buri (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Singave (Kingdom of Wallis and Futuna)": [
            {
                "Region Name": "Singave (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singave (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singave (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singave (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singave (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singave (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singave (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singave (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singave (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singave (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singave (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singave (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singave (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singave (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singave (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singave (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singave (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singave (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singave (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singave (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singave (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Singave (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "S\xeengerei (District of Moldova)": [
            {
                "Region Name": "S\xeengerei (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xeengerei (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xeengerei (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xeengerei (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "S\xeengerei (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "S\xeengerei (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xeengerei (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "S\xeengerei (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xeengerei (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "S\xeengerei (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "S\xeengerei (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "S\xeengerei (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "S\xeengerei (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "S\xeengerei (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "S\xeengerei (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xeengerei (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xeengerei (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xeengerei (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xeengerei (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xeengerei (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xeengerei (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "S\xeengerei (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Singida (Region of Tanzania)": [
            {
                "Region Name": "Singida (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Singida (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Singida (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Singida (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Singida (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Singida (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Singida (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Singida (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Singida (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Singida (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Singida (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Singida (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Singida (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Singida (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Singida (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Singida (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Singida (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Singida (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Singida (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Singida (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Singida (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Singida (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 30
            }
        ],
        "Sinoe (County of Liberia)": [
            {
                "Region Name": "Sinoe (County of Liberia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinoe (County of Liberia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sinoe (County of Liberia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sinoe (County of Liberia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinoe (County of Liberia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sinoe (County of Liberia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinoe (County of Liberia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinoe (County of Liberia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sinoe (County of Liberia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sinoe (County of Liberia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sinoe (County of Liberia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sinoe (County of Liberia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sinoe (County of Liberia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sinoe (County of Liberia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sinoe (County of Liberia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinoe (County of Liberia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sinoe (County of Liberia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sinoe (County of Liberia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sinoe (County of Liberia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinoe (County of Liberia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinoe (County of Liberia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sinoe (County of Liberia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sinop (Province of Turkey)": [
            {
                "Region Name": "Sinop (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinop (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinop (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sinop (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinop (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sinop (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinop (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinop (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinop (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinop (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinop (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinop (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinop (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinop (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sinop (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinop (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sinop (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinop (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinop (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sinop (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sinop (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sinop (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)": [
            {
                "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sint Eustatius (Municipality of Bonaire, Sint Eustatius and Saba)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sin\u016Diju (Special Administrative Region of North Korea)": [
            {
                "Region Name": "Sin\u016Diju (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sin\u016Diju (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sin\u016Diju (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sin\u016Diju (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sin\u016Diju (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sin\u016Diju (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sin\u016Diju (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sin\u016Diju (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sin\u016Diju (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sin\u016Diju (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sin\u016Diju (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sin\u016Diju (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sin\u016Diju (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sin\u016Diju (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sin\u016Diju (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sin\u016Diju (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sin\u016Diju (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sin\u016Diju (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sin\u016Diju (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sin\u016Diju (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sin\u016Diju (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sin\u016Diju (Special Administrative Region of North Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sipaliwini (District of Suriname)": [
            {
                "Region Name": "Sipaliwini (District of Suriname)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Sipaliwini (District of Suriname)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sipaliwini (District of Suriname)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Sipaliwini (District of Suriname)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sipaliwini (District of Suriname)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sipaliwini (District of Suriname)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sipaliwini (District of Suriname)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sipaliwini (District of Suriname)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Sipaliwini (District of Suriname)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sipaliwini (District of Suriname)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Sipaliwini (District of Suriname)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 132
            },
            {
                "Region Name": "Sipaliwini (District of Suriname)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sipaliwini (District of Suriname)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 79
            },
            {
                "Region Name": "Sipaliwini (District of Suriname)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sipaliwini (District of Suriname)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Sipaliwini (District of Suriname)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sipaliwini (District of Suriname)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sipaliwini (District of Suriname)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Sipaliwini (District of Suriname)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sipaliwini (District of Suriname)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sipaliwini (District of Suriname)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sipaliwini (District of Suriname)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 43
            }
        ],
        "Siparia (Region of Trinidad and Tobago)": [
            {
                "Region Name": "Siparia (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Siparia (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siparia (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siparia (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siparia (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Siparia (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Siparia (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siparia (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Siparia (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Siparia (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siparia (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siparia (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siparia (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siparia (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Siparia (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Siparia (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siparia (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Siparia (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siparia (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siparia (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siparia (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siparia (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Siquijor (Province of Philippines)": [
            {
                "Region Name": "Siquijor (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siquijor (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siquijor (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siquijor (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siquijor (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siquijor (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siquijor (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siquijor (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siquijor (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siquijor (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siquijor (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siquijor (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siquijor (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siquijor (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siquijor (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siquijor (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siquijor (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siquijor (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siquijor (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siquijor (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siquijor (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Siquijor (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sirdaryo (Region of Uzbekistan)": [
            {
                "Region Name": "Sirdaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sirdaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sirdaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sirdaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sirdaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sirdaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sirdaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sirdaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sirdaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sirdaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sirdaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sirdaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sirdaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sirdaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sirdaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sirdaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sirdaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sirdaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sirdaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sirdaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sirdaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sirdaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Sirnak (Province of Turkey)": [
            {
                "Region Name": "Sirnak (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Sirnak (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sirnak (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sirnak (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sirnak (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sirnak (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sirnak (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sirnak (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sirnak (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sirnak (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sirnak (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sirnak (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sirnak (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sirnak (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sirnak (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sirnak (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sirnak (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sirnak (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sirnak (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sirnak (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sirnak (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sirnak (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Sironko (District of Uganda)": [
            {
                "Region Name": "Sironko (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sironko (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sironko (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sironko (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Sironko (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sironko (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sironko (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sironko (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sironko (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Sironko (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sironko (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sironko (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sironko (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Sironko (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sironko (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sironko (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Sironko (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Sironko (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sironko (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Sironko (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sironko (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sironko (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Sisacko-Moslavacka (County of Croatia)": [
            {
                "Region Name": "Sisacko-Moslavacka (County of Croatia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sisacko-Moslavacka (County of Croatia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sisacko-Moslavacka (County of Croatia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sisacko-Moslavacka (County of Croatia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sisacko-Moslavacka (County of Croatia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sisacko-Moslavacka (County of Croatia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sisacko-Moslavacka (County of Croatia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sisacko-Moslavacka (County of Croatia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sisacko-Moslavacka (County of Croatia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sisacko-Moslavacka (County of Croatia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sisacko-Moslavacka (County of Croatia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sisacko-Moslavacka (County of Croatia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sisacko-Moslavacka (County of Croatia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sisacko-Moslavacka (County of Croatia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sisacko-Moslavacka (County of Croatia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sisacko-Moslavacka (County of Croatia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sisacko-Moslavacka (County of Croatia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sisacko-Moslavacka (County of Croatia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sisacko-Moslavacka (County of Croatia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sisacko-Moslavacka (County of Croatia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sisacko-Moslavacka (County of Croatia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sisacko-Moslavacka (County of Croatia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sistan and Baluchestan (Province of Iran)": [
            {
                "Region Name": "Sistan and Baluchestan (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sistan and Baluchestan (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sistan and Baluchestan (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sistan and Baluchestan (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sistan and Baluchestan (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sistan and Baluchestan (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sistan and Baluchestan (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sistan and Baluchestan (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sistan and Baluchestan (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sistan and Baluchestan (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sistan and Baluchestan (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sistan and Baluchestan (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sistan and Baluchestan (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sistan and Baluchestan (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sistan and Baluchestan (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sistan and Baluchestan (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sistan and Baluchestan (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sistan and Baluchestan (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sistan and Baluchestan (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sistan and Baluchestan (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sistan and Baluchestan (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sistan and Baluchestan (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sister Islands (District of Cayman Islands)": [
            {
                "Region Name": "Sister Islands (District of Cayman Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sister Islands (District of Cayman Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sister Islands (District of Cayman Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sister Islands (District of Cayman Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sister Islands (District of Cayman Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sister Islands (District of Cayman Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sister Islands (District of Cayman Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sister Islands (District of Cayman Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sister Islands (District of Cayman Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sister Islands (District of Cayman Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sister Islands (District of Cayman Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sister Islands (District of Cayman Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sister Islands (District of Cayman Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sister Islands (District of Cayman Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sister Islands (District of Cayman Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sister Islands (District of Cayman Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sister Islands (District of Cayman Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sister Islands (District of Cayman Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sister Islands (District of Cayman Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sister Islands (District of Cayman Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sister Islands (District of Cayman Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sister Islands (District of Cayman Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sivas (Province of Turkey)": [
            {
                "Region Name": "Sivas (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sivas (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sivas (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sivas (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sivas (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sivas (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sivas (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sivas (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sivas (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sivas (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Sivas (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sivas (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sivas (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sivas (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sivas (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sivas (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sivas (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sivas (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sivas (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sivas (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sivas (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sivas (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Sj\xe6lland (Region of Denmark)": [
            {
                "Region Name": "Sj\xe6lland (Region of Denmark)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sj\xe6lland (Region of Denmark)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sj\xe6lland (Region of Denmark)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sj\xe6lland (Region of Denmark)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sj\xe6lland (Region of Denmark)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sj\xe6lland (Region of Denmark)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sj\xe6lland (Region of Denmark)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sj\xe6lland (Region of Denmark)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sj\xe6lland (Region of Denmark)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sj\xe6lland (Region of Denmark)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sj\xe6lland (Region of Denmark)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sj\xe6lland (Region of Denmark)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sj\xe6lland (Region of Denmark)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sj\xe6lland (Region of Denmark)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sj\xe6lland (Region of Denmark)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sj\xe6lland (Region of Denmark)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sj\xe6lland (Region of Denmark)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sj\xe6lland (Region of Denmark)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sj\xe6lland (Region of Denmark)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sj\xe6lland (Region of Denmark)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sj\xe6lland (Region of Denmark)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sj\xe6lland (Region of Denmark)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sk\xe5ne (County of Sweden)": [
            {
                "Region Name": "Sk\xe5ne (County of Sweden)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sk\xe5ne (County of Sweden)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sk\xe5ne (County of Sweden)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sk\xe5ne (County of Sweden)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sk\xe5ne (County of Sweden)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sk\xe5ne (County of Sweden)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sk\xe5ne (County of Sweden)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sk\xe5ne (County of Sweden)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sk\xe5ne (County of Sweden)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sk\xe5ne (County of Sweden)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sk\xe5ne (County of Sweden)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sk\xe5ne (County of Sweden)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sk\xe5ne (County of Sweden)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sk\xe5ne (County of Sweden)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sk\xe5ne (County of Sweden)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sk\xe5ne (County of Sweden)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sk\xe5ne (County of Sweden)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sk\xe5ne (County of Sweden)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sk\xe5ne (County of Sweden)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sk\xe5ne (County of Sweden)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sk\xe5ne (County of Sweden)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sk\xe5ne (County of Sweden)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Skikda (Province of Algeria)": [
            {
                "Region Name": "Skikda (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Skikda (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Skikda (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Skikda (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Skikda (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Skikda (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Skikda (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Skikda (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Skikda (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Skikda (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Skikda (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Skikda (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Skikda (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Skikda (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Skikda (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Skikda (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Skikda (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Skikda (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Skikda (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Skikda (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Skikda (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Skikda (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 27
            }
        ],
        "\u015Al\u0105skie (Voivodeship of Poland)": [
            {
                "Region Name": "\u015Al\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Al\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Al\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u015Al\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "\u015Al\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Al\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\u015Al\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Al\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u015Al\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Al\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "\u015Al\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Al\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u015Al\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u015Al\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u015Al\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Al\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Al\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Al\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Al\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Al\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Al\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u015Al\u0105skie (Voivodeship of Poland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sligo (County of Ireland)": [
            {
                "Region Name": "Sligo (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sligo (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sligo (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sligo (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sligo (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sligo (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sligo (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sligo (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sligo (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sligo (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sligo (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sligo (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sligo (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sligo (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sligo (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sligo (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sligo (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sligo (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sligo (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sligo (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sligo (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sligo (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sliven (Province of Bulgaria)": [
            {
                "Region Name": "Sliven (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sliven (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sliven (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Sliven (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sliven (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sliven (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sliven (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sliven (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sliven (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sliven (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sliven (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sliven (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sliven (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sliven (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sliven (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sliven (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sliven (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sliven (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sliven (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sliven (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sliven (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sliven (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Smiths (Parish of Bermuda)": [
            {
                "Region Name": "Smiths (Parish of Bermuda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smiths (Parish of Bermuda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smiths (Parish of Bermuda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smiths (Parish of Bermuda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smiths (Parish of Bermuda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smiths (Parish of Bermuda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smiths (Parish of Bermuda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smiths (Parish of Bermuda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smiths (Parish of Bermuda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smiths (Parish of Bermuda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smiths (Parish of Bermuda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smiths (Parish of Bermuda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smiths (Parish of Bermuda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smiths (Parish of Bermuda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smiths (Parish of Bermuda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smiths (Parish of Bermuda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smiths (Parish of Bermuda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smiths (Parish of Bermuda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smiths (Parish of Bermuda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smiths (Parish of Bermuda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smiths (Parish of Bermuda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smiths (Parish of Bermuda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Smolensk (Region of Russia)": [
            {
                "Region Name": "Smolensk (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Smolensk (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Smolensk (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Smolensk (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Smolensk (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Smolensk (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Smolensk (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Smolensk (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Smolensk (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Smolensk (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Smolensk (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Smolensk (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Smolensk (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Smolensk (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Smolensk (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Smolensk (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Smolensk (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Smolensk (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Smolensk (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Smolensk (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Smolensk (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Smolensk (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Smolyan (Province of Bulgaria)": [
            {
                "Region Name": "Smolyan (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smolyan (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smolyan (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smolyan (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smolyan (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smolyan (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Smolyan (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smolyan (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smolyan (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smolyan (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smolyan (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smolyan (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smolyan (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smolyan (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smolyan (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smolyan (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smolyan (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smolyan (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smolyan (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Smolyan (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smolyan (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Smolyan (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "S\xf3c Tr\u0103ng (Province of Vietnam)": [
            {
                "Region Name": "S\xf3c Tr\u0103ng (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf3c Tr\u0103ng (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf3c Tr\u0103ng (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "S\xf3c Tr\u0103ng (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "S\xf3c Tr\u0103ng (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf3c Tr\u0103ng (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf3c Tr\u0103ng (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "S\xf3c Tr\u0103ng (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "S\xf3c Tr\u0103ng (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "S\xf3c Tr\u0103ng (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "S\xf3c Tr\u0103ng (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "S\xf3c Tr\u0103ng (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "S\xf3c Tr\u0103ng (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "S\xf3c Tr\u0103ng (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "S\xf3c Tr\u0103ng (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "S\xf3c Tr\u0103ng (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "S\xf3c Tr\u0103ng (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "S\xf3c Tr\u0103ng (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "S\xf3c Tr\u0103ng (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "S\xf3c Tr\u0103ng (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "S\xf3c Tr\u0103ng (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "S\xf3c Tr\u0103ng (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 22
            }
        ],
        "S\xf6dermanland (County of Sweden)": [
            {
                "Region Name": "S\xf6dermanland (County of Sweden)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf6dermanland (County of Sweden)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf6dermanland (County of Sweden)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf6dermanland (County of Sweden)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf6dermanland (County of Sweden)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf6dermanland (County of Sweden)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf6dermanland (County of Sweden)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf6dermanland (County of Sweden)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf6dermanland (County of Sweden)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf6dermanland (County of Sweden)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf6dermanland (County of Sweden)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf6dermanland (County of Sweden)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf6dermanland (County of Sweden)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf6dermanland (County of Sweden)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf6dermanland (County of Sweden)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf6dermanland (County of Sweden)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf6dermanland (County of Sweden)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf6dermanland (County of Sweden)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf6dermanland (County of Sweden)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf6dermanland (County of Sweden)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf6dermanland (County of Sweden)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf6dermanland (County of Sweden)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sofala (Province of Mozambique)": [
            {
                "Region Name": "Sofala (Province of Mozambique)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sofala (Province of Mozambique)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sofala (Province of Mozambique)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sofala (Province of Mozambique)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sofala (Province of Mozambique)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sofala (Province of Mozambique)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sofala (Province of Mozambique)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sofala (Province of Mozambique)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sofala (Province of Mozambique)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sofala (Province of Mozambique)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sofala (Province of Mozambique)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sofala (Province of Mozambique)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sofala (Province of Mozambique)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sofala (Province of Mozambique)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sofala (Province of Mozambique)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sofala (Province of Mozambique)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sofala (Province of Mozambique)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sofala (Province of Mozambique)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sofala (Province of Mozambique)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sofala (Province of Mozambique)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sofala (Province of Mozambique)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Sofala (Province of Mozambique)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Sofia (Province of Bulgaria)": [
            {
                "Region Name": "Sofia (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sofia (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sofia (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sofia (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sofia (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sofia (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sofia (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sofia (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sofia (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sofia (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Sofia (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sofia (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sofia (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sofia (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sofia (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sofia (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sofia (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sofia (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sofia (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sofia (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sofia (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sofia (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 23
            }
        ],
        "Sogn og Fjordane (County of Norway)": [
            {
                "Region Name": "Sogn og Fjordane (County of Norway)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sogn og Fjordane (County of Norway)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sogn og Fjordane (County of Norway)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sogn og Fjordane (County of Norway)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sogn og Fjordane (County of Norway)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sogn og Fjordane (County of Norway)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sogn og Fjordane (County of Norway)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sogn og Fjordane (County of Norway)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sogn og Fjordane (County of Norway)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sogn og Fjordane (County of Norway)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sogn og Fjordane (County of Norway)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sogn og Fjordane (County of Norway)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sogn og Fjordane (County of Norway)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sogn og Fjordane (County of Norway)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sogn og Fjordane (County of Norway)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sogn og Fjordane (County of Norway)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sogn og Fjordane (County of Norway)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sogn og Fjordane (County of Norway)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sogn og Fjordane (County of Norway)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sogn og Fjordane (County of Norway)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sogn og Fjordane (County of Norway)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sogn og Fjordane (County of Norway)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sokoto (State of Nigeria)": [
            {
                "Region Name": "Sokoto (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Sokoto (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Sokoto (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Sokoto (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Sokoto (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Sokoto (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sokoto (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sokoto (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Sokoto (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Sokoto (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sokoto (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Sokoto (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sokoto (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Sokoto (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Sokoto (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Sokoto (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Sokoto (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Sokoto (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Sokoto (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Sokoto (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Sokoto (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Sokoto (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 22
            }
        ],
        "\u0218old\u0103ne\u0219ti (District of Moldova)": [
            {
                "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\u0218old\u0103ne\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Solol\xe1 (Department of Guatemala)": [
            {
                "Region Name": "Solol\xe1 (Department of Guatemala)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Solol\xe1 (Department of Guatemala)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solol\xe1 (Department of Guatemala)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Solol\xe1 (Department of Guatemala)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Solol\xe1 (Department of Guatemala)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solol\xe1 (Department of Guatemala)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solol\xe1 (Department of Guatemala)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solol\xe1 (Department of Guatemala)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solol\xe1 (Department of Guatemala)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solol\xe1 (Department of Guatemala)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solol\xe1 (Department of Guatemala)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solol\xe1 (Department of Guatemala)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Solol\xe1 (Department of Guatemala)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solol\xe1 (Department of Guatemala)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solol\xe1 (Department of Guatemala)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solol\xe1 (Department of Guatemala)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solol\xe1 (Department of Guatemala)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Solol\xe1 (Department of Guatemala)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solol\xe1 (Department of Guatemala)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solol\xe1 (Department of Guatemala)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solol\xe1 (Department of Guatemala)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solol\xe1 (Department of Guatemala)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Solothurn (Canton of Switzerland)": [
            {
                "Region Name": "Solothurn (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solothurn (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solothurn (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solothurn (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Solothurn (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solothurn (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solothurn (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solothurn (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solothurn (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solothurn (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solothurn (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solothurn (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solothurn (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Solothurn (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solothurn (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solothurn (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solothurn (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solothurn (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solothurn (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solothurn (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solothurn (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Solothurn (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Somali (State of Ethiopia)": [
            {
                "Region Name": "Somali (State of Ethiopia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Somali (State of Ethiopia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Somali (State of Ethiopia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Somali (State of Ethiopia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Somali (State of Ethiopia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Somali (State of Ethiopia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Somali (State of Ethiopia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Somali (State of Ethiopia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Somali (State of Ethiopia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Somali (State of Ethiopia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Somali (State of Ethiopia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Somali (State of Ethiopia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Somali (State of Ethiopia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Somali (State of Ethiopia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Somali (State of Ethiopia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Somali (State of Ethiopia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Somali (State of Ethiopia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Somali (State of Ethiopia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Somali (State of Ethiopia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Somali (State of Ethiopia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Somali (State of Ethiopia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Somali (State of Ethiopia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 25
            }
        ],
        "Sombrero Island (Island of Anguilla)": [
            {
                "Region Name": "Sombrero Island (Island of Anguilla)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sombrero Island (Island of Anguilla)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sombrero Island (Island of Anguilla)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sombrero Island (Island of Anguilla)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sombrero Island (Island of Anguilla)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sombrero Island (Island of Anguilla)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sombrero Island (Island of Anguilla)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sombrero Island (Island of Anguilla)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sombrero Island (Island of Anguilla)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sombrero Island (Island of Anguilla)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sombrero Island (Island of Anguilla)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sombrero Island (Island of Anguilla)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sombrero Island (Island of Anguilla)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sombrero Island (Island of Anguilla)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sombrero Island (Island of Anguilla)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sombrero Island (Island of Anguilla)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sombrero Island (Island of Anguilla)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sombrero Island (Island of Anguilla)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sombrero Island (Island of Anguilla)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sombrero Island (Island of Anguilla)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sombrero Island (Island of Anguilla)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sombrero Island (Island of Anguilla)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Somogy (County of Hungary)": [
            {
                "Region Name": "Somogy (County of Hungary)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Somogy (County of Hungary)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Somogy (County of Hungary)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Somogy (County of Hungary)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Somogy (County of Hungary)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Somogy (County of Hungary)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Somogy (County of Hungary)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Somogy (County of Hungary)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Somogy (County of Hungary)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Somogy (County of Hungary)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Somogy (County of Hungary)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Somogy (County of Hungary)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Somogy (County of Hungary)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Somogy (County of Hungary)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Somogy (County of Hungary)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Somogy (County of Hungary)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Somogy (County of Hungary)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Somogy (County of Hungary)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Somogy (County of Hungary)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Somogy (County of Hungary)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Somogy (County of Hungary)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Somogy (County of Hungary)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "S\u01A1n La (Province of Vietnam)": [
            {
                "Region Name": "S\u01A1n La (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "S\u01A1n La (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "S\u01A1n La (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "S\u01A1n La (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "S\u01A1n La (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "S\u01A1n La (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "S\u01A1n La (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "S\u01A1n La (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "S\u01A1n La (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "S\u01A1n La (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "S\u01A1n La (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "S\u01A1n La (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "S\u01A1n La (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "S\u01A1n La (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "S\u01A1n La (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "S\u01A1n La (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "S\u01A1n La (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "S\u01A1n La (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "S\u01A1n La (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "S\u01A1n La (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "S\u01A1n La (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "S\u01A1n La (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Songkhla (Province of Thailand)": [
            {
                "Region Name": "Songkhla (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Songkhla (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Songkhla (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Songkhla (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Songkhla (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Songkhla (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Songkhla (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Songkhla (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Songkhla (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Songkhla (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Songkhla (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Songkhla (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Songkhla (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Songkhla (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Songkhla (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Songkhla (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Songkhla (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Songkhla (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Songkhla (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Songkhla (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Songkhla (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Songkhla (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Songwe (Region of Tanzania)": [
            {
                "Region Name": "Songwe (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Songwe (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Songwe (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Songwe (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Songwe (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Songwe (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Songwe (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Songwe (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Songwe (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Songwe (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Songwe (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Songwe (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Songwe (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Songwe (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Songwe (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Songwe (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Songwe (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Songwe (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Songwe (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Songwe (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Songwe (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Songwe (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 24
            }
        ],
        "Sonora (State of M\xe9xico)": [
            {
                "Region Name": "Sonora (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sonora (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sonora (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sonora (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sonora (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Sonora (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sonora (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sonora (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sonora (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sonora (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Sonora (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Sonora (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Sonora (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sonora (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sonora (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Sonora (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Sonora (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Sonora (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sonora (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sonora (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sonora (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sonora (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 28
            }
        ],
        "Sonsonate (Department of El Salvador)": [
            {
                "Region Name": "Sonsonate (Department of El Salvador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sonsonate (Department of El Salvador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sonsonate (Department of El Salvador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sonsonate (Department of El Salvador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sonsonate (Department of El Salvador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sonsonate (Department of El Salvador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sonsonate (Department of El Salvador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sonsonate (Department of El Salvador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsonate (Department of El Salvador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsonate (Department of El Salvador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsonate (Department of El Salvador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sonsonate (Department of El Salvador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsonate (Department of El Salvador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sonsonate (Department of El Salvador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sonsonate (Department of El Salvador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sonsonate (Department of El Salvador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsonate (Department of El Salvador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sonsonate (Department of El Salvador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sonsonate (Department of El Salvador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sonsonate (Department of El Salvador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sonsonate (Department of El Salvador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsonate (Department of El Salvador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sonsorol (State of Palau)": [
            {
                "Region Name": "Sonsorol (State of Palau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsorol (State of Palau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsorol (State of Palau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsorol (State of Palau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsorol (State of Palau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsorol (State of Palau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsorol (State of Palau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsorol (State of Palau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsorol (State of Palau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsorol (State of Palau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsorol (State of Palau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsorol (State of Palau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsorol (State of Palau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsorol (State of Palau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsorol (State of Palau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsorol (State of Palau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsorol (State of Palau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsorol (State of Palau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsorol (State of Palau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsorol (State of Palau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsorol (State of Palau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sonsorol (State of Palau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sool (Region of Somalia)": [
            {
                "Region Name": "Sool (Region of Somalia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sool (Region of Somalia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sool (Region of Somalia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sool (Region of Somalia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sool (Region of Somalia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sool (Region of Somalia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sool (Region of Somalia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sool (Region of Somalia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sool (Region of Somalia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sool (Region of Somalia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sool (Region of Somalia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sool (Region of Somalia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sool (Region of Somalia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sool (Region of Somalia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sool (Region of Somalia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sool (Region of Somalia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sool (Region of Somalia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sool (Region of Somalia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sool (Region of Somalia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sool (Region of Somalia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sool (Region of Somalia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sool (Region of Somalia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sopi\u0161te (Municipality of North Macedonia)": [
            {
                "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sopi\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "S\xf8r-Tr\xf8ndelag (County of Norway)": [
            {
                "Region Name": "S\xf8r-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf8r-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf8r-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf8r-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf8r-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf8r-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf8r-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf8r-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf8r-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf8r-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf8r-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf8r-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf8r-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf8r-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf8r-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf8r-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf8r-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf8r-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf8r-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf8r-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf8r-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xf8r-Tr\xf8ndelag (County of Norway)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Soriano (Department of Uruguay)": [
            {
                "Region Name": "Soriano (Department of Uruguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Soriano (Department of Uruguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Soriano (Department of Uruguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Soriano (Department of Uruguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Soriano (Department of Uruguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Soriano (Department of Uruguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Soriano (Department of Uruguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Soriano (Department of Uruguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Soriano (Department of Uruguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Soriano (Department of Uruguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Soriano (Department of Uruguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Soriano (Department of Uruguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Soriano (Department of Uruguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Soriano (Department of Uruguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Soriano (Department of Uruguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Soriano (Department of Uruguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Soriano (Department of Uruguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Soriano (Department of Uruguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Soriano (Department of Uruguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Soriano (Department of Uruguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Soriano (Department of Uruguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Soriano (Department of Uruguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Soroca (District of Moldova)": [
            {
                "Region Name": "Soroca (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soroca (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soroca (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Soroca (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Soroca (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Soroca (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Soroca (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Soroca (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Soroca (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soroca (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Soroca (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soroca (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soroca (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Soroca (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soroca (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soroca (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Soroca (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soroca (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Soroca (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soroca (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soroca (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soroca (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Soroti (District of Uganda)": [
            {
                "Region Name": "Soroti (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Soroti (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Soroti (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Soroti (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Soroti (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Soroti (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Soroti (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Soroti (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Soroti (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Soroti (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soroti (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Soroti (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soroti (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Soroti (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soroti (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Soroti (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Soroti (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Soroti (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soroti (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soroti (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soroti (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Soroti (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sorsogon (Province of Philippines)": [
            {
                "Region Name": "Sorsogon (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sorsogon (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sorsogon (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sorsogon (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sorsogon (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sorsogon (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sorsogon (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sorsogon (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sorsogon (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sorsogon (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sorsogon (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sorsogon (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sorsogon (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sorsogon (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sorsogon (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sorsogon (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sorsogon (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sorsogon (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sorsogon (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sorsogon (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sorsogon (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sorsogon (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Soufri\xe8re (Quarter of Saint Lucia)": [
            {
                "Region Name": "Soufri\xe8re (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soufri\xe8re (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soufri\xe8re (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soufri\xe8re (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soufri\xe8re (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soufri\xe8re (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soufri\xe8re (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soufri\xe8re (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soufri\xe8re (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soufri\xe8re (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soufri\xe8re (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soufri\xe8re (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soufri\xe8re (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soufri\xe8re (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soufri\xe8re (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soufri\xe8re (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soufri\xe8re (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soufri\xe8re (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soufri\xe8re (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soufri\xe8re (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soufri\xe8re (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Soufri\xe8re (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Souk Ahras (Province of Algeria)": [
            {
                "Region Name": "Souk Ahras (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Souk Ahras (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Souk Ahras (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Souk Ahras (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Souk Ahras (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Souk Ahras (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Souk Ahras (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Souk Ahras (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Souk Ahras (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Souk Ahras (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Souk Ahras (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Souk Ahras (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Souk Ahras (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Souk Ahras (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Souk Ahras (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Souk Ahras (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Souk Ahras (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Souk Ahras (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Souk Ahras (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Souk Ahras (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Souk Ahras (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Souk Ahras (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Sous le Vent (Parish of Saint-Barth\xe9lemy)": [
            {
                "Region Name": "Sous le Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sous le Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sous le Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sous le Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sous le Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sous le Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sous le Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sous le Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sous le Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sous le Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sous le Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sous le Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sous le Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sous le Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sous le Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sous le Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sous le Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sous le Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sous le Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sous le Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sous le Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sous le Vent (Parish of Saint-Barth\xe9lemy)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Souss - Massa - Dra\xe2 (Region of Morocco)": [
            {
                "Region Name": "Souss - Massa - Dra\xe2 (Region of Morocco)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Souss - Massa - Dra\xe2 (Region of Morocco)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Souss - Massa - Dra\xe2 (Region of Morocco)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Souss - Massa - Dra\xe2 (Region of Morocco)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Souss - Massa - Dra\xe2 (Region of Morocco)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Souss - Massa - Dra\xe2 (Region of Morocco)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Souss - Massa - Dra\xe2 (Region of Morocco)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Souss - Massa - Dra\xe2 (Region of Morocco)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Souss - Massa - Dra\xe2 (Region of Morocco)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Souss - Massa - Dra\xe2 (Region of Morocco)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Souss - Massa - Dra\xe2 (Region of Morocco)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Souss - Massa - Dra\xe2 (Region of Morocco)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Souss - Massa - Dra\xe2 (Region of Morocco)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Souss - Massa - Dra\xe2 (Region of Morocco)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Souss - Massa - Dra\xe2 (Region of Morocco)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Souss - Massa - Dra\xe2 (Region of Morocco)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Souss - Massa - Dra\xe2 (Region of Morocco)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Souss - Massa - Dra\xe2 (Region of Morocco)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Souss - Massa - Dra\xe2 (Region of Morocco)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Souss - Massa - Dra\xe2 (Region of Morocco)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Souss - Massa - Dra\xe2 (Region of Morocco)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Souss - Massa - Dra\xe2 (Region of Morocco)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Sousse (Governorate of Tunisia)": [
            {
                "Region Name": "Sousse (Governorate of Tunisia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sousse (Governorate of Tunisia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sousse (Governorate of Tunisia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sousse (Governorate of Tunisia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sousse (Governorate of Tunisia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sousse (Governorate of Tunisia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sousse (Governorate of Tunisia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sousse (Governorate of Tunisia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sousse (Governorate of Tunisia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sousse (Governorate of Tunisia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sousse (Governorate of Tunisia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sousse (Governorate of Tunisia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sousse (Governorate of Tunisia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sousse (Governorate of Tunisia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sousse (Governorate of Tunisia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sousse (Governorate of Tunisia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sousse (Governorate of Tunisia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sousse (Governorate of Tunisia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sousse (Governorate of Tunisia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Sousse (Governorate of Tunisia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sousse (Governorate of Tunisia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sousse (Governorate of Tunisia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "South-East (District of Botswana)": [
            {
                "Region Name": "South-East (District of Botswana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "South-East (District of Botswana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "South-East (District of Botswana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "South-East (District of Botswana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "South-East (District of Botswana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "South-East (District of Botswana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South-East (District of Botswana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 65
            },
            {
                "Region Name": "South-East (District of Botswana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South-East (District of Botswana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South-East (District of Botswana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South-East (District of Botswana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "South-East (District of Botswana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South-East (District of Botswana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South-East (District of Botswana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "South-East (District of Botswana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South-East (District of Botswana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South-East (District of Botswana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "South-East (District of Botswana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South-East (District of Botswana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South-East (District of Botswana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "South-East (District of Botswana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "South-East (District of Botswana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 21
            }
        ],
        "South (Governorate of Lebanon)": [
            {
                "Region Name": "South (Governorate of Lebanon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South (Governorate of Lebanon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South (Governorate of Lebanon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South (Governorate of Lebanon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South (Governorate of Lebanon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South (Governorate of Lebanon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South (Governorate of Lebanon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South (Governorate of Lebanon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South (Governorate of Lebanon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South (Governorate of Lebanon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South (Governorate of Lebanon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South (Governorate of Lebanon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South (Governorate of Lebanon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South (Governorate of Lebanon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South (Governorate of Lebanon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South (Governorate of Lebanon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South (Governorate of Lebanon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South (Governorate of Lebanon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South (Governorate of Lebanon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South (Governorate of Lebanon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "South (Governorate of Lebanon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South (Governorate of Lebanon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "South Abaco (District of Bahamas)": [
            {
                "Region Name": "South Abaco (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "South Abaco (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Abaco (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "South Abaco (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "South Abaco (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Abaco (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "South Abaco (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 93
            },
            {
                "Region Name": "South Abaco (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Abaco (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "South Abaco (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 118
            },
            {
                "Region Name": "South Abaco (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "South Abaco (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 152
            },
            {
                "Region Name": "South Abaco (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Abaco (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South Abaco (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "South Abaco (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "South Abaco (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Abaco (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Abaco (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "South Abaco (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Abaco (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Abaco (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "South Andros (District of Bahamas)": [
            {
                "Region Name": "South Andros (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Andros (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Andros (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Andros (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Andros (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "South Andros (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Andros (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Andros (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Andros (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Andros (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South Andros (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Andros (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Andros (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Andros (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "South Andros (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Andros (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Andros (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Andros (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Andros (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "South Andros (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Andros (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Andros (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "South Australia (State of Australia)": [
            {
                "Region Name": "South Australia (State of Australia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 110
            },
            {
                "Region Name": "South Australia (State of Australia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South Australia (State of Australia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "South Australia (State of Australia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South Australia (State of Australia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "South Australia (State of Australia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "South Australia (State of Australia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "South Australia (State of Australia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "South Australia (State of Australia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South Australia (State of Australia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "South Australia (State of Australia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 109
            },
            {
                "Region Name": "South Australia (State of Australia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "South Australia (State of Australia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "South Australia (State of Australia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "South Australia (State of Australia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South Australia (State of Australia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "South Australia (State of Australia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "South Australia (State of Australia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 111
            },
            {
                "Region Name": "South Australia (State of Australia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "South Australia (State of Australia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South Australia (State of Australia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "South Australia (State of Australia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 40
            }
        ],
        "South Caicos and East Caicos (District of Turks and Caicos Islands)": [
            {
                "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Caicos and East Caicos (District of Turks and Caicos Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "South Carolina (State of United States)": [
            {
                "Region Name": "South Carolina (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South Carolina (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South Carolina (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South Carolina (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South Carolina (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South Carolina (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South Carolina (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South Carolina (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South Carolina (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South Carolina (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South Carolina (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South Carolina (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "South Carolina (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "South Carolina (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South Carolina (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "South Carolina (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "South Carolina (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South Carolina (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South Carolina (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South Carolina (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "South Carolina (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South Carolina (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "South Cotabato (Province of Philippines)": [
            {
                "Region Name": "South Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "South Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "South Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "South Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "South Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "South Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "South Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Cotabato (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "South Dakota (State of United States)": [
            {
                "Region Name": "South Dakota (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "South Dakota (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "South Dakota (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "South Dakota (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South Dakota (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "South Dakota (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South Dakota (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "South Dakota (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "South Dakota (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "South Dakota (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "South Dakota (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "South Dakota (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "South Dakota (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South Dakota (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South Dakota (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "South Dakota (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South Dakota (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "South Dakota (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "South Dakota (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South Dakota (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "South Dakota (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South Dakota (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "South Darfur (State of Sudan)": [
            {
                "Region Name": "South Darfur (State of Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 63
            },
            {
                "Region Name": "South Darfur (State of Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "South Darfur (State of Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 64
            },
            {
                "Region Name": "South Darfur (State of Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "South Darfur (State of Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 64
            },
            {
                "Region Name": "South Darfur (State of Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "South Darfur (State of Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "South Darfur (State of Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "South Darfur (State of Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "South Darfur (State of Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "South Darfur (State of Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "South Darfur (State of Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "South Darfur (State of Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "South Darfur (State of Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "South Darfur (State of Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "South Darfur (State of Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "South Darfur (State of Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "South Darfur (State of Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "South Darfur (State of Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "South Darfur (State of Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "South Darfur (State of Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "South Darfur (State of Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 23
            }
        ],
        "South Eleuthera (District of Bahamas)": [
            {
                "Region Name": "South Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "South Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "South Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Eleuthera (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "South Hill (District of Anguilla)": [
            {
                "Region Name": "South Hill (District of Anguilla)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Hill (District of Anguilla)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Hill (District of Anguilla)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Hill (District of Anguilla)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Hill (District of Anguilla)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Hill (District of Anguilla)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Hill (District of Anguilla)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Hill (District of Anguilla)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Hill (District of Anguilla)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Hill (District of Anguilla)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Hill (District of Anguilla)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Hill (District of Anguilla)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Hill (District of Anguilla)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Hill (District of Anguilla)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Hill (District of Anguilla)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Hill (District of Anguilla)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Hill (District of Anguilla)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Hill (District of Anguilla)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Hill (District of Anguilla)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Hill (District of Anguilla)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Hill (District of Anguilla)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Hill (District of Anguilla)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "South Kazakhstan (Region of Kazakhstan)": [
            {
                "Region Name": "South Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "South Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "South Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 67
            },
            {
                "Region Name": "South Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "South Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "South Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "South Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "South Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "South Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "South Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "South Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "South Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "South Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "South Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "South Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "South Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "South Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "South Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "South Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "South Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "South Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "South Khorasan (Province of Iran)": [
            {
                "Region Name": "South Khorasan (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Khorasan (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Khorasan (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Khorasan (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Khorasan (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Khorasan (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Khorasan (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Khorasan (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "South Khorasan (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Khorasan (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Khorasan (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Khorasan (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Khorasan (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Khorasan (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Khorasan (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Khorasan (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Khorasan (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Khorasan (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Khorasan (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Khorasan (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Khorasan (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "South Khorasan (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "South Kurdufan (State of Sudan)": [
            {
                "Region Name": "South Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "South Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "South Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "South Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "South Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "South Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "South Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "South Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "South Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "South Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "South Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "South Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "South Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "South Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "South Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "South Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "South Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "South Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "South Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "South Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "South Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "South Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 19
            }
        ],
        "Southampton (Parish of Bermuda)": [
            {
                "Region Name": "Southampton (Parish of Bermuda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southampton (Parish of Bermuda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southampton (Parish of Bermuda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southampton (Parish of Bermuda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southampton (Parish of Bermuda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southampton (Parish of Bermuda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southampton (Parish of Bermuda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southampton (Parish of Bermuda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southampton (Parish of Bermuda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southampton (Parish of Bermuda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southampton (Parish of Bermuda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southampton (Parish of Bermuda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southampton (Parish of Bermuda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southampton (Parish of Bermuda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southampton (Parish of Bermuda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southampton (Parish of Bermuda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southampton (Parish of Bermuda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southampton (Parish of Bermuda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southampton (Parish of Bermuda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southampton (Parish of Bermuda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southampton (Parish of Bermuda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southampton (Parish of Bermuda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Southern (District of Botswana)": [
            {
                "Region Name": "Southern (District of Botswana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 98
            },
            {
                "Region Name": "Southern (District of Botswana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Southern (District of Botswana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Southern (District of Botswana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 167
            },
            {
                "Region Name": "Southern (District of Botswana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Southern (District of Botswana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 273
            },
            {
                "Region Name": "Southern (District of Botswana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "Southern (District of Botswana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 59
            },
            {
                "Region Name": "Southern (District of Botswana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 216
            },
            {
                "Region Name": "Southern (District of Botswana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 81
            },
            {
                "Region Name": "Southern (District of Botswana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 101
            },
            {
                "Region Name": "Southern (District of Botswana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Southern (District of Botswana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 116
            },
            {
                "Region Name": "Southern (District of Botswana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Southern (District of Botswana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Southern (District of Botswana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "Southern (District of Botswana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 146
            },
            {
                "Region Name": "Southern (District of Botswana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Southern (District of Botswana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Southern (District of Botswana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 221
            },
            {
                "Region Name": "Southern (District of Botswana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 134
            },
            {
                "Region Name": "Southern (District of Botswana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 112
            }
        ],
        "Southern (Governorate of Bahrain)": [
            {
                "Region Name": "Southern (Governorate of Bahrain)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern (Governorate of Bahrain)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern (Governorate of Bahrain)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern (Governorate of Bahrain)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern (Governorate of Bahrain)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern (Governorate of Bahrain)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern (Governorate of Bahrain)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern (Governorate of Bahrain)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern (Governorate of Bahrain)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern (Governorate of Bahrain)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern (Governorate of Bahrain)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern (Governorate of Bahrain)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern (Governorate of Bahrain)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern (Governorate of Bahrain)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern (Governorate of Bahrain)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern (Governorate of Bahrain)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern (Governorate of Bahrain)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern (Governorate of Bahrain)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern (Governorate of Bahrain)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern (Governorate of Bahrain)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern (Governorate of Bahrain)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern (Governorate of Bahrain)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Southern (Province of Sierra Leone)": [
            {
                "Region Name": "Southern (Province of Sierra Leone)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Southern (Province of Sierra Leone)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Southern (Province of Sierra Leone)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Southern (Province of Sierra Leone)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Southern (Province of Sierra Leone)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Southern (Province of Sierra Leone)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Southern (Province of Sierra Leone)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Southern (Province of Sierra Leone)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Southern (Province of Sierra Leone)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Southern (Province of Sierra Leone)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Southern (Province of Sierra Leone)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Southern (Province of Sierra Leone)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Southern (Province of Sierra Leone)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Southern (Province of Sierra Leone)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Southern (Province of Sierra Leone)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Southern (Province of Sierra Leone)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Southern (Province of Sierra Leone)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Southern (Province of Sierra Leone)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Southern (Province of Sierra Leone)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Southern (Province of Sierra Leone)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Southern (Province of Sierra Leone)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Southern (Province of Sierra Leone)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Southern (Province of Zambia)": [
            {
                "Region Name": "Southern (Province of Zambia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Southern (Province of Zambia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Southern (Province of Zambia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Southern (Province of Zambia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Southern (Province of Zambia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Southern (Province of Zambia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Southern (Province of Zambia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Southern (Province of Zambia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Southern (Province of Zambia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Southern (Province of Zambia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Southern (Province of Zambia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Southern (Province of Zambia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Southern (Province of Zambia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Southern (Province of Zambia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Southern (Province of Zambia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Southern (Province of Zambia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Southern (Province of Zambia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Southern (Province of Zambia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Southern (Province of Zambia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Southern (Province of Zambia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Southern (Province of Zambia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Southern (Province of Zambia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Southern Finland (Province of Finland)": [
            {
                "Region Name": "Southern Finland (Province of Finland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Southern Finland (Province of Finland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Southern Finland (Province of Finland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Finland (Province of Finland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Finland (Province of Finland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Southern Finland (Province of Finland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Southern Finland (Province of Finland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Southern Finland (Province of Finland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Southern Finland (Province of Finland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Southern Finland (Province of Finland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Southern Finland (Province of Finland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Finland (Province of Finland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Southern Finland (Province of Finland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Finland (Province of Finland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Finland (Province of Finland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Southern Finland (Province of Finland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Finland (Province of Finland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Southern Finland (Province of Finland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Southern Finland (Province of Finland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Finland (Province of Finland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Southern Finland (Province of Finland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Finland (Province of Finland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Southern Highlands (Province of Papua New Guinea)": [
            {
                "Region Name": "Southern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Southern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Southern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Southern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Southern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Southern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Southern Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Southern Islands (Group of islands of New Zealand)": [
            {
                "Region Name": "Southern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Islands (Group of islands of New Zealand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Southern Leyte (Province of Philippines)": [
            {
                "Region Name": "Southern Leyte (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Leyte (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Leyte (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Leyte (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Leyte (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Leyte (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Leyte (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Leyte (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Leyte (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Leyte (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Leyte (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Leyte (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Leyte (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Leyte (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Leyte (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Leyte (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Leyte (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Leyte (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Leyte (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Leyte (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Leyte (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southern Leyte (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Southern Nations, Nationalities (State of Ethiopia)": [
            {
                "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Southern Nations, Nationalities (State of Ethiopia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Southland (Region of New Zealand)": [
            {
                "Region Name": "Southland (Region of New Zealand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southland (Region of New Zealand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Southland (Region of New Zealand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southland (Region of New Zealand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southland (Region of New Zealand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southland (Region of New Zealand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southland (Region of New Zealand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Southland (Region of New Zealand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southland (Region of New Zealand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southland (Region of New Zealand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southland (Region of New Zealand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southland (Region of New Zealand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southland (Region of New Zealand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Southland (Region of New Zealand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southland (Region of New Zealand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southland (Region of New Zealand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Southland (Region of New Zealand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southland (Region of New Zealand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southland (Region of New Zealand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southland (Region of New Zealand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southland (Region of New Zealand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Southland (Region of New Zealand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sowa (Town of Botswana)": [
            {
                "Region Name": "Sowa (Town of Botswana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sowa (Town of Botswana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sowa (Town of Botswana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sowa (Town of Botswana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sowa (Town of Botswana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sowa (Town of Botswana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sowa (Town of Botswana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sowa (Town of Botswana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sowa (Town of Botswana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sowa (Town of Botswana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sowa (Town of Botswana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sowa (Town of Botswana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sowa (Town of Botswana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sowa (Town of Botswana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sowa (Town of Botswana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sowa (Town of Botswana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sowa (Town of Botswana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sowa (Town of Botswana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sowa (Town of Botswana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sowa (Town of Botswana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sowa (Town of Botswana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sowa (Town of Botswana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Spanish Wells (District of Bahamas)": [
            {
                "Region Name": "Spanish Wells (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spanish Wells (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spanish Wells (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spanish Wells (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spanish Wells (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spanish Wells (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spanish Wells (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spanish Wells (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spanish Wells (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spanish Wells (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spanish Wells (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spanish Wells (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spanish Wells (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spanish Wells (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spanish Wells (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spanish Wells (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spanish Wells (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spanish Wells (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spanish Wells (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spanish Wells (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spanish Wells (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spanish Wells (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Splitsko-Dalmatinska (County of Croatia)": [
            {
                "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 79
            },
            {
                "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Splitsko-Dalmatinska (County of Croatia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Spodnjeposavska (Statistical Region of Slovenia)": [
            {
                "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Spodnjeposavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Srednje-Banatski (District of Serbia)": [
            {
                "Region Name": "Srednje-Banatski (District of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Srednje-Banatski (District of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Srednje-Banatski (District of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Srednje-Banatski (District of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Srednje-Banatski (District of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Srednje-Banatski (District of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Srednje-Banatski (District of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Srednje-Banatski (District of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Srednje-Banatski (District of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Srednje-Banatski (District of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Srednje-Banatski (District of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Srednje-Banatski (District of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Srednje-Banatski (District of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Srednje-Banatski (District of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Srednje-Banatski (District of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Srednje-Banatski (District of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Srednje-Banatski (District of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Srednje-Banatski (District of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Srednje-Banatski (District of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Srednje-Banatski (District of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Srednje-Banatski (District of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Srednje-Banatski (District of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Sremski (District of Serbia)": [
            {
                "Region Name": "Sremski (District of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sremski (District of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sremski (District of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sremski (District of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sremski (District of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sremski (District of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sremski (District of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Sremski (District of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sremski (District of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sremski (District of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sremski (District of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sremski (District of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sremski (District of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sremski (District of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sremski (District of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sremski (District of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sremski (District of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sremski (District of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sremski (District of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sremski (District of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sremski (District of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sremski (District of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 35
            }
        ],
        "Stann Creek (District of Belize)": [
            {
                "Region Name": "Stann Creek (District of Belize)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Stann Creek (District of Belize)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Stann Creek (District of Belize)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Stann Creek (District of Belize)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Stann Creek (District of Belize)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Stann Creek (District of Belize)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Stann Creek (District of Belize)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Stann Creek (District of Belize)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Stann Creek (District of Belize)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Stann Creek (District of Belize)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Stann Creek (District of Belize)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Stann Creek (District of Belize)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Stann Creek (District of Belize)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Stann Creek (District of Belize)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Stann Creek (District of Belize)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Stann Creek (District of Belize)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Stann Creek (District of Belize)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Stann Creek (District of Belize)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Stann Creek (District of Belize)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Stann Creek (District of Belize)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Stann Creek (District of Belize)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Stann Creek (District of Belize)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Star Dojran (Municipality of North Macedonia)": [
            {
                "Region Name": "Star Dojran (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Star Dojran (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Star Dojran (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Star Dojran (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Star Dojran (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Star Dojran (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Star Dojran (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Star Dojran (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Star Dojran (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Star Dojran (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Star Dojran (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Star Dojran (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Star Dojran (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Star Dojran (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Star Dojran (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Star Dojran (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Star Dojran (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Star Dojran (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Star Dojran (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Star Dojran (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Star Dojran (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Star Dojran (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Stara Zagora (Province of Bulgaria)": [
            {
                "Region Name": "Stara Zagora (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Stara Zagora (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Stara Zagora (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Stara Zagora (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Stara Zagora (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Stara Zagora (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Stara Zagora (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Stara Zagora (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Stara Zagora (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Stara Zagora (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Stara Zagora (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Stara Zagora (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Stara Zagora (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Stara Zagora (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stara Zagora (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Stara Zagora (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Stara Zagora (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Stara Zagora (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Stara Zagora (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Stara Zagora (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Stara Zagora (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Stara Zagora (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Staro Nagori\u010Dane (Municipality of North Macedonia)": [
            {
                "Region Name": "Staro Nagori\u010Dane (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Staro Nagori\u010Dane (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Staro Nagori\u010Dane (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Staro Nagori\u010Dane (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Staro Nagori\u010Dane (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Staro Nagori\u010Dane (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Staro Nagori\u010Dane (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Staro Nagori\u010Dane (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Staro Nagori\u010Dane (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Staro Nagori\u010Dane (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Staro Nagori\u010Dane (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Staro Nagori\u010Dane (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Staro Nagori\u010Dane (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Staro Nagori\u010Dane (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Staro Nagori\u010Dane (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Staro Nagori\u010Dane (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Staro Nagori\u010Dane (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Staro Nagori\u010Dane (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Staro Nagori\u010Dane (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Staro Nagori\u010Dane (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Staro Nagori\u010Dane (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Staro Nagori\u010Dane (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Stavropol' (Territory of Russia)": [
            {
                "Region Name": "Stavropol' (Territory of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Stavropol' (Territory of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Stavropol' (Territory of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Stavropol' (Territory of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Stavropol' (Territory of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Stavropol' (Territory of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Stavropol' (Territory of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Stavropol' (Territory of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Stavropol' (Territory of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Stavropol' (Territory of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Stavropol' (Territory of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Stavropol' (Territory of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Stavropol' (Territory of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Stavropol' (Territory of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Stavropol' (Territory of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Stavropol' (Territory of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Stavropol' (Territory of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Stavropol' (Territory of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Stavropol' (Territory of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Stavropol' (Territory of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Stavropol' (Territory of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Stavropol' (Territory of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "\u0218tefan Vod\u0103 (District of Moldova)": [
            {
                "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0218tefan Vod\u0103 (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Steiermark (State of Austria)": [
            {
                "Region Name": "Steiermark (State of Austria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Steiermark (State of Austria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Steiermark (State of Austria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Steiermark (State of Austria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Steiermark (State of Austria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Steiermark (State of Austria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Steiermark (State of Austria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Steiermark (State of Austria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Steiermark (State of Austria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Steiermark (State of Austria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Steiermark (State of Austria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Steiermark (State of Austria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Steiermark (State of Austria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Steiermark (State of Austria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Steiermark (State of Austria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Steiermark (State of Austria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Steiermark (State of Austria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Steiermark (State of Austria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Steiermark (State of Austria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Steiermark (State of Austria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Steiermark (State of Austria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Steiermark (State of Austria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\u0160tip (Municipality of North Macedonia)": [
            {
                "Region Name": "\u0160tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u0160tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "\u0160tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u0160tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "\u0160tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160tip (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Stockholm (County of Sweden)": [
            {
                "Region Name": "Stockholm (County of Sweden)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stockholm (County of Sweden)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stockholm (County of Sweden)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stockholm (County of Sweden)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stockholm (County of Sweden)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stockholm (County of Sweden)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stockholm (County of Sweden)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stockholm (County of Sweden)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stockholm (County of Sweden)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stockholm (County of Sweden)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stockholm (County of Sweden)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stockholm (County of Sweden)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stockholm (County of Sweden)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stockholm (County of Sweden)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stockholm (County of Sweden)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stockholm (County of Sweden)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stockholm (County of Sweden)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stockholm (County of Sweden)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stockholm (County of Sweden)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stockholm (County of Sweden)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stockholm (County of Sweden)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stockholm (County of Sweden)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "St\u0153ng Tr\xe9ng (Province of Cambodia)": [
            {
                "Region Name": "St\u0153ng Tr\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "St\u0153ng Tr\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "St\u0153ng Tr\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "St\u0153ng Tr\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "St\u0153ng Tr\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "St\u0153ng Tr\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "St\u0153ng Tr\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "St\u0153ng Tr\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "St\u0153ng Tr\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "St\u0153ng Tr\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "St\u0153ng Tr\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "St\u0153ng Tr\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "St\u0153ng Tr\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "St\u0153ng Tr\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "St\u0153ng Tr\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "St\u0153ng Tr\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "St\u0153ng Tr\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "St\u0153ng Tr\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "St\u0153ng Tr\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "St\u0153ng Tr\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "St\u0153ng Tr\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "St\u0153ng Tr\xe9ng (Province of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Stoney Ground (District of Anguilla)": [
            {
                "Region Name": "Stoney Ground (District of Anguilla)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stoney Ground (District of Anguilla)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stoney Ground (District of Anguilla)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stoney Ground (District of Anguilla)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stoney Ground (District of Anguilla)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stoney Ground (District of Anguilla)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stoney Ground (District of Anguilla)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stoney Ground (District of Anguilla)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stoney Ground (District of Anguilla)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stoney Ground (District of Anguilla)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stoney Ground (District of Anguilla)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stoney Ground (District of Anguilla)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stoney Ground (District of Anguilla)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stoney Ground (District of Anguilla)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stoney Ground (District of Anguilla)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stoney Ground (District of Anguilla)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stoney Ground (District of Anguilla)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stoney Ground (District of Anguilla)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stoney Ground (District of Anguilla)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stoney Ground (District of Anguilla)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stoney Ground (District of Anguilla)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Stoney Ground (District of Anguilla)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Str\u0103\u0219eni (District of Moldova)": [
            {
                "Region Name": "Str\u0103\u0219eni (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Str\u0103\u0219eni (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Str\u0103\u0219eni (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Str\u0103\u0219eni (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Str\u0103\u0219eni (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Str\u0103\u0219eni (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Str\u0103\u0219eni (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Str\u0103\u0219eni (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Str\u0103\u0219eni (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Str\u0103\u0219eni (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Str\u0103\u0219eni (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Str\u0103\u0219eni (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Str\u0103\u0219eni (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Str\u0103\u0219eni (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Str\u0103\u0219eni (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Str\u0103\u0219eni (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Str\u0103\u0219eni (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Str\u0103\u0219eni (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Str\u0103\u0219eni (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Str\u0103\u0219eni (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Str\u0103\u0219eni (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Str\u0103\u0219eni (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "St\u0159edo\u010Desk\xfd (Region of Czechia)": [
            {
                "Region Name": "St\u0159edo\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "St\u0159edo\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "St\u0159edo\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "St\u0159edo\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "St\u0159edo\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "St\u0159edo\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "St\u0159edo\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "St\u0159edo\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "St\u0159edo\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "St\u0159edo\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "St\u0159edo\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "St\u0159edo\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "St\u0159edo\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "St\u0159edo\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "St\u0159edo\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "St\u0159edo\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "St\u0159edo\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "St\u0159edo\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "St\u0159edo\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "St\u0159edo\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "St\u0159edo\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "St\u0159edo\u010Desk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Streymoyar (Region of Faroe Islands)": [
            {
                "Region Name": "Streymoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Streymoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Streymoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Streymoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Streymoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Streymoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Streymoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Streymoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Streymoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Streymoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Streymoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Streymoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Streymoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Streymoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Streymoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Streymoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Streymoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Streymoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Streymoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Streymoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Streymoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Streymoyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Struga (Municipality of North Macedonia)": [
            {
                "Region Name": "Struga (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Struga (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Struga (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Struga (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Struga (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Struga (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Struga (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Struga (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Struga (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Struga (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Struga (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Struga (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Struga (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Struga (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Struga (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Struga (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Struga (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Struga (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Struga (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Struga (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Struga (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Struga (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Strumitsa (Municipality of North Macedonia)": [
            {
                "Region Name": "Strumitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Strumitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Strumitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Strumitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Strumitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Strumitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Strumitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Strumitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Strumitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Strumitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Strumitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Strumitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Strumitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Strumitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Strumitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Strumitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Strumitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Strumitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Strumitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Strumitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Strumitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Strumitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Studeni\u010Dani (Municipality of North Macedonia)": [
            {
                "Region Name": "Studeni\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Studeni\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Studeni\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Studeni\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Studeni\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Studeni\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Studeni\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Studeni\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Studeni\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Studeni\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Studeni\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Studeni\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Studeni\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Studeni\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Studeni\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Studeni\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Studeni\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Studeni\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Studeni\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Studeni\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Studeni\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Studeni\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Suceava (County of Romania)": [
            {
                "Region Name": "Suceava (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suceava (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suceava (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suceava (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suceava (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suceava (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Suceava (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suceava (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Suceava (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suceava (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suceava (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Suceava (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Suceava (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suceava (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suceava (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suceava (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suceava (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Suceava (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suceava (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suceava (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suceava (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Suceava (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Suchitep\xe9quez (Department of Guatemala)": [
            {
                "Region Name": "Suchitep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Suchitep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Suchitep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Suchitep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Suchitep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Suchitep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Suchitep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Suchitep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Suchitep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Suchitep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Suchitep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Suchitep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Suchitep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Suchitep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Suchitep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Suchitep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Suchitep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Suchitep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Suchitep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Suchitep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Suchitep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Suchitep\xe9quez (Department of Guatemala)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Sucre (Department of Colombia)": [
            {
                "Region Name": "Sucre (Department of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sucre (Department of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sucre (Department of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sucre (Department of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sucre (Department of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sucre (Department of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sucre (Department of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sucre (Department of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sucre (Department of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sucre (Department of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sucre (Department of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sucre (Department of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sucre (Department of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sucre (Department of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sucre (Department of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sucre (Department of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sucre (Department of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sucre (Department of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sucre (Department of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sucre (Department of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sucre (Department of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sucre (Department of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Sucre (State of Venezuela)": [
            {
                "Region Name": "Sucre (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sucre (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sucre (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sucre (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sucre (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sucre (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sucre (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Sucre (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sucre (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sucre (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sucre (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sucre (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Sucre (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sucre (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Sucre (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sucre (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sucre (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sucre (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sucre (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sucre (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sucre (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sucre (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Sucumbios (Province of Ecuador)": [
            {
                "Region Name": "Sucumbios (Province of Ecuador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sucumbios (Province of Ecuador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sucumbios (Province of Ecuador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sucumbios (Province of Ecuador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sucumbios (Province of Ecuador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sucumbios (Province of Ecuador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sucumbios (Province of Ecuador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sucumbios (Province of Ecuador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sucumbios (Province of Ecuador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sucumbios (Province of Ecuador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sucumbios (Province of Ecuador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sucumbios (Province of Ecuador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sucumbios (Province of Ecuador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sucumbios (Province of Ecuador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sucumbios (Province of Ecuador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sucumbios (Province of Ecuador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sucumbios (Province of Ecuador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sucumbios (Province of Ecuador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sucumbios (Province of Ecuador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sucumbios (Province of Ecuador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sucumbios (Province of Ecuador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sucumbios (Province of Ecuador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sud-Est (Department of Haiti)": [
            {
                "Region Name": "Sud-Est (Department of Haiti)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud-Est (Department of Haiti)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud-Est (Department of Haiti)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud-Est (Department of Haiti)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud-Est (Department of Haiti)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud-Est (Department of Haiti)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud-Est (Department of Haiti)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud-Est (Department of Haiti)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud-Est (Department of Haiti)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud-Est (Department of Haiti)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud-Est (Department of Haiti)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud-Est (Department of Haiti)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud-Est (Department of Haiti)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud-Est (Department of Haiti)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud-Est (Department of Haiti)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud-Est (Department of Haiti)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud-Est (Department of Haiti)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud-Est (Department of Haiti)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud-Est (Department of Haiti)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud-Est (Department of Haiti)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud-Est (Department of Haiti)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud-Est (Department of Haiti)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sud-Kivu (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sud-Kivu (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Sud-Ouest (Region of Burkina Faso)": [
            {
                "Region Name": "Sud-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Sud-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Sud-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sud-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Sud-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sud-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sud-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sud-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sud-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sud-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sud-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sud-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sud-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sud-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sud-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sud-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sud-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sud-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sud-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sud-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sud-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sud-Ouest (Region of Burkina Faso)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Sud-Ouest (Region of Cameroon)": [
            {
                "Region Name": "Sud-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sud-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sud-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sud-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sud-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sud-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sud-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sud-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sud-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sud-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sud-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sud-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sud-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sud-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sud-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sud-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sud-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sud-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sud-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sud-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sud-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sud-Ouest (Region of Cameroon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Sud-Ubangi (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sud-Ubangi (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Sud (Department of Haiti)": [
            {
                "Region Name": "Sud (Department of Haiti)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Department of Haiti)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Department of Haiti)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Department of Haiti)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Department of Haiti)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Department of Haiti)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Department of Haiti)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Department of Haiti)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Department of Haiti)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Department of Haiti)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Department of Haiti)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Department of Haiti)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Department of Haiti)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Department of Haiti)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Department of Haiti)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Department of Haiti)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Department of Haiti)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sud (Department of Haiti)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Department of Haiti)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Department of Haiti)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Department of Haiti)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Department of Haiti)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sud (Province of New Caledonia)": [
            {
                "Region Name": "Sud (Province of New Caledonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sud (Province of New Caledonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Province of New Caledonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sud (Province of New Caledonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Sud (Province of New Caledonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Province of New Caledonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Province of New Caledonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Province of New Caledonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Province of New Caledonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Province of New Caledonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sud (Province of New Caledonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Province of New Caledonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Province of New Caledonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Province of New Caledonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sud (Province of New Caledonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Province of New Caledonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sud (Province of New Caledonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Province of New Caledonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Sud (Province of New Caledonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Province of New Caledonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sud (Province of New Caledonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Province of New Caledonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Sud (Region of Cameroon)": [
            {
                "Region Name": "Sud (Region of Cameroon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Region of Cameroon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sud (Region of Cameroon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Region of Cameroon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Region of Cameroon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sud (Region of Cameroon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sud (Region of Cameroon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sud (Region of Cameroon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sud (Region of Cameroon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sud (Region of Cameroon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Region of Cameroon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sud (Region of Cameroon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sud (Region of Cameroon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sud (Region of Cameroon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sud (Region of Cameroon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sud (Region of Cameroon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sud (Region of Cameroon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sud (Region of Cameroon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sud (Region of Cameroon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sud (Region of Cameroon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sud (Region of Cameroon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sud (Region of Cameroon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Su\xf0urland (Region of Iceland)": [
            {
                "Region Name": "Su\xf0urland (Region of Iceland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urland (Region of Iceland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urland (Region of Iceland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urland (Region of Iceland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urland (Region of Iceland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urland (Region of Iceland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urland (Region of Iceland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urland (Region of Iceland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urland (Region of Iceland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urland (Region of Iceland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urland (Region of Iceland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urland (Region of Iceland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urland (Region of Iceland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urland (Region of Iceland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urland (Region of Iceland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urland (Region of Iceland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urland (Region of Iceland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urland (Region of Iceland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urland (Region of Iceland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urland (Region of Iceland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urland (Region of Iceland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urland (Region of Iceland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Su\xf0urnes (Independent Town of Iceland)": [
            {
                "Region Name": "Su\xf0urnes (Independent Town of Iceland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urnes (Independent Town of Iceland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urnes (Independent Town of Iceland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urnes (Independent Town of Iceland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urnes (Independent Town of Iceland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urnes (Independent Town of Iceland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urnes (Independent Town of Iceland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urnes (Independent Town of Iceland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urnes (Independent Town of Iceland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urnes (Independent Town of Iceland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urnes (Independent Town of Iceland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urnes (Independent Town of Iceland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urnes (Independent Town of Iceland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urnes (Independent Town of Iceland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urnes (Independent Town of Iceland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urnes (Independent Town of Iceland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urnes (Independent Town of Iceland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urnes (Independent Town of Iceland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urnes (Independent Town of Iceland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urnes (Independent Town of Iceland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urnes (Independent Town of Iceland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0urnes (Independent Town of Iceland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Su\xf0uroyar (Region of Faroe Islands)": [
            {
                "Region Name": "Su\xf0uroyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0uroyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0uroyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0uroyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0uroyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0uroyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0uroyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0uroyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0uroyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0uroyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0uroyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0uroyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0uroyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0uroyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0uroyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0uroyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0uroyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0uroyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0uroyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0uroyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0uroyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Su\xf0uroyar (Region of Faroe Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sughd (Region of Tajikistan)": [
            {
                "Region Name": "Sughd (Region of Tajikistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sughd (Region of Tajikistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sughd (Region of Tajikistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sughd (Region of Tajikistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sughd (Region of Tajikistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sughd (Region of Tajikistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sughd (Region of Tajikistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sughd (Region of Tajikistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sughd (Region of Tajikistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sughd (Region of Tajikistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sughd (Region of Tajikistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sughd (Region of Tajikistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sughd (Region of Tajikistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sughd (Region of Tajikistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sughd (Region of Tajikistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sughd (Region of Tajikistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sughd (Region of Tajikistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sughd (Region of Tajikistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sughd (Region of Tajikistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sughd (Region of Tajikistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sughd (Region of Tajikistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sughd (Region of Tajikistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Suhaj (Governorate of Egypt)": [
            {
                "Region Name": "Suhaj (Governorate of Egypt)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suhaj (Governorate of Egypt)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suhaj (Governorate of Egypt)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suhaj (Governorate of Egypt)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suhaj (Governorate of Egypt)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suhaj (Governorate of Egypt)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suhaj (Governorate of Egypt)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suhaj (Governorate of Egypt)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suhaj (Governorate of Egypt)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suhaj (Governorate of Egypt)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suhaj (Governorate of Egypt)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suhaj (Governorate of Egypt)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suhaj (Governorate of Egypt)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suhaj (Governorate of Egypt)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suhaj (Governorate of Egypt)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suhaj (Governorate of Egypt)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suhaj (Governorate of Egypt)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suhaj (Governorate of Egypt)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suhaj (Governorate of Egypt)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suhaj (Governorate of Egypt)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suhaj (Governorate of Egypt)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Suhaj (Governorate of Egypt)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "S\xfchbaatar (Province of Mongolia)": [
            {
                "Region Name": "S\xfchbaatar (Province of Mongolia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "S\xfchbaatar (Province of Mongolia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "S\xfchbaatar (Province of Mongolia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 85
            },
            {
                "Region Name": "S\xfchbaatar (Province of Mongolia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 517
            },
            {
                "Region Name": "S\xfchbaatar (Province of Mongolia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 65
            },
            {
                "Region Name": "S\xfchbaatar (Province of Mongolia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 66
            },
            {
                "Region Name": "S\xfchbaatar (Province of Mongolia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "S\xfchbaatar (Province of Mongolia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "S\xfchbaatar (Province of Mongolia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "S\xfchbaatar (Province of Mongolia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 155
            },
            {
                "Region Name": "S\xfchbaatar (Province of Mongolia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "S\xfchbaatar (Province of Mongolia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 144
            },
            {
                "Region Name": "S\xfchbaatar (Province of Mongolia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 195
            },
            {
                "Region Name": "S\xfchbaatar (Province of Mongolia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 115
            },
            {
                "Region Name": "S\xfchbaatar (Province of Mongolia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 208
            },
            {
                "Region Name": "S\xfchbaatar (Province of Mongolia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "S\xfchbaatar (Province of Mongolia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "S\xfchbaatar (Province of Mongolia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "S\xfchbaatar (Province of Mongolia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "S\xfchbaatar (Province of Mongolia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "S\xfchbaatar (Province of Mongolia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 77
            },
            {
                "Region Name": "S\xfchbaatar (Province of Mongolia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 86
            }
        ],
        "Sukhothai (Province of Thailand)": [
            {
                "Region Name": "Sukhothai (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sukhothai (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sukhothai (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sukhothai (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sukhothai (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sukhothai (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sukhothai (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sukhothai (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sukhothai (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sukhothai (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Sukhothai (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sukhothai (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sukhothai (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sukhothai (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sukhothai (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sukhothai (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sukhothai (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sukhothai (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sukhothai (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sukhothai (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sukhothai (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sukhothai (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Sulawesi Barat (Province of Indonesia)": [
            {
                "Region Name": "Sulawesi Barat (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sulawesi Barat (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sulawesi Barat (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sulawesi Barat (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sulawesi Barat (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sulawesi Barat (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sulawesi Barat (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sulawesi Barat (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sulawesi Barat (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sulawesi Barat (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sulawesi Barat (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sulawesi Barat (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulawesi Barat (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sulawesi Barat (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sulawesi Barat (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulawesi Barat (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sulawesi Barat (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sulawesi Barat (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sulawesi Barat (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sulawesi Barat (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulawesi Barat (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulawesi Barat (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Sulawesi Selatan (Province of Indonesia)": [
            {
                "Region Name": "Sulawesi Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sulawesi Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sulawesi Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sulawesi Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sulawesi Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sulawesi Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sulawesi Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sulawesi Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sulawesi Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sulawesi Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sulawesi Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sulawesi Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sulawesi Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sulawesi Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sulawesi Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sulawesi Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sulawesi Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sulawesi Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sulawesi Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sulawesi Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sulawesi Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sulawesi Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Sulawesi Tengah (Province of Indonesia)": [
            {
                "Region Name": "Sulawesi Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sulawesi Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sulawesi Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sulawesi Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sulawesi Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sulawesi Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sulawesi Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sulawesi Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sulawesi Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sulawesi Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sulawesi Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sulawesi Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sulawesi Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sulawesi Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sulawesi Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulawesi Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sulawesi Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sulawesi Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sulawesi Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulawesi Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulawesi Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulawesi Tengah (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Sulawesi Tenggara (Province of Indonesia)": [
            {
                "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sulawesi Tenggara (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Sulawesi Utara (Province of Indonesia)": [
            {
                "Region Name": "Sulawesi Utara (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sulawesi Utara (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sulawesi Utara (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sulawesi Utara (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sulawesi Utara (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sulawesi Utara (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sulawesi Utara (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulawesi Utara (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sulawesi Utara (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulawesi Utara (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sulawesi Utara (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Sulawesi Utara (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulawesi Utara (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sulawesi Utara (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sulawesi Utara (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulawesi Utara (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulawesi Utara (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sulawesi Utara (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sulawesi Utara (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulawesi Utara (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulawesi Utara (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulawesi Utara (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sultan Kudarat (Province of Philippines)": [
            {
                "Region Name": "Sultan Kudarat (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sultan Kudarat (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sultan Kudarat (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sultan Kudarat (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sultan Kudarat (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sultan Kudarat (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sultan Kudarat (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sultan Kudarat (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sultan Kudarat (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sultan Kudarat (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sultan Kudarat (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sultan Kudarat (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sultan Kudarat (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sultan Kudarat (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sultan Kudarat (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sultan Kudarat (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sultan Kudarat (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sultan Kudarat (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sultan Kudarat (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sultan Kudarat (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sultan Kudarat (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sultan Kudarat (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Sulu (Province of Philippines)": [
            {
                "Region Name": "Sulu (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulu (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulu (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulu (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulu (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulu (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulu (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulu (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulu (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulu (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulu (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulu (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sulu (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulu (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sulu (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulu (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulu (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulu (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sulu (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulu (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulu (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sulu (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\u0160umadijski (District of Serbia)": [
            {
                "Region Name": "\u0160umadijski (District of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160umadijski (District of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160umadijski (District of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160umadijski (District of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160umadijski (District of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160umadijski (District of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u0160umadijski (District of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160umadijski (District of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160umadijski (District of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160umadijski (District of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160umadijski (District of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160umadijski (District of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160umadijski (District of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160umadijski (District of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160umadijski (District of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160umadijski (District of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160umadijski (District of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160umadijski (District of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160umadijski (District of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160umadijski (District of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160umadijski (District of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160umadijski (District of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sumatera Barat (Province of Indonesia)": [
            {
                "Region Name": "Sumatera Barat (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sumatera Barat (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sumatera Barat (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sumatera Barat (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sumatera Barat (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sumatera Barat (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sumatera Barat (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sumatera Barat (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sumatera Barat (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sumatera Barat (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sumatera Barat (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sumatera Barat (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sumatera Barat (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sumatera Barat (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sumatera Barat (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sumatera Barat (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sumatera Barat (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sumatera Barat (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sumatera Barat (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sumatera Barat (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sumatera Barat (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sumatera Barat (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Sumatera Selatan (Province of Indonesia)": [
            {
                "Region Name": "Sumatera Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sumatera Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sumatera Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sumatera Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sumatera Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sumatera Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sumatera Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sumatera Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sumatera Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sumatera Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sumatera Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sumatera Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sumatera Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sumatera Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sumatera Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sumatera Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sumatera Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sumatera Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Sumatera Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sumatera Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sumatera Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sumatera Selatan (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Sumatera Utara (Province of Indonesia)": [
            {
                "Region Name": "Sumatera Utara (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sumatera Utara (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sumatera Utara (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sumatera Utara (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sumatera Utara (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sumatera Utara (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sumatera Utara (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sumatera Utara (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sumatera Utara (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sumatera Utara (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sumatera Utara (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sumatera Utara (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sumatera Utara (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sumatera Utara (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sumatera Utara (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sumatera Utara (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sumatera Utara (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sumatera Utara (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sumatera Utara (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sumatera Utara (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sumatera Utara (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sumatera Utara (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Sumy (Region of Ukraine)": [
            {
                "Region Name": "Sumy (Region of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sumy (Region of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sumy (Region of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sumy (Region of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sumy (Region of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sumy (Region of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sumy (Region of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sumy (Region of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sumy (Region of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sumy (Region of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sumy (Region of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sumy (Region of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sumy (Region of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sumy (Region of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sumy (Region of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sumy (Region of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sumy (Region of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sumy (Region of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sumy (Region of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sumy (Region of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sumy (Region of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sumy (Region of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Suphan Buri (Province of Thailand)": [
            {
                "Region Name": "Suphan Buri (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Suphan Buri (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Suphan Buri (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Suphan Buri (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Suphan Buri (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Suphan Buri (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Suphan Buri (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Suphan Buri (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Suphan Buri (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Suphan Buri (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Suphan Buri (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Suphan Buri (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Suphan Buri (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Suphan Buri (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Suphan Buri (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Suphan Buri (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Suphan Buri (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Suphan Buri (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Suphan Buri (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Suphan Buri (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Suphan Buri (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Suphan Buri (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Surat Thani (Province of Thailand)": [
            {
                "Region Name": "Surat Thani (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Surat Thani (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Surat Thani (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Surat Thani (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Surat Thani (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surat Thani (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surat Thani (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surat Thani (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surat Thani (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surat Thani (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surat Thani (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surat Thani (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Surat Thani (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Surat Thani (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surat Thani (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surat Thani (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Surat Thani (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surat Thani (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surat Thani (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surat Thani (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surat Thani (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surat Thani (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Surigao del Norte (Province of Philippines)": [
            {
                "Region Name": "Surigao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Surigao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Surigao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Surigao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Norte (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Surigao del Sur (Province of Philippines)": [
            {
                "Region Name": "Surigao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Surigao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surigao del Sur (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Surin (Province of Thailand)": [
            {
                "Region Name": "Surin (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Surin (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Surin (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Surin (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Surin (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Surin (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Surin (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Surin (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Surin (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Surin (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Surin (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Surin (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Surin (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Surin (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Surin (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Surin (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Surin (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Surin (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Surin (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Surin (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Surin (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Surin (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Surt (District of Libya)": [
            {
                "Region Name": "Surt (District of Libya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Surt (District of Libya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surt (District of Libya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surt (District of Libya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surt (District of Libya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surt (District of Libya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surt (District of Libya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surt (District of Libya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surt (District of Libya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surt (District of Libya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Surt (District of Libya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surt (District of Libya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surt (District of Libya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surt (District of Libya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Surt (District of Libya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surt (District of Libya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surt (District of Libya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surt (District of Libya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surt (District of Libya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surt (District of Libya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surt (District of Libya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Surt (District of Libya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Surxondaryo (Region of Uzbekistan)": [
            {
                "Region Name": "Surxondaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Surxondaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Surxondaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Surxondaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Surxondaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Surxondaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Surxondaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Surxondaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Surxondaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Surxondaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Surxondaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Surxondaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Surxondaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Surxondaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Surxondaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Surxondaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Surxondaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Surxondaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Surxondaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Surxondaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Surxondaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Surxondaryo (Region of Uzbekistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "\u0160uto Orizari (Municipality of North Macedonia)": [
            {
                "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u0160uto Orizari (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Svalbard (Territory of Svalbard and Jan Mayen)": [
            {
                "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Svalbard (Territory of Svalbard and Jan Mayen)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Svay Rieng (Province of Cambodia)": [
            {
                "Region Name": "Svay Rieng (Province of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Svay Rieng (Province of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Svay Rieng (Province of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Svay Rieng (Province of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Svay Rieng (Province of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Svay Rieng (Province of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Svay Rieng (Province of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Svay Rieng (Province of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Svay Rieng (Province of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Svay Rieng (Province of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Svay Rieng (Province of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Svay Rieng (Province of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Svay Rieng (Province of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Svay Rieng (Province of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Svay Rieng (Province of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Svay Rieng (Province of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Svay Rieng (Province of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Svay Rieng (Province of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Svay Rieng (Province of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Svay Rieng (Province of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Svay Rieng (Province of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Svay Rieng (Province of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Sverdlovsk (Region of Russia)": [
            {
                "Region Name": "Sverdlovsk (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sverdlovsk (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sverdlovsk (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Sverdlovsk (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sverdlovsk (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sverdlovsk (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sverdlovsk (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sverdlovsk (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sverdlovsk (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Sverdlovsk (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Sverdlovsk (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sverdlovsk (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Sverdlovsk (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sverdlovsk (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sverdlovsk (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Sverdlovsk (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sverdlovsk (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sverdlovsk (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sverdlovsk (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sverdlovsk (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Sverdlovsk (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sverdlovsk (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 22
            }
        ],
        "Sveti Nikole (Municipality of North Macedonia)": [
            {
                "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sveti Nikole (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\u015Awi\u0119tokrzyskie (Voivodeship of Poland)": [
            {
                "Region Name": "\u015Awi\u0119tokrzyskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Awi\u0119tokrzyskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "\u015Awi\u0119tokrzyskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u015Awi\u0119tokrzyskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u015Awi\u0119tokrzyskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Awi\u0119tokrzyskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Awi\u0119tokrzyskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Awi\u0119tokrzyskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Awi\u0119tokrzyskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u015Awi\u0119tokrzyskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "\u015Awi\u0119tokrzyskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Awi\u0119tokrzyskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Awi\u0119tokrzyskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u015Awi\u0119tokrzyskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Awi\u0119tokrzyskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Awi\u0119tokrzyskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Awi\u0119tokrzyskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Awi\u0119tokrzyskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Awi\u0119tokrzyskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Awi\u0119tokrzyskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Awi\u0119tokrzyskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u015Awi\u0119tokrzyskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Syddanmark (Region of Denmark)": [
            {
                "Region Name": "Syddanmark (Region of Denmark)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Syddanmark (Region of Denmark)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Syddanmark (Region of Denmark)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Syddanmark (Region of Denmark)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Syddanmark (Region of Denmark)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Syddanmark (Region of Denmark)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Syddanmark (Region of Denmark)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Syddanmark (Region of Denmark)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Syddanmark (Region of Denmark)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Syddanmark (Region of Denmark)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Syddanmark (Region of Denmark)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Syddanmark (Region of Denmark)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Syddanmark (Region of Denmark)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Syddanmark (Region of Denmark)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Syddanmark (Region of Denmark)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Syddanmark (Region of Denmark)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Syddanmark (Region of Denmark)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Syddanmark (Region of Denmark)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Syddanmark (Region of Denmark)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Syddanmark (Region of Denmark)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Syddanmark (Region of Denmark)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Syddanmark (Region of Denmark)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Sylhet (Division of Bangladesh)": [
            {
                "Region Name": "Sylhet (Division of Bangladesh)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sylhet (Division of Bangladesh)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sylhet (Division of Bangladesh)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Sylhet (Division of Bangladesh)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sylhet (Division of Bangladesh)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sylhet (Division of Bangladesh)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sylhet (Division of Bangladesh)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sylhet (Division of Bangladesh)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Sylhet (Division of Bangladesh)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sylhet (Division of Bangladesh)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Sylhet (Division of Bangladesh)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sylhet (Division of Bangladesh)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sylhet (Division of Bangladesh)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Sylhet (Division of Bangladesh)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Sylhet (Division of Bangladesh)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sylhet (Division of Bangladesh)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sylhet (Division of Bangladesh)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Sylhet (Division of Bangladesh)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sylhet (Division of Bangladesh)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sylhet (Division of Bangladesh)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Sylhet (Division of Bangladesh)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Sylhet (Division of Bangladesh)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Syunik (Province of Armenia)": [
            {
                "Region Name": "Syunik (Province of Armenia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Syunik (Province of Armenia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Syunik (Province of Armenia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Syunik (Province of Armenia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Syunik (Province of Armenia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Syunik (Province of Armenia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Syunik (Province of Armenia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Syunik (Province of Armenia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Syunik (Province of Armenia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Syunik (Province of Armenia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Syunik (Province of Armenia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Syunik (Province of Armenia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Syunik (Province of Armenia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Syunik (Province of Armenia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Syunik (Province of Armenia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Syunik (Province of Armenia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Syunik (Province of Armenia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Syunik (Province of Armenia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Syunik (Province of Armenia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Syunik (Province of Armenia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Syunik (Province of Armenia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Syunik (Province of Armenia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Szabolcs-Szatm\xe1r-Bereg (County of Hungary)": [
            {
                "Region Name": "Szabolcs-Szatm\xe1r-Bereg (County of Hungary)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Szabolcs-Szatm\xe1r-Bereg (County of Hungary)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Szabolcs-Szatm\xe1r-Bereg (County of Hungary)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Szabolcs-Szatm\xe1r-Bereg (County of Hungary)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Szabolcs-Szatm\xe1r-Bereg (County of Hungary)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Szabolcs-Szatm\xe1r-Bereg (County of Hungary)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Szabolcs-Szatm\xe1r-Bereg (County of Hungary)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Szabolcs-Szatm\xe1r-Bereg (County of Hungary)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Szabolcs-Szatm\xe1r-Bereg (County of Hungary)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Szabolcs-Szatm\xe1r-Bereg (County of Hungary)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Szabolcs-Szatm\xe1r-Bereg (County of Hungary)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Szabolcs-Szatm\xe1r-Bereg (County of Hungary)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Szabolcs-Szatm\xe1r-Bereg (County of Hungary)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Szabolcs-Szatm\xe1r-Bereg (County of Hungary)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Szabolcs-Szatm\xe1r-Bereg (County of Hungary)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Szabolcs-Szatm\xe1r-Bereg (County of Hungary)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Szabolcs-Szatm\xe1r-Bereg (County of Hungary)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Szabolcs-Szatm\xe1r-Bereg (County of Hungary)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Szabolcs-Szatm\xe1r-Bereg (County of Hungary)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Szabolcs-Szatm\xe1r-Bereg (County of Hungary)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Szabolcs-Szatm\xe1r-Bereg (County of Hungary)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Szabolcs-Szatm\xe1r-Bereg (County of Hungary)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Ta`izz (Governorate of Yemen)": [
            {
                "Region Name": "Ta`izz (Governorate of Yemen)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ta`izz (Governorate of Yemen)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ta`izz (Governorate of Yemen)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ta`izz (Governorate of Yemen)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ta`izz (Governorate of Yemen)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ta`izz (Governorate of Yemen)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ta`izz (Governorate of Yemen)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ta`izz (Governorate of Yemen)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ta`izz (Governorate of Yemen)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ta`izz (Governorate of Yemen)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ta`izz (Governorate of Yemen)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ta`izz (Governorate of Yemen)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ta`izz (Governorate of Yemen)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ta`izz (Governorate of Yemen)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ta`izz (Governorate of Yemen)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ta`izz (Governorate of Yemen)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ta`izz (Governorate of Yemen)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ta`izz (Governorate of Yemen)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ta`izz (Governorate of Yemen)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ta`izz (Governorate of Yemen)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ta`izz (Governorate of Yemen)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ta`izz (Governorate of Yemen)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tabasco (State of M\xe9xico)": [
            {
                "Region Name": "Tabasco (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tabasco (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tabasco (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tabasco (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tabasco (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tabasco (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tabasco (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tabasco (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tabasco (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tabasco (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tabasco (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tabasco (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tabasco (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tabasco (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tabasco (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tabasco (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tabasco (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tabasco (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tabasco (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tabasco (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tabasco (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tabasco (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Tabora (Region of Tanzania)": [
            {
                "Region Name": "Tabora (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Tabora (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Tabora (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Tabora (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Tabora (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Tabora (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Tabora (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Tabora (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Tabora (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Tabora (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Tabora (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Tabora (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Tabora (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Tabora (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Tabora (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Tabora (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Tabora (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Tabora (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Tabora (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Tabora (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Tabora (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Tabora (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 19
            }
        ],
        "Tabuk (Province of Saudi Arabia)": [
            {
                "Region Name": "Tabuk (Province of Saudi Arabia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tabuk (Province of Saudi Arabia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tabuk (Province of Saudi Arabia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tabuk (Province of Saudi Arabia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tabuk (Province of Saudi Arabia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Tabuk (Province of Saudi Arabia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tabuk (Province of Saudi Arabia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tabuk (Province of Saudi Arabia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tabuk (Province of Saudi Arabia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tabuk (Province of Saudi Arabia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tabuk (Province of Saudi Arabia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tabuk (Province of Saudi Arabia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tabuk (Province of Saudi Arabia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tabuk (Province of Saudi Arabia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tabuk (Province of Saudi Arabia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tabuk (Province of Saudi Arabia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tabuk (Province of Saudi Arabia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tabuk (Province of Saudi Arabia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tabuk (Province of Saudi Arabia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tabuk (Province of Saudi Arabia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tabuk (Province of Saudi Arabia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Tabuk (Province of Saudi Arabia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "T\xe1chira (State of Venezuela)": [
            {
                "Region Name": "T\xe1chira (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "T\xe1chira (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "T\xe1chira (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "T\xe1chira (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "T\xe1chira (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "T\xe1chira (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "T\xe1chira (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "T\xe1chira (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "T\xe1chira (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "T\xe1chira (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "T\xe1chira (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "T\xe1chira (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "T\xe1chira (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "T\xe1chira (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "T\xe1chira (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "T\xe1chira (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "T\xe1chira (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "T\xe1chira (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "T\xe1chira (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "T\xe1chira (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "T\xe1chira (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "T\xe1chira (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tacna (Region of Peru)": [
            {
                "Region Name": "Tacna (Region of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tacna (Region of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tacna (Region of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tacna (Region of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tacna (Region of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tacna (Region of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tacna (Region of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tacna (Region of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tacna (Region of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tacna (Region of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tacna (Region of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tacna (Region of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tacna (Region of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tacna (Region of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tacna (Region of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tacna (Region of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tacna (Region of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tacna (Region of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tacna (Region of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tacna (Region of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tacna (Region of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tacna (Region of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tacuaremb\xf3 (Department of Uruguay)": [
            {
                "Region Name": "Tacuaremb\xf3 (Department of Uruguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tacuaremb\xf3 (Department of Uruguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tacuaremb\xf3 (Department of Uruguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tacuaremb\xf3 (Department of Uruguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tacuaremb\xf3 (Department of Uruguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tacuaremb\xf3 (Department of Uruguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tacuaremb\xf3 (Department of Uruguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tacuaremb\xf3 (Department of Uruguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tacuaremb\xf3 (Department of Uruguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tacuaremb\xf3 (Department of Uruguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tacuaremb\xf3 (Department of Uruguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tacuaremb\xf3 (Department of Uruguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tacuaremb\xf3 (Department of Uruguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tacuaremb\xf3 (Department of Uruguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tacuaremb\xf3 (Department of Uruguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tacuaremb\xf3 (Department of Uruguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tacuaremb\xf3 (Department of Uruguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tacuaremb\xf3 (Department of Uruguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tacuaremb\xf3 (Department of Uruguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tacuaremb\xf3 (Department of Uruguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tacuaremb\xf3 (Department of Uruguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tacuaremb\xf3 (Department of Uruguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Tadjoura (Region of Djibouti)": [
            {
                "Region Name": "Tadjoura (Region of Djibouti)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadjoura (Region of Djibouti)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadjoura (Region of Djibouti)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadjoura (Region of Djibouti)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadjoura (Region of Djibouti)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadjoura (Region of Djibouti)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadjoura (Region of Djibouti)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadjoura (Region of Djibouti)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadjoura (Region of Djibouti)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadjoura (Region of Djibouti)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadjoura (Region of Djibouti)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadjoura (Region of Djibouti)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadjoura (Region of Djibouti)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadjoura (Region of Djibouti)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadjoura (Region of Djibouti)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tadjoura (Region of Djibouti)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadjoura (Region of Djibouti)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadjoura (Region of Djibouti)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadjoura (Region of Djibouti)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadjoura (Region of Djibouti)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadjoura (Region of Djibouti)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tadjoura (Region of Djibouti)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tadla - Azilal (Region of Morocco)": [
            {
                "Region Name": "Tadla - Azilal (Region of Morocco)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadla - Azilal (Region of Morocco)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadla - Azilal (Region of Morocco)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadla - Azilal (Region of Morocco)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadla - Azilal (Region of Morocco)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadla - Azilal (Region of Morocco)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadla - Azilal (Region of Morocco)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tadla - Azilal (Region of Morocco)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tadla - Azilal (Region of Morocco)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadla - Azilal (Region of Morocco)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadla - Azilal (Region of Morocco)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadla - Azilal (Region of Morocco)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadla - Azilal (Region of Morocco)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tadla - Azilal (Region of Morocco)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadla - Azilal (Region of Morocco)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadla - Azilal (Region of Morocco)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tadla - Azilal (Region of Morocco)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadla - Azilal (Region of Morocco)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadla - Azilal (Region of Morocco)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadla - Azilal (Region of Morocco)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadla - Azilal (Region of Morocco)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tadla - Azilal (Region of Morocco)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tafea (Province of Vanuatu)": [
            {
                "Region Name": "Tafea (Province of Vanuatu)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafea (Province of Vanuatu)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafea (Province of Vanuatu)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafea (Province of Vanuatu)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafea (Province of Vanuatu)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafea (Province of Vanuatu)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafea (Province of Vanuatu)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafea (Province of Vanuatu)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafea (Province of Vanuatu)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafea (Province of Vanuatu)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafea (Province of Vanuatu)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafea (Province of Vanuatu)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafea (Province of Vanuatu)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafea (Province of Vanuatu)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tafea (Province of Vanuatu)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafea (Province of Vanuatu)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafea (Province of Vanuatu)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafea (Province of Vanuatu)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafea (Province of Vanuatu)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafea (Province of Vanuatu)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafea (Province of Vanuatu)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafea (Province of Vanuatu)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tafilah (Province of Jordan)": [
            {
                "Region Name": "Tafilah (Province of Jordan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafilah (Province of Jordan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafilah (Province of Jordan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafilah (Province of Jordan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafilah (Province of Jordan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafilah (Province of Jordan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafilah (Province of Jordan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafilah (Province of Jordan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafilah (Province of Jordan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafilah (Province of Jordan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafilah (Province of Jordan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafilah (Province of Jordan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafilah (Province of Jordan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafilah (Province of Jordan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafilah (Province of Jordan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafilah (Province of Jordan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafilah (Province of Jordan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafilah (Province of Jordan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafilah (Province of Jordan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafilah (Province of Jordan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafilah (Province of Jordan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tafilah (Province of Jordan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tagant (Region of Mauritania)": [
            {
                "Region Name": "Tagant (Region of Mauritania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tagant (Region of Mauritania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tagant (Region of Mauritania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tagant (Region of Mauritania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tagant (Region of Mauritania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tagant (Region of Mauritania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tagant (Region of Mauritania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tagant (Region of Mauritania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tagant (Region of Mauritania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tagant (Region of Mauritania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tagant (Region of Mauritania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tagant (Region of Mauritania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tagant (Region of Mauritania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tagant (Region of Mauritania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tagant (Region of Mauritania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tagant (Region of Mauritania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tagant (Region of Mauritania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tagant (Region of Mauritania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tagant (Region of Mauritania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tagant (Region of Mauritania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tagant (Region of Mauritania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tagant (Region of Mauritania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tahoua (Department of Niger)": [
            {
                "Region Name": "Tahoua (Department of Niger)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tahoua (Department of Niger)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tahoua (Department of Niger)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tahoua (Department of Niger)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Tahoua (Department of Niger)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tahoua (Department of Niger)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Tahoua (Department of Niger)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Tahoua (Department of Niger)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tahoua (Department of Niger)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 125
            },
            {
                "Region Name": "Tahoua (Department of Niger)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tahoua (Department of Niger)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tahoua (Department of Niger)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Tahoua (Department of Niger)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Tahoua (Department of Niger)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tahoua (Department of Niger)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tahoua (Department of Niger)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tahoua (Department of Niger)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tahoua (Department of Niger)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tahoua (Department of Niger)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "Tahoua (Department of Niger)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 219
            },
            {
                "Region Name": "Tahoua (Department of Niger)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 85
            },
            {
                "Region Name": "Tahoua (Department of Niger)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 46
            }
        ],
        "Taichung (Special Municipality of Taiwan)": [
            {
                "Region Name": "Taichung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taichung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Taichung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taichung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Taichung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taichung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Taichung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Taichung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Taichung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taichung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taichung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taichung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taichung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taichung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Taichung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taichung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taichung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taichung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Taichung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taichung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taichung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Taichung (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tainan (Special Municipality of Taiwan)": [
            {
                "Region Name": "Tainan (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tainan (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tainan (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tainan (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tainan (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tainan (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tainan (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tainan (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tainan (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tainan (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tainan (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tainan (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tainan (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tainan (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tainan (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tainan (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tainan (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tainan (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tainan (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tainan (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tainan (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tainan (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Taipei (Special Municipality of Taiwan)": [
            {
                "Region Name": "Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taipei (Special Municipality of Taiwan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Taita Taveta (County of Kenya)": [
            {
                "Region Name": "Taita Taveta (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Taita Taveta (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Taita Taveta (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Taita Taveta (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Taita Taveta (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Taita Taveta (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Taita Taveta (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Taita Taveta (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taita Taveta (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Taita Taveta (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Taita Taveta (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Taita Taveta (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Taita Taveta (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Taita Taveta (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Taita Taveta (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Taita Taveta (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Taita Taveta (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Taita Taveta (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taita Taveta (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 66
            },
            {
                "Region Name": "Taita Taveta (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Taita Taveta (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Taita Taveta (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Taiwan (Province of Taiwan)": [
            {
                "Region Name": "Taiwan (Province of Taiwan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taiwan (Province of Taiwan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Taiwan (Province of Taiwan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Taiwan (Province of Taiwan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Taiwan (Province of Taiwan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taiwan (Province of Taiwan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taiwan (Province of Taiwan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Taiwan (Province of Taiwan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Taiwan (Province of Taiwan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Taiwan (Province of Taiwan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taiwan (Province of Taiwan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taiwan (Province of Taiwan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Taiwan (Province of Taiwan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taiwan (Province of Taiwan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Taiwan (Province of Taiwan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Taiwan (Province of Taiwan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taiwan (Province of Taiwan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taiwan (Province of Taiwan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Taiwan (Province of Taiwan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taiwan (Province of Taiwan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Taiwan (Province of Taiwan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Taiwan (Province of Taiwan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tak (Province of Thailand)": [
            {
                "Region Name": "Tak (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Tak (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tak (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tak (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tak (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tak (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tak (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tak (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tak (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tak (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tak (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tak (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tak (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tak (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tak (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tak (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tak (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tak (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tak (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tak (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tak (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tak (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Takamaka (District of Seychelles)": [
            {
                "Region Name": "Takamaka (District of Seychelles)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takamaka (District of Seychelles)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takamaka (District of Seychelles)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takamaka (District of Seychelles)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takamaka (District of Seychelles)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takamaka (District of Seychelles)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takamaka (District of Seychelles)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takamaka (District of Seychelles)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takamaka (District of Seychelles)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takamaka (District of Seychelles)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takamaka (District of Seychelles)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takamaka (District of Seychelles)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takamaka (District of Seychelles)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takamaka (District of Seychelles)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takamaka (District of Seychelles)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takamaka (District of Seychelles)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takamaka (District of Seychelles)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takamaka (District of Seychelles)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takamaka (District of Seychelles)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takamaka (District of Seychelles)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takamaka (District of Seychelles)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takamaka (District of Seychelles)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tak\xe9 (Province of Cambodia)": [
            {
                "Region Name": "Tak\xe9 (Province of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tak\xe9 (Province of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tak\xe9 (Province of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Tak\xe9 (Province of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tak\xe9 (Province of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tak\xe9 (Province of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tak\xe9 (Province of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tak\xe9 (Province of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tak\xe9 (Province of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Tak\xe9 (Province of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Tak\xe9 (Province of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Tak\xe9 (Province of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tak\xe9 (Province of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tak\xe9 (Province of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tak\xe9 (Province of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Tak\xe9 (Province of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tak\xe9 (Province of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tak\xe9 (Province of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tak\xe9 (Province of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tak\xe9 (Province of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tak\xe9 (Province of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tak\xe9 (Province of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 19
            }
        ],
        "Takhar (Province of Afghanistan)": [
            {
                "Region Name": "Takhar (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Takhar (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Takhar (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takhar (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takhar (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Takhar (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takhar (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Takhar (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takhar (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takhar (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takhar (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takhar (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takhar (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takhar (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Takhar (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takhar (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takhar (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takhar (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Takhar (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takhar (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takhar (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Takhar (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Talas (Province of Kyrgyzstan)": [
            {
                "Region Name": "Talas (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Talas (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Talas (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Talas (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Talas (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Talas (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Talas (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Talas (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talas (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Talas (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talas (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Talas (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Talas (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talas (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Talas (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Talas (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talas (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Talas (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talas (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Talas (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talas (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talas (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Talofofo (Municipality of Guam)": [
            {
                "Region Name": "Talofofo (Municipality of Guam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talofofo (Municipality of Guam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talofofo (Municipality of Guam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talofofo (Municipality of Guam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talofofo (Municipality of Guam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talofofo (Municipality of Guam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talofofo (Municipality of Guam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talofofo (Municipality of Guam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talofofo (Municipality of Guam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talofofo (Municipality of Guam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talofofo (Municipality of Guam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talofofo (Municipality of Guam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talofofo (Municipality of Guam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talofofo (Municipality of Guam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talofofo (Municipality of Guam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talofofo (Municipality of Guam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talofofo (Municipality of Guam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talofofo (Municipality of Guam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talofofo (Municipality of Guam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talofofo (Municipality of Guam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talofofo (Municipality of Guam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Talofofo (Municipality of Guam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tamanghasset (Province of Algeria)": [
            {
                "Region Name": "Tamanghasset (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tamanghasset (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamanghasset (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamanghasset (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamanghasset (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamanghasset (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamanghasset (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamanghasset (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamanghasset (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamanghasset (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamanghasset (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamanghasset (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamanghasset (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamanghasset (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamanghasset (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamanghasset (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamanghasset (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamanghasset (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamanghasset (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamanghasset (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamanghasset (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamanghasset (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tamaulipas (State of M\xe9xico)": [
            {
                "Region Name": "Tamaulipas (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tamaulipas (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tamaulipas (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tamaulipas (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tamaulipas (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tamaulipas (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tamaulipas (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tamaulipas (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tamaulipas (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tamaulipas (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tamaulipas (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tamaulipas (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tamaulipas (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tamaulipas (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tamaulipas (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tamaulipas (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tamaulipas (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tamaulipas (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tamaulipas (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tamaulipas (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tamaulipas (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tamaulipas (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Tambacounda (Region of Senegal)": [
            {
                "Region Name": "Tambacounda (Region of Senegal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "Tambacounda (Region of Senegal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Tambacounda (Region of Senegal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Tambacounda (Region of Senegal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Tambacounda (Region of Senegal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Tambacounda (Region of Senegal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Tambacounda (Region of Senegal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Tambacounda (Region of Senegal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Tambacounda (Region of Senegal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Tambacounda (Region of Senegal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Tambacounda (Region of Senegal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Tambacounda (Region of Senegal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Tambacounda (Region of Senegal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Tambacounda (Region of Senegal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Tambacounda (Region of Senegal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Tambacounda (Region of Senegal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Tambacounda (Region of Senegal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Tambacounda (Region of Senegal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Tambacounda (Region of Senegal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Tambacounda (Region of Senegal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Tambacounda (Region of Senegal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Tambacounda (Region of Senegal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 27
            }
        ],
        "Tambov (Region of Russia)": [
            {
                "Region Name": "Tambov (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tambov (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tambov (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tambov (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tambov (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tambov (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tambov (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tambov (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tambov (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tambov (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tambov (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tambov (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tambov (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tambov (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tambov (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tambov (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tambov (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tambov (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tambov (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tambov (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tambov (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tambov (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Tamil Nadu (State of India)": [
            {
                "Region Name": "Tamil Nadu (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tamil Nadu (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tamil Nadu (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tamil Nadu (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tamil Nadu (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tamil Nadu (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tamil Nadu (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tamil Nadu (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tamil Nadu (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tamil Nadu (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tamil Nadu (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tamil Nadu (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tamil Nadu (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tamil Nadu (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tamil Nadu (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tamil Nadu (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tamil Nadu (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tamil Nadu (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tamil Nadu (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tamil Nadu (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tamil Nadu (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tamil Nadu (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Tamuning (Municipality of Guam)": [
            {
                "Region Name": "Tamuning (Municipality of Guam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamuning (Municipality of Guam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamuning (Municipality of Guam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamuning (Municipality of Guam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamuning (Municipality of Guam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamuning (Municipality of Guam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamuning (Municipality of Guam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamuning (Municipality of Guam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamuning (Municipality of Guam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamuning (Municipality of Guam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamuning (Municipality of Guam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamuning (Municipality of Guam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamuning (Municipality of Guam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamuning (Municipality of Guam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamuning (Municipality of Guam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamuning (Municipality of Guam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamuning (Municipality of Guam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamuning (Municipality of Guam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamuning (Municipality of Guam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamuning (Municipality of Guam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamuning (Municipality of Guam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tamuning (Municipality of Guam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tana River (County of Kenya)": [
            {
                "Region Name": "Tana River (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tana River (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tana River (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tana River (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tana River (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tana River (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tana River (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tana River (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tana River (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tana River (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tana River (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tana River (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tana River (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tana River (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tana River (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tana River (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tana River (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tana River (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tana River (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Tana River (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tana River (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tana River (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tandjil\xe9 (Region of Chad)": [
            {
                "Region Name": "Tandjil\xe9 (Region of Chad)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Tandjil\xe9 (Region of Chad)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Tandjil\xe9 (Region of Chad)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Tandjil\xe9 (Region of Chad)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Tandjil\xe9 (Region of Chad)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Tandjil\xe9 (Region of Chad)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tandjil\xe9 (Region of Chad)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tandjil\xe9 (Region of Chad)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Tandjil\xe9 (Region of Chad)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Tandjil\xe9 (Region of Chad)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tandjil\xe9 (Region of Chad)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tandjil\xe9 (Region of Chad)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tandjil\xe9 (Region of Chad)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tandjil\xe9 (Region of Chad)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tandjil\xe9 (Region of Chad)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Tandjil\xe9 (Region of Chad)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Tandjil\xe9 (Region of Chad)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tandjil\xe9 (Region of Chad)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tandjil\xe9 (Region of Chad)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tandjil\xe9 (Region of Chad)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tandjil\xe9 (Region of Chad)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tandjil\xe9 (Region of Chad)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Tanga (Region of Tanzania)": [
            {
                "Region Name": "Tanga (Region of Tanzania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tanga (Region of Tanzania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tanga (Region of Tanzania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tanga (Region of Tanzania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tanga (Region of Tanzania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tanga (Region of Tanzania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tanga (Region of Tanzania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tanga (Region of Tanzania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tanga (Region of Tanzania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tanga (Region of Tanzania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tanga (Region of Tanzania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tanga (Region of Tanzania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tanga (Region of Tanzania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tanga (Region of Tanzania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tanga (Region of Tanzania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tanga (Region of Tanzania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tanga (Region of Tanzania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tanga (Region of Tanzania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tanga (Region of Tanzania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tanga (Region of Tanzania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tanga (Region of Tanzania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tanga (Region of Tanzania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Tanganyika (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Tanganyika (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "Tanger - T\xe9touan (Region of Morocco)": [
            {
                "Region Name": "Tanger - T\xe9touan (Region of Morocco)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tanger - T\xe9touan (Region of Morocco)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tanger - T\xe9touan (Region of Morocco)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Tanger - T\xe9touan (Region of Morocco)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tanger - T\xe9touan (Region of Morocco)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tanger - T\xe9touan (Region of Morocco)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tanger - T\xe9touan (Region of Morocco)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tanger - T\xe9touan (Region of Morocco)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tanger - T\xe9touan (Region of Morocco)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tanger - T\xe9touan (Region of Morocco)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tanger - T\xe9touan (Region of Morocco)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Tanger - T\xe9touan (Region of Morocco)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tanger - T\xe9touan (Region of Morocco)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tanger - T\xe9touan (Region of Morocco)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tanger - T\xe9touan (Region of Morocco)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tanger - T\xe9touan (Region of Morocco)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tanger - T\xe9touan (Region of Morocco)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tanger - T\xe9touan (Region of Morocco)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Tanger - T\xe9touan (Region of Morocco)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Tanger - T\xe9touan (Region of Morocco)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Tanger - T\xe9touan (Region of Morocco)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 115
            },
            {
                "Region Name": "Tanger - T\xe9touan (Region of Morocco)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Tanintharyi (Division of Myanmar)": [
            {
                "Region Name": "Tanintharyi (Division of Myanmar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tanintharyi (Division of Myanmar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tanintharyi (Division of Myanmar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tanintharyi (Division of Myanmar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tanintharyi (Division of Myanmar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tanintharyi (Division of Myanmar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tanintharyi (Division of Myanmar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tanintharyi (Division of Myanmar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tanintharyi (Division of Myanmar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tanintharyi (Division of Myanmar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tanintharyi (Division of Myanmar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tanintharyi (Division of Myanmar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tanintharyi (Division of Myanmar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tanintharyi (Division of Myanmar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tanintharyi (Division of Myanmar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tanintharyi (Division of Myanmar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tanintharyi (Division of Myanmar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tanintharyi (Division of Myanmar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tanintharyi (Division of Myanmar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tanintharyi (Division of Myanmar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tanintharyi (Division of Myanmar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tanintharyi (Division of Myanmar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Taraba (State of Nigeria)": [
            {
                "Region Name": "Taraba (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Taraba (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Taraba (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Taraba (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Taraba (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Taraba (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Taraba (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Taraba (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Taraba (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Taraba (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Taraba (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Taraba (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Taraba (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Taraba (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Taraba (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Taraba (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Taraba (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Taraba (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Taraba (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Taraba (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Taraba (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Taraba (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Taraclia (District of Moldova)": [
            {
                "Region Name": "Taraclia (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Taraclia (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Taraclia (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Taraclia (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Taraclia (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Taraclia (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Taraclia (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Taraclia (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Taraclia (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Taraclia (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Taraclia (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Taraclia (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Taraclia (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Taraclia (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Taraclia (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Taraclia (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Taraclia (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Taraclia (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Taraclia (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Taraclia (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Taraclia (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taraclia (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Taranaki (Region of New Zealand)": [
            {
                "Region Name": "Taranaki (Region of New Zealand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taranaki (Region of New Zealand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taranaki (Region of New Zealand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taranaki (Region of New Zealand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taranaki (Region of New Zealand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taranaki (Region of New Zealand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taranaki (Region of New Zealand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taranaki (Region of New Zealand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taranaki (Region of New Zealand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taranaki (Region of New Zealand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taranaki (Region of New Zealand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taranaki (Region of New Zealand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taranaki (Region of New Zealand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taranaki (Region of New Zealand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taranaki (Region of New Zealand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taranaki (Region of New Zealand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taranaki (Region of New Zealand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taranaki (Region of New Zealand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taranaki (Region of New Zealand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taranaki (Region of New Zealand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taranaki (Region of New Zealand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taranaki (Region of New Zealand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tarapac\xe1 (Region of Chile)": [
            {
                "Region Name": "Tarapac\xe1 (Region of Chile)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarapac\xe1 (Region of Chile)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarapac\xe1 (Region of Chile)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarapac\xe1 (Region of Chile)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarapac\xe1 (Region of Chile)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarapac\xe1 (Region of Chile)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarapac\xe1 (Region of Chile)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarapac\xe1 (Region of Chile)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarapac\xe1 (Region of Chile)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarapac\xe1 (Region of Chile)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarapac\xe1 (Region of Chile)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarapac\xe1 (Region of Chile)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarapac\xe1 (Region of Chile)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tarapac\xe1 (Region of Chile)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarapac\xe1 (Region of Chile)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarapac\xe1 (Region of Chile)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarapac\xe1 (Region of Chile)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarapac\xe1 (Region of Chile)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarapac\xe1 (Region of Chile)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarapac\xe1 (Region of Chile)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tarapac\xe1 (Region of Chile)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarapac\xe1 (Region of Chile)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Targovishte (Province of Bulgaria)": [
            {
                "Region Name": "Targovishte (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Targovishte (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Targovishte (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Targovishte (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Targovishte (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Targovishte (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Targovishte (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Targovishte (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Targovishte (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Targovishte (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Targovishte (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Targovishte (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Targovishte (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Targovishte (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Targovishte (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Targovishte (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Targovishte (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Targovishte (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Targovishte (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Targovishte (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Targovishte (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Targovishte (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tarija (Department of Bolivia)": [
            {
                "Region Name": "Tarija (Department of Bolivia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tarija (Department of Bolivia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tarija (Department of Bolivia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tarija (Department of Bolivia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tarija (Department of Bolivia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tarija (Department of Bolivia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tarija (Department of Bolivia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tarija (Department of Bolivia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tarija (Department of Bolivia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tarija (Department of Bolivia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tarija (Department of Bolivia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tarija (Department of Bolivia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tarija (Department of Bolivia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tarija (Department of Bolivia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tarija (Department of Bolivia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tarija (Department of Bolivia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Tarija (Department of Bolivia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tarija (Department of Bolivia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tarija (Department of Bolivia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tarija (Department of Bolivia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tarija (Department of Bolivia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tarija (Department of Bolivia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Tarlac (Province of Philippines)": [
            {
                "Region Name": "Tarlac (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tarlac (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tarlac (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tarlac (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tarlac (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tarlac (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tarlac (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tarlac (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tarlac (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tarlac (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tarlac (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tarlac (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tarlac (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tarlac (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tarlac (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tarlac (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tarlac (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tarlac (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tarlac (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tarlac (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tarlac (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tarlac (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Tarrafal (County of Cabo Verde)": [
            {
                "Region Name": "Tarrafal (County of Cabo Verde)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal (County of Cabo Verde)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal (County of Cabo Verde)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal (County of Cabo Verde)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal (County of Cabo Verde)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal (County of Cabo Verde)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal (County of Cabo Verde)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal (County of Cabo Verde)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal (County of Cabo Verde)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal (County of Cabo Verde)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal (County of Cabo Verde)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal (County of Cabo Verde)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal (County of Cabo Verde)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal (County of Cabo Verde)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal (County of Cabo Verde)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal (County of Cabo Verde)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal (County of Cabo Verde)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal (County of Cabo Verde)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal (County of Cabo Verde)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal (County of Cabo Verde)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal (County of Cabo Verde)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal (County of Cabo Verde)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Tarrafal de S\xe3o Nicolau (County of Cabo Verde)": [
            {
                "Region Name": "Tarrafal de S\xe3o Nicolau (County of Cabo Verde)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal de S\xe3o Nicolau (County of Cabo Verde)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal de S\xe3o Nicolau (County of Cabo Verde)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal de S\xe3o Nicolau (County of Cabo Verde)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal de S\xe3o Nicolau (County of Cabo Verde)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal de S\xe3o Nicolau (County of Cabo Verde)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal de S\xe3o Nicolau (County of Cabo Verde)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal de S\xe3o Nicolau (County of Cabo Verde)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal de S\xe3o Nicolau (County of Cabo Verde)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal de S\xe3o Nicolau (County of Cabo Verde)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal de S\xe3o Nicolau (County of Cabo Verde)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal de S\xe3o Nicolau (County of Cabo Verde)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal de S\xe3o Nicolau (County of Cabo Verde)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal de S\xe3o Nicolau (County of Cabo Verde)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal de S\xe3o Nicolau (County of Cabo Verde)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal de S\xe3o Nicolau (County of Cabo Verde)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal de S\xe3o Nicolau (County of Cabo Verde)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal de S\xe3o Nicolau (County of Cabo Verde)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal de S\xe3o Nicolau (County of Cabo Verde)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal de S\xe3o Nicolau (County of Cabo Verde)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal de S\xe3o Nicolau (County of Cabo Verde)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tarrafal de S\xe3o Nicolau (County of Cabo Verde)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tartu (County of Estonia)": [
            {
                "Region Name": "Tartu (County of Estonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tartu (County of Estonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartu (County of Estonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartu (County of Estonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartu (County of Estonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tartu (County of Estonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartu (County of Estonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartu (County of Estonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartu (County of Estonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tartu (County of Estonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartu (County of Estonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartu (County of Estonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartu (County of Estonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartu (County of Estonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartu (County of Estonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartu (County of Estonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartu (County of Estonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartu (County of Estonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartu (County of Estonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tartu (County of Estonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartu (County of Estonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tartu (County of Estonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tartus (Governorate of Syria)": [
            {
                "Region Name": "Tartus (Governorate of Syria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartus (Governorate of Syria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartus (Governorate of Syria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartus (Governorate of Syria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartus (Governorate of Syria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartus (Governorate of Syria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartus (Governorate of Syria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartus (Governorate of Syria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartus (Governorate of Syria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartus (Governorate of Syria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartus (Governorate of Syria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartus (Governorate of Syria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tartus (Governorate of Syria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartus (Governorate of Syria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartus (Governorate of Syria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartus (Governorate of Syria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartus (Governorate of Syria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartus (Governorate of Syria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartus (Governorate of Syria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tartus (Governorate of Syria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartus (Governorate of Syria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tartus (Governorate of Syria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tasman (Region of New Zealand)": [
            {
                "Region Name": "Tasman (Region of New Zealand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tasman (Region of New Zealand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tasman (Region of New Zealand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tasman (Region of New Zealand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tasman (Region of New Zealand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tasman (Region of New Zealand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tasman (Region of New Zealand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tasman (Region of New Zealand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tasman (Region of New Zealand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tasman (Region of New Zealand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tasman (Region of New Zealand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tasman (Region of New Zealand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tasman (Region of New Zealand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tasman (Region of New Zealand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tasman (Region of New Zealand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tasman (Region of New Zealand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tasman (Region of New Zealand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Tasman (Region of New Zealand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tasman (Region of New Zealand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tasman (Region of New Zealand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tasman (Region of New Zealand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tasman (Region of New Zealand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tasmania (State of Australia)": [
            {
                "Region Name": "Tasmania (State of Australia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Tasmania (State of Australia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Tasmania (State of Australia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Tasmania (State of Australia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Tasmania (State of Australia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 131
            },
            {
                "Region Name": "Tasmania (State of Australia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Tasmania (State of Australia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Tasmania (State of Australia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Tasmania (State of Australia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tasmania (State of Australia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Tasmania (State of Australia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "Tasmania (State of Australia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Tasmania (State of Australia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Tasmania (State of Australia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Tasmania (State of Australia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 104
            },
            {
                "Region Name": "Tasmania (State of Australia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Tasmania (State of Australia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 70
            },
            {
                "Region Name": "Tasmania (State of Australia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Tasmania (State of Australia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tasmania (State of Australia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tasmania (State of Australia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tasmania (State of Australia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 30
            }
        ],
        "Tataouine (Governorate of Tunisia)": [
            {
                "Region Name": "Tataouine (Governorate of Tunisia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tataouine (Governorate of Tunisia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tataouine (Governorate of Tunisia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tataouine (Governorate of Tunisia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tataouine (Governorate of Tunisia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tataouine (Governorate of Tunisia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tataouine (Governorate of Tunisia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tataouine (Governorate of Tunisia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tataouine (Governorate of Tunisia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tataouine (Governorate of Tunisia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tataouine (Governorate of Tunisia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tataouine (Governorate of Tunisia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tataouine (Governorate of Tunisia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tataouine (Governorate of Tunisia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tataouine (Governorate of Tunisia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tataouine (Governorate of Tunisia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tataouine (Governorate of Tunisia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tataouine (Governorate of Tunisia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tataouine (Governorate of Tunisia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tataouine (Governorate of Tunisia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tataouine (Governorate of Tunisia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tataouine (Governorate of Tunisia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tatarstan (Republic of Russia)": [
            {
                "Region Name": "Tatarstan (Republic of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tatarstan (Republic of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tatarstan (Republic of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tatarstan (Republic of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tatarstan (Republic of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tatarstan (Republic of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tatarstan (Republic of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tatarstan (Republic of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tatarstan (Republic of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tatarstan (Republic of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tatarstan (Republic of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tatarstan (Republic of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tatarstan (Republic of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tatarstan (Republic of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tatarstan (Republic of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tatarstan (Republic of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tatarstan (Republic of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tatarstan (Republic of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tatarstan (Republic of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tatarstan (Republic of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tatarstan (Republic of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tatarstan (Republic of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Taurages (County of Lithuania)": [
            {
                "Region Name": "Taurages (County of Lithuania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taurages (County of Lithuania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Taurages (County of Lithuania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taurages (County of Lithuania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taurages (County of Lithuania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taurages (County of Lithuania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taurages (County of Lithuania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taurages (County of Lithuania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taurages (County of Lithuania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taurages (County of Lithuania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taurages (County of Lithuania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taurages (County of Lithuania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taurages (County of Lithuania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taurages (County of Lithuania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taurages (County of Lithuania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taurages (County of Lithuania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taurages (County of Lithuania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taurages (County of Lithuania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taurages (County of Lithuania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taurages (County of Lithuania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taurages (County of Lithuania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taurages (County of Lithuania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tavush (Province of Armenia)": [
            {
                "Region Name": "Tavush (Province of Armenia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tavush (Province of Armenia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tavush (Province of Armenia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tavush (Province of Armenia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tavush (Province of Armenia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Tavush (Province of Armenia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tavush (Province of Armenia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tavush (Province of Armenia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tavush (Province of Armenia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Tavush (Province of Armenia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tavush (Province of Armenia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tavush (Province of Armenia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tavush (Province of Armenia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tavush (Province of Armenia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tavush (Province of Armenia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tavush (Province of Armenia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tavush (Province of Armenia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tavush (Province of Armenia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tavush (Province of Armenia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tavush (Province of Armenia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tavush (Province of Armenia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tavush (Province of Armenia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Tawi-Tawi (Province of Philippines)": [
            {
                "Region Name": "Tawi-Tawi (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tawi-Tawi (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tawi-Tawi (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tawi-Tawi (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tawi-Tawi (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tawi-Tawi (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tawi-Tawi (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tawi-Tawi (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tawi-Tawi (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tawi-Tawi (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tawi-Tawi (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tawi-Tawi (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tawi-Tawi (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tawi-Tawi (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tawi-Tawi (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tawi-Tawi (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tawi-Tawi (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tawi-Tawi (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tawi-Tawi (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tawi-Tawi (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tawi-Tawi (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tawi-Tawi (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "T\xe2y Ninh (Province of Vietnam)": [
            {
                "Region Name": "T\xe2y Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "T\xe2y Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "T\xe2y Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "T\xe2y Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "T\xe2y Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "T\xe2y Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "T\xe2y Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "T\xe2y Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "T\xe2y Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "T\xe2y Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "T\xe2y Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "T\xe2y Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "T\xe2y Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "T\xe2y Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "T\xe2y Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "T\xe2y Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "T\xe2y Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "T\xe2y Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "T\xe2y Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "T\xe2y Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "T\xe2y Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "T\xe2y Ninh (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Taza - Al Hoceima - Taounate (Region of Morocco)": [
            {
                "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Taza - Al Hoceima - Taounate (Region of Morocco)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Tbilisi (Independent City of Georgia)": [
            {
                "Region Name": "Tbilisi (Independent City of Georgia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tbilisi (Independent City of Georgia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tbilisi (Independent City of Georgia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tbilisi (Independent City of Georgia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tbilisi (Independent City of Georgia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tbilisi (Independent City of Georgia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tbilisi (Independent City of Georgia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tbilisi (Independent City of Georgia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tbilisi (Independent City of Georgia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tbilisi (Independent City of Georgia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tbilisi (Independent City of Georgia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tbilisi (Independent City of Georgia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tbilisi (Independent City of Georgia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tbilisi (Independent City of Georgia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tbilisi (Independent City of Georgia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tbilisi (Independent City of Georgia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tbilisi (Independent City of Georgia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tbilisi (Independent City of Georgia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tbilisi (Independent City of Georgia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tbilisi (Independent City of Georgia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tbilisi (Independent City of Georgia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tbilisi (Independent City of Georgia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tbong Khmum (Province of Cambodia)": [
            {
                "Region Name": "Tbong Khmum (Province of Cambodia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tbong Khmum (Province of Cambodia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tbong Khmum (Province of Cambodia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tbong Khmum (Province of Cambodia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tbong Khmum (Province of Cambodia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tbong Khmum (Province of Cambodia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tbong Khmum (Province of Cambodia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tbong Khmum (Province of Cambodia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tbong Khmum (Province of Cambodia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tbong Khmum (Province of Cambodia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tbong Khmum (Province of Cambodia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tbong Khmum (Province of Cambodia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tbong Khmum (Province of Cambodia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tbong Khmum (Province of Cambodia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tbong Khmum (Province of Cambodia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tbong Khmum (Province of Cambodia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tbong Khmum (Province of Cambodia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tbong Khmum (Province of Cambodia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tbong Khmum (Province of Cambodia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tbong Khmum (Province of Cambodia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tbong Khmum (Province of Cambodia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tbong Khmum (Province of Cambodia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Tearce (Municipality of North Macedonia)": [
            {
                "Region Name": "Tearce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tearce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tearce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tearce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tearce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tearce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tearce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tearce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tearce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tearce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tearce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tearce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tearce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tearce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tearce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tearce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tearce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tearce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tearce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tearce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tearce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tearce (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "T\xe9bessa (Province of Algeria)": [
            {
                "Region Name": "T\xe9bessa (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "T\xe9bessa (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "T\xe9bessa (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "T\xe9bessa (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "T\xe9bessa (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "T\xe9bessa (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "T\xe9bessa (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "T\xe9bessa (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "T\xe9bessa (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "T\xe9bessa (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "T\xe9bessa (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "T\xe9bessa (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "T\xe9bessa (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "T\xe9bessa (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "T\xe9bessa (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "T\xe9bessa (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "T\xe9bessa (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "T\xe9bessa (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "T\xe9bessa (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "T\xe9bessa (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "T\xe9bessa (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "T\xe9bessa (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tehran (Province of Iran)": [
            {
                "Region Name": "Tehran (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tehran (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tehran (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tehran (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tehran (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tehran (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tehran (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tehran (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tehran (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tehran (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tehran (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tehran (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tehran (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tehran (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tehran (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Tehran (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tehran (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tehran (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tehran (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tehran (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tehran (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tehran (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Tekirdag (Province of Turkey)": [
            {
                "Region Name": "Tekirdag (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tekirdag (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tekirdag (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tekirdag (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tekirdag (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tekirdag (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tekirdag (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tekirdag (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tekirdag (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tekirdag (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tekirdag (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tekirdag (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tekirdag (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tekirdag (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tekirdag (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tekirdag (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tekirdag (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tekirdag (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tekirdag (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tekirdag (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tekirdag (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tekirdag (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Tel Aviv (District of Israel)": [
            {
                "Region Name": "Tel Aviv (District of Israel)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel Aviv (District of Israel)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel Aviv (District of Israel)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel Aviv (District of Israel)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel Aviv (District of Israel)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel Aviv (District of Israel)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel Aviv (District of Israel)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel Aviv (District of Israel)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel Aviv (District of Israel)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel Aviv (District of Israel)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel Aviv (District of Israel)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel Aviv (District of Israel)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel Aviv (District of Israel)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel Aviv (District of Israel)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel Aviv (District of Israel)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel Aviv (District of Israel)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel Aviv (District of Israel)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel Aviv (District of Israel)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel Aviv (District of Israel)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel Aviv (District of Israel)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel Aviv (District of Israel)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel Aviv (District of Israel)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Telangana (State of India)": [
            {
                "Region Name": "Telangana (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Telangana (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Telangana (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Telangana (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Telangana (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Telangana (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Telangana (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Telangana (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Telangana (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Telangana (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Telangana (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Telangana (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Telangana (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Telangana (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Telangana (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Telangana (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Telangana (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Telangana (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Telangana (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Telangana (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Telangana (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Telangana (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 15
            }
        ],
        "Telemark (County of Norway)": [
            {
                "Region Name": "Telemark (County of Norway)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telemark (County of Norway)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telemark (County of Norway)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telemark (County of Norway)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telemark (County of Norway)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telemark (County of Norway)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telemark (County of Norway)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telemark (County of Norway)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telemark (County of Norway)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telemark (County of Norway)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telemark (County of Norway)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telemark (County of Norway)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telemark (County of Norway)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telemark (County of Norway)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telemark (County of Norway)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telemark (County of Norway)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telemark (County of Norway)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telemark (County of Norway)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telemark (County of Norway)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telemark (County of Norway)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telemark (County of Norway)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telemark (County of Norway)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Telene\u0219ti (District of Moldova)": [
            {
                "Region Name": "Telene\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telene\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telene\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telene\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telene\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telene\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telene\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Telene\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telene\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telene\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Telene\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telene\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Telene\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Telene\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telene\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Telene\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telene\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telene\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telene\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telene\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Telene\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Telene\u0219ti (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Teleorman (County of Romania)": [
            {
                "Region Name": "Teleorman (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Teleorman (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Teleorman (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Teleorman (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Teleorman (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Teleorman (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Teleorman (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Teleorman (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Teleorman (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Teleorman (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Teleorman (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Teleorman (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Teleorman (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Teleorman (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Teleorman (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Teleorman (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Teleorman (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Teleorman (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Teleorman (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Teleorman (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Teleorman (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Teleorman (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Tel\u0161iai (County of Lithuania)": [
            {
                "Region Name": "Tel\u0161iai (County of Lithuania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel\u0161iai (County of Lithuania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel\u0161iai (County of Lithuania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel\u0161iai (County of Lithuania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel\u0161iai (County of Lithuania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel\u0161iai (County of Lithuania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel\u0161iai (County of Lithuania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel\u0161iai (County of Lithuania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel\u0161iai (County of Lithuania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel\u0161iai (County of Lithuania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel\u0161iai (County of Lithuania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel\u0161iai (County of Lithuania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel\u0161iai (County of Lithuania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel\u0161iai (County of Lithuania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel\u0161iai (County of Lithuania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel\u0161iai (County of Lithuania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel\u0161iai (County of Lithuania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel\u0161iai (County of Lithuania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel\u0161iai (County of Lithuania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel\u0161iai (County of Lithuania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel\u0161iai (County of Lithuania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tel\u0161iai (County of Lithuania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Temburong (District of Brunei)": [
            {
                "Region Name": "Temburong (District of Brunei)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temburong (District of Brunei)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temburong (District of Brunei)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Temburong (District of Brunei)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temburong (District of Brunei)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temburong (District of Brunei)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temburong (District of Brunei)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temburong (District of Brunei)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Temburong (District of Brunei)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temburong (District of Brunei)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temburong (District of Brunei)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temburong (District of Brunei)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temburong (District of Brunei)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temburong (District of Brunei)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temburong (District of Brunei)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temburong (District of Brunei)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temburong (District of Brunei)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temburong (District of Brunei)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temburong (District of Brunei)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temburong (District of Brunei)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temburong (District of Brunei)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temburong (District of Brunei)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Temotu (Province of Solomon Islands)": [
            {
                "Region Name": "Temotu (Province of Solomon Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temotu (Province of Solomon Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temotu (Province of Solomon Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temotu (Province of Solomon Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temotu (Province of Solomon Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temotu (Province of Solomon Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temotu (Province of Solomon Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temotu (Province of Solomon Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temotu (Province of Solomon Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temotu (Province of Solomon Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temotu (Province of Solomon Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temotu (Province of Solomon Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temotu (Province of Solomon Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temotu (Province of Solomon Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temotu (Province of Solomon Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temotu (Province of Solomon Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temotu (Province of Solomon Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temotu (Province of Solomon Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temotu (Province of Solomon Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temotu (Province of Solomon Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temotu (Province of Solomon Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Temotu (Province of Solomon Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tennessee (State of United States)": [
            {
                "Region Name": "Tennessee (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tennessee (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tennessee (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tennessee (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tennessee (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tennessee (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tennessee (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tennessee (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tennessee (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tennessee (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tennessee (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tennessee (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tennessee (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tennessee (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tennessee (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tennessee (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tennessee (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tennessee (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tennessee (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tennessee (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tennessee (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Tennessee (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Ternopil' (Region of Ukraine)": [
            {
                "Region Name": "Ternopil' (Region of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ternopil' (Region of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ternopil' (Region of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ternopil' (Region of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ternopil' (Region of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ternopil' (Region of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ternopil' (Region of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ternopil' (Region of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ternopil' (Region of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ternopil' (Region of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ternopil' (Region of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ternopil' (Region of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ternopil' (Region of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ternopil' (Region of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ternopil' (Region of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ternopil' (Region of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ternopil' (Region of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ternopil' (Region of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ternopil' (Region of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ternopil' (Region of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ternopil' (Region of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ternopil' (Region of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Tete (Province of Mozambique)": [
            {
                "Region Name": "Tete (Province of Mozambique)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tete (Province of Mozambique)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Tete (Province of Mozambique)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Tete (Province of Mozambique)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Tete (Province of Mozambique)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Tete (Province of Mozambique)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Tete (Province of Mozambique)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Tete (Province of Mozambique)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tete (Province of Mozambique)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Tete (Province of Mozambique)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Tete (Province of Mozambique)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Tete (Province of Mozambique)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tete (Province of Mozambique)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Tete (Province of Mozambique)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Tete (Province of Mozambique)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tete (Province of Mozambique)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tete (Province of Mozambique)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tete (Province of Mozambique)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tete (Province of Mozambique)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tete (Province of Mozambique)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tete (Province of Mozambique)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Tete (Province of Mozambique)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Tetovo (Municipality of North Macedonia)": [
            {
                "Region Name": "Tetovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tetovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tetovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tetovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tetovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tetovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tetovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tetovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tetovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tetovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Tetovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tetovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tetovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tetovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tetovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tetovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tetovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tetovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tetovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tetovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tetovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tetovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Texas (State of United States)": [
            {
                "Region Name": "Texas (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Texas (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Texas (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Texas (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Texas (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Texas (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Texas (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Texas (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Texas (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Texas (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Texas (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Texas (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Texas (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Texas (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Texas (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Texas (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Texas (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Texas (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Texas (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Texas (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Texas (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Texas (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Thaba-Tseka (District of Lesotho)": [
            {
                "Region Name": "Thaba-Tseka (District of Lesotho)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Thaba-Tseka (District of Lesotho)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Thaba-Tseka (District of Lesotho)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Thaba-Tseka (District of Lesotho)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Thaba-Tseka (District of Lesotho)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Thaba-Tseka (District of Lesotho)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Thaba-Tseka (District of Lesotho)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Thaba-Tseka (District of Lesotho)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Thaba-Tseka (District of Lesotho)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Thaba-Tseka (District of Lesotho)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Thaba-Tseka (District of Lesotho)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Thaba-Tseka (District of Lesotho)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Thaba-Tseka (District of Lesotho)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Thaba-Tseka (District of Lesotho)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Thaba-Tseka (District of Lesotho)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Thaba-Tseka (District of Lesotho)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Thaba-Tseka (District of Lesotho)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Thaba-Tseka (District of Lesotho)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Thaba-Tseka (District of Lesotho)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Thaba-Tseka (District of Lesotho)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Thaba-Tseka (District of Lesotho)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Thaba-Tseka (District of Lesotho)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Th\xe1i B\xecnh (Province of Vietnam)": [
            {
                "Region Name": "Th\xe1i B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Th\xe1i B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i B\xecnh (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Th\xe1i Nguy\xean (Province of Vietnam)": [
            {
                "Region Name": "Th\xe1i Nguy\xean (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i Nguy\xean (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i Nguy\xean (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i Nguy\xean (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i Nguy\xean (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Th\xe1i Nguy\xean (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i Nguy\xean (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Th\xe1i Nguy\xean (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Th\xe1i Nguy\xean (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i Nguy\xean (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i Nguy\xean (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i Nguy\xean (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Th\xe1i Nguy\xean (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Th\xe1i Nguy\xean (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i Nguy\xean (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i Nguy\xean (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i Nguy\xean (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i Nguy\xean (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i Nguy\xean (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i Nguy\xean (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i Nguy\xean (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xe1i Nguy\xean (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Thanh H\xf3a (Province of Vietnam)": [
            {
                "Region Name": "Thanh H\xf3a (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thanh H\xf3a (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Thanh H\xf3a (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Thanh H\xf3a (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Thanh H\xf3a (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Thanh H\xf3a (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Thanh H\xf3a (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Thanh H\xf3a (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Thanh H\xf3a (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Thanh H\xf3a (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thanh H\xf3a (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Thanh H\xf3a (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Thanh H\xf3a (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Thanh H\xf3a (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Thanh H\xf3a (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Thanh H\xf3a (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thanh H\xf3a (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thanh H\xf3a (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Thanh H\xf3a (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Thanh H\xf3a (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Thanh H\xf3a (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Thanh H\xf3a (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Tharaka-Nithi (County of Kenya)": [
            {
                "Region Name": "Tharaka-Nithi (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tharaka-Nithi (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tharaka-Nithi (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tharaka-Nithi (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tharaka-Nithi (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tharaka-Nithi (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tharaka-Nithi (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tharaka-Nithi (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tharaka-Nithi (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tharaka-Nithi (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tharaka-Nithi (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tharaka-Nithi (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tharaka-Nithi (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tharaka-Nithi (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tharaka-Nithi (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tharaka-Nithi (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tharaka-Nithi (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tharaka-Nithi (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tharaka-Nithi (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tharaka-Nithi (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tharaka-Nithi (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tharaka-Nithi (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "The Farrington (District of Anguilla)": [
            {
                "Region Name": "The Farrington (District of Anguilla)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Farrington (District of Anguilla)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Farrington (District of Anguilla)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Farrington (District of Anguilla)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Farrington (District of Anguilla)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Farrington (District of Anguilla)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Farrington (District of Anguilla)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Farrington (District of Anguilla)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Farrington (District of Anguilla)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Farrington (District of Anguilla)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Farrington (District of Anguilla)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Farrington (District of Anguilla)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Farrington (District of Anguilla)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Farrington (District of Anguilla)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Farrington (District of Anguilla)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Farrington (District of Anguilla)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Farrington (District of Anguilla)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Farrington (District of Anguilla)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Farrington (District of Anguilla)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Farrington (District of Anguilla)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Farrington (District of Anguilla)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Farrington (District of Anguilla)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "The Quarter (District of Anguilla)": [
            {
                "Region Name": "The Quarter (District of Anguilla)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Quarter (District of Anguilla)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Quarter (District of Anguilla)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Quarter (District of Anguilla)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Quarter (District of Anguilla)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Quarter (District of Anguilla)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Quarter (District of Anguilla)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Quarter (District of Anguilla)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Quarter (District of Anguilla)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Quarter (District of Anguilla)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Quarter (District of Anguilla)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Quarter (District of Anguilla)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Quarter (District of Anguilla)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Quarter (District of Anguilla)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Quarter (District of Anguilla)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Quarter (District of Anguilla)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Quarter (District of Anguilla)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Quarter (District of Anguilla)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Quarter (District of Anguilla)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Quarter (District of Anguilla)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Quarter (District of Anguilla)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Quarter (District of Anguilla)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "The Valley (District of Anguilla)": [
            {
                "Region Name": "The Valley (District of Anguilla)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Valley (District of Anguilla)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Valley (District of Anguilla)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Valley (District of Anguilla)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Valley (District of Anguilla)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Valley (District of Anguilla)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Valley (District of Anguilla)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Valley (District of Anguilla)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Valley (District of Anguilla)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Valley (District of Anguilla)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Valley (District of Anguilla)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Valley (District of Anguilla)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Valley (District of Anguilla)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Valley (District of Anguilla)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Valley (District of Anguilla)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Valley (District of Anguilla)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Valley (District of Anguilla)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Valley (District of Anguilla)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Valley (District of Anguilla)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Valley (District of Anguilla)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Valley (District of Anguilla)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "The Valley (District of Anguilla)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Thessaly and Central Greece (Decentralized administration of Greece)": [
            {
                "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Thessaly and Central Greece (Decentralized administration of Greece)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 50
            }
        ],
        "Thi\xe8s (Region of Senegal)": [
            {
                "Region Name": "Thi\xe8s (Region of Senegal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thi\xe8s (Region of Senegal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Thi\xe8s (Region of Senegal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thi\xe8s (Region of Senegal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Thi\xe8s (Region of Senegal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Thi\xe8s (Region of Senegal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Thi\xe8s (Region of Senegal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thi\xe8s (Region of Senegal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Thi\xe8s (Region of Senegal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Thi\xe8s (Region of Senegal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thi\xe8s (Region of Senegal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Thi\xe8s (Region of Senegal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Thi\xe8s (Region of Senegal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thi\xe8s (Region of Senegal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thi\xe8s (Region of Senegal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thi\xe8s (Region of Senegal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thi\xe8s (Region of Senegal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Thi\xe8s (Region of Senegal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Thi\xe8s (Region of Senegal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Thi\xe8s (Region of Senegal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Thi\xe8s (Region of Senegal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Thi\xe8s (Region of Senegal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Thimphu (District of Bhutan)": [
            {
                "Region Name": "Thimphu (District of Bhutan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Thimphu (District of Bhutan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thimphu (District of Bhutan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thimphu (District of Bhutan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Thimphu (District of Bhutan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thimphu (District of Bhutan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Thimphu (District of Bhutan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thimphu (District of Bhutan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thimphu (District of Bhutan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thimphu (District of Bhutan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Thimphu (District of Bhutan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Thimphu (District of Bhutan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thimphu (District of Bhutan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thimphu (District of Bhutan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thimphu (District of Bhutan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thimphu (District of Bhutan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thimphu (District of Bhutan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Thimphu (District of Bhutan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thimphu (District of Bhutan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thimphu (District of Bhutan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thimphu (District of Bhutan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Thimphu (District of Bhutan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Th\u1EEBa Thi\xean Hu\u1EBF (Province of Vietnam)": [
            {
                "Region Name": "Th\u1EEBa Thi\xean Hu\u1EBF (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Th\u1EEBa Thi\xean Hu\u1EBF (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Th\u1EEBa Thi\xean Hu\u1EBF (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Th\u1EEBa Thi\xean Hu\u1EBF (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Th\u1EEBa Thi\xean Hu\u1EBF (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Th\u1EEBa Thi\xean Hu\u1EBF (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Th\u1EEBa Thi\xean Hu\u1EBF (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\u1EEBa Thi\xean Hu\u1EBF (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Th\u1EEBa Thi\xean Hu\u1EBF (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Th\u1EEBa Thi\xean Hu\u1EBF (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\u1EEBa Thi\xean Hu\u1EBF (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Th\u1EEBa Thi\xean Hu\u1EBF (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Th\u1EEBa Thi\xean Hu\u1EBF (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Th\u1EEBa Thi\xean Hu\u1EBF (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Th\u1EEBa Thi\xean Hu\u1EBF (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Th\u1EEBa Thi\xean Hu\u1EBF (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\u1EEBa Thi\xean Hu\u1EBF (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\u1EEBa Thi\xean Hu\u1EBF (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Th\u1EEBa Thi\xean Hu\u1EBF (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Th\u1EEBa Thi\xean Hu\u1EBF (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Th\u1EEBa Thi\xean Hu\u1EBF (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Th\u1EEBa Thi\xean Hu\u1EBF (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Thurgau (Canton of Switzerland)": [
            {
                "Region Name": "Thurgau (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thurgau (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thurgau (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thurgau (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thurgau (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thurgau (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thurgau (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thurgau (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thurgau (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thurgau (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thurgau (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thurgau (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thurgau (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thurgau (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thurgau (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thurgau (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thurgau (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thurgau (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thurgau (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thurgau (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thurgau (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Thurgau (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Th\xfcringen (State of Germany)": [
            {
                "Region Name": "Th\xfcringen (State of Germany)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xfcringen (State of Germany)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xfcringen (State of Germany)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Th\xfcringen (State of Germany)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xfcringen (State of Germany)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xfcringen (State of Germany)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xfcringen (State of Germany)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xfcringen (State of Germany)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xfcringen (State of Germany)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xfcringen (State of Germany)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Th\xfcringen (State of Germany)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xfcringen (State of Germany)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xfcringen (State of Germany)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xfcringen (State of Germany)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xfcringen (State of Germany)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xfcringen (State of Germany)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xfcringen (State of Germany)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xfcringen (State of Germany)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xfcringen (State of Germany)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xfcringen (State of Germany)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Th\xfcringen (State of Germany)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Th\xfcringen (State of Germany)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Thyolo (District of Malawi)": [
            {
                "Region Name": "Thyolo (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Thyolo (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Thyolo (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Thyolo (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Thyolo (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Thyolo (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Thyolo (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Thyolo (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Thyolo (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Thyolo (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Thyolo (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Thyolo (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Thyolo (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Thyolo (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Thyolo (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Thyolo (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Thyolo (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Thyolo (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Thyolo (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Thyolo (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Thyolo (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Thyolo (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tianjin (Municipality of China)": [
            {
                "Region Name": "Tianjin (Municipality of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Tianjin (Municipality of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Tianjin (Municipality of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tianjin (Municipality of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tianjin (Municipality of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tianjin (Municipality of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tianjin (Municipality of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Tianjin (Municipality of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tianjin (Municipality of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Tianjin (Municipality of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tianjin (Municipality of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tianjin (Municipality of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tianjin (Municipality of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tianjin (Municipality of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tianjin (Municipality of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Tianjin (Municipality of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tianjin (Municipality of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tianjin (Municipality of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tianjin (Municipality of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tianjin (Municipality of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tianjin (Municipality of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tianjin (Municipality of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Tiaret (Province of Algeria)": [
            {
                "Region Name": "Tiaret (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tiaret (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Tiaret (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Tiaret (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiaret (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tiaret (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Tiaret (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tiaret (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiaret (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Tiaret (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiaret (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tiaret (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tiaret (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Tiaret (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tiaret (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiaret (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tiaret (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiaret (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiaret (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tiaret (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiaret (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiaret (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tibesti (Region of Chad)": [
            {
                "Region Name": "Tibesti (Region of Chad)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tibesti (Region of Chad)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tibesti (Region of Chad)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tibesti (Region of Chad)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tibesti (Region of Chad)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tibesti (Region of Chad)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tibesti (Region of Chad)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tibesti (Region of Chad)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tibesti (Region of Chad)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tibesti (Region of Chad)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tibesti (Region of Chad)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tibesti (Region of Chad)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tibesti (Region of Chad)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tibesti (Region of Chad)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tibesti (Region of Chad)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tibesti (Region of Chad)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tibesti (Region of Chad)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tibesti (Region of Chad)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tibesti (Region of Chad)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tibesti (Region of Chad)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tibesti (Region of Chad)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tibesti (Region of Chad)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ticino (Canton of Switzerland)": [
            {
                "Region Name": "Ticino (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ticino (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ticino (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ticino (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ticino (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ticino (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ticino (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ticino (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ticino (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ticino (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ticino (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ticino (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ticino (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ticino (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ticino (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ticino (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ticino (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ticino (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ticino (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ticino (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ticino (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ticino (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ti\u1EC1n Giang (Province of Vietnam)": [
            {
                "Region Name": "Ti\u1EC1n Giang (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ti\u1EC1n Giang (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ti\u1EC1n Giang (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ti\u1EC1n Giang (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ti\u1EC1n Giang (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Ti\u1EC1n Giang (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ti\u1EC1n Giang (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ti\u1EC1n Giang (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 67
            },
            {
                "Region Name": "Ti\u1EC1n Giang (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ti\u1EC1n Giang (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Ti\u1EC1n Giang (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Ti\u1EC1n Giang (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Ti\u1EC1n Giang (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Ti\u1EC1n Giang (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Ti\u1EC1n Giang (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ti\u1EC1n Giang (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Ti\u1EC1n Giang (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Ti\u1EC1n Giang (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ti\u1EC1n Giang (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Ti\u1EC1n Giang (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ti\u1EC1n Giang (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ti\u1EC1n Giang (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Tierra del Fuego (Province of Argentina)": [
            {
                "Region Name": "Tierra del Fuego (Province of Argentina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tierra del Fuego (Province of Argentina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tierra del Fuego (Province of Argentina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tierra del Fuego (Province of Argentina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tierra del Fuego (Province of Argentina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tierra del Fuego (Province of Argentina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tierra del Fuego (Province of Argentina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tierra del Fuego (Province of Argentina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tierra del Fuego (Province of Argentina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tierra del Fuego (Province of Argentina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Tierra del Fuego (Province of Argentina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tierra del Fuego (Province of Argentina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tierra del Fuego (Province of Argentina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tierra del Fuego (Province of Argentina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tierra del Fuego (Province of Argentina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tierra del Fuego (Province of Argentina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tierra del Fuego (Province of Argentina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tierra del Fuego (Province of Argentina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tierra del Fuego (Province of Argentina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tierra del Fuego (Province of Argentina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tierra del Fuego (Province of Argentina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Tierra del Fuego (Province of Argentina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tigray (State of Ethiopia)": [
            {
                "Region Name": "Tigray (State of Ethiopia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Tigray (State of Ethiopia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Tigray (State of Ethiopia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Tigray (State of Ethiopia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Tigray (State of Ethiopia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Tigray (State of Ethiopia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Tigray (State of Ethiopia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tigray (State of Ethiopia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tigray (State of Ethiopia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Tigray (State of Ethiopia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Tigray (State of Ethiopia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Tigray (State of Ethiopia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Tigray (State of Ethiopia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Tigray (State of Ethiopia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tigray (State of Ethiopia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Tigray (State of Ethiopia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tigray (State of Ethiopia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Tigray (State of Ethiopia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tigray (State of Ethiopia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tigray (State of Ethiopia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Tigray (State of Ethiopia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tigray (State of Ethiopia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Tillab\xe9ry (Department of Niger)": [
            {
                "Region Name": "Tillab\xe9ry (Department of Niger)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Tillab\xe9ry (Department of Niger)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 102
            },
            {
                "Region Name": "Tillab\xe9ry (Department of Niger)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Tillab\xe9ry (Department of Niger)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Tillab\xe9ry (Department of Niger)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 84
            },
            {
                "Region Name": "Tillab\xe9ry (Department of Niger)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Tillab\xe9ry (Department of Niger)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "Tillab\xe9ry (Department of Niger)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Tillab\xe9ry (Department of Niger)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Tillab\xe9ry (Department of Niger)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Tillab\xe9ry (Department of Niger)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Tillab\xe9ry (Department of Niger)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Tillab\xe9ry (Department of Niger)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Tillab\xe9ry (Department of Niger)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Tillab\xe9ry (Department of Niger)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Tillab\xe9ry (Department of Niger)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 72
            },
            {
                "Region Name": "Tillab\xe9ry (Department of Niger)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "Tillab\xe9ry (Department of Niger)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Tillab\xe9ry (Department of Niger)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Tillab\xe9ry (Department of Niger)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Tillab\xe9ry (Department of Niger)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Tillab\xe9ry (Department of Niger)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 44
            }
        ],
        "Timbuktu (Region of Mali)": [
            {
                "Region Name": "Timbuktu (Region of Mali)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Timbuktu (Region of Mali)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Timbuktu (Region of Mali)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Timbuktu (Region of Mali)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 178
            },
            {
                "Region Name": "Timbuktu (Region of Mali)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 75
            },
            {
                "Region Name": "Timbuktu (Region of Mali)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 343
            },
            {
                "Region Name": "Timbuktu (Region of Mali)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Timbuktu (Region of Mali)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Timbuktu (Region of Mali)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 70
            },
            {
                "Region Name": "Timbuktu (Region of Mali)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 78
            },
            {
                "Region Name": "Timbuktu (Region of Mali)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 174
            },
            {
                "Region Name": "Timbuktu (Region of Mali)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 195
            },
            {
                "Region Name": "Timbuktu (Region of Mali)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Timbuktu (Region of Mali)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 210
            },
            {
                "Region Name": "Timbuktu (Region of Mali)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Timbuktu (Region of Mali)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Timbuktu (Region of Mali)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "Timbuktu (Region of Mali)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Timbuktu (Region of Mali)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Timbuktu (Region of Mali)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Timbuktu (Region of Mali)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Timbuktu (Region of Mali)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 81
            }
        ],
        "Timi\u0219 (County of Romania)": [
            {
                "Region Name": "Timi\u0219 (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Timi\u0219 (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Timi\u0219 (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Timi\u0219 (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Timi\u0219 (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Timi\u0219 (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Timi\u0219 (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Timi\u0219 (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Timi\u0219 (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Timi\u0219 (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Timi\u0219 (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Timi\u0219 (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Timi\u0219 (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Timi\u0219 (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Timi\u0219 (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Timi\u0219 (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Timi\u0219 (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Timi\u0219 (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Timi\u0219 (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Timi\u0219 (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Timi\u0219 (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Timi\u0219 (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Tindouf (Province of Algeria)": [
            {
                "Region Name": "Tindouf (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tindouf (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tindouf (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tindouf (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tindouf (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tindouf (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tindouf (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tindouf (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tindouf (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tindouf (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tindouf (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tindouf (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tindouf (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tindouf (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tindouf (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tindouf (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tindouf (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tindouf (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tindouf (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tindouf (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tindouf (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tindouf (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tinian (Municipality of Northern Mariana Islands)": [
            {
                "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tinian (Municipality of Northern Mariana Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tipaza (Province of Algeria)": [
            {
                "Region Name": "Tipaza (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tipaza (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tipaza (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Tipaza (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tipaza (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tipaza (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Tipaza (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tipaza (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tipaza (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tipaza (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tipaza (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Tipaza (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tipaza (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tipaza (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tipaza (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tipaza (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tipaza (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tipaza (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tipaza (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tipaza (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tipaza (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tipaza (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Tipperary (County of Ireland)": [
            {
                "Region Name": "Tipperary (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tipperary (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tipperary (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tipperary (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tipperary (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tipperary (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tipperary (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tipperary (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tipperary (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tipperary (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tipperary (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tipperary (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tipperary (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tipperary (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tipperary (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tipperary (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tipperary (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tipperary (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tipperary (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tipperary (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tipperary (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tipperary (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tiran\xeb (County of Albania)": [
            {
                "Region Name": "Tiran\xeb (County of Albania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiran\xeb (County of Albania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tiran\xeb (County of Albania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiran\xeb (County of Albania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiran\xeb (County of Albania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiran\xeb (County of Albania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tiran\xeb (County of Albania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiran\xeb (County of Albania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiran\xeb (County of Albania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiran\xeb (County of Albania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tiran\xeb (County of Albania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tiran\xeb (County of Albania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiran\xeb (County of Albania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiran\xeb (County of Albania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiran\xeb (County of Albania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiran\xeb (County of Albania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tiran\xeb (County of Albania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tiran\xeb (County of Albania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiran\xeb (County of Albania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tiran\xeb (County of Albania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tiran\xeb (County of Albania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiran\xeb (County of Albania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Tiris Zemmour (Region of Mauritania)": [
            {
                "Region Name": "Tiris Zemmour (Region of Mauritania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiris Zemmour (Region of Mauritania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiris Zemmour (Region of Mauritania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiris Zemmour (Region of Mauritania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiris Zemmour (Region of Mauritania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiris Zemmour (Region of Mauritania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiris Zemmour (Region of Mauritania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiris Zemmour (Region of Mauritania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiris Zemmour (Region of Mauritania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiris Zemmour (Region of Mauritania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiris Zemmour (Region of Mauritania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiris Zemmour (Region of Mauritania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiris Zemmour (Region of Mauritania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiris Zemmour (Region of Mauritania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiris Zemmour (Region of Mauritania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiris Zemmour (Region of Mauritania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiris Zemmour (Region of Mauritania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiris Zemmour (Region of Mauritania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiris Zemmour (Region of Mauritania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiris Zemmour (Region of Mauritania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiris Zemmour (Region of Mauritania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tiris Zemmour (Region of Mauritania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tirol (State of Austria)": [
            {
                "Region Name": "Tirol (State of Austria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tirol (State of Austria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tirol (State of Austria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tirol (State of Austria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tirol (State of Austria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tirol (State of Austria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tirol (State of Austria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tirol (State of Austria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tirol (State of Austria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tirol (State of Austria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tirol (State of Austria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tirol (State of Austria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tirol (State of Austria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tirol (State of Austria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tirol (State of Austria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tirol (State of Austria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tirol (State of Austria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tirol (State of Austria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tirol (State of Austria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tirol (State of Austria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tirol (State of Austria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tirol (State of Austria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tissemsilt (Province of Algeria)": [
            {
                "Region Name": "Tissemsilt (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tissemsilt (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tissemsilt (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Tissemsilt (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Tissemsilt (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tissemsilt (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tissemsilt (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tissemsilt (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tissemsilt (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tissemsilt (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tissemsilt (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tissemsilt (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tissemsilt (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tissemsilt (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tissemsilt (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tissemsilt (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tissemsilt (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tissemsilt (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tissemsilt (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tissemsilt (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tissemsilt (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tissemsilt (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tivat (Municipality of Montenegro)": [
            {
                "Region Name": "Tivat (Municipality of Montenegro)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tivat (Municipality of Montenegro)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tivat (Municipality of Montenegro)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tivat (Municipality of Montenegro)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tivat (Municipality of Montenegro)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tivat (Municipality of Montenegro)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tivat (Municipality of Montenegro)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tivat (Municipality of Montenegro)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tivat (Municipality of Montenegro)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tivat (Municipality of Montenegro)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tivat (Municipality of Montenegro)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tivat (Municipality of Montenegro)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tivat (Municipality of Montenegro)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tivat (Municipality of Montenegro)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tivat (Municipality of Montenegro)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tivat (Municipality of Montenegro)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tivat (Municipality of Montenegro)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tivat (Municipality of Montenegro)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tivat (Municipality of Montenegro)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tivat (Municipality of Montenegro)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tivat (Municipality of Montenegro)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tivat (Municipality of Montenegro)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tizi Ouzou (Province of Algeria)": [
            {
                "Region Name": "Tizi Ouzou (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tizi Ouzou (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tizi Ouzou (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tizi Ouzou (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tizi Ouzou (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tizi Ouzou (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tizi Ouzou (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tizi Ouzou (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tizi Ouzou (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tizi Ouzou (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tizi Ouzou (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tizi Ouzou (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tizi Ouzou (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tizi Ouzou (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tizi Ouzou (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tizi Ouzou (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tizi Ouzou (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tizi Ouzou (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tizi Ouzou (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tizi Ouzou (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 167
            },
            {
                "Region Name": "Tizi Ouzou (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tizi Ouzou (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Tlaxcala (State of M\xe9xico)": [
            {
                "Region Name": "Tlaxcala (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tlaxcala (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tlaxcala (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tlaxcala (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tlaxcala (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Tlaxcala (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tlaxcala (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tlaxcala (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tlaxcala (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tlaxcala (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tlaxcala (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tlaxcala (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tlaxcala (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tlaxcala (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tlaxcala (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tlaxcala (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tlaxcala (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tlaxcala (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tlaxcala (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tlaxcala (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tlaxcala (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tlaxcala (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tlemcen (Province of Algeria)": [
            {
                "Region Name": "Tlemcen (Province of Algeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tlemcen (Province of Algeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Tlemcen (Province of Algeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "Tlemcen (Province of Algeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Tlemcen (Province of Algeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tlemcen (Province of Algeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Tlemcen (Province of Algeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tlemcen (Province of Algeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tlemcen (Province of Algeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tlemcen (Province of Algeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tlemcen (Province of Algeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tlemcen (Province of Algeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tlemcen (Province of Algeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Tlemcen (Province of Algeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Tlemcen (Province of Algeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tlemcen (Province of Algeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Tlemcen (Province of Algeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tlemcen (Province of Algeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tlemcen (Province of Algeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tlemcen (Province of Algeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tlemcen (Province of Algeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tlemcen (Province of Algeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Toa Alta (Municipality of Puerto Rico)": [
            {
                "Region Name": "Toa Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Toa Baja (Municipality of Puerto Rico)": [
            {
                "Region Name": "Toa Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toa Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Toamasina (NA of Madagascar)": [
            {
                "Region Name": "Toamasina (NA of Madagascar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Toamasina (NA of Madagascar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Toamasina (NA of Madagascar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Toamasina (NA of Madagascar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Toamasina (NA of Madagascar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Toamasina (NA of Madagascar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Toamasina (NA of Madagascar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Toamasina (NA of Madagascar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Toamasina (NA of Madagascar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Toamasina (NA of Madagascar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Toamasina (NA of Madagascar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Toamasina (NA of Madagascar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Toamasina (NA of Madagascar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Toamasina (NA of Madagascar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Toamasina (NA of Madagascar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Toamasina (NA of Madagascar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Toamasina (NA of Madagascar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Toamasina (NA of Madagascar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Toamasina (NA of Madagascar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Toamasina (NA of Madagascar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Toamasina (NA of Madagascar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Toamasina (NA of Madagascar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Tobago (Region of Trinidad and Tobago)": [
            {
                "Region Name": "Tobago (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tobago (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tobago (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tobago (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tobago (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tobago (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tobago (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tobago (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tobago (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tobago (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tobago (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tobago (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tobago (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tobago (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tobago (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tobago (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tobago (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tobago (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tobago (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tobago (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tobago (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tobago (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tocantins (State of Brazil)": [
            {
                "Region Name": "Tocantins (State of Brazil)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Tocantins (State of Brazil)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Tocantins (State of Brazil)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Tocantins (State of Brazil)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Tocantins (State of Brazil)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Tocantins (State of Brazil)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Tocantins (State of Brazil)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Tocantins (State of Brazil)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Tocantins (State of Brazil)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Tocantins (State of Brazil)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Tocantins (State of Brazil)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Tocantins (State of Brazil)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Tocantins (State of Brazil)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Tocantins (State of Brazil)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Tocantins (State of Brazil)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Tocantins (State of Brazil)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Tocantins (State of Brazil)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Tocantins (State of Brazil)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Tocantins (State of Brazil)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Tocantins (State of Brazil)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Tocantins (State of Brazil)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Tocantins (State of Brazil)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "Tochigi (Prefecture of Japan)": [
            {
                "Region Name": "Tochigi (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tochigi (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Tochigi (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tochigi (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Tochigi (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Tochigi (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tochigi (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Tochigi (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Tochigi (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tochigi (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tochigi (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tochigi (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Tochigi (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tochigi (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Tochigi (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tochigi (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tochigi (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tochigi (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tochigi (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tochigi (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Tochigi (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tochigi (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Togdheer (Region of Somalia)": [
            {
                "Region Name": "Togdheer (Region of Somalia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Togdheer (Region of Somalia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Togdheer (Region of Somalia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Togdheer (Region of Somalia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Togdheer (Region of Somalia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Togdheer (Region of Somalia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Togdheer (Region of Somalia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Togdheer (Region of Somalia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Togdheer (Region of Somalia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Togdheer (Region of Somalia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Togdheer (Region of Somalia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Togdheer (Region of Somalia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Togdheer (Region of Somalia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Togdheer (Region of Somalia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Togdheer (Region of Somalia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Togdheer (Region of Somalia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Togdheer (Region of Somalia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Togdheer (Region of Somalia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Togdheer (Region of Somalia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Togdheer (Region of Somalia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Togdheer (Region of Somalia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Togdheer (Region of Somalia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tokat (Province of Turkey)": [
            {
                "Region Name": "Tokat (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokat (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokat (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tokat (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tokat (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tokat (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokat (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tokat (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tokat (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tokat (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tokat (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokat (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tokat (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokat (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tokat (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tokat (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokat (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokat (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokat (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokat (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tokat (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tokat (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tokushima (Prefecture of Japan)": [
            {
                "Region Name": "Tokushima (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokushima (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokushima (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokushima (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokushima (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokushima (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokushima (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokushima (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokushima (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokushima (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokushima (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokushima (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokushima (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokushima (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokushima (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokushima (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokushima (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokushima (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokushima (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokushima (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokushima (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokushima (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tokyo (Metropolis of Japan)": [
            {
                "Region Name": "Tokyo (Metropolis of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokyo (Metropolis of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokyo (Metropolis of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokyo (Metropolis of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokyo (Metropolis of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokyo (Metropolis of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokyo (Metropolis of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokyo (Metropolis of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokyo (Metropolis of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokyo (Metropolis of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokyo (Metropolis of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokyo (Metropolis of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokyo (Metropolis of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokyo (Metropolis of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokyo (Metropolis of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokyo (Metropolis of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokyo (Metropolis of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokyo (Metropolis of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokyo (Metropolis of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokyo (Metropolis of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokyo (Metropolis of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tokyo (Metropolis of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Toledo (District of Belize)": [
            {
                "Region Name": "Toledo (District of Belize)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Toledo (District of Belize)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Toledo (District of Belize)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Toledo (District of Belize)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Toledo (District of Belize)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Toledo (District of Belize)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Toledo (District of Belize)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Toledo (District of Belize)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Toledo (District of Belize)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Toledo (District of Belize)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Toledo (District of Belize)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Toledo (District of Belize)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Toledo (District of Belize)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Toledo (District of Belize)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Toledo (District of Belize)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Toledo (District of Belize)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Toledo (District of Belize)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Toledo (District of Belize)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Toledo (District of Belize)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Toledo (District of Belize)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Toledo (District of Belize)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Toledo (District of Belize)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Toliary (NA of Madagascar)": [
            {
                "Region Name": "Toliary (NA of Madagascar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Toliary (NA of Madagascar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Toliary (NA of Madagascar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Toliary (NA of Madagascar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Toliary (NA of Madagascar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Toliary (NA of Madagascar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Toliary (NA of Madagascar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Toliary (NA of Madagascar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Toliary (NA of Madagascar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Toliary (NA of Madagascar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Toliary (NA of Madagascar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Toliary (NA of Madagascar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Toliary (NA of Madagascar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Toliary (NA of Madagascar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Toliary (NA of Madagascar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Toliary (NA of Madagascar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Toliary (NA of Madagascar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Toliary (NA of Madagascar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Toliary (NA of Madagascar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Toliary (NA of Madagascar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Toliary (NA of Madagascar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Toliary (NA of Madagascar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Tolima (Department of Colombia)": [
            {
                "Region Name": "Tolima (Department of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tolima (Department of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tolima (Department of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tolima (Department of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tolima (Department of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tolima (Department of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tolima (Department of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tolima (Department of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tolima (Department of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tolima (Department of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tolima (Department of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tolima (Department of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tolima (Department of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tolima (Department of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Tolima (Department of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tolima (Department of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tolima (Department of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tolima (Department of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tolima (Department of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tolima (Department of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tolima (Department of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tolima (Department of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Tolna (County of Hungary)": [
            {
                "Region Name": "Tolna (County of Hungary)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tolna (County of Hungary)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tolna (County of Hungary)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Tolna (County of Hungary)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tolna (County of Hungary)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Tolna (County of Hungary)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tolna (County of Hungary)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tolna (County of Hungary)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tolna (County of Hungary)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tolna (County of Hungary)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tolna (County of Hungary)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tolna (County of Hungary)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tolna (County of Hungary)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tolna (County of Hungary)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tolna (County of Hungary)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tolna (County of Hungary)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tolna (County of Hungary)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tolna (County of Hungary)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tolna (County of Hungary)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tolna (County of Hungary)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tolna (County of Hungary)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tolna (County of Hungary)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tombali (Region of Guinea-Bissau)": [
            {
                "Region Name": "Tombali (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tombali (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tombali (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tombali (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tombali (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tombali (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tombali (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tombali (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tombali (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tombali (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tombali (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tombali (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tombali (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tombali (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tombali (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tombali (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tombali (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tombali (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tombali (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tombali (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tombali (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tombali (Region of Guinea-Bissau)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Tomsk (Region of Russia)": [
            {
                "Region Name": "Tomsk (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tomsk (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Tomsk (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Tomsk (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tomsk (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tomsk (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tomsk (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Tomsk (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tomsk (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Tomsk (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Tomsk (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Tomsk (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tomsk (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tomsk (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tomsk (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Tomsk (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Tomsk (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tomsk (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tomsk (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tomsk (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tomsk (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tomsk (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 20
            }
        ],
        "Tongatapu (Island Group of Tonga)": [
            {
                "Region Name": "Tongatapu (Island Group of Tonga)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tongatapu (Island Group of Tonga)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tongatapu (Island Group of Tonga)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tongatapu (Island Group of Tonga)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tongatapu (Island Group of Tonga)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tongatapu (Island Group of Tonga)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tongatapu (Island Group of Tonga)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tongatapu (Island Group of Tonga)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tongatapu (Island Group of Tonga)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tongatapu (Island Group of Tonga)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tongatapu (Island Group of Tonga)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tongatapu (Island Group of Tonga)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tongatapu (Island Group of Tonga)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tongatapu (Island Group of Tonga)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tongatapu (Island Group of Tonga)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tongatapu (Island Group of Tonga)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tongatapu (Island Group of Tonga)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tongatapu (Island Group of Tonga)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tongatapu (Island Group of Tonga)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tongatapu (Island Group of Tonga)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tongatapu (Island Group of Tonga)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tongatapu (Island Group of Tonga)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Topli\u010Dki (District of Serbia)": [
            {
                "Region Name": "Topli\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Topli\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Topli\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Topli\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Topli\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Topli\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Topli\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Topli\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Topli\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Topli\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Topli\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Topli\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Topli\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Topli\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Topli\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Topli\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Topli\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Topli\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Topli\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Topli\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Topli\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Topli\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Torba (Province of Vanuatu)": [
            {
                "Region Name": "Torba (Province of Vanuatu)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torba (Province of Vanuatu)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torba (Province of Vanuatu)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torba (Province of Vanuatu)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torba (Province of Vanuatu)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torba (Province of Vanuatu)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torba (Province of Vanuatu)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torba (Province of Vanuatu)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torba (Province of Vanuatu)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torba (Province of Vanuatu)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torba (Province of Vanuatu)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torba (Province of Vanuatu)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torba (Province of Vanuatu)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torba (Province of Vanuatu)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torba (Province of Vanuatu)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torba (Province of Vanuatu)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torba (Province of Vanuatu)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torba (Province of Vanuatu)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torba (Province of Vanuatu)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torba (Province of Vanuatu)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torba (Province of Vanuatu)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torba (Province of Vanuatu)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tororo (District of Uganda)": [
            {
                "Region Name": "Tororo (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tororo (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tororo (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tororo (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tororo (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tororo (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tororo (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tororo (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tororo (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tororo (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tororo (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tororo (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tororo (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tororo (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tororo (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tororo (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tororo (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tororo (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tororo (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tororo (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tororo (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tororo (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Torteval (Parish of Guernsey)": [
            {
                "Region Name": "Torteval (Parish of Guernsey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torteval (Parish of Guernsey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torteval (Parish of Guernsey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torteval (Parish of Guernsey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torteval (Parish of Guernsey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torteval (Parish of Guernsey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torteval (Parish of Guernsey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torteval (Parish of Guernsey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torteval (Parish of Guernsey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torteval (Parish of Guernsey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torteval (Parish of Guernsey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torteval (Parish of Guernsey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torteval (Parish of Guernsey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torteval (Parish of Guernsey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torteval (Parish of Guernsey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torteval (Parish of Guernsey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torteval (Parish of Guernsey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torteval (Parish of Guernsey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torteval (Parish of Guernsey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torteval (Parish of Guernsey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torteval (Parish of Guernsey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Torteval (Parish of Guernsey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tortola (District of British Virgin Islands)": [
            {
                "Region Name": "Tortola (District of British Virgin Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tortola (District of British Virgin Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tortola (District of British Virgin Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tortola (District of British Virgin Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tortola (District of British Virgin Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tortola (District of British Virgin Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tortola (District of British Virgin Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tortola (District of British Virgin Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tortola (District of British Virgin Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tortola (District of British Virgin Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tortola (District of British Virgin Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tortola (District of British Virgin Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tortola (District of British Virgin Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tortola (District of British Virgin Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tortola (District of British Virgin Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tortola (District of British Virgin Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tortola (District of British Virgin Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tortola (District of British Virgin Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tortola (District of British Virgin Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tortola (District of British Virgin Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tortola (District of British Virgin Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tortola (District of British Virgin Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Toscana (Region of Italy)": [
            {
                "Region Name": "Toscana (Region of Italy)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toscana (Region of Italy)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Toscana (Region of Italy)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Toscana (Region of Italy)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toscana (Region of Italy)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toscana (Region of Italy)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toscana (Region of Italy)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toscana (Region of Italy)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Toscana (Region of Italy)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toscana (Region of Italy)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toscana (Region of Italy)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Toscana (Region of Italy)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toscana (Region of Italy)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Toscana (Region of Italy)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toscana (Region of Italy)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toscana (Region of Italy)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Toscana (Region of Italy)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Toscana (Region of Italy)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toscana (Region of Italy)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toscana (Region of Italy)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toscana (Region of Italy)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Toscana (Region of Italy)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Toshkent (Region of Uzbekistan)": [
            {
                "Region Name": "Toshkent (Region of Uzbekistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Toshkent (Region of Uzbekistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Toshkent (Region of Uzbekistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Toshkent (Region of Uzbekistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Toshkent (Region of Uzbekistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Toshkent (Region of Uzbekistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Toshkent (Region of Uzbekistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Toshkent (Region of Uzbekistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Toshkent (Region of Uzbekistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Toshkent (Region of Uzbekistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Toshkent (Region of Uzbekistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Toshkent (Region of Uzbekistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Toshkent (Region of Uzbekistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Toshkent (Region of Uzbekistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Toshkent (Region of Uzbekistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Toshkent (Region of Uzbekistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Toshkent (Region of Uzbekistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Toshkent (Region of Uzbekistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Toshkent (Region of Uzbekistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Toshkent (Region of Uzbekistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Toshkent (Region of Uzbekistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Toshkent (Region of Uzbekistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Toshkent Shahri (City of Uzbekistan)": [
            {
                "Region Name": "Toshkent Shahri (City of Uzbekistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toshkent Shahri (City of Uzbekistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toshkent Shahri (City of Uzbekistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toshkent Shahri (City of Uzbekistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toshkent Shahri (City of Uzbekistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toshkent Shahri (City of Uzbekistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toshkent Shahri (City of Uzbekistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toshkent Shahri (City of Uzbekistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toshkent Shahri (City of Uzbekistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toshkent Shahri (City of Uzbekistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toshkent Shahri (City of Uzbekistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toshkent Shahri (City of Uzbekistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toshkent Shahri (City of Uzbekistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toshkent Shahri (City of Uzbekistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toshkent Shahri (City of Uzbekistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toshkent Shahri (City of Uzbekistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toshkent Shahri (City of Uzbekistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toshkent Shahri (City of Uzbekistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toshkent Shahri (City of Uzbekistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toshkent Shahri (City of Uzbekistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toshkent Shahri (City of Uzbekistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toshkent Shahri (City of Uzbekistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Totonicap\xe1n (Department of Guatemala)": [
            {
                "Region Name": "Totonicap\xe1n (Department of Guatemala)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Totonicap\xe1n (Department of Guatemala)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Totonicap\xe1n (Department of Guatemala)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Totonicap\xe1n (Department of Guatemala)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Totonicap\xe1n (Department of Guatemala)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Totonicap\xe1n (Department of Guatemala)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Totonicap\xe1n (Department of Guatemala)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Totonicap\xe1n (Department of Guatemala)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Totonicap\xe1n (Department of Guatemala)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Totonicap\xe1n (Department of Guatemala)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Totonicap\xe1n (Department of Guatemala)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Totonicap\xe1n (Department of Guatemala)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Totonicap\xe1n (Department of Guatemala)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Totonicap\xe1n (Department of Guatemala)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Totonicap\xe1n (Department of Guatemala)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Totonicap\xe1n (Department of Guatemala)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Totonicap\xe1n (Department of Guatemala)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Totonicap\xe1n (Department of Guatemala)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Totonicap\xe1n (Department of Guatemala)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Totonicap\xe1n (Department of Guatemala)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Totonicap\xe1n (Department of Guatemala)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Totonicap\xe1n (Department of Guatemala)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tottori (Prefecture of Japan)": [
            {
                "Region Name": "Tottori (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tottori (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tottori (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tottori (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tottori (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tottori (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tottori (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tottori (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tottori (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tottori (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tottori (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tottori (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tottori (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tottori (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tottori (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tottori (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tottori (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tottori (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tottori (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tottori (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tottori (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tottori (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "T\xf6v (Province of Mongolia)": [
            {
                "Region Name": "T\xf6v (Province of Mongolia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 61
            },
            {
                "Region Name": "T\xf6v (Province of Mongolia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "T\xf6v (Province of Mongolia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "T\xf6v (Province of Mongolia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "T\xf6v (Province of Mongolia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "T\xf6v (Province of Mongolia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "T\xf6v (Province of Mongolia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "T\xf6v (Province of Mongolia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "T\xf6v (Province of Mongolia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "T\xf6v (Province of Mongolia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "T\xf6v (Province of Mongolia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "T\xf6v (Province of Mongolia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "T\xf6v (Province of Mongolia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "T\xf6v (Province of Mongolia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "T\xf6v (Province of Mongolia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "T\xf6v (Province of Mongolia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "T\xf6v (Province of Mongolia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "T\xf6v (Province of Mongolia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "T\xf6v (Province of Mongolia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "T\xf6v (Province of Mongolia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "T\xf6v (Province of Mongolia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "T\xf6v (Province of Mongolia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Toyama (Prefecture of Japan)": [
            {
                "Region Name": "Toyama (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toyama (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toyama (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toyama (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toyama (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toyama (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Toyama (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toyama (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toyama (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toyama (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toyama (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toyama (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Toyama (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toyama (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toyama (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toyama (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toyama (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toyama (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toyama (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toyama (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toyama (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Toyama (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tozeur (Governorate of Tunisia)": [
            {
                "Region Name": "Tozeur (Governorate of Tunisia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tozeur (Governorate of Tunisia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tozeur (Governorate of Tunisia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tozeur (Governorate of Tunisia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tozeur (Governorate of Tunisia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tozeur (Governorate of Tunisia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tozeur (Governorate of Tunisia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tozeur (Governorate of Tunisia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tozeur (Governorate of Tunisia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tozeur (Governorate of Tunisia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tozeur (Governorate of Tunisia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tozeur (Governorate of Tunisia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tozeur (Governorate of Tunisia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tozeur (Governorate of Tunisia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tozeur (Governorate of Tunisia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tozeur (Governorate of Tunisia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tozeur (Governorate of Tunisia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tozeur (Governorate of Tunisia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tozeur (Governorate of Tunisia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tozeur (Governorate of Tunisia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tozeur (Governorate of Tunisia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tozeur (Governorate of Tunisia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tr\xe0 Vinh (Province of Vietnam)": [
            {
                "Region Name": "Tr\xe0 Vinh (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tr\xe0 Vinh (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tr\xe0 Vinh (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tr\xe0 Vinh (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tr\xe0 Vinh (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tr\xe0 Vinh (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tr\xe0 Vinh (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tr\xe0 Vinh (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tr\xe0 Vinh (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tr\xe0 Vinh (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Tr\xe0 Vinh (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tr\xe0 Vinh (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Tr\xe0 Vinh (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Tr\xe0 Vinh (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tr\xe0 Vinh (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tr\xe0 Vinh (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tr\xe0 Vinh (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tr\xe0 Vinh (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tr\xe0 Vinh (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Tr\xe0 Vinh (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tr\xe0 Vinh (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tr\xe0 Vinh (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Trabzon (Province of Turkey)": [
            {
                "Region Name": "Trabzon (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trabzon (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trabzon (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trabzon (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trabzon (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trabzon (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trabzon (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trabzon (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trabzon (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trabzon (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trabzon (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trabzon (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trabzon (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trabzon (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trabzon (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trabzon (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trabzon (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trabzon (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trabzon (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trabzon (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trabzon (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trabzon (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tramuntana (Region of Malta)": [
            {
                "Region Name": "Tramuntana (Region of Malta)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tramuntana (Region of Malta)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tramuntana (Region of Malta)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tramuntana (Region of Malta)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tramuntana (Region of Malta)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tramuntana (Region of Malta)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tramuntana (Region of Malta)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tramuntana (Region of Malta)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tramuntana (Region of Malta)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tramuntana (Region of Malta)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tramuntana (Region of Malta)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tramuntana (Region of Malta)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tramuntana (Region of Malta)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tramuntana (Region of Malta)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tramuntana (Region of Malta)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tramuntana (Region of Malta)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tramuntana (Region of Malta)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tramuntana (Region of Malta)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tramuntana (Region of Malta)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tramuntana (Region of Malta)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tramuntana (Region of Malta)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tramuntana (Region of Malta)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Trang (Province of Thailand)": [
            {
                "Region Name": "Trang (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trang (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trang (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trang (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trang (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trang (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trang (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trang (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trang (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trang (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trang (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trang (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trang (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trang (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trang (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trang (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trang (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trang (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trang (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trang (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trang (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trang (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Trans Nzoia (County of Kenya)": [
            {
                "Region Name": "Trans Nzoia (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trans Nzoia (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trans Nzoia (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Trans Nzoia (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trans Nzoia (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trans Nzoia (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Trans Nzoia (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trans Nzoia (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Trans Nzoia (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Trans Nzoia (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Trans Nzoia (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Trans Nzoia (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trans Nzoia (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Trans Nzoia (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Trans Nzoia (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Trans Nzoia (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Trans Nzoia (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Trans Nzoia (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Trans Nzoia (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trans Nzoia (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Trans Nzoia (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Trans Nzoia (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Transnistria (Territorial Unit of Moldova)": [
            {
                "Region Name": "Transnistria (Territorial Unit of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Transnistria (Territorial Unit of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Transnistria (Territorial Unit of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Transnistria (Territorial Unit of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Transnistria (Territorial Unit of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Transnistria (Territorial Unit of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Transnistria (Territorial Unit of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Transnistria (Territorial Unit of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Transnistria (Territorial Unit of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Transnistria (Territorial Unit of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Transnistria (Territorial Unit of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Transnistria (Territorial Unit of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Transnistria (Territorial Unit of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Transnistria (Territorial Unit of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Transnistria (Territorial Unit of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Transnistria (Territorial Unit of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Transnistria (Territorial Unit of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Transnistria (Territorial Unit of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Transnistria (Territorial Unit of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Transnistria (Territorial Unit of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Transnistria (Territorial Unit of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Transnistria (Territorial Unit of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Trarza (Region of Mauritania)": [
            {
                "Region Name": "Trarza (Region of Mauritania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trarza (Region of Mauritania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trarza (Region of Mauritania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trarza (Region of Mauritania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trarza (Region of Mauritania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trarza (Region of Mauritania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Trarza (Region of Mauritania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trarza (Region of Mauritania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trarza (Region of Mauritania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Trarza (Region of Mauritania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trarza (Region of Mauritania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Trarza (Region of Mauritania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Trarza (Region of Mauritania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trarza (Region of Mauritania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Trarza (Region of Mauritania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Trarza (Region of Mauritania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Trarza (Region of Mauritania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Trarza (Region of Mauritania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Trarza (Region of Mauritania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trarza (Region of Mauritania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trarza (Region of Mauritania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Trarza (Region of Mauritania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Trashi Yangtse (District of Bhutan)": [
            {
                "Region Name": "Trashi Yangtse (District of Bhutan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trashi Yangtse (District of Bhutan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trashi Yangtse (District of Bhutan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trashi Yangtse (District of Bhutan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trashi Yangtse (District of Bhutan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trashi Yangtse (District of Bhutan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Trashi Yangtse (District of Bhutan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trashi Yangtse (District of Bhutan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trashi Yangtse (District of Bhutan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Trashi Yangtse (District of Bhutan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trashi Yangtse (District of Bhutan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trashi Yangtse (District of Bhutan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trashi Yangtse (District of Bhutan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Trashi Yangtse (District of Bhutan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Trashi Yangtse (District of Bhutan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Trashi Yangtse (District of Bhutan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trashi Yangtse (District of Bhutan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Trashi Yangtse (District of Bhutan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trashi Yangtse (District of Bhutan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trashi Yangtse (District of Bhutan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trashi Yangtse (District of Bhutan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trashi Yangtse (District of Bhutan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Trashigang (District of Bhutan)": [
            {
                "Region Name": "Trashigang (District of Bhutan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trashigang (District of Bhutan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trashigang (District of Bhutan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trashigang (District of Bhutan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Trashigang (District of Bhutan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Trashigang (District of Bhutan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trashigang (District of Bhutan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trashigang (District of Bhutan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trashigang (District of Bhutan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Trashigang (District of Bhutan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Trashigang (District of Bhutan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trashigang (District of Bhutan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trashigang (District of Bhutan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Trashigang (District of Bhutan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trashigang (District of Bhutan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Trashigang (District of Bhutan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Trashigang (District of Bhutan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Trashigang (District of Bhutan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trashigang (District of Bhutan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trashigang (District of Bhutan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Trashigang (District of Bhutan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trashigang (District of Bhutan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Trat (Province of Thailand)": [
            {
                "Region Name": "Trat (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trat (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trat (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trat (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Trat (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trat (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trat (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Trat (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trat (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trat (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trat (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trat (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trat (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trat (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trat (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trat (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trat (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trat (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Trat (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trat (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trat (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trat (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Treinta y Tres (Department of Uruguay)": [
            {
                "Region Name": "Treinta y Tres (Department of Uruguay)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Treinta y Tres (Department of Uruguay)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Treinta y Tres (Department of Uruguay)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Treinta y Tres (Department of Uruguay)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Treinta y Tres (Department of Uruguay)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Treinta y Tres (Department of Uruguay)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Treinta y Tres (Department of Uruguay)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Treinta y Tres (Department of Uruguay)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Treinta y Tres (Department of Uruguay)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Treinta y Tres (Department of Uruguay)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Treinta y Tres (Department of Uruguay)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Treinta y Tres (Department of Uruguay)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Treinta y Tres (Department of Uruguay)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Treinta y Tres (Department of Uruguay)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Treinta y Tres (Department of Uruguay)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Treinta y Tres (Department of Uruguay)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Treinta y Tres (Department of Uruguay)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Treinta y Tres (Department of Uruguay)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Treinta y Tres (Department of Uruguay)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Treinta y Tres (Department of Uruguay)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Treinta y Tres (Department of Uruguay)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Treinta y Tres (Department of Uruguay)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Trelawny (Parish of Jamaica)": [
            {
                "Region Name": "Trelawny (Parish of Jamaica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trelawny (Parish of Jamaica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trelawny (Parish of Jamaica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trelawny (Parish of Jamaica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trelawny (Parish of Jamaica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trelawny (Parish of Jamaica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trelawny (Parish of Jamaica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trelawny (Parish of Jamaica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trelawny (Parish of Jamaica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trelawny (Parish of Jamaica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trelawny (Parish of Jamaica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trelawny (Parish of Jamaica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trelawny (Parish of Jamaica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trelawny (Parish of Jamaica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Trelawny (Parish of Jamaica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trelawny (Parish of Jamaica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trelawny (Parish of Jamaica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trelawny (Parish of Jamaica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trelawny (Parish of Jamaica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trelawny (Parish of Jamaica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trelawny (Parish of Jamaica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trelawny (Parish of Jamaica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tren\u010Diansky (Region of Slovakia)": [
            {
                "Region Name": "Tren\u010Diansky (Region of Slovakia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tren\u010Diansky (Region of Slovakia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tren\u010Diansky (Region of Slovakia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tren\u010Diansky (Region of Slovakia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tren\u010Diansky (Region of Slovakia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tren\u010Diansky (Region of Slovakia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tren\u010Diansky (Region of Slovakia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tren\u010Diansky (Region of Slovakia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tren\u010Diansky (Region of Slovakia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tren\u010Diansky (Region of Slovakia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tren\u010Diansky (Region of Slovakia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tren\u010Diansky (Region of Slovakia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tren\u010Diansky (Region of Slovakia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tren\u010Diansky (Region of Slovakia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tren\u010Diansky (Region of Slovakia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tren\u010Diansky (Region of Slovakia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tren\u010Diansky (Region of Slovakia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tren\u010Diansky (Region of Slovakia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tren\u010Diansky (Region of Slovakia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tren\u010Diansky (Region of Slovakia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tren\u010Diansky (Region of Slovakia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tren\u010Diansky (Region of Slovakia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Trengganu (State of Malaysia)": [
            {
                "Region Name": "Trengganu (State of Malaysia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trengganu (State of Malaysia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trengganu (State of Malaysia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Trengganu (State of Malaysia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trengganu (State of Malaysia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trengganu (State of Malaysia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trengganu (State of Malaysia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trengganu (State of Malaysia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trengganu (State of Malaysia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trengganu (State of Malaysia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trengganu (State of Malaysia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trengganu (State of Malaysia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trengganu (State of Malaysia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trengganu (State of Malaysia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trengganu (State of Malaysia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trengganu (State of Malaysia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trengganu (State of Malaysia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trengganu (State of Malaysia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trengganu (State of Malaysia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trengganu (State of Malaysia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trengganu (State of Malaysia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trengganu (State of Malaysia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Trentino-Alto Adige (Autonomous Region of Italy)": [
            {
                "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trentino-Alto Adige (Autonomous Region of Italy)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Triesen (Commune of Liechtenstein)": [
            {
                "Region Name": "Triesen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesen (Commune of Liechtenstein)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Triesenberg (Commune of Liechtenstein)": [
            {
                "Region Name": "Triesenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Triesenberg (Commune of Liechtenstein)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Trincomalee (District of Sri Lanka)": [
            {
                "Region Name": "Trincomalee (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trincomalee (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Trincomalee (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trincomalee (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trincomalee (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Trincomalee (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Trincomalee (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trincomalee (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Trincomalee (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trincomalee (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trincomalee (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trincomalee (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trincomalee (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trincomalee (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Trincomalee (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Trincomalee (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trincomalee (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trincomalee (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trincomalee (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trincomalee (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trincomalee (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trincomalee (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Trinity (Parish of Jersey)": [
            {
                "Region Name": "Trinity (Parish of Jersey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity (Parish of Jersey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity (Parish of Jersey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity (Parish of Jersey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity (Parish of Jersey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity (Parish of Jersey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity (Parish of Jersey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity (Parish of Jersey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity (Parish of Jersey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity (Parish of Jersey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity (Parish of Jersey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity (Parish of Jersey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity (Parish of Jersey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity (Parish of Jersey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity (Parish of Jersey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity (Parish of Jersey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity (Parish of Jersey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity (Parish of Jersey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity (Parish of Jersey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity (Parish of Jersey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity (Parish of Jersey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity (Parish of Jersey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)": [
            {
                "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trinity Palmetto Point (Parish of Saint Kitts and Nevis)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tripoli (District of Libya)": [
            {
                "Region Name": "Tripoli (District of Libya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tripoli (District of Libya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tripoli (District of Libya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tripoli (District of Libya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tripoli (District of Libya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tripoli (District of Libya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tripoli (District of Libya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tripoli (District of Libya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tripoli (District of Libya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tripoli (District of Libya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tripoli (District of Libya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tripoli (District of Libya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tripoli (District of Libya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tripoli (District of Libya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tripoli (District of Libya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tripoli (District of Libya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tripoli (District of Libya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tripoli (District of Libya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tripoli (District of Libya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tripoli (District of Libya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tripoli (District of Libya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tripoli (District of Libya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tripura (State of India)": [
            {
                "Region Name": "Tripura (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tripura (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tripura (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tripura (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tripura (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Tripura (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tripura (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tripura (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tripura (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tripura (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tripura (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tripura (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tripura (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tripura (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tripura (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tripura (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tripura (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tripura (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tripura (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tripura (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tripura (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tripura (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)": [
            {
                "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tristan da Cunha (Dependency of Saint Helena, Ascension and Tris)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Trnavsk\xfd (Region of Slovakia)": [
            {
                "Region Name": "Trnavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Trnavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trnavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trnavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trnavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trnavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trnavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trnavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trnavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trnavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trnavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trnavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Trnavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Trnavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trnavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trnavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trnavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trnavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trnavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trnavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trnavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trnavsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Troms (County of Norway)": [
            {
                "Region Name": "Troms (County of Norway)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Troms (County of Norway)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Troms (County of Norway)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Troms (County of Norway)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Troms (County of Norway)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Troms (County of Norway)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Troms (County of Norway)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Troms (County of Norway)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Troms (County of Norway)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Troms (County of Norway)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Troms (County of Norway)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Troms (County of Norway)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Troms (County of Norway)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Troms (County of Norway)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Troms (County of Norway)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Troms (County of Norway)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Troms (County of Norway)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Troms (County of Norway)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Troms (County of Norway)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Troms (County of Norway)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Troms (County of Norway)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Troms (County of Norway)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Trongsa (District of Bhutan)": [
            {
                "Region Name": "Trongsa (District of Bhutan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trongsa (District of Bhutan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trongsa (District of Bhutan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trongsa (District of Bhutan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trongsa (District of Bhutan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trongsa (District of Bhutan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trongsa (District of Bhutan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trongsa (District of Bhutan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trongsa (District of Bhutan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trongsa (District of Bhutan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trongsa (District of Bhutan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trongsa (District of Bhutan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trongsa (District of Bhutan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trongsa (District of Bhutan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trongsa (District of Bhutan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trongsa (District of Bhutan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trongsa (District of Bhutan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trongsa (District of Bhutan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trongsa (District of Bhutan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trongsa (District of Bhutan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trongsa (District of Bhutan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trongsa (District of Bhutan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Trujillo (State of Venezuela)": [
            {
                "Region Name": "Trujillo (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Trujillo (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Trujillo (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trujillo (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trujillo (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trujillo (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trujillo (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trujillo (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Trujillo (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Trujillo (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Trujillo (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Trujillo (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Trujillo (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Trujillo (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Trujillo (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trujillo (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trujillo (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Trujillo (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trujillo (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Trujillo (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Trujillo (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Trujillo (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Trujillo Alto (Municipality of Puerto Rico)": [
            {
                "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Trujillo Alto (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tshopo (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tshopo (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Tshuapa (Province of Democratic Republic of the Congo)": [
            {
                "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tshuapa (Province of Democratic Republic of the Congo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Tsingoni (Commune of Mayotte)": [
            {
                "Region Name": "Tsingoni (Commune of Mayotte)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsingoni (Commune of Mayotte)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsingoni (Commune of Mayotte)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsingoni (Commune of Mayotte)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsingoni (Commune of Mayotte)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsingoni (Commune of Mayotte)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsingoni (Commune of Mayotte)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsingoni (Commune of Mayotte)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsingoni (Commune of Mayotte)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsingoni (Commune of Mayotte)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsingoni (Commune of Mayotte)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsingoni (Commune of Mayotte)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsingoni (Commune of Mayotte)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsingoni (Commune of Mayotte)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsingoni (Commune of Mayotte)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsingoni (Commune of Mayotte)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsingoni (Commune of Mayotte)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsingoni (Commune of Mayotte)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsingoni (Commune of Mayotte)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsingoni (Commune of Mayotte)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsingoni (Commune of Mayotte)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsingoni (Commune of Mayotte)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tsirang (District of Bhutan)": [
            {
                "Region Name": "Tsirang (District of Bhutan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsirang (District of Bhutan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsirang (District of Bhutan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsirang (District of Bhutan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsirang (District of Bhutan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tsirang (District of Bhutan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsirang (District of Bhutan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsirang (District of Bhutan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsirang (District of Bhutan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsirang (District of Bhutan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsirang (District of Bhutan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsirang (District of Bhutan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsirang (District of Bhutan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsirang (District of Bhutan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Tsirang (District of Bhutan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsirang (District of Bhutan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsirang (District of Bhutan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsirang (District of Bhutan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsirang (District of Bhutan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsirang (District of Bhutan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsirang (District of Bhutan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tsirang (District of Bhutan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tuamasaga (District of Samoa)": [
            {
                "Region Name": "Tuamasaga (District of Samoa)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuamasaga (District of Samoa)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuamasaga (District of Samoa)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuamasaga (District of Samoa)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuamasaga (District of Samoa)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuamasaga (District of Samoa)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuamasaga (District of Samoa)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuamasaga (District of Samoa)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuamasaga (District of Samoa)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuamasaga (District of Samoa)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuamasaga (District of Samoa)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuamasaga (District of Samoa)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuamasaga (District of Samoa)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuamasaga (District of Samoa)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuamasaga (District of Samoa)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuamasaga (District of Samoa)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuamasaga (District of Samoa)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuamasaga (District of Samoa)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuamasaga (District of Samoa)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuamasaga (District of Samoa)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuamasaga (District of Samoa)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuamasaga (District of Samoa)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tucum\xe1n (Province of Argentina)": [
            {
                "Region Name": "Tucum\xe1n (Province of Argentina)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tucum\xe1n (Province of Argentina)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tucum\xe1n (Province of Argentina)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tucum\xe1n (Province of Argentina)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tucum\xe1n (Province of Argentina)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tucum\xe1n (Province of Argentina)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tucum\xe1n (Province of Argentina)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tucum\xe1n (Province of Argentina)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tucum\xe1n (Province of Argentina)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tucum\xe1n (Province of Argentina)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tucum\xe1n (Province of Argentina)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tucum\xe1n (Province of Argentina)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tucum\xe1n (Province of Argentina)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tucum\xe1n (Province of Argentina)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tucum\xe1n (Province of Argentina)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tucum\xe1n (Province of Argentina)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tucum\xe1n (Province of Argentina)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tucum\xe1n (Province of Argentina)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tucum\xe1n (Province of Argentina)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tucum\xe1n (Province of Argentina)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tucum\xe1n (Province of Argentina)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tucum\xe1n (Province of Argentina)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Tula (Region of Russia)": [
            {
                "Region Name": "Tula (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tula (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tula (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tula (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tula (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tula (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tula (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tula (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tula (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tula (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tula (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tula (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tula (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tula (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tula (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tula (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tula (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tula (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tula (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tula (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tula (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tula (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Tulcea (County of Romania)": [
            {
                "Region Name": "Tulcea (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tulcea (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tulcea (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tulcea (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tulcea (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tulcea (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tulcea (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tulcea (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tulcea (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tulcea (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Tulcea (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tulcea (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tulcea (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tulcea (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tulcea (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tulcea (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tulcea (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tulcea (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tulcea (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tulcea (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Tulcea (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Tulcea (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Tumbes (Region of Peru)": [
            {
                "Region Name": "Tumbes (Region of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tumbes (Region of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tumbes (Region of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tumbes (Region of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tumbes (Region of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tumbes (Region of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Tumbes (Region of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tumbes (Region of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tumbes (Region of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tumbes (Region of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Tumbes (Region of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tumbes (Region of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tumbes (Region of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tumbes (Region of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tumbes (Region of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tumbes (Region of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tumbes (Region of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tumbes (Region of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tumbes (Region of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tumbes (Region of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tumbes (Region of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tumbes (Region of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Tunapuna/Piarco (Region of Trinidad and Tobago)": [
            {
                "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunapuna/Piarco (Region of Trinidad and Tobago)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tunceli (Province of Turkey)": [
            {
                "Region Name": "Tunceli (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tunceli (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunceli (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tunceli (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunceli (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tunceli (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tunceli (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunceli (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tunceli (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tunceli (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tunceli (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tunceli (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tunceli (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunceli (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tunceli (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tunceli (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tunceli (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tunceli (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tunceli (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tunceli (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tunceli (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunceli (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Tungurahua (Province of Ecuador)": [
            {
                "Region Name": "Tungurahua (Province of Ecuador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tungurahua (Province of Ecuador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tungurahua (Province of Ecuador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tungurahua (Province of Ecuador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tungurahua (Province of Ecuador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tungurahua (Province of Ecuador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tungurahua (Province of Ecuador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tungurahua (Province of Ecuador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tungurahua (Province of Ecuador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tungurahua (Province of Ecuador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tungurahua (Province of Ecuador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tungurahua (Province of Ecuador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tungurahua (Province of Ecuador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tungurahua (Province of Ecuador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tungurahua (Province of Ecuador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tungurahua (Province of Ecuador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tungurahua (Province of Ecuador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tungurahua (Province of Ecuador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tungurahua (Province of Ecuador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tungurahua (Province of Ecuador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tungurahua (Province of Ecuador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tungurahua (Province of Ecuador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tunis (Governorate of Tunisia)": [
            {
                "Region Name": "Tunis (Governorate of Tunisia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunis (Governorate of Tunisia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunis (Governorate of Tunisia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunis (Governorate of Tunisia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunis (Governorate of Tunisia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunis (Governorate of Tunisia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunis (Governorate of Tunisia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunis (Governorate of Tunisia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunis (Governorate of Tunisia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunis (Governorate of Tunisia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunis (Governorate of Tunisia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunis (Governorate of Tunisia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunis (Governorate of Tunisia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunis (Governorate of Tunisia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunis (Governorate of Tunisia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunis (Governorate of Tunisia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunis (Governorate of Tunisia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunis (Governorate of Tunisia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunis (Governorate of Tunisia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunis (Governorate of Tunisia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunis (Governorate of Tunisia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tunis (Governorate of Tunisia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Turkana (County of Kenya)": [
            {
                "Region Name": "Turkana (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Turkana (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Turkana (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Turkana (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Turkana (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Turkana (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Turkana (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Turkana (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Turkana (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Turkana (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Turkana (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Turkana (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Turkana (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Turkana (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Turkana (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Turkana (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Turkana (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Turkana (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Turkana (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Turkana (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Turkana (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Turkana (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "Tutong (District of Brunei)": [
            {
                "Region Name": "Tutong (District of Brunei)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tutong (District of Brunei)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tutong (District of Brunei)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tutong (District of Brunei)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tutong (District of Brunei)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tutong (District of Brunei)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tutong (District of Brunei)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tutong (District of Brunei)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tutong (District of Brunei)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tutong (District of Brunei)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tutong (District of Brunei)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tutong (District of Brunei)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tutong (District of Brunei)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tutong (District of Brunei)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tutong (District of Brunei)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tutong (District of Brunei)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tutong (District of Brunei)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tutong (District of Brunei)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tutong (District of Brunei)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tutong (District of Brunei)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tutong (District of Brunei)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tutong (District of Brunei)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tuva (Republic of Russia)": [
            {
                "Region Name": "Tuva (Republic of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Tuva (Republic of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Tuva (Republic of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Tuva (Republic of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Tuva (Republic of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Tuva (Republic of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Tuva (Republic of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Tuva (Republic of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tuva (Republic of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tuva (Republic of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tuva (Republic of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Tuva (Republic of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tuva (Republic of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Tuva (Republic of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Tuva (Republic of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tuva (Republic of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Tuva (Republic of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tuva (Republic of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tuva (Republic of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tuva (Republic of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tuva (Republic of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Tuva (Republic of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Tuy\xean Quang (Province of Vietnam)": [
            {
                "Region Name": "Tuy\xean Quang (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tuy\xean Quang (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tuy\xean Quang (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tuy\xean Quang (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuy\xean Quang (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tuy\xean Quang (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuy\xean Quang (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tuy\xean Quang (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuy\xean Quang (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuy\xean Quang (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuy\xean Quang (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuy\xean Quang (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuy\xean Quang (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuy\xean Quang (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuy\xean Quang (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuy\xean Quang (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuy\xean Quang (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuy\xean Quang (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuy\xean Quang (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuy\xean Quang (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tuy\xean Quang (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tuy\xean Quang (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Tver' (Region of Russia)": [
            {
                "Region Name": "Tver' (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tver' (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Tver' (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tver' (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Tver' (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tver' (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tver' (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tver' (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tver' (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tver' (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Tver' (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tver' (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tver' (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tver' (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tver' (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tver' (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Tver' (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Tver' (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tver' (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Tver' (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tver' (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Tver' (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Tyumen' (Region of Russia)": [
            {
                "Region Name": "Tyumen' (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Tyumen' (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tyumen' (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tyumen' (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tyumen' (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tyumen' (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Tyumen' (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Tyumen' (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Tyumen' (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Tyumen' (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tyumen' (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tyumen' (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tyumen' (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Tyumen' (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tyumen' (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Tyumen' (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Tyumen' (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Tyumen' (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Tyumen' (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Tyumen' (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Tyumen' (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Tyumen' (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 91
            }
        ],
        "Uaboe (District of Nauru)": [
            {
                "Region Name": "Uaboe (District of Nauru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uaboe (District of Nauru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uaboe (District of Nauru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uaboe (District of Nauru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uaboe (District of Nauru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uaboe (District of Nauru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uaboe (District of Nauru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uaboe (District of Nauru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uaboe (District of Nauru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uaboe (District of Nauru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uaboe (District of Nauru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uaboe (District of Nauru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uaboe (District of Nauru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uaboe (District of Nauru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uaboe (District of Nauru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uaboe (District of Nauru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uaboe (District of Nauru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uaboe (District of Nauru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uaboe (District of Nauru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uaboe (District of Nauru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uaboe (District of Nauru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uaboe (District of Nauru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Uasin Gishu (County of Kenya)": [
            {
                "Region Name": "Uasin Gishu (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Uasin Gishu (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Uasin Gishu (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Uasin Gishu (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Uasin Gishu (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uasin Gishu (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Uasin Gishu (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Uasin Gishu (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Uasin Gishu (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Uasin Gishu (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Uasin Gishu (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Uasin Gishu (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Uasin Gishu (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Uasin Gishu (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Uasin Gishu (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uasin Gishu (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Uasin Gishu (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uasin Gishu (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Uasin Gishu (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uasin Gishu (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uasin Gishu (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uasin Gishu (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Ubon Ratchathani (Province of Thailand)": [
            {
                "Region Name": "Ubon Ratchathani (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ubon Ratchathani (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ubon Ratchathani (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ubon Ratchathani (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ubon Ratchathani (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ubon Ratchathani (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ubon Ratchathani (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ubon Ratchathani (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ubon Ratchathani (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ubon Ratchathani (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ubon Ratchathani (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ubon Ratchathani (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ubon Ratchathani (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ubon Ratchathani (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ubon Ratchathani (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ubon Ratchathani (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ubon Ratchathani (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ubon Ratchathani (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ubon Ratchathani (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ubon Ratchathani (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ubon Ratchathani (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ubon Ratchathani (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Ucayali (Region of Peru)": [
            {
                "Region Name": "Ucayali (Region of Peru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ucayali (Region of Peru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ucayali (Region of Peru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ucayali (Region of Peru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ucayali (Region of Peru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ucayali (Region of Peru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ucayali (Region of Peru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ucayali (Region of Peru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ucayali (Region of Peru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ucayali (Region of Peru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ucayali (Region of Peru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ucayali (Region of Peru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ucayali (Region of Peru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ucayali (Region of Peru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ucayali (Region of Peru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ucayali (Region of Peru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ucayali (Region of Peru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ucayali (Region of Peru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ucayali (Region of Peru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ucayali (Region of Peru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ucayali (Region of Peru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ucayali (Region of Peru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Udmurt (Republic of Russia)": [
            {
                "Region Name": "Udmurt (Republic of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Udmurt (Republic of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Udmurt (Republic of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Udmurt (Republic of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Udmurt (Republic of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Udmurt (Republic of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Udmurt (Republic of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Udmurt (Republic of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Udmurt (Republic of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Udmurt (Republic of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Udmurt (Republic of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Udmurt (Republic of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Udmurt (Republic of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Udmurt (Republic of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Udmurt (Republic of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Udmurt (Republic of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Udmurt (Republic of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Udmurt (Republic of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Udmurt (Republic of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Udmurt (Republic of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Udmurt (Republic of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Udmurt (Republic of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Udon Thani (Province of Thailand)": [
            {
                "Region Name": "Udon Thani (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Udon Thani (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Udon Thani (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Udon Thani (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Udon Thani (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Udon Thani (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Udon Thani (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Udon Thani (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Udon Thani (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Udon Thani (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Udon Thani (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Udon Thani (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Udon Thani (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Udon Thani (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Udon Thani (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Udon Thani (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Udon Thani (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Udon Thani (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Udon Thani (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Udon Thani (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Udon Thani (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Udon Thani (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "U\xedge (Province of Angola)": [
            {
                "Region Name": "U\xedge (Province of Angola)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "U\xedge (Province of Angola)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "U\xedge (Province of Angola)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "U\xedge (Province of Angola)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "U\xedge (Province of Angola)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "U\xedge (Province of Angola)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "U\xedge (Province of Angola)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "U\xedge (Province of Angola)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "U\xedge (Province of Angola)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "U\xedge (Province of Angola)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "U\xedge (Province of Angola)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "U\xedge (Province of Angola)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "U\xedge (Province of Angola)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "U\xedge (Province of Angola)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "U\xedge (Province of Angola)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "U\xedge (Province of Angola)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "U\xedge (Province of Angola)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "U\xedge (Province of Angola)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "U\xedge (Province of Angola)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "U\xedge (Province of Angola)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "U\xedge (Province of Angola)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "U\xedge (Province of Angola)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Ujae (Atol of Marshall Islands)": [
            {
                "Region Name": "Ujae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ujae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ujae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ujae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ujae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ujae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ujae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ujae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ujae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ujae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ujae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ujae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ujae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ujae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ujae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ujae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ujae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ujae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ujae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ujae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ujae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ujae (Atol of Marshall Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ul'yanovsk (Region of Russia)": [
            {
                "Region Name": "Ul'yanovsk (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ul'yanovsk (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ul'yanovsk (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ul'yanovsk (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ul'yanovsk (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ul'yanovsk (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ul'yanovsk (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ul'yanovsk (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ul'yanovsk (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ul'yanovsk (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ul'yanovsk (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ul'yanovsk (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ul'yanovsk (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ul'yanovsk (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ul'yanovsk (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ul'yanovsk (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ul'yanovsk (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ul'yanovsk (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ul'yanovsk (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Ul'yanovsk (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Ul'yanovsk (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ul'yanovsk (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Ulaanbaatar (Municipality of Mongolia)": [
            {
                "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulaanbaatar (Municipality of Mongolia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ulcinj (Municipality of Montenegro)": [
            {
                "Region Name": "Ulcinj (Municipality of Montenegro)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulcinj (Municipality of Montenegro)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ulcinj (Municipality of Montenegro)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulcinj (Municipality of Montenegro)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulcinj (Municipality of Montenegro)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulcinj (Municipality of Montenegro)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulcinj (Municipality of Montenegro)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulcinj (Municipality of Montenegro)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulcinj (Municipality of Montenegro)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulcinj (Municipality of Montenegro)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulcinj (Municipality of Montenegro)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Ulcinj (Municipality of Montenegro)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulcinj (Municipality of Montenegro)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulcinj (Municipality of Montenegro)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulcinj (Municipality of Montenegro)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulcinj (Municipality of Montenegro)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ulcinj (Municipality of Montenegro)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulcinj (Municipality of Montenegro)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulcinj (Municipality of Montenegro)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulcinj (Municipality of Montenegro)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulcinj (Municipality of Montenegro)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulcinj (Municipality of Montenegro)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ulsan (Metropolitan City of South Korea)": [
            {
                "Region Name": "Ulsan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulsan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulsan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulsan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulsan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulsan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulsan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulsan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulsan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulsan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulsan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ulsan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulsan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulsan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulsan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulsan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulsan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulsan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulsan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulsan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulsan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ulsan (Metropolitan City of South Korea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Umatac (Municipality of Guam)": [
            {
                "Region Name": "Umatac (Municipality of Guam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umatac (Municipality of Guam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umatac (Municipality of Guam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umatac (Municipality of Guam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umatac (Municipality of Guam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umatac (Municipality of Guam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umatac (Municipality of Guam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umatac (Municipality of Guam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umatac (Municipality of Guam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umatac (Municipality of Guam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umatac (Municipality of Guam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umatac (Municipality of Guam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umatac (Municipality of Guam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umatac (Municipality of Guam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umatac (Municipality of Guam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umatac (Municipality of Guam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umatac (Municipality of Guam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umatac (Municipality of Guam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umatac (Municipality of Guam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umatac (Municipality of Guam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umatac (Municipality of Guam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umatac (Municipality of Guam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Umbria (Region of Italy)": [
            {
                "Region Name": "Umbria (Region of Italy)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Umbria (Region of Italy)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umbria (Region of Italy)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umbria (Region of Italy)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umbria (Region of Italy)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umbria (Region of Italy)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umbria (Region of Italy)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Umbria (Region of Italy)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umbria (Region of Italy)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umbria (Region of Italy)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umbria (Region of Italy)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Umbria (Region of Italy)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umbria (Region of Italy)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umbria (Region of Italy)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umbria (Region of Italy)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umbria (Region of Italy)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umbria (Region of Italy)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umbria (Region of Italy)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umbria (Region of Italy)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umbria (Region of Italy)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umbria (Region of Italy)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umbria (Region of Italy)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Umm al-Qaywayn (Emirate of United Arab Emirates)": [
            {
                "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm al-Qaywayn (Emirate of United Arab Emirates)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Umm Salal (Municipality of Qatar)": [
            {
                "Region Name": "Umm Salal (Municipality of Qatar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm Salal (Municipality of Qatar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm Salal (Municipality of Qatar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm Salal (Municipality of Qatar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm Salal (Municipality of Qatar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm Salal (Municipality of Qatar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm Salal (Municipality of Qatar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm Salal (Municipality of Qatar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm Salal (Municipality of Qatar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm Salal (Municipality of Qatar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm Salal (Municipality of Qatar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm Salal (Municipality of Qatar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm Salal (Municipality of Qatar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm Salal (Municipality of Qatar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm Salal (Municipality of Qatar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm Salal (Municipality of Qatar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm Salal (Municipality of Qatar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm Salal (Municipality of Qatar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm Salal (Municipality of Qatar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm Salal (Municipality of Qatar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm Salal (Municipality of Qatar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umm Salal (Municipality of Qatar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Umujyi wa Kigali (Province of Rwanda)": [
            {
                "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Umujyi wa Kigali (Province of Rwanda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ungheni (District of Moldova)": [
            {
                "Region Name": "Ungheni (District of Moldova)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ungheni (District of Moldova)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ungheni (District of Moldova)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ungheni (District of Moldova)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ungheni (District of Moldova)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ungheni (District of Moldova)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ungheni (District of Moldova)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ungheni (District of Moldova)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ungheni (District of Moldova)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ungheni (District of Moldova)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Ungheni (District of Moldova)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ungheni (District of Moldova)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ungheni (District of Moldova)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ungheni (District of Moldova)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ungheni (District of Moldova)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ungheni (District of Moldova)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ungheni (District of Moldova)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ungheni (District of Moldova)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ungheni (District of Moldova)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ungheni (District of Moldova)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Ungheni (District of Moldova)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Ungheni (District of Moldova)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Unity (State of South Sudan)": [
            {
                "Region Name": "Unity (State of South Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Unity (State of South Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Unity (State of South Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Unity (State of South Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Unity (State of South Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Unity (State of South Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Unity (State of South Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Unity (State of South Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Unity (State of South Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Unity (State of South Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Unity (State of South Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Unity (State of South Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Unity (State of South Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Unity (State of South Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Unity (State of South Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Unity (State of South Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Unity (State of South Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Unity (State of South Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Unity (State of South Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Unity (State of South Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Unity (State of South Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Unity (State of South Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 23
            }
        ],
        "Unorganized (District of American Samoa)": [
            {
                "Region Name": "Unorganized (District of American Samoa)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Unorganized (District of American Samoa)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Unorganized (District of American Samoa)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Unorganized (District of American Samoa)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Unorganized (District of American Samoa)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Unorganized (District of American Samoa)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Unorganized (District of American Samoa)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Unorganized (District of American Samoa)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Unorganized (District of American Samoa)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Unorganized (District of American Samoa)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Unorganized (District of American Samoa)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Unorganized (District of American Samoa)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Unorganized (District of American Samoa)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Unorganized (District of American Samoa)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Unorganized (District of American Samoa)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Unorganized (District of American Samoa)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Unorganized (District of American Samoa)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Unorganized (District of American Samoa)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Unorganized (District of American Samoa)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Unorganized (District of American Samoa)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Unorganized (District of American Samoa)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Unorganized (District of American Samoa)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Upper Demerara-Berbice (Region of Guyana)": [
            {
                "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Upper Demerara-Berbice (Region of Guyana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Upper East (Region of Ghana)": [
            {
                "Region Name": "Upper East (Region of Ghana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Upper East (Region of Ghana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Upper East (Region of Ghana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Upper East (Region of Ghana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Upper East (Region of Ghana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Upper East (Region of Ghana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Upper East (Region of Ghana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Upper East (Region of Ghana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Upper East (Region of Ghana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Upper East (Region of Ghana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Upper East (Region of Ghana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Upper East (Region of Ghana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Upper East (Region of Ghana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Upper East (Region of Ghana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Upper East (Region of Ghana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Upper East (Region of Ghana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Upper East (Region of Ghana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Upper East (Region of Ghana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Upper East (Region of Ghana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Upper East (Region of Ghana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Upper East (Region of Ghana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Upper East (Region of Ghana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 20
            }
        ],
        "Upper Nile (State of South Sudan)": [
            {
                "Region Name": "Upper Nile (State of South Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Upper Nile (State of South Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Upper Nile (State of South Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Upper Nile (State of South Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Upper Nile (State of South Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 57
            },
            {
                "Region Name": "Upper Nile (State of South Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Upper Nile (State of South Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Upper Nile (State of South Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Upper Nile (State of South Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Upper Nile (State of South Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Upper Nile (State of South Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Upper Nile (State of South Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Upper Nile (State of South Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Upper Nile (State of South Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Upper Nile (State of South Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Upper Nile (State of South Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Upper Nile (State of South Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Upper Nile (State of South Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Upper Nile (State of South Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Upper Nile (State of South Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Upper Nile (State of South Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Upper Nile (State of South Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 28
            }
        ],
        "Upper River (Division of Gambia)": [
            {
                "Region Name": "Upper River (Division of Gambia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Upper River (Division of Gambia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Upper River (Division of Gambia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Upper River (Division of Gambia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Upper River (Division of Gambia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Upper River (Division of Gambia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Upper River (Division of Gambia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Upper River (Division of Gambia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Upper River (Division of Gambia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Upper River (Division of Gambia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Upper River (Division of Gambia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Upper River (Division of Gambia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Upper River (Division of Gambia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Upper River (Division of Gambia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Upper River (Division of Gambia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Upper River (Division of Gambia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Upper River (Division of Gambia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Upper River (Division of Gambia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Upper River (Division of Gambia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Upper River (Division of Gambia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Upper River (Division of Gambia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Upper River (Division of Gambia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Upper Takutu-Upper Essequibo (Region of Guyana)": [
            {
                "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Upper Takutu-Upper Essequibo (Region of Guyana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Upper West (Region of Ghana)": [
            {
                "Region Name": "Upper West (Region of Ghana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Upper West (Region of Ghana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Upper West (Region of Ghana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Upper West (Region of Ghana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Upper West (Region of Ghana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Upper West (Region of Ghana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Upper West (Region of Ghana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Upper West (Region of Ghana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Upper West (Region of Ghana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Upper West (Region of Ghana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Upper West (Region of Ghana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Upper West (Region of Ghana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Upper West (Region of Ghana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Upper West (Region of Ghana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Upper West (Region of Ghana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Upper West (Region of Ghana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Upper West (Region of Ghana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Upper West (Region of Ghana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Upper West (Region of Ghana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Upper West (Region of Ghana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Upper West (Region of Ghana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Upper West (Region of Ghana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 19
            }
        ],
        "Uppsala (County of Sweden)": [
            {
                "Region Name": "Uppsala (County of Sweden)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uppsala (County of Sweden)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uppsala (County of Sweden)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uppsala (County of Sweden)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uppsala (County of Sweden)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uppsala (County of Sweden)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uppsala (County of Sweden)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uppsala (County of Sweden)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uppsala (County of Sweden)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uppsala (County of Sweden)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uppsala (County of Sweden)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uppsala (County of Sweden)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uppsala (County of Sweden)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uppsala (County of Sweden)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uppsala (County of Sweden)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uppsala (County of Sweden)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uppsala (County of Sweden)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uppsala (County of Sweden)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uppsala (County of Sweden)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uppsala (County of Sweden)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uppsala (County of Sweden)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uppsala (County of Sweden)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Uri (Canton of Switzerland)": [
            {
                "Region Name": "Uri (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uri (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uri (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uri (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uri (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uri (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uri (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uri (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uri (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uri (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uri (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uri (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uri (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uri (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uri (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uri (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uri (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uri (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uri (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uri (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uri (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uri (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Uro\u0161evac (District of Kosovo)": [
            {
                "Region Name": "Uro\u0161evac (District of Kosovo)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uro\u0161evac (District of Kosovo)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uro\u0161evac (District of Kosovo)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uro\u0161evac (District of Kosovo)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uro\u0161evac (District of Kosovo)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uro\u0161evac (District of Kosovo)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uro\u0161evac (District of Kosovo)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Uro\u0161evac (District of Kosovo)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uro\u0161evac (District of Kosovo)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uro\u0161evac (District of Kosovo)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uro\u0161evac (District of Kosovo)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Uro\u0161evac (District of Kosovo)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uro\u0161evac (District of Kosovo)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uro\u0161evac (District of Kosovo)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uro\u0161evac (District of Kosovo)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uro\u0161evac (District of Kosovo)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uro\u0161evac (District of Kosovo)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uro\u0161evac (District of Kosovo)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Uro\u0161evac (District of Kosovo)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Uro\u0161evac (District of Kosovo)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uro\u0161evac (District of Kosovo)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uro\u0161evac (District of Kosovo)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Uruzgan (Province of Afghanistan)": [
            {
                "Region Name": "Uruzgan (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uruzgan (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uruzgan (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uruzgan (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uruzgan (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uruzgan (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uruzgan (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uruzgan (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uruzgan (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uruzgan (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uruzgan (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uruzgan (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uruzgan (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uruzgan (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uruzgan (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Uruzgan (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uruzgan (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uruzgan (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uruzgan (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uruzgan (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uruzgan (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uruzgan (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Usak (Province of Turkey)": [
            {
                "Region Name": "Usak (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Usak (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Usak (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Usak (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Usak (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Usak (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Usak (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Usak (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Usak (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Usak (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Usak (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Usak (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Usak (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Usak (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Usak (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Usak (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Usak (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Usak (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Usak (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Usak (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Usak (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Usak (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "\xdasteck\xfd (Region of Czechia)": [
            {
                "Region Name": "\xdasteck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xdasteck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xdasteck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\xdasteck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xdasteck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xdasteck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xdasteck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xdasteck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xdasteck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xdasteck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xdasteck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xdasteck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xdasteck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xdasteck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xdasteck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xdasteck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xdasteck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xdasteck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xdasteck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xdasteck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\xdasteck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "\xdasteck\xfd (Region of Czechia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Usulut\xe1n (Department of El Salvador)": [
            {
                "Region Name": "Usulut\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Usulut\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Usulut\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Usulut\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Usulut\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Usulut\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Usulut\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Usulut\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Usulut\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Usulut\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Usulut\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Usulut\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Usulut\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Usulut\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Usulut\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Usulut\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Usulut\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Usulut\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Usulut\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Usulut\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Usulut\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Usulut\xe1n (Department of El Salvador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Utah (State of United States)": [
            {
                "Region Name": "Utah (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Utah (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Utah (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Utah (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Utah (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Utah (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Utah (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Utah (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Utah (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Utah (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Utah (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Utah (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Utah (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Utah (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Utah (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Utah (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Utah (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Utah (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Utah (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Utah (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Utah (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Utah (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Utenos (County of Lithuania)": [
            {
                "Region Name": "Utenos (County of Lithuania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utenos (County of Lithuania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Utenos (County of Lithuania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Utenos (County of Lithuania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utenos (County of Lithuania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Utenos (County of Lithuania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utenos (County of Lithuania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utenos (County of Lithuania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Utenos (County of Lithuania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utenos (County of Lithuania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utenos (County of Lithuania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utenos (County of Lithuania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utenos (County of Lithuania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utenos (County of Lithuania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utenos (County of Lithuania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utenos (County of Lithuania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utenos (County of Lithuania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utenos (County of Lithuania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utenos (County of Lithuania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utenos (County of Lithuania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utenos (County of Lithuania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utenos (County of Lithuania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Uthai Thani (Province of Thailand)": [
            {
                "Region Name": "Uthai Thani (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Uthai Thani (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Uthai Thani (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Uthai Thani (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Uthai Thani (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Uthai Thani (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Uthai Thani (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Uthai Thani (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Uthai Thani (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Uthai Thani (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uthai Thani (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uthai Thani (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Uthai Thani (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Uthai Thani (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Uthai Thani (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Uthai Thani (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Uthai Thani (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Uthai Thani (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Uthai Thani (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Uthai Thani (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Uthai Thani (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uthai Thani (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Utirik (Atol of Marshall Islands)": [
            {
                "Region Name": "Utirik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utirik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utirik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utirik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utirik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utirik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utirik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utirik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utirik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utirik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utirik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utirik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utirik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utirik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utirik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utirik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utirik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utirik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utirik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utirik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utirik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utirik (Atol of Marshall Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Utrecht (Province of Netherlands)": [
            {
                "Region Name": "Utrecht (Province of Netherlands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utrecht (Province of Netherlands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utrecht (Province of Netherlands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utrecht (Province of Netherlands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utrecht (Province of Netherlands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utrecht (Province of Netherlands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utrecht (Province of Netherlands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utrecht (Province of Netherlands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utrecht (Province of Netherlands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utrecht (Province of Netherlands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utrecht (Province of Netherlands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utrecht (Province of Netherlands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utrecht (Province of Netherlands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utrecht (Province of Netherlands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utrecht (Province of Netherlands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utrecht (Province of Netherlands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utrecht (Province of Netherlands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utrecht (Province of Netherlands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utrecht (Province of Netherlands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utrecht (Province of Netherlands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utrecht (Province of Netherlands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utrecht (Province of Netherlands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Uttar Pradesh (State of India)": [
            {
                "Region Name": "Uttar Pradesh (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Uttar Pradesh (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Uttar Pradesh (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Uttar Pradesh (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Uttar Pradesh (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Uttar Pradesh (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Uttar Pradesh (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Uttar Pradesh (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Uttar Pradesh (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Uttar Pradesh (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Uttar Pradesh (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Uttar Pradesh (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Uttar Pradesh (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Uttar Pradesh (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Uttar Pradesh (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Uttar Pradesh (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Uttar Pradesh (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Uttar Pradesh (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Uttar Pradesh (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Uttar Pradesh (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Uttar Pradesh (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Uttar Pradesh (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Uttaradit (Province of Thailand)": [
            {
                "Region Name": "Uttaradit (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Uttaradit (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uttaradit (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uttaradit (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uttaradit (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Uttaradit (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Uttaradit (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Uttaradit (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Uttaradit (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Uttaradit (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Uttaradit (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Uttaradit (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uttaradit (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uttaradit (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uttaradit (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Uttaradit (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uttaradit (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uttaradit (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Uttaradit (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Uttaradit (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Uttaradit (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Uttaradit (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Uttarakhand (State of India)": [
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uttarakhand (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Utuado (Municipality of Puerto Rico)": [
            {
                "Region Name": "Utuado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utuado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utuado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utuado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utuado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utuado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utuado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utuado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utuado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utuado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utuado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utuado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utuado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utuado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utuado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utuado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utuado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utuado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utuado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utuado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utuado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Utuado (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Uv\xe9a (Kingdom of Wallis and Futuna)": [
            {
                "Region Name": "Uv\xe9a (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uv\xe9a (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uv\xe9a (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uv\xe9a (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uv\xe9a (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uv\xe9a (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uv\xe9a (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uv\xe9a (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uv\xe9a (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uv\xe9a (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uv\xe9a (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uv\xe9a (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uv\xe9a (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uv\xe9a (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uv\xe9a (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uv\xe9a (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uv\xe9a (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uv\xe9a (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uv\xe9a (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uv\xe9a (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uv\xe9a (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uv\xe9a (Kingdom of Wallis and Futuna)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Uvs (Province of Mongolia)": [
            {
                "Region Name": "Uvs (Province of Mongolia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Uvs (Province of Mongolia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Uvs (Province of Mongolia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uvs (Province of Mongolia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Uvs (Province of Mongolia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Uvs (Province of Mongolia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Uvs (Province of Mongolia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Uvs (Province of Mongolia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uvs (Province of Mongolia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Uvs (Province of Mongolia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Uvs (Province of Mongolia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Uvs (Province of Mongolia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Uvs (Province of Mongolia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Uvs (Province of Mongolia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uvs (Province of Mongolia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uvs (Province of Mongolia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uvs (Province of Mongolia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Uvs (Province of Mongolia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uvs (Province of Mongolia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Uvs (Province of Mongolia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Uvs (Province of Mongolia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Uvs (Province of Mongolia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Va'a-o-Fonoti (District of Samoa)": [
            {
                "Region Name": "Va'a-o-Fonoti (District of Samoa)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Va'a-o-Fonoti (District of Samoa)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Va'a-o-Fonoti (District of Samoa)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Va'a-o-Fonoti (District of Samoa)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Va'a-o-Fonoti (District of Samoa)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Va'a-o-Fonoti (District of Samoa)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Va'a-o-Fonoti (District of Samoa)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Va'a-o-Fonoti (District of Samoa)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Va'a-o-Fonoti (District of Samoa)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Va'a-o-Fonoti (District of Samoa)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Va'a-o-Fonoti (District of Samoa)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Va'a-o-Fonoti (District of Samoa)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Va'a-o-Fonoti (District of Samoa)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Va'a-o-Fonoti (District of Samoa)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Va'a-o-Fonoti (District of Samoa)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Va'a-o-Fonoti (District of Samoa)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Va'a-o-Fonoti (District of Samoa)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Va'a-o-Fonoti (District of Samoa)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Va'a-o-Fonoti (District of Samoa)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Va'a-o-Fonoti (District of Samoa)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Va'a-o-Fonoti (District of Samoa)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Va'a-o-Fonoti (District of Samoa)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "V\xe1g\xf8 (Region of Faroe Islands)": [
            {
                "Region Name": "V\xe1g\xf8 (Region of Faroe Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe1g\xf8 (Region of Faroe Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe1g\xf8 (Region of Faroe Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe1g\xf8 (Region of Faroe Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe1g\xf8 (Region of Faroe Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe1g\xf8 (Region of Faroe Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe1g\xf8 (Region of Faroe Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe1g\xf8 (Region of Faroe Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe1g\xf8 (Region of Faroe Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe1g\xf8 (Region of Faroe Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe1g\xf8 (Region of Faroe Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe1g\xf8 (Region of Faroe Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe1g\xf8 (Region of Faroe Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe1g\xf8 (Region of Faroe Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe1g\xf8 (Region of Faroe Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe1g\xf8 (Region of Faroe Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe1g\xf8 (Region of Faroe Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe1g\xf8 (Region of Faroe Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe1g\xf8 (Region of Faroe Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe1g\xf8 (Region of Faroe Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe1g\xf8 (Region of Faroe Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe1g\xf8 (Region of Faroe Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vaisigano (District of Samoa)": [
            {
                "Region Name": "Vaisigano (District of Samoa)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaisigano (District of Samoa)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaisigano (District of Samoa)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaisigano (District of Samoa)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaisigano (District of Samoa)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaisigano (District of Samoa)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaisigano (District of Samoa)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaisigano (District of Samoa)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaisigano (District of Samoa)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaisigano (District of Samoa)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaisigano (District of Samoa)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaisigano (District of Samoa)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaisigano (District of Samoa)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaisigano (District of Samoa)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaisigano (District of Samoa)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaisigano (District of Samoa)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaisigano (District of Samoa)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaisigano (District of Samoa)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaisigano (District of Samoa)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaisigano (District of Samoa)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaisigano (District of Samoa)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaisigano (District of Samoa)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vaitupu (Island Council of Tuvalu)": [
            {
                "Region Name": "Vaitupu (Island Council of Tuvalu)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaitupu (Island Council of Tuvalu)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaitupu (Island Council of Tuvalu)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaitupu (Island Council of Tuvalu)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaitupu (Island Council of Tuvalu)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaitupu (Island Council of Tuvalu)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaitupu (Island Council of Tuvalu)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaitupu (Island Council of Tuvalu)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaitupu (Island Council of Tuvalu)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaitupu (Island Council of Tuvalu)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaitupu (Island Council of Tuvalu)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaitupu (Island Council of Tuvalu)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaitupu (Island Council of Tuvalu)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaitupu (Island Council of Tuvalu)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaitupu (Island Council of Tuvalu)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaitupu (Island Council of Tuvalu)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaitupu (Island Council of Tuvalu)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaitupu (Island Council of Tuvalu)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaitupu (Island Council of Tuvalu)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaitupu (Island Council of Tuvalu)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaitupu (Island Council of Tuvalu)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaitupu (Island Council of Tuvalu)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vakaga (Prefecture of Central African Republic)": [
            {
                "Region Name": "Vakaga (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 83
            },
            {
                "Region Name": "Vakaga (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 104
            },
            {
                "Region Name": "Vakaga (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 76
            },
            {
                "Region Name": "Vakaga (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "Vakaga (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 79
            },
            {
                "Region Name": "Vakaga (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Vakaga (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 72
            },
            {
                "Region Name": "Vakaga (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Vakaga (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Vakaga (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Vakaga (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Vakaga (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Vakaga (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Vakaga (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Vakaga (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Vakaga (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Vakaga (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Vakaga (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Vakaga (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Vakaga (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Vakaga (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Vakaga (Prefecture of Central African Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 26
            }
        ],
        "Valais (Canton of Switzerland)": [
            {
                "Region Name": "Valais (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valais (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Valais (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valais (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valais (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valais (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valais (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valais (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valais (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valais (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valais (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valais (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valais (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valais (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valais (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valais (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valais (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valais (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valais (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valais (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valais (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valais (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Valandovo (Municipality of North Macedonia)": [
            {
                "Region Name": "Valandovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Valandovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valandovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valandovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valandovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valandovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Valandovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valandovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valandovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valandovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valandovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Valandovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valandovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valandovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valandovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valandovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Valandovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valandovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valandovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valandovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Valandovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valandovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "V\xe2lcea (County of Romania)": [
            {
                "Region Name": "V\xe2lcea (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe2lcea (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe2lcea (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe2lcea (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe2lcea (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe2lcea (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe2lcea (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe2lcea (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe2lcea (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe2lcea (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "V\xe2lcea (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "V\xe2lcea (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe2lcea (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe2lcea (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe2lcea (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe2lcea (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe2lcea (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe2lcea (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "V\xe2lcea (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe2lcea (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "V\xe2lcea (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "V\xe2lcea (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Valduz (Commune of Liechtenstein)": [
            {
                "Region Name": "Valduz (Commune of Liechtenstein)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valduz (Commune of Liechtenstein)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valduz (Commune of Liechtenstein)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valduz (Commune of Liechtenstein)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valduz (Commune of Liechtenstein)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valduz (Commune of Liechtenstein)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valduz (Commune of Liechtenstein)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valduz (Commune of Liechtenstein)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valduz (Commune of Liechtenstein)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valduz (Commune of Liechtenstein)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valduz (Commune of Liechtenstein)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valduz (Commune of Liechtenstein)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valduz (Commune of Liechtenstein)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valduz (Commune of Liechtenstein)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valduz (Commune of Liechtenstein)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valduz (Commune of Liechtenstein)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valduz (Commune of Liechtenstein)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valduz (Commune of Liechtenstein)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valduz (Commune of Liechtenstein)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valduz (Commune of Liechtenstein)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valduz (Commune of Liechtenstein)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valduz (Commune of Liechtenstein)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vale (Parish of Guernsey)": [
            {
                "Region Name": "Vale (Parish of Guernsey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vale (Parish of Guernsey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vale (Parish of Guernsey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vale (Parish of Guernsey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vale (Parish of Guernsey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vale (Parish of Guernsey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vale (Parish of Guernsey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vale (Parish of Guernsey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vale (Parish of Guernsey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vale (Parish of Guernsey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vale (Parish of Guernsey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vale (Parish of Guernsey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vale (Parish of Guernsey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vale (Parish of Guernsey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vale (Parish of Guernsey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vale (Parish of Guernsey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vale (Parish of Guernsey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vale (Parish of Guernsey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vale (Parish of Guernsey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vale (Parish of Guernsey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vale (Parish of Guernsey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vale (Parish of Guernsey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Valga (County of Estonia)": [
            {
                "Region Name": "Valga (County of Estonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valga (County of Estonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Valga (County of Estonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Valga (County of Estonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valga (County of Estonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valga (County of Estonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valga (County of Estonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valga (County of Estonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valga (County of Estonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valga (County of Estonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valga (County of Estonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valga (County of Estonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valga (County of Estonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valga (County of Estonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valga (County of Estonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valga (County of Estonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valga (County of Estonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valga (County of Estonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valga (County of Estonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valga (County of Estonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valga (County of Estonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Valga (County of Estonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Valle (Department of Honduras)": [
            {
                "Region Name": "Valle (Department of Honduras)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Valle (Department of Honduras)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Valle (Department of Honduras)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Valle (Department of Honduras)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Valle (Department of Honduras)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Valle (Department of Honduras)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valle (Department of Honduras)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valle (Department of Honduras)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Valle (Department of Honduras)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valle (Department of Honduras)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Valle (Department of Honduras)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Valle (Department of Honduras)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Valle (Department of Honduras)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Valle (Department of Honduras)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Valle (Department of Honduras)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Valle (Department of Honduras)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Valle (Department of Honduras)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Valle (Department of Honduras)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Valle (Department of Honduras)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Valle (Department of Honduras)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Valle (Department of Honduras)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Valle (Department of Honduras)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Valle d'Aosta (Autonomous Region of Italy)": [
            {
                "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valle d'Aosta (Autonomous Region of Italy)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Valle del Cauca (Department of Colombia)": [
            {
                "Region Name": "Valle del Cauca (Department of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Valle del Cauca (Department of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Valle del Cauca (Department of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Valle del Cauca (Department of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Valle del Cauca (Department of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Valle del Cauca (Department of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Valle del Cauca (Department of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Valle del Cauca (Department of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Valle del Cauca (Department of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Valle del Cauca (Department of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Valle del Cauca (Department of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Valle del Cauca (Department of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Valle del Cauca (Department of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Valle del Cauca (Department of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Valle del Cauca (Department of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Valle del Cauca (Department of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Valle del Cauca (Department of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Valle del Cauca (Department of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Valle del Cauca (Department of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Valle del Cauca (Department of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Valle del Cauca (Department of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Valle del Cauca (Department of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Vall\xe9e du Bandama (District of C\xf4te d'Ivoire)": [
            {
                "Region Name": "Vall\xe9e du Bandama (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Vall\xe9e du Bandama (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Vall\xe9e du Bandama (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Vall\xe9e du Bandama (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vall\xe9e du Bandama (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Vall\xe9e du Bandama (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Vall\xe9e du Bandama (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vall\xe9e du Bandama (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vall\xe9e du Bandama (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vall\xe9e du Bandama (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Vall\xe9e du Bandama (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Vall\xe9e du Bandama (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Vall\xe9e du Bandama (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Vall\xe9e du Bandama (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Vall\xe9e du Bandama (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vall\xe9e du Bandama (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vall\xe9e du Bandama (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vall\xe9e du Bandama (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vall\xe9e du Bandama (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vall\xe9e du Bandama (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vall\xe9e du Bandama (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vall\xe9e du Bandama (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Valpara\xedso (Region of Chile)": [
            {
                "Region Name": "Valpara\xedso (Region of Chile)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Valpara\xedso (Region of Chile)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Valpara\xedso (Region of Chile)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Valpara\xedso (Region of Chile)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Valpara\xedso (Region of Chile)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Valpara\xedso (Region of Chile)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Valpara\xedso (Region of Chile)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Valpara\xedso (Region of Chile)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Valpara\xedso (Region of Chile)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Valpara\xedso (Region of Chile)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Valpara\xedso (Region of Chile)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Valpara\xedso (Region of Chile)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 122
            },
            {
                "Region Name": "Valpara\xedso (Region of Chile)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Valpara\xedso (Region of Chile)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Valpara\xedso (Region of Chile)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Valpara\xedso (Region of Chile)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Valpara\xedso (Region of Chile)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Valpara\xedso (Region of Chile)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Valpara\xedso (Region of Chile)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Valpara\xedso (Region of Chile)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Valpara\xedso (Region of Chile)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Valpara\xedso (Region of Chile)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 70
            }
        ],
        "Valverde (Province of Dominican Republic)": [
            {
                "Region Name": "Valverde (Province of Dominican Republic)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valverde (Province of Dominican Republic)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valverde (Province of Dominican Republic)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Valverde (Province of Dominican Republic)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valverde (Province of Dominican Republic)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valverde (Province of Dominican Republic)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Valverde (Province of Dominican Republic)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valverde (Province of Dominican Republic)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valverde (Province of Dominican Republic)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valverde (Province of Dominican Republic)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Valverde (Province of Dominican Republic)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Valverde (Province of Dominican Republic)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Valverde (Province of Dominican Republic)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Valverde (Province of Dominican Republic)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valverde (Province of Dominican Republic)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valverde (Province of Dominican Republic)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Valverde (Province of Dominican Republic)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valverde (Province of Dominican Republic)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valverde (Province of Dominican Republic)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valverde (Province of Dominican Republic)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Valverde (Province of Dominican Republic)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Valverde (Province of Dominican Republic)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Van (Province of Turkey)": [
            {
                "Region Name": "Van (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Van (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Van (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Van (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Van (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Van (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Van (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Van (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Van (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Van (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Van (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Van (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Van (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Van (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Van (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Van (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Van (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Van (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Van (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Van (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Van (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Van (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vara\u017Edinska (County of Croatia)": [
            {
                "Region Name": "Vara\u017Edinska (County of Croatia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vara\u017Edinska (County of Croatia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vara\u017Edinska (County of Croatia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vara\u017Edinska (County of Croatia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vara\u017Edinska (County of Croatia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vara\u017Edinska (County of Croatia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vara\u017Edinska (County of Croatia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vara\u017Edinska (County of Croatia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vara\u017Edinska (County of Croatia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vara\u017Edinska (County of Croatia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vara\u017Edinska (County of Croatia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vara\u017Edinska (County of Croatia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vara\u017Edinska (County of Croatia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vara\u017Edinska (County of Croatia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vara\u017Edinska (County of Croatia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vara\u017Edinska (County of Croatia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vara\u017Edinska (County of Croatia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vara\u017Edinska (County of Croatia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vara\u017Edinska (County of Croatia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vara\u017Edinska (County of Croatia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vara\u017Edinska (County of Croatia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vara\u017Edinska (County of Croatia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vargas (State of Venezuela)": [
            {
                "Region Name": "Vargas (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vargas (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vargas (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vargas (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vargas (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vargas (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vargas (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vargas (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vargas (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vargas (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vargas (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vargas (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vargas (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vargas (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vargas (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vargas (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vargas (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vargas (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vargas (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vargas (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vargas (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vargas (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "V\xe4rmland (County of Sweden)": [
            {
                "Region Name": "V\xe4rmland (County of Sweden)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4rmland (County of Sweden)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4rmland (County of Sweden)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4rmland (County of Sweden)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4rmland (County of Sweden)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4rmland (County of Sweden)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4rmland (County of Sweden)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4rmland (County of Sweden)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4rmland (County of Sweden)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4rmland (County of Sweden)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4rmland (County of Sweden)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4rmland (County of Sweden)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4rmland (County of Sweden)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4rmland (County of Sweden)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4rmland (County of Sweden)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4rmland (County of Sweden)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4rmland (County of Sweden)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4rmland (County of Sweden)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4rmland (County of Sweden)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4rmland (County of Sweden)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4rmland (County of Sweden)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4rmland (County of Sweden)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Varna (Province of Bulgaria)": [
            {
                "Region Name": "Varna (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Varna (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Varna (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Varna (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Varna (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Varna (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Varna (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Varna (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Varna (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Varna (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Varna (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Varna (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Varna (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Varna (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Varna (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Varna (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Varna (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Varna (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Varna (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Varna (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Varna (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Varna (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vas (County of Hungary)": [
            {
                "Region Name": "Vas (County of Hungary)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vas (County of Hungary)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vas (County of Hungary)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vas (County of Hungary)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vas (County of Hungary)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vas (County of Hungary)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vas (County of Hungary)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vas (County of Hungary)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vas (County of Hungary)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vas (County of Hungary)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vas (County of Hungary)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vas (County of Hungary)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vas (County of Hungary)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vas (County of Hungary)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vas (County of Hungary)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vas (County of Hungary)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vas (County of Hungary)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vas (County of Hungary)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vas (County of Hungary)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vas (County of Hungary)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vas (County of Hungary)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vas (County of Hungary)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vasilevo (Municipality of North Macedonia)": [
            {
                "Region Name": "Vasilevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vasilevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vasilevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vasilevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vasilevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vasilevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vasilevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vasilevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vasilevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vasilevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vasilevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vasilevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vasilevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vasilevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vasilevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vasilevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vasilevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vasilevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vasilevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vasilevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vasilevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vasilevo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vaslui (County of Romania)": [
            {
                "Region Name": "Vaslui (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaslui (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaslui (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vaslui (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vaslui (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vaslui (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vaslui (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vaslui (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vaslui (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Vaslui (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vaslui (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vaslui (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vaslui (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vaslui (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vaslui (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vaslui (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vaslui (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaslui (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vaslui (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaslui (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaslui (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vaslui (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "V\xe4sterbotten (County of Sweden)": [
            {
                "Region Name": "V\xe4sterbotten (County of Sweden)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sterbotten (County of Sweden)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sterbotten (County of Sweden)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sterbotten (County of Sweden)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sterbotten (County of Sweden)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "V\xe4sterbotten (County of Sweden)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sterbotten (County of Sweden)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sterbotten (County of Sweden)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sterbotten (County of Sweden)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sterbotten (County of Sweden)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sterbotten (County of Sweden)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sterbotten (County of Sweden)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sterbotten (County of Sweden)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sterbotten (County of Sweden)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sterbotten (County of Sweden)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sterbotten (County of Sweden)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sterbotten (County of Sweden)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sterbotten (County of Sweden)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sterbotten (County of Sweden)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sterbotten (County of Sweden)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sterbotten (County of Sweden)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sterbotten (County of Sweden)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "V\xe4sternorrland (County of Sweden)": [
            {
                "Region Name": "V\xe4sternorrland (County of Sweden)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sternorrland (County of Sweden)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sternorrland (County of Sweden)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sternorrland (County of Sweden)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sternorrland (County of Sweden)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sternorrland (County of Sweden)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sternorrland (County of Sweden)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sternorrland (County of Sweden)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sternorrland (County of Sweden)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sternorrland (County of Sweden)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sternorrland (County of Sweden)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sternorrland (County of Sweden)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sternorrland (County of Sweden)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sternorrland (County of Sweden)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sternorrland (County of Sweden)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sternorrland (County of Sweden)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sternorrland (County of Sweden)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sternorrland (County of Sweden)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sternorrland (County of Sweden)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sternorrland (County of Sweden)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sternorrland (County of Sweden)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4sternorrland (County of Sweden)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "V\xe4stmanland (County of Sweden)": [
            {
                "Region Name": "V\xe4stmanland (County of Sweden)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stmanland (County of Sweden)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stmanland (County of Sweden)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stmanland (County of Sweden)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stmanland (County of Sweden)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stmanland (County of Sweden)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stmanland (County of Sweden)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stmanland (County of Sweden)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stmanland (County of Sweden)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stmanland (County of Sweden)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stmanland (County of Sweden)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stmanland (County of Sweden)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stmanland (County of Sweden)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "V\xe4stmanland (County of Sweden)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stmanland (County of Sweden)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stmanland (County of Sweden)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stmanland (County of Sweden)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stmanland (County of Sweden)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stmanland (County of Sweden)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stmanland (County of Sweden)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stmanland (County of Sweden)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stmanland (County of Sweden)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "V\xe4stra G\xf6taland (County of Sweden)": [
            {
                "Region Name": "V\xe4stra G\xf6taland (County of Sweden)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stra G\xf6taland (County of Sweden)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stra G\xf6taland (County of Sweden)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stra G\xf6taland (County of Sweden)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stra G\xf6taland (County of Sweden)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stra G\xf6taland (County of Sweden)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stra G\xf6taland (County of Sweden)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stra G\xf6taland (County of Sweden)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stra G\xf6taland (County of Sweden)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stra G\xf6taland (County of Sweden)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stra G\xf6taland (County of Sweden)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stra G\xf6taland (County of Sweden)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stra G\xf6taland (County of Sweden)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stra G\xf6taland (County of Sweden)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stra G\xf6taland (County of Sweden)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stra G\xf6taland (County of Sweden)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stra G\xf6taland (County of Sweden)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "V\xe4stra G\xf6taland (County of Sweden)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stra G\xf6taland (County of Sweden)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stra G\xf6taland (County of Sweden)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stra G\xf6taland (County of Sweden)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xe4stra G\xf6taland (County of Sweden)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vaud (Canton of Switzerland)": [
            {
                "Region Name": "Vaud (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaud (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaud (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaud (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaud (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaud (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaud (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaud (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaud (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaud (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaud (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaud (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaud (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vaud (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaud (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaud (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaud (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaud (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaud (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaud (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaud (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaud (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vaup\xe9s (Commissiary of Colombia)": [
            {
                "Region Name": "Vaup\xe9s (Commissiary of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaup\xe9s (Commissiary of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vaup\xe9s (Commissiary of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vaup\xe9s (Commissiary of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaup\xe9s (Commissiary of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Vaup\xe9s (Commissiary of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vaup\xe9s (Commissiary of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaup\xe9s (Commissiary of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaup\xe9s (Commissiary of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vaup\xe9s (Commissiary of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vaup\xe9s (Commissiary of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vaup\xe9s (Commissiary of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vaup\xe9s (Commissiary of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaup\xe9s (Commissiary of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vaup\xe9s (Commissiary of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vaup\xe9s (Commissiary of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaup\xe9s (Commissiary of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaup\xe9s (Commissiary of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaup\xe9s (Commissiary of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vaup\xe9s (Commissiary of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaup\xe9s (Commissiary of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vaup\xe9s (Commissiary of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vava'u (Island Group of Tonga)": [
            {
                "Region Name": "Vava'u (Island Group of Tonga)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vava'u (Island Group of Tonga)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vava'u (Island Group of Tonga)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vava'u (Island Group of Tonga)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vava'u (Island Group of Tonga)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vava'u (Island Group of Tonga)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vava'u (Island Group of Tonga)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vava'u (Island Group of Tonga)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vava'u (Island Group of Tonga)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vava'u (Island Group of Tonga)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vava'u (Island Group of Tonga)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vava'u (Island Group of Tonga)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vava'u (Island Group of Tonga)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vava'u (Island Group of Tonga)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vava'u (Island Group of Tonga)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vava'u (Island Group of Tonga)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vava'u (Island Group of Tonga)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vava'u (Island Group of Tonga)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vava'u (Island Group of Tonga)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vava'u (Island Group of Tonga)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vava'u (Island Group of Tonga)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vava'u (Island Group of Tonga)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vavuniya (District of Sri Lanka)": [
            {
                "Region Name": "Vavuniya (District of Sri Lanka)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vavuniya (District of Sri Lanka)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vavuniya (District of Sri Lanka)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vavuniya (District of Sri Lanka)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vavuniya (District of Sri Lanka)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vavuniya (District of Sri Lanka)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vavuniya (District of Sri Lanka)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vavuniya (District of Sri Lanka)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vavuniya (District of Sri Lanka)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vavuniya (District of Sri Lanka)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vavuniya (District of Sri Lanka)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vavuniya (District of Sri Lanka)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vavuniya (District of Sri Lanka)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vavuniya (District of Sri Lanka)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vavuniya (District of Sri Lanka)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vavuniya (District of Sri Lanka)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vavuniya (District of Sri Lanka)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vavuniya (District of Sri Lanka)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vavuniya (District of Sri Lanka)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vavuniya (District of Sri Lanka)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vavuniya (District of Sri Lanka)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vavuniya (District of Sri Lanka)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Vayots Dzor (Province of Armenia)": [
            {
                "Region Name": "Vayots Dzor (Province of Armenia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vayots Dzor (Province of Armenia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vayots Dzor (Province of Armenia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vayots Dzor (Province of Armenia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vayots Dzor (Province of Armenia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vayots Dzor (Province of Armenia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vayots Dzor (Province of Armenia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vayots Dzor (Province of Armenia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vayots Dzor (Province of Armenia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vayots Dzor (Province of Armenia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vayots Dzor (Province of Armenia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vayots Dzor (Province of Armenia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vayots Dzor (Province of Armenia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Vayots Dzor (Province of Armenia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vayots Dzor (Province of Armenia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vayots Dzor (Province of Armenia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vayots Dzor (Province of Armenia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Vayots Dzor (Province of Armenia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vayots Dzor (Province of Armenia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vayots Dzor (Province of Armenia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vayots Dzor (Province of Armenia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vayots Dzor (Province of Armenia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Vega Alta (Municipality of Puerto Rico)": [
            {
                "Region Name": "Vega Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Alta (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vega Baja (Municipality of Puerto Rico)": [
            {
                "Region Name": "Vega Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vega Baja (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Veles (Municipality of North Macedonia)": [
            {
                "Region Name": "Veles (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veles (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veles (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veles (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veles (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veles (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Veles (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veles (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veles (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veles (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Veles (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veles (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veles (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veles (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veles (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veles (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veles (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veles (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Veles (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veles (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veles (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veles (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Veliko Tarnovo (Province of Bulgaria)": [
            {
                "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Veliko Tarnovo (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Veneto (Region of Italy)": [
            {
                "Region Name": "Veneto (Region of Italy)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Veneto (Region of Italy)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veneto (Region of Italy)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Veneto (Region of Italy)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Veneto (Region of Italy)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Veneto (Region of Italy)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Veneto (Region of Italy)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veneto (Region of Italy)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Veneto (Region of Italy)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Veneto (Region of Italy)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Veneto (Region of Italy)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Veneto (Region of Italy)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Veneto (Region of Italy)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Veneto (Region of Italy)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veneto (Region of Italy)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Veneto (Region of Italy)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Veneto (Region of Italy)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Veneto (Region of Italy)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Veneto (Region of Italy)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Veneto (Region of Italy)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Veneto (Region of Italy)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veneto (Region of Italy)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Veracruz (State of M\xe9xico)": [
            {
                "Region Name": "Veracruz (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veracruz (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Veracruz (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veracruz (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veracruz (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veracruz (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veracruz (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veracruz (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veracruz (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veracruz (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veracruz (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veracruz (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veracruz (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veracruz (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Veracruz (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veracruz (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veracruz (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veracruz (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Veracruz (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veracruz (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veracruz (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Veracruz (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Veraguas (Province of Panama)": [
            {
                "Region Name": "Veraguas (Province of Panama)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Veraguas (Province of Panama)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Veraguas (Province of Panama)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Veraguas (Province of Panama)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Veraguas (Province of Panama)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veraguas (Province of Panama)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veraguas (Province of Panama)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Veraguas (Province of Panama)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veraguas (Province of Panama)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Veraguas (Province of Panama)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Veraguas (Province of Panama)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veraguas (Province of Panama)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Veraguas (Province of Panama)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Veraguas (Province of Panama)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Veraguas (Province of Panama)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Veraguas (Province of Panama)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Veraguas (Province of Panama)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veraguas (Province of Panama)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Veraguas (Province of Panama)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Veraguas (Province of Panama)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Veraguas (Province of Panama)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Veraguas (Province of Panama)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Vermont (State of United States)": [
            {
                "Region Name": "Vermont (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vermont (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vermont (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vermont (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vermont (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vermont (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vermont (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vermont (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vermont (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vermont (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vermont (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vermont (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vermont (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vermont (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vermont (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vermont (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vermont (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vermont (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vermont (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vermont (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vermont (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vermont (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Vest-Agder (County of Norway)": [
            {
                "Region Name": "Vest-Agder (County of Norway)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vest-Agder (County of Norway)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vest-Agder (County of Norway)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vest-Agder (County of Norway)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vest-Agder (County of Norway)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vest-Agder (County of Norway)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vest-Agder (County of Norway)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vest-Agder (County of Norway)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vest-Agder (County of Norway)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vest-Agder (County of Norway)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vest-Agder (County of Norway)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vest-Agder (County of Norway)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vest-Agder (County of Norway)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vest-Agder (County of Norway)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vest-Agder (County of Norway)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vest-Agder (County of Norway)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vest-Agder (County of Norway)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vest-Agder (County of Norway)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vest-Agder (County of Norway)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vest-Agder (County of Norway)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vest-Agder (County of Norway)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vest-Agder (County of Norway)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vestfir\xf0ir (Region of Iceland)": [
            {
                "Region Name": "Vestfir\xf0ir (Region of Iceland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfir\xf0ir (Region of Iceland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfir\xf0ir (Region of Iceland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfir\xf0ir (Region of Iceland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfir\xf0ir (Region of Iceland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfir\xf0ir (Region of Iceland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfir\xf0ir (Region of Iceland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfir\xf0ir (Region of Iceland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfir\xf0ir (Region of Iceland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfir\xf0ir (Region of Iceland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfir\xf0ir (Region of Iceland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfir\xf0ir (Region of Iceland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfir\xf0ir (Region of Iceland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfir\xf0ir (Region of Iceland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfir\xf0ir (Region of Iceland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfir\xf0ir (Region of Iceland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfir\xf0ir (Region of Iceland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfir\xf0ir (Region of Iceland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfir\xf0ir (Region of Iceland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfir\xf0ir (Region of Iceland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfir\xf0ir (Region of Iceland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfir\xf0ir (Region of Iceland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vestfold (County of Norway)": [
            {
                "Region Name": "Vestfold (County of Norway)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfold (County of Norway)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfold (County of Norway)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfold (County of Norway)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfold (County of Norway)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfold (County of Norway)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfold (County of Norway)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfold (County of Norway)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfold (County of Norway)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfold (County of Norway)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfold (County of Norway)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfold (County of Norway)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfold (County of Norway)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfold (County of Norway)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfold (County of Norway)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfold (County of Norway)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfold (County of Norway)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfold (County of Norway)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfold (County of Norway)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfold (County of Norway)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfold (County of Norway)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vestfold (County of Norway)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vesturland (Region of Iceland)": [
            {
                "Region Name": "Vesturland (Region of Iceland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vesturland (Region of Iceland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vesturland (Region of Iceland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vesturland (Region of Iceland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vesturland (Region of Iceland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Vesturland (Region of Iceland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vesturland (Region of Iceland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vesturland (Region of Iceland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vesturland (Region of Iceland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vesturland (Region of Iceland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vesturland (Region of Iceland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vesturland (Region of Iceland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vesturland (Region of Iceland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vesturland (Region of Iceland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vesturland (Region of Iceland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vesturland (Region of Iceland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vesturland (Region of Iceland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vesturland (Region of Iceland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vesturland (Region of Iceland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vesturland (Region of Iceland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vesturland (Region of Iceland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vesturland (Region of Iceland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Veszpr\xe9m (County of Hungary)": [
            {
                "Region Name": "Veszpr\xe9m (County of Hungary)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Veszpr\xe9m (County of Hungary)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Veszpr\xe9m (County of Hungary)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veszpr\xe9m (County of Hungary)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Veszpr\xe9m (County of Hungary)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Veszpr\xe9m (County of Hungary)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Veszpr\xe9m (County of Hungary)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veszpr\xe9m (County of Hungary)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veszpr\xe9m (County of Hungary)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veszpr\xe9m (County of Hungary)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veszpr\xe9m (County of Hungary)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veszpr\xe9m (County of Hungary)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Veszpr\xe9m (County of Hungary)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Veszpr\xe9m (County of Hungary)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veszpr\xe9m (County of Hungary)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veszpr\xe9m (County of Hungary)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veszpr\xe9m (County of Hungary)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veszpr\xe9m (County of Hungary)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veszpr\xe9m (County of Hungary)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veszpr\xe9m (County of Hungary)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Veszpr\xe9m (County of Hungary)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Veszpr\xe9m (County of Hungary)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vev\u010Dani (Municipality of North Macedonia)": [
            {
                "Region Name": "Vev\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vev\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vev\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vev\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vev\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vev\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vev\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vev\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vev\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vev\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vev\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vev\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vev\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vev\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vev\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vev\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vev\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vev\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vev\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vev\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vev\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vev\u010Dani (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Viana do Castelo (District of Portugal)": [
            {
                "Region Name": "Viana do Castelo (District of Portugal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Viana do Castelo (District of Portugal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Viana do Castelo (District of Portugal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Viana do Castelo (District of Portugal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Viana do Castelo (District of Portugal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Viana do Castelo (District of Portugal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Viana do Castelo (District of Portugal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viana do Castelo (District of Portugal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Viana do Castelo (District of Portugal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Viana do Castelo (District of Portugal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Viana do Castelo (District of Portugal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Viana do Castelo (District of Portugal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Viana do Castelo (District of Portugal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Viana do Castelo (District of Portugal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Viana do Castelo (District of Portugal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Viana do Castelo (District of Portugal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Viana do Castelo (District of Portugal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Viana do Castelo (District of Portugal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Viana do Castelo (District of Portugal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Viana do Castelo (District of Portugal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Viana do Castelo (District of Portugal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Viana do Castelo (District of Portugal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vichada (Commissiary of Colombia)": [
            {
                "Region Name": "Vichada (Commissiary of Colombia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Vichada (Commissiary of Colombia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Vichada (Commissiary of Colombia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Vichada (Commissiary of Colombia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Vichada (Commissiary of Colombia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Vichada (Commissiary of Colombia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Vichada (Commissiary of Colombia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Vichada (Commissiary of Colombia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Vichada (Commissiary of Colombia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Vichada (Commissiary of Colombia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Vichada (Commissiary of Colombia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Vichada (Commissiary of Colombia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Vichada (Commissiary of Colombia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Vichada (Commissiary of Colombia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Vichada (Commissiary of Colombia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Vichada (Commissiary of Colombia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Vichada (Commissiary of Colombia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Vichada (Commissiary of Colombia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Vichada (Commissiary of Colombia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Vichada (Commissiary of Colombia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Vichada (Commissiary of Colombia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Vichada (Commissiary of Colombia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "Victoria (State of Australia)": [
            {
                "Region Name": "Victoria (State of Australia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 178
            },
            {
                "Region Name": "Victoria (State of Australia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Victoria (State of Australia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Victoria (State of Australia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Victoria (State of Australia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 112
            },
            {
                "Region Name": "Victoria (State of Australia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Victoria (State of Australia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Victoria (State of Australia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Victoria (State of Australia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Victoria (State of Australia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Victoria (State of Australia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Victoria (State of Australia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Victoria (State of Australia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Victoria (State of Australia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Victoria (State of Australia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Victoria (State of Australia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Victoria (State of Australia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Victoria (State of Australia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 112
            },
            {
                "Region Name": "Victoria (State of Australia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Victoria (State of Australia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Victoria (State of Australia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Victoria (State of Australia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Vidin (Province of Bulgaria)": [
            {
                "Region Name": "Vidin (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Vidin (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Vidin (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vidin (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vidin (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Vidin (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Vidin (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vidin (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vidin (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vidin (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vidin (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vidin (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Vidin (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vidin (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Vidin (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vidin (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vidin (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vidin (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Vidin (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vidin (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vidin (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vidin (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vidzeme (Province of Latvia)": [
            {
                "Region Name": "Vidzeme (Province of Latvia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vidzeme (Province of Latvia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Vidzeme (Province of Latvia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vidzeme (Province of Latvia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vidzeme (Province of Latvia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vidzeme (Province of Latvia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vidzeme (Province of Latvia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vidzeme (Province of Latvia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vidzeme (Province of Latvia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vidzeme (Province of Latvia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vidzeme (Province of Latvia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vidzeme (Province of Latvia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vidzeme (Province of Latvia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vidzeme (Province of Latvia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vidzeme (Province of Latvia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vidzeme (Province of Latvia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vidzeme (Province of Latvia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vidzeme (Province of Latvia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vidzeme (Province of Latvia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vidzeme (Province of Latvia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vidzeme (Province of Latvia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vidzeme (Province of Latvia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vientiane (Province of Laos)": [
            {
                "Region Name": "Vientiane (Province of Laos)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vientiane (Province of Laos)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vientiane (Province of Laos)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vientiane (Province of Laos)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vientiane (Province of Laos)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vientiane (Province of Laos)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vientiane (Province of Laos)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vientiane (Province of Laos)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vientiane (Province of Laos)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vientiane (Province of Laos)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vientiane (Province of Laos)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vientiane (Province of Laos)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vientiane (Province of Laos)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vientiane (Province of Laos)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vientiane (Province of Laos)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vientiane (Province of Laos)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vientiane (Province of Laos)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vientiane (Province of Laos)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vientiane (Province of Laos)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vientiane (Province of Laos)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vientiane (Province of Laos)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vientiane (Province of Laos)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Vientiane [prefecture] (Municipality|Prefecture of Laos)": [
            {
                "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vientiane [prefecture] (Municipality|Prefecture of Laos)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Vieques (Municipality of Puerto Rico)": [
            {
                "Region Name": "Vieques (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieques (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieques (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieques (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieques (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieques (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieques (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieques (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieques (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieques (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieques (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieques (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieques (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieques (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieques (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieques (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieques (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieques (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieques (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieques (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieques (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieques (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vieux Fort (Quarter of Saint Lucia)": [
            {
                "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vieux Fort (Quarter of Saint Lucia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vihiga (County of Kenya)": [
            {
                "Region Name": "Vihiga (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vihiga (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vihiga (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vihiga (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vihiga (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vihiga (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vihiga (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vihiga (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vihiga (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vihiga (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vihiga (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vihiga (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vihiga (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vihiga (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vihiga (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vihiga (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vihiga (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vihiga (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vihiga (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vihiga (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vihiga (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vihiga (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vila Real (District of Portugal)": [
            {
                "Region Name": "Vila Real (District of Portugal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Vila Real (District of Portugal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Vila Real (District of Portugal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Vila Real (District of Portugal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Vila Real (District of Portugal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vila Real (District of Portugal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vila Real (District of Portugal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vila Real (District of Portugal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Vila Real (District of Portugal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Vila Real (District of Portugal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Vila Real (District of Portugal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vila Real (District of Portugal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Vila Real (District of Portugal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vila Real (District of Portugal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vila Real (District of Portugal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Vila Real (District of Portugal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Vila Real (District of Portugal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vila Real (District of Portugal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vila Real (District of Portugal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Vila Real (District of Portugal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vila Real (District of Portugal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 64
            },
            {
                "Region Name": "Vila Real (District of Portugal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Viljandi (County of Estonia)": [
            {
                "Region Name": "Viljandi (County of Estonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viljandi (County of Estonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viljandi (County of Estonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Viljandi (County of Estonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viljandi (County of Estonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viljandi (County of Estonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viljandi (County of Estonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viljandi (County of Estonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viljandi (County of Estonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viljandi (County of Estonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viljandi (County of Estonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viljandi (County of Estonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viljandi (County of Estonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viljandi (County of Estonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viljandi (County of Estonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viljandi (County of Estonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viljandi (County of Estonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viljandi (County of Estonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viljandi (County of Estonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viljandi (County of Estonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viljandi (County of Estonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viljandi (County of Estonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Villa Clara (Province of Cuba)": [
            {
                "Region Name": "Villa Clara (Province of Cuba)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Villa Clara (Province of Cuba)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Villa Clara (Province of Cuba)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Villa Clara (Province of Cuba)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Villa Clara (Province of Cuba)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Villa Clara (Province of Cuba)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Villa Clara (Province of Cuba)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Villa Clara (Province of Cuba)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Villa Clara (Province of Cuba)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Villa Clara (Province of Cuba)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Villa Clara (Province of Cuba)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Villa Clara (Province of Cuba)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Villa Clara (Province of Cuba)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Villa Clara (Province of Cuba)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Villa Clara (Province of Cuba)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Villa Clara (Province of Cuba)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Villa Clara (Province of Cuba)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Villa Clara (Province of Cuba)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Villa Clara (Province of Cuba)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Villa Clara (Province of Cuba)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Villa Clara (Province of Cuba)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Villa Clara (Province of Cuba)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Villalba (Municipality of Puerto Rico)": [
            {
                "Region Name": "Villalba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Villalba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Villalba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Villalba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Villalba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Villalba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Villalba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Villalba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Villalba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Villalba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Villalba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Villalba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Villalba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Villalba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Villalba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Villalba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Villalba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Villalba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Villalba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Villalba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Villalba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Villalba (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Ville de N'Djamena (Region of Chad)": [
            {
                "Region Name": "Ville de N'Djamena (Region of Chad)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ville de N'Djamena (Region of Chad)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ville de N'Djamena (Region of Chad)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ville de N'Djamena (Region of Chad)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ville de N'Djamena (Region of Chad)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ville de N'Djamena (Region of Chad)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ville de N'Djamena (Region of Chad)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ville de N'Djamena (Region of Chad)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ville de N'Djamena (Region of Chad)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ville de N'Djamena (Region of Chad)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ville de N'Djamena (Region of Chad)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ville de N'Djamena (Region of Chad)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ville de N'Djamena (Region of Chad)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ville de N'Djamena (Region of Chad)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ville de N'Djamena (Region of Chad)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ville de N'Djamena (Region of Chad)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ville de N'Djamena (Region of Chad)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ville de N'Djamena (Region of Chad)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ville de N'Djamena (Region of Chad)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ville de N'Djamena (Region of Chad)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ville de N'Djamena (Region of Chad)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ville de N'Djamena (Region of Chad)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vilniaus (County of Lithuania)": [
            {
                "Region Name": "Vilniaus (County of Lithuania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vilniaus (County of Lithuania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Vilniaus (County of Lithuania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vilniaus (County of Lithuania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vilniaus (County of Lithuania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vilniaus (County of Lithuania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vilniaus (County of Lithuania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vilniaus (County of Lithuania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vilniaus (County of Lithuania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vilniaus (County of Lithuania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vilniaus (County of Lithuania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vilniaus (County of Lithuania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vilniaus (County of Lithuania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vilniaus (County of Lithuania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vilniaus (County of Lithuania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vilniaus (County of Lithuania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vilniaus (County of Lithuania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vilniaus (County of Lithuania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vilniaus (County of Lithuania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vilniaus (County of Lithuania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vilniaus (County of Lithuania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vilniaus (County of Lithuania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "V\u0129nh Long (Province of Vietnam)": [
            {
                "Region Name": "V\u0129nh Long (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "V\u0129nh Long (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "V\u0129nh Long (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "V\u0129nh Long (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "V\u0129nh Long (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "V\u0129nh Long (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "V\u0129nh Long (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "V\u0129nh Long (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "V\u0129nh Long (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "V\u0129nh Long (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "V\u0129nh Long (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "V\u0129nh Long (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "V\u0129nh Long (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "V\u0129nh Long (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "V\u0129nh Long (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\u0129nh Long (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "V\u0129nh Long (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "V\u0129nh Long (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "V\u0129nh Long (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "V\u0129nh Long (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "V\u0129nh Long (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "V\u0129nh Long (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "V\u0129nh Ph\xfac (Province of Vietnam)": [
            {
                "Region Name": "V\u0129nh Ph\xfac (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\u0129nh Ph\xfac (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\u0129nh Ph\xfac (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\u0129nh Ph\xfac (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\u0129nh Ph\xfac (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\u0129nh Ph\xfac (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\u0129nh Ph\xfac (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\u0129nh Ph\xfac (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\u0129nh Ph\xfac (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\u0129nh Ph\xfac (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "V\u0129nh Ph\xfac (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\u0129nh Ph\xfac (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\u0129nh Ph\xfac (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "V\u0129nh Ph\xfac (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\u0129nh Ph\xfac (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\u0129nh Ph\xfac (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\u0129nh Ph\xfac (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\u0129nh Ph\xfac (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\u0129nh Ph\xfac (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\u0129nh Ph\xfac (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\u0129nh Ph\xfac (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\u0129nh Ph\xfac (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Vinitsa (Municipality of North Macedonia)": [
            {
                "Region Name": "Vinitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vinitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vinitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vinitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vinitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vinitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vinitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vinitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vinitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vinitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vinitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vinitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vinitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vinitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vinitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vinitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vinitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vinitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vinitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vinitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vinitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vinitsa (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vinnytsya (Region of Ukraine)": [
            {
                "Region Name": "Vinnytsya (Region of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Vinnytsya (Region of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vinnytsya (Region of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vinnytsya (Region of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vinnytsya (Region of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vinnytsya (Region of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Vinnytsya (Region of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vinnytsya (Region of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vinnytsya (Region of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vinnytsya (Region of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vinnytsya (Region of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vinnytsya (Region of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vinnytsya (Region of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vinnytsya (Region of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vinnytsya (Region of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vinnytsya (Region of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vinnytsya (Region of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vinnytsya (Region of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Vinnytsya (Region of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vinnytsya (Region of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Vinnytsya (Region of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Vinnytsya (Region of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Viqueque (District of Timor-Leste)": [
            {
                "Region Name": "Viqueque (District of Timor-Leste)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Viqueque (District of Timor-Leste)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Viqueque (District of Timor-Leste)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Viqueque (District of Timor-Leste)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Viqueque (District of Timor-Leste)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Viqueque (District of Timor-Leste)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Viqueque (District of Timor-Leste)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Viqueque (District of Timor-Leste)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Viqueque (District of Timor-Leste)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viqueque (District of Timor-Leste)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viqueque (District of Timor-Leste)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viqueque (District of Timor-Leste)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viqueque (District of Timor-Leste)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Viqueque (District of Timor-Leste)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viqueque (District of Timor-Leste)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viqueque (District of Timor-Leste)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Viqueque (District of Timor-Leste)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Viqueque (District of Timor-Leste)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Viqueque (District of Timor-Leste)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Viqueque (District of Timor-Leste)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viqueque (District of Timor-Leste)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viqueque (District of Timor-Leste)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Virgin Gorda (District of British Virgin Islands)": [
            {
                "Region Name": "Virgin Gorda (District of British Virgin Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Virgin Gorda (District of British Virgin Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Virgin Gorda (District of British Virgin Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Virgin Gorda (District of British Virgin Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Virgin Gorda (District of British Virgin Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Virgin Gorda (District of British Virgin Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Virgin Gorda (District of British Virgin Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Virgin Gorda (District of British Virgin Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Virgin Gorda (District of British Virgin Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Virgin Gorda (District of British Virgin Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Virgin Gorda (District of British Virgin Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Virgin Gorda (District of British Virgin Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Virgin Gorda (District of British Virgin Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Virgin Gorda (District of British Virgin Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Virgin Gorda (District of British Virgin Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Virgin Gorda (District of British Virgin Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Virgin Gorda (District of British Virgin Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Virgin Gorda (District of British Virgin Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Virgin Gorda (District of British Virgin Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Virgin Gorda (District of British Virgin Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Virgin Gorda (District of British Virgin Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Virgin Gorda (District of British Virgin Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Virginia (State of United States)": [
            {
                "Region Name": "Virginia (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Virginia (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Virginia (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Virginia (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Virginia (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Virginia (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Virginia (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Virginia (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Virginia (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Virginia (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Virginia (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Virginia (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Virginia (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Virginia (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Virginia (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Virginia (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Virginia (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Virginia (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Virginia (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Virginia (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Virginia (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Virginia (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Viroviticko-Podravska (County of Croatia)": [
            {
                "Region Name": "Viroviticko-Podravska (County of Croatia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Viroviticko-Podravska (County of Croatia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viroviticko-Podravska (County of Croatia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Viroviticko-Podravska (County of Croatia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viroviticko-Podravska (County of Croatia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viroviticko-Podravska (County of Croatia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Viroviticko-Podravska (County of Croatia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viroviticko-Podravska (County of Croatia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viroviticko-Podravska (County of Croatia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Viroviticko-Podravska (County of Croatia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viroviticko-Podravska (County of Croatia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viroviticko-Podravska (County of Croatia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viroviticko-Podravska (County of Croatia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viroviticko-Podravska (County of Croatia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viroviticko-Podravska (County of Croatia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viroviticko-Podravska (County of Croatia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viroviticko-Podravska (County of Croatia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viroviticko-Podravska (County of Croatia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viroviticko-Podravska (County of Croatia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viroviticko-Podravska (County of Croatia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viroviticko-Podravska (County of Croatia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Viroviticko-Podravska (County of Croatia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Viseu (District of Portugal)": [
            {
                "Region Name": "Viseu (District of Portugal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Viseu (District of Portugal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Viseu (District of Portugal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Viseu (District of Portugal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Viseu (District of Portugal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Viseu (District of Portugal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Viseu (District of Portugal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Viseu (District of Portugal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Viseu (District of Portugal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Viseu (District of Portugal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Viseu (District of Portugal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Viseu (District of Portugal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Viseu (District of Portugal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Viseu (District of Portugal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Viseu (District of Portugal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Viseu (District of Portugal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 81
            },
            {
                "Region Name": "Viseu (District of Portugal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Viseu (District of Portugal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Viseu (District of Portugal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Viseu (District of Portugal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Viseu (District of Portugal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Viseu (District of Portugal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Vitebsk (Region of Belarus)": [
            {
                "Region Name": "Vitebsk (Region of Belarus)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Vitebsk (Region of Belarus)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Vitebsk (Region of Belarus)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vitebsk (Region of Belarus)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vitebsk (Region of Belarus)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vitebsk (Region of Belarus)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vitebsk (Region of Belarus)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vitebsk (Region of Belarus)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vitebsk (Region of Belarus)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vitebsk (Region of Belarus)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vitebsk (Region of Belarus)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vitebsk (Region of Belarus)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vitebsk (Region of Belarus)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vitebsk (Region of Belarus)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vitebsk (Region of Belarus)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vitebsk (Region of Belarus)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vitebsk (Region of Belarus)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Vitebsk (Region of Belarus)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vitebsk (Region of Belarus)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vitebsk (Region of Belarus)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vitebsk (Region of Belarus)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vitebsk (Region of Belarus)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Vlaanderen (Region of Belgium)": [
            {
                "Region Name": "Vlaanderen (Region of Belgium)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vlaanderen (Region of Belgium)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vlaanderen (Region of Belgium)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vlaanderen (Region of Belgium)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vlaanderen (Region of Belgium)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vlaanderen (Region of Belgium)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vlaanderen (Region of Belgium)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vlaanderen (Region of Belgium)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vlaanderen (Region of Belgium)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vlaanderen (Region of Belgium)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vlaanderen (Region of Belgium)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vlaanderen (Region of Belgium)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vlaanderen (Region of Belgium)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vlaanderen (Region of Belgium)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vlaanderen (Region of Belgium)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vlaanderen (Region of Belgium)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vlaanderen (Region of Belgium)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vlaanderen (Region of Belgium)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vlaanderen (Region of Belgium)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vlaanderen (Region of Belgium)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vlaanderen (Region of Belgium)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vlaanderen (Region of Belgium)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vladimir (Region of Russia)": [
            {
                "Region Name": "Vladimir (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vladimir (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Vladimir (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vladimir (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vladimir (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vladimir (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Vladimir (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vladimir (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Vladimir (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Vladimir (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Vladimir (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Vladimir (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vladimir (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vladimir (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vladimir (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vladimir (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vladimir (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Vladimir (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vladimir (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vladimir (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Vladimir (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Vladimir (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Vlor\xeb (County of Albania)": [
            {
                "Region Name": "Vlor\xeb (County of Albania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vlor\xeb (County of Albania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Vlor\xeb (County of Albania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vlor\xeb (County of Albania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vlor\xeb (County of Albania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Vlor\xeb (County of Albania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Vlor\xeb (County of Albania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Vlor\xeb (County of Albania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Vlor\xeb (County of Albania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Vlor\xeb (County of Albania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Vlor\xeb (County of Albania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vlor\xeb (County of Albania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vlor\xeb (County of Albania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vlor\xeb (County of Albania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Vlor\xeb (County of Albania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vlor\xeb (County of Albania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Vlor\xeb (County of Albania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vlor\xeb (County of Albania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vlor\xeb (County of Albania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vlor\xeb (County of Albania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Vlor\xeb (County of Albania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vlor\xeb (County of Albania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Volgograd (Region of Russia)": [
            {
                "Region Name": "Volgograd (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Volgograd (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Volgograd (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Volgograd (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Volgograd (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Volgograd (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Volgograd (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Volgograd (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Volgograd (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Volgograd (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Volgograd (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Volgograd (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Volgograd (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Volgograd (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Volgograd (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Volgograd (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Volgograd (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Volgograd (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Volgograd (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Volgograd (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Volgograd (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Volgograd (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Vologda (Region of Russia)": [
            {
                "Region Name": "Vologda (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Vologda (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Vologda (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vologda (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vologda (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Vologda (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vologda (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Vologda (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Vologda (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vologda (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Vologda (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vologda (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vologda (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vologda (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vologda (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vologda (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vologda (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vologda (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vologda (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vologda (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vologda (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vologda (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Volta (Region of Ghana)": [
            {
                "Region Name": "Volta (Region of Ghana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Volta (Region of Ghana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Volta (Region of Ghana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Volta (Region of Ghana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Volta (Region of Ghana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Volta (Region of Ghana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Volta (Region of Ghana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Volta (Region of Ghana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Volta (Region of Ghana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Volta (Region of Ghana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Volta (Region of Ghana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Volta (Region of Ghana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Volta (Region of Ghana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Volta (Region of Ghana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Volta (Region of Ghana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Volta (Region of Ghana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Volta (Region of Ghana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Volta (Region of Ghana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Volta (Region of Ghana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Volta (Region of Ghana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Volta (Region of Ghana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Volta (Region of Ghana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Volyn (Region of Ukraine)": [
            {
                "Region Name": "Volyn (Region of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Volyn (Region of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Volyn (Region of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Volyn (Region of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Volyn (Region of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Volyn (Region of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Volyn (Region of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Volyn (Region of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Volyn (Region of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Volyn (Region of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Volyn (Region of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Volyn (Region of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Volyn (Region of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Volyn (Region of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Volyn (Region of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Volyn (Region of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Volyn (Region of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Volyn (Region of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Volyn (Region of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Volyn (Region of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Volyn (Region of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Volyn (Region of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Vorarlberg (State of Austria)": [
            {
                "Region Name": "Vorarlberg (State of Austria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vorarlberg (State of Austria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vorarlberg (State of Austria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vorarlberg (State of Austria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vorarlberg (State of Austria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vorarlberg (State of Austria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vorarlberg (State of Austria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vorarlberg (State of Austria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vorarlberg (State of Austria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vorarlberg (State of Austria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vorarlberg (State of Austria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vorarlberg (State of Austria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vorarlberg (State of Austria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vorarlberg (State of Austria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vorarlberg (State of Austria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vorarlberg (State of Austria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vorarlberg (State of Austria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vorarlberg (State of Austria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vorarlberg (State of Austria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vorarlberg (State of Austria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vorarlberg (State of Austria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vorarlberg (State of Austria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Voronezh (Region of Russia)": [
            {
                "Region Name": "Voronezh (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Voronezh (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Voronezh (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Voronezh (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Voronezh (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Voronezh (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Voronezh (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Voronezh (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Voronezh (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Voronezh (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Voronezh (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Voronezh (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Voronezh (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Voronezh (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Voronezh (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Voronezh (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Voronezh (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Voronezh (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Voronezh (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Voronezh (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Voronezh (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Voronezh (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "V\xf5ru (County of Estonia)": [
            {
                "Region Name": "V\xf5ru (County of Estonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "V\xf5ru (County of Estonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "V\xf5ru (County of Estonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "V\xf5ru (County of Estonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xf5ru (County of Estonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xf5ru (County of Estonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xf5ru (County of Estonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xf5ru (County of Estonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xf5ru (County of Estonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xf5ru (County of Estonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xf5ru (County of Estonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xf5ru (County of Estonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xf5ru (County of Estonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xf5ru (County of Estonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xf5ru (County of Estonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xf5ru (County of Estonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xf5ru (County of Estonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xf5ru (County of Estonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xf5ru (County of Estonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xf5ru (County of Estonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xf5ru (County of Estonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "V\xf5ru (County of Estonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vrancea (County of Romania)": [
            {
                "Region Name": "Vrancea (County of Romania)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrancea (County of Romania)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrancea (County of Romania)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrancea (County of Romania)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Vrancea (County of Romania)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vrancea (County of Romania)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vrancea (County of Romania)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vrancea (County of Romania)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vrancea (County of Romania)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vrancea (County of Romania)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vrancea (County of Romania)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vrancea (County of Romania)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vrancea (County of Romania)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrancea (County of Romania)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrancea (County of Romania)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vrancea (County of Romania)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrancea (County of Romania)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vrancea (County of Romania)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vrancea (County of Romania)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrancea (County of Romania)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrancea (County of Romania)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrancea (County of Romania)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vrap\u010Di\u0161te (Municipality of North Macedonia)": [
            {
                "Region Name": "Vrap\u010Di\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrap\u010Di\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrap\u010Di\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrap\u010Di\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrap\u010Di\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrap\u010Di\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrap\u010Di\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrap\u010Di\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrap\u010Di\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrap\u010Di\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrap\u010Di\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vrap\u010Di\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrap\u010Di\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrap\u010Di\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrap\u010Di\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrap\u010Di\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrap\u010Di\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrap\u010Di\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vrap\u010Di\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrap\u010Di\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrap\u010Di\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vrap\u010Di\u0161te (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Vratsa (Province of Bulgaria)": [
            {
                "Region Name": "Vratsa (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vratsa (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vratsa (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vratsa (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vratsa (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Vratsa (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Vratsa (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vratsa (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Vratsa (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vratsa (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vratsa (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Vratsa (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Vratsa (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Vratsa (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vratsa (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Vratsa (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vratsa (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vratsa (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Vratsa (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vratsa (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vratsa (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Vratsa (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Vukovarsko-Srijemska (County of Croatia)": [
            {
                "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Vukovarsko-Srijemska (County of Croatia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Wadi al Hayat (District of Libya)": [
            {
                "Region Name": "Wadi al Hayat (District of Libya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi al Hayat (District of Libya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi al Hayat (District of Libya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi al Hayat (District of Libya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi al Hayat (District of Libya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi al Hayat (District of Libya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi al Hayat (District of Libya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi al Hayat (District of Libya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi al Hayat (District of Libya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi al Hayat (District of Libya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Wadi al Hayat (District of Libya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi al Hayat (District of Libya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi al Hayat (District of Libya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi al Hayat (District of Libya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi al Hayat (District of Libya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi al Hayat (District of Libya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi al Hayat (District of Libya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi al Hayat (District of Libya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi al Hayat (District of Libya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi al Hayat (District of Libya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi al Hayat (District of Libya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi al Hayat (District of Libya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Wadi ash Shati' (District of Libya)": [
            {
                "Region Name": "Wadi ash Shati' (District of Libya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi ash Shati' (District of Libya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi ash Shati' (District of Libya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi ash Shati' (District of Libya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi ash Shati' (District of Libya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi ash Shati' (District of Libya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi ash Shati' (District of Libya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi ash Shati' (District of Libya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi ash Shati' (District of Libya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi ash Shati' (District of Libya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi ash Shati' (District of Libya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi ash Shati' (District of Libya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi ash Shati' (District of Libya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi ash Shati' (District of Libya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi ash Shati' (District of Libya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi ash Shati' (District of Libya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi ash Shati' (District of Libya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi ash Shati' (District of Libya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi ash Shati' (District of Libya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi ash Shati' (District of Libya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi ash Shati' (District of Libya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wadi ash Shati' (District of Libya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Wadi Fira (Region of Chad)": [
            {
                "Region Name": "Wadi Fira (Region of Chad)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 70
            },
            {
                "Region Name": "Wadi Fira (Region of Chad)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Wadi Fira (Region of Chad)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 135
            },
            {
                "Region Name": "Wadi Fira (Region of Chad)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 234
            },
            {
                "Region Name": "Wadi Fira (Region of Chad)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 169
            },
            {
                "Region Name": "Wadi Fira (Region of Chad)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 91
            },
            {
                "Region Name": "Wadi Fira (Region of Chad)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 101
            },
            {
                "Region Name": "Wadi Fira (Region of Chad)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 460
            },
            {
                "Region Name": "Wadi Fira (Region of Chad)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Wadi Fira (Region of Chad)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 100
            },
            {
                "Region Name": "Wadi Fira (Region of Chad)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 331
            },
            {
                "Region Name": "Wadi Fira (Region of Chad)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 210
            },
            {
                "Region Name": "Wadi Fira (Region of Chad)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1085
            },
            {
                "Region Name": "Wadi Fira (Region of Chad)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 253
            },
            {
                "Region Name": "Wadi Fira (Region of Chad)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Wadi Fira (Region of Chad)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 81
            },
            {
                "Region Name": "Wadi Fira (Region of Chad)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 167
            },
            {
                "Region Name": "Wadi Fira (Region of Chad)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 121
            },
            {
                "Region Name": "Wadi Fira (Region of Chad)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 465
            },
            {
                "Region Name": "Wadi Fira (Region of Chad)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "Wadi Fira (Region of Chad)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Wadi Fira (Region of Chad)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Waikato (Region of New Zealand)": [
            {
                "Region Name": "Waikato (Region of New Zealand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waikato (Region of New Zealand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waikato (Region of New Zealand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Waikato (Region of New Zealand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waikato (Region of New Zealand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waikato (Region of New Zealand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Waikato (Region of New Zealand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waikato (Region of New Zealand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waikato (Region of New Zealand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waikato (Region of New Zealand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waikato (Region of New Zealand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Waikato (Region of New Zealand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Waikato (Region of New Zealand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waikato (Region of New Zealand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waikato (Region of New Zealand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waikato (Region of New Zealand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waikato (Region of New Zealand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waikato (Region of New Zealand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waikato (Region of New Zealand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waikato (Region of New Zealand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waikato (Region of New Zealand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waikato (Region of New Zealand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Wajir (County of Kenya)": [
            {
                "Region Name": "Wajir (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Wajir (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Wajir (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Wajir (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Wajir (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "Wajir (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Wajir (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wajir (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Wajir (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wajir (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 66
            },
            {
                "Region Name": "Wajir (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Wajir (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 66
            },
            {
                "Region Name": "Wajir (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Wajir (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Wajir (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Wajir (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wajir (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Wajir (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Wajir (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Wajir (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wajir (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wajir (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Wakayama (Prefecture of Japan)": [
            {
                "Region Name": "Wakayama (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakayama (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakayama (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakayama (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakayama (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakayama (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakayama (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakayama (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakayama (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakayama (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakayama (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakayama (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakayama (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakayama (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakayama (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakayama (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakayama (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakayama (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakayama (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakayama (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakayama (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakayama (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Wake (Island of United States Minor Outlying Isl)": [
            {
                "Region Name": "Wake (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wake (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wake (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wake (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wake (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wake (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wake (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wake (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wake (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wake (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wake (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wake (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wake (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wake (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wake (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wake (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wake (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wake (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wake (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wake (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wake (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wake (Island of United States Minor Outlying Isl)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Wakiso (District of Uganda)": [
            {
                "Region Name": "Wakiso (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wakiso (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wakiso (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wakiso (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wakiso (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakiso (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakiso (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakiso (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wakiso (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Wakiso (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wakiso (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakiso (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Wakiso (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakiso (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wakiso (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wakiso (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wakiso (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakiso (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakiso (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakiso (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wakiso (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Wakiso (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Wales (Constituent Country of United Kingdom)": [
            {
                "Region Name": "Wales (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wales (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wales (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wales (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wales (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wales (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wales (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wales (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wales (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wales (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wales (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wales (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wales (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wales (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wales (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wales (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wales (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Wales (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wales (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Wales (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wales (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wales (Constituent Country of United Kingdom)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Wallonie (Region of Belgium)": [
            {
                "Region Name": "Wallonie (Region of Belgium)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallonie (Region of Belgium)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallonie (Region of Belgium)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wallonie (Region of Belgium)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallonie (Region of Belgium)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallonie (Region of Belgium)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallonie (Region of Belgium)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallonie (Region of Belgium)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallonie (Region of Belgium)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallonie (Region of Belgium)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Wallonie (Region of Belgium)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallonie (Region of Belgium)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallonie (Region of Belgium)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wallonie (Region of Belgium)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallonie (Region of Belgium)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallonie (Region of Belgium)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallonie (Region of Belgium)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallonie (Region of Belgium)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallonie (Region of Belgium)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallonie (Region of Belgium)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallonie (Region of Belgium)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wallonie (Region of Belgium)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Wangdue Phodrang (District of Bhutan)": [
            {
                "Region Name": "Wangdue Phodrang (District of Bhutan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Wangdue Phodrang (District of Bhutan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wangdue Phodrang (District of Bhutan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wangdue Phodrang (District of Bhutan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wangdue Phodrang (District of Bhutan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wangdue Phodrang (District of Bhutan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Wangdue Phodrang (District of Bhutan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wangdue Phodrang (District of Bhutan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wangdue Phodrang (District of Bhutan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Wangdue Phodrang (District of Bhutan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wangdue Phodrang (District of Bhutan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Wangdue Phodrang (District of Bhutan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Wangdue Phodrang (District of Bhutan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Wangdue Phodrang (District of Bhutan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Wangdue Phodrang (District of Bhutan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Wangdue Phodrang (District of Bhutan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Wangdue Phodrang (District of Bhutan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Wangdue Phodrang (District of Bhutan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wangdue Phodrang (District of Bhutan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wangdue Phodrang (District of Bhutan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Wangdue Phodrang (District of Bhutan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Wangdue Phodrang (District of Bhutan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Wanica (District of Suriname)": [
            {
                "Region Name": "Wanica (District of Suriname)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wanica (District of Suriname)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wanica (District of Suriname)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wanica (District of Suriname)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wanica (District of Suriname)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wanica (District of Suriname)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wanica (District of Suriname)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wanica (District of Suriname)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wanica (District of Suriname)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wanica (District of Suriname)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wanica (District of Suriname)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wanica (District of Suriname)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wanica (District of Suriname)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wanica (District of Suriname)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wanica (District of Suriname)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wanica (District of Suriname)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wanica (District of Suriname)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wanica (District of Suriname)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wanica (District of Suriname)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wanica (District of Suriname)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wanica (District of Suriname)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wanica (District of Suriname)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Warap (State of South Sudan)": [
            {
                "Region Name": "Warap (State of South Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Warap (State of South Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Warap (State of South Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Warap (State of South Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Warap (State of South Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Warap (State of South Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Warap (State of South Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Warap (State of South Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Warap (State of South Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Warap (State of South Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Warap (State of South Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Warap (State of South Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Warap (State of South Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Warap (State of South Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Warap (State of South Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Warap (State of South Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Warap (State of South Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Warap (State of South Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Warap (State of South Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Warap (State of South Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Warap (State of South Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Warap (State of South Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 19
            }
        ],
        "Wardak (Province of Afghanistan)": [
            {
                "Region Name": "Wardak (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wardak (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wardak (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wardak (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wardak (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wardak (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wardak (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wardak (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wardak (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wardak (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wardak (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wardak (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wardak (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wardak (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wardak (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wardak (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wardak (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wardak (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wardak (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wardak (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wardak (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wardak (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)": [
            {
                "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Warmi\u0144sko-Mazurskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Warwick (Parish of Bermuda)": [
            {
                "Region Name": "Warwick (Parish of Bermuda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warwick (Parish of Bermuda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warwick (Parish of Bermuda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warwick (Parish of Bermuda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warwick (Parish of Bermuda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warwick (Parish of Bermuda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warwick (Parish of Bermuda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warwick (Parish of Bermuda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warwick (Parish of Bermuda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warwick (Parish of Bermuda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warwick (Parish of Bermuda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warwick (Parish of Bermuda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warwick (Parish of Bermuda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warwick (Parish of Bermuda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warwick (Parish of Bermuda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warwick (Parish of Bermuda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warwick (Parish of Bermuda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warwick (Parish of Bermuda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warwick (Parish of Bermuda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warwick (Parish of Bermuda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warwick (Parish of Bermuda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Warwick (Parish of Bermuda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Washington (State of United States)": [
            {
                "Region Name": "Washington (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Washington (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Washington (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Washington (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Washington (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Washington (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Washington (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Washington (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Washington (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Washington (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Washington (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Washington (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Washington (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Washington (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 83
            },
            {
                "Region Name": "Washington (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Washington (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Washington (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Washington (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Washington (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Washington (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Washington (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Washington (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Wasit (Province of Iraq)": [
            {
                "Region Name": "Wasit (Province of Iraq)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wasit (Province of Iraq)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Wasit (Province of Iraq)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wasit (Province of Iraq)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wasit (Province of Iraq)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wasit (Province of Iraq)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wasit (Province of Iraq)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wasit (Province of Iraq)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wasit (Province of Iraq)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Wasit (Province of Iraq)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wasit (Province of Iraq)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wasit (Province of Iraq)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Wasit (Province of Iraq)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Wasit (Province of Iraq)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wasit (Province of Iraq)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wasit (Province of Iraq)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wasit (Province of Iraq)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wasit (Province of Iraq)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Wasit (Province of Iraq)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Wasit (Province of Iraq)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Wasit (Province of Iraq)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wasit (Province of Iraq)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Waterford (County of Ireland)": [
            {
                "Region Name": "Waterford (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waterford (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waterford (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waterford (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waterford (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waterford (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waterford (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waterford (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waterford (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waterford (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waterford (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waterford (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waterford (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waterford (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Waterford (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waterford (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waterford (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waterford (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waterford (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waterford (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waterford (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Waterford (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Wele-Nzas (Province of Equatorial Guinea)": [
            {
                "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wele-Nzas (Province of Equatorial Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Wellington (Region of New Zealand)": [
            {
                "Region Name": "Wellington (Region of New Zealand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wellington (Region of New Zealand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wellington (Region of New Zealand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wellington (Region of New Zealand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wellington (Region of New Zealand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wellington (Region of New Zealand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wellington (Region of New Zealand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wellington (Region of New Zealand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wellington (Region of New Zealand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wellington (Region of New Zealand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wellington (Region of New Zealand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wellington (Region of New Zealand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wellington (Region of New Zealand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wellington (Region of New Zealand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wellington (Region of New Zealand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wellington (Region of New Zealand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wellington (Region of New Zealand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wellington (Region of New Zealand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wellington (Region of New Zealand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wellington (Region of New Zealand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wellington (Region of New Zealand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wellington (Region of New Zealand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "West (Development Region of Nepal)": [
            {
                "Region Name": "West (Development Region of Nepal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "West (Development Region of Nepal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "West (Development Region of Nepal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "West (Development Region of Nepal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "West (Development Region of Nepal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "West (Development Region of Nepal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "West (Development Region of Nepal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "West (Development Region of Nepal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "West (Development Region of Nepal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "West (Development Region of Nepal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "West (Development Region of Nepal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "West (Development Region of Nepal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "West (Development Region of Nepal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "West (Development Region of Nepal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "West (Development Region of Nepal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "West (Development Region of Nepal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "West (Development Region of Nepal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "West (Development Region of Nepal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "West (Development Region of Nepal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "West (Development Region of Nepal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "West (Development Region of Nepal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "West (Development Region of Nepal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 65
            }
        ],
        "West (Region of Singapore)": [
            {
                "Region Name": "West (Region of Singapore)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West (Region of Singapore)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West (Region of Singapore)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West (Region of Singapore)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West (Region of Singapore)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West (Region of Singapore)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West (Region of Singapore)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West (Region of Singapore)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West (Region of Singapore)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West (Region of Singapore)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West (Region of Singapore)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West (Region of Singapore)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West (Region of Singapore)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West (Region of Singapore)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West (Region of Singapore)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West (Region of Singapore)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West (Region of Singapore)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West (Region of Singapore)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West (Region of Singapore)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West (Region of Singapore)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West (Region of Singapore)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West (Region of Singapore)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "West Azarbaijan (Province of Iran)": [
            {
                "Region Name": "West Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "West Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "West Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "West Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "West Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "West Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "West Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "West Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "West Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "West Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "West Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "West Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "West Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "West Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "West Azarbaijan (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "West Bahr-al-Ghazal (State of South Sudan)": [
            {
                "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 123
            },
            {
                "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 103
            },
            {
                "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 130
            },
            {
                "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 106
            },
            {
                "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 99
            },
            {
                "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 82
            },
            {
                "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 82
            },
            {
                "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 116
            },
            {
                "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 111
            },
            {
                "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 106
            },
            {
                "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 96
            },
            {
                "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 77
            },
            {
                "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 88
            },
            {
                "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 83
            },
            {
                "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 85
            },
            {
                "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 71
            },
            {
                "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 77
            },
            {
                "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 70
            },
            {
                "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "West Bahr-al-Ghazal (State of South Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 48
            }
        ],
        "West Bank (District of Palestine)": [
            {
                "Region Name": "West Bank (District of Palestine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West Bank (District of Palestine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bank (District of Palestine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "West Bank (District of Palestine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West Bank (District of Palestine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bank (District of Palestine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bank (District of Palestine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "West Bank (District of Palestine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bank (District of Palestine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West Bank (District of Palestine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bank (District of Palestine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bank (District of Palestine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bank (District of Palestine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bank (District of Palestine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "West Bank (District of Palestine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "West Bank (District of Palestine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "West Bank (District of Palestine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bank (District of Palestine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West Bank (District of Palestine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West Bank (District of Palestine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "West Bank (District of Palestine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bank (District of Palestine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "West Bay (District of Cayman Islands)": [
            {
                "Region Name": "West Bay (District of Cayman Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bay (District of Cayman Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bay (District of Cayman Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bay (District of Cayman Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bay (District of Cayman Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bay (District of Cayman Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bay (District of Cayman Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bay (District of Cayman Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bay (District of Cayman Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bay (District of Cayman Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bay (District of Cayman Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bay (District of Cayman Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bay (District of Cayman Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bay (District of Cayman Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bay (District of Cayman Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bay (District of Cayman Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bay (District of Cayman Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bay (District of Cayman Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bay (District of Cayman Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bay (District of Cayman Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bay (District of Cayman Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Bay (District of Cayman Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "West Bengal (State of India)": [
            {
                "Region Name": "West Bengal (State of India)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "West Bengal (State of India)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "West Bengal (State of India)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "West Bengal (State of India)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "West Bengal (State of India)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "West Bengal (State of India)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "West Bengal (State of India)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "West Bengal (State of India)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "West Bengal (State of India)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "West Bengal (State of India)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "West Bengal (State of India)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "West Bengal (State of India)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "West Bengal (State of India)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "West Bengal (State of India)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "West Bengal (State of India)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "West Bengal (State of India)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "West Bengal (State of India)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "West Bengal (State of India)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "West Bengal (State of India)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "West Bengal (State of India)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "West Bengal (State of India)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "West Bengal (State of India)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "West Coast (Region of New Zealand)": [
            {
                "Region Name": "West Coast (Region of New Zealand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Coast (Region of New Zealand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Coast (Region of New Zealand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Coast (Region of New Zealand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Coast (Region of New Zealand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Coast (Region of New Zealand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Coast (Region of New Zealand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Coast (Region of New Zealand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Coast (Region of New Zealand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Coast (Region of New Zealand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Coast (Region of New Zealand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Coast (Region of New Zealand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Coast (Region of New Zealand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Coast (Region of New Zealand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Coast (Region of New Zealand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Coast (Region of New Zealand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Coast (Region of New Zealand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Coast (Region of New Zealand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Coast (Region of New Zealand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Coast (Region of New Zealand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Coast (Region of New Zealand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Coast (Region of New Zealand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "West Darfur (State of Sudan)": [
            {
                "Region Name": "West Darfur (State of Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 67
            },
            {
                "Region Name": "West Darfur (State of Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 78
            },
            {
                "Region Name": "West Darfur (State of Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "West Darfur (State of Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 87
            },
            {
                "Region Name": "West Darfur (State of Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 64
            },
            {
                "Region Name": "West Darfur (State of Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "West Darfur (State of Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 63
            },
            {
                "Region Name": "West Darfur (State of Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "West Darfur (State of Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "West Darfur (State of Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "West Darfur (State of Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 59
            },
            {
                "Region Name": "West Darfur (State of Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "West Darfur (State of Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "West Darfur (State of Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "West Darfur (State of Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "West Darfur (State of Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "West Darfur (State of Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "West Darfur (State of Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "West Darfur (State of Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "West Darfur (State of Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "West Darfur (State of Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "West Darfur (State of Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 26
            }
        ],
        "West End (District of Anguilla)": [
            {
                "Region Name": "West End (District of Anguilla)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West End (District of Anguilla)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West End (District of Anguilla)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West End (District of Anguilla)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West End (District of Anguilla)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West End (District of Anguilla)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West End (District of Anguilla)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West End (District of Anguilla)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West End (District of Anguilla)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West End (District of Anguilla)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West End (District of Anguilla)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West End (District of Anguilla)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West End (District of Anguilla)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West End (District of Anguilla)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West End (District of Anguilla)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West End (District of Anguilla)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West End (District of Anguilla)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West End (District of Anguilla)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West End (District of Anguilla)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West End (District of Anguilla)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West End (District of Anguilla)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West End (District of Anguilla)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "West Equatoria (State of South Sudan)": [
            {
                "Region Name": "West Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "West Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "West Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "West Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "West Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "West Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "West Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "West Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "West Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "West Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "West Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "West Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "West Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "West Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "West Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "West Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "West Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "West Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "West Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "West Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "West Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "West Equatoria (State of South Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 29
            }
        ],
        "West Grand Bahama (District of Bahamas)": [
            {
                "Region Name": "West Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "West Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "West Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "West Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "West Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "West Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "West Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "West Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "West Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "West Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "West Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "West Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "West Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Grand Bahama (District of Bahamas)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "West Kazakhstan (Region of Kazakhstan)": [
            {
                "Region Name": "West Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 100
            },
            {
                "Region Name": "West Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "West Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "West Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 94
            },
            {
                "Region Name": "West Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 155
            },
            {
                "Region Name": "West Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 174
            },
            {
                "Region Name": "West Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 94
            },
            {
                "Region Name": "West Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 71
            },
            {
                "Region Name": "West Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 153
            },
            {
                "Region Name": "West Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 97
            },
            {
                "Region Name": "West Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 92
            },
            {
                "Region Name": "West Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "West Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 194
            },
            {
                "Region Name": "West Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 145
            },
            {
                "Region Name": "West Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "West Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 181
            },
            {
                "Region Name": "West Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 57
            },
            {
                "Region Name": "West Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "West Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 75
            },
            {
                "Region Name": "West Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "West Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 75
            },
            {
                "Region Name": "West Kazakhstan (Region of Kazakhstan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "West Kurdufan (State of Sudan)": [
            {
                "Region Name": "West Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "West Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "West Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "West Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "West Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "West Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "West Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "West Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "West Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "West Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "West Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "West Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "West Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "West Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "West Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "West Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "West Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "West Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "West Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "West Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "West Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "West Kurdufan (State of Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "West New Britain (Province of Papua New Guinea)": [
            {
                "Region Name": "West New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "West New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "West New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "West New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "West New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "West New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "West New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "West New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "West New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "West New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West New Britain (Province of Papua New Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "West Pokot (County of Kenya)": [
            {
                "Region Name": "West Pokot (County of Kenya)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Pokot (County of Kenya)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "West Pokot (County of Kenya)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "West Pokot (County of Kenya)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "West Pokot (County of Kenya)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West Pokot (County of Kenya)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "West Pokot (County of Kenya)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "West Pokot (County of Kenya)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West Pokot (County of Kenya)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "West Pokot (County of Kenya)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West Pokot (County of Kenya)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 67
            },
            {
                "Region Name": "West Pokot (County of Kenya)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "West Pokot (County of Kenya)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "West Pokot (County of Kenya)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "West Pokot (County of Kenya)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West Pokot (County of Kenya)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Pokot (County of Kenya)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "West Pokot (County of Kenya)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Pokot (County of Kenya)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "West Pokot (County of Kenya)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Pokot (County of Kenya)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West Pokot (County of Kenya)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "West Virginia (State of United States)": [
            {
                "Region Name": "West Virginia (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West Virginia (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "West Virginia (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "West Virginia (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "West Virginia (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "West Virginia (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "West Virginia (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "West Virginia (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West Virginia (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "West Virginia (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Virginia (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "West Virginia (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "West Virginia (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "West Virginia (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Virginia (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "West Virginia (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Virginia (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Virginia (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Virginia (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "West Virginia (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "West Virginia (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "West Virginia (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 19
            }
        ],
        "Western (District of American Samoa)": [
            {
                "Region Name": "Western (District of American Samoa)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (District of American Samoa)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (District of American Samoa)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (District of American Samoa)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (District of American Samoa)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (District of American Samoa)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (District of American Samoa)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (District of American Samoa)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (District of American Samoa)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (District of American Samoa)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (District of American Samoa)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (District of American Samoa)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (District of American Samoa)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (District of American Samoa)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (District of American Samoa)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (District of American Samoa)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (District of American Samoa)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (District of American Samoa)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (District of American Samoa)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (District of American Samoa)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (District of American Samoa)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (District of American Samoa)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Western (Division of Fiji)": [
            {
                "Region Name": "Western (Division of Fiji)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Division of Fiji)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Western (Division of Fiji)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Western (Division of Fiji)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Division of Fiji)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Western (Division of Fiji)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Western (Division of Fiji)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Western (Division of Fiji)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Western (Division of Fiji)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Western (Division of Fiji)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Division of Fiji)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Division of Fiji)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Western (Division of Fiji)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Western (Division of Fiji)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Western (Division of Fiji)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Western (Division of Fiji)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Western (Division of Fiji)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Western (Division of Fiji)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Division of Fiji)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Division of Fiji)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Western (Division of Fiji)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Western (Division of Fiji)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Western (Division of Gambia)": [
            {
                "Region Name": "Western (Division of Gambia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Western (Division of Gambia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Western (Division of Gambia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Western (Division of Gambia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Western (Division of Gambia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Western (Division of Gambia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Western (Division of Gambia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Western (Division of Gambia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Western (Division of Gambia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Western (Division of Gambia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Western (Division of Gambia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Western (Division of Gambia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Western (Division of Gambia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Western (Division of Gambia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Western (Division of Gambia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Western (Division of Gambia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Western (Division of Gambia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Western (Division of Gambia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Western (Division of Gambia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Western (Division of Gambia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Western (Division of Gambia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Western (Division of Gambia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 16
            }
        ],
        "Western (Province of Papua New Guinea)": [
            {
                "Region Name": "Western (Province of Papua New Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Western (Province of Papua New Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Western (Province of Papua New Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Western (Province of Papua New Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Western (Province of Papua New Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Western (Province of Papua New Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Western (Province of Papua New Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Western (Province of Papua New Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Western (Province of Papua New Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Western (Province of Papua New Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Western (Province of Papua New Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Western (Province of Papua New Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Western (Province of Papua New Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Western (Province of Papua New Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Western (Province of Papua New Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Western (Province of Papua New Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Western (Province of Papua New Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Western (Province of Papua New Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Western (Province of Papua New Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Western (Province of Papua New Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Western (Province of Papua New Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Western (Province of Papua New Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Western (Province of Sierra Leone)": [
            {
                "Region Name": "Western (Province of Sierra Leone)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Sierra Leone)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Western (Province of Sierra Leone)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Western (Province of Sierra Leone)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Sierra Leone)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Western (Province of Sierra Leone)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Sierra Leone)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Western (Province of Sierra Leone)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Western (Province of Sierra Leone)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Western (Province of Sierra Leone)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Western (Province of Sierra Leone)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Sierra Leone)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Western (Province of Sierra Leone)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Western (Province of Sierra Leone)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Western (Province of Sierra Leone)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Western (Province of Sierra Leone)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Sierra Leone)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Sierra Leone)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Western (Province of Sierra Leone)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Sierra Leone)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Western (Province of Sierra Leone)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Sierra Leone)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Western (Province of Solomon Islands)": [
            {
                "Region Name": "Western (Province of Solomon Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Solomon Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Solomon Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Solomon Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Solomon Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Solomon Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Solomon Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Solomon Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Solomon Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Solomon Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Solomon Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Solomon Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Solomon Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Solomon Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Solomon Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Solomon Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Solomon Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Solomon Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Solomon Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Solomon Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Solomon Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Province of Solomon Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Western (Province of Zambia)": [
            {
                "Region Name": "Western (Province of Zambia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Western (Province of Zambia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Western (Province of Zambia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Western (Province of Zambia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Western (Province of Zambia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Western (Province of Zambia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Western (Province of Zambia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Western (Province of Zambia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Western (Province of Zambia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Western (Province of Zambia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Western (Province of Zambia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Western (Province of Zambia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Western (Province of Zambia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Western (Province of Zambia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Western (Province of Zambia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Western (Province of Zambia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Western (Province of Zambia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Western (Province of Zambia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Western (Province of Zambia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Western (Province of Zambia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Western (Province of Zambia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Western (Province of Zambia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "Western (Region of Ghana)": [
            {
                "Region Name": "Western (Region of Ghana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Region of Ghana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Western (Region of Ghana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Western (Region of Ghana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Western (Region of Ghana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Western (Region of Ghana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Western (Region of Ghana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Region of Ghana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Region of Ghana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Region of Ghana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Western (Region of Ghana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Western (Region of Ghana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Western (Region of Ghana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Western (Region of Ghana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Western (Region of Ghana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Region of Ghana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Region of Ghana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Region of Ghana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western (Region of Ghana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Western (Region of Ghana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Western (Region of Ghana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Western (Region of Ghana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Western Australia (State of Australia)": [
            {
                "Region Name": "Western Australia (State of Australia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 153
            },
            {
                "Region Name": "Western Australia (State of Australia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "Western Australia (State of Australia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 87
            },
            {
                "Region Name": "Western Australia (State of Australia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "Western Australia (State of Australia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 111
            },
            {
                "Region Name": "Western Australia (State of Australia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 101
            },
            {
                "Region Name": "Western Australia (State of Australia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 88
            },
            {
                "Region Name": "Western Australia (State of Australia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 63
            },
            {
                "Region Name": "Western Australia (State of Australia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Western Australia (State of Australia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 82
            },
            {
                "Region Name": "Western Australia (State of Australia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 117
            },
            {
                "Region Name": "Western Australia (State of Australia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 67
            },
            {
                "Region Name": "Western Australia (State of Australia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 68
            },
            {
                "Region Name": "Western Australia (State of Australia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 67
            },
            {
                "Region Name": "Western Australia (State of Australia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Western Australia (State of Australia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Western Australia (State of Australia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 107
            },
            {
                "Region Name": "Western Australia (State of Australia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Western Australia (State of Australia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Western Australia (State of Australia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Western Australia (State of Australia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Western Australia (State of Australia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 77
            }
        ],
        "Western Cape (Province of South Africa)": [
            {
                "Region Name": "Western Cape (Province of South Africa)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Western Cape (Province of South Africa)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Western Cape (Province of South Africa)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Western Cape (Province of South Africa)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Western Cape (Province of South Africa)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Western Cape (Province of South Africa)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Western Cape (Province of South Africa)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Western Cape (Province of South Africa)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Western Cape (Province of South Africa)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Western Cape (Province of South Africa)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Western Cape (Province of South Africa)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Western Cape (Province of South Africa)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Western Cape (Province of South Africa)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Western Cape (Province of South Africa)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Western Cape (Province of South Africa)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 61
            },
            {
                "Region Name": "Western Cape (Province of South Africa)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Western Cape (Province of South Africa)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Western Cape (Province of South Africa)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Western Cape (Province of South Africa)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Western Cape (Province of South Africa)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Western Cape (Province of South Africa)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Western Cape (Province of South Africa)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 14
            }
        ],
        "Western Finland (Province of Finland)": [
            {
                "Region Name": "Western Finland (Province of Finland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Western Finland (Province of Finland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Western Finland (Province of Finland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western Finland (Province of Finland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western Finland (Province of Finland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Western Finland (Province of Finland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Western Finland (Province of Finland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western Finland (Province of Finland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Western Finland (Province of Finland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western Finland (Province of Finland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Western Finland (Province of Finland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western Finland (Province of Finland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western Finland (Province of Finland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western Finland (Province of Finland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Western Finland (Province of Finland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Western Finland (Province of Finland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western Finland (Province of Finland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Western Finland (Province of Finland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western Finland (Province of Finland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western Finland (Province of Finland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western Finland (Province of Finland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western Finland (Province of Finland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Western Highlands (Province of Papua New Guinea)": [
            {
                "Region Name": "Western Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Western Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Western Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Western Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Western Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Western Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Western Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Western Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Western Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Western Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Western Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Western Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Western Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Western Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Western Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Western Highlands (Province of Papua New Guinea)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Western North (Region of Ghana)": [
            {
                "Region Name": "Western North (Region of Ghana)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western North (Region of Ghana)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western North (Region of Ghana)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western North (Region of Ghana)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western North (Region of Ghana)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Western North (Region of Ghana)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Western North (Region of Ghana)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western North (Region of Ghana)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western North (Region of Ghana)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western North (Region of Ghana)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Western North (Region of Ghana)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western North (Region of Ghana)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Western North (Region of Ghana)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western North (Region of Ghana)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Western North (Region of Ghana)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western North (Region of Ghana)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western North (Region of Ghana)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western North (Region of Ghana)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Western North (Region of Ghana)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Western North (Region of Ghana)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Western North (Region of Ghana)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Western North (Region of Ghana)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Westmeath (County of Ireland)": [
            {
                "Region Name": "Westmeath (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Westmeath (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Westmeath (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Westmeath (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Westmeath (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Westmeath (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Westmeath (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Westmeath (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Westmeath (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Westmeath (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Westmeath (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Westmeath (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Westmeath (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Westmeath (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Westmeath (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Westmeath (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Westmeath (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Westmeath (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Westmeath (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Westmeath (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Westmeath (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Westmeath (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Westmoreland (Parish of Jamaica)": [
            {
                "Region Name": "Westmoreland (Parish of Jamaica)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Westmoreland (Parish of Jamaica)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Westmoreland (Parish of Jamaica)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Westmoreland (Parish of Jamaica)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Westmoreland (Parish of Jamaica)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Westmoreland (Parish of Jamaica)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Westmoreland (Parish of Jamaica)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Westmoreland (Parish of Jamaica)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Westmoreland (Parish of Jamaica)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Westmoreland (Parish of Jamaica)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Westmoreland (Parish of Jamaica)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Westmoreland (Parish of Jamaica)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Westmoreland (Parish of Jamaica)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Westmoreland (Parish of Jamaica)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Westmoreland (Parish of Jamaica)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Westmoreland (Parish of Jamaica)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Westmoreland (Parish of Jamaica)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Westmoreland (Parish of Jamaica)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Westmoreland (Parish of Jamaica)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Westmoreland (Parish of Jamaica)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Westmoreland (Parish of Jamaica)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Westmoreland (Parish of Jamaica)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Wexford (County of Ireland)": [
            {
                "Region Name": "Wexford (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wexford (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wexford (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wexford (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wexford (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wexford (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Wexford (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wexford (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wexford (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wexford (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wexford (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wexford (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wexford (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wexford (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wexford (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wexford (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wexford (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wexford (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wexford (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wexford (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wexford (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wexford (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "White Nile (State of Sudan)": [
            {
                "Region Name": "White Nile (State of Sudan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "White Nile (State of Sudan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "White Nile (State of Sudan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "White Nile (State of Sudan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "White Nile (State of Sudan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "White Nile (State of Sudan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "White Nile (State of Sudan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "White Nile (State of Sudan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "White Nile (State of Sudan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "White Nile (State of Sudan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "White Nile (State of Sudan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "White Nile (State of Sudan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "White Nile (State of Sudan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "White Nile (State of Sudan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "White Nile (State of Sudan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "White Nile (State of Sudan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "White Nile (State of Sudan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "White Nile (State of Sudan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "White Nile (State of Sudan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "White Nile (State of Sudan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "White Nile (State of Sudan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "White Nile (State of Sudan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Wicklow (County of Ireland)": [
            {
                "Region Name": "Wicklow (County of Ireland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wicklow (County of Ireland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wicklow (County of Ireland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wicklow (County of Ireland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wicklow (County of Ireland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wicklow (County of Ireland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Wicklow (County of Ireland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wicklow (County of Ireland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wicklow (County of Ireland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Wicklow (County of Ireland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wicklow (County of Ireland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wicklow (County of Ireland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wicklow (County of Ireland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wicklow (County of Ireland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wicklow (County of Ireland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wicklow (County of Ireland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wicklow (County of Ireland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wicklow (County of Ireland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wicklow (County of Ireland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Wicklow (County of Ireland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wicklow (County of Ireland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wicklow (County of Ireland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Wielkopolskie (Voivodeship of Poland)": [
            {
                "Region Name": "Wielkopolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wielkopolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Wielkopolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wielkopolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wielkopolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Wielkopolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Wielkopolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wielkopolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wielkopolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Wielkopolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wielkopolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wielkopolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wielkopolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wielkopolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wielkopolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wielkopolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wielkopolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Wielkopolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wielkopolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wielkopolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wielkopolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wielkopolskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Wien (State of Austria)": [
            {
                "Region Name": "Wien (State of Austria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wien (State of Austria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wien (State of Austria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wien (State of Austria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wien (State of Austria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wien (State of Austria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wien (State of Austria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wien (State of Austria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wien (State of Austria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wien (State of Austria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wien (State of Austria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wien (State of Austria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wien (State of Austria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wien (State of Austria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wien (State of Austria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wien (State of Austria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wien (State of Austria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wien (State of Austria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wien (State of Austria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wien (State of Austria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wien (State of Austria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wien (State of Austria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Wisconsin (State of United States)": [
            {
                "Region Name": "Wisconsin (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Wisconsin (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Wisconsin (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Wisconsin (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Wisconsin (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Wisconsin (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wisconsin (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wisconsin (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Wisconsin (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Wisconsin (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Wisconsin (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Wisconsin (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Wisconsin (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Wisconsin (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Wisconsin (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Wisconsin (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wisconsin (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Wisconsin (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Wisconsin (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wisconsin (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wisconsin (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Wisconsin (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Woqooyi Galbeed (Region of Somalia)": [
            {
                "Region Name": "Woqooyi Galbeed (Region of Somalia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Woqooyi Galbeed (Region of Somalia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Woqooyi Galbeed (Region of Somalia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Woqooyi Galbeed (Region of Somalia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Woqooyi Galbeed (Region of Somalia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Woqooyi Galbeed (Region of Somalia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Woqooyi Galbeed (Region of Somalia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Woqooyi Galbeed (Region of Somalia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Woqooyi Galbeed (Region of Somalia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Woqooyi Galbeed (Region of Somalia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Woqooyi Galbeed (Region of Somalia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Woqooyi Galbeed (Region of Somalia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Woqooyi Galbeed (Region of Somalia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Woqooyi Galbeed (Region of Somalia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Woqooyi Galbeed (Region of Somalia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Woqooyi Galbeed (Region of Somalia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Woqooyi Galbeed (Region of Somalia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Woqooyi Galbeed (Region of Somalia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Woqooyi Galbeed (Region of Somalia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Woqooyi Galbeed (Region of Somalia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Woqooyi Galbeed (Region of Somalia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Woqooyi Galbeed (Region of Somalia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Woroba (District of C\xf4te d'Ivoire)": [
            {
                "Region Name": "Woroba (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Woroba (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Woroba (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Woroba (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Woroba (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Woroba (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Woroba (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Woroba (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Woroba (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Woroba (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Woroba (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Woroba (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Woroba (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Woroba (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Woroba (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Woroba (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Woroba (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Woroba (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Woroba (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Woroba (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Woroba (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Woroba (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Wotho (Atol of Marshall Islands)": [
            {
                "Region Name": "Wotho (Atol of Marshall Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotho (Atol of Marshall Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotho (Atol of Marshall Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotho (Atol of Marshall Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotho (Atol of Marshall Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotho (Atol of Marshall Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotho (Atol of Marshall Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotho (Atol of Marshall Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotho (Atol of Marshall Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotho (Atol of Marshall Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotho (Atol of Marshall Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotho (Atol of Marshall Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotho (Atol of Marshall Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotho (Atol of Marshall Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotho (Atol of Marshall Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotho (Atol of Marshall Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotho (Atol of Marshall Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotho (Atol of Marshall Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotho (Atol of Marshall Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotho (Atol of Marshall Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotho (Atol of Marshall Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotho (Atol of Marshall Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Wotje (Atol of Marshall Islands)": [
            {
                "Region Name": "Wotje (Atol of Marshall Islands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotje (Atol of Marshall Islands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotje (Atol of Marshall Islands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotje (Atol of Marshall Islands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotje (Atol of Marshall Islands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotje (Atol of Marshall Islands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotje (Atol of Marshall Islands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotje (Atol of Marshall Islands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotje (Atol of Marshall Islands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotje (Atol of Marshall Islands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotje (Atol of Marshall Islands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotje (Atol of Marshall Islands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotje (Atol of Marshall Islands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotje (Atol of Marshall Islands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotje (Atol of Marshall Islands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotje (Atol of Marshall Islands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotje (Atol of Marshall Islands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotje (Atol of Marshall Islands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotje (Atol of Marshall Islands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotje (Atol of Marshall Islands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotje (Atol of Marshall Islands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wotje (Atol of Marshall Islands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Wouleu-Ntem (Province of Gabon)": [
            {
                "Region Name": "Wouleu-Ntem (Province of Gabon)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wouleu-Ntem (Province of Gabon)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wouleu-Ntem (Province of Gabon)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Wouleu-Ntem (Province of Gabon)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wouleu-Ntem (Province of Gabon)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wouleu-Ntem (Province of Gabon)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wouleu-Ntem (Province of Gabon)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wouleu-Ntem (Province of Gabon)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wouleu-Ntem (Province of Gabon)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wouleu-Ntem (Province of Gabon)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wouleu-Ntem (Province of Gabon)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wouleu-Ntem (Province of Gabon)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wouleu-Ntem (Province of Gabon)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Wouleu-Ntem (Province of Gabon)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wouleu-Ntem (Province of Gabon)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wouleu-Ntem (Province of Gabon)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Wouleu-Ntem (Province of Gabon)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Wouleu-Ntem (Province of Gabon)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Wouleu-Ntem (Province of Gabon)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wouleu-Ntem (Province of Gabon)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wouleu-Ntem (Province of Gabon)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Wouleu-Ntem (Province of Gabon)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Wyoming (State of United States)": [
            {
                "Region Name": "Wyoming (State of United States)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Wyoming (State of United States)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Wyoming (State of United States)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Wyoming (State of United States)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Wyoming (State of United States)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Wyoming (State of United States)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Wyoming (State of United States)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Wyoming (State of United States)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Wyoming (State of United States)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Wyoming (State of United States)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Wyoming (State of United States)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Wyoming (State of United States)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Wyoming (State of United States)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Wyoming (State of United States)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Wyoming (State of United States)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Wyoming (State of United States)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Wyoming (State of United States)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Wyoming (State of United States)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Wyoming (State of United States)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Wyoming (State of United States)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Wyoming (State of United States)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Wyoming (State of United States)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Xaignabouri (Province of Laos)": [
            {
                "Region Name": "Xaignabouri (Province of Laos)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Xaignabouri (Province of Laos)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Xaignabouri (Province of Laos)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Xaignabouri (Province of Laos)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Xaignabouri (Province of Laos)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Xaignabouri (Province of Laos)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Xaignabouri (Province of Laos)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Xaignabouri (Province of Laos)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Xaignabouri (Province of Laos)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Xaignabouri (Province of Laos)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Xaignabouri (Province of Laos)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Xaignabouri (Province of Laos)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Xaignabouri (Province of Laos)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Xaignabouri (Province of Laos)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Xaignabouri (Province of Laos)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Xaignabouri (Province of Laos)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Xaignabouri (Province of Laos)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xaignabouri (Province of Laos)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Xaignabouri (Province of Laos)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Xaignabouri (Province of Laos)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Xaignabouri (Province of Laos)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Xaignabouri (Province of Laos)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Xais\xf4mboun (Special Region|Zone of Laos)": [
            {
                "Region Name": "Xais\xf4mboun (Special Region|Zone of Laos)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Xais\xf4mboun (Special Region|Zone of Laos)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Xais\xf4mboun (Special Region|Zone of Laos)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Xais\xf4mboun (Special Region|Zone of Laos)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Xais\xf4mboun (Special Region|Zone of Laos)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Xais\xf4mboun (Special Region|Zone of Laos)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Xais\xf4mboun (Special Region|Zone of Laos)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Xais\xf4mboun (Special Region|Zone of Laos)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Xais\xf4mboun (Special Region|Zone of Laos)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Xais\xf4mboun (Special Region|Zone of Laos)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xais\xf4mboun (Special Region|Zone of Laos)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xais\xf4mboun (Special Region|Zone of Laos)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xais\xf4mboun (Special Region|Zone of Laos)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Xais\xf4mboun (Special Region|Zone of Laos)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xais\xf4mboun (Special Region|Zone of Laos)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xais\xf4mboun (Special Region|Zone of Laos)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xais\xf4mboun (Special Region|Zone of Laos)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xais\xf4mboun (Special Region|Zone of Laos)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xais\xf4mboun (Special Region|Zone of Laos)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xais\xf4mboun (Special Region|Zone of Laos)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Xais\xf4mboun (Special Region|Zone of Laos)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xais\xf4mboun (Special Region|Zone of Laos)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "X\xe9kong (Province of Laos)": [
            {
                "Region Name": "X\xe9kong (Province of Laos)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "X\xe9kong (Province of Laos)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "X\xe9kong (Province of Laos)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "X\xe9kong (Province of Laos)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "X\xe9kong (Province of Laos)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "X\xe9kong (Province of Laos)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "X\xe9kong (Province of Laos)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "X\xe9kong (Province of Laos)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "X\xe9kong (Province of Laos)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "X\xe9kong (Province of Laos)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "X\xe9kong (Province of Laos)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "X\xe9kong (Province of Laos)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "X\xe9kong (Province of Laos)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "X\xe9kong (Province of Laos)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "X\xe9kong (Province of Laos)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "X\xe9kong (Province of Laos)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "X\xe9kong (Province of Laos)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "X\xe9kong (Province of Laos)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "X\xe9kong (Province of Laos)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "X\xe9kong (Province of Laos)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "X\xe9kong (Province of Laos)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "X\xe9kong (Province of Laos)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Xiangkhoang (Province of Laos)": [
            {
                "Region Name": "Xiangkhoang (Province of Laos)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Xiangkhoang (Province of Laos)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Xiangkhoang (Province of Laos)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Xiangkhoang (Province of Laos)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Xiangkhoang (Province of Laos)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Xiangkhoang (Province of Laos)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Xiangkhoang (Province of Laos)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xiangkhoang (Province of Laos)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Xiangkhoang (Province of Laos)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Xiangkhoang (Province of Laos)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Xiangkhoang (Province of Laos)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Xiangkhoang (Province of Laos)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xiangkhoang (Province of Laos)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Xiangkhoang (Province of Laos)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Xiangkhoang (Province of Laos)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Xiangkhoang (Province of Laos)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xiangkhoang (Province of Laos)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xiangkhoang (Province of Laos)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xiangkhoang (Province of Laos)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xiangkhoang (Province of Laos)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xiangkhoang (Province of Laos)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xiangkhoang (Province of Laos)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Xinjiang Uygur (Autonomous Region of China)": [
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xinjiang Uygur (Autonomous Region of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Xizang (Autonomous Region of China)": [
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xizang (Autonomous Region of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Xlokk (Region of Malta)": [
            {
                "Region Name": "Xlokk (Region of Malta)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xlokk (Region of Malta)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xlokk (Region of Malta)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xlokk (Region of Malta)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xlokk (Region of Malta)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xlokk (Region of Malta)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xlokk (Region of Malta)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xlokk (Region of Malta)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xlokk (Region of Malta)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xlokk (Region of Malta)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xlokk (Region of Malta)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xlokk (Region of Malta)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xlokk (Region of Malta)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xlokk (Region of Malta)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xlokk (Region of Malta)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xlokk (Region of Malta)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xlokk (Region of Malta)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xlokk (Region of Malta)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xlokk (Region of Malta)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xlokk (Region of Malta)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xlokk (Region of Malta)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xlokk (Region of Malta)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Xorazm (Region of Uzbekistan)": [
            {
                "Region Name": "Xorazm (Region of Uzbekistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xorazm (Region of Uzbekistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xorazm (Region of Uzbekistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xorazm (Region of Uzbekistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xorazm (Region of Uzbekistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xorazm (Region of Uzbekistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Xorazm (Region of Uzbekistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xorazm (Region of Uzbekistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Xorazm (Region of Uzbekistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xorazm (Region of Uzbekistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xorazm (Region of Uzbekistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xorazm (Region of Uzbekistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xorazm (Region of Uzbekistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xorazm (Region of Uzbekistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xorazm (Region of Uzbekistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xorazm (Region of Uzbekistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xorazm (Region of Uzbekistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xorazm (Region of Uzbekistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Xorazm (Region of Uzbekistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xorazm (Region of Uzbekistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xorazm (Region of Uzbekistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Xorazm (Region of Uzbekistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Yabucoa (Municipality of Puerto Rico)": [
            {
                "Region Name": "Yabucoa (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yabucoa (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yabucoa (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yabucoa (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yabucoa (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yabucoa (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yabucoa (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yabucoa (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yabucoa (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yabucoa (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yabucoa (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yabucoa (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yabucoa (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yabucoa (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yabucoa (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yabucoa (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yabucoa (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yabucoa (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yabucoa (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yabucoa (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yabucoa (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yabucoa (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Yala (Province of Thailand)": [
            {
                "Region Name": "Yala (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yala (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yala (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yala (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yala (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yala (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yala (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yala (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yala (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yala (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yala (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yala (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yala (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yala (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yala (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yala (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yala (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yala (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yala (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yala (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yala (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yala (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Yalova (Province of Turkey)": [
            {
                "Region Name": "Yalova (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yalova (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yalova (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yalova (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yalova (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yalova (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yalova (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yalova (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Yalova (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yalova (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yalova (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yalova (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yalova (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yalova (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yalova (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yalova (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yalova (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yalova (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yalova (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yalova (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yalova (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yalova (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Yamagata (Prefecture of Japan)": [
            {
                "Region Name": "Yamagata (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamagata (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamagata (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Yamagata (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamagata (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamagata (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamagata (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Yamagata (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yamagata (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamagata (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamagata (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamagata (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yamagata (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamagata (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamagata (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamagata (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamagata (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamagata (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamagata (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamagata (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamagata (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamagata (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Yamaguchi (Prefecture of Japan)": [
            {
                "Region Name": "Yamaguchi (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamaguchi (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Yamaguchi (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamaguchi (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamaguchi (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamaguchi (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamaguchi (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Yamaguchi (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yamaguchi (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yamaguchi (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yamaguchi (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamaguchi (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Yamaguchi (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Yamaguchi (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamaguchi (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Yamaguchi (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yamaguchi (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Yamaguchi (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Yamaguchi (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamaguchi (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yamaguchi (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamaguchi (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Yamal-Nenets (Autonomous Province of Russia)": [
            {
                "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Yamal-Nenets (Autonomous Province of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Yamanashi (Prefecture of Japan)": [
            {
                "Region Name": "Yamanashi (Prefecture of Japan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamanashi (Prefecture of Japan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamanashi (Prefecture of Japan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Yamanashi (Prefecture of Japan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Yamanashi (Prefecture of Japan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamanashi (Prefecture of Japan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Yamanashi (Prefecture of Japan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamanashi (Prefecture of Japan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamanashi (Prefecture of Japan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yamanashi (Prefecture of Japan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yamanashi (Prefecture of Japan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamanashi (Prefecture of Japan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Yamanashi (Prefecture of Japan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yamanashi (Prefecture of Japan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamanashi (Prefecture of Japan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamanashi (Prefecture of Japan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamanashi (Prefecture of Japan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Yamanashi (Prefecture of Japan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamanashi (Prefecture of Japan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Yamanashi (Prefecture of Japan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yamanashi (Prefecture of Japan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Yamanashi (Prefecture of Japan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Yambol (Province of Bulgaria)": [
            {
                "Region Name": "Yambol (Province of Bulgaria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yambol (Province of Bulgaria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yambol (Province of Bulgaria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yambol (Province of Bulgaria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Yambol (Province of Bulgaria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yambol (Province of Bulgaria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Yambol (Province of Bulgaria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yambol (Province of Bulgaria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yambol (Province of Bulgaria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yambol (Province of Bulgaria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yambol (Province of Bulgaria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Yambol (Province of Bulgaria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yambol (Province of Bulgaria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yambol (Province of Bulgaria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yambol (Province of Bulgaria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yambol (Province of Bulgaria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yambol (Province of Bulgaria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yambol (Province of Bulgaria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yambol (Province of Bulgaria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Yambol (Province of Bulgaria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yambol (Province of Bulgaria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yambol (Province of Bulgaria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Yamoussoukro (Autonomous district of C\xf4te d'Ivoire)": [
            {
                "Region Name": "Yamoussoukro (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Yamoussoukro (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Yamoussoukro (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yamoussoukro (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yamoussoukro (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yamoussoukro (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Yamoussoukro (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yamoussoukro (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yamoussoukro (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yamoussoukro (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yamoussoukro (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yamoussoukro (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yamoussoukro (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Yamoussoukro (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Yamoussoukro (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yamoussoukro (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yamoussoukro (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yamoussoukro (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yamoussoukro (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yamoussoukro (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yamoussoukro (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yamoussoukro (Autonomous district of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Yangon (Division of Myanmar)": [
            {
                "Region Name": "Yangon (Division of Myanmar)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yangon (Division of Myanmar)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yangon (Division of Myanmar)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yangon (Division of Myanmar)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yangon (Division of Myanmar)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yangon (Division of Myanmar)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yangon (Division of Myanmar)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yangon (Division of Myanmar)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yangon (Division of Myanmar)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yangon (Division of Myanmar)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yangon (Division of Myanmar)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yangon (Division of Myanmar)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yangon (Division of Myanmar)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yangon (Division of Myanmar)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yangon (Division of Myanmar)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yangon (Division of Myanmar)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yangon (Division of Myanmar)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Yangon (Division of Myanmar)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yangon (Division of Myanmar)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yangon (Division of Myanmar)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yangon (Division of Myanmar)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yangon (Division of Myanmar)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Yap (State of Micronesia)": [
            {
                "Region Name": "Yap (State of Micronesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yap (State of Micronesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yap (State of Micronesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yap (State of Micronesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yap (State of Micronesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yap (State of Micronesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yap (State of Micronesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yap (State of Micronesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yap (State of Micronesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yap (State of Micronesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yap (State of Micronesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yap (State of Micronesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yap (State of Micronesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yap (State of Micronesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yap (State of Micronesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yap (State of Micronesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yap (State of Micronesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yap (State of Micronesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yap (State of Micronesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yap (State of Micronesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yap (State of Micronesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yap (State of Micronesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Yaracuy (State of Venezuela)": [
            {
                "Region Name": "Yaracuy (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yaracuy (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yaracuy (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yaracuy (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yaracuy (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yaracuy (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yaracuy (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yaracuy (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yaracuy (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yaracuy (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yaracuy (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yaracuy (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yaracuy (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yaracuy (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yaracuy (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yaracuy (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Yaracuy (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yaracuy (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yaracuy (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yaracuy (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yaracuy (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yaracuy (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Yaren (District of Nauru)": [
            {
                "Region Name": "Yaren (District of Nauru)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yaren (District of Nauru)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yaren (District of Nauru)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yaren (District of Nauru)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yaren (District of Nauru)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yaren (District of Nauru)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yaren (District of Nauru)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yaren (District of Nauru)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yaren (District of Nauru)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yaren (District of Nauru)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yaren (District of Nauru)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yaren (District of Nauru)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yaren (District of Nauru)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yaren (District of Nauru)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yaren (District of Nauru)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yaren (District of Nauru)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yaren (District of Nauru)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yaren (District of Nauru)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yaren (District of Nauru)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yaren (District of Nauru)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yaren (District of Nauru)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yaren (District of Nauru)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Yaroslavl' (Region of Russia)": [
            {
                "Region Name": "Yaroslavl' (Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yaroslavl' (Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Yaroslavl' (Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yaroslavl' (Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yaroslavl' (Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yaroslavl' (Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Yaroslavl' (Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yaroslavl' (Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Yaroslavl' (Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yaroslavl' (Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yaroslavl' (Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Yaroslavl' (Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yaroslavl' (Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yaroslavl' (Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yaroslavl' (Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yaroslavl' (Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yaroslavl' (Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Yaroslavl' (Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yaroslavl' (Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yaroslavl' (Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Yaroslavl' (Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Yaroslavl' (Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Yasothon (Province of Thailand)": [
            {
                "Region Name": "Yasothon (Province of Thailand)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Yasothon (Province of Thailand)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yasothon (Province of Thailand)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yasothon (Province of Thailand)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yasothon (Province of Thailand)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yasothon (Province of Thailand)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yasothon (Province of Thailand)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yasothon (Province of Thailand)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yasothon (Province of Thailand)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yasothon (Province of Thailand)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yasothon (Province of Thailand)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yasothon (Province of Thailand)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yasothon (Province of Thailand)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yasothon (Province of Thailand)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yasothon (Province of Thailand)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yasothon (Province of Thailand)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yasothon (Province of Thailand)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yasothon (Province of Thailand)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yasothon (Province of Thailand)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yasothon (Province of Thailand)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yasothon (Province of Thailand)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yasothon (Province of Thailand)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Yauco (Municipality of Puerto Rico)": [
            {
                "Region Name": "Yauco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yauco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yauco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yauco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yauco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yauco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yauco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yauco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yauco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yauco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yauco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yauco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yauco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yauco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yauco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yauco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yauco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yauco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yauco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yauco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yauco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yauco (Municipality of Puerto Rico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Yazd (Province of Iran)": [
            {
                "Region Name": "Yazd (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yazd (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yazd (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yazd (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yazd (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yazd (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yazd (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yazd (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yazd (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yazd (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yazd (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yazd (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yazd (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yazd (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yazd (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yazd (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yazd (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yazd (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yazd (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yazd (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yazd (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yazd (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Y\xean B\xe1i (Province of Vietnam)": [
            {
                "Region Name": "Y\xean B\xe1i (Province of Vietnam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Y\xean B\xe1i (Province of Vietnam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Y\xean B\xe1i (Province of Vietnam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Y\xean B\xe1i (Province of Vietnam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Y\xean B\xe1i (Province of Vietnam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Y\xean B\xe1i (Province of Vietnam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Y\xean B\xe1i (Province of Vietnam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Y\xean B\xe1i (Province of Vietnam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Y\xean B\xe1i (Province of Vietnam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Y\xean B\xe1i (Province of Vietnam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Y\xean B\xe1i (Province of Vietnam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Y\xean B\xe1i (Province of Vietnam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Y\xean B\xe1i (Province of Vietnam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Y\xean B\xe1i (Province of Vietnam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Y\xean B\xe1i (Province of Vietnam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Y\xean B\xe1i (Province of Vietnam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Y\xean B\xe1i (Province of Vietnam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Y\xean B\xe1i (Province of Vietnam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Y\xean B\xe1i (Province of Vietnam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Y\xean B\xe1i (Province of Vietnam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Y\xean B\xe1i (Province of Vietnam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Y\xean B\xe1i (Province of Vietnam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Yevrey (Autonomous Region of Russia)": [
            {
                "Region Name": "Yevrey (Autonomous Region of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Yevrey (Autonomous Region of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Yevrey (Autonomous Region of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Yevrey (Autonomous Region of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Yevrey (Autonomous Region of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Yevrey (Autonomous Region of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Yevrey (Autonomous Region of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Yevrey (Autonomous Region of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Yevrey (Autonomous Region of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Yevrey (Autonomous Region of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Yevrey (Autonomous Region of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yevrey (Autonomous Region of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Yevrey (Autonomous Region of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Yevrey (Autonomous Region of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Yevrey (Autonomous Region of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Yevrey (Autonomous Region of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Yevrey (Autonomous Region of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Yevrey (Autonomous Region of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Yevrey (Autonomous Region of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Yevrey (Autonomous Region of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Yevrey (Autonomous Region of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Yevrey (Autonomous Region of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Yigo (Municipality of Guam)": [
            {
                "Region Name": "Yigo (Municipality of Guam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yigo (Municipality of Guam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yigo (Municipality of Guam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yigo (Municipality of Guam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yigo (Municipality of Guam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yigo (Municipality of Guam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yigo (Municipality of Guam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yigo (Municipality of Guam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yigo (Municipality of Guam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yigo (Municipality of Guam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yigo (Municipality of Guam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yigo (Municipality of Guam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yigo (Municipality of Guam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yigo (Municipality of Guam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yigo (Municipality of Guam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yigo (Municipality of Guam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yigo (Municipality of Guam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yigo (Municipality of Guam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yigo (Municipality of Guam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yigo (Municipality of Guam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yigo (Municipality of Guam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yigo (Municipality of Guam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Yobe (State of Nigeria)": [
            {
                "Region Name": "Yobe (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Yobe (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Yobe (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Yobe (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Yobe (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Yobe (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Yobe (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Yobe (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Yobe (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Yobe (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Yobe (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Yobe (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Yobe (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Yobe (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Yobe (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Yobe (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Yobe (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Yobe (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Yobe (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Yobe (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yobe (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Yobe (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Yogyakarta (Province of Indonesia)": [
            {
                "Region Name": "Yogyakarta (Province of Indonesia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yogyakarta (Province of Indonesia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yogyakarta (Province of Indonesia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yogyakarta (Province of Indonesia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yogyakarta (Province of Indonesia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yogyakarta (Province of Indonesia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yogyakarta (Province of Indonesia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yogyakarta (Province of Indonesia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yogyakarta (Province of Indonesia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yogyakarta (Province of Indonesia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yogyakarta (Province of Indonesia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yogyakarta (Province of Indonesia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yogyakarta (Province of Indonesia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yogyakarta (Province of Indonesia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yogyakarta (Province of Indonesia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yogyakarta (Province of Indonesia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yogyakarta (Province of Indonesia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yogyakarta (Province of Indonesia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yogyakarta (Province of Indonesia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yogyakarta (Province of Indonesia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yogyakarta (Province of Indonesia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yogyakarta (Province of Indonesia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Yona (Municipality of Guam)": [
            {
                "Region Name": "Yona (Municipality of Guam)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yona (Municipality of Guam)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yona (Municipality of Guam)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yona (Municipality of Guam)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yona (Municipality of Guam)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yona (Municipality of Guam)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yona (Municipality of Guam)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yona (Municipality of Guam)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yona (Municipality of Guam)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yona (Municipality of Guam)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yona (Municipality of Guam)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yona (Municipality of Guam)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yona (Municipality of Guam)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yona (Municipality of Guam)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yona (Municipality of Guam)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yona (Municipality of Guam)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yona (Municipality of Guam)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yona (Municipality of Guam)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yona (Municipality of Guam)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yona (Municipality of Guam)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yona (Municipality of Guam)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yona (Municipality of Guam)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Yoro (Department of Honduras)": [
            {
                "Region Name": "Yoro (Department of Honduras)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yoro (Department of Honduras)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yoro (Department of Honduras)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yoro (Department of Honduras)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yoro (Department of Honduras)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yoro (Department of Honduras)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yoro (Department of Honduras)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yoro (Department of Honduras)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yoro (Department of Honduras)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yoro (Department of Honduras)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yoro (Department of Honduras)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yoro (Department of Honduras)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yoro (Department of Honduras)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yoro (Department of Honduras)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yoro (Department of Honduras)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yoro (Department of Honduras)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yoro (Department of Honduras)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yoro (Department of Honduras)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yoro (Department of Honduras)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yoro (Department of Honduras)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yoro (Department of Honduras)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yoro (Department of Honduras)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Yozgat (Province of Turkey)": [
            {
                "Region Name": "Yozgat (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Yozgat (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Yozgat (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Yozgat (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Yozgat (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Yozgat (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yozgat (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yozgat (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Yozgat (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Yozgat (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Yozgat (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yozgat (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Yozgat (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yozgat (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Yozgat (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yozgat (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yozgat (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yozgat (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yozgat (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yozgat (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yozgat (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Yozgat (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Ysyk-K\xf6l (Province of Kyrgyzstan)": [
            {
                "Region Name": "Ysyk-K\xf6l (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ysyk-K\xf6l (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ysyk-K\xf6l (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ysyk-K\xf6l (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Ysyk-K\xf6l (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ysyk-K\xf6l (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ysyk-K\xf6l (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ysyk-K\xf6l (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ysyk-K\xf6l (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ysyk-K\xf6l (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ysyk-K\xf6l (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Ysyk-K\xf6l (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ysyk-K\xf6l (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ysyk-K\xf6l (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ysyk-K\xf6l (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ysyk-K\xf6l (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ysyk-K\xf6l (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Ysyk-K\xf6l (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ysyk-K\xf6l (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ysyk-K\xf6l (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Ysyk-K\xf6l (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Ysyk-K\xf6l (Province of Kyrgyzstan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Yucat\xe1n (State of M\xe9xico)": [
            {
                "Region Name": "Yucat\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Yucat\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Yucat\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yucat\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yucat\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yucat\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yucat\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yucat\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yucat\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yucat\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yucat\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yucat\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yucat\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yucat\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yucat\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yucat\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yucat\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yucat\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yucat\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yucat\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yucat\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yucat\xe1n (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Yukhari-Karabakh (Region of Azerbaijan)": [
            {
                "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 61
            },
            {
                "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yukhari-Karabakh (Region of Azerbaijan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Yukon (Territory of Canada)": [
            {
                "Region Name": "Yukon (Territory of Canada)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Yukon (Territory of Canada)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Yukon (Territory of Canada)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Yukon (Territory of Canada)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Yukon (Territory of Canada)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "Yukon (Territory of Canada)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yukon (Territory of Canada)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yukon (Territory of Canada)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Yukon (Territory of Canada)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Yukon (Territory of Canada)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Yukon (Territory of Canada)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Yukon (Territory of Canada)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Yukon (Territory of Canada)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yukon (Territory of Canada)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Yukon (Territory of Canada)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Yukon (Territory of Canada)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Yukon (Territory of Canada)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Yukon (Territory of Canada)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Yukon (Territory of Canada)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Yukon (Territory of Canada)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Yukon (Territory of Canada)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Yukon (Territory of Canada)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 35
            }
        ],
        "Yumbe (District of Uganda)": [
            {
                "Region Name": "Yumbe (District of Uganda)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Yumbe (District of Uganda)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Yumbe (District of Uganda)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Yumbe (District of Uganda)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Yumbe (District of Uganda)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Yumbe (District of Uganda)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Yumbe (District of Uganda)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Yumbe (District of Uganda)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Yumbe (District of Uganda)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Yumbe (District of Uganda)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Yumbe (District of Uganda)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Yumbe (District of Uganda)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Yumbe (District of Uganda)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Yumbe (District of Uganda)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Yumbe (District of Uganda)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Yumbe (District of Uganda)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Yumbe (District of Uganda)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Yumbe (District of Uganda)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Yumbe (District of Uganda)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yumbe (District of Uganda)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yumbe (District of Uganda)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Yumbe (District of Uganda)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Yunnan (Province of China)": [
            {
                "Region Name": "Yunnan (Province of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yunnan (Province of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yunnan (Province of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yunnan (Province of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yunnan (Province of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yunnan (Province of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yunnan (Province of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yunnan (Province of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Yunnan (Province of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yunnan (Province of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yunnan (Province of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yunnan (Province of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yunnan (Province of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Yunnan (Province of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yunnan (Province of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yunnan (Province of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yunnan (Province of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yunnan (Province of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Yunnan (Province of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Yunnan (Province of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Yunnan (Province of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Yunnan (Province of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Zabaykal'ye (Territory of Russia)": [
            {
                "Region Name": "Zabaykal'ye (Territory of Russia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Zabaykal'ye (Territory of Russia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Zabaykal'ye (Territory of Russia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Zabaykal'ye (Territory of Russia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Zabaykal'ye (Territory of Russia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Zabaykal'ye (Territory of Russia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Zabaykal'ye (Territory of Russia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Zabaykal'ye (Territory of Russia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Zabaykal'ye (Territory of Russia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Zabaykal'ye (Territory of Russia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Zabaykal'ye (Territory of Russia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Zabaykal'ye (Territory of Russia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Zabaykal'ye (Territory of Russia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 79
            },
            {
                "Region Name": "Zabaykal'ye (Territory of Russia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Zabaykal'ye (Territory of Russia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Zabaykal'ye (Territory of Russia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Zabaykal'ye (Territory of Russia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Zabaykal'ye (Territory of Russia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Zabaykal'ye (Territory of Russia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Zabaykal'ye (Territory of Russia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Zabaykal'ye (Territory of Russia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Zabaykal'ye (Territory of Russia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 24
            }
        ],
        "\u017Dabljak (Municipality of Montenegro)": [
            {
                "Region Name": "\u017Dabljak (Municipality of Montenegro)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dabljak (Municipality of Montenegro)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dabljak (Municipality of Montenegro)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dabljak (Municipality of Montenegro)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dabljak (Municipality of Montenegro)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dabljak (Municipality of Montenegro)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "\u017Dabljak (Municipality of Montenegro)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dabljak (Municipality of Montenegro)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dabljak (Municipality of Montenegro)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dabljak (Municipality of Montenegro)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dabljak (Municipality of Montenegro)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u017Dabljak (Municipality of Montenegro)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dabljak (Municipality of Montenegro)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dabljak (Municipality of Montenegro)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dabljak (Municipality of Montenegro)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dabljak (Municipality of Montenegro)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dabljak (Municipality of Montenegro)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dabljak (Municipality of Montenegro)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dabljak (Municipality of Montenegro)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dabljak (Municipality of Montenegro)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dabljak (Municipality of Montenegro)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dabljak (Municipality of Montenegro)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zabul (Province of Afghanistan)": [
            {
                "Region Name": "Zabul (Province of Afghanistan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zabul (Province of Afghanistan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zabul (Province of Afghanistan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zabul (Province of Afghanistan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zabul (Province of Afghanistan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zabul (Province of Afghanistan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zabul (Province of Afghanistan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zabul (Province of Afghanistan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zabul (Province of Afghanistan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zabul (Province of Afghanistan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zabul (Province of Afghanistan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zabul (Province of Afghanistan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zabul (Province of Afghanistan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zabul (Province of Afghanistan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zabul (Province of Afghanistan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zabul (Province of Afghanistan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zabul (Province of Afghanistan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zabul (Province of Afghanistan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zabul (Province of Afghanistan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zabul (Province of Afghanistan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zabul (Province of Afghanistan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zabul (Province of Afghanistan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zacapa (Department of Guatemala)": [
            {
                "Region Name": "Zacapa (Department of Guatemala)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zacapa (Department of Guatemala)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zacapa (Department of Guatemala)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zacapa (Department of Guatemala)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zacapa (Department of Guatemala)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zacapa (Department of Guatemala)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zacapa (Department of Guatemala)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zacapa (Department of Guatemala)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zacapa (Department of Guatemala)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zacapa (Department of Guatemala)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zacapa (Department of Guatemala)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zacapa (Department of Guatemala)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zacapa (Department of Guatemala)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zacapa (Department of Guatemala)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zacapa (Department of Guatemala)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zacapa (Department of Guatemala)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zacapa (Department of Guatemala)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zacapa (Department of Guatemala)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zacapa (Department of Guatemala)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Zacapa (Department of Guatemala)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zacapa (Department of Guatemala)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zacapa (Department of Guatemala)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Zacatecas (State of M\xe9xico)": [
            {
                "Region Name": "Zacatecas (State of M\xe9xico)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zacatecas (State of M\xe9xico)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Zacatecas (State of M\xe9xico)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zacatecas (State of M\xe9xico)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Zacatecas (State of M\xe9xico)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Zacatecas (State of M\xe9xico)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Zacatecas (State of M\xe9xico)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Zacatecas (State of M\xe9xico)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Zacatecas (State of M\xe9xico)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Zacatecas (State of M\xe9xico)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 76
            },
            {
                "Region Name": "Zacatecas (State of M\xe9xico)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Zacatecas (State of M\xe9xico)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zacatecas (State of M\xe9xico)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zacatecas (State of M\xe9xico)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zacatecas (State of M\xe9xico)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zacatecas (State of M\xe9xico)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Zacatecas (State of M\xe9xico)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Zacatecas (State of M\xe9xico)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Zacatecas (State of M\xe9xico)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zacatecas (State of M\xe9xico)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Zacatecas (State of M\xe9xico)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Zacatecas (State of M\xe9xico)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 58
            }
        ],
        "Zachodniopomorskie (Voivodeship of Poland)": [
            {
                "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zachodniopomorskie (Voivodeship of Poland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Zadarska (County of Croatia)": [
            {
                "Region Name": "Zadarska (County of Croatia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zadarska (County of Croatia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Zadarska (County of Croatia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zadarska (County of Croatia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zadarska (County of Croatia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zadarska (County of Croatia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Zadarska (County of Croatia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zadarska (County of Croatia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Zadarska (County of Croatia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zadarska (County of Croatia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Zadarska (County of Croatia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Zadarska (County of Croatia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zadarska (County of Croatia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zadarska (County of Croatia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Zadarska (County of Croatia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zadarska (County of Croatia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Zadarska (County of Croatia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zadarska (County of Croatia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zadarska (County of Croatia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Zadarska (County of Croatia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zadarska (County of Croatia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Zadarska (County of Croatia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zaghouan (Governorate of Tunisia)": [
            {
                "Region Name": "Zaghouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaghouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zaghouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaghouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zaghouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaghouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zaghouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaghouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaghouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zaghouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaghouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaghouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Zaghouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zaghouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaghouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaghouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaghouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaghouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaghouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaghouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Zaghouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Zaghouan (Governorate of Tunisia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zagreba\u010Dka (County of Croatia)": [
            {
                "Region Name": "Zagreba\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zagreba\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zagreba\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zagreba\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zagreba\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zagreba\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zagreba\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zagreba\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zagreba\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zagreba\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zagreba\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zagreba\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zagreba\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zagreba\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zagreba\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zagreba\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zagreba\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zagreba\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zagreba\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zagreba\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zagreba\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zagreba\u010Dka (County of Croatia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zaire (Province of Angola)": [
            {
                "Region Name": "Zaire (Province of Angola)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Zaire (Province of Angola)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Zaire (Province of Angola)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Zaire (Province of Angola)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zaire (Province of Angola)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Zaire (Province of Angola)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zaire (Province of Angola)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zaire (Province of Angola)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zaire (Province of Angola)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Zaire (Province of Angola)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zaire (Province of Angola)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Zaire (Province of Angola)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Zaire (Province of Angola)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zaire (Province of Angola)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Zaire (Province of Angola)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zaire (Province of Angola)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zaire (Province of Angola)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zaire (Province of Angola)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zaire (Province of Angola)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Zaire (Province of Angola)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zaire (Province of Angola)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Zaire (Province of Angola)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Zaje\u010Darski (District of Serbia)": [
            {
                "Region Name": "Zaje\u010Darski (District of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zaje\u010Darski (District of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zaje\u010Darski (District of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaje\u010Darski (District of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaje\u010Darski (District of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaje\u010Darski (District of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zaje\u010Darski (District of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zaje\u010Darski (District of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaje\u010Darski (District of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaje\u010Darski (District of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaje\u010Darski (District of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Zaje\u010Darski (District of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaje\u010Darski (District of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaje\u010Darski (District of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaje\u010Darski (District of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaje\u010Darski (District of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaje\u010Darski (District of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaje\u010Darski (District of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zaje\u010Darski (District of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zaje\u010Darski (District of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zaje\u010Darski (District of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zaje\u010Darski (District of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zakarpattia (Region of Ukraine)": [
            {
                "Region Name": "Zakarpattia (Region of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zakarpattia (Region of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zakarpattia (Region of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zakarpattia (Region of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zakarpattia (Region of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zakarpattia (Region of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zakarpattia (Region of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zakarpattia (Region of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Zakarpattia (Region of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zakarpattia (Region of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Zakarpattia (Region of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zakarpattia (Region of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Zakarpattia (Region of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zakarpattia (Region of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Zakarpattia (Region of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zakarpattia (Region of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zakarpattia (Region of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zakarpattia (Region of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zakarpattia (Region of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zakarpattia (Region of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zakarpattia (Region of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zakarpattia (Region of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zala (County of Hungary)": [
            {
                "Region Name": "Zala (County of Hungary)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zala (County of Hungary)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zala (County of Hungary)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zala (County of Hungary)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zala (County of Hungary)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zala (County of Hungary)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zala (County of Hungary)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zala (County of Hungary)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zala (County of Hungary)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zala (County of Hungary)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zala (County of Hungary)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zala (County of Hungary)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zala (County of Hungary)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zala (County of Hungary)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zala (County of Hungary)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zala (County of Hungary)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zala (County of Hungary)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zala (County of Hungary)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zala (County of Hungary)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zala (County of Hungary)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zala (County of Hungary)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zala (County of Hungary)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zambales (Province of Philippines)": [
            {
                "Region Name": "Zambales (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zambales (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zambales (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zambales (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zambales (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zambales (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zambales (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zambales (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zambales (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zambales (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zambales (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zambales (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zambales (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zambales (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zambales (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zambales (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zambales (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zambales (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zambales (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zambales (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zambales (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zambales (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Zambezi (Region of Namibia)": [
            {
                "Region Name": "Zambezi (Region of Namibia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Zambezi (Region of Namibia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Zambezi (Region of Namibia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Zambezi (Region of Namibia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Zambezi (Region of Namibia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Zambezi (Region of Namibia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Zambezi (Region of Namibia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Zambezi (Region of Namibia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Zambezi (Region of Namibia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Zambezi (Region of Namibia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Zambezi (Region of Namibia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Zambezi (Region of Namibia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Zambezi (Region of Namibia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Zambezi (Region of Namibia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Zambezi (Region of Namibia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Zambezi (Region of Namibia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Zambezi (Region of Namibia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Zambezi (Region of Namibia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Zambezi (Region of Namibia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Zambezi (Region of Namibia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Zambezi (Region of Namibia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Zambezi (Region of Namibia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 23
            }
        ],
        "Zambezia (Province of Mozambique)": [
            {
                "Region Name": "Zambezia (Province of Mozambique)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Zambezia (Province of Mozambique)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Zambezia (Province of Mozambique)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Zambezia (Province of Mozambique)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Zambezia (Province of Mozambique)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Zambezia (Province of Mozambique)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Zambezia (Province of Mozambique)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Zambezia (Province of Mozambique)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Zambezia (Province of Mozambique)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Zambezia (Province of Mozambique)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Zambezia (Province of Mozambique)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Zambezia (Province of Mozambique)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Zambezia (Province of Mozambique)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Zambezia (Province of Mozambique)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Zambezia (Province of Mozambique)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Zambezia (Province of Mozambique)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Zambezia (Province of Mozambique)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Zambezia (Province of Mozambique)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Zambezia (Province of Mozambique)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Zambezia (Province of Mozambique)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Zambezia (Province of Mozambique)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Zambezia (Province of Mozambique)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 25
            }
        ],
        "Zamboanga del Norte (Province of Philippines)": [
            {
                "Region Name": "Zamboanga del Norte (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga del Norte (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zamboanga del Norte (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga del Norte (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zamboanga del Norte (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga del Norte (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zamboanga del Norte (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga del Norte (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Zamboanga del Norte (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zamboanga del Norte (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga del Norte (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga del Norte (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga del Norte (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zamboanga del Norte (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zamboanga del Norte (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zamboanga del Norte (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga del Norte (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zamboanga del Norte (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zamboanga del Norte (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zamboanga del Norte (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga del Norte (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga del Norte (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zamboanga del Sur (Province of Philippines)": [
            {
                "Region Name": "Zamboanga del Sur (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga del Sur (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zamboanga del Sur (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zamboanga del Sur (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga del Sur (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga del Sur (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga del Sur (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga del Sur (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zamboanga del Sur (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zamboanga del Sur (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga del Sur (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga del Sur (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga del Sur (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zamboanga del Sur (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zamboanga del Sur (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zamboanga del Sur (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga del Sur (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zamboanga del Sur (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zamboanga del Sur (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zamboanga del Sur (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga del Sur (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga del Sur (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Zamboanga Sibugay (Province of Philippines)": [
            {
                "Region Name": "Zamboanga Sibugay (Province of Philippines)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zamboanga Sibugay (Province of Philippines)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga Sibugay (Province of Philippines)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga Sibugay (Province of Philippines)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga Sibugay (Province of Philippines)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga Sibugay (Province of Philippines)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zamboanga Sibugay (Province of Philippines)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga Sibugay (Province of Philippines)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga Sibugay (Province of Philippines)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga Sibugay (Province of Philippines)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga Sibugay (Province of Philippines)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga Sibugay (Province of Philippines)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga Sibugay (Province of Philippines)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga Sibugay (Province of Philippines)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zamboanga Sibugay (Province of Philippines)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga Sibugay (Province of Philippines)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga Sibugay (Province of Philippines)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga Sibugay (Province of Philippines)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga Sibugay (Province of Philippines)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga Sibugay (Province of Philippines)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga Sibugay (Province of Philippines)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamboanga Sibugay (Province of Philippines)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zamfara (State of Nigeria)": [
            {
                "Region Name": "Zamfara (State of Nigeria)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Zamfara (State of Nigeria)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Zamfara (State of Nigeria)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Zamfara (State of Nigeria)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Zamfara (State of Nigeria)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Zamfara (State of Nigeria)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Zamfara (State of Nigeria)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Zamfara (State of Nigeria)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Zamfara (State of Nigeria)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Zamfara (State of Nigeria)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Zamfara (State of Nigeria)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Zamfara (State of Nigeria)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Zamfara (State of Nigeria)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Zamfara (State of Nigeria)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Zamfara (State of Nigeria)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Zamfara (State of Nigeria)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Zamfara (State of Nigeria)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Zamfara (State of Nigeria)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Zamfara (State of Nigeria)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Zamfara (State of Nigeria)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Zamfara (State of Nigeria)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Zamfara (State of Nigeria)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 23
            }
        ],
        "Zamora Chinchipe (Province of Ecuador)": [
            {
                "Region Name": "Zamora Chinchipe (Province of Ecuador)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamora Chinchipe (Province of Ecuador)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamora Chinchipe (Province of Ecuador)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamora Chinchipe (Province of Ecuador)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Zamora Chinchipe (Province of Ecuador)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zamora Chinchipe (Province of Ecuador)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamora Chinchipe (Province of Ecuador)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamora Chinchipe (Province of Ecuador)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zamora Chinchipe (Province of Ecuador)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamora Chinchipe (Province of Ecuador)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamora Chinchipe (Province of Ecuador)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamora Chinchipe (Province of Ecuador)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zamora Chinchipe (Province of Ecuador)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamora Chinchipe (Province of Ecuador)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamora Chinchipe (Province of Ecuador)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zamora Chinchipe (Province of Ecuador)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamora Chinchipe (Province of Ecuador)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamora Chinchipe (Province of Ecuador)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamora Chinchipe (Province of Ecuador)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamora Chinchipe (Province of Ecuador)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamora Chinchipe (Province of Ecuador)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zamora Chinchipe (Province of Ecuador)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zanjan (Province of Iran)": [
            {
                "Region Name": "Zanjan (Province of Iran)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zanjan (Province of Iran)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zanjan (Province of Iran)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zanjan (Province of Iran)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zanjan (Province of Iran)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zanjan (Province of Iran)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zanjan (Province of Iran)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zanjan (Province of Iran)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zanjan (Province of Iran)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zanjan (Province of Iran)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zanjan (Province of Iran)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zanjan (Province of Iran)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zanjan (Province of Iran)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zanjan (Province of Iran)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zanjan (Province of Iran)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zanjan (Province of Iran)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zanjan (Province of Iran)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zanjan (Province of Iran)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zanjan (Province of Iran)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zanjan (Province of Iran)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zanjan (Province of Iran)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zanjan (Province of Iran)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zanzan (District of C\xf4te d'Ivoire)": [
            {
                "Region Name": "Zanzan (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Zanzan (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Zanzan (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Zanzan (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Zanzan (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Zanzan (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Zanzan (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Zanzan (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Zanzan (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Zanzan (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Zanzan (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Zanzan (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Zanzan (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Zanzan (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Zanzan (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Zanzan (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 57
            },
            {
                "Region Name": "Zanzan (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 50
            },
            {
                "Region Name": "Zanzan (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Zanzan (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Zanzan (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Zanzan (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Zanzan (District of C\xf4te d'Ivoire)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 63
            }
        ],
        "Zapadno-Ba\u010Dki (District of Serbia)": [
            {
                "Region Name": "Zapadno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zapadno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zapadno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zapadno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zapadno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zapadno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zapadno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Zapadno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zapadno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zapadno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zapadno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zapadno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zapadno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Zapadno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zapadno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zapadno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zapadno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zapadno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zapadno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Zapadno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zapadno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zapadno-Ba\u010Dki (District of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zaporizhia (Region of Ukraine)": [
            {
                "Region Name": "Zaporizhia (Region of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zaporizhia (Region of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zaporizhia (Region of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zaporizhia (Region of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zaporizhia (Region of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zaporizhia (Region of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zaporizhia (Region of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zaporizhia (Region of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zaporizhia (Region of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zaporizhia (Region of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zaporizhia (Region of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zaporizhia (Region of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zaporizhia (Region of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zaporizhia (Region of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zaporizhia (Region of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zaporizhia (Region of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zaporizhia (Region of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zaporizhia (Region of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zaporizhia (Region of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zaporizhia (Region of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zaporizhia (Region of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zaporizhia (Region of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Zarqa (Province of Jordan)": [
            {
                "Region Name": "Zarqa (Province of Jordan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zarqa (Province of Jordan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zarqa (Province of Jordan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zarqa (Province of Jordan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zarqa (Province of Jordan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zarqa (Province of Jordan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zarqa (Province of Jordan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zarqa (Province of Jordan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zarqa (Province of Jordan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zarqa (Province of Jordan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zarqa (Province of Jordan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zarqa (Province of Jordan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zarqa (Province of Jordan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zarqa (Province of Jordan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zarqa (Province of Jordan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zarqa (Province of Jordan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zarqa (Province of Jordan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zarqa (Province of Jordan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zarqa (Province of Jordan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zarqa (Province of Jordan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zarqa (Province of Jordan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zarqa (Province of Jordan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Zasavska (Statistical Region of Slovenia)": [
            {
                "Region Name": "Zasavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zasavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zasavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zasavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zasavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zasavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zasavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zasavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zasavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zasavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zasavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zasavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zasavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zasavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zasavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zasavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zasavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zasavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zasavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zasavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zasavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zasavska (Statistical Region of Slovenia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zeeland (Province of Netherlands)": [
            {
                "Region Name": "Zeeland (Province of Netherlands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeland (Province of Netherlands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeland (Province of Netherlands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeland (Province of Netherlands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeland (Province of Netherlands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zeeland (Province of Netherlands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeland (Province of Netherlands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeland (Province of Netherlands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeland (Province of Netherlands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeland (Province of Netherlands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeland (Province of Netherlands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeland (Province of Netherlands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeland (Province of Netherlands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeland (Province of Netherlands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeland (Province of Netherlands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeland (Province of Netherlands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeland (Province of Netherlands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeland (Province of Netherlands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeland (Province of Netherlands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeland (Province of Netherlands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeland (Province of Netherlands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeland (Province of Netherlands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zeeuwse meren (Water body of Netherlands)": [
            {
                "Region Name": "Zeeuwse meren (Water body of Netherlands)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeuwse meren (Water body of Netherlands)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeuwse meren (Water body of Netherlands)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeuwse meren (Water body of Netherlands)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeuwse meren (Water body of Netherlands)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeuwse meren (Water body of Netherlands)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeuwse meren (Water body of Netherlands)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeuwse meren (Water body of Netherlands)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeuwse meren (Water body of Netherlands)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeuwse meren (Water body of Netherlands)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeuwse meren (Water body of Netherlands)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeuwse meren (Water body of Netherlands)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeuwse meren (Water body of Netherlands)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeuwse meren (Water body of Netherlands)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeuwse meren (Water body of Netherlands)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeuwse meren (Water body of Netherlands)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeuwse meren (Water body of Netherlands)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeuwse meren (Water body of Netherlands)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeuwse meren (Water body of Netherlands)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeuwse meren (Water body of Netherlands)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeuwse meren (Water body of Netherlands)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zeeuwse meren (Water body of Netherlands)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zelenikovo (Municipality of North Macedonia)": [
            {
                "Region Name": "Zelenikovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zelenikovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zelenikovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zelenikovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zelenikovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zelenikovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zelenikovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zelenikovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zelenikovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zelenikovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zelenikovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zelenikovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zelenikovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zelenikovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zelenikovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zelenikovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zelenikovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zelenikovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zelenikovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zelenikovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zelenikovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zelenikovo (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "\u017Delino (Municipality of North Macedonia)": [
            {
                "Region Name": "\u017Delino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Delino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Delino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Delino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Delino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Delino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "\u017Delino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Delino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Delino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Delino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u017Delino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "\u017Delino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Delino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Delino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Delino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Delino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Delino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Delino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "\u017Delino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Delino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Delino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Delino (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zemgale (Province of Latvia)": [
            {
                "Region Name": "Zemgale (Province of Latvia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zemgale (Province of Latvia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Zemgale (Province of Latvia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zemgale (Province of Latvia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zemgale (Province of Latvia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zemgale (Province of Latvia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zemgale (Province of Latvia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zemgale (Province of Latvia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zemgale (Province of Latvia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zemgale (Province of Latvia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zemgale (Province of Latvia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zemgale (Province of Latvia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zemgale (Province of Latvia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zemgale (Province of Latvia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zemgale (Province of Latvia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zemgale (Province of Latvia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zemgale (Province of Latvia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zemgale (Province of Latvia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zemgale (Province of Latvia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zemgale (Province of Latvia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zemgale (Province of Latvia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zemgale (Province of Latvia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 2
            }
        ],
        "Zhambyl (Region of Kazakhstan)": [
            {
                "Region Name": "Zhambyl (Region of Kazakhstan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 77
            },
            {
                "Region Name": "Zhambyl (Region of Kazakhstan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 47
            },
            {
                "Region Name": "Zhambyl (Region of Kazakhstan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Zhambyl (Region of Kazakhstan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Zhambyl (Region of Kazakhstan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Zhambyl (Region of Kazakhstan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "Zhambyl (Region of Kazakhstan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Zhambyl (Region of Kazakhstan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 85
            },
            {
                "Region Name": "Zhambyl (Region of Kazakhstan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Zhambyl (Region of Kazakhstan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 79
            },
            {
                "Region Name": "Zhambyl (Region of Kazakhstan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Zhambyl (Region of Kazakhstan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Zhambyl (Region of Kazakhstan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Zhambyl (Region of Kazakhstan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 67
            },
            {
                "Region Name": "Zhambyl (Region of Kazakhstan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Zhambyl (Region of Kazakhstan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Zhambyl (Region of Kazakhstan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "Zhambyl (Region of Kazakhstan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Zhambyl (Region of Kazakhstan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 68
            },
            {
                "Region Name": "Zhambyl (Region of Kazakhstan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Zhambyl (Region of Kazakhstan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Zhambyl (Region of Kazakhstan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 20
            }
        ],
        "Zhejiang (Province of China)": [
            {
                "Region Name": "Zhejiang (Province of China)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zhejiang (Province of China)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zhejiang (Province of China)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zhejiang (Province of China)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zhejiang (Province of China)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zhejiang (Province of China)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Zhejiang (Province of China)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zhejiang (Province of China)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zhejiang (Province of China)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zhejiang (Province of China)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zhejiang (Province of China)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zhejiang (Province of China)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zhejiang (Province of China)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zhejiang (Province of China)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zhejiang (Province of China)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zhejiang (Province of China)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zhejiang (Province of China)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zhejiang (Province of China)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zhejiang (Province of China)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zhejiang (Province of China)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zhejiang (Province of China)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zhejiang (Province of China)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Zhemgang (District of Bhutan)": [
            {
                "Region Name": "Zhemgang (District of Bhutan)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zhemgang (District of Bhutan)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zhemgang (District of Bhutan)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zhemgang (District of Bhutan)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zhemgang (District of Bhutan)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zhemgang (District of Bhutan)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zhemgang (District of Bhutan)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zhemgang (District of Bhutan)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zhemgang (District of Bhutan)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zhemgang (District of Bhutan)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zhemgang (District of Bhutan)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zhemgang (District of Bhutan)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zhemgang (District of Bhutan)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zhemgang (District of Bhutan)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zhemgang (District of Bhutan)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zhemgang (District of Bhutan)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zhemgang (District of Bhutan)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zhemgang (District of Bhutan)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zhemgang (District of Bhutan)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zhemgang (District of Bhutan)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zhemgang (District of Bhutan)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zhemgang (District of Bhutan)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zhytomyr (Region of Ukraine)": [
            {
                "Region Name": "Zhytomyr (Region of Ukraine)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Zhytomyr (Region of Ukraine)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zhytomyr (Region of Ukraine)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zhytomyr (Region of Ukraine)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zhytomyr (Region of Ukraine)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Zhytomyr (Region of Ukraine)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zhytomyr (Region of Ukraine)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zhytomyr (Region of Ukraine)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zhytomyr (Region of Ukraine)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Zhytomyr (Region of Ukraine)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zhytomyr (Region of Ukraine)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Zhytomyr (Region of Ukraine)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zhytomyr (Region of Ukraine)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Zhytomyr (Region of Ukraine)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zhytomyr (Region of Ukraine)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Zhytomyr (Region of Ukraine)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zhytomyr (Region of Ukraine)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Zhytomyr (Region of Ukraine)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zhytomyr (Region of Ukraine)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Zhytomyr (Region of Ukraine)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zhytomyr (Region of Ukraine)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Zhytomyr (Region of Ukraine)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Ziguinchor (Region of Senegal)": [
            {
                "Region Name": "Ziguinchor (Region of Senegal)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Ziguinchor (Region of Senegal)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "Ziguinchor (Region of Senegal)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Ziguinchor (Region of Senegal)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Ziguinchor (Region of Senegal)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Ziguinchor (Region of Senegal)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Ziguinchor (Region of Senegal)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Ziguinchor (Region of Senegal)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Ziguinchor (Region of Senegal)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Ziguinchor (Region of Senegal)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Ziguinchor (Region of Senegal)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Ziguinchor (Region of Senegal)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Ziguinchor (Region of Senegal)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Ziguinchor (Region of Senegal)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Ziguinchor (Region of Senegal)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Ziguinchor (Region of Senegal)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Ziguinchor (Region of Senegal)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Ziguinchor (Region of Senegal)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Ziguinchor (Region of Senegal)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Ziguinchor (Region of Senegal)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Ziguinchor (Region of Senegal)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Ziguinchor (Region of Senegal)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 34
            }
        ],
        "\u017Dilinsk\xfd (Region of Slovakia)": [
            {
                "Region Name": "\u017Dilinsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dilinsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dilinsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dilinsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dilinsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dilinsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dilinsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dilinsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dilinsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dilinsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dilinsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dilinsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dilinsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dilinsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dilinsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dilinsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dilinsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dilinsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dilinsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dilinsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dilinsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "\u017Dilinsk\xfd (Region of Slovakia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zinder (Department of Niger)": [
            {
                "Region Name": "Zinder (Department of Niger)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Zinder (Department of Niger)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Zinder (Department of Niger)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Zinder (Department of Niger)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Zinder (Department of Niger)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "Zinder (Department of Niger)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Zinder (Department of Niger)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Zinder (Department of Niger)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zinder (Department of Niger)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Zinder (Department of Niger)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 55
            },
            {
                "Region Name": "Zinder (Department of Niger)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Zinder (Department of Niger)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Zinder (Department of Niger)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Zinder (Department of Niger)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 54
            },
            {
                "Region Name": "Zinder (Department of Niger)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 91
            },
            {
                "Region Name": "Zinder (Department of Niger)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Zinder (Department of Niger)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 83
            },
            {
                "Region Name": "Zinder (Department of Niger)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Zinder (Department of Niger)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 72
            },
            {
                "Region Name": "Zinder (Department of Niger)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 71
            },
            {
                "Region Name": "Zinder (Department of Niger)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "Zinder (Department of Niger)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 91
            }
        ],
        "Zinguldak (Province of Turkey)": [
            {
                "Region Name": "Zinguldak (Province of Turkey)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zinguldak (Province of Turkey)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zinguldak (Province of Turkey)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zinguldak (Province of Turkey)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zinguldak (Province of Turkey)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zinguldak (Province of Turkey)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zinguldak (Province of Turkey)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zinguldak (Province of Turkey)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zinguldak (Province of Turkey)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zinguldak (Province of Turkey)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zinguldak (Province of Turkey)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zinguldak (Province of Turkey)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zinguldak (Province of Turkey)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zinguldak (Province of Turkey)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zinguldak (Province of Turkey)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zinguldak (Province of Turkey)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zinguldak (Province of Turkey)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zinguldak (Province of Turkey)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zinguldak (Province of Turkey)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zinguldak (Province of Turkey)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zinguldak (Province of Turkey)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zinguldak (Province of Turkey)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zlatiborski (District of Serbia)": [
            {
                "Region Name": "Zlatiborski (District of Serbia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zlatiborski (District of Serbia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zlatiborski (District of Serbia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zlatiborski (District of Serbia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zlatiborski (District of Serbia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zlatiborski (District of Serbia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zlatiborski (District of Serbia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zlatiborski (District of Serbia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zlatiborski (District of Serbia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zlatiborski (District of Serbia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zlatiborski (District of Serbia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Zlatiborski (District of Serbia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zlatiborski (District of Serbia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zlatiborski (District of Serbia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zlatiborski (District of Serbia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zlatiborski (District of Serbia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zlatiborski (District of Serbia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zlatiborski (District of Serbia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zlatiborski (District of Serbia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zlatiborski (District of Serbia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zlatiborski (District of Serbia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zlatiborski (District of Serbia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zl\xednsk\xfd (Region of Czechia)": [
            {
                "Region Name": "Zl\xednsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zl\xednsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zl\xednsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zl\xednsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zl\xednsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zl\xednsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zl\xednsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zl\xednsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zl\xednsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zl\xednsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zl\xednsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zl\xednsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zl\xednsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zl\xednsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zl\xednsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zl\xednsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zl\xednsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zl\xednsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zl\xednsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zl\xednsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zl\xednsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zl\xednsk\xfd (Region of Czechia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zomba (District of Malawi)": [
            {
                "Region Name": "Zomba (District of Malawi)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zomba (District of Malawi)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zomba (District of Malawi)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zomba (District of Malawi)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zomba (District of Malawi)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zomba (District of Malawi)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zomba (District of Malawi)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zomba (District of Malawi)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Zomba (District of Malawi)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zomba (District of Malawi)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Zomba (District of Malawi)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Zomba (District of Malawi)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zomba (District of Malawi)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zomba (District of Malawi)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zomba (District of Malawi)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zomba (District of Malawi)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zomba (District of Malawi)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Zomba (District of Malawi)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zomba (District of Malawi)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Zomba (District of Malawi)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zomba (District of Malawi)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zomba (District of Malawi)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zou (Department of Benin)": [
            {
                "Region Name": "Zou (Department of Benin)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Zou (Department of Benin)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Zou (Department of Benin)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Zou (Department of Benin)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zou (Department of Benin)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Zou (Department of Benin)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Zou (Department of Benin)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zou (Department of Benin)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Zou (Department of Benin)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zou (Department of Benin)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zou (Department of Benin)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zou (Department of Benin)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zou (Department of Benin)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zou (Department of Benin)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Zou (Department of Benin)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zou (Department of Benin)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Zou (Department of Benin)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zou (Department of Benin)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Zou (Department of Benin)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zou (Department of Benin)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zou (Department of Benin)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Zou (Department of Benin)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Zrnovci (Municipality of North Macedonia)": [
            {
                "Region Name": "Zrnovci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zrnovci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zrnovci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zrnovci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zrnovci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zrnovci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zrnovci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zrnovci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zrnovci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zrnovci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zrnovci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zrnovci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zrnovci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zrnovci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zrnovci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zrnovci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zrnovci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zrnovci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zrnovci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zrnovci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zrnovci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zrnovci (Municipality of North Macedonia)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zug (Canton of Switzerland)": [
            {
                "Region Name": "Zug (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zug (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zug (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zug (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zug (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zug (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zug (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zug (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Zug (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zug (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zug (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zug (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zug (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zug (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zug (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zug (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zug (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zug (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zug (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zug (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zug (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Zug (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Zulia (State of Venezuela)": [
            {
                "Region Name": "Zulia (State of Venezuela)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Zulia (State of Venezuela)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Zulia (State of Venezuela)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Zulia (State of Venezuela)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zulia (State of Venezuela)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Zulia (State of Venezuela)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Zulia (State of Venezuela)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zulia (State of Venezuela)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Zulia (State of Venezuela)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Zulia (State of Venezuela)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zulia (State of Venezuela)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Zulia (State of Venezuela)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Zulia (State of Venezuela)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Zulia (State of Venezuela)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Zulia (State of Venezuela)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Zulia (State of Venezuela)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Zulia (State of Venezuela)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Zulia (State of Venezuela)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Zulia (State of Venezuela)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Zulia (State of Venezuela)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Zulia (State of Venezuela)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Zulia (State of Venezuela)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Z\xfcrich (Canton of Switzerland)": [
            {
                "Region Name": "Z\xfcrich (Canton of Switzerland)",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Z\xfcrich (Canton of Switzerland)",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Z\xfcrich (Canton of Switzerland)",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Z\xfcrich (Canton of Switzerland)",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Z\xfcrich (Canton of Switzerland)",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Z\xfcrich (Canton of Switzerland)",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Z\xfcrich (Canton of Switzerland)",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Z\xfcrich (Canton of Switzerland)",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Z\xfcrich (Canton of Switzerland)",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Z\xfcrich (Canton of Switzerland)",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Z\xfcrich (Canton of Switzerland)",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Z\xfcrich (Canton of Switzerland)",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Z\xfcrich (Canton of Switzerland)",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Z\xfcrich (Canton of Switzerland)",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Z\xfcrich (Canton of Switzerland)",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Z\xfcrich (Canton of Switzerland)",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Z\xfcrich (Canton of Switzerland)",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Z\xfcrich (Canton of Switzerland)",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Z\xfcrich (Canton of Switzerland)",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Z\xfcrich (Canton of Switzerland)",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Z\xfcrich (Canton of Switzerland)",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Z\xfcrich (Canton of Switzerland)",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ]
    },
    "Continental Biomes": {
        "Africa - (Sub)tropical dry broadleaf forest": [
            {
                "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Africa - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Africa - (Sub)tropical grassland, savannah & shrubland": [
            {
                "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Africa - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 16
            }
        ],
        "Africa - (Sub)tropical moist broadleaf forest": [
            {
                "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Africa - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Africa - Deserts & xeric shrublands": [
            {
                "Region Name": "Africa - Deserts & xeric shrublands",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Africa - Deserts & xeric shrublands",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Africa - Deserts & xeric shrublands",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - Deserts & xeric shrublands",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Africa - Deserts & xeric shrublands",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Africa - Deserts & xeric shrublands",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Africa - Deserts & xeric shrublands",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Africa - Deserts & xeric shrublands",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Africa - Deserts & xeric shrublands",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Africa - Deserts & xeric shrublands",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Africa - Deserts & xeric shrublands",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Africa - Deserts & xeric shrublands",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - Deserts & xeric shrublands",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Africa - Deserts & xeric shrublands",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Africa - Deserts & xeric shrublands",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - Deserts & xeric shrublands",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Africa - Deserts & xeric shrublands",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Africa - Deserts & xeric shrublands",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Africa - Deserts & xeric shrublands",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Africa - Deserts & xeric shrublands",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Africa - Deserts & xeric shrublands",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Africa - Deserts & xeric shrublands",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 35
            }
        ],
        "Africa - Flooded grassland & savannah": [
            {
                "Region Name": "Africa - Flooded grassland & savannah",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Africa - Flooded grassland & savannah",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Africa - Flooded grassland & savannah",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Africa - Flooded grassland & savannah",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Africa - Flooded grassland & savannah",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Africa - Flooded grassland & savannah",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Africa - Flooded grassland & savannah",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Africa - Flooded grassland & savannah",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Africa - Flooded grassland & savannah",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Africa - Flooded grassland & savannah",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Africa - Flooded grassland & savannah",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Africa - Flooded grassland & savannah",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Africa - Flooded grassland & savannah",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Africa - Flooded grassland & savannah",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Africa - Flooded grassland & savannah",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Africa - Flooded grassland & savannah",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Africa - Flooded grassland & savannah",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Africa - Flooded grassland & savannah",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Africa - Flooded grassland & savannah",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Africa - Flooded grassland & savannah",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Africa - Flooded grassland & savannah",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Africa - Flooded grassland & savannah",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 26
            }
        ],
        "Africa - Mangroves": [
            {
                "Region Name": "Africa - Mangroves",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - Mangroves",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Africa - Mangroves",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Africa - Mangroves",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - Mangroves",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Africa - Mangroves",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Africa - Mangroves",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Africa - Mangroves",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Africa - Mangroves",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - Mangroves",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Africa - Mangroves",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Africa - Mangroves",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Africa - Mangroves",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Africa - Mangroves",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Africa - Mangroves",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Africa - Mangroves",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Africa - Mangroves",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Africa - Mangroves",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Africa - Mangroves",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Africa - Mangroves",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Africa - Mangroves",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Africa - Mangroves",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Africa - Mediterranean forests,  woodlands and scrub": [
            {
                "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Africa - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 24
            }
        ],
        "Africa - Montane grassland & shrubland": [
            {
                "Region Name": "Africa - Montane grassland & shrubland",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Africa - Montane grassland & shrubland",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Africa - Montane grassland & shrubland",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Africa - Montane grassland & shrubland",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Africa - Montane grassland & shrubland",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Africa - Montane grassland & shrubland",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Africa - Montane grassland & shrubland",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Africa - Montane grassland & shrubland",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Africa - Montane grassland & shrubland",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Africa - Montane grassland & shrubland",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Africa - Montane grassland & shrubland",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Africa - Montane grassland & shrubland",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Africa - Montane grassland & shrubland",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Africa - Montane grassland & shrubland",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Africa - Montane grassland & shrubland",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Africa - Montane grassland & shrubland",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Africa - Montane grassland & shrubland",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Africa - Montane grassland & shrubland",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Africa - Montane grassland & shrubland",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Africa - Montane grassland & shrubland",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Africa - Montane grassland & shrubland",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Africa - Montane grassland & shrubland",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Africa - Temperate broadleaf & mixed forest": [
            {
                "Region Name": "Africa - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Africa - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Africa - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Africa - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Africa - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Africa - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Africa - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Africa - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Africa - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 63
            },
            {
                "Region Name": "Africa - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Africa - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Africa - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Africa - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Africa - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Africa - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 39
            },
            {
                "Region Name": "Africa - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Africa - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Africa - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Africa - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Africa - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Africa - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Africa - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 35
            }
        ],
        "Africa - Temperate conifer forest": [
            {
                "Region Name": "Africa - Temperate conifer forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Africa - Temperate conifer forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Africa - Temperate conifer forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Africa - Temperate conifer forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Africa - Temperate conifer forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Africa - Temperate conifer forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Africa - Temperate conifer forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Africa - Temperate conifer forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Africa - Temperate conifer forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Africa - Temperate conifer forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Africa - Temperate conifer forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Africa - Temperate conifer forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Africa - Temperate conifer forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Africa - Temperate conifer forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Africa - Temperate conifer forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Africa - Temperate conifer forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Africa - Temperate conifer forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Africa - Temperate conifer forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Africa - Temperate conifer forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Africa - Temperate conifer forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "Africa - Temperate conifer forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Africa - Temperate conifer forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 29
            }
        ],
        "Antarctica - Tundra": [
            {
                "Region Name": "Antarctica - Tundra",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica - Tundra",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica - Tundra",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica - Tundra",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica - Tundra",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica - Tundra",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica - Tundra",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica - Tundra",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica - Tundra",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica - Tundra",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica - Tundra",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica - Tundra",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica - Tundra",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica - Tundra",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica - Tundra",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica - Tundra",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica - Tundra",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica - Tundra",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica - Tundra",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica - Tundra",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica - Tundra",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Antarctica - Tundra",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Asia - (Sub)tropical coniferous forest": [
            {
                "Region Name": "Asia - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Asia - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Asia - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Asia - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Asia - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Asia - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Asia - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Asia - (Sub)tropical dry broadleaf forest": [
            {
                "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Asia - (Sub)tropical grassland, savannah & shrubland": [
            {
                "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Asia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Asia - (Sub)tropical moist broadleaf forest": [
            {
                "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Asia - Boreal forest": [
            {
                "Region Name": "Asia - Boreal forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Asia - Boreal forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Asia - Boreal forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Asia - Boreal forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Asia - Boreal forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Asia - Boreal forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Asia - Boreal forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Asia - Boreal forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Asia - Boreal forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Asia - Boreal forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Asia - Boreal forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Asia - Boreal forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Asia - Boreal forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Asia - Boreal forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Asia - Boreal forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Asia - Boreal forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Asia - Boreal forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Asia - Boreal forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Asia - Boreal forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Asia - Boreal forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Asia - Boreal forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Asia - Boreal forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 23
            }
        ],
        "Asia - Deserts & xeric shrublands": [
            {
                "Region Name": "Asia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Asia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Asia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Asia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Asia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Asia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Asia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Asia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Asia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Asia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Asia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Asia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Asia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Asia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Asia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Asia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Asia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Asia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Asia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Asia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Asia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Asia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 11
            }
        ],
        "Asia - Flooded grassland & savannah": [
            {
                "Region Name": "Asia - Flooded grassland & savannah",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - Flooded grassland & savannah",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - Flooded grassland & savannah",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - Flooded grassland & savannah",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Asia - Flooded grassland & savannah",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - Flooded grassland & savannah",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - Flooded grassland & savannah",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Asia - Flooded grassland & savannah",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - Flooded grassland & savannah",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - Flooded grassland & savannah",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - Flooded grassland & savannah",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - Flooded grassland & savannah",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - Flooded grassland & savannah",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - Flooded grassland & savannah",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - Flooded grassland & savannah",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - Flooded grassland & savannah",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - Flooded grassland & savannah",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Asia - Flooded grassland & savannah",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - Flooded grassland & savannah",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - Flooded grassland & savannah",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Asia - Flooded grassland & savannah",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Asia - Flooded grassland & savannah",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Asia - Mangroves": [
            {
                "Region Name": "Asia - Mangroves",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - Mangroves",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Asia - Mangroves",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Asia - Mangroves",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Asia - Mangroves",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - Mangroves",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Asia - Mangroves",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - Mangroves",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Asia - Mangroves",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - Mangroves",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Asia - Mangroves",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - Mangroves",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - Mangroves",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Asia - Mangroves",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - Mangroves",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - Mangroves",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - Mangroves",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Asia - Mangroves",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Asia - Mangroves",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - Mangroves",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - Mangroves",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Asia - Mangroves",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Asia - Mediterranean forests,  woodlands and scrub": [
            {
                "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Asia - Montane grassland & shrubland": [
            {
                "Region Name": "Asia - Montane grassland & shrubland",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Asia - Montane grassland & shrubland",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - Montane grassland & shrubland",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - Montane grassland & shrubland",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Asia - Montane grassland & shrubland",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Asia - Montane grassland & shrubland",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - Montane grassland & shrubland",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - Montane grassland & shrubland",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - Montane grassland & shrubland",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - Montane grassland & shrubland",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Asia - Montane grassland & shrubland",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - Montane grassland & shrubland",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Asia - Montane grassland & shrubland",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - Montane grassland & shrubland",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Asia - Montane grassland & shrubland",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - Montane grassland & shrubland",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Asia - Montane grassland & shrubland",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Asia - Montane grassland & shrubland",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Asia - Montane grassland & shrubland",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Asia - Montane grassland & shrubland",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - Montane grassland & shrubland",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Asia - Montane grassland & shrubland",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 3
            }
        ],
        "Asia - Temperate broadleaf & mixed forest": [
            {
                "Region Name": "Asia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Asia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Asia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Asia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Asia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Asia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Asia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Asia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Asia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Asia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Asia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Asia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Asia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Asia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Asia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Asia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Asia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Asia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Asia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Asia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 16
            }
        ],
        "Asia - Temperate conifer forest": [
            {
                "Region Name": "Asia - Temperate conifer forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "Asia - Temperate conifer forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Asia - Temperate conifer forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Asia - Temperate conifer forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Asia - Temperate conifer forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - Temperate conifer forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Asia - Temperate conifer forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Asia - Temperate conifer forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - Temperate conifer forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Asia - Temperate conifer forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Asia - Temperate conifer forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Asia - Temperate conifer forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Asia - Temperate conifer forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Asia - Temperate conifer forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Asia - Temperate conifer forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - Temperate conifer forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - Temperate conifer forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Asia - Temperate conifer forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Asia - Temperate conifer forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - Temperate conifer forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - Temperate conifer forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - Temperate conifer forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Asia - Temperate grassland, savannah & shrubland": [
            {
                "Region Name": "Asia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Asia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Asia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Asia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Asia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Asia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Asia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Asia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Asia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Asia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Asia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Asia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Asia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Asia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Asia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Asia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Asia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Asia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Asia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Asia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Asia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Asia - Tundra": [
            {
                "Region Name": "Asia - Tundra",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Asia - Tundra",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Asia - Tundra",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Asia - Tundra",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Asia - Tundra",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - Tundra",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - Tundra",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - Tundra",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Asia - Tundra",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Asia - Tundra",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Asia - Tundra",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Asia - Tundra",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - Tundra",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - Tundra",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Asia - Tundra",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Asia - Tundra",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Asia - Tundra",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Asia - Tundra",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Asia - Tundra",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Asia - Tundra",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Asia - Tundra",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Asia - Tundra",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Australia - (Sub)tropical grassland, savannah & shrubland": [
            {
                "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 91
            },
            {
                "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 61
            },
            {
                "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 85
            },
            {
                "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 57
            },
            {
                "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 74
            },
            {
                "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 63
            },
            {
                "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 64
            },
            {
                "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 78
            },
            {
                "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 61
            },
            {
                "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 36
            },
            {
                "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "Australia - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 46
            }
        ],
        "Australia - (Sub)tropical moist broadleaf forest": [
            {
                "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 43
            },
            {
                "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 32
            },
            {
                "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 81
            },
            {
                "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Australia - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 19
            }
        ],
        "Australia - Deserts & xeric shrublands": [
            {
                "Region Name": "Australia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 188
            },
            {
                "Region Name": "Australia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "Australia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 123
            },
            {
                "Region Name": "Australia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "Australia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 157
            },
            {
                "Region Name": "Australia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 117
            },
            {
                "Region Name": "Australia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "Australia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "Australia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 77
            },
            {
                "Region Name": "Australia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 181
            },
            {
                "Region Name": "Australia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 199
            },
            {
                "Region Name": "Australia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 97
            },
            {
                "Region Name": "Australia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 124
            },
            {
                "Region Name": "Australia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 132
            },
            {
                "Region Name": "Australia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "Australia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 162
            },
            {
                "Region Name": "Australia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 161
            },
            {
                "Region Name": "Australia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 63
            },
            {
                "Region Name": "Australia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Australia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 87
            },
            {
                "Region Name": "Australia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 95
            },
            {
                "Region Name": "Australia - Deserts & xeric shrublands",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 213
            }
        ],
        "Australia - Mediterranean forests,  woodlands and scrub": [
            {
                "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 63
            },
            {
                "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Australia - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "Australia - Montane grassland & shrubland": [
            {
                "Region Name": "Australia - Montane grassland & shrubland",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 362
            },
            {
                "Region Name": "Australia - Montane grassland & shrubland",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Australia - Montane grassland & shrubland",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Australia - Montane grassland & shrubland",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Montane grassland & shrubland",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 101
            },
            {
                "Region Name": "Australia - Montane grassland & shrubland",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Montane grassland & shrubland",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 109
            },
            {
                "Region Name": "Australia - Montane grassland & shrubland",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Montane grassland & shrubland",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Montane grassland & shrubland",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Montane grassland & shrubland",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Australia - Montane grassland & shrubland",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Australia - Montane grassland & shrubland",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Montane grassland & shrubland",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Australia - Montane grassland & shrubland",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Australia - Montane grassland & shrubland",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "Australia - Montane grassland & shrubland",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 45
            },
            {
                "Region Name": "Australia - Montane grassland & shrubland",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 109
            },
            {
                "Region Name": "Australia - Montane grassland & shrubland",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Australia - Montane grassland & shrubland",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Australia - Montane grassland & shrubland",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Montane grassland & shrubland",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Australia - Temperate broadleaf & mixed forest": [
            {
                "Region Name": "Australia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "Australia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Australia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Australia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Australia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Australia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Australia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Australia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Australia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Australia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Australia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Australia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Australia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Australia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Australia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Australia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Australia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Australia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 124
            },
            {
                "Region Name": "Australia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Australia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Australia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Australia - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "Australia - Temperate grassland, savannah & shrubland": [
            {
                "Region Name": "Australia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Australia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Australia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Australia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Australia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Australia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Australia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Australia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Australia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Australia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Australia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Australia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Australia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Australia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Australia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Australia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Australia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Australia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Australia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Australia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Australia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Australia - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Australia - Tundra": [
            {
                "Region Name": "Australia - Tundra",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Tundra",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Tundra",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Tundra",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Tundra",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Tundra",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Tundra",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Tundra",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Tundra",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Tundra",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Tundra",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Tundra",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Tundra",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Tundra",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Tundra",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Tundra",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Tundra",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Tundra",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Tundra",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Tundra",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Tundra",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Australia - Tundra",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Europe - Boreal forest": [
            {
                "Region Name": "Europe - Boreal forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Europe - Boreal forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Europe - Boreal forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Boreal forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Europe - Boreal forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Europe - Boreal forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Boreal forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Europe - Boreal forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Europe - Boreal forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Europe - Boreal forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Europe - Boreal forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Boreal forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Europe - Boreal forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Europe - Boreal forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Europe - Boreal forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Europe - Boreal forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Europe - Boreal forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Europe - Boreal forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Boreal forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Europe - Boreal forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Boreal forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Europe - Boreal forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Europe - Deserts & xeric shrublands": [
            {
                "Region Name": "Europe - Deserts & xeric shrublands",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Europe - Deserts & xeric shrublands",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Europe - Deserts & xeric shrublands",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Europe - Deserts & xeric shrublands",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "Europe - Deserts & xeric shrublands",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 56
            },
            {
                "Region Name": "Europe - Deserts & xeric shrublands",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Europe - Deserts & xeric shrublands",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Europe - Deserts & xeric shrublands",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Europe - Deserts & xeric shrublands",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 34
            },
            {
                "Region Name": "Europe - Deserts & xeric shrublands",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "Europe - Deserts & xeric shrublands",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Europe - Deserts & xeric shrublands",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Europe - Deserts & xeric shrublands",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Europe - Deserts & xeric shrublands",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Europe - Deserts & xeric shrublands",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "Europe - Deserts & xeric shrublands",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Europe - Deserts & xeric shrublands",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Europe - Deserts & xeric shrublands",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "Europe - Deserts & xeric shrublands",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Europe - Deserts & xeric shrublands",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Europe - Deserts & xeric shrublands",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "Europe - Deserts & xeric shrublands",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 20
            }
        ],
        "Europe - Mediterranean forests,  woodlands and scrub": [
            {
                "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "Europe - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "Europe - Temperate broadleaf & mixed forest": [
            {
                "Region Name": "Europe - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Europe - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Europe - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Europe - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Europe - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Europe - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Europe - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Europe - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Europe - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Europe - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Europe - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Europe - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Europe - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Europe - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "Europe - Temperate conifer forest": [
            {
                "Region Name": "Europe - Temperate conifer forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Europe - Temperate conifer forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Europe - Temperate conifer forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Europe - Temperate conifer forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Europe - Temperate conifer forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Temperate conifer forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Europe - Temperate conifer forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Europe - Temperate conifer forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Europe - Temperate conifer forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Europe - Temperate conifer forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Europe - Temperate conifer forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Europe - Temperate conifer forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Europe - Temperate conifer forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Europe - Temperate conifer forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Europe - Temperate conifer forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Temperate conifer forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Europe - Temperate conifer forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Europe - Temperate conifer forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Europe - Temperate conifer forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Europe - Temperate conifer forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Temperate conifer forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Europe - Temperate conifer forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "Europe - Temperate grassland, savannah & shrubland": [
            {
                "Region Name": "Europe - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Europe - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Europe - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Europe - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Europe - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Europe - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Europe - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Europe - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Europe - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Europe - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Europe - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Europe - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Europe - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "Europe - Tundra": [
            {
                "Region Name": "Europe - Tundra",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Europe - Tundra",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Europe - Tundra",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Europe - Tundra",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Europe - Tundra",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Europe - Tundra",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Europe - Tundra",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Europe - Tundra",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Europe - Tundra",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Europe - Tundra",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Europe - Tundra",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Europe - Tundra",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Europe - Tundra",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Europe - Tundra",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Europe - Tundra",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Europe - Tundra",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Europe - Tundra",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Europe - Tundra",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Europe - Tundra",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Europe - Tundra",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Europe - Tundra",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Europe - Tundra",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "North America - (Sub)tropical coniferous forest": [
            {
                "Region Name": "North America - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "North America - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North America - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North America - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "North America - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North America - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North America - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North America - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North America - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "North America - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "North America - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North America - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North America - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North America - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North America - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North America - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North America - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "North America - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "North America - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North America - (Sub)tropical coniferous forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 12
            }
        ],
        "North America - (Sub)tropical dry broadleaf forest": [
            {
                "Region Name": "North America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "North America - (Sub)tropical grassland, savannah & shrubland": [
            {
                "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "North America - (Sub)tropical moist broadleaf forest": [
            {
                "Region Name": "North America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "North America - Boreal forest": [
            {
                "Region Name": "North America - Boreal forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 65
            },
            {
                "Region Name": "North America - Boreal forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 52
            },
            {
                "Region Name": "North America - Boreal forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 33
            },
            {
                "Region Name": "North America - Boreal forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 42
            },
            {
                "Region Name": "North America - Boreal forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 51
            },
            {
                "Region Name": "North America - Boreal forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 58
            },
            {
                "Region Name": "North America - Boreal forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "North America - Boreal forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "North America - Boreal forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "North America - Boreal forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "North America - Boreal forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 35
            },
            {
                "Region Name": "North America - Boreal forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "North America - Boreal forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 53
            },
            {
                "Region Name": "North America - Boreal forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "North America - Boreal forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 31
            },
            {
                "Region Name": "North America - Boreal forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 44
            },
            {
                "Region Name": "North America - Boreal forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "North America - Boreal forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "North America - Boreal forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Boreal forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 70
            },
            {
                "Region Name": "North America - Boreal forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "North America - Boreal forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 68
            }
        ],
        "North America - Deserts & xeric shrublands": [
            {
                "Region Name": "North America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "North America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "North America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 21
            },
            {
                "Region Name": "North America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "North America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "North America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "North America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "North America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "North America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "North America - Flooded grassland & savannah": [
            {
                "Region Name": "North America - Flooded grassland & savannah",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Flooded grassland & savannah",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Flooded grassland & savannah",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - Flooded grassland & savannah",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - Flooded grassland & savannah",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North America - Flooded grassland & savannah",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Flooded grassland & savannah",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - Flooded grassland & savannah",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - Flooded grassland & savannah",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Flooded grassland & savannah",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - Flooded grassland & savannah",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - Flooded grassland & savannah",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - Flooded grassland & savannah",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - Flooded grassland & savannah",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Flooded grassland & savannah",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Flooded grassland & savannah",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - Flooded grassland & savannah",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Flooded grassland & savannah",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North America - Flooded grassland & savannah",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Flooded grassland & savannah",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - Flooded grassland & savannah",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - Flooded grassland & savannah",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "North America - Mangroves": [
            {
                "Region Name": "North America - Mangroves",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Mangroves",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North America - Mangroves",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - Mangroves",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North America - Mangroves",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North America - Mangroves",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - Mangroves",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - Mangroves",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North America - Mangroves",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Mangroves",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North America - Mangroves",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Mangroves",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - Mangroves",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - Mangroves",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - Mangroves",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - Mangroves",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - Mangroves",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Mangroves",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - Mangroves",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North America - Mangroves",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - Mangroves",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Mangroves",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "North America - Mediterranean forests,  woodlands and scrub": [
            {
                "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 62
            },
            {
                "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 73
            },
            {
                "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 46
            },
            {
                "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 155
            },
            {
                "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 59
            },
            {
                "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 69
            },
            {
                "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 37
            },
            {
                "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 259
            },
            {
                "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 150
            },
            {
                "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 93
            },
            {
                "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 108
            },
            {
                "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 24
            },
            {
                "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 175
            },
            {
                "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 38
            },
            {
                "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 60
            },
            {
                "Region Name": "North America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 28
            }
        ],
        "North America - Temperate broadleaf & mixed forest": [
            {
                "Region Name": "North America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 6
            }
        ],
        "North America - Temperate conifer forest": [
            {
                "Region Name": "North America - Temperate conifer forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North America - Temperate conifer forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "North America - Temperate conifer forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - Temperate conifer forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - Temperate conifer forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North America - Temperate conifer forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "North America - Temperate conifer forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North America - Temperate conifer forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - Temperate conifer forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - Temperate conifer forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North America - Temperate conifer forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North America - Temperate conifer forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - Temperate conifer forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North America - Temperate conifer forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "North America - Temperate conifer forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - Temperate conifer forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "North America - Temperate conifer forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "North America - Temperate conifer forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - Temperate conifer forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "North America - Temperate conifer forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "North America - Temperate conifer forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North America - Temperate conifer forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 18
            }
        ],
        "North America - Temperate grassland, savannah & shrubland": [
            {
                "Region Name": "North America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "North America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "North America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "North America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "North America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "North America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "North America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "North America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "North America - Tundra": [
            {
                "Region Name": "North America - Tundra",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "North America - Tundra",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "North America - Tundra",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "North America - Tundra",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "North America - Tundra",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "North America - Tundra",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North America - Tundra",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North America - Tundra",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "North America - Tundra",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "North America - Tundra",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "North America - Tundra",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "North America - Tundra",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "North America - Tundra",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "North America - Tundra",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North America - Tundra",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "North America - Tundra",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - Tundra",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "North America - Tundra",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "North America - Tundra",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Tundra",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "North America - Tundra",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "North America - Tundra",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "Oceania - (Sub)tropical dry broadleaf forest": [
            {
                "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 19
            },
            {
                "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 93
            },
            {
                "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 30
            },
            {
                "Region Name": "Oceania - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "Oceania - (Sub)tropical grassland, savannah & shrubland": [
            {
                "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 49
            },
            {
                "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 17
            }
        ],
        "Oceania - (Sub)tropical moist broadleaf forest": [
            {
                "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "Oceania - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Oceania - Montane grassland & shrubland": [
            {
                "Region Name": "Oceania - Montane grassland & shrubland",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Montane grassland & shrubland",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Montane grassland & shrubland",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Montane grassland & shrubland",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Montane grassland & shrubland",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oceania - Montane grassland & shrubland",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oceania - Montane grassland & shrubland",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Montane grassland & shrubland",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Montane grassland & shrubland",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oceania - Montane grassland & shrubland",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Montane grassland & shrubland",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Montane grassland & shrubland",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Montane grassland & shrubland",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oceania - Montane grassland & shrubland",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Montane grassland & shrubland",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oceania - Montane grassland & shrubland",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "Oceania - Montane grassland & shrubland",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Montane grassland & shrubland",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oceania - Montane grassland & shrubland",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Oceania - Montane grassland & shrubland",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oceania - Montane grassland & shrubland",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Montane grassland & shrubland",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "Oceania - Temperate broadleaf & mixed forest": [
            {
                "Region Name": "Oceania - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oceania - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oceania - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oceania - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oceania - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oceania - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oceania - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "Oceania - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oceania - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "Oceania - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 1
            }
        ],
        "Oceania - Temperate grassland, savannah & shrubland": [
            {
                "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 1
            },
            {
                "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "Oceania - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 4
            }
        ],
        "Oceania - Tundra": [
            {
                "Region Name": "Oceania - Tundra",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Tundra",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Tundra",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Tundra",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Tundra",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Tundra",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Tundra",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Tundra",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Tundra",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Tundra",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Tundra",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Tundra",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Tundra",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Tundra",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Tundra",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Tundra",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Tundra",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Tundra",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Tundra",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Tundra",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Tundra",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 0
            },
            {
                "Region Name": "Oceania - Tundra",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 0
            }
        ],
        "South America - (Sub)tropical dry broadleaf forest": [
            {
                "Region Name": "South America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "South America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "South America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "South America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "South America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "South America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 20
            },
            {
                "Region Name": "South America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "South America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "South America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "South America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "South America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "South America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - (Sub)tropical dry broadleaf forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "South America - (Sub)tropical grassland, savannah & shrubland": [
            {
                "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 15
            },
            {
                "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "South America - (Sub)tropical grassland, savannah & shrubland",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 13
            }
        ],
        "South America - (Sub)tropical moist broadleaf forest": [
            {
                "Region Name": "South America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "South America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "South America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "South America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - (Sub)tropical moist broadleaf forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ],
        "South America - Deserts & xeric shrublands": [
            {
                "Region Name": "South America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "South America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "South America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "South America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "South America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "South America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - Deserts & xeric shrublands",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 10
            }
        ],
        "South America - Flooded grassland & savannah": [
            {
                "Region Name": "South America - Flooded grassland & savannah",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 40
            },
            {
                "Region Name": "South America - Flooded grassland & savannah",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "South America - Flooded grassland & savannah",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "South America - Flooded grassland & savannah",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "South America - Flooded grassland & savannah",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "South America - Flooded grassland & savannah",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "South America - Flooded grassland & savannah",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "South America - Flooded grassland & savannah",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "South America - Flooded grassland & savannah",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 48
            },
            {
                "Region Name": "South America - Flooded grassland & savannah",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "South America - Flooded grassland & savannah",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 25
            },
            {
                "Region Name": "South America - Flooded grassland & savannah",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "South America - Flooded grassland & savannah",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South America - Flooded grassland & savannah",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 18
            },
            {
                "Region Name": "South America - Flooded grassland & savannah",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 22
            },
            {
                "Region Name": "South America - Flooded grassland & savannah",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "South America - Flooded grassland & savannah",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "South America - Flooded grassland & savannah",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 41
            },
            {
                "Region Name": "South America - Flooded grassland & savannah",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "South America - Flooded grassland & savannah",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "South America - Flooded grassland & savannah",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "South America - Flooded grassland & savannah",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 45
            }
        ],
        "South America - Mangroves": [
            {
                "Region Name": "South America - Mangroves",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - Mangroves",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - Mangroves",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South America - Mangroves",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South America - Mangroves",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - Mangroves",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South America - Mangroves",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - Mangroves",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South America - Mangroves",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - Mangroves",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "South America - Mangroves",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "South America - Mangroves",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "South America - Mangroves",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South America - Mangroves",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - Mangroves",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South America - Mangroves",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South America - Mangroves",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - Mangroves",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South America - Mangroves",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South America - Mangroves",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South America - Mangroves",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - Mangroves",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 7
            }
        ],
        "South America - Mediterranean forests,  woodlands and scrub": [
            {
                "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 28
            },
            {
                "Region Name": "South America - Mediterranean forests,  woodlands and scrub",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 9
            }
        ],
        "South America - Montane grassland & shrubland": [
            {
                "Region Name": "South America - Montane grassland & shrubland",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "South America - Montane grassland & shrubland",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "South America - Montane grassland & shrubland",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "South America - Montane grassland & shrubland",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - Montane grassland & shrubland",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South America - Montane grassland & shrubland",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South America - Montane grassland & shrubland",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South America - Montane grassland & shrubland",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - Montane grassland & shrubland",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South America - Montane grassland & shrubland",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South America - Montane grassland & shrubland",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South America - Montane grassland & shrubland",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - Montane grassland & shrubland",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "South America - Montane grassland & shrubland",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - Montane grassland & shrubland",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - Montane grassland & shrubland",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 26
            },
            {
                "Region Name": "South America - Montane grassland & shrubland",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - Montane grassland & shrubland",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "South America - Montane grassland & shrubland",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South America - Montane grassland & shrubland",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - Montane grassland & shrubland",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 12
            },
            {
                "Region Name": "South America - Montane grassland & shrubland",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "South America - Temperate broadleaf & mixed forest": [
            {
                "Region Name": "South America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "South America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "South America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "South America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "South America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "South America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 3
            },
            {
                "Region Name": "South America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 4
            },
            {
                "Region Name": "South America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "South America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 16
            },
            {
                "Region Name": "South America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 88
            },
            {
                "Region Name": "South America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 2
            },
            {
                "Region Name": "South America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "South America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 5
            },
            {
                "Region Name": "South America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 23
            },
            {
                "Region Name": "South America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 63
            },
            {
                "Region Name": "South America - Temperate broadleaf & mixed forest",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 5
            }
        ],
        "South America - Temperate grassland, savannah & shrubland": [
            {
                "Region Name": "South America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2002,
                "95th Percentile Fire Size (km^2)": 27
            },
            {
                "Region Name": "South America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2003,
                "95th Percentile Fire Size (km^2)": 11
            },
            {
                "Region Name": "South America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2004,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2005,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2006,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2007,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2008,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "South America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2009,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "South America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2010,
                "95th Percentile Fire Size (km^2)": 6
            },
            {
                "Region Name": "South America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2011,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2012,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2013,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2014,
                "95th Percentile Fire Size (km^2)": 10
            },
            {
                "Region Name": "South America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2015,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2016,
                "95th Percentile Fire Size (km^2)": 29
            },
            {
                "Region Name": "South America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2017,
                "95th Percentile Fire Size (km^2)": 17
            },
            {
                "Region Name": "South America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2018,
                "95th Percentile Fire Size (km^2)": 13
            },
            {
                "Region Name": "South America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2019,
                "95th Percentile Fire Size (km^2)": 7
            },
            {
                "Region Name": "South America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2020,
                "95th Percentile Fire Size (km^2)": 8
            },
            {
                "Region Name": "South America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2021,
                "95th Percentile Fire Size (km^2)": 9
            },
            {
                "Region Name": "South America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2022,
                "95th Percentile Fire Size (km^2)": 14
            },
            {
                "Region Name": "South America - Temperate grassland, savannah & shrubland",
                "Fire Season Start Year": 2023,
                "95th Percentile Fire Size (km^2)": 8
            }
        ]
    }
};

});


//# sourceMappingURL=timeseries_fire_size.576c94d4.js.map
